import * as dateFns from "date-fns";
import { addBusinessDays, addDays, differenceInCalendarDays, endOfMonth, intervalToDuration, parse, parseISO, startOfMonth } from "date-fns";
import queryString from "query-string";
import urlJoin from "url-join";
import { formatInTimeZone, fromZonedTime, toZonedTime } from "date-fns-tz";
import { jsonDateParser } from "json-date-parser";
import generateEmojiRegex from "emoji-regex";
import Joi from "joi";
import joiPasswordComplexity from "joi-password-complexity";
// \0rolldown/runtime.js
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJSMin = (cb, mod) => () => (mod || (cb((mod = { exports: {} }).exports, mod, mod.exports), cb = null), mod.exports);
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
		key = keys[i];
		if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: ((k) => from[k]).bind(null, key),
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule || !__hasOwnProp.call(mod, "default") ? __defProp(target, "default", {
	value: mod,
	enumerable: true
}) : target, mod));
// ../../node_modules/date-fns/locale/_lib/buildFormatLongFn.js
function buildFormatLongFn(args) {
	return (options = {}) => {
		const width = options.width ? String(options.width) : args.defaultWidth;
		return args.formats[width] || args.formats[args.defaultWidth];
	};
}
// ../../node_modules/date-fns/locale/_lib/buildLocalizeFn.js
/**
* The localize function argument callback which allows to convert raw value to
* the actual type.
*
* @param value - The value to convert
*
* @returns The converted value
*/
/**
* The map of localized values for each width.
*/
/**
* The index type of the locale unit value. It types conversion of units of
* values that don't start at 0 (i.e. quarters).
*/
/**
* Converts the unit value to the tuple of values.
*/
/**
* The tuple of localized era values. The first element represents BC,
* the second element represents AD.
*/
/**
* The tuple of localized quarter values. The first element represents Q1.
*/
/**
* The tuple of localized day values. The first element represents Sunday.
*/
/**
* The tuple of localized month values. The first element represents January.
*/
function buildLocalizeFn(args) {
	return (value, options) => {
		const context = options?.context ? String(options.context) : "standalone";
		let valuesArray;
		if (context === "formatting" && args.formattingValues) {
			const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
			const width = options?.width ? String(options.width) : defaultWidth;
			valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
		} else {
			const defaultWidth = args.defaultWidth;
			const width = options?.width ? String(options.width) : args.defaultWidth;
			valuesArray = args.values[width] || args.values[defaultWidth];
		}
		const index = args.argumentCallback ? args.argumentCallback(value) : value;
		return valuesArray[index];
	};
}
// ../../node_modules/date-fns/locale/_lib/buildMatchFn.js
function buildMatchFn(args) {
	return (string, options = {}) => {
		const width = options.width;
		const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
		const matchResult = string.match(matchPattern);
		if (!matchResult) return null;
		const matchedString = matchResult[0];
		const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
		const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString)) : findKey(parsePatterns, (pattern) => pattern.test(matchedString));
		let value;
		value = args.valueCallback ? args.valueCallback(key) : key;
		value = options.valueCallback ? options.valueCallback(value) : value;
		const rest = string.slice(matchedString.length);
		return {
			value,
			rest
		};
	};
}
function findKey(object, predicate) {
	for (const key in object) if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
}
function findIndex(array, predicate) {
	for (let key = 0; key < array.length; key++) if (predicate(array[key])) return key;
}
// ../../node_modules/date-fns/locale/_lib/buildMatchPatternFn.js
function buildMatchPatternFn(args) {
	return (string, options = {}) => {
		const matchResult = string.match(args.matchPattern);
		if (!matchResult) return null;
		const matchedString = matchResult[0];
		const parseResult = string.match(args.parsePattern);
		if (!parseResult) return null;
		let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
		value = options.valueCallback ? options.valueCallback(value) : value;
		const rest = string.slice(matchedString.length);
		return {
			value,
			rest
		};
	};
}
// ../../node_modules/date-fns/locale/de/_lib/formatDistance.js
var formatDistanceLocale = {
	lessThanXSeconds: {
		standalone: {
			one: "weniger als 1 Sekunde",
			other: "weniger als {{count}} Sekunden"
		},
		withPreposition: {
			one: "weniger als 1 Sekunde",
			other: "weniger als {{count}} Sekunden"
		}
	},
	xSeconds: {
		standalone: {
			one: "1 Sekunde",
			other: "{{count}} Sekunden"
		},
		withPreposition: {
			one: "1 Sekunde",
			other: "{{count}} Sekunden"
		}
	},
	halfAMinute: {
		standalone: "eine halbe Minute",
		withPreposition: "einer halben Minute"
	},
	lessThanXMinutes: {
		standalone: {
			one: "weniger als 1 Minute",
			other: "weniger als {{count}} Minuten"
		},
		withPreposition: {
			one: "weniger als 1 Minute",
			other: "weniger als {{count}} Minuten"
		}
	},
	xMinutes: {
		standalone: {
			one: "1 Minute",
			other: "{{count}} Minuten"
		},
		withPreposition: {
			one: "1 Minute",
			other: "{{count}} Minuten"
		}
	},
	aboutXHours: {
		standalone: {
			one: "etwa 1 Stunde",
			other: "etwa {{count}} Stunden"
		},
		withPreposition: {
			one: "etwa 1 Stunde",
			other: "etwa {{count}} Stunden"
		}
	},
	xHours: {
		standalone: {
			one: "1 Stunde",
			other: "{{count}} Stunden"
		},
		withPreposition: {
			one: "1 Stunde",
			other: "{{count}} Stunden"
		}
	},
	xDays: {
		standalone: {
			one: "1 Tag",
			other: "{{count}} Tage"
		},
		withPreposition: {
			one: "1 Tag",
			other: "{{count}} Tagen"
		}
	},
	aboutXWeeks: {
		standalone: {
			one: "etwa 1 Woche",
			other: "etwa {{count}} Wochen"
		},
		withPreposition: {
			one: "etwa 1 Woche",
			other: "etwa {{count}} Wochen"
		}
	},
	xWeeks: {
		standalone: {
			one: "1 Woche",
			other: "{{count}} Wochen"
		},
		withPreposition: {
			one: "1 Woche",
			other: "{{count}} Wochen"
		}
	},
	aboutXMonths: {
		standalone: {
			one: "etwa 1 Monat",
			other: "etwa {{count}} Monate"
		},
		withPreposition: {
			one: "etwa 1 Monat",
			other: "etwa {{count}} Monaten"
		}
	},
	xMonths: {
		standalone: {
			one: "1 Monat",
			other: "{{count}} Monate"
		},
		withPreposition: {
			one: "1 Monat",
			other: "{{count}} Monaten"
		}
	},
	aboutXYears: {
		standalone: {
			one: "etwa 1 Jahr",
			other: "etwa {{count}} Jahre"
		},
		withPreposition: {
			one: "etwa 1 Jahr",
			other: "etwa {{count}} Jahren"
		}
	},
	xYears: {
		standalone: {
			one: "1 Jahr",
			other: "{{count}} Jahre"
		},
		withPreposition: {
			one: "1 Jahr",
			other: "{{count}} Jahren"
		}
	},
	overXYears: {
		standalone: {
			one: "mehr als 1 Jahr",
			other: "mehr als {{count}} Jahre"
		},
		withPreposition: {
			one: "mehr als 1 Jahr",
			other: "mehr als {{count}} Jahren"
		}
	},
	almostXYears: {
		standalone: {
			one: "fast 1 Jahr",
			other: "fast {{count}} Jahre"
		},
		withPreposition: {
			one: "fast 1 Jahr",
			other: "fast {{count}} Jahren"
		}
	}
};
var formatDistance = (token, count, options) => {
	let result;
	const tokenValue = options?.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
	if (typeof tokenValue === "string") result = tokenValue;
	else if (count === 1) result = tokenValue.one;
	else result = tokenValue.other.replace("{{count}}", String(count));
	if (options?.addSuffix) {
		if (options.comparison && options.comparison > 0) return "in " + result;
		else return "vor " + result;
	}
	return result;
};
var formatLong = {
	date: buildFormatLongFn({
		formats: {
			full: "EEEE, do MMMM y",
			long: "do MMMM y",
			medium: "do MMM y",
			short: "dd.MM.y"
		},
		defaultWidth: "full"
	}),
	time: buildFormatLongFn({
		formats: {
			full: "HH:mm:ss zzzz",
			long: "HH:mm:ss z",
			medium: "HH:mm:ss",
			short: "HH:mm"
		},
		defaultWidth: "full"
	}),
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} 'um' {{time}}",
			long: "{{date}} 'um' {{time}}",
			medium: "{{date}} {{time}}",
			short: "{{date}} {{time}}"
		},
		defaultWidth: "full"
	})
};
// ../../node_modules/date-fns/locale/de/_lib/formatRelative.js
var formatRelativeLocale = {
	lastWeek: "'letzten' eeee 'um' p",
	yesterday: "'gestern um' p",
	today: "'heute um' p",
	tomorrow: "'morgen um' p",
	nextWeek: "eeee 'um' p",
	other: "P"
};
var formatRelative = (token, _date, _baseDate, _options) => formatRelativeLocale[token];
// ../../node_modules/date-fns/locale/de/_lib/localize.js
var eraValues = {
	narrow: ["v.Chr.", "n.Chr."],
	abbreviated: ["v.Chr.", "n.Chr."],
	wide: ["vor Christus", "nach Christus"]
};
var quarterValues = {
	narrow: [
		"1",
		"2",
		"3",
		"4"
	],
	abbreviated: [
		"Q1",
		"Q2",
		"Q3",
		"Q4"
	],
	wide: [
		"1. Quartal",
		"2. Quartal",
		"3. Quartal",
		"4. Quartal"
	]
};
var monthValues = {
	narrow: [
		"J",
		"F",
		"M",
		"A",
		"M",
		"J",
		"J",
		"A",
		"S",
		"O",
		"N",
		"D"
	],
	abbreviated: [
		"Jan",
		"Feb",
		"Mär",
		"Apr",
		"Mai",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Okt",
		"Nov",
		"Dez"
	],
	wide: [
		"Januar",
		"Februar",
		"März",
		"April",
		"Mai",
		"Juni",
		"Juli",
		"August",
		"September",
		"Oktober",
		"November",
		"Dezember"
	]
};
var formattingMonthValues = {
	narrow: monthValues.narrow,
	abbreviated: [
		"Jan.",
		"Feb.",
		"März",
		"Apr.",
		"Mai",
		"Juni",
		"Juli",
		"Aug.",
		"Sep.",
		"Okt.",
		"Nov.",
		"Dez."
	],
	wide: monthValues.wide
};
var dayValues = {
	narrow: [
		"S",
		"M",
		"D",
		"M",
		"D",
		"F",
		"S"
	],
	short: [
		"So",
		"Mo",
		"Di",
		"Mi",
		"Do",
		"Fr",
		"Sa"
	],
	abbreviated: [
		"So.",
		"Mo.",
		"Di.",
		"Mi.",
		"Do.",
		"Fr.",
		"Sa."
	],
	wide: [
		"Sonntag",
		"Montag",
		"Dienstag",
		"Mittwoch",
		"Donnerstag",
		"Freitag",
		"Samstag"
	]
};
var dayPeriodValues = {
	narrow: {
		am: "vm.",
		pm: "nm.",
		midnight: "Mitternacht",
		noon: "Mittag",
		morning: "Morgen",
		afternoon: "Nachm.",
		evening: "Abend",
		night: "Nacht"
	},
	abbreviated: {
		am: "vorm.",
		pm: "nachm.",
		midnight: "Mitternacht",
		noon: "Mittag",
		morning: "Morgen",
		afternoon: "Nachmittag",
		evening: "Abend",
		night: "Nacht"
	},
	wide: {
		am: "vormittags",
		pm: "nachmittags",
		midnight: "Mitternacht",
		noon: "Mittag",
		morning: "Morgen",
		afternoon: "Nachmittag",
		evening: "Abend",
		night: "Nacht"
	}
};
var formattingDayPeriodValues = {
	narrow: {
		am: "vm.",
		pm: "nm.",
		midnight: "Mitternacht",
		noon: "Mittag",
		morning: "morgens",
		afternoon: "nachm.",
		evening: "abends",
		night: "nachts"
	},
	abbreviated: {
		am: "vorm.",
		pm: "nachm.",
		midnight: "Mitternacht",
		noon: "Mittag",
		morning: "morgens",
		afternoon: "nachmittags",
		evening: "abends",
		night: "nachts"
	},
	wide: {
		am: "vormittags",
		pm: "nachmittags",
		midnight: "Mitternacht",
		noon: "Mittag",
		morning: "morgens",
		afternoon: "nachmittags",
		evening: "abends",
		night: "nachts"
	}
};
var ordinalNumber = (dirtyNumber) => {
	return Number(dirtyNumber) + ".";
};
// ../../node_modules/date-fns/locale/de.js
/**
* @category Locales
* @summary German locale.
* @language German
* @iso-639-2 deu
* @author Thomas Eilmsteiner [@DeMuu](https://github.com/DeMuu)
* @author Asia [@asia-t](https://github.com/asia-t)
* @author Van Vuong Ngo [@vanvuongngo](https://github.com/vanvuongngo)
* @author RomanErnst [@pex](https://github.com/pex)
* @author Philipp Keck [@Philipp91](https://github.com/Philipp91)
*/
var de = {
	code: "de",
	formatDistance,
	formatLong,
	formatRelative,
	localize: {
		ordinalNumber,
		era: buildLocalizeFn({
			values: eraValues,
			defaultWidth: "wide"
		}),
		quarter: buildLocalizeFn({
			values: quarterValues,
			defaultWidth: "wide",
			argumentCallback: (quarter) => quarter - 1
		}),
		month: buildLocalizeFn({
			values: monthValues,
			formattingValues: formattingMonthValues,
			defaultWidth: "wide"
		}),
		day: buildLocalizeFn({
			values: dayValues,
			defaultWidth: "wide"
		}),
		dayPeriod: buildLocalizeFn({
			values: dayPeriodValues,
			defaultWidth: "wide",
			formattingValues: formattingDayPeriodValues,
			defaultFormattingWidth: "wide"
		})
	},
	match: {
		ordinalNumber: buildMatchPatternFn({
			matchPattern: /^(\d+)(\.)?/i,
			parsePattern: /\d+/i,
			valueCallback: (value) => parseInt(value)
		}),
		era: buildMatchFn({
			matchPatterns: {
				narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
				abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
				wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^v/i, /^n/i] },
			defaultParseWidth: "any"
		}),
		quarter: buildMatchFn({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^q[1234]/i,
				wide: /^[1234](\.)? Quartal/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: (index) => index + 1
		}),
		month: buildMatchFn({
			matchPatterns: {
				narrow: /^[jfmasond]/i,
				abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
				wide: /^(jänner|januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^j/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^j[aä]/i,
					/^f/i,
					/^mär/i,
					/^ap/i,
					/^mai/i,
					/^jun/i,
					/^jul/i,
					/^au/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: buildMatchFn({
			matchPatterns: {
				narrow: /^[smdmf]/i,
				short: /^(so|mo|di|mi|do|fr|sa)/i,
				abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
				wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/^so/i,
				/^mo/i,
				/^di/i,
				/^mi/i,
				/^do/i,
				/^f/i,
				/^sa/i
			] },
			defaultParseWidth: "any"
		}),
		dayPeriod: buildMatchFn({
			matchPatterns: {
				narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
				abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
				wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: {
				am: /^v/i,
				pm: /^n/i,
				midnight: /^Mitte/i,
				noon: /^Mitta/i,
				morning: /morgens/i,
				afternoon: /nachmittags/i,
				evening: /abends/i,
				night: /nachts/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 1,
		firstWeekContainsDate: 4
	}
};
// source/base/app-error-type.ts
var AppErrorTypeGroupNames = /* @__PURE__ */ function(AppErrorTypeGroupNames) {
	AppErrorTypeGroupNames["EXTERNAL"] = "EXTERNAL";
	AppErrorTypeGroupNames["INTERNAL"] = "INTERNAL";
	AppErrorTypeGroupNames["INVALID"] = "INVALID";
	AppErrorTypeGroupNames["NOT_FOUND"] = "NOT_FOUND";
	AppErrorTypeGroupNames["UNAUTHENTICATED"] = "UNAUTHENTICATED";
	AppErrorTypeGroupNames["UNAUTHORIZED"] = "UNAUTHORIZED";
	return AppErrorTypeGroupNames;
}(AppErrorTypeGroupNames || {});
var AppErrorType = /* @__PURE__ */ function(AppErrorType) {
	AppErrorType["EXTERNAL_GCLOUD"] = "EXTERNAL_GCLOUD";
	AppErrorType["EXTERNAL_MAILER_SEND"] = "EXTERNAL_MAILER_SEND";
	AppErrorType["EXTERNAL_MONDAY"] = "EXTERNAL_MONDAY";
	AppErrorType["FAILED_DB_UPDATE"] = "FAILED_DB_UPDATE";
	AppErrorType["FAILED_FILE_UPLOAD"] = "FAILED_FILE_UPLOAD";
	AppErrorType["INTERNAL_MAINTENANCE_MODE"] = "INTERNAL_MAINTENANCE_MODE";
	AppErrorType["INTERNAL_NOT_IMPLEMENTED"] = "INTERNAL_NOT_IMPLEMENTED";
	AppErrorType["INTERNAL_OTHER"] = "INTERNAL_OTHER";
	AppErrorType["INTERNAL_INSERT_FAILED"] = "INTERNAL_INSERT_FAILED";
	AppErrorType["INVALID_APPLICANT_NOT_ARCHIVED"] = "APPLICANT_NOT_ARCHIVED";
	AppErrorType["INVALID_APPLICANT_ARCHIVED"] = "INVALID_APPLICANT_ARCHIVED";
	AppErrorType["INVALID_JOB_POSITION_NOT_ARCHIVED"] = "JOB_POSITION_NOT_ARCHIVED";
	AppErrorType["INVALID_JOB_POSITION_ARCHIVED"] = "JOB_POSITION_ARCHIVED";
	AppErrorType["INVALID_JOB_POSITION_HAS_APPLICANTS"] = "INVALID_JOB_POSITION_HAS_APPLICANTS";
	AppErrorType["INVALID_JOB_POSITION_BA_SYNCED"] = "INVALID_JOB_POSITION_BA_SYNCED";
	AppErrorType["INVALID_APPLICANT_SOURCE_PROPS"] = "INVALID_APPLICANT_SOURCE_PROPS";
	AppErrorType["INVALID_AUTHORIZATION_REFRESH_TOKEN"] = "INVALID_AUTHORIZATION_REFRESH_TOKEN";
	AppErrorType["INVALID_AUTOMATIC_CRON_INVOCATION_PROTECTION"] = "INVALID_AUTOMATIC_CRON_INVOCATION_PROTECTION";
	AppErrorType["INVALID_CONFLICT"] = "CONFLICT";
	AppErrorType["INVALID_SIGNATURE_IN_USE"] = "INVALID_SIGNATURE_IN_USE";
	AppErrorType["INVALID_SIGNATURE_IS_DEFAULT"] = "INVALID_SIGNATURE_IS_DEFAULT";
	AppErrorType["INVALID_DUPLICATE_DOCUMENT"] = "DUPLICATE_DOCUMENT";
	AppErrorType["INVALID_MAX_APPLICANT_DOCUMENTS"] = "MAX_APPLICANT_DOCUMENTS";
	AppErrorType["INVALID_MONDAY_DATA"] = "INVALID_MONDAY_DATA";
	AppErrorType["INVALID_ORIGIN"] = "INVALID_ORIGIN";
	AppErrorType["INVALID_PASSWORD"] = "INVALID_PASSWORD";
	AppErrorType["INVALID_REQUEST_BODY"] = "INVALID_REQUEST_BODY";
	AppErrorType["INVALID_REQUEST_DATA"] = "INVALID_REQUEST_DATA";
	AppErrorType["INVALID_REQUEST_PARAMS"] = "INVALID_REQUEST_PARAMS";
	AppErrorType["INVALID_REQUEST_QUERY_PARAMS"] = "INVALID_REQUEST_QUERY_PARAMS";
	AppErrorType["INVALID_TEST_EMAIL"] = "INVALID_TEST_EMAIL";
	AppErrorType["INVALID_EMAIL_RECIPIENTS"] = "INVALID_EMAIL_RECIPIENTS";
	AppErrorType["INVALID_CAREER_DOMAIN_ALREADY_EXISTS"] = "INVALID_CAREER_DOMAIN_ALREADY_EXISTS";
	AppErrorType["INVALID_EMAIL_PROVIDER"] = "INVALID_EMAIL_PROVIDER";
	AppErrorType["INVALID_ALTERNATIVE_SENDER_DOMAIN"] = "INVALID_ALTERNATIVE_SENDER_DOMAIN";
	AppErrorType["INVALID_HRBAXML_CONFIG_INACTIVE"] = "INVALID_HRBAXML_CONFIG_INACTIVE";
	AppErrorType["INVALID_HRBAXML_CONFIG_INCOMPLETE"] = "INVALID_HRBAXML_CONFIG_INCOMPLETE";
	AppErrorType["INVALID_HIRING_GUARANTEE_INACTIVE"] = "INVALID_HIRING_GUARANTEE_INACTIVE";
	AppErrorType["INVALID_NO_OVERDUE_STATUS_UPDATES"] = "INVALID_NO_OVERDUE_STATUS_UPDATES";
	AppErrorType["NETWORK"] = "NETWORK";
	AppErrorType["INVALID_WEBHOOK"] = "INVALID_WEBHOOK";
	AppErrorType["INVALID_TOKEN"] = "INVALID_TOKEN";
	AppErrorType["INVALID_CAREER_DOMAIN_NOT_READY"] = "INVALID_CAREER_DOMAIN_NOT_READY";
	AppErrorType["INVALID_CAREER_SETTINGS_NOT_ACTIVE"] = "INVALID_CAREER_SETTINGS_NOT_ACTIVE";
	AppErrorType["INVALID_CERTIFICATE_NOT_READY"] = "INVALID_CERTIFICATE_NOT_READY";
	AppErrorType["INVALID_JOB_POSITION_NAME_ALREADY_EXISTS"] = "INVALID_JOB_POSITION_NAME_ALREADY_EXISTS";
	AppErrorType["INVALID_CAREER_PAGE_INACTIVE"] = "INVALID_CAREER_PAGE_INACTIVE";
	AppErrorType["INVALID_DELETION_IN_PROGRESS"] = "INVALID_DELETION_IN_PROGRESS";
	AppErrorType["INVALID_UNSUPPORTED_FILE_TYPE"] = "INVALID_UNSUPPORTED_FILE_TYPE";
	AppErrorType["NOT_FOUND_APPLICANT"] = "NOT_FOUND_APPLICANT";
	AppErrorType["NOT_FOUND_APPLICANT_DOCUMENT"] = "NOT_FOUND_APPLICANT_DOCUMENT";
	AppErrorType["NOT_FOUND_APPLICANT_PHASE"] = "NOT_FOUND_APPLICANT_PHASE";
	AppErrorType["NOT_FOUND_APPLICANT_MANAGER"] = "NOT_FOUND_APPLICANT_MANAGER";
	AppErrorType["NOT_FOUND_APPLICANT_SOURCE"] = "NOT_FOUND_APPLICANT_SOURCE";
	AppErrorType["NOT_FOUND_EMAIL_TEMPLATE"] = "NOT_FOUND_EMAIL_TEMPLATE";
	AppErrorType["NOT_FOUND_COMPANY"] = "NOT_FOUND_COMPANY";
	AppErrorType["NOT_FOUND_CUSTOMER"] = "NOT_FOUND_CUSTOMER";
	AppErrorType["NOT_FOUND_LOCATION"] = "NOT_FOUND_LOCATION";
	AppErrorType["NOT_FOUND_SCHEDULED_EMAIL"] = "NOT_FOUND_SCHEDULED_EMAIL";
	AppErrorType["NOT_FOUND_MAP_ROUTE"] = "NOT_FOUND_MAP_ROUTE";
	AppErrorType["NOT_FOUND_WORK_AREA"] = "NOT_FOUND_WORK_AREA";
	AppErrorType["NOT_FOUND_JOB_POSITION"] = "NOT_FOUND_JOB_POSITION";
	AppErrorType["NOT_FOUND_JOB_POSITION_TEMPLATE"] = "NOT_FOUND_JOB_POSITION_TEMPLATE";
	AppErrorType["NOT_FOUND_MIGRATION"] = "NOT_FOUND_MIGRATION";
	AppErrorType["NOT_FOUND_PHASE_TO_SUPPORTED_PHASE"] = "NOT_FOUND_PHASE_TO_SUPPORTED_PHASE";
	AppErrorType["NOT_FOUND_PLATFORM"] = "NOT_FOUND_PLATFORM";
	AppErrorType["NOT_FOUND_ROUTE"] = "NOT_FOUND_ROUTE";
	AppErrorType["NOT_FOUND_WEBHOOK"] = "NOT_FOUND_WEBHOOK";
	AppErrorType["NOT_FOUND_SCORE_CARD"] = "NOT_FOUND_SCORE_CARD";
	AppErrorType["NOT_FOUND_APPLICANT_STATUS_UPDATE"] = "NOT_FOUND_APPLICANT_STATUS_UPDATE";
	AppErrorType["NOT_FOUND_CUSTOMER_MONDAY_DATA"] = "NOT_FOUND_CUSTOMER_MONDAY_DATA";
	AppErrorType["NOT_FOUND_APPLICANT_AUTOMATION_TEMPLATE"] = "NOT_FOUND_APPLICANT_AUTOMATION_TEMPLATE";
	AppErrorType["NOT_FOUND_BLOCKED_APPLICANT"] = "NOT_FOUND_BLOCKED_APPLICANT";
	AppErrorType["NOT_FOUND_CAREER_DOMAIN"] = "NOT_FOUND_CAREER_DOMAIN";
	AppErrorType["NOT_FOUND_URL_MAP"] = "NOT_FOUND_URL_MAP";
	AppErrorType["NOT_FOUND_CERTIFICATE"] = "NOT_FOUND_CERTIFICATE";
	AppErrorType["NOT_FOUND_CERTIFICATE_MAP"] = "NOT_FOUND_CERTIFICATE_MAP";
	AppErrorType["NOT_FOUND_BACKEND_BUCKET"] = "NOT_FOUND_BACKEND_BUCKET";
	AppErrorType["NOT_FOUND_CAREER_SETTINGS"] = "NOT_FOUND_CAREER_SETTINGS";
	AppErrorType["NOT_FOUND_EMAIL_PROVIDER"] = "NOT_FOUND_EMAIL_PROVIDER";
	AppErrorType["NOT_FOUND_CUSTOMER_EMAIL_TEMPLATE"] = "NOT_FOUND_CUSTOMER_EMAIL_TEMPLATE";
	AppErrorType["NOT_FOUND_CUSTOMER_EMAIL_SIGNATURE"] = "NOT_FOUND_CUSTOMER_EMAIL_SIGNATURE";
	AppErrorType["NOT_FOUND_EMAIL_PROVIDER_OAUTH_TOKEN"] = "NOT_FOUND_EMAIL_PROVIDER_OAUTH_TOKEN";
	AppErrorType["NOT_FOUND_UMAMI_WEBSITE"] = "NOT_FOUND_UMAMI_WEBSITE";
	AppErrorType["NOT_FOUND_CUSTOMER_ANALYTICS"] = "NOT_FOUND_CUSTOMER_ANALYTICS";
	AppErrorType["NOT_FOUND_CUSTOMER_FONT"] = "NOT_FOUND_CUSTOMER_FONT";
	AppErrorType["NOT_FOUND_MONDAY_RECRUITING"] = "NOT_FOUND_MONDAY_RECRUITING";
	AppErrorType["NOT_FOUND_RECRUITING_LOG_ENTRY"] = "NOT_FOUND_RECRUITING_LOG_ENTRY";
	AppErrorType["NOT_FOUND_HRBAXML_CONFIG"] = "NOT_FOUND_HRBAXML_CONFIG";
	AppErrorType["NOT_FOUND_HRBAXML_CERT"] = "NOT_FOUND_HRBAXML_CERT";
	AppErrorType["OTHER"] = "OTHER";
	AppErrorType["UNAUTHENTICATED_PERMISSION"] = "UNAUTHENTICATED_PERMISSION";
	AppErrorType["UNAUTHENTICATED_ROLE"] = "UNAUTHENTICATED_ROLE";
	AppErrorType["UNAUTHORIZED_CREDENTIALS"] = "UNAUTHORIZED_CREDENTIALS";
	AppErrorType["UNAUTHORIZED_AUTHORIZATION_HEADER_FORMAT"] = "UNAUTHORIZED_AUTHORIZATION_HEADER_FORMAT";
	AppErrorType["UNAUTHORIZED_AUTHORIZATION_HEADER_MISSING"] = "UNAUTHORIZED_AUTHORIZATION_HEADER_MISSING";
	AppErrorType["AUTHORIZATION_HEADER_OR_QUERY_TOKEN_MISSING"] = "AUTHORIZATION_HEADER_OR_QUERY_TOKEN_MISSING";
	AppErrorType["UNAUTHORIZED_GCLOUD_OAUTH2_CLIENT"] = "UNAUTHORIZED_GCLOUD_OAUTH2_CLIENT";
	AppErrorType["UNAUTHORIZED_JWT_FORMAT"] = "UNAUTHORIZED_JWT_FORMAT";
	AppErrorType["UNAUTHORIZED_WEBHOOK"] = "UNAUTHORIZED_WEBHOOK";
	AppErrorType["UNAUTHORIZED_INTEGRATION"] = "UNAUTHORIZED_INTEGRATION";
	AppErrorType["UNAUTHORIZED_P12_CERTIFICATE_MISSING"] = "UNAUTHORIZED_P12_CERTIFICATE_MISSING";
	AppErrorType["UNAUTHORIZED_P12_CERTIFICATE_EXPIRED"] = "UNAUTHORIZED_P12_CERTIFICATE_EXPIRED";
	AppErrorType["COURSE_NOT_FOUND"] = "COURSE_NOT_FOUND";
	AppErrorType["CHAPTER_NOT_FOUND"] = "CHAPTER_NOT_FOUND";
	AppErrorType["LESSON_NOT_FOUND"] = "LESSON_NOT_FOUND";
	AppErrorType["DNS_AUTHORIZATION_ERROR"] = "DNS_AUTHORIZATION_ERROR";
	AppErrorType["INTERNAL_NO_FREE_LOAD_BALANCER"] = "INTERNAL_NO_FREE_LOAD_BALANCER";
	AppErrorType["INTERNAL_LOAD_BALANCER_NOT_FOUND"] = "INTERNAL_LOAD_BALANCER_NOT_FOUND";
	AppErrorType["INTERNAL_OAUTH_TOKEN_STORE_FAILED"] = "INTERNAL_OAUTH_TOKEN_STORE_FAILED";
	AppErrorType["INTERNAL_OAUTH_ACQUIRE_TOKEN_FAILED"] = "INTERNAL_OAUTH_ACQUIRE_TOKEN_FAILED";
	AppErrorType["INTERNAL_OAUTH_TOKEN_REFRESH_FAILED"] = "INTERNAL_OAUTH_TOKEN_REFRESH_FAILED";
	AppErrorType["INVALID_OAUTH_TOKEN"] = "INVALID_OAUTH_TOKEN";
	AppErrorType["INTERNAL_CAREER_PAGE_GENERATION_FAILED"] = "INTERNAL_CAREER_PAGE_GENERATION_FAILED";
	AppErrorType["INTERNAL_SCHEDULED_EMAIL_CREATION_FAILED"] = "INTERNAL_SCHEDULED_EMAIL_CREATION_FAILED";
	AppErrorType["INTERNAL_SCHEDULED_EMAIL_UPDATE_FAILED"] = "INTERNAL_SCHEDULED_EMAIL_UPDATE_FAILED";
	AppErrorType["INTERNAL_SCHEDULED_EMAIL_NOT_AVAILABLE_IN_DEV"] = "INTERNAL_SCHEDULED_EMAIL_NOT_AVAILABLE_IN_DEV";
	AppErrorType["INTERNAL_SCHEDULED_EMAIL_CANCELLATION_FAILED"] = "INTERNAL_SCHEDULED_EMAIL_CANCELLATION_FAILED";
	AppErrorType["INTERNAL_CLOUD_TASKS_NOT_AVAILABLE_IN_DEV"] = "INTERNAL_CLOUD_TASKS_NOT_AVAILABLE_IN_DEV";
	AppErrorType["INTERNAL_JOB_POSITION_COULD_NOT_BE_CREATED"] = "INTERNAL_JOB_POSITION_COULD_NOT_BE_CREATED";
	AppErrorType["INTERNAL_COULD_NOT_CREATE_APPLICANT_MANAGER"] = "INTERNAL_COULD_NOT_CREATE_APPLICANT_MANAGER";
	AppErrorType["INTERNAL_COULD_NOT_SYNC_APPLICANT_MANAGERS"] = "INTERNAL_COULD_NOT_SYNC_APPLICANT_MANAGERS";
	AppErrorType["INTERNAL_COULD_NOT_SCRAPE_CUSTOMERS"] = "INTERNAL_COULD_NOT_SCRAPE_CUSTOMERS";
	AppErrorType["INTERNAL_COULD_NOT_CREATE_JOB_POSITION_TEMPLATE"] = "INTERNAL_COULD_NOT_CREATE_JOB_POSITION_TEMPLATE";
	AppErrorType["INTERNAL_MICROSOFT_EMAIL_COULD_NOT_BE_SENT"] = "INTERNAL_MICROSOFT_EMAIL_COULD_NOT_BE_SENT";
	AppErrorType["INTERNAL_SMTP_EMAIL_COULD_NOT_BE_SENT"] = "INTERNAL_SMTP_EMAIL_COULD_NOT_BE_SENT";
	AppErrorType["INTERNAL_MONDAY_SETTINGS_COULD_NOT_BE_SCRAPED"] = "INTERNAL_MONDAY_SETTINGS_COULD_NOT_BE_SCRAPED";
	AppErrorType["INTERNAL_MONDAY_RECRUITING_COULD_NOT_BE_SCRAPED"] = "INTERNAL_MONDAY_RECRUITING_COULD_NOT_BE_SCRAPED";
	AppErrorType["INTERNAL_COULD_NOT_CREATE_CUSTOMER_ANALYTICS"] = "INTERNAL_COULD_NOT_CREATE_CUSTOMER_ANALYTICS";
	AppErrorType["INTERNAL_UMAMI_REQUEST_FAILED"] = "INTERNAL_UMAMI_REQUEST_FAILED";
	AppErrorType["INTERNAL_COULD_NOT_CREATE_EMAIL_PROVIDER"] = "INTERNAL_COULD_NOT_CREATE_EMAIL_PROVIDER";
	AppErrorType["INTERNAL_COULD_NOT_UPDATE_EMAIL_PROVIDER"] = "INTERNAL_COULD_NOT_UPDATE_EMAIL_PROVIDER";
	AppErrorType["UNSAFE_DOCUMENT"] = "UNSAFE_DOCUMENT";
	return AppErrorType;
}(AppErrorType || {});
var formatAppErrorType = (appErrorType) => {
	switch (appErrorType) {
		case "EXTERNAL_MONDAY": return "Es ist ein externer Fehler mit Monday aufgetreten.";
		case "EXTERNAL_GCLOUD": return "Es ist ein externer Fehler mit dem Datenspeicher aufgetreten.";
		case "EXTERNAL_MAILER_SEND": return "Es ist ein externer Fehler mit dem Mailversender aufgetreten.";
		case "FAILED_DB_UPDATE": return "Es ist ein Fehler beim Speichern der Daten aufgetreten.";
		case "FAILED_FILE_UPLOAD": return "Es ist ein Fehler beim Hochladen der Datei aufgetreten.";
		case "INTERNAL_NOT_IMPLEMENTED": return "Die Funktion ist nicht implementiert.";
		case "INTERNAL_MAINTENANCE_MODE": return "Der Server ist im Wartungsmodus.";
		case "INTERNAL_OTHER": return "Es ist ein interner Serverfehler aufgetreten.";
		case "INVALID_REQUEST_DATA":
		case "INVALID_REQUEST_BODY":
		case "INVALID_REQUEST_PARAMS":
		case "INVALID_REQUEST_QUERY_PARAMS": return "Die Eingabedaten sind ungültig.";
		case "INVALID_PASSWORD": return "Das Passwort ist falsch.";
		case "INVALID_ORIGIN": return "Von diesem Gerät können keine Anfragen an den Server gesendet werden.";
		case "INVALID_AUTOMATIC_CRON_INVOCATION_PROTECTION": return "Die Funktion darf nicht automatisch aufgerufen werden.";
		case "INVALID_MONDAY_DATA": return "Daten in Monday sind ungültig.";
		case "INVALID_APPLICANT_SOURCE_PROPS": return "Die Quellenangaben des Bewerbers sind ungültig.";
		case "CONFLICT": return "Ein Konflikt ist aufgetreten.";
		case "DUPLICATE_DOCUMENT": return "Das Dokument existiert bereits.";
		case "MAX_APPLICANT_DOCUMENTS": return "Die maximale Anzahl an Bewerbungsdokumenten wurde erreicht.";
		case "INVALID_TEST_EMAIL": return "Die Test-E-Mail-Adresse ist ungültig.";
		case "INVALID_EMAIL_RECIPIENTS": return "Die Empfängeradresse(n) sind ungültig.";
		case "INVALID_HIRING_GUARANTEE_INACTIVE": return "Für diesen Kunden ist das automatisierte Erkennen einer Verletzung der Garantiebedingungen nicht aktiv.";
		case "INVALID_NO_OVERDUE_STATUS_UPDATES": return "Bei keinem Kandidaten ist das Status-Update überfällig.";
		case "INVALID_ALTERNATIVE_SENDER_DOMAIN": return "Die alternative Absenderadresse muss dieselbe Domain wie das verbundene Postfach verwenden. Andernfalls stufen E-Mail-Anbieter wie web.de oder GMX die E-Mails als Spam ein oder lehnen sie ab.";
		case "NETWORK": return "Ein Netzwerkfehler ist aufgetreten.";
		case "INVALID_WEBHOOK": return "Der Webhook ist ungültig.";
		case "INVALID_JOB_POSITION_BA_SYNCED": return "Diese Stelle ist mit der Bundesagentur für Arbeit synchronisiert und kann nicht direkt gelöscht werden.";
		case "NOT_FOUND_CUSTOMER": return "Der Kunde wurde nicht gefunden.";
		case "NOT_FOUND_MIGRATION": return "Die Migration wurde nicht gefunden.";
		case "NOT_FOUND_APPLICANT": return "Der Bewerber wurde nicht gefunden.";
		case "NOT_FOUND_ROUTE": return "Die URL wurde nicht gefunden.";
		case "NOT_FOUND_MONDAY_RECRUITING": return "Der Recruiting-Eintrag wurde nicht gefunden.";
		case "NOT_FOUND_RECRUITING_LOG_ENTRY": return "Der Verlaufseintrag wurde nicht gefunden.";
		case "UNAUTHORIZED_AUTHORIZATION_HEADER_FORMAT":
		case "UNAUTHORIZED_AUTHORIZATION_HEADER_MISSING": return "Nicht berechtigt.";
		case "UNAUTHORIZED_GCLOUD_OAUTH2_CLIENT": return "Der Gcloud OAuth2 Client ist nicht berechtigt.";
		case "UNAUTHORIZED_CREDENTIALS": return "Anmeldedaten sind nicht berechtigt.";
		case "UNAUTHORIZED_JWT_FORMAT": return "Ungültiges JWT-Format.";
		case "UNAUTHORIZED_WEBHOOK": return "Nicht berechtigter Webhook.";
		case "UNAUTHORIZED_INTEGRATION": return "Nicht berechtigte Integration.";
		case "UNAUTHENTICATED_PERMISSION":
		case "UNAUTHENTICATED_ROLE": return "Sie sind nicht angemeldet oder Ihre Berechtigungen sind unzureichend.";
		default: return "Es ist ein unbekannter Fehler aufgetreten.";
	}
};
// source/base/app-error.ts
var AppError = class extends Error {
	type;
	details;
	originalError;
	customMessage;
	constructor({ type, details, originalError, customMessage }) {
		super(type);
		this.type = type;
		this.details = details;
		this.originalError = originalError;
		this.customMessage = customMessage;
	}
	format() {
		if (this.customMessage !== null) return this.customMessage;
		return formatAppErrorType(this.type);
	}
};
// source/config/environment.ts
var Environment = /* @__PURE__ */ function(Environment) {
	Environment["DEVELOPMENT"] = "development";
	Environment["STAGING"] = "staging";
	Environment["PRODUCTION"] = "production";
	return Environment;
}(Environment || {});
// source/config/get-environment.ts
var getEnvironment = () => {
	return "production";
};
// source/config/check-is-development-environment.ts
var checkIsDevelopmentEnvironment = () => getEnvironment() === Environment.DEVELOPMENT;
// source/config/check-is-production-environment.ts
var checkIsProductionEnvironment = () => getEnvironment() === Environment.PRODUCTION;
// source/config/check-is-production-or-staging-environment.ts
var checkIsProductionOrStagingEnvironment = () => getEnvironment() === Environment.PRODUCTION || getEnvironment() === Environment.STAGING;
// source/config/base-config.ts
var BaseConfig = class {
	homePageUrl;
	imprintUrl;
	dataPrivacyUrl;
	appUrl;
	apiUrl;
	apiPort;
	aiApiUrl;
	resumeBuilderUrl;
	timeZone;
	timeout;
	documentFileSizeLimit;
	smallImageFileSize;
	mediumImageFileSize;
	largeImageFileSize;
	applicantDocumentLimit;
	archivedApplicantsTtl;
	jobPositionEmailRecipientLimit;
	maxEmailDelayInMs;
	defaultResumePrimaryColor;
	defaultResumePrimaryContrastColor;
	gcloudBucketNameSuffix;
	sharedApplicantUrl;
	testAccountMondayItemId;
	constructor({ homePageUrl = "https://www.stahlhart-recruiting.de", imprintUrl = "https://www.stahlhart-recruiting.de/impressum", dataPrivacyUrl = "https://www.stahlhart-recruiting.de/datenschutzerklarung", appUrl, apiUrl, apiPort, aiApiUrl, resumeBuilderUrl, timeZone = "Europe/Berlin", timeout = dateFns.milliseconds({ minutes: 5 }), documentFileSizeLimit = 31457280, smallImageFileSize = 512e3, mediumImageFileSize = 2097152, largeImageFileSize = 10485760, applicantDocumentLimit = 30, archivedApplicantsTtl = 2592e6, jobPositionEmailRecipientLimit = 5, maxEmailDelayInMs = 2556e5, defaultResumePrimaryColor = "#000000", defaultResumePrimaryContrastColor = "#FFFFFF", gcloudBucketNameSuffix, sharedApplicantUrl, testAccountMondayItemId = "1861388767" }) {
		this.homePageUrl = homePageUrl;
		this.imprintUrl = imprintUrl;
		this.dataPrivacyUrl = dataPrivacyUrl;
		this.appUrl = appUrl;
		this.apiUrl = apiUrl;
		this.apiPort = apiPort;
		this.aiApiUrl = aiApiUrl;
		this.resumeBuilderUrl = resumeBuilderUrl;
		this.timeZone = timeZone;
		this.timeout = timeout;
		this.documentFileSizeLimit = documentFileSizeLimit;
		this.smallImageFileSize = smallImageFileSize;
		this.mediumImageFileSize = mediumImageFileSize;
		this.largeImageFileSize = largeImageFileSize;
		this.applicantDocumentLimit = applicantDocumentLimit;
		this.archivedApplicantsTtl = archivedApplicantsTtl;
		this.jobPositionEmailRecipientLimit = jobPositionEmailRecipientLimit;
		this.maxEmailDelayInMs = maxEmailDelayInMs;
		this.defaultResumePrimaryColor = defaultResumePrimaryColor;
		this.defaultResumePrimaryContrastColor = defaultResumePrimaryContrastColor;
		this.gcloudBucketNameSuffix = gcloudBucketNameSuffix;
		this.sharedApplicantUrl = sharedApplicantUrl;
		this.testAccountMondayItemId = testAccountMondayItemId;
	}
};
// source/config/generate-config.development.ts
var generateDevelopmentConfig = () => new BaseConfig({
	appUrl: "http://localhost:7010",
	apiUrl: "http://127.0.0.1:7001",
	apiPort: 7001,
	aiApiUrl: "http://127.0.0.1:7002",
	resumeBuilderUrl: "http://127.0.0.1:7011",
	gcloudBucketNameSuffix: "development.partner-portal.stahlhart-recruiting.de",
	sharedApplicantUrl: "http://127.0.0.1:7012"
});
// source/config/generate-config.production.ts
var generateProductionConfig = () => new BaseConfig({
	appUrl: "https://partner-portal.stahlhart-recruiting.de",
	apiUrl: "https://api.partner-portal.stahlhart-recruiting.de",
	apiPort: Number.parseInt(process?.env?.PORT || "8080", 10),
	aiApiUrl: "https://ai-api.partner-portal.stahlhart-recruiting.de",
	resumeBuilderUrl: "https://lebenslauf.bewerbungen-kurz.de",
	gcloudBucketNameSuffix: "partner-portal.stahlhart-recruiting.de",
	sharedApplicantUrl: "https://bewerber.stahlhart-recruiting.de"
});
// source/config/generate-config.staging.ts
var generateStagingConfig = () => new BaseConfig({
	appUrl: "https://app-137825522572.europe-west1.run.app",
	apiUrl: "https://api-137825522572.europe-west1.run.app",
	apiPort: Number.parseInt(process.env.PORT, 10),
	aiApiUrl: "https://ai-api-137825522572.europe-west1.run.app",
	resumeBuilderUrl: "https://resume-builder-137825522572.europe-west1.run.app",
	gcloudBucketNameSuffix: "staging.partner-portal.stahlhart-recruiting.de",
	sharedApplicantUrl: "https://shared-applicant-137825522572.europe-west1.run.app"
});
// source/config/config.ts
var config;
switch (getEnvironment()) {
	case Environment.DEVELOPMENT:
		config = generateDevelopmentConfig();
		break;
	case Environment.STAGING:
		config = generateStagingConfig();
		break;
	case Environment.PRODUCTION:
		config = generateProductionConfig();
		break;
	default: throw new Error(`Invalid environment: ${getEnvironment()}`);
}
// source/enums/applicant-phase-type.ts
var ApplicantPhaseType = {
	CONTACT_STAHLHART: "CONTACT_STAHLHART",
	WAITING_FOR_DOCUMENTS_STAHLHART: "WAITING_FOR_DOCUMENTS_STAHLHART",
	CONTACT_PARTNER: "CONTACT_PARTNER",
	WAITING_FOR_INTERVIEW: "WAITING_FOR_INTERVIEW",
	SECOND_INTERVIEW_SCHEDULED: "SECOND_INTERVIEW_SCHEDULED",
	WAITING_FOR_SECOND_INTERVIEW: "WAITING_FOR_SECOND_INTERVIEW",
	CONTRACT_PENDING: "CONTRACT_PENDING",
	WAITING_FOR_SIGNATURE: "WAITING_FOR_SIGNATURE",
	HIRED: "HIRED",
	TALENT_POOL: "TALENT_POOL",
	NOT_REACHED_STAHLHART: "NOT_REACHED_STAHLHART",
	NOT_REACHED_PARTNER: "NOT_REACHED_PARTNER",
	REJECTED_STAHLHART: "REJECTED_STAHLHART",
	REJECTED_PARTNER: "REJECTED_PARTNER",
	REJECTED_APPLICANT: "REJECTED_APPLICANT"
};
// source/enums/applicant-score-ratings.ts
var ApplicantScoreRatings = {
	APPROVED: "APPROVED",
	PARTIAL: "PARTIAL",
	REJECTED: "REJECTED"
};
// source/enums/applicant-source-type.ts
var ApplicantSourceType = {
	SOCIAL_MEDIA_CAMPAIGN: "SOCIAL_MEDIA_CAMPAIGN",
	GOOGLE_ADS: "GOOGLE_ADS",
	DIRECT_APPROACH: "DIRECT_APPROACH",
	JOB_PORTAL: "JOB_PORTAL",
	EMPLOYEE_REFERRAL: "EMPLOYEE_REFERRAL",
	TRADE_FAIR: "TRADE_FAIR",
	OTHER: "OTHER",
	INTERNAL_TALENT_POOL: "INTERNAL_TALENT_POOL",
	GOOGLE_SEARCH: "GOOGLE_SEARCH",
	GOOGLE_FOR_JOBS: "GOOGLE_FOR_JOBS",
	UNKNOWN: "UNKNOWN"
};
// source/enums/career-page-status.ts
var CareerPageStatus = {
	ACTIVE: "ACTIVE",
	INACTIVE: "INACTIVE",
	IN_PREPARATION: "IN_PREPARATION",
	NOT_BOOKED: "NOT_BOOKED"
};
// source/enums/customer-acquisition-search-ad-status.ts
var CustomerAcquisitionSearchAdStatus = {
	ACTIVE: "ACTIVE",
	IN_PREPARATION: "IN_PREPARATION",
	INACTIVE: "INACTIVE",
	NOT_BOOKED: "NOT_BOOKED"
};
// source/enums/document-type.ts
/**
* Document types which are allowed in the DB.
* We allow more in the DB then in the upload for backwards compatibility.
*/
var DocumentType = {
	PDF: "PDF",
	DOC: "DOC",
	DOCX: "DOCX",
	TXT: "TXT",
	JPG: "JPG",
	PNG: "PNG",
	SVG: "SVG"
};
DocumentType.PDF, DocumentType.JPG, DocumentType.PNG, DocumentType.SVG;
// source/enums/document-mime-type.ts
var UploadDocumentMimeTypeMap = {
	[DocumentType.PDF]: "application/pdf",
	[DocumentType.JPG]: "image/jpeg",
	[DocumentType.PNG]: "image/png",
	[DocumentType.SVG]: "image/svg+xml"
};
DocumentType.JPG, DocumentType.PNG, DocumentType.SVG;
var AcceptedDocuments = {
	"application/pdf": [".pdf"],
	"image/jpeg": [".jpg", ".jpeg"],
	"image/png": [".png"],
	"image/svg+xml": [".svg"]
};
var AcceptedImages = { "image/jpeg": [".jpg", ".jpeg"] };
var AcceptedLogoImages = {
	"image/png": [".png"],
	"image/svg+xml": [".svg"]
};
var DocumentMimeTypeMap = {
	[DocumentType.PDF]: "application/pdf",
	[DocumentType.DOC]: "application/msword",
	[DocumentType.DOCX]: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	[DocumentType.TXT]: "text/plain",
	[DocumentType.JPG]: "image/jpeg",
	[DocumentType.PNG]: "image/png",
	[DocumentType.SVG]: "image/svg+xml"
};
var InverseDocumentMimeTypeMap = Object.fromEntries(Object.entries(DocumentMimeTypeMap).map((a) => a.reverse()));
// source/enums/document-source.ts
var DocumentSource = { G_CLOUD: "G_CLOUD" };
// source/enums/email-content-type.ts
var EmailContentType = {
	TEXT: "TEXT",
	HTML: "HTML",
	MJML: "MJML"
};
// source/enums/email-target.ts
var EmailTarget = {
	CUSTOMER: "CUSTOMER",
	EMPLOYEE: "EMPLOYEE",
	TRAINEE_AND_DUAL_STUDENT: "TRAINEE_AND_DUAL_STUDENT",
	INTERNAL: "INTERNAL"
};
// source/enums/email-template-key.ts
var EmailTemplateKey = /* @__PURE__ */ function(EmailTemplateKey) {
	EmailTemplateKey["APPLICATION_FORWARDED"] = "APPLICATION_FORWARDED";
	EmailTemplateKey["APPLICATION_FORWARDED_TRAINEES_DUAL_STUDENTS"] = "APPLICATION_FORWARDED_TRAINEES_DUAL_STUDENTS";
	EmailTemplateKey["AUTO_CONFIRMATION_EMPLOYEE"] = "AUTO_CONFIRMATION_EMPLOYEE";
	EmailTemplateKey["AUTO_CONFIRMATION_EMPLOYEE_TRAINEES_DUAL_STUDENTS"] = "AUTO_CONFIRMATION_EMPLOYEE_TRAINEES_DUAL_STUDENTS";
	EmailTemplateKey["AUTO_CONFIRMATION_TRAINEES_DUAL_STUDENTS"] = "AUTO_CONFIRMATION_TRAINEES_DUAL_STUDENTS";
	EmailTemplateKey["CALL_ATTEMPT_FAILED_1_TIME"] = "CALL_ATTEMPT_FAILED_1_TIME";
	EmailTemplateKey["CALL_ATTEMPT_FAILED_1_TIME_TRAINEES_DUAL_STUDENTS"] = "CALL_ATTEMPT_FAILED_1_TIME_TRAINEES_DUAL_STUDENTS";
	EmailTemplateKey["CAREER_PAGE_DOMAIN_DNS_BACK_ONLINE"] = "CAREER_PAGE_DOMAIN_DNS_BACK_ONLINE";
	EmailTemplateKey["CAREER_PAGE_DOMAIN_DNS_FAILED"] = "CAREER_PAGE_DOMAIN_DNS_FAILED";
	EmailTemplateKey["CAREER_PAGE_DOMAIN_READY"] = "CAREER_PAGE_DOMAIN_READY";
	EmailTemplateKey["CUSTOM"] = "CUSTOM";
	EmailTemplateKey["DOCUMENTS_RECEIVED_TRAINEES_DUAL_STUDENTS"] = "DOCUMENTS_RECEIVED_TRAINEES_DUAL_STUDENTS";
	EmailTemplateKey["DOCUMENTS_SUBMISSION_REMINDER_TRAINEES_DUAL_STUDENTS"] = "DOCUMENTS_SUBMISSION_REMINDER_TRAINEES_DUAL_STUDENTS";
	EmailTemplateKey["DOCUMENTS_SUBMISSION_REQUEST_TRAINEES_DUAL_STUDENTS"] = "DOCUMENTS_SUBMISSION_REQUEST_TRAINEES_DUAL_STUDENTS";
	EmailTemplateKey["NEW_APPLICANT"] = "NEW_APPLICANT";
	EmailTemplateKey["NEW_APPLICANT_PREQUALIFIED"] = "NEW_APPLICANT_PREQUALIFIED";
	EmailTemplateKey["NEW_COMMENT_ON_SHARED_APPLICANT"] = "NEW_COMMENT_ON_SHARED_APPLICANT";
	EmailTemplateKey["PHONE_NUMBER_MISSING_INCORRECT"] = "PHONE_NUMBER_MISSING_INCORRECT";
	EmailTemplateKey["PHONE_NUMBER_MISSING_INCORRECT_TRAINEES_DUAL_STUDENTS"] = "PHONE_NUMBER_MISSING_INCORRECT_TRAINEES_DUAL_STUDENTS";
	EmailTemplateKey["PM_JOB_POSITION_CAREER_PAGE_ACTIVATED"] = "PM_JOB_POSITION_CAREER_PAGE_ACTIVATED";
	EmailTemplateKey["PM_NEW_APPLICANT_NOTIFICATION"] = "PM_NEW_APPLICANT_NOTIFICATION";
	EmailTemplateKey["PM_STATUS_UPDATE_OVERDUE_NOTIFICATION"] = "PM_STATUS_UPDATE_OVERDUE_NOTIFICATION";
	EmailTemplateKey["REJECTION_NOTICE"] = "REJECTION_NOTICE";
	EmailTemplateKey["REJECTION_NOTICE_TRAINEES_DUAL_STUDENTS"] = "REJECTION_NOTICE_TRAINEES_DUAL_STUDENTS";
	EmailTemplateKey["RESUME_CREATED"] = "RESUME_CREATED";
	EmailTemplateKey["RESUME_CREATED_TRAINEES_DUAL_STUDENTS"] = "RESUME_CREATED_TRAINEES_DUAL_STUDENTS";
	EmailTemplateKey["RESUME_INCOMPLETE"] = "RESUME_INCOMPLETE";
	EmailTemplateKey["RESUME_RECEIVED"] = "RESUME_RECEIVED";
	EmailTemplateKey["RESUME_SUBMISSION_REMINDER"] = "RESUME_SUBMISSION_REMINDER";
	EmailTemplateKey["RESUME_SUBMISSION_REQUEST"] = "RESUME_SUBMISSION_REQUEST";
	return EmailTemplateKey;
}(EmailTemplateKey || {});
// source/enums/job-position-campaign-status.ts
var JobPositionCampaignStatus = {
	ACTIVE: "ACTIVE",
	INACTIVE: "INACTIVE",
	IN_PREPARATION: "IN_PREPARATION"
};
// source/enums/job-position-potential.ts
var JobPositionPotential = {
	NOT_CHECKED: "NOT_CHECKED",
	NO_POTENTIAL: "NO_POTENTIAL",
	HAS_POTENTIAL: "HAS_POTENTIAL"
};
// source/enums/job-position-quota-guarantee.ts
var JobPositionQuotaGuarantee = {
	GRACE_PERIOD: "GRACE_PERIOD",
	HIRING_GUARANTEE: "HIRING_GUARANTEE"
};
// source/enums/job-position-schedule.ts
var JobPositionSchedule = {
	FULL_TIME: "FULL_TIME",
	PART_TIME: "PART_TIME",
	RANGE: "RANGE"
};
// source/enums/job-position-type.ts
var JobPositionType = {
	TRAINEE: "TRAINEE",
	EMPLOYEE: "EMPLOYEE",
	DUAL_STUDENT: "DUAL_STUDENT"
};
// source/enums/monday/monday-custom-state.ts
var MondayCustomState = /* @__PURE__ */ function(MondayCustomState) {
	MondayCustomState["MAIN_PRODUCT_NOT_BOOKED"] = "MAIN_PRODUCT_NOT_BOOKED";
	MondayCustomState["NOT_BOOKED"] = "NOT_BOOKED";
	MondayCustomState["ACTIVE"] = "ACTIVE";
	MondayCustomState["INACTIVE"] = "INACTIVE";
	return MondayCustomState;
}(MondayCustomState || {});
var MondayCustomStateFormatting = /* @__PURE__ */ function(MondayCustomStateFormatting) {
	MondayCustomStateFormatting["ACTIVE"] = "ACTIVE";
	MondayCustomStateFormatting["ONLINE"] = "ONLINE";
	MondayCustomStateFormatting["CREATED"] = "CREATED";
	return MondayCustomStateFormatting;
}(MondayCustomStateFormatting || {});
var mondayCustomStateFormattingToMondayCustomStateToTextMap = {
	["ACTIVE"]: {
		["MAIN_PRODUCT_NOT_BOOKED"]: "Hauptprodukt nicht gebucht",
		["NOT_BOOKED"]: "Nicht gebucht",
		["ACTIVE"]: "Aktiv",
		["INACTIVE"]: "Inaktiv"
	},
	["ONLINE"]: {
		["MAIN_PRODUCT_NOT_BOOKED"]: "Hauptprodukt nicht gebucht",
		["NOT_BOOKED"]: "Nicht gebucht",
		["ACTIVE"]: "Online",
		["INACTIVE"]: "Offline"
	},
	["CREATED"]: {
		["MAIN_PRODUCT_NOT_BOOKED"]: "Hauptprodukt nicht gebucht",
		["NOT_BOOKED"]: "Nicht gebucht",
		["ACTIVE"]: "Erstellt",
		["INACTIVE"]: "Inaktiv"
	}
};
var formatMondayCustomState = (state, mondayCustomStateFormatting) => {
	const customStateToTextMap = mondayCustomStateFormattingToMondayCustomStateToTextMap[mondayCustomStateFormatting];
	if (customStateToTextMap === void 0) throw new Error(`Invalid custom state formatting: ${mondayCustomStateFormatting}`);
	const text = customStateToTextMap[state];
	if (text === void 0) throw new Error(`Invalid custom state: ${state}`);
	return text;
};
var getMondayCustomStateColor = (state) => {
	switch (state) {
		case "MAIN_PRODUCT_NOT_BOOKED":
		case "NOT_BOOKED": return "default";
		case "ACTIVE": return "success";
		case "INACTIVE": return "default";
		default: throw new Error(`Invalid custom state: ${state}`);
	}
};
var convertBoolToCustomState = (bool, customStateTrue, customStateFalse) => {
	return bool ? customStateTrue : customStateFalse;
};
var combineMondayCustomStates = (customState1, customState2) => {
	if (customState1 === "MAIN_PRODUCT_NOT_BOOKED") return customState1;
	if (customState2 === "MAIN_PRODUCT_NOT_BOOKED") return customState2;
	if (customState1 === "NOT_BOOKED") return customState1;
	if (customState2 === "NOT_BOOKED") return customState2;
	if (customState1 === "INACTIVE") return customState1;
	if (customState2 === "INACTIVE") return customState2;
	if (customState1 === "ACTIVE") return customState1;
	if (customState2 === "ACTIVE") return customState2;
	throw new Error(`Invalid custom states: ${customState1}, ${customState2}`);
};
var checkIsMondayCustomStateActive = (state) => {
	return state === "ACTIVE";
};
var polyfillMondayCustomState = (state) => {
	return state === void 0 ? "NOT_BOOKED" : state;
};
// source/enums/monday/monday-job-position-direct-approach-channel-platform.ts
var JobPositionDirectApproachChannelPlatform = {
	LINKEDIN: "LINKEDIN",
	XING: "XING",
	INDEED: "INDEED",
	STEPSTONE: "STEPSTONE"
};
var formatJobPositionDirectApproachChannelPlatform = (jobPositionDirectApproachChannelPlatform) => {
	switch (jobPositionDirectApproachChannelPlatform) {
		case JobPositionDirectApproachChannelPlatform.LINKEDIN: return "LinkedIn";
		case JobPositionDirectApproachChannelPlatform.XING: return "Xing";
		case JobPositionDirectApproachChannelPlatform.INDEED: return "Indeed";
		case JobPositionDirectApproachChannelPlatform.STEPSTONE: return "Stepstone";
		default: throw new Error(`Invalid job position direct approach channel platform: ${jobPositionDirectApproachChannelPlatform}`);
	}
};
var getJobPositionDirectApproachChannelPlatformIconName = (jobPositionDirectApproachChannelPlatform) => {
	switch (jobPositionDirectApproachChannelPlatform) {
		case JobPositionDirectApproachChannelPlatform.LINKEDIN: return "simple-icons:linkedin";
		case JobPositionDirectApproachChannelPlatform.XING: return "simple-icons:xing";
		case JobPositionDirectApproachChannelPlatform.INDEED: return "simple-icons:indeed";
		case JobPositionDirectApproachChannelPlatform.STEPSTONE: return "emojione-monotone:letter-s";
		default: throw new Error(`Invalid job position direct approach channel platform: ${jobPositionDirectApproachChannelPlatform}`);
	}
};
// source/enums/monday/monday-job-position-direct-approach-channel-potential.ts
var JobPositionDirectApproachChannelPotential = {
	NOT_EVALUATED: "NOT_EVALUATED",
	NO: "NO",
	YES: "YES"
};
var formatMondayJobPositionDirectApproachChannelPotential = (jobPositionDirectApproachChannelPotential) => {
	switch (jobPositionDirectApproachChannelPotential) {
		case JobPositionDirectApproachChannelPotential.NOT_EVALUATED: return "Noch nicht geprüft";
		case JobPositionDirectApproachChannelPotential.NO: return "Kein Potential";
		case JobPositionDirectApproachChannelPotential.YES: return "Potential vorhanden";
		default: throw new Error(`Invalid job position direct approach channel potential: ${jobPositionDirectApproachChannelPotential}`);
	}
};
var getMondayJobPositionDirectApproachChannelPotentialColor = (jobPositionDirectApproachChannelPotential) => {
	switch (jobPositionDirectApproachChannelPotential) {
		case JobPositionDirectApproachChannelPotential.NOT_EVALUATED: return "warning";
		case JobPositionDirectApproachChannelPotential.NO: return "danger";
		case JobPositionDirectApproachChannelPotential.YES: return "success";
		default: throw new Error(`Invalid job position direct approach channel potential: ${jobPositionDirectApproachChannelPotential}`);
	}
};
// source/enums/monday/monday-job-position-type.ts
/** @deprecated Use JopPositionType */
var MondayJobPositionType = {
	TRAINEE: "TRAINEE",
	EMPLOYEE: "EMPLOYEE"
};
var parseMondayStateToMondayJobPositionType = (mondayJobPositionTypeMondayState) => {
	switch (mondayJobPositionTypeMondayState) {
		case "A": return MondayJobPositionType.TRAINEE;
		case "M": return MondayJobPositionType.EMPLOYEE;
		default: throw new Error(`Invalid job position type monday state: ${mondayJobPositionTypeMondayState}`);
	}
};
// source/enums/role.ts
var Role = {
	MANAGER: "MANAGER",
	CUSTOMER: "CUSTOMER",
	APPLICANT_MANAGER: "APPLICANT_MANAGER",
	ADMIN: "ADMIN"
};
// source/enums/salutation.ts
var Salutation = {
	FORMAL: "FORMAL",
	INFORMAL: "INFORMAL"
};
// source/enums/search-ad-status.ts
var SearchAdStatus = {
	ACTIVE: "ACTIVE",
	IN_PREPARATION: "IN_PREPARATION",
	INACTIVE: "INACTIVE",
	NOT_BOOKED: "NOT_BOOKED"
};
// source/enums/sms-template-key.ts
var SmsTemplateKey = /* @__PURE__ */ function(SmsTemplateKey) {
	SmsTemplateKey["CALL_ATTEMPT_FAILED_1_TIME"] = "CALL_ATTEMPT_FAILED_1_TIME";
	SmsTemplateKey["CALL_ATTEMPT_FAILED_1_TIME_TRAINEES_DUAL_STUDENTS"] = "CALL_ATTEMPT_FAILED_1_TIME_TRAINEES_DUAL_STUDENTS";
	SmsTemplateKey["RESUME_SUBMISSION_REQUEST"] = "RESUME_SUBMISSION_REQUEST";
	SmsTemplateKey["RESUME_SUBMISSION_REMINDER"] = "RESUME_SUBMISSION_REMINDER";
	SmsTemplateKey["RESUME_INCOMPLETE"] = "RESUME_INCOMPLETE";
	SmsTemplateKey["DOCUMENTS_SUBMISSION_REQUEST_TRAINEES_DUAL_STUDENTS"] = "DOCUMENTS_SUBMISSION_REQUEST_TRAINEES_DUAL_STUDENTS";
	SmsTemplateKey["DOCUMENTS_SUBMISSION_REMINDER_TRAINEES_DUAL_STUDENTS"] = "DOCUMENTS_SUBMISSION_REMINDER_TRAINEES_DUAL_STUDENTS";
	return SmsTemplateKey;
}(SmsTemplateKey || {});
// source/enums/social-media-support-status.ts
var SocialMediaSupportStatus = {
	ACTIVE: "ACTIVE",
	IN_PREPARATION: "IN_PREPARATION",
	INACTIVE: "INACTIVE",
	NOT_BOOKED: "NOT_BOOKED"
};
// source/enums/webhook-sources.ts
var WebhookSources = {
	PERSPECTIVE: "PERSPECTIVE",
	WL_LANDING_PAGE: "WL_LANDING_PAGE"
};
// source/enums/career-domain-status.ts
var CareerDomainStatus = {
	PENDING: "PENDING",
	SUCCESS: "SUCCESS",
	FAILED: "FAILED"
};
// source/enums/oauth-provider.ts
var OAuthProvider = {
	GOOGLE: "GOOGLE",
	MICROSOFT: "MICROSOFT"
};
// source/enums/email-provider-option.ts
var EmailProviderOption = {
	GOOGLE: "GOOGLE",
	MICROSOFT: "MICROSOFT",
	SMTP: "SMTP",
	CUSTOM: "CUSTOM"
};
// source/enums/career-page-publish-status.ts
var CareerPagePublishStatus = {
	DRAFT: "DRAFT",
	PENDING: "PENDING",
	SUCCESS: "SUCCESS",
	FAILED: "FAILED"
};
// source/enums/gender.ts
var Gender = {
	FEMALE: "FEMALE",
	MALE: "MALE",
	DIVERSE: "DIVERSE"
};
// source/enums/hrbaxml-last-action.ts
var HrbaxmlLastAction = {
	INSERT: "INSERT",
	UPDATE: "UPDATE",
	DELETE: "DELETE"
};
// source/enums/hrbaxml-sync-status.ts
var HrbaxmlSyncStatus = {
	PENDING: "PENDING",
	SYNCED: "SYNCED",
	ERROR: "ERROR",
	DELETED: "DELETED"
};
// source/enums/career-page-referral-source.ts
var CareerPageReferralSource = {
	INDEED: "Indeed",
	STEPSTONE: "Stepstone",
	OTHER_JOB_PORTAL: "Anderes Jobportal",
	EMPLOYEE_REFERRAL: "Mitarbeiterempfehlung",
	TRADE_FAIR: "Messe",
	SOCIAL_MEDIA_CAMPAIGN: "Facebook/Instagram-Kampagne",
	GOOGLE_SEARCH: "Google Suche",
	LINKED_IN: "LinkedIn",
	BUNDESAGENTUR_FUER_ARBEIT: "Bundesagentur",
	OTHER: "Sonstiges"
};
// source/enums/font-source.ts
var FontSource = { G_CLOUD: "G_CLOUD" };
// source/enums/font-type.ts
/**
* Font types which are allowed in the DB.
*/
var FontType = {
	TTF: "TTF",
	OTF: "OTF",
	WOFF: "WOFF",
	WOFF2: "WOFF2",
	EOT: "EOT",
	SVG: "SVG"
};
// source/enums/font-mime-type.ts
var fontMimeTypes = [
	"font/ttf",
	"font/otf",
	"font/woff",
	"font/woff2",
	"application/vnd.ms-fontobject",
	"image/svg+xml"
];
var FontMimeTypeMap = {
	[FontType.TTF]: "font/ttf",
	[FontType.OTF]: "font/otf",
	[FontType.WOFF]: "font/woff",
	[FontType.WOFF2]: "font/woff2",
	[FontType.EOT]: "application/vnd.ms-fontobject",
	[FontType.SVG]: "image/svg+xml"
};
var InverseFontMimeTypeMap = Object.fromEntries(Object.entries(FontMimeTypeMap).map((a) => a.reverse()));
var AcceptedFonts = {
	"font/ttf": [".ttf"],
	"font/otf": [".otf"],
	"font/woff": [".woff"],
	"font/woff2": [".woff2"],
	"application/vnd.ms-fontobject": [".eot"],
	"image/svg+xml": [".svg"]
};
// source/enums/umami-unit-enum.ts
var umamiUnits = [
	"year",
	"month",
	"day",
	"hour"
];
var UmamiUnit = {
	YEAR: "year",
	MONTH: "month",
	DAY: "day",
	HOUR: "hour"
};
// source/enums/metric-events.ts
var MetricEvent = /* @__PURE__ */ function(MetricEvent) {
	MetricEvent["APPLICATION_SENT"] = "APPLICATION_SENT";
	return MetricEvent;
}(MetricEvent || {});
// source/enums/oauth-error-type.ts
var OAuthErrorType = {
	INVALID_ACCESS_TOKEN: "INVALID_ACCESS_TOKEN",
	INVALID_REFRESH_TOKEN: "INVALID_REFRESH_TOKEN"
};
// source/enums/applicant-document-status.ts
var ApplicantDocumentStatus = {
	NOT_SCANNED: "NOT_SCANNED",
	NEEDS_SCAN: "NEEDS_SCAN",
	SCAN_FAILED: "SCAN_FAILED",
	INFECTED: "INFECTED",
	CLEAN: "CLEAN"
};
var DangerousApplicantDocumentStatuses = [
	ApplicantDocumentStatus.NEEDS_SCAN,
	ApplicantDocumentStatus.SCAN_FAILED,
	ApplicantDocumentStatus.INFECTED
];
// ../../node_modules/react/cjs/react.production.js
/**
* @license React
* react.production.js
*
* Copyright (c) Meta Platforms, Inc. and affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var require_react_production = /* @__PURE__ */ __commonJSMin(((exports) => {
	var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element");
	var REACT_PORTAL_TYPE = Symbol.for("react.portal");
	var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
	var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
	var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
	var REACT_CONSUMER_TYPE = Symbol.for("react.consumer");
	var REACT_CONTEXT_TYPE = Symbol.for("react.context");
	var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
	var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
	var REACT_MEMO_TYPE = Symbol.for("react.memo");
	var REACT_LAZY_TYPE = Symbol.for("react.lazy");
	var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
	var REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition");
	var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
	function getIteratorFn(maybeIterable) {
		if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
		maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
		return "function" === typeof maybeIterable ? maybeIterable : null;
	}
	var ReactNoopUpdateQueue = {
		isMounted: function() {
			return !1;
		},
		enqueueForceUpdate: function() {},
		enqueueReplaceState: function() {},
		enqueueSetState: function() {}
	};
	var assign = Object.assign;
	var emptyObject = {};
	function Component(props, context, updater) {
		this.props = props;
		this.context = context;
		this.refs = emptyObject;
		this.updater = updater || ReactNoopUpdateQueue;
	}
	Component.prototype.isReactComponent = {};
	Component.prototype.setState = function(partialState, callback) {
		if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
		this.updater.enqueueSetState(this, partialState, callback, "setState");
	};
	Component.prototype.forceUpdate = function(callback) {
		this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
	};
	function ComponentDummy() {}
	ComponentDummy.prototype = Component.prototype;
	function PureComponent(props, context, updater) {
		this.props = props;
		this.context = context;
		this.refs = emptyObject;
		this.updater = updater || ReactNoopUpdateQueue;
	}
	var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
	pureComponentPrototype.constructor = PureComponent;
	assign(pureComponentPrototype, Component.prototype);
	pureComponentPrototype.isPureReactComponent = !0;
	var isArrayImpl = Array.isArray;
	function noop() {}
	var ReactSharedInternals = {
		H: null,
		A: null,
		T: null,
		S: null
	};
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function ReactElement(type, key, props) {
		var refProp = props.ref;
		return {
			$$typeof: REACT_ELEMENT_TYPE,
			type,
			key,
			ref: void 0 !== refProp ? refProp : null,
			props
		};
	}
	function cloneAndReplaceKey(oldElement, newKey) {
		return ReactElement(oldElement.type, newKey, oldElement.props);
	}
	function isValidElement(object) {
		return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function escape(key) {
		var escaperLookup = {
			"=": "=0",
			":": "=2"
		};
		return "$" + key.replace(/[=:]/g, function(match) {
			return escaperLookup[match];
		});
	}
	var userProvidedKeyEscapeRegex = /\/+/g;
	function getElementKey(element, index) {
		return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
	}
	function resolveThenable(thenable) {
		switch (thenable.status) {
			case "fulfilled": return thenable.value;
			case "rejected": throw thenable.reason;
			default: switch ("string" === typeof thenable.status ? thenable.then(noop, noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
				"pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
			}, function(error) {
				"pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
			})), thenable.status) {
				case "fulfilled": return thenable.value;
				case "rejected": throw thenable.reason;
			}
		}
		throw thenable;
	}
	function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
		var type = typeof children;
		if ("undefined" === type || "boolean" === type) children = null;
		var invokeCallback = !1;
		if (null === children) invokeCallback = !0;
		else switch (type) {
			case "bigint":
			case "string":
			case "number":
				invokeCallback = !0;
				break;
			case "object": switch (children.$$typeof) {
				case REACT_ELEMENT_TYPE:
				case REACT_PORTAL_TYPE:
					invokeCallback = !0;
					break;
				case REACT_LAZY_TYPE: return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
			}
		}
		if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
			return c;
		})) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
		invokeCallback = 0;
		var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
		if (isArrayImpl(children)) for (var i = 0; i < children.length; i++) nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
		else if (i = getIteratorFn(children), "function" === typeof i) for (children = i.call(children), i = 0; !(nameSoFar = children.next()).done;) nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
		else if ("object" === type) {
			if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
			array = String(children);
			throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
		}
		return invokeCallback;
	}
	function mapChildren(children, func, context) {
		if (null == children) return children;
		var result = [], count = 0;
		mapIntoArray(children, result, "", "", function(child) {
			return func.call(context, child, count++);
		});
		return result;
	}
	function lazyInitializer(payload) {
		if (-1 === payload._status) {
			var ctor = payload._result, thenable = ctor();
			thenable.then(function(moduleObject) {
				if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
			}, function(error) {
				if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
			});
			-1 === payload._status && (payload._status = 0, payload._result = thenable);
		}
		if (1 === payload._status) return payload._result.default;
		throw payload._result;
	}
	var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
		if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
			var event = new window.ErrorEvent("error", {
				bubbles: !0,
				cancelable: !0,
				message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
				error
			});
			if (!window.dispatchEvent(event)) return;
		} else if ("object" === typeof process && "function" === typeof process.emit) {
			process.emit("uncaughtException", error);
			return;
		}
		console.error(error);
	};
	function startTransition(scope) {
		var prevTransition = ReactSharedInternals.T, currentTransition = {};
		currentTransition.types = null !== prevTransition ? prevTransition.types : null;
		ReactSharedInternals.T = currentTransition;
		try {
			var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
			null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
			"object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
		} catch (error) {
			reportGlobalError(error);
		} finally {
			null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
		}
	}
	function addTransitionType(type) {
		var transition = ReactSharedInternals.T;
		if (null !== transition) {
			var transitionTypes = transition.types;
			null === transitionTypes ? transition.types = [type] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
		} else startTransition(addTransitionType.bind(null, type));
	}
	var Children = {
		map: mapChildren,
		forEach: function(children, forEachFunc, forEachContext) {
			mapChildren(children, function() {
				forEachFunc.apply(this, arguments);
			}, forEachContext);
		},
		count: function(children) {
			var n = 0;
			mapChildren(children, function() {
				n++;
			});
			return n;
		},
		toArray: function(children) {
			return mapChildren(children, function(child) {
				return child;
			}) || [];
		},
		only: function(children) {
			if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
			return children;
		}
	};
	exports.Activity = REACT_ACTIVITY_TYPE;
	exports.Children = Children;
	exports.Component = Component;
	exports.Fragment = REACT_FRAGMENT_TYPE;
	exports.Profiler = REACT_PROFILER_TYPE;
	exports.PureComponent = PureComponent;
	exports.StrictMode = REACT_STRICT_MODE_TYPE;
	exports.Suspense = REACT_SUSPENSE_TYPE;
	exports.ViewTransition = REACT_VIEW_TRANSITION_TYPE;
	exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
	exports.__COMPILER_RUNTIME = {
		__proto__: null,
		c: function(size) {
			return ReactSharedInternals.H.useMemoCache(size);
		}
	};
	exports.addTransitionType = addTransitionType;
	exports.cache = function(fn) {
		return function() {
			return fn.apply(null, arguments);
		};
	};
	exports.cacheSignal = function() {
		return null;
	};
	exports.cloneElement = function(element, config, children) {
		if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
		var props = assign({}, element.props), key = element.key;
		if (null != config) for (propName in void 0 !== config.key && (key = "" + config.key), config) !hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
		var propName = arguments.length - 2;
		if (1 === propName) props.children = children;
		else if (1 < propName) {
			for (var childArray = Array(propName), i = 0; i < propName; i++) childArray[i] = arguments[i + 2];
			props.children = childArray;
		}
		return ReactElement(element.type, key, props);
	};
	exports.createContext = function(defaultValue) {
		defaultValue = {
			$$typeof: REACT_CONTEXT_TYPE,
			_currentValue: defaultValue,
			_currentValue2: defaultValue,
			_threadCount: 0,
			Provider: null,
			Consumer: null
		};
		defaultValue.Provider = defaultValue;
		defaultValue.Consumer = {
			$$typeof: REACT_CONSUMER_TYPE,
			_context: defaultValue
		};
		return defaultValue;
	};
	exports.createElement = function(type, config, children) {
		var propName, props = {}, key = null;
		if (null != config) for (propName in void 0 !== config.key && (key = "" + config.key), config) hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
		var childrenLength = arguments.length - 2;
		if (1 === childrenLength) props.children = children;
		else if (1 < childrenLength) {
			for (var childArray = Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 2];
			props.children = childArray;
		}
		if (type && type.defaultProps) for (propName in childrenLength = type.defaultProps, childrenLength) void 0 === props[propName] && (props[propName] = childrenLength[propName]);
		return ReactElement(type, key, props);
	};
	exports.createRef = function() {
		return { current: null };
	};
	exports.forwardRef = function(render) {
		return {
			$$typeof: REACT_FORWARD_REF_TYPE,
			render
		};
	};
	exports.isValidElement = isValidElement;
	exports.lazy = function(ctor) {
		return {
			$$typeof: REACT_LAZY_TYPE,
			_payload: {
				_status: -1,
				_result: ctor
			},
			_init: lazyInitializer
		};
	};
	exports.memo = function(type, compare) {
		return {
			$$typeof: REACT_MEMO_TYPE,
			type,
			compare: void 0 === compare ? null : compare
		};
	};
	exports.startTransition = startTransition;
	exports.unstable_useCacheRefresh = function() {
		return ReactSharedInternals.H.useCacheRefresh();
	};
	exports.use = function(usable) {
		return ReactSharedInternals.H.use(usable);
	};
	exports.useActionState = function(action, initialState, permalink) {
		return ReactSharedInternals.H.useActionState(action, initialState, permalink);
	};
	exports.useCallback = function(callback, deps) {
		return ReactSharedInternals.H.useCallback(callback, deps);
	};
	exports.useContext = function(Context) {
		return ReactSharedInternals.H.useContext(Context);
	};
	exports.useDebugValue = function() {};
	exports.useDeferredValue = function(value, initialValue) {
		return ReactSharedInternals.H.useDeferredValue(value, initialValue);
	};
	exports.useEffect = function(create, deps) {
		return ReactSharedInternals.H.useEffect(create, deps);
	};
	exports.useEffectEvent = function(callback) {
		return ReactSharedInternals.H.useEffectEvent(callback);
	};
	exports.useId = function() {
		return ReactSharedInternals.H.useId();
	};
	exports.useImperativeHandle = function(ref, create, deps) {
		return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
	};
	exports.useInsertionEffect = function(create, deps) {
		return ReactSharedInternals.H.useInsertionEffect(create, deps);
	};
	exports.useLayoutEffect = function(create, deps) {
		return ReactSharedInternals.H.useLayoutEffect(create, deps);
	};
	exports.useMemo = function(create, deps) {
		return ReactSharedInternals.H.useMemo(create, deps);
	};
	exports.useOptimistic = function(passthrough, reducer) {
		return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
	};
	exports.useReducer = function(reducer, initialArg, init) {
		return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
	};
	exports.useRef = function(initialValue) {
		return ReactSharedInternals.H.useRef(initialValue);
	};
	exports.useState = function(initialState) {
		return ReactSharedInternals.H.useState(initialState);
	};
	exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
		return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
	};
	exports.useTransition = function() {
		return ReactSharedInternals.H.useTransition();
	};
	exports.version = "19.3.1";
}));
// ../../node_modules/react/cjs/react.development.js
/**
* @license React
* react.development.js
*
* Copyright (c) Meta Platforms, Inc. and affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var require_react_development = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	"production" !== process.env.NODE_ENV && (function() {
		function defineDeprecationWarning(methodName, info) {
			Object.defineProperty(Component.prototype, methodName, { get: function() {
				console.warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
			} });
		}
		function getIteratorFn(maybeIterable) {
			if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
			maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
			return "function" === typeof maybeIterable ? maybeIterable : null;
		}
		function warnNoop(publicInstance, callerName) {
			publicInstance = (publicInstance = publicInstance.constructor) && (publicInstance.displayName || publicInstance.name) || "ReactClass";
			var warningKey = publicInstance + "." + callerName;
			didWarnStateUpdateForUnmountedComponent[warningKey] || (console.error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, publicInstance), didWarnStateUpdateForUnmountedComponent[warningKey] = !0);
		}
		function Component(props, context, updater) {
			this.props = props;
			this.context = context;
			this.refs = emptyObject;
			this.updater = updater || ReactNoopUpdateQueue;
		}
		function ComponentDummy() {}
		function PureComponent(props, context, updater) {
			this.props = props;
			this.context = context;
			this.refs = emptyObject;
			this.updater = updater || ReactNoopUpdateQueue;
		}
		function noop() {}
		function testStringCoercion(value) {
			return "" + value;
		}
		function checkKeyStringCoercion(value) {
			try {
				testStringCoercion(value);
				var JSCompiler_inline_result = !1;
			} catch (e) {
				JSCompiler_inline_result = !0;
			}
			if (JSCompiler_inline_result) {
				JSCompiler_inline_result = console;
				var JSCompiler_temp_const = JSCompiler_inline_result.error;
				var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
				JSCompiler_temp_const.call(JSCompiler_inline_result, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", JSCompiler_inline_result$jscomp$0);
				return testStringCoercion(value);
			}
		}
		function getComponentNameFromType(type) {
			if (null == type) return null;
			if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
			if ("string" === typeof type) return type;
			switch (type) {
				case REACT_FRAGMENT_TYPE: return "Fragment";
				case REACT_PROFILER_TYPE: return "Profiler";
				case REACT_STRICT_MODE_TYPE: return "StrictMode";
				case REACT_SUSPENSE_TYPE: return "Suspense";
				case REACT_SUSPENSE_LIST_TYPE: return "SuspenseList";
				case REACT_ACTIVITY_TYPE: return "Activity";
				case REACT_VIEW_TRANSITION_TYPE: return "ViewTransition";
			}
			if ("object" === typeof type) switch ("number" === typeof type.tag && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), type.$$typeof) {
				case REACT_PORTAL_TYPE: return "Portal";
				case REACT_CONTEXT_TYPE: return type.displayName || "Context";
				case REACT_CONSUMER_TYPE: return (type._context.displayName || "Context") + ".Consumer";
				case REACT_FORWARD_REF_TYPE:
					var innerType = type.render;
					type = type.displayName;
					type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
					return type;
				case REACT_MEMO_TYPE: return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
				case REACT_LAZY_TYPE:
					innerType = type._payload;
					type = type._init;
					try {
						return getComponentNameFromType(type(innerType));
					} catch (x) {}
			}
			return null;
		}
		function getTaskName(type) {
			if (type === REACT_FRAGMENT_TYPE) return "<>";
			if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE) return "<...>";
			try {
				var name = getComponentNameFromType(type);
				return name ? "<" + name + ">" : "<...>";
			} catch (x) {
				return "<...>";
			}
		}
		function getOwner() {
			var dispatcher = ReactSharedInternals.A;
			return null === dispatcher ? null : dispatcher.getOwner();
		}
		function UnknownOwner() {
			return Error("react-stack-top-frame");
		}
		function hasValidKey(config) {
			if (hasOwnProperty.call(config, "key")) {
				var getter = Object.getOwnPropertyDescriptor(config, "key").get;
				if (getter && getter.isReactWarning) return !1;
			}
			return void 0 !== config.key;
		}
		function defineKeyPropWarningGetter(props, displayName) {
			function warnAboutAccessingKey() {
				specialPropKeyWarningShown || (specialPropKeyWarningShown = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", displayName));
			}
			warnAboutAccessingKey.isReactWarning = !0;
			Object.defineProperty(props, "key", {
				get: warnAboutAccessingKey,
				configurable: !0
			});
		}
		function elementRefGetterWithDeprecationWarning() {
			var componentName = getComponentNameFromType(this.type);
			didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."));
			componentName = this.props.ref;
			return void 0 !== componentName ? componentName : null;
		}
		function ReactElement(type, key, props, owner, debugStack, debugTask) {
			var refProp = props.ref;
			type = {
				$$typeof: REACT_ELEMENT_TYPE,
				type,
				key,
				props,
				_owner: owner
			};
			null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
				enumerable: !1,
				get: elementRefGetterWithDeprecationWarning
			}) : Object.defineProperty(type, "ref", {
				enumerable: !1,
				value: null
			});
			type._store = {};
			Object.defineProperty(type._store, "validated", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: 0
			});
			Object.defineProperty(type, "_debugInfo", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: null
			});
			Object.defineProperty(type, "_debugStack", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: debugStack
			});
			Object.defineProperty(type, "_debugTask", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: debugTask
			});
			Object.freeze && (Object.freeze(type.props), Object.freeze(type));
			return type;
		}
		function cloneAndReplaceKey(oldElement, newKey) {
			newKey = ReactElement(oldElement.type, newKey, oldElement.props, oldElement._owner, oldElement._debugStack, oldElement._debugTask);
			oldElement._store && (newKey._store.validated = oldElement._store.validated);
			return newKey;
		}
		function validateChildKeys(node) {
			isValidElement(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
		}
		function isValidElement(object) {
			return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
		}
		function escape(key) {
			var escaperLookup = {
				"=": "=0",
				":": "=2"
			};
			return "$" + key.replace(/[=:]/g, function(match) {
				return escaperLookup[match];
			});
		}
		function getElementKey(element, index) {
			return "object" === typeof element && null !== element && null != element.key ? (checkKeyStringCoercion(element.key), escape("" + element.key)) : index.toString(36);
		}
		function resolveThenable(thenable) {
			switch (thenable.status) {
				case "fulfilled": return thenable.value;
				case "rejected": throw thenable.reason;
				default: switch ("string" === typeof thenable.status ? thenable.then(noop, noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
					"pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
				}, function(error) {
					"pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
				})), thenable.status) {
					case "fulfilled": return thenable.value;
					case "rejected": throw thenable.reason;
				}
			}
			throw thenable;
		}
		function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
			var type = typeof children;
			if ("undefined" === type || "boolean" === type) children = null;
			var invokeCallback = !1;
			if (null === children) invokeCallback = !0;
			else switch (type) {
				case "bigint":
				case "string":
				case "number":
					invokeCallback = !0;
					break;
				case "object": switch (children.$$typeof) {
					case REACT_ELEMENT_TYPE:
					case REACT_PORTAL_TYPE:
						invokeCallback = !0;
						break;
					case REACT_LAZY_TYPE: return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
				}
			}
			if (invokeCallback) {
				invokeCallback = children;
				callback = callback(invokeCallback);
				var childKey = "" === nameSoFar ? "." + getElementKey(invokeCallback, 0) : nameSoFar;
				isArrayImpl(callback) ? (escapedPrefix = "", null != childKey && (escapedPrefix = childKey.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
					return c;
				})) : null != callback && (isValidElement(callback) && (null != callback.key && (invokeCallback && invokeCallback.key === callback.key || checkKeyStringCoercion(callback.key)), escapedPrefix = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || invokeCallback && invokeCallback.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + childKey), "" !== nameSoFar && null != invokeCallback && isValidElement(invokeCallback) && null == invokeCallback.key && invokeCallback._store && !invokeCallback._store.validated && (escapedPrefix._store.validated = 2), callback = escapedPrefix), array.push(callback));
				return 1;
			}
			invokeCallback = 0;
			childKey = "" === nameSoFar ? "." : nameSoFar + ":";
			if (isArrayImpl(children)) for (var i = 0; i < children.length; i++) nameSoFar = children[i], type = childKey + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
			else if (i = getIteratorFn(children), "function" === typeof i) for (i === children.entries && (didWarnAboutMaps || console.warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), didWarnAboutMaps = !0), children = i.call(children), i = 0; !(nameSoFar = children.next()).done;) nameSoFar = nameSoFar.value, type = childKey + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
			else if ("object" === type) {
				if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
				array = String(children);
				throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
			}
			return invokeCallback;
		}
		function mapChildren(children, func, context) {
			if (null == children) return children;
			var result = [], count = 0;
			mapIntoArray(children, result, "", "", function(child) {
				return func.call(context, child, count++);
			});
			return result;
		}
		function lazyInitializer(payload) {
			if (-1 === payload._status) {
				var resolveDebugValue = null, rejectDebugValue = null, ioInfo = payload._ioInfo;
				null != ioInfo && (ioInfo.start = ioInfo.end = performance.now(), ioInfo.value = new Promise(function(resolve, reject) {
					resolveDebugValue = resolve;
					rejectDebugValue = reject;
				}));
				ioInfo = payload._result;
				var thenable = ioInfo();
				thenable.then(function(moduleObject) {
					if (0 === payload._status || -1 === payload._status) {
						payload._status = 1;
						payload._result = moduleObject;
						var _ioInfo = payload._ioInfo;
						if (null != _ioInfo) {
							_ioInfo.end = performance.now();
							var debugValue = null == moduleObject ? void 0 : moduleObject.default;
							resolveDebugValue(debugValue);
							_ioInfo.value.status = "fulfilled";
							_ioInfo.value.value = debugValue;
						}
						void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
					}
				}, function(error) {
					if (0 === payload._status || -1 === payload._status) {
						payload._status = 2;
						payload._result = error;
						var _ioInfo2 = payload._ioInfo;
						null != _ioInfo2 && (_ioInfo2.end = performance.now(), _ioInfo2.value.then(noop, noop), rejectDebugValue(error), _ioInfo2.value.status = "rejected", _ioInfo2.value.reason = error);
						void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
					}
				});
				ioInfo = payload._ioInfo;
				if (null != ioInfo) {
					var displayName = thenable.displayName;
					"string" === typeof displayName && (ioInfo.name = displayName);
				}
				-1 === payload._status && (payload._status = 0, payload._result = thenable);
			}
			if (1 === payload._status) return ioInfo = payload._result, void 0 === ioInfo && console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", ioInfo), "default" in ioInfo || console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", ioInfo), ioInfo.default;
			throw payload._result;
		}
		function resolveDispatcher() {
			var dispatcher = ReactSharedInternals.H;
			null === dispatcher && console.error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.");
			return dispatcher;
		}
		function releaseAsyncTransition() {
			ReactSharedInternals.asyncTransitions--;
		}
		function startTransition(scope) {
			var prevTransition = ReactSharedInternals.T, currentTransition = {};
			currentTransition.types = null !== prevTransition ? prevTransition.types : null;
			currentTransition._updatedFibers = /* @__PURE__ */ new Set();
			ReactSharedInternals.T = currentTransition;
			try {
				var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
				null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
				"object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && (ReactSharedInternals.asyncTransitions++, returnValue.then(releaseAsyncTransition, releaseAsyncTransition), returnValue.then(noop, reportGlobalError));
			} catch (error) {
				reportGlobalError(error);
			} finally {
				null === prevTransition && currentTransition._updatedFibers && (scope = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < scope && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.")), null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
			}
		}
		function addTransitionType(type) {
			var transition = ReactSharedInternals.T;
			if (null !== transition) {
				var transitionTypes = transition.types;
				null === transitionTypes ? transition.types = [type] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
			} else 0 === ReactSharedInternals.asyncTransitions && console.error("addTransitionType can only be called inside a `startTransition()` callback. It must be associated with a specific Transition."), startTransition(addTransitionType.bind(null, type));
		}
		function enqueueTask(task) {
			if (null === enqueueTaskImpl) try {
				var requireString = ("require" + Math.random()).slice(0, 7);
				enqueueTaskImpl = (module && module[requireString]).call(module, "timers").setImmediate;
			} catch (_err) {
				enqueueTaskImpl = function(callback) {
					!1 === didWarnAboutMessageChannel && (didWarnAboutMessageChannel = !0, "undefined" === typeof MessageChannel && console.error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
					var channel = new MessageChannel();
					channel.port1.onmessage = callback;
					channel.port2.postMessage(void 0);
				};
			}
			return enqueueTaskImpl(task);
		}
		function aggregateErrors(errors) {
			return 1 < errors.length && "function" === typeof AggregateError ? new AggregateError(errors) : errors[0];
		}
		function popActScope(prevActQueue, prevActScopeDepth) {
			prevActScopeDepth !== actScopeDepth - 1 && console.error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
			actScopeDepth = prevActScopeDepth;
		}
		function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
			var queue = ReactSharedInternals.actQueue;
			if (null !== queue) if (0 !== queue.length) try {
				flushActQueue(queue);
				enqueueTask(function() {
					return recursivelyFlushAsyncActWork(returnValue, resolve, reject);
				});
				return;
			} catch (error) {
				ReactSharedInternals.thrownErrors.push(error);
			}
			else ReactSharedInternals.actQueue = null;
			0 < ReactSharedInternals.thrownErrors.length ? (queue = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, reject(queue)) : resolve(returnValue);
		}
		function flushActQueue(queue) {
			if (!isFlushing) {
				isFlushing = !0;
				var i = 0;
				try {
					for (; i < queue.length; i++) {
						var callback = queue[i];
						do {
							ReactSharedInternals.didUsePromise = !1;
							var continuation = callback(!1);
							if (null !== continuation) {
								if (ReactSharedInternals.didUsePromise) {
									queue[i] = callback;
									queue.splice(0, i);
									return;
								}
								callback = continuation;
							} else break;
						} while (1);
					}
					queue.length = 0;
				} catch (error) {
					queue.splice(0, i + 1), ReactSharedInternals.thrownErrors.push(error);
				} finally {
					isFlushing = !1;
				}
			}
		}
		"undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
		var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator, didWarnStateUpdateForUnmountedComponent = {}, ReactNoopUpdateQueue = {
			isMounted: function() {
				return !1;
			},
			enqueueForceUpdate: function(publicInstance) {
				warnNoop(publicInstance, "forceUpdate");
			},
			enqueueReplaceState: function(publicInstance) {
				warnNoop(publicInstance, "replaceState");
			},
			enqueueSetState: function(publicInstance) {
				warnNoop(publicInstance, "setState");
			}
		}, assign = Object.assign, emptyObject = {};
		Object.freeze(emptyObject);
		Component.prototype.isReactComponent = {};
		Component.prototype.setState = function(partialState, callback) {
			if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
			this.updater.enqueueSetState(this, partialState, callback, "setState");
		};
		Component.prototype.forceUpdate = function(callback) {
			this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
		};
		var deprecatedAPIs = {
			isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
			replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
		};
		for (fnName in deprecatedAPIs) deprecatedAPIs.hasOwnProperty(fnName) && defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
		ComponentDummy.prototype = Component.prototype;
		deprecatedAPIs = PureComponent.prototype = new ComponentDummy();
		deprecatedAPIs.constructor = PureComponent;
		assign(deprecatedAPIs, Component.prototype);
		deprecatedAPIs.isPureReactComponent = !0;
		var isArrayImpl = Array.isArray, REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), ReactSharedInternals = {
			H: null,
			A: null,
			T: null,
			S: null,
			actQueue: null,
			asyncTransitions: 0,
			isBatchingLegacy: !1,
			didScheduleLegacyUpdate: !1,
			didUsePromise: !1,
			thrownErrors: [],
			getCurrentStack: null,
			recentlyCreatedOwnerStacks: 0
		}, hasOwnProperty = Object.prototype.hasOwnProperty, createTask = console.createTask ? console.createTask : function() {
			return null;
		};
		deprecatedAPIs = { react_stack_bottom_frame: function(callStackForError) {
			return callStackForError();
		} };
		var specialPropKeyWarningShown, didWarnAboutOldJSXRuntime;
		var didWarnAboutElementRef = {};
		var unknownOwnerDebugStack = deprecatedAPIs.react_stack_bottom_frame.bind(deprecatedAPIs, UnknownOwner)();
		var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
		var didWarnAboutMaps = !1, userProvidedKeyEscapeRegex = /\/+/g, reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
			if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
				var event = new window.ErrorEvent("error", {
					bubbles: !0,
					cancelable: !0,
					message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
					error
				});
				if (!window.dispatchEvent(event)) return;
			} else if ("object" === typeof process && "function" === typeof process.emit) {
				process.emit("uncaughtException", error);
				return;
			}
			console.error(error);
		}, didWarnAboutMessageChannel = !1, enqueueTaskImpl = null, actScopeDepth = 0, didWarnNoAwaitAct = !1, isFlushing = !1, queueSeveralMicrotasks = "function" === typeof queueMicrotask ? function(callback) {
			queueMicrotask(function() {
				return queueMicrotask(callback);
			});
		} : enqueueTask;
		deprecatedAPIs = Object.freeze({
			__proto__: null,
			c: function(size) {
				return resolveDispatcher().useMemoCache(size);
			}
		});
		var fnName = {
			map: mapChildren,
			forEach: function(children, forEachFunc, forEachContext) {
				mapChildren(children, function() {
					forEachFunc.apply(this, arguments);
				}, forEachContext);
			},
			count: function(children) {
				var n = 0;
				mapChildren(children, function() {
					n++;
				});
				return n;
			},
			toArray: function(children) {
				return mapChildren(children, function(child) {
					return child;
				}) || [];
			},
			only: function(children) {
				if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
				return children;
			}
		};
		exports.Activity = REACT_ACTIVITY_TYPE;
		exports.Children = fnName;
		exports.Component = Component;
		exports.Fragment = REACT_FRAGMENT_TYPE;
		exports.Profiler = REACT_PROFILER_TYPE;
		exports.PureComponent = PureComponent;
		exports.StrictMode = REACT_STRICT_MODE_TYPE;
		exports.Suspense = REACT_SUSPENSE_TYPE;
		exports.ViewTransition = REACT_VIEW_TRANSITION_TYPE;
		exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
		exports.__COMPILER_RUNTIME = deprecatedAPIs;
		exports.act = function(callback) {
			var prevActQueue = ReactSharedInternals.actQueue, prevActScopeDepth = actScopeDepth;
			actScopeDepth++;
			var queue = ReactSharedInternals.actQueue = null !== prevActQueue ? prevActQueue : [], didAwaitActCall = !1;
			try {
				var result = callback();
			} catch (error) {
				ReactSharedInternals.thrownErrors.push(error);
			}
			if (0 < ReactSharedInternals.thrownErrors.length) throw popActScope(prevActQueue, prevActScopeDepth), callback = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, callback;
			if (null !== result && "object" === typeof result && "function" === typeof result.then) {
				var thenable = result;
				queueSeveralMicrotasks(function() {
					didAwaitActCall || didWarnNoAwaitAct || (didWarnNoAwaitAct = !0, console.error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
				});
				return { then: function(resolve, reject) {
					didAwaitActCall = !0;
					thenable.then(function(returnValue) {
						popActScope(prevActQueue, prevActScopeDepth);
						if (0 === prevActScopeDepth) {
							try {
								flushActQueue(queue), enqueueTask(function() {
									return recursivelyFlushAsyncActWork(returnValue, resolve, reject);
								});
							} catch (error$0) {
								ReactSharedInternals.thrownErrors.push(error$0);
							}
							if (0 < ReactSharedInternals.thrownErrors.length) {
								var _thrownError = aggregateErrors(ReactSharedInternals.thrownErrors);
								ReactSharedInternals.thrownErrors.length = 0;
								reject(_thrownError);
							}
						} else resolve(returnValue);
					}, function(error) {
						popActScope(prevActQueue, prevActScopeDepth);
						0 < ReactSharedInternals.thrownErrors.length ? (error = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, reject(error)) : reject(error);
					});
				} };
			}
			var returnValue$jscomp$0 = result;
			popActScope(prevActQueue, prevActScopeDepth);
			0 === prevActScopeDepth && (flushActQueue(queue), 0 !== queue.length && queueSeveralMicrotasks(function() {
				didAwaitActCall || didWarnNoAwaitAct || (didWarnNoAwaitAct = !0, console.error("A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)"));
			}), ReactSharedInternals.actQueue = null);
			if (0 < ReactSharedInternals.thrownErrors.length) throw callback = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, callback;
			return { then: function(resolve, reject) {
				didAwaitActCall = !0;
				0 === prevActScopeDepth ? (ReactSharedInternals.actQueue = queue, enqueueTask(function() {
					return recursivelyFlushAsyncActWork(returnValue$jscomp$0, resolve, reject);
				})) : resolve(returnValue$jscomp$0);
			} };
		};
		exports.addTransitionType = addTransitionType;
		exports.cache = function(fn) {
			return function() {
				return fn.apply(null, arguments);
			};
		};
		exports.cacheSignal = function() {
			return null;
		};
		exports.captureOwnerStack = function() {
			var getCurrentStack = ReactSharedInternals.getCurrentStack;
			return null === getCurrentStack ? null : getCurrentStack();
		};
		exports.cloneElement = function(element, config, children) {
			if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
			var props = assign({}, element.props), key = element.key, owner = element._owner;
			if (null != config) {
				var JSCompiler_inline_result;
				a: {
					if (hasOwnProperty.call(config, "ref") && (JSCompiler_inline_result = Object.getOwnPropertyDescriptor(config, "ref").get) && JSCompiler_inline_result.isReactWarning) {
						JSCompiler_inline_result = !1;
						break a;
					}
					JSCompiler_inline_result = void 0 !== config.ref;
				}
				JSCompiler_inline_result && (owner = getOwner());
				hasValidKey(config) && (checkKeyStringCoercion(config.key), key = "" + config.key);
				for (propName in config) !hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
			}
			var propName = arguments.length - 2;
			if (1 === propName) props.children = children;
			else if (1 < propName) {
				JSCompiler_inline_result = Array(propName);
				for (var i = 0; i < propName; i++) JSCompiler_inline_result[i] = arguments[i + 2];
				props.children = JSCompiler_inline_result;
			}
			props = ReactElement(element.type, key, props, owner, element._debugStack, element._debugTask);
			for (key = 2; key < arguments.length; key++) validateChildKeys(arguments[key]);
			return props;
		};
		exports.createContext = function(defaultValue) {
			defaultValue = {
				$$typeof: REACT_CONTEXT_TYPE,
				_currentValue: defaultValue,
				_currentValue2: defaultValue,
				_threadCount: 0,
				Provider: null,
				Consumer: null
			};
			defaultValue.Provider = defaultValue;
			defaultValue.Consumer = {
				$$typeof: REACT_CONSUMER_TYPE,
				_context: defaultValue
			};
			defaultValue._currentRenderer = null;
			defaultValue._currentRenderer2 = null;
			return defaultValue;
		};
		exports.createElement = function(type, config, children) {
			for (var i = 2; i < arguments.length; i++) validateChildKeys(arguments[i]);
			var propName;
			i = {};
			var key = null;
			if (null != config) for (propName in didWarnAboutOldJSXRuntime || !("__self" in config) || "key" in config || (didWarnAboutOldJSXRuntime = !0, console.warn("Your app (or one of its dependencies) is using an outdated JSX transform. Update to the modern JSX transform for faster performance: https://react.dev/link/new-jsx-transform")), hasValidKey(config) && (checkKeyStringCoercion(config.key), key = "" + config.key), config) hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (i[propName] = config[propName]);
			var childrenLength = arguments.length - 2;
			if (1 === childrenLength) i.children = children;
			else if (1 < childrenLength) {
				for (var childArray = Array(childrenLength), _i = 0; _i < childrenLength; _i++) childArray[_i] = arguments[_i + 2];
				Object.freeze && Object.freeze(childArray);
				i.children = childArray;
			}
			if (type && type.defaultProps) for (propName in childrenLength = type.defaultProps, childrenLength) void 0 === i[propName] && (i[propName] = childrenLength[propName]);
			key && defineKeyPropWarningGetter(i, "function" === typeof type ? type.displayName || type.name || "Unknown" : type);
			(propName = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++) ? (childArray = Error.stackTraceLimit, Error.stackTraceLimit = 10, childrenLength = Error("react-stack-top-frame"), Error.stackTraceLimit = childArray) : childrenLength = unknownOwnerDebugStack;
			return ReactElement(type, key, i, getOwner(), childrenLength, propName ? createTask(getTaskName(type)) : unknownOwnerDebugTask);
		};
		exports.createRef = function() {
			var refObject = { current: null };
			Object.seal(refObject);
			return refObject;
		};
		exports.forwardRef = function(render) {
			null != render && render.$$typeof === REACT_MEMO_TYPE ? console.error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : "function" !== typeof render ? console.error("forwardRef requires a render function but was given %s.", null === render ? "null" : typeof render) : 0 !== render.length && 2 !== render.length && console.error("forwardRef render functions accept exactly two parameters: props and ref. %s", 1 === render.length ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
			null != render && null != render.defaultProps && console.error("forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?");
			var elementType = {
				$$typeof: REACT_FORWARD_REF_TYPE,
				render
			}, ownName;
			Object.defineProperty(elementType, "displayName", {
				enumerable: !1,
				configurable: !0,
				get: function() {
					return ownName;
				},
				set: function(name) {
					ownName = name;
					render.name || render.displayName || (Object.defineProperty(render, "name", { value: name }), render.displayName = name);
				}
			});
			return elementType;
		};
		exports.isValidElement = isValidElement;
		exports.lazy = function(ctor) {
			ctor = {
				_status: -1,
				_result: ctor
			};
			var lazyType = {
				$$typeof: REACT_LAZY_TYPE,
				_payload: ctor,
				_init: lazyInitializer
			}, ioInfo = {
				name: "lazy",
				start: -1,
				end: -1,
				value: null,
				owner: null,
				debugStack: Error("react-stack-top-frame"),
				debugTask: console.createTask ? console.createTask("lazy()") : null
			};
			ctor._ioInfo = ioInfo;
			lazyType._debugInfo = [{ awaited: ioInfo }];
			return lazyType;
		};
		exports.memo = function(type, compare) {
			type ?? console.error("memo: The first argument must be a component. Instead received: %s", null === type ? "null" : typeof type);
			compare = {
				$$typeof: REACT_MEMO_TYPE,
				type,
				compare: void 0 === compare ? null : compare
			};
			var ownName;
			Object.defineProperty(compare, "displayName", {
				enumerable: !1,
				configurable: !0,
				get: function() {
					return ownName;
				},
				set: function(name) {
					ownName = name;
					type.name || type.displayName || (Object.defineProperty(type, "name", { value: name }), type.displayName = name);
				}
			});
			return compare;
		};
		exports.startTransition = startTransition;
		exports.unstable_useCacheRefresh = function() {
			return resolveDispatcher().useCacheRefresh();
		};
		exports.use = function(usable) {
			return resolveDispatcher().use(usable);
		};
		exports.useActionState = function(action, initialState, permalink) {
			return resolveDispatcher().useActionState(action, initialState, permalink);
		};
		exports.useCallback = function(callback, deps) {
			return resolveDispatcher().useCallback(callback, deps);
		};
		exports.useContext = function(Context) {
			var dispatcher = resolveDispatcher();
			Context.$$typeof === REACT_CONSUMER_TYPE && console.error("Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?");
			return dispatcher.useContext(Context);
		};
		exports.useDebugValue = function(value, formatterFn) {
			return resolveDispatcher().useDebugValue(value, formatterFn);
		};
		exports.useDeferredValue = function(value, initialValue) {
			return resolveDispatcher().useDeferredValue(value, initialValue);
		};
		exports.useEffect = function(create, deps) {
			create ?? console.warn("React Hook useEffect requires an effect callback. Did you forget to pass a callback to the hook?");
			return resolveDispatcher().useEffect(create, deps);
		};
		exports.useEffectEvent = function(callback) {
			return resolveDispatcher().useEffectEvent(callback);
		};
		exports.useId = function() {
			return resolveDispatcher().useId();
		};
		exports.useImperativeHandle = function(ref, create, deps) {
			return resolveDispatcher().useImperativeHandle(ref, create, deps);
		};
		exports.useInsertionEffect = function(create, deps) {
			create ?? console.warn("React Hook useInsertionEffect requires an effect callback. Did you forget to pass a callback to the hook?");
			return resolveDispatcher().useInsertionEffect(create, deps);
		};
		exports.useLayoutEffect = function(create, deps) {
			create ?? console.warn("React Hook useLayoutEffect requires an effect callback. Did you forget to pass a callback to the hook?");
			return resolveDispatcher().useLayoutEffect(create, deps);
		};
		exports.useMemo = function(create, deps) {
			return resolveDispatcher().useMemo(create, deps);
		};
		exports.useOptimistic = function(passthrough, reducer) {
			return resolveDispatcher().useOptimistic(passthrough, reducer);
		};
		exports.useReducer = function(reducer, initialArg, init) {
			return resolveDispatcher().useReducer(reducer, initialArg, init);
		};
		exports.useRef = function(initialValue) {
			return resolveDispatcher().useRef(initialValue);
		};
		exports.useState = function(initialState) {
			return resolveDispatcher().useState(initialState);
		};
		exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
			return resolveDispatcher().useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
		};
		exports.useTransition = function() {
			return resolveDispatcher().useTransition();
		};
		exports.version = "19.3.1";
		"undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
	})();
}));
// ../../node_modules/react/index.js
var require_react = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	if (process.env.NODE_ENV === "production") module.exports = require_react_production();
	else module.exports = require_react_development();
}));
// ../../node_modules/@tabler/icons-react/dist/esm/defaultAttributes.mjs
/**
* @license @tabler/icons-react v3.49.0 - MIT
*
* This source code is licensed under the MIT license.
* See the LICENSE file in the root directory of this source tree.
*/
var defaultAttributes = {
	outline: {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	},
	filled: {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "currentColor",
		stroke: "none"
	}
};
// ../../node_modules/@tabler/icons-react/dist/esm/createReactComponent.mjs
var import_react = require_react();
/**
* @license @tabler/icons-react v3.49.0 - MIT
*
* This source code is licensed under the MIT license.
* See the LICENSE file in the root directory of this source tree.
*/
var createReactComponent = (type, iconName, iconNamePascal, iconNode) => {
	const Component = (0, import_react.forwardRef)(({ color = "currentColor", size = 24, stroke = 2, title, className, children, ...rest }, ref) => (0, import_react.createElement)("svg", {
		ref,
		...defaultAttributes[type],
		width: size,
		height: size,
		className: [
			`tabler-icon`,
			`tabler-icon-${iconName}`,
			className
		].filter(Boolean).join(" "),
		...type === "filled" ? { fill: color } : {
			strokeWidth: stroke,
			stroke: color
		},
		...rest
	}, [
		title && (0, import_react.createElement)("title", { key: "svg-title" }, title),
		...iconNode.map(([tag, attrs]) => (0, import_react.createElement)(tag, attrs)),
		...Array.isArray(children) ? children : [children]
	]));
	Component.displayName = `${iconNamePascal}`;
	return Component;
};
/**
* @license @tabler/icons-react v3.49.0 - MIT
*
* This source code is licensed under the MIT license.
* See the LICENSE file in the root directory of this source tree.
*/
var IconBrandFacebook = createReactComponent("outline", "brand-facebook", "BrandFacebook", [["path", {
	"d": "M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3",
	"key": "svg-0"
}]]);
/**
* @license @tabler/icons-react v3.49.0 - MIT
*
* This source code is licensed under the MIT license.
* See the LICENSE file in the root directory of this source tree.
*/
var IconBrandInstagram = createReactComponent("outline", "brand-instagram", "BrandInstagram", [
	["path", {
		"d": "M3 7a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4l0 -10",
		"key": "svg-0"
	}],
	["path", {
		"d": "M8.5 12a3.5 3.5 0 1 0 7 0a3.5 3.5 0 0 0 -7 0",
		"key": "svg-1"
	}],
	["path", {
		"d": "M17 7v.01",
		"key": "svg-2"
	}]
]);
/**
* @license @tabler/icons-react v3.49.0 - MIT
*
* This source code is licensed under the MIT license.
* See the LICENSE file in the root directory of this source tree.
*/
var IconBrandLinkedin = createReactComponent("outline", "brand-linkedin", "BrandLinkedin", [
	["path", {
		"d": "M8 11v5",
		"key": "svg-0"
	}],
	["path", {
		"d": "M8 8v.01",
		"key": "svg-1"
	}],
	["path", {
		"d": "M12 16v-5",
		"key": "svg-2"
	}],
	["path", {
		"d": "M16 16v-3a2 2 0 1 0 -4 0",
		"key": "svg-3"
	}],
	["path", {
		"d": "M3 7a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4l0 -10",
		"key": "svg-4"
	}]
]);
/**
* @license @tabler/icons-react v3.49.0 - MIT
*
* This source code is licensed under the MIT license.
* See the LICENSE file in the root directory of this source tree.
*/
var IconBrandTiktok = createReactComponent("outline", "brand-tiktok", "BrandTiktok", [["path", {
	"d": "M21 7.917v4.034a9.948 9.948 0 0 1 -5 -1.951v4.5a6.5 6.5 0 1 1 -8 -6.326v4.326a2.5 2.5 0 1 0 4 2v-11.5h4.083a6.005 6.005 0 0 0 4.917 4.917",
	"key": "svg-0"
}]]);
/**
* @license @tabler/icons-react v3.49.0 - MIT
*
* This source code is licensed under the MIT license.
* See the LICENSE file in the root directory of this source tree.
*/
var IconBuildings = createReactComponent("outline", "buildings", "Buildings", [
	["path", {
		"d": "M4 21v-15c0 -1 1 -2 2 -2h5c1 0 2 1 2 2v15",
		"key": "svg-0"
	}],
	["path", {
		"d": "M16 8h2c1 0 2 1 2 2v11",
		"key": "svg-1"
	}],
	["path", {
		"d": "M3 21h18",
		"key": "svg-2"
	}],
	["path", {
		"d": "M10 12v.01",
		"key": "svg-3"
	}],
	["path", {
		"d": "M10 16v.01",
		"key": "svg-4"
	}],
	["path", {
		"d": "M10 8v.01",
		"key": "svg-5"
	}],
	["path", {
		"d": "M7 12v.01",
		"key": "svg-6"
	}],
	["path", {
		"d": "M7 16v.01",
		"key": "svg-7"
	}],
	["path", {
		"d": "M7 8v.01",
		"key": "svg-8"
	}],
	["path", {
		"d": "M17 12v.01",
		"key": "svg-9"
	}],
	["path", {
		"d": "M17 16v.01",
		"key": "svg-10"
	}]
]);
/**
* @license @tabler/icons-react v3.49.0 - MIT
*
* This source code is licensed under the MIT license.
* See the LICENSE file in the root directory of this source tree.
*/
var IconHelpCircle = createReactComponent("outline", "help-circle", "HelpCircle", [
	["path", {
		"d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0",
		"key": "svg-0"
	}],
	["path", {
		"d": "M12 16v.01",
		"key": "svg-1"
	}],
	["path", {
		"d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483",
		"key": "svg-2"
	}]
]);
/**
* @license @tabler/icons-react v3.49.0 - MIT
*
* This source code is licensed under the MIT license.
* See the LICENSE file in the root directory of this source tree.
*/
var IconLetterJ = createReactComponent("outline", "letter-j", "LetterJ", [["path", {
	"d": "M17 4v12a4 4 0 0 1 -4 4h-2a4 4 0 0 1 -4 -4",
	"key": "svg-0"
}]]);
/**
* @license @tabler/icons-react v3.49.0 - MIT
*
* This source code is licensed under the MIT license.
* See the LICENSE file in the root directory of this source tree.
*/
var IconLetterK = createReactComponent("outline", "letter-k", "LetterK", [
	["path", {
		"d": "M7 4l0 16",
		"key": "svg-0"
	}],
	["path", {
		"d": "M7 12h2l8 -8",
		"key": "svg-1"
	}],
	["path", {
		"d": "M9 12l8 8",
		"key": "svg-2"
	}]
]);
// source/enums/login-data-platform.ts
var LoginDataPlatform = {
	PARTNER_PORTAL: "PARTNER_PORTAL",
	INSTAGRAM: "INSTAGRAM",
	FACEBOOK: "FACEBOOK",
	LINKEDIN: "LINKEDIN",
	TIKTOK: "TIKTOK",
	KUNUNU: "KUNUNU",
	JOIN: "JOIN",
	OTHER: "OTHER"
};
var LoginViewableDataPlatform = {
	PARTNER_PORTAL: "PARTNER_PORTAL",
	INSTAGRAM: "INSTAGRAM",
	FACEBOOK: "FACEBOOK",
	LINKEDIN: "LINKEDIN",
	TIKTOK: "TIKTOK",
	KUNUNU: "KUNUNU",
	OTHER: "OTHER"
};
var EditableLoginDataPlatform = {
	INSTAGRAM: "INSTAGRAM",
	TIKTOK: "TIKTOK"
};
var SocialDataPlatform = {
	INSTAGRAM: "INSTAGRAM",
	FACEBOOK: "FACEBOOK",
	LINKEDIN: "LINKEDIN",
	TIKTOK: "TIKTOK",
	KUNUNU: "KUNUNU"
};
var formatLoginDataPlatform = (loginDataPlatform) => {
	switch (loginDataPlatform) {
		case LoginDataPlatform.PARTNER_PORTAL: return "Partner Portal";
		case LoginDataPlatform.INSTAGRAM: return "Instagram";
		case LoginDataPlatform.FACEBOOK: return "Facebook";
		case LoginDataPlatform.LINKEDIN: return "LinkedIn";
		case LoginDataPlatform.TIKTOK: return "TikTok";
		case LoginDataPlatform.KUNUNU: return "Kununu";
		case LoginDataPlatform.JOIN: return "Join";
		case LoginDataPlatform.OTHER: return "Other";
		default: return loginDataPlatform;
	}
};
var getLoginDataPlatformIcon = (loginDataPlatform) => {
	switch (loginDataPlatform) {
		case LoginDataPlatform.PARTNER_PORTAL: return {
			icon: IconBuildings,
			color: "text-black"
		};
		case LoginDataPlatform.INSTAGRAM: return {
			icon: IconBrandInstagram,
			color: "text-instagram"
		};
		case LoginDataPlatform.FACEBOOK: return {
			icon: IconBrandFacebook,
			color: "text-facebook"
		};
		case LoginDataPlatform.LINKEDIN: return {
			icon: IconBrandLinkedin,
			color: "text-linkedin"
		};
		case LoginDataPlatform.TIKTOK: return {
			icon: IconBrandTiktok,
			color: "text-black"
		};
		case LoginDataPlatform.KUNUNU: return {
			icon: IconLetterK,
			color: "text-black"
		};
		case LoginDataPlatform.JOIN: return {
			icon: IconLetterJ,
			color: "text-black"
		};
		case LoginDataPlatform.OTHER: return {
			icon: IconHelpCircle,
			color: "text-black"
		};
		default: throw new Error(`Invalid login data platform: ${loginDataPlatform}`);
	}
};
// source/enums/analytics-type.ts
var AnalyticsType = {
	FOLLOWERS: "FOLLOWERS",
	IMPRESSIONS: "IMPRESSIONS"
};
// source/enums/platform-type.ts
var PlatformType = {
	FACEBOOK: "FACEBOOK",
	INSTAGRAM: "INSTAGRAM",
	LINKEDIN: "LINKEDIN",
	TIKTOK: "TIKTOK"
};
// source/enums/applicant-origin.ts
var ApplicantOrigin = {
	MANUAL: "MANUAL",
	PERSPECTIVE: "PERSPECTIVE",
	CAREER_PAGE: "CAREER_PAGE",
	WL_LANDING_PAGE: "WL_LANDING_PAGE"
};
// source/enums/website-status.ts
var WebsiteStatus = {
	ACTIVE: "ACTIVE",
	INACTIVE: "INACTIVE",
	IN_PREPARATION: "IN_PREPARATION",
	NOT_BOOKED: "NOT_BOOKED"
};
// source/enums/smtp-port.ts
var SmtpPort = {
	465: "465",
	587: "587"
};
// source/enums/prequalification-status.ts
var PrequalificationStatus = {
	APPROVED: "APPROVED",
	REJECTED: "REJECTED",
	NOT_REACHED: "NOT_REACHED",
	APPROVED_WITHOUT_GUARANTEE: "APPROVED_WITHOUT_GUARANTEE"
};
var prequalificationStatusToLabelMap = {
	[PrequalificationStatus.APPROVED]: {
		label: "Weitergeleitet",
		color: "success"
	},
	[PrequalificationStatus.APPROVED_WITHOUT_GUARANTEE]: {
		label: "Weitergeleitet (ohne Garantie)",
		color: "secondary"
	},
	[PrequalificationStatus.NOT_REACHED]: {
		label: "Nicht erreicht",
		color: "warning"
	},
	[PrequalificationStatus.REJECTED]: {
		label: "Disqualifiziert",
		color: "danger"
	}
};
/**
* Both "approved" statuses mean the candidate was forwarded to the customer,
* so analyses that count forwarded candidates have to treat them alike. Only
* the guarantee distinguishes them, see isGuaranteeCandidate.
*/
var forwardedPrequalificationStatuses = [PrequalificationStatus.APPROVED, PrequalificationStatus.APPROVED_WITHOUT_GUARANTEE];
var isForwardedPrequalificationStatus = (status) => forwardedPrequalificationStatuses.includes(status);
// source/enums/last-phase-change-role.ts
var LastPhaseChangeRole = {
	MANAGER: "MANAGER",
	CUSTOMER: "CUSTOMER",
	APPLICANT_MANAGER: "APPLICANT_MANAGER",
	ADMIN: "ADMIN",
	AUTOMATION: "AUTOMATION"
};
var getLastPhaseChangeRoleFromRole = (role) => role;
// source/enums/monday-recruiting-status.ts
var MondayRecruitingStatus = {
	UNRESOLVED: "UNRESOLVED",
	PROBLEM: "PROBLEM",
	RESOLVED: "RESOLVED"
};
// source/enums/product-version.ts
var ProductVersion = {
	V1: "V1",
	V2: "V2"
};
// source/enums/on-behalf-of.ts
var OnBehalfOf = {
	STAHLHART: "STAHLHART",
	CUSTOMER: "CUSTOMER"
};
// source/enums/country-code.ts
var countryCodes = [
	"DE",
	"AT",
	"CH"
];
var CountryCode = {
	DE: "DE",
	AT: "AT",
	CH: "CH"
};
var countryCodeToLabelMap = {
	DE: "Deutschland",
	AT: "Österreich",
	CH: "Schweiz"
};
// source/routes/generate-route.ts
var generateRoute = (segments = [""], subRoutes = {}) => (buildPrevious = () => "") => (isRootsParent = false, args = {}) => {
	const build = (queryParams = void 0) => {
		const segmentsToJoin = [];
		if (isRootsParent === false) {
			segmentsToJoin.push(buildPrevious());
			segmentsToJoin.push(...Object.keys(args).reduce((segmentsWithArgsAccumulator, arg) => segmentsWithArgsAccumulator.map((segment) => segment !== `:${arg}` ? segment : String(args[arg])), segments));
		}
		if (queryParams !== void 0) segmentsToJoin.push(`?${queryString.stringify(queryParams, { replacer: (_key, value) => value !== null && typeof value === "object" && !Array.isArray(value) ? String(value) : value })}`);
		return (isRootsParent === true ? "/" : "") + urlJoin(segmentsToJoin);
	};
	return {
		build,
		...Object.fromEntries(Object.keys(subRoutes).map((x) => [x, subRoutes[x](build)]))
	};
};
// source/routes/api-routes.ts
var apiRoutes = generateRoute([config.apiUrl], {
	migrations: generateRoute(["migrations"], { migrate: generateRoute([":name"]) }),
	cron: generateRoute(["cron"], {
		syncCustomersFromMonday: generateRoute(["sync-customers-from-monday"]),
		syncCustomerAnalytics: generateRoute(["sync-customer-analytics"]),
		syncSettingsFromMonday: generateRoute(["sync-settings-from-monday"]),
		syncRecruitingFromMonday: generateRoute(["sync-recruiting-from-monday"]),
		scrapeOutdatedCustomers: generateRoute(["scrape-outdated-customers"]),
		syncJobPositionsAdsAnalytics: generateRoute(["sync-ads-analytics"]),
		deleteOutdatedArchivedApplicants: generateRoute(["delete-outdated-archived-applicants"]),
		verifyDomainOwnerships: generateRoute(["verify-domain-ownerships"]),
		monitor: generateRoute(["monitor"]),
		checkUmami: generateRoute(["check-umami"]),
		processHrbaxmlErrorLogs: generateRoute(["process-hrbaxml-error-logs"]),
		syncHrbaxmlPostings: generateRoute(["sync-hrbaxml-postings"]),
		regenerateCareerPages: generateRoute(["regenerate-career-pages"]),
		checkOverdueStatusUpdates: generateRoute(["check-overdue-status-updates"]),
		checkSocialMediaCreditDocuments: generateRoute(["check-social-media-credit-documents"]),
		checkJobPositionQuotaEndDates: generateRoute(["check-job-position-quota-end-dates"]),
		createWeeklyRecruitingLogEntries: generateRoute(["create-weekly-recruiting-log-entries"])
	}),
	mondaySettingsData: generateRoute(["monday-settings"], { get: generateRoute() }),
	mondayRecruiting: generateRoute(["monday-recruiting"], {
		getAll: generateRoute(["all"]),
		getAllLight: generateRoute(["all-light"]),
		sync: generateRoute(["sync"]),
		syncOne: generateRoute(["sync", ":id"]),
		updateStatus: generateRoute(["status", ":id"]),
		get: generateRoute([":id"])
	}),
	recruitingLogEntries: generateRoute(["recruiting-log-entries"], {
		getAllByMondayRecruitingId: generateRoute(["by-campaign", ":id"]),
		create: generateRoute(["by-campaign", ":id"]),
		update: generateRoute([":id"]),
		remove: generateRoute([":id"])
	}),
	customers: generateRoute(["customers"], {
		create: generateRoute(),
		scrape: generateRoute(["scrape", ":id"]),
		mondayEvent: generateRoute(["monday-event"]),
		get: generateRoute([":id"]),
		getByFirebaseUid: generateRoute(["by-firebase-uid"]),
		getByCompanyId: generateRoute(["by-company-id", ":id"]),
		getAll: generateRoute(["all"]),
		getAllLight: generateRoute(["all-light"]),
		getAllByApplicantManagerId: generateRoute(["by-applicant-manager-id"]),
		syncAll: generateRoute(["sync-all"]),
		toggleCareerReceiptConfirmation: generateRoute(["toggle-career-receipt-confirmation", ":id"])
	}),
	customerFonts: generateRoute(["customer-fonts"], {
		create: generateRoute(),
		get: generateRoute([":id"]),
		getByCustomerId: generateRoute(["by-customer-id", ":id"]),
		rename: generateRoute(["rename", ":id"]),
		setActiveWeight: generateRoute(["set-active-weight", ":id"]),
		remove: generateRoute([":id"])
	}),
	companies: generateRoute(["companies"], {
		get: generateRoute([":id"]),
		getByCustomerId: generateRoute(["by-customer-id", ":id"]),
		getByJobPositionId: generateRoute(["by-job-position-id", ":id"]),
		getAll: generateRoute(["all"]),
		update: generateRoute([":id"]),
		partialUpdate: generateRoute(["partial", ":id"])
	}),
	careerSettings: generateRoute(["career-settings"], {
		getByCustomerId: generateRoute(["/by-customer-id", ":id"]),
		updateByCustomerId: generateRoute(["/by-customer-id", ":id"]),
		upload: generateRoute([":id", "upload"]),
		sendApplication: generateRoute(["send-application"]),
		setActive: generateRoute(["active", ":id"])
	}),
	careerPage: generateRoute(["career-page"], {
		generate: generateRoute(["generate"]),
		clean: generateRoute(["clean", ":id"]),
		check: generateRoute(["check", ":id"]),
		needsPublishing: generateRoute(["needs-publishing", ":id"])
	}),
	npsLogs: generateRoute(["nps-logs"], { create: generateRoute() }),
	jobPositionAnalytics: generateRoute(["job-position-analytics"], {
		getByJobPositionId: generateRoute(["by-job-position-id", ":id"]),
		getByCustomerId: generateRoute(["by-customer-id", ":id"]),
		getReach: generateRoute(["reach"])
	}),
	jobPositions: generateRoute(["job-positions"], {
		create: generateRoute(),
		get: generateRoute([":id"]),
		getAll: generateRoute(["all"]),
		getAllByApplicantManagerId: generateRoute(["by-applicant-manager-id", ":id"]),
		update: generateRoute([":id"]),
		remove: generateRoute([":id"]),
		partialUpdate: generateRoute(["partial", ":id"]),
		mediaUpdate: generateRoute(["media", ":id"]),
		searchSalary: generateRoute(["search-salary"])
	}),
	jobPositionTemplates: generateRoute(["job-position-templates"], {
		create: generateRoute(),
		get: generateRoute([":id"]),
		getByCustomerId: generateRoute(["by-customer-id", ":id"]),
		update: generateRoute([":id"]),
		upsert: generateRoute(),
		remove: generateRoute([":id"])
	}),
	applicants: generateRoute(["applicants"], {
		create: generateRoute(),
		upload: generateRoute(["upload"]),
		get: generateRoute([":id"]),
		find: generateRoute(["find"]),
		getAllByCustomerId: generateRoute(["by-customer-id", ":id"]),
		getEndPhaseByCustomerId: generateRoute(["end-phase-by-customer-id", ":id"]),
		getEndPhaseCountsByCustomerId: generateRoute(["end-phase-counts-by-customer-id", ":id"]),
		getByJobId: generateRoute(["by-job-id", ":id"]),
		getAllByApplicantManagerId: generateRoute(["by-applicant-manager-id", ":id"]),
		getAllDuplicatedByApplicantManagerId: generateRoute(["duplicated-by-applicant-manager-id", ":id"]),
		getAll: generateRoute(["all"]),
		update: generateRoute([":id"]),
		updatePersonalInfo: generateRoute(["personal-info", ":token"]),
		archive: generateRoute(["archive", ":id"]),
		restore: generateRoute(["restore", ":id"]),
		remove: generateRoute([":id"]),
		getByShareLinkToken: generateRoute(["shared", ":token"]),
		updateByShareLinkToken: generateRoute(["shared", ":token"]),
		markCustomerNoteCommentsAsRead: generateRoute(["mark-comments-read", ":id"]),
		getCountByCustomerId: generateRoute(["count-by-customer-id", ":id"]),
		getCampaignsByCustomerId: generateRoute(["campaigns-by-customer-id", ":id"]),
		getLandingPageVersionsByCustomerId: generateRoute(["landing-page-versions-by-customer-id", ":id"])
	}),
	applicantProcessingStates: generateRoute(["applicant-processing-states"], {
		getAllByApplicantManagerId: generateRoute(["by-applicant-manager-id", ":id"]),
		resolve: generateRoute(["resolve", ":id"]),
		unresolve: generateRoute(["unresolve", ":id"]),
		lock: generateRoute(["lock", ":id"]),
		unlock: generateRoute(["unlock", ":id"])
	}),
	applicantManagers: generateRoute(["applicant-managers"], {
		getByFirebaseUid: generateRoute(["by-firebase-uid"]),
		getCustomToken: generateRoute(["custom-token"]),
		getAll: generateRoute(["all"])
	}),
	applicantPhases: generateRoute(["applicant-phases"], {
		addSupported: generateRoute(["add-supported"]),
		removeSupported: generateRoute(["remove-supported"]),
		create: generateRoute(),
		get: generateRoute([":id"]),
		getAll: generateRoute(["all"]),
		update: generateRoute([":id"]),
		remove: generateRoute([":id"])
	}),
	applicantSources: generateRoute(["applicant-sources"], {
		create: generateRoute(),
		get: generateRoute([":id"]),
		getAll: generateRoute(["all"]),
		update: generateRoute([":id"]),
		remove: generateRoute([":id"])
	}),
	blockedApplicants: generateRoute(["blocked-applicants"], {
		create: generateRoute(),
		get: generateRoute([":id"]),
		getAll: generateRoute(["all"]),
		update: generateRoute([":id"]),
		remove: generateRoute([":id"])
	}),
	platforms: generateRoute(["platforms"], {
		create: generateRoute(),
		get: generateRoute([":id"]),
		getAll: generateRoute(["all"]),
		update: generateRoute([":id"]),
		remove: generateRoute([":id"])
	}),
	applicantDocuments: generateRoute(["applicant-documents"], {
		create: generateRoute(),
		get: generateRoute([":id"]),
		getDownloadUrl: generateRoute(["download-url", ":id"]),
		getDownloadAllForApplicantUrl: generateRoute(["download-all-for-applicant", ":id"]),
		getPreviewUrl: generateRoute(["preview-url", ":id"]),
		getThumbnailUrl: generateRoute(["thumbnail-url", ":id"]),
		getByApplicantId: generateRoute(["by-applicant-id", ":id"]),
		rename: generateRoute(["rename", ":id"]),
		markRead: generateRoute(["mark-read", ":id"]),
		markAllReadForApplicant: generateRoute(["mark-read-for-applicant", ":id"]),
		markUnread: generateRoute(["mark-unread", ":id"]),
		remove: generateRoute([":id"]),
		getByShareLinkToken: generateRoute(["shared", ":token"]),
		getDownloadUrlByShareLinkToken: generateRoute([
			"shared",
			"download-url",
			":id"
		]),
		getPreviewUrlByShareLinkToken: generateRoute([
			"shared",
			"preview-url",
			":id"
		]),
		getThumbnailUrlByShareLinkToken: generateRoute([
			"shared",
			"thumbnail-url",
			":id"
		])
	}),
	locations: generateRoute(["locations"], {
		get: generateRoute([":id"]),
		getByCustomerId: generateRoute(["by-customer-id", ":id"]),
		update: generateRoute([":id"]),
		create: generateRoute(),
		remove: generateRoute([":id"]),
		toggleActive: generateRoute([":id", "toggle-active"]),
		routeByPostalCode: generateRoute(["route-by-postal-code"]),
		mapLocationByPostalCode: generateRoute(["location-by-postal-code"])
	}),
	workAreas: generateRoute(["work-areas"], {
		get: generateRoute([":id"]),
		getByCustomerId: generateRoute(["by-customer-id", ":id"]),
		update: generateRoute([":id"]),
		create: generateRoute(),
		remove: generateRoute([":id"])
	}),
	scoreCards: generateRoute(["score-cards"], {
		get: generateRoute([":id"]),
		getByJobPositionId: generateRoute(["by-job-position-id", ":id"]),
		update: generateRoute([":id"]),
		create: generateRoute(),
		remove: generateRoute([":id"]),
		upsertMany: generateRoute(["upsert-many"])
	}),
	applicantScores: generateRoute(["applicant-scores"], {
		get: generateRoute([":id"]),
		getForApplicant: generateRoute(["applicant"]),
		update: generateRoute([":id"]),
		upsert: generateRoute(["upsert"]),
		create: generateRoute(),
		remove: generateRoute([":id"])
	}),
	applicantStatusUpdates: generateRoute(["applicant-status-updates"], {
		create: generateRoute(),
		getForApplicant: generateRoute(["applicant"]),
		getGuaranteeForfeitureEmail: generateRoute(["guarantee-forfeiture-email", ":id"]),
		sendGuaranteeForfeitureEmail: generateRoute(["guarantee-forfeiture-email", ":id"])
	}),
	webhooks: generateRoute(["webhooks"], {
		perspective: generateRoute(["perspective"]),
		wlLandingPage: generateRoute(["wl-landing-page"]),
		generateCareerPage: generateRoute(["generate-career-page"]),
		sendScheduledMail: generateRoute(["send-scheduled-mail"]),
		removeCareerDomain: generateRoute(["remove-career-domain"]),
		scanDocument: generateRoute(["scan-document"]),
		syncCustomerAnalytics: generateRoute(["sync-customer-analytics"]),
		syncHrbaxmlPosting: generateRoute(["sync-hrbaxml-posting"]),
		processHrbaxmlErrorLogs: generateRoute(["process-hrbaxml-error-logs"]),
		generateIndeedXmlFeed: generateRoute(["generate-indeed-xml-feed"]),
		checkSocialMediaCreditDocument: generateRoute(["check-social-media-credit-document"]),
		mailersendBounce: generateRoute(["mailersend-bounce"]),
		create: generateRoute(["create"]),
		getByJobPositionId: generateRoute(["by-job-position-id", ":id"]),
		update: generateRoute([":id"]),
		remove: generateRoute([":id"])
	}),
	integrations: generateRoute(["integrations"], { stahlhart: generateRoute(["stahlhart"], {
		getCompanies: generateRoute(["companies"]),
		getCompany: generateRoute(["companies", ":customerId"]),
		getJobPositions: generateRoute(["job-positions"]),
		getJobPosition: generateRoute(["job-positions", ":id"]),
		getJobPositionApplicantCounts: generateRoute([
			"job-positions",
			":id",
			"applicant-counts"
		]),
		upsertJobPositionWebhook: generateRoute([
			"job-positions",
			":id",
			"webhook"
		]),
		removeJobPositionWebhook: generateRoute([
			"job-positions",
			":id",
			"webhook"
		])
	}) }),
	emailTemplates: generateRoute(["email-templates"], {
		get: generateRoute([":id"]),
		getAll: generateRoute(["all"]),
		update: generateRoute([":id"]),
		sendTestEmail: generateRoute(["send-test-email", ":id"])
	}),
	smsTemplates: generateRoute(["sms-templates"], {
		get: generateRoute([":id"]),
		getAll: generateRoute(["all"]),
		update: generateRoute([":id"])
	}),
	emailSignatures: generateRoute(["email-signatures"], {
		get: generateRoute([":id"]),
		getAll: generateRoute(["all"]),
		update: generateRoute([":id"])
	}),
	applicantAutomations: generateRoute(["applicant-automations"], { run: generateRoute(["run"]) }),
	applicantAutomationTemplates: generateRoute(["applicant-automation-templates"], {
		get: generateRoute([":id"]),
		getAll: generateRoute(["all"])
	}),
	resume: generateRoute(["resume"], {
		getData: generateRoute(["data", ":token"]),
		sendResume: generateRoute(["send-resume", ":token"])
	}),
	sanity: generateRoute(["sanity"], {
		courses: generateRoute(["courses"]),
		course: generateRoute(["course", ":id"]),
		chapter: generateRoute(["chapter", ":id"]),
		lesson: generateRoute(["lesson", ":id"])
	}),
	careerDomains: generateRoute(["career-domains"], {
		create: generateRoute(),
		get: generateRoute([":id"]),
		getByCustomerId: generateRoute(["by-customer-id", ":id"]),
		verify: generateRoute(["verify", ":id"]),
		remove: generateRoute([":id"])
	}),
	oAuth: generateRoute(["oauth"], {
		google: generateRoute(["google"], {
			initiate: generateRoute(["initialize", ":id"]),
			callback: generateRoute(["callback"])
		}),
		microsoft: generateRoute(["microsoft"], {
			initiate: generateRoute(["initialize", ":id"]),
			callback: generateRoute(["callback"])
		})
	}),
	emailProviders: generateRoute(["email-providers"], {
		getByCustomerId: generateRoute(["by-customer-id", ":id"]),
		get: generateRoute([":id"]),
		remove: generateRoute([":id"]),
		update: generateRoute([":id"]),
		createSmtpProvider: generateRoute(["smtp", ":id"])
	}),
	customerEmails: generateRoute(["customer-emails"], {
		send: generateRoute(["send", ":id"]),
		sendTestEmail: generateRoute(["send-test-email", ":id"])
	}),
	customerEmailTemplates: generateRoute(["customer-email-templates"], {
		get: generateRoute([":id"]),
		getByKey: generateRoute(["by-key", ":id"]),
		getByCustomerId: generateRoute(["by-customer-id", ":id"]),
		create: generateRoute(),
		update: generateRoute([":id"]),
		remove: generateRoute([":id"])
	}),
	customerEmailSignatures: generateRoute(["customer-email-signatures"], {
		get: generateRoute([":id"]),
		getByCustomerId: generateRoute(["by-customer-id", ":id"]),
		create: generateRoute(),
		update: generateRoute([":id"]),
		remove: generateRoute([":id"])
	}),
	metrics: generateRoute(["metrics"], { api: generateRoute(["api"], { websites: generateRoute(["websites"], {
		latest: generateRoute(["latest", ":id"]),
		values: generateRoute([":id", "values"]),
		active: generateRoute([":id", "active"]),
		events: generateRoute([":id", "events"]),
		pageViews: generateRoute([":id", "pageviews"]),
		metrics: generateRoute([":id", "metrics"]),
		stats: generateRoute([":id", "stats"]),
		detailedEvents: generateRoute([":id", "detailed-events"])
	}) }) }),
	clientErrors: generateRoute(["client-errors"]),
	health: generateRoute(["health"], {
		ready: generateRoute(["ready"]),
		stats: generateRoute(["stats"]),
		version: generateRoute(["version"]),
		migrations: generateRoute(["migrations"])
	}),
	customerAnalytics: generateRoute(["customer-analytics"], {
		getByCustomerId: generateRoute(["by-customer-id", ":id"]),
		getEarliestByCustomerId: generateRoute(["earliest-by-customer-id", ":id"])
	}),
	hrbaxmlConfig: generateRoute(["hrbaxml-config"], {
		getByCustomerId: generateRoute(["by-customer-id", ":id"]),
		create: generateRoute([":id"]),
		update: generateRoute([":id"]),
		uploadCertificate: generateRoute(["certificate", ":id"]),
		testConnection: generateRoute(["test-connection", ":id"])
	}),
	hrbaxmlSync: generateRoute(["hrbaxml-sync"], {
		syncByCustomerId: generateRoute(["by-customer-id", ":id"]),
		getStatusByCustomerId: generateRoute(["status-by-customer-id", ":id"]),
		getPostingSync: generateRoute(["posting", ":id"]),
		updatePostingSync: generateRoute(["posting", ":id"]),
		getHrbaxmlByCustomerId: generateRoute(["xml-by-customer-id", ":id"])
	}),
	hrbaxmlProxy: generateRoute(["hrbaxml-proxy"], { get: generateRoute([":id"]) }),
	scheduledEmails: generateRoute(["scheduled-emails"], {
		getByCustomerId: generateRoute(["by-customer-id", ":id"]),
		cancel: generateRoute([":id"])
	})
})();
// source/routes/app-routes.ts
var appRoutes = generateRoute([config.appUrl], {
	pageNotFound: generateRoute(["page-not-found"]),
	logout: generateRoute(["logout"]),
	account: generateRoute(["account"], { login: generateRoute(["login"]) }),
	dashboard: generateRoute(["dashboard"], {
		welcome: generateRoute(["welcome"]),
		applicants: generateRoute(["applicants"]),
		companySettings: generateRoute(["company-settings"]),
		analytics: generateRoute(["analytics"], {
			general: generateRoute(["general"]),
			digitalCampaigns: generateRoute(["digital-campaigns"]),
			careerAnalytics: generateRoute(["career-analytics"]),
			socialMedia: generateRoute(["social-media"])
		}),
		jobPositions: generateRoute(["job-positions"]),
		jobPosition: generateRoute(["job-position", ":id"]),
		foundation: generateRoute(["foundation"]),
		platformSettings: generateRoute(["platform-settings"]),
		jobPositionSearch: generateRoute(["stellen-datenbank"]),
		courses: generateRoute(["courses"], { course: generateRoute([":courseId"]) })
	}),
	applicantManagerDashboard: generateRoute(["applicant-manager-dashboard"], { preQualification: generateRoute(["pre-qualification"]) }),
	marketingManagerDashboard: generateRoute(["marketing-manager-dashboard"], { campaigns: generateRoute(["campaigns"]) }),
	oauth: generateRoute(["oauth"], {
		google: generateRoute(["google", ":customerId"]),
		microsoft: generateRoute(["microsoft", ":customerId"]),
		success: generateRoute(["success"])
	}),
	sharedApplicant: generateRoute(["applicant", ":token"])
})();
// source/utilities/array.ts
var padArray = (arr, minLength = 0) => {
	const deficit = Math.max(0, minLength - arr.length);
	const padding = Array.from({ length: deficit }, () => ({}));
	return arr.concat(padding);
};
// source/utilities/async-array.ts
var asyncForEach = async (array, doAsync) => {
	for (const element of array) await doAsync(element);
};
var asyncMap = async (array, mapAsync) => {
	const result = [];
	for (const element of array) result.push(await mapAsync(element));
	return result;
};
var asyncEvery = async (array, checkAsync) => {
	for (const element of array) if (!await checkAsync(element)) return false;
	return true;
};
var asyncSome = async (array, checkAsync) => {
	for (const element of array) if (await checkAsync(element)) return true;
	return false;
};
// source/models/additional-requirement/additional-requirement.ts
var AdditionalRequirement = class {
	value;
	isKoCriteria;
	isDirect;
	label;
	selectOptions;
	isProtected;
	constructor({ value, isKoCriteria, isDirect, label, selectOptions, isProtected }) {
		this.value = value;
		this.isKoCriteria = isKoCriteria;
		this.isDirect = isDirect;
		this.label = label;
		this.selectOptions = selectOptions;
		this.isProtected = isProtected;
	}
};
// source/models/applicant/applicant.ts
var Applicant = class Applicant {
	id;
	name;
	customerId;
	jobPositionId;
	phaseId;
	currentState;
	profile;
	sourceId;
	sourcePlatformId;
	sourceCampaign;
	sourceMedium;
	sourceKeyword;
	declineReason;
	emailAddress;
	phoneNumber;
	normalizedPhoneNumber;
	isArchived;
	deadline;
	landingPageVersion;
	forwardedAt;
	receivedAt;
	customerNotes;
	token;
	referralSource;
	talentPoolConsentGiven;
	shareLinkWithNotes;
	shareLinkToken;
	hasCustomerNoteComments;
	duplicatedApplicants;
	origin;
	prequalificationStatus;
	lastPhaseChangeRole;
	createdAt;
	updatedAt;
	constructor({ id, name, customerId, jobPositionId, phaseId, currentState, profile, sourceId, sourcePlatformId, sourceCampaign, sourceMedium, sourceKeyword, declineReason, emailAddress, phoneNumber, normalizedPhoneNumber, isArchived, deadline, landingPageVersion, forwardedAt, receivedAt, customerNotes, token, referralSource, talentPoolConsentGiven, shareLinkWithNotes, shareLinkToken, hasCustomerNoteComments, duplicatedApplicants, origin, prequalificationStatus, lastPhaseChangeRole, createdAt, updatedAt }) {
		this.id = id;
		this.name = name;
		this.customerId = customerId;
		this.jobPositionId = jobPositionId;
		this.phaseId = phaseId;
		this.currentState = currentState;
		this.profile = profile;
		this.sourceId = sourceId;
		this.sourcePlatformId = sourcePlatformId;
		this.sourceCampaign = sourceCampaign;
		this.sourceMedium = sourceMedium;
		this.sourceKeyword = sourceKeyword;
		this.declineReason = declineReason;
		this.emailAddress = emailAddress;
		this.phoneNumber = phoneNumber;
		this.normalizedPhoneNumber = normalizedPhoneNumber;
		this.isArchived = isArchived;
		this.deadline = deadline;
		this.landingPageVersion = landingPageVersion;
		this.forwardedAt = forwardedAt;
		this.receivedAt = receivedAt;
		this.customerNotes = customerNotes;
		this.token = token;
		this.referralSource = referralSource;
		this.talentPoolConsentGiven = talentPoolConsentGiven;
		this.shareLinkWithNotes = shareLinkWithNotes;
		this.shareLinkToken = shareLinkToken;
		this.hasCustomerNoteComments = hasCustomerNoteComments;
		this.duplicatedApplicants = duplicatedApplicants;
		this.origin = origin;
		this.prequalificationStatus = prequalificationStatus;
		this.lastPhaseChangeRole = lastPhaseChangeRole;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(applicantDbObject) {
		return new Applicant({
			id: applicantDbObject.id,
			name: applicantDbObject.name,
			customerId: applicantDbObject.customer_id,
			jobPositionId: applicantDbObject.job_position_id,
			phaseId: applicantDbObject.phase_id,
			currentState: applicantDbObject.current_state,
			profile: applicantDbObject.profile,
			sourceId: applicantDbObject.source_id,
			sourcePlatformId: applicantDbObject.source_platform_id,
			sourceCampaign: applicantDbObject.source_campaign,
			sourceMedium: applicantDbObject.source_medium,
			sourceKeyword: applicantDbObject.source_keyword,
			declineReason: applicantDbObject.decline_reason,
			emailAddress: applicantDbObject.email_address,
			phoneNumber: applicantDbObject.phone_number,
			normalizedPhoneNumber: applicantDbObject.normalized_phone_number,
			isArchived: applicantDbObject.is_archived,
			deadline: applicantDbObject.deadline,
			landingPageVersion: applicantDbObject.landing_page_version,
			forwardedAt: applicantDbObject.forwarded_at,
			receivedAt: applicantDbObject.received_at,
			customerNotes: applicantDbObject.customer_notes,
			token: applicantDbObject.token,
			referralSource: applicantDbObject.referral_source,
			talentPoolConsentGiven: applicantDbObject.talent_pool_consent_given,
			shareLinkWithNotes: applicantDbObject.share_link_with_notes,
			shareLinkToken: applicantDbObject.share_link_token,
			hasCustomerNoteComments: applicantDbObject.has_customer_note_comments,
			duplicatedApplicants: applicantDbObject.duplicated_applicants,
			origin: applicantDbObject.origin,
			prequalificationStatus: applicantDbObject.prequalificationStatus,
			lastPhaseChangeRole: applicantDbObject.last_phase_change_role,
			createdAt: applicantDbObject.created_at,
			updatedAt: applicantDbObject.updated_at
		});
	}
};
// source/models/applicant/applicant-creation-dto.ts
var ApplicantCreationDto = class ApplicantCreationDto {
	name;
	jobPositionId;
	phaseId;
	currentState;
	profile;
	sourceId;
	sourcePlatformId;
	sourceCampaign;
	sourceMedium;
	sourceKeyword;
	declineReason;
	emailAddress;
	phoneNumber;
	isArchived;
	deadline;
	landingPageVersion;
	forwardedAt;
	receivedAt;
	customerNotes;
	referralSource;
	talentPoolConsentGiven;
	shareLinkWithNotes;
	origin;
	constructor({ name, jobPositionId, phaseId, currentState, profile, sourceId, sourcePlatformId, sourceCampaign, sourceMedium, sourceKeyword, declineReason, emailAddress, phoneNumber, isArchived, deadline, landingPageVersion, forwardedAt, receivedAt, customerNotes, referralSource, talentPoolConsentGiven, shareLinkWithNotes, origin }) {
		this.name = name;
		this.jobPositionId = jobPositionId;
		this.phaseId = phaseId;
		this.currentState = currentState;
		this.profile = profile;
		this.sourceId = sourceId;
		this.sourcePlatformId = sourcePlatformId;
		this.sourceCampaign = sourceCampaign;
		this.sourceMedium = sourceMedium;
		this.sourceKeyword = sourceKeyword;
		this.declineReason = declineReason;
		this.emailAddress = emailAddress;
		this.phoneNumber = phoneNumber;
		this.isArchived = isArchived;
		this.deadline = deadline;
		this.landingPageVersion = landingPageVersion;
		this.forwardedAt = forwardedAt;
		this.receivedAt = receivedAt;
		this.customerNotes = customerNotes;
		this.referralSource = referralSource;
		this.talentPoolConsentGiven = talentPoolConsentGiven;
		this.shareLinkWithNotes = shareLinkWithNotes;
		this.origin = origin;
	}
	static createFromApplicantCreationData(applicantCreationData) {
		return new ApplicantCreationDto({
			name: applicantCreationData.name,
			jobPositionId: applicantCreationData.jobPositionId,
			phaseId: applicantCreationData.phaseId,
			currentState: applicantCreationData.currentState,
			profile: applicantCreationData.profile,
			sourceId: applicantCreationData.sourceId,
			sourcePlatformId: applicantCreationData.sourcePlatformId,
			sourceCampaign: applicantCreationData.sourceCampaign,
			sourceMedium: applicantCreationData.sourceMedium,
			sourceKeyword: applicantCreationData.sourceKeyword,
			declineReason: applicantCreationData.declineReason,
			emailAddress: applicantCreationData.emailAddress,
			phoneNumber: applicantCreationData.phoneNumber,
			isArchived: applicantCreationData.isArchived,
			deadline: applicantCreationData.deadline,
			landingPageVersion: applicantCreationData.landingPageVersion,
			forwardedAt: applicantCreationData.forwardedAt,
			receivedAt: applicantCreationData.receivedAt,
			customerNotes: applicantCreationData.customerNotes,
			referralSource: applicantCreationData.referralSource,
			talentPoolConsentGiven: applicantCreationData.talentPoolConsentGiven,
			shareLinkWithNotes: applicantCreationData.shareLinkWithNotes,
			origin: applicantCreationData.origin
		});
	}
	convertToDbObject() {
		return {
			name: this.name,
			job_position_id: this.jobPositionId,
			phase_id: this.phaseId,
			current_state: this.currentState,
			profile: this.profile,
			source_id: this.sourceId,
			source_platform_id: this.sourcePlatformId,
			source_campaign: this.sourceCampaign,
			source_medium: this.sourceMedium,
			source_keyword: this.sourceKeyword,
			decline_reason: this.declineReason,
			email_address: this.emailAddress,
			phone_number: this.phoneNumber,
			normalized_phone_number: normalizePhoneNumber({ phone: this.phoneNumber }),
			is_archived: this.isArchived,
			deadline: this.deadline,
			landing_page_version: this.landingPageVersion,
			forwarded_at: this.forwardedAt,
			received_at: this.receivedAt,
			customer_notes: this.customerNotes,
			referral_source: this.referralSource,
			talent_pool_consent_given: this.talentPoolConsentGiven,
			share_link_with_notes: this.shareLinkWithNotes,
			origin: this.origin
		};
	}
};
// source/models/applicant/applicant-dto.ts
var ApplicantDto = class ApplicantDto {
	id;
	name;
	customerId;
	jobPositionId;
	phaseId;
	currentState;
	profile;
	sourceId;
	sourcePlatformId;
	sourceCampaign;
	sourceMedium;
	sourceKeyword;
	declineReason;
	emailAddress;
	phoneNumber;
	normalizedPhoneNumber;
	isArchived;
	deadline;
	landingPageVersion;
	forwardedAt;
	receivedAt;
	customerNotes;
	token;
	referralSource;
	talentPoolConsentGiven;
	shareLinkWithNotes;
	shareLinkToken;
	hasCustomerNoteComments;
	duplicatedApplicants;
	origin;
	prequalificationStatus;
	lastPhaseChangeRole;
	createdAt;
	updatedAt;
	constructor({ id, name, customerId, jobPositionId, phaseId, currentState, profile, sourceId, sourcePlatformId, sourceCampaign, sourceMedium, sourceKeyword, declineReason, emailAddress, phoneNumber, normalizedPhoneNumber, isArchived, deadline, landingPageVersion, forwardedAt, receivedAt, customerNotes, token, referralSource, talentPoolConsentGiven, shareLinkWithNotes, shareLinkToken, hasCustomerNoteComments, duplicatedApplicants, origin, prequalificationStatus, lastPhaseChangeRole, createdAt, updatedAt }) {
		this.id = id;
		this.name = name;
		this.customerId = customerId;
		this.jobPositionId = jobPositionId;
		this.phaseId = phaseId;
		this.currentState = currentState;
		this.profile = profile;
		this.sourceId = sourceId;
		this.sourcePlatformId = sourcePlatformId;
		this.sourceCampaign = sourceCampaign;
		this.sourceMedium = sourceMedium;
		this.sourceKeyword = sourceKeyword;
		this.declineReason = declineReason;
		this.emailAddress = emailAddress;
		this.phoneNumber = phoneNumber;
		this.normalizedPhoneNumber = normalizedPhoneNumber;
		this.isArchived = isArchived;
		this.deadline = deadline;
		this.landingPageVersion = landingPageVersion;
		this.forwardedAt = forwardedAt;
		this.receivedAt = receivedAt;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
		this.customerNotes = customerNotes;
		this.token = token;
		this.referralSource = referralSource;
		this.talentPoolConsentGiven = talentPoolConsentGiven;
		this.shareLinkWithNotes = shareLinkWithNotes;
		this.shareLinkToken = shareLinkToken;
		this.hasCustomerNoteComments = hasCustomerNoteComments;
		this.duplicatedApplicants = duplicatedApplicants;
		this.origin = origin;
		this.prequalificationStatus = prequalificationStatus;
		this.lastPhaseChangeRole = lastPhaseChangeRole;
	}
	toApplicant() {
		return new Applicant({
			id: this.id,
			name: this.name,
			customerId: this.customerId,
			jobPositionId: this.jobPositionId,
			phaseId: this.phaseId,
			currentState: this.currentState,
			profile: this.profile,
			sourceId: this.sourceId,
			sourcePlatformId: this.sourcePlatformId,
			sourceCampaign: this.sourceCampaign,
			sourceMedium: this.sourceMedium,
			sourceKeyword: this.sourceKeyword,
			declineReason: this.declineReason,
			emailAddress: this.emailAddress,
			phoneNumber: this.phoneNumber,
			normalizedPhoneNumber: this.normalizedPhoneNumber,
			isArchived: this.isArchived,
			deadline: this.deadline,
			landingPageVersion: this.landingPageVersion,
			forwardedAt: this.forwardedAt,
			receivedAt: this.receivedAt,
			customerNotes: this.customerNotes,
			token: this.token,
			referralSource: this.referralSource,
			talentPoolConsentGiven: this.talentPoolConsentGiven,
			shareLinkWithNotes: this.shareLinkWithNotes,
			shareLinkToken: this.shareLinkToken,
			hasCustomerNoteComments: this.hasCustomerNoteComments,
			duplicatedApplicants: this.duplicatedApplicants,
			origin: this.origin,
			prequalificationStatus: this.prequalificationStatus,
			lastPhaseChangeRole: this.lastPhaseChangeRole,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromApplicant(applicant) {
		return new ApplicantDto({
			id: applicant.id,
			name: applicant.name,
			customerId: applicant.customerId,
			jobPositionId: applicant.jobPositionId,
			phaseId: applicant.phaseId,
			currentState: applicant.currentState,
			profile: applicant.profile,
			sourceId: applicant.sourceId,
			sourcePlatformId: applicant.sourcePlatformId,
			sourceCampaign: applicant.sourceCampaign,
			sourceMedium: applicant.sourceMedium,
			sourceKeyword: applicant.sourceKeyword,
			declineReason: applicant.declineReason,
			emailAddress: applicant.emailAddress,
			phoneNumber: applicant.phoneNumber,
			normalizedPhoneNumber: applicant.normalizedPhoneNumber,
			isArchived: applicant.isArchived,
			deadline: applicant.deadline,
			landingPageVersion: applicant.landingPageVersion,
			forwardedAt: applicant.forwardedAt,
			receivedAt: applicant.receivedAt,
			customerNotes: applicant.customerNotes,
			token: applicant.token,
			referralSource: applicant.referralSource,
			talentPoolConsentGiven: applicant.talentPoolConsentGiven,
			shareLinkWithNotes: applicant.shareLinkWithNotes,
			shareLinkToken: applicant.shareLinkToken,
			hasCustomerNoteComments: applicant.hasCustomerNoteComments,
			duplicatedApplicants: applicant.duplicatedApplicants,
			origin: applicant.origin,
			prequalificationStatus: applicant.prequalificationStatus,
			lastPhaseChangeRole: applicant.lastPhaseChangeRole,
			createdAt: applicant.createdAt,
			updatedAt: applicant.updatedAt
		});
	}
	static createFromDbObject(applicantDbObject) {
		return new ApplicantDto({
			id: applicantDbObject.id,
			name: applicantDbObject.name,
			customerId: applicantDbObject.customer_id,
			jobPositionId: applicantDbObject.job_position_id,
			phaseId: applicantDbObject.phase_id,
			currentState: applicantDbObject.current_state,
			profile: applicantDbObject.profile,
			sourceId: applicantDbObject.source_id,
			sourcePlatformId: applicantDbObject.source_platform_id,
			sourceCampaign: applicantDbObject.source_campaign,
			sourceMedium: applicantDbObject.source_medium,
			sourceKeyword: applicantDbObject.source_keyword,
			declineReason: applicantDbObject.decline_reason,
			emailAddress: applicantDbObject.email_address,
			phoneNumber: applicantDbObject.phone_number,
			normalizedPhoneNumber: applicantDbObject.normalized_phone_number,
			isArchived: applicantDbObject.is_archived,
			deadline: applicantDbObject.deadline,
			landingPageVersion: applicantDbObject.landing_page_version,
			forwardedAt: applicantDbObject.forwarded_at,
			receivedAt: applicantDbObject.received_at,
			customerNotes: applicantDbObject.customer_notes,
			token: applicantDbObject.token,
			referralSource: applicantDbObject.referral_source,
			talentPoolConsentGiven: applicantDbObject.talent_pool_consent_given,
			shareLinkWithNotes: applicantDbObject.share_link_with_notes,
			shareLinkToken: applicantDbObject.share_link_token,
			hasCustomerNoteComments: applicantDbObject.has_customer_note_comments,
			duplicatedApplicants: applicantDbObject.duplicated_applicants,
			origin: applicantDbObject.origin,
			prequalificationStatus: applicantDbObject.prequalification_status,
			lastPhaseChangeRole: applicantDbObject.last_phase_change_role,
			createdAt: applicantDbObject.created_at,
			updatedAt: applicantDbObject.updated_at
		});
	}
	static createFromApplicantData(applicantData) {
		return new ApplicantDto({
			id: applicantData.id,
			name: applicantData.name,
			customerId: applicantData.customerId,
			jobPositionId: applicantData.jobPositionId,
			phaseId: applicantData.phaseId,
			currentState: applicantData.currentState,
			profile: applicantData.profile,
			sourceId: applicantData.sourceId,
			sourcePlatformId: applicantData.sourcePlatformId,
			sourceCampaign: applicantData.sourceCampaign,
			sourceMedium: applicantData.sourceMedium,
			sourceKeyword: applicantData.sourceKeyword,
			declineReason: applicantData.declineReason,
			emailAddress: applicantData.emailAddress,
			phoneNumber: applicantData.phoneNumber,
			normalizedPhoneNumber: applicantData.normalizedPhoneNumber,
			isArchived: applicantData.isArchived,
			deadline: applicantData.deadline,
			landingPageVersion: applicantData.landingPageVersion,
			forwardedAt: applicantData.forwardedAt,
			receivedAt: applicantData.receivedAt,
			customerNotes: applicantData.customerNotes,
			token: applicantData.token,
			referralSource: applicantData.referralSource,
			talentPoolConsentGiven: applicantData.talentPoolConsentGiven,
			shareLinkWithNotes: applicantData.shareLinkWithNotes,
			shareLinkToken: applicantData.shareLinkToken,
			hasCustomerNoteComments: applicantData.hasCustomerNoteComments,
			duplicatedApplicants: applicantData.duplicatedApplicants,
			origin: applicantData.origin,
			prequalificationStatus: applicantData.prequalificationStatus,
			lastPhaseChangeRole: applicantData.lastPhaseChangeRole,
			createdAt: applicantData.createdAt,
			updatedAt: applicantData.updatedAt
		});
	}
};
// source/models/applicant/applicant-personal-info-update-dto.ts
var ApplicantPersonalInfoUpdateDto = class ApplicantPersonalInfoUpdateDto {
	name;
	emailAddress;
	phoneNumber;
	constructor({ name, emailAddress, phoneNumber }) {
		this.name = name;
		this.emailAddress = emailAddress;
		this.phoneNumber = phoneNumber;
	}
	static createFromApplicantUpdateData(applicantUpdateData) {
		return new ApplicantPersonalInfoUpdateDto({
			name: applicantUpdateData.name,
			emailAddress: applicantUpdateData.emailAddress,
			phoneNumber: applicantUpdateData.phoneNumber
		});
	}
	convertToDbObject() {
		return {
			name: this.name,
			email_address: this.emailAddress,
			phone_number: this.phoneNumber,
			normalized_phone_number: normalizePhoneNumber({ phone: this.phoneNumber })
		};
	}
};
// source/models/applicant/applicant-public.ts
var ApplicantPublic = class ApplicantPublic {
	name;
	emailAddress;
	phoneNumber;
	normalizedPhoneNumber;
	token;
	constructor({ name, emailAddress, phoneNumber, normalizedPhoneNumber, token }) {
		this.name = name;
		this.emailAddress = emailAddress;
		this.phoneNumber = phoneNumber;
		this.normalizedPhoneNumber = normalizedPhoneNumber;
		this.token = token;
	}
	static createFromDbObject(applicantDbObject) {
		return new ApplicantPublic({
			name: applicantDbObject.name,
			emailAddress: applicantDbObject.email_address,
			phoneNumber: applicantDbObject.phone_number,
			normalizedPhoneNumber: applicantDbObject.normalized_phone_number,
			token: applicantDbObject.token
		});
	}
};
// source/models/applicant/applicant-public-dto.ts
var ApplicantPublicDto = class ApplicantPublicDto {
	name;
	emailAddress;
	phoneNumber;
	normalizedPhoneNumber;
	token;
	constructor({ name, emailAddress, phoneNumber, normalizedPhoneNumber, token }) {
		this.name = name;
		this.emailAddress = emailAddress;
		this.phoneNumber = phoneNumber;
		this.normalizedPhoneNumber = normalizedPhoneNumber;
		this.token = token;
	}
	toApplicantPublic() {
		return new ApplicantPublic({
			name: this.name,
			emailAddress: this.emailAddress,
			phoneNumber: this.phoneNumber,
			normalizedPhoneNumber: this.normalizedPhoneNumber,
			token: this.token
		});
	}
	static createFromApplicant(applicant) {
		return new ApplicantPublicDto({
			name: applicant.name,
			emailAddress: applicant.emailAddress,
			phoneNumber: applicant.phoneNumber,
			normalizedPhoneNumber: applicant.normalizedPhoneNumber,
			token: applicant.token
		});
	}
	static createFromApplicantPublic(applicant) {
		return new ApplicantPublicDto({
			name: applicant.name,
			emailAddress: applicant.emailAddress,
			phoneNumber: applicant.phoneNumber,
			normalizedPhoneNumber: applicant.normalizedPhoneNumber,
			token: applicant.token
		});
	}
	static createFromDbObject(applicantDbObject) {
		return new ApplicantPublicDto({
			name: applicantDbObject.name,
			emailAddress: applicantDbObject.email_address,
			phoneNumber: applicantDbObject.phone_number,
			normalizedPhoneNumber: applicantDbObject.normalized_phone_number,
			token: applicantDbObject.token
		});
	}
	static createFromApplicantData(applicantData) {
		return new ApplicantPublicDto({
			name: applicantData.name,
			emailAddress: applicantData.emailAddress,
			phoneNumber: applicantData.phoneNumber,
			normalizedPhoneNumber: applicantData.normalizedPhoneNumber,
			token: applicantData.token
		});
	}
};
// source/models/applicant/applicant-update-dto.ts
var ApplicantUpdateDto = class ApplicantUpdateDto {
	name;
	jobPositionId;
	phaseId;
	currentState;
	profile;
	sourceId;
	sourcePlatformId;
	sourceCampaign;
	sourceMedium;
	sourceKeyword;
	declineReason;
	emailAddress;
	phoneNumber;
	isArchived;
	deadline;
	landingPageVersion;
	forwardedAt;
	receivedAt;
	customerNotes;
	referralSource;
	talentPoolConsentGiven;
	shareLinkWithNotes;
	hasCustomerNoteComments;
	prequalificationStatus;
	constructor({ name, jobPositionId, phaseId, currentState, profile, sourceId, sourcePlatformId, sourceCampaign, sourceMedium, sourceKeyword, declineReason, emailAddress, phoneNumber, isArchived, deadline, landingPageVersion, forwardedAt, receivedAt, customerNotes, referralSource, talentPoolConsentGiven, shareLinkWithNotes, hasCustomerNoteComments, prequalificationStatus }) {
		this.name = name;
		this.jobPositionId = jobPositionId;
		this.phaseId = phaseId;
		this.currentState = currentState;
		this.profile = profile;
		this.sourceId = sourceId;
		this.sourcePlatformId = sourcePlatformId;
		this.sourceCampaign = sourceCampaign;
		this.sourceMedium = sourceMedium;
		this.sourceKeyword = sourceKeyword;
		this.declineReason = declineReason;
		this.emailAddress = emailAddress;
		this.phoneNumber = phoneNumber;
		this.isArchived = isArchived;
		this.deadline = deadline;
		this.landingPageVersion = landingPageVersion;
		this.forwardedAt = forwardedAt;
		this.receivedAt = receivedAt;
		this.customerNotes = customerNotes;
		this.referralSource = referralSource;
		this.talentPoolConsentGiven = talentPoolConsentGiven;
		this.shareLinkWithNotes = shareLinkWithNotes;
		this.hasCustomerNoteComments = hasCustomerNoteComments;
		this.prequalificationStatus = prequalificationStatus;
	}
	static createFromApplicantUpdateData(applicantUpdateData) {
		return new ApplicantUpdateDto({
			name: applicantUpdateData.name,
			jobPositionId: applicantUpdateData.jobPositionId,
			phaseId: applicantUpdateData.phaseId,
			currentState: applicantUpdateData.currentState,
			profile: applicantUpdateData.profile,
			sourceId: applicantUpdateData.sourceId,
			sourcePlatformId: applicantUpdateData.sourcePlatformId,
			sourceCampaign: applicantUpdateData.sourceCampaign,
			sourceMedium: applicantUpdateData.sourceMedium,
			sourceKeyword: applicantUpdateData.sourceKeyword,
			declineReason: applicantUpdateData.declineReason,
			emailAddress: applicantUpdateData.emailAddress,
			phoneNumber: applicantUpdateData.phoneNumber,
			isArchived: applicantUpdateData.isArchived,
			deadline: applicantUpdateData.deadline,
			landingPageVersion: applicantUpdateData.landingPageVersion,
			forwardedAt: applicantUpdateData.forwardedAt,
			receivedAt: applicantUpdateData.receivedAt,
			customerNotes: applicantUpdateData.customerNotes,
			referralSource: applicantUpdateData.referralSource,
			talentPoolConsentGiven: applicantUpdateData.talentPoolConsentGiven,
			shareLinkWithNotes: applicantUpdateData.shareLinkWithNotes,
			hasCustomerNoteComments: applicantUpdateData.hasCustomerNoteComments,
			prequalificationStatus: applicantUpdateData.prequalificationStatus
		});
	}
	convertToDbObject() {
		return {
			name: this.name,
			job_position_id: this.jobPositionId,
			phase_id: this.phaseId,
			current_state: this.currentState,
			profile: this.profile,
			source_id: this.sourceId,
			source_platform_id: this.sourcePlatformId,
			source_campaign: this.sourceCampaign,
			source_medium: this.sourceMedium,
			source_keyword: this.sourceKeyword,
			decline_reason: this.declineReason,
			email_address: this.emailAddress,
			phone_number: this.phoneNumber,
			normalized_phone_number: this.phoneNumber !== void 0 ? normalizePhoneNumber({ phone: this.phoneNumber }) : void 0,
			is_archived: this.isArchived,
			deadline: this.deadline,
			landing_page_version: this.landingPageVersion,
			forwarded_at: this.forwardedAt,
			received_at: this.receivedAt,
			customer_notes: this.customerNotes,
			referral_source: this.referralSource,
			talent_pool_consent_given: this.talentPoolConsentGiven,
			share_link_with_notes: this.shareLinkWithNotes,
			has_customer_note_comments: this.hasCustomerNoteComments,
			prequalification_status: this.prequalificationStatus
		};
	}
};
// source/models/applicant/applicant-shared.ts
var ApplicantShared = class ApplicantShared {
	name;
	jobPositionId;
	phaseId;
	currentState;
	profile;
	emailAddress;
	phoneNumber;
	normalizedPhoneNumber;
	forwardedAt;
	receivedAt;
	customerNotes;
	referralSource;
	shareLinkWithNotes;
	constructor({ name, jobPositionId, phaseId, currentState, profile, emailAddress, phoneNumber, normalizedPhoneNumber, forwardedAt, receivedAt, customerNotes, referralSource, shareLinkWithNotes }) {
		this.name = name;
		this.jobPositionId = jobPositionId;
		this.phaseId = phaseId;
		this.currentState = currentState;
		this.profile = profile;
		this.emailAddress = emailAddress;
		this.phoneNumber = phoneNumber;
		this.normalizedPhoneNumber = normalizedPhoneNumber;
		this.forwardedAt = forwardedAt;
		this.receivedAt = receivedAt;
		this.customerNotes = customerNotes;
		this.referralSource = referralSource;
		this.shareLinkWithNotes = shareLinkWithNotes;
	}
	static createFromDbObject(applicantDbObject) {
		return new ApplicantShared({
			name: applicantDbObject.name,
			jobPositionId: applicantDbObject.job_position_id,
			phaseId: applicantDbObject.phase_id,
			currentState: applicantDbObject.current_state,
			profile: applicantDbObject.profile,
			emailAddress: applicantDbObject.email_address,
			phoneNumber: applicantDbObject.phone_number,
			normalizedPhoneNumber: applicantDbObject.normalized_phone_number,
			forwardedAt: applicantDbObject.forwarded_at,
			receivedAt: applicantDbObject.received_at,
			customerNotes: applicantDbObject.customer_notes,
			referralSource: applicantDbObject.referral_source,
			shareLinkWithNotes: applicantDbObject.share_link_with_notes
		});
	}
};
// source/models/applicant/applicant-shared-dto.ts
var ApplicantSharedDto = class ApplicantSharedDto {
	name;
	jobPositionId;
	phaseId;
	currentState;
	profile;
	emailAddress;
	phoneNumber;
	normalizedPhoneNumber;
	forwardedAt;
	receivedAt;
	customerNotes;
	referralSource;
	shareLinkWithNotes;
	constructor({ name, jobPositionId, phaseId, currentState, profile, emailAddress, phoneNumber, normalizedPhoneNumber, forwardedAt, receivedAt, customerNotes, referralSource, shareLinkWithNotes }) {
		this.name = name;
		this.jobPositionId = jobPositionId;
		this.phaseId = phaseId;
		this.currentState = currentState;
		this.profile = profile;
		this.emailAddress = emailAddress;
		this.phoneNumber = phoneNumber;
		this.normalizedPhoneNumber = normalizedPhoneNumber;
		this.forwardedAt = forwardedAt;
		this.receivedAt = receivedAt;
		this.customerNotes = customerNotes;
		this.referralSource = referralSource;
		this.shareLinkWithNotes = shareLinkWithNotes;
	}
	toApplicantShared() {
		return new ApplicantShared({
			name: this.name,
			jobPositionId: this.jobPositionId,
			phaseId: this.phaseId,
			currentState: this.currentState,
			profile: this.profile,
			emailAddress: this.emailAddress,
			phoneNumber: this.phoneNumber,
			normalizedPhoneNumber: this.normalizedPhoneNumber,
			forwardedAt: this.forwardedAt,
			receivedAt: this.receivedAt,
			customerNotes: this.customerNotes,
			referralSource: this.referralSource,
			shareLinkWithNotes: this.shareLinkWithNotes
		});
	}
	static createFromApplicant(applicant) {
		return new ApplicantSharedDto({
			name: applicant.name,
			jobPositionId: applicant.jobPositionId,
			phaseId: applicant.phaseId,
			currentState: applicant.currentState,
			profile: applicant.profile,
			emailAddress: applicant.emailAddress,
			phoneNumber: applicant.phoneNumber,
			normalizedPhoneNumber: applicant.normalizedPhoneNumber,
			forwardedAt: applicant.forwardedAt,
			receivedAt: applicant.receivedAt,
			customerNotes: applicant.customerNotes,
			referralSource: applicant.referralSource,
			shareLinkWithNotes: applicant.shareLinkWithNotes
		});
	}
	static createFromApplicantShared(applicant) {
		return new ApplicantSharedDto({
			name: applicant.name,
			jobPositionId: applicant.jobPositionId,
			phaseId: applicant.phaseId,
			currentState: applicant.currentState,
			profile: applicant.profile,
			emailAddress: applicant.emailAddress,
			phoneNumber: applicant.phoneNumber,
			normalizedPhoneNumber: applicant.normalizedPhoneNumber,
			forwardedAt: applicant.forwardedAt,
			receivedAt: applicant.receivedAt,
			customerNotes: applicant.customerNotes,
			referralSource: applicant.referralSource,
			shareLinkWithNotes: applicant.shareLinkWithNotes
		});
	}
	static createFromDbObject(applicantDbObject) {
		return new ApplicantSharedDto({
			name: applicantDbObject.name,
			jobPositionId: applicantDbObject.job_position_id,
			phaseId: applicantDbObject.phase_id,
			currentState: applicantDbObject.current_state,
			profile: applicantDbObject.profile,
			emailAddress: applicantDbObject.email_address,
			phoneNumber: applicantDbObject.phone_number,
			normalizedPhoneNumber: applicantDbObject.normalized_phone_number,
			forwardedAt: applicantDbObject.forwarded_at,
			receivedAt: applicantDbObject.received_at,
			customerNotes: applicantDbObject.customer_notes,
			referralSource: applicantDbObject.referral_source,
			shareLinkWithNotes: applicantDbObject.share_link_with_notes
		});
	}
	static createFromApplicantData(applicantData) {
		return new ApplicantSharedDto({
			name: applicantData.name,
			jobPositionId: applicantData.jobPositionId,
			phaseId: applicantData.phaseId,
			currentState: applicantData.currentState,
			profile: applicantData.profile,
			emailAddress: applicantData.emailAddress,
			phoneNumber: applicantData.phoneNumber,
			normalizedPhoneNumber: applicantData.normalizedPhoneNumber,
			forwardedAt: applicantData.forwardedAt,
			receivedAt: applicantData.receivedAt,
			customerNotes: applicantData.customerNotes,
			referralSource: applicantData.referralSource,
			shareLinkWithNotes: applicantData.shareLinkWithNotes
		});
	}
};
// source/models/applicant-automation/applicant-automation.ts
var ApplicantAutomation = class {
	emails;
	currentState;
	phaseId;
	forwardedAt;
	declineReason;
	deadline;
	markApplicantDocumentsAsRead;
	prequalificationStatus;
	constructor({ emails, currentState, phaseId, forwardedAt, declineReason, deadline, markApplicantDocumentsAsRead, prequalificationStatus }) {
		this.emails = emails;
		this.currentState = currentState;
		this.phaseId = phaseId;
		this.forwardedAt = forwardedAt;
		this.declineReason = declineReason;
		this.deadline = deadline;
		this.markApplicantDocumentsAsRead = markApplicantDocumentsAsRead;
		this.prequalificationStatus = prequalificationStatus;
	}
	getApplicantUpdateDto() {
		return new ApplicantUpdateDto({
			currentState: this.currentState,
			phaseId: this.phaseId,
			forwardedAt: this.forwardedAt,
			declineReason: this.declineReason,
			deadline: this.deadline,
			prequalificationStatus: this.prequalificationStatus
		});
	}
};
// source/models/applicant-automation/applicant-automation-dto.ts
var ApplicantAutomationDto = class ApplicantAutomationDto {
	emails;
	currentState;
	phaseId;
	forwardedAt;
	declineReason;
	deadline;
	markApplicantDocumentsAsRead;
	prequalificationStatus;
	constructor({ emails, currentState, phaseId, forwardedAt, declineReason, deadline, markApplicantDocumentsAsRead, prequalificationStatus }) {
		this.emails = emails;
		this.currentState = currentState;
		this.phaseId = phaseId;
		this.forwardedAt = forwardedAt;
		this.declineReason = declineReason;
		this.deadline = deadline;
		this.markApplicantDocumentsAsRead = markApplicantDocumentsAsRead;
		this.prequalificationStatus = prequalificationStatus;
	}
	toApplicantAutomation() {
		return new ApplicantAutomation({
			emails: this.emails,
			currentState: this.currentState,
			phaseId: this.phaseId,
			forwardedAt: this.forwardedAt,
			declineReason: this.declineReason,
			deadline: this.deadline,
			markApplicantDocumentsAsRead: this.markApplicantDocumentsAsRead,
			prequalificationStatus: this.prequalificationStatus
		});
	}
	static createFromApplicantAutomation(applicantAutomation) {
		return new ApplicantAutomationDto({
			emails: applicantAutomation.emails,
			currentState: applicantAutomation.currentState,
			phaseId: applicantAutomation.phaseId,
			forwardedAt: applicantAutomation.forwardedAt,
			declineReason: applicantAutomation.declineReason,
			deadline: applicantAutomation.deadline,
			markApplicantDocumentsAsRead: applicantAutomation.markApplicantDocumentsAsRead,
			prequalificationStatus: applicantAutomation.prequalificationStatus
		});
	}
	static createFromApplicantAutomationData(applicantAutomationData) {
		return new ApplicantAutomationDto({
			emails: applicantAutomationData.emails,
			currentState: applicantAutomationData.currentState,
			phaseId: applicantAutomationData.phaseId,
			forwardedAt: applicantAutomationData.forwardedAt,
			declineReason: applicantAutomationData.declineReason,
			deadline: applicantAutomationData.deadline,
			markApplicantDocumentsAsRead: applicantAutomationData.markApplicantDocumentsAsRead,
			prequalificationStatus: applicantAutomationData.prequalificationStatus
		});
	}
};
// source/models/applicant-automation-template/applicant-automation-template.ts
var ApplicantAutomationTemplate = class ApplicantAutomationTemplate {
	id;
	label;
	type;
	emails;
	currentStateTemplate;
	hideCurrentStateChange;
	phaseType;
	forwardedAt;
	hideForwardedAtChange;
	declineReason;
	declineReasonRequired;
	declineReasonTemplate;
	color;
	deadline;
	markApplicantDocumentsAsRead;
	prequalificationStatus;
	static applicantUpdateFields = [
		{
			key: "currentState",
			templateKey: "currentStateTemplate"
		},
		{
			key: "declineReason",
			templateKey: "declineReasonTemplate"
		},
		{
			key: "forwardedAt",
			templateKey: "forwardedAt"
		},
		{
			key: "deadline",
			templateKey: "deadline"
		}
	];
	constructor({ id, label, type, emails, currentStateTemplate, hideCurrentStateChange, phaseType, forwardedAt, hideForwardedAtChange, declineReason, declineReasonRequired, declineReasonTemplate, color, deadline, markApplicantDocumentsAsRead, prequalificationStatus }) {
		this.id = id;
		this.label = label;
		this.type = type;
		this.emails = emails;
		this.currentStateTemplate = currentStateTemplate;
		this.hideCurrentStateChange = hideCurrentStateChange;
		this.phaseType = phaseType;
		this.forwardedAt = forwardedAt;
		this.hideForwardedAtChange = hideForwardedAtChange;
		this.declineReason = declineReason;
		this.declineReasonRequired = declineReasonRequired;
		this.declineReasonTemplate = declineReasonTemplate;
		this.color = color;
		this.deadline = deadline;
		this.markApplicantDocumentsAsRead = markApplicantDocumentsAsRead;
		this.prequalificationStatus = prequalificationStatus;
	}
	static getApplicantUpdateFields() {
		return ApplicantAutomationTemplate.applicantUpdateFields;
	}
};
// source/models/applicant-automation-template/applicant-automation-template-dto.ts
var ApplicantAutomationTemplateDto = class ApplicantAutomationTemplateDto {
	id;
	label;
	type;
	emails;
	currentStateTemplate;
	hideCurrentStateChange;
	phaseType;
	forwardedAt;
	hideForwardedAtChange;
	declineReason;
	declineReasonRequired;
	declineReasonTemplate;
	color;
	deadline;
	markApplicantDocumentsAsRead;
	prequalificationStatus;
	constructor({ id, label, type, emails, currentStateTemplate, hideCurrentStateChange, phaseType, forwardedAt, hideForwardedAtChange, declineReason, declineReasonRequired, declineReasonTemplate, color, deadline, markApplicantDocumentsAsRead, prequalificationStatus }) {
		this.id = id;
		this.label = label;
		this.type = type;
		this.emails = emails;
		this.currentStateTemplate = currentStateTemplate;
		this.hideCurrentStateChange = hideCurrentStateChange;
		this.phaseType = phaseType;
		this.forwardedAt = forwardedAt;
		this.hideForwardedAtChange = hideForwardedAtChange;
		this.declineReason = declineReason;
		this.declineReasonRequired = declineReasonRequired;
		this.declineReasonTemplate = declineReasonTemplate;
		this.color = color;
		this.deadline = deadline;
		this.markApplicantDocumentsAsRead = markApplicantDocumentsAsRead;
		this.prequalificationStatus = prequalificationStatus;
	}
	toApplicantAutomationTemplate() {
		return new ApplicantAutomationTemplate({
			id: this.id,
			label: this.label,
			type: this.type,
			emails: this.emails,
			currentStateTemplate: this.currentStateTemplate,
			hideCurrentStateChange: this.hideCurrentStateChange,
			phaseType: this.phaseType,
			forwardedAt: this.forwardedAt,
			hideForwardedAtChange: this.hideForwardedAtChange,
			declineReason: this.declineReason,
			declineReasonRequired: this.declineReasonRequired,
			declineReasonTemplate: this.declineReasonTemplate,
			color: this.color,
			deadline: this.deadline,
			markApplicantDocumentsAsRead: this.markApplicantDocumentsAsRead,
			prequalificationStatus: this.prequalificationStatus
		});
	}
	static createFromApplicantAutomationTemplate(applicantAutomationTemplate) {
		return new ApplicantAutomationTemplateDto({
			id: applicantAutomationTemplate.id,
			label: applicantAutomationTemplate.label,
			type: applicantAutomationTemplate.type,
			emails: applicantAutomationTemplate.emails,
			currentStateTemplate: applicantAutomationTemplate.currentStateTemplate,
			hideCurrentStateChange: applicantAutomationTemplate.hideCurrentStateChange,
			phaseType: applicantAutomationTemplate.phaseType,
			forwardedAt: applicantAutomationTemplate.forwardedAt,
			hideForwardedAtChange: applicantAutomationTemplate.hideForwardedAtChange,
			declineReason: applicantAutomationTemplate.declineReason,
			declineReasonRequired: applicantAutomationTemplate.declineReasonRequired,
			declineReasonTemplate: applicantAutomationTemplate.declineReasonTemplate,
			color: applicantAutomationTemplate.color,
			deadline: applicantAutomationTemplate.deadline,
			markApplicantDocumentsAsRead: applicantAutomationTemplate.markApplicantDocumentsAsRead,
			prequalificationStatus: applicantAutomationTemplate.prequalificationStatus
		});
	}
};
// source/models/applicant-automation-template-with-relations/applicant-automation-template-with-relations.ts
var ApplicantAutomationTemplateWithRelations = class ApplicantAutomationTemplateWithRelations {
	id;
	label;
	type;
	emails;
	currentStateTemplate;
	hideCurrentStateChange;
	phaseType;
	phase;
	forwardedAt;
	hideForwardedAtChange;
	declineReason;
	declineReasonRequired;
	declineReasonTemplate;
	color;
	deadline;
	markApplicantDocumentsAsRead;
	prequalificationStatus;
	constructor({ id, label, type, emails, currentStateTemplate, hideCurrentStateChange, phaseType, phase, forwardedAt, hideForwardedAtChange, declineReason, declineReasonRequired, declineReasonTemplate, color, deadline, markApplicantDocumentsAsRead, prequalificationStatus }) {
		this.id = id;
		this.label = label;
		this.type = type;
		this.emails = emails;
		this.currentStateTemplate = currentStateTemplate;
		this.hideCurrentStateChange = hideCurrentStateChange;
		this.phaseType = phaseType;
		this.phase = phase;
		this.forwardedAt = forwardedAt;
		this.hideForwardedAtChange = hideForwardedAtChange;
		this.declineReason = declineReason;
		this.declineReasonRequired = declineReasonRequired;
		this.declineReasonTemplate = declineReasonTemplate;
		this.color = color;
		this.deadline = deadline;
		this.markApplicantDocumentsAsRead = markApplicantDocumentsAsRead;
		this.prequalificationStatus = prequalificationStatus;
	}
	setPhase(phase) {
		this.phase = phase;
	}
	setEmailForEmailTemplates(emailTemplates) {
		if (!this.emails) return;
		this.emails = this.emails.map((email) => {
			const emailTemplate = emailTemplates.find((emailTemplate) => emailTemplate.key === email.emailTemplateKey);
			if (!emailTemplate) return email;
			return {
				...email,
				emailTemplate
			};
		});
	}
	static createFromApplicantAutomationTemplate(applicantAutomationTemplate) {
		return new ApplicantAutomationTemplateWithRelations({
			id: applicantAutomationTemplate.id,
			label: applicantAutomationTemplate.label,
			type: applicantAutomationTemplate.type,
			emails: applicantAutomationTemplate.emails?.map((email) => ({
				emailTemplateKey: email.emailTemplateKey,
				emailDelayInMs: email.emailDelayInMs,
				emailSchedule: email.emailSchedule
			})),
			currentStateTemplate: applicantAutomationTemplate.currentStateTemplate,
			hideCurrentStateChange: applicantAutomationTemplate.hideCurrentStateChange,
			phaseType: applicantAutomationTemplate.phaseType,
			forwardedAt: applicantAutomationTemplate.forwardedAt,
			hideForwardedAtChange: applicantAutomationTemplate.hideForwardedAtChange,
			declineReason: applicantAutomationTemplate.declineReason,
			declineReasonRequired: applicantAutomationTemplate.declineReasonRequired,
			declineReasonTemplate: applicantAutomationTemplate.declineReasonTemplate,
			color: applicantAutomationTemplate.color,
			deadline: applicantAutomationTemplate.deadline,
			markApplicantDocumentsAsRead: applicantAutomationTemplate.markApplicantDocumentsAsRead,
			prequalificationStatus: applicantAutomationTemplate.prequalificationStatus
		});
	}
};
// source/models/applicant-phase/applicant-phase.ts
var ApplicantPhase = class ApplicantPhase {
	id;
	name;
	color;
	type;
	createdAt;
	updatedAt;
	constructor({ id, name, color, type, createdAt, updatedAt }) {
		this.id = id;
		this.name = name;
		this.color = color;
		this.type = type;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(applicantPhaseDbObject) {
		return new ApplicantPhase({
			id: applicantPhaseDbObject.id,
			name: applicantPhaseDbObject.name,
			color: applicantPhaseDbObject.color,
			type: applicantPhaseDbObject.type,
			createdAt: applicantPhaseDbObject.created_at,
			updatedAt: applicantPhaseDbObject.updated_at
		});
	}
};
// source/models/applicant-phase/applicant-phase-creation-dto.ts
var ApplicantPhaseCreationDto = class ApplicantPhaseCreationDto {
	name;
	color;
	type;
	constructor({ name, color, type }) {
		this.name = name;
		this.color = color;
		this.type = type;
	}
	static createFromApplicantPhaseCreationData(applicantPhaseCreationData) {
		return new ApplicantPhaseCreationDto({
			name: applicantPhaseCreationData.name,
			color: applicantPhaseCreationData.color,
			type: applicantPhaseCreationData.type
		});
	}
};
// source/models/applicant-phase/applicant-phase-dto.ts
var ApplicantPhaseDto = class ApplicantPhaseDto {
	id;
	name;
	color;
	type;
	createdAt;
	updatedAt;
	constructor({ id, name, color, type, createdAt, updatedAt }) {
		this.id = id;
		this.name = name;
		this.color = color;
		this.type = type;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toApplicantPhase() {
		return new ApplicantPhase({
			id: this.id,
			name: this.name,
			color: this.color,
			type: this.type,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromApplicantPhase(applicantPhase) {
		return new ApplicantPhaseDto({
			id: applicantPhase.id,
			name: applicantPhase.name,
			color: applicantPhase.color,
			type: applicantPhase.type,
			createdAt: applicantPhase.createdAt,
			updatedAt: applicantPhase.updatedAt
		});
	}
	static createFromDbObject(applicantPhaseDbObject) {
		return new ApplicantPhaseDto({
			id: applicantPhaseDbObject.id,
			name: applicantPhaseDbObject.name,
			color: applicantPhaseDbObject.color,
			type: applicantPhaseDbObject.type,
			createdAt: applicantPhaseDbObject.created_at,
			updatedAt: applicantPhaseDbObject.updated_at
		});
	}
	static createFromApplicantPhaseData(applicantPhaseData) {
		return new ApplicantPhaseDto({
			id: applicantPhaseData.id,
			name: applicantPhaseData.name,
			color: applicantPhaseData.color,
			type: applicantPhaseData.type,
			createdAt: applicantPhaseData.createdAt,
			updatedAt: applicantPhaseData.updatedAt
		});
	}
};
// source/models/applicant-phase/applicant-phase-update-dto.ts
var ApplicantPhaseUpdateDto = class ApplicantPhaseUpdateDto {
	name;
	color;
	type;
	constructor({ name, color, type }) {
		this.name = name;
		this.color = color;
		this.type = type;
	}
	static createFromApplicantPhaseUpdateData(applicantPhaseUpdateData) {
		return new ApplicantPhaseUpdateDto({
			name: applicantPhaseUpdateData.name,
			color: applicantPhaseUpdateData.color,
			type: applicantPhaseUpdateData.type
		});
	}
};
// source/models/email-signature/email-signature.ts
var EmailSignature = class EmailSignature {
	id;
	key;
	name;
	type;
	signature;
	createdAt;
	updatedAt;
	static CUSTOM_SIGNATURE_KEY = "CUSTOM_SIGNATURE";
	constructor({ id, key, name, type, signature, createdAt, updatedAt }) {
		this.id = id;
		this.key = key;
		this.name = name;
		this.type = type;
		this.signature = signature;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new EmailSignature({
			id: dbObject.id,
			key: dbObject.key,
			name: dbObject.name,
			type: dbObject.type,
			signature: dbObject.signature,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
	static createCustomSignatureFromCustomerEmailTemplate(customerEmailSignature) {
		return new EmailSignature({
			id: customerEmailSignature.id,
			key: EmailSignature.CUSTOM_SIGNATURE_KEY,
			name: customerEmailSignature.name,
			type: customerEmailSignature.type,
			signature: customerEmailSignature.signature,
			createdAt: customerEmailSignature.createdAt,
			updatedAt: customerEmailSignature.updatedAt
		});
	}
};
// source/models/email-signature/email-signature-dto.ts
var EmailSignatureDto = class EmailSignatureDto {
	id;
	key;
	name;
	type;
	signature;
	createdAt;
	updatedAt;
	constructor({ id, key, name, type, signature, createdAt, updatedAt }) {
		this.id = id;
		this.key = key;
		this.name = name;
		this.type = type;
		this.signature = signature;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toEmailSignature() {
		return new EmailSignature({
			id: this.id,
			key: this.key,
			name: this.name,
			type: this.type,
			signature: this.signature,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new EmailSignatureDto({
			id: dbObject.id,
			key: dbObject.key,
			name: dbObject.name,
			type: dbObject.type,
			signature: dbObject.signature,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
	static createFromEmailSignature(emailSignature) {
		return new EmailSignatureDto({
			id: emailSignature.id,
			key: emailSignature.key,
			name: emailSignature.name,
			type: emailSignature.type,
			signature: emailSignature.signature,
			createdAt: emailSignature.createdAt,
			updatedAt: emailSignature.updatedAt
		});
	}
	static createFromEmailSignatureData(emailSignatureData) {
		return new EmailSignatureDto({
			id: emailSignatureData.id,
			key: emailSignatureData.key,
			name: emailSignatureData.name,
			type: emailSignatureData.type,
			signature: emailSignatureData.signature,
			createdAt: emailSignatureData.createdAt,
			updatedAt: emailSignatureData.updatedAt
		});
	}
};
// source/models/email-signature/email-signature-update-dto.ts
var EmailSignatureUpdateDto = class EmailSignatureUpdateDto {
	name;
	signature;
	constructor({ name, signature }) {
		this.name = name;
		this.signature = signature;
	}
	static createFromDbObject(dbObject) {
		return new EmailSignatureUpdateDto({
			name: dbObject.name,
			signature: dbObject.signature
		});
	}
	static createFromEmailSignatureUpdateData(data) {
		return new EmailSignatureUpdateDto({
			name: data.name,
			signature: data.signature
		});
	}
};
// source/models/email-template/email-template.ts
var EmailTemplate = class EmailTemplate {
	id;
	key;
	onBehalfOf;
	name;
	type;
	subject;
	body;
	target;
	signatureId;
	createdAt;
	updatedAt;
	constructor({ id, key, onBehalfOf, name, type, subject, body, target, signatureId, createdAt, updatedAt }) {
		this.id = id;
		this.key = key;
		this.onBehalfOf = onBehalfOf;
		this.name = name;
		this.type = type;
		this.subject = subject;
		this.body = body;
		this.target = target;
		this.signatureId = signatureId;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	setBody(body) {
		this.body = body;
	}
	setSubject(subject) {
		this.subject = subject;
	}
	static createFromDbObject(dbObject) {
		return new EmailTemplate({
			id: dbObject.id,
			key: dbObject.key,
			onBehalfOf: dbObject.on_behalf_of,
			name: dbObject.name,
			type: dbObject.type,
			subject: dbObject.subject,
			body: dbObject.body,
			target: dbObject.target,
			signatureId: dbObject.signature_id,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/email-template/email-template-dto.ts
var EmailTemplateDto = class EmailTemplateDto {
	id;
	key;
	onBehalfOf;
	name;
	type;
	subject;
	body;
	target;
	signatureId;
	createdAt;
	updatedAt;
	constructor({ id, key, onBehalfOf, name, type, subject, body, target, signatureId, createdAt, updatedAt }) {
		this.id = id;
		this.key = key;
		this.onBehalfOf = onBehalfOf;
		this.name = name;
		this.type = type;
		this.subject = subject;
		this.body = body;
		this.target = target;
		this.signatureId = signatureId;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toEmailTemplate() {
		return new EmailTemplate({
			id: this.id,
			key: this.key,
			onBehalfOf: this.onBehalfOf,
			name: this.name,
			type: this.type,
			subject: this.subject,
			body: this.body,
			target: this.target,
			signatureId: this.signatureId,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new EmailTemplateDto({
			id: dbObject.id,
			key: dbObject.key,
			onBehalfOf: dbObject.on_behalf_of,
			name: dbObject.name,
			type: dbObject.type,
			subject: dbObject.subject,
			body: dbObject.body,
			target: dbObject.target,
			signatureId: dbObject.signature_id,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
	static createFromEmailTemplate(emailTemplate) {
		return new EmailTemplateDto({
			id: emailTemplate.id,
			key: emailTemplate.key,
			onBehalfOf: emailTemplate.onBehalfOf,
			name: emailTemplate.name,
			type: emailTemplate.type,
			subject: emailTemplate.subject,
			body: emailTemplate.body,
			target: emailTemplate.target,
			signatureId: emailTemplate.signatureId,
			createdAt: emailTemplate.createdAt,
			updatedAt: emailTemplate.updatedAt
		});
	}
	static createFromEmailTemplateData(emailTemplateData) {
		return new EmailTemplateDto({
			id: emailTemplateData.id,
			key: emailTemplateData.key,
			onBehalfOf: emailTemplateData.onBehalfOf,
			name: emailTemplateData.name,
			type: emailTemplateData.type,
			subject: emailTemplateData.subject,
			body: emailTemplateData.body,
			target: emailTemplateData.target,
			signatureId: emailTemplateData.signature_id,
			createdAt: emailTemplateData.createdAt,
			updatedAt: emailTemplateData.updatedAt
		});
	}
};
// source/models/email-template/email-template-update-dto.ts
var EmailTemplateUpdateDto = class EmailTemplateUpdateDto {
	name;
	subject;
	body;
	constructor({ name, subject, body }) {
		this.name = name;
		this.subject = subject;
		this.body = body;
	}
	static createFromDbObject(dbObject) {
		return new EmailTemplateUpdateDto({
			name: dbObject.name,
			subject: dbObject.subject,
			body: dbObject.body
		});
	}
	static createFromEmailTemplateUpdateData(data) {
		return new EmailTemplateUpdateDto({
			name: data.name,
			subject: data.subject,
			body: data.body
		});
	}
};
// source/models/email-template-with-relations/email-template-with-relations.ts
var EmailTemplateWithRelations = class EmailTemplateWithRelations extends EmailTemplate {
	signature;
	constructor({ signature, ...props }) {
		super(props);
		this.signature = signature;
	}
	static createFromDbObject(dbObject) {
		return new EmailTemplateWithRelations({
			id: dbObject.id,
			key: dbObject.key,
			onBehalfOf: dbObject.on_behalf_of,
			name: dbObject.name,
			type: dbObject.type,
			subject: dbObject.subject,
			body: dbObject.body,
			target: dbObject.target,
			signatureId: dbObject.signature_id,
			signature: dbObject.signature ? EmailSignature.createFromDbObject(dbObject.signature) : void 0,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/email-template-with-relations/email-template-with-relations-dto.ts
var EmailTemplateWithRelationsDto = class EmailTemplateWithRelationsDto extends EmailTemplateDto {
	signature;
	constructor({ signature, ...props }) {
		super(props);
		this.signature = signature;
	}
	toEmailTemplate() {
		return new EmailTemplateWithRelations({
			id: this.id,
			key: this.key,
			onBehalfOf: this.onBehalfOf,
			name: this.name,
			type: this.type,
			subject: this.subject,
			body: this.body,
			target: this.target,
			signatureId: this.signatureId,
			signature: this.signature ? this.signature.toEmailSignature() : void 0,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new EmailTemplateWithRelationsDto({
			id: dbObject.id,
			key: dbObject.key,
			onBehalfOf: dbObject.on_behalf_of,
			name: dbObject.name,
			type: dbObject.type,
			subject: dbObject.subject,
			body: dbObject.body,
			target: dbObject.target,
			signatureId: dbObject.signature_id,
			signature: dbObject.signature ? EmailSignatureDto.createFromDbObject(dbObject.signature) : void 0,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
	static createFromEmailTemplate(emailTemplate) {
		return new EmailTemplateWithRelationsDto({
			id: emailTemplate.id,
			key: emailTemplate.key,
			onBehalfOf: emailTemplate.onBehalfOf,
			name: emailTemplate.name,
			type: emailTemplate.type,
			subject: emailTemplate.subject,
			body: emailTemplate.body,
			target: emailTemplate.target,
			signatureId: emailTemplate.signatureId,
			signature: emailTemplate.signature ? EmailSignatureDto.createFromEmailSignature(emailTemplate.signature) : void 0,
			createdAt: emailTemplate.createdAt,
			updatedAt: emailTemplate.updatedAt
		});
	}
	static createFromEmailTemplateData(emailTemplateData) {
		return new EmailTemplateWithRelationsDto({
			id: emailTemplateData.id,
			key: emailTemplateData.key,
			onBehalfOf: emailTemplateData.onBehalfOf,
			name: emailTemplateData.name,
			type: emailTemplateData.type,
			subject: emailTemplateData.subject,
			body: emailTemplateData.body,
			target: emailTemplateData.target,
			signatureId: emailTemplateData.signature_id,
			signature: emailTemplateData.signature ? EmailSignatureDto.createFromEmailSignatureData(emailTemplateData.signature) : void 0,
			createdAt: emailTemplateData.createdAt,
			updatedAt: emailTemplateData.updatedAt
		});
	}
};
// source/models/applicant-automation-template-with-relations/applicant-automation-template-with-relations-dto.ts
var ApplicantAutomationTemplateWithRelationsDto = class ApplicantAutomationTemplateWithRelationsDto {
	id;
	label;
	type;
	emails;
	currentStateTemplate;
	hideCurrentStateChange;
	phaseType;
	phase;
	forwardedAt;
	hideForwardedAtChange;
	declineReason;
	declineReasonRequired;
	declineReasonTemplate;
	color;
	deadline;
	markApplicantDocumentsAsRead;
	prequalificationStatus;
	constructor({ id, label, type, emails, currentStateTemplate, hideCurrentStateChange, phaseType, phase, forwardedAt, hideForwardedAtChange, declineReason, declineReasonRequired, declineReasonTemplate, color, deadline, markApplicantDocumentsAsRead, prequalificationStatus }) {
		this.id = id;
		this.label = label;
		this.type = type;
		this.emails = emails;
		this.currentStateTemplate = currentStateTemplate;
		this.hideCurrentStateChange = hideCurrentStateChange;
		this.phaseType = phaseType;
		this.phase = phase;
		this.forwardedAt = forwardedAt;
		this.hideForwardedAtChange = hideForwardedAtChange;
		this.declineReason = declineReason;
		this.declineReasonRequired = declineReasonRequired;
		this.declineReasonTemplate = declineReasonTemplate;
		this.color = color;
		this.deadline = deadline;
		this.markApplicantDocumentsAsRead = markApplicantDocumentsAsRead;
		this.prequalificationStatus = prequalificationStatus;
	}
	toApplicantAutomationTemplateWithRelations() {
		return new ApplicantAutomationTemplateWithRelations({
			id: this.id,
			label: this.label,
			type: this.type,
			emails: this.emails?.map((email) => ({
				emailTemplateKey: email.emailTemplateKey,
				emailTemplate: email.emailTemplate?.toEmailTemplate(),
				emailDelayInMs: email.emailDelayInMs,
				emailSchedule: email.emailSchedule
			})),
			currentStateTemplate: this.currentStateTemplate,
			hideCurrentStateChange: this.hideCurrentStateChange,
			phaseType: this.phaseType,
			phase: this.phase?.toApplicantPhase(),
			forwardedAt: this.forwardedAt,
			hideForwardedAtChange: this.hideForwardedAtChange,
			declineReason: this.declineReason,
			declineReasonRequired: this.declineReasonRequired,
			declineReasonTemplate: this.declineReasonTemplate,
			color: this.color,
			deadline: this.deadline,
			markApplicantDocumentsAsRead: this.markApplicantDocumentsAsRead,
			prequalificationStatus: this.prequalificationStatus
		});
	}
	static createFromApplicantAutomationTemplateWithRelations(applicantAutomationTemplateWithRelations) {
		return new ApplicantAutomationTemplateWithRelationsDto({
			id: applicantAutomationTemplateWithRelations.id,
			label: applicantAutomationTemplateWithRelations.label,
			type: applicantAutomationTemplateWithRelations.type,
			emails: applicantAutomationTemplateWithRelations.emails?.map((email) => ({
				emailTemplateKey: email.emailTemplateKey,
				emailTemplate: EmailTemplateWithRelationsDto.createFromEmailTemplate(email.emailTemplate),
				emailDelayInMs: email.emailDelayInMs,
				emailSchedule: email.emailSchedule
			})),
			currentStateTemplate: applicantAutomationTemplateWithRelations.currentStateTemplate,
			hideCurrentStateChange: applicantAutomationTemplateWithRelations.hideCurrentStateChange,
			phaseType: applicantAutomationTemplateWithRelations.phaseType,
			phase: applicantAutomationTemplateWithRelations.phase ? ApplicantPhaseDto.createFromApplicantPhase(applicantAutomationTemplateWithRelations.phase) : null,
			forwardedAt: applicantAutomationTemplateWithRelations.forwardedAt,
			hideForwardedAtChange: applicantAutomationTemplateWithRelations.hideForwardedAtChange,
			declineReason: applicantAutomationTemplateWithRelations.declineReason,
			declineReasonRequired: applicantAutomationTemplateWithRelations.declineReasonRequired,
			declineReasonTemplate: applicantAutomationTemplateWithRelations.declineReasonTemplate,
			color: applicantAutomationTemplateWithRelations.color,
			deadline: applicantAutomationTemplateWithRelations.deadline,
			markApplicantDocumentsAsRead: applicantAutomationTemplateWithRelations.markApplicantDocumentsAsRead,
			prequalificationStatus: applicantAutomationTemplateWithRelations.prequalificationStatus
		});
	}
	static createFromApplicantAutomationTemplateWithRelationsData(data) {
		return new ApplicantAutomationTemplateWithRelationsDto({
			id: data.id,
			label: data.label,
			type: data.type,
			emails: data.emails?.map((email) => ({
				emailTemplateKey: email.emailTemplateKey,
				emailTemplate: EmailTemplateWithRelationsDto.createFromEmailTemplateData(email.emailTemplate),
				emailDelayInMs: email.emailDelayInMs,
				emailSchedule: email.emailSchedule
			})),
			currentStateTemplate: data.currentStateTemplate,
			hideCurrentStateChange: data.hideCurrentStateChange,
			phaseType: data.phaseType,
			phase: data.phase && ApplicantPhaseDto.createFromApplicantPhaseData(data.phase),
			forwardedAt: data.forwardedAt,
			hideForwardedAtChange: data.hideForwardedAtChange,
			declineReason: data.declineReason,
			declineReasonRequired: data.declineReasonRequired,
			declineReasonTemplate: data.declineReasonTemplate,
			color: data.color,
			deadline: data.deadline,
			markApplicantDocumentsAsRead: data.markApplicantDocumentsAsRead,
			prequalificationStatus: data.prequalificationStatus
		});
	}
};
// source/models/applicant-document/applicant-document.ts
var ApplicantDocument = class ApplicantDocument {
	id;
	applicantId;
	name;
	source;
	filePath;
	thumbnailPath;
	type;
	readAt;
	status;
	createdAt;
	updatedAt;
	constructor({ id, applicantId, name, source, filePath, thumbnailPath, type, readAt, status, createdAt, updatedAt }) {
		this.id = id;
		this.applicantId = applicantId;
		this.name = name;
		this.source = source;
		this.filePath = filePath;
		this.thumbnailPath = thumbnailPath;
		this.type = type;
		this.readAt = readAt;
		this.status = status;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(applicantDocumentDbObject) {
		return new ApplicantDocument({
			id: applicantDocumentDbObject.id,
			applicantId: applicantDocumentDbObject.applicant_id,
			name: applicantDocumentDbObject.name,
			source: applicantDocumentDbObject.source,
			filePath: applicantDocumentDbObject.file_path,
			thumbnailPath: applicantDocumentDbObject.thumbnail_path,
			type: applicantDocumentDbObject.type,
			readAt: applicantDocumentDbObject.read_at,
			status: applicantDocumentDbObject.status,
			createdAt: applicantDocumentDbObject.created_at,
			updatedAt: applicantDocumentDbObject.updated_at
		});
	}
};
// source/models/applicant-document/applicant-document-creation-dto.ts
var ApplicantDocumentCreationDto = class ApplicantDocumentCreationDto {
	applicantId;
	constructor({ applicantId }) {
		this.applicantId = applicantId;
	}
	static createFromApplicantDocumentCreationData(applicantDocumentCreationData) {
		return new ApplicantDocumentCreationDto({ applicantId: applicantDocumentCreationData.applicantId });
	}
};
// source/models/applicant-document/applicant-document-dto.ts
var ApplicantDocumentDto = class ApplicantDocumentDto {
	id;
	applicantId;
	name;
	type;
	thumbnailPath;
	readAt;
	status;
	createdAt;
	updatedAt;
	constructor({ id, applicantId, name, type, thumbnailPath, readAt, status, createdAt, updatedAt }) {
		this.id = id;
		this.applicantId = applicantId;
		this.name = name;
		this.type = type;
		this.thumbnailPath = thumbnailPath;
		this.readAt = readAt;
		this.status = status;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toApplicantDocument() {
		return new ApplicantDocument({
			id: this.id,
			applicantId: this.applicantId,
			name: this.name,
			type: this.type,
			thumbnailPath: this.thumbnailPath,
			readAt: this.readAt,
			status: this.status,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromApplicantDocument(applicantDocument) {
		return new ApplicantDocumentDto({
			id: applicantDocument.id,
			applicantId: applicantDocument.applicantId,
			name: applicantDocument.name,
			type: applicantDocument.type,
			thumbnailPath: applicantDocument.thumbnailPath,
			readAt: applicantDocument.readAt,
			status: applicantDocument.status,
			createdAt: applicantDocument.createdAt,
			updatedAt: applicantDocument.updatedAt
		});
	}
	static createFromDbObject(applicantDocumentDbObject) {
		return new ApplicantDocumentDto({
			id: applicantDocumentDbObject.id,
			applicantId: applicantDocumentDbObject.applicant_id,
			name: applicantDocumentDbObject.name,
			type: applicantDocumentDbObject.type,
			thumbnailPath: applicantDocumentDbObject.thumbnail_path,
			readAt: applicantDocumentDbObject.read_at,
			status: applicantDocumentDbObject.status,
			createdAt: applicantDocumentDbObject.created_at,
			updatedAt: applicantDocumentDbObject.updated_at
		});
	}
	static createFromApplicantDocumentData(applicantDocumentData) {
		return new ApplicantDocumentDto({
			id: applicantDocumentData.id,
			applicantId: applicantDocumentData.applicantId,
			name: applicantDocumentData.name,
			type: applicantDocumentData.type,
			thumbnailPath: applicantDocumentData.thumbnailPath,
			readAt: applicantDocumentData.readAt,
			status: applicantDocumentData.status,
			createdAt: applicantDocumentData.createdAt,
			updatedAt: applicantDocumentData.updatedAt
		});
	}
};
// source/models/applicant-manager/applicant-manager.tsx
var ApplicantManager = class ApplicantManager {
	id;
	firebaseUid;
	emailAddress;
	name;
	createdAt;
	updatedAt;
	constructor({ id, name, emailAddress, firebaseUid, createdAt, updatedAt }) {
		this.id = id;
		this.name = name;
		this.emailAddress = emailAddress;
		this.firebaseUid = firebaseUid;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(applicantManagerDbObject) {
		return new ApplicantManager({
			id: applicantManagerDbObject.id,
			name: applicantManagerDbObject.name,
			emailAddress: applicantManagerDbObject.email_address,
			firebaseUid: applicantManagerDbObject.firebase_uid,
			createdAt: applicantManagerDbObject.created_at,
			updatedAt: applicantManagerDbObject.updated_at
		});
	}
};
// source/models/applicant-manager/applicant-manager-dto.tsx
var ApplicantManagerDto = class ApplicantManagerDto {
	id;
	firebaseUid;
	emailAddress;
	name;
	createdAt;
	updatedAt;
	constructor({ id, name, emailAddress, firebaseUid, createdAt, updatedAt }) {
		this.id = id;
		this.name = name;
		this.emailAddress = emailAddress;
		this.firebaseUid = firebaseUid;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toApplicantManager() {
		return new ApplicantManager({
			id: this.id,
			name: this.name,
			emailAddress: this.emailAddress,
			firebaseUid: this.firebaseUid,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromApplicantManager(applicantManager) {
		return new ApplicantManagerDto({
			id: applicantManager.id,
			name: applicantManager.name,
			emailAddress: applicantManager.emailAddress,
			firebaseUid: applicantManager.firebaseUid,
			createdAt: applicantManager.createdAt,
			updatedAt: applicantManager.updatedAt
		});
	}
	static createFromApplicantManagerData(applicantManager) {
		return new ApplicantManagerDto({
			id: applicantManager.id,
			name: applicantManager.name,
			emailAddress: applicantManager.emailAddress,
			firebaseUid: applicantManager.firebaseUid,
			createdAt: applicantManager.createdAt,
			updatedAt: applicantManager.updatedAt
		});
	}
	static createFromDbObject(applicantManagerDbObject) {
		return new ApplicantManagerDto({
			id: applicantManagerDbObject.id,
			name: applicantManagerDbObject.name,
			emailAddress: applicantManagerDbObject.email_address,
			firebaseUid: applicantManagerDbObject.firebase_uid,
			createdAt: applicantManagerDbObject.created_at,
			updatedAt: applicantManagerDbObject.updated_at
		});
	}
};
// source/models/applicant-processing-state/applicant-processing-state.ts
var ApplicantProcessingState = class ApplicantProcessingState {
	id;
	applicantId;
	resolvedAt;
	lockedByApplicantManagerId;
	lockedByApplicantManagerName;
	lockedBySessionId;
	lockedByLoginFirebaseUid;
	lockedByLoginName;
	lockedByLoginPhotoUrl;
	lockedAt;
	createdAt;
	updatedAt;
	constructor({ id, applicantId, resolvedAt, lockedByApplicantManagerId, lockedByApplicantManagerName, lockedBySessionId, lockedByLoginFirebaseUid, lockedByLoginName, lockedByLoginPhotoUrl, lockedAt, createdAt, updatedAt }) {
		this.id = id;
		this.applicantId = applicantId;
		this.resolvedAt = resolvedAt;
		this.lockedByApplicantManagerId = lockedByApplicantManagerId;
		this.lockedByApplicantManagerName = lockedByApplicantManagerName;
		this.lockedBySessionId = lockedBySessionId;
		this.lockedByLoginFirebaseUid = lockedByLoginFirebaseUid;
		this.lockedByLoginName = lockedByLoginName;
		this.lockedByLoginPhotoUrl = lockedByLoginPhotoUrl;
		this.lockedAt = lockedAt;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(applicantProcessingStateDbObject) {
		return new ApplicantProcessingState({
			id: applicantProcessingStateDbObject.id,
			applicantId: applicantProcessingStateDbObject.applicant_id,
			resolvedAt: applicantProcessingStateDbObject.resolved_at ?? null,
			lockedByApplicantManagerId: applicantProcessingStateDbObject.locked_by_applicant_manager_id ?? null,
			lockedByApplicantManagerName: applicantProcessingStateDbObject.locked_by_applicant_manager_name ?? null,
			lockedBySessionId: applicantProcessingStateDbObject.locked_by_session_id ?? null,
			lockedByLoginFirebaseUid: applicantProcessingStateDbObject.locked_by_login_firebase_uid ?? null,
			lockedByLoginName: applicantProcessingStateDbObject.locked_by_login_name ?? null,
			lockedByLoginPhotoUrl: applicantProcessingStateDbObject.locked_by_login_photo_url ?? null,
			lockedAt: applicantProcessingStateDbObject.locked_at ?? null,
			createdAt: applicantProcessingStateDbObject.created_at,
			updatedAt: applicantProcessingStateDbObject.updated_at
		});
	}
};
// source/models/applicant-processing-state/applicant-processing-state-dto.ts
var ApplicantProcessingStateDto = class ApplicantProcessingStateDto {
	id;
	applicantId;
	resolvedAt;
	lockedByApplicantManagerId;
	lockedByApplicantManagerName;
	lockedBySessionId;
	lockedByLoginFirebaseUid;
	lockedByLoginName;
	lockedByLoginPhotoUrl;
	lockedAt;
	createdAt;
	updatedAt;
	constructor({ id, applicantId, resolvedAt, lockedByApplicantManagerId, lockedByApplicantManagerName, lockedBySessionId, lockedByLoginFirebaseUid, lockedByLoginName, lockedByLoginPhotoUrl, lockedAt, createdAt, updatedAt }) {
		this.id = id;
		this.applicantId = applicantId;
		this.resolvedAt = resolvedAt;
		this.lockedByApplicantManagerId = lockedByApplicantManagerId;
		this.lockedByApplicantManagerName = lockedByApplicantManagerName;
		this.lockedBySessionId = lockedBySessionId;
		this.lockedByLoginFirebaseUid = lockedByLoginFirebaseUid;
		this.lockedByLoginName = lockedByLoginName;
		this.lockedByLoginPhotoUrl = lockedByLoginPhotoUrl;
		this.lockedAt = lockedAt;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromApplicantProcessingState(applicantProcessingState) {
		return new ApplicantProcessingStateDto(applicantProcessingState);
	}
	static createFromApplicantProcessingStateData(data) {
		return new ApplicantProcessingStateDto({
			id: data.id,
			applicantId: data.applicantId,
			resolvedAt: data.resolvedAt,
			lockedByApplicantManagerId: data.lockedByApplicantManagerId,
			lockedByApplicantManagerName: data.lockedByApplicantManagerName,
			lockedBySessionId: data.lockedBySessionId,
			lockedByLoginFirebaseUid: data.lockedByLoginFirebaseUid,
			lockedByLoginName: data.lockedByLoginName,
			lockedByLoginPhotoUrl: data.lockedByLoginPhotoUrl,
			lockedAt: data.lockedAt,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
	toApplicantProcessingState() {
		return new ApplicantProcessingState({
			id: this.id,
			applicantId: this.applicantId,
			resolvedAt: this.resolvedAt,
			lockedByApplicantManagerId: this.lockedByApplicantManagerId,
			lockedByApplicantManagerName: this.lockedByApplicantManagerName,
			lockedBySessionId: this.lockedBySessionId,
			lockedByLoginFirebaseUid: this.lockedByLoginFirebaseUid,
			lockedByLoginName: this.lockedByLoginName,
			lockedByLoginPhotoUrl: this.lockedByLoginPhotoUrl,
			lockedAt: this.lockedAt,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
};
// source/models/applicant-score/applicant-score.ts
var ApplicantScore = class ApplicantScore {
	id;
	applicantId;
	scoreCardId;
	rating;
	notes;
	createdAt;
	updatedAt;
	constructor({ id, applicantId, scoreCardId, rating, notes, createdAt, updatedAt }) {
		this.id = id;
		this.applicantId = applicantId;
		this.scoreCardId = scoreCardId;
		this.rating = rating;
		this.notes = notes;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new ApplicantScore({
			id: dbObject.id,
			applicantId: dbObject.applicant_id,
			scoreCardId: dbObject.score_card_id,
			rating: dbObject.rating,
			notes: dbObject.notes,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/applicant-score/applicant-score-creation-dto.ts
var ApplicantScoreCreationDto = class ApplicantScoreCreationDto {
	applicantId;
	scoreCardId;
	rating;
	notes;
	constructor({ applicantId, scoreCardId, rating, notes }) {
		this.applicantId = applicantId;
		this.scoreCardId = scoreCardId;
		this.rating = rating;
		this.notes = notes;
	}
	static createFromApplicantScoreCreationData(data) {
		return new ApplicantScoreCreationDto({
			applicantId: data.applicantId,
			scoreCardId: data.scoreCardId,
			rating: data.rating,
			notes: data.notes
		});
	}
	static createFromDbObject(dbObject) {
		return new ApplicantScoreCreationDto({
			applicantId: dbObject.applicant_id,
			scoreCardId: dbObject.score_card_id,
			rating: dbObject.rating,
			notes: dbObject.notes
		});
	}
	convertToDbObject() {
		return {
			applicant_id: this.applicantId,
			score_card_id: this.scoreCardId,
			rating: this.rating,
			notes: this.notes
		};
	}
};
// source/models/applicant-score/applicant-score-dto.ts
var ApplicantScoreDto = class ApplicantScoreDto {
	id;
	applicantId;
	scoreCardId;
	rating;
	notes;
	createdAt;
	updatedAt;
	constructor({ id, applicantId, scoreCardId, rating, notes, createdAt, updatedAt }) {
		this.id = id;
		this.applicantId = applicantId;
		this.scoreCardId = scoreCardId;
		this.rating = rating;
		this.notes = notes;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toApplicantScore() {
		return new ApplicantScore({
			id: this.id,
			applicantId: this.applicantId,
			scoreCardId: this.scoreCardId,
			rating: this.rating,
			notes: this.notes,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromApplicantScore(applicantScore) {
		return new ApplicantScoreDto({
			id: applicantScore.id,
			applicantId: applicantScore.applicantId,
			scoreCardId: applicantScore.scoreCardId,
			rating: applicantScore.rating,
			notes: applicantScore.notes,
			createdAt: applicantScore.createdAt,
			updatedAt: applicantScore.updatedAt
		});
	}
	static createFromApplicantScoreData(data) {
		return new ApplicantScoreDto({
			id: data.id,
			applicantId: data.applicantId,
			scoreCardId: data.scoreCardId,
			rating: data.rating,
			notes: data.notes,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new ApplicantScoreDto({
			id: dbObject.id,
			applicantId: dbObject.applicant_id,
			scoreCardId: dbObject.score_card_id,
			rating: dbObject.rating,
			notes: dbObject.notes,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/applicant-score/applicant-score-update-dto.ts
var ApplicantScoreUpdateDto = class ApplicantScoreUpdateDto {
	rating;
	notes;
	constructor({ rating, notes }) {
		this.rating = rating;
		this.notes = notes;
	}
	static createFromApplicantScoreUpdateData(data) {
		return new ApplicantScoreUpdateDto({
			rating: data.rating,
			notes: data.notes
		});
	}
	convertToDbObject() {
		return {
			rating: this.rating,
			notes: this.notes
		};
	}
};
// source/models/applicant-score/applicant-score-upsert-dto.ts
var ApplicantScoreUpsertDto = class ApplicantScoreUpsertDto {
	id;
	applicantId;
	scoreCardId;
	rating;
	notes;
	constructor({ id, applicantId, scoreCardId, rating, notes }) {
		this.id = id;
		this.applicantId = applicantId;
		this.scoreCardId = scoreCardId;
		this.rating = rating;
		this.notes = notes;
	}
	static createFromApplicantScoreUpsertData(data) {
		return new ApplicantScoreUpsertDto({
			id: data.id,
			applicantId: data.applicantId,
			scoreCardId: data.scoreCardId,
			rating: data.rating,
			notes: data.notes
		});
	}
	static createFromApplicantScore(applicantScore) {
		return new ApplicantScoreUpsertDto({
			id: applicantScore.id,
			applicantId: applicantScore.applicantId,
			scoreCardId: applicantScore.scoreCardId,
			rating: applicantScore.rating,
			notes: applicantScore.notes
		});
	}
	convertToDbObject() {
		return {
			id: this.id,
			applicant_id: this.applicantId,
			score_card_id: this.scoreCardId,
			rating: this.rating,
			notes: this.notes
		};
	}
	convertToDataObject() {
		return {
			id: this.id,
			applicantId: this.applicantId,
			scoreCardId: this.scoreCardId,
			rating: this.rating,
			notes: this.notes
		};
	}
};
// source/models/score-card/score-card.ts
var ScoreCard = class ScoreCard {
	id;
	jobPositionId;
	title;
	description;
	position;
	createdAt;
	updatedAt;
	constructor({ id, title, jobPositionId, description, position, createdAt, updatedAt }) {
		this.id = id;
		this.jobPositionId = jobPositionId;
		this.title = title;
		this.description = description;
		this.position = position;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new ScoreCard({
			id: dbObject.id,
			jobPositionId: dbObject.job_position_id,
			title: dbObject.title,
			description: dbObject.description,
			position: dbObject.position,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/score-card/score-card-creation-dto.ts
var ScoreCardCreationDto = class ScoreCardCreationDto {
	jobPositionId;
	title;
	description;
	position;
	constructor({ jobPositionId, title, description, position }) {
		this.jobPositionId = jobPositionId;
		this.title = title;
		this.description = description;
		this.position = position;
	}
	static createFromScoreCardCreationData(data) {
		return new ScoreCardCreationDto({
			jobPositionId: data.jobPositionId,
			title: data.title,
			description: data.description,
			position: data.position
		});
	}
	static createFromDbObject(dbObject) {
		return new ScoreCardCreationDto({
			jobPositionId: dbObject.job_position_id,
			title: dbObject.title,
			description: dbObject.description,
			position: dbObject.position
		});
	}
	convertToDbObject() {
		return {
			job_position_id: this.jobPositionId,
			title: this.title,
			description: this.description,
			position: this.position
		};
	}
};
// source/models/score-card/score-card-dto.ts
var ScoreCardDto = class ScoreCardDto {
	id;
	jobPositionId;
	title;
	description;
	position;
	createdAt;
	updatedAt;
	constructor({ id, jobPositionId, title, description, position, createdAt, updatedAt }) {
		this.id = id;
		this.jobPositionId = jobPositionId;
		this.title = title;
		this.description = description;
		this.position = position;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toScoreCard() {
		return new ScoreCard({
			id: this.id,
			jobPositionId: this.jobPositionId,
			title: this.title,
			description: this.description,
			position: this.position,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromScoreCard(scoreCard) {
		return new ScoreCardDto({
			id: scoreCard.id,
			jobPositionId: scoreCard.jobPositionId,
			title: scoreCard.title,
			description: scoreCard.description,
			position: scoreCard.position,
			createdAt: scoreCard.createdAt,
			updatedAt: scoreCard.updatedAt
		});
	}
	static createFromScoreCardData(data) {
		return new ScoreCardDto({
			id: data.id,
			jobPositionId: data.jobPositionId,
			title: data.title,
			description: data.description,
			position: data.position,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new ScoreCardDto({
			id: dbObject.id,
			jobPositionId: dbObject.job_position_id,
			title: dbObject.title,
			description: dbObject.description,
			position: dbObject.position,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/score-card/score-card-update-dto.ts
var ScoreCardUpdateDto = class ScoreCardUpdateDto {
	title;
	description;
	position;
	constructor({ title, description, position }) {
		this.title = title;
		this.description = description;
		this.position = position;
	}
	static createFromScoreCardUpdateData(data) {
		return new ScoreCardUpdateDto({
			title: data.title,
			description: data.description,
			position: data.position
		});
	}
	convertToDbObject() {
		return {
			title: this.title,
			description: this.description,
			position: this.position
		};
	}
};
// source/models/score-card/score-card-upsert-dto.ts
var ScoreCardUpsertDto = class ScoreCardUpsertDto {
	id;
	jobPositionId;
	title;
	description;
	position;
	constructor({ id, jobPositionId, title, description, position }) {
		this.id = id;
		this.jobPositionId = jobPositionId;
		this.title = title;
		this.description = description;
		this.position = position;
	}
	static createFromScoreCardUpsertData(data) {
		return new ScoreCardUpsertDto({
			id: data.id,
			jobPositionId: data.jobPositionId,
			title: data.title,
			description: data.description,
			position: data.position
		});
	}
	static createFromScoreCard(data) {
		return new ScoreCardUpsertDto({
			id: data.id,
			jobPositionId: data.jobPositionId,
			title: data.title,
			description: data.description,
			position: data.position
		});
	}
	convertToDbObject() {
		return {
			id: this.id,
			job_position_id: this.jobPositionId,
			title: this.title,
			description: this.description,
			position: this.position
		};
	}
	convertToDataOject() {
		return {
			id: this.id,
			jobPositionId: this.jobPositionId,
			title: this.title,
			description: this.description,
			position: this.position
		};
	}
};
// source/models/applicant-score-with-relations/applicant-score-with-relations.ts
var ApplicantScoreWithRelations = class ApplicantScoreWithRelations extends ApplicantScore {
	scoreCard;
	constructor({ scoreCard, ...props }) {
		super(props);
		this.scoreCard = scoreCard;
	}
	static createFromDbObject(applicantScoreWithRelationsDbObject) {
		return new ApplicantScoreWithRelations({
			id: applicantScoreWithRelationsDbObject.id,
			applicantId: applicantScoreWithRelationsDbObject.applicant_id,
			scoreCardId: applicantScoreWithRelationsDbObject.score_card_id,
			rating: applicantScoreWithRelationsDbObject.rating,
			notes: applicantScoreWithRelationsDbObject.notes,
			createdAt: applicantScoreWithRelationsDbObject.created_at,
			updatedAt: applicantScoreWithRelationsDbObject.updated_at,
			scoreCard: ScoreCard.createFromDbObject(applicantScoreWithRelationsDbObject.company)
		});
	}
};
// source/models/applicant-score-with-relations/applicant-score-with-relations-dto.ts
var ApplicantScoreWithRelationsDto = class ApplicantScoreWithRelationsDto extends ApplicantScoreDto {
	scoreCard;
	constructor({ scoreCard, ...props }) {
		super(props);
		this.scoreCard = scoreCard;
	}
	toApplicantScoreWithRelations() {
		return new ApplicantScoreWithRelations({
			id: this.id,
			applicantId: this.applicantId,
			scoreCardId: this.scoreCardId,
			rating: this.rating,
			notes: this.notes,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt,
			scoreCard: this.scoreCard.toScoreCard()
		});
	}
	static createFromApplicantScoreWithRelations(applicantScoreWithRelations) {
		return new ApplicantScoreWithRelationsDto({
			id: applicantScoreWithRelations.id,
			applicantId: applicantScoreWithRelations.applicantId,
			scoreCardId: applicantScoreWithRelations.scoreCardId,
			rating: applicantScoreWithRelations.rating,
			notes: applicantScoreWithRelations.notes,
			createdAt: applicantScoreWithRelations.createdAt,
			updatedAt: applicantScoreWithRelations.updatedAt,
			scoreCard: ScoreCardDto.createFromScoreCardData(applicantScoreWithRelations.company)
		});
	}
	static createFromDbObject(applicantScoreWithRelationsDbObject) {
		return new ApplicantScoreWithRelationsDto({
			id: applicantScoreWithRelationsDbObject.id,
			applicantId: applicantScoreWithRelationsDbObject.applicant_id,
			scoreCardId: applicantScoreWithRelationsDbObject.score_card_id,
			rating: applicantScoreWithRelationsDbObject.rating,
			notes: applicantScoreWithRelationsDbObject.notes,
			createdAt: applicantScoreWithRelationsDbObject.created_at,
			updatedAt: applicantScoreWithRelationsDbObject.updated_at,
			scoreCard: ScoreCardDto.createFromDbObject(applicantScoreWithRelationsDbObject.company)
		});
	}
	static createFromApplicantScoreWithRelationsData(applicantScoreWithRelationsData) {
		return new ApplicantScoreWithRelationsDto({
			id: applicantScoreWithRelationsData.id,
			applicantId: applicantScoreWithRelationsData.applicantId,
			scoreCardId: applicantScoreWithRelationsData.scoreCardId,
			rating: applicantScoreWithRelationsData.rating,
			notes: applicantScoreWithRelationsData.notes,
			createdAt: applicantScoreWithRelationsData.createdAt,
			updatedAt: applicantScoreWithRelationsData.updatedAt,
			scoreCard: ScoreCardDto.createFromScoreCardData(applicantScoreWithRelationsData.company)
		});
	}
};
// source/models/applicant-source/applicant-source.ts
var ApplicantSource = class ApplicantSource {
	id;
	name;
	color;
	type;
	position;
	createdAt;
	updatedAt;
	constructor({ id, name, color, type, position, createdAt, updatedAt }) {
		this.id = id;
		this.name = name;
		this.color = color;
		this.type = type;
		this.position = position;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(applicantSourceDbObject) {
		return new ApplicantSource({
			id: applicantSourceDbObject.id,
			name: applicantSourceDbObject.name,
			color: applicantSourceDbObject.color,
			type: applicantSourceDbObject.type,
			position: applicantSourceDbObject.position,
			createdAt: applicantSourceDbObject.created_at,
			updatedAt: applicantSourceDbObject.updated_at
		});
	}
};
// source/models/applicant-source/applicant-source-creation-dto.ts
var ApplicantSourceCreationDto = class ApplicantSourceCreationDto {
	name;
	color;
	type;
	constructor({ name, color, type }) {
		this.name = name;
		this.color = color;
		this.type = type;
	}
	static createFromApplicantSourceCreationData(applicantSourceCreationData) {
		return new ApplicantSourceCreationDto({
			name: applicantSourceCreationData.name,
			color: applicantSourceCreationData.color,
			type: applicantSourceCreationData.type
		});
	}
};
// source/models/applicant-source/applicant-source-dto.ts
var ApplicantSourceDto = class ApplicantSourceDto {
	id;
	name;
	color;
	type;
	position;
	createdAt;
	updatedAt;
	constructor({ id, name, color, type, position, createdAt, updatedAt }) {
		this.id = id;
		this.name = name;
		this.color = color;
		this.type = type;
		this.position = position;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toApplicantSource() {
		return new ApplicantSource({
			id: this.id,
			name: this.name,
			color: this.color,
			type: this.type,
			position: this.position,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromApplicantSource(applicantSource) {
		return new ApplicantSourceDto({
			id: applicantSource.id,
			name: applicantSource.name,
			color: applicantSource.color,
			type: applicantSource.type,
			position: applicantSource.position,
			createdAt: applicantSource.createdAt,
			updatedAt: applicantSource.updatedAt
		});
	}
	static createFromDbObject(applicantSourceDbObject) {
		return new ApplicantSourceDto({
			id: applicantSourceDbObject.id,
			name: applicantSourceDbObject.name,
			color: applicantSourceDbObject.color,
			type: applicantSourceDbObject.type,
			position: applicantSourceDbObject.position,
			createdAt: applicantSourceDbObject.created_at,
			updatedAt: applicantSourceDbObject.updated_at
		});
	}
	static createFromApplicantSourceData(applicantSourceData) {
		return new ApplicantSourceDto({
			id: applicantSourceData.id,
			name: applicantSourceData.name,
			color: applicantSourceData.color,
			type: applicantSourceData.type,
			position: applicantSourceData.position,
			createdAt: applicantSourceData.createdAt,
			updatedAt: applicantSourceData.updatedAt
		});
	}
};
// source/models/applicant-source/applicant-source-update-dto.ts
var ApplicantSourceUpdateDto = class ApplicantSourceUpdateDto {
	name;
	color;
	type;
	constructor({ name, color, type }) {
		this.name = name;
		this.color = color;
		this.type = type;
	}
	static createFromApplicantSourceUpdateData(applicantSourceUpdateData) {
		return new ApplicantSourceUpdateDto({
			name: applicantSourceUpdateData.name,
			color: applicantSourceUpdateData.color,
			type: applicantSourceUpdateData.type
		});
	}
};
// source/models/applicant-status-update/applicant-status-update.ts
var ApplicantStatusUpdate = class ApplicantStatusUpdate {
	id;
	applicantId;
	content;
	followUpDate;
	followUpContent;
	createdAt;
	updatedAt;
	constructor({ id, applicantId, content, followUpDate, followUpContent, createdAt, updatedAt }) {
		this.id = id;
		this.applicantId = applicantId;
		this.content = content;
		this.followUpDate = followUpDate;
		this.followUpContent = followUpContent;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new ApplicantStatusUpdate({
			id: dbObject.id,
			applicantId: dbObject.applicant_id,
			content: dbObject.content,
			followUpDate: dbObject.follow_up_date,
			followUpContent: dbObject.follow_up_content,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/applicant-status-update/applicant-status-update-creation-dto.ts
var ApplicantStatusUpdateCreationDto = class ApplicantStatusUpdateCreationDto {
	applicantId;
	content;
	followUpDate;
	followUpContent;
	constructor({ applicantId, content, followUpDate, followUpContent }) {
		this.applicantId = applicantId;
		this.content = content;
		this.followUpDate = followUpDate;
		this.followUpContent = followUpContent;
	}
	static createFromApplicantStatusUpdateCreationData(data) {
		return new ApplicantStatusUpdateCreationDto({
			applicantId: data.applicantId,
			content: data.content,
			followUpDate: data.followUpDate,
			followUpContent: data.followUpContent
		});
	}
	static createFromDbObject(dbObject) {
		return new ApplicantStatusUpdateCreationDto({
			applicantId: dbObject.applicant_id,
			content: dbObject.content,
			followUpDate: dbObject.follow_up_date,
			followUpContent: dbObject.follow_up_content
		});
	}
	convertToDbObject() {
		return {
			applicant_id: this.applicantId,
			content: this.content,
			follow_up_date: this.followUpDate || null,
			follow_up_content: this.followUpContent || null
		};
	}
};
// source/models/applicant-status-update/applicant-status-update-dto.ts
var ApplicantStatusUpdateDto = class ApplicantStatusUpdateDto {
	id;
	applicantId;
	content;
	followUpDate;
	followUpContent;
	createdAt;
	updatedAt;
	constructor({ id, applicantId, content, followUpDate, followUpContent, createdAt, updatedAt }) {
		this.id = id;
		this.applicantId = applicantId;
		this.content = content;
		this.followUpDate = followUpDate;
		this.followUpContent = followUpContent;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toApplicantStatusUpdate() {
		return new ApplicantStatusUpdate({
			id: this.id,
			applicantId: this.applicantId,
			content: this.content,
			followUpDate: this.followUpDate,
			followUpContent: this.followUpContent,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromApplicantStatusUpdate(applicantStatusUpdate) {
		return new ApplicantStatusUpdateDto({
			id: applicantStatusUpdate.id,
			applicantId: applicantStatusUpdate.applicantId,
			content: applicantStatusUpdate.content,
			followUpDate: applicantStatusUpdate.followUpDate,
			followUpContent: applicantStatusUpdate.followUpContent,
			createdAt: applicantStatusUpdate.createdAt,
			updatedAt: applicantStatusUpdate.updatedAt
		});
	}
	static createFromApplicantStatusUpdateData(data) {
		return new ApplicantStatusUpdateDto({
			id: data.id,
			applicantId: data.applicantId,
			content: data.content,
			followUpDate: data.followUpDate,
			followUpContent: data.followUpContent,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new ApplicantStatusUpdateDto({
			id: dbObject.id,
			applicantId: dbObject.applicant_id,
			content: dbObject.content,
			followUpDate: dbObject.follow_up_date,
			followUpContent: dbObject.follow_up_content,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/job-position-settings/job-position-settings.ts
var JobPositionSettings = class {
	addressZipCode;
	addressCity;
	weeklyHours;
	weeklyHoursMax;
	schedule;
	startDate;
	shiftWork;
	salary;
	salaryIsPublic;
	/**
	* @deprecated Salutation not needed anymore, we use always "Du"
	*/
	salutation;
	searchArea;
	searchCenter;
	searchCenterCountry;
	searchRadius;
	cvRequired;
	cvRequiredInForm;
	emailRecipients;
	type;
	/**
	* @deprecated merged into other_manager_info
	*/
	fieldServiceAndHomeOffice;
	otherManagerInfo;
	trainingDuration;
	isFlexibleInternshipPossible;
	requirements;
	additionalRequirements;
	tasks;
	benefits;
	contactPersonName;
	contactPersonPosition;
	contactPersonEmail;
	contactPersonSalutation;
	/**
	* @deprecated addressLink is not needed anymore, instead a reference to location is used
	*/
	addressLink;
	traineeFirstYearSalary;
	traineeSecondYearSalary;
	traineeThirdYearSalary;
	traineeFourthYearSalary;
	dualStudentSalary;
	locationId;
	workAreaId;
	applicantNotesTemplate;
	documentsRequiredForForwarding;
	requiredDocumentsDescription;
	constructor({ addressZipCode, addressCity, weeklyHours, weeklyHoursMax, schedule, startDate, shiftWork, salary, salaryIsPublic, salutation, searchArea, searchCenter, searchCenterCountry, searchRadius, cvRequired, cvRequiredInForm, emailRecipients, type, fieldServiceAndHomeOffice, otherManagerInfo, trainingDuration, isFlexibleInternshipPossible, requirements, additionalRequirements, tasks, benefits, contactPersonName, contactPersonPosition, contactPersonEmail, contactPersonSalutation, addressLink, traineeFirstYearSalary, traineeSecondYearSalary, traineeThirdYearSalary, traineeFourthYearSalary, dualStudentSalary, locationId, workAreaId, applicantNotesTemplate, documentsRequiredForForwarding, requiredDocumentsDescription }) {
		this.addressZipCode = addressZipCode;
		this.addressCity = addressCity;
		this.weeklyHours = weeklyHours;
		this.weeklyHoursMax = weeklyHoursMax;
		this.schedule = schedule;
		this.startDate = startDate;
		this.shiftWork = shiftWork;
		this.salary = salary;
		this.salaryIsPublic = salaryIsPublic;
		this.salutation = salutation;
		this.searchArea = searchArea;
		this.searchCenter = searchCenter;
		this.searchCenterCountry = searchCenterCountry;
		this.searchRadius = searchRadius;
		this.cvRequired = cvRequired;
		this.cvRequiredInForm = cvRequiredInForm;
		this.emailRecipients = emailRecipients;
		this.type = type;
		this.fieldServiceAndHomeOffice = fieldServiceAndHomeOffice;
		this.otherManagerInfo = otherManagerInfo;
		this.trainingDuration = trainingDuration;
		this.isFlexibleInternshipPossible = isFlexibleInternshipPossible;
		this.requirements = requirements;
		this.additionalRequirements = additionalRequirements;
		this.tasks = tasks;
		this.benefits = benefits;
		this.contactPersonName = contactPersonName;
		this.contactPersonPosition = contactPersonPosition;
		this.contactPersonEmail = contactPersonEmail;
		this.contactPersonSalutation = contactPersonSalutation;
		this.addressLink = addressLink;
		this.traineeFirstYearSalary = traineeFirstYearSalary;
		this.traineeSecondYearSalary = traineeSecondYearSalary;
		this.traineeThirdYearSalary = traineeThirdYearSalary;
		this.traineeFourthYearSalary = traineeFourthYearSalary;
		this.dualStudentSalary = dualStudentSalary;
		this.locationId = locationId;
		this.workAreaId = workAreaId;
		this.applicantNotesTemplate = applicantNotesTemplate;
		this.documentsRequiredForForwarding = documentsRequiredForForwarding;
		this.requiredDocumentsDescription = requiredDocumentsDescription;
	}
};
// source/models/job-position/job-position.ts
var JobPosition = class JobPosition extends JobPositionSettings {
	id;
	customerId;
	mondayItemId;
	name;
	fullName;
	specialization;
	university;
	externalApplicationUrl;
	isPreQualified;
	isCampaignActive;
	monthlyAdvertisingBudget;
	landingPageUrl;
	isCampaignExpiring;
	campaignEndDate;
	directApproaches;
	potential;
	campaignError;
	directApproachesError;
	isIndeedActive;
	indeedDeadline;
	indeedMonthlyBudget;
	isStepstoneActive;
	stepstoneDeadline;
	jobPortalError;
	isArchived;
	careerPageActive;
	repostedAt;
	searchAdStatus;
	campaignStatus;
	campaignId;
	campaignRelatedJobPositionNames;
	heroImagePath;
	heroVideoPath;
	heroVideoVimeoId;
	heroVideoActive;
	secondImagePath;
	thirdImagePath;
	/**
	* @deprecated Fourth image is not used anymore, but kept for now in case it is needed in the future
	*/
	fourthImagePath;
	isQuotaActive;
	isQuotaExpiring;
	quotaRelatedJobPositionNames;
	quotaEndDate;
	quotaBudget;
	quotaGuarantee;
	isUnsolicited;
	baLastAction;
	createdAt;
	updatedAt;
	constructor({ id, customerId, mondayItemId, name, fullName, specialization, university, externalApplicationUrl, isPreQualified, isCampaignActive, monthlyAdvertisingBudget, landingPageUrl, isCampaignExpiring, campaignEndDate, directApproaches, potential, campaignError, directApproachesError, isIndeedActive, indeedDeadline, indeedMonthlyBudget, isStepstoneActive, stepstoneDeadline, jobPortalError, isArchived, careerPageActive, repostedAt, searchAdStatus, campaignStatus, campaignRelatedJobPositionNames, campaignId, heroImagePath, heroVideoPath, heroVideoVimeoId, heroVideoActive, secondImagePath, thirdImagePath, fourthImagePath, isQuotaActive, isQuotaExpiring, quotaEndDate, quotaRelatedJobPositionNames, quotaBudget, quotaGuarantee, isUnsolicited, baLastAction, createdAt, updatedAt, ...jobPositionSettings }) {
		super(jobPositionSettings);
		this.id = id;
		this.customerId = customerId;
		this.mondayItemId = mondayItemId;
		this.name = name;
		this.fullName = fullName;
		this.specialization = specialization;
		this.university = university;
		this.externalApplicationUrl = externalApplicationUrl;
		this.isPreQualified = isPreQualified;
		this.isCampaignActive = isCampaignActive;
		this.monthlyAdvertisingBudget = monthlyAdvertisingBudget;
		this.landingPageUrl = landingPageUrl;
		this.isCampaignExpiring = isCampaignExpiring;
		this.campaignEndDate = campaignEndDate;
		this.directApproaches = directApproaches;
		this.potential = potential;
		this.campaignError = campaignError;
		this.directApproachesError = directApproachesError;
		this.isIndeedActive = isIndeedActive;
		this.indeedDeadline = indeedDeadline;
		this.indeedMonthlyBudget = indeedMonthlyBudget;
		this.isStepstoneActive = isStepstoneActive;
		this.stepstoneDeadline = stepstoneDeadline;
		this.jobPortalError = jobPortalError;
		this.isArchived = isArchived;
		this.careerPageActive = careerPageActive;
		this.repostedAt = repostedAt;
		this.searchAdStatus = searchAdStatus;
		this.campaignStatus = campaignStatus;
		this.campaignId = campaignId;
		this.campaignRelatedJobPositionNames = campaignRelatedJobPositionNames;
		this.heroImagePath = heroImagePath;
		this.heroVideoPath = heroVideoPath;
		this.heroVideoVimeoId = heroVideoVimeoId;
		this.heroVideoActive = heroVideoActive;
		this.secondImagePath = secondImagePath;
		this.thirdImagePath = thirdImagePath;
		this.fourthImagePath = fourthImagePath;
		this.isQuotaActive = isQuotaActive;
		this.isQuotaExpiring = isQuotaExpiring;
		this.quotaEndDate = quotaEndDate;
		this.quotaRelatedJobPositionNames = quotaRelatedJobPositionNames;
		this.quotaBudget = quotaBudget;
		this.quotaGuarantee = quotaGuarantee;
		this.isUnsolicited = isUnsolicited;
		this.baLastAction = baLastAction;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new JobPosition({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			mondayItemId: dbObject.monday_item_id,
			name: dbObject.name,
			fullName: dbObject.full_name,
			addressZipCode: dbObject.address_zip_code,
			addressCity: dbObject.address_city,
			weeklyHours: dbObject.weekly_hours,
			weeklyHoursMax: dbObject.weekly_hours_max,
			schedule: dbObject.schedule,
			startDate: dbObject.start_date,
			shiftWork: dbObject.shift_work,
			salary: dbObject.salary,
			salaryIsPublic: dbObject.salary_is_public,
			salutation: dbObject.salutation,
			searchArea: dbObject.search_area,
			searchCenter: dbObject.search_center,
			searchCenterCountry: dbObject.search_center_country,
			searchRadius: dbObject.search_radius,
			cvRequired: dbObject.cv_required,
			cvRequiredInForm: dbObject.cv_required_in_form,
			emailRecipients: dbObject.email_recipients,
			isPreQualified: dbObject.is_pre_qualified,
			type: dbObject.type,
			specialization: dbObject.specialization,
			university: dbObject.university,
			externalApplicationUrl: dbObject.external_application_url,
			fieldServiceAndHomeOffice: dbObject.field_service_and_home_office,
			otherManagerInfo: dbObject.other_manager_info,
			trainingDuration: dbObject.training_duration,
			isFlexibleInternshipPossible: dbObject.is_flexible_internship_possible,
			requirements: dbObject.requirements,
			additionalRequirements: dbObject.additional_requirements,
			tasks: dbObject.tasks,
			benefits: dbObject.benefits,
			contactPersonName: dbObject.contact_person_name,
			contactPersonPosition: dbObject.contact_person_position,
			contactPersonEmail: dbObject.contact_person_email,
			contactPersonSalutation: dbObject.contact_person_salutation,
			addressLink: dbObject.address_link,
			isCampaignActive: dbObject.is_campaign_active,
			monthlyAdvertisingBudget: dbObject.monthly_advertising_budget,
			landingPageUrl: dbObject.landing_page_url,
			isCampaignExpiring: dbObject.is_campaign_expiring,
			campaignEndDate: dbObject.campaign_end_date,
			directApproaches: dbObject.direct_approaches,
			potential: dbObject.potential,
			campaignError: dbObject.campaign_error,
			directApproachesError: dbObject.direct_approaches_error,
			isIndeedActive: dbObject.is_indeed_active,
			indeedDeadline: dbObject.indeed_deadline,
			indeedMonthlyBudget: dbObject.indeed_monthly_budget,
			isStepstoneActive: dbObject.is_stepstone_active,
			stepstoneDeadline: dbObject.stepstone_deadline,
			jobPortalError: dbObject.job_portal_error,
			isArchived: dbObject.is_archived,
			careerPageActive: dbObject.career_page_active,
			repostedAt: dbObject.reposted_at?.toISOString() ?? null,
			searchAdStatus: dbObject.search_ad_status,
			traineeFirstYearSalary: dbObject.trainee_first_year_salary,
			traineeSecondYearSalary: dbObject.trainee_second_year_salary,
			traineeThirdYearSalary: dbObject.trainee_third_year_salary,
			traineeFourthYearSalary: dbObject.trainee_fourth_year_salary,
			dualStudentSalary: dbObject.dual_student_salary,
			locationId: dbObject.location_id,
			workAreaId: dbObject.work_area_id,
			campaignStatus: dbObject.campaign_status,
			campaignRelatedJobPositionNames: dbObject.campaign_related_job_position_names,
			campaignId: dbObject.campaign_id,
			applicantNotesTemplate: dbObject.applicant_notes_template,
			heroImagePath: dbObject.hero_image_path,
			heroVideoPath: dbObject.hero_video_path,
			heroVideoVimeoId: dbObject.hero_video_vimeo_id,
			heroVideoActive: dbObject.hero_video_active,
			secondImagePath: dbObject.second_image_path,
			thirdImagePath: dbObject.third_image_path,
			fourthImagePath: dbObject.fourth_image_path,
			isQuotaActive: dbObject.is_quota_active,
			isQuotaExpiring: dbObject.is_quota_expiring,
			quotaEndDate: dbObject.quota_end_date,
			quotaRelatedJobPositionNames: dbObject.quota_related_job_position_names,
			quotaBudget: dbObject.quota_budget,
			quotaGuarantee: dbObject.quota_guarantee,
			isUnsolicited: dbObject.is_unsolicited,
			baLastAction: dbObject.ba_last_action,
			documentsRequiredForForwarding: dbObject.documents_required_for_forwarding,
			requiredDocumentsDescription: dbObject.required_documents_description,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/job-position/job-position-creation-dto.ts
var JobPositionCreationDto = class JobPositionCreationDto extends JobPositionSettings {
	customerId;
	mondayItemId;
	name;
	fullName;
	specialization;
	university;
	externalApplicationUrl;
	isPreQualified;
	isCampaignActive;
	monthlyAdvertisingBudget;
	landingPageUrl;
	isCampaignExpiring;
	campaignEndDate;
	directApproaches;
	potential;
	campaignError;
	directApproachesError;
	isIndeedActive;
	indeedDeadline;
	indeedMonthlyBudget;
	isStepstoneActive;
	stepstoneDeadline;
	jobPortalError;
	isArchived;
	careerPageActive;
	searchAdStatus;
	campaignStatus;
	isQuotaActive;
	isQuotaExpiring;
	quotaEndDate;
	heroVideoVimeoId;
	heroVideoActive;
	isUnsolicited;
	constructor({ customerId, mondayItemId, name, fullName, specialization, university, externalApplicationUrl, isPreQualified, isCampaignActive, monthlyAdvertisingBudget, landingPageUrl, isCampaignExpiring, campaignEndDate, directApproaches, potential, campaignError, directApproachesError, isIndeedActive, indeedDeadline, indeedMonthlyBudget, isStepstoneActive, stepstoneDeadline, jobPortalError, isArchived, careerPageActive, searchAdStatus, campaignStatus, isQuotaActive, isQuotaExpiring, quotaEndDate, heroVideoVimeoId, heroVideoActive, isUnsolicited, ...jobPositionSettings }) {
		super(jobPositionSettings);
		this.customerId = customerId;
		this.mondayItemId = mondayItemId;
		this.name = name;
		this.fullName = fullName;
		this.specialization = specialization;
		this.university = university;
		this.externalApplicationUrl = externalApplicationUrl;
		this.isPreQualified = isPreQualified;
		this.isCampaignActive = isCampaignActive;
		this.monthlyAdvertisingBudget = monthlyAdvertisingBudget;
		this.landingPageUrl = landingPageUrl;
		this.isCampaignExpiring = isCampaignExpiring;
		this.campaignEndDate = campaignEndDate;
		this.directApproaches = directApproaches;
		this.potential = potential;
		this.campaignError = campaignError;
		this.directApproachesError = directApproachesError;
		this.isIndeedActive = isIndeedActive;
		this.indeedDeadline = indeedDeadline;
		this.indeedMonthlyBudget = indeedMonthlyBudget;
		this.isStepstoneActive = isStepstoneActive;
		this.stepstoneDeadline = stepstoneDeadline;
		this.jobPortalError = jobPortalError;
		this.isArchived = isArchived;
		this.careerPageActive = careerPageActive;
		this.searchAdStatus = searchAdStatus;
		this.campaignStatus = campaignStatus;
		this.isQuotaActive = isQuotaActive;
		this.isQuotaExpiring = isQuotaExpiring;
		this.quotaEndDate = quotaEndDate;
		this.heroVideoVimeoId = heroVideoVimeoId;
		this.heroVideoActive = heroVideoActive;
		this.isUnsolicited = isUnsolicited;
	}
	static createFromJobPositionCreationData(data) {
		return new JobPositionCreationDto({
			customerId: data.customerId,
			mondayItemId: data.mondayItemId,
			name: data.name,
			fullName: data.fullName,
			addressZipCode: data.addressZipCode,
			addressCity: data.addressCity,
			weeklyHours: data.weeklyHours,
			weeklyHoursMax: data.weeklyHoursMax,
			schedule: data.schedule,
			startDate: data.startDate,
			shiftWork: data.shiftWork,
			salary: data.salary,
			salaryIsPublic: data.salaryIsPublic,
			/**
			* @deprecated Salutation not needed anymore, we use always "Du"
			*/
			salutation: data.salutation,
			searchArea: data.searchArea,
			searchCenter: data.searchCenter,
			searchCenterCountry: data.searchCenterCountry,
			searchRadius: data.searchRadius,
			cvRequired: data.cvRequired,
			cvRequiredInForm: data.cvRequiredInForm,
			emailRecipients: data.emailRecipients,
			type: data.type,
			specialization: data.specialization,
			university: data.university,
			externalApplicationUrl: data.externalApplicationUrl,
			/**
			* @deprecated merged into other_manager_info
			*/
			fieldServiceAndHomeOffice: data.fieldServiceAndHomeOffice,
			otherManagerInfo: data.otherManagerInfo,
			trainingDuration: data.trainingDuration,
			isFlexibleInternshipPossible: data.isFlexibleInternshipPossible,
			requirements: data.requirements,
			additionalRequirements: data.additionalRequirements,
			tasks: data.tasks,
			benefits: data.benefits,
			contactPersonName: data.contactPersonName,
			contactPersonPosition: data.contactPersonPosition,
			contactPersonEmail: data.contactPersonEmail,
			contactPersonSalutation: data.contactPersonSalutation,
			/**
			* @deprecated addressLink is not needed anymore, instead a reference to location is used
			*/
			addressLink: data.addressLink,
			isPreQualified: data.isPreQualified,
			isCampaignActive: data.isCampaignActive,
			monthlyAdvertisingBudget: data.monthlyAdvertisingBudget,
			landingPageUrl: data.landingPageUrl,
			isCampaignExpiring: data.isCampaignExpiring,
			campaignEndDate: data.campaignEndDate,
			directApproaches: data.directApproaches,
			potential: data.potential,
			campaignError: data.campaignError,
			directApproachesError: data.directApproachesError,
			isIndeedActive: data.isIndeedActive,
			indeedDeadline: data.indeedDeadline,
			indeedMonthlyBudget: data.indeedMonthlyBudget,
			isStepstoneActive: data.isStepstoneActive,
			stepstoneDeadline: data.stepstoneDeadline,
			jobPortalError: data.jobPortalError,
			isArchived: data.isArchived,
			careerPageActive: data.careerPageActive,
			searchAdStatus: data.searchAdStatus,
			traineeFirstYearSalary: data.traineeFirstYearSalary,
			traineeSecondYearSalary: data.traineeSecondYearSalary,
			traineeThirdYearSalary: data.traineeThirdYearSalary,
			traineeFourthYearSalary: data.traineeFourthYearSalary,
			dualStudentSalary: data.dualStudentSalary,
			locationId: data.locationId,
			workAreaId: data.workAreaId,
			campaignStatus: data.campaignStatus,
			applicantNotesTemplate: data.applicantNotesTemplate,
			isQuotaActive: data.isQuotaActive,
			isQuotaExpiring: data.isQuotaExpiring,
			quotaEndDate: data.quotaEndDate,
			heroVideoVimeoId: data.heroVideoVimeoId,
			heroVideoActive: data.heroVideoActive,
			isUnsolicited: data.isUnsolicited,
			documentsRequiredForForwarding: data.documentsRequiredForForwarding,
			requiredDocumentsDescription: data.requiredDocumentsDescription
		});
	}
	convertToDbObject() {
		return {
			customer_id: this.customerId,
			monday_item_id: this.mondayItemId,
			name: this.name,
			full_name: this.fullName,
			address_zip_code: this.addressZipCode,
			address_city: this.addressCity,
			weekly_hours: this.weeklyHours,
			weekly_hours_max: this.weeklyHoursMax,
			schedule: this.schedule,
			start_date: this.startDate,
			shift_work: this.shiftWork,
			salary: this.salary,
			salary_is_public: this.salaryIsPublic,
			salutation: this.salutation,
			search_area: this.searchArea,
			search_center: this.searchCenter,
			search_center_country: this.searchCenterCountry,
			search_radius: this.searchRadius,
			cv_required: this.cvRequired,
			cv_required_in_form: this.cvRequiredInForm,
			email_recipients: this.emailRecipients,
			type: this.type,
			specialization: this.specialization,
			university: this.university,
			external_application_url: this.externalApplicationUrl,
			field_service_and_home_office: this.fieldServiceAndHomeOffice,
			other_manager_info: this.otherManagerInfo,
			training_duration: this.trainingDuration,
			is_flexible_internship_possible: this.isFlexibleInternshipPossible,
			requirements: this.requirements,
			additional_requirements: this.additionalRequirements,
			tasks: this.tasks,
			benefits: this.benefits,
			contact_person_name: this.contactPersonName,
			contact_person_position: this.contactPersonPosition,
			contact_person_email: this.contactPersonEmail,
			contactPersonSalutation: this.contactPersonSalutation,
			address_link: this.addressLink,
			is_pre_qualified: this.isPreQualified,
			is_campaign_active: this.isCampaignActive,
			monthly_advertising_budget: this.monthlyAdvertisingBudget,
			landing_page_url: this.landingPageUrl,
			is_campaign_expiring: this.isCampaignExpiring,
			campaign_end_date: this.campaignEndDate,
			direct_approaches: this.directApproaches,
			potential: this.potential,
			campaign_error: this.campaignError,
			direct_approaches_error: this.directApproachesError,
			is_indeed_active: this.isIndeedActive,
			indeed_deadline: this.indeedDeadline,
			indeed_monthly_budget: this.indeedMonthlyBudget,
			is_stepstone_active: this.isStepstoneActive,
			stepstone_deadline: this.stepstoneDeadline,
			job_portal_error: this.jobPortalError,
			is_archived: this.isArchived,
			career_page_active: this.careerPageActive,
			search_ad_status: this.searchAdStatus,
			trainee_first_year_salary: this.traineeFirstYearSalary,
			trainee_second_year_salary: this.traineeSecondYearSalary,
			trainee_third_year_salary: this.traineeThirdYearSalary,
			trainee_fourth_year_salary: this.traineeFourthYearSalary,
			dual_student_salary: this.dualStudentSalary,
			location_id: this.locationId,
			work_area_id: this.workAreaId,
			campaign_status: this.campaignStatus,
			applicant_notes_template: this.applicantNotesTemplate,
			is_quota_active: this.isQuotaActive,
			is_quota_expiring: this.isQuotaExpiring,
			quota_end_date: this.quotaEndDate,
			hero_video_vimeo_id: this.heroVideoVimeoId,
			hero_video_active: this.heroVideoActive,
			is_unsolicited: this.isUnsolicited,
			documents_required_for_forwarding: this.documentsRequiredForForwarding,
			required_documents_description: this.requiredDocumentsDescription
		};
	}
};
// source/models/job-position/job-position-dto.ts
var JobPositionDto = class JobPositionDto extends JobPositionSettings {
	id;
	customerId;
	mondayItemId;
	name;
	fullName;
	specialization;
	university;
	externalApplicationUrl;
	isPreQualified;
	isCampaignActive;
	monthlyAdvertisingBudget;
	landingPageUrl;
	isCampaignExpiring;
	campaignEndDate;
	directApproaches;
	potential;
	campaignError;
	directApproachesError;
	isIndeedActive;
	indeedDeadline;
	indeedMonthlyBudget;
	isStepstoneActive;
	stepstoneDeadline;
	jobPortalError;
	isArchived;
	careerPageActive;
	repostedAt;
	searchAdStatus;
	campaignStatus;
	campaignId;
	campaignRelatedJobPositionNames;
	heroImagePath;
	heroVideoPath;
	heroVideoVimeoId;
	heroVideoActive;
	secondImagePath;
	thirdImagePath;
	/**
	* @deprecated Fourth image is not used anymore, but kept for now in case it is needed in the future
	*/
	fourthImagePath;
	isQuotaActive;
	isQuotaExpiring;
	quotaEndDate;
	quotaRelatedJobPositionNames;
	quotaBudget;
	quotaGuarantee;
	isUnsolicited;
	baLastAction;
	createdAt;
	updatedAt;
	constructor({ id, customerId, mondayItemId, name, fullName, specialization, university, externalApplicationUrl, isPreQualified, isCampaignActive, monthlyAdvertisingBudget, landingPageUrl, isCampaignExpiring, campaignEndDate, directApproaches, potential, campaignError, directApproachesError, isIndeedActive, indeedDeadline, indeedMonthlyBudget, isStepstoneActive, stepstoneDeadline, jobPortalError, isArchived, careerPageActive, repostedAt, searchAdStatus, campaignStatus, campaignId, campaignRelatedJobPositionNames, heroImagePath, heroVideoPath, heroVideoVimeoId, heroVideoActive, secondImagePath, thirdImagePath, fourthImagePath, isQuotaActive, isQuotaExpiring, quotaEndDate, quotaRelatedJobPositionNames, quotaBudget, quotaGuarantee, isUnsolicited, baLastAction, createdAt, updatedAt, ...jobPositionSettings }) {
		super(jobPositionSettings);
		this.id = id;
		this.customerId = customerId;
		this.mondayItemId = mondayItemId;
		this.name = name;
		this.fullName = fullName;
		this.specialization = specialization;
		this.university = university;
		this.externalApplicationUrl = externalApplicationUrl;
		this.isPreQualified = isPreQualified;
		this.isCampaignActive = isCampaignActive;
		this.monthlyAdvertisingBudget = monthlyAdvertisingBudget;
		this.landingPageUrl = landingPageUrl;
		this.isCampaignExpiring = isCampaignExpiring;
		this.campaignEndDate = campaignEndDate;
		this.directApproaches = directApproaches;
		this.potential = potential;
		this.campaignError = campaignError;
		this.directApproachesError = directApproachesError;
		this.isIndeedActive = isIndeedActive;
		this.indeedDeadline = indeedDeadline;
		this.indeedMonthlyBudget = indeedMonthlyBudget;
		this.isStepstoneActive = isStepstoneActive;
		this.stepstoneDeadline = stepstoneDeadline;
		this.jobPortalError = jobPortalError;
		this.isArchived = isArchived;
		this.careerPageActive = careerPageActive;
		this.repostedAt = repostedAt;
		this.searchAdStatus = searchAdStatus;
		this.campaignStatus = campaignStatus;
		this.campaignId = campaignId;
		this.campaignRelatedJobPositionNames = campaignRelatedJobPositionNames;
		this.heroImagePath = heroImagePath;
		this.heroVideoPath = heroVideoPath;
		this.heroVideoVimeoId = heroVideoVimeoId;
		this.heroVideoActive = heroVideoActive;
		this.secondImagePath = secondImagePath;
		this.thirdImagePath = thirdImagePath;
		this.fourthImagePath = fourthImagePath;
		this.isQuotaActive = isQuotaActive;
		this.isQuotaExpiring = isQuotaExpiring;
		this.quotaEndDate = quotaEndDate;
		this.quotaRelatedJobPositionNames = quotaRelatedJobPositionNames;
		this.quotaBudget = quotaBudget;
		this.quotaGuarantee = quotaGuarantee;
		this.isUnsolicited = isUnsolicited, this.createdAt = createdAt;
		this.baLastAction = baLastAction;
		this.updatedAt = updatedAt;
	}
	toJobPosition() {
		return new JobPosition({
			id: this.id,
			customerId: this.customerId,
			mondayItemId: this.mondayItemId,
			name: this.name,
			fullName: this.fullName,
			addressZipCode: this.addressZipCode,
			addressCity: this.addressCity,
			weeklyHours: this.weeklyHours,
			weeklyHoursMax: this.weeklyHoursMax,
			schedule: this.schedule,
			startDate: this.startDate,
			shiftWork: this.shiftWork,
			salary: this.salary,
			salaryIsPublic: this.salaryIsPublic,
			salutation: this.salutation,
			searchArea: this.searchArea,
			searchCenter: this.searchCenter,
			searchCenterCountry: this.searchCenterCountry,
			searchRadius: this.searchRadius,
			cvRequired: this.cvRequired,
			cvRequiredInForm: this.cvRequiredInForm,
			emailRecipients: this.emailRecipients,
			isPreQualified: this.isPreQualified,
			type: this.type,
			specialization: this.specialization,
			university: this.university,
			externalApplicationUrl: this.externalApplicationUrl,
			fieldServiceAndHomeOffice: this.fieldServiceAndHomeOffice,
			otherManagerInfo: this.otherManagerInfo,
			trainingDuration: this.trainingDuration,
			isFlexibleInternshipPossible: this.isFlexibleInternshipPossible,
			requirements: this.requirements,
			additionalRequirements: this.additionalRequirements,
			tasks: this.tasks,
			benefits: this.benefits,
			contactPersonName: this.contactPersonName,
			contactPersonPosition: this.contactPersonPosition,
			contactPersonEmail: this.contactPersonEmail,
			contactPersonSalutation: this.contactPersonSalutation,
			/**
			* @deprecated address_link is not needed anymore, instead a reference to location is used
			*/
			addressLink: this.addressLink,
			isCampaignActive: this.isCampaignActive,
			monthlyAdvertisingBudget: this.monthlyAdvertisingBudget,
			landingPageUrl: this.landingPageUrl,
			isCampaignExpiring: this.isCampaignExpiring,
			campaignEndDate: this.campaignEndDate,
			directApproaches: this.directApproaches,
			potential: this.potential,
			campaignError: this.campaignError,
			directApproachesError: this.directApproachesError,
			isIndeedActive: this.isIndeedActive,
			indeedDeadline: this.indeedDeadline,
			indeedMonthlyBudget: this.indeedMonthlyBudget,
			isStepstoneActive: this.isStepstoneActive,
			stepstoneDeadline: this.stepstoneDeadline,
			jobPortalError: this.jobPortalError,
			isArchived: this.isArchived,
			careerPageActive: this.careerPageActive,
			searchAdStatus: this.searchAdStatus,
			traineeFirstYearSalary: this.traineeFirstYearSalary,
			traineeSecondYearSalary: this.traineeSecondYearSalary,
			traineeThirdYearSalary: this.traineeThirdYearSalary,
			traineeFourthYearSalary: this.traineeFourthYearSalary,
			dualStudentSalary: this.dualStudentSalary,
			locationId: this.locationId,
			workAreaId: this.workAreaId,
			campaignStatus: this.campaignStatus,
			campaignId: this.campaignId,
			campaignRelatedJobPositionNames: this.campaignRelatedJobPositionNames,
			applicantNotesTemplate: this.applicantNotesTemplate,
			heroImagePath: this.heroImagePath,
			heroVideoPath: this.heroVideoPath,
			heroVideoVimeoId: this.heroVideoVimeoId,
			heroVideoActive: this.heroVideoActive,
			secondImagePath: this.secondImagePath,
			thirdImagePath: this.thirdImagePath,
			fourthImagePath: this.fourthImagePath,
			isQuotaActive: this.isQuotaActive,
			isQuotaExpiring: this.isQuotaExpiring,
			quotaEndDate: this.quotaEndDate,
			quotaRelatedJobPositionNames: this.quotaRelatedJobPositionNames,
			quotaBudget: this.quotaBudget,
			quotaGuarantee: this.quotaGuarantee,
			isUnsolicited: this.isUnsolicited,
			baLastAction: this.baLastAction,
			documentsRequiredForForwarding: this.documentsRequiredForForwarding,
			requiredDocumentsDescription: this.requiredDocumentsDescription,
			repostedAt: this.repostedAt,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromJobPosition(jobPosition) {
		return new JobPositionDto({
			id: jobPosition.id,
			customerId: jobPosition.customerId,
			mondayItemId: jobPosition.mondayItemId,
			name: jobPosition.name,
			fullName: jobPosition.fullName,
			addressZipCode: jobPosition.addressZipCode,
			addressCity: jobPosition.addressCity,
			weeklyHours: jobPosition.weeklyHours,
			weeklyHoursMax: jobPosition.weeklyHoursMax,
			schedule: jobPosition.schedule,
			startDate: jobPosition.startDate,
			shiftWork: jobPosition.shiftWork,
			salary: jobPosition.salary,
			salaryIsPublic: jobPosition.salaryIsPublic,
			salutation: jobPosition.salutation,
			searchArea: jobPosition.searchArea,
			searchCenter: jobPosition.searchCenter,
			searchCenterCountry: jobPosition.searchCenterCountry,
			searchRadius: jobPosition.searchRadius,
			cvRequired: jobPosition.cvRequired,
			cvRequiredInForm: jobPosition.cvRequiredInForm,
			emailRecipients: jobPosition.emailRecipients,
			isPreQualified: jobPosition.isPreQualified,
			type: jobPosition.type,
			specialization: jobPosition.specialization,
			university: jobPosition.university,
			externalApplicationUrl: jobPosition.externalApplicationUrl,
			fieldServiceAndHomeOffice: jobPosition.fieldServiceAndHomeOffice,
			otherManagerInfo: jobPosition.otherManagerInfo,
			trainingDuration: jobPosition.trainingDuration,
			isFlexibleInternshipPossible: jobPosition.isFlexibleInternshipPossible,
			requirements: jobPosition.requirements,
			additionalRequirements: jobPosition.additionalRequirements,
			tasks: jobPosition.tasks,
			benefits: jobPosition.benefits,
			contactPersonName: jobPosition.contactPersonName,
			contactPersonPosition: jobPosition.contactPersonPosition,
			contactPersonEmail: jobPosition.contactPersonEmail,
			contactPersonSalutation: jobPosition.contactPersonSalutation,
			addressLink: jobPosition.addressLink,
			isCampaignActive: jobPosition.isCampaignActive,
			monthlyAdvertisingBudget: jobPosition.monthlyAdvertisingBudget,
			landingPageUrl: jobPosition.landingPageUrl,
			isCampaignExpiring: jobPosition.isCampaignExpiring,
			campaignEndDate: jobPosition.campaignEndDate,
			directApproaches: jobPosition.directApproaches,
			potential: jobPosition.potential,
			campaignError: jobPosition.campaignError,
			directApproachesError: jobPosition.directApproachesError,
			isIndeedActive: jobPosition.isIndeedActive,
			indeedDeadline: jobPosition.indeedDeadline,
			indeedMonthlyBudget: jobPosition.indeedMonthlyBudget,
			isStepstoneActive: jobPosition.isStepstoneActive,
			stepstoneDeadline: jobPosition.stepstoneDeadline,
			jobPortalError: jobPosition.jobPortalError,
			isArchived: jobPosition.isArchived,
			careerPageActive: jobPosition.careerPageActive,
			searchAdStatus: jobPosition.searchAdStatus,
			traineeFirstYearSalary: jobPosition.traineeFirstYearSalary,
			traineeSecondYearSalary: jobPosition.traineeSecondYearSalary,
			traineeThirdYearSalary: jobPosition.traineeThirdYearSalary,
			traineeFourthYearSalary: jobPosition.traineeFourthYearSalary,
			dualStudentSalary: jobPosition.dualStudentSalary,
			locationId: jobPosition.locationId,
			workAreaId: jobPosition.workAreaId,
			campaignStatus: jobPosition.campaignStatus,
			campaignId: jobPosition.campaignId,
			campaignRelatedJobPositionNames: jobPosition.campaignRelatedJobPositionNames,
			applicantNotesTemplate: jobPosition.applicantNotesTemplate,
			heroImagePath: jobPosition.heroImagePath,
			heroVideoPath: jobPosition.heroVideoPath,
			heroVideoVimeoId: jobPosition.heroVideoVimeoId,
			heroVideoActive: jobPosition.heroVideoActive,
			secondImagePath: jobPosition.secondImagePath,
			thirdImagePath: jobPosition.thirdImagePath,
			fourthImagePath: jobPosition.fourthImagePath,
			isQuotaActive: jobPosition.isQuotaActive,
			isQuotaExpiring: jobPosition.isQuotaExpiring,
			quotaEndDate: jobPosition.quotaEndDate,
			quotaRelatedJobPositionNames: jobPosition.quotaRelatedJobPositionNames,
			quotaBudget: jobPosition.quotaBudget,
			quotaGuarantee: jobPosition.quotaGuarantee,
			isUnsolicited: jobPosition.isUnsolicited,
			baLastAction: jobPosition.baLastAction,
			documentsRequiredForForwarding: jobPosition.documentsRequiredForForwarding,
			requiredDocumentsDescription: jobPosition.requiredDocumentsDescription,
			repostedAt: jobPosition.repostedAt,
			createdAt: jobPosition.createdAt,
			updatedAt: jobPosition.updatedAt
		});
	}
	static createFromJobPositionData(data) {
		return new JobPositionDto({
			id: data.id,
			customerId: data.customerId,
			mondayItemId: data.mondayItemId,
			name: data.name,
			fullName: data.fullName,
			addressZipCode: data.addressZipCode,
			addressCity: data.addressCity,
			weeklyHours: data.weeklyHours,
			weeklyHoursMax: data.weeklyHoursMax,
			schedule: data.schedule,
			startDate: data.startDate,
			shiftWork: data.shiftWork,
			salary: data.salary,
			salaryIsPublic: data.salaryIsPublic,
			salutation: data.salutation,
			searchArea: data.searchArea,
			searchCenter: data.searchCenter,
			searchCenterCountry: data.searchCenterCountry,
			searchRadius: data.searchRadius,
			cvRequired: data.cvRequired,
			cvRequiredInForm: data.cvRequiredInForm,
			emailRecipients: data.emailRecipients,
			isPreQualified: data.isPreQualified,
			type: data.type,
			specialization: data.specialization,
			university: data.university,
			externalApplicationUrl: data.externalApplicationUrl,
			fieldServiceAndHomeOffice: data.fieldServiceAndHomeOffice,
			otherManagerInfo: data.otherManagerInfo,
			trainingDuration: data.trainingDuration,
			isFlexibleInternshipPossible: data.isFlexibleInternshipPossible,
			requirements: data.requirements,
			additionalRequirements: data.additionalRequirements,
			tasks: data.tasks,
			benefits: data.benefits,
			contactPersonName: data.contactPersonName,
			contactPersonPosition: data.contactPersonPosition,
			contactPersonEmail: data.contactPersonEmail,
			contactPersonSalutation: data.contactPersonSalutation,
			addressLink: data.addressLink,
			isCampaignActive: data.isCampaignActive,
			monthlyAdvertisingBudget: data.monthlyAdvertisingBudget,
			landingPageUrl: data.landingPageUrl,
			isCampaignExpiring: data.isCampaignExpiring,
			campaignEndDate: data.campaignEndDate,
			directApproaches: data.directApproaches,
			potential: data.potential,
			campaignError: data.campaignError,
			directApproachesError: data.directApproachesError,
			isIndeedActive: data.isIndeedActive,
			indeedDeadline: data.indeedDeadline,
			indeedMonthlyBudget: data.indeedMonthlyBudget,
			isStepstoneActive: data.isStepstoneActive,
			stepstoneDeadline: data.stepstoneDeadline,
			jobPortalError: data.jobPortalError,
			isArchived: data.isArchived,
			careerPageActive: data.careerPageActive,
			searchAdStatus: data.searchAdStatus,
			traineeFirstYearSalary: data.traineeFirstYearSalary,
			traineeSecondYearSalary: data.traineeSecondYearSalary,
			traineeThirdYearSalary: data.traineeThirdYearSalary,
			traineeFourthYearSalary: data.traineeFourthYearSalary,
			dualStudentSalary: data.dualStudentSalary,
			locationId: data.locationId,
			workAreaId: data.workAreaId,
			campaignStatus: data.campaignStatus,
			campaignRelatedJobPositionNames: data.campaignRelatedJobPositionNames,
			campaignId: data.campaignId,
			applicantNotesTemplate: data.applicantNotesTemplate,
			heroImagePath: data.heroImagePath,
			heroVideoPath: data.heroVideoPath,
			heroVideoVimeoId: data.heroVideoVimeoId,
			heroVideoActive: data.heroVideoActive,
			secondImagePath: data.secondImagePath,
			thirdImagePath: data.thirdImagePath,
			fourthImagePath: data.fourthImagePath,
			isQuotaActive: data.isQuotaActive,
			isQuotaExpiring: data.isQuotaExpiring,
			quotaEndDate: data.quotaEndDate,
			quotaRelatedJobPositionNames: data.quotaRelatedJobPositionNames,
			quotaBudget: data.quotaBudget,
			quotaGuarantee: data.quotaGuarantee,
			isUnsolicited: data.isUnsolicited,
			baLastAction: data.baLastAction,
			documentsRequiredForForwarding: data.documentsRequiredForForwarding,
			requiredDocumentsDescription: data.requiredDocumentsDescription,
			repostedAt: data.repostedAt,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new JobPositionDto({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			mondayItemId: dbObject.monday_item_id,
			name: dbObject.name,
			fullName: dbObject.full_name,
			addressZipCode: dbObject.address_zip_code,
			addressCity: dbObject.address_city,
			weeklyHours: dbObject.weekly_hours,
			weeklyHoursMax: dbObject.weekly_hours_max,
			schedule: dbObject.schedule,
			startDate: dbObject.start_date,
			shiftWork: dbObject.shift_work,
			salary: dbObject.salary,
			salaryIsPublic: dbObject.salary_is_public,
			salutation: dbObject.salutation,
			searchArea: dbObject.search_area,
			searchCenter: dbObject.search_center,
			searchCenterCountry: dbObject.search_center_country,
			searchRadius: dbObject.search_radius,
			cvRequired: dbObject.cv_required,
			cvRequiredInForm: dbObject.cv_required_in_form,
			emailRecipients: dbObject.email_recipients,
			isPreQualified: dbObject.is_pre_qualified,
			type: dbObject.type,
			specialization: dbObject.specialization,
			university: dbObject.university,
			externalApplicationUrl: dbObject.external_application_url,
			fieldServiceAndHomeOffice: dbObject.field_service_and_home_office,
			otherManagerInfo: dbObject.other_manager_info,
			trainingDuration: dbObject.training_duration,
			isFlexibleInternshipPossible: dbObject.is_flexible_internship_possible,
			requirements: dbObject.requirements,
			additionalRequirements: dbObject.additional_requirements,
			tasks: dbObject.tasks,
			benefits: dbObject.benefits,
			contactPersonName: dbObject.contact_person_name,
			contactPersonPosition: dbObject.contact_person_position,
			contactPersonEmail: dbObject.contact_person_email,
			contactPersonSalutation: dbObject.contact_person_salutation,
			addressLink: dbObject.address_link,
			isCampaignActive: dbObject.is_campaign_active,
			monthlyAdvertisingBudget: dbObject.monthly_advertising_budget,
			landingPageUrl: dbObject.landing_page_url,
			isCampaignExpiring: dbObject.is_campaign_expiring,
			campaignEndDate: dbObject.campaign_end_date,
			directApproaches: dbObject.direct_approaches,
			potential: dbObject.potential,
			campaignError: dbObject.campaign_error,
			directApproachesError: dbObject.direct_approaches_error,
			isIndeedActive: dbObject.is_indeed_active,
			indeedDeadline: dbObject.indeed_deadline,
			indeedMonthlyBudget: dbObject.indeed_monthly_budget,
			isStepstoneActive: dbObject.is_stepstone_active,
			stepstoneDeadline: dbObject.stepstone_deadline,
			jobPortalError: dbObject.job_portal_error,
			isArchived: dbObject.is_archived,
			careerPageActive: dbObject.career_page_active,
			searchAdStatus: dbObject.search_ad_status,
			traineeFirstYearSalary: dbObject.trainee_first_year_salary,
			traineeSecondYearSalary: dbObject.trainee_second_year_salary,
			traineeThirdYearSalary: dbObject.trainee_third_year_salary,
			traineeFourthYearSalary: dbObject.trainee_fourth_year_salary,
			dualStudentSalary: dbObject.dual_student_salary,
			locationId: dbObject.location,
			workAreaId: dbObject.work_area_id,
			campaignStatus: dbObject.campaign_status,
			campaignId: dbObject.campaign_id,
			campaignRelatedJobPositionNames: dbObject.campaign_related_job_position_names,
			applicantNotesTemplate: dbObject.applicant_notes_template,
			heroImagePath: dbObject.hero_image_path,
			heroVideoPath: dbObject.hero_video_path,
			heroVideoVimeoId: dbObject.hero_video_vimeo_id,
			heroVideoActive: dbObject.hero_video_active,
			secondImagePath: dbObject.second_image_path,
			thirdImagePath: dbObject.third_image_path,
			fourthImagePath: dbObject.fourth_image_path,
			isQuotaActive: dbObject.is_quota_active,
			isQuotaExpiring: dbObject.is_quota_expiring,
			quotaEndDate: dbObject.quota_end_date,
			quotaRelatedJobPositionNames: dbObject.quota_related_job_position_names,
			quotaBudget: dbObject.quota_budget,
			quotaGuarantee: dbObject.quota_guarantee,
			isUnsolicited: dbObject.is_unsolicited,
			documentsRequiredForForwarding: dbObject.documents_required_for_forwarding,
			requiredDocumentsDescription: dbObject.required_documents_description,
			baLastAction: dbObject.ba_last_action,
			repostedAt: dbObject.reposted_at?.toISOString() ?? null,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/job-position/job-position-info.ts
var JobPositionInfo = class JobPositionInfo {
	id;
	customerId;
	name;
	type;
	fullName;
	applicantCount;
	city;
	locationName;
	createdAt;
	updatedAt;
	constructor({ id, customerId, name, type, fullName, applicantCount, city, locationName, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.name = name;
		this.type = type;
		this.fullName = fullName;
		this.applicantCount = applicantCount;
		this.city = city;
		this.locationName = locationName;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new JobPositionInfo({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			name: dbObject.name,
			type: dbObject.type,
			fullName: dbObject.full_name,
			applicantCount: dbObject.applicant_count,
			city: dbObject.city,
			locationName: dbObject.location_name,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/job-position/job-position-info-dto.ts
var JobPositionInfoDto = class JobPositionInfoDto {
	id;
	customerId;
	name;
	type;
	fullName;
	applicantCount;
	city;
	locationName;
	createdAt;
	updatedAt;
	constructor({ id, customerId, name, type, fullName, applicantCount, city, locationName, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.name = name;
		this.type = type;
		this.fullName = fullName;
		this.applicantCount = applicantCount;
		this.city = city;
		this.locationName = locationName;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toJobPositionInfo() {
		return new JobPositionInfo({
			id: this.id,
			customerId: this.customerId,
			name: this.name,
			type: this.type,
			fullName: this.fullName,
			applicantCount: this.applicantCount,
			city: this.city,
			locationName: this.locationName,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromJobPositionInfo(jobPositionInfo) {
		return new JobPositionInfoDto({
			id: jobPositionInfo.id,
			customerId: jobPositionInfo.customerId,
			name: jobPositionInfo.name,
			type: jobPositionInfo.type,
			fullName: jobPositionInfo.fullName,
			applicantCount: jobPositionInfo.applicantCount,
			city: jobPositionInfo.city,
			locationName: jobPositionInfo.locationName,
			createdAt: jobPositionInfo.createdAt,
			updatedAt: jobPositionInfo.updatedAt
		});
	}
	static createFromJobPositionInfoData(data) {
		return new JobPositionInfoDto({
			id: data.id,
			customerId: data.customerId,
			name: data.name,
			type: data.type,
			fullName: data.fullName,
			applicantCount: data.applicantCount,
			city: data.city,
			locationName: data.locationName,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new JobPositionInfoDto({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			name: dbObject.name,
			type: dbObject.type,
			fullName: dbObject.full_name,
			applicantCount: dbObject.applicant_count,
			city: dbObject.city,
			locationName: dbObject.location_name,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/job-position/job-position-update-dto.ts
var JobPositionUpdateDto = class JobPositionUpdateDto extends JobPositionSettings {
	name;
	fullName;
	specialization;
	university;
	externalApplicationUrl;
	isPreQualified;
	isCampaignActive;
	monthlyAdvertisingBudget;
	landingPageUrl;
	isCampaignExpiring;
	campaignEndDate;
	directApproaches;
	potential;
	campaignError;
	directApproachesError;
	isIndeedActive;
	indeedDeadline;
	indeedMonthlyBudget;
	isStepstoneActive;
	stepstoneDeadline;
	jobPortalError;
	isArchived;
	careerPageActive;
	searchAdStatus;
	campaignStatus;
	campaignId;
	campaignRelatedJobPositionNames;
	isQuotaActive;
	isQuotaExpiring;
	quotaEndDate;
	quotaRelatedJobPositionNames;
	quotaBudget;
	quotaGuarantee;
	heroVideoVimeoId;
	heroVideoActive;
	constructor({ name, fullName, specialization, university, externalApplicationUrl, isPreQualified, isCampaignActive, monthlyAdvertisingBudget, landingPageUrl, isCampaignExpiring, campaignEndDate, directApproaches, potential, campaignError, directApproachesError, isIndeedActive, indeedDeadline, indeedMonthlyBudget, isStepstoneActive, stepstoneDeadline, jobPortalError, isArchived, careerPageActive, searchAdStatus, campaignStatus, campaignRelatedJobPositionNames, campaignId, isQuotaActive, isQuotaExpiring, quotaEndDate, quotaRelatedJobPositionNames, quotaBudget, quotaGuarantee, heroVideoVimeoId, heroVideoActive, ...jobPositionSettings }) {
		super(jobPositionSettings);
		this.name = name;
		this.fullName = fullName;
		this.specialization = specialization;
		this.university = university;
		this.externalApplicationUrl = externalApplicationUrl;
		this.isPreQualified = isPreQualified;
		this.isCampaignActive = isCampaignActive;
		this.monthlyAdvertisingBudget = monthlyAdvertisingBudget;
		this.landingPageUrl = landingPageUrl;
		this.isCampaignExpiring = isCampaignExpiring;
		this.campaignEndDate = campaignEndDate;
		this.directApproaches = directApproaches;
		this.potential = potential;
		this.campaignError = campaignError;
		this.directApproachesError = directApproachesError;
		this.isIndeedActive = isIndeedActive;
		this.indeedDeadline = indeedDeadline;
		this.indeedMonthlyBudget = indeedMonthlyBudget;
		this.isStepstoneActive = isStepstoneActive;
		this.stepstoneDeadline = stepstoneDeadline;
		this.jobPortalError = jobPortalError;
		this.isArchived = isArchived;
		this.careerPageActive = careerPageActive;
		this.searchAdStatus = searchAdStatus;
		this.campaignStatus = campaignStatus;
		this.campaignRelatedJobPositionNames = campaignRelatedJobPositionNames;
		this.campaignId = campaignId;
		this.isQuotaActive = isQuotaActive;
		this.isQuotaExpiring = isQuotaExpiring;
		this.quotaEndDate = quotaEndDate;
		this.quotaRelatedJobPositionNames = quotaRelatedJobPositionNames;
		this.quotaBudget = quotaBudget;
		this.quotaGuarantee = quotaGuarantee;
		this.heroVideoVimeoId = heroVideoVimeoId;
		this.heroVideoActive = heroVideoActive;
	}
	static createFromJobPositionUpdateData(data) {
		return new JobPositionUpdateDto({
			name: data.name,
			fullName: data.fullName,
			addressZipCode: data.addressZipCode,
			addressCity: data.addressCity,
			weeklyHours: data.weeklyHours,
			weeklyHoursMax: data.weeklyHoursMax,
			schedule: data.schedule,
			startDate: data.startDate,
			shiftWork: data.shiftWork,
			salary: data.salary,
			salaryIsPublic: data.salaryIsPublic,
			salutation: data.salutation,
			searchArea: data.searchArea,
			searchCenter: data.searchCenter,
			searchCenterCountry: data.searchCenterCountry,
			searchRadius: data.searchRadius,
			cvRequired: data.cvRequired,
			cvRequiredInForm: data.cvRequiredInForm,
			emailRecipients: data.emailRecipients,
			type: data.type,
			specialization: data.specialization,
			university: data.university,
			externalApplicationUrl: data.externalApplicationUrl,
			fieldServiceAndHomeOffice: data.fieldServiceAndHomeOffice,
			otherManagerInfo: data.otherManagerInfo,
			trainingDuration: data.trainingDuration,
			isFlexibleInternshipPossible: data.isFlexibleInternshipPossible,
			requirements: data.requirements,
			additionalRequirements: data.additionalRequirements,
			tasks: data.tasks,
			benefits: data.benefits,
			contactPersonName: data.contactPersonName,
			contactPersonPosition: data.contactPersonPosition,
			contactPersonEmail: data.contactPersonEmail,
			contactPersonSalutation: data.contactPersonSalutation,
			addressLink: data.addressLink,
			isPreQualified: data.isPreQualified,
			isCampaignActive: data.isCampaignActive,
			monthlyAdvertisingBudget: data.monthlyAdvertisingBudget,
			landingPageUrl: data.landingPageUrl,
			isCampaignExpiring: data.isCampaignExpiring,
			campaignEndDate: data.campaignEndDate,
			directApproaches: data.directApproaches,
			potential: data.potential,
			campaignError: data.campaignError,
			directApproachesError: data.directApproachesError,
			isIndeedActive: data.isIndeedActive,
			indeedDeadline: data.indeedDeadline,
			indeedMonthlyBudget: data.indeedMonthlyBudget,
			isStepstoneActive: data.isStepstoneActive,
			stepstoneDeadline: data.stepstoneDeadline,
			jobPortalError: data.jobPortalError,
			isArchived: data.isArchived,
			careerPageActive: data.careerPageActive,
			searchAdStatus: data.searchAdStatus,
			traineeFirstYearSalary: data.traineeFirstYearSalary,
			traineeSecondYearSalary: data.traineeSecondYearSalary,
			traineeThirdYearSalary: data.traineeThirdYearSalary,
			traineeFourthYearSalary: data.traineeFourthYearSalary,
			dualStudentSalary: data.dualStudentSalary,
			locationId: data.locationId,
			workAreaId: data.workAreaId,
			campaignStatus: data.campaignStatus,
			campaignRelatedJobPositionNames: data.campaignRelatedJobPositionNames,
			campaignId: data.campaignId,
			applicantNotesTemplate: data.applicantNotesTemplate,
			isQuotaActive: data.isQuotaActive,
			isQuotaExpiring: data.isQuotaExpiring,
			quotaEndDate: data.quotaEndDate,
			quotaRelatedJobPositionNames: data.quotaRelatedJobPositionNames,
			quotaBudget: data.quotaBudget,
			quotaGuarantee: data.quotaGuarantee,
			heroVideoVimeoId: data.heroVideoVimeoId,
			heroVideoActive: data.heroVideoActive,
			documentsRequiredForForwarding: data.documentsRequiredForForwarding,
			requiredDocumentsDescription: data.requiredDocumentsDescription
		});
	}
	convertToDbObject() {
		return {
			name: this.name,
			full_name: this.fullName,
			address_zip_code: this.addressZipCode,
			address_city: this.addressCity,
			weekly_hours: this.weeklyHours,
			weekly_hours_max: this.weeklyHoursMax,
			schedule: this.schedule,
			start_date: this.startDate,
			shift_work: this.shiftWork,
			salary: this.salary,
			salary_is_public: this.salaryIsPublic,
			salutation: this.salutation,
			search_area: this.searchArea,
			search_center: this.searchCenter,
			search_center_country: this.searchCenterCountry,
			search_radius: this.searchRadius,
			cv_required: this.cvRequired,
			cv_required_in_form: this.cvRequiredInForm,
			email_recipients: this.emailRecipients,
			type: this.type,
			specialization: this.specialization,
			university: this.university,
			external_application_url: this.externalApplicationUrl,
			field_service_and_home_office: this.fieldServiceAndHomeOffice,
			other_manager_info: this.otherManagerInfo,
			training_duration: this.trainingDuration,
			is_flexible_internship_possible: this.isFlexibleInternshipPossible,
			requirements: this.requirements,
			additional_requirements: this.additionalRequirements,
			tasks: this.tasks,
			benefits: this.benefits,
			contact_person_name: this.contactPersonName,
			contact_person_position: this.contactPersonPosition,
			contact_person_email: this.contactPersonEmail,
			contact_person_salutation: this.contactPersonSalutation,
			address_link: this.addressLink,
			is_pre_qualified: this.isPreQualified,
			is_campaign_active: this.isCampaignActive,
			monthly_advertising_budget: this.monthlyAdvertisingBudget,
			landing_page_url: this.landingPageUrl,
			is_campaign_expiring: this.isCampaignExpiring,
			campaign_end_date: this.campaignEndDate,
			direct_approaches: this.directApproaches,
			potential: this.potential,
			campaign_error: this.campaignError,
			direct_approaches_error: this.directApproachesError,
			is_indeed_active: this.isIndeedActive,
			indeed_deadline: this.indeedDeadline,
			indeed_monthly_budget: this.indeedMonthlyBudget,
			is_stepstone_active: this.isStepstoneActive,
			stepstone_deadline: this.stepstoneDeadline,
			job_portal_error: this.jobPortalError,
			is_archived: this.isArchived,
			career_page_active: this.careerPageActive,
			search_ad_status: this.searchAdStatus,
			trainee_first_year_salary: this.traineeFirstYearSalary,
			trainee_second_year_salary: this.traineeSecondYearSalary,
			trainee_third_year_salary: this.traineeThirdYearSalary,
			trainee_fourth_year_salary: this.traineeFourthYearSalary,
			dual_student_salary: this.dualStudentSalary,
			location_id: this.locationId,
			work_area_id: this.workAreaId,
			campaign_status: this.campaignStatus,
			campaign_related_job_position_names: this.campaignRelatedJobPositionNames,
			campaign_id: this.campaignId,
			applicant_notes_template: this.applicantNotesTemplate,
			is_quota_active: this.isQuotaActive,
			is_quota_expiring: this.isQuotaExpiring,
			quota_end_date: this.quotaEndDate,
			quota_related_job_position_names: this.quotaRelatedJobPositionNames,
			quota_budget: this.quotaBudget,
			quota_guarantee: this.quotaGuarantee,
			hero_video_vimeo_id: this.heroVideoVimeoId,
			hero_video_active: this.heroVideoActive,
			documents_required_for_forwarding: this.documentsRequiredForForwarding,
			required_documents_description: this.requiredDocumentsDescription
		};
	}
};
// source/models/job-position/job-position-public.ts
var JobPositionPublic = class JobPositionPublic {
	id;
	name;
	type;
	fullName;
	companyShortName;
	companyLongName;
	constructor({ id, name, type, fullName, companyShortName, companyLongName }) {
		this.id = id;
		this.name = name;
		this.type = type;
		this.fullName = fullName;
		this.companyShortName = companyShortName;
		this.companyLongName = companyLongName;
	}
	static createFromDbObject(dbObject) {
		return new JobPositionPublic({
			id: dbObject.id,
			name: dbObject.name,
			type: dbObject.type,
			fullName: dbObject.full_name,
			companyShortName: dbObject.company_short_name,
			companyLongName: dbObject.company_long_name
		});
	}
};
// source/models/job-position/job-position-public-dto.ts
var JobPositionPublicDto = class JobPositionPublicDto {
	id;
	name;
	type;
	fullName;
	companyShortName;
	companyLongName;
	constructor({ id, name, type, fullName, companyShortName, companyLongName }) {
		this.id = id;
		this.name = name;
		this.type = type;
		this.fullName = fullName;
		this.companyShortName = companyShortName;
		this.companyLongName = companyLongName;
	}
	toJobPositionPublic() {
		return new JobPositionPublic({
			id: this.id,
			name: this.name,
			type: this.type,
			fullName: this.fullName,
			companyShortName: this.companyShortName,
			companyLongName: this.companyLongName
		});
	}
	static createFromJobPositionPublic(jobPositionInfo) {
		return new JobPositionPublicDto({
			id: jobPositionInfo.id,
			name: jobPositionInfo.name,
			type: jobPositionInfo.type,
			fullName: jobPositionInfo.fullName,
			companyShortName: jobPositionInfo.companyShortName,
			companyLongName: jobPositionInfo.companyLongName
		});
	}
	static createFromData(data) {
		return new JobPositionPublicDto({
			id: data.id,
			name: data.name,
			type: data.type,
			fullName: data.fullName,
			companyShortName: data.companyShortName,
			companyLongName: data.companyLongName
		});
	}
	static createFromDbObject(dbObject) {
		return new JobPositionPublicDto({
			id: dbObject.id,
			name: dbObject.name,
			type: dbObject.type,
			fullName: dbObject.full_name,
			companyShortName: dbObject.company_short_name,
			companyLongName: dbObject.company_long_name
		});
	}
};
// source/models/location/location.ts
var Location = class Location {
	id;
	customerId;
	address;
	zipCode;
	city;
	country;
	googleMapsIsActive;
	isInUse;
	googleMapsTitle;
	googleMapsLatitude;
	googleMapsLongitude;
	name;
	createdAt;
	updatedAt;
	constructor({ id, customerId, address, zipCode, city, country, googleMapsIsActive, isInUse, googleMapsTitle, googleMapsLatitude, googleMapsLongitude, name, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.address = address;
		this.zipCode = zipCode;
		this.city = city;
		this.country = country;
		this.googleMapsIsActive = googleMapsIsActive;
		this.isInUse = isInUse;
		this.googleMapsTitle = googleMapsTitle;
		this.googleMapsLatitude = googleMapsLatitude;
		this.googleMapsLongitude = googleMapsLongitude;
		this.name = name;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new Location({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			address: dbObject.address,
			zipCode: dbObject.zip_code,
			city: dbObject.city,
			country: dbObject.country,
			googleMapsIsActive: dbObject.google_maps_is_active ?? true,
			isInUse: dbObject.is_in_use,
			googleMapsTitle: dbObject.google_maps_title,
			googleMapsLatitude: dbObject.google_maps_latitude ? Number(dbObject.google_maps_latitude) : null,
			googleMapsLongitude: dbObject.google_maps_longitude ? Number(dbObject.google_maps_longitude) : null,
			name: dbObject.name,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/location/location-creation-dto.ts
var LocationCreationDto = class LocationCreationDto {
	customerId;
	address;
	zipCode;
	city;
	country;
	googleMapsTitle;
	googleMapsLatitude;
	googleMapsLongitude;
	name;
	constructor({ customerId, address, zipCode, city, country, googleMapsTitle, googleMapsLatitude, googleMapsLongitude, name }) {
		this.customerId = customerId;
		this.address = address;
		this.zipCode = zipCode;
		this.city = city;
		this.country = country;
		this.googleMapsTitle = googleMapsTitle;
		this.googleMapsLatitude = googleMapsLatitude;
		this.googleMapsLongitude = googleMapsLongitude;
		this.name = name;
	}
	static createFromLocationCreationData(data) {
		return new LocationCreationDto({
			customerId: data.customerId,
			address: data.address,
			zipCode: data.zipCode,
			city: data.city,
			country: data.country,
			googleMapsTitle: data.googleMapsTitle,
			googleMapsLatitude: data.googleMapsLatitude,
			googleMapsLongitude: data.googleMapsLongitude,
			name: data.name
		});
	}
	convertToDbObject() {
		return {
			customer_id: this.customerId,
			address: this.address,
			zip_code: this.zipCode,
			city: this.city,
			country: this.country,
			google_maps_title: this.googleMapsTitle,
			google_maps_latitude: this.googleMapsLatitude?.toString(),
			google_maps_longitude: this.googleMapsLongitude?.toString(),
			name: this.name
		};
	}
};
// source/models/location/location-dto.ts
var LocationDto = class LocationDto {
	id;
	customerId;
	address;
	zipCode;
	city;
	country;
	googleMapsIsActive;
	isInUse;
	googleMapsTitle;
	googleMapsLatitude;
	googleMapsLongitude;
	name;
	createdAt;
	updatedAt;
	constructor({ id, customerId, address, zipCode, city, country, googleMapsIsActive, isInUse, googleMapsTitle, googleMapsLatitude, googleMapsLongitude, name, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.address = address;
		this.zipCode = zipCode;
		this.city = city;
		this.country = country;
		this.googleMapsIsActive = googleMapsIsActive;
		this.isInUse = isInUse;
		this.googleMapsTitle = googleMapsTitle;
		this.googleMapsLatitude = googleMapsLatitude;
		this.googleMapsLongitude = googleMapsLongitude;
		this.name = name;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toLocation() {
		return new Location({
			id: this.id,
			customerId: this.customerId,
			address: this.address,
			zipCode: this.zipCode,
			city: this.city,
			country: this.country,
			googleMapsIsActive: this.googleMapsIsActive,
			isInUse: this.isInUse,
			googleMapsTitle: this.googleMapsTitle,
			googleMapsLatitude: this.googleMapsLatitude,
			googleMapsLongitude: this.googleMapsLongitude,
			name: this.name,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromLocation(location) {
		return new LocationDto({
			id: location.id,
			customerId: location.customerId,
			address: location.address,
			zipCode: location.zipCode,
			city: location.city,
			country: location.country,
			googleMapsIsActive: location.googleMapsIsActive,
			isInUse: location.isInUse,
			googleMapsTitle: location.googleMapsTitle,
			googleMapsLatitude: location.googleMapsLatitude,
			googleMapsLongitude: location.googleMapsLongitude,
			name: location.name,
			createdAt: location.createdAt,
			updatedAt: location.updatedAt
		});
	}
	static createFromLocationData(data) {
		return new LocationDto({
			id: data.id,
			customerId: data.customerId,
			address: data.address,
			zipCode: data.zipCode,
			city: data.city,
			country: data.country,
			googleMapsIsActive: data.googleMapsIsActive,
			isInUse: data.isInUse,
			googleMapsTitle: data.googleMapsTitle,
			googleMapsLatitude: data.googleMapsLatitude,
			googleMapsLongitude: data.googleMapsLongitude,
			name: data.name,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new LocationDto({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			address: dbObject.address,
			zipCode: dbObject.zip_code,
			city: dbObject.city,
			country: dbObject.country,
			googleMapsIsActive: dbObject.google_maps_is_active ?? true,
			isInUse: dbObject.is_in_use,
			googleMapsTitle: dbObject.google_maps_title,
			googleMapsLatitude: dbObject.google_maps_latitude,
			googleMapsLongitude: dbObject.google_maps_longitude,
			name: dbObject.name,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/location/location-update-dto.ts
var LocationUpdateDto = class LocationUpdateDto {
	address;
	zipCode;
	city;
	country;
	googleMapsIsActive;
	googleMapsTitle;
	googleMapsLatitude;
	googleMapsLongitude;
	name;
	constructor({ address, zipCode, city, country, googleMapsIsActive, googleMapsTitle, googleMapsLatitude, googleMapsLongitude, name }) {
		this.address = address;
		this.zipCode = zipCode;
		this.city = city;
		this.country = country;
		this.googleMapsIsActive = googleMapsIsActive;
		this.googleMapsTitle = googleMapsTitle;
		this.googleMapsLatitude = googleMapsLatitude;
		this.googleMapsLongitude = googleMapsLongitude;
		this.name = name;
	}
	static createFromLocationUpdateData(data) {
		return new LocationUpdateDto({
			address: data.address,
			zipCode: data.zipCode,
			city: data.city,
			country: data.country,
			googleMapsIsActive: data.googleMapsIsActive,
			googleMapsTitle: data.googleMapsTitle,
			googleMapsLatitude: data.googleMapsLatitude,
			googleMapsLongitude: data.googleMapsLongitude,
			name: data.name
		});
	}
	convertToDbObject() {
		return {
			address: this.address,
			zip_code: this.zipCode,
			city: this.city,
			country: this.country,
			google_maps_is_active: this.googleMapsIsActive,
			google_maps_title: this.googleMapsTitle,
			google_maps_latitude: this.googleMapsLatitude?.toString(),
			google_maps_longitude: this.googleMapsLongitude?.toString(),
			name: this.name
		};
	}
};
// source/models/work-area/work-area.ts
var WorkArea = class WorkArea {
	id;
	customerId;
	name;
	type;
	isInUse;
	createdAt;
	updatedAt;
	constructor({ id, customerId, name, type, isInUse, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.name = name;
		this.type = type;
		this.isInUse = isInUse;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new WorkArea({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			name: dbObject.name,
			type: dbObject.type,
			isInUse: dbObject.is_in_use,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/work-area/work-area-creation-dto.ts
var WorkAreaCreationDto = class WorkAreaCreationDto {
	customerId;
	name;
	type;
	constructor({ customerId, name, type }) {
		this.customerId = customerId;
		this.name = name;
		this.type = type;
	}
	static createFromWorkAreaCreationData(data) {
		return new WorkAreaCreationDto({
			customerId: data.customerId,
			name: data.name,
			type: data.type
		});
	}
	convertToDbObject() {
		return {
			customer_id: this.customerId,
			name: this.name,
			type: this.type
		};
	}
};
// source/models/work-area/work-area-dto.ts
var WorkAreaDto = class WorkAreaDto {
	id;
	customerId;
	name;
	type;
	isInUse;
	createdAt;
	updatedAt;
	constructor({ id, customerId, name, type, isInUse, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.name = name;
		this.type = type;
		this.isInUse = isInUse;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toWorkArea() {
		return new WorkArea({
			id: this.id,
			customerId: this.customerId,
			name: this.name,
			type: this.type,
			isInUse: this.isInUse,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromWorkArea(workArea) {
		return new WorkAreaDto({
			id: workArea.id,
			customerId: workArea.customerId,
			name: workArea.name,
			type: workArea.type,
			isInUse: workArea.isInUse,
			createdAt: workArea.createdAt,
			updatedAt: workArea.updatedAt
		});
	}
	static createFromWorkAreaData(data) {
		return new WorkAreaDto({
			id: data.id,
			customerId: data.customerId,
			name: data.name,
			type: data.type,
			isInUse: data.isInUse,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new WorkAreaDto({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			name: dbObject.name,
			type: dbObject.type,
			isInUse: dbObject.is_in_use,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/work-area/work-area-update-dto.ts
var WorkAreaUpdateDto = class WorkAreaUpdateDto {
	name;
	type;
	constructor({ name, type }) {
		this.name = name;
		this.type = type;
	}
	static createFromWorkAreaUpdateData(data) {
		return new WorkAreaUpdateDto({
			name: data.name,
			type: data.type
		});
	}
	convertToDbObject() {
		return {
			name: this.name,
			type: this.type
		};
	}
};
// source/models/job-position-with-relations/job-position-with-relations.ts
var JobPositionWithRelations = class JobPositionWithRelations extends JobPosition {
	location;
	workArea;
	constructor({ location, workArea, ...props }) {
		super(props);
		this.location = location;
		this.workArea = workArea;
	}
	static createFromDbObject(dbObject) {
		return new JobPositionWithRelations({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			mondayItemId: dbObject.monday_item_id,
			name: dbObject.name,
			fullName: dbObject.full_name,
			addressZipCode: dbObject.address_zip_code,
			addressCity: dbObject.address_city,
			weeklyHours: dbObject.weekly_hours,
			weeklyHoursMax: dbObject.weekly_hours_max,
			schedule: dbObject.schedule,
			startDate: dbObject.start_date,
			shiftWork: dbObject.shift_work,
			salary: dbObject.salary,
			salaryIsPublic: dbObject.salary_is_public,
			salutation: dbObject.salutation,
			searchArea: dbObject.search_area,
			searchCenter: dbObject.search_center,
			searchCenterCountry: dbObject.search_center_country,
			searchRadius: dbObject.search_radius,
			cvRequired: dbObject.cv_required,
			cvRequiredInForm: dbObject.cv_required_in_form,
			emailRecipients: dbObject.email_recipients,
			isPreQualified: dbObject.is_pre_qualified,
			type: dbObject.type,
			specialization: dbObject.specialization,
			university: dbObject.university,
			externalApplicationUrl: dbObject.external_application_url,
			fieldServiceAndHomeOffice: dbObject.field_service_and_home_office,
			otherManagerInfo: dbObject.other_manager_info,
			trainingDuration: dbObject.training_duration,
			isFlexibleInternshipPossible: dbObject.is_flexible_internship_possible,
			requirements: dbObject.requirements,
			additionalRequirements: dbObject.additional_requirements,
			tasks: dbObject.tasks,
			benefits: dbObject.benefits,
			contactPersonName: dbObject.contact_person_name,
			contactPersonEmail: dbObject.contact_person_email,
			contactPersonPosition: dbObject.contact_person_position,
			contactPersonSalutation: dbObject.contact_person_salutation,
			addressLink: dbObject.address_link,
			isCampaignActive: dbObject.is_campaign_active,
			monthlyAdvertisingBudget: dbObject.monthly_advertising_budget,
			landingPageUrl: dbObject.landing_page_url,
			isCampaignExpiring: dbObject.is_campaign_expiring,
			campaignEndDate: dbObject.campaign_end_date,
			directApproaches: dbObject.direct_approaches,
			potential: dbObject.potential,
			campaignError: dbObject.campaign_error,
			directApproachesError: dbObject.direct_approaches_error,
			isIndeedActive: dbObject.is_indeed_active,
			indeedDeadline: dbObject.indeed_deadline,
			indeedMonthlyBudget: dbObject.indeed_monthly_budget,
			isStepstoneActive: dbObject.is_stepstone_active,
			stepstoneDeadline: dbObject.stepstone_deadline,
			jobPortalError: dbObject.job_portal_error,
			isArchived: dbObject.is_archived,
			careerPageActive: dbObject.career_page_active,
			searchAdStatus: dbObject.search_ad_status,
			traineeFirstYearSalary: dbObject.trainee_first_year_salary,
			traineeSecondYearSalary: dbObject.trainee_second_year_salary,
			traineeThirdYearSalary: dbObject.trainee_third_year_salary,
			traineeFourthYearSalary: dbObject.trainee_fourth_year_salary,
			dualStudentSalary: dbObject.dual_student_salary,
			locationId: dbObject.location_id,
			location: dbObject.location && Location.createFromDbObject(dbObject.location),
			workAreaId: dbObject.work_area_id,
			workArea: dbObject.work_area && WorkArea.createFromDbObject(dbObject.work_area),
			campaignStatus: dbObject.campaign_status,
			campaignId: dbObject.campaign_id,
			campaignRelatedJobPositionNames: dbObject.campaign_related_job_position_names,
			applicantNotesTemplate: dbObject.applicant_notes_template,
			heroImagePath: dbObject.hero_image_path,
			heroVideoPath: dbObject.hero_video_path,
			heroVideoVimeoId: dbObject.hero_video_vimeo_id,
			heroVideoActive: dbObject.hero_video_active,
			secondImagePath: dbObject.second_image_path,
			thirdImagePath: dbObject.third_image_path,
			fourthImagePath: dbObject.fourth_image_path,
			isQuotaActive: dbObject.is_quota_active,
			isQuotaExpiring: dbObject.is_quota_expiring,
			quotaEndDate: dbObject.quota_end_date,
			quotaRelatedJobPositionNames: dbObject.quota_related_job_position_names,
			quotaBudget: dbObject.quota_budget,
			quotaGuarantee: dbObject.quota_guarantee,
			isUnsolicited: dbObject.is_unsolicited,
			baLastAction: dbObject.ba_last_action,
			documentsRequiredForForwarding: dbObject.documents_required_for_forwarding,
			requiredDocumentsDescription: dbObject.required_documents_description,
			repostedAt: dbObject.reposted_at?.toISOString() ?? null,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/job-position-with-relations/job-position-with-relations-dto.ts
var JobPositionWithRelationsDto = class JobPositionWithRelationsDto extends JobPositionDto {
	location;
	workArea;
	constructor({ location, workArea, ...props }) {
		super(props);
		this.location = location;
		this.workArea = workArea;
	}
	toJobPositionWithRelations() {
		return new JobPositionWithRelations({
			id: this.id,
			customerId: this.customerId,
			mondayItemId: this.mondayItemId,
			name: this.name,
			fullName: this.fullName,
			addressZipCode: this.addressZipCode,
			addressCity: this.addressCity,
			weeklyHours: this.weeklyHours,
			weeklyHoursMax: this.weeklyHoursMax,
			schedule: this.schedule,
			startDate: this.startDate,
			shiftWork: this.shiftWork,
			salary: this.salary,
			salaryIsPublic: this.salaryIsPublic,
			salutation: this.salutation,
			searchArea: this.searchArea,
			searchCenter: this.searchCenter,
			searchCenterCountry: this.searchCenterCountry,
			searchRadius: this.searchRadius,
			cvRequired: this.cvRequired,
			cvRequiredInForm: this.cvRequiredInForm,
			emailRecipients: this.emailRecipients,
			isPreQualified: this.isPreQualified,
			type: this.type,
			specialization: this.specialization,
			university: this.university,
			externalApplicationUrl: this.externalApplicationUrl,
			fieldServiceAndHomeOffice: this.fieldServiceAndHomeOffice,
			otherManagerInfo: this.otherManagerInfo,
			trainingDuration: this.trainingDuration,
			isFlexibleInternshipPossible: this.isFlexibleInternshipPossible,
			requirements: this.requirements,
			additionalRequirements: this.additionalRequirements,
			tasks: this.tasks,
			benefits: this.benefits,
			contactPersonName: this.contactPersonName,
			contactPersonEmail: this.contactPersonEmail,
			contactPersonPosition: this.contactPersonPosition,
			contactPersonSalutation: this.contactPersonSalutation,
			addressLink: this.addressLink,
			isCampaignActive: this.isCampaignActive,
			monthlyAdvertisingBudget: this.monthlyAdvertisingBudget,
			landingPageUrl: this.landingPageUrl,
			isCampaignExpiring: this.isCampaignExpiring,
			campaignEndDate: this.campaignEndDate,
			directApproaches: this.directApproaches,
			potential: this.potential,
			campaignError: this.campaignError,
			directApproachesError: this.directApproachesError,
			isIndeedActive: this.isIndeedActive,
			indeedDeadline: this.indeedDeadline,
			indeedMonthlyBudget: this.indeedMonthlyBudget,
			isStepstoneActive: this.isStepstoneActive,
			stepstoneDeadline: this.stepstoneDeadline,
			jobPortalError: this.jobPortalError,
			isArchived: this.isArchived,
			careerPageActive: this.careerPageActive,
			searchAdStatus: this.searchAdStatus,
			traineeFirstYearSalary: this.traineeFirstYearSalary,
			traineeSecondYearSalary: this.traineeSecondYearSalary,
			traineeThirdYearSalary: this.traineeThirdYearSalary,
			traineeFourthYearSalary: this.traineeFourthYearSalary,
			dualStudentSalary: this.dualStudentSalary,
			locationId: this.locationId,
			location: this.location?.toLocation(),
			workAreaId: this.workAreaId,
			workArea: this.workArea?.toWorkArea(),
			campaignStatus: this.campaignStatus,
			campaignId: this.campaignId,
			campaignRelatedJobPositionNames: this.campaignRelatedJobPositionNames,
			applicantNotesTemplate: this.applicantNotesTemplate,
			heroImagePath: this.heroImagePath,
			heroVideoPath: this.heroVideoPath,
			heroVideoVimeoId: this.heroVideoVimeoId,
			heroVideoActive: this.heroVideoActive,
			secondImagePath: this.secondImagePath,
			thirdImagePath: this.thirdImagePath,
			fourthImagePath: this.fourthImagePath,
			isQuotaActive: this.isQuotaActive,
			isQuotaExpiring: this.isQuotaExpiring,
			quotaEndDate: this.quotaEndDate,
			quotaRelatedJobPositionNames: this.quotaRelatedJobPositionNames,
			quotaBudget: this.quotaBudget,
			quotaGuarantee: this.quotaGuarantee,
			isUnsolicited: this.isUnsolicited,
			documentsRequiredForForwarding: this.documentsRequiredForForwarding,
			requiredDocumentsDescription: this.requiredDocumentsDescription,
			baLastAction: this.baLastAction,
			repostedAt: this.repostedAt,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromJobPositionWithRelations(jobPositionWithRelations) {
		return new JobPositionWithRelationsDto({
			id: jobPositionWithRelations.id,
			customerId: jobPositionWithRelations.customerId,
			mondayItemId: jobPositionWithRelations.mondayItemId,
			name: jobPositionWithRelations.name,
			fullName: jobPositionWithRelations.fullName,
			addressZipCode: jobPositionWithRelations.addressZipCode,
			addressCity: jobPositionWithRelations.addressCity,
			weeklyHours: jobPositionWithRelations.weeklyHours,
			weeklyHoursMax: jobPositionWithRelations.weeklyHoursMax,
			schedule: jobPositionWithRelations.schedule,
			startDate: jobPositionWithRelations.startDate,
			shiftWork: jobPositionWithRelations.shiftWork,
			salary: jobPositionWithRelations.salary,
			salaryIsPublic: jobPositionWithRelations.salaryIsPublic,
			salutation: jobPositionWithRelations.salutation,
			searchArea: jobPositionWithRelations.searchArea,
			searchCenter: jobPositionWithRelations.searchCenter,
			searchCenterCountry: jobPositionWithRelations.searchCenterCountry,
			searchRadius: jobPositionWithRelations.searchRadius,
			cvRequired: jobPositionWithRelations.cvRequired,
			cvRequiredInForm: jobPositionWithRelations.cvRequiredInForm,
			emailRecipients: jobPositionWithRelations.emailRecipients,
			isPreQualified: jobPositionWithRelations.isPreQualified,
			type: jobPositionWithRelations.type,
			specialization: jobPositionWithRelations.specialization,
			university: jobPositionWithRelations.university,
			externalApplicationUrl: jobPositionWithRelations.externalApplicationUrl,
			fieldServiceAndHomeOffice: jobPositionWithRelations.fieldServiceAndHomeOffice,
			otherManagerInfo: jobPositionWithRelations.otherManagerInfo,
			trainingDuration: jobPositionWithRelations.trainingDuration,
			isFlexibleInternshipPossible: jobPositionWithRelations.isFlexibleInternshipPossible,
			requirements: jobPositionWithRelations.requirements,
			additionalRequirements: jobPositionWithRelations.additionalRequirements,
			tasks: jobPositionWithRelations.tasks,
			benefits: jobPositionWithRelations.benefits,
			contactPersonName: jobPositionWithRelations.contactPersonName,
			contactPersonEmail: jobPositionWithRelations.contactPersonEmail,
			contactPersonPosition: jobPositionWithRelations.contactPersonPosition,
			contactPersonSalutation: jobPositionWithRelations.contactPersonSalutation,
			addressLink: jobPositionWithRelations.addressLink,
			isCampaignActive: jobPositionWithRelations.isCampaignActive,
			monthlyAdvertisingBudget: jobPositionWithRelations.monthlyAdvertisingBudget,
			landingPageUrl: jobPositionWithRelations.landingPageUrl,
			isCampaignExpiring: jobPositionWithRelations.isCampaignExpiring,
			campaignEndDate: jobPositionWithRelations.campaignEndDate,
			directApproaches: jobPositionWithRelations.directApproaches,
			potential: jobPositionWithRelations.potential,
			campaignError: jobPositionWithRelations.campaignError,
			directApproachesError: jobPositionWithRelations.directApproachesError,
			isIndeedActive: jobPositionWithRelations.isIndeedActive,
			indeedDeadline: jobPositionWithRelations.indeedDeadline,
			indeedMonthlyBudget: jobPositionWithRelations.indeedMonthlyBudget,
			isStepstoneActive: jobPositionWithRelations.isStepstoneActive,
			stepstoneDeadline: jobPositionWithRelations.stepstoneDeadline,
			jobPortalError: jobPositionWithRelations.jobPortalError,
			isArchived: jobPositionWithRelations.isArchived,
			careerPageActive: jobPositionWithRelations.careerPageActive,
			searchAdStatus: jobPositionWithRelations.searchAdStatus,
			traineeFirstYearSalary: jobPositionWithRelations.traineeFirstYearSalary,
			traineeSecondYearSalary: jobPositionWithRelations.traineeSecondYearSalary,
			traineeThirdYearSalary: jobPositionWithRelations.traineeThirdYearSalary,
			traineeFourthYearSalary: jobPositionWithRelations.traineeFourthYearSalary,
			dualStudentSalary: jobPositionWithRelations.dualStudentSalary,
			locationId: jobPositionWithRelations.locationId,
			location: jobPositionWithRelations.location && LocationDto.createFromLocation(jobPositionWithRelations.location),
			workAreaId: jobPositionWithRelations.workAreaId,
			workArea: jobPositionWithRelations.workArea && WorkAreaDto.createFromWorkArea(jobPositionWithRelations.workArea),
			campaignStatus: jobPositionWithRelations.campaignStatus,
			campaignId: jobPositionWithRelations.campaignId,
			campaignRelatedJobPositionNames: jobPositionWithRelations.campaignRelatedJobPositionNames,
			applicantNotesTemplate: jobPositionWithRelations.applicantNotesTemplate,
			heroImagePath: jobPositionWithRelations.heroImagePath,
			heroVideoPath: jobPositionWithRelations.heroVideoPath,
			heroVideoVimeoId: jobPositionWithRelations.heroVideoVimeoId,
			heroVideoActive: jobPositionWithRelations.heroVideoActive,
			secondImagePath: jobPositionWithRelations.secondImagePath,
			thirdImagePath: jobPositionWithRelations.thirdImagePath,
			fourthImagePath: jobPositionWithRelations.fourthImagePath,
			isQuotaActive: jobPositionWithRelations.isQuotaActive,
			isQuotaExpiring: jobPositionWithRelations.isQuotaExpiring,
			quotaEndDate: jobPositionWithRelations.quotaEndDate,
			quotaRelatedJobPositionNames: jobPositionWithRelations.quotaRelatedJobPositionNames,
			quotaBudget: jobPositionWithRelations.quotaBudget,
			quotaGuarantee: jobPositionWithRelations.quotaGuarantee,
			isUnsolicited: jobPositionWithRelations.isUnsolicited,
			documentsRequiredForForwarding: jobPositionWithRelations.documentsRequiredForForwarding,
			requiredDocumentsDescription: jobPositionWithRelations.requiredDocumentsDescription,
			baLastAction: jobPositionWithRelations.baLastAction,
			repostedAt: jobPositionWithRelations.repostedAt,
			createdAt: jobPositionWithRelations.createdAt,
			updatedAt: jobPositionWithRelations.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new JobPositionWithRelationsDto({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			mondayItemId: dbObject.monday_item_id,
			name: dbObject.name,
			fullName: dbObject.full_name,
			addressZipCode: dbObject.address_zip_code,
			addressCity: dbObject.address_city,
			weeklyHours: dbObject.weekly_hours,
			weeklyHoursMax: dbObject.weekly_hours_max,
			schedule: dbObject.schedule,
			startDate: dbObject.start_date,
			shiftWork: dbObject.shift_work,
			salary: dbObject.salary,
			salaryIsPublic: dbObject.salary_is_public,
			salutation: dbObject.salutation,
			searchArea: dbObject.search_area,
			searchCenter: dbObject.search_center,
			searchCenterCountry: dbObject.search_center_country,
			searchRadius: dbObject.search_radius,
			cvRequired: dbObject.cv_required,
			cvRequiredInForm: dbObject.cv_required_in_form,
			emailRecipients: dbObject.email_recipients,
			isPreQualified: dbObject.is_pre_qualified,
			type: dbObject.type,
			specialization: dbObject.specialization,
			university: dbObject.university,
			externalApplicationUrl: dbObject.external_application_url,
			fieldServiceAndHomeOffice: dbObject.field_service_and_home_office,
			otherManagerInfo: dbObject.other_manager_info,
			trainingDuration: dbObject.training_duration,
			isFlexibleInternshipPossible: dbObject.is_flexible_internship_possible,
			requirements: dbObject.requirements,
			additionalRequirements: dbObject.additional_requirements,
			tasks: dbObject.tasks,
			benefits: dbObject.benefits,
			contactPersonName: dbObject.contact_person_name,
			contactPersonEmail: dbObject.contact_person_email,
			contactPersonPosition: dbObject.contact_person_position,
			contactPersonSalutation: dbObject.contact_person_salutation,
			addressLink: dbObject.address_link,
			isCampaignActive: dbObject.is_campaign_active,
			monthlyAdvertisingBudget: dbObject.monthly_advertising_budget,
			landingPageUrl: dbObject.landing_page_url,
			isCampaignExpiring: dbObject.is_campaign_expiring,
			campaignEndDate: dbObject.campaign_end_date,
			directApproaches: dbObject.direct_approaches,
			potential: dbObject.potential,
			campaignError: dbObject.campaign_error,
			directApproachesError: dbObject.direct_approaches_error,
			isIndeedActive: dbObject.is_indeed_active,
			indeedDeadline: dbObject.indeed_deadline,
			indeedMonthlyBudget: dbObject.indeed_monthly_budget,
			isStepstoneActive: dbObject.is_stepstone_active,
			stepstoneDeadline: dbObject.stepstone_deadline,
			jobPortalError: dbObject.job_portal_error,
			isArchived: dbObject.is_archived,
			careerPageActive: dbObject.career_page_active,
			searchAdStatus: dbObject.search_ad_status,
			traineeFirstYearSalary: dbObject.trainee_first_year_salary,
			traineeSecondYearSalary: dbObject.trainee_second_year_salary,
			traineeThirdYearSalary: dbObject.trainee_third_year_salary,
			traineeFourthYearSalary: dbObject.trainee_fourth_year_salary,
			dualStudentSalary: dbObject.dual_student_salary,
			locationId: dbObject.location_id,
			location: dbObject.location && LocationDto.createFromDbObject(dbObject.location),
			workAreaId: dbObject.work_area_id,
			workArea: dbObject.work_area && WorkAreaDto.createFromWorkArea(dbObject.work_area),
			campaignStatus: dbObject.campaign_status,
			campaignId: dbObject.campaign_id,
			campaignRelatedJobPositionNames: dbObject.campaign_related_job_position_names,
			applicantNotesTemplate: dbObject.applicant_notes_template,
			heroImagePath: dbObject.hero_image_path,
			heroVideoPath: dbObject.hero_video_path,
			heroVideoVimeoId: dbObject.hero_video_vimeo_id,
			heroVideoActive: dbObject.hero_video_active,
			secondImagePath: dbObject.second_image_path,
			thirdImagePath: dbObject.third_image_path,
			fourthImagePath: dbObject.fourth_image_path,
			isQuotaActive: dbObject.is_quota_active,
			isQuotaExpiring: dbObject.is_quota_expiring,
			quotaEndDate: dbObject.quota_end_date,
			quotaRelatedJobPositionNames: dbObject.quota_related_job_position_names,
			quotaBudget: dbObject.quota_budget,
			quotaGuarantee: dbObject.quota_guarantee,
			isUnsolicited: dbObject.is_unsolicited,
			documentsRequiredForForwarding: dbObject.documents_required_for_forwarding,
			requiredDocumentsDescription: dbObject.required_documents_description,
			baLastAction: dbObject.ba_last_action,
			repostedAt: dbObject.reposted_at?.toISOString() ?? null,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
	static createFromJobPositionWithRelationsData(jobPositionWithRelationsData) {
		return new JobPositionWithRelationsDto({
			id: jobPositionWithRelationsData.id,
			customerId: jobPositionWithRelationsData.customerId,
			mondayItemId: jobPositionWithRelationsData.mondayItemId,
			name: jobPositionWithRelationsData.name,
			fullName: jobPositionWithRelationsData.fullName,
			addressZipCode: jobPositionWithRelationsData.addressZipCode,
			addressCity: jobPositionWithRelationsData.addressCity,
			weeklyHours: jobPositionWithRelationsData.weeklyHours,
			weeklyHoursMax: jobPositionWithRelationsData.weeklyHoursMax,
			schedule: jobPositionWithRelationsData.schedule,
			startDate: jobPositionWithRelationsData.startDate,
			shiftWork: jobPositionWithRelationsData.shiftWork,
			salary: jobPositionWithRelationsData.salary,
			salaryIsPublic: jobPositionWithRelationsData.salaryIsPublic,
			salutation: jobPositionWithRelationsData.salutation,
			searchArea: jobPositionWithRelationsData.searchArea,
			searchCenter: jobPositionWithRelationsData.searchCenter,
			searchCenterCountry: jobPositionWithRelationsData.searchCenterCountry,
			searchRadius: jobPositionWithRelationsData.searchRadius,
			cvRequired: jobPositionWithRelationsData.cvRequired,
			cvRequiredInForm: jobPositionWithRelationsData.cvRequiredInForm,
			emailRecipients: jobPositionWithRelationsData.emailRecipients,
			isPreQualified: jobPositionWithRelationsData.isPreQualified,
			type: jobPositionWithRelationsData.type,
			specialization: jobPositionWithRelationsData.specialization,
			university: jobPositionWithRelationsData.university,
			externalApplicationUrl: jobPositionWithRelationsData.externalApplicationUrl,
			fieldServiceAndHomeOffice: jobPositionWithRelationsData.fieldServiceAndHomeOffice,
			otherManagerInfo: jobPositionWithRelationsData.otherManagerInfo,
			trainingDuration: jobPositionWithRelationsData.trainingDuration,
			isFlexibleInternshipPossible: jobPositionWithRelationsData.isFlexibleInternshipPossible,
			requirements: jobPositionWithRelationsData.requirements,
			additionalRequirements: jobPositionWithRelationsData.additionalRequirements,
			tasks: jobPositionWithRelationsData.tasks,
			benefits: jobPositionWithRelationsData.benefits,
			contactPersonName: jobPositionWithRelationsData.contactPersonName,
			contactPersonEmail: jobPositionWithRelationsData.contactPersonEmail,
			contactPersonPosition: jobPositionWithRelationsData.contactPersonPosition,
			contactPersonSalutation: jobPositionWithRelationsData.contactPersonSalutation,
			addressLink: jobPositionWithRelationsData.addressLink,
			isCampaignActive: jobPositionWithRelationsData.isCampaignActive,
			monthlyAdvertisingBudget: jobPositionWithRelationsData.monthlyAdvertisingBudget,
			landingPageUrl: jobPositionWithRelationsData.landingPageUrl,
			isCampaignExpiring: jobPositionWithRelationsData.isCampaignExpiring,
			campaignEndDate: jobPositionWithRelationsData.campaignEndDate,
			directApproaches: jobPositionWithRelationsData.directApproaches,
			potential: jobPositionWithRelationsData.potential,
			campaignError: jobPositionWithRelationsData.campaignError,
			directApproachesError: jobPositionWithRelationsData.directApproachesError,
			isIndeedActive: jobPositionWithRelationsData.isIndeedActive,
			indeedDeadline: jobPositionWithRelationsData.indeedDeadline,
			indeedMonthlyBudget: jobPositionWithRelationsData.indeedMonthlyBudget,
			isStepstoneActive: jobPositionWithRelationsData.isStepstoneActive,
			stepstoneDeadline: jobPositionWithRelationsData.stepstoneDeadline,
			jobPortalError: jobPositionWithRelationsData.jobPortalError,
			isArchived: jobPositionWithRelationsData.isArchived,
			careerPageActive: jobPositionWithRelationsData.careerPageActive,
			searchAdStatus: jobPositionWithRelationsData.searchAdStatus,
			traineeFirstYearSalary: jobPositionWithRelationsData.traineeFirstYearSalary,
			traineeSecondYearSalary: jobPositionWithRelationsData.traineeSecondYearSalary,
			traineeThirdYearSalary: jobPositionWithRelationsData.traineeThirdYearSalary,
			traineeFourthYearSalary: jobPositionWithRelationsData.traineeFourthYearSalary,
			dualStudentSalary: jobPositionWithRelationsData.dualStudentSalary,
			locationId: jobPositionWithRelationsData.locationId,
			location: jobPositionWithRelationsData.location && LocationDto.createFromLocationData(jobPositionWithRelationsData.location),
			workAreaId: jobPositionWithRelationsData.workAreaId,
			workArea: jobPositionWithRelationsData.workArea && WorkAreaDto.createFromWorkArea(jobPositionWithRelationsData.workArea),
			campaignStatus: jobPositionWithRelationsData.campaignStatus,
			campaignId: jobPositionWithRelationsData.campaignId,
			campaignRelatedJobPositionNames: jobPositionWithRelationsData.campaignRelatedJobPositionNames,
			applicantNotesTemplate: jobPositionWithRelationsData.applicantNotesTemplate,
			heroImagePath: jobPositionWithRelationsData.heroImagePath,
			heroVideoPath: jobPositionWithRelationsData.heroVideoPath,
			heroVideoVimeoId: jobPositionWithRelationsData.heroVideoVimeoId,
			heroVideoActive: jobPositionWithRelationsData.heroVideoActive,
			secondImagePath: jobPositionWithRelationsData.secondImagePath,
			thirdImagePath: jobPositionWithRelationsData.thirdImagePath,
			fourthImagePath: jobPositionWithRelationsData.fourthImagePath,
			isQuotaActive: jobPositionWithRelationsData.isQuotaActive,
			isQuotaExpiring: jobPositionWithRelationsData.isQuotaExpiring,
			quotaEndDate: jobPositionWithRelationsData.quotaEndDate,
			quotaRelatedJobPositionNames: jobPositionWithRelationsData.quotaRelatedJobPositionNames,
			quotaBudget: jobPositionWithRelationsData.quotaBudget,
			quotaGuarantee: jobPositionWithRelationsData.quotaGuarantee,
			isUnsolicited: jobPositionWithRelationsData.isUnsolicited,
			documentsRequiredForForwarding: jobPositionWithRelationsData.documentsRequiredForForwarding,
			requiredDocumentsDescription: jobPositionWithRelationsData.requiredDocumentsDescription,
			baLastAction: jobPositionWithRelationsData.baLastAction,
			repostedAt: jobPositionWithRelationsData.repostedAt,
			createdAt: jobPositionWithRelationsData.createdAt,
			updatedAt: jobPositionWithRelationsData.updatedAt
		});
	}
};
// source/models/applicant-with-relations/applicant-with-relations.ts
var ApplicantWithRelations = class ApplicantWithRelations extends Applicant {
	jobPosition;
	documentCount;
	unreadDocumentCount;
	safeDocumentCount;
	documents;
	constructor({ jobPosition, documentCount, unreadDocumentCount, safeDocumentCount, documents, ...props }) {
		super(props);
		this.jobPosition = jobPosition;
		this.documentCount = documentCount;
		this.unreadDocumentCount = unreadDocumentCount;
		this.safeDocumentCount = safeDocumentCount;
		this.documents = documents;
	}
	static createFromDbObject(applicantWithRelationsDbObject) {
		return new ApplicantWithRelations({
			id: applicantWithRelationsDbObject.id,
			name: applicantWithRelationsDbObject.name,
			customerId: applicantWithRelationsDbObject.customer_id,
			jobPositionId: applicantWithRelationsDbObject.job_position_id,
			jobPosition: applicantWithRelationsDbObject.job_position ? JobPositionWithRelations.createFromDbObject(applicantWithRelationsDbObject.job_position) : void 0,
			phaseId: applicantWithRelationsDbObject.phase_id,
			currentState: applicantWithRelationsDbObject.current_state,
			profile: applicantWithRelationsDbObject.profile,
			sourceId: applicantWithRelationsDbObject.source_id,
			sourcePlatformId: applicantWithRelationsDbObject.source_platform_id,
			sourceCampaign: applicantWithRelationsDbObject.source_campaign,
			sourceMedium: applicantWithRelationsDbObject.source_medium,
			sourceKeyword: applicantWithRelationsDbObject.source_keyword,
			declineReason: applicantWithRelationsDbObject.decline_reason,
			emailAddress: applicantWithRelationsDbObject.email_address,
			phoneNumber: applicantWithRelationsDbObject.phone_number,
			normalizedPhoneNumber: applicantWithRelationsDbObject.normalized_phone_number,
			isArchived: applicantWithRelationsDbObject.is_archived,
			deadline: applicantWithRelationsDbObject.deadline,
			landingPageVersion: applicantWithRelationsDbObject.landing_page_version,
			forwardedAt: applicantWithRelationsDbObject.forwarded_at,
			receivedAt: applicantWithRelationsDbObject.received_at,
			customerNotes: applicantWithRelationsDbObject.customer_notes,
			documentCount: applicantWithRelationsDbObject.document_count,
			unreadDocumentCount: applicantWithRelationsDbObject.unread_document_count,
			token: applicantWithRelationsDbObject.token,
			referralSource: applicantWithRelationsDbObject.referral_source,
			talentPoolConsentGiven: applicantWithRelationsDbObject.talent_pool_consent_given,
			shareLinkWithNotes: applicantWithRelationsDbObject.share_link_with_notes,
			shareLinkToken: applicantWithRelationsDbObject.share_link_token,
			hasCustomerNoteComments: applicantWithRelationsDbObject.has_customer_note_comments,
			safeDocumentCount: applicantWithRelationsDbObject.safe_document_count,
			duplicatedApplicants: applicantWithRelationsDbObject.duplicated_applicants,
			origin: applicantWithRelationsDbObject.origin,
			prequalificationStatus: applicantWithRelationsDbObject.prequalification_status,
			lastPhaseChangeRole: applicantWithRelationsDbObject.last_phase_change_role,
			documents: applicantWithRelationsDbObject.documents,
			createdAt: applicantWithRelationsDbObject.created_at,
			updatedAt: applicantWithRelationsDbObject.updated_at
		});
	}
};
// source/models/applicant-with-relations/applicant-with-relations-dto.ts
var ApplicantWithRelationsDto = class ApplicantWithRelationsDto extends ApplicantDto {
	jobPosition;
	documentCount;
	unreadDocumentCount;
	safeDocumentCount;
	documents;
	constructor({ jobPosition, documentCount, unreadDocumentCount, safeDocumentCount, documents, ...props }) {
		super(props);
		this.jobPosition = jobPosition;
		this.documentCount = documentCount;
		this.unreadDocumentCount = unreadDocumentCount;
		this.safeDocumentCount = safeDocumentCount;
		this.documents = documents;
	}
	toApplicantWithRelations() {
		return new ApplicantWithRelations({
			id: this.id,
			name: this.name,
			customerId: this.customerId,
			jobPositionId: this.jobPositionId,
			jobPosition: this.jobPosition ? this.jobPosition.toJobPositionWithRelations() : void 0,
			phaseId: this.phaseId,
			currentState: this.currentState,
			profile: this.profile,
			sourceId: this.sourceId,
			sourcePlatformId: this.sourcePlatformId,
			sourceCampaign: this.sourceCampaign,
			sourceMedium: this.sourceMedium,
			sourceKeyword: this.sourceKeyword,
			declineReason: this.declineReason,
			emailAddress: this.emailAddress,
			phoneNumber: this.phoneNumber,
			normalizedPhoneNumber: this.normalizedPhoneNumber,
			isArchived: this.isArchived,
			deadline: this.deadline,
			landingPageVersion: this.landingPageVersion,
			forwardedAt: this.forwardedAt,
			receivedAt: this.receivedAt,
			customerNotes: this.customerNotes,
			documentCount: this.documentCount,
			unreadDocumentCount: this.unreadDocumentCount,
			token: this.token,
			referralSource: this.referralSource,
			talentPoolConsentGiven: this.talentPoolConsentGiven,
			shareLinkWithNotes: this.shareLinkWithNotes,
			shareLinkToken: this.shareLinkToken,
			hasCustomerNoteComments: this.hasCustomerNoteComments,
			safeDocumentCount: this.safeDocumentCount,
			duplicatedApplicants: this.duplicatedApplicants,
			origin: this.origin,
			prequalificationStatus: this.prequalificationStatus,
			lastPhaseChangeRole: this.lastPhaseChangeRole,
			documents: this.documents,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromApplicantWithRelations(applicantWithRelations) {
		return new ApplicantWithRelationsDto({
			id: applicantWithRelations.id,
			name: applicantWithRelations.name,
			customerId: applicantWithRelations.customerId,
			jobPositionId: applicantWithRelations.jobPositionId,
			jobPosition: applicantWithRelations.jobPosition ? JobPositionWithRelationsDto.createFromJobPositionWithRelations(applicantWithRelations.jobPosition) : void 0,
			phaseId: applicantWithRelations.phaseId,
			currentState: applicantWithRelations.currentState,
			profile: applicantWithRelations.profile,
			sourceId: applicantWithRelations.sourceId,
			sourcePlatformId: applicantWithRelations.sourcePlatformId,
			sourceCampaign: applicantWithRelations.sourceCampaign,
			sourceMedium: applicantWithRelations.sourceMedium,
			sourceKeyword: applicantWithRelations.sourceKeyword,
			declineReason: applicantWithRelations.declineReason,
			emailAddress: applicantWithRelations.emailAddress,
			phoneNumber: applicantWithRelations.phoneNumber,
			normalizedPhoneNumber: applicantWithRelations.normalizedPhoneNumber,
			isArchived: applicantWithRelations.isArchived,
			deadline: applicantWithRelations.deadline,
			landingPageVersion: applicantWithRelations.landingPageVersion,
			forwardedAt: applicantWithRelations.forwardedAt,
			receivedAt: applicantWithRelations.receivedAt,
			customerNotes: applicantWithRelations.customerNotes,
			documentCount: applicantWithRelations.documentCount,
			unreadDocumentCount: applicantWithRelations.unreadDocumentCount,
			token: applicantWithRelations.token,
			referralSource: applicantWithRelations.referralSource,
			talentPoolConsentGiven: applicantWithRelations.talentPoolConsentGiven,
			shareLinkWithNotes: applicantWithRelations.shareLinkWithNotes,
			shareLinkToken: applicantWithRelations.shareLinkToken,
			hasCustomerNoteComments: applicantWithRelations.hasCustomerNoteComments,
			safeDocumentCount: applicantWithRelations.safeDocumentCount,
			duplicatedApplicants: applicantWithRelations.duplicatedApplicants,
			origin: applicantWithRelations.origin,
			prequalificationStatus: applicantWithRelations.prequalificationStatus,
			lastPhaseChangeRole: applicantWithRelations.lastPhaseChangeRole,
			documents: applicantWithRelations.documents,
			createdAt: applicantWithRelations.createdAt,
			updatedAt: applicantWithRelations.updatedAt
		});
	}
	static createFromDbObject(applicantWithRelationsDbObject) {
		return new ApplicantWithRelationsDto({
			id: applicantWithRelationsDbObject.id,
			customerId: applicantWithRelationsDbObject.customer_id,
			name: applicantWithRelationsDbObject.name,
			jobPositionId: applicantWithRelationsDbObject.job_position_id,
			jobPosition: applicantWithRelationsDbObject.job_position ? JobPositionWithRelationsDto.createFromDbObject(applicantWithRelationsDbObject.job_position) : void 0,
			phaseId: applicantWithRelationsDbObject.phase_id,
			currentState: applicantWithRelationsDbObject.current_state,
			profile: applicantWithRelationsDbObject.profile,
			sourceId: applicantWithRelationsDbObject.source_id,
			sourcePlatformId: applicantWithRelationsDbObject.source_platform_id,
			sourceCampaign: applicantWithRelationsDbObject.source_campaign,
			sourceMedium: applicantWithRelationsDbObject.source_medium,
			sourceKeyword: applicantWithRelationsDbObject.source_keyword,
			declineReason: applicantWithRelationsDbObject.decline_reason,
			emailAddress: applicantWithRelationsDbObject.email_address,
			phoneNumber: applicantWithRelationsDbObject.phone_number,
			normalizedPhoneNumber: applicantWithRelationsDbObject.normalized_phone_number,
			isArchived: applicantWithRelationsDbObject.is_archived,
			deadline: applicantWithRelationsDbObject.deadline,
			landingPageVersion: applicantWithRelationsDbObject.landing_page_version,
			forwardedAt: applicantWithRelationsDbObject.forwarded_at,
			receivedAt: applicantWithRelationsDbObject.received_at,
			customerNotes: applicantWithRelationsDbObject.customer_notes,
			documentCount: applicantWithRelationsDbObject.document_count,
			unreadDocumentCount: applicantWithRelationsDbObject.unread_document_count,
			token: applicantWithRelationsDbObject.token,
			referralSource: applicantWithRelationsDbObject.referral_source,
			talentPoolConsentGiven: applicantWithRelationsDbObject.talent_pool_consent_given,
			shareLinkWithNotes: applicantWithRelationsDbObject.share_link_with_notes,
			shareLinkToken: applicantWithRelationsDbObject.share_link_token,
			hasCustomerNoteComments: applicantWithRelationsDbObject.has_customer_note_comments,
			safeDocumentCount: applicantWithRelationsDbObject.safe_document_count,
			duplicatedApplicants: applicantWithRelationsDbObject.duplicated_applicants,
			origin: applicantWithRelationsDbObject.origin,
			prequalificationStatus: applicantWithRelationsDbObject.prequalificationStatus,
			lastPhaseChangeRole: applicantWithRelationsDbObject.last_phase_change_role,
			documents: applicantWithRelationsDbObject.documents,
			createdAt: applicantWithRelationsDbObject.created_at,
			updatedAt: applicantWithRelationsDbObject.updated_at
		});
	}
	static createFromApplicantWithRelationsData(applicantWithRelationsData) {
		return new ApplicantWithRelationsDto({
			id: applicantWithRelationsData.id,
			name: applicantWithRelationsData.name,
			customerId: applicantWithRelationsData.customerId,
			jobPositionId: applicantWithRelationsData.jobPositionId,
			jobPosition: applicantWithRelationsData.jobPosition ? JobPositionWithRelationsDto.createFromJobPositionWithRelationsData(applicantWithRelationsData.jobPosition) : void 0,
			phaseId: applicantWithRelationsData.phaseId,
			currentState: applicantWithRelationsData.currentState,
			profile: applicantWithRelationsData.profile,
			sourceId: applicantWithRelationsData.sourceId,
			sourcePlatformId: applicantWithRelationsData.sourcePlatformId,
			sourceCampaign: applicantWithRelationsData.sourceCampaign,
			sourceMedium: applicantWithRelationsData.sourceMedium,
			sourceKeyword: applicantWithRelationsData.sourceKeyword,
			declineReason: applicantWithRelationsData.declineReason,
			emailAddress: applicantWithRelationsData.emailAddress,
			phoneNumber: applicantWithRelationsData.phoneNumber,
			normalizedPhoneNumber: applicantWithRelationsData.normalizedPhoneNumber,
			isArchived: applicantWithRelationsData.isArchived,
			deadline: applicantWithRelationsData.deadline,
			landingPageVersion: applicantWithRelationsData.landingPageVersion,
			forwardedAt: applicantWithRelationsData.forwardedAt,
			receivedAt: applicantWithRelationsData.receivedAt,
			customerNotes: applicantWithRelationsData.customerNotes,
			documentCount: applicantWithRelationsData.documentCount,
			unreadDocumentCount: applicantWithRelationsData.unreadDocumentCount,
			token: applicantWithRelationsData.token,
			referralSource: applicantWithRelationsData.referralSource,
			talentPoolConsentGiven: applicantWithRelationsData.talentPoolConsentGiven,
			shareLinkWithNotes: applicantWithRelationsData.shareLinkWithNotes,
			shareLinkToken: applicantWithRelationsData.shareLinkToken,
			hasCustomerNoteComments: applicantWithRelationsData.hasCustomerNoteComments,
			safeDocumentCount: applicantWithRelationsData.safeDocumentCount,
			duplicatedApplicants: applicantWithRelationsData.duplicatedApplicants,
			origin: applicantWithRelationsData.origin,
			prequalificationStatus: applicantWithRelationsData.prequalificationStatus,
			lastPhaseChangeRole: applicantWithRelationsData.lastPhaseChangeRole,
			documents: applicantWithRelationsData.documents,
			createdAt: applicantWithRelationsData.createdAt,
			updatedAt: applicantWithRelationsData.updatedAt
		});
	}
};
// source/models/blocked-applicant/blocked-applicant.ts
var BlockedApplicant = class BlockedApplicant {
	id;
	normalizedPhoneNumber;
	email;
	reason;
	blockedAt;
	createdAt;
	updatedAt;
	constructor({ id, normalizedPhoneNumber, email, reason, blockedAt, createdAt, updatedAt }) {
		this.id = id;
		this.normalizedPhoneNumber = normalizedPhoneNumber;
		this.email = email;
		this.reason = reason;
		this.blockedAt = blockedAt;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(applicantPhaseDbObject) {
		return new BlockedApplicant({
			id: applicantPhaseDbObject.id,
			normalizedPhoneNumber: applicantPhaseDbObject.normalized_phone_number,
			email: applicantPhaseDbObject.email,
			reason: applicantPhaseDbObject.reason,
			blockedAt: applicantPhaseDbObject.blocked_at,
			createdAt: applicantPhaseDbObject.created_at,
			updatedAt: applicantPhaseDbObject.updated_at
		});
	}
};
// source/models/blocked-applicant/blocked-applicant-creation-dto.ts
var BlockedApplicantCreationDto = class BlockedApplicantCreationDto {
	normalizedPhoneNumber;
	email;
	reason;
	constructor({ normalizedPhoneNumber, email, reason }) {
		this.normalizedPhoneNumber = normalizedPhoneNumber;
		this.email = email;
		this.reason = reason;
	}
	convertToDbObject() {
		return {
			normalized_phone_number: this.normalizedPhoneNumber,
			email: this.email,
			reason: this.reason
		};
	}
	static createFromData(data) {
		return new BlockedApplicantCreationDto(data);
	}
};
// source/models/blocked-applicant/blocked-applicant-dto.ts
var BlockedApplicantDto = class BlockedApplicantDto {
	id;
	normalizedPhoneNumber;
	email;
	reason;
	blockedAt;
	createdAt;
	updatedAt;
	constructor({ id, normalizedPhoneNumber, email, reason, blockedAt, createdAt, updatedAt }) {
		this.id = id;
		this.normalizedPhoneNumber = normalizedPhoneNumber;
		this.email = email;
		this.reason = reason;
		this.blockedAt = blockedAt;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromBlockedApplicant(blockedApplicant) {
		return new BlockedApplicantDto(blockedApplicant);
	}
	static createFromBlockedApplicantData(data) {
		return new BlockedApplicantDto({
			id: data.id,
			normalizedPhoneNumber: data.normalizedPhoneNumber,
			email: data.email,
			reason: data.reason,
			blockedAt: data.blockedAt,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
	toBlockedApplicant() {
		return new BlockedApplicant({
			id: this.id,
			normalizedPhoneNumber: this.normalizedPhoneNumber,
			email: this.email,
			reason: this.reason,
			blockedAt: this.blockedAt,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
};
// source/models/blocked-applicant/blocked-applicant-update-dto.ts
var BlockedApplicantUpdateDto = class BlockedApplicantUpdateDto {
	normalizedPhoneNumber;
	email;
	reason;
	constructor({ normalizedPhoneNumber = null, email = null, reason }) {
		this.normalizedPhoneNumber = normalizedPhoneNumber;
		this.email = email;
		this.reason = reason;
	}
	convertToDbObject() {
		return {
			normalized_phone_number: this.normalizedPhoneNumber,
			email: this.email,
			reason: this.reason
		};
	}
	static createFromData(data) {
		return new BlockedApplicantUpdateDto(data);
	}
};
// source/models/career/career.ts
var Career = class Career {
	isActive;
	publishStatus;
	publish;
	publishedAt;
	general;
	design;
	global;
	trainees;
	jobs;
	createdAt;
	updatedAt;
	constructor(params) {
		this.isActive = params.isActive;
		this.publishStatus = params.publishStatus;
		this.publish = params.publish;
		this.publishedAt = params.publishedAt;
		this.general = params.general;
		this.design = params.design;
		this.global = params.global;
		this.trainees = params.trainees;
		this.jobs = params.jobs;
		this.createdAt = params.createdAt;
		this.updatedAt = params.updatedAt;
	}
	static createFromDbObject(db) {
		return new Career({
			isActive: db.is_active,
			publishStatus: db.publish_status,
			publish: db.publish,
			publishedAt: db.published_at,
			general: db.general,
			design: db.design,
			global: db.global,
			trainees: db.trainees,
			jobs: db.jobs,
			createdAt: db.created_at,
			updatedAt: db.updated_at
		});
	}
};
// source/models/career/career-creation-dto.ts
var CareerCreationDto = class CareerCreationDto {
	publish;
	general;
	design;
	global;
	trainees;
	jobs;
	constructor({ publish, general, design, global, trainees, jobs }) {
		this.publish = publish;
		this.general = general;
		this.design = design;
		this.global = global;
		this.trainees = trainees;
		this.jobs = jobs;
	}
	static createFromCareerCreationData(data) {
		return new CareerCreationDto({
			publish: data.publish,
			general: data.general,
			design: data.design,
			global: data.global,
			trainees: data.trainees,
			jobs: data.jobs
		});
	}
	convertToDbObject() {
		return {
			publish: this.publish,
			general: this.general,
			design: this.design,
			global: this.global,
			trainees: this.trainees,
			jobs: this.jobs
		};
	}
};
// source/models/career/career-dto.ts
var CareerDto = class CareerDto {
	isActive;
	publishStatus;
	publishedAt;
	publish;
	general;
	design;
	global;
	trainees;
	jobs;
	createdAt;
	updatedAt;
	constructor(params) {
		this.isActive = params.isActive;
		this.publishStatus = params.publishStatus;
		this.publish = params.publish;
		this.publishedAt = params.publishedAt;
		this.general = params.general;
		this.design = params.design;
		this.global = params.global;
		this.trainees = params.trainees;
		this.jobs = params.jobs;
		this.createdAt = params.createdAt;
		this.updatedAt = params.updatedAt;
	}
	toCareer() {
		return new Career({
			isActive: this.isActive,
			publishStatus: this.publishStatus,
			publishedAt: this.publishedAt,
			publish: this.publish,
			general: this.general,
			design: this.design,
			global: this.global,
			trainees: this.trainees,
			jobs: this.jobs,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromCareer(dto) {
		return new CareerDto({
			isActive: dto.isActive,
			publishStatus: dto.publishStatus,
			publish: dto.publish,
			publishedAt: dto.publishedAt,
			general: dto.general,
			design: dto.design,
			global: dto.global,
			trainees: dto.trainees,
			jobs: dto.jobs,
			createdAt: dto.createdAt,
			updatedAt: dto.updatedAt
		});
	}
	static createFromCareerDtoData(data) {
		return new CareerDto({
			isActive: data.isActive,
			publishStatus: data.publishStatus,
			publish: data.publish,
			publishedAt: data.publishedAt,
			general: data.general,
			design: data.design,
			global: data.global,
			trainees: data.trainees,
			jobs: data.jobs,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
	static createFromDbObject(db) {
		return new CareerDto({
			isActive: db.is_active,
			publishStatus: db.publish_status,
			publish: db.publish,
			publishedAt: db.published_at,
			general: db.general,
			design: db.design,
			global: db.global,
			trainees: db.trainees,
			jobs: db.jobs,
			createdAt: db.created_at,
			updatedAt: db.updated_at
		});
	}
};
// source/models/career/career-update-dto.ts
var CareerUpdateDto = class CareerUpdateDto {
	publish;
	general;
	design;
	global;
	trainees;
	jobs;
	constructor({ publish, general, design, global, trainees, jobs }) {
		this.publish = publish;
		this.general = general;
		this.design = design;
		this.global = global;
		this.trainees = trainees;
		this.jobs = jobs;
	}
	static createFromCareerUpdateData(data) {
		return new CareerUpdateDto({
			publish: data.publish,
			general: data.general,
			design: data.design,
			global: data.global,
			trainees: data.trainees,
			jobs: data.jobs
		});
	}
	convertToDbObject() {
		return {
			publish: this.publish,
			general: this.general,
			design: this.design,
			global: this.global,
			trainees: this.trainees,
			jobs: this.jobs
		};
	}
};
// source/models/company/company.ts
var Company = class Company {
	id;
	customerId;
	applicantManagerId;
	longName;
	shortName;
	mondayName;
	websiteUrl;
	employeeCount;
	foundingYear;
	description;
	platformCredentials;
	ceoName;
	localCourt;
	commercialRegisterNumber;
	zipCode;
	city;
	address;
	createdAt;
	updatedAt;
	designColors;
	logoPath;
	resumePrimaryColor;
	resumePrimaryContrastColor;
	imprint;
	privacy;
	startScreenImagePath;
	googleDriveDownloadUrl;
	googleDriveUploadUrl;
	partnerTodos;
	portalLogoPath;
	dynamicRecruiting;
	contactCareerPageApplicantsOnBehalfOfStahlhart;
	contactImportedAndManualApplicantsOnBehalfOfStahlhart;
	hiringGuarantee;
	hideCustomerApplicantTableColumns;
	showGeneralAnalyticsTab;
	facebookBusinessId;
	instagramFollowerGoal;
	constructor({ id, customerId, applicantManagerId, longName, shortName, mondayName, websiteUrl, employeeCount, foundingYear, description, platformCredentials, ceoName, localCourt, commercialRegisterNumber, zipCode, city, address, createdAt, updatedAt, designColors, logoPath, resumePrimaryColor, resumePrimaryContrastColor, imprint, privacy, startScreenImagePath, googleDriveDownloadUrl, googleDriveUploadUrl, partnerTodos, portalLogoPath, dynamicRecruiting, contactCareerPageApplicantsOnBehalfOfStahlhart, contactImportedAndManualApplicantsOnBehalfOfStahlhart, hiringGuarantee, hideCustomerApplicantTableColumns, showGeneralAnalyticsTab, facebookBusinessId, instagramFollowerGoal }) {
		this.id = id;
		this.customerId = customerId;
		this.applicantManagerId = applicantManagerId;
		this.longName = longName;
		this.shortName = shortName;
		this.mondayName = mondayName;
		this.websiteUrl = websiteUrl;
		this.employeeCount = employeeCount;
		this.foundingYear = foundingYear;
		this.description = description;
		this.platformCredentials = platformCredentials;
		this.imprint = imprint;
		this.privacy = privacy;
		this.ceoName = ceoName;
		this.localCourt = localCourt;
		this.commercialRegisterNumber = commercialRegisterNumber;
		this.zipCode = zipCode;
		this.city = city;
		this.address = address;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
		this.designColors = designColors;
		this.logoPath = logoPath;
		this.resumePrimaryColor = resumePrimaryColor;
		this.resumePrimaryContrastColor = resumePrimaryContrastColor;
		this.startScreenImagePath = startScreenImagePath;
		this.googleDriveDownloadUrl = googleDriveDownloadUrl;
		this.googleDriveUploadUrl = googleDriveUploadUrl;
		this.partnerTodos = partnerTodos;
		this.portalLogoPath = portalLogoPath;
		this.dynamicRecruiting = dynamicRecruiting;
		this.contactCareerPageApplicantsOnBehalfOfStahlhart = contactCareerPageApplicantsOnBehalfOfStahlhart;
		this.contactImportedAndManualApplicantsOnBehalfOfStahlhart = contactImportedAndManualApplicantsOnBehalfOfStahlhart;
		this.hiringGuarantee = hiringGuarantee;
		this.hideCustomerApplicantTableColumns = hideCustomerApplicantTableColumns;
		this.showGeneralAnalyticsTab = showGeneralAnalyticsTab;
		this.facebookBusinessId = facebookBusinessId;
		this.instagramFollowerGoal = instagramFollowerGoal;
	}
	static createFromDbObject(dbObject) {
		return new Company({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			applicantManagerId: dbObject.applicant_manager_id,
			longName: dbObject.long_name,
			shortName: dbObject.short_name,
			mondayName: dbObject.monday_name,
			websiteUrl: dbObject.website_url,
			employeeCount: dbObject.employee_count,
			foundingYear: dbObject.founding_year,
			description: dbObject.description,
			platformCredentials: dbObject.platform_credentials,
			imprint: dbObject.imprint,
			privacy: dbObject.privacy,
			ceoName: dbObject.ceo_name,
			localCourt: dbObject.local_court,
			commercialRegisterNumber: dbObject.commercial_register_number,
			zipCode: dbObject.zip_code,
			city: dbObject.city,
			address: dbObject.address,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at,
			designColors: dbObject.design_colors,
			logoPath: dbObject.logo_path,
			resumePrimaryColor: dbObject.resume_primary_color,
			resumePrimaryContrastColor: dbObject.resume_primary_contrast_color,
			startScreenImagePath: dbObject.start_screen_image_path,
			googleDriveDownloadUrl: dbObject.google_drive_download_url,
			googleDriveUploadUrl: dbObject.google_drive_upload_url,
			partnerTodos: dbObject.partner_todos,
			portalLogoPath: dbObject.portal_logo_path,
			dynamicRecruiting: dbObject.dynamic_recruiting,
			contactCareerPageApplicantsOnBehalfOfStahlhart: dbObject.contact_career_page_applicants_on_behalf_of_stahlhart,
			contactImportedAndManualApplicantsOnBehalfOfStahlhart: dbObject.contact_imported_and_manual_applicants_on_behalf_of_stahlhart,
			hiringGuarantee: dbObject.hiring_guarantee,
			hideCustomerApplicantTableColumns: dbObject.hide_customer_applicant_table_columns,
			showGeneralAnalyticsTab: dbObject.show_general_analytics_tab,
			facebookBusinessId: dbObject.facebook_business_id,
			instagramFollowerGoal: dbObject.instagram_follower_goal
		});
	}
};
// source/models/company/company-creation-dto.ts
var CompanyCreationDto = class CompanyCreationDto {
	longName;
	shortName;
	mondayName;
	websiteUrl;
	employeeCount;
	foundingYear;
	description;
	platformCredentials;
	ceoName;
	localCourt;
	commercialRegisterNumber;
	zipCode;
	city;
	address;
	designColors;
	logoPath;
	resumePrimaryColor;
	imprint;
	privacy;
	resumePrimaryContrastColor;
	startScreenImagePath;
	googleDriveDownloadUrl;
	googleDriveUploadUrl;
	partnerTodos;
	portalLogoPath;
	facebookBusinessId;
	instagramFollowerGoal;
	constructor({ longName, shortName, mondayName, websiteUrl, employeeCount, foundingYear, description, platformCredentials, designColors, logoPath, resumePrimaryColor, resumePrimaryContrastColor, imprint, privacy, ceoName, localCourt, commercialRegisterNumber, zipCode, city, address, startScreenImagePath, googleDriveDownloadUrl, googleDriveUploadUrl, partnerTodos, portalLogoPath, facebookBusinessId, instagramFollowerGoal }) {
		this.longName = longName;
		this.shortName = shortName;
		this.mondayName = mondayName;
		this.websiteUrl = websiteUrl;
		this.employeeCount = employeeCount;
		this.foundingYear = foundingYear;
		this.description = description;
		this.platformCredentials = platformCredentials;
		this.designColors = designColors;
		this.logoPath = logoPath;
		this.resumePrimaryColor = resumePrimaryColor;
		this.resumePrimaryContrastColor = resumePrimaryContrastColor;
		this.imprint = imprint;
		this.privacy = privacy;
		this.ceoName = ceoName;
		this.localCourt = localCourt;
		this.commercialRegisterNumber = commercialRegisterNumber;
		this.zipCode = zipCode;
		this.city = city;
		this.address = address;
		this.startScreenImagePath = startScreenImagePath;
		this.googleDriveDownloadUrl = googleDriveDownloadUrl;
		this.googleDriveUploadUrl = googleDriveUploadUrl;
		this.partnerTodos = partnerTodos;
		this.portalLogoPath = portalLogoPath;
		this.facebookBusinessId = facebookBusinessId;
		this.instagramFollowerGoal = instagramFollowerGoal;
	}
	static createFromCompanyCreationData(data) {
		return new CompanyCreationDto({
			longName: data.longName,
			shortName: data.shortName,
			mondayName: data.mondayName,
			websiteUrl: data.websiteUrl,
			employeeCount: data.employeeCount,
			foundingYear: data.foundingYear,
			description: data.description,
			platformCredentials: data.platformCredentials,
			designColors: data.designColors,
			logoPath: data.logoPath,
			resumePrimaryColor: data.resumePrimaryColor,
			resumePrimaryContrastColor: data.resumePrimaryContrastColor,
			imprint: data.imprint,
			privacy: data.privacy,
			ceoName: data.ceoName,
			localCourt: data.localCourt,
			commercialRegisterNumber: data.commercialRegisterNumber,
			zipCode: data.zipCode,
			city: data.city,
			address: data.address,
			startScreenImagePath: data.startScreenImagePath,
			googleDriveDownloadUrl: data.googleDriveDownloadUrl,
			googleDriveUploadUrl: data.googleDriveUploadUrl,
			partnerTodos: data.partnerTodos,
			portalLogoPath: data.portalLogoPath,
			facebookBusinessId: data.facebookBusinessId,
			instagramFollowerGoal: data.instagramFollowerGoal
		});
	}
	convertToDbObject() {
		return {
			long_name: this.longName,
			short_name: this.shortName,
			monday_name: this.mondayName,
			website_url: this.websiteUrl,
			employee_count: this.employeeCount,
			founding_year: this.foundingYear,
			description: this.description,
			platform_credentials: this.platformCredentials,
			design_colors: this.designColors,
			logo_path: this.logoPath,
			resume_primary_color: this.resumePrimaryColor,
			resume_primary_contrast_color: this.resumePrimaryContrastColor,
			imprint: this.imprint,
			privacy: this.privacy,
			ceo_name: this.ceoName,
			local_court: this.localCourt,
			commercial_register_number: this.commercialRegisterNumber,
			zip_code: this.zipCode,
			city: this.city,
			address: this.address,
			start_screen_image_path: this.startScreenImagePath,
			google_drive_download_url: this.googleDriveDownloadUrl,
			google_drive_upload_url: this.googleDriveUploadUrl,
			partner_todos: this.partnerTodos,
			portal_logo_path: this.portalLogoPath,
			facebook_business_id: this.facebookBusinessId,
			instagram_follower_goal: this.instagramFollowerGoal
		};
	}
};
// source/models/company/company-dto.ts
var CompanyDto = class CompanyDto {
	id;
	customerId;
	applicantManagerId;
	longName;
	shortName;
	mondayName;
	websiteUrl;
	employeeCount;
	foundingYear;
	description;
	platformCredentials;
	ceoName;
	localCourt;
	commercialRegisterNumber;
	zipCode;
	city;
	address;
	createdAt;
	updatedAt;
	imprint;
	privacy;
	designColors;
	logoPath;
	resumePrimaryColor;
	resumePrimaryContrastColor;
	startScreenImagePath;
	googleDriveDownloadUrl;
	googleDriveUploadUrl;
	partnerTodos;
	portalLogoPath;
	dynamicRecruiting;
	contactCareerPageApplicantsOnBehalfOfStahlhart;
	contactImportedAndManualApplicantsOnBehalfOfStahlhart;
	hiringGuarantee;
	hideCustomerApplicantTableColumns;
	showGeneralAnalyticsTab;
	facebookBusinessId;
	instagramFollowerGoal;
	constructor({ id, customerId, applicantManagerId, longName, shortName, mondayName, websiteUrl, employeeCount, foundingYear, description, platformCredentials, imprint, privacy, createdAt, updatedAt, designColors, logoPath, resumePrimaryColor, resumePrimaryContrastColor, ceoName, localCourt, commercialRegisterNumber, zipCode, city, address, startScreenImagePath, googleDriveDownloadUrl, googleDriveUploadUrl, partnerTodos, portalLogoPath, dynamicRecruiting, contactCareerPageApplicantsOnBehalfOfStahlhart, contactImportedAndManualApplicantsOnBehalfOfStahlhart, hiringGuarantee, hideCustomerApplicantTableColumns, showGeneralAnalyticsTab, facebookBusinessId, instagramFollowerGoal }) {
		this.id = id;
		this.customerId = customerId;
		this.applicantManagerId = applicantManagerId;
		this.longName = longName;
		this.shortName = shortName;
		this.mondayName = mondayName;
		this.websiteUrl = websiteUrl;
		this.employeeCount = employeeCount;
		this.foundingYear = foundingYear;
		this.description = description;
		this.platformCredentials = platformCredentials;
		this.imprint = imprint;
		this.privacy = privacy;
		this.ceoName = ceoName;
		this.localCourt = localCourt;
		this.commercialRegisterNumber = commercialRegisterNumber;
		this.zipCode = zipCode;
		this.city = city;
		this.address = address;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
		this.designColors = designColors;
		this.logoPath = logoPath;
		this.resumePrimaryColor = resumePrimaryColor;
		this.resumePrimaryContrastColor = resumePrimaryContrastColor;
		this.startScreenImagePath = startScreenImagePath;
		this.googleDriveDownloadUrl = googleDriveDownloadUrl;
		this.googleDriveUploadUrl = googleDriveUploadUrl;
		this.partnerTodos = partnerTodos;
		this.portalLogoPath = portalLogoPath;
		this.dynamicRecruiting = dynamicRecruiting;
		this.contactCareerPageApplicantsOnBehalfOfStahlhart = contactCareerPageApplicantsOnBehalfOfStahlhart;
		this.contactImportedAndManualApplicantsOnBehalfOfStahlhart = contactImportedAndManualApplicantsOnBehalfOfStahlhart;
		this.hiringGuarantee = hiringGuarantee;
		this.hideCustomerApplicantTableColumns = hideCustomerApplicantTableColumns;
		this.showGeneralAnalyticsTab = showGeneralAnalyticsTab;
		this.facebookBusinessId = facebookBusinessId;
		this.instagramFollowerGoal = instagramFollowerGoal;
	}
	toCompany() {
		return new Company({
			id: this.id,
			customerId: this.customerId,
			applicantManagerId: this.applicantManagerId,
			longName: this.longName,
			shortName: this.shortName,
			mondayName: this.mondayName,
			websiteUrl: this.websiteUrl,
			employeeCount: this.employeeCount,
			foundingYear: this.foundingYear,
			description: this.description,
			platformCredentials: this.platformCredentials,
			imprint: this.imprint,
			privacy: this.privacy,
			ceoName: this.ceoName,
			localCourt: this.localCourt,
			commercialRegisterNumber: this.commercialRegisterNumber,
			zipCode: this.zipCode,
			city: this.city,
			address: this.address,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt,
			designColors: this.designColors,
			logoPath: this.logoPath,
			resumePrimaryColor: this.resumePrimaryColor,
			resumePrimaryContrastColor: this.resumePrimaryContrastColor,
			startScreenImagePath: this.startScreenImagePath,
			googleDriveDownloadUrl: this.googleDriveDownloadUrl,
			googleDriveUploadUrl: this.googleDriveUploadUrl,
			partnerTodos: this.partnerTodos,
			portalLogoPath: this.portalLogoPath,
			dynamicRecruiting: this.dynamicRecruiting,
			contactCareerPageApplicantsOnBehalfOfStahlhart: this.contactCareerPageApplicantsOnBehalfOfStahlhart,
			contactImportedAndManualApplicantsOnBehalfOfStahlhart: this.contactImportedAndManualApplicantsOnBehalfOfStahlhart,
			hiringGuarantee: this.hiringGuarantee,
			hideCustomerApplicantTableColumns: this.hideCustomerApplicantTableColumns,
			showGeneralAnalyticsTab: this.showGeneralAnalyticsTab,
			facebookBusinessId: this.facebookBusinessId,
			instagramFollowerGoal: this.instagramFollowerGoal
		});
	}
	static createFromCompany(company) {
		return new CompanyDto({
			id: company.id,
			customerId: company.customerId,
			applicantManagerId: company.applicantManagerId,
			longName: company.longName,
			shortName: company.shortName,
			mondayName: company.mondayName,
			websiteUrl: company.websiteUrl,
			employeeCount: company.employeeCount,
			foundingYear: company.foundingYear,
			description: company.description,
			platformCredentials: company.platformCredentials,
			imprint: company.imprint,
			privacy: company.privacy,
			ceoName: company.ceoName,
			localCourt: company.localCourt,
			commercialRegisterNumber: company.commercialRegisterNumber,
			zipCode: company.zipCode,
			city: company.city,
			address: company.address,
			createdAt: company.createdAt,
			updatedAt: company.updatedAt,
			designColors: company.designColors,
			logoPath: company.logoPath,
			resumePrimaryColor: company.resumePrimaryColor,
			resumePrimaryContrastColor: company.resumePrimaryContrastColor,
			startScreenImagePath: company.startScreenImagePath,
			googleDriveDownloadUrl: company.googleDriveDownloadUrl,
			googleDriveUploadUrl: company.googleDriveUploadUrl,
			partnerTodos: company.partnerTodos,
			portalLogoPath: company.portalLogoPath,
			dynamicRecruiting: company.dynamicRecruiting,
			contactCareerPageApplicantsOnBehalfOfStahlhart: company.contactCareerPageApplicantsOnBehalfOfStahlhart,
			contactImportedAndManualApplicantsOnBehalfOfStahlhart: company.contactImportedAndManualApplicantsOnBehalfOfStahlhart,
			hiringGuarantee: company.hiringGuarantee,
			hideCustomerApplicantTableColumns: company.hideCustomerApplicantTableColumns,
			showGeneralAnalyticsTab: company.showGeneralAnalyticsTab,
			facebookBusinessId: company.facebookBusinessId,
			instagramFollowerGoal: company.instagramFollowerGoal
		});
	}
	static createFromCompanyData(data) {
		return new CompanyDto({
			id: data.id,
			customerId: data.customerId,
			applicantManagerId: data.applicantManagerId,
			longName: data.longName,
			shortName: data.shortName,
			mondayName: data.mondayName,
			websiteUrl: data.websiteUrl,
			employeeCount: data.employeeCount,
			foundingYear: data.foundingYear,
			description: data.description,
			platformCredentials: data.platformCredentials,
			imprint: data.imprint,
			privacy: data.privacy,
			ceoName: data.ceoName,
			localCourt: data.localCourt,
			commercialRegisterNumber: data.commercialRegisterNumber,
			zipCode: data.zipCode,
			city: data.city,
			address: data.address,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt,
			designColors: data.designColors,
			logoPath: data.logoPath,
			resumePrimaryColor: data.resumePrimaryColor,
			resumePrimaryContrastColor: data.resumePrimaryContrastColor,
			startScreenImagePath: data.startScreenImagePath,
			googleDriveDownloadUrl: data.googleDriveDownloadUrl,
			googleDriveUploadUrl: data.googleDriveUploadUrl,
			partnerTodos: data.partnerTodos,
			portalLogoPath: data.portalLogoPath,
			dynamicRecruiting: data.dynamicRecruiting,
			contactCareerPageApplicantsOnBehalfOfStahlhart: data.contactCareerPageApplicantsOnBehalfOfStahlhart,
			contactImportedAndManualApplicantsOnBehalfOfStahlhart: data.contactImportedAndManualApplicantsOnBehalfOfStahlhart,
			hiringGuarantee: data.hiringGuarantee,
			hideCustomerApplicantTableColumns: data.hideCustomerApplicantTableColumns,
			showGeneralAnalyticsTab: data.showGeneralAnalyticsTab,
			facebookBusinessId: data.facebookBusinessId,
			instagramFollowerGoal: data.instagramFollowerGoal
		});
	}
	static createFromDbObject(dbObject) {
		return new CompanyDto({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			applicantManagerId: dbObject.applicant_manager_id,
			longName: dbObject.long_name,
			shortName: dbObject.short_name,
			mondayName: dbObject.monday_name,
			websiteUrl: dbObject.website_url,
			employeeCount: dbObject.employee_count,
			foundingYear: dbObject.founding_year,
			description: dbObject.description,
			platformCredentials: dbObject.platform_credentials,
			imprint: dbObject.imprint,
			privacy: dbObject.privacy,
			ceoName: dbObject.ceo_name,
			localCourt: dbObject.local_court,
			commercialRegisterNumber: dbObject.commercial_register_number,
			zipCode: dbObject.zip_code,
			city: dbObject.city,
			address: dbObject.address,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at,
			designColors: dbObject.design_colors,
			logoPath: dbObject.logo_path,
			resumePrimaryColor: dbObject.resume_primary_color,
			resumePrimaryContrastColor: dbObject.resume_primary_contrast_color,
			startScreenImagePath: dbObject.start_screen_image_path,
			googleDriveDownloadUrl: dbObject.google_drive_download_url,
			googleDriveUploadUrl: dbObject.google_drive_upload_url,
			partnerTodos: dbObject.partner_todos,
			portalLogoPath: dbObject.portal_logo_path,
			dynamicRecruiting: dbObject.dynamic_recruiting,
			contactCareerPageApplicantsOnBehalfOfStahlhart: dbObject.contact_career_page_applicants_on_behalf_of_stahlhart,
			contactImportedAndManualApplicantsOnBehalfOfStahlhart: dbObject.contact_imported_and_manual_applicants_on_behalf_of_stahlhart,
			hiringGuarantee: dbObject.hiring_guarantee,
			hideCustomerApplicantTableColumns: dbObject.hide_customer_applicant_table_columns,
			showGeneralAnalyticsTab: dbObject.show_general_analytics_tab,
			facebookBusinessId: dbObject.facebook_business_id,
			instagramFollowerGoal: dbObject.instagram_follower_goal
		});
	}
};
// source/models/company/company-public.ts
var CompanyPublic = class CompanyPublic {
	id;
	longName;
	shortName;
	websiteUrl;
	description;
	ceoName;
	localCourt;
	commercialRegisterNumber;
	zipCode;
	city;
	address;
	designColors;
	logoPath;
	resumePrimaryColor;
	resumePrimaryContrastColor;
	imprint;
	privacy;
	constructor({ longName, shortName, websiteUrl, description, ceoName, localCourt, commercialRegisterNumber, zipCode, city, address, designColors, logoPath, resumePrimaryColor, resumePrimaryContrastColor, imprint, privacy }) {
		this.longName = longName;
		this.shortName = shortName;
		this.websiteUrl = websiteUrl;
		this.description = description;
		this.imprint = imprint;
		this.privacy = privacy;
		this.ceoName = ceoName;
		this.localCourt = localCourt;
		this.commercialRegisterNumber = commercialRegisterNumber;
		this.zipCode = zipCode;
		this.city = city;
		this.address = address;
		this.designColors = designColors;
		this.logoPath = logoPath;
		this.resumePrimaryColor = resumePrimaryColor;
		this.resumePrimaryContrastColor = resumePrimaryContrastColor;
	}
	static createFromDbObject(dbObject) {
		return new CompanyPublic({
			longName: dbObject.long_name,
			shortName: dbObject.short_name,
			websiteUrl: dbObject.website_url,
			description: dbObject.description,
			imprint: dbObject.imprint,
			privacy: dbObject.privacy,
			ceoName: dbObject.ceo_name,
			localCourt: dbObject.local_court,
			commercialRegisterNumber: dbObject.commercial_register_number,
			zipCode: dbObject.zip_code,
			city: dbObject.city,
			address: dbObject.address,
			designColors: dbObject.design_colors,
			logoPath: dbObject.logo_path,
			resumePrimaryColor: dbObject.resume_primary_color,
			resumePrimaryContrastColor: dbObject.resume_primary_contrast_color
		});
	}
};
// source/models/company/company-public-dto.ts
var CompanyPublicDto = class CompanyPublicDto {
	longName;
	shortName;
	websiteUrl;
	description;
	ceoName;
	localCourt;
	commercialRegisterNumber;
	zipCode;
	city;
	address;
	imprint;
	privacy;
	designColors;
	logoPath;
	resumePrimaryColor;
	resumePrimaryContrastColor;
	constructor({ longName, shortName, websiteUrl, description, imprint, privacy, designColors, logoPath, resumePrimaryColor, resumePrimaryContrastColor, ceoName, localCourt, commercialRegisterNumber, zipCode, city, address }) {
		this.longName = longName;
		this.shortName = shortName;
		this.websiteUrl = websiteUrl;
		this.description = description;
		this.imprint = imprint;
		this.privacy = privacy;
		this.ceoName = ceoName;
		this.localCourt = localCourt;
		this.commercialRegisterNumber = commercialRegisterNumber;
		this.zipCode = zipCode;
		this.city = city;
		this.address = address;
		this.designColors = designColors;
		this.logoPath = logoPath;
		this.resumePrimaryColor = resumePrimaryColor;
		this.resumePrimaryContrastColor = resumePrimaryContrastColor;
	}
	toCompanyPublic() {
		return new CompanyPublic({
			longName: this.longName,
			shortName: this.shortName,
			websiteUrl: this.websiteUrl,
			description: this.description,
			imprint: this.imprint,
			privacy: this.privacy,
			ceoName: this.ceoName,
			localCourt: this.localCourt,
			commercialRegisterNumber: this.commercialRegisterNumber,
			zipCode: this.zipCode,
			city: this.city,
			address: this.address,
			designColors: this.designColors,
			logoPath: this.logoPath,
			resumePrimaryColor: this.resumePrimaryColor,
			resumePrimaryContrastColor: this.resumePrimaryContrastColor
		});
	}
	static createFromCompanyPublic(company) {
		return new CompanyPublicDto({
			longName: company.longName,
			shortName: company.shortName,
			websiteUrl: company.websiteUrl,
			description: company.description,
			imprint: company.imprint,
			privacy: company.privacy,
			ceoName: company.ceoName,
			localCourt: company.localCourt,
			commercialRegisterNumber: company.commercialRegisterNumber,
			zipCode: company.zipCode,
			city: company.city,
			address: company.address,
			designColors: company.designColors,
			logoPath: company.logoPath,
			resumePrimaryColor: company.resumePrimaryColor,
			resumePrimaryContrastColor: company.resumePrimaryContrastColor
		});
	}
	static createFromCompany(company) {
		return new CompanyPublicDto({
			longName: company.longName,
			shortName: company.shortName,
			websiteUrl: company.websiteUrl,
			description: company.description,
			imprint: company.imprint,
			privacy: company.privacy,
			ceoName: company.ceoName,
			localCourt: company.localCourt,
			commercialRegisterNumber: company.commercialRegisterNumber,
			zipCode: company.zipCode,
			city: company.city,
			address: company.address,
			designColors: company.designColors,
			logoPath: company.logoPath,
			resumePrimaryColor: company.resumePrimaryColor,
			resumePrimaryContrastColor: company.resumePrimaryContrastColor
		});
	}
	static createFromCompanyData(data) {
		return new CompanyPublicDto({
			longName: data.longName,
			shortName: data.shortName,
			websiteUrl: data.websiteUrl,
			description: data.description,
			imprint: data.imprint,
			privacy: data.privacy,
			ceoName: data.ceoName,
			localCourt: data.localCourt,
			commercialRegisterNumber: data.commercialRegisterNumber,
			zipCode: data.zipCode,
			city: data.city,
			address: data.address,
			designColors: data.designColors,
			logoPath: data.logoPath,
			resumePrimaryColor: data.resumePrimaryColor,
			resumePrimaryContrastColor: data.resumePrimaryContrastColor
		});
	}
	static createFromDbObject(dbObject) {
		return new CompanyPublicDto({
			longName: dbObject.long_name,
			shortName: dbObject.short_name,
			websiteUrl: dbObject.website_url,
			description: dbObject.description,
			imprint: dbObject.imprint,
			privacy: dbObject.privacy,
			ceoName: dbObject.ceo_name,
			localCourt: dbObject.local_court,
			commercialRegisterNumber: dbObject.commercial_register_number,
			zipCode: dbObject.zip_code,
			city: dbObject.city,
			address: dbObject.address,
			designColors: dbObject.design_colors,
			logoPath: dbObject.logo_path,
			resumePrimaryColor: dbObject.resume_primary_color,
			resumePrimaryContrastColor: dbObject.resume_primary_contrast_color
		});
	}
};
// source/models/company/company-update-dto.ts
var CompanyUpdateDto = class CompanyUpdateDto {
	longName;
	shortName;
	websiteUrl;
	employeeCount;
	foundingYear;
	description;
	platformCredentials;
	designColors;
	logoPath;
	resumePrimaryColor;
	imprint;
	privacy;
	resumePrimaryContrastColor;
	ceoName;
	localCourt;
	commercialRegisterNumber;
	zipCode;
	city;
	address;
	startScreenImagePath;
	googleDriveDownloadUrl;
	googleDriveUploadUrl;
	partnerTodos;
	portalLogoPath;
	facebookBusinessId;
	instagramFollowerGoal;
	contactCareerPageApplicantsOnBehalfOfStahlhart;
	contactImportedAndManualApplicantsOnBehalfOfStahlhart;
	hiringGuarantee;
	hideCustomerApplicantTableColumns;
	showGeneralAnalyticsTab;
	constructor({ longName, shortName, websiteUrl, employeeCount, foundingYear, description, platformCredentials, designColors, logoPath, resumePrimaryColor, imprint, privacy, resumePrimaryContrastColor, ceoName, localCourt, commercialRegisterNumber, zipCode, city, address, startScreenImagePath, googleDriveDownloadUrl, googleDriveUploadUrl, partnerTodos, portalLogoPath, facebookBusinessId, instagramFollowerGoal, contactCareerPageApplicantsOnBehalfOfStahlhart, contactImportedAndManualApplicantsOnBehalfOfStahlhart, hiringGuarantee, hideCustomerApplicantTableColumns, showGeneralAnalyticsTab }) {
		this.longName = longName;
		this.shortName = shortName;
		this.websiteUrl = websiteUrl;
		this.employeeCount = employeeCount;
		this.foundingYear = foundingYear;
		this.description = description;
		this.platformCredentials = platformCredentials;
		this.designColors = designColors;
		this.logoPath = logoPath;
		this.resumePrimaryColor = resumePrimaryColor;
		this.imprint = imprint;
		this.privacy = privacy;
		this.resumePrimaryContrastColor = resumePrimaryContrastColor;
		this.ceoName = ceoName;
		this.localCourt = localCourt;
		this.commercialRegisterNumber = commercialRegisterNumber;
		this.zipCode = zipCode;
		this.city = city;
		this.address = address;
		this.startScreenImagePath = startScreenImagePath;
		this.googleDriveDownloadUrl = googleDriveDownloadUrl;
		this.googleDriveUploadUrl = googleDriveUploadUrl;
		this.partnerTodos = partnerTodos;
		this.portalLogoPath = portalLogoPath;
		this.facebookBusinessId = facebookBusinessId;
		this.instagramFollowerGoal = instagramFollowerGoal;
		this.contactCareerPageApplicantsOnBehalfOfStahlhart = contactCareerPageApplicantsOnBehalfOfStahlhart;
		this.contactImportedAndManualApplicantsOnBehalfOfStahlhart = contactImportedAndManualApplicantsOnBehalfOfStahlhart;
		this.hiringGuarantee = hiringGuarantee;
		this.hideCustomerApplicantTableColumns = hideCustomerApplicantTableColumns;
		this.showGeneralAnalyticsTab = showGeneralAnalyticsTab;
	}
	static createFromCompanyUpdateData(data) {
		return new CompanyUpdateDto({
			longName: data.longName,
			shortName: data.shortName,
			websiteUrl: data.websiteUrl,
			employeeCount: data.employeeCount,
			foundingYear: data.foundingYear,
			description: data.description,
			platformCredentials: data.platformCredentials,
			designColors: data.designColors,
			logoPath: data.logoPath,
			resumePrimaryColor: data.resumePrimaryColor,
			imprint: data.imprint,
			privacy: data.privacy,
			resumePrimaryContrastColor: data.resumePrimaryContrastColor,
			ceoName: data.ceoName,
			localCourt: data.localCourt,
			commercialRegisterNumber: data.commercialRegisterNumber,
			zipCode: data.zipCode,
			city: data.city,
			address: data.address,
			startScreenImagePath: data.startScreenImagePath,
			googleDriveDownloadUrl: data.googleDriveDownloadUrl,
			googleDriveUploadUrl: data.googleDriveUploadUrl,
			partnerTodos: data.partnerTodos,
			portalLogoPath: data.portalLogoPath,
			facebookBusinessId: data.facebookBusinessId,
			instagramFollowerGoal: data.instagramFollowerGoal,
			contactCareerPageApplicantsOnBehalfOfStahlhart: data.contactCareerPageApplicantsOnBehalfOfStahlhart,
			contactImportedAndManualApplicantsOnBehalfOfStahlhart: data.contactImportedAndManualApplicantsOnBehalfOfStahlhart,
			hiringGuarantee: data.hiringGuarantee,
			hideCustomerApplicantTableColumns: data.hideCustomerApplicantTableColumns,
			showGeneralAnalyticsTab: data.showGeneralAnalyticsTab
		});
	}
	convertToDbObject() {
		return {
			long_name: this.longName,
			short_name: this.shortName,
			website_url: this.websiteUrl,
			employee_count: this.employeeCount,
			founding_year: this.foundingYear,
			description: this.description,
			platform_credentials: this.platformCredentials,
			design_colors: this.designColors,
			logo_path: this.logoPath,
			resume_primary_color: this.resumePrimaryColor,
			imprint: this.imprint,
			privacy: this.privacy,
			resume_primary_contrast_color: this.resumePrimaryContrastColor,
			ceo_name: this.ceoName,
			local_court: this.localCourt,
			commercial_register_number: this.commercialRegisterNumber,
			zip_code: this.zipCode,
			city: this.city,
			address: this.address,
			start_screen_image_path: this.startScreenImagePath,
			google_drive_download_url: this.googleDriveDownloadUrl,
			google_drive_upload_url: this.googleDriveUploadUrl,
			partner_todos: this.partnerTodos,
			portal_logo_path: this.portalLogoPath,
			facebook_business_id: this.facebookBusinessId,
			instagram_follower_goal: this.instagramFollowerGoal,
			contact_career_page_applicants_on_behalf_of_stahlhart: this.contactCareerPageApplicantsOnBehalfOfStahlhart,
			contact_imported_and_manual_applicants_on_behalf_of_stahlhart: this.contactImportedAndManualApplicantsOnBehalfOfStahlhart,
			hiring_guarantee: this.hiringGuarantee,
			hide_customer_applicant_table_columns: this.hideCustomerApplicantTableColumns,
			show_general_analytics_tab: this.showGeneralAnalyticsTab
		};
	}
};
// source/models/customer/customer.ts
var Customer = class Customer {
	id;
	firebaseUid;
	mondayItemId;
	/**
	* @deprecated NPS logs are not used anymore, kept for backward compatibility and removal in future versions
	*/
	lastNpsSentAt;
	/**
	* @deprecated NPS logs are not used anymore, kept for backward compatibility and removal in future versions
	*/
	lastNpsScore;
	emailAddress;
	isFrameworkAgreement;
	agreementEnd;
	careerPageStatus;
	careerPageEndDate;
	/**
	* @deprecated Not used any more
	*/
	careerPageMonthlyAdBudget;
	searchAdBooked;
	searchAdStatus;
	searchAdEndDate;
	searchAdMonthlyBudget;
	socialMediaSupportBooked;
	socialMediaSupportEndDate;
	socialMediaCreditTransactions;
	socialMediaTotalCredits;
	socialMediaMonthlyAdsBudget;
	socialMediaMonthlyPostCount;
	socialMediaFigmaBoardUrl;
	socialMediaSupportStatus;
	customerAcquisitionSearchAdEndDate;
	customerAcquisitionSearchAdBooked;
	customerAcquisitionSearchAdMonthlyBudget;
	customerAcquisitionSearchAdStatus;
	projectManager;
	hasDirectApproaches;
	isCommissionAgreement;
	isRecruitingAgreement;
	isCareerPageReceiptConfirmationActive;
	isSocialMediaAnalyticsActive;
	websiteStatus;
	websiteEndDate;
	productVersion;
	isRecruitingAutoRenewActive;
	isCareerPageAutoRenewActive;
	isWebsiteAutoRenewActive;
	isSocialMediaSupportAutoRenewActive;
	createdAt;
	updatedAt;
	constructor({ id, firebaseUid, mondayItemId, lastNpsSentAt, lastNpsScore, emailAddress, isFrameworkAgreement, agreementEnd, careerPageStatus, careerPageEndDate, careerPageMonthlyAdBudget, searchAdEndDate, searchAdBooked, searchAdMonthlyBudget, searchAdStatus, socialMediaSupportBooked, socialMediaSupportEndDate, socialMediaCreditTransactions, socialMediaTotalCredits, socialMediaMonthlyAdsBudget, socialMediaMonthlyPostCount, socialMediaFigmaBoardUrl, socialMediaSupportStatus, customerAcquisitionSearchAdEndDate, customerAcquisitionSearchAdBooked, customerAcquisitionSearchAdMonthlyBudget, customerAcquisitionSearchAdStatus, projectManager, hasDirectApproaches, isCommissionAgreement, isRecruitingAgreement, isCareerPageReceiptConfirmationActive, isSocialMediaAnalyticsActive, websiteStatus, websiteEndDate, productVersion, isRecruitingAutoRenewActive, isCareerPageAutoRenewActive, isWebsiteAutoRenewActive, isSocialMediaSupportAutoRenewActive, createdAt, updatedAt }) {
		this.id = id;
		this.firebaseUid = firebaseUid;
		this.mondayItemId = mondayItemId;
		this.lastNpsSentAt = lastNpsSentAt;
		this.lastNpsScore = lastNpsScore;
		this.emailAddress = emailAddress;
		this.isFrameworkAgreement = isFrameworkAgreement;
		this.agreementEnd = agreementEnd;
		this.careerPageStatus = careerPageStatus;
		this.searchAdBooked = searchAdBooked;
		this.careerPageEndDate = careerPageEndDate;
		this.careerPageMonthlyAdBudget = careerPageMonthlyAdBudget;
		this.searchAdEndDate = searchAdEndDate;
		this.searchAdStatus = searchAdStatus;
		this.searchAdMonthlyBudget = searchAdMonthlyBudget;
		this.socialMediaSupportBooked = socialMediaSupportBooked;
		this.socialMediaSupportEndDate = socialMediaSupportEndDate;
		this.socialMediaCreditTransactions = socialMediaCreditTransactions;
		this.socialMediaTotalCredits = socialMediaTotalCredits;
		this.socialMediaMonthlyAdsBudget = socialMediaMonthlyAdsBudget;
		this.socialMediaMonthlyPostCount = socialMediaMonthlyPostCount;
		this.socialMediaFigmaBoardUrl = socialMediaFigmaBoardUrl;
		this.socialMediaSupportStatus = socialMediaSupportStatus;
		this.customerAcquisitionSearchAdEndDate = customerAcquisitionSearchAdEndDate;
		this.customerAcquisitionSearchAdBooked = customerAcquisitionSearchAdBooked;
		this.customerAcquisitionSearchAdMonthlyBudget = customerAcquisitionSearchAdMonthlyBudget;
		this.customerAcquisitionSearchAdStatus = customerAcquisitionSearchAdStatus;
		this.projectManager = projectManager;
		this.hasDirectApproaches = hasDirectApproaches;
		this.isCommissionAgreement = isCommissionAgreement;
		this.isRecruitingAgreement = isRecruitingAgreement;
		this.isCareerPageReceiptConfirmationActive = isCareerPageReceiptConfirmationActive;
		this.isSocialMediaAnalyticsActive = isSocialMediaAnalyticsActive;
		this.websiteStatus = websiteStatus;
		this.websiteEndDate = websiteEndDate;
		this.productVersion = productVersion;
		this.isRecruitingAutoRenewActive = isRecruitingAutoRenewActive;
		this.isCareerPageAutoRenewActive = isCareerPageAutoRenewActive;
		this.isWebsiteAutoRenewActive = isWebsiteAutoRenewActive;
		this.isSocialMediaSupportAutoRenewActive = isSocialMediaSupportAutoRenewActive;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new Customer({
			id: dbObject.id,
			firebaseUid: dbObject.firebase_uid,
			mondayItemId: dbObject.monday_item_id,
			lastNpsSentAt: dbObject.last_nps_sent_at,
			lastNpsScore: dbObject.last_nps_score,
			emailAddress: dbObject.email_address,
			isFrameworkAgreement: dbObject.is_framework_agreement,
			agreementEnd: dbObject.agreement_end,
			careerPageStatus: dbObject.career_page_status,
			searchAdBooked: dbObject.search_ad_booked,
			searchAdStatus: dbObject.search_ad_status,
			careerPageEndDate: dbObject.career_page_end_date,
			careerPageMonthlyAdBudget: dbObject.career_page_monthly_ad_budget,
			searchAdEndDate: dbObject.search_ad_end_date,
			searchAdMonthlyBudget: dbObject.search_ad_monthly_budget,
			socialMediaSupportBooked: dbObject.social_media_support_booked,
			socialMediaSupportEndDate: dbObject.social_media_support_end_date,
			socialMediaCreditTransactions: dbObject.social_media_credit_transactions,
			socialMediaTotalCredits: dbObject.social_media_total_credits,
			socialMediaMonthlyAdsBudget: dbObject.social_media_monthly_ads_budget,
			socialMediaMonthlyPostCount: dbObject.social_media_monthly_post_count,
			socialMediaFigmaBoardUrl: dbObject.social_media_figma_board_url,
			socialMediaSupportStatus: dbObject.social_media_support_status,
			customerAcquisitionSearchAdEndDate: dbObject.customer_acquisition_search_ad_end_date,
			customerAcquisitionSearchAdBooked: dbObject.customer_acquisition_search_ad_booked,
			customerAcquisitionSearchAdMonthlyBudget: dbObject.customer_acquisition_search_ad_monthly_budget,
			customerAcquisitionSearchAdStatus: dbObject.customer_acquisition_search_ad_status,
			projectManager: dbObject.project_manager,
			hasDirectApproaches: dbObject.has_direct_approaches,
			isCommissionAgreement: dbObject.is_commission_agreement,
			isRecruitingAgreement: dbObject.is_recruiting_agreement,
			isCareerPageReceiptConfirmationActive: dbObject.is_career_page_receipt_confirmation_active,
			isSocialMediaAnalyticsActive: dbObject.is_social_media_analytics_active,
			websiteStatus: dbObject.website_status,
			websiteEndDate: dbObject.website_end_date,
			productVersion: dbObject.product_version,
			isRecruitingAutoRenewActive: dbObject.is_recruiting_auto_renew_active,
			isCareerPageAutoRenewActive: dbObject.is_career_page_auto_renew_active,
			isWebsiteAutoRenewActive: dbObject.is_website_auto_renew_active,
			isSocialMediaSupportAutoRenewActive: dbObject.is_social_media_support_auto_renew_active,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/customer/customer-update-dto.ts
var CustomerUpdateDto = class CustomerUpdateDto {
	mondayItemId;
	/**
	* @deprecated NPS logs are not used anymore, kept for backward compatibility and removal in future versions
	*/
	lastNpsSentAt;
	/**
	* @deprecated NPS logs are not used anymore, kept for backward compatibility and removal in future versions
	*/
	lastNpsScore;
	emailAddress;
	isFrameworkAgreement;
	agreementEnd;
	careerPageStatus;
	careerPageEndDate;
	/**
	* @deprecated Not used any more
	*/
	careerPageMonthlyAdBudget;
	searchAdBooked;
	searchAdStatus;
	searchAdEndDate;
	searchAdMonthlyBudget;
	socialMediaSupportBooked;
	socialMediaSupportEndDate;
	socialMediaCreditTransactions;
	socialMediaTotalCredits;
	socialMediaMonthlyAdsBudget;
	socialMediaMonthlyPostCount;
	socialMediaFigmaBoardUrl;
	socialMediaSupportStatus;
	customerAcquisitionSearchAdEndDate;
	customerAcquisitionSearchAdBooked;
	customerAcquisitionSearchAdMonthlyBudget;
	customerAcquisitionSearchAdStatus;
	projectManager;
	hasDirectApproaches;
	isCommissionAgreement;
	isRecruitingAgreement;
	isCareerPageReceiptConfirmationActive;
	isSocialMediaAnalyticsActive;
	websiteStatus;
	websiteEndDate;
	productVersion;
	isRecruitingAutoRenewActive;
	isCareerPageAutoRenewActive;
	isWebsiteAutoRenewActive;
	isSocialMediaSupportAutoRenewActive;
	constructor({ mondayItemId, lastNpsSentAt, lastNpsScore, emailAddress, isFrameworkAgreement, agreementEnd, careerPageStatus, searchAdBooked, searchAdStatus, searchAdMonthlyBudget, careerPageEndDate, careerPageMonthlyAdBudget, searchAdEndDate, socialMediaSupportBooked, socialMediaSupportEndDate, socialMediaCreditTransactions, socialMediaTotalCredits, socialMediaMonthlyAdsBudget, socialMediaMonthlyPostCount, socialMediaFigmaBoardUrl, socialMediaSupportStatus, customerAcquisitionSearchAdEndDate, customerAcquisitionSearchAdBooked, customerAcquisitionSearchAdMonthlyBudget, customerAcquisitionSearchAdStatus, projectManager, hasDirectApproaches, isCommissionAgreement, isRecruitingAgreement, isCareerPageReceiptConfirmationActive, isSocialMediaAnalyticsActive, websiteStatus, websiteEndDate, productVersion, isRecruitingAutoRenewActive, isCareerPageAutoRenewActive, isWebsiteAutoRenewActive, isSocialMediaSupportAutoRenewActive }) {
		this.mondayItemId = mondayItemId;
		this.lastNpsSentAt = lastNpsSentAt;
		this.lastNpsScore = lastNpsScore;
		this.emailAddress = emailAddress;
		this.isFrameworkAgreement = isFrameworkAgreement;
		this.agreementEnd = agreementEnd;
		this.careerPageStatus = careerPageStatus;
		this.searchAdBooked = searchAdBooked;
		this.searchAdStatus = searchAdStatus;
		this.searchAdMonthlyBudget = searchAdMonthlyBudget;
		this.careerPageEndDate = careerPageEndDate;
		this.careerPageMonthlyAdBudget = careerPageMonthlyAdBudget;
		this.searchAdEndDate = searchAdEndDate;
		this.socialMediaSupportBooked = socialMediaSupportBooked;
		this.socialMediaSupportEndDate = socialMediaSupportEndDate;
		this.socialMediaCreditTransactions = socialMediaCreditTransactions;
		this.socialMediaTotalCredits = socialMediaTotalCredits;
		this.socialMediaMonthlyAdsBudget = socialMediaMonthlyAdsBudget;
		this.socialMediaMonthlyPostCount = socialMediaMonthlyPostCount;
		this.socialMediaFigmaBoardUrl = socialMediaFigmaBoardUrl;
		this.socialMediaSupportStatus = socialMediaSupportStatus;
		this.customerAcquisitionSearchAdEndDate = customerAcquisitionSearchAdEndDate;
		this.customerAcquisitionSearchAdBooked = customerAcquisitionSearchAdBooked;
		this.customerAcquisitionSearchAdMonthlyBudget = customerAcquisitionSearchAdMonthlyBudget;
		this.customerAcquisitionSearchAdStatus = customerAcquisitionSearchAdStatus;
		this.projectManager = projectManager;
		this.hasDirectApproaches = hasDirectApproaches;
		this.isCommissionAgreement = isCommissionAgreement;
		this.isRecruitingAgreement = isRecruitingAgreement;
		this.isCareerPageReceiptConfirmationActive = isCareerPageReceiptConfirmationActive;
		this.isSocialMediaAnalyticsActive = isSocialMediaAnalyticsActive;
		this.websiteStatus = websiteStatus;
		this.websiteEndDate = websiteEndDate;
		this.productVersion = productVersion;
		this.isRecruitingAutoRenewActive = isRecruitingAutoRenewActive;
		this.isCareerPageAutoRenewActive = isCareerPageAutoRenewActive;
		this.isWebsiteAutoRenewActive = isWebsiteAutoRenewActive;
		this.isSocialMediaSupportAutoRenewActive = isSocialMediaSupportAutoRenewActive;
	}
	static createFromData(data) {
		return new CustomerUpdateDto({
			mondayItemId: data.mondayItemId,
			lastNpsSentAt: data.lastNpsSentAt,
			lastNpsScore: data.lastNpsScore,
			emailAddress: data.emailAddress,
			isFrameworkAgreement: data.isFrameworkAgreement,
			agreementEnd: data.agreementEnd,
			careerPageStatus: data.careerPageStatus,
			searchAdBooked: data.searchAdBooked,
			searchAdStatus: data.searchAdStatus,
			searchAdMonthlyBudget: data.searchAdMonthlyBudget,
			careerPageEndDate: data.careerPageEndDate,
			careerPageMonthlyAdBudget: data.careerPageMonthlyAdBudget,
			searchAdEndDate: data.searchAdEndDate,
			socialMediaSupportBooked: data.socialMediaSupportBooked,
			socialMediaSupportEndDate: data.socialMediaSupportEndDate,
			socialMediaCreditTransactions: data.socialMediaCreditTransactions,
			socialMediaTotalCredits: data.socialMediaTotalCredits,
			socialMediaMonthlyAdsBudget: data.socialMediaMonthlyAdsBudget,
			socialMediaMonthlyPostCount: data.socialMediaMonthlyPostCount,
			socialMediaFigmaBoardUrl: data.socialMediaFigmaBoardUrl,
			socialMediaSupportStatus: data.socialMediaSupportStatus,
			customerAcquisitionSearchAdEndDate: data.customerAcquisitionSearchAdEndDate,
			customerAcquisitionSearchAdBooked: data.customerAcquisitionSearchAdBooked,
			customerAcquisitionSearchAdMonthlyBudget: data.customerAcquisitionSearchAdMonthlyBudget,
			customerAcquisitionSearchAdStatus: data.customerAcquisitionSearchAdStatus,
			projectManager: data.projectManager,
			hasDirectApproaches: data.hasDirectApproaches,
			isCommissionAgreement: data.isCommissionAgreement,
			isRecruitingAgreement: data.isRecruitingAgreement,
			isCareerPageReceiptConfirmationActive: data.isCareerPageReceiptConfirmationActive,
			isSocialMediaAnalyticsActive: data.isSocialMediaAnalyticsActive,
			websiteStatus: data.websiteStatus,
			websiteEndDate: data.websiteEndDate,
			productVersion: data.productVersion,
			isRecruitingAutoRenewActive: data.isRecruitingAutoRenewActive,
			isCareerPageAutoRenewActive: data.isCareerPageAutoRenewActive,
			isWebsiteAutoRenewActive: data.isWebsiteAutoRenewActive,
			isSocialMediaSupportAutoRenewActive: data.isSocialMediaSupportAutoRenewActive
		});
	}
	static createFromMondayCustomer(customer) {
		return new CustomerUpdateDto({
			mondayItemId: customer.id,
			isFrameworkAgreement: customer.isFrameworkAgreement,
			agreementEnd: customer.annualContractEndAt,
			isCommissionAgreement: customer.isCommissionAgreement,
			isRecruitingAgreement: customer.isRecruitingAgreement,
			productVersion: customer.productVersion,
			isRecruitingAutoRenewActive: customer.isRecruitingAutoRenewActive
		});
	}
	toDbObject() {
		return {
			monday_item_id: this.mondayItemId,
			last_nps_sent_at: this.lastNpsSentAt,
			last_nps_score: this.lastNpsScore,
			email_address: this.emailAddress,
			is_framework_agreement: this.isFrameworkAgreement,
			agreement_end: this.agreementEnd,
			career_page_status: this.careerPageStatus,
			search_ad_booked: this.searchAdBooked,
			search_ad_status: this.searchAdStatus,
			career_page_end_date: this.careerPageEndDate,
			career_page_monthly_ad_budget: this.careerPageMonthlyAdBudget,
			search_ad_end_date: this.searchAdEndDate,
			search_ad_monthly_budget: this.searchAdMonthlyBudget,
			social_media_support_booked: this.socialMediaSupportBooked,
			social_media_support_end_date: this.socialMediaSupportEndDate,
			social_media_credit_transactions: this.socialMediaCreditTransactions,
			social_media_total_credits: this.socialMediaTotalCredits,
			social_media_monthly_ads_budget: this.socialMediaMonthlyAdsBudget,
			social_media_monthly_post_count: this.socialMediaMonthlyPostCount,
			social_media_figma_board_url: this.socialMediaFigmaBoardUrl,
			social_media_support_status: this.socialMediaSupportStatus,
			customer_acquisition_search_ad_end_date: this.customerAcquisitionSearchAdEndDate,
			customer_acquisition_search_ad_booked: this.customerAcquisitionSearchAdBooked,
			customer_acquisition_search_ad_monthly_budget: this.customerAcquisitionSearchAdMonthlyBudget,
			customer_acquisition_search_ad_status: this.customerAcquisitionSearchAdStatus,
			project_manager: this.projectManager,
			has_direct_approaches: this.hasDirectApproaches,
			is_commission_agreement: this.isCommissionAgreement,
			is_recruiting_agreement: this.isRecruitingAgreement,
			is_career_page_receipt_confirmation_active: this.isCareerPageReceiptConfirmationActive,
			is_social_media_analytics_active: this.isSocialMediaAnalyticsActive,
			website_status: this.websiteStatus,
			website_end_date: this.websiteEndDate,
			product_version: this.productVersion,
			is_recruiting_auto_renew_active: this.isRecruitingAutoRenewActive,
			is_career_page_auto_renew_active: this.isCareerPageAutoRenewActive,
			is_website_auto_renew_active: this.isWebsiteAutoRenewActive,
			is_social_media_support_auto_renew_active: this.isSocialMediaSupportAutoRenewActive
		};
	}
};
// source/models/customer/customer-creation-dto.ts
var CustomerCreationDto = class CustomerCreationDto {
	firebaseUid;
	mondayItemId;
	/**
	* @deprecated NPS logs are not used anymore, kept for backward compatibility and removal in future versions
	*/
	lastNpsSentAt;
	/**
	* @deprecated NPS logs are not used anymore, kept for backward compatibility and removal in future versions
	*/
	lastNpsScore;
	emailAddress;
	isFrameworkAgreement;
	agreementEnd;
	careerPageStatus;
	careerPageEndDate;
	/**
	* @deprecated Not used any more
	*/
	careerPageMonthlyAdBudget;
	searchAdBooked;
	searchAdEndDate;
	searchAdMonthlyBudget;
	socialMediaSupportBooked;
	socialMediaSupportEndDate;
	socialMediaCreditTransactions;
	socialMediaTotalCredits;
	socialMediaMonthlyAdsBudget;
	socialMediaMonthlyPostCount;
	socialMediaFigmaBoardUrl;
	customerAcquisitionSearchAdEndDate;
	customerAcquisitionSearchAdBooked;
	customerAcquisitionSearchAdMonthlyBudget;
	projectManager;
	isCommissionAgreement;
	isRecruitingAgreement;
	isCareerPageReceiptConfirmationActive;
	isSocialMediaAnalyticsActive;
	constructor({ firebaseUid, mondayItemId, lastNpsSentAt, lastNpsScore, emailAddress, isFrameworkAgreement, agreementEnd, careerPageStatus, searchAdBooked, searchAdMonthlyBudget, careerPageEndDate, careerPageMonthlyAdBudget, searchAdEndDate, socialMediaSupportBooked, socialMediaSupportEndDate, socialMediaCreditTransactions, socialMediaTotalCredits, socialMediaMonthlyAdsBudget, socialMediaMonthlyPostCount, socialMediaFigmaBoardUrl, customerAcquisitionSearchAdEndDate, customerAcquisitionSearchAdBooked, customerAcquisitionSearchAdMonthlyBudget, projectManager, isCommissionAgreement, isRecruitingAgreement, isCareerPageReceiptConfirmationActive, isSocialMediaAnalyticsActive }) {
		this.firebaseUid = firebaseUid;
		this.mondayItemId = mondayItemId;
		this.lastNpsSentAt = lastNpsSentAt;
		this.lastNpsScore = lastNpsScore;
		this.emailAddress = emailAddress;
		this.isFrameworkAgreement = isFrameworkAgreement;
		this.agreementEnd = agreementEnd;
		this.careerPageStatus = careerPageStatus;
		this.searchAdBooked = searchAdBooked;
		this.searchAdMonthlyBudget = searchAdMonthlyBudget;
		this.careerPageEndDate = careerPageEndDate;
		this.careerPageMonthlyAdBudget = careerPageMonthlyAdBudget;
		this.searchAdEndDate = searchAdEndDate;
		this.socialMediaSupportBooked = socialMediaSupportBooked;
		this.socialMediaSupportEndDate = socialMediaSupportEndDate;
		this.socialMediaCreditTransactions = socialMediaCreditTransactions;
		this.socialMediaTotalCredits = socialMediaTotalCredits;
		this.socialMediaMonthlyAdsBudget = socialMediaMonthlyAdsBudget;
		this.socialMediaMonthlyPostCount = socialMediaMonthlyPostCount;
		this.socialMediaFigmaBoardUrl = socialMediaFigmaBoardUrl;
		this.customerAcquisitionSearchAdEndDate = customerAcquisitionSearchAdEndDate;
		this.customerAcquisitionSearchAdBooked = customerAcquisitionSearchAdBooked;
		this.customerAcquisitionSearchAdMonthlyBudget = customerAcquisitionSearchAdMonthlyBudget;
		this.projectManager = projectManager;
		this.isCommissionAgreement = isCommissionAgreement;
		this.isRecruitingAgreement = isRecruitingAgreement;
		this.isCareerPageReceiptConfirmationActive = isCareerPageReceiptConfirmationActive;
		this.isSocialMediaAnalyticsActive = isSocialMediaAnalyticsActive;
	}
	static createFromData(data) {
		return new CustomerCreationDto({
			firebaseUid: data.firebaseUid,
			mondayItemId: data.mondayItemId,
			lastNpsSentAt: data.lastNpsSentAt,
			lastNpsScore: data.lastNpsScore,
			emailAddress: data.emailAddress,
			isFrameworkAgreement: data.isFrameworkAgreement,
			agreementEnd: data.agreementEnd,
			careerPageStatus: data.careerPageStatus,
			searchAdBooked: data.searchAdBooked,
			searchAdMonthlyBudget: data.searchAdMonthlyBudget,
			careerPageEndDate: data.careerPageEndDate,
			careerPageMonthlyAdBudget: data.careerPageMonthlyAdBudget,
			searchAdEndDate: data.searchAdEndDate,
			socialMediaSupportBooked: data.socialMediaSupportBooked,
			socialMediaSupportEndDate: data.socialMediaSupportEndDate,
			socialMediaCreditTransactions: data.socialMediaCreditTransactions,
			socialMediaTotalCredits: data.socialMediaTotalCredits,
			socialMediaMonthlyAdsBudget: data.socialMediaMonthlyAdsBudget,
			socialMediaMonthlyPostCount: data.socialMediaMonthlyPostCount,
			socialMediaFigmaBoardUrl: data.socialMediaFigma,
			customerAcquisitionSearchAdEndDate: data.customerAcquisitionSearchAdEndDate,
			customerAcquisitionSearchAdBooked: data.customerAcquisitionSearchAdBooked,
			customerAcquisitionSearchAdMonthlyBudget: data.customerAcquisitionSearchAdMonthlyBudget,
			projectManager: data.projectManager,
			isCommissionAgreement: data.isCommissionAgreement,
			isRecruitingAgreement: data.isRecruitingAgreement,
			isCareerPageReceiptConfirmationActive: data.isCareerPageReceiptConfirmationActive,
			isSocialMediaAnalyticsActive: data.isSocialMediaAnalyticsActive
		});
	}
	toUpdateDto() {
		return new CustomerUpdateDto({
			mondayItemId: this.mondayItemId,
			lastNpsSentAt: this.lastNpsSentAt,
			lastNpsScore: this.lastNpsScore,
			emailAddress: this.emailAddress,
			isFrameworkAgreement: this.isFrameworkAgreement,
			agreementEnd: this.agreementEnd,
			careerPageStatus: this.careerPageStatus,
			searchAdBooked: this.searchAdBooked,
			searchAdMonthlyBudget: this.searchAdMonthlyBudget,
			careerPageEndDate: this.careerPageEndDate,
			careerPageMonthlyAdBudget: this.careerPageMonthlyAdBudget,
			searchAdEndDate: this.searchAdEndDate,
			socialMediaSupportBooked: this.socialMediaSupportBooked,
			socialMediaSupportEndDate: this.socialMediaSupportEndDate,
			socialMediaCreditTransactions: this.socialMediaCreditTransactions,
			socialMediaTotalCredits: this.socialMediaTotalCredits,
			socialMediaMonthlyAdsBudget: this.socialMediaMonthlyAdsBudget,
			socialMediaMonthlyPostCount: this.socialMediaMonthlyPostCount,
			socialMediaFigmaBoardUrl: this.socialMediaFigmaBoardUrl,
			customerAcquisitionSearchAdEndDate: this.customerAcquisitionSearchAdEndDate,
			customerAcquisitionSearchAdBooked: this.customerAcquisitionSearchAdBooked,
			customerAcquisitionSearchAdMonthlyBudget: this.customerAcquisitionSearchAdMonthlyBudget,
			projectManager: this.projectManager,
			isCommissionAgreement: this.isCommissionAgreement,
			isRecruitingAgreement: this.isRecruitingAgreement,
			isCareerPageReceiptConfirmationActive: this.isCareerPageReceiptConfirmationActive,
			isSocialMediaAnalyticsActive: this.isSocialMediaAnalyticsActive
		});
	}
};
// source/models/customer/customer-dto.ts
var CustomerDto = class CustomerDto {
	id;
	firebaseUid;
	mondayItemId;
	/**
	* @deprecated NPS logs are not used anymore, kept for backward compatibility and removal in future versions
	*/
	lastNpsSentAt;
	/**
	* @deprecated NPS logs are not used anymore, kept for backward compatibility and removal in future versions
	*/
	lastNpsScore;
	emailAddress;
	isFrameworkAgreement;
	agreementEnd;
	careerPageStatus;
	careerPageEndDate;
	/**
	* @deprecated Not used any more
	*/
	careerPageMonthlyAdBudget;
	searchAdBooked;
	searchAdStatus;
	searchAdEndDate;
	searchAdMonthlyBudget;
	socialMediaSupportBooked;
	socialMediaSupportEndDate;
	socialMediaCreditTransactions;
	socialMediaTotalCredits;
	socialMediaMonthlyAdsBudget;
	socialMediaMonthlyPostCount;
	socialMediaFigmaBoardUrl;
	socialMediaSupportStatus;
	customerAcquisitionSearchAdEndDate;
	customerAcquisitionSearchAdBooked;
	customerAcquisitionSearchAdMonthlyBudget;
	customerAcquisitionSearchAdStatus;
	projectManager;
	hasDirectApproaches;
	isCommissionAgreement;
	isRecruitingAgreement;
	isCareerPageReceiptConfirmationActive;
	isSocialMediaAnalyticsActive;
	websiteStatus;
	websiteEndDate;
	productVersion;
	isRecruitingAutoRenewActive;
	isCareerPageAutoRenewActive;
	isWebsiteAutoRenewActive;
	isSocialMediaSupportAutoRenewActive;
	createdAt;
	updatedAt;
	constructor({ id, firebaseUid, mondayItemId, lastNpsSentAt, lastNpsScore, emailAddress, isFrameworkAgreement, agreementEnd, careerPageStatus, searchAdBooked, searchAdStatus, searchAdMonthlyBudget, careerPageEndDate, careerPageMonthlyAdBudget, searchAdEndDate, socialMediaSupportBooked, socialMediaSupportEndDate, socialMediaCreditTransactions, socialMediaTotalCredits, socialMediaMonthlyAdsBudget, socialMediaMonthlyPostCount, socialMediaFigmaBoardUrl, socialMediaSupportStatus, customerAcquisitionSearchAdEndDate, customerAcquisitionSearchAdBooked, customerAcquisitionSearchAdMonthlyBudget, customerAcquisitionSearchAdStatus, projectManager, hasDirectApproaches, isCommissionAgreement, isRecruitingAgreement, isCareerPageReceiptConfirmationActive, isSocialMediaAnalyticsActive, websiteStatus, websiteEndDate, productVersion, isRecruitingAutoRenewActive, isCareerPageAutoRenewActive, isWebsiteAutoRenewActive, isSocialMediaSupportAutoRenewActive, createdAt, updatedAt }) {
		this.id = id;
		this.firebaseUid = firebaseUid;
		this.mondayItemId = mondayItemId;
		this.lastNpsSentAt = lastNpsSentAt;
		this.lastNpsScore = lastNpsScore;
		this.emailAddress = emailAddress;
		this.isFrameworkAgreement = isFrameworkAgreement;
		this.agreementEnd = agreementEnd;
		this.careerPageStatus = careerPageStatus;
		this.searchAdBooked = searchAdBooked;
		this.searchAdStatus = searchAdStatus;
		this.searchAdMonthlyBudget = searchAdMonthlyBudget;
		this.careerPageEndDate = careerPageEndDate;
		this.careerPageMonthlyAdBudget = careerPageMonthlyAdBudget;
		this.searchAdEndDate = searchAdEndDate;
		this.socialMediaSupportBooked = socialMediaSupportBooked;
		this.socialMediaSupportEndDate = socialMediaSupportEndDate;
		this.socialMediaCreditTransactions = socialMediaCreditTransactions;
		this.socialMediaTotalCredits = socialMediaTotalCredits;
		this.socialMediaMonthlyAdsBudget = socialMediaMonthlyAdsBudget;
		this.socialMediaMonthlyPostCount = socialMediaMonthlyPostCount;
		this.socialMediaFigmaBoardUrl = socialMediaFigmaBoardUrl;
		this.socialMediaSupportStatus = socialMediaSupportStatus;
		this.customerAcquisitionSearchAdEndDate = customerAcquisitionSearchAdEndDate;
		this.customerAcquisitionSearchAdBooked = customerAcquisitionSearchAdBooked;
		this.customerAcquisitionSearchAdMonthlyBudget = customerAcquisitionSearchAdMonthlyBudget;
		this.customerAcquisitionSearchAdStatus = customerAcquisitionSearchAdStatus;
		this.projectManager = projectManager;
		this.hasDirectApproaches = hasDirectApproaches;
		this.isCommissionAgreement = isCommissionAgreement;
		this.isRecruitingAgreement = isRecruitingAgreement;
		this.isCareerPageReceiptConfirmationActive = isCareerPageReceiptConfirmationActive;
		this.isSocialMediaAnalyticsActive = isSocialMediaAnalyticsActive;
		this.websiteStatus = websiteStatus;
		this.websiteEndDate = websiteEndDate;
		this.productVersion = productVersion;
		this.isRecruitingAutoRenewActive = isRecruitingAutoRenewActive;
		this.isCareerPageAutoRenewActive = isCareerPageAutoRenewActive;
		this.isWebsiteAutoRenewActive = isWebsiteAutoRenewActive;
		this.isSocialMediaSupportAutoRenewActive = isSocialMediaSupportAutoRenewActive;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	convertToCustomer() {
		return new Customer({
			id: this.id,
			firebaseUid: this.firebaseUid,
			mondayItemId: this.mondayItemId,
			lastNpsSentAt: this.lastNpsSentAt,
			lastNpsScore: this.lastNpsScore,
			emailAddress: this.emailAddress,
			isFrameworkAgreement: this.isFrameworkAgreement,
			agreementEnd: this.agreementEnd,
			careerPageStatus: this.careerPageStatus,
			searchAdBooked: this.searchAdBooked,
			searchAdStatus: this.searchAdStatus,
			searchAdMonthlyBudget: this.searchAdMonthlyBudget,
			careerPageEndDate: this.careerPageEndDate,
			careerPageMonthlyAdBudget: this.careerPageMonthlyAdBudget,
			searchAdEndDate: this.searchAdEndDate,
			socialMediaSupportBooked: this.socialMediaSupportBooked,
			socialMediaSupportEndDate: this.socialMediaSupportEndDate,
			socialMediaCreditTransactions: this.socialMediaCreditTransactions,
			socialMediaTotalCredits: this.socialMediaTotalCredits,
			socialMediaMonthlyAdsBudget: this.socialMediaMonthlyAdsBudget,
			socialMediaMonthlyPostCount: this.socialMediaMonthlyPostCount,
			socialMediaFigmaBoardUrl: this.socialMediaFigmaBoardUrl,
			socialMediaSupportStatus: this.socialMediaSupportStatus,
			customerAcquisitionSearchAdEndDate: this.customerAcquisitionSearchAdEndDate,
			customerAcquisitionSearchAdBooked: this.customerAcquisitionSearchAdBooked,
			customerAcquisitionSearchAdMonthlyBudget: this.customerAcquisitionSearchAdMonthlyBudget,
			customerAcquisitionSearchAdStatus: this.customerAcquisitionSearchAdStatus,
			projectManager: this.projectManager,
			hasDirectApproaches: this.hasDirectApproaches,
			isCommissionAgreement: this.isCommissionAgreement,
			isRecruitingAgreement: this.isRecruitingAgreement,
			isCareerPageReceiptConfirmationActive: this.isCareerPageReceiptConfirmationActive,
			isSocialMediaAnalyticsActive: this.isSocialMediaAnalyticsActive,
			websiteStatus: this.websiteStatus,
			websiteEndDate: this.websiteEndDate,
			productVersion: this.productVersion,
			isRecruitingAutoRenewActive: this.isRecruitingAutoRenewActive,
			isCareerPageAutoRenewActive: this.isCareerPageAutoRenewActive,
			isWebsiteAutoRenewActive: this.isWebsiteAutoRenewActive,
			isSocialMediaSupportAutoRenewActive: this.isSocialMediaSupportAutoRenewActive,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromCustomer(customer) {
		return new CustomerDto({
			id: customer.id,
			firebaseUid: customer.firebaseUid,
			mondayItemId: customer.mondayItemId,
			lastNpsSentAt: customer.lastNpsSentAt,
			lastNpsScore: customer.lastNpsScore,
			emailAddress: customer.emailAddress,
			isFrameworkAgreement: customer.isFrameworkAgreement,
			agreementEnd: customer.agreementEnd,
			careerPageStatus: customer.careerPageStatus,
			searchAdBooked: customer.searchAdBooked,
			searchAdStatus: customer.searchAdStatus,
			searchAdMonthlyBudget: customer.searchAdMonthlyBudget,
			careerPageEndDate: customer.careerPageEndDate,
			careerPageMonthlyAdBudget: customer.careerPageMonthlyAdBudget,
			searchAdEndDate: customer.searchAdEndDate,
			socialMediaSupportBooked: customer.socialMediaSupportBooked,
			socialMediaSupportEndDate: customer.socialMediaSupportEndDate,
			socialMediaCreditTransactions: customer.socialMediaCreditTransactions,
			socialMediaTotalCredits: customer.socialMediaTotalCredits,
			socialMediaMonthlyAdsBudget: customer.socialMediaMonthlyAdsBudget,
			socialMediaMonthlyPostCount: customer.socialMediaMonthlyPostCount,
			socialMediaFigmaBoardUrl: customer.socialMediaFigmaBoardUrl,
			socialMediaSupportStatus: customer.socialMediaSupportStatus,
			customerAcquisitionSearchAdEndDate: customer.customerAcquisitionSearchAdEndDate,
			customerAcquisitionSearchAdBooked: customer.customerAcquisitionSearchAdBooked,
			customerAcquisitionSearchAdMonthlyBudget: customer.customerAcquisitionSearchAdMonthlyBudget,
			customerAcquisitionSearchAdStatus: customer.customerAcquisitionSearchAdStatus,
			projectManager: customer.projectManager,
			hasDirectApproaches: customer.hasDirectApproaches,
			isCommissionAgreement: customer.isCommissionAgreement,
			isRecruitingAgreement: customer.isRecruitingAgreement,
			isCareerPageReceiptConfirmationActive: customer.isCareerPageReceiptConfirmationActive,
			isSocialMediaAnalyticsActive: customer.isSocialMediaAnalyticsActive,
			websiteStatus: customer.websiteStatus,
			websiteEndDate: customer.websiteEndDate,
			productVersion: customer.productVersion,
			isRecruitingAutoRenewActive: customer.isRecruitingAutoRenewActive,
			isCareerPageAutoRenewActive: customer.isCareerPageAutoRenewActive,
			isWebsiteAutoRenewActive: customer.isWebsiteAutoRenewActive,
			isSocialMediaSupportAutoRenewActive: customer.isSocialMediaSupportAutoRenewActive,
			createdAt: customer.createdAt,
			updatedAt: customer.updatedAt
		});
	}
	static createFromData(data) {
		return new CustomerDto({
			id: data.id,
			firebaseUid: data.firebaseUid,
			mondayItemId: data.mondayItemId,
			lastNpsSentAt: data.lastNpsSentAt,
			lastNpsScore: data.lastNpsScore,
			emailAddress: data.emailAddress,
			isFrameworkAgreement: data.isFrameworkAgreement,
			agreementEnd: data.agreementEnd,
			careerPageStatus: data.careerPageStatus,
			searchAdBooked: data.searchAdBooked,
			searchAdStatus: data.searchAdStatus,
			careerPageEndDate: data.careerPageEndDate,
			careerPageMonthlyAdBudget: data.careerPageMonthlyAdBudget,
			searchAdEndDate: data.searchAdEndDate,
			searchAdMonthlyBudget: data.searchAdMonthlyBudget,
			socialMediaSupportBooked: data.socialMediaSupportBooked,
			socialMediaSupportEndDate: data.socialMediaSupportEndDate,
			socialMediaCreditTransactions: data.socialMediaCreditTransactions,
			socialMediaTotalCredits: data.socialMediaTotalCredits,
			socialMediaMonthlyAdsBudget: data.socialMediaMonthlyAdsBudget,
			socialMediaMonthlyPostCount: data.socialMediaMonthlyPostCount,
			socialMediaFigmaBoardUrl: data.socialMediaFigmaBoardUrl,
			socialMediaSupportStatus: data.socialMediaSupportStatus,
			customerAcquisitionSearchAdEndDate: data.customerAcquisitionSearchAdEndDate,
			customerAcquisitionSearchAdBooked: data.customerAcquisitionSearchAdBooked,
			customerAcquisitionSearchAdMonthlyBudget: data.customerAcquisitionSearchAdMonthlyBudget,
			customerAcquisitionSearchAdStatus: data.customerAcquisitionSearchAdStatus,
			projectManager: data.projectManager,
			hasDirectApproaches: data.hasDirectApproaches,
			isCommissionAgreement: data.isCommissionAgreement,
			isRecruitingAgreement: data.isRecruitingAgreement,
			isCareerPageReceiptConfirmationActive: data.isCareerPageReceiptConfirmationActive,
			isSocialMediaAnalyticsActive: data.isSocialMediaAnalyticsActive,
			websiteStatus: data.websiteStatus,
			websiteEndDate: data.websiteEndDate,
			productVersion: data.productVersion,
			isRecruitingAutoRenewActive: data.isRecruitingAutoRenewActive,
			isCareerPageAutoRenewActive: data.isCareerPageAutoRenewActive,
			isWebsiteAutoRenewActive: data.isWebsiteAutoRenewActive,
			isSocialMediaSupportAutoRenewActive: data.isSocialMediaSupportAutoRenewActive,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
};
// source/models/customer-with-relations/customer-with-relations.ts
var CustomerWithRelations = class CustomerWithRelations extends Customer {
	company;
	career;
	jobPositions;
	constructor({ company, career, jobPositions, ...props }) {
		super(props);
		this.company = company;
		this.career = career;
		this.jobPositions = jobPositions;
	}
	static createFromDbObject(customerWithRelationsDbObject) {
		return new CustomerWithRelations({
			id: customerWithRelationsDbObject.id,
			firebaseUid: customerWithRelationsDbObject.firebase_uid,
			mondayItemId: customerWithRelationsDbObject.monday_item_id,
			lastNpsSentAt: customerWithRelationsDbObject.last_nps_sent_at,
			lastNpsScore: customerWithRelationsDbObject.last_nps_score,
			emailAddress: customerWithRelationsDbObject.email_address,
			isFrameworkAgreement: customerWithRelationsDbObject.is_framework_agreement,
			agreementEnd: customerWithRelationsDbObject.agreement_end,
			careerPageStatus: customerWithRelationsDbObject.career_page_status,
			searchAdBooked: customerWithRelationsDbObject.search_ad_booked,
			searchAdStatus: customerWithRelationsDbObject.search_ad_status,
			careerPageEndDate: customerWithRelationsDbObject.career_page_end_date,
			careerPageMonthlyAdBudget: customerWithRelationsDbObject.career_page_monthly_ad_budget,
			searchAdEndDate: customerWithRelationsDbObject.search_ad_end_date,
			searchAdMonthlyBudget: customerWithRelationsDbObject.search_ad_monthly_budget,
			socialMediaSupportBooked: customerWithRelationsDbObject.social_media_support_booked,
			socialMediaSupportEndDate: customerWithRelationsDbObject.social_media_support_end_date,
			socialMediaCreditTransactions: customerWithRelationsDbObject.social_media_credit_transactions,
			socialMediaTotalCredits: customerWithRelationsDbObject.social_media_total_credits,
			socialMediaMonthlyAdsBudget: customerWithRelationsDbObject.social_media_monthly_ads_budget,
			socialMediaMonthlyPostCount: customerWithRelationsDbObject.social_media_monthly_post_count,
			socialMediaFigmaBoardUrl: customerWithRelationsDbObject.social_media_figma_board_url,
			socialMediaSupportStatus: customerWithRelationsDbObject.social_media_support_status,
			customerAcquisitionSearchAdEndDate: customerWithRelationsDbObject.customer_acquisition_search_ad_end_date,
			customerAcquisitionSearchAdBooked: customerWithRelationsDbObject.customer_acquisition_search_ad_booked,
			customerAcquisitionSearchAdMonthlyBudget: customerWithRelationsDbObject.customer_acquisition_search_ad_monthly_budget,
			customerAcquisitionSearchAdStatus: customerWithRelationsDbObject.customer_acquisition_search_ad_status,
			projectManager: customerWithRelationsDbObject.project_manager,
			hasDirectApproaches: customerWithRelationsDbObject.has_direct_approaches,
			createdAt: customerWithRelationsDbObject.created_at,
			updatedAt: customerWithRelationsDbObject.updated_at,
			company: customerWithRelationsDbObject.company && Company.createFromDbObject(customerWithRelationsDbObject.company),
			career: customerWithRelationsDbObject.career && Career.createFromDbObject(customerWithRelationsDbObject.career),
			jobPositions: customerWithRelationsDbObject.job_positions?.map((jobPosition) => JobPositionInfo.createFromDbObject(jobPosition)),
			isCommissionAgreement: customerWithRelationsDbObject.is_commission_agreement,
			isRecruitingAgreement: customerWithRelationsDbObject.is_recruiting_agreement,
			isCareerPageReceiptConfirmationActive: customerWithRelationsDbObject.is_career_page_receipt_confirmation_active,
			isSocialMediaAnalyticsActive: customerWithRelationsDbObject.is_social_media_analytics_active,
			websiteStatus: customerWithRelationsDbObject.website_status,
			websiteEndDate: customerWithRelationsDbObject.website_end_date,
			productVersion: customerWithRelationsDbObject.product_version,
			isRecruitingAutoRenewActive: customerWithRelationsDbObject.is_recruiting_auto_renew_active,
			isCareerPageAutoRenewActive: customerWithRelationsDbObject.is_career_page_auto_renew_active,
			isWebsiteAutoRenewActive: customerWithRelationsDbObject.is_website_auto_renew_active,
			isSocialMediaSupportAutoRenewActive: customerWithRelationsDbObject.is_social_media_support_auto_renew_active
		});
	}
};
// source/models/customer-with-relations/customer-with-relations-dto.ts
var CustomerWithRelationsDto = class CustomerWithRelationsDto extends CustomerDto {
	company;
	career;
	jobPositions;
	constructor({ company, career, jobPositions, ...props }) {
		super(props);
		this.company = company;
		this.career = career;
		this.jobPositions = jobPositions;
	}
	toCustomerWithRelations() {
		return new CustomerWithRelations({
			id: this.id,
			firebaseUid: this.firebaseUid,
			mondayItemId: this.mondayItemId,
			lastNpsSentAt: this.lastNpsSentAt,
			lastNpsScore: this.lastNpsScore,
			emailAddress: this.emailAddress,
			isFrameworkAgreement: this.isFrameworkAgreement,
			agreementEnd: this.agreementEnd,
			careerPageStatus: this.careerPageStatus,
			searchAdBooked: this.searchAdBooked,
			searchAdStatus: this.searchAdStatus,
			searchAdMonthlyBudget: this.searchAdMonthlyBudget,
			careerPageEndDate: this.careerPageEndDate,
			careerPageMonthlyAdBudget: this.careerPageMonthlyAdBudget,
			searchAdEndDate: this.searchAdEndDate,
			socialMediaSupportBooked: this.socialMediaSupportBooked,
			socialMediaSupportEndDate: this.socialMediaSupportEndDate,
			socialMediaCreditTransactions: this.socialMediaCreditTransactions,
			socialMediaTotalCredits: this.socialMediaTotalCredits,
			socialMediaMonthlyAdsBudget: this.socialMediaMonthlyAdsBudget,
			socialMediaMonthlyPostCount: this.socialMediaMonthlyPostCount,
			socialMediaFigmaBoardUrl: this.socialMediaFigmaBoardUrl,
			socialMediaSupportStatus: this.socialMediaSupportStatus,
			customerAcquisitionSearchAdEndDate: this.customerAcquisitionSearchAdEndDate,
			customerAcquisitionSearchAdBooked: this.customerAcquisitionSearchAdBooked,
			customerAcquisitionSearchAdMonthlyBudget: this.customerAcquisitionSearchAdMonthlyBudget,
			customerAcquisitionSearchAdStatus: this.customerAcquisitionSearchAdStatus,
			projectManager: this.projectManager,
			hasDirectApproaches: this.hasDirectApproaches,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt,
			company: this.company.toCompany(),
			career: this.career?.toCareer(),
			jobPositions: this.jobPositions?.map((jobPosition) => jobPosition.toJobPositionInfo()),
			isCommissionAgreement: this.isCommissionAgreement,
			isRecruitingAgreement: this.isRecruitingAgreement,
			isCareerPageReceiptConfirmationActive: this.isCareerPageReceiptConfirmationActive,
			isSocialMediaAnalyticsActive: this.isSocialMediaAnalyticsActive,
			websiteStatus: this.websiteStatus,
			websiteEndDate: this.websiteEndDate,
			productVersion: this.productVersion,
			isRecruitingAutoRenewActive: this.isRecruitingAutoRenewActive,
			isCareerPageAutoRenewActive: this.isCareerPageAutoRenewActive,
			isWebsiteAutoRenewActive: this.isWebsiteAutoRenewActive,
			isSocialMediaSupportAutoRenewActive: this.isSocialMediaSupportAutoRenewActive
		});
	}
	static createFromCustomerWithRelations(customerWithRelations) {
		return new CustomerWithRelationsDto({
			id: customerWithRelations.id,
			firebaseUid: customerWithRelations.firebaseUid,
			mondayItemId: customerWithRelations.mondayItemId,
			lastNpsSentAt: customerWithRelations.lastNpsSentAt,
			lastNpsScore: customerWithRelations.lastNpsScore,
			emailAddress: customerWithRelations.emailAddress,
			isFrameworkAgreement: customerWithRelations.isFrameworkAgreement,
			agreementEnd: customerWithRelations.agreementEnd,
			careerPageStatus: customerWithRelations.careerPageStatus,
			searchAdBooked: customerWithRelations.searchAdBooked,
			searchAdStatus: customerWithRelations.searchAdStatus,
			searchAdMonthlyBudget: customerWithRelations.searchAdMonthlyBudget,
			careerPageEndDate: customerWithRelations.careerPageEndDate,
			careerPageMonthlyAdBudget: customerWithRelations.careerPageMonthlyAdBudget,
			searchAdEndDate: customerWithRelations.searchAdEndDate,
			socialMediaSupportBooked: customerWithRelations.socialMediaSupportBooked,
			socialMediaSupportEndDate: customerWithRelations.socialMediaSupportEndDate,
			socialMediaCreditTransactions: customerWithRelations.socialMediaCreditTransactions,
			socialMediaTotalCredits: customerWithRelations.socialMediaTotalCredits,
			socialMediaMonthlyAdsBudget: customerWithRelations.socialMediaMonthlyAdsBudget,
			socialMediaMonthlyPostCount: customerWithRelations.socialMediaMonthlyPostCount,
			socialMediaSupportStatus: customerWithRelations.socialMediaSupportStatus,
			socialMediaFigmaBoardUrl: customerWithRelations.socialMediaFigmaBoardUrl,
			customerAcquisitionSearchAdEndDate: customerWithRelations.customerAcquisitionSearchAdEndDate,
			customerAcquisitionSearchAdBooked: customerWithRelations.customerAcquisitionSearchAdBooked,
			customerAcquisitionSearchAdMonthlyBudget: customerWithRelations.customerAcquisitionSearchAdMonthlyBudget,
			customerAcquisitionSearchAdStatus: customerWithRelations.customerAcquisitionSearchAdStatus,
			projectManager: customerWithRelations.projectManager,
			hasDirectApproaches: customerWithRelations.hasDirectApproaches,
			createdAt: customerWithRelations.createdAt,
			updatedAt: customerWithRelations.updatedAt,
			company: CompanyDto.createFromCompanyData(customerWithRelations.company),
			career: customerWithRelations.career ? CareerDto.createFromCareer(customerWithRelations.career) : void 0,
			jobPositions: customerWithRelations.jobPositions?.map((jobPosition) => JobPositionInfoDto.createFromJobPositionInfo(jobPosition)),
			isCommissionAgreement: customerWithRelations.isCommissionAgreement,
			isRecruitingAgreement: customerWithRelations.isRecruitingAgreement,
			isCareerPageReceiptConfirmationActive: customerWithRelations.isCareerPageReceiptConfirmationActive,
			isSocialMediaAnalyticsActive: customerWithRelations.isSocialMediaAnalyticsActive,
			websiteStatus: customerWithRelations.websiteStatus,
			websiteEndDate: customerWithRelations.websiteEndDate,
			productVersion: customerWithRelations.productVersion,
			isRecruitingAutoRenewActive: customerWithRelations.isRecruitingAutoRenewActive,
			isCareerPageAutoRenewActive: customerWithRelations.isCareerPageAutoRenewActive,
			isWebsiteAutoRenewActive: customerWithRelations.isWebsiteAutoRenewActive,
			isSocialMediaSupportAutoRenewActive: customerWithRelations.isSocialMediaSupportAutoRenewActive
		});
	}
	static createFromDbObject(customerWithRelationsDbObject) {
		return new CustomerWithRelationsDto({
			id: customerWithRelationsDbObject.id,
			firebaseUid: customerWithRelationsDbObject.firebase_uid,
			mondayItemId: customerWithRelationsDbObject.monday_item_id,
			lastNpsSentAt: customerWithRelationsDbObject.last_nps_sent_at,
			lastNpsScore: customerWithRelationsDbObject.last_nps_score,
			emailAddress: customerWithRelationsDbObject.email_address,
			isFrameworkAgreement: customerWithRelationsDbObject.is_framework_agreement,
			agreementEnd: customerWithRelationsDbObject.agreement_end,
			careerPageStatus: customerWithRelationsDbObject.career_page_status,
			searchAdBooked: customerWithRelationsDbObject.search_ad_booked,
			searchAdStatus: customerWithRelationsDbObject.search_ad_status,
			careerPageEndDate: customerWithRelationsDbObject.career_page_end_date,
			careerPageMonthlyAdBudget: customerWithRelationsDbObject.career_page_monthly_ad_budget,
			searchAdEndDate: customerWithRelationsDbObject.search_ad_end_date,
			searchAdMonthlyBudget: customerWithRelationsDbObject.search_ad_monthly_budget,
			socialMediaSupportBooked: customerWithRelationsDbObject.social_media_support_booked,
			socialMediaSupportEndDate: customerWithRelationsDbObject.social_media_support_end_date,
			socialMediaCreditTransactions: customerWithRelationsDbObject.social_media_credit_transactions,
			socialMediaTotalCredits: customerWithRelationsDbObject.social_media_total_credits,
			socialMediaMonthlyAdsBudget: customerWithRelationsDbObject.social_media_monthly_ads_budget,
			socialMediaMonthlyPostCount: customerWithRelationsDbObject.social_media_monthly_post_count,
			socialMediaFigmaBoardUrl: customerWithRelationsDbObject.social_media_figma_board_url,
			socialMediaSupportStatus: customerWithRelationsDbObject.social_media_support_status,
			customerAcquisitionSearchAdBooked: customerWithRelationsDbObject.customer_acquisition_search_ad_booked,
			customerAcquisitionSearchAdEndDate: customerWithRelationsDbObject.customer_acquisition_search_ad_end_date,
			customerAcquisitionSearchAdMonthlyBudget: customerWithRelationsDbObject.customer_acquisition_search_ad_monthly_budget,
			customerAcquisitionSearchAdStatus: customerWithRelationsDbObject.customer_acquisition_search_ad_status,
			projectManager: customerWithRelationsDbObject.project_manager,
			hasDirectApproaches: customerWithRelationsDbObject.has_direct_approaches,
			createdAt: customerWithRelationsDbObject.created_at,
			updatedAt: customerWithRelationsDbObject.updated_at,
			company: CompanyDto.createFromDbObject(customerWithRelationsDbObject.company),
			career: customerWithRelationsDbObject.career ? CareerDto.createFromDbObject(customerWithRelationsDbObject.career) : void 0,
			jobPositions: customerWithRelationsDbObject.job_positions?.map((jobPosition) => JobPositionInfoDto.createFromDbObject(jobPosition)),
			isCommissionAgreement: customerWithRelationsDbObject.is_commission_agreement,
			isRecruitingAgreement: customerWithRelationsDbObject.is_recruiting_agreement,
			isCareerPageReceiptConfirmationActive: customerWithRelationsDbObject.is_career_page_receipt_confirmation_active,
			isSocialMediaAnalyticsActive: customerWithRelationsDbObject.is_social_media_analytics_active,
			websiteStatus: customerWithRelationsDbObject.website_status,
			websiteEndDate: customerWithRelationsDbObject.website_end_date,
			productVersion: customerWithRelationsDbObject.product_version,
			isRecruitingAutoRenewActive: customerWithRelationsDbObject.is_recruiting_auto_renew_active,
			isCareerPageAutoRenewActive: customerWithRelationsDbObject.is_career_page_auto_renew_active,
			isWebsiteAutoRenewActive: customerWithRelationsDbObject.is_website_auto_renew_active,
			isSocialMediaSupportAutoRenewActive: customerWithRelationsDbObject.is_social_media_support_auto_renew_active
		});
	}
	static createFromCustomerWithRelationsData(customerWithRelationsData) {
		return new CustomerWithRelationsDto({
			id: customerWithRelationsData.id,
			firebaseUid: customerWithRelationsData.firebaseUid,
			mondayItemId: customerWithRelationsData.mondayItemId,
			lastNpsSentAt: customerWithRelationsData.lastNpsSentAt,
			lastNpsScore: customerWithRelationsData.lastNpsScore,
			emailAddress: customerWithRelationsData.emailAddress,
			isFrameworkAgreement: customerWithRelationsData.isFrameworkAgreement,
			agreementEnd: customerWithRelationsData.agreementEnd,
			careerPageStatus: customerWithRelationsData.careerPageStatus,
			searchAdBooked: customerWithRelationsData.searchAdBooked,
			searchAdStatus: customerWithRelationsData.searchAdStatus,
			careerPageEndDate: customerWithRelationsData.careerPageEndDate,
			careerPageMonthlyAdBudget: customerWithRelationsData.careerPageMonthlyAdBudget,
			searchAdEndDate: customerWithRelationsData.searchAdEndDate,
			searchAdMonthlyBudget: customerWithRelationsData.searchAdMonthlyBudget,
			socialMediaSupportBooked: customerWithRelationsData.socialMediaSupportBooked,
			socialMediaSupportEndDate: customerWithRelationsData.socialMediaSupportEndDate,
			socialMediaCreditTransactions: customerWithRelationsData.socialMediaCreditTransactions,
			socialMediaTotalCredits: customerWithRelationsData.socialMediaTotalCredits,
			socialMediaMonthlyAdsBudget: customerWithRelationsData.socialMediaMonthlyAdsBudget,
			socialMediaMonthlyPostCount: customerWithRelationsData.socialMediaMonthlyPostCount,
			socialMediaFigmaBoardUrl: customerWithRelationsData.socialMediaFigmaBoardUrl,
			socialMediaSupportStatus: customerWithRelationsData.socialMediaSupportStatus,
			customerAcquisitionSearchAdEndDate: customerWithRelationsData.customerAcquisitionSearchAdEndDate,
			customerAcquisitionSearchAdBooked: customerWithRelationsData.customerAcquisitionSearchAdBooked,
			customerAcquisitionSearchAdMonthlyBudget: customerWithRelationsData.customerAcquisitionSearchAdMonthlyBudget,
			customerAcquisitionSearchAdStatus: customerWithRelationsData.customerAcquisitionSearchAdStatus,
			projectManager: customerWithRelationsData.projectManager,
			hasDirectApproaches: customerWithRelationsData.hasDirectApproaches,
			createdAt: customerWithRelationsData.createdAt,
			updatedAt: customerWithRelationsData.updatedAt,
			company: CompanyDto.createFromCompanyData(customerWithRelationsData.company),
			career: customerWithRelationsData.career ? CareerDto.createFromCareer(customerWithRelationsData.career) : void 0,
			jobPositions: customerWithRelationsData.jobPositions?.map((jobPosition) => JobPositionInfoDto.createFromJobPositionInfoData(jobPosition)),
			isCommissionAgreement: customerWithRelationsData.isCommissionAgreement,
			isRecruitingAgreement: customerWithRelationsData.isRecruitingAgreement,
			isCareerPageReceiptConfirmationActive: customerWithRelationsData.isCareerPageReceiptConfirmationActive,
			isSocialMediaAnalyticsActive: customerWithRelationsData.isSocialMediaAnalyticsActive,
			websiteStatus: customerWithRelationsData.websiteStatus,
			websiteEndDate: customerWithRelationsData.websiteEndDate,
			productVersion: customerWithRelationsData.productVersion,
			isRecruitingAutoRenewActive: customerWithRelationsData.isRecruitingAutoRenewActive,
			isCareerPageAutoRenewActive: customerWithRelationsData.isCareerPageAutoRenewActive,
			isWebsiteAutoRenewActive: customerWithRelationsData.isWebsiteAutoRenewActive,
			isSocialMediaSupportAutoRenewActive: customerWithRelationsData.isSocialMediaSupportAutoRenewActive
		});
	}
};
// source/models/job-position-analytics/job-position-analytics.ts
var JobPositionAnalytics = class JobPositionAnalytics {
	id;
	customerId;
	jobPositionId;
	fbCampaignId;
	name;
	fbAdsAnalytics;
	createdAt;
	updatedAt;
	constructor({ id, customerId, jobPositionId, fbCampaignId, name, fbAdsAnalytics, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.jobPositionId = jobPositionId;
		this.fbCampaignId = fbCampaignId;
		this.name = name;
		this.fbAdsAnalytics = fbAdsAnalytics;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new JobPositionAnalytics({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			jobPositionId: dbObject.job_position_id,
			fbCampaignId: dbObject.fb_campaign_id,
			name: dbObject.name,
			fbAdsAnalytics: dbObject.fb_ads_analytics,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/job-position-analytics/job-position-analytics-dto.ts
var JobPositionAnalyticsDto = class JobPositionAnalyticsDto {
	id;
	customerId;
	jobPositionId;
	fbCampaignId;
	name;
	fbAdsAnalytics;
	createdAt;
	updatedAt;
	constructor({ id, customerId, jobPositionId, fbCampaignId, name, fbAdsAnalytics, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.jobPositionId = jobPositionId;
		this.fbCampaignId = fbCampaignId;
		this.name = name;
		this.fbAdsAnalytics = fbAdsAnalytics;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toJobPositionAnalytics() {
		return new JobPositionAnalytics({
			id: this.id,
			customerId: this.customerId,
			jobPositionId: this.jobPositionId,
			fbCampaignId: this.fbCampaignId,
			name: this.name,
			fbAdsAnalytics: this.fbAdsAnalytics,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromJobPositionAnalyticsData(data) {
		return new JobPositionAnalyticsDto({
			id: data.id,
			customerId: data.customerId,
			jobPositionId: data.jobPositionId,
			fbCampaignId: data.fbCampaignId,
			name: data.name,
			fbAdsAnalytics: data.fbAdsAnalytics,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new JobPositionAnalyticsDto({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			jobPositionId: dbObject.job_position_id,
			fbCampaignId: dbObject.fb_campaign_id,
			name: dbObject.name,
			fbAdsAnalytics: dbObject.fb_ads_analytics,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/job-position-presets/job-position-presets.ts
var JobPositionPresets = class {
	/**
	* @deprecated Don't append this suffix to the job position name anymore.
	* For now we leave the remove logic via `safelyRemoveSuffixFromString` in the code, in case the suffix gets reintroduced again.
	* If the future shows that the suffix is not needed anymore, we can remove the logic and the suffix.
	*/
	titleSuffix;
	additionalRequirements;
	constructor({ titleSuffix, additionalRequirements }) {
		this.titleSuffix = titleSuffix;
		this.additionalRequirements = additionalRequirements;
	}
};
// source/models/job-position-template/job-position-template.ts
var JobPositionTemplate = class JobPositionTemplate extends JobPositionSettings {
	id;
	customerId;
	createdAt;
	updatedAt;
	constructor({ id, customerId, createdAt, updatedAt, ...jobPositionSettings }) {
		super(jobPositionSettings);
		this.id = id;
		this.customerId = customerId;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new JobPositionTemplate({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			addressZipCode: dbObject.address_zip_code,
			addressCity: dbObject.address_city,
			weeklyHours: dbObject.weekly_hours,
			weeklyHoursMax: dbObject.weekly_hours_max,
			schedule: dbObject.schedule,
			shiftWork: dbObject.shift_work,
			startDate: dbObject.start_date,
			salary: dbObject.salary,
			salaryIsPublic: dbObject.salary_is_public,
			salutation: dbObject.salutation,
			searchArea: dbObject.search_area,
			searchCenter: dbObject.search_center,
			searchCenterCountry: dbObject.search_center_country,
			searchRadius: dbObject.search_radius,
			cvRequired: dbObject.cv_required,
			cvRequiredInForm: dbObject.cv_required_in_form,
			emailRecipients: dbObject.email_recipients,
			type: dbObject.type,
			fieldServiceAndHomeOffice: dbObject.field_service_and_home_office,
			otherManagerInfo: dbObject.other_manager_info,
			trainingDuration: dbObject.training_duration,
			isFlexibleInternshipPossible: dbObject.is_flexible_internship_possible,
			requirements: dbObject.requirements,
			additionalRequirements: dbObject.additional_requirements,
			tasks: dbObject.tasks,
			benefits: dbObject.benefits,
			contactPersonName: dbObject.contact_person_name,
			contactPersonPosition: dbObject.contact_person_position,
			contactPersonEmail: dbObject.contact_person_email,
			contactPersonSalutation: dbObject.contact_person_salutation,
			addressLink: dbObject.address_link,
			traineeFirstYearSalary: dbObject.trainee_first_year_salary,
			traineeSecondYearSalary: dbObject.trainee_second_year_salary,
			traineeThirdYearSalary: dbObject.trainee_third_year_salary,
			traineeFourthYearSalary: dbObject.trainee_fourth_year_salary,
			dualStudentSalary: dbObject.dual_student_salary,
			locationId: dbObject.location_id,
			workAreaId: dbObject.work_area_id,
			applicantNotesTemplate: dbObject.applicant_notes_template,
			documentsRequiredForForwarding: dbObject.documents_required_for_forwarding,
			requiredDocumentsDescription: dbObject.required_documents_description,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/job-position-template/job-position-template-creation-dto.ts
var JobPositionTemplateCreationDto = class JobPositionTemplateCreationDto extends JobPositionSettings {
	customerId;
	constructor({ customerId, ...jobPositionSettings }) {
		super(jobPositionSettings);
		this.customerId = customerId;
	}
	static createFromJobPositionTemplateUpdateData(data) {
		return new JobPositionTemplateCreationDto({
			customerId: data.customerId,
			addressZipCode: data.addressZipCode,
			addressCity: data.addressCity,
			weeklyHours: data.weeklyHours,
			weeklyHoursMax: data.weeklyHoursMax,
			schedule: data.schedule,
			shiftWork: data.shiftWork,
			startDate: data.startDate,
			salary: data.salary,
			salaryIsPublic: data.salaryIsPublic,
			salutation: data.salutation,
			searchArea: data.searchArea,
			searchCenter: data.searchCenter,
			searchCenterCountry: data.searchCenterCountry,
			searchRadius: data.searchRadius,
			cvRequired: data.cvRequired,
			cvRequiredInForm: data.cvRequiredInForm,
			emailRecipients: data.emailRecipients,
			type: data.type,
			fieldServiceAndHomeOffice: data.fieldServiceAndHomeOffice,
			otherManagerInfo: data.otherManagerInfo,
			trainingDuration: data.trainingDuration,
			isFlexibleInternshipPossible: data.isFlexibleInternshipPossible,
			requirements: data.requirements,
			additionalRequirements: data.additionalRequirements,
			tasks: data.tasks,
			benefits: data.benefits,
			contactPersonName: data.contactPersonName,
			contactPersonPosition: data.contactPersonPosition,
			contactPersonEmail: data.contactPersonEmail,
			contactPersonSalutation: data.contactPersonSalutation,
			addressLink: data.addressLink,
			traineeFirstYearSalary: data.traineeFirstYearSalary,
			traineeSecondYearSalary: data.traineeSecondYearSalary,
			traineeThirdYearSalary: data.traineeThirdYearSalary,
			traineeFourthYearSalary: data.traineeFourthYearSalary,
			dualStudentSalary: data.dualStudentSalary,
			locationId: data.locationId,
			workAreaId: data.workAreaId,
			applicantNotesTemplate: data.applicantNotesTemplate,
			documentsRequiredForForwarding: data.documentsRequiredForForwarding,
			requiredDocumentsDescription: data.requiredDocumentsDescription
		});
	}
	convertToDbObject() {
		return {
			customer_id: this.customerId,
			address_zip_code: this.addressZipCode,
			address_city: this.addressCity,
			weekly_hours: this.weeklyHours,
			weekly_hours_max: this.weeklyHoursMax,
			schedule: this.schedule,
			shift_work: this.shiftWork,
			start_date: this.startDate,
			salary: this.salary,
			salary_is_public: this.salaryIsPublic,
			salutation: this.salutation,
			search_area: this.searchArea,
			search_center: this.searchCenter,
			search_center_country: this.searchCenterCountry,
			search_radius: this.searchRadius,
			cv_required: this.cvRequired,
			cv_required_in_form: this.cvRequiredInForm,
			email_recipients: this.emailRecipients,
			type: this.type,
			field_service_and_home_office: this.fieldServiceAndHomeOffice,
			other_manager_info: this.otherManagerInfo,
			training_duration: this.trainingDuration,
			is_flexible_internship_possible: this.isFlexibleInternshipPossible,
			requirements: this.requirements,
			additional_requirements: this.additionalRequirements,
			tasks: this.tasks,
			benefits: this.benefits,
			contact_person_name: this.contactPersonName,
			contact_person_position: this.contactPersonPosition,
			contact_person_email: this.contactPersonEmail,
			address_link: this.addressLink,
			trainee_first_year_salary: this.traineeFirstYearSalary,
			trainee_second_year_salary: this.traineeSecondYearSalary,
			trainee_third_year_salary: this.traineeThirdYearSalary,
			trainee_fourth_year_salary: this.traineeFourthYearSalary,
			dualStudentSalary: this.dualStudentSalary,
			locationId: this.locationId,
			workAreaId: this.workAreaId,
			applicantNotesTemplate: this.applicantNotesTemplate,
			documents_required_for_forwarding: this.documentsRequiredForForwarding,
			required_documents_description: this.requiredDocumentsDescription
		};
	}
};
// source/models/job-position-template/job-position-template-dto.ts
var JobPositionTemplateDto = class JobPositionTemplateDto extends JobPositionSettings {
	id;
	customerId;
	createdAt;
	updatedAt;
	constructor({ id, customerId, createdAt, updatedAt, ...jobPositionSettings }) {
		super(jobPositionSettings);
		this.id = id;
		this.customerId = customerId;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toJobPositionTemplate() {
		return new JobPositionTemplate({
			id: this.id,
			customerId: this.customerId,
			addressZipCode: this.addressZipCode,
			addressCity: this.addressCity,
			weeklyHours: this.weeklyHours,
			weeklyHoursMax: this.weeklyHoursMax,
			schedule: this.schedule,
			shiftWork: this.shiftWork,
			startDate: this.startDate,
			salary: this.salary,
			salaryIsPublic: this.salaryIsPublic,
			salutation: this.salutation,
			searchArea: this.searchArea,
			searchCenter: this.searchCenter,
			searchCenterCountry: this.searchCenterCountry,
			searchRadius: this.searchRadius,
			cvRequired: this.cvRequired,
			cvRequiredInForm: this.cvRequiredInForm,
			emailRecipients: this.emailRecipients,
			type: this.type,
			fieldServiceAndHomeOffice: this.fieldServiceAndHomeOffice,
			otherManagerInfo: this.otherManagerInfo,
			trainingDuration: this.trainingDuration,
			isFlexibleInternshipPossible: this.isFlexibleInternshipPossible,
			requirements: this.requirements,
			additionalRequirements: this.additionalRequirements,
			tasks: this.tasks,
			benefits: this.benefits,
			contactPersonName: this.contactPersonName,
			contactPersonPosition: this.contactPersonPosition,
			contactPersonEmail: this.contactPersonEmail,
			contactPersonSalutation: this.contactPersonSalutation,
			addressLink: this.addressLink,
			traineeFirstYearSalary: this.traineeFirstYearSalary,
			traineeSecondYearSalary: this.traineeSecondYearSalary,
			traineeThirdYearSalary: this.traineeThirdYearSalary,
			traineeFourthYearSalary: this.traineeFourthYearSalary,
			dualStudentSalary: this.dualStudentSalary,
			locationId: this.locationId,
			workAreaId: this.workAreaId,
			applicantNotesTemplate: this.applicantNotesTemplate,
			documentsRequiredForForwarding: this.documentsRequiredForForwarding,
			requiredDocumentsDescription: this.requiredDocumentsDescription,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromJobPositionTemplate(JobPositionTemplate) {
		return new JobPositionTemplateDto({
			id: JobPositionTemplate.id,
			customerId: JobPositionTemplate.customerId,
			addressZipCode: JobPositionTemplate.addressZipCode,
			addressCity: JobPositionTemplate.addressCity,
			weeklyHours: JobPositionTemplate.weeklyHours,
			weeklyHoursMax: JobPositionTemplate.weeklyHoursMax,
			schedule: JobPositionTemplate.schedule,
			shiftWork: JobPositionTemplate.shiftWork,
			startDate: JobPositionTemplate.startDate,
			salary: JobPositionTemplate.salary,
			salaryIsPublic: JobPositionTemplate.salaryIsPublic,
			salutation: JobPositionTemplate.salutation,
			searchArea: JobPositionTemplate.searchArea,
			searchCenter: JobPositionTemplate.searchCenter,
			searchCenterCountry: JobPositionTemplate.searchCenterCountry,
			searchRadius: JobPositionTemplate.searchRadius,
			cvRequired: JobPositionTemplate.cvRequired,
			cvRequiredInForm: JobPositionTemplate.cvRequiredInForm,
			emailRecipients: JobPositionTemplate.emailRecipients,
			type: JobPositionTemplate.type,
			fieldServiceAndHomeOffice: JobPositionTemplate.fieldServiceAndHomeOffice,
			otherManagerInfo: JobPositionTemplate.otherManagerInfo,
			trainingDuration: JobPositionTemplate.trainingDuration,
			isFlexibleInternshipPossible: JobPositionTemplate.isFlexibleInternshipPossible,
			requirements: JobPositionTemplate.requirements,
			additionalRequirements: JobPositionTemplate.additionalRequirements,
			tasks: JobPositionTemplate.tasks,
			benefits: JobPositionTemplate.benefits,
			contactPersonName: JobPositionTemplate.contactPersonName,
			contactPersonPosition: JobPositionTemplate.contactPersonPosition,
			contactPersonEmail: JobPositionTemplate.contactPersonEmail,
			contactPersonSalutation: JobPositionTemplate.contactPersonSalutation,
			addressLink: JobPositionTemplate.addressLink,
			traineeFirstYearSalary: JobPositionTemplate.traineeFirstYearSalary,
			traineeSecondYearSalary: JobPositionTemplate.traineeSecondYearSalary,
			traineeThirdYearSalary: JobPositionTemplate.traineeThirdYearSalary,
			traineeFourthYearSalary: JobPositionTemplate.traineeFourthYearSalary,
			dualStudentSalary: JobPositionTemplate.dualStudentSalary,
			locationId: JobPositionTemplate.locationId,
			workAreaId: JobPositionTemplate.workAreaId,
			applicantNotesTemplate: JobPositionTemplate.applicantNotesTemplate,
			documentsRequiredForForwarding: JobPositionTemplate.documentsRequiredForForwarding,
			requiredDocumentsDescription: JobPositionTemplate.requiredDocumentsDescription,
			createdAt: JobPositionTemplate.createdAt,
			updatedAt: JobPositionTemplate.updatedAt
		});
	}
	static createFromJobPositionTemplateData(data) {
		return new JobPositionTemplateDto({
			id: data.id,
			customerId: data.customerId,
			addressZipCode: data.addressZipCode,
			addressCity: data.addressCity,
			weeklyHours: data.weeklyHours,
			weeklyHoursMax: data.weeklyHoursMax,
			schedule: data.schedule,
			shiftWork: data.shiftWork,
			startDate: data.startDate,
			salary: data.salary,
			salaryIsPublic: data.salaryIsPublic,
			salutation: data.salutation,
			searchArea: data.searchArea,
			searchCenter: data.searchCenter,
			searchCenterCountry: data.searchCenterCountry,
			searchRadius: data.searchRadius,
			cvRequired: data.cvRequired,
			cvRequiredInForm: data.cvRequiredInForm,
			emailRecipients: data.emailRecipients,
			type: data.type,
			fieldServiceAndHomeOffice: data.fieldServiceAndHomeOffice,
			otherManagerInfo: data.otherManagerInfo,
			trainingDuration: data.trainingDuration,
			isFlexibleInternshipPossible: data.isFlexibleInternshipPossible,
			requirements: data.requirements,
			additionalRequirements: data.additionalRequirements,
			tasks: data.tasks,
			benefits: data.benefits,
			contactPersonName: data.contactPersonName,
			contactPersonPosition: data.contactPersonPosition,
			contactPersonEmail: data.contactPersonEmail,
			contactPersonSalutation: data.contactPersonSalutation,
			addressLink: data.addressLink,
			traineeFirstYearSalary: data.traineeFirstYearSalary,
			traineeSecondYearSalary: data.traineeSecondYearSalary,
			traineeThirdYearSalary: data.traineeThirdYearSalary,
			traineeFourthYearSalary: data.traineeFourthYearSalary,
			dualStudentSalary: data.dualStudentSalary,
			locationId: data.locationId,
			workAreaId: data.workAreaId,
			applicantNotesTemplate: data.applicantNotesTemplate,
			documentsRequiredForForwarding: data.documentsRequiredForForwarding,
			requiredDocumentsDescription: data.requiredDocumentsDescription,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new JobPositionTemplateDto({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			addressZipCode: dbObject.address_zip_code,
			addressCity: dbObject.address_city,
			weeklyHours: dbObject.weekly_hours,
			weeklyHoursMax: dbObject.weekly_hours_max,
			schedule: dbObject.schedule,
			shiftWork: dbObject.shift_work,
			startDate: dbObject.start_date,
			salary: dbObject.salary,
			salaryIsPublic: dbObject.salary_is_public,
			salutation: dbObject.salutation,
			searchArea: dbObject.search_area,
			searchCenter: dbObject.search_center,
			searchCenterCountry: dbObject.search_center_country,
			searchRadius: dbObject.search_radius,
			cvRequired: dbObject.cv_required,
			cvRequiredInForm: dbObject.cv_required_in_form,
			emailRecipients: dbObject.email_recipients,
			type: dbObject.type,
			fieldServiceAndHomeOffice: dbObject.field_service_and_home_office,
			otherManagerInfo: dbObject.other_manager_info,
			trainingDuration: dbObject.training_duration,
			isFlexibleInternshipPossible: dbObject.is_flexible_internship_possible,
			requirements: dbObject.requirements,
			additionalRequirements: dbObject.additional_requirements,
			tasks: dbObject.tasks,
			benefits: dbObject.benefits,
			contactPersonName: dbObject.contact_person_name,
			contactPersonPosition: dbObject.contact_person_position,
			contactPersonEmail: dbObject.contact_person_email,
			contactPersonSalutation: dbObject.contact_person_salutation,
			addressLink: dbObject.address_link,
			traineeFirstYearSalary: dbObject.trainee_first_year_salary,
			traineeSecondYearSalary: dbObject.trainee_second_year_salary,
			traineeThirdYearSalary: dbObject.trainee_third_year_salary,
			traineeFourthYearSalary: dbObject.trainee_fourth_year_salary,
			dualStudentSalary: dbObject.dual_student_salary,
			locationId: dbObject.location_id,
			workAreaId: dbObject.work_area_id,
			applicantNotesTemplate: dbObject.applicant_notes_template,
			documentsRequiredForForwarding: dbObject.documents_required_for_forwarding,
			requiredDocumentsDescription: dbObject.required_documents_description,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/job-position-template/job-position-template-update-dto.ts
var JobPositionTemplateUpdateDto = class JobPositionTemplateUpdateDto extends JobPositionSettings {
	static createFromJobPositionTemplateUpdateData(data) {
		return new JobPositionTemplateUpdateDto({
			addressZipCode: data.addressZipCode,
			addressCity: data.addressCity,
			weeklyHours: data.weeklyHours,
			weeklyHoursMax: data.weeklyHoursMax,
			schedule: data.schedule,
			shiftWork: data.shiftWork,
			startDate: data.startDate,
			salary: data.salary,
			salaryIsPublic: data.salaryIsPublic,
			salutation: data.salutation,
			searchArea: data.searchArea,
			searchCenter: data.searchCenter,
			searchCenterCountry: data.searchCenterCountry,
			searchRadius: data.searchRadius,
			cvRequired: data.cvRequired,
			cvRequiredInForm: data.cvRequiredInForm,
			emailRecipients: data.emailRecipients,
			type: data.type,
			fieldServiceAndHomeOffice: data.fieldServiceAndHomeOffice,
			otherManagerInfo: data.otherManagerInfo,
			trainingDuration: data.trainingDuration,
			isFlexibleInternshipPossible: data.isFlexibleInternshipPossible,
			requirements: data.requirements,
			additionalRequirements: data.additionalRequirements,
			tasks: data.tasks,
			benefits: data.benefits,
			contactPersonName: data.contactPersonName,
			contactPersonPosition: data.contactPersonPosition,
			contactPersonEmail: data.contactPersonEmail,
			contactPersonSalutation: data.contactPersonSalutation,
			addressLink: data.addressLink,
			traineeFirstYearSalary: data.traineeFirstYearSalary,
			traineeSecondYearSalary: data.traineeSecondYearSalary,
			traineeThirdYearSalary: data.traineeThirdYearSalary,
			traineeFourthYearSalary: data.traineeFourthYearSalary,
			dualStudentSalary: data.dualStudentSalary,
			locationId: data.locationId,
			workAreaId: data.workAreaId,
			applicantNotesTemplate: data.applicantNotesTemplate,
			documentsRequiredForForwarding: data.documentsRequiredForForwarding,
			requiredDocumentsDescription: data.requiredDocumentsDescription
		});
	}
	convertToDbObject() {
		return {
			address_zip_code: this.addressZipCode,
			address_city: this.addressCity,
			weekly_hours: this.weeklyHours,
			salary: this.salary,
			salary_is_public: this.salaryIsPublic,
			salutation: this.salutation,
			search_area: this.searchArea,
			search_center: this.searchCenter,
			search_center_country: this.searchCenterCountry,
			search_radius: this.searchRadius,
			cv_required: this.cvRequired,
			cv_required_in_form: this.cvRequiredInForm,
			email_recipients: this.emailRecipients,
			type: this.type,
			field_service_and_home_office: this.fieldServiceAndHomeOffice,
			other_manager_info: this.otherManagerInfo,
			training_duration: this.trainingDuration,
			is_flexible_internship_possible: this.isFlexibleInternshipPossible,
			requirements: this.requirements,
			additional_requirements: this.additionalRequirements,
			tasks: this.tasks,
			benefits: this.benefits,
			contact_person_name: this.contactPersonName,
			contact_person_position: this.contactPersonPosition,
			contact_person_email: this.contactPersonEmail,
			address_link: this.addressLink,
			trainee_first_year_salary: this.traineeFirstYearSalary,
			trainee_second_year_salary: this.traineeSecondYearSalary,
			trainee_third_year_salary: this.traineeThirdYearSalary,
			trainee_fourth_year_salary: this.traineeFourthYearSalary,
			dual_student_salary: this.dualStudentSalary,
			location_id: this.locationId,
			work_area_id: this.workAreaId,
			applicant_notes_template: this.applicantNotesTemplate,
			documents_required_for_forwarding: this.documentsRequiredForForwarding,
			required_documents_description: this.requiredDocumentsDescription
		};
	}
};
// source/models/monday/monday-project-manager.ts
var MondayProjectManager = class MondayProjectManager {
	id;
	name;
	profilePictureDataUrl;
	phoneNumber;
	emailAddress;
	calendlyPopUpUrl;
	constructor({ id, name, profilePictureDataUrl, phoneNumber, emailAddress, calendlyPopUpUrl }) {
		this.id = id;
		this.name = name;
		this.profilePictureDataUrl = profilePictureDataUrl;
		this.phoneNumber = phoneNumber;
		this.emailAddress = emailAddress;
		this.calendlyPopUpUrl = calendlyPopUpUrl;
	}
	static createFromData(data) {
		return new MondayProjectManager({
			id: data.id,
			name: data.name,
			profilePictureDataUrl: data.profilePictureDataUrl,
			phoneNumber: data.phoneNumber,
			emailAddress: data.emailAddress,
			calendlyPopUpUrl: data.calendlyPopUpUrl
		});
	}
};
// source/models/monday/monday-social-media-campaign-credit-transaction.ts
var MondaySocialMediaCampaignCreditTransaction = class MondaySocialMediaCampaignCreditTransaction {
	at;
	count;
	newTotal;
	description;
	constructor({ at, count, newTotal, description }) {
		this.at = at;
		this.count = count;
		this.newTotal = newTotal;
		this.description = description;
	}
	static createFromData(data) {
		return new MondaySocialMediaCampaignCreditTransaction({
			at: data.at,
			count: data.count,
			newTotal: data.newTotal,
			description: data.description
		});
	}
	toJSON() {
		return {
			at: this.at instanceof Date && !Number.isNaN(this.at.getTime()) ? this.at.toISOString() : this.at,
			count: this.count,
			newTotal: this.newTotal,
			description: this.description
		};
	}
};
// source/models/monday/monday-social-media-campaign-credits.ts
var MondaySocialMediaCampaignCredits = class MondaySocialMediaCampaignCredits {
	total;
	transactions;
	constructor({ total, transactions }) {
		this.total = total;
		this.transactions = transactions;
	}
	static createFromData(data) {
		return new MondaySocialMediaCampaignCredits({
			total: data.total,
			transactions: data.transactions.map((x) => MondaySocialMediaCampaignCreditTransaction.createFromData(x))
		});
	}
};
// source/models/monday/monday-customer.ts
var MondayCustomer = class MondayCustomer {
	id;
	name;
	logoDataUrl;
	startScreenImageDataUrl;
	projectManager;
	googleDriveDownloadUrl;
	googleDriveUploadUrl;
	todos;
	isDecisionFreedomEnabled;
	isFrameworkAgreement;
	isDynamicRecruiting;
	socialMediaCampaignCredits;
	annualContractEndAt;
	npsLogs;
	isCommissionAgreement;
	isRecruitingAgreement;
	productVersion;
	isRecruitingAutoRenewActive;
	constructor({ id, name, logoDataUrl, startScreenImageDataUrl, projectManager, googleDriveDownloadUrl = null, googleDriveUploadUrl = null, todos, isDecisionFreedomEnabled, isFrameworkAgreement, isDynamicRecruiting, socialMediaCampaignCredits = null, annualContractEndAt = null, npsLogs, isCommissionAgreement, isRecruitingAgreement, productVersion, isRecruitingAutoRenewActive }) {
		this.id = id;
		this.name = name;
		this.logoDataUrl = logoDataUrl;
		this.startScreenImageDataUrl = startScreenImageDataUrl;
		this.projectManager = projectManager;
		this.googleDriveDownloadUrl = googleDriveDownloadUrl;
		this.googleDriveUploadUrl = googleDriveUploadUrl;
		this.todos = todos;
		this.isDecisionFreedomEnabled = isDecisionFreedomEnabled;
		this.isFrameworkAgreement = isFrameworkAgreement;
		this.isDynamicRecruiting = isDynamicRecruiting;
		this.socialMediaCampaignCredits = socialMediaCampaignCredits;
		this.annualContractEndAt = annualContractEndAt;
		this.npsLogs = npsLogs;
		this.isCommissionAgreement = isCommissionAgreement;
		this.isRecruitingAgreement = isRecruitingAgreement;
		this.productVersion = productVersion;
		this.isRecruitingAutoRenewActive = isRecruitingAutoRenewActive;
	}
	static createFromData(data) {
		return new MondayCustomer({
			id: data.id,
			name: data.name,
			logoDataUrl: data.logoDataUrl,
			startScreenImageDataUrl: data.startScreenImageDataUrl,
			projectManager: data.projectManager ? MondayProjectManager.createFromData(data.projectManager) : null,
			googleDriveDownloadUrl: data.googleDriveDownloadUrl,
			googleDriveUploadUrl: data.googleDriveUploadUrl,
			todos: data.todos,
			isDecisionFreedomEnabled: data.isDecisionFreedomEnabled,
			isFrameworkAgreement: data.isFrameworkAgreement,
			isDynamicRecruiting: data.isDynamicRecruiting,
			socialMediaCampaignCredits: data.socialMediaCampaignCredits === null ? null : MondaySocialMediaCampaignCredits.createFromData(data.socialMediaCampaignCredits),
			annualContractEndAt: data.annualContractEndAt,
			npsLogs: data.npsLogs,
			isCommissionAgreement: data.isCommissionAgreement,
			isRecruitingAgreement: data.isRecruitingAgreement,
			productVersion: data.productVersion,
			isRecruitingAutoRenewActive: data.isRecruitingAutoRenewActive
		});
	}
};
// source/models/monday/monday-social-media-support.ts
var MondaySocialMediaSupport = class MondaySocialMediaSupport {
	id;
	state;
	monthlyAdsBudget;
	monthlyPostCount;
	figmaBoardUrl;
	endsAt;
	isAutoRenewActive;
	constructor({ id, state, monthlyAdsBudget = null, monthlyPostCount = null, figmaBoardUrl = null, endsAt = null, isAutoRenewActive = false }) {
		this.id = id;
		this.state = state;
		this.monthlyAdsBudget = monthlyAdsBudget;
		this.monthlyPostCount = monthlyPostCount;
		this.figmaBoardUrl = figmaBoardUrl;
		this.endsAt = endsAt;
		this.isAutoRenewActive = isAutoRenewActive;
	}
	static createFromData(data) {
		return new MondaySocialMediaSupport({
			id: data.id,
			state: data.state,
			monthlyAdsBudget: data.monthlyAdsBudget,
			monthlyPostCount: data.monthlyPostCount,
			figmaBoardUrl: data.figmaBoardUrl,
			endsAt: data.endsAt,
			isAutoRenewActive: data.isAutoRenewActive
		});
	}
};
// source/models/monday/monday-customer-data-package.ts
var MondayCustomerDataPackage = class MondayCustomerDataPackage {
	customer;
	socialMediaSupport;
	constructor({ customer, socialMediaSupport = null }) {
		this.customer = customer;
		this.socialMediaSupport = socialMediaSupport;
	}
	getSocialMediaSupportState() {
		return polyfillMondayCustomState(this.socialMediaSupport?.state);
	}
	static createFromData(data) {
		return new MondayCustomerDataPackage({
			customer: MondayCustomer.createFromData(data.customer),
			socialMediaSupport: data.socialMediaSupport === null ? null : MondaySocialMediaSupport.createFromData(data.socialMediaSupport)
		});
	}
};
// source/models/monday-recruiting/monday-recruiting.ts
var MondayRecruiting = class MondayRecruiting {
	id;
	mondayItemId;
	jobPositionName;
	customerName;
	customerMondayItemId;
	customerId;
	quotaCredits;
	applicantManagerName;
	accountManager;
	marketingManager;
	jobPositionIds;
	phase;
	landingPageUrl;
	landingPageWlUrl;
	adsUrl;
	monthlyAdvertisingBudget;
	dailyAdvertisingBudget28Days;
	dailyAdvertisingBudget31Days;
	documentObjectId;
	quotaEndsAt;
	shouldExpire;
	customerDecisionFreedom;
	customerDocumentUrl;
	customerAgreement;
	productVersion;
	customerGuarantee;
	subitemMondayItemIds;
	status;
	statusChangedAt;
	createdAt;
	updatedAt;
	constructor({ id, mondayItemId, jobPositionName, customerName, customerMondayItemId, customerId, quotaCredits, applicantManagerName, accountManager, marketingManager, jobPositionIds, phase, landingPageUrl, landingPageWlUrl, adsUrl, monthlyAdvertisingBudget, dailyAdvertisingBudget28Days, dailyAdvertisingBudget31Days, documentObjectId, quotaEndsAt, shouldExpire, customerDecisionFreedom, customerDocumentUrl, customerAgreement, productVersion, customerGuarantee, subitemMondayItemIds, status, statusChangedAt, createdAt, updatedAt }) {
		this.id = id;
		this.mondayItemId = mondayItemId;
		this.jobPositionName = jobPositionName;
		this.customerName = customerName;
		this.customerMondayItemId = customerMondayItemId;
		this.customerId = customerId;
		this.quotaCredits = quotaCredits;
		this.applicantManagerName = applicantManagerName;
		this.accountManager = accountManager;
		this.marketingManager = marketingManager;
		this.jobPositionIds = jobPositionIds;
		this.phase = phase;
		this.landingPageUrl = landingPageUrl;
		this.landingPageWlUrl = landingPageWlUrl;
		this.adsUrl = adsUrl;
		this.monthlyAdvertisingBudget = monthlyAdvertisingBudget;
		this.dailyAdvertisingBudget28Days = dailyAdvertisingBudget28Days;
		this.dailyAdvertisingBudget31Days = dailyAdvertisingBudget31Days;
		this.documentObjectId = documentObjectId;
		this.quotaEndsAt = quotaEndsAt;
		this.shouldExpire = shouldExpire;
		this.customerDecisionFreedom = customerDecisionFreedom;
		this.customerDocumentUrl = customerDocumentUrl;
		this.customerAgreement = customerAgreement;
		this.productVersion = productVersion;
		this.customerGuarantee = customerGuarantee;
		this.subitemMondayItemIds = subitemMondayItemIds;
		this.status = status;
		this.statusChangedAt = statusChangedAt;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new MondayRecruiting({
			id: dbObject.id,
			mondayItemId: dbObject.monday_item_id,
			jobPositionName: dbObject.job_position_name,
			customerName: dbObject.customer_name,
			customerMondayItemId: dbObject.customer_monday_item_id,
			customerId: dbObject.customer_id,
			quotaCredits: dbObject.quota_credits,
			applicantManagerName: dbObject.applicant_manager_name,
			accountManager: dbObject.account_manager,
			marketingManager: dbObject.marketing_manager,
			jobPositionIds: dbObject.job_position_ids,
			phase: dbObject.phase,
			landingPageUrl: dbObject.landing_page_url,
			landingPageWlUrl: dbObject.landing_page_wl_url,
			adsUrl: dbObject.ads_url,
			monthlyAdvertisingBudget: dbObject.monthly_advertising_budget,
			dailyAdvertisingBudget28Days: dbObject.daily_advertising_budget_28_days,
			dailyAdvertisingBudget31Days: dbObject.daily_advertising_budget_31_days,
			documentObjectId: dbObject.document_object_id,
			quotaEndsAt: dbObject.quota_ends_at,
			shouldExpire: dbObject.should_expire,
			customerDecisionFreedom: dbObject.customer_decision_freedom,
			customerDocumentUrl: dbObject.customer_document_url,
			customerAgreement: dbObject.customer_agreement,
			productVersion: dbObject.product_version,
			customerGuarantee: dbObject.customer_guarantee,
			subitemMondayItemIds: dbObject.subitem_monday_item_ids,
			status: dbObject.status,
			statusChangedAt: dbObject.status_changed_at,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/monday-recruiting/monday-recruiting-dto.ts
var MondayRecruitingDto = class MondayRecruitingDto {
	id;
	mondayItemId;
	jobPositionName;
	customerName;
	customerMondayItemId;
	customerId;
	quotaCredits;
	applicantManagerName;
	accountManager;
	marketingManager;
	jobPositionIds;
	phase;
	landingPageUrl;
	landingPageWlUrl;
	adsUrl;
	monthlyAdvertisingBudget;
	dailyAdvertisingBudget28Days;
	dailyAdvertisingBudget31Days;
	documentObjectId;
	quotaEndsAt;
	shouldExpire;
	customerDecisionFreedom;
	customerDocumentUrl;
	customerAgreement;
	productVersion;
	customerGuarantee;
	subitemMondayItemIds;
	status;
	statusChangedAt;
	createdAt;
	updatedAt;
	constructor({ id, mondayItemId, jobPositionName, customerName, customerMondayItemId, customerId, quotaCredits, applicantManagerName, accountManager, marketingManager, jobPositionIds, phase, landingPageUrl, landingPageWlUrl, adsUrl, monthlyAdvertisingBudget, dailyAdvertisingBudget28Days, dailyAdvertisingBudget31Days, documentObjectId, quotaEndsAt, shouldExpire, customerDecisionFreedom, customerDocumentUrl, customerAgreement, productVersion, customerGuarantee, subitemMondayItemIds, status, statusChangedAt, createdAt, updatedAt }) {
		this.id = id;
		this.mondayItemId = mondayItemId;
		this.jobPositionName = jobPositionName;
		this.customerName = customerName;
		this.customerMondayItemId = customerMondayItemId;
		this.customerId = customerId;
		this.quotaCredits = quotaCredits;
		this.applicantManagerName = applicantManagerName;
		this.accountManager = accountManager;
		this.marketingManager = marketingManager;
		this.jobPositionIds = jobPositionIds;
		this.phase = phase;
		this.landingPageUrl = landingPageUrl;
		this.landingPageWlUrl = landingPageWlUrl;
		this.adsUrl = adsUrl;
		this.monthlyAdvertisingBudget = monthlyAdvertisingBudget;
		this.dailyAdvertisingBudget28Days = dailyAdvertisingBudget28Days;
		this.dailyAdvertisingBudget31Days = dailyAdvertisingBudget31Days;
		this.documentObjectId = documentObjectId;
		this.quotaEndsAt = quotaEndsAt;
		this.shouldExpire = shouldExpire;
		this.customerDecisionFreedom = customerDecisionFreedom;
		this.customerDocumentUrl = customerDocumentUrl;
		this.customerAgreement = customerAgreement;
		this.productVersion = productVersion;
		this.customerGuarantee = customerGuarantee;
		this.subitemMondayItemIds = subitemMondayItemIds;
		this.status = status;
		this.statusChangedAt = statusChangedAt;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toMondayRecruiting() {
		return new MondayRecruiting({
			id: this.id,
			mondayItemId: this.mondayItemId,
			jobPositionName: this.jobPositionName,
			customerName: this.customerName,
			customerMondayItemId: this.customerMondayItemId,
			customerId: this.customerId,
			quotaCredits: this.quotaCredits,
			applicantManagerName: this.applicantManagerName,
			accountManager: this.accountManager,
			marketingManager: this.marketingManager,
			jobPositionIds: this.jobPositionIds,
			phase: this.phase,
			landingPageUrl: this.landingPageUrl,
			landingPageWlUrl: this.landingPageWlUrl,
			adsUrl: this.adsUrl,
			monthlyAdvertisingBudget: this.monthlyAdvertisingBudget,
			dailyAdvertisingBudget28Days: this.dailyAdvertisingBudget28Days,
			dailyAdvertisingBudget31Days: this.dailyAdvertisingBudget31Days,
			documentObjectId: this.documentObjectId,
			quotaEndsAt: this.quotaEndsAt,
			shouldExpire: this.shouldExpire,
			customerDecisionFreedom: this.customerDecisionFreedom,
			customerDocumentUrl: this.customerDocumentUrl,
			customerAgreement: this.customerAgreement,
			productVersion: this.productVersion,
			customerGuarantee: this.customerGuarantee,
			subitemMondayItemIds: this.subitemMondayItemIds,
			status: this.status,
			statusChangedAt: this.statusChangedAt,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromMondayRecruiting(mondayRecruiting) {
		return new MondayRecruitingDto({
			id: mondayRecruiting.id,
			mondayItemId: mondayRecruiting.mondayItemId,
			jobPositionName: mondayRecruiting.jobPositionName,
			customerName: mondayRecruiting.customerName,
			customerMondayItemId: mondayRecruiting.customerMondayItemId,
			customerId: mondayRecruiting.customerId,
			quotaCredits: mondayRecruiting.quotaCredits,
			applicantManagerName: mondayRecruiting.applicantManagerName,
			accountManager: mondayRecruiting.accountManager,
			marketingManager: mondayRecruiting.marketingManager,
			jobPositionIds: mondayRecruiting.jobPositionIds,
			phase: mondayRecruiting.phase,
			landingPageUrl: mondayRecruiting.landingPageUrl,
			landingPageWlUrl: mondayRecruiting.landingPageWlUrl,
			adsUrl: mondayRecruiting.adsUrl,
			monthlyAdvertisingBudget: mondayRecruiting.monthlyAdvertisingBudget,
			dailyAdvertisingBudget28Days: mondayRecruiting.dailyAdvertisingBudget28Days,
			dailyAdvertisingBudget31Days: mondayRecruiting.dailyAdvertisingBudget31Days,
			documentObjectId: mondayRecruiting.documentObjectId,
			quotaEndsAt: mondayRecruiting.quotaEndsAt,
			shouldExpire: mondayRecruiting.shouldExpire,
			customerDecisionFreedom: mondayRecruiting.customerDecisionFreedom,
			customerDocumentUrl: mondayRecruiting.customerDocumentUrl,
			customerAgreement: mondayRecruiting.customerAgreement,
			productVersion: mondayRecruiting.productVersion,
			customerGuarantee: mondayRecruiting.customerGuarantee,
			subitemMondayItemIds: mondayRecruiting.subitemMondayItemIds,
			status: mondayRecruiting.status,
			statusChangedAt: mondayRecruiting.statusChangedAt,
			createdAt: mondayRecruiting.createdAt,
			updatedAt: mondayRecruiting.updatedAt
		});
	}
	static createFromMondayRecruitingData(data) {
		return new MondayRecruitingDto({
			id: data.id,
			mondayItemId: data.mondayItemId,
			jobPositionName: data.jobPositionName,
			customerName: data.customerName,
			customerMondayItemId: data.customerMondayItemId,
			customerId: data.customerId,
			quotaCredits: data.quotaCredits,
			applicantManagerName: data.applicantManagerName,
			accountManager: data.accountManager,
			marketingManager: data.marketingManager,
			jobPositionIds: data.jobPositionIds,
			phase: data.phase,
			landingPageUrl: data.landingPageUrl,
			landingPageWlUrl: data.landingPageWlUrl,
			adsUrl: data.adsUrl,
			monthlyAdvertisingBudget: data.monthlyAdvertisingBudget,
			dailyAdvertisingBudget28Days: data.dailyAdvertisingBudget28Days,
			dailyAdvertisingBudget31Days: data.dailyAdvertisingBudget31Days,
			documentObjectId: data.documentObjectId,
			quotaEndsAt: data.quotaEndsAt,
			shouldExpire: data.shouldExpire,
			customerDecisionFreedom: data.customerDecisionFreedom,
			customerDocumentUrl: data.customerDocumentUrl,
			customerAgreement: data.customerAgreement,
			productVersion: data.productVersion,
			customerGuarantee: data.customerGuarantee,
			subitemMondayItemIds: data.subitemMondayItemIds,
			status: data.status,
			statusChangedAt: data.statusChangedAt,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new MondayRecruitingDto({
			id: dbObject.id,
			mondayItemId: dbObject.monday_item_id,
			jobPositionName: dbObject.job_position_name,
			customerName: dbObject.customer_name,
			customerMondayItemId: dbObject.customer_monday_item_id,
			customerId: dbObject.customer_id,
			quotaCredits: dbObject.quota_credits,
			applicantManagerName: dbObject.applicant_manager_name,
			accountManager: dbObject.account_manager,
			marketingManager: dbObject.marketing_manager,
			jobPositionIds: dbObject.job_position_ids,
			phase: dbObject.phase,
			landingPageUrl: dbObject.landing_page_url,
			landingPageWlUrl: dbObject.landing_page_wl_url,
			adsUrl: dbObject.ads_url,
			monthlyAdvertisingBudget: dbObject.monthly_advertising_budget,
			dailyAdvertisingBudget28Days: dbObject.daily_advertising_budget_28_days,
			dailyAdvertisingBudget31Days: dbObject.daily_advertising_budget_31_days,
			documentObjectId: dbObject.document_object_id,
			quotaEndsAt: dbObject.quota_ends_at,
			shouldExpire: dbObject.should_expire,
			customerDecisionFreedom: dbObject.customer_decision_freedom,
			customerDocumentUrl: dbObject.customer_document_url,
			customerAgreement: dbObject.customer_agreement,
			productVersion: dbObject.product_version,
			customerGuarantee: dbObject.customer_guarantee,
			subitemMondayItemIds: dbObject.subitem_monday_item_ids,
			status: dbObject.status,
			statusChangedAt: dbObject.status_changed_at,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/monday-settings-data/monday-settings-data.ts
var MondaySettingsData = class MondaySettingsData {
	id;
	employeeBenefits;
	employeeRequirements;
	traineeBenefits;
	traineeRequirements;
	traineeProfessionsAndSpecializations;
	dualStudentBenefits;
	dualStudentRequirements;
	faqEmployeeTemplates;
	faqTraineeTemplates;
	createdAt;
	updatedAt;
	constructor({ id, employeeBenefits, employeeRequirements, traineeBenefits, traineeRequirements, traineeProfessionsAndSpecializations, dualStudentBenefits, dualStudentRequirements, faqEmployeeTemplates, faqTraineeTemplates, createdAt, updatedAt }) {
		this.id = id;
		this.employeeBenefits = employeeBenefits;
		this.employeeRequirements = employeeRequirements;
		this.traineeBenefits = traineeBenefits;
		this.traineeRequirements = traineeRequirements;
		this.traineeProfessionsAndSpecializations = traineeProfessionsAndSpecializations;
		this.dualStudentBenefits = dualStudentBenefits;
		this.dualStudentRequirements = dualStudentRequirements;
		this.faqEmployeeTemplates = faqEmployeeTemplates;
		this.faqTraineeTemplates = faqTraineeTemplates;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromData(data) {
		return new MondaySettingsData({
			id: data.id,
			employeeBenefits: data.employeeBenefits,
			employeeRequirements: data.employeeRequirements,
			traineeBenefits: data.traineeBenefits,
			traineeRequirements: data.traineeRequirements,
			traineeProfessionsAndSpecializations: data.traineeProfessionsAndSpecializations,
			dualStudentBenefits: data.dualStudentBenefits,
			dualStudentRequirements: data.dualStudentRequirements,
			faqEmployeeTemplates: data.faqEmployeeTemplates,
			faqTraineeTemplates: data.faqTraineeTemplates,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
	static createFromDbObject(mondaySettingsDataDbObject) {
		return new MondaySettingsData({
			id: mondaySettingsDataDbObject.id,
			employeeBenefits: mondaySettingsDataDbObject.employee_benefits,
			employeeRequirements: mondaySettingsDataDbObject.employee_requirements,
			traineeBenefits: mondaySettingsDataDbObject.trainee_benefits,
			traineeRequirements: mondaySettingsDataDbObject.trainee_requirements,
			traineeProfessionsAndSpecializations: mondaySettingsDataDbObject.trainee_professions_and_specializations,
			dualStudentBenefits: mondaySettingsDataDbObject.dual_student_benefits,
			dualStudentRequirements: mondaySettingsDataDbObject.dual_student_requirements,
			faqEmployeeTemplates: mondaySettingsDataDbObject.faq_employee_templates,
			faqTraineeTemplates: mondaySettingsDataDbObject.faq_trainee_templates,
			createdAt: mondaySettingsDataDbObject.created_at,
			updatedAt: mondaySettingsDataDbObject.updated_at
		});
	}
};
// source/models/monday-settings-data/monday-settings-data-dto.ts
var MondaySettingsDataDto = class MondaySettingsDataDto {
	id;
	employeeBenefits;
	employeeRequirements;
	traineeBenefits;
	traineeRequirements;
	traineeProfessionsAndSpecializations;
	dualStudentBenefits;
	dualStudentRequirements;
	faqEmployeeTemplates;
	faqTraineeTemplates;
	createdAt;
	updatedAt;
	constructor({ id, employeeBenefits, employeeRequirements, traineeBenefits, traineeRequirements, traineeProfessionsAndSpecializations, dualStudentBenefits, dualStudentRequirements, faqEmployeeTemplates, faqTraineeTemplates, createdAt, updatedAt }) {
		this.id = id;
		this.employeeBenefits = employeeBenefits;
		this.employeeRequirements = employeeRequirements;
		this.traineeBenefits = traineeBenefits;
		this.traineeRequirements = traineeRequirements;
		this.traineeProfessionsAndSpecializations = traineeProfessionsAndSpecializations;
		this.dualStudentBenefits = dualStudentBenefits;
		this.dualStudentRequirements = dualStudentRequirements;
		this.faqEmployeeTemplates = faqEmployeeTemplates;
		this.faqTraineeTemplates = faqTraineeTemplates;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toMondaySettingsData() {
		return new MondaySettingsData({
			id: this.id,
			employeeBenefits: this.employeeBenefits,
			employeeRequirements: this.employeeRequirements,
			traineeBenefits: this.traineeBenefits,
			traineeRequirements: this.traineeRequirements,
			traineeProfessionsAndSpecializations: this.traineeProfessionsAndSpecializations,
			dualStudentBenefits: this.dualStudentBenefits,
			dualStudentRequirements: this.dualStudentRequirements,
			faqEmployeeTemplates: this.faqEmployeeTemplates,
			faqTraineeTemplates: this.faqTraineeTemplates,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromMondaySettingsData(mondaySettingsData) {
		return new MondaySettingsDataDto({
			id: mondaySettingsData.id,
			employeeBenefits: mondaySettingsData.employeeBenefits,
			employeeRequirements: mondaySettingsData.employeeRequirements,
			traineeBenefits: mondaySettingsData.traineeBenefits,
			traineeRequirements: mondaySettingsData.traineeRequirements,
			traineeProfessionsAndSpecializations: mondaySettingsData.traineeProfessionsAndSpecializations,
			dualStudentBenefits: mondaySettingsData.dualStudentBenefits,
			dualStudentRequirements: mondaySettingsData.dualStudentRequirements,
			faqEmployeeTemplates: mondaySettingsData.faqEmployeeTemplates,
			faqTraineeTemplates: mondaySettingsData.faqTraineeTemplates,
			createdAt: mondaySettingsData.createdAt,
			updatedAt: mondaySettingsData.updatedAt
		});
	}
	static createFromDbObject(mondaySettingsDataDbObject) {
		return new MondaySettingsDataDto({
			id: mondaySettingsDataDbObject.id,
			employeeBenefits: mondaySettingsDataDbObject.employee_benefits,
			employeeRequirements: mondaySettingsDataDbObject.employee_requirements,
			traineeBenefits: mondaySettingsDataDbObject.trainee_benefits,
			traineeRequirements: mondaySettingsDataDbObject.trainee_requirements,
			traineeProfessionsAndSpecializations: mondaySettingsDataDbObject.trainee_professions_and_specializations,
			dualStudentBenefits: mondaySettingsDataDbObject.dual_student_benefits,
			dualStudentRequirements: mondaySettingsDataDbObject.dual_student_requirements,
			faqEmployeeTemplates: mondaySettingsDataDbObject.faq_employee_templates,
			faqTraineeTemplates: mondaySettingsDataDbObject.faq_trainee_templates,
			createdAt: mondaySettingsDataDbObject.created_at,
			updatedAt: mondaySettingsDataDbObject.updated_at
		});
	}
	static createFromData(data) {
		return new MondaySettingsDataDto({
			id: data.id,
			employeeBenefits: data.employeeBenefits,
			employeeRequirements: data.employeeRequirements,
			traineeBenefits: data.traineeBenefits,
			traineeRequirements: data.traineeRequirements,
			traineeProfessionsAndSpecializations: data.traineeProfessionsAndSpecializations,
			dualStudentBenefits: data.dualStudentBenefits,
			dualStudentRequirements: data.dualStudentRequirements,
			faqEmployeeTemplates: data.faqEmployeeTemplates,
			faqTraineeTemplates: data.faqTraineeTemplates,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
};
// source/models/nps-log/nps-log.ts
var NpsLog = class {
	value;
	createdAt;
	constructor({ value, createdAt }) {
		this.value = value;
		this.createdAt = createdAt;
	}
};
// source/models/nps-log/nps-log-creation-dto.ts
var NpsLogCreationDto = class NpsLogCreationDto {
	customerId;
	value;
	constructor({ customerId, value }) {
		this.customerId = customerId;
		this.value = value;
	}
	static createFromData(data) {
		return new NpsLogCreationDto({
			customerId: data.customerId,
			value: data.value
		});
	}
};
// source/models/nps-log/nps-log-dto.ts
var NpsLogDto = class NpsLogDto {
	value;
	createdAt;
	constructor({ value, createdAt }) {
		this.value = value;
		this.createdAt = createdAt;
	}
	toNpsLog() {
		return new NpsLog({
			value: this.value,
			createdAt: this.createdAt
		});
	}
	static createFromNpsLogData(npsLogData) {
		return new NpsLogDto({
			value: npsLogData.value,
			createdAt: npsLogData.createdAt
		});
	}
	static createFromNpsLog(npsLog) {
		return new NpsLogDto({
			value: npsLog.value,
			createdAt: npsLog.createdAt
		});
	}
};
// source/models/platform/platform.ts
var Platform = class Platform {
	id;
	name;
	color;
	isOutreachPossible;
	createdAt;
	updatedAt;
	constructor({ id, name, color, isOutreachPossible, createdAt, updatedAt }) {
		this.id = id;
		this.name = name;
		this.color = color;
		this.isOutreachPossible = isOutreachPossible;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(platformDbObject) {
		return new Platform({
			id: platformDbObject.id,
			name: platformDbObject.name,
			color: platformDbObject.color,
			isOutreachPossible: platformDbObject.is_outreach_possible,
			createdAt: platformDbObject.created_at,
			updatedAt: platformDbObject.updated_at
		});
	}
};
// source/models/platform/platform-creation-dto.ts
var PlatformCreationDto = class PlatformCreationDto {
	name;
	color;
	isOutreachPossible;
	constructor({ name, color, isOutreachPossible }) {
		this.name = name;
		this.color = color;
		this.isOutreachPossible = isOutreachPossible;
	}
	static createFromPlatformCreationData(platformCreationData) {
		return new PlatformCreationDto({
			name: platformCreationData.name,
			color: platformCreationData.color,
			isOutreachPossible: platformCreationData.isOutreachPossible
		});
	}
};
// source/models/platform/platform-dto.ts
var PlatformDto = class PlatformDto {
	id;
	name;
	color;
	isOutreachPossible;
	createdAt;
	updatedAt;
	constructor({ id, name, color, isOutreachPossible, createdAt, updatedAt }) {
		this.id = id;
		this.name = name;
		this.color = color;
		this.isOutreachPossible = isOutreachPossible;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toPlatform() {
		return new Platform({
			id: this.id,
			name: this.name,
			color: this.color,
			isOutreachPossible: this.isOutreachPossible,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromPlatform(platform) {
		return new PlatformDto({
			id: platform.id,
			name: platform.name,
			color: platform.color,
			isOutreachPossible: platform.isOutreachPossible,
			createdAt: platform.createdAt,
			updatedAt: platform.updatedAt
		});
	}
	static createFromDbObject(platformDbObject) {
		return new PlatformDto({
			id: platformDbObject.id,
			name: platformDbObject.name,
			color: platformDbObject.color,
			isOutreachPossible: platformDbObject.is_outreach_possible,
			createdAt: platformDbObject.created_at,
			updatedAt: platformDbObject.updated_at
		});
	}
	static createFromPlatformData(platformData) {
		return new PlatformDto({
			id: platformData.id,
			name: platformData.name,
			color: platformData.color,
			isOutreachPossible: platformData.isOutreachPossible,
			createdAt: platformData.createdAt,
			updatedAt: platformData.updatedAt
		});
	}
};
// source/models/platform/platform-update-dto.ts
var PlatformUpdateDto = class PlatformUpdateDto {
	name;
	color;
	isOutreachPossible;
	constructor({ name, color, isOutreachPossible }) {
		this.name = name;
		this.color = color;
		this.isOutreachPossible = isOutreachPossible;
	}
	static createFromPlatformUpdateData(platformUpdateData) {
		return new PlatformUpdateDto({
			name: platformUpdateData.name,
			color: platformUpdateData.color,
			isOutreachPossible: platformUpdateData.isOutreachPossible
		});
	}
};
// source/models/recruiting-log-entry/recruiting-log-entry.ts
/**
* One line of the optimization history of a campaign. The calendar week is not
* stored, it is derived from the date wherever it gets shown.
*
* The description is carried twice: as plain words, which is what a row is
* recognized and compared by, and as html holding the emphasis the sheets were
* written with. The html is missing on everything written before the formatting
* was carried over, and the plain text is shown in its place.
*/
var RecruitingLogEntry = class RecruitingLogEntry {
	id;
	mondayItemId;
	happenedOn;
	description;
	descriptionHtml;
	type;
	sourceKey;
	createdAt;
	updatedAt;
	constructor({ id, mondayItemId, happenedOn, description, descriptionHtml, type, sourceKey, createdAt, updatedAt }) {
		this.id = id;
		this.mondayItemId = mondayItemId;
		this.happenedOn = happenedOn;
		this.description = description;
		this.descriptionHtml = descriptionHtml;
		this.type = type;
		this.sourceKey = sourceKey;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new RecruitingLogEntry({
			id: dbObject.id,
			mondayItemId: dbObject.monday_item_id,
			happenedOn: dbObject.happened_on,
			description: dbObject.description,
			descriptionHtml: dbObject.description_html,
			type: dbObject.type,
			sourceKey: dbObject.source_key,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/recruiting-log-entry/recruiting-log-entry-dto.ts
var RecruitingLogEntryDto = class RecruitingLogEntryDto {
	id;
	mondayItemId;
	happenedOn;
	description;
	descriptionHtml;
	type;
	sourceKey;
	createdAt;
	updatedAt;
	constructor({ id, mondayItemId, happenedOn, description, descriptionHtml, type, sourceKey, createdAt, updatedAt }) {
		this.id = id;
		this.mondayItemId = mondayItemId;
		this.happenedOn = happenedOn;
		this.description = description;
		this.descriptionHtml = descriptionHtml;
		this.type = type;
		this.sourceKey = sourceKey;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toRecruitingLogEntry() {
		return new RecruitingLogEntry({
			id: this.id,
			mondayItemId: this.mondayItemId,
			happenedOn: this.happenedOn,
			description: this.description,
			descriptionHtml: this.descriptionHtml,
			type: this.type,
			sourceKey: this.sourceKey,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromRecruitingLogEntry(recruitingLogEntry) {
		return new RecruitingLogEntryDto({
			id: recruitingLogEntry.id,
			mondayItemId: recruitingLogEntry.mondayItemId,
			happenedOn: recruitingLogEntry.happenedOn,
			description: recruitingLogEntry.description,
			descriptionHtml: recruitingLogEntry.descriptionHtml,
			type: recruitingLogEntry.type,
			sourceKey: recruitingLogEntry.sourceKey,
			createdAt: recruitingLogEntry.createdAt,
			updatedAt: recruitingLogEntry.updatedAt
		});
	}
	static createFromRecruitingLogEntryData(data) {
		return new RecruitingLogEntryDto({
			id: data.id,
			mondayItemId: data.mondayItemId,
			happenedOn: data.happenedOn,
			description: data.description,
			descriptionHtml: data.descriptionHtml ?? null,
			type: data.type,
			sourceKey: data.sourceKey,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
};
// source/models/resume-data/resume-data.ts
var ResumeData = class {
	applicant;
	company;
	constructor({ applicant, company }) {
		this.applicant = applicant;
		this.company = company;
	}
};
// source/models/resume-data/resume-data-dto.ts
var ResumeDataDto = class ResumeDataDto {
	applicant;
	company;
	constructor({ applicant, company }) {
		this.applicant = applicant;
		this.company = company;
	}
	toResumeData() {
		return new ResumeData({
			applicant: this.applicant.toApplicantPublic(),
			company: this.company.toCompanyPublic()
		});
	}
	static createFromResumeData(resumeData) {
		return new ResumeDataDto({
			applicant: ApplicantPublicDto.createFromApplicantPublic(resumeData.applicant),
			company: CompanyPublicDto.createFromCompanyPublic(resumeData.company)
		});
	}
	static createFromData(data) {
		return new ResumeDataDto({
			applicant: ApplicantPublicDto.createFromApplicantData(data.applicant),
			company: CompanyPublicDto.createFromCompanyData(data.company)
		});
	}
};
// source/models/route/route.ts
var Route = class {
	postalCode;
	city;
	lat;
	lng;
	distance;
	duration;
	steps;
	mapsLink;
	localities;
	overviewPolyline;
	constructor({ postalCode, city, lat, lng, distance, duration, steps, mapsLink, localities, overviewPolyline }) {
		this.postalCode = postalCode;
		this.city = city;
		this.lat = lat;
		this.lng = lng;
		this.distance = distance;
		this.duration = duration;
		this.steps = steps;
		this.mapsLink = mapsLink;
		this.localities = localities;
		this.overviewPolyline = overviewPolyline;
	}
};
// source/models/route/route-dto.ts
var RouteDto = class RouteDto {
	postalCode;
	city;
	lat;
	lng;
	distance;
	duration;
	steps;
	mapsLink;
	localities;
	overviewPolyline;
	constructor({ postalCode, city, lat, lng, distance, duration, steps, mapsLink, localities, overviewPolyline }) {
		this.postalCode = postalCode;
		this.city = city;
		this.lat = lat;
		this.lng = lng;
		this.distance = distance;
		this.duration = duration;
		this.steps = steps;
		this.mapsLink = mapsLink;
		this.localities = localities;
		this.overviewPolyline = overviewPolyline;
	}
	toRoute() {
		return new RouteDto({
			postalCode: this.postalCode,
			city: this.city,
			lat: this.lat,
			lng: this.lng,
			distance: this.distance,
			duration: this.duration,
			steps: this.steps,
			mapsLink: this.mapsLink,
			localities: this.localities,
			overviewPolyline: this.overviewPolyline
		});
	}
	static createFromRoute(route) {
		return new RouteDto({
			postalCode: route.postalCode,
			city: route.city,
			lat: route.lat,
			lng: route.lng,
			distance: route.distance,
			duration: route.duration,
			steps: route.steps,
			mapsLink: route.mapsLink,
			localities: route.localities,
			overviewPolyline: route.overviewPolyline
		});
	}
	static createFromData(data) {
		return new RouteDto({
			postalCode: data.postalCode,
			city: data.city,
			lat: data.lat,
			lng: data.lng,
			distance: data.distance,
			duration: data.duration,
			steps: data.steps,
			mapsLink: data.mapsLink,
			localities: data.localities,
			overviewPolyline: data.overviewPolyline
		});
	}
};
// source/models/sanity/chapter/chapter.ts
var Chapter = class {
	id;
	title;
	duration;
	lessonCount;
	constructor({ id, title, duration, lessonCount }) {
		this.id = id;
		this.title = title;
		this.duration = duration;
		this.lessonCount = lessonCount;
	}
};
// source/models/sanity/chapter/chapter-dto.ts
var ChapterDto = class ChapterDto {
	id;
	title;
	duration;
	lessonCount;
	constructor({ id, title, duration, lessonCount }) {
		this.id = id;
		this.title = title;
		this.duration = duration;
		this.lessonCount = lessonCount;
	}
	static createFromData(data) {
		return new ChapterDto({
			id: data.id,
			title: data.title,
			duration: data.duration,
			lessonCount: data.lessonCount
		});
	}
	toChapter() {
		return new Chapter({
			id: this.id,
			title: this.title,
			duration: this.duration,
			lessonCount: this.lessonCount
		});
	}
};
// source/models/sanity/chapter-with-relations/chapter-with-relations.ts
var ChapterWithRelations = class extends Chapter {
	lessons;
	constructor({ lessons, ...props }) {
		super(props);
		this.lessons = lessons;
	}
};
// source/models/sanity/lesson/lesson.ts
var Lesson = class {
	id;
	title;
	duration;
	constructor({ id, title, duration }) {
		this.id = id;
		this.title = title;
		this.duration = duration;
	}
};
// source/models/sanity/lesson/lesson-dto.ts
var LessonDto = class {
	id;
	title;
	duration;
	constructor({ id, title, duration }) {
		this.id = id;
		this.title = title;
		this.duration = duration;
	}
};
// source/models/sanity/lesson-with-relations/lesson-with-relations.ts
var LessonWithRelations = class extends Lesson {
	video;
	constructor({ video, ...props }) {
		super(props);
		this.video = video;
	}
};
// source/models/sanity/video/video.ts
var Video = class {
	id;
	assetId;
	playbackId;
	thumbTime;
	duration;
	constructor({ id, assetId, playbackId, thumbTime, duration }) {
		this.id = id;
		this.assetId = assetId;
		this.playbackId = playbackId;
		this.thumbTime = thumbTime;
		this.duration = duration;
	}
};
// source/models/sanity/video/video-dto.ts
var VideoDto = class VideoDto {
	id;
	assetId;
	playbackId;
	thumbTime;
	duration;
	constructor({ id, assetId, playbackId, thumbTime, duration }) {
		this.id = id;
		this.assetId = assetId;
		this.playbackId = playbackId;
		this.thumbTime = thumbTime;
		this.duration = duration;
	}
	static createFromData(data) {
		return new VideoDto({
			id: data.id,
			assetId: data.assetId,
			playbackId: data.playbackId,
			thumbTime: data.thumbTime,
			duration: data.duration
		});
	}
	toVideo() {
		return new Video({
			id: this.id,
			assetId: this.assetId,
			playbackId: this.playbackId,
			thumbTime: this.thumbTime,
			duration: this.duration
		});
	}
};
// source/models/sanity/lesson-with-relations/lesson-with-relations-dto.ts
var LessonWithRelationsDto = class LessonWithRelationsDto extends LessonDto {
	video;
	constructor({ video, ...props }) {
		super(props);
		this.video = video;
	}
	static createFromData(data) {
		return new LessonWithRelationsDto({
			id: data.id,
			title: data.title,
			duration: data.duration,
			video: VideoDto.createFromData(data.video)
		});
	}
	toLessonWithRelations() {
		return new LessonWithRelations({
			id: this.id,
			title: this.title,
			duration: this.duration,
			video: this.video?.toVideo()
		});
	}
};
// source/models/sanity/chapter-with-relations/chapter-with-relations-dto.ts
var ChapterWithRelationsDto = class ChapterWithRelationsDto extends ChapterDto {
	lessons;
	constructor({ lessons, ...props }) {
		super(props);
		this.lessons = lessons;
	}
	static createFromData(data) {
		return new ChapterWithRelationsDto({
			id: data.id,
			title: data.title,
			duration: data.duration,
			lessonCount: data.lessonCount,
			lessons: data.lessons?.map((lesson) => LessonWithRelationsDto.createFromData(lesson)) || []
		});
	}
	toChapterWithRelations() {
		return new ChapterWithRelations({
			id: this.id,
			title: this.title,
			duration: this.duration,
			lessonCount: this.lessonCount,
			lessons: this.lessons.map((lesson) => lesson?.toLessonWithRelations())
		});
	}
};
// source/models/sanity/course/course.ts
var Course = class {
	id;
	title;
	description;
	thumbnail;
	duration;
	lessonCount;
	constructor({ id, title, description, thumbnail, duration, lessonCount }) {
		this.id = id;
		this.title = title;
		this.description = description;
		this.thumbnail = thumbnail;
		this.duration = duration;
		this.lessonCount = lessonCount;
	}
};
// source/models/sanity/course/course-dto.ts
var CourseDto = class CourseDto {
	id;
	title;
	description;
	thumbnail;
	duration;
	lessonCount;
	constructor({ id, title, description, thumbnail, duration, lessonCount }) {
		this.id = id;
		this.title = title;
		this.description = description;
		this.thumbnail = thumbnail;
		this.duration = duration;
		this.lessonCount = lessonCount;
	}
	static createFromData(data) {
		return new CourseDto({
			id: data.id,
			title: data.title,
			description: data.description,
			thumbnail: data.thumbnail,
			duration: data.duration,
			lessonCount: data.lessonCount
		});
	}
	toCourse() {
		return new Course({
			id: this.id,
			title: this.title,
			description: this.description,
			thumbnail: this.thumbnail,
			duration: this.duration,
			lessonCount: this.lessonCount
		});
	}
};
// source/models/sanity/course-with-relations/course-with-relations.ts
var CourseWithRelations = class extends Course {
	chapters;
	constructor({ chapters, ...props }) {
		super(props);
		this.chapters = chapters;
	}
};
// source/models/sanity/course-with-relations/course-with-relations-dto.ts
var CourseWithRelationsDto = class CourseWithRelationsDto extends CourseDto {
	chapters;
	constructor({ chapters, ...props }) {
		super(props);
		this.chapters = chapters;
	}
	static createFromData(data) {
		return new CourseWithRelationsDto({
			id: data.id,
			title: data.title,
			description: data.description,
			thumbnail: data.thumbnail,
			duration: data.duration,
			lessonCount: data.lessonCount,
			chapters: data.chapters.map((chapter) => ChapterDto.createFromData(chapter))
		});
	}
	toCourseWithRelations() {
		return new CourseWithRelations({
			id: this.id,
			title: this.title,
			description: this.description,
			thumbnail: this.thumbnail,
			duration: this.duration,
			lessonCount: this.lessonCount,
			chapters: this.chapters?.map((chapter) => chapter.toChapter()) || []
		});
	}
};
// source/models/webhook/webhook.ts
var Webhook = class Webhook {
	id;
	customerId;
	jobPositionId;
	name;
	source;
	token;
	createdAt;
	updatedAt;
	constructor({ id, customerId, jobPositionId, name, source, token, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.jobPositionId = jobPositionId;
		this.name = name;
		this.source = source;
		this.token = token;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new Webhook({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			jobPositionId: dbObject.job_position_id,
			name: dbObject.name,
			source: dbObject.source,
			token: dbObject.token,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/webhook/webhook-creation-dto.ts
var WebhookCreationDto = class WebhookCreationDto {
	customerId;
	jobPositionId;
	name;
	source;
	constructor({ customerId, jobPositionId, name, source }) {
		this.customerId = customerId;
		this.jobPositionId = jobPositionId;
		this.name = name;
		this.source = source;
	}
	static createFromData(data) {
		return new WebhookCreationDto({
			customerId: data.customerId,
			jobPositionId: data.jobPositionId,
			name: data.name,
			source: data.source
		});
	}
};
// source/models/webhook/webhook-dto.ts
var WebhookDto = class WebhookDto {
	id;
	customerId;
	jobPositionId;
	name;
	source;
	token;
	createdAt;
	updatedAt;
	constructor({ id, customerId, jobPositionId, name, source, token, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.jobPositionId = jobPositionId;
		this.name = name;
		this.source = source;
		this.token = token;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toWebhook() {
		return new Webhook({
			id: this.id,
			customerId: this.customerId,
			jobPositionId: this.jobPositionId,
			name: this.name,
			source: this.source,
			token: this.token,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromWebhook(webhook) {
		return new WebhookDto({
			id: webhook.id,
			customerId: webhook.customerId,
			jobPositionId: webhook.jobPositionId,
			name: webhook.name,
			source: webhook.source,
			token: webhook.token,
			createdAt: webhook.createdAt,
			updatedAt: webhook.updatedAt
		});
	}
	static createFromData(data) {
		return new WebhookDto({
			id: data.id,
			customerId: data.customerId,
			jobPositionId: data.jobPositionId,
			name: data.name,
			source: data.source,
			token: data.token,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
};
// source/models/webhook/webhook-update-dto.ts
var WebhookUpdateDto = class WebhookUpdateDto {
	name;
	constructor({ name }) {
		this.name = name;
	}
	static createFromData(data) {
		return new WebhookUpdateDto({ name: data.name });
	}
};
// source/models/career-domain/career-domain.ts
var CareerDomain = class CareerDomain {
	id;
	customerId;
	domain;
	isActive;
	dnsResourceRecords;
	dnsStatus;
	sslCertificateStatus;
	loadBalancerStatus;
	loadBalancerIp;
	initialSetupComplete;
	lastDnsCheckAt;
	isDeleting;
	analyticsId;
	googleSearchConsoleToken;
	googleSearchConsoleVerificationInitiatedAt;
	googleSearchConsoleStatus;
	createdAt;
	updatedAt;
	constructor({ id, customerId, domain, isActive, dnsResourceRecords, dnsStatus, sslCertificateStatus, loadBalancerStatus, loadBalancerIp, initialSetupComplete, lastDnsCheckAt, isDeleting, analyticsId, googleSearchConsoleToken, googleSearchConsoleVerificationInitiatedAt, googleSearchConsoleStatus, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.domain = domain;
		this.isActive = isActive;
		this.dnsResourceRecords = dnsResourceRecords;
		this.dnsStatus = dnsStatus;
		this.sslCertificateStatus = sslCertificateStatus;
		this.loadBalancerStatus = loadBalancerStatus;
		this.loadBalancerIp = loadBalancerIp;
		this.initialSetupComplete = initialSetupComplete;
		this.lastDnsCheckAt = lastDnsCheckAt;
		this.isDeleting = isDeleting;
		this.analyticsId = analyticsId;
		this.googleSearchConsoleToken = googleSearchConsoleToken;
		this.googleSearchConsoleVerificationInitiatedAt = googleSearchConsoleVerificationInitiatedAt;
		this.googleSearchConsoleStatus = googleSearchConsoleStatus;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(careerDomainDbObject) {
		return new CareerDomain({
			id: careerDomainDbObject.id,
			customerId: careerDomainDbObject.customer_id,
			domain: careerDomainDbObject.domain,
			isActive: careerDomainDbObject.is_active,
			dnsResourceRecords: careerDomainDbObject.dns_resource_records,
			dnsStatus: careerDomainDbObject.dns_status,
			sslCertificateStatus: careerDomainDbObject.ssl_certificate_status,
			loadBalancerStatus: careerDomainDbObject.load_balancer_status,
			loadBalancerIp: careerDomainDbObject.load_balancer_ip,
			lastDnsCheckAt: careerDomainDbObject.last_dns_check_at,
			initialSetupComplete: careerDomainDbObject.initial_setup_complete,
			isDeleting: careerDomainDbObject.is_deleting,
			analyticsId: careerDomainDbObject.analytics_id,
			googleSearchConsoleToken: careerDomainDbObject.google_search_console_token,
			googleSearchConsoleVerificationInitiatedAt: careerDomainDbObject.google_search_console_verification_initiated_at,
			googleSearchConsoleStatus: careerDomainDbObject.google_search_console_status,
			createdAt: careerDomainDbObject.created_at,
			updatedAt: careerDomainDbObject.updated_at
		});
	}
};
// source/models/career-domain/career-domain-dto.ts
var CareerDomainDto = class CareerDomainDto {
	id;
	customerId;
	domain;
	isActive;
	dnsResourceRecords;
	dnsStatus;
	sslCertificateStatus;
	loadBalancerStatus;
	loadBalancerIp;
	initialSetupComplete;
	lastDnsCheckAt;
	isDeleting;
	analyticsId;
	googleSearchConsoleStatus;
	createdAt;
	updatedAt;
	constructor({ id, customerId, domain, isActive, dnsResourceRecords, dnsStatus, sslCertificateStatus, loadBalancerStatus, loadBalancerIp, initialSetupComplete, lastDnsCheckAt, isDeleting, analyticsId, googleSearchConsoleStatus, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.domain = domain;
		this.isActive = isActive;
		this.dnsResourceRecords = dnsResourceRecords;
		this.dnsStatus = dnsStatus;
		this.sslCertificateStatus = sslCertificateStatus;
		this.loadBalancerStatus = loadBalancerStatus;
		this.loadBalancerIp = loadBalancerIp;
		this.initialSetupComplete = initialSetupComplete;
		this.lastDnsCheckAt = lastDnsCheckAt;
		this.isDeleting = isDeleting;
		this.analyticsId = analyticsId;
		this.googleSearchConsoleStatus = googleSearchConsoleStatus;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toCareerDomain() {
		return new CareerDomain({
			id: this.id,
			customerId: this.customerId,
			domain: this.domain,
			isActive: this.isActive,
			dnsResourceRecords: this.dnsResourceRecords,
			dnsStatus: this.dnsStatus,
			sslCertificateStatus: this.sslCertificateStatus,
			loadBalancerStatus: this.loadBalancerStatus,
			loadBalancerIp: this.loadBalancerIp,
			initialSetupComplete: this.initialSetupComplete,
			lastDnsCheckAt: this.lastDnsCheckAt,
			isDeleting: this.isDeleting,
			analyticsId: this.analyticsId,
			googleSearchConsoleStatus: this.googleSearchConsoleStatus,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromCareerDomain(careerDomain) {
		return new CareerDomainDto({
			id: careerDomain.id,
			customerId: careerDomain.customerId,
			domain: careerDomain.domain,
			isActive: careerDomain.isActive,
			dnsResourceRecords: careerDomain.dnsResourceRecords,
			dnsStatus: careerDomain.dnsStatus,
			sslCertificateStatus: careerDomain.sslCertificateStatus,
			loadBalancerStatus: careerDomain.loadBalancerStatus,
			loadBalancerIp: careerDomain.loadBalancerIp,
			initialSetupComplete: careerDomain.initialSetupComplete,
			lastDnsCheckAt: careerDomain.lastDnsCheckAt,
			isDeleting: careerDomain.isDeleting,
			analyticsId: careerDomain.analyticsId,
			googleSearchConsoleStatus: careerDomain.googleSearchConsoleStatus,
			createdAt: careerDomain.createdAt,
			updatedAt: careerDomain.updatedAt
		});
	}
	static createFromDbObject(careerDomainDbObject) {
		return new CareerDomainDto({
			id: careerDomainDbObject.id,
			customerId: careerDomainDbObject.customer_id,
			domain: careerDomainDbObject.domain,
			isActive: careerDomainDbObject.is_active,
			dnsResourceRecords: careerDomainDbObject.dns_resource_records,
			dnsStatus: careerDomainDbObject.dns_status,
			sslCertificateStatus: careerDomainDbObject.ssl_certificate_status,
			loadBalancerStatus: careerDomainDbObject.load_balancer_status,
			loadBalancerIp: careerDomainDbObject.load_balancer_ip,
			initialSetupComplete: careerDomainDbObject.initial_setup_complete,
			lastDnsCheckAt: careerDomainDbObject.last_dns_check_at,
			isDeleting: careerDomainDbObject.is_deleting,
			analyticsId: careerDomainDbObject.analytics_id,
			googleSearchConsoleStatus: careerDomainDbObject.google_search_console_status,
			createdAt: careerDomainDbObject.created_at,
			updatedAt: careerDomainDbObject.updated_at
		});
	}
	static createFromCareerDomainData(careerDomainData) {
		return new CareerDomainDto({
			id: careerDomainData.id,
			customerId: careerDomainData.customerId,
			domain: careerDomainData.domain,
			isActive: careerDomainData.isActive,
			dnsResourceRecords: careerDomainData.dnsResourceRecords,
			dnsStatus: careerDomainData.dnsStatus,
			sslCertificateStatus: careerDomainData.sslCertificateStatus,
			loadBalancerStatus: careerDomainData.loadBalancerStatus,
			loadBalancerIp: careerDomainData.loadBalancerIp,
			initialSetupComplete: careerDomainData.initialSetupComplete,
			lastDnsCheckAt: careerDomainData.lastDnsCheckAt,
			isDeleting: careerDomainData.isDeleting,
			analyticsId: careerDomainData.analyticsId,
			googleSearchConsoleStatus: careerDomainData.googleSearchConsoleStatus,
			createdAt: careerDomainData.createdAt,
			updatedAt: careerDomainData.updatedAt
		});
	}
};
// source/models/career-domain/career-domain-creation-dto.ts
var CareerDomainCreationDto = class CareerDomainCreationDto {
	customerId;
	domain;
	constructor({ customerId, domain }) {
		this.customerId = customerId;
		this.domain = domain;
	}
	static createFromCareerDomainData(careerDomainCreationData) {
		return new CareerDomainCreationDto({
			customerId: careerDomainCreationData.customerId,
			domain: careerDomainCreationData.domain
		});
	}
	convertToDbObject() {
		return {
			customer_id: this.customerId,
			domain: this.domain
		};
	}
};
// source/models/email-provider/email-provider.ts
var EmailProvider = class EmailProvider {
	id;
	customerId;
	provider;
	email;
	alternativeSender;
	signatureId;
	errorType;
	withSignature;
	smtpHost;
	smtpPort;
	smtpSecure;
	createdAt;
	updatedAt;
	constructor({ id, customerId, provider, email, alternativeSender, signatureId, withSignature, errorType, smtpHost, smtpPort, smtpSecure, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.provider = provider;
		this.email = email;
		this.alternativeSender = alternativeSender;
		this.signatureId = signatureId;
		this.withSignature = withSignature;
		this.errorType = errorType;
		this.smtpHost = smtpHost;
		this.smtpPort = smtpPort;
		this.smtpSecure = smtpSecure;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new EmailProvider({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			provider: dbObject.provider,
			email: dbObject.email,
			alternativeSender: dbObject.alternative_sender,
			signatureId: dbObject.signature_id,
			withSignature: dbObject.with_signature,
			smtpHost: dbObject.smtp_host,
			smtpPort: dbObject.smtp_port,
			smtpSecure: dbObject.smtp_secure,
			errorType: dbObject.error_type,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/email-provider/email-provider-cretion-dto.ts
var EmailProviderCreationDto = class EmailProviderCreationDto {
	email;
	password;
	smtpHost;
	smtpPort;
	smtpSecure;
	constructor({ email, password, smtpHost, smtpPort, smtpSecure }) {
		this.email = email;
		this.password = password;
		this.smtpHost = smtpHost;
		this.smtpPort = smtpPort;
		this.smtpSecure = smtpSecure;
	}
	static createFromDbObject(dbObject) {
		return new EmailProviderCreationDto({
			email: dbObject.email,
			password: dbObject.password,
			smtpHost: dbObject.smtp_host,
			smtpPort: dbObject.smtp_port,
			smtpSecure: dbObject.smtp_secure
		});
	}
	static createFromEmailProviderCreationData(data) {
		return new EmailProviderCreationDto({
			password: data.password,
			email: data.email,
			smtpHost: data.smtpHost,
			smtpPort: data.smtpPort,
			smtpSecure: data.smtpSecure
		});
	}
	convertToDbObject() {
		return {
			email: this.email,
			password: this.password,
			smtp_host: this.smtpHost,
			smtp_port: this.smtpPort,
			smtp_secure: this.smtpSecure
		};
	}
};
// source/models/email-provider/email-provider-dto.ts
var EmailProviderDto = class EmailProviderDto {
	id;
	customerId;
	provider;
	email;
	alternativeSender;
	signatureId;
	withSignature;
	errorType;
	smtpHost;
	smtpPort;
	smtpSecure;
	createdAt;
	updatedAt;
	constructor({ id, customerId, provider, signatureId, withSignature, email, alternativeSender, errorType, smtpHost, smtpPort, smtpSecure, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.provider = provider;
		this.email = email;
		this.alternativeSender = alternativeSender;
		this.signatureId = signatureId;
		this.withSignature = withSignature;
		this.errorType = errorType;
		this.smtpHost = smtpHost;
		this.smtpPort = smtpPort;
		this.smtpSecure = smtpSecure;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toEmailProvider() {
		return new EmailProvider({
			id: this.id,
			customerId: this.customerId,
			provider: this.provider,
			email: this.email,
			alternativeSender: this.alternativeSender,
			signatureId: this.signatureId,
			withSignature: this.withSignature,
			errorType: this.errorType,
			smtpHost: this.smtpHost,
			smtpPort: this.smtpPort,
			smtpSecure: this.smtpSecure,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromEmailProvider(emailProvider) {
		return new EmailProviderDto({
			id: emailProvider.id,
			customerId: emailProvider.customerId,
			provider: emailProvider.provider,
			email: emailProvider.email,
			alternativeSender: emailProvider.alternativeSender,
			signatureId: emailProvider.signatureId,
			withSignature: emailProvider.withSignature,
			errorType: emailProvider.errorType,
			smtpHost: emailProvider.smtpHost,
			smtpPort: emailProvider.smtpPort,
			smtpSecure: emailProvider.smtpSecure,
			createdAt: emailProvider.createdAt,
			updatedAt: emailProvider.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new EmailProviderDto({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			provider: dbObject.provider,
			email: dbObject.email,
			alternativeSender: dbObject.alternative_sender,
			signatureId: dbObject.signature_id,
			withSignature: dbObject.with_signature,
			errorType: dbObject.error_type,
			smtpHost: dbObject.smtp_host,
			smtpPort: dbObject.smtp_port,
			smtpSecure: dbObject.smtp_secure,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
	static createFromEmailProviderData(emailProviderData) {
		return new EmailProviderDto({
			id: emailProviderData.id,
			customerId: emailProviderData.customerId,
			provider: emailProviderData.provider,
			email: emailProviderData.email,
			alternativeSender: emailProviderData.alternativeSender,
			signatureId: emailProviderData.signatureId,
			withSignature: emailProviderData.withSignature,
			errorType: emailProviderData.errorType,
			smtpHost: emailProviderData.smtpHost,
			smtpPort: emailProviderData.smtpPort,
			smtpSecure: emailProviderData.smtpSecure,
			createdAt: emailProviderData.createdAt,
			updatedAt: emailProviderData.updatedAt
		});
	}
};
// source/models/email-provider/email-provider-update-dto.ts
var EmailProviderUpdateDto = class EmailProviderUpdateDto {
	withSignature;
	alternativeSender;
	smtpHost;
	smtpPort;
	smtpSecure;
	constructor({ withSignature, alternativeSender, smtpHost, smtpPort, smtpSecure }) {
		this.withSignature = withSignature;
		this.alternativeSender = alternativeSender;
		this.smtpHost = smtpHost;
		this.smtpPort = smtpPort;
		this.smtpSecure = smtpSecure;
	}
	static createFromDbObject(dbObject) {
		return new EmailProviderUpdateDto({
			withSignature: dbObject.with_signature,
			alternativeSender: dbObject.alternative_sender,
			smtpHost: dbObject.smtp_host,
			smtpPort: dbObject.smtp_port,
			smtpSecure: dbObject.smtp_secure
		});
	}
	static createFromEmailProviderUpdateData(data) {
		return new EmailProviderUpdateDto({
			withSignature: data.withSignature,
			alternativeSender: data.alternativeSender,
			smtpHost: data.smtpHost,
			smtpPort: data.smtpPort,
			smtpSecure: data.smtpSecure
		});
	}
};
// source/models/customer-email-signature/customer-email-signature.ts
var CustomerEmailSignature = class CustomerEmailSignature {
	id;
	customerId;
	name;
	type;
	signature;
	isDefault;
	createdAt;
	updatedAt;
	constructor({ id, customerId, name, type, signature, isDefault, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.name = name;
		this.type = type;
		this.signature = signature;
		this.isDefault = isDefault;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new CustomerEmailSignature({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			name: dbObject.name,
			type: dbObject.type,
			signature: dbObject.signature,
			isDefault: dbObject.is_default,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/customer-email-signature/customer-email-signature-dto.ts
var CustomerEmailSignatureDto = class CustomerEmailSignatureDto {
	id;
	customerId;
	name;
	type;
	signature;
	isDefault;
	createdAt;
	updatedAt;
	constructor({ id, customerId, name, type, signature, isDefault, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.name = name;
		this.type = type;
		this.signature = signature;
		this.isDefault = isDefault;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toCustomerEmailSignature() {
		return new CustomerEmailSignature({
			id: this.id,
			customerId: this.customerId,
			name: this.name,
			type: this.type,
			signature: this.signature,
			isDefault: this.isDefault,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new CustomerEmailSignatureDto({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			name: dbObject.name,
			type: dbObject.type,
			signature: dbObject.signature,
			isDefault: dbObject.is_default,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
	static createFromCustomerEmailSignature(emailSignature) {
		return new CustomerEmailSignatureDto({
			id: emailSignature.id,
			customerId: emailSignature.customerId,
			name: emailSignature.name,
			type: emailSignature.type,
			signature: emailSignature.signature,
			isDefault: emailSignature.isDefault,
			createdAt: emailSignature.createdAt,
			updatedAt: emailSignature.updatedAt
		});
	}
	static createFromCustomerEmailSignatureData(emailSignatureData) {
		return new CustomerEmailSignatureDto({
			id: emailSignatureData.id,
			customerId: emailSignatureData.customerId,
			name: emailSignatureData.name,
			type: emailSignatureData.type,
			signature: emailSignatureData.signature,
			isDefault: emailSignatureData.isDefault,
			createdAt: emailSignatureData.createdAt,
			updatedAt: emailSignatureData.updatedAt
		});
	}
};
// source/models/customer-email-signature/customer-email-signature-update-dto.ts
var CustomerEmailSignatureUpdateDto = class CustomerEmailSignatureUpdateDto {
	name;
	signature;
	constructor({ name, signature }) {
		this.name = name;
		this.signature = signature;
	}
	static createFromDbObject(dbObject) {
		return new CustomerEmailSignatureUpdateDto({
			name: dbObject.name,
			signature: dbObject.signature
		});
	}
	static createFromCustomerEmailSignatureUpdateData(data) {
		return new CustomerEmailSignatureUpdateDto({
			name: data.name,
			signature: data.signature
		});
	}
};
// source/models/customer-email-signature/customer-email-signature-creation-dto.ts
var CustomerEmailSignatureCreationDto = class CustomerEmailSignatureCreationDto {
	customerId;
	name;
	signature;
	constructor({ customerId, name, signature }) {
		this.customerId = customerId;
		this.name = name;
		this.signature = signature;
	}
	static createFromDbObject(dbObject) {
		return new CustomerEmailSignatureCreationDto({
			customerId: dbObject.customer_id,
			name: dbObject.name,
			signature: dbObject.signature
		});
	}
	static createFromCustomerEmailSignatureCreationData(data) {
		return new CustomerEmailSignatureCreationDto({
			customerId: data.customerId,
			name: data.name,
			signature: data.signature
		});
	}
};
// source/models/email-provider-with-relations/email-provider-with-relations.ts
var EmailProviderWithRelations = class EmailProviderWithRelations extends EmailProvider {
	signature;
	constructor({ signature, ...props }) {
		super(props);
		this.signature = signature;
	}
	static createFromEmailProviderData(data) {
		return new EmailProviderWithRelations({
			id: data.id,
			customerId: data.customerId,
			provider: data.provider,
			email: data.email,
			alternativeSender: data.alternativeSender,
			signatureId: data.signatureId,
			signature: data.signature ? CustomerEmailSignature.createFromDbObject(data.signature) : void 0,
			withSignature: data.withSignature,
			errorType: data.errorType,
			smtpHost: data.smtpHost,
			smtpPort: data.smtpPort,
			smtpSecure: data.smtpSecure,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new EmailProviderWithRelations({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			provider: dbObject.provider,
			email: dbObject.email,
			alternativeSender: dbObject.alternative_sender,
			signatureId: dbObject.signature_id,
			signature: dbObject.signature ? CustomerEmailSignature.createFromDbObject(dbObject.signature) : void 0,
			withSignature: dbObject.with_signature,
			errorType: dbObject.error_type,
			smtpHost: dbObject.smtp_host,
			smtpPort: dbObject.smtp_port,
			smtpSecure: dbObject.smtp_secure,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/email-provider-with-relations/email-provider-with-relations-dto.ts
var EmailProviderWithRelationsDto = class EmailProviderWithRelationsDto extends EmailProvider {
	signature;
	constructor({ signature, ...props }) {
		super(props);
		this.signature = signature;
	}
	toEmailProvider() {
		return new EmailProviderWithRelations({
			id: this.id,
			customerId: this.customerId,
			provider: this.provider,
			email: this.email,
			alternativeSender: this.alternativeSender,
			signatureId: this.signatureId,
			signature: this.signature ? this.signature.toCustomerEmailSignature() : void 0,
			withSignature: this.withSignature,
			errorType: this.errorType,
			smtpHost: this.smtpHost,
			smtpPort: this.smtpPort,
			smtpSecure: this.smtpSecure,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new EmailProviderWithRelationsDto({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			provider: dbObject.provider,
			email: dbObject.email,
			alternativeSender: dbObject.alternative_sender,
			signatureId: dbObject.signature_id,
			signature: dbObject.signature ? CustomerEmailSignatureDto.createFromDbObject(dbObject.signature) : void 0,
			withSignature: dbObject.with_signature,
			errorType: dbObject.error_type,
			smtpHost: dbObject.smtp_host,
			smtpPort: dbObject.smtp_port,
			smtpSecure: dbObject.smtp_secure,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
	static createFromEmailProvider(emailProvider) {
		return new EmailProviderWithRelationsDto({
			id: emailProvider.id,
			customerId: emailProvider.customerId,
			provider: emailProvider.provider,
			email: emailProvider.email,
			alternativeSender: emailProvider.alternativeSender,
			signatureId: emailProvider.signatureId,
			signature: emailProvider.signature ? CustomerEmailSignatureDto.createFromCustomerEmailSignature(emailProvider.signature) : void 0,
			withSignature: emailProvider.withSignature,
			errorType: emailProvider.errorType,
			smtpHost: emailProvider.smtpHost,
			smtpPort: emailProvider.smtpPort,
			smtpSecure: emailProvider.smtpSecure,
			createdAt: emailProvider.createdAt,
			updatedAt: emailProvider.updatedAt
		});
	}
	static createFromEmailProviderData(emailProviderData) {
		return new EmailProviderWithRelationsDto({
			id: emailProviderData.id,
			customerId: emailProviderData.customerId,
			provider: emailProviderData.provider,
			email: emailProviderData.email,
			alternativeSender: emailProviderData.alternativeSender,
			signatureId: emailProviderData.signatureId,
			signature: emailProviderData.signature ? CustomerEmailSignatureDto.createFromCustomerEmailSignatureData(emailProviderData.signature) : void 0,
			withSignature: emailProviderData.withSignature,
			errorType: emailProviderData.errorType,
			smtpHost: emailProviderData.smtpHost,
			smtpPort: emailProviderData.smtpPort,
			smtpSecure: emailProviderData.smtpSecure,
			createdAt: emailProviderData.createdAt,
			updatedAt: emailProviderData.updatedAt
		});
	}
};
// source/models/email-provider-with-relations/email-provider-with-relations-update-dto.ts
var EmailProviderWithRelationsUpdateDto = class EmailProviderWithRelationsUpdateDto {
	withSignature;
	signature;
	alternativeSender;
	constructor({ withSignature, signature, alternativeSender }) {
		this.withSignature = withSignature;
		this.signature = signature;
		this.alternativeSender = alternativeSender;
	}
	static createFromEmailProviderUpdateData(data) {
		return new EmailProviderWithRelationsUpdateDto({
			withSignature: data.withSignature,
			signature: data.signature,
			alternativeSender: data.alternativeSender
		});
	}
};
// source/models/hrbaxml/hrbaxml-config.ts
var HrbaxmlConfig = class HrbaxmlConfig {
	id;
	customerId;
	supplierId;
	allianzPartnerNr;
	hiringOrgId;
	supplierName;
	partnerType;
	hasCertificate;
	certificateExpiresAt;
	isActive;
	supervisionDesired;
	lastSyncAt;
	createdAt;
	updatedAt;
	constructor({ id, customerId, supplierId, allianzPartnerNr, hiringOrgId, supplierName, partnerType, hasCertificate, certificateExpiresAt, isActive, supervisionDesired, lastSyncAt, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.supplierId = supplierId;
		this.allianzPartnerNr = allianzPartnerNr;
		this.hiringOrgId = hiringOrgId;
		this.supplierName = supplierName;
		this.partnerType = partnerType;
		this.hasCertificate = hasCertificate;
		this.certificateExpiresAt = certificateExpiresAt;
		this.isActive = isActive;
		this.supervisionDesired = supervisionDesired;
		this.lastSyncAt = lastSyncAt;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	get isConfigured() {
		return this.supplierId !== null && this.supplierName !== null && this.allianzPartnerNr !== null && this.hiringOrgId !== null;
	}
	static createFromDbObject(dbObject) {
		return new HrbaxmlConfig({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			supplierId: dbObject.supplier_id,
			allianzPartnerNr: dbObject.allianz_partner_nr,
			hiringOrgId: dbObject.hiring_org_id,
			supplierName: dbObject.supplier_name,
			partnerType: dbObject.partner_type,
			hasCertificate: dbObject.certificate_p12_encrypted !== null,
			certificateExpiresAt: dbObject.certificate_expires_at,
			isActive: dbObject.is_active,
			supervisionDesired: dbObject.supervision_desired,
			lastSyncAt: dbObject.last_sync_at,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/hrbaxml/hrbaxml-config-creation-dto.ts
var HrbaxmlConfigCreationDto = class HrbaxmlConfigCreationDto {
	supplierId;
	supplierName;
	allianzPartnerNr;
	hiringOrgId;
	supervisionDesired;
	constructor({ supplierId, supplierName, allianzPartnerNr, hiringOrgId, supervisionDesired }) {
		this.supplierId = supplierId;
		this.supplierName = supplierName;
		this.allianzPartnerNr = allianzPartnerNr;
		this.hiringOrgId = hiringOrgId;
		this.supervisionDesired = supervisionDesired;
	}
	static createFromData(data) {
		return new HrbaxmlConfigCreationDto({
			supplierId: data.supplierId,
			supplierName: data.supplierName,
			allianzPartnerNr: data.allianzPartnerNr,
			hiringOrgId: data.hiringOrgId,
			supervisionDesired: data.supervisionDesired
		});
	}
};
// source/models/hrbaxml/hrbaxml-config-update-dto.ts
var HrbaxmlConfigUpdateDto = class HrbaxmlConfigUpdateDto {
	supplierId;
	supplierName;
	allianzPartnerNr;
	hiringOrgId;
	isActive;
	supervisionDesired;
	constructor({ supplierId, supplierName, allianzPartnerNr, hiringOrgId, isActive, supervisionDesired }) {
		this.supplierId = supplierId;
		this.supplierName = supplierName;
		this.allianzPartnerNr = allianzPartnerNr;
		this.hiringOrgId = hiringOrgId;
		this.isActive = isActive;
		this.supervisionDesired = supervisionDesired;
	}
	static createFromData(data) {
		return new HrbaxmlConfigUpdateDto({
			supplierId: data.supplierId,
			supplierName: data.supplierName,
			allianzPartnerNr: data.allianzPartnerNr,
			hiringOrgId: data.hiringOrgId,
			isActive: data.isActive,
			supervisionDesired: data.supervisionDesired
		});
	}
};
// source/models/hrbaxml/hrbaxml-posting-sync.ts
var HrbaxmlPostingSync = class HrbaxmlPostingSync {
	jobPositionId;
	customerId;
	baSyncStatus;
	baLastAction;
	baLastXmlHash;
	baLastErrorMessage;
	baBerufId;
	baRegionCode;
	baEducationType;
	constructor({ jobPositionId, customerId, baSyncStatus, baLastAction, baLastXmlHash, baLastErrorMessage, baBerufId, baRegionCode, baEducationType }) {
		this.jobPositionId = jobPositionId;
		this.customerId = customerId;
		this.baSyncStatus = baSyncStatus;
		this.baLastAction = baLastAction;
		this.baLastXmlHash = baLastXmlHash;
		this.baLastErrorMessage = baLastErrorMessage;
		this.baBerufId = baBerufId;
		this.baRegionCode = baRegionCode;
		this.baEducationType = baEducationType;
	}
	static createFromDbObject(dbObject) {
		return new HrbaxmlPostingSync({
			jobPositionId: dbObject.id,
			customerId: dbObject.customer_id,
			baSyncStatus: dbObject.ba_sync_status,
			baLastAction: dbObject.ba_last_action,
			baLastXmlHash: dbObject.ba_last_xml_hash,
			baLastErrorMessage: dbObject.ba_last_error_message,
			baBerufId: dbObject.ba_beruf_id,
			baRegionCode: dbObject.ba_region_code,
			baEducationType: dbObject.ba_education_type
		});
	}
};
// source/models/customer-email-template/customer-email-template.ts
var CustomerEmailTemplate = class CustomerEmailTemplate {
	id;
	customerId;
	name;
	key;
	type;
	subject;
	body;
	signatureId;
	emailProviderId;
	createdAt;
	updatedAt;
	constructor({ id, customerId, name, type, key, subject, body, signatureId, emailProviderId, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.name = name;
		this.type = type;
		this.key = key;
		this.subject = subject;
		this.body = body;
		this.signatureId = signatureId;
		this.emailProviderId = emailProviderId;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	setBody(body) {
		this.body = body;
	}
	setSubject(subject) {
		this.subject = subject;
	}
	static createFromDbObject(dbObject) {
		return new CustomerEmailTemplate({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			name: dbObject.name,
			type: dbObject.type,
			key: dbObject.key,
			subject: dbObject.subject,
			body: dbObject.body,
			signatureId: dbObject.signature_id,
			emailProviderId: dbObject.email_provider_id,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/customer-email-template/customer-email-template-dto.ts
var CustomerEmailTemplateDto = class CustomerEmailTemplateDto {
	id;
	customerId;
	name;
	type;
	key;
	subject;
	body;
	signatureId;
	emailProviderId;
	createdAt;
	updatedAt;
	constructor({ id, customerId, name, type, key, subject, body, signatureId, emailProviderId, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.name = name;
		this.type = type;
		this.key = key;
		this.subject = subject;
		this.body = body;
		this.signatureId = signatureId;
		this.emailProviderId = emailProviderId;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toCustomerEmailTemplate() {
		return new CustomerEmailTemplate({
			id: this.id,
			customerId: this.customerId,
			name: this.name,
			type: this.type,
			key: this.key,
			subject: this.subject,
			body: this.body,
			signatureId: this.signatureId,
			emailProviderId: this.emailProviderId,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new CustomerEmailTemplateDto({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			name: dbObject.name,
			type: dbObject.type,
			key: dbObject.key,
			subject: dbObject.subject,
			body: dbObject.body,
			signatureId: dbObject.signature_id,
			emailProviderId: dbObject.email_provider_id,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
	static createFromCustomerEmailTemplate(emailTemplate) {
		return new CustomerEmailTemplateDto({
			id: emailTemplate.id,
			customerId: emailTemplate.customerId,
			name: emailTemplate.name,
			type: emailTemplate.type,
			key: emailTemplate.key,
			subject: emailTemplate.subject,
			body: emailTemplate.body,
			signatureId: emailTemplate.signatureId,
			emailProviderId: emailTemplate.emailProviderId,
			createdAt: emailTemplate.createdAt,
			updatedAt: emailTemplate.updatedAt
		});
	}
	static createFromCustomerEmailTemplateData(emailTemplateData) {
		return new CustomerEmailTemplateDto({
			id: emailTemplateData.id,
			customerId: emailTemplateData.customerId,
			name: emailTemplateData.name,
			type: emailTemplateData.type,
			key: emailTemplateData.key,
			subject: emailTemplateData.subject,
			body: emailTemplateData.body,
			signatureId: emailTemplateData.signature_id,
			emailProviderId: emailTemplateData.emailProviderId,
			createdAt: emailTemplateData.createdAt,
			updatedAt: emailTemplateData.updatedAt
		});
	}
};
// source/models/customer-email-template/customer-email-template-update-dto.ts
var CustomerEmailTemplateUpdateDto = class CustomerEmailTemplateUpdateDto {
	name;
	key;
	subject;
	body;
	signatureId;
	emailProviderId;
	constructor({ name, key, subject, body, signatureId, emailProviderId }) {
		this.name = name;
		this.key = key;
		this.subject = subject;
		this.body = body;
		this.signatureId = signatureId;
		this.emailProviderId = emailProviderId;
	}
	static createFromDbObject(dbObject) {
		return new CustomerEmailTemplateUpdateDto({
			name: dbObject.name,
			key: dbObject.key,
			subject: dbObject.subject,
			body: dbObject.body,
			signatureId: dbObject.signature_id,
			emailProviderId: dbObject.email_provider_id
		});
	}
	static createFromCustomerEmailTemplateUpdateData(data) {
		return new CustomerEmailTemplateUpdateDto({
			name: data.name,
			key: data.key,
			subject: data.subject,
			body: data.body,
			signatureId: data.signatureId,
			emailProviderId: data.emailProviderId
		});
	}
};
// source/models/customer-email-template/customer-email-template-creation-dto.ts
var CustomerEmailTemplateCreationDto = class CustomerEmailTemplateCreationDto {
	customerId;
	name;
	subject;
	body;
	signatureId;
	emailProviderId;
	constructor({ customerId, name, subject, body, signatureId, emailProviderId }) {
		this.customerId = customerId;
		this.name = name;
		this.subject = subject;
		this.body = body;
		this.signatureId = signatureId;
		this.emailProviderId = emailProviderId;
	}
	static createFromDbObject(dbObject) {
		return new CustomerEmailTemplateCreationDto({
			customerId: dbObject.customer_id,
			name: dbObject.name,
			subject: dbObject.subject,
			body: dbObject.body,
			signatureId: dbObject.signature_id,
			emailProviderId: dbObject.email_provider_id
		});
	}
	static createFromCustomerEmailTemplateCreationData(data) {
		return new CustomerEmailTemplateCreationDto({
			customerId: data.customerId,
			name: data.name,
			subject: data.subject,
			body: data.body,
			signatureId: data.signatureId,
			emailProviderId: data.emailProviderId
		});
	}
};
// source/models/customer-email-template-with-relations/customer-email-template-with-relations.ts
var CustomerEmailTemplateWithRelations = class CustomerEmailTemplateWithRelations extends CustomerEmailTemplate {
	signature;
	emailProvider;
	constructor({ signature, emailProvider, ...props }) {
		super(props);
		this.signature = signature;
		this.emailProvider = emailProvider;
	}
	static createFromDbObject(dbObject) {
		return new CustomerEmailTemplateWithRelations({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			name: dbObject.name,
			type: dbObject.type,
			key: dbObject.key,
			subject: dbObject.subject,
			body: dbObject.body,
			signatureId: dbObject.signature_id,
			signature: dbObject.signature ? CustomerEmailSignature.createFromDbObject(dbObject.signature) : void 0,
			emailProviderId: dbObject.email_provider_id,
			emailProvider: dbObject.emailProvider ? EmailProvider.createFromDbObject(dbObject.emailProvider) : void 0,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/customer-email-template-with-relations/customer-email-template-with-relations-dto.ts
var CustomerEmailTemplateWithRelationsDto = class CustomerEmailTemplateWithRelationsDto extends CustomerEmailTemplateDto {
	signature;
	emailProvider;
	constructor({ signature, emailProvider, ...props }) {
		super(props);
		this.signature = signature;
		this.emailProvider = emailProvider;
	}
	toCustomerEmailTemplate() {
		return new CustomerEmailTemplateWithRelations({
			id: this.id,
			customerId: this.customerId,
			name: this.name,
			type: this.type,
			key: this.key,
			subject: this.subject,
			body: this.body,
			signatureId: this.signatureId,
			signature: this.signature ? this.signature.toCustomerEmailSignature() : void 0,
			emailProviderId: this.emailProviderId,
			emailProvider: this.emailProvider ? this.emailProvider.toEmailProvider() : void 0,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new CustomerEmailTemplateWithRelationsDto({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			name: dbObject.name,
			type: dbObject.type,
			key: dbObject.key,
			subject: dbObject.subject,
			body: dbObject.body,
			signatureId: dbObject.signature_id,
			signature: dbObject.signature ? CustomerEmailSignatureDto.createFromDbObject(dbObject.signature) : void 0,
			emailProviderId: dbObject.email_provider_id,
			emailProvider: dbObject.emailProvider ? EmailProviderDto.createFromDbObject(dbObject.emailProvider) : void 0,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
	static createFromCustomerEmailTemplate(emailTemplate) {
		return new CustomerEmailTemplateWithRelationsDto({
			id: emailTemplate.id,
			customerId: emailTemplate.customerId,
			name: emailTemplate.name,
			type: emailTemplate.type,
			key: emailTemplate.key,
			subject: emailTemplate.subject,
			body: emailTemplate.body,
			signatureId: emailTemplate.signatureId,
			signature: emailTemplate.signature ? CustomerEmailSignatureDto.createFromCustomerEmailSignature(emailTemplate.signature) : void 0,
			emailProviderId: emailTemplate.emailProviderId,
			emailProvider: emailTemplate.emailProvider ? EmailProviderDto.createFromEmailProvider(emailTemplate.emailProvider) : void 0,
			createdAt: emailTemplate.createdAt,
			updatedAt: emailTemplate.updatedAt
		});
	}
	static createFromCustomerEmailTemplateData(emailTemplateData) {
		return new CustomerEmailTemplateWithRelationsDto({
			id: emailTemplateData.id,
			customerId: emailTemplateData.customerId,
			name: emailTemplateData.name,
			type: emailTemplateData.type,
			key: emailTemplateData.key,
			subject: emailTemplateData.subject,
			body: emailTemplateData.body,
			signatureId: emailTemplateData.signatureId,
			signature: emailTemplateData.signature ? CustomerEmailSignatureDto.createFromCustomerEmailSignatureData(emailTemplateData.signature) : void 0,
			emailProviderId: emailTemplateData.emailProviderId,
			emailProvider: emailTemplateData.emailProvider ? EmailProviderDto.createFromEmailProviderData(emailTemplateData.emailProvider) : void 0,
			createdAt: emailTemplateData.createdAt,
			updatedAt: emailTemplateData.updatedAt
		});
	}
};
// source/models/customer-font/customer-font.ts
var CustomerFont = class CustomerFont {
	id;
	customerId;
	name;
	source;
	type;
	filePath;
	activeForWeight100;
	activeForWeight200;
	activeForWeight300;
	activeForWeight400;
	activeForWeight500;
	activeForWeight600;
	activeForWeight700;
	activeForWeight800;
	activeForWeight900;
	createdAt;
	updatedAt;
	constructor({ id, customerId, name, source, type, filePath, activeForWeight100, activeForWeight200, activeForWeight300, activeForWeight400, activeForWeight500, activeForWeight600, activeForWeight700, activeForWeight800, activeForWeight900, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.name = name;
		this.source = source;
		this.type = type;
		this.filePath = filePath;
		this.activeForWeight100 = activeForWeight100;
		this.activeForWeight200 = activeForWeight200;
		this.activeForWeight300 = activeForWeight300;
		this.activeForWeight400 = activeForWeight400;
		this.activeForWeight500 = activeForWeight500;
		this.activeForWeight600 = activeForWeight600;
		this.activeForWeight700 = activeForWeight700;
		this.activeForWeight800 = activeForWeight800;
		this.activeForWeight900 = activeForWeight900;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new CustomerFont({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			name: dbObject.name,
			source: dbObject.source,
			type: dbObject.type,
			filePath: dbObject.file_path,
			activeForWeight100: dbObject.active_for_weight_100,
			activeForWeight200: dbObject.active_for_weight_200,
			activeForWeight300: dbObject.active_for_weight_300,
			activeForWeight400: dbObject.active_for_weight_400,
			activeForWeight500: dbObject.active_for_weight_500,
			activeForWeight600: dbObject.active_for_weight_600,
			activeForWeight700: dbObject.active_for_weight_700,
			activeForWeight800: dbObject.active_for_weight_800,
			activeForWeight900: dbObject.active_for_weight_900,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/customer-font/customer-font-dto.ts
var CustomerFontDto = class CustomerFontDto {
	id;
	customerId;
	name;
	source;
	type;
	filePath;
	activeForWeight100;
	activeForWeight200;
	activeForWeight300;
	activeForWeight400;
	activeForWeight500;
	activeForWeight600;
	activeForWeight700;
	activeForWeight800;
	activeForWeight900;
	createdAt;
	updatedAt;
	constructor({ id, customerId, name, source, type, filePath, activeForWeight100, activeForWeight200, activeForWeight300, activeForWeight400, activeForWeight500, activeForWeight600, activeForWeight700, activeForWeight800, activeForWeight900, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.name = name;
		this.source = source;
		this.type = type;
		this.filePath = filePath;
		this.activeForWeight100 = activeForWeight100;
		this.activeForWeight200 = activeForWeight200;
		this.activeForWeight300 = activeForWeight300;
		this.activeForWeight400 = activeForWeight400;
		this.activeForWeight500 = activeForWeight500;
		this.activeForWeight600 = activeForWeight600;
		this.activeForWeight700 = activeForWeight700;
		this.activeForWeight800 = activeForWeight800;
		this.activeForWeight900 = activeForWeight900;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toCustomerFont() {
		return new CustomerFont({
			id: this.id,
			customerId: this.customerId,
			name: this.name,
			source: this.source,
			type: this.type,
			filePath: this.filePath,
			activeForWeight100: this.activeForWeight100,
			activeForWeight200: this.activeForWeight200,
			activeForWeight300: this.activeForWeight300,
			activeForWeight400: this.activeForWeight400,
			activeForWeight500: this.activeForWeight500,
			activeForWeight600: this.activeForWeight600,
			activeForWeight700: this.activeForWeight700,
			activeForWeight800: this.activeForWeight800,
			activeForWeight900: this.activeForWeight900,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new CustomerFontDto({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			name: dbObject.name,
			source: dbObject.source,
			type: dbObject.type,
			filePath: dbObject.file_path,
			activeForWeight100: dbObject.active_for_weight_100,
			activeForWeight200: dbObject.active_for_weight_200,
			activeForWeight300: dbObject.active_for_weight_300,
			activeForWeight400: dbObject.active_for_weight_400,
			activeForWeight500: dbObject.active_for_weight_500,
			activeForWeight600: dbObject.active_for_weight_600,
			activeForWeight700: dbObject.active_for_weight_700,
			activeForWeight800: dbObject.active_for_weight_800,
			activeForWeight900: dbObject.active_for_weight_900,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
	static createFromCustomerFont(emailTemplate) {
		return new CustomerFontDto({
			id: emailTemplate.id,
			customerId: emailTemplate.customerId,
			name: emailTemplate.name,
			source: emailTemplate.source,
			type: emailTemplate.type,
			filePath: emailTemplate.filePath,
			activeForWeight100: emailTemplate.activeForWeight100,
			activeForWeight200: emailTemplate.activeForWeight200,
			activeForWeight300: emailTemplate.activeForWeight300,
			activeForWeight400: emailTemplate.activeForWeight400,
			activeForWeight500: emailTemplate.activeForWeight500,
			activeForWeight600: emailTemplate.activeForWeight600,
			activeForWeight700: emailTemplate.activeForWeight700,
			activeForWeight800: emailTemplate.activeForWeight800,
			activeForWeight900: emailTemplate.activeForWeight900,
			createdAt: emailTemplate.createdAt,
			updatedAt: emailTemplate.updatedAt
		});
	}
	static createFromCustomerFontData(emailTemplateData) {
		return new CustomerFontDto({
			id: emailTemplateData.id,
			customerId: emailTemplateData.customerId,
			name: emailTemplateData.name,
			source: emailTemplateData.source,
			type: emailTemplateData.type,
			filePath: emailTemplateData.filePath,
			activeForWeight100: emailTemplateData.activeForWeight100,
			activeForWeight200: emailTemplateData.activeForWeight200,
			activeForWeight300: emailTemplateData.activeForWeight300,
			activeForWeight400: emailTemplateData.activeForWeight400,
			activeForWeight500: emailTemplateData.activeForWeight500,
			activeForWeight600: emailTemplateData.activeForWeight600,
			activeForWeight700: emailTemplateData.activeForWeight700,
			activeForWeight800: emailTemplateData.activeForWeight800,
			activeForWeight900: emailTemplateData.activeForWeight900,
			createdAt: emailTemplateData.createdAt,
			updatedAt: emailTemplateData.updatedAt
		});
	}
};
// source/models/customer-font/customer-font-update-dto.ts
var CustomerFontUpdateDto = class CustomerFontUpdateDto {
	name;
	activeForWeight100;
	activeForWeight200;
	activeForWeight300;
	activeForWeight400;
	activeForWeight500;
	activeForWeight600;
	activeForWeight700;
	activeForWeight800;
	activeForWeight900;
	constructor({ name, activeForWeight100, activeForWeight200, activeForWeight300, activeForWeight400, activeForWeight500, activeForWeight600, activeForWeight700, activeForWeight800, activeForWeight900 }) {
		this.name = name;
		this.activeForWeight100 = activeForWeight100;
		this.activeForWeight200 = activeForWeight200;
		this.activeForWeight300 = activeForWeight300;
		this.activeForWeight400 = activeForWeight400;
		this.activeForWeight500 = activeForWeight500;
		this.activeForWeight600 = activeForWeight600;
		this.activeForWeight700 = activeForWeight700;
		this.activeForWeight800 = activeForWeight800;
		this.activeForWeight900 = activeForWeight900;
	}
	static createFromDbObject(dbObject) {
		return new CustomerFontUpdateDto({
			name: dbObject.name,
			activeForWeight100: dbObject.active_for_weight_100,
			activeForWeight200: dbObject.active_for_weight_200,
			activeForWeight300: dbObject.active_for_weight_300,
			activeForWeight400: dbObject.active_for_weight_400,
			activeForWeight500: dbObject.active_for_weight_500,
			activeForWeight600: dbObject.active_for_weight_600,
			activeForWeight700: dbObject.active_for_weight_700,
			activeForWeight800: dbObject.active_for_weight_800,
			activeForWeight900: dbObject.active_for_weight_900
		});
	}
	static createFromCustomerFontUpdateData(data) {
		return new CustomerFontUpdateDto({
			name: data.name,
			activeForWeight100: data.activeForWeight100,
			activeForWeight200: data.activeForWeight200,
			activeForWeight300: data.activeForWeight300,
			activeForWeight400: data.activeForWeight400,
			activeForWeight500: data.activeForWeight500,
			activeForWeight600: data.activeForWeight600,
			activeForWeight700: data.activeForWeight700,
			activeForWeight800: data.activeForWeight800,
			activeForWeight900: data.activeForWeight900
		});
	}
};
// source/models/customer-font/customer-font-creation-dto.ts
var CustomerFontCreationDto = class CustomerFontCreationDto {
	customerId;
	constructor({ customerId }) {
		this.customerId = customerId;
	}
	static createFromDbObject(dbObject) {
		return new CustomerFontCreationDto({ customerId: dbObject.customer_id });
	}
	static createFromCustomerFontCreationData(data) {
		return new CustomerFontCreationDto({ customerId: data.customerId });
	}
};
// source/models/applicant-shared-with-relations/applicant-shared-with-relations.ts
var ApplicantSharedWithRelations = class ApplicantSharedWithRelations extends ApplicantShared {
	jobPosition;
	documentCount;
	unreadDocumentCount;
	safeDocumentCount;
	constructor({ jobPosition, documentCount, unreadDocumentCount, safeDocumentCount, ...props }) {
		super(props);
		this.jobPosition = jobPosition;
		this.documentCount = documentCount;
		this.unreadDocumentCount = unreadDocumentCount;
		this.safeDocumentCount = safeDocumentCount;
	}
	static createFromDbObject(applicantWithRelationsDbObject) {
		return new ApplicantSharedWithRelations({
			name: applicantWithRelationsDbObject.name,
			jobPositionId: applicantWithRelationsDbObject.job_position_id,
			jobPosition: JobPositionPublic.createFromDbObject(applicantWithRelationsDbObject.job_position),
			phaseId: applicantWithRelationsDbObject.phase_id,
			currentState: applicantWithRelationsDbObject.current_state,
			profile: applicantWithRelationsDbObject.profile,
			emailAddress: applicantWithRelationsDbObject.email_address,
			phoneNumber: applicantWithRelationsDbObject.phone_number,
			normalizedPhoneNumber: applicantWithRelationsDbObject.normalized_phone_number,
			forwardedAt: applicantWithRelationsDbObject.forwarded_at,
			receivedAt: applicantWithRelationsDbObject.received_at,
			customerNotes: applicantWithRelationsDbObject.customer_notes,
			documentCount: applicantWithRelationsDbObject.document_count,
			unreadDocumentCount: applicantWithRelationsDbObject.unread_document_count,
			shareLinkWithNotes: applicantWithRelationsDbObject.share_link_with_notes,
			safeDocumentCount: applicantWithRelationsDbObject.safe_document_count
		});
	}
};
// source/models/applicant-shared-with-relations/applicant-shared-with-relations-dto.ts
var ApplicantSharedWithRelationsDto = class ApplicantSharedWithRelationsDto extends ApplicantSharedDto {
	jobPosition;
	documentCount;
	unreadDocumentCount;
	safeDocumentCount;
	constructor({ jobPosition, documentCount, unreadDocumentCount, safeDocumentCount, ...props }) {
		super(props);
		this.jobPosition = jobPosition;
		this.documentCount = documentCount;
		this.unreadDocumentCount = unreadDocumentCount;
	}
	toApplicantWithRelations() {
		return new ApplicantSharedWithRelations({
			name: this.name,
			jobPositionId: this.jobPositionId,
			jobPosition: this.jobPosition.toJobPositionPublic(),
			phaseId: this.phaseId,
			currentState: this.currentState,
			profile: this.profile,
			emailAddress: this.emailAddress,
			phoneNumber: this.phoneNumber,
			normalizedPhoneNumber: this.normalizedPhoneNumber,
			forwardedAt: this.forwardedAt,
			receivedAt: this.receivedAt,
			customerNotes: this.customerNotes,
			documentCount: this.documentCount,
			unreadDocumentCount: this.unreadDocumentCount,
			referralSource: this.referralSource,
			shareLinkWithNotes: this.shareLinkWithNotes,
			safeDocumentCount: this.safeDocumentCount
		});
	}
	static createFromApplicantWithRelations(applicantWithRelations) {
		return new ApplicantSharedWithRelationsDto({
			name: applicantWithRelations.name,
			jobPositionId: applicantWithRelations.jobPositionId,
			jobPosition: JobPositionPublicDto.createFromJobPositionPublic(applicantWithRelations.jobPosition),
			phaseId: applicantWithRelations.phaseId,
			currentState: applicantWithRelations.currentState,
			profile: applicantWithRelations.profile,
			emailAddress: applicantWithRelations.emailAddress,
			phoneNumber: applicantWithRelations.phoneNumber,
			normalizedPhoneNumber: applicantWithRelations.normalizedPhoneNumber,
			forwardedAt: applicantWithRelations.forwardedAt,
			receivedAt: applicantWithRelations.receivedAt,
			customerNotes: applicantWithRelations.customerNotes,
			documentCount: applicantWithRelations.documentCount,
			unreadDocumentCount: applicantWithRelations.unreadDocumentCount,
			referralSource: applicantWithRelations.referralSource,
			shareLinkWithNotes: applicantWithRelations.shareLinkWithNotes,
			safeDocumentCount: applicantWithRelations.safeDocumentCount
		});
	}
	static createFromDbObject(applicantWithRelationsDbObject) {
		return new ApplicantSharedWithRelationsDto({
			name: applicantWithRelationsDbObject.name,
			jobPositionId: applicantWithRelationsDbObject.job_position_id,
			jobPosition: JobPositionPublicDto.createFromDbObject(applicantWithRelationsDbObject.job_position),
			phaseId: applicantWithRelationsDbObject.phase_id,
			currentState: applicantWithRelationsDbObject.current_state,
			profile: applicantWithRelationsDbObject.profile,
			emailAddress: applicantWithRelationsDbObject.email_address,
			phoneNumber: applicantWithRelationsDbObject.phone_number,
			normalizedPhoneNumber: applicantWithRelationsDbObject.normalized_phone_number,
			forwardedAt: applicantWithRelationsDbObject.forwarded_at,
			receivedAt: applicantWithRelationsDbObject.received_at,
			customerNotes: applicantWithRelationsDbObject.customer_notes,
			documentCount: applicantWithRelationsDbObject.document_count,
			unreadDocumentCount: applicantWithRelationsDbObject.unread_document_count,
			referralSource: applicantWithRelationsDbObject.referral_source,
			shareLinkWithNotes: applicantWithRelationsDbObject.share_link_with_notes,
			safeDocumentCount: applicantWithRelationsDbObject.safe_document_count
		});
	}
	static createFromApplicantWithRelationsData(applicantWithRelationsData) {
		return new ApplicantSharedWithRelationsDto({
			name: applicantWithRelationsData.name,
			jobPositionId: applicantWithRelationsData.jobPositionId,
			jobPosition: JobPositionPublicDto.createFromData(applicantWithRelationsData.jobPosition),
			phaseId: applicantWithRelationsData.phaseId,
			currentState: applicantWithRelationsData.currentState,
			profile: applicantWithRelationsData.profile,
			emailAddress: applicantWithRelationsData.emailAddress,
			phoneNumber: applicantWithRelationsData.phoneNumber,
			normalizedPhoneNumber: applicantWithRelationsData.normalizedPhoneNumber,
			forwardedAt: applicantWithRelationsData.forwardedAt,
			receivedAt: applicantWithRelationsData.receivedAt,
			customerNotes: applicantWithRelationsData.customerNotes,
			documentCount: applicantWithRelationsData.documentCount,
			unreadDocumentCount: applicantWithRelationsData.unreadDocumentCount,
			referralSource: applicantWithRelationsData.referralSource,
			shareLinkWithNotes: applicantWithRelationsData.shareLinkWithNotes,
			safeDocumentCount: applicantWithRelationsData.safeDocumentCount
		});
	}
};
// source/models/map-location/map-location.ts
var MapLocation = class {
	postalCode;
	city;
	lat;
	lng;
	distance;
	constructor({ postalCode, city, lat, lng }) {
		this.postalCode = postalCode;
		this.city = city;
		this.lat = lat;
		this.lng = lng;
	}
};
// source/models/map-location/map-location-dto.ts
var MapLocationDto = class MapLocationDto {
	postalCode;
	city;
	lat;
	lng;
	constructor({ postalCode, city, lat, lng }) {
		this.postalCode = postalCode;
		this.city = city;
		this.lat = lat;
		this.lng = lng;
	}
	toMapLocation() {
		return new MapLocation({
			postalCode: this.postalCode,
			city: this.city,
			lat: this.lat,
			lng: this.lng
		});
	}
	static createFromMapLocation(mapLocation) {
		return new MapLocationDto({
			postalCode: mapLocation.postalCode,
			city: mapLocation.city,
			lat: mapLocation.lat,
			lng: mapLocation.lng
		});
	}
	static createFromData(data) {
		return new MapLocationDto({
			postalCode: data.postalCode,
			city: data.city,
			lat: data.lat,
			lng: data.lng
		});
	}
};
// source/models/company-light/company-light.ts
var CompanyLight = class CompanyLight {
	id;
	customerId;
	applicantManagerId;
	longName;
	shortName;
	mondayName;
	contactCareerPageApplicantsOnBehalfOfStahlhart;
	contactImportedAndManualApplicantsOnBehalfOfStahlhart;
	city;
	createdAt;
	updatedAt;
	constructor({ id, customerId, applicantManagerId, longName, shortName, mondayName, contactCareerPageApplicantsOnBehalfOfStahlhart, contactImportedAndManualApplicantsOnBehalfOfStahlhart, city, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.applicantManagerId = applicantManagerId;
		this.longName = longName;
		this.shortName = shortName;
		this.mondayName = mondayName;
		this.contactCareerPageApplicantsOnBehalfOfStahlhart = contactCareerPageApplicantsOnBehalfOfStahlhart;
		this.contactImportedAndManualApplicantsOnBehalfOfStahlhart = contactImportedAndManualApplicantsOnBehalfOfStahlhart;
		this.city = city;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new CompanyLight({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			applicantManagerId: dbObject.applicant_manager_id,
			longName: dbObject.long_name,
			shortName: dbObject.short_name,
			mondayName: dbObject.monday_name,
			contactCareerPageApplicantsOnBehalfOfStahlhart: dbObject.contact_career_page_applicants_on_behalf_of_stahlhart,
			contactImportedAndManualApplicantsOnBehalfOfStahlhart: dbObject.contact_imported_and_manual_applicants_on_behalf_of_stahlhart,
			city: dbObject.city,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/company-light/company-light-dto.ts
var CompanyLightDto = class CompanyLightDto {
	id;
	customerId;
	applicantManagerId;
	longName;
	shortName;
	mondayName;
	contactCareerPageApplicantsOnBehalfOfStahlhart;
	contactImportedAndManualApplicantsOnBehalfOfStahlhart;
	city;
	createdAt;
	updatedAt;
	constructor({ id, customerId, applicantManagerId, longName, shortName, mondayName, contactCareerPageApplicantsOnBehalfOfStahlhart, contactImportedAndManualApplicantsOnBehalfOfStahlhart, city, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.applicantManagerId = applicantManagerId;
		this.longName = longName;
		this.shortName = shortName;
		this.mondayName = mondayName;
		this.contactCareerPageApplicantsOnBehalfOfStahlhart = contactCareerPageApplicantsOnBehalfOfStahlhart;
		this.contactImportedAndManualApplicantsOnBehalfOfStahlhart = contactImportedAndManualApplicantsOnBehalfOfStahlhart;
		this.city = city;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toCompany() {
		return new CompanyLight({
			id: this.id,
			customerId: this.customerId,
			applicantManagerId: this.applicantManagerId,
			longName: this.longName,
			shortName: this.shortName,
			mondayName: this.mondayName,
			contactCareerPageApplicantsOnBehalfOfStahlhart: this.contactCareerPageApplicantsOnBehalfOfStahlhart,
			contactImportedAndManualApplicantsOnBehalfOfStahlhart: this.contactImportedAndManualApplicantsOnBehalfOfStahlhart,
			city: this.city,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromCompany(company) {
		return new CompanyLightDto({
			id: company.id,
			customerId: company.customerId,
			applicantManagerId: company.applicantManagerId,
			longName: company.longName,
			shortName: company.shortName,
			mondayName: company.mondayName,
			contactCareerPageApplicantsOnBehalfOfStahlhart: company.contactCareerPageApplicantsOnBehalfOfStahlhart,
			contactImportedAndManualApplicantsOnBehalfOfStahlhart: company.contactImportedAndManualApplicantsOnBehalfOfStahlhart,
			city: company.city,
			createdAt: company.createdAt,
			updatedAt: company.updatedAt
		});
	}
	static createFromCompanyData(data) {
		return new CompanyLightDto({
			id: data.id,
			customerId: data.customerId,
			applicantManagerId: data.applicantManagerId,
			longName: data.longName,
			shortName: data.shortName,
			mondayName: data.mondayName,
			contactCareerPageApplicantsOnBehalfOfStahlhart: data.contactCareerPageApplicantsOnBehalfOfStahlhart,
			contactImportedAndManualApplicantsOnBehalfOfStahlhart: data.contactImportedAndManualApplicantsOnBehalfOfStahlhart,
			city: data.city,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new CompanyLightDto({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			applicantManagerId: dbObject.applicant_manager_id,
			longName: dbObject.long_name,
			shortName: dbObject.short_name,
			mondayName: dbObject.monday_name,
			contactCareerPageApplicantsOnBehalfOfStahlhart: dbObject.contact_career_page_applicants_on_behalf_of_stahlhart,
			contactImportedAndManualApplicantsOnBehalfOfStahlhart: dbObject.contact_imported_and_manual_applicants_on_behalf_of_stahlhart,
			city: dbObject.city,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/customer-light/customer-light.ts
var CustomerLight = class CustomerLight {
	id;
	firebaseUid;
	mondayItemId;
	productVersion;
	projectManager;
	company;
	jobPositions;
	createdAt;
	updatedAt;
	constructor({ id, firebaseUid, mondayItemId, productVersion, projectManager, company, jobPositions, createdAt, updatedAt }) {
		this.id = id;
		this.firebaseUid = firebaseUid;
		this.mondayItemId = mondayItemId;
		this.productVersion = productVersion;
		this.projectManager = projectManager;
		this.company = company;
		this.jobPositions = jobPositions;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(customerLightDbObject) {
		return new CustomerLight({
			id: customerLightDbObject.id,
			firebaseUid: customerLightDbObject.firebase_uid,
			mondayItemId: customerLightDbObject.monday_item_id,
			productVersion: customerLightDbObject.product_version,
			projectManager: customerLightDbObject.project_manager,
			company: CompanyLight.createFromDbObject(customerLightDbObject.company),
			jobPositions: customerLightDbObject.job_positions?.map((jobPosition) => JobPositionInfo.createFromDbObject(jobPosition)),
			createdAt: customerLightDbObject.created_at,
			updatedAt: customerLightDbObject.updated_at
		});
	}
};
// source/models/customer-light/customer-light-dto.ts
var CustomerLightDto = class CustomerLightDto {
	id;
	firebaseUid;
	mondayItemId;
	productVersion;
	projectManager;
	company;
	jobPositions;
	createdAt;
	updatedAt;
	constructor({ id, firebaseUid, mondayItemId, productVersion, projectManager, company, jobPositions, createdAt, updatedAt }) {
		this.id = id;
		this.firebaseUid = firebaseUid;
		this.mondayItemId = mondayItemId;
		this.productVersion = productVersion;
		this.projectManager = projectManager;
		this.company = company;
		this.jobPositions = jobPositions;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toCustomerLight() {
		return new CustomerLight({
			id: this.id,
			firebaseUid: this.firebaseUid,
			mondayItemId: this.mondayItemId,
			productVersion: this.productVersion,
			projectManager: this.projectManager,
			company: this.company.toCompany(),
			jobPositions: this.jobPositions?.map((jobPosition) => jobPosition.toJobPositionInfo()),
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromCustomerLight(customerLight) {
		return new CustomerLightDto({
			id: customerLight.id,
			firebaseUid: customerLight.firebaseUid,
			mondayItemId: customerLight.mondayItemId,
			productVersion: customerLight.productVersion,
			projectManager: customerLight.projectManager,
			company: CompanyLightDto.createFromCompanyData(customerLight.company),
			jobPositions: customerLight.jobPositions?.map((jobPosition) => JobPositionInfoDto.createFromJobPositionInfo(jobPosition)),
			createdAt: customerLight.createdAt,
			updatedAt: customerLight.updatedAt
		});
	}
	static createFromDbObject(customerLightDbObject) {
		return new CustomerLightDto({
			id: customerLightDbObject.id,
			firebaseUid: customerLightDbObject.firebase_uid,
			mondayItemId: customerLightDbObject.monday_item_id,
			productVersion: customerLightDbObject.product_version,
			projectManager: customerLightDbObject.project_manager,
			company: CompanyLightDto.createFromDbObject(customerLightDbObject.company),
			jobPositions: customerLightDbObject.job_positions?.map((jobPosition) => JobPositionInfoDto.createFromDbObject(jobPosition)),
			createdAt: customerLightDbObject.created_at,
			updatedAt: customerLightDbObject.updated_at
		});
	}
	static createFromCustomerLightData(customerLightData) {
		return new CustomerLightDto({
			id: customerLightData.id,
			firebaseUid: customerLightData.firebaseUid,
			mondayItemId: customerLightData.mondayItemId,
			productVersion: customerLightData.productVersion,
			projectManager: customerLightData.projectManager,
			company: CompanyLightDto.createFromCompanyData(customerLightData.company),
			jobPositions: customerLightData.jobPositions?.map((jobPosition) => JobPositionInfoDto.createFromJobPositionInfoData(jobPosition)),
			createdAt: customerLightData.createdAt,
			updatedAt: customerLightData.updatedAt
		});
	}
};
// source/models/customer-analytics/customer-analytics.ts
var CustomerAnalytics = class CustomerAnalytics {
	id;
	customerId;
	platform;
	type;
	value;
	date;
	endedAt;
	createdAt;
	updatedAt;
	constructor({ id, customerId, platform, type, value, date, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.platform = platform;
		this.type = type;
		this.value = value;
		this.date = date;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new CustomerAnalytics({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			platform: dbObject.platform,
			type: dbObject.type,
			value: dbObject.value,
			date: dbObject.date,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/customer-analytics/customer-analytics-dto.ts
var CustomerAnalyticsDto = class CustomerAnalyticsDto {
	id;
	customerId;
	platform;
	type;
	value;
	date;
	createdAt;
	updatedAt;
	constructor({ id, customerId, platform, type, value, date, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.platform = platform;
		this.type = type;
		this.value = value;
		this.date = date;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toCustomerAnalytics() {
		return new CustomerAnalytics({
			id: this.id,
			customerId: this.customerId,
			platform: this.platform,
			type: this.type,
			value: this.value,
			date: this.date,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromCustomerAnalyticsData(data) {
		return new CustomerAnalyticsDto({
			id: data.id,
			customerId: data.customerId,
			platform: data.platform,
			type: data.type,
			value: data.value,
			date: data.date,
			createdAt: data.createdAt,
			updatedAt: data.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new CustomerAnalyticsDto({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			platform: dbObject.platform,
			type: dbObject.type,
			value: dbObject.value,
			date: dbObject.date,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/customer-analytics/customer-analytics-creation-dto.ts
var CustomerAnalyticsCreationDto = class CustomerAnalyticsCreationDto {
	customerId;
	platform;
	type;
	value;
	date;
	constructor({ customerId, platform, type, value, date }) {
		this.customerId = customerId;
		this.platform = platform;
		this.type = type;
		this.value = value;
		this.date = date;
	}
	static createFromCustomerAnalyticsData(data) {
		return new CustomerAnalyticsCreationDto({
			customerId: data.customerId,
			platform: data.platform,
			type: data.type,
			value: data.value,
			date: data.date
		});
	}
	convertToDbObject() {
		return {
			customer_id: this.customerId,
			platform: this.platform,
			type: this.type,
			value: this.value,
			date: this.date
		};
	}
};
// source/models/scheduled-email/scheduled-email.tsx
var ScheduledEmail = class ScheduledEmail {
	id;
	customerId;
	applicantId;
	applicantName;
	emailProviderId;
	subject;
	body;
	signature;
	error;
	recipients;
	scheduledFor;
	delayInBusinessDays;
	sentAt;
	cloudTaskName;
	createdAt;
	updatedAt;
	constructor({ id, customerId, applicantId, applicantName, emailProviderId, subject, body, signature, error, recipients, scheduledFor, delayInBusinessDays, sentAt, cloudTaskName, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.applicantId = applicantId;
		this.applicantName = applicantName ?? null;
		this.emailProviderId = emailProviderId;
		this.subject = subject;
		this.body = body;
		this.signature = signature;
		this.error = error;
		this.recipients = recipients;
		this.scheduledFor = scheduledFor;
		this.delayInBusinessDays = delayInBusinessDays;
		this.sentAt = sentAt;
		this.cloudTaskName = cloudTaskName;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(applicantManagerDbObject) {
		return new ScheduledEmail({
			id: applicantManagerDbObject.id,
			customerId: applicantManagerDbObject.customer_id,
			applicantId: applicantManagerDbObject.applicant_id,
			applicantName: applicantManagerDbObject.applicant_name ?? null,
			emailProviderId: applicantManagerDbObject.email_provider_id,
			subject: applicantManagerDbObject.subject,
			body: applicantManagerDbObject.body,
			signature: applicantManagerDbObject.signature,
			error: applicantManagerDbObject.error,
			recipients: applicantManagerDbObject.recipients,
			scheduledFor: applicantManagerDbObject.scheduled_for,
			delayInBusinessDays: applicantManagerDbObject.delay_in_business_days,
			sentAt: applicantManagerDbObject.sent_at,
			cloudTaskName: applicantManagerDbObject.cloud_task_name,
			createdAt: applicantManagerDbObject.created_at,
			updatedAt: applicantManagerDbObject.updated_at
		});
	}
};
// source/models/scheduled-email/scheduled-email-dto.tsx
var ScheduledEmailDto = class ScheduledEmailDto {
	id;
	customerId;
	applicantId;
	applicantName;
	emailProviderId;
	error;
	recipients;
	scheduledFor;
	delayInBusinessDays;
	sentAt;
	createdAt;
	updatedAt;
	constructor({ id, customerId, applicantId, applicantName, emailProviderId, error, recipients, scheduledFor, delayInBusinessDays, sentAt, createdAt, updatedAt }) {
		this.id = id;
		this.customerId = customerId;
		this.applicantId = applicantId;
		this.applicantName = applicantName ?? null;
		this.emailProviderId = emailProviderId;
		this.error = error;
		this.recipients = recipients;
		this.scheduledFor = scheduledFor;
		this.delayInBusinessDays = delayInBusinessDays;
		this.sentAt = sentAt;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toScheduledEmail() {
		return new ScheduledEmail({
			id: this.id,
			customerId: this.customerId,
			applicantId: this.applicantId,
			applicantName: this.applicantName,
			emailProviderId: this.emailProviderId,
			subject: "",
			body: "",
			signature: null,
			error: this.error,
			recipients: this.recipients,
			scheduledFor: this.scheduledFor,
			delayInBusinessDays: this.delayInBusinessDays,
			sentAt: this.sentAt,
			cloudTaskName: null,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromScheduledEmail(scheduledEmail) {
		return new ScheduledEmailDto({
			id: scheduledEmail.id,
			customerId: scheduledEmail.customerId,
			applicantId: scheduledEmail.applicantId,
			applicantName: scheduledEmail.applicantName,
			emailProviderId: scheduledEmail.emailProviderId,
			error: scheduledEmail.error,
			recipients: scheduledEmail.recipients,
			scheduledFor: scheduledEmail.scheduledFor,
			delayInBusinessDays: scheduledEmail.delayInBusinessDays,
			sentAt: scheduledEmail.sentAt,
			createdAt: scheduledEmail.createdAt,
			updatedAt: scheduledEmail.updatedAt
		});
	}
	static createFromScheduledEmailData(scheduledEmail) {
		return new ScheduledEmailDto({
			id: scheduledEmail.id,
			customerId: scheduledEmail.customerId,
			applicantId: scheduledEmail.applicantId,
			applicantName: scheduledEmail.applicantName ?? null,
			emailProviderId: scheduledEmail.emailProviderId,
			error: scheduledEmail.error,
			recipients: scheduledEmail.recipients,
			scheduledFor: scheduledEmail.scheduledFor,
			delayInBusinessDays: scheduledEmail.delayInBusinessDays,
			sentAt: scheduledEmail.sentAt,
			createdAt: scheduledEmail.createdAt,
			updatedAt: scheduledEmail.updatedAt
		});
	}
	static createFromDbObject(scheduledEmailDbObject) {
		return new ScheduledEmailDto({
			id: scheduledEmailDbObject.id,
			customerId: scheduledEmailDbObject.customer_id,
			applicantId: scheduledEmailDbObject.applicant_id,
			applicantName: scheduledEmailDbObject.applicant_name ?? null,
			emailProviderId: scheduledEmailDbObject.email_provider_id,
			error: scheduledEmailDbObject.error,
			recipients: scheduledEmailDbObject.recipients,
			scheduledFor: scheduledEmailDbObject.scheduled_for,
			delayInBusinessDays: scheduledEmailDbObject.delay_in_business_days,
			sentAt: scheduledEmailDbObject.sent_at,
			createdAt: scheduledEmailDbObject.created_at,
			updatedAt: scheduledEmailDbObject.updated_at
		});
	}
};
// source/models/sms-template/sms-template.ts
var SmsTemplate = class SmsTemplate {
	id;
	key;
	onBehalfOf;
	name;
	target;
	body;
	createdAt;
	updatedAt;
	constructor({ id, key, onBehalfOf, name, target, body, createdAt, updatedAt }) {
		this.id = id;
		this.key = key;
		this.onBehalfOf = onBehalfOf;
		this.name = name;
		this.target = target;
		this.body = body;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	static createFromDbObject(dbObject) {
		return new SmsTemplate({
			id: dbObject.id,
			key: dbObject.key,
			onBehalfOf: dbObject.on_behalf_of,
			name: dbObject.name,
			target: dbObject.target,
			body: dbObject.body,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
};
// source/models/sms-template/sms-template-dto.ts
var SmsTemplateDto = class SmsTemplateDto {
	id;
	key;
	onBehalfOf;
	name;
	target;
	body;
	createdAt;
	updatedAt;
	constructor({ id, key, onBehalfOf, name, target, body, createdAt, updatedAt }) {
		this.id = id;
		this.key = key;
		this.onBehalfOf = onBehalfOf;
		this.name = name;
		this.target = target;
		this.body = body;
		this.createdAt = createdAt;
		this.updatedAt = updatedAt;
	}
	toSmsTemplate() {
		return new SmsTemplate({
			id: this.id,
			key: this.key,
			onBehalfOf: this.onBehalfOf,
			name: this.name,
			target: this.target,
			body: this.body,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		});
	}
	static createFromDbObject(dbObject) {
		return new SmsTemplateDto({
			id: dbObject.id,
			key: dbObject.key,
			onBehalfOf: dbObject.on_behalf_of,
			name: dbObject.name,
			target: dbObject.target,
			body: dbObject.body,
			createdAt: dbObject.created_at,
			updatedAt: dbObject.updated_at
		});
	}
	static createFromSmsTemplate(smsTemplate) {
		return new SmsTemplateDto({
			id: smsTemplate.id,
			key: smsTemplate.key,
			onBehalfOf: smsTemplate.onBehalfOf,
			name: smsTemplate.name,
			target: smsTemplate.target,
			body: smsTemplate.body,
			createdAt: smsTemplate.createdAt,
			updatedAt: smsTemplate.updatedAt
		});
	}
	static createFromSmsTemplateData(smsTemplateData) {
		return new SmsTemplateDto({
			id: smsTemplateData.id,
			key: smsTemplateData.key,
			onBehalfOf: smsTemplateData.onBehalfOf,
			name: smsTemplateData.name,
			target: smsTemplateData.target,
			body: smsTemplateData.body,
			createdAt: smsTemplateData.createdAt,
			updatedAt: smsTemplateData.updatedAt
		});
	}
};
// source/models/sms-template/sms-template-update-dto.ts
var SmsTemplateUpdateDto = class SmsTemplateUpdateDto {
	name;
	body;
	constructor({ name, body }) {
		this.name = name;
		this.body = body;
	}
	static createFromSmsTemplateUpdateData(data) {
		return new SmsTemplateUpdateDto({
			name: data.name,
			body: data.body
		});
	}
};
// source/models/stahlhart-integration/stahlhart-applicant-counts-dto.ts
/**
* How many applicants of one origin a job position has, per calendar day in
* Europe/Berlin (`YYYY-MM-DD`, by `received_at`) and in total. Only counts
* leave the portal, never an applicant.
*/
var StahlhartApplicantCountsDto = class StahlhartApplicantCountsDto {
	jobPositionId;
	origin;
	total;
	days;
	constructor({ jobPositionId, origin, total, days }) {
		this.jobPositionId = jobPositionId;
		this.origin = origin;
		this.total = total;
		this.days = days;
	}
	/**
	* The rows come grouped by day from the database; days without an
	* applicant have no row. The total is the sum of the rows, the days keep
	* their ascending order.
	*/
	static createFromDbRows({ jobPositionId, origin, rows }) {
		const days = rows.map((row) => ({
			day: row.day,
			count: Number(row.count)
		})).filter((row) => Number.isFinite(row.count) && row.count > 0).sort((a, b) => a.day.localeCompare(b.day));
		return new StahlhartApplicantCountsDto({
			jobPositionId,
			origin,
			total: days.reduce((sum, row) => sum + row.count, 0),
			days
		});
	}
};
// source/models/stahlhart-integration/stahlhart-company-dto.ts
/** Not a public profile of the company, so the platform has no use for it. */
var excludedSocialLinkPlatforms = [LoginDataPlatform.PARTNER_PORTAL, LoginDataPlatform.OTHER];
/**
* The credentials hold usernames and passwords; only platform and url may
* ever leave the portal.
*/
var toSocialLinks = (platformCredentials) => (platformCredentials ?? []).flatMap((platformCredential) => {
	const url = platformCredential?.url?.trim();
	if (!platformCredential?.platform || !url || excludedSocialLinkPlatforms.includes(platformCredential.platform)) return [];
	return [{
		platform: platformCredential.platform,
		url
	}];
});
var StahlhartCompanyDto = class StahlhartCompanyDto {
	customerId;
	shortName;
	longName;
	mondayItemId;
	description;
	employeeCount;
	foundingYear;
	city;
	zipCode;
	websiteUrl;
	/** Public URL of the company logo, or `null` when none is uploaded. */
	logoUrl;
	socialLinks;
	constructor({ customerId, shortName, longName, mondayItemId, description, employeeCount, foundingYear, city, zipCode, websiteUrl, logoUrl, socialLinks }) {
		this.customerId = customerId;
		this.shortName = shortName;
		this.longName = longName;
		this.mondayItemId = mondayItemId;
		this.description = description;
		this.employeeCount = employeeCount;
		this.foundingYear = foundingYear;
		this.city = city;
		this.zipCode = zipCode;
		this.websiteUrl = websiteUrl;
		this.logoUrl = logoUrl;
		this.socialLinks = socialLinks;
	}
	static createFromDbObject(dbObject) {
		const logoPath = dbObject.logo_path || dbObject.portal_logo_path;
		return new StahlhartCompanyDto({
			customerId: dbObject.customer_id,
			shortName: dbObject.short_name,
			longName: dbObject.long_name,
			mondayItemId: dbObject.customer.monday_item_id,
			description: dbObject.description,
			employeeCount: dbObject.employee_count,
			foundingYear: dbObject.founding_year,
			city: dbObject.city,
			zipCode: dbObject.zip_code,
			websiteUrl: dbObject.website_url,
			logoUrl: logoPath ? getBucketObjectURL(logoPath) || null : null,
			socialLinks: toSocialLinks(dbObject.platform_credentials)
		});
	}
};
// source/models/stahlhart-integration/stahlhart-job-position-dto.ts
var mapContentEntries = (entries) => (entries ?? []).map((entry) => entry?.content).filter((content) => Boolean(content));
var parseNumeric = (value) => {
	if (value === null || value === void 0) return null;
	const parsedValue = Number.parseFloat(value);
	return Number.isNaN(parsedValue) ? null : parsedValue;
};
/**
* Mirrors the job position form: a position that is not pre-qualified has no
* public-only section, so every requirement counts as `isPublicOnly: false`.
* The stored order is kept.
*/
var mapRequirements = (requirements, isPreQualified) => (requirements ?? []).filter((requirement) => Boolean(requirement?.value)).map((requirement) => {
	const isKoCriteria = "isKoCriteria" in requirement ? requirement.isKoCriteria ?? null : null;
	if (isPreQualified !== true) return {
		value: requirement.value,
		isKoCriteria: isKoCriteria || null,
		isPublicOnly: false
	};
	return {
		value: requirement.value,
		isKoCriteria: requirement.isPublicOnly ? null : isKoCriteria,
		isPublicOnly: requirement.isPublicOnly === true
	};
});
var StahlhartJobPositionDto = class StahlhartJobPositionDto {
	id;
	customerId;
	name;
	fullName;
	type;
	salary;
	salaryIsPublic;
	benefits;
	tasks;
	addressCity;
	addressZipCode;
	location;
	careerPageActive;
	isArchived;
	mondayItemId;
	repostedAt;
	shiftWork;
	schedule;
	weeklyHours;
	weeklyHoursMax;
	requirements;
	germanLevel;
	otherManagerInfo;
	constructor({ id, customerId, name, fullName, type, salary, salaryIsPublic, benefits, tasks, addressCity, addressZipCode, location, careerPageActive, isArchived, mondayItemId, repostedAt, shiftWork, schedule, weeklyHours, weeklyHoursMax, requirements, germanLevel, otherManagerInfo }) {
		this.id = id;
		this.customerId = customerId;
		this.name = name;
		this.fullName = fullName;
		this.type = type;
		this.salary = salary;
		this.salaryIsPublic = salaryIsPublic;
		this.benefits = benefits;
		this.tasks = tasks;
		this.addressCity = addressCity;
		this.addressZipCode = addressZipCode;
		this.location = location;
		this.careerPageActive = careerPageActive;
		this.isArchived = isArchived;
		this.mondayItemId = mondayItemId;
		this.repostedAt = repostedAt;
		this.shiftWork = shiftWork;
		this.schedule = schedule;
		this.weeklyHours = weeklyHours;
		this.weeklyHoursMax = weeklyHoursMax;
		this.requirements = requirements;
		this.germanLevel = germanLevel;
		this.otherManagerInfo = otherManagerInfo;
	}
	static createFromDbObject(dbObject) {
		return new StahlhartJobPositionDto({
			id: dbObject.id,
			customerId: dbObject.customer_id,
			name: dbObject.name,
			fullName: dbObject.full_name,
			type: dbObject.type,
			salary: dbObject.salary,
			salaryIsPublic: dbObject.salary_is_public,
			benefits: mapContentEntries(dbObject.benefits),
			tasks: mapContentEntries(dbObject.tasks),
			addressCity: dbObject.address_city,
			addressZipCode: dbObject.address_zip_code,
			location: dbObject.location ? {
				city: dbObject.location.city,
				zipCode: dbObject.location.zip_code
			} : null,
			careerPageActive: dbObject.career_page_active,
			isArchived: dbObject.is_archived,
			mondayItemId: dbObject.monday_item_id,
			repostedAt: dbObject.reposted_at,
			shiftWork: dbObject.shift_work,
			schedule: dbObject.schedule,
			weeklyHours: parseNumeric(dbObject.weekly_hours),
			weeklyHoursMax: parseNumeric(dbObject.weekly_hours_max),
			requirements: mapRequirements(dbObject.requirements, dbObject.is_pre_qualified),
			germanLevel: dbObject.german_level,
			otherManagerInfo: mapContentEntries(dbObject.other_manager_info)
		});
	}
};
// source/data/applicant-automation-templates.ts
var resumeReceivedAutomationTemplate = new ApplicantAutomationTemplate({
	id: "resume-received",
	label: "Lebenslauf erhalten",
	type: "manual",
	color: "#d1f4e0",
	emails: [{ emailTemplateKey: EmailTemplateKey.RESUME_RECEIVED }, { emailTemplateKey: EmailTemplateKey.NEW_APPLICANT_PREQUALIFIED }],
	currentStateTemplate: null,
	hideCurrentStateChange: true,
	phaseType: ApplicantPhaseType.CONTACT_PARTNER,
	forwardedAt: "today",
	hideForwardedAtChange: true,
	deadline: null,
	markApplicantDocumentsAsRead: true,
	prequalificationStatus: PrequalificationStatus.APPROVED
});
var resumeReminderAutomationTemplate = new ApplicantAutomationTemplate({
	id: "resume-reminder",
	color: "#fdf7d3",
	label: "An Lebenslauf erinnern",
	type: "manual",
	emails: [{ emailTemplateKey: EmailTemplateKey.RESUME_SUBMISSION_REMINDER }],
	currentStateTemplate: "{{today}} Erinnerung verschickt - {{applicant.currentState}}",
	deadline: "move7DaysForward"
});
var resumeIncompleteAutomationTemplate = new ApplicantAutomationTemplate({
	id: "resume-incomplete",
	color: "#fdf7d3",
	label: "Lebenslauf unvollständig",
	type: "manual",
	emails: [{ emailTemplateKey: EmailTemplateKey.RESUME_INCOMPLETE }],
	currentStateTemplate: "{{today}} Vervollständigung angefragt - {{applicant.currentState}}",
	deadline: "move7DaysForward"
});
var resumeNotReceivedAutomationTemplate = new ApplicantAutomationTemplate({
	id: "resume-not-received",
	color: "#fdd0df",
	label: "Lebenslauf nicht erhalten",
	type: "manual",
	phaseType: ApplicantPhaseType.REJECTED_STAHLHART,
	declineReason: "Lebenslauf nicht erhalten",
	declineReasonRequired: true,
	currentStateTemplate: null,
	hideCurrentStateChange: true,
	deadline: null,
	prequalificationStatus: PrequalificationStatus.REJECTED
});
var callAttemptFailedOneTimeAutomationTemplate = new ApplicantAutomationTemplate({
	id: "call-attempt-failed-one-time",
	color: "#fdf7d3",
	label: "1 Mal nicht erreicht",
	type: "manual",
	emails: [{ emailTemplateKey: EmailTemplateKey.CALL_ATTEMPT_FAILED_1_TIME }, { emailTemplateKey: EmailTemplateKey.CALL_ATTEMPT_FAILED_1_TIME_TRAINEES_DUAL_STUDENTS }],
	currentStateTemplate: "1"
});
var callAttemptFailedFiveTimesAutomationTemplate = new ApplicantAutomationTemplate({
	id: "call-attempt-failed-five-times",
	label: "5 Mal nicht erreicht",
	type: "manual",
	color: "#fde7d3",
	phaseType: ApplicantPhaseType.NOT_REACHED_STAHLHART,
	currentStateTemplate: "5",
	markApplicantDocumentsAsRead: true,
	prequalificationStatus: PrequalificationStatus.NOT_REACHED
});
var applicantForwardedAutomationTemplate = new ApplicantAutomationTemplate({
	id: "applicant-forwarded",
	label: "Weiterleitung",
	type: "manual",
	color: "#d1f4e0",
	emails: [
		{ emailTemplateKey: EmailTemplateKey.APPLICATION_FORWARDED },
		{ emailTemplateKey: EmailTemplateKey.APPLICATION_FORWARDED_TRAINEES_DUAL_STUDENTS },
		{ emailTemplateKey: EmailTemplateKey.NEW_APPLICANT_PREQUALIFIED }
	],
	phaseType: ApplicantPhaseType.CONTACT_PARTNER,
	forwardedAt: "today",
	currentStateTemplate: null,
	hideCurrentStateChange: true,
	markApplicantDocumentsAsRead: true,
	prequalificationStatus: PrequalificationStatus.APPROVED
});
var disqualifiedAtCallAutomationTemplate = new ApplicantAutomationTemplate({
	id: "disqualified-at-call",
	label: "Am Telefon disqualifiziert",
	type: "manual",
	color: "#fdd0df",
	phaseType: ApplicantPhaseType.REJECTED_STAHLHART,
	declineReasonRequired: true,
	currentStateTemplate: null,
	hideCurrentStateChange: true,
	markApplicantDocumentsAsRead: true,
	prequalificationStatus: PrequalificationStatus.REJECTED
});
var indirectRejectionAutomationTemplate = new ApplicantAutomationTemplate({
	id: "indirect-rejection",
	label: "Indirekte Absage",
	type: "manual",
	color: "#fdd0df",
	emails: [{
		emailTemplateKey: EmailTemplateKey.REJECTION_NOTICE,
		emailSchedule: "2@15:00:00"
	}, {
		emailTemplateKey: EmailTemplateKey.REJECTION_NOTICE_TRAINEES_DUAL_STUDENTS,
		emailSchedule: "2@15:00:00"
	}],
	phaseType: ApplicantPhaseType.REJECTED_STAHLHART,
	declineReasonRequired: true,
	currentStateTemplate: null,
	hideCurrentStateChange: true,
	markApplicantDocumentsAsRead: true,
	prequalificationStatus: PrequalificationStatus.REJECTED
});
var phoneNumberMissingAutomationTemplate = new ApplicantAutomationTemplate({
	id: "phone-number-missing",
	label: "Telefonnummer fehlt/falsch",
	type: "manual",
	color: "#fdf7d3",
	emails: [{ emailTemplateKey: EmailTemplateKey.PHONE_NUMBER_MISSING_INCORRECT }, { emailTemplateKey: EmailTemplateKey.PHONE_NUMBER_MISSING_INCORRECT_TRAINEES_DUAL_STUDENTS }],
	currentStateTemplate: "{{today}} (Richtige) Nummer angefragt",
	markApplicantDocumentsAsRead: true
});
var phoneNumberNotReceivedAutomationTemplate = new ApplicantAutomationTemplate({
	id: "phone-number-not-received",
	label: "(Richtige) Telefonnummer nicht bekommen",
	type: "manual",
	color: "#fde7d3",
	phaseType: ApplicantPhaseType.NOT_REACHED_STAHLHART,
	currentStateTemplate: "(Richtige) Telefonnummer nicht bekommen",
	markApplicantDocumentsAsRead: true,
	prequalificationStatus: PrequalificationStatus.REJECTED
});
var waitingForResumeAutomationTemplate = new ApplicantAutomationTemplate({
	id: "waiting-for-resume",
	label: "Warten auf Lebenslauf",
	type: "manual",
	color: "#d1f4e0",
	emails: [{ emailTemplateKey: EmailTemplateKey.RESUME_SUBMISSION_REQUEST }],
	phaseType: ApplicantPhaseType.WAITING_FOR_DOCUMENTS_STAHLHART,
	currentStateTemplate: "{{today}} Lebenslauf telefonisch angefragt",
	deadline: "move7DaysForward"
});
var applicantRejectedTemplate = new ApplicantAutomationTemplate({
	id: "applicant-rejected",
	label: "Absage vom Bewerber",
	type: "manual",
	color: "#fdd0df",
	phaseType: ApplicantPhaseType.REJECTED_APPLICANT,
	declineReasonRequired: true,
	currentStateTemplate: null,
	hideCurrentStateChange: true,
	deadline: null,
	prequalificationStatus: PrequalificationStatus.REJECTED
});
var applicantRejectedThroughRecruiterTemplate = new ApplicantAutomationTemplate({
	id: "applicant-rejected-through-recruiter",
	label: "Absage vom Bewerber",
	type: "manual",
	color: "#fdd0df",
	phaseType: ApplicantPhaseType.REJECTED_STAHLHART,
	declineReasonRequired: true,
	declineReasonTemplate: "Bewerber hat abgelehnt, weil ",
	currentStateTemplate: null,
	hideCurrentStateChange: true,
	deadline: null,
	prequalificationStatus: PrequalificationStatus.REJECTED
});
var disqualifiedAutomationTemplate = new ApplicantAutomationTemplate({
	id: "disqualified",
	label: "Disqualifizieren",
	type: "manual",
	color: "#fdd0df",
	emails: [{
		emailTemplateKey: EmailTemplateKey.REJECTION_NOTICE,
		emailSchedule: "2@15:00:00"
	}, {
		emailTemplateKey: EmailTemplateKey.REJECTION_NOTICE_TRAINEES_DUAL_STUDENTS,
		emailSchedule: "2@15:00:00"
	}],
	phaseType: ApplicantPhaseType.REJECTED_STAHLHART,
	declineReasonRequired: true,
	currentStateTemplate: null,
	hideCurrentStateChange: true,
	markApplicantDocumentsAsRead: true,
	prequalificationStatus: PrequalificationStatus.REJECTED
});
var waitingForDocumentsAutomationTemplate = new ApplicantAutomationTemplate({
	id: "waiting-for-documents",
	label: "Warten auf Unterlagen",
	type: "manual",
	color: "#d1f4e0",
	emails: [{ emailTemplateKey: EmailTemplateKey.DOCUMENTS_SUBMISSION_REQUEST_TRAINEES_DUAL_STUDENTS }],
	phaseType: ApplicantPhaseType.WAITING_FOR_DOCUMENTS_STAHLHART,
	currentStateTemplate: "{{today}} Unterlagen telefonisch angefragt",
	deadline: "move7DaysForward"
});
var documentsReceivedAutomationTemplate = new ApplicantAutomationTemplate({
	id: "documents-received",
	label: "Unterlagen erhalten",
	type: "manual",
	color: "#d1f4e0",
	emails: [{ emailTemplateKey: EmailTemplateKey.DOCUMENTS_RECEIVED_TRAINEES_DUAL_STUDENTS }, { emailTemplateKey: EmailTemplateKey.NEW_APPLICANT_PREQUALIFIED }],
	currentStateTemplate: null,
	hideCurrentStateChange: true,
	phaseType: ApplicantPhaseType.CONTACT_PARTNER,
	forwardedAt: "today",
	deadline: null,
	markApplicantDocumentsAsRead: true,
	prequalificationStatus: PrequalificationStatus.APPROVED
});
var documentsReminderAutomationTemplate = new ApplicantAutomationTemplate({
	id: "documents-reminder",
	color: "#fdf7d3",
	label: "An Unterlagen erinnern",
	type: "manual",
	emails: [{ emailTemplateKey: EmailTemplateKey.DOCUMENTS_SUBMISSION_REMINDER_TRAINEES_DUAL_STUDENTS }],
	currentStateTemplate: "{{today}} Erinnerung verschickt - {{applicant.currentState}}",
	deadline: "move7DaysForward"
});
var documentsNotReceivedAutomationTemplate = new ApplicantAutomationTemplate({
	id: "documents-not-received",
	color: "#fdd0df",
	label: "Unterlagen nicht erhalten",
	type: "manual",
	phaseType: ApplicantPhaseType.REJECTED_STAHLHART,
	declineReason: "Unterlagen nicht erhalten",
	declineReasonRequired: true,
	currentStateTemplate: null,
	hideCurrentStateChange: true,
	deadline: null,
	prequalificationStatus: PrequalificationStatus.REJECTED
});
/**
* Internal automation templates
*/
var applicantMovedToNotReachedPartner = new ApplicantAutomationTemplate({
	id: "applicant-moved-to-not-reached-partner",
	label: ApplicantPhaseType.NOT_REACHED_PARTNER,
	type: "internal",
	phaseType: ApplicantPhaseType.NOT_REACHED_PARTNER,
	currentStateTemplate: null,
	deadline: null
});
var applicantMovedToRejectedApplicant = new ApplicantAutomationTemplate({
	id: "applicant-moved-to-rejected-applicant",
	label: ApplicantPhaseType.REJECTED_APPLICANT,
	type: "internal",
	phaseType: ApplicantPhaseType.REJECTED_APPLICANT,
	currentStateTemplate: null,
	deadline: null,
	declineReasonRequired: true
});
var applicantMovedToRejectedPartner = new ApplicantAutomationTemplate({
	id: "applicant-moved-to-rejected-partner",
	label: ApplicantPhaseType.REJECTED_PARTNER,
	type: "internal",
	phaseType: ApplicantPhaseType.REJECTED_PARTNER,
	currentStateTemplate: null,
	deadline: null,
	declineReasonRequired: true
});
var applicantMovedToHired = new ApplicantAutomationTemplate({
	id: "applicant-moved-to-hired",
	label: ApplicantPhaseType.HIRED,
	type: "internal",
	phaseType: ApplicantPhaseType.HIRED,
	currentStateTemplate: null,
	markApplicantDocumentsAsRead: true,
	deadline: null
});
var applicantAutomationTemplates = [
	resumeReceivedAutomationTemplate,
	resumeReminderAutomationTemplate,
	resumeIncompleteAutomationTemplate,
	resumeNotReceivedAutomationTemplate,
	callAttemptFailedOneTimeAutomationTemplate,
	callAttemptFailedFiveTimesAutomationTemplate,
	applicantForwardedAutomationTemplate,
	disqualifiedAtCallAutomationTemplate,
	indirectRejectionAutomationTemplate,
	phoneNumberMissingAutomationTemplate,
	phoneNumberNotReceivedAutomationTemplate,
	waitingForResumeAutomationTemplate,
	applicantRejectedTemplate,
	applicantRejectedThroughRecruiterTemplate,
	disqualifiedAutomationTemplate,
	waitingForDocumentsAutomationTemplate,
	documentsReceivedAutomationTemplate,
	documentsReminderAutomationTemplate,
	documentsNotReceivedAutomationTemplate
];
var applicantPhaseMovedAutomationTemplates = [
	applicantMovedToNotReachedPartner,
	applicantMovedToRejectedApplicant,
	applicantMovedToRejectedPartner,
	applicantMovedToHired
];
// source/data/applicant-origins.ts
var importedAndManualApplicantOrigins = [
	ApplicantOrigin.PERSPECTIVE,
	ApplicantOrigin.WL_LANDING_PAGE,
	ApplicantOrigin.MANUAL
];
// source/data/applicant-phases.ts
var internalPhaseTypes = [
	ApplicantPhaseType.CONTACT_STAHLHART,
	ApplicantPhaseType.WAITING_FOR_DOCUMENTS_STAHLHART,
	ApplicantPhaseType.REJECTED_STAHLHART,
	ApplicantPhaseType.NOT_REACHED_STAHLHART
];
var customerPhaseTypes = [
	ApplicantPhaseType.WAITING_FOR_INTERVIEW,
	ApplicantPhaseType.WAITING_FOR_SECOND_INTERVIEW,
	ApplicantPhaseType.SECOND_INTERVIEW_SCHEDULED,
	ApplicantPhaseType.CONTRACT_PENDING,
	ApplicantPhaseType.WAITING_FOR_SIGNATURE
];
var activePhaseTypes = [
	ApplicantPhaseType.CONTACT_STAHLHART,
	ApplicantPhaseType.WAITING_FOR_DOCUMENTS_STAHLHART,
	ApplicantPhaseType.CONTACT_PARTNER,
	ApplicantPhaseType.WAITING_FOR_INTERVIEW,
	ApplicantPhaseType.SECOND_INTERVIEW_SCHEDULED,
	ApplicantPhaseType.WAITING_FOR_SECOND_INTERVIEW,
	ApplicantPhaseType.CONTRACT_PENDING,
	ApplicantPhaseType.WAITING_FOR_SIGNATURE,
	ApplicantPhaseType.HIRED,
	ApplicantPhaseType.TALENT_POOL
];
var endPhaseTypes = [
	ApplicantPhaseType.REJECTED_PARTNER,
	ApplicantPhaseType.REJECTED_STAHLHART,
	ApplicantPhaseType.REJECTED_APPLICANT,
	ApplicantPhaseType.NOT_REACHED_STAHLHART,
	ApplicantPhaseType.NOT_REACHED_PARTNER
];
// source/data/career-mappings.ts
/**
* Enum für alle data-sh-id Werte
*/
var DataShId = /* @__PURE__ */ function(DataShId) {
	DataShId["HeroSection"] = "hero__section";
	DataShId["HeroImage"] = "hero__image";
	DataShId["HeroOverviewImage"] = "hero__overview-image";
	DataShId["HeroText"] = "hero__text";
	DataShId["HeroTitleNamePart"] = "hero__title-name-part";
	DataShId["HeroLocationTagTemplate"] = "hero__location-tag-template";
	DataShId["HeroLocationTag"] = "hero__location-tag";
	DataShId["OverviewCardTemplate"] = "overview__card-template";
	DataShId["OverviewCardEmpty"] = "overview__card-empty";
	DataShId["OverviewCardEmptyForFilter"] = "overview__card-empty-for-filter";
	DataShId["OverviewCard"] = "overview__card";
	DataShId["OverviewCardImage"] = "overview__card-image";
	DataShId["OverviewCardTitle"] = "overview__card-title";
	DataShId["OverviewCardStartAt"] = "overview__card-start-at";
	DataShId["OverviewCardLocation"] = "overview__card-location";
	DataShId["OverviewCardSalary"] = "overview__card-salary";
	DataShId["JobsOverviewSection"] = "jobs-overview-card__section";
	DataShId["TraineeOverviewSection"] = "trainee-overview-card__section";
	DataShId["TraineeVideo"] = "trainee__video";
	DataShId["TraineeVideoSection"] = "azubifilm__section";
	DataShId["PraktikumImage"] = "praktikum__image";
	DataShId["PraktikumSection"] = "praktikum__section";
	DataShId["JobVideoUrl"] = "job__video";
	DataShId["JobVideoSection"] = "arbeitgeberfilm__section";
	DataShId["BenefitsCardTemplate"] = "benefits__card-template";
	DataShId["BenefitsCardParent"] = "benefits__card";
	DataShId["BenefitsCardIcon"] = "benefits__card-icon";
	DataShId["BenefitsCardTitle"] = "benefits__card-title";
	DataShId["BenefitsCardItemTemplate"] = "benefits__card-item-template";
	DataShId["BenefitsCardItemParent"] = "benefits__card-item";
	DataShId["BenefitsCardItemText"] = "benefits__card-item-text";
	DataShId["BenefitsCardSlide"] = "benefits__card-slide";
	DataShId["GalleryImageTemplate"] = "gallery__image-template";
	DataShId["GalleryImageParent"] = "gallery__image";
	DataShId["GalleryImageUrl"] = "gallery__image-url";
	DataShId["GallerySection"] = "gallery__section";
	DataShId["TestimonialsCardTemplate"] = "testimonials__card-template";
	DataShId["TestimonialsCardParent"] = "testimonials__card";
	DataShId["TestimonialsCardImage"] = "testimonials__card-image";
	DataShId["TestimonialsCardName"] = "testimonials__card-name";
	DataShId["TestimonialsCardText"] = "testimonials__card-text";
	DataShId["TestimonialsCardPosition"] = "testimonials__card-position";
	DataShId["TestimonialsCardSlide"] = "testimonials__card-slide";
	DataShId["TestimonialsSection"] = "testimonials__section";
	DataShId["BenefitsSection"] = "benefits__section";
	DataShId["GlobalFactTemplate"] = "global__fact-template";
	DataShId["GlobalFactParent"] = "global__fact";
	DataShId["GlobalFactNumber"] = "global__fact-number";
	DataShId["GlobalFactText"] = "global__fact-text";
	DataShId["AboutUsSection"] = "about-us__section";
	DataShId["GlobalCompanyParent"] = "global__company";
	DataShId["GlobalCompanyVideo"] = "global__company-video";
	DataShId["GlobalCompanyImage"] = "global__company-image";
	DataShId["GlobalGoogleMapsLatitude"] = "global__google-maps-latitude";
	DataShId["GlobalGoogleMapsLongitude"] = "global__google-maps-longitude";
	DataShId["GlobalInstagramWidgetId"] = "global__instagram-widget-id";
	DataShId["GoogleMapSection"] = "google-map__section";
	DataShId["ContactLogo"] = "contact__logo";
	DataShId["ContactTitleNamePart"] = "contact__title-name-part";
	DataShId["ContactEmailAddress"] = "contact__email-address";
	DataShId["ContactPhoneNumber"] = "contact__phone-number";
	DataShId["ContactOpeningHours"] = "contact__opening-hours";
	DataShId["ContactSection"] = "contact__section";
	DataShId["ContactWhatsappNumber"] = "contact__whatsapp-number";
	DataShId["FaqsFaqParent"] = "faqs__faq";
	DataShId["FaqsFaqTemplate"] = "faqs__faq-template";
	DataShId["FaqsFaqQuestion"] = "faqs__faq-question";
	DataShId["FaqsFaqAnswer"] = "faqs__faq-answer";
	DataShId["FaqsSection"] = "faq__section";
	DataShId["SocialMediaInstagramLink"] = "social-media__instagram-link";
	DataShId["SocialMediaFacebookLink"] = "social-media__facebook-link";
	DataShId["SocialMediaLinkedinLink"] = "social-media__linkedin-link";
	DataShId["SocialMediaTiktokLink"] = "social-media__tiktok-link";
	DataShId["SocialMediaKununuLink"] = "social-media__kununu-link";
	DataShId["SocialMediaSection"] = "social-media__section";
	DataShId["CompanyName"] = "company__name";
	DataShId["CompanyDescription"] = "company__description";
	DataShId["CompanySettingsDescription"] = "company-settings__description";
	DataShId["LinkImprint"] = "link__imprint";
	DataShId["LinkPrivacy"] = "link__privacy";
	DataShId["LinkGoToWebsite"] = "link__go-to-website";
	DataShId["HeroStartImage"] = "hero__start-image";
	DataShId["DetailHeroLocation"] = "details-hero__location";
	DataShId["DetailHeroWeeklyHours"] = "details-hero__weeklyhours";
	DataShId["DetailHeroSalary"] = "details-hero__salary";
	DataShId["DetailHeroShiftWork"] = "details-hero__shiftwork";
	DataShId["DetailHeroTitle"] = "details-hero__title";
	DataShId["DetailHeroImage"] = "details-hero__image";
	DataShId["DetailHeroVideo"] = "details-hero__video";
	DataShId["DetailHeroApplicationUrl"] = "details-application__url";
	DataShId["DetailHeroAdditionalApplicationButton"] = "details-application__additional-button";
	DataShId["BenefitDetailList"] = "benefit__list";
	DataShId["BenefitDetailListItem"] = "benefit__list-item";
	DataShId["BenefitDetailListItemText"] = "benefit__list-item-text";
	DataShId["TasksDetailList"] = "tasks__list";
	DataShId["TasksDetailListItem"] = "tasks__list-item";
	DataShId["TasksDetailListItemText"] = "tasks__list-item-text";
	DataShId["TasksDetailImage"] = "tasks__image";
	DataShId["RequirementsDetailList"] = "requirements__list";
	DataShId["RequirementsDetailListItem"] = "requirements__list-item";
	DataShId["RequirementsDetailListItemText"] = "requirements__list-item-text";
	DataShId["RequirementsDetailImage"] = "requirements__image";
	DataShId["HeroSpecialization"] = "details-hero__specialization";
	DataShId["HeroStartDate"] = "details-hero__start-date";
	DataShId["HeroTrainingDuration"] = "details-hero__training-duration";
	DataShId["HeroFlexibleInternship"] = "details-hero__flexible-internship";
	DataShId["HeroSalaryFirstYear"] = "details-hero__salary-first-year";
	DataShId["HeroSalarySecondYear"] = "details-hero__salary-second-year";
	DataShId["HeroSalaryThirdYear"] = "details-hero__salary-third-year";
	DataShId["HeroSalaryFourthYear"] = "details-hero__salary-fourth-year";
	DataShId["HeroSalaryDualStudent"] = "details-hero__salary-dual-student";
	DataShId["HeroUniversity"] = "details-hero__university";
	DataShId["NavigationSection"] = "navigation__section";
	DataShId["FooterSection"] = "footer__section";
	DataShId["GeneralPagesAusbildungen"] = "general__pages-ausbildungen";
	DataShId["DetailsHeroSection"] = "details__hero__section";
	DataShId["DetailsBenefitsSection"] = "details__benefits__section";
	DataShId["DetailsProfileSection"] = "details__profile__section";
	DataShId["DetailsApplicationFormSection"] = "details__application__form__section";
	DataShId["DetailsTasksSection"] = "details__tasks__section";
	DataShId["CookieBannerSection"] = "cookie-banner__section";
	DataShId["FormLoadingSpinner"] = "form__loading-spinner";
	DataShId["PositionsFilterDropdown"] = "form__positions-filter-dropdown";
	DataShId["Logo"] = "logo";
	DataShId["BgImage"] = "bg-image";
	DataShId["ContactFemaleSuffix1"] = "contact__female-suffix-1";
	DataShId["ContactFemaleSuffix2"] = "contact__female-suffix-2";
	return DataShId;
}({});
/**
* Mapping: data-sh-id → JSON-Pfad
*/
var dataShIdToJsonPath = {
	["hero__section"]: "",
	["hero__image"]: "career.trainees.introduction.logo",
	["hero__overview-image"]: "career.trainees.introduction.logo",
	["hero__text"]: "career.trainees.introduction.text",
	["hero__title-name-part"]: "company.shortName",
	["hero__location-tag-template"]: "jobPositions[]",
	["hero__location-tag"]: "",
	["overview__card-template"]: "jobPositions[]",
	["overview__card"]: "jobPositions",
	["overview__card-empty"]: "",
	["overview__card-empty-for-filter"]: "",
	["overview__card-image"]: "",
	["overview__card-title"]: "",
	["overview__card-start-at"]: "",
	["overview__card-location"]: "",
	["overview__card-salary"]: "",
	["jobs-overview-card__section"]: "",
	["trainee-overview-card__section"]: "",
	["trainee__video"]: "career.trainees.videoUrl",
	["azubifilm__section"]: "",
	["praktikum__image"]: "career.trainees.internshipLogo",
	["praktikum__section"]: "",
	["job__video"]: "career.jobs.videoUrl",
	["arbeitgeberfilm__section"]: "",
	["testimonials__card-template"]: "career.trainees.testimonials[]",
	["testimonials__card"]: "career.trainees.testimonials",
	["testimonials__card-image"]: "",
	["testimonials__card-name"]: "",
	["testimonials__card-text"]: "",
	["testimonials__card-position"]: "",
	["testimonials__card-slide"]: "career.trainees.testimonials[]",
	["testimonials__section"]: "",
	["benefits__card-template"]: "career.trainees.benefits[]",
	["benefits__card"]: "career.trainees.benefits",
	["benefits__card-icon"]: "",
	["benefits__card-title"]: "",
	["benefits__card-item-template"]: "",
	["benefits__card-item"]: "",
	["benefits__card-item-text"]: "",
	["benefits__card-slide"]: "career.trainees.benefits[]",
	["benefits__section"]: "",
	["gallery__image-template"]: "career.trainees.images[]",
	["gallery__image"]: "career.trainees.images",
	["gallery__image-url"]: "",
	["global__fact-template"]: "career.global.facts[]",
	["global__fact"]: "",
	["global__fact-number"]: "career.global.facts[].value",
	["global__fact-text"]: "career.global.facts[].text",
	["global__company-video"]: "career.global.companyVideo.mediaUrl",
	["global__company"]: "career.global",
	["global__company-image"]: "career.global.companyImage.mediaUrl",
	["global__google-maps-latitude"]: "career.global.googleMaps.latitude",
	["global__google-maps-longitude"]: "career.global.googleMaps.longitude",
	["global__instagram-widget-id"]: "career.global.instagramWidgetId",
	["contact__logo"]: "career.trainees.contacts.logo",
	["contact__title-name-part"]: "career.trainees.contacts.name",
	["contact__email-address"]: "career.trainees.contacts.email",
	["contact__phone-number"]: "career.trainees.contacts.phone",
	["contact__opening-hours"]: "career.trainees.contacts.openingHours",
	["contact__whatsapp-number"]: "career.trainees.contacts.whatsappNumber",
	["faqs__faq"]: "",
	["faqs__faq-template"]: "career.trainees.faq[]",
	["faqs__faq-question"]: "career.trainees.faq[].question",
	["faqs__faq-answer"]: "career.trainees.faq[].answer",
	["faq__section"]: "",
	["social-media__instagram-link"]: "company.instagramLink",
	["social-media__facebook-link"]: "company.facebookLink",
	["social-media__linkedin-link"]: "company.linkedinLink",
	["social-media__tiktok-link"]: "company.tiktokLink",
	["social-media__kununu-link"]: "company.kununuLink",
	["company__name"]: "company.longName",
	["company__description"]: "company.description",
	["company-settings__description"]: "company.description",
	["details-hero__location"]: "",
	["details-hero__weeklyhours"]: "",
	["details-hero__salary"]: "",
	["details-hero__shiftwork"]: "",
	["details-hero__title"]: "",
	["details-hero__image"]: "",
	["details-hero__video"]: "",
	["details-application__url"]: "",
	["details-application__additional-button"]: "",
	["benefit__list"]: "",
	["benefit__list-item"]: "",
	["benefit__list-item-text"]: "",
	["tasks__list"]: "",
	["tasks__list-item"]: "",
	["tasks__list-item-text"]: "",
	["tasks__image"]: "",
	["requirements__list"]: "",
	["requirements__list-item"]: "",
	["requirements__list-item-text"]: "",
	["requirements__image"]: "",
	["details-hero__specialization"]: "",
	["details-hero__start-date"]: "",
	["details-hero__training-duration"]: "",
	["details-hero__flexible-internship"]: "",
	["details-hero__salary-first-year"]: "",
	["details-hero__salary-second-year"]: "",
	["details-hero__salary-third-year"]: "",
	["details-hero__salary-fourth-year"]: "",
	["details-hero__salary-dual-student"]: "",
	["details-hero__university"]: "",
	["link__imprint"]: "company.imprint",
	["link__privacy"]: "company.privacy",
	["link__go-to-website"]: "company.websiteUrl",
	["hero__start-image"]: "career.general.selectionPageImage",
	["navigation__section"]: "",
	["footer__section"]: "",
	["general__pages-ausbildungen"]: "",
	["cookie-banner__section"]: "",
	["logo"]: "career.design.careerPageLogo",
	["bg-image"]: "career.design.background.image",
	["contact__female-suffix-1"]: "",
	["contact__female-suffix-2"]: "",
	["details__hero__section"]: "",
	["details__benefits__section"]: "",
	["details__profile__section"]: "",
	["details__application__form__section"]: "",
	["details__tasks__section"]: "",
	["form__loading-spinner"]: "",
	["form__positions-filter-dropdown"]: "",
	["gallery__section"]: "",
	["contact__section"]: "",
	["google-map__section"]: "",
	["social-media__section"]: "",
	["about-us__section"]: ""
};
// source/data/career-settings.ts
var COLORS = {
	background: {
		color: "#000000",
		text: "Hintergrund"
	},
	foreground: {
		color: "#FFFFFF",
		text: "Text"
	},
	accent: {
		color: "#FFFFFF",
		text: "Akzent"
	},
	title: {
		color: "#FFFFFF",
		text: "Überschrift"
	},
	titleAccent: {
		color: "#FFFFFF",
		text: "Überschrift Akzent"
	},
	button: {
		color: "#FFFFFF",
		text: "Button"
	},
	colorOnButton: {
		color: "#000000",
		text: "Text auf Button"
	},
	map: {
		color: "#FFFFFF",
		text: "Karte"
	},
	textOnMap: {
		color: "#000000",
		text: "Text auf Karte"
	},
	accentOnMap: {
		color: "#000000",
		text: "Akzent auf Karte"
	}
};
var INVERTED_COLORS = {
	background: {
		color: "#FFFFFF",
		text: "Hintergrund"
	},
	foreground: {
		color: "#000000",
		text: "Text"
	},
	accent: {
		color: "#000000",
		text: "Akzent"
	},
	title: {
		color: "#000000",
		text: "Überschrift"
	},
	titleAccent: {
		color: "#000000",
		text: "Überschrift Akzent"
	},
	button: {
		color: "#000000",
		text: "Button"
	},
	colorOnButton: {
		color: "#FFFFFF",
		text: "Text auf Button"
	},
	map: {
		color: "#000000",
		text: "Karte"
	},
	textOnMap: {
		color: "#FFFFFF",
		text: "Text auf Karte"
	},
	accentOnMap: {
		color: "#FFFFFF",
		text: "Akzent auf Karte"
	}
};
var InitialCareerFormValues = {
	isActive: false,
	publishStatus: CareerPagePublishStatus.DRAFT,
	publish: { status: "jobs" },
	general: {
		pages: [
			{
				id: "jobs",
				title: "Jobs",
				isActive: true,
				required: true
			},
			{
				id: "trainee",
				title: "Ausbildung",
				isActive: false,
				required: false
			},
			{
				id: "job-details",
				title: "Job Details",
				isActive: true,
				required: false
			},
			{
				id: "trainee-details",
				title: "Ausbildung Details",
				isActive: true,
				required: false
			},
			{
				id: "home",
				title: "Startseite",
				isActive: true,
				required: false
			},
			{
				id: "thank-you",
				title: "Dankesseite",
				isActive: true,
				required: false
			},
			{
				id: "global",
				title: "Global",
				isActive: true,
				required: true
			}
		],
		sections: [
			{
				id: "cookieBanner",
				title: "Cookie Banner",
				isActive: true,
				pageId: "global",
				required: true,
				theme: "theme-a"
			},
			{
				id: "navigation",
				title: "Navigation",
				isActive: true,
				pageId: "jobs",
				required: true
			},
			{
				id: "hero",
				title: "Hero",
				isActive: true,
				pageId: "jobs",
				required: true
			},
			{
				id: "offeneStellen",
				title: "Offene Stellen",
				isActive: true,
				pageId: "jobs",
				required: true
			},
			{
				id: "arbeitgeberfilm",
				title: "Arbeitgeberfilm",
				isActive: false,
				pageId: "jobs",
				required: false
			},
			{
				id: "vorteile",
				title: "Vorteile/Benefits",
				isActive: false,
				pageId: "jobs",
				required: false
			},
			{
				id: "testimonials",
				title: "Testimonials",
				isActive: false,
				pageId: "jobs",
				required: false
			},
			{
				id: "bilder",
				title: "Bilder",
				isActive: false,
				pageId: "jobs",
				required: false
			},
			{
				id: "unternehmensvorstellung",
				title: "Unternehmensvorstellung",
				isActive: true,
				pageId: "jobs",
				required: true
			},
			{
				id: "googleMaps",
				title: "Google Maps",
				isActive: false,
				pageId: "jobs",
				required: false
			},
			{
				id: "instagramFeed",
				title: "Instagram Feed",
				isActive: false,
				pageId: "jobs",
				required: false
			},
			{
				id: "ansprechpartner",
				title: "Ansprechpartner",
				isActive: false,
				pageId: "jobs",
				required: false
			},
			{
				id: "faq",
				title: "Faq",
				isActive: false,
				pageId: "jobs",
				required: false
			},
			{
				id: "footer",
				title: "Footer",
				isActive: true,
				pageId: "jobs",
				required: true
			},
			{
				id: "navigation",
				title: "Navigation",
				isActive: true,
				pageId: "trainee",
				required: true
			},
			{
				id: "hero",
				title: "Hero",
				isActive: true,
				pageId: "trainee",
				required: true
			},
			{
				id: "offeneAusbildungen",
				title: "Offene Ausbildungen",
				isActive: true,
				pageId: "trainee",
				required: true
			},
			{
				id: "praktikum",
				title: "Praktikum flexibel möglich",
				isActive: false,
				pageId: "trainee",
				required: false
			},
			{
				id: "azubifilm",
				title: "Azubifilm",
				isActive: false,
				pageId: "trainee",
				required: false
			},
			{
				id: "vorteile",
				title: "Vorteile/Benefits",
				isActive: false,
				pageId: "trainee",
				required: false
			},
			{
				id: "testimonials",
				title: "Testimonials",
				isActive: false,
				pageId: "trainee",
				required: false
			},
			{
				id: "bilder",
				title: "Bilder",
				isActive: false,
				pageId: "trainee",
				required: false
			},
			{
				id: "unternehmensvorstellung",
				title: "Unternehmensvorstellung",
				isActive: true,
				pageId: "trainee",
				required: true
			},
			{
				id: "googleMaps",
				title: "Google Maps",
				isActive: false,
				pageId: "trainee",
				required: false
			},
			{
				id: "instagramFeed",
				title: "Instagram Feed",
				isActive: false,
				pageId: "trainee",
				required: false
			},
			{
				id: "ansprechpartner",
				title: "Ansprechpartner",
				isActive: false,
				pageId: "trainee",
				required: false
			},
			{
				id: "faq",
				title: "Faq",
				isActive: false,
				pageId: "trainee",
				required: false
			},
			{
				id: "footer",
				title: "Footer",
				isActive: true,
				pageId: "trainee",
				required: true
			},
			{
				id: "navigation",
				title: "Navigation",
				isActive: true,
				pageId: "job-details",
				required: true
			},
			{
				id: "hero",
				title: "Hero",
				isActive: true,
				pageId: "job-details",
				required: true
			},
			{
				id: "detailsBenefits",
				title: "Benefits",
				isActive: true,
				pageId: "job-details",
				required: true
			},
			{
				id: "detailsTasks",
				title: "Tasks",
				isActive: true,
				pageId: "job-details",
				required: true
			},
			{
				id: "detailsProfile",
				title: "Profile",
				isActive: true,
				pageId: "job-details",
				required: true
			},
			{
				id: "applicationForm",
				title: "Application Form",
				isActive: true,
				pageId: "job-details",
				required: true
			},
			{
				id: "footer",
				title: "Footer",
				isActive: true,
				pageId: "job-details",
				required: true
			},
			{
				id: "navigation",
				title: "Navigation",
				isActive: true,
				pageId: "trainee-details",
				required: true
			},
			{
				id: "hero",
				title: "Hero",
				isActive: true,
				pageId: "trainee-details",
				required: true
			},
			{
				id: "detailsBenefits",
				title: "Benefits",
				isActive: true,
				pageId: "trainee-details",
				required: true
			},
			{
				id: "detailsTasks",
				title: "Tasks",
				isActive: true,
				pageId: "trainee-details",
				required: true
			},
			{
				id: "detailsProfile",
				title: "Profile",
				isActive: true,
				pageId: "trainee-details",
				required: true
			},
			{
				id: "applicationForm",
				title: "Application Form",
				isActive: true,
				pageId: "trainee-details",
				required: true
			},
			{
				id: "footer",
				title: "Footer",
				isActive: true,
				pageId: "trainee-details",
				required: true
			},
			{
				id: "navigation",
				title: "Navigation",
				isActive: true,
				pageId: "home",
				required: true
			},
			{
				id: "hero",
				title: "Hero",
				isActive: true,
				pageId: "home",
				required: true
			},
			{
				id: "footer",
				title: "Footer",
				isActive: true,
				pageId: "home",
				required: true
			},
			{
				id: "navigation",
				title: "Navigation",
				isActive: true,
				pageId: "thank-you",
				required: true
			},
			{
				id: "hero",
				title: "Hero",
				isActive: true,
				pageId: "thank-you",
				required: true
			},
			{
				id: "footer",
				title: "Footer",
				isActive: true,
				pageId: "thank-you",
				required: true
			}
		],
		selectionPageText: "",
		selectionPageImage: "",
		isWorkAreasActive: false,
		isTraineeWorkAreasActive: false,
		isExternalApplicationActive: false
	},
	design: {
		logo: "",
		careerPageLogo: "",
		googleJobsLogo: "",
		favicon: "",
		borderRadiusButtons: "none",
		borderRadiusCards: "none",
		headers: {
			uppercase: false,
			italic: false,
			colored: false
		},
		colors: {
			sectionA: {
				...COLORS,
				isActive: true
			},
			sectionB: {
				...INVERTED_COLORS,
				isActive: true
			},
			sectionC: {
				...COLORS,
				isActive: false
			},
			sectionD: {
				...INVERTED_COLORS,
				isActive: false
			},
			sectionE: {
				...COLORS,
				isActive: false
			},
			general: {
				specialColor: {
					color: "#000000",
					text: "Sonderfarbe"
				},
				isActive: true
			}
		},
		background: { image: "" },
		shareImage: ""
	},
	global: {
		googleMapsUrl: "",
		enableMultipleLocations: false,
		companyImage: {
			active: true,
			mediaUrl: ""
		},
		companyVideo: {
			active: false,
			mediaUrl: ""
		},
		instagramUsername: "",
		facts: []
	},
	trainees: {
		introduction: {
			text: "",
			logo: ""
		},
		videoUrl: "",
		internshipLogo: "",
		benefits: [],
		testimonials: [],
		faq: [],
		isUnsolicitedJobsActive: false,
		unsolicitedJobEmailRecipients: [],
		unsolicitedJobExternalApplicationUrl: "",
		contacts: {
			name: "",
			openingHours: "Mo. bis Fr. 8 - 16 Uhr",
			email: "",
			phone: "",
			logo: "",
			whatsappNumber: ""
		},
		images: [
			{
				id: 1,
				imageUrl: ""
			},
			{
				id: 2,
				imageUrl: ""
			},
			{
				id: 3,
				imageUrl: ""
			},
			{
				id: 4,
				imageUrl: ""
			},
			{
				id: 5,
				imageUrl: ""
			},
			{
				id: 6,
				imageUrl: ""
			},
			{
				id: 7,
				imageUrl: ""
			},
			{
				id: 8,
				imageUrl: ""
			}
		]
	},
	jobs: {
		introduction: {
			text: "",
			logo: ""
		},
		videoUrl: "",
		internshipLogo: "",
		benefits: [],
		testimonials: [],
		faq: [],
		isUnsolicitedJobsActive: false,
		unsolicitedJobEmailRecipients: [],
		unsolicitedJobExternalApplicationUrl: "",
		contacts: {
			name: "",
			openingHours: "Mo. bis Fr. 8 - 16 Uhr",
			email: "",
			phone: "",
			logo: "",
			whatsappNumber: ""
		},
		images: [
			{
				id: 1,
				imageUrl: ""
			},
			{
				id: 2,
				imageUrl: ""
			},
			{
				id: 3,
				imageUrl: ""
			},
			{
				id: 4,
				imageUrl: ""
			},
			{
				id: 5,
				imageUrl: ""
			},
			{
				id: 6,
				imageUrl: ""
			},
			{
				id: 7,
				imageUrl: ""
			},
			{
				id: 8,
				imageUrl: ""
			}
		]
	}
};
// source/data/customer-email-signature.ts
var defaultEmailSignature = {
	name: "Standard",
	signature: "Mit freundlichen Grüßen",
	type: EmailContentType.HTML
};
// source/data/customer-email-template.ts
var genericRejectionBeforeInterview = {
	type: EmailContentType.HTML,
	key: "generic-rejection-before-interview",
	name: "Generische Absage vor Gespräch",
	subject: "Ihre Bewerbung bei XY",
	body: "<p>Hallo {{bewerberName}},</p><p>vielen Dank für Ihre Bewerbung und Ihr Interesse an einer Anstellung in unserem Unternehmen.</p><p>Da uns eine Vielzahl an qualifizierten Bewerbungen erreicht hat, müssen wir Ihnen leider mitteilen, dass wir Ihre Bewerbung in der engeren Auswahl nicht weiter berücksichtigen können.</p><p>Wir wünschen Ihnen für den weiteren beruflichen Weg alles Gute und viel Erfolg.</p>"
};
var genericRejectionAfterInterview = {
	type: EmailContentType.HTML,
	key: "generic-rejection-after-interview",
	name: "Generische Absage nach Gespräch",
	subject: "Ihre Bewerbung bei XY",
	body: "<p>Hallo {{bewerberName}},</p><p>vielen Dank, dass Sie sich die Zeit für ein Gespräch bei uns genommen haben.</p><p>Da uns eine Vielzahl an qualifizierten Bewerbungen erreicht hat, müssen wir Ihnen leider mitteilen, dass wir Ihre Bewerbung in der weiteren Auswahl nicht weiter berücksichtigen können.</p><p>Wir wünschen Ihnen für den weiteren beruflichen Weg alles Gute und viel Erfolg.</p>"
};
var callAttemptFailedOneTime = {
	type: EmailContentType.HTML,
	key: "call-attempt-failed-one-time",
	name: "Telefonisch 1 Mal nicht erreicht",
	subject: "Telefonische Erreichbarkeit | Bewerbung bei XY",
	body: "<p>Hallo {{bewerberName}},</p><p>ich habe Sie telefonisch gerade leider verpasst.</p><p>Gibt es bestimmte Zeiten, zu denen Sie besser zu erreichen sind?</p><p>Unter meiner Nummer bin ich leider nicht für Rückrufe verfügbar. Ich werde es bei Ihnen die Tage aber nochmal probieren.</p><p>Über eine kurze Rückmeldung von Ihnen würde ich mich sehr freuen!</p>"
};
var talentPoolPermissionRequest = {
	type: EmailContentType.HTML,
	key: "talent-pool-permission-request",
	name: "Erlaubnis für Talentpool",
	subject: "Aufnahme in unseren Talentpool | Bewerbung bei XY",
	body: "<p>Hallo {{bewerberName}},</p><p>vielen Dank für Ihre Bewerbung und Ihr Interesse. Die Stelle, auf die Sie sich beworben haben, ist mittlerweile leider besetzt.</p><p>Da wir Ihr Profil jedoch als sehr passend empfinden und in diesem Bereich voraussichtlich weitere Vakanzen entstehen werden, möchten wir Sie gerne in unseren Talentpool aufnehmen. So können wir Sie bei einer passenden zukünftigen Stelle direkt berücksichtigen und kontaktieren.</p><p>Bitte lassen Sie uns kurz wissen, ob wir Ihre Daten hierfür speichern dürfen.</p>"
};
var introductoryMeetingConfirmation = {
	type: EmailContentType.HTML,
	key: "introductory-meeting-confirmation",
	name: "Bestätigung Kennenlerngespräch",
	subject: "Bestätigung Ihres Kennenlerngesprächs | Bewerbung bei XY",
	body: "<p>Hallo {{bewerberName}},</p><p>wie telefonisch vereinbart, bestätigen wir Ihnen hiermit Ihr Kennenlerngespräch.</p><p>Datum: XY<br>Uhrzeit: XY<br>Adresse: XY</p><p>Bitte rufen Sie mich unter XY an, sobald Sie vor Ort sind.</p><p>Wir freuen uns auf das Gespräch mit Ihnen.</p>"
};
var automaticJobCareerPageReceiptConfirmation = {
	type: EmailContentType.HTML,
	key: "automatic-job-career-page-receipt-confirmation",
	name: "Automatische Eingangsbestätigung für die Karriereseite (Jobs)",
	subject: "",
	body: ""
};
var automaticTraineeAndDualStudentCareerPageReceiptConfirmation = {
	type: EmailContentType.HTML,
	key: "automatic-trainee-and-dual-student-career-page-receipt-confirmation",
	name: "Automatische Eingangsbestätigung für die Karriereseite (Azubis & Duale Studenten)",
	subject: "",
	body: ""
};
// source/data/email.ts
var emptyEmailBody = "<p></p>";
// source/data/emails.ts
var customerEmailContextKeys = { bewerberName: "Vollständiger Name des Bewerbers" };
// source/data/gender.ts
var genderOptions = [{
	name: "Weiblich",
	id: Gender.FEMALE
}, {
	name: "Männlich",
	id: Gender.MALE
}];
// source/data/iso-3166-map.ts
var iso3166Map = {
	"AD-02": "Canillo",
	"AD-03": "Encamp",
	"AD-04": "La Massana",
	"AD-05": "Ordino",
	"AD-06": "Sant Julia de Loria",
	"AD-07": "Andorra la Vella",
	"AD-08": "Escaldes-Engordany",
	"AE-AJ": "'Ajman",
	"AE-AZ": "Abu Zaby",
	"AE-DU": "Dubayy",
	"AE-FU": "Al Fujayrah",
	"AE-RK": "Ra's al Khaymah",
	"AE-SH": "Ash Shariqah",
	"AE-UQ": "Umm al Qaywayn",
	"AF-BAL": "Balkh",
	"AF-BAM": "Bamyan",
	"AF-BDG": "Badghis",
	"AF-BGL": "Baghlan",
	"AF-DAY": "Daykundi",
	"AF-FRA": "Farah",
	"AF-FYB": "Faryab",
	"AF-GHA": "Ghazni",
	"AF-GHO": "Ghor",
	"AF-HEL": "Helmand",
	"AF-HER": "Herat",
	"AF-JOW": "Jowzjan",
	"AF-KAB": "Kabul",
	"AF-KAN": "Kandahar",
	"AF-KDZ": "Kunduz",
	"AF-KHO": "Khost",
	"AF-LAG": "Laghman",
	"AF-LOG": "Logar",
	"AF-NAN": "Nangarhar",
	"AF-NIM": "Nimroz",
	"AF-PAN": "Panjshayr",
	"AF-PAR": "Parwan",
	"AF-PIA": "Paktiya",
	"AF-PKA": "Paktika",
	"AF-SAM": "Samangan",
	"AF-SAR": "Sar-e Pul",
	"AF-TAK": "Takhar",
	"AF-URU": "Uruzgan",
	"AG-03": "Saint George",
	"AG-04": "Saint John",
	"AG-05": "Saint Mary",
	"AG-07": "Saint Peter",
	"AG-08": "Saint Philip",
	"AG-10": "Barbuda",
	"AG-11": "Redonda",
	"AL-01": "Berat",
	"AL-02": "Durres",
	"AL-03": "Elbasan",
	"AL-04": "Fier",
	"AL-05": "Gjirokaster",
	"AL-06": "Korce",
	"AL-07": "Kukes",
	"AL-08": "Lezhe",
	"AL-09": "Diber",
	"AL-10": "Shkoder",
	"AL-11": "Tirane",
	"AL-12": "Vlore",
	"AM-AG": "Aragacotn",
	"AM-AR": "Ararat",
	"AM-AV": "Armavir",
	"AM-ER": "Erevan",
	"AM-GR": "Gegark'unik'",
	"AM-KT": "Kotayk'",
	"AM-LO": "Lori",
	"AM-SH": "Sirak",
	"AM-SU": "Syunik'",
	"AM-TV": "Tavus",
	"AM-VD": "Vayoc Jor",
	"AO-BGO": "Bengo",
	"AO-BGU": "Benguela",
	"AO-BIE": "Bie",
	"AO-CAB": "Cabinda",
	"AO-CCU": "Cuando Cubango",
	"AO-CNN": "Cunene",
	"AO-CNO": "Cuanza-Norte",
	"AO-CUS": "Cuanza-Sul",
	"AO-HUA": "Huambo",
	"AO-HUI": "Huila",
	"AO-LNO": "Lunda-Norte",
	"AO-LSU": "Lunda-Sul",
	"AO-LUA": "Luanda",
	"AO-MAL": "Malange",
	"AO-MOX": "Moxico",
	"AO-NAM": "Namibe",
	"AO-UIG": "Uige",
	"AO-ZAI": "Zaire",
	"AR-A": "Salta",
	"AR-B": "Buenos Aires",
	"AR-C": "Ciudad Autonoma de Buenos Aires",
	"AR-D": "San Luis",
	"AR-E": "Entre Rios",
	"AR-F": "La Rioja",
	"AR-G": "Santiago del Estero",
	"AR-H": "Chaco",
	"AR-J": "San Juan",
	"AR-K": "Catamarca",
	"AR-L": "La Pampa",
	"AR-M": "Mendoza",
	"AR-N": "Misiones",
	"AR-P": "Formosa",
	"AR-Q": "Neuquen",
	"AR-R": "Rio Negro",
	"AR-S": "Santa Fe",
	"AR-T": "Tucuman",
	"AR-U": "Chubut",
	"AR-V": "Tierra del Fuego",
	"AR-W": "Corrientes",
	"AR-X": "Cordoba",
	"AR-Y": "Jujuy",
	"AR-Z": "Santa Cruz",
	"AT-1": "Burgenland",
	"AT-2": "Karnten",
	"AT-3": "Niederosterreich",
	"AT-4": "Oberosterreich",
	"AT-5": "Salzburg",
	"AT-6": "Steiermark",
	"AT-7": "Tirol",
	"AT-8": "Vorarlberg",
	"AT-9": "Wien",
	"AU-ACT": "Australian Capital Territory",
	"AU-NSW": "New South Wales",
	"AU-NT": "Northern Territory",
	"AU-QLD": "Queensland",
	"AU-SA": "South Australia",
	"AU-TAS": "Tasmania",
	"AU-VIC": "Victoria",
	"AU-WA": "Western Australia",
	"AZ-ABS": "Abseron",
	"AZ-AGA": "Agstafa",
	"AZ-AGC": "Agcabadi",
	"AZ-AGS": "Agdas",
	"AZ-AGU": "Agsu",
	"AZ-AST": "Astara",
	"AZ-BA": "Baki",
	"AZ-BAL": "Balakan",
	"AZ-BAR": "Barda",
	"AZ-BEY": "Beylaqan",
	"AZ-BIL": "Bilasuvar",
	"AZ-DAS": "Daskasan",
	"AZ-FUZ": "Fuzuli",
	"AZ-GA": "Ganca",
	"AZ-GAD": "Gadabay",
	"AZ-GOY": "Goycay",
	"AZ-GYG": "Goygol",
	"AZ-IMI": "Imisli",
	"AZ-ISM": "Ismayilli",
	"AZ-KUR": "Kurdamir",
	"AZ-LA": "Lankaran",
	"AZ-MAS": "Masalli",
	"AZ-MI": "Mingacevir",
	"AZ-NA": "Naftalan",
	"AZ-NEF": "Neftcala",
	"AZ-NX": "Naxcivan",
	"AZ-OGU": "Oguz",
	"AZ-QAB": "Qabala",
	"AZ-QAX": "Qax",
	"AZ-QAZ": "Qazax",
	"AZ-QBA": "Quba",
	"AZ-QUS": "Qusar",
	"AZ-SAB": "Sabirabad",
	"AZ-SAK": "Saki",
	"AZ-SAL": "Salyan",
	"AZ-SAT": "Saatli",
	"AZ-SIY": "Siyazan",
	"AZ-SKR": "Samkir",
	"AZ-SM": "Sumqayit",
	"AZ-SMI": "Samaxi",
	"AZ-SMX": "Samux",
	"AZ-SR": "Sirvan",
	"AZ-TAR": "Tartar",
	"AZ-TOV": "Tovuz",
	"AZ-UCA": "Ucar",
	"AZ-XAC": "Xacmaz",
	"AZ-XIZ": "Xizi",
	"AZ-YAR": "Yardimli",
	"AZ-YEV": "Yevlax",
	"AZ-ZAQ": "Zaqatala",
	"AZ-ZAR": "Zardab",
	"BA-BIH": "Federacija Bosne i Hercegovine",
	"BA-BRC": "Brcko distrikt",
	"BA-SRP": "Republika Srpska",
	"BB-01": "Christ Church",
	"BB-02": "Saint Andrew",
	"BB-03": "Saint George",
	"BB-04": "Saint James",
	"BB-05": "Saint John",
	"BB-07": "Saint Lucy",
	"BB-08": "Saint Michael",
	"BB-09": "Saint Peter",
	"BB-10": "Saint Philip",
	"BB-11": "Saint Thomas",
	"BD-A": "Barishal",
	"BD-B": "Chattogram",
	"BD-C": "Dhaka",
	"BD-D": "Khulna",
	"BD-E": "Rajshahi",
	"BD-F": "Rangpur",
	"BD-G": "Sylhet",
	"BD-H": "Mymensingh",
	"BD-01": "Bandarban",
	"BD-02": "Barguna",
	"BD-03": "Bogura",
	"BD-04": "Brahmanbaria",
	"BD-05": "Bagerhat",
	"BD-06": "Barishal",
	"BD-07": "Bhola",
	"BD-08": "Cumilla",
	"BD-09": "Chandpur",
	"BD-10": "Chattogram",
	"BD-11": "Cox's Bazar",
	"BD-12": "Chuadanga",
	"BD-13": "Dhaka",
	"BD-14": "Dinajpur",
	"BD-15": "Faridpur",
	"BD-16": "Feni",
	"BD-17": "Gopalganj",
	"BD-18": "Gazipur",
	"BD-19": "Gaibandha",
	"BD-20": "Habiganj",
	"BD-21": "Jamalpur",
	"BD-22": "Jashore",
	"BD-23": "Jhenaidah",
	"BD-24": "Joypurhat",
	"BD-25": "Jhalakathi",
	"BD-26": "Kishoreganj",
	"BD-27": "Khulna",
	"BD-28": "Kurigram",
	"BD-29": "Khagrachhari",
	"BD-30": "Kushtia",
	"BD-31": "Lakshmipur",
	"BD-32": "Lalmonirhat",
	"BD-33": "Manikganj",
	"BD-34": "Mymensingh",
	"BD-35": "Munshiganj",
	"BD-36": "Madaripur",
	"BD-37": "Magura",
	"BD-38": "Moulvibazar",
	"BD-39": "Meherpur",
	"BD-40": "Narayanganj",
	"BD-41": "Netrakona",
	"BD-42": "Narsingdi",
	"BD-43": "Narail",
	"BD-44": "Natore",
	"BD-45": "Chapai Nawabganj",
	"BD-46": "Nilphamari",
	"BD-47": "Noakhali",
	"BD-48": "Naogaon",
	"BD-49": "Pabna",
	"BD-50": "Pirojpur",
	"BD-51": "Patuakhali",
	"BD-52": "Panchagarh",
	"BD-53": "Rajbari",
	"BD-54": "Rajshahi",
	"BD-55": "Rangpur",
	"BD-56": "Rangamati",
	"BD-57": "Sherpur",
	"BD-58": "Satkhira",
	"BD-59": "Sirajganj",
	"BD-60": "Sylhet",
	"BD-61": "Sunamganj",
	"BD-62": "Shariatpur",
	"BD-63": "Tangail",
	"BD-64": "Thakurgaon",
	"BE-BRU": "Brussels Hoofdstedelijk Gewest",
	"BE-VLG": "Vlaams Gewest",
	"BE-WAL": "Waals Gewest",
	"BE-VAN": "Antwerpen",
	"BE-VBR": "Vlaams-Brabant",
	"BE-VLI": "Limburg",
	"BE-VOV": "Oost-Vlaanderen",
	"BE-VWV": "West-Vlaanderen",
	"BE-WBR": "Brabant wallon",
	"BE-WHT": "Hainaut",
	"BE-WLG": "Liege",
	"BE-WLX": "Luxembourg",
	"BE-WNA": "Namur",
	"BF-BAL": "Bale",
	"BF-BAM": "Bam",
	"BF-BAN": "Banwa",
	"BF-BAZ": "Bazega",
	"BF-BGR": "Bougouriba",
	"BF-BLG": "Boulgou",
	"BF-BLK": "Boulkiemde",
	"BF-COM": "Comoe",
	"BF-GAN": "Ganzourgou",
	"BF-GNA": "Gnagna",
	"BF-GOU": "Gourma",
	"BF-HOU": "Houet",
	"BF-KAD": "Kadiogo",
	"BF-KEN": "Kenedougou",
	"BF-KMP": "Kompienga",
	"BF-KOS": "Kossi",
	"BF-KOT": "Kouritenga",
	"BF-KOW": "Kourweogo",
	"BF-LER": "Leraba",
	"BF-LOR": "Loroum",
	"BF-MOU": "Mouhoun",
	"BF-NAM": "Namentenga",
	"BF-NAO": "Nahouri",
	"BF-NAY": "Nayala",
	"BF-OUB": "Oubritenga",
	"BF-OUD": "Oudalan",
	"BF-PAS": "Passore",
	"BF-SEN": "Seno",
	"BF-SIS": "Sissili",
	"BF-SMT": "Sanmatenga",
	"BF-SOM": "Soum",
	"BF-SOR": "Sourou",
	"BF-TAP": "Tapoa",
	"BF-TUI": "Tuy",
	"BF-YAT": "Yatenga",
	"BF-ZIR": "Ziro",
	"BF-ZON": "Zondoma",
	"BF-ZOU": "Zoundweogo",
	"BG-01": "Blagoevgrad",
	"BG-02": "Burgas",
	"BG-03": "Varna",
	"BG-04": "Veliko Tarnovo",
	"BG-05": "Vidin",
	"BG-06": "Vratsa",
	"BG-07": "Gabrovo",
	"BG-08": "Dobrich",
	"BG-09": "Kardzhali",
	"BG-10": "Kyustendil",
	"BG-11": "Lovech",
	"BG-12": "Montana",
	"BG-13": "Pazardzhik",
	"BG-14": "Pernik",
	"BG-15": "Pleven",
	"BG-16": "Plovdiv",
	"BG-17": "Razgrad",
	"BG-18": "Ruse",
	"BG-19": "Silistra",
	"BG-20": "Sliven",
	"BG-21": "Smolyan",
	"BG-22": "Sofia (stolitsa)",
	"BG-23": "Sofia",
	"BG-24": "Stara Zagora",
	"BG-25": "Targovishte",
	"BG-26": "Haskovo",
	"BG-27": "Shumen",
	"BG-28": "Yambol",
	"BH-13": "Al 'Asimah",
	"BH-14": "Al Janubiyah",
	"BH-15": "Al Muharraq",
	"BH-17": "Ash Shamaliyah",
	"BI-BM": "Bujumbura Mairie",
	"BI-BR": "Bururi",
	"BI-CI": "Cibitoke",
	"BI-GI": "Gitega",
	"BI-KI": "Kirundo",
	"BI-MW": "Mwaro",
	"BI-NG": "Ngozi",
	"BI-RM": "Rumonge",
	"BI-RT": "Rutana",
	"BI-RY": "Ruyigi",
	"BJ-AQ": "Atlantique",
	"BJ-BO": "Borgou",
	"BJ-CO": "Collines",
	"BJ-LI": "Littoral",
	"BJ-MO": "Mono",
	"BJ-OU": "Oueme",
	"BJ-PL": "Plateau",
	"BJ-ZO": "Zou",
	"BN-BE": "Belait",
	"BN-BM": "Brunei-Muara",
	"BN-TE": "Temburong",
	"BN-TU": "Tutong",
	"BO-B": "El Beni",
	"BO-C": "Cochabamba",
	"BO-H": "Chuquisaca",
	"BO-L": "La Paz",
	"BO-N": "Pando",
	"BO-O": "Oruro",
	"BO-P": "Potosi",
	"BO-S": "Santa Cruz",
	"BO-T": "Tarija",
	"BQ-BO": "Bonaire",
	"BQ-SA": "Saba",
	"BQ-SE": "Sint Eustatius",
	"BR-AC": "Acre",
	"BR-AL": "Alagoas",
	"BR-AM": "Amazonas",
	"BR-AP": "Amapa",
	"BR-BA": "Bahia",
	"BR-CE": "Ceara",
	"BR-DF": "Distrito Federal",
	"BR-ES": "Espirito Santo",
	"BR-GO": "Goias",
	"BR-MA": "Maranhao",
	"BR-MG": "Minas Gerais",
	"BR-MS": "Mato Grosso do Sul",
	"BR-MT": "Mato Grosso",
	"BR-PA": "Para",
	"BR-PB": "Paraiba",
	"BR-PE": "Pernambuco",
	"BR-PI": "Piaui",
	"BR-PR": "Parana",
	"BR-RJ": "Rio de Janeiro",
	"BR-RN": "Rio Grande do Norte",
	"BR-RO": "Rondonia",
	"BR-RR": "Roraima",
	"BR-RS": "Rio Grande do Sul",
	"BR-SC": "Santa Catarina",
	"BR-SE": "Sergipe",
	"BR-SP": "Sao Paulo",
	"BR-TO": "Tocantins",
	"BS-BP": "Black Point",
	"BS-CO": "Central Abaco",
	"BS-EG": "East Grand Bahama",
	"BS-FP": "City of Freeport",
	"BS-HI": "Harbour Island",
	"BS-LI": "Long Island",
	"BS-NE": "North Eleuthera",
	"BS-NP": "New Providence",
	"BS-NS": "North Andros",
	"BS-SE": "South Eleuthera",
	"BS-SS": "San Salvador",
	"BS-WG": "West Grand Bahama",
	"BT-11": "Paro",
	"BT-12": "Chhukha",
	"BT-14": "Samtse",
	"BT-15": "Thimphu",
	"BT-21": "Tsirang",
	"BT-22": "Dagana",
	"BT-23": "Punakha",
	"BT-24": "Wangdue Phodrang",
	"BT-31": "Sarpang",
	"BT-32": "Trongsa",
	"BT-33": "Bumthang",
	"BT-41": "Trashigang",
	"BT-42": "Monggar",
	"BT-43": "Pema Gatshel",
	"BT-44": "Lhuentse",
	"BT-45": "Samdrup Jongkhar",
	"BT-GA": "Gasa",
	"BW-CE": "Central",
	"BW-CH": "Chobe",
	"BW-GH": "Ghanzi",
	"BW-KG": "Kgalagadi",
	"BW-KL": "Kgatleng",
	"BW-KW": "Kweneng",
	"BW-NE": "North East",
	"BW-NW": "North West",
	"BW-SE": "South East",
	"BW-SO": "Southern",
	"BY-BR": "Brestskaya voblasts'",
	"BY-HM": "Horad Minsk",
	"BY-HO": "Homyel'skaya voblasts'",
	"BY-HR": "Hrodzyenskaya voblasts'",
	"BY-MA": "Mahilyowskaya voblasts'",
	"BY-MI": "Minskaya voblasts'",
	"BY-VI": "Vitsyebskaya voblasts'",
	"BZ-BZ": "Belize",
	"BZ-CY": "Cayo",
	"BZ-CZL": "Corozal",
	"BZ-OW": "Orange Walk",
	"BZ-SC": "Stann Creek",
	"BZ-TOL": "Toledo",
	"CA-AB": "Alberta",
	"CA-BC": "British Columbia",
	"CA-MB": "Manitoba",
	"CA-NB": "New Brunswick",
	"CA-NL": "Newfoundland and Labrador",
	"CA-NS": "Nova Scotia",
	"CA-NT": "Northwest Territories",
	"CA-NU": "Nunavut",
	"CA-ON": "Ontario",
	"CA-PE": "Prince Edward Island",
	"CA-QC": "Quebec",
	"CA-SK": "Saskatchewan",
	"CA-YT": "Yukon",
	"CD-EQ": "Equateur",
	"CD-HK": "Haut-Katanga",
	"CD-IT": "Ituri",
	"CD-KC": "Kasai Central",
	"CD-KE": "Kasai Oriental",
	"CD-KG": "Kwango",
	"CD-KL": "Kwilu",
	"CD-KN": "Kinshasa",
	"CD-LU": "Lualaba",
	"CD-MA": "Maniema",
	"CD-NK": "Nord-Kivu",
	"CD-SA": "Sankuru",
	"CD-SK": "Sud-Kivu",
	"CD-TA": "Tanganyika",
	"CD-TO": "Tshopo",
	"CF-AC": "Ouham",
	"CF-BB": "Bamingui-Bangoran",
	"CF-BGF": "Bangui",
	"CF-HS": "Mambere-Kadei",
	"CF-KB": "Gribingui",
	"CF-KG": "Kemo-Gribingui",
	"CF-NM": "Nana-Mambere",
	"CF-OP": "Ouham-Pende",
	"CF-SE": "Sangha",
	"CF-UK": "Ouaka",
	"CG-11": "Bouenza",
	"CG-13": "Sangha",
	"CG-16": "Pointe-Noire",
	"CG-8": "Cuvette",
	"CG-9": "Niari",
	"CG-BZV": "Brazzaville",
	"CH-AG": "Aargau",
	"CH-AI": "Appenzell Innerrhoden",
	"CH-AR": "Appenzell Ausserrhoden",
	"CH-BE": "Bern",
	"CH-BL": "Basel-Landschaft",
	"CH-BS": "Basel-Stadt",
	"CH-FR": "Fribourg",
	"CH-GE": "Geneve",
	"CH-GL": "Glarus",
	"CH-GR": "Graubunden",
	"CH-JU": "Jura",
	"CH-LU": "Luzern",
	"CH-NE": "Neuchatel",
	"CH-NW": "Nidwalden",
	"CH-OW": "Obwalden",
	"CH-SG": "Sankt Gallen",
	"CH-SH": "Schaffhausen",
	"CH-SO": "Solothurn",
	"CH-SZ": "Schwyz",
	"CH-TG": "Thurgau",
	"CH-TI": "Ticino",
	"CH-UR": "Uri",
	"CH-VD": "Vaud",
	"CH-VS": "Valais",
	"CH-ZG": "Zug",
	"CH-ZH": "Zurich",
	"CI-AB": "Abidjan",
	"CI-BS": "Bas-Sassandra",
	"CI-CM": "Comoe",
	"CI-DN": "Denguele",
	"CI-GD": "Goh-Djiboua",
	"CI-LC": "Lacs",
	"CI-LG": "Lagunes",
	"CI-MG": "Montagnes",
	"CI-SM": "Sassandra-Marahoue",
	"CI-SV": "Savanes",
	"CI-VB": "Vallee du Bandama",
	"CI-WR": "Woroba",
	"CI-YM": "Yamoussoukro",
	"CI-ZZ": "Zanzan",
	"CL-AI": "Aisen del General Carlos Ibanez del Campo",
	"CL-AN": "Antofagasta",
	"CL-AP": "Arica y Parinacota",
	"CL-AR": "La Araucania",
	"CL-AT": "Atacama",
	"CL-BI": "Biobio",
	"CL-CO": "Coquimbo",
	"CL-LI": "Libertador General Bernardo O'Higgins",
	"CL-LL": "Los Lagos",
	"CL-LR": "Los Rios",
	"CL-MA": "Magallanes",
	"CL-ML": "Maule",
	"CL-NB": "Nuble",
	"CL-RM": "Region Metropolitana de Santiago",
	"CL-TA": "Tarapaca",
	"CL-VS": "Valparaiso",
	"CM-AD": "Adamaoua",
	"CM-CE": "Centre",
	"CM-EN": "Extreme-Nord",
	"CM-ES": "Est",
	"CM-LT": "Littoral",
	"CM-NO": "Nord",
	"CM-NW": "Nord-Ouest",
	"CM-OU": "Ouest",
	"CM-SU": "Sud",
	"CM-SW": "Sud-Ouest",
	"CN-AH": "Anhui",
	"CN-BJ": "Beijing",
	"CN-CQ": "Chongqing",
	"CN-FJ": "Fujian",
	"CN-GD": "Guangdong",
	"CN-GS": "Gansu",
	"CN-GX": "Guangxi Zhuangzu",
	"CN-GZ": "Guizhou",
	"CN-HA": "Henan",
	"CN-HB": "Hubei",
	"CN-HE": "Hebei",
	"CN-HI": "Hainan",
	"CN-HL": "Heilongjiang",
	"CN-HN": "Hunan",
	"CN-JL": "Jilin",
	"CN-JS": "Jiangsu",
	"CN-JX": "Jiangxi",
	"CN-LN": "Liaoning",
	"CN-NM": "Nei Mongol",
	"CN-NX": "Ningxia Huizu",
	"CN-QH": "Qinghai",
	"CN-SC": "Sichuan",
	"CN-SD": "Shandong",
	"CN-SH": "Shanghai",
	"CN-SN": "Shaanxi",
	"CN-SX": "Shanxi",
	"CN-TJ": "Tianjin",
	"CN-XJ": "Xinjiang Uygur",
	"CN-XZ": "Xizang",
	"CN-YN": "Yunnan",
	"CN-ZJ": "Zhejiang",
	"CO-AMA": "Amazonas",
	"CO-ANT": "Antioquia",
	"CO-ARA": "Arauca",
	"CO-ATL": "Atlantico",
	"CO-BOL": "Bolivar",
	"CO-BOY": "Boyaca",
	"CO-CAL": "Caldas",
	"CO-CAQ": "Caqueta",
	"CO-CAS": "Casanare",
	"CO-CAU": "Cauca",
	"CO-CES": "Cesar",
	"CO-CHO": "Choco",
	"CO-COR": "Cordoba",
	"CO-CUN": "Cundinamarca",
	"CO-DC": "Distrito Capital de Bogota",
	"CO-GUA": "Guainia",
	"CO-GUV": "Guaviare",
	"CO-HUI": "Huila",
	"CO-LAG": "La Guajira",
	"CO-MAG": "Magdalena",
	"CO-MET": "Meta",
	"CO-NAR": "Narino",
	"CO-NSA": "Norte de Santander",
	"CO-PUT": "Putumayo",
	"CO-QUI": "Quindio",
	"CO-RIS": "Risaralda",
	"CO-SAN": "Santander",
	"CO-SAP": "San Andres, Providencia y Santa Catalina",
	"CO-SUC": "Sucre",
	"CO-TOL": "Tolima",
	"CO-VAC": "Valle del Cauca",
	"CO-VID": "Vichada",
	"CR-A": "Alajuela",
	"CR-C": "Cartago",
	"CR-G": "Guanacaste",
	"CR-H": "Heredia",
	"CR-L": "Limon",
	"CR-P": "Puntarenas",
	"CR-SJ": "San Jose",
	"CU-01": "Pinar del Rio",
	"CU-03": "La Habana",
	"CU-04": "Matanzas",
	"CU-05": "Villa Clara",
	"CU-06": "Cienfuegos",
	"CU-07": "Sancti Spiritus",
	"CU-08": "Ciego de Avila",
	"CU-09": "Camaguey",
	"CU-10": "Las Tunas",
	"CU-11": "Holguin",
	"CU-12": "Granma",
	"CU-13": "Santiago de Cuba",
	"CU-14": "Guantanamo",
	"CU-15": "Artemisa",
	"CU-16": "Mayabeque",
	"CU-99": "Isla de la Juventud",
	"CV-BR": "Brava",
	"CV-BV": "Boa Vista",
	"CV-MO": "Mosteiros",
	"CV-PN": "Porto Novo",
	"CV-PR": "Praia",
	"CV-RS": "Ribeira Grande de Santiago",
	"CV-SD": "Sao Domingos",
	"CV-SL": "Sal",
	"CV-SV": "Sao Vicente",
	"CV-TA": "Tarrafal",
	"CY-01": "Lefkosia",
	"CY-02": "Lemesos",
	"CY-03": "Larnaka",
	"CY-04": "Ammochostos",
	"CY-05": "Pafos",
	"CY-06": "Keryneia",
	"CZ-10": "Praha, Hlavni mesto",
	"CZ-20": "Stredocesky kraj",
	"CZ-31": "Jihocesky kraj",
	"CZ-32": "Plzensky kraj",
	"CZ-41": "Karlovarsky kraj",
	"CZ-42": "Ustecky kraj",
	"CZ-51": "Liberecky kraj",
	"CZ-52": "Kralovehradecky kraj",
	"CZ-53": "Pardubicky kraj",
	"CZ-63": "Kraj Vysocina",
	"CZ-64": "Jihomoravsky kraj",
	"CZ-71": "Olomoucky kraj",
	"CZ-72": "Zlinsky kraj",
	"CZ-80": "Moravskoslezsky kraj",
	"DE-BB": "Brandenburg",
	"DE-BE": "Berlin",
	"DE-BW": "Baden-Wurttemberg",
	"DE-BY": "Bayern",
	"DE-HB": "Bremen",
	"DE-HE": "Hessen",
	"DE-HH": "Hamburg",
	"DE-MV": "Mecklenburg-Vorpommern",
	"DE-NI": "Niedersachsen",
	"DE-NW": "Nordrhein-Westfalen",
	"DE-RP": "Rheinland-Pfalz",
	"DE-SH": "Schleswig-Holstein",
	"DE-SL": "Saarland",
	"DE-SN": "Sachsen",
	"DE-ST": "Sachsen-Anhalt",
	"DE-TH": "Thuringen",
	"DJ-AR": "Arta",
	"DJ-DI": "Dikhil",
	"DJ-DJ": "Djibouti",
	"DK-81": "Nordjylland",
	"DK-82": "Midtjylland",
	"DK-83": "Syddanmark",
	"DK-84": "Hovedstaden",
	"DK-85": "Sjaelland",
	"DM-02": "Saint Andrew",
	"DM-04": "Saint George",
	"DM-05": "Saint John",
	"DM-06": "Saint Joseph",
	"DM-07": "Saint Luke",
	"DM-09": "Saint Patrick",
	"DM-10": "Saint Paul",
	"DO-01": "Distrito Nacional (Santo Domingo)",
	"DO-02": "Azua",
	"DO-03": "Baoruco",
	"DO-04": "Barahona",
	"DO-05": "Dajabon",
	"DO-06": "Duarte",
	"DO-07": "Elías Piña",
	"DO-08": "El Seibo",
	"DO-09": "Espaillat",
	"DO-10": "Independencia",
	"DO-11": "La Altagracia",
	"DO-12": "La Romana",
	"DO-13": "La Vega",
	"DO-14": "Maria Trinidad Sanchez",
	"DO-15": "Monte Cristi",
	"DO-16": "Pedernales",
	"DO-17": "Peravia",
	"DO-18": "Puerto Plata",
	"DO-19": "Hermanas Mirabal",
	"DO-20": "Samana",
	"DO-21": "San Cristobal",
	"DO-22": "San Juan",
	"DO-23": "San Pedro de Macoris",
	"DO-24": "Sanchez Ramirez",
	"DO-25": "Santiago",
	"DO-26": "Santiago Rodriguez",
	"DO-27": "Valverde",
	"DO-28": "Monsenor Nouel",
	"DO-29": "Monte Plata",
	"DO-30": "Hato Mayor",
	"DO-31": "San Jose de Ocoa",
	"DO-32": "Santo Domingo",
	"DO-33": "Cibao Nordeste",
	"DO-34": "Cibao Noroeste",
	"DO-35": "Cibao Norte",
	"DO-36": "Cibao Sur",
	"DO-37": "El Valle",
	"DO-38": "Enriquillo",
	"DO-39": "Higuamo",
	"DO-40": "Ozama",
	"DO-41": "Valdesia",
	"DO-42": "Yuma",
	"DZ-01": "Adrar",
	"DZ-02": "Chlef",
	"DZ-03": "Laghouat",
	"DZ-04": "Oum el Bouaghi",
	"DZ-05": "Batna",
	"DZ-06": "Bejaia",
	"DZ-07": "Biskra",
	"DZ-08": "Bechar",
	"DZ-09": "Blida",
	"DZ-10": "Bouira",
	"DZ-11": "Tamanrasset",
	"DZ-12": "Tebessa",
	"DZ-13": "Tlemcen",
	"DZ-14": "Tiaret",
	"DZ-15": "Tizi Ouzou",
	"DZ-16": "Alger",
	"DZ-17": "Djelfa",
	"DZ-18": "Jijel",
	"DZ-19": "Setif",
	"DZ-20": "Saida",
	"DZ-21": "Skikda",
	"DZ-22": "Sidi Bel Abbes",
	"DZ-23": "Annaba",
	"DZ-24": "Guelma",
	"DZ-25": "Constantine",
	"DZ-26": "Medea",
	"DZ-27": "Mostaganem",
	"DZ-28": "M'sila",
	"DZ-29": "Mascara",
	"DZ-30": "Ouargla",
	"DZ-31": "Oran",
	"DZ-32": "El Bayadh",
	"DZ-33": "Illizi",
	"DZ-34": "Bordj Bou Arreridj",
	"DZ-35": "Boumerdes",
	"DZ-36": "El Tarf",
	"DZ-37": "Tindouf",
	"DZ-38": "Tissemsilt",
	"DZ-39": "El Oued",
	"DZ-40": "Khenchela",
	"DZ-41": "Souk Ahras",
	"DZ-42": "Tipaza",
	"DZ-43": "Mila",
	"DZ-44": "Ain Defla",
	"DZ-45": "Naama",
	"DZ-46": "Ain Temouchent",
	"DZ-47": "Ghardaia",
	"DZ-48": "Relizane",
	"DZ-49": "Timimoun",
	"DZ-51": "Ouled Djellal",
	"DZ-53": "In Salah",
	"DZ-55": "Touggourt",
	"DZ-56": "Djanet",
	"DZ-57": "El Meghaier",
	"EC-A": "Azuay",
	"EC-B": "Bolivar",
	"EC-C": "Carchi",
	"EC-D": "Orellana",
	"EC-E": "Esmeraldas",
	"EC-F": "Canar",
	"EC-G": "Guayas",
	"EC-H": "Chimborazo",
	"EC-I": "Imbabura",
	"EC-L": "Loja",
	"EC-M": "Manabi",
	"EC-N": "Napo",
	"EC-O": "El Oro",
	"EC-P": "Pichincha",
	"EC-R": "Los Rios",
	"EC-S": "Morona Santiago",
	"EC-SD": "Santo Domingo de los Tsachilas",
	"EC-SE": "Santa Elena",
	"EC-T": "Tungurahua",
	"EC-U": "Sucumbios",
	"EC-W": "Galapagos",
	"EC-X": "Cotopaxi",
	"EC-Y": "Pastaza",
	"EC-Z": "Zamora Chinchipe",
	"EE-37": "Harjumaa",
	"EE-39": "Hiiumaa",
	"EE-45": "Ida-Virumaa",
	"EE-50": "Jogevamaa",
	"EE-52": "Jarvamaa",
	"EE-56": "Laanemaa",
	"EE-60": "Laane-Virumaa",
	"EE-64": "Polvamaa",
	"EE-68": "Parnumaa",
	"EE-71": "Raplamaa",
	"EE-74": "Saaremaa",
	"EE-79": "Tartumaa",
	"EE-81": "Valgamaa",
	"EE-84": "Viljandimaa",
	"EE-87": "Vorumaa",
	"EG-ALX": "Al Iskandariyah",
	"EG-ASN": "Aswan",
	"EG-AST": "Asyut",
	"EG-BA": "Al Bahr al Ahmar",
	"EG-BH": "Al Buhayrah",
	"EG-BNS": "Bani Suwayf",
	"EG-C": "Al Qahirah",
	"EG-DK": "Ad Daqahliyah",
	"EG-DT": "Dumyat",
	"EG-FYM": "Al Fayyum",
	"EG-GH": "Al Gharbiyah",
	"EG-GZ": "Al Jizah",
	"EG-IS": "Al Isma'iliyah",
	"EG-JS": "Janub Sina'",
	"EG-KB": "Al Qalyubiyah",
	"EG-KFS": "Kafr ash Shaykh",
	"EG-KN": "Qina",
	"EG-LX": "Al Uqsur",
	"EG-MN": "Al Minya",
	"EG-MNF": "Al Minufiyah",
	"EG-MT": "Matruh",
	"EG-PTS": "Bur Sa'id",
	"EG-SHG": "Suhaj",
	"EG-SHR": "Ash Sharqiyah",
	"EG-SIN": "Shamal Sina'",
	"EG-SUZ": "As Suways",
	"EG-WAD": "Al Wadi al Jadid",
	"ER-GB": "Qash-Barkah",
	"ER-MA": "Al Awsat",
	"ES-AN": "Andalucia",
	"ES-AR": "Aragon",
	"ES-AS": "Asturias, Principado de",
	"ES-CB": "Cantabria",
	"ES-CE": "Ceuta",
	"ES-CL": "Castilla y Leon",
	"ES-CM": "Castilla-La Mancha",
	"ES-CN": "Canarias",
	"ES-CT": "Catalunya",
	"ES-EX": "Extremadura",
	"ES-GA": "Galicia",
	"ES-IB": "Illes Balears",
	"ES-MC": "Murcia, Region de",
	"ES-MD": "Madrid, Comunidad de",
	"ES-ML": "Melilla",
	"ES-NC": "Navarra, Comunidad Foral de",
	"ES-PV": "Pais Vasco",
	"ES-RI": "La Rioja",
	"ES-VC": "Valenciana, Comunidad",
	"ET-AA": "Addis Ababa",
	"ET-AF": "Afar",
	"ET-AM": "Amara",
	"ET-BE": "Benshangul-Gumaz",
	"ET-DD": "Dire Dawa",
	"ET-HA": "Harari People",
	"ET-OR": "Oromia",
	"ET-SN": "Southern Nations, Nationalities and Peoples",
	"ET-SO": "Somali",
	"ET-TI": "Tigrai",
	"FI-02": "Etela-Karjala",
	"FI-03": "Etela-Pohjanmaa",
	"FI-04": "Etela-Savo",
	"FI-05": "Kainuu",
	"FI-06": "Kanta-Hame",
	"FI-07": "Keski-Pohjanmaa",
	"FI-08": "Keski-Suomi",
	"FI-09": "Kymenlaakso",
	"FI-10": "Lappi",
	"FI-11": "Pirkanmaa",
	"FI-12": "Pohjanmaa",
	"FI-13": "Pohjois-Karjala",
	"FI-14": "Pohjois-Pohjanmaa",
	"FI-15": "Pohjois-Savo",
	"FI-16": "Paijat-Hame",
	"FI-17": "Satakunta",
	"FI-18": "Uusimaa",
	"FI-19": "Varsinais-Suomi",
	"FJ-C": "Central",
	"FJ-E": "Eastern",
	"FJ-N": "Northern",
	"FJ-R": "Rotuma",
	"FJ-W": "Western",
	"FM-KSA": "Kosrae",
	"FM-PNI": "Pohnpei",
	"FM-TRK": "Chuuk",
	"FM-YAP": "Yap",
	"FR-20R": "Corse",
	"FR-ARA": "Auvergne-Rhone-Alpes",
	"FR-BFC": "Bourgogne-Franche-Comte",
	"FR-BRE": "Bretagne",
	"FR-CVL": "Centre-Val de Loire",
	"FR-GES": "Grand-Est",
	"FR-HDF": "Hauts-de-France",
	"FR-IDF": "Ile-de-France",
	"FR-NAQ": "Nouvelle-Aquitaine",
	"FR-NOR": "Normandie",
	"FR-OCC": "Occitanie",
	"FR-PAC": "Provence-Alpes-Cote-d'Azur",
	"FR-PDL": "Pays-de-la-Loire",
	"FR-PM": "Saint Pierre and Miquelon",
	"GA-1": "Estuaire",
	"GA-2": "Haut-Ogooue",
	"GA-3": "Moyen-Ogooue",
	"GA-4": "Ngounie",
	"GA-5": "Nyanga",
	"GA-7": "Ogooue-Lolo",
	"GA-8": "Ogooue-Maritime",
	"GA-9": "Woleu-Ntem",
	"GB-ENG": "England",
	"GB-NIR": "Northern Ireland",
	"GB-SCT": "Scotland",
	"GB-WLS": "Wales",
	"GD-01": "Saint Andrew",
	"GD-02": "Saint David",
	"GD-03": "Saint George",
	"GD-04": "Saint John",
	"GD-05": "Saint Mark",
	"GD-06": "Saint Patrick",
	"GD-10": "Southern Grenadine Islands",
	"GE-AB": "Abkhazia",
	"GE-AJ": "Ajaria",
	"GE-GU": "Guria",
	"GE-IM": "Imereti",
	"GE-KA": "K'akheti",
	"GE-KK": "Kvemo Kartli",
	"GE-MM": "Mtskheta-Mtianeti",
	"GE-RL": "Rach'a-Lechkhumi-Kvemo Svaneti",
	"GE-SJ": "Samtskhe-Javakheti",
	"GE-SK": "Shida Kartli",
	"GE-SZ": "Samegrelo-Zemo Svaneti",
	"GE-TB": "Tbilisi",
	"GH-AA": "Greater Accra",
	"GH-AF": "Ahafo",
	"GH-AH": "Ashanti",
	"GH-BE": "Bono East",
	"GH-BO": "Bono",
	"GH-CP": "Central",
	"GH-EP": "Eastern",
	"GH-NP": "Northern",
	"GH-TV": "Volta",
	"GH-UE": "Upper East",
	"GH-UW": "Upper West",
	"GH-WP": "Western",
	"GL-AV": "Avannaata Kommunia",
	"GL-KU": "Kommune Kujalleq",
	"GL-QE": "Qeqqata Kommunia",
	"GL-QT": "Kommune Qeqertalik",
	"GL-SM": "Kommuneqarfik Sermersooq",
	"GM-B": "Banjul",
	"GM-L": "Lower River",
	"GM-M": "Central River",
	"GM-N": "North Bank",
	"GM-U": "Upper River",
	"GM-W": "Western",
	"GN-B": "Boke",
	"GN-BE": "Beyla",
	"GN-BF": "Boffa",
	"GN-C": "Conakry",
	"GN-DB": "Dabola",
	"GN-DI": "Dinguiraye",
	"GN-DU": "Dubreka",
	"GN-FR": "Fria",
	"GN-K": "Kankan",
	"GN-KO": "Kouroussa",
	"GN-LE": "Lelouma",
	"GN-SI": "Siguiri",
	"GQ-BN": "Bioko Norte",
	"GQ-CS": "Centro Sur",
	"GQ-KN": "Kie-Ntem",
	"GQ-LI": "Litoral",
	"GQ-WN": "Wele-Nzas",
	"GR-69": "Agion Oros",
	"GR-A": "Anatoliki Makedonia kai Thraki",
	"GR-B": "Kentriki Makedonia",
	"GR-C": "Dytiki Makedonia",
	"GR-D": "Ipeiros",
	"GR-E": "Thessalia",
	"GR-F": "Ionia Nisia",
	"GR-G": "Dytiki Ellada",
	"GR-H": "Sterea Ellada",
	"GR-I": "Attiki",
	"GR-J": "Peloponnisos",
	"GR-K": "Voreio Aigaio",
	"GR-L": "Notio Aigaio",
	"GR-M": "Kriti",
	"GT-01": "Guatemala",
	"GT-02": "El Progreso",
	"GT-03": "Sacatepequez",
	"GT-04": "Chimaltenango",
	"GT-05": "Escuintla",
	"GT-06": "Santa Rosa",
	"GT-07": "Solola",
	"GT-08": "Totonicapan",
	"GT-09": "Quetzaltenango",
	"GT-10": "Suchitepequez",
	"GT-11": "Retalhuleu",
	"GT-12": "San Marcos",
	"GT-13": "Huehuetenango",
	"GT-14": "Quiche",
	"GT-15": "Baja Verapaz",
	"GT-16": "Alta Verapaz",
	"GT-17": "Peten",
	"GT-18": "Izabal",
	"GT-19": "Zacapa",
	"GT-20": "Chiquimula",
	"GT-21": "Jalapa",
	"GT-22": "Jutiapa",
	"GT-AV": "Alta Verapaz",
	"GT-BV": "Baja Verapaz",
	"GT-CM": "Chimaltenango",
	"GT-CQ": "Chiquimula",
	"GT-PR": "El Progreso",
	"GT-ES": "Escuintla",
	"GT-GU": "Guatemala Department",
	"GT-HU": "Huehuetenango",
	"GT-IZ": "Izabal",
	"GT-JA": "Jalapa",
	"GT-JU": "Jutiapa",
	"GT-PE": "Petén",
	"GT-QZ": "Quetzaltenango",
	"GT-QC": "Quiché",
	"GT-RE": "Retalhuleu",
	"GT-SA": "Sacatepéquez",
	"GT-SM": "San Marcos",
	"GT-SR": "Santa Rosa",
	"GT-SO": "Sololá",
	"GT-SU": "Suchitepéquez",
	"GT-TO": "Totonicapán",
	"GT-ZA": "Zacapa",
	"GW-BA": "Bafata",
	"GW-BS": "Bissau",
	"GW-GA": "Gabu",
	"GW-OI": "Oio",
	"GY-BA": "Barima-Waini",
	"GY-CU": "Cuyuni-Mazaruni",
	"GY-DE": "Demerara-Mahaica",
	"GY-EB": "East Berbice-Corentyne",
	"GY-ES": "Essequibo Islands-West Demerara",
	"GY-MA": "Mahaica-Berbice",
	"GY-PT": "Potaro-Siparuni",
	"GY-UD": "Upper Demerara-Berbice",
	"HK-HCW": "Central and Western",
	"HK-HEA": "Eastern",
	"HK-HSO": "Southern",
	"HK-HWC": "Wan Chai",
	"HK-KKC": "Kowloon City",
	"HK-KKT": "Kwun Tong",
	"HK-KSS": "Sham Shui Po",
	"HK-KWT": "Wong Tai Sin",
	"HK-KYT": "Yau Tsim Mong",
	"HK-NIS": "Islands",
	"HK-NKT": "Kwai Tsing",
	"HK-NNO": "North",
	"HK-NSK": "Sai Kung",
	"HK-NST": "Sha Tin",
	"HK-NTM": "Tuen Mun",
	"HK-NTP": "Tai Po",
	"HK-NTW": "Tsuen Wan",
	"HK-NYL": "Yuen Long",
	"HN-AT": "Atlantida",
	"HN-CH": "Choluteca",
	"HN-CL": "Colon",
	"HN-CM": "Comayagua",
	"HN-CP": "Copan",
	"HN-CR": "Cortes",
	"HN-EP": "El Paraiso",
	"HN-FM": "Francisco Morazan",
	"HN-GD": "Gracias a Dios",
	"HN-IB": "Islas de la Bahia",
	"HN-IN": "Intibuca",
	"HN-LE": "Lempira",
	"HN-LP": "La Paz",
	"HN-OC": "Ocotepeque",
	"HN-OL": "Olancho",
	"HN-SB": "Santa Barbara",
	"HN-VA": "Valle",
	"HN-YO": "Yoro",
	"HR-01": "Zagrebacka zupanija",
	"HR-02": "Krapinsko-zagorska zupanija",
	"HR-03": "Sisacko-moslavacka zupanija",
	"HR-04": "Karlovacka zupanija",
	"HR-05": "Varazdinska zupanija",
	"HR-06": "Koprivnicko-krizevacka zupanija",
	"HR-07": "Bjelovarsko-bilogorska zupanija",
	"HR-08": "Primorsko-goranska zupanija",
	"HR-09": "Licko-senjska zupanija",
	"HR-10": "Viroviticko-podravska zupanija",
	"HR-11": "Pozesko-slavonska zupanija",
	"HR-12": "Brodsko-posavska zupanija",
	"HR-13": "Zadarska zupanija",
	"HR-14": "Osjecko-baranjska zupanija",
	"HR-15": "Sibensko-kninska zupanija",
	"HR-16": "Vukovarsko-srijemska zupanija",
	"HR-17": "Splitsko-dalmatinska zupanija",
	"HR-18": "Istarska zupanija",
	"HR-19": "Dubrovacko-neretvanska zupanija",
	"HR-20": "Medimurska zupanija",
	"HR-21": "Grad Zagreb",
	"HT-AR": "Artibonite",
	"HT-CE": "Centre",
	"HT-GA": "Grande'Anse",
	"HT-ND": "Nord",
	"HT-NI": "Nippes",
	"HT-NO": "Nord-Ouest",
	"HT-OU": "Ouest",
	"HT-SD": "Sud",
	"HT-SE": "Sud-Est",
	"HU-BA": "Baranya",
	"HU-BE": "Bekes",
	"HU-BK": "Bacs-Kiskun",
	"HU-BU": "Budapest",
	"HU-BZ": "Borsod-Abauj-Zemplen",
	"HU-CS": "Csongrad-Csanad",
	"HU-FE": "Fejer",
	"HU-GS": "Gyor-Moson-Sopron",
	"HU-HB": "Hajdu-Bihar",
	"HU-HE": "Heves",
	"HU-JN": "Jasz-Nagykun-Szolnok",
	"HU-KE": "Komarom-Esztergom",
	"HU-NO": "Nograd",
	"HU-PE": "Pest",
	"HU-SO": "Somogy",
	"HU-SZ": "Szabolcs-Szatmar-Bereg",
	"HU-TO": "Tolna",
	"HU-VA": "Vas",
	"HU-VE": "Veszprem",
	"HU-ZA": "Zala",
	"ID-AC": "Aceh",
	"ID-BA": "Bali",
	"ID-BB": "Kepulauan Bangka Belitung",
	"ID-BE": "Bengkulu",
	"ID-BT": "Banten",
	"ID-GO": "Gorontalo",
	"ID-JA": "Jambi",
	"ID-JB": "Jawa Barat",
	"ID-JI": "Jawa Timur",
	"ID-JK": "Jakarta Raya",
	"ID-JT": "Jawa Tengah",
	"ID-KB": "Kalimantan Barat",
	"ID-KI": "Kalimantan Timur",
	"ID-KR": "Kepulauan Riau",
	"ID-KS": "Kalimantan Selatan",
	"ID-KT": "Kalimantan Tengah",
	"ID-KU": "Kalimantan Utara",
	"ID-LA": "Lampung",
	"ID-ML": "Maluku",
	"ID-MU": "Maluku Utara",
	"ID-NB": "Nusa Tenggara Barat",
	"ID-NT": "Nusa Tenggara Timur",
	"ID-PB": "Papua Barat",
	"ID-PE": "Papua Pengunungan",
	"ID-PP": "Papua",
	"ID-PS": "Papua Selatan",
	"ID-PT": "Papua Tengah",
	"ID-RI": "Riau",
	"ID-SA": "Sulawesi Utara",
	"ID-SB": "Sumatera Barat",
	"ID-SG": "Sulawesi Tenggara",
	"ID-SN": "Sulawesi Selatan",
	"ID-SR": "Sulawesi Barat",
	"ID-SS": "Sumatera Selatan",
	"ID-ST": "Sulawesi Tengah",
	"ID-SU": "Sumatera Utara",
	"ID-YO": "Yogyakarta",
	"IE-C": "Connaught",
	"IE-L": "Leinster",
	"IE-M": "Munster",
	"IE-U": "Ulster",
	"IE-CE": "Clare",
	"IE-CN": "Cavan",
	"IE-CO": "Cork",
	"IE-CW": "Carlow",
	"IE-D": "Dublin",
	"IE-DL": "Donegal",
	"IE-G": "Galway",
	"IE-KE": "Kildare",
	"IE-KK": "Kilkenny",
	"IE-KY": "Kerry",
	"IE-LD": "Longford",
	"IE-LH": "Louth",
	"IE-LK": "Limerick",
	"IE-LM": "Leitrim",
	"IE-LS": "Laois",
	"IE-MH": "Meath",
	"IE-MN": "Monaghan",
	"IE-MO": "Mayo",
	"IE-OY": "Offaly",
	"IE-RN": "Roscommon",
	"IE-SO": "Sligo",
	"IE-TA": "Tipperary",
	"IE-WD": "Waterford",
	"IE-WH": "Westmeath",
	"IE-WW": "Wicklow",
	"IE-WX": "Wexford",
	"IL-D": "HaDarom",
	"IL-HA": "Hefa",
	"IL-JM": "Yerushalayim",
	"IL-M": "HaMerkaz",
	"IL-TA": "Tel Aviv",
	"IL-Z": "HaTsafon",
	"IN-AN": "Andaman and Nicobar Islands",
	"IN-AP": "Andhra Pradesh",
	"IN-AR": "Arunachal Pradesh",
	"IN-AS": "Assam",
	"IN-BR": "Bihar",
	"IN-CH": "Chandigarh",
	"IN-CT": "Chhattisgarh",
	"IN-DH": "Dadra and Nagar Haveli and Daman and Diu",
	"IN-DL": "Delhi",
	"IN-DN": "Dadra and Nagar Haveli",
	"IN-GA": "Goa",
	"IN-GJ": "Gujarat",
	"IN-HP": "Himachal Pradesh",
	"IN-HR": "Haryana",
	"IN-JH": "Jharkhand",
	"IN-JK": "Jammu and Kashmir",
	"IN-KA": "Karnataka",
	"IN-KL": "Kerala",
	"IN-LD": "Lakshadweep",
	"IN-MH": "Maharashtra",
	"IN-ML": "Meghalaya",
	"IN-MN": "Manipur",
	"IN-MP": "Madhya Pradesh",
	"IN-MZ": "Mizoram",
	"IN-NL": "Nagaland",
	"IN-OR": "Odisha",
	"IN-PB": "Punjab",
	"IN-PY": "Puducherry",
	"IN-RJ": "Rajasthan",
	"IN-SK": "Sikkim",
	"IN-TG": "Telangana",
	"IN-TN": "Tamil Nadu",
	"IN-TR": "Tripura",
	"IN-UP": "Uttar Pradesh",
	"IN-UT": "Uttarakhand",
	"IN-WB": "West Bengal",
	"IQ-AN": "Al Anbar",
	"IQ-AR": "Arbil",
	"IQ-BA": "Al Basrah",
	"IQ-BB": "Babil",
	"IQ-BG": "Baghdad",
	"IQ-DA": "Dahuk",
	"IQ-DI": "Diyala",
	"IQ-DQ": "Dhi Qar",
	"IQ-KA": "Karbala'",
	"IQ-KI": "Kirkuk",
	"IQ-MA": "Maysan",
	"IQ-MU": "Al Muthanna",
	"IQ-NA": "An Najaf",
	"IQ-NI": "Ninawa",
	"IQ-QA": "Al Qadisiyah",
	"IQ-SD": "Salah ad Din",
	"IQ-SU": "As Sulaymaniyah",
	"IQ-WA": "Wasit",
	"IR-00": "Markazi",
	"IR-01": "Gilan",
	"IR-02": "Mazandaran",
	"IR-03": "Azarbayjan-e Sharqi",
	"IR-04": "Azarbayjan-e Gharbi",
	"IR-05": "Kermanshah",
	"IR-06": "Khuzestan",
	"IR-07": "Fars",
	"IR-08": "Kerman",
	"IR-09": "Khorasan-e Razavi",
	"IR-10": "Esfahan",
	"IR-11": "Sistan va Baluchestan",
	"IR-12": "Kordestan",
	"IR-13": "Hamadan",
	"IR-14": "Chahar Mahal va Bakhtiari",
	"IR-15": "Lorestan",
	"IR-16": "Ilam",
	"IR-17": "Kohgiluyeh va Bowyer Ahmad",
	"IR-18": "Bushehr",
	"IR-19": "Zanjan",
	"IR-20": "Semnan",
	"IR-21": "Yazd",
	"IR-22": "Hormozgan",
	"IR-23": "Tehran",
	"IR-24": "Ardabil",
	"IR-25": "Qom",
	"IR-26": "Qazvin",
	"IR-27": "Golestan",
	"IR-28": "Khorasan-e Shomali",
	"IR-29": "Khorasan-e Jonubi",
	"IR-30": "Alborz",
	"IS-1": "Hofudborgarsvaedi",
	"IS-2": "Sudurnes",
	"IS-3": "Vesturland",
	"IS-4": "Vestfirdir",
	"IS-5": "Nordurland vestra",
	"IS-6": "Nordurland eystra",
	"IS-7": "Austurland",
	"IS-8": "Sudurland",
	"IT-21": "Piemonte",
	"IT-23": "Valle d'Aosta",
	"IT-25": "Lombardia",
	"IT-32": "Trentino-Alto Adige",
	"IT-34": "Veneto",
	"IT-36": "Friuli-Venezia Giulia",
	"IT-42": "Liguria",
	"IT-45": "Emilia-Romagna",
	"IT-52": "Toscana",
	"IT-55": "Umbria",
	"IT-57": "Marche",
	"IT-62": "Lazio",
	"IT-65": "Abruzzo",
	"IT-67": "Molise",
	"IT-72": "Campania",
	"IT-75": "Puglia",
	"IT-77": "Basilicata",
	"IT-78": "Calabria",
	"IT-82": "Sicilia",
	"IT-88": "Sardegna",
	"JM-01": "Kingston",
	"JM-02": "Saint Andrew",
	"JM-03": "Saint Thomas",
	"JM-04": "Portland",
	"JM-05": "Saint Mary",
	"JM-06": "Saint Ann",
	"JM-07": "Trelawny",
	"JM-08": "Saint James",
	"JM-09": "Hanover",
	"JM-10": "Westmoreland",
	"JM-11": "Saint Elizabeth",
	"JM-12": "Manchester",
	"JM-13": "Clarendon",
	"JM-14": "Saint Catherine",
	"JO-AJ": "'Ajlun",
	"JO-AM": "Al 'Asimah",
	"JO-AQ": "Al 'Aqabah",
	"JO-AT": "At Tafilah",
	"JO-AZ": "Az Zarqa'",
	"JO-BA": "Al Balqa'",
	"JO-IR": "Irbid",
	"JO-JA": "Jarash",
	"JO-KA": "Al Karak",
	"JO-MA": "Al Mafraq",
	"JO-MD": "Madaba",
	"JO-MN": "Ma'an",
	"JP-01": "Hokkaido",
	"JP-02": "Aomori",
	"JP-03": "Iwate",
	"JP-04": "Miyagi",
	"JP-05": "Akita",
	"JP-06": "Yamagata",
	"JP-07": "Fukushima",
	"JP-08": "Ibaraki",
	"JP-09": "Tochigi",
	"JP-10": "Gunma",
	"JP-11": "Saitama",
	"JP-12": "Chiba",
	"JP-13": "Tokyo",
	"JP-14": "Kanagawa",
	"JP-15": "Niigata",
	"JP-16": "Toyama",
	"JP-17": "Ishikawa",
	"JP-18": "Fukui",
	"JP-19": "Yamanashi",
	"JP-20": "Nagano",
	"JP-21": "Gifu",
	"JP-22": "Shizuoka",
	"JP-23": "Aichi",
	"JP-24": "Mie",
	"JP-25": "Shiga",
	"JP-26": "Kyoto",
	"JP-27": "Osaka",
	"JP-28": "Hyogo",
	"JP-29": "Nara",
	"JP-30": "Wakayama",
	"JP-31": "Tottori",
	"JP-32": "Shimane",
	"JP-33": "Okayama",
	"JP-34": "Hiroshima",
	"JP-35": "Yamaguchi",
	"JP-36": "Tokushima",
	"JP-37": "Kagawa",
	"JP-38": "Ehime",
	"JP-39": "Kochi",
	"JP-40": "Fukuoka",
	"JP-41": "Saga",
	"JP-42": "Nagasaki",
	"JP-43": "Kumamoto",
	"JP-44": "Oita",
	"JP-45": "Miyazaki",
	"JP-46": "Kagoshima",
	"JP-47": "Okinawa",
	"KE-01": "Baringo",
	"KE-02": "Bomet",
	"KE-03": "Bungoma",
	"KE-04": "Busia",
	"KE-05": "Elgeyo/Marakwet",
	"KE-06": "Embu",
	"KE-07": "Garissa",
	"KE-08": "Homa Bay",
	"KE-09": "Isiolo",
	"KE-10": "Kajiado",
	"KE-11": "Kakamega",
	"KE-12": "Kericho",
	"KE-13": "Kiambu",
	"KE-14": "Kilifi",
	"KE-15": "Kirinyaga",
	"KE-16": "Kisii",
	"KE-17": "Kisumu",
	"KE-18": "Kitui",
	"KE-19": "Kwale",
	"KE-20": "Laikipia",
	"KE-21": "Lamu",
	"KE-22": "Machakos",
	"KE-23": "Makueni",
	"KE-24": "Mandera",
	"KE-25": "Marsabit",
	"KE-26": "Meru",
	"KE-27": "Migori",
	"KE-28": "Mombasa",
	"KE-29": "Murang'a",
	"KE-30": "Nairobi City",
	"KE-31": "Nakuru",
	"KE-32": "Nandi",
	"KE-33": "Narok",
	"KE-34": "Nyamira",
	"KE-35": "Nyandarua",
	"KE-36": "Nyeri",
	"KE-37": "Samburu",
	"KE-38": "Siaya",
	"KE-39": "Taita/Taveta",
	"KE-40": "Tana River",
	"KE-41": "Tharaka-Nithi",
	"KE-42": "Trans Nzoia",
	"KE-43": "Turkana",
	"KE-44": "Uasin Gishu",
	"KE-45": "Vihiga",
	"KE-46": "Wajir",
	"KE-47": "West Pokot",
	"KG-B": "Batken",
	"KG-C": "Chuy",
	"KG-GB": "Bishkek Shaary",
	"KG-GO": "Osh Shaary",
	"KG-J": "Jalal-Abad",
	"KG-N": "Naryn",
	"KG-T": "Talas",
	"KG-Y": "Ysyk-Kol",
	"KH-1": "Banteay Mean Choay",
	"KH-10": "Kracheh",
	"KH-11": "Mondol Kiri",
	"KH-12": "Phnom Penh",
	"KH-13": "Preah Vihear",
	"KH-14": "Prey Veaeng",
	"KH-15": "Pousaat",
	"KH-17": "Siem Reab",
	"KH-18": "Preah Sihanouk",
	"KH-19": "Stueng Traeng",
	"KH-2": "Baat Dambang",
	"KH-20": "Svaay Rieng",
	"KH-21": "Taakaev",
	"KH-23": "Kaeb",
	"KH-24": "Pailin",
	"KH-3": "Kampong Chaam",
	"KH-4": "Kampong Chhnang",
	"KH-5": "Kampong Spueu",
	"KH-6": "Kampong Thum",
	"KH-7": "Kampot",
	"KH-8": "Kandaal",
	"KI-G": "Gilbert Islands",
	"KI-L": "Line Islands",
	"KM-G": "Grande Comore",
	"KM-M": "Moheli",
	"KN-01": "Christ Church Nichola Town",
	"KN-02": "Saint Anne Sandy Point",
	"KN-03": "Saint George Basseterre",
	"KN-05": "Saint James Windward",
	"KN-06": "Saint John Capisterre",
	"KN-07": "Saint John Figtree",
	"KN-08": "Saint Mary Cayon",
	"KN-09": "Saint Paul Capisterre",
	"KN-10": "Saint Paul Charlestown",
	"KN-11": "Saint Peter Basseterre",
	"KN-13": "Saint Thomas Middle Island",
	"KN-15": "Trinity Palmetto Point",
	"KP-01": "P'yongyang",
	"KR-11": "Seoul-teukbyeolsi",
	"KR-26": "Busan-gwangyeoksi",
	"KR-27": "Daegu-gwangyeoksi",
	"KR-28": "Incheon-gwangyeoksi",
	"KR-29": "Gwangju-gwangyeoksi",
	"KR-30": "Daejeon-gwangyeoksi",
	"KR-31": "Ulsan-gwangyeoksi",
	"KR-41": "Gyeonggi-do",
	"KR-42": "Gangwon-do",
	"KR-43": "Chungcheongbuk-do",
	"KR-44": "Chungcheongnam-do",
	"KR-45": "Jeollabuk-do",
	"KR-46": "Jeollanam-do",
	"KR-47": "Gyeongsangbuk-do",
	"KR-48": "Gyeongsangnam-do",
	"KR-49": "Jeju-teukbyeoljachido",
	"KW-AH": "Al Ahmadi",
	"KW-FA": "Al Farwaniyah",
	"KW-HA": "Hawalli",
	"KW-JA": "Al Jahra'",
	"KW-KU": "Al 'Asimah",
	"KW-MU": "Mubarak al Kabir",
	"KZ-10": "Abay oblysy",
	"KZ-11": "Aqmola oblysy",
	"KZ-15": "Aqtobe oblysy",
	"KZ-19": "Almaty oblysy",
	"KZ-23": "Atyrau oblysy",
	"KZ-27": "Batys Qazaqstan oblysy",
	"KZ-31": "Zhambyl oblysy",
	"KZ-33": "Zhetisu oblysy",
	"KZ-35": "Qaraghandy oblysy",
	"KZ-39": "Qostanay oblysy",
	"KZ-43": "Qyzylorda oblysy",
	"KZ-47": "Mangghystau oblysy",
	"KZ-55": "Pavlodar oblysy",
	"KZ-59": "Soltustik Qazaqstan oblysy",
	"KZ-61": "Turkistan oblysy",
	"KZ-62": "Ulytau oblysy",
	"KZ-63": "Shyghys Qazaqstan oblysy",
	"KZ-71": "Astana",
	"KZ-75": "Almaty",
	"KZ-79": "Shymkent",
	"LA-AT": "Attapu",
	"LA-BK": "Bokeo",
	"LA-BL": "Bolikhamxai",
	"LA-CH": "Champasak",
	"LA-KH": "Khammouan",
	"LA-LP": "Louangphabang",
	"LA-OU": "Oudomxai",
	"LA-PH": "Phongsali",
	"LA-SV": "Savannakhet",
	"LA-VI": "Viangchan",
	"LA-XA": "Xaignabouli",
	"LA-XE": "Xekong",
	"LA-XI": "Xiangkhouang",
	"LB-AK": "Aakkar",
	"LB-AS": "Liban-Nord",
	"LB-BA": "Beyrouth",
	"LB-BH": "Baalbek-Hermel",
	"LB-BI": "Beqaa",
	"LB-JA": "Liban-Sud",
	"LB-JL": "Mont-Liban",
	"LB-NA": "Nabatiye",
	"LC-01": "Anse la Raye",
	"LC-02": "Castries",
	"LC-03": "Choiseul",
	"LC-05": "Dennery",
	"LC-06": "Gros Islet",
	"LC-07": "Laborie",
	"LC-08": "Micoud",
	"LC-10": "Soufriere",
	"LC-11": "Vieux Fort",
	"LI-01": "Balzers",
	"LI-02": "Eschen",
	"LI-03": "Gamprin",
	"LI-04": "Mauren",
	"LI-06": "Ruggell",
	"LI-07": "Schaan",
	"LI-09": "Triesen",
	"LI-10": "Triesenberg",
	"LI-11": "Vaduz",
	"LK-1": "Western Province",
	"LK-2": "Central Province",
	"LK-3": "Southern Province",
	"LK-4": "Northern Province",
	"LK-5": "Eastern Province",
	"LK-6": "North Western Province",
	"LK-7": "North Central Province",
	"LK-8": "Uva Province",
	"LK-9": "Sabaragamuwa Province",
	"LR-BG": "Bong",
	"LR-BM": "Bomi",
	"LR-GB": "Grand Bassa",
	"LR-GG": "Grand Gedeh",
	"LR-MG": "Margibi",
	"LR-MO": "Montserrado",
	"LR-MY": "Maryland",
	"LR-RI": "River Cess",
	"LR-SI": "Sinoe",
	"LS-A": "Maseru",
	"LS-B": "Botha-Bothe",
	"LS-C": "Leribe",
	"LS-D": "Berea",
	"LS-E": "Mafeteng",
	"LS-F": "Mohale's Hoek",
	"LS-G": "Quthing",
	"LS-H": "Qacha's Nek",
	"LS-J": "Mokhotlong",
	"LS-K": "Thaba-Tseka",
	"LT-AL": "Alytaus apskritis",
	"LT-KL": "Klaipedos apskritis",
	"LT-KU": "Kauno apskritis",
	"LT-MR": "Marijampoles apskritis",
	"LT-PN": "Panevezio apskritis",
	"LT-SA": "Siauliu apskritis",
	"LT-TA": "Taurages apskritis",
	"LT-TE": "Telsiu apskritis",
	"LT-UT": "Utenos apskritis",
	"LT-VL": "Vilniaus apskritis",
	"LU-CA": "Capellen",
	"LU-CL": "Clervaux",
	"LU-DI": "Diekirch",
	"LU-EC": "Echternach",
	"LU-ES": "Esch-sur-Alzette",
	"LU-GR": "Grevenmacher",
	"LU-LU": "Luxembourg",
	"LU-ME": "Mersch",
	"LU-RD": "Redange",
	"LU-RM": "Remich",
	"LU-VD": "Vianden",
	"LU-WI": "Wiltz",
	"LV-002": "Aizkraukles novads",
	"LV-007": "Aluksnes novads",
	"LV-011": "Adazu novads",
	"LV-015": "Balvu novads",
	"LV-016": "Bauskas novads",
	"LV-022": "Cesu novads",
	"LV-026": "Dobeles novads",
	"LV-033": "Gulbenes novads",
	"LV-041": "Jelgavas novads",
	"LV-042": "Jekabpils novads",
	"LV-047": "Kraslavas novads",
	"LV-050": "Kuldigas novads",
	"LV-052": "Kekavas novads",
	"LV-054": "Limbazu novads",
	"LV-056": "Livanu novads",
	"LV-058": "Ludzas novads",
	"LV-059": "Madonas novads",
	"LV-062": "Marupes novads",
	"LV-067": "Ogres novads",
	"LV-068": "Olaines novads",
	"LV-073": "Preilu novads",
	"LV-077": "Rezeknes novads",
	"LV-080": "Ropazu novads",
	"LV-087": "Salaspils novads",
	"LV-088": "Saldus novads",
	"LV-089": "Saulkrastu novads",
	"LV-091": "Siguldas novads",
	"LV-094": "Smiltenes novads",
	"LV-097": "Talsu novads",
	"LV-099": "Tukuma novads",
	"LV-101": "Valkas novads",
	"LV-102": "Varaklanu novads",
	"LV-106": "Ventspils novads",
	"LV-111": "Augsdaugavas novads",
	"LV-112": "Dienvidkurzemes novads",
	"LV-113": "Valmieras novads",
	"LV-DGV": "Daugavpils",
	"LV-JEL": "Jelgava",
	"LV-JUR": "Jurmala",
	"LV-LPX": "Liepaja",
	"LV-RIX": "Riga",
	"LY-BA": "Banghazi",
	"LY-BU": "Al Butnan",
	"LY-DR": "Darnah",
	"LY-JA": "Al Jabal al Akhdar",
	"LY-JG": "Al Jabal al Gharbi",
	"LY-JI": "Al Jafarah",
	"LY-JU": "Al Jufrah",
	"LY-KF": "Al Kufrah",
	"LY-MB": "Al Marqab",
	"LY-MI": "Misratah",
	"LY-MJ": "Al Marj",
	"LY-NL": "Nalut",
	"LY-NQ": "An Nuqat al Khams",
	"LY-SB": "Sabha",
	"LY-SR": "Surt",
	"LY-TB": "Tarabulus",
	"LY-WA": "Al Wahat",
	"LY-WS": "Wadi ash Shati'",
	"LY-ZA": "Az Zawiyah",
	"MA-01": "Tanger-Tetouan-Al Hoceima",
	"MA-02": "L'Oriental",
	"MA-03": "Fes- Meknes",
	"MA-04": "Rabat-Sale-Kenitra",
	"MA-05": "Beni-Mellal-Khenifra",
	"MA-06": "Casablanca-Settat",
	"MA-07": "Marrakech-Safi",
	"MA-08": "Draa-Tafilalet",
	"MA-09": "Souss-Massa",
	"MA-10": "Guelmim-Oued Noun (EH-partial)",
	"MA-11": "Laayoune-Sakia El Hamra (EH-partial)",
	"MC-CO": "La Condamine",
	"MC-FO": "Fontvieille",
	"MC-MC": "Monte-Carlo",
	"MC-MG": "Moneghetti",
	"MC-MO": "Monaco-Ville",
	"MC-SR": "Saint-Roman",
	"MD-AN": "Anenii Noi",
	"MD-BA": "Balti",
	"MD-BD": "Bender",
	"MD-BR": "Briceni",
	"MD-BS": "Basarabeasca",
	"MD-CA": "Cahul",
	"MD-CL": "Calarasi",
	"MD-CM": "Cimislia",
	"MD-CR": "Criuleni",
	"MD-CS": "Causeni",
	"MD-CT": "Cantemir",
	"MD-CU": "Chisinau",
	"MD-DO": "Donduseni",
	"MD-DR": "Drochia",
	"MD-DU": "Dubasari",
	"MD-ED": "Edinet",
	"MD-FA": "Falesti",
	"MD-FL": "Floresti",
	"MD-GA": "Gagauzia, Unitatea teritoriala autonoma",
	"MD-GL": "Glodeni",
	"MD-HI": "Hincesti",
	"MD-IA": "Ialoveni",
	"MD-LE": "Leova",
	"MD-NI": "Nisporeni",
	"MD-OC": "Ocnita",
	"MD-OR": "Orhei",
	"MD-RE": "Rezina",
	"MD-RI": "Riscani",
	"MD-SD": "Soldanesti",
	"MD-SI": "Singerei",
	"MD-SN": "Stinga Nistrului, unitatea teritoriala din",
	"MD-SO": "Soroca",
	"MD-ST": "Straseni",
	"MD-SV": "Stefan Voda",
	"MD-TA": "Taraclia",
	"MD-TE": "Telenesti",
	"MD-UN": "Ungheni",
	"ME-01": "Andrijevica",
	"ME-02": "Bar",
	"ME-03": "Berane",
	"ME-04": "Bijelo Polje",
	"ME-05": "Budva",
	"ME-06": "Cetinje",
	"ME-07": "Danilovgrad",
	"ME-08": "Herceg-Novi",
	"ME-09": "Kolasin",
	"ME-10": "Kotor",
	"ME-12": "Niksic",
	"ME-13": "Plav",
	"ME-14": "Pljevlja",
	"ME-15": "Pluzine",
	"ME-16": "Podgorica",
	"ME-17": "Rozaje",
	"ME-19": "Tivat",
	"ME-20": "Ulcinj",
	"ME-21": "Zabljak",
	"ME-24": "Tuzi",
	"MG-A": "Toamasina",
	"MG-D": "Antsiranana",
	"MG-F": "Fianarantsoa",
	"MG-M": "Mahajanga",
	"MG-T": "Antananarivo",
	"MG-U": "Toliara",
	"MH-KWA": "Kwajalein",
	"MH-MAJ": "Majuro",
	"MK-101": "Veles",
	"MK-102": "Gradsko",
	"MK-103": "Demir Kapija",
	"MK-104": "Kavadarci",
	"MK-105": "Lozovo",
	"MK-106": "Negotino",
	"MK-107": "Rosoman",
	"MK-108": "Sveti Nikole",
	"MK-109": "Caska",
	"MK-201": "Berovo",
	"MK-202": "Vinica",
	"MK-205": "Karbinci",
	"MK-206": "Kocani",
	"MK-207": "Makedonska Kamenica",
	"MK-208": "Pehcevo",
	"MK-209": "Probistip",
	"MK-210": "Cesinovo-Oblesevo",
	"MK-211": "Stip",
	"MK-301": "Vevcani",
	"MK-303": "Debar",
	"MK-307": "Kicevo",
	"MK-308": "Makedonski Brod",
	"MK-310": "Ohrid",
	"MK-311": "Plasnica",
	"MK-312": "Struga",
	"MK-401": "Bogdanci",
	"MK-402": "Bosilovo",
	"MK-403": "Valandovo",
	"MK-404": "Vasilevo",
	"MK-405": "Gevgelija",
	"MK-406": "Dojran",
	"MK-408": "Novo Selo",
	"MK-409": "Radovis",
	"MK-410": "Strumica",
	"MK-501": "Bitola",
	"MK-502": "Demir Hisar",
	"MK-503": "Dolneni",
	"MK-505": "Krusevo",
	"MK-506": "Mogila",
	"MK-507": "Novaci",
	"MK-508": "Prilep",
	"MK-509": "Resen",
	"MK-601": "Bogovinje",
	"MK-602": "Brvenica",
	"MK-604": "Gostivar",
	"MK-605": "Zelino",
	"MK-606": "Jegunovce",
	"MK-607": "Mavrovo i Rostusa",
	"MK-608": "Tearce",
	"MK-609": "Tetovo",
	"MK-701": "Kratovo",
	"MK-702": "Kriva Palanka",
	"MK-703": "Kumanovo",
	"MK-704": "Lipkovo",
	"MK-705": "Rankovce",
	"MK-802": "Aracinovo",
	"MK-803": "Butel",
	"MK-804": "Gazi Baba",
	"MK-806": "Zelenikovo",
	"MK-807": "Ilinden",
	"MK-809": "Kisela Voda",
	"MK-810": "Petrovec",
	"MK-811": "Saraj",
	"MK-812": "Sopiste",
	"MK-813": "Studenicani",
	"MK-814": "Centar",
	"MK-816": "Cucer Sandevo",
	"ML-1": "Kayes",
	"ML-2": "Koulikoro",
	"ML-3": "Sikasso",
	"ML-4": "Segou",
	"ML-5": "Mopti",
	"ML-6": "Tombouctou",
	"ML-7": "Gao",
	"ML-8": "Kidal",
	"ML-BKO": "Bamako",
	"MM-01": "Sagaing",
	"MM-02": "Bago",
	"MM-03": "Magway",
	"MM-04": "Mandalay",
	"MM-05": "Tanintharyi",
	"MM-06": "Yangon",
	"MM-07": "Ayeyarwady",
	"MM-11": "Kachin",
	"MM-12": "Kayah",
	"MM-13": "Kayin",
	"MM-15": "Mon",
	"MM-16": "Rakhine",
	"MM-17": "Shan",
	"MM-18": "Nay Pyi Taw",
	"MN-035": "Orhon",
	"MN-043": "Hovd",
	"MN-047": "Tov",
	"MN-049": "Selenge",
	"MN-055": "Ovorhangay",
	"MN-061": "Dornod",
	"MN-065": "Govi-Altay",
	"MN-069": "Bayanhongor",
	"MN-1": "Ulaanbaatar",
	"MR-01": "Hodh ech Chargui",
	"MR-02": "Hodh el Gharbi",
	"MR-03": "Assaba",
	"MR-04": "Gorgol",
	"MR-05": "Brakna",
	"MR-06": "Trarza",
	"MR-07": "Adrar",
	"MR-08": "Dakhlet Nouadhibou",
	"MR-09": "Tagant",
	"MR-11": "Tiris Zemmour",
	"MR-12": "Inchiri",
	"MR-13": "Nouakchott Ouest",
	"MT-01": "Attard",
	"MT-02": "Balzan",
	"MT-03": "Birgu",
	"MT-04": "Birkirkara",
	"MT-05": "Birzebbuga",
	"MT-06": "Bormla",
	"MT-07": "Dingli",
	"MT-08": "Fgura",
	"MT-09": "Floriana",
	"MT-10": "Fontana",
	"MT-11": "Gudja",
	"MT-12": "Gzira",
	"MT-13": "Ghajnsielem",
	"MT-14": "Gharb",
	"MT-15": "Gharghur",
	"MT-16": "Ghasri",
	"MT-17": "Ghaxaq",
	"MT-18": "Hamrun",
	"MT-19": "Iklin",
	"MT-20": "Isla",
	"MT-21": "Kalkara",
	"MT-23": "Kirkop",
	"MT-24": "Lija",
	"MT-25": "Luqa",
	"MT-26": "Marsa",
	"MT-27": "Marsaskala",
	"MT-28": "Marsaxlokk",
	"MT-29": "Mdina",
	"MT-30": "Mellieha",
	"MT-31": "Mgarr",
	"MT-32": "Mosta",
	"MT-33": "Mqabba",
	"MT-34": "Msida",
	"MT-35": "Mtarfa",
	"MT-36": "Munxar",
	"MT-37": "Nadur",
	"MT-38": "Naxxar",
	"MT-39": "Paola",
	"MT-40": "Pembroke",
	"MT-41": "Pieta",
	"MT-42": "Qala",
	"MT-43": "Qormi",
	"MT-44": "Qrendi",
	"MT-45": "Rabat Gozo",
	"MT-46": "Rabat Malta",
	"MT-47": "Safi",
	"MT-48": "Saint Julian's",
	"MT-49": "Saint John",
	"MT-50": "Saint Lawrence",
	"MT-51": "Saint Paul's Bay",
	"MT-52": "Sannat",
	"MT-53": "Saint Lucia's",
	"MT-54": "Santa Venera",
	"MT-55": "Siggiewi",
	"MT-56": "Sliema",
	"MT-57": "Swieqi",
	"MT-58": "Ta' Xbiex",
	"MT-59": "Tarxien",
	"MT-60": "Valletta",
	"MT-61": "Xaghra",
	"MT-62": "Xewkija",
	"MT-63": "Xghajra",
	"MT-64": "Zabbar",
	"MT-65": "Zebbug Gozo",
	"MT-67": "Zejtun",
	"MT-68": "Zurrieq",
	"MU-BL": "Black River",
	"MU-FL": "Flacq",
	"MU-GP": "Grand Port",
	"MU-MO": "Moka",
	"MU-PA": "Pamplemousses",
	"MU-PL": "Port Louis",
	"MU-PW": "Plaines Wilhems",
	"MU-RO": "Rodrigues Islands",
	"MU-RR": "Riviere du Rempart",
	"MU-SA": "Savanne",
	"MV-00": "South Ari Atoll",
	"MV-01": "Addu City",
	"MV-02": "North Ari Atoll",
	"MV-03": "Faadhippolhu",
	"MV-04": "Felidhu Atoll",
	"MV-05": "Hahdhunmathi",
	"MV-07": "North Thiladhunmathi",
	"MV-12": "Mulaku Atoll",
	"MV-13": "North Maalhosmadulu",
	"MV-20": "South Maalhosmadulu",
	"MV-23": "South Thiladhunmathi",
	"MV-25": "South Miladhunmadulu",
	"MV-28": "South Huvadhu Atoll",
	"MV-MLE": "Male",
	"MW-BA": "Balaka",
	"MW-BL": "Blantyre",
	"MW-CK": "Chikwawa",
	"MW-CR": "Chiradzulu",
	"MW-DE": "Dedza",
	"MW-DO": "Dowa",
	"MW-KR": "Karonga",
	"MW-LI": "Lilongwe",
	"MW-MC": "Mchinji",
	"MW-MG": "Mangochi",
	"MW-MH": "Machinga",
	"MW-MW": "Mwanza",
	"MW-MZ": "Mzimba",
	"MW-NE": "Neno",
	"MW-NI": "Ntchisi",
	"MW-NK": "Nkhotakota",
	"MW-SA": "Salima",
	"MW-TH": "Thyolo",
	"MW-ZO": "Zomba",
	"MX-AGU": "Aguascalientes",
	"MX-BCN": "Baja California",
	"MX-BCS": "Baja California Sur",
	"MX-CAM": "Campeche",
	"MX-CHH": "Chihuahua",
	"MX-CHP": "Chiapas",
	"MX-CMX": "Ciudad de Mexico",
	"MX-COA": "Coahuila de Zaragoza",
	"MX-COL": "Colima",
	"MX-DUR": "Durango",
	"MX-GRO": "Guerrero",
	"MX-GUA": "Guanajuato",
	"MX-HID": "Hidalgo",
	"MX-JAL": "Jalisco",
	"MX-MEX": "Mexico",
	"MX-MIC": "Michoacan de Ocampo",
	"MX-MOR": "Morelos",
	"MX-NAY": "Nayarit",
	"MX-NLE": "Nuevo Leon",
	"MX-OAX": "Oaxaca",
	"MX-PUE": "Puebla",
	"MX-QUE": "Queretaro",
	"MX-ROO": "Quintana Roo",
	"MX-SIN": "Sinaloa",
	"MX-SLP": "San Luis Potosi",
	"MX-SON": "Sonora",
	"MX-TAB": "Tabasco",
	"MX-TAM": "Tamaulipas",
	"MX-TLA": "Tlaxcala",
	"MX-VER": "Veracruz de Ignacio de la Llave",
	"MX-YUC": "Yucatan",
	"MX-ZAC": "Zacatecas",
	"MY-01": "Johor",
	"MY-02": "Kedah",
	"MY-03": "Kelantan",
	"MY-04": "Melaka",
	"MY-05": "Negeri Sembilan",
	"MY-06": "Pahang",
	"MY-07": "Pulau Pinang",
	"MY-08": "Perak",
	"MY-09": "Perlis",
	"MY-10": "Selangor",
	"MY-11": "Terengganu",
	"MY-12": "Sabah",
	"MY-13": "Sarawak",
	"MY-14": "Wilayah Persekutuan Kuala Lumpur",
	"MY-15": "Wilayah Persekutuan Labuan",
	"MY-16": "Wilayah Persekutuan Putrajaya",
	"MZ-A": "Niassa",
	"MZ-B": "Manica",
	"MZ-G": "Gaza",
	"MZ-I": "Inhambane",
	"MZ-L": "Maputo",
	"MZ-N": "Nampula",
	"MZ-P": "Cabo Delgado",
	"MZ-Q": "Zambezia",
	"MZ-S": "Sofala",
	"MZ-T": "Tete",
	"NA-CA": "Zambezi",
	"NA-ER": "Erongo",
	"NA-HA": "Hardap",
	"NA-KA": "Karas",
	"NA-KE": "Kavango East",
	"NA-KH": "Khomas",
	"NA-KU": "Kunene",
	"NA-KW": "Kavango West",
	"NA-OD": "Otjozondjupa",
	"NA-OH": "Omaheke",
	"NA-ON": "Oshana",
	"NA-OS": "Omusati",
	"NA-OT": "Oshikoto",
	"NA-OW": "Ohangwena",
	"NE-1": "Agadez",
	"NE-2": "Diffa",
	"NE-3": "Dosso",
	"NE-5": "Tahoua",
	"NE-6": "Tillaberi",
	"NE-7": "Zinder",
	"NE-8": "Niamey",
	"NG-AB": "Abia",
	"NG-AD": "Adamawa",
	"NG-AK": "Akwa Ibom",
	"NG-AN": "Anambra",
	"NG-BA": "Bauchi",
	"NG-BE": "Benue",
	"NG-BO": "Borno",
	"NG-BY": "Bayelsa",
	"NG-CR": "Cross River",
	"NG-DE": "Delta",
	"NG-EB": "Ebonyi",
	"NG-ED": "Edo",
	"NG-EK": "Ekiti",
	"NG-EN": "Enugu",
	"NG-FC": "Abuja Federal Capital Territory",
	"NG-GO": "Gombe",
	"NG-IM": "Imo",
	"NG-JI": "Jigawa",
	"NG-KD": "Kaduna",
	"NG-KE": "Kebbi",
	"NG-KN": "Kano",
	"NG-KO": "Kogi",
	"NG-KT": "Katsina",
	"NG-KW": "Kwara",
	"NG-LA": "Lagos",
	"NG-NA": "Nasarawa",
	"NG-NI": "Niger",
	"NG-OG": "Ogun",
	"NG-ON": "Ondo",
	"NG-OS": "Osun",
	"NG-OY": "Oyo",
	"NG-PL": "Plateau",
	"NG-RI": "Rivers",
	"NG-SO": "Sokoto",
	"NG-TA": "Taraba",
	"NG-YO": "Yobe",
	"NG-ZA": "Zamfara",
	"NI-AN": "Costa Caribe Norte",
	"NI-AS": "Costa Caribe Sur",
	"NI-BO": "Boaco",
	"NI-CA": "Carazo",
	"NI-CI": "Chinandega",
	"NI-CO": "Chontales",
	"NI-ES": "Esteli",
	"NI-GR": "Granada",
	"NI-JI": "Jinotega",
	"NI-LE": "Leon",
	"NI-MD": "Madriz",
	"NI-MN": "Managua",
	"NI-MS": "Masaya",
	"NI-MT": "Matagalpa",
	"NI-NS": "Nueva Segovia",
	"NI-RI": "Rivas",
	"NI-SJ": "Rio San Juan",
	"NL-DR": "Drenthe",
	"NL-FL": "Flevoland",
	"NL-FR": "Fryslan",
	"NL-GE": "Gelderland",
	"NL-GR": "Groningen",
	"NL-LI": "Limburg",
	"NL-NB": "Noord-Brabant",
	"NL-NH": "Noord-Holland",
	"NL-OV": "Overijssel",
	"NL-UT": "Utrecht",
	"NL-ZE": "Zeeland",
	"NL-ZH": "Zuid-Holland",
	"NO-03": "Oslo",
	"NO-11": "Rogaland",
	"NO-15": "More og Romsdal",
	"NO-18": "Nordland",
	"NO-30": "Viken",
	"NO-34": "Innlandet",
	"NO-38": "Vestfold og Telemark",
	"NO-42": "Agder",
	"NO-46": "Vestland",
	"NO-50": "Trondelag",
	"NO-54": "Troms og Finnmark",
	"NP-BA": "Bagmati",
	"NP-BH": "Bheri",
	"NP-DH": "Dhawalagiri",
	"NP-GA": "Gandaki",
	"NP-JA": "Janakpur",
	"NP-KA": "Karnali",
	"NP-KO": "Kosi",
	"NP-LU": "Lumbini",
	"NP-MA": "Mahakali",
	"NP-ME": "Mechi",
	"NP-NA": "Narayani",
	"NP-RA": "Rapti",
	"NP-SA": "Sagarmatha",
	"NP-SE": "Seti",
	"NR-01": "Aiwo",
	"NR-03": "Anetan",
	"NR-14": "Yaren",
	"NZ-AUK": "Auckland",
	"NZ-BOP": "Bay of Plenty",
	"NZ-CAN": "Canterbury",
	"NZ-CIT": "Chatham Islands Territory",
	"NZ-GIS": "Gisborne",
	"NZ-HKB": "Hawke's Bay",
	"NZ-MBH": "Marlborough",
	"NZ-MWT": "Manawatu-Wanganui",
	"NZ-NSN": "Nelson",
	"NZ-NTL": "Northland",
	"NZ-OTA": "Otago",
	"NZ-STL": "Southland",
	"NZ-TAS": "Tasman",
	"NZ-TKI": "Taranaki",
	"NZ-WGN": "Wellington",
	"NZ-WKO": "Waikato",
	"NZ-WTC": "West Coast",
	"OM-BJ": "Janub al Batinah",
	"OM-BS": "Shamal al Batinah",
	"OM-BU": "Al Buraymi",
	"OM-DA": "Ad Dakhiliyah",
	"OM-MA": "Masqat",
	"OM-MU": "Musandam",
	"OM-SJ": "Janub ash Sharqiyah",
	"OM-SS": "Shamal ash Sharqiyah",
	"OM-WU": "Al Wusta",
	"OM-ZA": "Az Zahirah",
	"OM-ZU": "Zufar",
	"PA-1": "Bocas del Toro",
	"PA-2": "Cocle",
	"PA-3": "Colon",
	"PA-4": "Chiriqui",
	"PA-5": "Darien",
	"PA-6": "Herrera",
	"PA-7": "Los Santos",
	"PA-8": "Panama",
	"PA-9": "Veraguas",
	"PA-KY": "Guna Yala",
	"PA-NB": "Ngobe-Bugle",
	"PE-AMA": "Amazonas",
	"PE-ANC": "Ancash",
	"PE-APU": "Apurimac",
	"PE-ARE": "Arequipa",
	"PE-AYA": "Ayacucho",
	"PE-CAJ": "Cajamarca",
	"PE-CAL": "El Callao",
	"PE-CUS": "Cusco",
	"PE-HUC": "Huanuco",
	"PE-HUV": "Huancavelica",
	"PE-ICA": "Ica",
	"PE-JUN": "Junin",
	"PE-LAL": "La Libertad",
	"PE-LAM": "Lambayeque",
	"PE-LIM": "Lima",
	"PE-LMA": "Municipalidad Metropolitana de Lima",
	"PE-LOR": "Loreto",
	"PE-MDD": "Madre de Dios",
	"PE-MOQ": "Moquegua",
	"PE-PAS": "Pasco",
	"PE-PIU": "Piura",
	"PE-PUN": "Puno",
	"PE-SAM": "San Martin",
	"PE-TAC": "Tacna",
	"PE-TUM": "Tumbes",
	"PE-UCA": "Ucayali",
	"PF-A": "Austral Islands",
	"PF-M": "Marquesas Islands",
	"PF-S": "Society Islands",
	"PF-T": "Tuamotu and Gambier Islands",
	"PF-V": "Windward Islands",
	"PG-CPK": "Chimbu",
	"PG-CPM": "Central",
	"PG-EBR": "East New Britain",
	"PG-EHG": "Eastern Highlands",
	"PG-ESW": "East Sepik",
	"PG-MBA": "Milne Bay",
	"PG-MPL": "Morobe",
	"PG-MPM": "Madang",
	"PG-MRL": "Manus",
	"PG-NCD": "National Capital District (Port Moresby)",
	"PG-NIK": "New Ireland",
	"PG-NSB": "Bougainville",
	"PG-SAN": "West Sepik",
	"PG-SHM": "Southern Highlands",
	"PG-WBK": "West New Britain",
	"PG-WHM": "Western Highlands",
	"PG-WPD": "Western",
	"PH-00": "National Capital Region",
	"PH-01": "Ilocos",
	"PH-02": "Cagayan Valley",
	"PH-03": "Central Luzon",
	"PH-05": "Bicol",
	"PH-06": "Western Visayas",
	"PH-07": "Central Visayas",
	"PH-08": "Eastern Visayas",
	"PH-09": "Zamboanga Peninsula",
	"PH-10": "Northern Mindanao",
	"PH-11": "Davao",
	"PH-12": "Soccsksargen",
	"PH-13": "Caraga",
	"PH-14": "Autonomous Region in Muslim Mindanao",
	"PH-15": "Cordillera Administrative Region",
	"PH-40": "Calabarzon",
	"PH-41": "Mimaropa",
	"PH-ABR": "Abra",
	"PH-AGN": "Agusan del Norte",
	"PH-AGS": "Agusan del Sur",
	"PH-AKL": "Aklan",
	"PH-ALB": "Albay",
	"PH-ANT": "Antique",
	"PH-APA": "Apayao",
	"PH-AUR": "Aurora",
	"PH-BAN": "Bataan",
	"PH-BAS": "Basilan",
	"PH-BEN": "Benguet",
	"PH-BIL": "Biliran",
	"PH-BOH": "Bohol",
	"PH-BTG": "Batangas",
	"PH-BTN": "Batanes",
	"PH-BUK": "Bukidnon",
	"PH-BUL": "Bulacan",
	"PH-CAG": "Cagayan",
	"PH-CAM": "Camiguin",
	"PH-CAN": "Camarines Norte",
	"PH-CAP": "Capiz",
	"PH-CAS": "Camarines Sur",
	"PH-CAT": "Catanduanes",
	"PH-CAV": "Cavite",
	"PH-CEB": "Cebu",
	"PH-COM": "Davao de Oro",
	"PH-DAO": "Davao Oriental",
	"PH-DAS": "Davao del Sur",
	"PH-DAV": "Davao del Norte",
	"PH-DIN": "Dinagat Islands",
	"PH-EAS": "Eastern Samar",
	"PH-GUI": "Guimaras",
	"PH-IFU": "Ifugao",
	"PH-ILI": "Iloilo",
	"PH-ILN": "Ilocos Norte",
	"PH-ILS": "Ilocos Sur",
	"PH-ISA": "Isabela",
	"PH-KAL": "Kalinga",
	"PH-LAG": "Laguna",
	"PH-LAN": "Lanao del Norte",
	"PH-LAS": "Lanao del Sur",
	"PH-LEY": "Leyte",
	"PH-LUN": "La Union",
	"PH-MAD": "Marinduque",
	"PH-MAG": "Maguindanao",
	"PH-MAS": "Masbate",
	"PH-MDC": "Mindoro Occidental",
	"PH-MDR": "Mindoro Oriental",
	"PH-MOU": "Mountain Province",
	"PH-MSC": "Misamis Occidental",
	"PH-MSR": "Misamis Oriental",
	"PH-NCO": "Cotabato",
	"PH-NEC": "Negros Occidental",
	"PH-NER": "Negros Oriental",
	"PH-NSA": "Northern Samar",
	"PH-NUE": "Nueva Ecija",
	"PH-NUV": "Nueva Vizcaya",
	"PH-PAM": "Pampanga",
	"PH-PAN": "Pangasinan",
	"PH-PLW": "Palawan",
	"PH-QUE": "Quezon",
	"PH-QUI": "Quirino",
	"PH-RIZ": "Rizal",
	"PH-ROM": "Romblon",
	"PH-SAR": "Sarangani",
	"PH-SCO": "South Cotabato",
	"PH-SIG": "Siquijor",
	"PH-SLE": "Southern Leyte",
	"PH-SLU": "Sulu",
	"PH-SOR": "Sorsogon",
	"PH-SUK": "Sultan Kudarat",
	"PH-SUN": "Surigao del Norte",
	"PH-SUR": "Surigao del Sur",
	"PH-TAR": "Tarlac",
	"PH-TAW": "Tawi-Tawi",
	"PH-WSA": "Samar",
	"PH-ZAN": "Zamboanga del Norte",
	"PH-ZAS": "Zamboanga del Sur",
	"PH-ZMB": "Zambales",
	"PH-ZSI": "Zamboanga Sibugay",
	"PK-BA": "Balochistan",
	"PK-GB": "Gilgit-Baltistan",
	"PK-IS": "Islamabad",
	"PK-JK": "Azad Jammu and Kashmir",
	"PK-KP": "Khyber Pakhtunkhwa",
	"PK-PB": "Punjab",
	"PK-SD": "Sindh",
	"PL-02": "Dolnoslaskie",
	"PL-04": "Kujawsko-pomorskie",
	"PL-06": "Lubelskie",
	"PL-08": "Lubuskie",
	"PL-10": "Lodzkie",
	"PL-12": "Malopolskie",
	"PL-14": "Mazowieckie",
	"PL-16": "Opolskie",
	"PL-18": "Podkarpackie",
	"PL-20": "Podlaskie",
	"PL-22": "Pomorskie",
	"PL-24": "Slaskie",
	"PL-26": "Swietokrzyskie",
	"PL-28": "Warminsko-mazurskie",
	"PL-30": "Wielkopolskie",
	"PL-32": "Zachodniopomorskie",
	"PM-P": "Saint-Pierre",
	"PM-M": "Miquelon-Langlade",
	"PS-BTH": "Bethlehem",
	"PS-DEB": "Deir El Balah",
	"PS-GZA": "Gaza",
	"PS-HBN": "Hebron",
	"PS-JEM": "Jerusalem",
	"PS-JEN": "Jenin",
	"PS-JRH": "Jericho and Al Aghwar",
	"PS-KYS": "Khan Yunis",
	"PS-NBS": "Nablus",
	"PS-QQA": "Qalqilya",
	"PS-RBH": "Ramallah",
	"PS-RFH": "Rafah",
	"PS-SLT": "Salfit",
	"PS-TBS": "Tubas",
	"PS-TKM": "Tulkarm",
	"PT-01": "Aveiro",
	"PT-02": "Beja",
	"PT-03": "Braga",
	"PT-04": "Braganca",
	"PT-05": "Castelo Branco",
	"PT-06": "Coimbra",
	"PT-07": "Evora",
	"PT-08": "Faro",
	"PT-09": "Guarda",
	"PT-10": "Leiria",
	"PT-11": "Lisboa",
	"PT-12": "Portalegre",
	"PT-13": "Porto",
	"PT-14": "Santarem",
	"PT-15": "Setubal",
	"PT-16": "Viana do Castelo",
	"PT-17": "Vila Real",
	"PT-18": "Viseu",
	"PT-20": "Regiao Autonoma dos Acores",
	"PT-30": "Regiao Autonoma da Madeira",
	"PW-004": "Airai",
	"PW-150": "Koror",
	"PW-212": "Melekeok",
	"PW-222": "Ngardmau",
	"PY-1": "Concepcion",
	"PY-10": "Alto Parana",
	"PY-11": "Central",
	"PY-12": "Neembucu",
	"PY-13": "Amambay",
	"PY-14": "Canindeyu",
	"PY-15": "Presidente Hayes",
	"PY-19": "Boqueron",
	"PY-2": "San Pedro",
	"PY-3": "Cordillera",
	"PY-4": "Guaira",
	"PY-5": "Caaguazu",
	"PY-6": "Caazapa",
	"PY-7": "Itapua",
	"PY-8": "Misiones",
	"PY-9": "Paraguari",
	"PY-ASU": "Asuncion",
	"QA-DA": "Ad Dawhah",
	"QA-KH": "Al Khawr wa adh Dhakhirah",
	"QA-MS": "Ash Shamal",
	"QA-RA": "Ar Rayyan",
	"QA-US": "Umm Salal",
	"QA-WA": "Al Wakrah",
	"QA-ZA": "Az Za'ayin",
	"RO-AB": "Alba",
	"RO-AG": "Arges",
	"RO-AR": "Arad",
	"RO-B": "Bucuresti",
	"RO-BC": "Bacau",
	"RO-BH": "Bihor",
	"RO-BN": "Bistrita-Nasaud",
	"RO-BR": "Braila",
	"RO-BT": "Botosani",
	"RO-BV": "Brasov",
	"RO-BZ": "Buzau",
	"RO-CJ": "Cluj",
	"RO-CL": "Calarasi",
	"RO-CS": "Caras-Severin",
	"RO-CT": "Constanta",
	"RO-CV": "Covasna",
	"RO-DB": "Dambovita",
	"RO-DJ": "Dolj",
	"RO-GJ": "Gorj",
	"RO-GL": "Galati",
	"RO-GR": "Giurgiu",
	"RO-HD": "Hunedoara",
	"RO-HR": "Harghita",
	"RO-IF": "Ilfov",
	"RO-IL": "Ialomita",
	"RO-IS": "Iasi",
	"RO-MH": "Mehedinti",
	"RO-MM": "Maramures",
	"RO-MS": "Mures",
	"RO-NT": "Neamt",
	"RO-OT": "Olt",
	"RO-PH": "Prahova",
	"RO-SB": "Sibiu",
	"RO-SJ": "Salaj",
	"RO-SM": "Satu Mare",
	"RO-SV": "Suceava",
	"RO-TL": "Tulcea",
	"RO-TM": "Timis",
	"RO-TR": "Teleorman",
	"RO-VL": "Valcea",
	"RO-VN": "Vrancea",
	"RO-VS": "Vaslui",
	"RS-00": "Beograd",
	"RS-01": "Severnobacki okrug",
	"RS-02": "Srednjebanatski okrug",
	"RS-03": "Severnobanatski okrug",
	"RS-04": "Juznobanatski okrug",
	"RS-05": "Zapadnobacki okrug",
	"RS-06": "Juznobacki okrug",
	"RS-07": "Sremski okrug",
	"RS-08": "Macvanski okrug",
	"RS-09": "Kolubarski okrug",
	"RS-10": "Podunavski okrug",
	"RS-11": "Branicevski okrug",
	"RS-12": "Sumadijski okrug",
	"RS-13": "Pomoravski okrug",
	"RS-14": "Borski okrug",
	"RS-15": "Zajecarski okrug",
	"RS-16": "Zlatiborski okrug",
	"RS-17": "Moravicki okrug",
	"RS-18": "Raski okrug",
	"RS-19": "Rasinski okrug",
	"RS-20": "Nisavski okrug",
	"RS-21": "Toplicki okrug",
	"RS-22": "Pirotski okrug",
	"RS-23": "Jablanicki okrug",
	"RS-24": "Pcinjski okrug",
	"RS-26": "Pecki okrug",
	"RS-27": "Prizrenski okrug",
	"RS-28": "Kosovsko-Mitrovacki okrug",
	"RU-AD": "Adygeya, Respublika",
	"RU-AL": "Altay, Respublika",
	"RU-ALT": "Altayskiy kray",
	"RU-AMU": "Amurskaya oblast'",
	"RU-ARK": "Arkhangel'skaya oblast'",
	"RU-AST": "Astrakhanskaya oblast'",
	"RU-BA": "Bashkortostan, Respublika",
	"RU-BEL": "Belgorodskaya oblast'",
	"RU-BRY": "Bryanskaya oblast'",
	"RU-BU": "Buryatiya, Respublika",
	"RU-CE": "Chechenskaya Respublika",
	"RU-CHE": "Chelyabinskaya oblast'",
	"RU-CHU": "Chukotskiy avtonomnyy okrug",
	"RU-CU": "Chuvashskaya Respublika",
	"RU-DA": "Dagestan, Respublika",
	"RU-IN": "Ingushetiya, Respublika",
	"RU-IRK": "Irkutskaya oblast'",
	"RU-IVA": "Ivanovskaya oblast'",
	"RU-KAM": "Kamchatskiy kray",
	"RU-KB": "Kabardino-Balkarskaya Respublika",
	"RU-KC": "Karachayevo-Cherkesskaya Respublika",
	"RU-KDA": "Krasnodarskiy kray",
	"RU-KEM": "Kemerovskaya oblast'",
	"RU-KGD": "Kaliningradskaya oblast'",
	"RU-KGN": "Kurganskaya oblast'",
	"RU-KHA": "Khabarovskiy kray",
	"RU-KHM": "Khanty-Mansiyskiy avtonomnyy okrug",
	"RU-KIR": "Kirovskaya oblast'",
	"RU-KK": "Khakasiya, Respublika",
	"RU-KL": "Kalmykiya, Respublika",
	"RU-KLU": "Kaluzhskaya oblast'",
	"RU-KO": "Komi, Respublika",
	"RU-KOS": "Kostromskaya oblast'",
	"RU-KR": "Kareliya, Respublika",
	"RU-KRS": "Kurskaya oblast'",
	"RU-KYA": "Krasnoyarskiy kray",
	"RU-LEN": "Leningradskaya oblast'",
	"RU-LIP": "Lipetskaya oblast'",
	"RU-MAG": "Magadanskaya oblast'",
	"RU-ME": "Mariy El, Respublika",
	"RU-MO": "Mordoviya, Respublika",
	"RU-MOS": "Moskovskaya oblast'",
	"RU-MOW": "Moskva",
	"RU-MUR": "Murmanskaya oblast'",
	"RU-NEN": "Nenetskiy avtonomnyy okrug",
	"RU-NGR": "Novgorodskaya oblast'",
	"RU-NIZ": "Nizhegorodskaya oblast'",
	"RU-NVS": "Novosibirskaya oblast'",
	"RU-OMS": "Omskaya oblast'",
	"RU-ORE": "Orenburgskaya oblast'",
	"RU-ORL": "Orlovskaya oblast'",
	"RU-PER": "Permskiy kray",
	"RU-PNZ": "Penzenskaya oblast'",
	"RU-PRI": "Primorskiy kray",
	"RU-PSK": "Pskovskaya oblast'",
	"RU-ROS": "Rostovskaya oblast'",
	"RU-RYA": "Ryazanskaya oblast'",
	"RU-SA": "Saha, Respublika",
	"RU-SAK": "Sakhalinskaya oblast'",
	"RU-SAM": "Samarskaya oblast'",
	"RU-SAR": "Saratovskaya oblast'",
	"RU-SE": "Severnaya Osetiya, Respublika",
	"RU-SMO": "Smolenskaya oblast'",
	"RU-SPE": "Sankt-Peterburg",
	"RU-STA": "Stavropol'skiy kray",
	"RU-SVE": "Sverdlovskaya oblast'",
	"RU-TA": "Tatarstan, Respublika",
	"RU-TAM": "Tambovskaya oblast'",
	"RU-TOM": "Tomskaya oblast'",
	"RU-TUL": "Tul'skaya oblast'",
	"RU-TVE": "Tverskaya oblast'",
	"RU-TY": "Tyva, Respublika",
	"RU-TYU": "Tyumenskaya oblast'",
	"RU-UD": "Udmurtskaya Respublika",
	"RU-ULY": "Ul'yanovskaya oblast'",
	"RU-VGG": "Volgogradskaya oblast'",
	"RU-VLA": "Vladimirskaya oblast'",
	"RU-VLG": "Vologodskaya oblast'",
	"RU-VOR": "Voronezhskaya oblast'",
	"RU-YAN": "Yamalo-Nenetskiy avtonomnyy okrug",
	"RU-YAR": "Yaroslavskaya oblast'",
	"RU-YEV": "Yevreyskaya avtonomnaya oblast'",
	"RU-ZAB": "Zabaykal'skiy kray",
	"RW-01": "Ville de Kigali",
	"RW-02": "Est",
	"RW-03": "Nord",
	"RW-04": "Ouest",
	"RW-05": "Sud",
	"SA-01": "Ar Riyad",
	"SA-02": "Makkah al Mukarramah",
	"SA-03": "Al Madinah al Munawwarah",
	"SA-04": "Ash Sharqiyah",
	"SA-05": "Al Qasim",
	"SA-06": "Ha'il",
	"SA-07": "Tabuk",
	"SA-08": "Al Hudud ash Shamaliyah",
	"SA-09": "Jazan",
	"SA-10": "Najran",
	"SA-11": "Al Bahah",
	"SA-12": "Al Jawf",
	"SA-14": "'Asir",
	"SB-CH": "Choiseul",
	"SB-GU": "Guadalcanal",
	"SB-WE": "Western",
	"SC-01": "Anse aux Pins",
	"SC-02": "Anse Boileau",
	"SC-05": "Anse Royale",
	"SC-06": "Baie Lazare",
	"SC-07": "Baie Sainte Anne",
	"SC-08": "Beau Vallon",
	"SC-10": "Bel Ombre",
	"SC-11": "Cascade",
	"SC-13": "Grand Anse Mahe",
	"SC-14": "Grand Anse Praslin",
	"SC-15": "La Digue",
	"SC-16": "English River",
	"SC-20": "Pointe Larue",
	"SC-23": "Takamaka",
	"SD-DC": "Central Darfur",
	"SD-DN": "North Darfur",
	"SD-DS": "South Darfur",
	"SD-DW": "West Darfur",
	"SD-GD": "Gedaref",
	"SD-GK": "West Kordofan",
	"SD-GZ": "Gezira",
	"SD-KA": "Kassala",
	"SD-KH": "Khartoum",
	"SD-KN": "North Kordofan",
	"SD-KS": "South Kordofan",
	"SD-NB": "Blue Nile",
	"SD-NO": "Northern",
	"SD-NR": "River Nile",
	"SD-NW": "White Nile",
	"SD-RS": "Red Sea",
	"SD-SI": "Sennar",
	"SE-AB": "Stockholms lan",
	"SE-AC": "Vasterbottens lan",
	"SE-BD": "Norrbottens lan",
	"SE-C": "Uppsala lan",
	"SE-D": "Sodermanlands lan",
	"SE-E": "Ostergotlands lan",
	"SE-F": "Jonkopings lan",
	"SE-G": "Kronobergs lan",
	"SE-H": "Kalmar lan",
	"SE-I": "Gotlands lan",
	"SE-K": "Blekinge lan",
	"SE-M": "Skane lan",
	"SE-N": "Hallands lan",
	"SE-O": "Vastra Gotalands lan",
	"SE-S": "Varmlands lan",
	"SE-T": "Orebro lan",
	"SE-U": "Vastmanlands lan",
	"SE-W": "Dalarnas lan",
	"SE-X": "Gavleborgs lan",
	"SE-Y": "Vasternorrlands lan",
	"SE-Z": "Jamtlands lan",
	"SH-HL": "Saint Helena",
	"SI-001": "Ajdovscina",
	"SI-002": "Beltinci",
	"SI-003": "Bled",
	"SI-004": "Bohinj",
	"SI-005": "Borovnica",
	"SI-006": "Bovec",
	"SI-007": "Brda",
	"SI-008": "Brezovica",
	"SI-009": "Brezice",
	"SI-010": "Tisina",
	"SI-011": "Celje",
	"SI-012": "Cerklje na Gorenjskem",
	"SI-013": "Cerknica",
	"SI-014": "Cerkno",
	"SI-015": "Crensovci",
	"SI-017": "Crnomelj",
	"SI-018": "Destrnik",
	"SI-019": "Divaca",
	"SI-020": "Dobrepolje",
	"SI-021": "Dobrova-Polhov Gradec",
	"SI-023": "Domzale",
	"SI-024": "Dornava",
	"SI-025": "Dravograd",
	"SI-026": "Duplek",
	"SI-029": "Gornja Radgona",
	"SI-031": "Gornji Petrovci",
	"SI-032": "Grosuplje",
	"SI-033": "Salovci",
	"SI-034": "Hrastnik",
	"SI-035": "Hrpelje-Kozina",
	"SI-036": "Idrija",
	"SI-037": "Ig",
	"SI-038": "Ilirska Bistrica",
	"SI-039": "Ivancna Gorica",
	"SI-040": "Izola",
	"SI-041": "Jesenice",
	"SI-042": "Jursinci",
	"SI-043": "Kamnik",
	"SI-044": "Kanal",
	"SI-045": "Kidricevo",
	"SI-046": "Kobarid",
	"SI-047": "Kobilje",
	"SI-048": "Kocevje",
	"SI-049": "Komen",
	"SI-050": "Koper",
	"SI-052": "Kranj",
	"SI-053": "Kranjska Gora",
	"SI-054": "Krsko",
	"SI-055": "Kungota",
	"SI-056": "Kuzma",
	"SI-057": "Lasko",
	"SI-058": "Lenart",
	"SI-059": "Lendava",
	"SI-060": "Litija",
	"SI-061": "Ljubljana",
	"SI-063": "Ljutomer",
	"SI-064": "Logatec",
	"SI-065": "Loska dolina",
	"SI-066": "Loski Potok",
	"SI-067": "Luce",
	"SI-068": "Lukovica",
	"SI-069": "Majsperk",
	"SI-070": "Maribor",
	"SI-071": "Medvode",
	"SI-072": "Menges",
	"SI-073": "Metlika",
	"SI-074": "Mezica",
	"SI-075": "Miren-Kostanjevica",
	"SI-076": "Mislinja",
	"SI-077": "Moravce",
	"SI-079": "Mozirje",
	"SI-080": "Murska Sobota",
	"SI-081": "Muta",
	"SI-082": "Naklo",
	"SI-083": "Nazarje",
	"SI-084": "Nova Gorica",
	"SI-085": "Novo Mesto",
	"SI-086": "Odranci",
	"SI-087": "Ormoz",
	"SI-090": "Piran",
	"SI-091": "Pivka",
	"SI-092": "Podcetrtek",
	"SI-094": "Postojna",
	"SI-095": "Preddvor",
	"SI-096": "Ptuj",
	"SI-097": "Puconci",
	"SI-098": "Race-Fram",
	"SI-099": "Radece",
	"SI-100": "Radenci",
	"SI-101": "Radlje ob Dravi",
	"SI-102": "Radovljica",
	"SI-103": "Ravne na Koroskem",
	"SI-104": "Ribnica",
	"SI-105": "Rogasovci",
	"SI-106": "Rogaska Slatina",
	"SI-108": "Ruse",
	"SI-109": "Semic",
	"SI-110": "Sevnica",
	"SI-111": "Sezana",
	"SI-112": "Slovenj Gradec",
	"SI-113": "Slovenska Bistrica",
	"SI-114": "Slovenske Konjice",
	"SI-115": "Starse",
	"SI-116": "Sveti Jurij ob Scavnici",
	"SI-117": "Sencur",
	"SI-118": "Sentilj",
	"SI-119": "Sentjernej",
	"SI-120": "Sentjur",
	"SI-121": "Skocjan",
	"SI-122": "Skofja Loka",
	"SI-123": "Skofljica",
	"SI-124": "Smarje pri Jelsah",
	"SI-125": "Smartno ob Paki",
	"SI-126": "Sostanj",
	"SI-127": "Store",
	"SI-128": "Tolmin",
	"SI-129": "Trbovlje",
	"SI-130": "Trebnje",
	"SI-131": "Trzic",
	"SI-132": "Turnisce",
	"SI-133": "Velenje",
	"SI-134": "Velike Lasce",
	"SI-135": "Videm",
	"SI-136": "Vipava",
	"SI-137": "Vitanje",
	"SI-138": "Vodice",
	"SI-139": "Vojnik",
	"SI-140": "Vrhnika",
	"SI-141": "Vuzenica",
	"SI-142": "Zagorje ob Savi",
	"SI-143": "Zavrc",
	"SI-144": "Zrece",
	"SI-146": "Zelezniki",
	"SI-147": "Ziri",
	"SI-148": "Benedikt",
	"SI-149": "Bistrica ob Sotli",
	"SI-150": "Bloke",
	"SI-151": "Braslovce",
	"SI-152": "Cankova",
	"SI-154": "Dobje",
	"SI-155": "Dobrna",
	"SI-156": "Dobrovnik",
	"SI-158": "Grad",
	"SI-159": "Hajdina",
	"SI-160": "Hoce-Slivnica",
	"SI-161": "Hodos",
	"SI-162": "Horjul",
	"SI-164": "Komenda",
	"SI-165": "Kostel",
	"SI-166": "Krizevci",
	"SI-167": "Lovrenc na Pohorju",
	"SI-168": "Markovci",
	"SI-169": "Miklavz na Dravskem polju",
	"SI-170": "Mirna Pec",
	"SI-171": "Oplotnica",
	"SI-172": "Podlehnik",
	"SI-173": "Polzela",
	"SI-174": "Prebold",
	"SI-175": "Prevalje",
	"SI-176": "Razkrizje",
	"SI-179": "Sodrazica",
	"SI-180": "Solcava",
	"SI-182": "Sveti Andraz v Slovenskih Goricah",
	"SI-183": "Sempeter-Vrtojba",
	"SI-184": "Tabor",
	"SI-185": "Trnovska Vas",
	"SI-186": "Trzin",
	"SI-187": "Velika Polana",
	"SI-188": "Verzej",
	"SI-189": "Vransko",
	"SI-190": "Zalec",
	"SI-191": "Zetale",
	"SI-193": "Zuzemberk",
	"SI-194": "Smartno pri Litiji",
	"SI-195": "Apace",
	"SI-196": "Cirkulane",
	"SI-197": "Kosanjevica na Krki",
	"SI-198": "Makole",
	"SI-199": "Mokronog-Trebelno",
	"SI-200": "Poljcane",
	"SI-201": "Rence-Vogrsko",
	"SI-203": "Straza",
	"SI-204": "Sveta Trojica v Slovenskih goricah",
	"SI-205": "Sveti Tomaz",
	"SI-206": "Smarjeske Toplice",
	"SI-207": "Gorje",
	"SI-208": "Log-Dragomer",
	"SI-209": "Recica ob Savinji",
	"SI-210": "Sveti Jurij v Slovenskih goricah",
	"SI-211": "Sentrupert",
	"SI-212": "Mirna",
	"SI-213": "Ankaran",
	"SK-BC": "Banskobystricky kraj",
	"SK-BL": "Bratislavsky kraj",
	"SK-KI": "Kosicky kraj",
	"SK-NI": "Nitriansky kraj",
	"SK-PV": "Presovsky kraj",
	"SK-TA": "Trnavsky kraj",
	"SK-TC": "Trenciansky kraj",
	"SK-ZI": "Zilinsky kraj",
	"SL-E": "Eastern",
	"SL-N": "Northern",
	"SL-S": "Southern",
	"SL-W": "Western Area",
	"SM-02": "Chiesanuova",
	"SM-04": "Faetano",
	"SM-07": "Citta di San Marino",
	"SM-09": "Serravalle",
	"SN-DB": "Diourbel",
	"SN-DK": "Dakar",
	"SN-FK": "Fatick",
	"SN-KA": "Kaffrine",
	"SN-KD": "Kolda",
	"SN-KE": "Kedougou",
	"SN-KL": "Kaolack",
	"SN-LG": "Louga",
	"SN-MT": "Matam",
	"SN-SE": "Sedhiou",
	"SN-SL": "Saint-Louis",
	"SN-TC": "Tambacounda",
	"SN-TH": "Thies",
	"SN-ZG": "Ziguinchor",
	"SO-AW": "Awdal",
	"SO-BN": "Banaadir",
	"SO-BR": "Bari",
	"SO-BY": "Bay",
	"SO-GA": "Galguduud",
	"SO-HI": "Hiiraan",
	"SO-JH": "Jubbada Hoose",
	"SO-MU": "Mudug",
	"SO-NU": "Nugaal",
	"SO-SA": "Sanaag",
	"SO-SH": "Shabeellaha Hoose",
	"SO-SO": "Sool",
	"SO-TO": "Togdheer",
	"SO-WO": "Woqooyi Galbeed",
	"SR-BR": "Brokopondo",
	"SR-CM": "Commewijne",
	"SR-CR": "Coronie",
	"SR-NI": "Nickerie",
	"SR-PM": "Paramaribo",
	"SR-SA": "Saramacca",
	"SR-SI": "Sipaliwini",
	"SR-WA": "Wanica",
	"SS-BN": "Northern Bahr el Ghazal",
	"SS-EC": "Central Equatoria",
	"SS-EE": "Eastern Equatoria",
	"SS-EW": "Western Equatoria",
	"SS-NU": "Upper Nile",
	"SS-UY": "Unity",
	"ST-01": "Agua Grande",
	"SV-AH": "Ahuachapan",
	"SV-CA": "Cabanas",
	"SV-CH": "Chalatenango",
	"SV-CU": "Cuscatlan",
	"SV-LI": "La Libertad",
	"SV-MO": "Morazan",
	"SV-PA": "La Paz",
	"SV-SA": "Santa Ana",
	"SV-SM": "San Miguel",
	"SV-SO": "Sonsonate",
	"SV-SS": "San Salvador",
	"SV-SV": "San Vicente",
	"SV-UN": "La Union",
	"SV-US": "Usulutan",
	"SY-DI": "Dimashq",
	"SY-DR": "Dar'a",
	"SY-DY": "Dayr az Zawr",
	"SY-HA": "Al Hasakah",
	"SY-HI": "Hims",
	"SY-HL": "Halab",
	"SY-HM": "Hamah",
	"SY-LA": "Al Ladhiqiyah",
	"SY-QU": "Al Qunaytirah",
	"SY-RA": "Ar Raqqah",
	"SY-RD": "Rif Dimashq",
	"SY-SU": "As Suwayda'",
	"SY-TA": "Tartus",
	"SZ-HH": "Hhohho",
	"SZ-LU": "Lubombo",
	"SZ-MA": "Manzini",
	"SZ-SH": "Shiselweni",
	"TD-BG": "Bahr el Ghazal",
	"TD-CB": "Chari-Baguirmi",
	"TD-LC": "Lac",
	"TD-ND": "Ville de Ndjamena",
	"TD-OD": "Ouaddai",
	"TD-SI": "Sila",
	"TG-C": "Centrale",
	"TG-K": "Kara",
	"TG-M": "Maritime",
	"TG-P": "Plateaux",
	"TG-S": "Savanes",
	"TH-10": "Krung Thep Maha Nakhon",
	"TH-11": "Samut Prakan",
	"TH-12": "Nonthaburi",
	"TH-13": "Pathum Thani",
	"TH-14": "Phra Nakhon Si Ayutthaya",
	"TH-15": "Ang Thong",
	"TH-16": "Lop Buri",
	"TH-17": "Sing Buri",
	"TH-18": "Chai Nat",
	"TH-19": "Saraburi",
	"TH-20": "Chon Buri",
	"TH-21": "Rayong",
	"TH-22": "Chanthaburi",
	"TH-23": "Trat",
	"TH-24": "Chachoengsao",
	"TH-25": "Prachin Buri",
	"TH-26": "Nakhon Nayok",
	"TH-27": "Sa Kaeo",
	"TH-30": "Nakhon Ratchasima",
	"TH-31": "Buri Ram",
	"TH-32": "Surin",
	"TH-33": "Si Sa Ket",
	"TH-34": "Ubon Ratchathani",
	"TH-35": "Yasothon",
	"TH-36": "Chaiyaphum",
	"TH-37": "Amnat Charoen",
	"TH-38": "Bueng Kan",
	"TH-39": "Nong Bua Lam Phu",
	"TH-40": "Khon Kaen",
	"TH-41": "Udon Thani",
	"TH-42": "Loei",
	"TH-43": "Nong Khai",
	"TH-44": "Maha Sarakham",
	"TH-45": "Roi Et",
	"TH-46": "Kalasin",
	"TH-47": "Sakon Nakhon",
	"TH-48": "Nakhon Phanom",
	"TH-49": "Mukdahan",
	"TH-50": "Chiang Mai",
	"TH-51": "Lamphun",
	"TH-52": "Lampang",
	"TH-53": "Uttaradit",
	"TH-54": "Phrae",
	"TH-55": "Nan",
	"TH-56": "Phayao",
	"TH-57": "Chiang Rai",
	"TH-58": "Mae Hong Son",
	"TH-60": "Nakhon Sawan",
	"TH-61": "Uthai Thani",
	"TH-62": "Kamphaeng Phet",
	"TH-63": "Tak",
	"TH-64": "Sukhothai",
	"TH-65": "Phitsanulok",
	"TH-66": "Phichit",
	"TH-67": "Phetchabun",
	"TH-70": "Ratchaburi",
	"TH-71": "Kanchanaburi",
	"TH-72": "Suphan Buri",
	"TH-73": "Nakhon Pathom",
	"TH-74": "Samut Sakhon",
	"TH-75": "Samut Songkhram",
	"TH-76": "Phetchaburi",
	"TH-77": "Prachuap Khiri Khan",
	"TH-80": "Nakhon Si Thammarat",
	"TH-81": "Krabi",
	"TH-82": "Phangnga",
	"TH-83": "Phuket",
	"TH-84": "Surat Thani",
	"TH-85": "Ranong",
	"TH-86": "Chumphon",
	"TH-90": "Songkhla",
	"TH-91": "Satun",
	"TH-92": "Trang",
	"TH-93": "Phatthalung",
	"TH-94": "Pattani",
	"TH-95": "Yala",
	"TH-96": "Narathiwat",
	"TJ-DU": "Dushanbe",
	"TJ-GB": "Kuhistoni Badakhshon",
	"TJ-KT": "Khatlon",
	"TJ-RA": "Nohiyahoi Tobei Jumhuri",
	"TJ-SU": "Sughd",
	"TL-AN": "Ainaro",
	"TL-CO": "Cova Lima",
	"TL-DI": "Dili",
	"TL-LI": "Liquica",
	"TM-A": "Ahal",
	"TM-B": "Balkan",
	"TM-D": "Dasoguz",
	"TM-L": "Lebap",
	"TM-M": "Mary",
	"TN-11": "Tunis",
	"TN-12": "L'Ariana",
	"TN-13": "Ben Arous",
	"TN-14": "La Manouba",
	"TN-21": "Nabeul",
	"TN-22": "Zaghouan",
	"TN-23": "Bizerte",
	"TN-31": "Beja",
	"TN-32": "Jendouba",
	"TN-33": "Le Kef",
	"TN-34": "Siliana",
	"TN-41": "Kairouan",
	"TN-42": "Kasserine",
	"TN-43": "Sidi Bouzid",
	"TN-51": "Sousse",
	"TN-52": "Monastir",
	"TN-53": "Mahdia",
	"TN-61": "Sfax",
	"TN-71": "Gafsa",
	"TN-72": "Tozeur",
	"TN-73": "Kebili",
	"TN-81": "Gabes",
	"TN-82": "Medenine",
	"TN-83": "Tataouine",
	"TO-01": "'Eua",
	"TO-02": "Ha'apai",
	"TO-03": "Niuas",
	"TO-04": "Tongatapu",
	"TO-05": "Vava'u",
	"TR-01": "Adana",
	"TR-02": "Adiyaman",
	"TR-03": "Afyonkarahisar",
	"TR-04": "Agri",
	"TR-05": "Amasya",
	"TR-06": "Ankara",
	"TR-07": "Antalya",
	"TR-08": "Artvin",
	"TR-09": "Aydin",
	"TR-10": "Balikesir",
	"TR-11": "Bilecik",
	"TR-12": "Bingol",
	"TR-13": "Bitlis",
	"TR-14": "Bolu",
	"TR-15": "Burdur",
	"TR-16": "Bursa",
	"TR-17": "Canakkale",
	"TR-18": "Cankiri",
	"TR-19": "Corum",
	"TR-20": "Denizli",
	"TR-21": "Diyarbakir",
	"TR-22": "Edirne",
	"TR-23": "Elazig",
	"TR-24": "Erzincan",
	"TR-25": "Erzurum",
	"TR-26": "Eskisehir",
	"TR-27": "Gaziantep",
	"TR-28": "Giresun",
	"TR-29": "Gumushane",
	"TR-30": "Hakkari",
	"TR-31": "Hatay",
	"TR-32": "Isparta",
	"TR-33": "Mersin",
	"TR-34": "Istanbul",
	"TR-35": "Izmir",
	"TR-36": "Kars",
	"TR-37": "Kastamonu",
	"TR-38": "Kayseri",
	"TR-39": "Kirklareli",
	"TR-40": "Kirsehir",
	"TR-41": "Kocaeli",
	"TR-42": "Konya",
	"TR-43": "Kutahya",
	"TR-44": "Malatya",
	"TR-45": "Manisa",
	"TR-46": "Kahramanmaras",
	"TR-47": "Mardin",
	"TR-48": "Mugla",
	"TR-49": "Mus",
	"TR-50": "Nevsehir",
	"TR-51": "Nigde",
	"TR-52": "Ordu",
	"TR-53": "Rize",
	"TR-54": "Sakarya",
	"TR-55": "Samsun",
	"TR-56": "Siirt",
	"TR-57": "Sinop",
	"TR-58": "Sivas",
	"TR-59": "Tekirdag",
	"TR-60": "Tokat",
	"TR-61": "Trabzon",
	"TR-62": "Tunceli",
	"TR-63": "Sanliurfa",
	"TR-64": "Usak",
	"TR-65": "Van",
	"TR-66": "Yozgat",
	"TR-67": "Zonguldak",
	"TR-68": "Aksaray",
	"TR-69": "Bayburt",
	"TR-70": "Karaman",
	"TR-71": "Kirikkale",
	"TR-72": "Batman",
	"TR-73": "Sirnak",
	"TR-74": "Bartin",
	"TR-75": "Ardahan",
	"TR-76": "Igdir",
	"TR-77": "Yalova",
	"TR-78": "Karabuk",
	"TR-79": "Kilis",
	"TR-80": "Osmaniye",
	"TR-81": "Duzce",
	"TT-ARI": "Arima",
	"TT-CHA": "Chaguanas",
	"TT-CTT": "Couva-Tabaquite-Talparo",
	"TT-DMN": "Diego Martin",
	"TT-MRC": "Mayaro-Rio Claro",
	"TT-PED": "Penal-Debe",
	"TT-POS": "Port of Spain",
	"TT-PRT": "Princes Town",
	"TT-PTF": "Point Fortin",
	"TT-SFO": "San Fernando",
	"TT-SGE": "Sangre Grande",
	"TT-SIP": "Siparia",
	"TT-SJL": "San Juan-Laventille",
	"TT-TOB": "Tobago",
	"TT-TUP": "Tunapuna-Piarco",
	"TV-FUN": "Funafuti",
	"TW-CHA": "Changhua",
	"TW-CYQ": "Chiayi",
	"TW-HSQ": "Hsinchu",
	"TW-HUA": "Hualien",
	"TW-ILA": "Yilan",
	"TW-KEE": "Keelung",
	"TW-KHH": "Kaohsiung",
	"TW-KIN": "Kinmen",
	"TW-LIE": "Lienchiang",
	"TW-MIA": "Miaoli",
	"TW-NAN": "Nantou",
	"TW-NWT": "New Taipei",
	"TW-PEN": "Penghu",
	"TW-PIF": "Pingtung",
	"TW-TAO": "Taoyuan",
	"TW-TNN": "Tainan",
	"TW-TPE": "Taipei",
	"TW-TTT": "Taitung",
	"TW-TXG": "Taichung",
	"TW-YUN": "Yunlin",
	"TZ-01": "Arusha",
	"TZ-02": "Dar es Salaam",
	"TZ-03": "Dodoma",
	"TZ-04": "Iringa",
	"TZ-05": "Kagera",
	"TZ-06": "Kaskazini Pemba",
	"TZ-07": "Kaskazini Unguja",
	"TZ-08": "Kigoma",
	"TZ-09": "Kilimanjaro",
	"TZ-10": "Kusini Pemba",
	"TZ-11": "Kusini Unguja",
	"TZ-12": "Lindi",
	"TZ-13": "Mara",
	"TZ-14": "Mbeya",
	"TZ-15": "Mjini Magharibi",
	"TZ-16": "Morogoro",
	"TZ-17": "Mtwara",
	"TZ-18": "Mwanza",
	"TZ-19": "Pwani",
	"TZ-20": "Rukwa",
	"TZ-21": "Ruvuma",
	"TZ-22": "Shinyanga",
	"TZ-23": "Singida",
	"TZ-24": "Tabora",
	"TZ-25": "Tanga",
	"TZ-26": "Manyara",
	"TZ-27": "Geita",
	"TZ-28": "Katavi",
	"TZ-29": "Njombe",
	"TZ-30": "Simiyu",
	"TZ-31": "Songwe",
	"UA-05": "Vinnytska oblast",
	"UA-07": "Volynska oblast",
	"UA-09": "Luhanska oblast",
	"UA-12": "Dnipropetrovska oblast",
	"UA-14": "Donetska oblast",
	"UA-18": "Zhytomyrska oblast",
	"UA-21": "Zakarpatska oblast",
	"UA-23": "Zaporizka oblast",
	"UA-26": "Ivano-Frankivska oblast",
	"UA-30": "Kyiv",
	"UA-32": "Kyivska oblast",
	"UA-35": "Kirovohradska oblast",
	"UA-40": "Sevastopol",
	"UA-43": "Avtonomna Respublika Krym",
	"UA-46": "Lvivska oblast",
	"UA-48": "Mykolaivska oblast",
	"UA-51": "Odeska oblast",
	"UA-53": "Poltavska oblast",
	"UA-56": "Rivnenska oblast",
	"UA-59": "Sumska oblast",
	"UA-61": "Ternopilska oblast",
	"UA-63": "Kharkivska oblast",
	"UA-65": "Khersonska oblast",
	"UA-68": "Khmelnytska oblast",
	"UA-71": "Cherkaska oblast",
	"UA-74": "Chernihivska oblast",
	"UA-77": "Chernivetska oblast",
	"UG-101": "Kalangala",
	"UG-102": "Kampala",
	"UG-103": "Kiboga",
	"UG-104": "Luwero",
	"UG-105": "Masaka",
	"UG-106": "Mpigi",
	"UG-107": "Mubende",
	"UG-108": "Mukono",
	"UG-109": "Nakasongola",
	"UG-110": "Rakai",
	"UG-111": "Sembabule",
	"UG-112": "Kayunga",
	"UG-113": "Wakiso",
	"UG-114": "Lyantonde",
	"UG-115": "Mityana",
	"UG-116": "Nakaseke",
	"UG-117": "Buikwe",
	"UG-118": "Bukomansibi",
	"UG-120": "Buvuma",
	"UG-121": "Gomba",
	"UG-122": "Kalungu",
	"UG-123": "Kyankwanzi",
	"UG-124": "Lwengo",
	"UG-201": "Bugiri",
	"UG-202": "Busia",
	"UG-203": "Iganga",
	"UG-204": "Jinja",
	"UG-205": "Kamuli",
	"UG-206": "Kapchorwa",
	"UG-207": "Katakwi",
	"UG-208": "Kumi",
	"UG-209": "Mbale",
	"UG-211": "Soroti",
	"UG-212": "Tororo",
	"UG-213": "Kaberamaido",
	"UG-214": "Mayuge",
	"UG-215": "Sironko",
	"UG-218": "Bududa",
	"UG-219": "Bukedea",
	"UG-222": "Kaliro",
	"UG-223": "Manafwa",
	"UG-224": "Namutumba",
	"UG-225": "Bulambuli",
	"UG-226": "Buyende",
	"UG-227": "Kibuku",
	"UG-228": "Kween",
	"UG-229": "Luuka",
	"UG-230": "Namayingo",
	"UG-301": "Adjumani",
	"UG-302": "Apac",
	"UG-303": "Arua",
	"UG-304": "Gulu",
	"UG-305": "Kitgum",
	"UG-307": "Lira",
	"UG-308": "Moroto",
	"UG-309": "Moyo",
	"UG-310": "Nebbi",
	"UG-311": "Nakapiripirit",
	"UG-312": "Pader",
	"UG-313": "Yumbe",
	"UG-314": "Abim",
	"UG-318": "Kaabong",
	"UG-319": "Koboko",
	"UG-320": "Maracha",
	"UG-321": "Oyam",
	"UG-322": "Agago",
	"UG-323": "Alebtong",
	"UG-325": "Kole",
	"UG-326": "Lamwo",
	"UG-327": "Napak",
	"UG-328": "Nwoya",
	"UG-330": "Zombo",
	"UG-401": "Bundibugyo",
	"UG-402": "Bushenyi",
	"UG-403": "Hoima",
	"UG-404": "Kabale",
	"UG-405": "Kabarole",
	"UG-406": "Kasese",
	"UG-407": "Kibaale",
	"UG-408": "Kisoro",
	"UG-409": "Masindi",
	"UG-410": "Mbarara",
	"UG-411": "Ntungamo",
	"UG-412": "Rukungiri",
	"UG-413": "Kamwenge",
	"UG-414": "Kanungu",
	"UG-415": "Kyenjojo",
	"UG-417": "Ibanda",
	"UG-418": "Isingiro",
	"UG-419": "Kiruhura",
	"UG-420": "Buhweju",
	"UG-421": "Kiryandongo",
	"UG-422": "Kyegegwa",
	"UG-423": "Mitooma",
	"UG-424": "Ntoroko",
	"UG-425": "Rubirizi",
	"UG-426": "Sheema",
	"UM-95": "Palmyra Atoll",
	"US-AK": "Alaska",
	"US-AL": "Alabama",
	"US-AR": "Arkansas",
	"US-AZ": "Arizona",
	"US-CA": "California",
	"US-CO": "Colorado",
	"US-CT": "Connecticut",
	"US-DC": "District of Columbia",
	"US-DE": "Delaware",
	"US-FL": "Florida",
	"US-GA": "Georgia",
	"US-HI": "Hawaii",
	"US-IA": "Iowa",
	"US-ID": "Idaho",
	"US-IL": "Illinois",
	"US-IN": "Indiana",
	"US-KS": "Kansas",
	"US-KY": "Kentucky",
	"US-LA": "Louisiana",
	"US-MA": "Massachusetts",
	"US-MD": "Maryland",
	"US-ME": "Maine",
	"US-MI": "Michigan",
	"US-MN": "Minnesota",
	"US-MO": "Missouri",
	"US-MS": "Mississippi",
	"US-MT": "Montana",
	"US-NC": "North Carolina",
	"US-ND": "North Dakota",
	"US-NE": "Nebraska",
	"US-NH": "New Hampshire",
	"US-NJ": "New Jersey",
	"US-NM": "New Mexico",
	"US-NV": "Nevada",
	"US-NY": "New York",
	"US-OH": "Ohio",
	"US-OK": "Oklahoma",
	"US-OR": "Oregon",
	"US-PA": "Pennsylvania",
	"US-RI": "Rhode Island",
	"US-SC": "South Carolina",
	"US-SD": "South Dakota",
	"US-TN": "Tennessee",
	"US-TX": "Texas",
	"US-UT": "Utah",
	"US-VA": "Virginia",
	"US-VT": "Vermont",
	"US-WA": "Washington",
	"US-WI": "Wisconsin",
	"US-WV": "West Virginia",
	"US-WY": "Wyoming",
	"UY-AR": "Artigas",
	"UY-CA": "Canelones",
	"UY-CL": "Cerro Largo",
	"UY-CO": "Colonia",
	"UY-DU": "Durazno",
	"UY-FD": "Florida",
	"UY-FS": "Flores",
	"UY-LA": "Lavalleja",
	"UY-MA": "Maldonado",
	"UY-MO": "Montevideo",
	"UY-PA": "Paysandu",
	"UY-RN": "Rio Negro",
	"UY-RO": "Rocha",
	"UY-RV": "Rivera",
	"UY-SA": "Salto",
	"UY-SJ": "San Jose",
	"UY-SO": "Soriano",
	"UY-TA": "Tacuarembo",
	"UY-TT": "Treinta y Tres",
	"UZ-AN": "Andijon",
	"UZ-BU": "Buxoro",
	"UZ-FA": "Farg'ona",
	"UZ-JI": "Jizzax",
	"UZ-NG": "Namangan",
	"UZ-NW": "Navoiy",
	"UZ-QA": "Qashqadaryo",
	"UZ-QR": "Qoraqalpog'iston Respublikasi",
	"UZ-SA": "Samarqand",
	"UZ-SI": "Sirdaryo",
	"UZ-SU": "Surxondaryo",
	"UZ-TK": "Toshkent",
	"UZ-XO": "Xorazm",
	"VC-01": "Charlotte",
	"VC-04": "Saint George",
	"VC-05": "Saint Patrick",
	"VC-06": "Grenadines",
	"VE-A": "Distrito Capital",
	"VE-B": "Anzoategui",
	"VE-C": "Apure",
	"VE-D": "Aragua",
	"VE-E": "Barinas",
	"VE-F": "Bolivar",
	"VE-G": "Carabobo",
	"VE-H": "Cojedes",
	"VE-I": "Falcon",
	"VE-J": "Guarico",
	"VE-K": "Lara",
	"VE-L": "Merida",
	"VE-M": "Miranda",
	"VE-N": "Monagas",
	"VE-O": "Nueva Esparta",
	"VE-P": "Portuguesa",
	"VE-R": "Sucre",
	"VE-S": "Tachira",
	"VE-T": "Trujillo",
	"VE-U": "Yaracuy",
	"VE-V": "Zulia",
	"VE-W": "Dependencias Federales",
	"VE-X": "La Guaira",
	"VE-Y": "Delta Amacuro",
	"VE-Z": "Amazonas",
	"VN-01": "Lai Chau",
	"VN-02": "Lao Cai",
	"VN-03": "Ha Giang",
	"VN-04": "Cao Bang",
	"VN-05": "Son La",
	"VN-06": "Yen Bai",
	"VN-07": "Tuyen Quang",
	"VN-09": "Lang Son",
	"VN-13": "Quang Ninh",
	"VN-14": "Hoa Binh",
	"VN-18": "Ninh Binh",
	"VN-20": "Thai Binh",
	"VN-21": "Thanh Hoa",
	"VN-22": "Nghe An",
	"VN-23": "Ha Tinh",
	"VN-24": "Quang Binh",
	"VN-25": "Quang Tri",
	"VN-26": "Thua Thien-Hue",
	"VN-27": "Quang Nam",
	"VN-28": "Kon Tum",
	"VN-29": "Quang Ngai",
	"VN-30": "Gia Lai",
	"VN-31": "Binh Dinh",
	"VN-32": "Phu Yen",
	"VN-33": "Dak Lak",
	"VN-34": "Khanh Hoa",
	"VN-35": "Lam Dong",
	"VN-36": "Ninh Thuan",
	"VN-37": "Tay Ninh",
	"VN-39": "Dong Nai",
	"VN-40": "Binh Thuan",
	"VN-41": "Long An",
	"VN-43": "Ba Ria - Vung Tau",
	"VN-44": "An Giang",
	"VN-45": "Dong Thap",
	"VN-46": "Tien Giang",
	"VN-47": "Kien Giang",
	"VN-49": "Vinh Long",
	"VN-50": "Ben Tre",
	"VN-51": "Tra Vinh",
	"VN-52": "Soc Trang",
	"VN-53": "Bac Kan",
	"VN-54": "Bac Giang",
	"VN-55": "Bac Lieu",
	"VN-56": "Bac Ninh",
	"VN-57": "Binh Duong",
	"VN-58": "Binh Phuoc",
	"VN-59": "Ca Mau",
	"VN-61": "Hai Duong",
	"VN-63": "Ha Nam",
	"VN-66": "Hung Yen",
	"VN-67": "Nam Dinh",
	"VN-68": "Phu Tho",
	"VN-69": "Thai Nguyen",
	"VN-70": "Vinh Phuc",
	"VN-71": "Dien Bien",
	"VN-72": "Dak Nong",
	"VN-73": "Hau Giang",
	"VN-CT": "Can Tho",
	"VN-DN": "Da Nang",
	"VN-HN": "Ha Noi",
	"VN-HP": "Hai Phong",
	"VN-SG": "Ho Chi Minh",
	"VU-SEE": "Shefa",
	"VU-TAE": "Tafea",
	"VU-TOB": "Torba",
	"WF-SG": "Sigave",
	"WF-UV": "Uvea",
	"WS-AT": "Atua",
	"WS-FA": "Fa'asaleleaga",
	"WS-GI": "Gagaifomauga",
	"WS-TU": "Tuamasaga",
	"YE-AD": "'Adan",
	"YE-AM": "'Amran",
	"YE-BA": "Al Bayda'",
	"YE-DA": "Ad Dali'",
	"YE-DH": "Dhamar",
	"YE-HD": "Hadramawt",
	"YE-HJ": "Hajjah",
	"YE-HU": "Al Hudaydah",
	"YE-IB": "Ibb",
	"YE-JA": "Al Jawf",
	"YE-LA": "Lahij",
	"YE-MA": "Ma'rib",
	"YE-MW": "Al Mahwit",
	"YE-SA": "Amanat al 'Asimah",
	"YE-SD": "Sa'dah",
	"YE-SH": "Shabwah",
	"YE-SN": "San'a'",
	"YE-TA": "Ta'izz",
	"ZA-EC": "Eastern Cape",
	"ZA-FS": "Free State",
	"ZA-GP": "Gauteng",
	"ZA-KZN": "Kwazulu-Natal",
	"ZA-LP": "Limpopo",
	"ZA-MP": "Mpumalanga",
	"ZA-NC": "Northern Cape",
	"ZA-NW": "North-West",
	"ZA-WC": "Western Cape",
	"ZM-01": "Western",
	"ZM-02": "Central",
	"ZM-03": "Eastern",
	"ZM-04": "Luapula",
	"ZM-05": "Northern",
	"ZM-06": "North-Western",
	"ZM-07": "Southern",
	"ZM-08": "Copperbelt",
	"ZM-09": "Lusaka",
	"ZM-10": "Muchinga",
	"ZW-BU": "Bulawayo",
	"ZW-HA": "Harare",
	"ZW-MA": "Manicaland",
	"ZW-MC": "Mashonaland Central",
	"ZW-ME": "Mashonaland East",
	"ZW-MI": "Midlands",
	"ZW-MN": "Matabeleland North",
	"ZW-MS": "Matabeleland South",
	"ZW-MV": "Masvingo",
	"ZW-MW": "Mashonaland West"
};
var jobPositionPresets = new JobPositionPresets({
	titleSuffix: " (m/w/d)",
	additionalRequirements: { germanSkill: new AdditionalRequirement({
		label: "Erforderliches Deutschniveau",
		value: "",
		selectOptions: [
			"Sehr gut",
			"Etwas gebrochen",
			"Sehr gebrochen",
			"Keins",
			"Noch nicht festgelegt"
		],
		isKoCriteria: true
	}) }
});
var defaultEmployeeNotesTemplate = `• Brutto-Gehaltsvorstellung:
• Wechselwillig, weil
• Arbeitssuchend seit XY, weil XY
• Wohnort:
• Erreichbarkeit:
• Persönlicher Eindruck:
• Deutschkenntnisse: Sehr gut; Mittel (Etwas gebrochen); Schlecht (Sehr gebrochen); Keine`;
var defaultTraineeNotesTemplate = `• Interesse an einem Praktikum vor der Ausbildung:
• Alter:
• Wohnort:
• Erreichbarkeit:
• Persönlicher Eindruck:
• Deutschkenntnisse: Sehr gut; Mittel (Etwas gebrochen); Schlecht (Sehr gebrochen); Keine`;
var defaultDualStudentNotesTemplate = `• Interesse an einem Praktikum vor dem Studium:
• Alter:
• Wohnort:
• Erreichbarkeit:
• Persönlicher Eindruck:
• Deutschkenntnisse: Sehr gut; Mittel (Etwas gebrochen); Schlecht (Sehr gebrochen); Keine`;
var defaultNotesTemplates = {
	[JobPositionType.EMPLOYEE]: defaultEmployeeNotesTemplate,
	[JobPositionType.TRAINEE]: defaultTraineeNotesTemplate,
	[JobPositionType.DUAL_STUDENT]: defaultDualStudentNotesTemplate
};
// source/data/perspective.ts
var utmParameterKeys = [
	"utm_source",
	"utm_medium",
	"utm_campaign",
	"utm_keyword",
	"Platzierung",
	"platzierung",
	"Kanal",
	"kanal",
	"Werbeanzeige",
	"werbeanzeige",
	"Keyword",
	"keyword"
];
// source/data/webhooks.ts
var applicantNotePrefix = "note_";
// source/data/sms.ts
var callAttemptFailedOneTimeSmsTemplate = `Hallo {{applicant.name}},

ich habe Sie telefonisch gerade leider verpasst.

Sie haben sich bei uns ({{{company.shortName}}}) beworben.

Gibt es bestimmte Zeiten, zu denen Sie besser zu erreichen sind?

Unter meiner Nummer bin ich leider nicht für Rückrufe verfügbar. Ich werde es bei Ihnen die Tage aber nochmal probieren.

Über eine kurze Rückmeldung von Ihnen würde ich mich sehr freuen!

Grüße Toni Weber von {{{company.shortName}}}`;
var waitingForResumeSmsTemplate = `Hallo {{applicant.name}},

vielen Dank für das nette Gespräch gerade. Ich glaube, Sie passen gut zu uns!

Damit ich Ihre Bewerbung weitergeben kann, schicken Sie mir bitte wie besprochen noch Ihren Lebenslauf so zeitnah wie möglich an folgende E-Mail-Adresse:
info@bewerbungen-kurz.de

Falls Sie keinen Lebenslauf haben, können Sie diesen hier in wenigen Minuten am Handy oder Laptop erstellen:
{{{resumeLink}}}

Ich freue mich, von Ihnen zu hören!

Grüße Toni Weber von {{{company.shortName}}}`;
var resumeReminderSmsTemplate = `Hallo {{applicant.name}},

ich möchte Sie höflich erinnern, dass wir aktuell noch auf Ihren Lebenslauf warten.

Schicken Sie mir diesen bitte an folgende E-Mail Adresse:
info@bewerbungen-kurz.de

Falls Sie keinen Lebenslauf haben, können Sie diesen hier in wenigen Minuten am Handy oder Laptop erstellen:
{{{resumeLink}}}

Ich freue mich, von Ihnen zu hören!

Grüße Toni Weber von {{{company.shortName}}}`;
var resumeIncompleteSmsTemplate = `Hallo {{applicant.name}},

vielen Dank für das Einreichen eines Lebenslaufes!

Beim Durchsehen ist mir aufgefallen, dass noch einige Angaben zur Ihrer Berufserfahrung fehlen.

Schicken Sie mir daher bitte einen vollständigen Lebenslauf oder eine kurze Ergänzung als Text zu.

Ich freue mich, von Ihnen zu hören!

Grüße Toni Weber von {{{company.shortName}}}`;
var waitingForDocumentsSmsTemplate = `Hallo {{applicant.name}},

vielen Dank für das nette Gespräch gerade. Ich glaube, Sie passen gut zu uns!

Damit ich Ihre Bewerbung weitergeben kann, schicken Sie mir bitte, wie gerade besprochen, die gewünschten Unterlagen an folgende E-Mail-Adresse: info@bewerbungen-kurz.de

Ich freue mich, von Ihnen zu hören!

Grüße Toni Weber von {{{company.shortName}}}`;
var documentsReminderSmsTemplate = `Hallo {{applicant.name}},

ich möchte Sie höflich erinnern, dass wir aktuell noch auf Ihre Unterlagen warten.

Schicken Sie mir diese bitte an folgende E-Mail Adresse:
info@bewerbungen-kurz.de

Ich freue mich, von Ihnen zu hören!

Grüße Toni Weber von {{{company.shortName}}}`;
var emailTemplateKeyToSmsTemplateKey = {
	[EmailTemplateKey.CALL_ATTEMPT_FAILED_1_TIME]: SmsTemplateKey.CALL_ATTEMPT_FAILED_1_TIME,
	[EmailTemplateKey.CALL_ATTEMPT_FAILED_1_TIME_TRAINEES_DUAL_STUDENTS]: SmsTemplateKey.CALL_ATTEMPT_FAILED_1_TIME_TRAINEES_DUAL_STUDENTS,
	[EmailTemplateKey.RESUME_SUBMISSION_REQUEST]: SmsTemplateKey.RESUME_SUBMISSION_REQUEST,
	[EmailTemplateKey.RESUME_SUBMISSION_REMINDER]: SmsTemplateKey.RESUME_SUBMISSION_REMINDER,
	[EmailTemplateKey.RESUME_INCOMPLETE]: SmsTemplateKey.RESUME_INCOMPLETE,
	[EmailTemplateKey.DOCUMENTS_SUBMISSION_REQUEST_TRAINEES_DUAL_STUDENTS]: SmsTemplateKey.DOCUMENTS_SUBMISSION_REQUEST_TRAINEES_DUAL_STUDENTS,
	[EmailTemplateKey.DOCUMENTS_SUBMISSION_REMINDER_TRAINEES_DUAL_STUDENTS]: SmsTemplateKey.DOCUMENTS_SUBMISSION_REMINDER_TRAINEES_DUAL_STUDENTS
};
var smsEmailMap = {
	[EmailTemplateKey.CALL_ATTEMPT_FAILED_1_TIME]: callAttemptFailedOneTimeSmsTemplate,
	[EmailTemplateKey.CALL_ATTEMPT_FAILED_1_TIME_TRAINEES_DUAL_STUDENTS]: callAttemptFailedOneTimeSmsTemplate,
	[EmailTemplateKey.RESUME_SUBMISSION_REQUEST]: waitingForResumeSmsTemplate,
	[EmailTemplateKey.RESUME_SUBMISSION_REMINDER]: resumeReminderSmsTemplate,
	[EmailTemplateKey.RESUME_INCOMPLETE]: resumeIncompleteSmsTemplate,
	[EmailTemplateKey.DOCUMENTS_SUBMISSION_REQUEST_TRAINEES_DUAL_STUDENTS]: waitingForDocumentsSmsTemplate,
	[EmailTemplateKey.DOCUMENTS_SUBMISSION_REMINDER_TRAINEES_DUAL_STUDENTS]: documentsReminderSmsTemplate
};
// source/utilities/career.ts
var defaultNumberOfFacts = 4;
var sectionMapping = {
	[DataShId.NavigationSection]: "navigation",
	[DataShId.HeroSection]: "hero",
	[DataShId.JobsOverviewSection]: "offeneStellen",
	[DataShId.TraineeOverviewSection]: "offeneAusbildungen",
	[DataShId.JobVideoSection]: "arbeitgeberfilm",
	[DataShId.TraineeVideoSection]: "azubifilm",
	[DataShId.PraktikumSection]: "praktikum",
	[DataShId.BenefitsSection]: "vorteile",
	[DataShId.GallerySection]: "bilder",
	[DataShId.TestimonialsSection]: "testimonials",
	[DataShId.AboutUsSection]: "unternehmensvorstellung",
	[DataShId.GoogleMapSection]: "googleMaps",
	[DataShId.SocialMediaSection]: "instagramFeed",
	[DataShId.ContactSection]: "ansprechpartner",
	[DataShId.FaqsSection]: "faq",
	[DataShId.DetailsBenefitsSection]: "detailsBenefits",
	[DataShId.DetailsTasksSection]: "detailsTasks",
	[DataShId.DetailsProfileSection]: "detailsProfile",
	[DataShId.DetailsApplicationFormSection]: "applicationForm",
	[DataShId.FooterSection]: "footer",
	[DataShId.CookieBannerSection]: "cookieBanner"
};
var nonThemeableSectionShIds = ["google-map__section", "gallery__section"];
var nonThemeableSectionIds = ["googleMaps", "bilder"];
var mergeSections = ({ sectionsA, sectionsB }) => {
	const sectionMap = /* @__PURE__ */ new Map();
	sectionsB.forEach((section) => {
		if (!sectionMap.has(section.pageId)) sectionMap.set(section.pageId, /* @__PURE__ */ new Map());
		sectionMap.get(section.pageId).set(section.id, section);
	});
	sectionsA.forEach((section) => {
		if (!sectionMap.has(section.pageId)) sectionMap.set(section.pageId, /* @__PURE__ */ new Map());
		sectionMap.get(section.pageId).set(section.id, section);
	});
	const mergedSections = [];
	sectionMap.forEach((sectionsById) => {
		sectionsById.forEach((section) => {
			mergedSections.push(section);
		});
	});
	return mergedSections;
};
var mergePages = ({ pagesA, pagesB }) => {
	const pageMap = /* @__PURE__ */ new Map();
	pagesB.forEach((page) => {
		pageMap.set(page.id, page);
	});
	pagesA.forEach((page) => {
		pageMap.set(page.id, page);
	});
	return Array.from(pageMap.values());
};
var getCareerSectionThemesForPage = ({ sections: initialSections = [], pageId, withTheme = true }) => {
	const sections = mergeSections({
		sectionsA: initialSections,
		sectionsB: InitialCareerFormValues.general.sections
	});
	const sectionsConfig = {};
	if (!sections.length || !pageId) return null;
	const pageIds = Array.isArray(pageId) ? pageId : [pageId];
	let themeableSectionCount = 0;
	Object.entries(sectionMapping).forEach(([dataShId, sectionId]) => {
		const currentSection = sections.find((section) => section.id === sectionId && pageIds.includes(section.pageId));
		if (!currentSection) return;
		if (!currentSection?.isActive || nonThemeableSectionShIds.includes(dataShId)) {
			sectionsConfig[dataShId] = {
				...currentSection,
				title: currentSection.title || ""
			};
			return;
		}
		const alternatingTheme = themeableSectionCount % 2 === 0 ? "theme-a" : "theme-b";
		sectionsConfig[dataShId] = {
			...currentSection,
			title: currentSection.title || "",
			...withTheme ? { theme: currentSection.theme || alternatingTheme } : {}
		};
		themeableSectionCount += 1;
	});
	return sectionsConfig;
};
var mergeColorSection = ({ section, fallbackSection, themeIsInUse }) => {
	const sectionIsActive = typeof section?.isActive === "boolean" ? section.isActive : fallbackSection.isActive;
	return {
		foreground: section?.foreground || fallbackSection.foreground,
		background: section?.background || fallbackSection.background,
		accent: section?.accent || fallbackSection.accent,
		title: section?.title || fallbackSection.title,
		titleAccent: section?.titleAccent || fallbackSection.titleAccent,
		button: section?.button || fallbackSection.button,
		colorOnButton: section?.colorOnButton || fallbackSection.colorOnButton,
		map: section?.map || fallbackSection.map,
		textOnMap: section?.textOnMap || fallbackSection.textOnMap,
		accentOnMap: section?.accentOnMap || fallbackSection.accentOnMap,
		isActive: sectionIsActive || !!themeIsInUse
	};
};
var getCareerSectionThemes = ({ sections }) => {
	const jobsPageSectionsConfig = getCareerSectionThemesForPage({
		sections,
		pageId: "jobs"
	}) || {};
	const traineesPageSectionsConfig = getCareerSectionThemesForPage({
		sections,
		pageId: "trainee"
	}) || {};
	const homePageSectionsConfig = getCareerSectionThemesForPage({
		sections,
		pageId: "home"
	}) || {};
	const thankYouPageSectionsConfig = getCareerSectionThemesForPage({
		sections,
		pageId: "thank-you",
		withTheme: false
	}) || {};
	const jobDetailsPageSectionsConfig = getCareerSectionThemesForPage({
		sections,
		pageId: "job-details"
	}) || {};
	const traineeDetailsPageSectionsConfig = getCareerSectionThemesForPage({
		sections,
		pageId: "trainee-details",
		withTheme: false
	}) || {};
	const globalPageSectionsConfig = getCareerSectionThemesForPage({
		sections,
		pageId: "global"
	}) || {};
	return [
		...Object.values(jobsPageSectionsConfig),
		...Object.values(traineesPageSectionsConfig),
		...Object.values(homePageSectionsConfig),
		...Object.values(thankYouPageSectionsConfig),
		...Object.values(jobDetailsPageSectionsConfig),
		...Object.values(traineeDetailsPageSectionsConfig),
		...Object.values(globalPageSectionsConfig)
	];
};
var getDefaultCareerData = (career) => {
	const careerData = career || InitialCareerFormValues;
	const companyImageActive = careerData?.global?.companyImage?.active || !careerData?.global?.companyVideo?.active;
	const pages = mergePages({
		pagesA: careerData?.general?.pages || [],
		pagesB: InitialCareerFormValues.general.pages
	});
	const sections = getCareerSectionThemes({ sections: careerData?.general?.sections });
	const currentFacts = careerData?.global?.facts || [];
	const facts = [...currentFacts, ...Array(Math.max(0, defaultNumberOfFacts - currentFacts.length)).fill({
		value: "",
		text: ""
	})];
	return {
		publish: careerData?.publish,
		general: {
			...careerData?.general,
			selectionPageText: careerData?.general?.selectionPageText || "",
			pages: pages?.map((page) => ({
				...page,
				title: page.title || ""
			})),
			sections
		},
		design: {
			...careerData?.design,
			colors: {
				...careerData?.design?.colors,
				sectionA: mergeColorSection({
					section: careerData?.design?.colors?.sectionA,
					fallbackSection: InitialCareerFormValues.design.colors.sectionA,
					themeIsInUse: sections?.some((section) => section.theme === "theme-a")
				}),
				sectionB: mergeColorSection({
					section: careerData?.design?.colors?.sectionB,
					fallbackSection: InitialCareerFormValues.design.colors.sectionB,
					themeIsInUse: sections?.some((section) => section.theme === "theme-b")
				}),
				sectionC: mergeColorSection({
					section: careerData?.design?.colors?.sectionC,
					fallbackSection: InitialCareerFormValues.design.colors.sectionC,
					themeIsInUse: sections?.some((section) => section.theme === "theme-c")
				}),
				sectionD: mergeColorSection({
					section: careerData?.design?.colors?.sectionD,
					fallbackSection: InitialCareerFormValues.design.colors.sectionD,
					themeIsInUse: sections?.some((section) => section.theme === "theme-d")
				}),
				sectionE: mergeColorSection({
					section: careerData?.design?.colors?.sectionE,
					fallbackSection: InitialCareerFormValues.design.colors.sectionE,
					themeIsInUse: sections?.some((section) => section.theme === "theme-e")
				}),
				general: {
					specialColor: careerData?.design?.colors?.general?.specialColor || InitialCareerFormValues.design.colors.general.specialColor,
					isActive: typeof careerData?.design?.colors?.general?.isActive === "boolean" ? careerData.design.colors.general.isActive : InitialCareerFormValues.design.colors.general.isActive
				}
			}
		},
		global: {
			...careerData?.global,
			googleMapsUrl: careerData?.global?.googleMapsUrl || "",
			enableMultipleLocations: careerData?.global?.enableMultipleLocations || false,
			companyImage: {
				active: companyImageActive,
				mediaUrl: careerData?.global?.companyImage?.mediaUrl || ""
			},
			companyVideo: {
				active: !companyImageActive,
				mediaUrl: careerData?.global?.companyVideo?.mediaUrl || ""
			},
			instagramUsername: careerData?.global?.instagramUsername || "",
			facts: facts.map((fact) => ({
				value: fact.value || "",
				text: fact.text || ""
			}))
		},
		jobs: {
			...careerData?.jobs,
			isUnsolicitedJobsActive: careerData?.jobs?.isUnsolicitedJobsActive || InitialCareerFormValues.jobs?.isUnsolicitedJobsActive,
			unsolicitedJobImagePath: careerData?.jobs?.unsolicitedJobImagePath || InitialCareerFormValues.jobs?.unsolicitedJobImagePath,
			unsolicitedJobEmailRecipients: careerData?.jobs?.unsolicitedJobEmailRecipients?.length ? careerData.jobs.unsolicitedJobEmailRecipients : InitialCareerFormValues.jobs?.unsolicitedJobEmailRecipients,
			unsolicitedJobExternalApplicationUrl: careerData?.jobs?.unsolicitedJobExternalApplicationUrl || InitialCareerFormValues.jobs?.unsolicitedJobExternalApplicationUrl || "",
			introduction: {
				...careerData?.jobs?.introduction,
				text: careerData?.jobs?.introduction?.text || ""
			},
			benefits: careerData?.jobs?.benefits?.map((benefit) => ({
				...benefit,
				title: benefit.title || "",
				benefits: benefit.benefits?.map((b) => ({ content: b.content || "" }))
			})),
			testimonials: careerData?.jobs?.testimonials?.map((testimonial) => ({
				...testimonial,
				name: testimonial.name || "",
				text: testimonial.text || ""
			})),
			faq: careerData?.jobs?.faq?.map((faq) => ({
				question: faq.question || "",
				answer: faq.answer || ""
			})),
			contacts: {
				...careerData?.jobs?.contacts,
				salutation: careerData?.jobs?.contacts?.salutation || "",
				name: careerData?.jobs?.contacts?.name || "",
				email: careerData?.jobs?.contacts?.email || "",
				phone: careerData?.jobs?.contacts?.phone || "",
				openingHours: careerData?.jobs?.contacts?.openingHours || "",
				whatsappNumber: careerData?.jobs?.contacts?.whatsappNumber || ""
			}
		},
		trainees: {
			...careerData?.trainees,
			isUnsolicitedJobsActive: careerData?.trainees?.isUnsolicitedJobsActive || InitialCareerFormValues.trainees?.isUnsolicitedJobsActive,
			unsolicitedJobImagePath: careerData?.trainees?.unsolicitedJobImagePath || InitialCareerFormValues.trainees?.unsolicitedJobImagePath,
			unsolicitedJobEmailRecipients: careerData?.trainees?.unsolicitedJobEmailRecipients?.length ? careerData.trainees.unsolicitedJobEmailRecipients : InitialCareerFormValues.trainees?.unsolicitedJobEmailRecipients,
			unsolicitedJobExternalApplicationUrl: careerData?.trainees?.unsolicitedJobExternalApplicationUrl || InitialCareerFormValues.trainees?.unsolicitedJobExternalApplicationUrl || "",
			introduction: {
				...careerData?.trainees?.introduction,
				text: careerData?.trainees?.introduction?.text || ""
			},
			benefits: careerData?.trainees?.benefits?.map((benefit) => ({
				...benefit,
				title: benefit.title || "",
				benefits: benefit.benefits?.map((b) => ({ content: b.content || "" }))
			})),
			testimonials: careerData?.trainees?.testimonials?.map((testimonial) => ({
				...testimonial,
				name: testimonial.name || "",
				text: testimonial.text || ""
			})),
			faq: careerData?.trainees?.faq?.map((faq) => ({
				question: faq.question || "",
				answer: faq.answer || ""
			})),
			contacts: {
				...careerData?.trainees?.contacts,
				salutation: careerData?.trainees?.contacts?.salutation || "",
				name: careerData?.trainees?.contacts?.name || "",
				email: careerData?.trainees?.contacts?.email || "",
				phone: careerData?.trainees?.contacts?.phone || "",
				openingHours: careerData?.trainees?.contacts?.openingHours || "",
				whatsappNumber: careerData?.trainees?.contacts?.whatsappNumber || ""
			}
		}
	};
};
// source/utilities/companies.ts
var LoginDataPlatforms = Object.keys(LoginDataPlatform);
var companyDefaultValues = { platformCredentials: LoginDataPlatforms.map((platform) => ({ platform })) };
var getDefaultPlatformCredentials = (credentials) => {
	if (!credentials || !Array.isArray(credentials) || credentials.length === 0) return companyDefaultValues.platformCredentials;
	const mergedCredentials = [];
	for (const platform of LoginDataPlatforms) {
		const credential = credentials.find((credential) => credential.platform === platform);
		if (credential) mergedCredentials.push({
			platform: credential.platform,
			url: credential.url || "",
			username: credential.username || "",
			password: credential.password || ""
		});
		else mergedCredentials.push({
			platform,
			url: "",
			password: "",
			username: ""
		});
	}
	return mergedCredentials;
};
// source/utilities/convert-schedule-to-timestamp.ts
var convertScheduleToTimestamp = (schedule, referenceDate = /* @__PURE__ */ new Date()) => {
	const [days, time] = schedule.split("@");
	const [hours, minutes, seconds] = time.split(":").map(Number);
	const currentDate = new Date(referenceDate);
	currentDate.setDate(currentDate.getDate() + Number.parseInt(days));
	currentDate.setHours(hours, minutes, seconds, 0);
	return currentDate.getTime();
};
// source/utilities/convert-schedule-to-email-delay.ts
var convertScheduleToEmailDelay = (schedule, referenceDate = /* @__PURE__ */ new Date()) => {
	return convertScheduleToTimestamp(schedule, referenceDate) - referenceDate.getTime();
};
// source/utilities/credentials.ts
var generatePassword = () => {
	const chars = `abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#^&*\$`;
	const passwordLength = 12;
	let password = "";
	for (let i = 0; i < passwordLength; i++) {
		const randIdx = Math.floor(Math.random() * chars.length);
		password += chars[randIdx];
	}
	return password;
};
var generateEmail = (name) => {
	const legalRegex = new RegExp(`\\b(${[
		"GmbH",
		"UG",
		"AG",
		"OHG",
		"KG",
		"GbR",
		"eK",
		"eG",
		"SE",
		"Co\\. KG",
		"KGaA",
		"mbH",
		"e\\.V\\.",
		"GmbH & Co\\. KG"
	].join("|")})\\b`, "gi");
	const prefix = "stahlhart.recruiting+";
	const maxNameLength = 43;
	let sanitizedName = name.replace(legalRegex, "").replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/Ä/g, "Ae").replace(/Ö/g, "Oe").replace(/Ü/g, "Ue").replace(/ß/g, "ss").replace(/[^a-zA-Z0-9\s]/g, "").toLocaleLowerCase().trim().replace(/\s+/g, "-");
	if (sanitizedName.length > maxNameLength) {
		const truncated = sanitizedName.slice(0, maxNameLength);
		const lastHyphen = truncated.lastIndexOf("-");
		sanitizedName = lastHyphen > 0 ? truncated.slice(0, lastHyphen) : truncated;
	}
	return `${prefix}${sanitizedName}@gmail.com`;
};
// ../../node_modules/@internationalized/date/dist/private/utils.mjs
function $09ec6a572d60460f$export$842a2cf37af977e1(amount, numerator) {
	return amount - numerator * Math.floor(amount / numerator);
}
// ../../node_modules/@internationalized/date/dist/private/calendars/GregorianCalendar.mjs
var $93635573935797de$var$EPOCH = 1721426;
function $93635573935797de$export$f297eb839006d339(era, year, month, day) {
	year = $93635573935797de$export$c36e0ecb2d4fa69d(era, year);
	let y1 = year - 1;
	let monthOffset = -2;
	if (month <= 2) monthOffset = 0;
	else if ($93635573935797de$export$553d7fa8e3805fc0(year)) monthOffset = -1;
	return 1721425 + 365 * y1 + Math.floor(y1 / 4) - Math.floor(y1 / 100) + Math.floor(y1 / 400) + Math.floor((367 * month - 362) / 12 + monthOffset + day);
}
function $93635573935797de$export$553d7fa8e3805fc0(year) {
	return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $93635573935797de$export$c36e0ecb2d4fa69d(era, year) {
	return era === "BC" ? 1 - year : year;
}
function $93635573935797de$export$4475b7e617eb123c(year) {
	let era = "AD";
	if (year <= 0) {
		era = "BC";
		year = 1 - year;
	}
	return [era, year];
}
var $93635573935797de$var$daysInMonth = {
	standard: [
		31,
		28,
		31,
		30,
		31,
		30,
		31,
		31,
		30,
		31,
		30,
		31
	],
	leapyear: [
		31,
		29,
		31,
		30,
		31,
		30,
		31,
		31,
		30,
		31,
		30,
		31
	]
};
var $93635573935797de$export$80ee6245ec4f29ec = class {
	fromJulianDay(jd) {
		let jd0 = jd;
		let depoch = jd0 - $93635573935797de$var$EPOCH;
		let quadricent = Math.floor(depoch / 146097);
		let dqc = $09ec6a572d60460f$export$842a2cf37af977e1(depoch, 146097);
		let cent = Math.floor(dqc / 36524);
		let dcent = $09ec6a572d60460f$export$842a2cf37af977e1(dqc, 36524);
		let quad = Math.floor(dcent / 1461);
		let dquad = $09ec6a572d60460f$export$842a2cf37af977e1(dcent, 1461);
		let yindex = Math.floor(dquad / 365);
		let [era, year] = $93635573935797de$export$4475b7e617eb123c(quadricent * 400 + cent * 100 + quad * 4 + yindex + (cent !== 4 && yindex !== 4 ? 1 : 0));
		let yearDay = jd0 - $93635573935797de$export$f297eb839006d339(era, year, 1, 1);
		let leapAdj = 2;
		if (jd0 < $93635573935797de$export$f297eb839006d339(era, year, 3, 1)) leapAdj = 0;
		else if ($93635573935797de$export$553d7fa8e3805fc0(year)) leapAdj = 1;
		let month = Math.floor(((yearDay + leapAdj) * 12 + 373) / 367);
		return new $2aaf608024c21ca1$export$99faa760c7908e4f(era, year, month, jd0 - $93635573935797de$export$f297eb839006d339(era, year, month, 1) + 1);
	}
	toJulianDay(date) {
		return $93635573935797de$export$f297eb839006d339(date.era, date.year, date.month, date.day);
	}
	getDaysInMonth(date) {
		return $93635573935797de$var$daysInMonth[$93635573935797de$export$553d7fa8e3805fc0(date.year) ? "leapyear" : "standard"][date.month - 1];
	}
	getMonthsInYear(date) {
		return 12;
	}
	getDaysInYear(date) {
		return $93635573935797de$export$553d7fa8e3805fc0(date.year) ? 366 : 365;
	}
	getMaximumMonthsInYear() {
		return 12;
	}
	getMaximumDaysInMonth() {
		return 31;
	}
	getYearsInEra(date) {
		return 9999;
	}
	getEras() {
		return ["BC", "AD"];
	}
	isInverseEra(date) {
		return date.era === "BC";
	}
	balanceDate(date) {
		if (date.year <= 0) {
			date.era = date.era === "BC" ? "AD" : "BC";
			date.year = 1 - date.year;
		}
	}
	constructor() {
		this.identifier = "gregory";
	}
};
// ../../node_modules/@internationalized/date/dist/private/queries.mjs
function $ad063034c8620db8$export$dbc69fd56b53d5e(a, b) {
	return a.isEqual?.(b) ?? b.isEqual?.(a) ?? a.identifier === b.identifier;
}
function $ad063034c8620db8$export$68781ddf31c0090f(a, b) {
	return a.calendar.toJulianDay(a) - b.calendar.toJulianDay(b);
}
function $ad063034c8620db8$export$c19a80a9721b80f6(a, b) {
	return $ad063034c8620db8$var$timeToMs(a) - $ad063034c8620db8$var$timeToMs(b);
}
function $ad063034c8620db8$var$timeToMs(a) {
	return a.hour * 36e5 + a.minute * 6e4 + a.second * 1e3 + a.millisecond;
}
var $ad063034c8620db8$var$localTimeZone = null;
var $ad063034c8620db8$var$localTimeZoneOverride = false;
function $ad063034c8620db8$export$aa8b41735afcabd2() {
	if ($ad063034c8620db8$var$localTimeZone == null) $ad063034c8620db8$var$localTimeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
	return $ad063034c8620db8$var$localTimeZone;
}
function $ad063034c8620db8$export$6ab69b273755230b() {
	return $ad063034c8620db8$var$localTimeZoneOverride;
}
function $ad063034c8620db8$export$a5a3b454ada2268e(date) {
	return date.subtract({ days: date.day - 1 });
}
function $ad063034c8620db8$export$a2258d9c4118825c(date) {
	return date.add({ days: date.calendar.getDaysInMonth(date) - date.day });
}
// ../../node_modules/@internationalized/date/dist/private/conversion.mjs
function $d07e34cce18680fd$export$bd4fb2bc8bb06fb(date) {
	date = $d07e34cce18680fd$export$b4a036af3fc0b032(date, new $93635573935797de$export$80ee6245ec4f29ec());
	return $d07e34cce18680fd$var$epochFromParts($93635573935797de$export$c36e0ecb2d4fa69d(date.era, date.year), date.month, date.day, date.hour, date.minute, date.second, date.millisecond);
}
function $d07e34cce18680fd$var$epochFromParts(year, month, day, hour, minute, second, millisecond) {
	let date = /* @__PURE__ */ new Date();
	date.setUTCHours(hour, minute, second, millisecond);
	date.setUTCFullYear(year, month - 1, day);
	return date.getTime();
}
function $d07e34cce18680fd$export$59c99f3515d3493f(ms, timeZone) {
	if (timeZone === "UTC") return 0;
	if (ms > 0 && timeZone === $ad063034c8620db8$export$aa8b41735afcabd2() && !$ad063034c8620db8$export$6ab69b273755230b()) return new Date(ms).getTimezoneOffset() * -6e4;
	let { year, month, day, hour, minute, second } = $d07e34cce18680fd$var$getTimeZoneParts(ms, timeZone);
	return $d07e34cce18680fd$var$epochFromParts(year, month, day, hour, minute, second, 0) - Math.floor(ms / 1e3) * 1e3;
}
var $d07e34cce18680fd$var$formattersByTimeZone = /* @__PURE__ */ new Map();
function $d07e34cce18680fd$var$getTimeZoneParts(ms, timeZone) {
	let formatter = $d07e34cce18680fd$var$formattersByTimeZone.get(timeZone);
	if (!formatter) {
		formatter = new Intl.DateTimeFormat("en-US", {
			timeZone,
			hour12: false,
			era: "short",
			year: "numeric",
			month: "numeric",
			day: "numeric",
			hour: "numeric",
			minute: "numeric",
			second: "numeric"
		});
		$d07e34cce18680fd$var$formattersByTimeZone.set(timeZone, formatter);
	}
	let parts = formatter.formatToParts(new Date(ms));
	let namedParts = {};
	for (let part of parts) if (part.type !== "literal") namedParts[part.type] = part.value;
	return {
		year: namedParts.era === "BC" || namedParts.era === "B" ? -namedParts.year + 1 : +namedParts.year,
		month: +namedParts.month,
		day: +namedParts.day,
		hour: namedParts.hour === "24" ? 0 : +namedParts.hour,
		minute: +namedParts.minute,
		second: +namedParts.second
	};
}
var $d07e34cce18680fd$var$DAYMILLIS = 864e5;
function $d07e34cce18680fd$var$getValidWallTimes(date, timeZone, earlier, later) {
	return (earlier === later ? [earlier] : [earlier, later]).filter((absolute) => $d07e34cce18680fd$var$isValidWallTime(date, timeZone, absolute));
}
function $d07e34cce18680fd$var$isValidWallTime(date, timeZone, absolute) {
	let parts = $d07e34cce18680fd$var$getTimeZoneParts(absolute, timeZone);
	return date.year === parts.year && date.month === parts.month && date.day === parts.day && date.hour === parts.hour && date.minute === parts.minute && date.second === parts.second;
}
function $d07e34cce18680fd$export$5107c82f94518f5c(date, timeZone, disambiguation = "compatible") {
	let dateTime = $d07e34cce18680fd$export$b21e0b124e224484(date);
	if (timeZone === "UTC") return $d07e34cce18680fd$export$bd4fb2bc8bb06fb(dateTime);
	if (timeZone === $ad063034c8620db8$export$aa8b41735afcabd2() && disambiguation === "compatible" && !$ad063034c8620db8$export$6ab69b273755230b()) {
		dateTime = $d07e34cce18680fd$export$b4a036af3fc0b032(dateTime, new $93635573935797de$export$80ee6245ec4f29ec());
		let date = /* @__PURE__ */ new Date();
		let year = $93635573935797de$export$c36e0ecb2d4fa69d(dateTime.era, dateTime.year);
		date.setFullYear(year, dateTime.month - 1, dateTime.day);
		date.setHours(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
		return date.getTime();
	}
	let ms = $d07e34cce18680fd$export$bd4fb2bc8bb06fb(dateTime);
	let offsetBefore = $d07e34cce18680fd$export$59c99f3515d3493f(ms - $d07e34cce18680fd$var$DAYMILLIS, timeZone);
	let offsetAfter = $d07e34cce18680fd$export$59c99f3515d3493f(ms + $d07e34cce18680fd$var$DAYMILLIS, timeZone);
	let valid = $d07e34cce18680fd$var$getValidWallTimes(dateTime, timeZone, ms - offsetBefore, ms - offsetAfter);
	if (valid.length === 1) return valid[0];
	if (valid.length > 1) switch (disambiguation) {
		case "compatible":
		case "earlier": return valid[0];
		case "later": return valid[valid.length - 1];
		case "reject": throw new RangeError("Multiple possible absolute times found");
	}
	switch (disambiguation) {
		case "earlier": return Math.min(ms - offsetBefore, ms - offsetAfter);
		case "compatible":
		case "later": return Math.max(ms - offsetBefore, ms - offsetAfter);
		case "reject": throw new RangeError("No such absolute time found");
	}
}
function $d07e34cce18680fd$export$e67a095c620b86fe(dateTime, timeZone, disambiguation = "compatible") {
	return new Date($d07e34cce18680fd$export$5107c82f94518f5c(dateTime, timeZone, disambiguation));
}
function $d07e34cce18680fd$export$b21e0b124e224484(date, time) {
	let hour = 0, minute = 0, second = 0, millisecond = 0;
	if ("timeZone" in date) ({hour: hour, minute: minute, second: second, millisecond: millisecond} = date);
	else if ("hour" in date && !time) return date;
	if (time) ({hour: hour, minute: minute, second: second, millisecond: millisecond} = time);
	return new $2aaf608024c21ca1$export$ca871e8dbb80966f(date.calendar, date.era, date.year, date.month, date.day, hour, minute, second, millisecond);
}
function $d07e34cce18680fd$export$b4a036af3fc0b032(date, calendar) {
	if ($ad063034c8620db8$export$dbc69fd56b53d5e(date.calendar, calendar)) return date;
	let calendarDate = calendar.fromJulianDay(date.calendar.toJulianDay(date));
	let copy = date.copy();
	copy.calendar = calendar;
	copy.era = calendarDate.era;
	copy.year = calendarDate.year;
	copy.month = calendarDate.month;
	copy.day = calendarDate.day;
	$435a2ceaa8778ed8$export$c4e2ecac49351ef2(copy);
	return copy;
}
// ../../node_modules/@internationalized/date/dist/private/manipulation.mjs
function $435a2ceaa8778ed8$export$e16d8520af44a096(date, duration) {
	let mutableDate = date.copy();
	let days = "hour" in mutableDate ? $435a2ceaa8778ed8$var$addTimeFields(mutableDate, duration) : 0;
	$435a2ceaa8778ed8$var$addYears(mutableDate, duration.years || 0);
	if (mutableDate.calendar.balanceYearMonth) mutableDate.calendar.balanceYearMonth(mutableDate, date);
	mutableDate.month += duration.months || 0;
	$435a2ceaa8778ed8$var$balanceYearMonth(mutableDate);
	$435a2ceaa8778ed8$var$constrainMonthDay(mutableDate);
	mutableDate.day += (duration.weeks || 0) * 7;
	mutableDate.day += duration.days || 0;
	mutableDate.day += days;
	$435a2ceaa8778ed8$var$balanceDay(mutableDate);
	if (mutableDate.calendar.balanceDate) mutableDate.calendar.balanceDate(mutableDate);
	if (mutableDate.year < 1) {
		mutableDate.year = 1;
		mutableDate.month = 1;
		mutableDate.day = 1;
	}
	let maxYear = mutableDate.calendar.getYearsInEra(mutableDate);
	if (mutableDate.year > maxYear) {
		let isInverseEra = mutableDate.calendar.isInverseEra?.(mutableDate);
		mutableDate.year = maxYear;
		mutableDate.month = isInverseEra ? 1 : mutableDate.calendar.getMonthsInYear(mutableDate);
		mutableDate.day = isInverseEra ? 1 : mutableDate.calendar.getDaysInMonth(mutableDate);
	}
	if (mutableDate.month < 1) {
		mutableDate.month = 1;
		mutableDate.day = 1;
	}
	let maxMonth = mutableDate.calendar.getMonthsInYear(mutableDate);
	if (mutableDate.month > maxMonth) {
		mutableDate.month = maxMonth;
		mutableDate.day = mutableDate.calendar.getDaysInMonth(mutableDate);
	}
	mutableDate.day = Math.max(1, Math.min(mutableDate.calendar.getDaysInMonth(mutableDate), mutableDate.day));
	return mutableDate;
}
function $435a2ceaa8778ed8$var$addYears(date, years) {
	if (date.calendar.isInverseEra?.(date)) years = -years;
	date.year += years;
}
function $435a2ceaa8778ed8$var$balanceYearMonth(date) {
	while (date.month < 1) {
		$435a2ceaa8778ed8$var$addYears(date, -1);
		date.month += date.calendar.getMonthsInYear(date);
	}
	let monthsInYear = 0;
	while (date.month > (monthsInYear = date.calendar.getMonthsInYear(date))) {
		date.month -= monthsInYear;
		$435a2ceaa8778ed8$var$addYears(date, 1);
	}
}
function $435a2ceaa8778ed8$var$balanceDay(date) {
	while (date.day < 1) {
		date.month--;
		$435a2ceaa8778ed8$var$balanceYearMonth(date);
		date.day += date.calendar.getDaysInMonth(date);
	}
	while (date.day > date.calendar.getDaysInMonth(date)) {
		date.day -= date.calendar.getDaysInMonth(date);
		date.month++;
		$435a2ceaa8778ed8$var$balanceYearMonth(date);
	}
}
function $435a2ceaa8778ed8$var$constrainMonthDay(date) {
	date.month = Math.max(1, Math.min(date.calendar.getMonthsInYear(date), date.month));
	date.day = Math.max(1, Math.min(date.calendar.getDaysInMonth(date), date.day));
}
function $435a2ceaa8778ed8$export$c4e2ecac49351ef2(date) {
	if (date.calendar.constrainDate) date.calendar.constrainDate(date);
	date.year = Math.max(1, Math.min(date.calendar.getYearsInEra(date), date.year));
	$435a2ceaa8778ed8$var$constrainMonthDay(date);
}
function $435a2ceaa8778ed8$export$3e2544e88a25bff8(duration) {
	let inverseDuration = {};
	for (let key in duration) if (typeof duration[key] === "number") inverseDuration[key] = -duration[key];
	return inverseDuration;
}
function $435a2ceaa8778ed8$export$4e2d2ead65e5f7e3(date, duration) {
	return $435a2ceaa8778ed8$export$e16d8520af44a096(date, $435a2ceaa8778ed8$export$3e2544e88a25bff8(duration));
}
function $435a2ceaa8778ed8$export$adaa4cf7ef1b65be(date, fields) {
	let mutableDate = date.copy();
	if (fields.era != null) mutableDate.era = fields.era;
	if (fields.year != null) mutableDate.year = fields.year;
	if (fields.month != null) mutableDate.month = fields.month;
	if (fields.day != null) mutableDate.day = fields.day;
	$435a2ceaa8778ed8$export$c4e2ecac49351ef2(mutableDate);
	return mutableDate;
}
function $435a2ceaa8778ed8$export$e5d5e1c1822b6e56(value, fields) {
	let mutableValue = value.copy();
	if (fields.hour != null) mutableValue.hour = fields.hour;
	if (fields.minute != null) mutableValue.minute = fields.minute;
	if (fields.second != null) mutableValue.second = fields.second;
	if (fields.millisecond != null) mutableValue.millisecond = fields.millisecond;
	$435a2ceaa8778ed8$export$7555de1e070510cb(mutableValue);
	return mutableValue;
}
function $435a2ceaa8778ed8$var$balanceTime(time) {
	time.second += Math.floor(time.millisecond / 1e3);
	time.millisecond = $435a2ceaa8778ed8$var$nonNegativeMod(time.millisecond, 1e3);
	time.minute += Math.floor(time.second / 60);
	time.second = $435a2ceaa8778ed8$var$nonNegativeMod(time.second, 60);
	time.hour += Math.floor(time.minute / 60);
	time.minute = $435a2ceaa8778ed8$var$nonNegativeMod(time.minute, 60);
	let days = Math.floor(time.hour / 24);
	time.hour = $435a2ceaa8778ed8$var$nonNegativeMod(time.hour, 24);
	return days;
}
function $435a2ceaa8778ed8$export$7555de1e070510cb(time) {
	time.millisecond = Math.max(0, Math.min(time.millisecond, 999));
	time.second = Math.max(0, Math.min(time.second, 59));
	time.minute = Math.max(0, Math.min(time.minute, 59));
	time.hour = Math.max(0, Math.min(time.hour, 23));
}
function $435a2ceaa8778ed8$var$nonNegativeMod(a, b) {
	let result = a % b;
	if (result < 0) result += b;
	return result;
}
function $435a2ceaa8778ed8$var$addTimeFields(time, duration) {
	time.hour += duration.hours || 0;
	time.minute += duration.minutes || 0;
	time.second += duration.seconds || 0;
	time.millisecond += duration.milliseconds || 0;
	return $435a2ceaa8778ed8$var$balanceTime(time);
}
function $435a2ceaa8778ed8$export$d52ced6badfb9a4c(value, field, amount, options) {
	let mutable = value.copy();
	switch (field) {
		case "era": {
			let eras = value.calendar.getEras();
			let eraIndex = eras.indexOf(value.era);
			if (eraIndex < 0) throw new Error("Invalid era: " + value.era);
			eraIndex = $435a2ceaa8778ed8$var$cycleValue(eraIndex, amount, 0, eras.length - 1, options?.round);
			mutable.era = eras[eraIndex];
			$435a2ceaa8778ed8$export$c4e2ecac49351ef2(mutable);
			break;
		}
		case "year":
			if (mutable.calendar.isInverseEra?.(mutable)) amount = -amount;
			mutable.year = $435a2ceaa8778ed8$var$cycleValue(value.year, amount, -Infinity, 9999, options?.round);
			if (mutable.year === -Infinity) mutable.year = 1;
			if (mutable.calendar.balanceYearMonth) mutable.calendar.balanceYearMonth(mutable, value);
			break;
		case "month":
			mutable.month = $435a2ceaa8778ed8$var$cycleValue(value.month, amount, 1, value.calendar.getMonthsInYear(value), options?.round);
			break;
		case "day":
			mutable.day = $435a2ceaa8778ed8$var$cycleValue(value.day, amount, 1, value.calendar.getDaysInMonth(value), options?.round);
			break;
		default: throw new Error("Unsupported field " + field);
	}
	if (value.calendar.balanceDate) value.calendar.balanceDate(mutable);
	$435a2ceaa8778ed8$export$c4e2ecac49351ef2(mutable);
	return mutable;
}
function $435a2ceaa8778ed8$export$dd02b3e0007dfe28(value, field, amount, options) {
	let mutable = value.copy();
	switch (field) {
		case "hour": {
			let hours = value.hour;
			let min = 0;
			let max = 23;
			if (options?.hourCycle === 12) {
				let isPM = hours >= 12;
				min = isPM ? 12 : 0;
				max = isPM ? 23 : 11;
			}
			mutable.hour = $435a2ceaa8778ed8$var$cycleValue(hours, amount, min, max, options?.round);
			break;
		}
		case "minute":
			mutable.minute = $435a2ceaa8778ed8$var$cycleValue(value.minute, amount, 0, 59, options?.round);
			break;
		case "second":
			mutable.second = $435a2ceaa8778ed8$var$cycleValue(value.second, amount, 0, 59, options?.round);
			break;
		case "millisecond":
			mutable.millisecond = $435a2ceaa8778ed8$var$cycleValue(value.millisecond, amount, 0, 999, options?.round);
			break;
		default: throw new Error("Unsupported field " + field);
	}
	return mutable;
}
function $435a2ceaa8778ed8$var$cycleValue(value, amount, min, max, round = false) {
	if (round) {
		value += Math.sign(amount);
		if (value < min) value = max;
		let div = Math.abs(amount);
		if (amount > 0) value = Math.ceil(value / div) * div;
		else value = Math.floor(value / div) * div;
		if (value > max) value = min;
	} else {
		value += amount;
		if (value < min) value = max - (min - value - 1);
		else if (value > max) value = min + (value - max - 1);
	}
	return value;
}
// ../../node_modules/@internationalized/date/dist/private/string.mjs
var $58246871e4652552$var$DATE_RE = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})$/;
var $58246871e4652552$var$ABSOLUTE_RE = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:(?:([+-]\d{2})(?::?(\d{2}))?)|Z)$/;
function $58246871e4652552$export$6b862160d295c8e(value) {
	let m = value.match($58246871e4652552$var$DATE_RE);
	if (!m) {
		if ($58246871e4652552$var$ABSOLUTE_RE.test(value)) throw new Error(`Invalid ISO 8601 date string: ${value}. Use parseAbsolute() instead.`);
		throw new Error("Invalid ISO 8601 date string: " + value);
	}
	let date = new $2aaf608024c21ca1$export$99faa760c7908e4f($58246871e4652552$var$parseNumber(m[1], 0, 9999), $58246871e4652552$var$parseNumber(m[2], 1, 12), 1);
	date.day = $58246871e4652552$var$parseNumber(m[3], 1, date.calendar.getDaysInMonth(date));
	return date;
}
function $58246871e4652552$var$parseNumber(value, min, max) {
	let val = Number(value);
	if (val < min || val > max) throw new RangeError(`Value out of range: ${min} <= ${val} <= ${max}`);
	return val;
}
function $58246871e4652552$export$f59dee82248f5ad4(time) {
	return `${String(time.hour).padStart(2, "0")}:${String(time.minute).padStart(2, "0")}:${String(time.second).padStart(2, "0")}${time.millisecond ? String(time.millisecond / 1e3).slice(1) : ""}`;
}
function $58246871e4652552$export$60dfd74aa96791bd(date) {
	let gregorianDate = $d07e34cce18680fd$export$b4a036af3fc0b032(date, new $93635573935797de$export$80ee6245ec4f29ec());
	let year;
	if (gregorianDate.era === "BC") year = gregorianDate.year === 1 ? "0000" : "-" + String(Math.abs(1 - gregorianDate.year)).padStart(6, "00");
	else year = String(gregorianDate.year).padStart(4, "0");
	return `${year}-${String(gregorianDate.month).padStart(2, "0")}-${String(gregorianDate.day).padStart(2, "0")}`;
}
function $58246871e4652552$export$4223de14708adc63(date) {
	return `${$58246871e4652552$export$60dfd74aa96791bd(date)}T${$58246871e4652552$export$f59dee82248f5ad4(date)}`;
}
// ../../node_modules/@internationalized/date/dist/private/CalendarDate.mjs
function $2aaf608024c21ca1$var$shiftArgs(args) {
	let calendar = typeof args[0] === "object" ? args.shift() : new $93635573935797de$export$80ee6245ec4f29ec();
	let era;
	if (typeof args[0] === "string") era = args.shift();
	else {
		let eras = calendar.getEras();
		era = eras[eras.length - 1];
	}
	let year = args.shift();
	let month = args.shift();
	let day = args.shift();
	return [
		calendar,
		era,
		year,
		month,
		day
	];
}
var $2aaf608024c21ca1$export$99faa760c7908e4f = class $2aaf608024c21ca1$export$99faa760c7908e4f {
	#type;
	constructor(...args) {
		let [calendar, era, year, month, day] = $2aaf608024c21ca1$var$shiftArgs(args);
		this.calendar = calendar;
		this.era = era;
		this.year = year;
		this.month = month;
		this.day = day;
		$435a2ceaa8778ed8$export$c4e2ecac49351ef2(this);
	}
	/** Returns a copy of this date. */ copy() {
		if (this.era) return new $2aaf608024c21ca1$export$99faa760c7908e4f(this.calendar, this.era, this.year, this.month, this.day);
		else return new $2aaf608024c21ca1$export$99faa760c7908e4f(this.calendar, this.year, this.month, this.day);
	}
	/** Returns a new `CalendarDate` with the given duration added to it. */ add(duration) {
		return $435a2ceaa8778ed8$export$e16d8520af44a096(this, duration);
	}
	/** Returns a new `CalendarDate` with the given duration subtracted from it. */ subtract(duration) {
		return $435a2ceaa8778ed8$export$4e2d2ead65e5f7e3(this, duration);
	}
	/**
	* Returns a new `CalendarDate` with the given fields set to the provided values. Other fields
	* will be constrained accordingly.
	*/ set(fields) {
		return $435a2ceaa8778ed8$export$adaa4cf7ef1b65be(this, fields);
	}
	/**
	* Returns a new `CalendarDate` with the given field adjusted by a specified amount.
	* When the resulting value reaches the limits of the field, it wraps around.
	*/ cycle(field, amount, options) {
		return $435a2ceaa8778ed8$export$d52ced6badfb9a4c(this, field, amount, options);
	}
	/**
	* Converts the date to a native JavaScript Date object, with the time set to midnight in the
	* given time zone.
	*/ toDate(timeZone) {
		return $d07e34cce18680fd$export$e67a095c620b86fe(this, timeZone);
	}
	/** Converts the date to an ISO 8601 formatted string. */ toString() {
		return $58246871e4652552$export$60dfd74aa96791bd(this);
	}
	/**
	* Compares this date with another. A negative result indicates that this date is before the given
	* one, and a positive date indicates that it is after.
	*/ compare(b) {
		return $ad063034c8620db8$export$68781ddf31c0090f(this, b);
	}
};
var $2aaf608024c21ca1$export$ca871e8dbb80966f = class $2aaf608024c21ca1$export$ca871e8dbb80966f {
	#type;
	constructor(...args) {
		let [calendar, era, year, month, day] = $2aaf608024c21ca1$var$shiftArgs(args);
		this.calendar = calendar;
		this.era = era;
		this.year = year;
		this.month = month;
		this.day = day;
		this.hour = args.shift() || 0;
		this.minute = args.shift() || 0;
		this.second = args.shift() || 0;
		this.millisecond = args.shift() || 0;
		$435a2ceaa8778ed8$export$c4e2ecac49351ef2(this);
	}
	/** Returns a copy of this date. */ copy() {
		if (this.era) return new $2aaf608024c21ca1$export$ca871e8dbb80966f(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
		else return new $2aaf608024c21ca1$export$ca871e8dbb80966f(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
	}
	/** Returns a new `CalendarDateTime` with the given duration added to it. */ add(duration) {
		return $435a2ceaa8778ed8$export$e16d8520af44a096(this, duration);
	}
	/** Returns a new `CalendarDateTime` with the given duration subtracted from it. */ subtract(duration) {
		return $435a2ceaa8778ed8$export$4e2d2ead65e5f7e3(this, duration);
	}
	/**
	* Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields
	* will be constrained accordingly.
	*/ set(fields) {
		return $435a2ceaa8778ed8$export$adaa4cf7ef1b65be($435a2ceaa8778ed8$export$e5d5e1c1822b6e56(this, fields), fields);
	}
	/**
	* Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
	* When the resulting value reaches the limits of the field, it wraps around.
	*/ cycle(field, amount, options) {
		switch (field) {
			case "era":
			case "year":
			case "month":
			case "day": return $435a2ceaa8778ed8$export$d52ced6badfb9a4c(this, field, amount, options);
			default: return $435a2ceaa8778ed8$export$dd02b3e0007dfe28(this, field, amount, options);
		}
	}
	/** Converts the date to a native JavaScript Date object in the given time zone. */ toDate(timeZone, disambiguation) {
		return $d07e34cce18680fd$export$e67a095c620b86fe(this, timeZone, disambiguation);
	}
	/** Converts the date to an ISO 8601 formatted string. */ toString() {
		return $58246871e4652552$export$4223de14708adc63(this);
	}
	/**
	* Compares this date with another. A negative result indicates that this date is before the given
	* one, and a positive date indicates that it is after.
	*/ compare(b) {
		let res = $ad063034c8620db8$export$68781ddf31c0090f(this, b);
		if (res === 0) return $ad063034c8620db8$export$c19a80a9721b80f6(this, $d07e34cce18680fd$export$b21e0b124e224484(b));
		return res;
	}
};
// source/utilities/dates.ts
var splitDateRangeIntoMonths = (startDate, endDate) => {
	const result = [];
	let current = $ad063034c8620db8$export$a5a3b454ada2268e($58246871e4652552$export$6b862160d295c8e((typeof startDate === "string" ? startDate : startDate.toISOString()).split("T")[0]));
	const finalDate = $58246871e4652552$export$6b862160d295c8e((typeof endDate === "string" ? endDate : endDate.toISOString()).split("T")[0]);
	while (current.compare(finalDate) <= 0) {
		const rangeStart = current.toString();
		const monthEnd = $ad063034c8620db8$export$a2258d9c4118825c(current);
		const rangeEnd = monthEnd.compare(finalDate) <= 0 ? monthEnd.toString() : finalDate.toString();
		result.push({
			startDate: rangeStart,
			endDate: rangeEnd
		});
		current = current.add({ months: 1 });
	}
	return result;
};
/**
* Generates an array of date ranges for each month between the start and end dates.
* The dates the first of the month at midnight.
*/
var getMonthsBetweenDates = (startDate, endDate) => {
	let current = $ad063034c8620db8$export$a5a3b454ada2268e(startDate);
	const end = $ad063034c8620db8$export$a5a3b454ada2268e(endDate);
	const result = [];
	while (current.compare(end) <= 0) {
		result.push(current);
		current = current.add({ months: 1 });
	}
	return result;
};
var setHoursToMidnight = (date) => {
	const midnightDate = new Date(date);
	midnightDate.setHours(0, 0, 0, 0);
	return midnightDate;
};
var setHoursToBeforeMidnight = (date) => {
	const beforeMidnightDate = new Date(date);
	beforeMidnightDate.setHours(23, 59, 59, 999);
	return beforeMidnightDate;
};
var getLastWeekMonday = () => {
	const today = setHoursToMidnight(/* @__PURE__ */ new Date());
	const thisWeeksMonday = new Date(today);
	const daysSinceMonday = (today.getDay() + 6) % 7;
	thisWeeksMonday.setDate(today.getDate() - daysSinceMonday);
	const lastWeeksMonday = new Date(thisWeeksMonday);
	lastWeeksMonday.setDate(thisWeeksMonday.getDate() - 7);
	return setHoursToMidnight(lastWeeksMonday);
};
// source/utilities/email.ts
var transformLineBreaksToHtml = (text) => {
	return text?.split(/\n\n+/).map((paragraph) => `<p>${paragraph.replace(/\n/g, "<br>")}</p>`).join("\n") ?? "";
};
var mergeHtmlBodyAndSignature = ({ body, signature }) => {
	if (!signature) return body;
	return `${body}
<p></p>
${signature}`;
};
var mergeTextBodyAndSignature = ({ body, signature }) => {
	if (!signature) return body;
	return `${body}\n\n${signature}`;
};
// source/utilities/fonts.ts
var getFontWeightRanges = (font) => {
	const ranges = [];
	let start = null;
	let last = null;
	const weights = [
		font.activeForWeight100 ? "100" : null,
		font.activeForWeight200 ? "200" : null,
		font.activeForWeight300 ? "300" : null,
		font.activeForWeight400 ? "400" : null,
		font.activeForWeight500 ? "500" : null,
		font.activeForWeight600 ? "600" : null,
		font.activeForWeight700 ? "700" : null,
		font.activeForWeight800 ? "800" : null,
		font.activeForWeight900 ? "900" : null
	];
	for (const w of weights) if (w) {
		if (start === null) start = w;
		last = w;
	} else if (start !== null) {
		ranges.push(start === last ? start : `${start} ${last}`);
		start = null;
		last = null;
	}
	if (start !== null) ranges.push(start === last ? start : `${start} ${last}`);
	return ranges;
};
var fontFormatMap = {
	TTF: "truetype",
	OTF: "opentype",
	WOFF: "woff",
	WOFF2: "woff2",
	EOT: "embedded-opentype",
	SVG: "svg"
};
// source/utilities/format-applicant-origin.ts
var formatApplicantOrigin = (origin) => {
	switch (origin) {
		case ApplicantOrigin.MANUAL: return "Manuell erstellt";
		case ApplicantOrigin.PERSPECTIVE: return "Perspective";
		case ApplicantOrigin.CAREER_PAGE: return "Karriereseite";
		case ApplicantOrigin.WL_LANDING_PAGE: return "WL Landing Page";
		default: return "-";
	}
};
// source/utilities/format-applicant-score-rating.ts
var formatApplicantScoreRating = (status) => {
	switch (status) {
		case ApplicantScoreRatings.APPROVED: return "Erfüllt";
		case ApplicantScoreRatings.PARTIAL: return "Teilweise erfüllt";
		case ApplicantScoreRatings.REJECTED: return "Nicht erfüllt";
		default: return "Nicht geprüft";
	}
};
// source/utilities/format-number.ts
var formatNumber = (number, precision = 0) => {
	return new Intl.NumberFormat("de-DE", {
		minimumFractionDigits: precision,
		maximumFractionDigits: precision
	}).format(number);
};
// source/utilities/format-credits.ts
var formatCredits = (credits) => {
	const suffix = Math.abs(credits) === 1 ? "Kontingent" : "Kontingente";
	return `${formatNumber(credits, Math.abs(credits % 1) !== 0 ? 1 : 0)} ${suffix}`;
};
// source/utilities/format-currency.ts
var formatCurrency = (amount, precision = 2) => {
	return new Intl.NumberFormat("de-DE", {
		style: "currency",
		currency: "EUR",
		minimumFractionDigits: precision,
		maximumFractionDigits: precision
	}).format(amount);
};
// source/utilities/format-date.ts
var shortMonthsMap = {
	"Mär.": "März",
	"Mai.": "Mai",
	"Jun.": "Juni",
	"Jul.": "Juli"
};
var formatDate = (date, dateFnsFormat, options) => {
	if (!date) return "–";
	if (!(date instanceof Date) && typeof date !== "string") return "–";
	let sanitizedDate = date instanceof Date ? new Date(date.getTime()) : date;
	if (options?.parseFormat && typeof sanitizedDate === "string") sanitizedDate = parse(sanitizedDate, options.parseFormat, /* @__PURE__ */ new Date());
	try {
		const isShortMonth = dateFnsFormat.includes("MMM") || dateFnsFormat.includes("LLL");
		let formattedDate = formatInTimeZone(sanitizedDate, config.timeZone, dateFnsFormat, { locale: de });
		if (isShortMonth) for (const [shortMonth, longMonth] of Object.entries(shortMonthsMap)) formattedDate = formattedDate.replace(shortMonth, longMonth);
		return formattedDate;
	} catch {
		return "Ungültiges Datum";
	}
};
// source/utilities/format-duration.ts
var formatDuration = (seconds, options) => {
	const hourUnit = options?.compact ? "h" : " std";
	const minuteUnit = options?.compact ? "m" : " min";
	const secondUnit = options?.compact ? "s" : " sek";
	const parsedSeconds = typeof seconds === "string" ? Number.parseFloat(seconds) : seconds;
	const hours = Math.floor(parsedSeconds / 3600);
	const mins = Math.floor(parsedSeconds % 3600 / 60);
	const secondsLeft = Math.floor(parsedSeconds % 60);
	if (parsedSeconds <= 60 && !options?.withSeconds) return `1${minuteUnit}`;
	const parts = [];
	if (hours) parts.push(`${hours}${hourUnit}`);
	if (mins) parts.push(`${mins}${minuteUnit}`);
	if (options?.withSeconds && typeof secondsLeft === "number") parts.push(`${secondsLeft}${secondUnit}`);
	return parts.join(" ");
};
/**
* Calculates the time between two dates and formats it in German.
* Assumes the start date is the first of a month and the end date is the last of a month.
*
* @param {Date} startDate - The start date of the period.
* @param {Date} endDate - The end date of the period.
* @returns {string} The formatted duration string (e.g., "1 Jahr und 2 Monate").
*/
var formatDateDuration = (startDate, endDate) => {
	const effectiveEndDate = addDays(endOfMonth(endDate), 1);
	const duration = intervalToDuration({
		start: startOfMonth(startDate),
		end: effectiveEndDate
	});
	const years = duration.years ?? 0;
	const months = duration.months ?? 0;
	const parts = [];
	if (years > 0) parts.push(`${years} ${years === 1 ? "Jahr" : "Jahre"}`);
	if (months > 0) parts.push(`${months} ${months === 1 ? "Monat" : "Monate"}`);
	return parts.join(" und ");
};
// source/utilities/format-job-position-label.ts
var formatJobPositionLabel = (jobPosition, options = {}) => {
	let formattedLabel = "";
	const jobPositionName = options.short ? jobPosition.name : jobPosition.fullName || jobPosition.name;
	switch (jobPosition.type) {
		case JobPositionType.EMPLOYEE:
			formattedLabel = jobPositionName;
			break;
		case JobPositionType.TRAINEE: {
			const specializationPart = jobPosition.specialization ? ` Fachrichtung ${jobPosition.specialization}` : "";
			formattedLabel = `Ausbildung ${jobPositionName}${options.short ? "" : specializationPart}`;
			break;
		}
		case JobPositionType.DUAL_STUDENT:
			formattedLabel = `Duales Studium ${jobPositionName}`;
			break;
		default: formattedLabel = jobPositionName;
	}
	return formattedLabel;
};
// source/utilities/format-job-position-quota-guarantee.ts
/**
* The German labels of the guarantee phases on the monday board "Recruiting",
* which is where the guarantee gets synced from (see `recruiting-phase`).
* "Einstellungsgarantie inaktiv" reads as "Einstellungsgarantie" here, as the
* customer sees no difference. Shared by every view which names the guarantee,
* so the admin table and the marketing manager panel cannot drift apart.
*/
var formatJobPositionQuotaGuarantee = (quotaGuarantee) => {
	switch (quotaGuarantee) {
		case JobPositionQuotaGuarantee.GRACE_PERIOD: return "Karenzzeit";
		case JobPositionQuotaGuarantee.HIRING_GUARANTEE: return "Einstellungsgarantie";
		default: return null;
	}
};
/**
* A quota with a guarantee stays active in monday, only its label differs, so
* the guarantee replaces "Aktiv" instead of being shown next to it.
*/
var formatJobPositionQuotaState = (isQuotaActive, quotaGuarantee) => {
	if (!isQuotaActive) return "Inaktiv";
	return formatJobPositionQuotaGuarantee(quotaGuarantee) ?? "Aktiv";
};
// source/utilities/format-job-position-type-noun.ts
/**
* The generic noun for what a job position is, for copy that talks *about* the
* position instead of naming it ("… hat die Stelle X online gestellt"). Kept
* apart from {@link formatJobPositionLabel}, which prefixes the title itself.
*/
var formatJobPositionTypeNoun = (jobPosition) => {
	switch (jobPosition.type) {
		case JobPositionType.TRAINEE: return "Ausbildung";
		case JobPositionType.DUAL_STUDENT: return "Duales Studium";
		default: return "Stelle";
	}
};
/**
* Same noun with its definite article. Spelled out per type instead of
* prefixing {@link formatJobPositionTypeNoun}, because the gender differs and
* the adjective in "Duales Studium" inflects once an article precedes it.
*/
var formatJobPositionTypeNounWithArticle = (jobPosition) => {
	switch (jobPosition.type) {
		case JobPositionType.TRAINEE: return "die Ausbildung";
		case JobPositionType.DUAL_STUDENT: return "das Duale Studium";
		default: return "die Stelle";
	}
};
// source/utilities/format-location.ts
var formatLocation = (location) => {
	if (!location) return "–";
	if (location?.name) return location.name;
	if (location.city || location.zipCode) return `${location.zipCode} ${location.city}`.trim();
	if (location?.googleMapsTitle) return location.googleMapsTitle;
	return "–";
};
// source/utilities/format-percent.ts
var formatPercent = (number, precision = 0) => {
	return new Intl.NumberFormat("de-DE", {
		style: "percent",
		minimumFractionDigits: precision,
		maximumFractionDigits: precision
	}).format(number);
};
// source/utilities/format-phone-number.ts
var formatPhoneNumber = (number) => {
	if (!number || typeof number !== "string") return number;
	return number.replace(/[^\d+]/g, "");
};
// source/utilities/format-time-ago.ts
var formatTimeAgo = (dateInput) => {
	if (!dateInput) return "";
	const date = new Date(dateInput);
	if (Number.isNaN(date.getTime())) return "";
	const now = /* @__PURE__ */ new Date();
	const isFuture = date > now;
	const start = isFuture ? now : date;
	const end = isFuture ? date : now;
	let years = end.getFullYear() - start.getFullYear();
	let months = end.getMonth() - start.getMonth();
	let days = end.getDate() - start.getDate();
	if (days < 0) {
		months--;
		const prevMonth = new Date(end.getFullYear(), end.getMonth(), 0);
		days += prevMonth.getDate();
	}
	if (months < 0) {
		years--;
		months += 12;
	}
	const parts = [];
	if (years > 0) parts.push(`${years} Jahr${years !== 1 ? "en" : ""}`);
	if (months > 0) parts.push(`${months} Monat${months !== 1 ? "en" : ""}`);
	if (days > 0) parts.push(`${days} Tag${days !== 1 ? "en" : ""}`);
	if (parts.length === 0) return "Heute";
	const result = parts.length === 1 ? parts[0] : `${parts.slice(0, -1).join(" ")} und ${parts[parts.length - 1]}`;
	return isFuture ? `In ${result}` : `Vor ${result}`;
};
// source/utilities/formatJobPositionCampaignStatus.ts
var formatJobPositionCampaignStatus = (status) => {
	switch (status) {
		case JobPositionCampaignStatus.ACTIVE: return "Aktiv";
		case JobPositionCampaignStatus.IN_PREPARATION: return "In Vorb.";
		case JobPositionCampaignStatus.INACTIVE: return "Inaktiv";
		default: return "Inaktiv";
	}
};
// source/utilities/gcloud.ts
var decodeSegment = (segment) => {
	try {
		return decodeURIComponent(segment);
	} catch {
		return segment;
	}
};
/**
* Percent-encodes a bucket object path so it becomes a valid URL.
*
* Object names uploaded before file names were sanitised still contain spaces,
* umlauts, parentheses and "+". Interpolating those straight into a URL yields
* a string that is not a valid URI, which breaks every strict consumer — most
* visibly Google, which then drops the company logo from the Google for Jobs
* card. Segments are encoded individually so the "/" separators survive, and
* each one is decoded first so encoding twice is a no-op.
*/
var encodeBucketPath = (path) => path.split("/").map((segment) => encodeURIComponent(decodeSegment(segment))).join("/");
var bucketPathToUrl = (path) => {
	try {
		const url = new URL(path);
		if (url.protocol === "http:" || url.protocol === "https:" || url.protocol === "blob:" || url.protocol === "data:") return url.href;
	} catch {}
	return `https://storage.googleapis.com/${encodeBucketPath(path)}`;
};
var getBucketObjectURL = (value) => {
	if (!value) return "";
	if (typeof value === "string") try {
		return new URL(value).href;
	} catch {
		return bucketPathToUrl(value);
	}
	try {
		return URL.createObjectURL(value);
	} catch {
		return "";
	}
};
var getCustomerCareerPageBucketName = (customerId) => {
	return `customer-${customerId}-career-page.${config.gcloudBucketNameSuffix}`;
};
var getCustomerCareerPageBucketUrl = (customerId) => {
	return `https://storage.googleapis.com/${getCustomerCareerPageBucketName(customerId)}`;
};
var getCustomerCareerPageBackendBucketName = (customerId) => {
	return `customer-${customerId}-career-page-backend-bucket`;
};
var getCustomerCareerUrlMapName = (customerId) => {
	return `customer-${customerId}-career-page-url-map`;
};
var getCustomerCareerHttpRedirectUrlMapName = (customerId) => {
	return `customer-${customerId}-career-page-http-redirect-url-map`;
};
var getCustomerCareerHttpsProxyName = (customerId) => {
	return `customer-${customerId}-career-page-https-proxy`;
};
var getCustomerCareerHttpProxyName = (customerId) => {
	return `customer-${customerId}-career-page-http-proxy`;
};
var getCustomerCareerHttpsForwardingRuleName = (customerId) => {
	return `customer-${customerId}-career-page-https-forwarding-rule`;
};
var getCustomerCareerHttpForwardingRuleName = (customerId) => {
	return `customer-${customerId}-career-page-http-forwarding-rule`;
};
var getCustomerCareerIpName = (customerId) => {
	return `customer-${customerId}-career-page-ip`;
};
var domainToGcpName = (domain) => {
	if (!domain) return domain;
	let name = domain.toLowerCase();
	name = name.replace(/[^a-z0-9-]/g, "-");
	name = name.replace(/-+/g, "-");
	name = name.replace(/^[^a-z]+/, "");
	if (name.length > 63) name = name.substring(0, 63);
	return name;
};
var getRedirectPathMatcherName = (pathMatcherName) => `${pathMatcherName}-www-redirect`;
var getCustomerCareerDnsAuthIdName = (domain) => {
	return `${domainToGcpName(domain)}-dns-auth-primary`;
};
// source/utilities/get-applicant-url.ts
var getApplicantUrl = (applicant) => {
	return `${appRoutes().dashboard().applicants().build()}?applicant=${applicant.id}`;
};
// source/utilities/get-job-position-quota-end-date-error.ts
var JobPositionQuotaEndDateError = {
	/** The quota is canceled, but monday holds no date it runs until */
	CANCELED_WITHOUT_END_DATE: "CANCELED_WITHOUT_END_DATE",
	/** An agreement quota runs indefinitely, yet monday holds an end date */
	END_DATE_WITHOUT_CANCELLATION: "END_DATE_WITHOUT_CANCELLATION",
	/** A monthly renewing quota needs the date it renews on */
	MISSING_END_DATE: "MISSING_END_DATE"
};
/**
* Decides whether the end date of an active recruiting quota contradicts the
* rest of what monday says about it, which is when the job positions table
* shows "Fehler" in the "R Laufzeit" column.
*
* Shared so that the table cell and the daily notification of the project
* manager cannot drift apart: the mail must name exactly the job positions
* the table flags.
*
* The order of the checks is the order the cell renders in. A guarantee and a
* commission agreement both overrule the end date, so neither can be an error.
*/
var getJobPositionQuotaEndDateError = ({ isQuotaActive, quotaEndDate, isQuotaExpiring, quotaGuarantee, isFrameworkAgreement, isCommissionAgreement, isRecruitingAgreement }) => {
	if (!isQuotaActive || quotaGuarantee || isCommissionAgreement) return null;
	if (isQuotaExpiring) return quotaEndDate ? null : JobPositionQuotaEndDateError.CANCELED_WITHOUT_END_DATE;
	if (isFrameworkAgreement || isRecruitingAgreement) return quotaEndDate ? JobPositionQuotaEndDateError.END_DATE_WITHOUT_CANCELLATION : null;
	return quotaEndDate ? null : JobPositionQuotaEndDateError.MISSING_END_DATE;
};
// source/utilities/get-resume-builder-url.ts
var getResumeBuilderUrl = (applicant) => {
	if (!config.resumeBuilderUrl) return "";
	if (!applicant) return config.resumeBuilderUrl;
	return `${config.resumeBuilderUrl}?token=${applicant.token}`;
};
// source/utilities/get-shared-applicant-url.ts
var getSharedApplicantUrl = (applicant) => {
	if (!config.sharedApplicantUrl || !applicant?.shareLinkToken) return "";
	return `${config.sharedApplicantUrl}/${applicant.shareLinkToken}`;
};
// ../../node_modules/lodash/isArray.js
var require_isArray = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = Array.isArray;
}));
// ../../node_modules/lodash/_freeGlobal.js
var require__freeGlobal = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = typeof global == "object" && global && global.Object === Object && global;
}));
// ../../node_modules/lodash/_root.js
var require__root = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var freeGlobal = require__freeGlobal();
	/** Detect free variable `self`. */
	var freeSelf = typeof self == "object" && self && self.Object === Object && self;
	module.exports = freeGlobal || freeSelf || Function("return this")();
}));
// ../../node_modules/lodash/_Symbol.js
var require__Symbol = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = require__root().Symbol;
}));
// ../../node_modules/lodash/_getRawTag.js
var require__getRawTag = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var Symbol = require__Symbol();
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	/**
	* Used to resolve the
	* [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	* of values.
	*/
	var nativeObjectToString = objectProto.toString;
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : void 0;
	/**
	* A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	*
	* @private
	* @param {*} value The value to query.
	* @returns {string} Returns the raw `toStringTag`.
	*/
	function getRawTag(value) {
		var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
		try {
			value[symToStringTag] = void 0;
			var unmasked = true;
		} catch (e) {}
		var result = nativeObjectToString.call(value);
		if (unmasked) {
			if (isOwn) value[symToStringTag] = tag;
			else delete value[symToStringTag];
		}
		return result;
	}
	module.exports = getRawTag;
}));
// ../../node_modules/lodash/_objectToString.js
var require__objectToString = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Used to resolve the
	* [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	* of values.
	*/
	var nativeObjectToString = Object.prototype.toString;
	/**
	* Converts `value` to a string using `Object.prototype.toString`.
	*
	* @private
	* @param {*} value The value to convert.
	* @returns {string} Returns the converted string.
	*/
	function objectToString(value) {
		return nativeObjectToString.call(value);
	}
	module.exports = objectToString;
}));
// ../../node_modules/lodash/_baseGetTag.js
var require__baseGetTag = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var Symbol = require__Symbol();
	var getRawTag = require__getRawTag();
	var objectToString = require__objectToString();
	/** `Object#toString` result references. */
	var nullTag = "[object Null]";
	var undefinedTag = "[object Undefined]";
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : void 0;
	/**
	* The base implementation of `getTag` without fallbacks for buggy environments.
	*
	* @private
	* @param {*} value The value to query.
	* @returns {string} Returns the `toStringTag`.
	*/
	function baseGetTag(value) {
		if (value == null) return value === void 0 ? undefinedTag : nullTag;
		return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
	}
	module.exports = baseGetTag;
}));
// ../../node_modules/lodash/isObjectLike.js
var require_isObjectLike = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Checks if `value` is object-like. A value is object-like if it's not `null`
	* and has a `typeof` result of "object".
	*
	* @static
	* @memberOf _
	* @since 4.0.0
	* @category Lang
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	* @example
	*
	* _.isObjectLike({});
	* // => true
	*
	* _.isObjectLike([1, 2, 3]);
	* // => true
	*
	* _.isObjectLike(_.noop);
	* // => false
	*
	* _.isObjectLike(null);
	* // => false
	*/
	function isObjectLike(value) {
		return value != null && typeof value == "object";
	}
	module.exports = isObjectLike;
}));
// ../../node_modules/lodash/isSymbol.js
var require_isSymbol = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseGetTag = require__baseGetTag();
	var isObjectLike = require_isObjectLike();
	/** `Object#toString` result references. */
	var symbolTag = "[object Symbol]";
	/**
	* Checks if `value` is classified as a `Symbol` primitive or object.
	*
	* @static
	* @memberOf _
	* @since 4.0.0
	* @category Lang
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	* @example
	*
	* _.isSymbol(Symbol.iterator);
	* // => true
	*
	* _.isSymbol('abc');
	* // => false
	*/
	function isSymbol(value) {
		return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
	}
	module.exports = isSymbol;
}));
// ../../node_modules/lodash/_isKey.js
var require__isKey = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isArray = require_isArray();
	var isSymbol = require_isSymbol();
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
	var reIsPlainProp = /^\w*$/;
	/**
	* Checks if `value` is a property name and not a property path.
	*
	* @private
	* @param {*} value The value to check.
	* @param {Object} [object] The object to query keys on.
	* @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	*/
	function isKey(value, object) {
		if (isArray(value)) return false;
		var type = typeof value;
		if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
		return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
	}
	module.exports = isKey;
}));
// ../../node_modules/lodash/isObject.js
var require_isObject = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Checks if `value` is the
	* [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	* of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	*
	* @static
	* @memberOf _
	* @since 0.1.0
	* @category Lang
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is an object, else `false`.
	* @example
	*
	* _.isObject({});
	* // => true
	*
	* _.isObject([1, 2, 3]);
	* // => true
	*
	* _.isObject(_.noop);
	* // => true
	*
	* _.isObject(null);
	* // => false
	*/
	function isObject(value) {
		var type = typeof value;
		return value != null && (type == "object" || type == "function");
	}
	module.exports = isObject;
}));
// ../../node_modules/lodash/isFunction.js
var require_isFunction = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseGetTag = require__baseGetTag();
	var isObject = require_isObject();
	/** `Object#toString` result references. */
	var asyncTag = "[object AsyncFunction]";
	var funcTag = "[object Function]";
	var genTag = "[object GeneratorFunction]";
	var proxyTag = "[object Proxy]";
	/**
	* Checks if `value` is classified as a `Function` object.
	*
	* @static
	* @memberOf _
	* @since 0.1.0
	* @category Lang
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is a function, else `false`.
	* @example
	*
	* _.isFunction(_);
	* // => true
	*
	* _.isFunction(/abc/);
	* // => false
	*/
	function isFunction(value) {
		if (!isObject(value)) return false;
		var tag = baseGetTag(value);
		return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	module.exports = isFunction;
}));
// ../../node_modules/lodash/_coreJsData.js
var require__coreJsData = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = require__root()["__core-js_shared__"];
}));
// ../../node_modules/lodash/_isMasked.js
var require__isMasked = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var coreJsData = require__coreJsData();
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = function() {
		var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
		return uid ? "Symbol(src)_1." + uid : "";
	}();
	/**
	* Checks if `func` has its source masked.
	*
	* @private
	* @param {Function} func The function to check.
	* @returns {boolean} Returns `true` if `func` is masked, else `false`.
	*/
	function isMasked(func) {
		return !!maskSrcKey && maskSrcKey in func;
	}
	module.exports = isMasked;
}));
// ../../node_modules/lodash/_toSource.js
var require__toSource = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	/**
	* Converts `func` to its source code.
	*
	* @private
	* @param {Function} func The function to convert.
	* @returns {string} Returns the source code.
	*/
	function toSource(func) {
		if (func != null) {
			try {
				return funcToString.call(func);
			} catch (e) {}
			try {
				return func + "";
			} catch (e) {}
		}
		return "";
	}
	module.exports = toSource;
}));
// ../../node_modules/lodash/_baseIsNative.js
var require__baseIsNative = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isFunction = require_isFunction();
	var isMasked = require__isMasked();
	var isObject = require_isObject();
	var toSource = require__toSource();
	/**
	* Used to match `RegExp`
	* [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	*/
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	var objectProto = Object.prototype;
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	/** Used to detect if a method is native. */
	var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
	/**
	* The base implementation of `_.isNative` without bad shim checks.
	*
	* @private
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is a native function,
	*  else `false`.
	*/
	function baseIsNative(value) {
		if (!isObject(value) || isMasked(value)) return false;
		return (isFunction(value) ? reIsNative : reIsHostCtor).test(toSource(value));
	}
	module.exports = baseIsNative;
}));
// ../../node_modules/lodash/_getValue.js
var require__getValue = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Gets the value at `key` of `object`.
	*
	* @private
	* @param {Object} [object] The object to query.
	* @param {string} key The key of the property to get.
	* @returns {*} Returns the property value.
	*/
	function getValue(object, key) {
		return object == null ? void 0 : object[key];
	}
	module.exports = getValue;
}));
// ../../node_modules/lodash/_getNative.js
var require__getNative = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseIsNative = require__baseIsNative();
	var getValue = require__getValue();
	/**
	* Gets the native function at `key` of `object`.
	*
	* @private
	* @param {Object} object The object to query.
	* @param {string} key The key of the method to get.
	* @returns {*} Returns the function if it's native, else `undefined`.
	*/
	function getNative(object, key) {
		var value = getValue(object, key);
		return baseIsNative(value) ? value : void 0;
	}
	module.exports = getNative;
}));
// ../../node_modules/lodash/_nativeCreate.js
var require__nativeCreate = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = require__getNative()(Object, "create");
}));
// ../../node_modules/lodash/_hashClear.js
var require__hashClear = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var nativeCreate = require__nativeCreate();
	/**
	* Removes all key-value entries from the hash.
	*
	* @private
	* @name clear
	* @memberOf Hash
	*/
	function hashClear() {
		this.__data__ = nativeCreate ? nativeCreate(null) : {};
		this.size = 0;
	}
	module.exports = hashClear;
}));
// ../../node_modules/lodash/_hashDelete.js
var require__hashDelete = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Removes `key` and its value from the hash.
	*
	* @private
	* @name delete
	* @memberOf Hash
	* @param {Object} hash The hash to modify.
	* @param {string} key The key of the value to remove.
	* @returns {boolean} Returns `true` if the entry was removed, else `false`.
	*/
	function hashDelete(key) {
		var result = this.has(key) && delete this.__data__[key];
		this.size -= result ? 1 : 0;
		return result;
	}
	module.exports = hashDelete;
}));
// ../../node_modules/lodash/_hashGet.js
var require__hashGet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var nativeCreate = require__nativeCreate();
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = "__lodash_hash_undefined__";
	/** Used to check objects for own properties. */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	/**
	* Gets the hash value for `key`.
	*
	* @private
	* @name get
	* @memberOf Hash
	* @param {string} key The key of the value to get.
	* @returns {*} Returns the entry value.
	*/
	function hashGet(key) {
		var data = this.__data__;
		if (nativeCreate) {
			var result = data[key];
			return result === HASH_UNDEFINED ? void 0 : result;
		}
		return hasOwnProperty.call(data, key) ? data[key] : void 0;
	}
	module.exports = hashGet;
}));
// ../../node_modules/lodash/_hashHas.js
var require__hashHas = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var nativeCreate = require__nativeCreate();
	/** Used to check objects for own properties. */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	/**
	* Checks if a hash value for `key` exists.
	*
	* @private
	* @name has
	* @memberOf Hash
	* @param {string} key The key of the entry to check.
	* @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	*/
	function hashHas(key) {
		var data = this.__data__;
		return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
	}
	module.exports = hashHas;
}));
// ../../node_modules/lodash/_hashSet.js
var require__hashSet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var nativeCreate = require__nativeCreate();
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = "__lodash_hash_undefined__";
	/**
	* Sets the hash `key` to `value`.
	*
	* @private
	* @name set
	* @memberOf Hash
	* @param {string} key The key of the value to set.
	* @param {*} value The value to set.
	* @returns {Object} Returns the hash instance.
	*/
	function hashSet(key, value) {
		var data = this.__data__;
		this.size += this.has(key) ? 0 : 1;
		data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
		return this;
	}
	module.exports = hashSet;
}));
// ../../node_modules/lodash/_Hash.js
var require__Hash = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var hashClear = require__hashClear();
	var hashDelete = require__hashDelete();
	var hashGet = require__hashGet();
	var hashHas = require__hashHas();
	var hashSet = require__hashSet();
	/**
	* Creates a hash object.
	*
	* @private
	* @constructor
	* @param {Array} [entries] The key-value pairs to cache.
	*/
	function Hash(entries) {
		var index = -1, length = entries == null ? 0 : entries.length;
		this.clear();
		while (++index < length) {
			var entry = entries[index];
			this.set(entry[0], entry[1]);
		}
	}
	Hash.prototype.clear = hashClear;
	Hash.prototype["delete"] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	module.exports = Hash;
}));
// ../../node_modules/lodash/_listCacheClear.js
var require__listCacheClear = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Removes all key-value entries from the list cache.
	*
	* @private
	* @name clear
	* @memberOf ListCache
	*/
	function listCacheClear() {
		this.__data__ = [];
		this.size = 0;
	}
	module.exports = listCacheClear;
}));
// ../../node_modules/lodash/eq.js
var require_eq = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Performs a
	* [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	* comparison between two values to determine if they are equivalent.
	*
	* @static
	* @memberOf _
	* @since 4.0.0
	* @category Lang
	* @param {*} value The value to compare.
	* @param {*} other The other value to compare.
	* @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	* @example
	*
	* var object = { 'a': 1 };
	* var other = { 'a': 1 };
	*
	* _.eq(object, object);
	* // => true
	*
	* _.eq(object, other);
	* // => false
	*
	* _.eq('a', 'a');
	* // => true
	*
	* _.eq('a', Object('a'));
	* // => false
	*
	* _.eq(NaN, NaN);
	* // => true
	*/
	function eq(value, other) {
		return value === other || value !== value && other !== other;
	}
	module.exports = eq;
}));
// ../../node_modules/lodash/_assocIndexOf.js
var require__assocIndexOf = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var eq = require_eq();
	/**
	* Gets the index at which the `key` is found in `array` of key-value pairs.
	*
	* @private
	* @param {Array} array The array to inspect.
	* @param {*} key The key to search for.
	* @returns {number} Returns the index of the matched value, else `-1`.
	*/
	function assocIndexOf(array, key) {
		var length = array.length;
		while (length--) if (eq(array[length][0], key)) return length;
		return -1;
	}
	module.exports = assocIndexOf;
}));
// ../../node_modules/lodash/_listCacheDelete.js
var require__listCacheDelete = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var assocIndexOf = require__assocIndexOf();
	/** Built-in value references. */
	var splice = Array.prototype.splice;
	/**
	* Removes `key` and its value from the list cache.
	*
	* @private
	* @name delete
	* @memberOf ListCache
	* @param {string} key The key of the value to remove.
	* @returns {boolean} Returns `true` if the entry was removed, else `false`.
	*/
	function listCacheDelete(key) {
		var data = this.__data__, index = assocIndexOf(data, key);
		if (index < 0) return false;
		if (index == data.length - 1) data.pop();
		else splice.call(data, index, 1);
		--this.size;
		return true;
	}
	module.exports = listCacheDelete;
}));
// ../../node_modules/lodash/_listCacheGet.js
var require__listCacheGet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var assocIndexOf = require__assocIndexOf();
	/**
	* Gets the list cache value for `key`.
	*
	* @private
	* @name get
	* @memberOf ListCache
	* @param {string} key The key of the value to get.
	* @returns {*} Returns the entry value.
	*/
	function listCacheGet(key) {
		var data = this.__data__, index = assocIndexOf(data, key);
		return index < 0 ? void 0 : data[index][1];
	}
	module.exports = listCacheGet;
}));
// ../../node_modules/lodash/_listCacheHas.js
var require__listCacheHas = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var assocIndexOf = require__assocIndexOf();
	/**
	* Checks if a list cache value for `key` exists.
	*
	* @private
	* @name has
	* @memberOf ListCache
	* @param {string} key The key of the entry to check.
	* @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	*/
	function listCacheHas(key) {
		return assocIndexOf(this.__data__, key) > -1;
	}
	module.exports = listCacheHas;
}));
// ../../node_modules/lodash/_listCacheSet.js
var require__listCacheSet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var assocIndexOf = require__assocIndexOf();
	/**
	* Sets the list cache `key` to `value`.
	*
	* @private
	* @name set
	* @memberOf ListCache
	* @param {string} key The key of the value to set.
	* @param {*} value The value to set.
	* @returns {Object} Returns the list cache instance.
	*/
	function listCacheSet(key, value) {
		var data = this.__data__, index = assocIndexOf(data, key);
		if (index < 0) {
			++this.size;
			data.push([key, value]);
		} else data[index][1] = value;
		return this;
	}
	module.exports = listCacheSet;
}));
// ../../node_modules/lodash/_ListCache.js
var require__ListCache = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var listCacheClear = require__listCacheClear();
	var listCacheDelete = require__listCacheDelete();
	var listCacheGet = require__listCacheGet();
	var listCacheHas = require__listCacheHas();
	var listCacheSet = require__listCacheSet();
	/**
	* Creates an list cache object.
	*
	* @private
	* @constructor
	* @param {Array} [entries] The key-value pairs to cache.
	*/
	function ListCache(entries) {
		var index = -1, length = entries == null ? 0 : entries.length;
		this.clear();
		while (++index < length) {
			var entry = entries[index];
			this.set(entry[0], entry[1]);
		}
	}
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype["delete"] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	module.exports = ListCache;
}));
// ../../node_modules/lodash/_Map.js
var require__Map = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = require__getNative()(require__root(), "Map");
}));
// ../../node_modules/lodash/_mapCacheClear.js
var require__mapCacheClear = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var Hash = require__Hash();
	var ListCache = require__ListCache();
	var Map = require__Map();
	/**
	* Removes all key-value entries from the map.
	*
	* @private
	* @name clear
	* @memberOf MapCache
	*/
	function mapCacheClear() {
		this.size = 0;
		this.__data__ = {
			"hash": new Hash(),
			"map": new (Map || ListCache)(),
			"string": new Hash()
		};
	}
	module.exports = mapCacheClear;
}));
// ../../node_modules/lodash/_isKeyable.js
var require__isKeyable = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Checks if `value` is suitable for use as unique object key.
	*
	* @private
	* @param {*} value The value to check.
	* @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	*/
	function isKeyable(value) {
		var type = typeof value;
		return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
	}
	module.exports = isKeyable;
}));
// ../../node_modules/lodash/_getMapData.js
var require__getMapData = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isKeyable = require__isKeyable();
	/**
	* Gets the data for `map`.
	*
	* @private
	* @param {Object} map The map to query.
	* @param {string} key The reference key.
	* @returns {*} Returns the map data.
	*/
	function getMapData(map, key) {
		var data = map.__data__;
		return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
	}
	module.exports = getMapData;
}));
// ../../node_modules/lodash/_mapCacheDelete.js
var require__mapCacheDelete = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var getMapData = require__getMapData();
	/**
	* Removes `key` and its value from the map.
	*
	* @private
	* @name delete
	* @memberOf MapCache
	* @param {string} key The key of the value to remove.
	* @returns {boolean} Returns `true` if the entry was removed, else `false`.
	*/
	function mapCacheDelete(key) {
		var result = getMapData(this, key)["delete"](key);
		this.size -= result ? 1 : 0;
		return result;
	}
	module.exports = mapCacheDelete;
}));
// ../../node_modules/lodash/_mapCacheGet.js
var require__mapCacheGet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var getMapData = require__getMapData();
	/**
	* Gets the map value for `key`.
	*
	* @private
	* @name get
	* @memberOf MapCache
	* @param {string} key The key of the value to get.
	* @returns {*} Returns the entry value.
	*/
	function mapCacheGet(key) {
		return getMapData(this, key).get(key);
	}
	module.exports = mapCacheGet;
}));
// ../../node_modules/lodash/_mapCacheHas.js
var require__mapCacheHas = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var getMapData = require__getMapData();
	/**
	* Checks if a map value for `key` exists.
	*
	* @private
	* @name has
	* @memberOf MapCache
	* @param {string} key The key of the entry to check.
	* @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	*/
	function mapCacheHas(key) {
		return getMapData(this, key).has(key);
	}
	module.exports = mapCacheHas;
}));
// ../../node_modules/lodash/_mapCacheSet.js
var require__mapCacheSet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var getMapData = require__getMapData();
	/**
	* Sets the map `key` to `value`.
	*
	* @private
	* @name set
	* @memberOf MapCache
	* @param {string} key The key of the value to set.
	* @param {*} value The value to set.
	* @returns {Object} Returns the map cache instance.
	*/
	function mapCacheSet(key, value) {
		var data = getMapData(this, key), size = data.size;
		data.set(key, value);
		this.size += data.size == size ? 0 : 1;
		return this;
	}
	module.exports = mapCacheSet;
}));
// ../../node_modules/lodash/_MapCache.js
var require__MapCache = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var mapCacheClear = require__mapCacheClear();
	var mapCacheDelete = require__mapCacheDelete();
	var mapCacheGet = require__mapCacheGet();
	var mapCacheHas = require__mapCacheHas();
	var mapCacheSet = require__mapCacheSet();
	/**
	* Creates a map cache object to store key-value pairs.
	*
	* @private
	* @constructor
	* @param {Array} [entries] The key-value pairs to cache.
	*/
	function MapCache(entries) {
		var index = -1, length = entries == null ? 0 : entries.length;
		this.clear();
		while (++index < length) {
			var entry = entries[index];
			this.set(entry[0], entry[1]);
		}
	}
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype["delete"] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	module.exports = MapCache;
}));
// ../../node_modules/lodash/memoize.js
var require_memoize = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var MapCache = require__MapCache();
	/** Error message constants. */
	var FUNC_ERROR_TEXT = "Expected a function";
	/**
	* Creates a function that memoizes the result of `func`. If `resolver` is
	* provided, it determines the cache key for storing the result based on the
	* arguments provided to the memoized function. By default, the first argument
	* provided to the memoized function is used as the map cache key. The `func`
	* is invoked with the `this` binding of the memoized function.
	*
	* **Note:** The cache is exposed as the `cache` property on the memoized
	* function. Its creation may be customized by replacing the `_.memoize.Cache`
	* constructor with one whose instances implement the
	* [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	* method interface of `clear`, `delete`, `get`, `has`, and `set`.
	*
	* @static
	* @memberOf _
	* @since 0.1.0
	* @category Function
	* @param {Function} func The function to have its output memoized.
	* @param {Function} [resolver] The function to resolve the cache key.
	* @returns {Function} Returns the new memoized function.
	* @example
	*
	* var object = { 'a': 1, 'b': 2 };
	* var other = { 'c': 3, 'd': 4 };
	*
	* var values = _.memoize(_.values);
	* values(object);
	* // => [1, 2]
	*
	* values(other);
	* // => [3, 4]
	*
	* object.a = 2;
	* values(object);
	* // => [1, 2]
	*
	* // Modify the result cache.
	* values.cache.set(object, ['a', 'b']);
	* values(object);
	* // => ['a', 'b']
	*
	* // Replace `_.memoize.Cache`.
	* _.memoize.Cache = WeakMap;
	*/
	function memoize(func, resolver) {
		if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
		var memoized = function() {
			var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
			if (cache.has(key)) return cache.get(key);
			var result = func.apply(this, args);
			memoized.cache = cache.set(key, result) || cache;
			return result;
		};
		memoized.cache = new (memoize.Cache || MapCache)();
		return memoized;
	}
	memoize.Cache = MapCache;
	module.exports = memoize;
}));
// ../../node_modules/lodash/_memoizeCapped.js
var require__memoizeCapped = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var memoize = require_memoize();
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	/**
	* A specialized version of `_.memoize` which clears the memoized function's
	* cache when it exceeds `MAX_MEMOIZE_SIZE`.
	*
	* @private
	* @param {Function} func The function to have its output memoized.
	* @returns {Function} Returns the new memoized function.
	*/
	function memoizeCapped(func) {
		var result = memoize(func, function(key) {
			if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
			return key;
		});
		var cache = result.cache;
		return result;
	}
	module.exports = memoizeCapped;
}));
// ../../node_modules/lodash/_stringToPath.js
var require__stringToPath = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var memoizeCapped = require__memoizeCapped();
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	module.exports = memoizeCapped(function(string) {
		var result = [];
		if (string.charCodeAt(0) === 46) result.push("");
		string.replace(rePropName, function(match, number, quote, subString) {
			result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
		});
		return result;
	});
}));
// ../../node_modules/lodash/_arrayMap.js
var require__arrayMap = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* A specialized version of `_.map` for arrays without support for iteratee
	* shorthands.
	*
	* @private
	* @param {Array} [array] The array to iterate over.
	* @param {Function} iteratee The function invoked per iteration.
	* @returns {Array} Returns the new mapped array.
	*/
	function arrayMap(array, iteratee) {
		var index = -1, length = array == null ? 0 : array.length, result = Array(length);
		while (++index < length) result[index] = iteratee(array[index], index, array);
		return result;
	}
	module.exports = arrayMap;
}));
// ../../node_modules/lodash/_baseToString.js
var require__baseToString = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var Symbol = require__Symbol();
	var arrayMap = require__arrayMap();
	var isArray = require_isArray();
	var isSymbol = require_isSymbol();
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : void 0;
	var symbolToString = symbolProto ? symbolProto.toString : void 0;
	/**
	* The base implementation of `_.toString` which doesn't convert nullish
	* values to empty strings.
	*
	* @private
	* @param {*} value The value to process.
	* @returns {string} Returns the string.
	*/
	function baseToString(value) {
		if (typeof value == "string") return value;
		if (isArray(value)) return arrayMap(value, baseToString) + "";
		if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
		var result = value + "";
		return result == "0" && 1 / value == -INFINITY ? "-0" : result;
	}
	module.exports = baseToString;
}));
// ../../node_modules/lodash/toString.js
var require_toString = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseToString = require__baseToString();
	/**
	* Converts `value` to a string. An empty string is returned for `null`
	* and `undefined` values. The sign of `-0` is preserved.
	*
	* @static
	* @memberOf _
	* @since 4.0.0
	* @category Lang
	* @param {*} value The value to convert.
	* @returns {string} Returns the converted string.
	* @example
	*
	* _.toString(null);
	* // => ''
	*
	* _.toString(-0);
	* // => '-0'
	*
	* _.toString([1, 2, 3]);
	* // => '1,2,3'
	*/
	function toString(value) {
		return value == null ? "" : baseToString(value);
	}
	module.exports = toString;
}));
// ../../node_modules/lodash/_castPath.js
var require__castPath = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isArray = require_isArray();
	var isKey = require__isKey();
	var stringToPath = require__stringToPath();
	var toString = require_toString();
	/**
	* Casts `value` to a path array if it's not one.
	*
	* @private
	* @param {*} value The value to inspect.
	* @param {Object} [object] The object to query keys on.
	* @returns {Array} Returns the cast property path array.
	*/
	function castPath(value, object) {
		if (isArray(value)) return value;
		return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	module.exports = castPath;
}));
// ../../node_modules/lodash/_toKey.js
var require__toKey = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var isSymbol = require_isSymbol();
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	/**
	* Converts `value` to a string key if it's not a string or symbol.
	*
	* @private
	* @param {*} value The value to inspect.
	* @returns {string|symbol} Returns the key.
	*/
	function toKey(value) {
		if (typeof value == "string" || isSymbol(value)) return value;
		var result = value + "";
		return result == "0" && 1 / value == -INFINITY ? "-0" : result;
	}
	module.exports = toKey;
}));
// ../../node_modules/lodash/_baseGet.js
var require__baseGet = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var castPath = require__castPath();
	var toKey = require__toKey();
	/**
	* The base implementation of `_.get` without support for default values.
	*
	* @private
	* @param {Object} object The object to query.
	* @param {Array|string} path The path of the property to get.
	* @returns {*} Returns the resolved value.
	*/
	function baseGet(object, path) {
		path = castPath(path, object);
		var index = 0, length = path.length;
		while (object != null && index < length) object = object[toKey(path[index++])];
		return index && index == length ? object : void 0;
	}
	module.exports = baseGet;
}));
// source/utilities/getValueAtPath.ts
var import_get = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((exports, module) => {
	var baseGet = require__baseGet();
	/**
	* Gets the value at `path` of `object`. If the resolved value is
	* `undefined`, the `defaultValue` is returned in its place.
	*
	* @static
	* @memberOf _
	* @since 3.7.0
	* @category Object
	* @param {Object} object The object to query.
	* @param {Array|string} path The path of the property to get.
	* @param {*} [defaultValue] The value returned for `undefined` resolved values.
	* @returns {*} Returns the resolved value.
	* @example
	*
	* var object = { 'a': [{ 'b': { 'c': 3 } }] };
	*
	* _.get(object, 'a[0].b.c');
	* // => 3
	*
	* _.get(object, ['a', '0', 'b', 'c']);
	* // => 3
	*
	* _.get(object, 'a.b.c', 'default');
	* // => 'default'
	*/
	function get(object, path, defaultValue) {
		var result = object == null ? void 0 : baseGet(object, path);
		return result === void 0 ? defaultValue : result;
	}
	module.exports = get;
})))(), 1);
/**
* Extends lodash.get to handle array wildcards "[]".
* Example: getValueAtPath(obj, 'a.b[].c', defaultValue)
* This will return an array of all 'c' values from each element in array 'b'.
*/
function getValueAtPath(object, path, defaultValue) {
	const splitIndex = path.indexOf("[]");
	if (splitIndex === -1) return (0, import_get.default)(object, path, defaultValue);
	const preArrayPath = path.substring(0, splitIndex);
	let postArrayPath = path.substring(splitIndex + 2);
	if (postArrayPath.startsWith(".")) postArrayPath = postArrayPath.substring(1);
	const targetArray = preArrayPath ? (0, import_get.default)(object, preArrayPath) : object;
	if (!Array.isArray(targetArray)) return;
	if (!postArrayPath) return targetArray;
	return targetArray.map((item) => getValueAtPath(item, postArrayPath, defaultValue));
}
// source/utilities/google-maps.ts
var getGoogleMapsUrl = (latitude, longitude) => {
	return `https://www.google.com/maps?q=${latitude},${longitude}`;
};
var getGoogleMapsAddressUrl = (address) => {
	return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
};
var getGoogleMapsRouteUrl = ({ origin, destination }) => `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}&travelmode=driving`;
// source/utilities/guarantee-candidate.ts
/**
* A candidate counts towards the hiring guarantee as soon as they have been
* forwarded to the customer ("Übermittelt am" is set). The only way out of the
* guarantee is the explicit "Weitergeleitet (ohne Garantie)" status, which
* Stahlhart sets when the customer reports the candidate as not qualified.
*
* Derived on purpose instead of being stored: the forwarded date and the
* prequalification status are the single source of truth, so the applicants
* table and the marketing count cannot drift apart.
*/
var isGuaranteeCandidate = (applicant) => !!applicant.forwardedAt && applicant.prequalificationStatus !== PrequalificationStatus.APPROVED_WITHOUT_GUARANTEE;
// source/utilities/hiring-guarantee.ts
/**
* The hiring guarantee only exists in the new product version, so the setting
* is hidden for V1 customers.
*
* Shared so that the UI (which hides the switch) and the API (which drops the
* field on update) cannot drift apart.
*/
var isHiringGuaranteeAvailable = (productVersion) => productVersion === ProductVersion.V2;
// source/utilities/is-duplicated-applicant.ts
var isDuplicatedApplicant = (applicantA, applicantB) => {
	if (applicantA.jobPosition.customerId !== applicantB.jobPosition.customerId) return false;
	if (applicantA.phoneNumber && applicantA.phoneNumber === applicantB.phoneNumber) return true;
	if (applicantA.normalizedPhoneNumber && applicantA.normalizedPhoneNumber === applicantB.normalizedPhoneNumber) return true;
	if (applicantA.emailAddress && applicantA.emailAddress === applicantB.emailAddress) return true;
	return false;
};
// source/utilities/is-valid-url.ts
var isValidUrl = (url) => {
	try {
		new URL(url);
		return true;
	} catch {
		return false;
	}
};
// source/utilities/job-positions.ts
var BOTH = "both";
var defaultValues = {
	addressZipCode: "",
	addressCity: "",
	weeklyHours: "",
	schedule: "",
	startDate: "",
	shiftWork: "",
	salary: "",
	salaryIsPublic: false,
	/**
	* @deprecated Salutation not needed anymore, we use always "Du"
	*/
	salutation: void 0,
	searchArea: "",
	searchCenter: "",
	searchCenterCountry: CountryCode.DE,
	searchRadius: "",
	cvRequired: "",
	cvRequiredInForm: "",
	emailRecipients: [],
	type: "",
	/**
	* @deprecated merged into other_manager_info
	*/
	fieldServiceAndHomeOffice: [],
	otherManagerInfo: [],
	trainingDuration: "",
	specialization: "",
	university: "",
	requirements: [],
	additionalRequirements: [],
	benefits: [],
	contactPersonName: "",
	contactPersonPosition: "",
	contactPersonEmail: "",
	/**
	* @deprecated address_link is not needed anymore, instead a reference to location is used
	*/
	addressLink: "",
	traineeFirstYearSalary: "",
	traineeSecondYearSalary: "",
	traineeThirdYearSalary: "",
	traineeFourthYearSalary: "",
	dualStudentSalary: "",
	locationId: "",
	workAreaId: "",
	externalApplicationUrl: "",
	documentsRequiredForForwarding: "",
	requiredDocumentsDescription: ""
};
var defaultEmployeeAdditionalRequirements = [
	{
		value: "Brutto-Gehaltsvorstellung",
		isKoCriteria: false,
		isDirect: true
	},
	{
		value: "Wechselwillig/Arbeitssuchend",
		isKoCriteria: false,
		isDirect: true
	},
	{
		value: "Wohnort",
		isKoCriteria: false,
		isDirect: true
	},
	{
		value: "Erreichbarkeit",
		isKoCriteria: false,
		isDirect: true
	},
	{
		value: "Persönlicher Eindruck",
		isKoCriteria: false,
		isDirect: false
	},
	{
		...jobPositionPresets.additionalRequirements.germanSkill,
		value: "Noch nicht festgelegt",
		isDirect: false,
		isKoCriteria: true
	}
];
var defaultTraineeAdditionalRequirements = [
	{
		value: "Zunächst Praktikum oder direkt Ausbildung?",
		isKoCriteria: false,
		isDirect: true
	},
	{
		value: "Alter",
		isKoCriteria: false,
		isDirect: true
	},
	{
		value: "Wohnort - max. X Minuten Anfahrt",
		isKoCriteria: true,
		isDirect: true
	},
	{
		value: "Erreichbarkeit",
		isKoCriteria: false,
		isDirect: true
	},
	{
		...jobPositionPresets.additionalRequirements.germanSkill,
		value: "Noch nicht festgelegt",
		isDirect: false,
		isKoCriteria: true
	},
	{
		value: "Persönlicher Eindruck",
		isKoCriteria: false,
		isDirect: false
	}
];
var defaultDualStudentAdditionalRequirements = [
	{
		value: "Zunächst Praktikum oder direkt duales Studium?",
		isKoCriteria: false,
		isDirect: true
	},
	{
		value: "Alter",
		isKoCriteria: false,
		isDirect: true
	},
	{
		value: "Wohnort - max. X Minuten Anfahrt",
		isKoCriteria: true,
		isDirect: true
	},
	{
		value: "Erreichbarkeit",
		isKoCriteria: false,
		isDirect: true
	},
	{
		...jobPositionPresets.additionalRequirements.germanSkill,
		value: "Noch nicht festgelegt",
		isDirect: false,
		isKoCriteria: true
	},
	{
		value: "Persönlicher Eindruck",
		isKoCriteria: false,
		isDirect: false
	}
];
var defaultRequirements = {
	[JobPositionType.EMPLOYEE]: defaultEmployeeAdditionalRequirements,
	[JobPositionType.TRAINEE]: defaultTraineeAdditionalRequirements,
	[JobPositionType.DUAL_STUDENT]: defaultDualStudentAdditionalRequirements
};
var getConditionalJobPositionValues = ({ jobPosition, isPreQualified = null, jobPositionType = null, isTemplate = false, withCustomerId = true }) => {
	let values = { ...defaultValues };
	const positionIsPreQualified = typeof jobPosition?.isPreQualified === "boolean" ? jobPosition.isPreQualified : isPreQualified;
	const positionType = jobPosition?.type || jobPositionType;
	values = {
		...values,
		...withCustomerId ? { customerId: jobPosition?.customerId } : {},
		addressZipCode: jobPosition?.addressZipCode || defaultValues.addressZipCode,
		addressCity: jobPosition?.addressCity || defaultValues.addressCity,
		salaryIsPublic: typeof jobPosition?.salaryIsPublic === "boolean" ? jobPosition?.salaryIsPublic : defaultValues.salaryIsPublic,
		salutation: jobPosition?.salutation || defaultValues.salutation,
		searchArea: jobPosition?.searchArea || defaultValues.searchArea,
		searchCenter: jobPosition?.searchCenter || defaultValues.searchCenter,
		searchCenterCountry: jobPosition?.searchCenterCountry || defaultValues.searchCenterCountry,
		searchRadius: jobPosition?.searchRadius || defaultValues.searchRadius,
		emailRecipients: jobPosition?.emailRecipients || defaultValues.emailRecipients,
		type: jobPosition?.type || defaultValues.type,
		isFlexibleInternshipPossible: typeof jobPosition?.isFlexibleInternshipPossible === "boolean" ? jobPosition?.isFlexibleInternshipPossible : "",
		requirements: jobPosition?.requirements || defaultValues.requirements,
		benefits: jobPosition?.benefits || defaultValues.benefits,
		locationId: jobPosition?.locationId || defaultValues.locationId,
		workAreaId: jobPosition?.workAreaId || defaultValues.workAreaId,
		heroVideoActive: jobPosition?.heroVideoActive ?? false,
		heroVideoVimeoId: jobPosition?.heroVideoVimeoId || "",
		externalApplicationUrl: jobPosition?.externalApplicationUrl || defaultValues.externalApplicationUrl
	};
	if (!isTemplate) values = {
		...values,
		name: jobPosition?.name || "",
		fullName: jobPosition?.fullName || "",
		isPreQualified: typeof positionIsPreQualified === "boolean" ? positionIsPreQualified : null,
		tasks: jobPosition?.tasks || [],
		isArchived: jobPosition?.isArchived ?? false,
		potential: jobPosition?.potential || "",
		specialization: "",
		university: ""
	};
	if (positionType === JobPositionType.TRAINEE) values = {
		...values,
		trainingDuration: jobPosition?.trainingDuration,
		isFlexibleInternshipPossible: jobPosition?.isFlexibleInternshipPossible,
		specialization: jobPosition?.specialization,
		startDate: jobPosition?.startDate,
		traineeFirstYearSalary: jobPosition?.traineeFirstYearSalary || defaultValues.traineeFirstYearSalary,
		traineeSecondYearSalary: jobPosition?.traineeSecondYearSalary || defaultValues.traineeSecondYearSalary,
		traineeThirdYearSalary: jobPosition?.traineeThirdYearSalary || defaultValues.traineeThirdYearSalary,
		traineeFourthYearSalary: jobPosition?.traineeFourthYearSalary || defaultValues.traineeFourthYearSalary
	};
	if (positionType === JobPositionType.DUAL_STUDENT) values = {
		...values,
		trainingDuration: jobPosition?.trainingDuration,
		isFlexibleInternshipPossible: jobPosition?.isFlexibleInternshipPossible,
		university: jobPosition?.university,
		startDate: jobPosition?.startDate,
		dualStudentSalary: jobPosition?.dualStudentSalary || defaultValues.dualStudentSalary
	};
	if (positionType === JobPositionType.EMPLOYEE) {
		values = {
			...values,
			salary: jobPosition?.salary || defaultValues.salary,
			weeklyHours: jobPosition?.weeklyHours || defaultValues.weeklyHours,
			schedule: jobPosition?.schedule || defaultValues.schedule,
			shiftWork: jobPosition?.shiftWork || defaultValues.shiftWork
		};
		if (jobPosition?.schedule === JobPositionSchedule.RANGE) values = {
			...values,
			weeklyHoursMax: jobPosition?.weeklyHoursMax || defaultValues.weeklyHoursMax
		};
	}
	if (positionIsPreQualified === true || positionIsPreQualified === BOTH) {
		values = {
			...values,
			additionalRequirements: jobPosition?.additionalRequirements || defaultRequirements[jobPosition?.type] || defaultValues.additionalRequirements,
			otherManagerInfo: jobPosition?.otherManagerInfo || defaultValues.otherManagerInfo,
			addressLink: jobPosition?.addressLink || defaultValues.addressLink,
			contactPersonName: jobPosition?.contactPersonName || defaultValues.contactPersonName,
			contactPersonPosition: jobPosition?.contactPersonPosition || defaultValues.contactPersonPosition,
			contactPersonEmail: jobPosition?.contactPersonEmail || defaultValues.contactPersonEmail
		};
		if (positionType === JobPositionType.EMPLOYEE) values = {
			...values,
			cvRequired: typeof jobPosition?.cvRequired === "boolean" ? jobPosition?.cvRequired : defaultValues.cvRequired,
			fieldServiceAndHomeOffice: jobPosition?.fieldServiceAndHomeOffice || defaultValues.fieldServiceAndHomeOffice
		};
		if (positionType !== JobPositionType.EMPLOYEE) values = {
			...values,
			documentsRequiredForForwarding: typeof jobPosition?.documentsRequiredForForwarding === "boolean" ? jobPosition?.documentsRequiredForForwarding : defaultValues.documentsRequiredForForwarding,
			requiredDocumentsDescription: jobPosition?.requiredDocumentsDescription || defaultValues.requiredDocumentsDescription
		};
	}
	if (positionIsPreQualified === false || positionIsPreQualified === BOTH) values = {
		...values,
		cvRequiredInForm: typeof jobPosition?.cvRequiredInForm === "boolean" ? jobPosition?.cvRequiredInForm : defaultValues.cvRequiredInForm
	};
	return Object.fromEntries(Object.entries(values).filter(([_, value]) => value !== void 0));
};
// source/utilities/join-list.ts
var joinList = (list) => {
	if (list.length === 0) return "";
	if (list.length === 1) return `${list[0]}`;
	if (list.length === 2) return `${list[0]} und ${list[1]}`;
	return `${list.slice(0, -1).join(", ")} und ${list[list.length - 1]}`;
};
// source/utilities/network.ts
var getCurrentIp = async () => {
	const res = await fetch("https://api.ipify.org?format=json");
	if (!res.ok) throw new Error(`Failed to fetch IP: ${res.status}`);
	return (await res.json()).ip;
};
// source/utilities/normalize-email.ts
var normalizeEmail = (email) => {
	if (!email) return null;
	return email.toLowerCase().trim();
};
// ../../node_modules/libphonenumber-js/metadata.min.json.js
var metadata_min_json_default = {
	"version": 4,
	"country_calling_codes": {
		"1": [
			"US",
			"AG",
			"AI",
			"AS",
			"BB",
			"BM",
			"BS",
			"CA",
			"DM",
			"DO",
			"GD",
			"GU",
			"JM",
			"KN",
			"KY",
			"LC",
			"MP",
			"MS",
			"PR",
			"SX",
			"TC",
			"TT",
			"VC",
			"VG",
			"VI"
		],
		"7": ["RU", "KZ"],
		"20": ["EG"],
		"27": ["ZA"],
		"30": ["GR"],
		"31": ["NL"],
		"32": ["BE"],
		"33": ["FR"],
		"34": ["ES"],
		"36": ["HU"],
		"39": ["IT", "VA"],
		"40": ["RO"],
		"41": ["CH"],
		"43": ["AT"],
		"44": [
			"GB",
			"GG",
			"IM",
			"JE"
		],
		"45": ["DK"],
		"46": ["SE"],
		"47": ["NO", "SJ"],
		"48": ["PL"],
		"49": ["DE"],
		"51": ["PE"],
		"52": ["MX"],
		"53": ["CU"],
		"54": ["AR"],
		"55": ["BR"],
		"56": ["CL"],
		"57": ["CO"],
		"58": ["VE"],
		"60": ["MY"],
		"61": [
			"AU",
			"CC",
			"CX"
		],
		"62": ["ID"],
		"63": ["PH"],
		"64": ["NZ"],
		"65": ["SG"],
		"66": ["TH"],
		"81": ["JP"],
		"82": ["KR"],
		"84": ["VN"],
		"86": ["CN"],
		"90": ["TR"],
		"91": ["IN"],
		"92": ["PK"],
		"93": ["AF"],
		"94": ["LK"],
		"95": ["MM"],
		"98": ["IR"],
		"211": ["SS"],
		"212": ["MA", "EH"],
		"213": ["DZ"],
		"216": ["TN"],
		"218": ["LY"],
		"220": ["GM"],
		"221": ["SN"],
		"222": ["MR"],
		"223": ["ML"],
		"224": ["GN"],
		"225": ["CI"],
		"226": ["BF"],
		"227": ["NE"],
		"228": ["TG"],
		"229": ["BJ"],
		"230": ["MU"],
		"231": ["LR"],
		"232": ["SL"],
		"233": ["GH"],
		"234": ["NG"],
		"235": ["TD"],
		"236": ["CF"],
		"237": ["CM"],
		"238": ["CV"],
		"239": ["ST"],
		"240": ["GQ"],
		"241": ["GA"],
		"242": ["CG"],
		"243": ["CD"],
		"244": ["AO"],
		"245": ["GW"],
		"246": ["IO"],
		"247": ["AC"],
		"248": ["SC"],
		"249": ["SD"],
		"250": ["RW"],
		"251": ["ET"],
		"252": ["SO"],
		"253": ["DJ"],
		"254": ["KE"],
		"255": ["TZ"],
		"256": ["UG"],
		"257": ["BI"],
		"258": ["MZ"],
		"260": ["ZM"],
		"261": ["MG"],
		"262": ["RE", "YT"],
		"263": ["ZW"],
		"264": ["NA"],
		"265": ["MW"],
		"266": ["LS"],
		"267": ["BW"],
		"268": ["SZ"],
		"269": ["KM"],
		"290": ["SH", "TA"],
		"291": ["ER"],
		"297": ["AW"],
		"298": ["FO"],
		"299": ["GL"],
		"350": ["GI"],
		"351": ["PT"],
		"352": ["LU"],
		"353": ["IE"],
		"354": ["IS"],
		"355": ["AL"],
		"356": ["MT"],
		"357": ["CY"],
		"358": ["FI", "AX"],
		"359": ["BG"],
		"370": ["LT"],
		"371": ["LV"],
		"372": ["EE"],
		"373": ["MD"],
		"374": ["AM"],
		"375": ["BY"],
		"376": ["AD"],
		"377": ["MC"],
		"378": ["SM"],
		"380": ["UA"],
		"381": ["RS"],
		"382": ["ME"],
		"383": ["XK"],
		"385": ["HR"],
		"386": ["SI"],
		"387": ["BA"],
		"389": ["MK"],
		"420": ["CZ"],
		"421": ["SK"],
		"423": ["LI"],
		"500": ["FK"],
		"501": ["BZ"],
		"502": ["GT"],
		"503": ["SV"],
		"504": ["HN"],
		"505": ["NI"],
		"506": ["CR"],
		"507": ["PA"],
		"508": ["PM"],
		"509": ["HT"],
		"590": [
			"GP",
			"BL",
			"MF"
		],
		"591": ["BO"],
		"592": ["GY"],
		"593": ["EC"],
		"594": ["GF"],
		"595": ["PY"],
		"596": ["MQ"],
		"597": ["SR"],
		"598": ["UY"],
		"599": ["CW", "BQ"],
		"670": ["TL"],
		"672": ["NF"],
		"673": ["BN"],
		"674": ["NR"],
		"675": ["PG"],
		"676": ["TO"],
		"677": ["SB"],
		"678": ["VU"],
		"679": ["FJ"],
		"680": ["PW"],
		"681": ["WF"],
		"682": ["CK"],
		"683": ["NU"],
		"685": ["WS"],
		"686": ["KI"],
		"687": ["NC"],
		"688": ["TV"],
		"689": ["PF"],
		"690": ["TK"],
		"691": ["FM"],
		"692": ["MH"],
		"850": ["KP"],
		"852": ["HK"],
		"853": ["MO"],
		"855": ["KH"],
		"856": ["LA"],
		"880": ["BD"],
		"886": ["TW"],
		"960": ["MV"],
		"961": ["LB"],
		"962": ["JO"],
		"963": ["SY"],
		"964": ["IQ"],
		"965": ["KW"],
		"966": ["SA"],
		"967": ["YE"],
		"968": ["OM"],
		"970": ["PS"],
		"971": ["AE"],
		"972": ["IL"],
		"973": ["BH"],
		"974": ["QA"],
		"975": ["BT"],
		"976": ["MN"],
		"977": ["NP"],
		"992": ["TJ"],
		"993": ["TM"],
		"994": ["AZ"],
		"995": ["GE"],
		"996": ["KG"],
		"998": ["UZ"]
	},
	"countries": {
		"AC": [
			"247",
			"00",
			"(?:[01589]\\d|[2-467])\\d{4}",
			[5, 6]
		],
		"AD": [
			"376",
			"00",
			"(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
			[
				6,
				8,
				9
			],
			[
				[
					"(\\d{3})(\\d{3})",
					"$1 $2",
					["[135-9]"]
				],
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["1"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["6"]
				]
			]
		],
		"AE": [
			"971",
			"00",
			"(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
			[
				5,
				6,
				7,
				8,
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{3})(\\d{2,9})",
					"$1 $2",
					["60|8"]
				],
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[236]|[479][2-8]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d)(\\d{5})",
					"$1 $2 $3",
					["[479]"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["5"],
					"0$1"
				]
			],
			"0"
		],
		"AF": [
			"93",
			"00",
			"[2-7]\\d{8}",
			[9],
			[[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["[2-7]"],
				"0$1"
			]],
			"0"
		],
		"AG": [
			"1",
			"011",
			"(?:268|[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([457]\\d{6})$|1",
			"268$1",
			0,
			"268"
		],
		"AI": [
			"1",
			"011",
			"(?:264|[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2457]\\d{6})$|1",
			"264$1",
			0,
			"264"
		],
		"AL": [
			"355",
			"00",
			"(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
			[
				6,
				7,
				8,
				9
			],
			[
				[
					"(\\d{3})(\\d{3,4})",
					"$1 $2",
					["80|9"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["4[2-6]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[2358][2-5]|4"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{5})",
					"$1 $2",
					["[23578]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["6"],
					"0$1"
				]
			],
			"0"
		],
		"AM": [
			"374",
			"00",
			"(?:[1-489]\\d|55|60|77)\\d{6}",
			[8],
			[
				[
					"(\\d{3})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["[89]0"],
					"0 $1"
				],
				[
					"(\\d{3})(\\d{5})",
					"$1 $2",
					["2|3[12]"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{6})",
					"$1 $2",
					["1|47"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{6})",
					"$1 $2",
					["[3-9]"],
					"0$1"
				]
			],
			"0"
		],
		"AO": [
			"244",
			"00",
			"[29]\\d{8}",
			[9],
			[[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[29]"]
			]]
		],
		"AR": [
			"54",
			"00",
			"(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
			[10, 11],
			[
				[
					"(\\d{4})(\\d{2})(\\d{4})",
					"$1 $2-$3",
					[
						"2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
						"2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
						"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
						"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
					],
					"0$1",
					1
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2-$3",
					["1"],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1-$2-$3",
					["[68]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2-$3",
					["[23]"],
					"0$1",
					1
				],
				[
					"(\\d)(\\d{4})(\\d{2})(\\d{4})",
					"$2 15-$3-$4",
					[
						"9(?:2[2-469]|3[3-578])",
						"9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
						"9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
						"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
						"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
					],
					"0$1",
					0,
					"$1 $2 $3-$4"
				],
				[
					"(\\d)(\\d{2})(\\d{4})(\\d{4})",
					"$2 15-$3-$4",
					["91"],
					"0$1",
					0,
					"$1 $2 $3-$4"
				],
				[
					"(\\d{3})(\\d{3})(\\d{5})",
					"$1-$2-$3",
					["8"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{3})(\\d{4})",
					"$2 15-$3-$4",
					["9"],
					"0$1",
					0,
					"$1 $2 $3-$4"
				]
			],
			"0",
			0,
			"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
			"9$1"
		],
		"AS": [
			"1",
			"011",
			"(?:[58]\\d\\d|684|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([267]\\d{6})$|1",
			"684$1",
			0,
			"684"
		],
		"AT": [
			"43",
			"00",
			"1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
			[
				4,
				5,
				6,
				7,
				8,
				9,
				10,
				11,
				12,
				13
			],
			[
				[
					"(\\d)(\\d{3,12})",
					"$1 $2",
					["1(?:11|[2-9])"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})",
					"$1 $2",
					["517"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3,5})",
					"$1 $2",
					["5[079]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3,10})",
					"$1 $2",
					["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3,9})",
					"$1 $2",
					["[2-467]|5[2-6]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["5"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4})(\\d{4,7})",
					"$1 $2 $3",
					["5"],
					"0$1"
				]
			],
			"0"
		],
		"AU": [
			"61",
			"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
			"1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
			[
				5,
				6,
				7,
				8,
				9,
				10,
				12
			],
			[
				[
					"(\\d{2})(\\d{3,4})",
					"$1 $2",
					["16"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2,4})",
					"$1 $2 $3",
					["16"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["14|4"],
					"0$1"
				],
				[
					"(\\d)(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["[2378]"],
					"(0$1)"
				],
				[
					"(\\d{4})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["1(?:30|[89])"]
				]
			],
			"0",
			0,
			"(183[12])|0",
			0,
			0,
			0,
			[
				["(?:(?:241|349)0\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|91(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79]))))\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:55|6[0-8]|[78]\\d|9[02-9]))\\d{6}", [9]],
				["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]],
				["180(?:0\\d{3}|2)\\d{3}", [7, 10]],
				["190[0-26]\\d{6}", [10]],
				0,
				0,
				0,
				["163\\d{2,6}", [
					5,
					6,
					7,
					8,
					9
				]],
				["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]],
				["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [
					6,
					8,
					10,
					12
				]]
			],
			"0011"
		],
		"AW": [
			"297",
			"00",
			"(?:[25-79]\\d\\d|800)\\d{4}",
			[7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[25-9]"]
			]]
		],
		"AX": [
			"358",
			"00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
			"2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
			[
				5,
				6,
				7,
				8,
				9,
				10,
				11,
				12
			],
			0,
			"0",
			0,
			0,
			0,
			0,
			"18",
			0,
			"00"
		],
		"AZ": [
			"994",
			"00",
			"365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
			[9],
			[
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["90"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					[
						"1[28]|2|365|46",
						"1[28]|2|365[45]|46",
						"1[28]|2|365(?:4|5[02])|46"
					],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[13-9]"],
					"0$1"
				]
			],
			"0"
		],
		"BA": [
			"387",
			"00",
			"6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
			[8, 9],
			[
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["6[1-3]|[7-9]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2-$3",
					["[3-5]|6[56]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
					"$1 $2 $3 $4",
					["6"],
					"0$1"
				]
			],
			"0"
		],
		"BB": [
			"1",
			"011",
			"(?:246|[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-9]\\d{6})$|1",
			"246$1",
			0,
			"246"
		],
		"BD": [
			"880",
			"00",
			"[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
			[
				6,
				7,
				8,
				9,
				10
			],
			[
				[
					"(\\d{2})(\\d{4,6})",
					"$1-$2",
					["31[5-8]|[459]1"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3,7})",
					"$1-$2",
					["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3,6})",
					"$1-$2",
					["[13-9]|2[23]"],
					"0$1"
				],
				[
					"(\\d)(\\d{7,8})",
					"$1-$2",
					["2"],
					"0$1"
				]
			],
			"0"
		],
		"BE": [
			"32",
			"00",
			"4\\d{8}|[1-9]\\d{7}",
			[8, 9],
			[
				[
					"(\\d{3})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["(?:80|9)0"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[239]|4[23]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[15-8]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["4"],
					"0$1"
				]
			],
			"0"
		],
		"BF": [
			"226",
			"00",
			"[024-7]\\d{7}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[024-7]"]
			]]
		],
		"BG": [
			"359",
			"00",
			"00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
			[
				6,
				7,
				8,
				9,
				12
			],
			[
				[
					"(\\d)(\\d)(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["2"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					["43[1-6]|70[1-9]"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["2"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2,3})",
					"$1 $2 $3",
					["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["(?:70|8)0"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{2})",
					"$1 $2 $3",
					["43[1-7]|7"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[48]|9[08]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["9"],
					"0$1"
				]
			],
			"0"
		],
		"BH": [
			"973",
			"00",
			"[136-9]\\d{7}",
			[8],
			[[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[13679]|8[02-4679]"]
			]]
		],
		"BI": [
			"257",
			"00",
			"(?:[267]\\d|31)\\d{6}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[2367]"]
			]]
		],
		"BJ": [
			"229",
			"00",
			"(?:01\\d|8)\\d{7}",
			[8, 10],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["8"]
			], [
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4 $5",
				["0"]
			]]
		],
		"BL": [
			"590",
			"00",
			"7090\\d{5}|(?:[56]9|[89]\\d)\\d{7}",
			[9],
			0,
			"0",
			0,
			0,
			0,
			0,
			0,
			[
				["(?:59(?:0(?:2[7-9]|3[3-7]|5[12]|87)|87\\d)|80[6-9]\\d\\d)\\d{4}"],
				["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4}"],
				["80[0-5]\\d{6}"],
				["8[129]\\d{7}"],
				0,
				0,
				0,
				0,
				["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]
			]
		],
		"BM": [
			"1",
			"011",
			"(?:441|[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-9]\\d{6})$|1",
			"441$1",
			0,
			"441"
		],
		"BN": [
			"673",
			"00",
			"[2-578]\\d{6}",
			[7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[2-578]"]
			]]
		],
		"BO": [
			"591",
			"00(?:1\\d)?",
			"(?:[2-7]\\d\\d|8001)\\d{5}",
			[8, 9],
			[
				[
					"(\\d)(\\d{7})",
					"$1 $2",
					["[23]|4[46]|50"]
				],
				[
					"(\\d{8})",
					"$1",
					["[5-7]"]
				],
				[
					"(\\d{3})(\\d{2})(\\d{4})",
					"$1 $2 $3",
					["8"]
				]
			],
			"0",
			0,
			"0(1\\d)?"
		],
		"BQ": [
			"599",
			"00",
			"(?:[34]1|7\\d)\\d{5}",
			[7],
			0,
			0,
			0,
			0,
			0,
			0,
			"[347]"
		],
		"BR": [
			"55",
			"00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
			"[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}",
			[
				8,
				9,
				10,
				11
			],
			[
				[
					"(\\d{4})(\\d{4})",
					"$1-$2",
					["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]
				],
				[
					"(\\d{3})(\\d{2,3})(\\d{4})",
					"$1 $2 $3",
					["(?:[358]|90)0"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2-$3",
					["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],
					"($1)"
				],
				[
					"(\\d{2})(\\d{5})(\\d{4})",
					"$1 $2-$3",
					["[16][1-9]|[2-57-9]"],
					"($1)"
				]
			],
			"0",
			0,
			"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
			"$2"
		],
		"BS": [
			"1",
			"011",
			"(?:242|[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([3-8]\\d{6})$|1",
			"242$1",
			0,
			"242"
		],
		"BT": [
			"975",
			"00",
			"[178]\\d{7}|[2-8]\\d{6}",
			[7, 8],
			[[
				"(\\d)(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[2-6]|7[246]|8[2-4]"]
			], [
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["1[67]|[78]"]
			]]
		],
		"BW": [
			"267",
			"00",
			"(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
			[
				7,
				8,
				10
			],
			[
				[
					"(\\d{2})(\\d{5})",
					"$1 $2",
					["90"]
				],
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					["[24-6]|3[15-9]"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[37]"]
				],
				[
					"(\\d{4})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["0"]
				],
				[
					"(\\d{3})(\\d{4})(\\d{3})",
					"$1 $2 $3",
					["8"]
				]
			]
		],
		"BY": [
			"375",
			"810",
			"(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
			[
				6,
				7,
				8,
				9,
				10,
				11
			],
			[
				[
					"(\\d{3})(\\d{3})",
					"$1 $2",
					["800"],
					"8 $1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2,4})",
					"$1 $2 $3",
					["800"],
					"8 $1"
				],
				[
					"(\\d{4})(\\d{2})(\\d{3})",
					"$1 $2-$3",
					["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],
					"8 0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2-$3-$4",
					["1(?:[56]|7[467])|2[1-3]"],
					"8 0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2-$3-$4",
					["[1-4]"],
					"8 0$1"
				],
				[
					"(\\d{3})(\\d{3,4})(\\d{4})",
					"$1 $2 $3",
					["[89]"],
					"8 $1"
				]
			],
			"8",
			0,
			"0|80?",
			0,
			0,
			0,
			0,
			"8~10"
		],
		"BZ": [
			"501",
			"00",
			"(?:0800\\d|[2-8])\\d{6}",
			[7, 11],
			[[
				"(\\d{3})(\\d{4})",
				"$1-$2",
				["[2-8]"]
			], [
				"(\\d)(\\d{3})(\\d{4})(\\d{3})",
				"$1-$2-$3-$4",
				["0"]
			]]
		],
		"CA": [
			"1",
			"011",
			"[2-9]\\d{9}|3\\d{6}",
			[7, 10],
			0,
			"1",
			0,
			0,
			0,
			0,
			0,
			[
				["(?:2(?:04|[23]6|[48]9|5[07]|[67]3)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]],
				["", [10]],
				["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]],
				["900[2-9]\\d{6}", [10]],
				["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|3[23]|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]],
				0,
				["310\\d{4}", [7]],
				0,
				["600[2-9]\\d{6}", [10]]
			]
		],
		"CC": [
			"61",
			"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
			"1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
			[
				6,
				7,
				8,
				9,
				10,
				12
			],
			0,
			"0",
			0,
			"([59]\\d{7})$|0",
			"8$1",
			0,
			0,
			[
				["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]],
				["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]],
				["180(?:0\\d{3}|2)\\d{3}", [7, 10]],
				["190[0-26]\\d{6}", [10]],
				0,
				0,
				0,
				0,
				["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]],
				["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [
					6,
					8,
					10,
					12
				]]
			],
			"0011"
		],
		"CD": [
			"243",
			"00",
			"(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
			[
				7,
				8,
				9,
				10
			],
			[
				[
					"(\\d{2})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["88"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{5})",
					"$1 $2",
					["[1-6]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{4})",
					"$1 $2 $3",
					["2"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["1"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[89]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["5"],
					"0$1"
				]
			],
			"0"
		],
		"CF": [
			"236",
			"00",
			"8776\\d{4}|(?:[27]\\d|61)\\d{6}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[26-8]"]
			]]
		],
		"CG": [
			"242",
			"00",
			"222\\d{6}|(?:0\\d|80)\\d{7}",
			[9],
			[[
				"(\\d)(\\d{4})(\\d{4})",
				"$1 $2 $3",
				["8"]
			], [
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["[02]"]
			]]
		],
		"CH": [
			"41",
			"00",
			"8\\d{11}|[2-9]\\d{8}",
			[9, 12],
			[
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["8[047]|90"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[2-79]|81"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4 $5",
					["8"],
					"0$1"
				]
			],
			"0"
		],
		"CI": [
			"225",
			"00",
			"[02]\\d{9}",
			[10],
			[[
				"(\\d{2})(\\d{2})(\\d)(\\d{5})",
				"$1 $2 $3 $4",
				["2"]
			], [
				"(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
				"$1 $2 $3 $4",
				["0"]
			]]
		],
		"CK": [
			"682",
			"00",
			"[2-578]\\d{4}",
			[5],
			[[
				"(\\d{2})(\\d{3})",
				"$1 $2",
				["[2-578]"]
			]]
		],
		"CL": [
			"56",
			"(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
			"12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
			[
				9,
				10,
				11
			],
			[
				[
					"(\\d{5})(\\d{4})",
					"$1 $2",
					["219", "2196"],
					"($1)"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["60|809"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["44"]
				],
				[
					"(\\d)(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["2[1-36]"],
					"($1)"
				],
				[
					"(\\d)(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["9(?:10|[2-9])"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"],
					"($1)"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["60|8"]
				],
				[
					"(\\d{4})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["1"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
					"$1 $2 $3 $4",
					["60"]
				]
			]
		],
		"CM": [
			"237",
			"00",
			"[26]\\d{8}|88\\d{6,7}",
			[8, 9],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["88"]
			], [
				"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4 $5",
				["[26]|88"]
			]]
		],
		"CN": [
			"86",
			"00|1(?:[12]\\d|79)\\d\\d00",
			"(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
			[
				7,
				8,
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{2})(\\d{5,6})",
					"$1 $2",
					[
						"(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
						"(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
						"10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
						"10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
						"10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
					],
					"0$1"
				],
				[
					"(\\d{3})(\\d{5,6})",
					"$1 $2",
					[
						"3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
						"(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
						"85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
						"85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
					],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["(?:4|80)0"]
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					[
						"10|2(?:[02-57-9]|1[1-9])",
						"10|2(?:[02-57-9]|1[1-9])",
						"10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
					],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{7,8})",
					"$1 $2",
					["9"]
				],
				[
					"(\\d{4})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["80"],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["[3-578]"],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["1[3-9]"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3 $4",
					["[12]"],
					"0$1",
					1
				]
			],
			"0",
			0,
			"(1(?:[12]\\d|79)\\d\\d)|0",
			0,
			0,
			0,
			0,
			"00"
		],
		"CO": [
			"57",
			"00(?:4(?:[14]4|56)|[579])",
			"(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",
			[
				8,
				10,
				11
			],
			[
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["46"]
				],
				[
					"(\\d{3})(\\d{7})",
					"$1 $2",
					["6|90"],
					"($1)"
				],
				[
					"(\\d{3})(\\d{7})",
					"$1 $2",
					["3[0-357]|9[14]"]
				],
				[
					"(\\d)(\\d{3})(\\d{7})",
					"$1-$2-$3",
					["1"],
					"0$1",
					0,
					"$1 $2 $3"
				]
			],
			"0",
			0,
			"0([3579]|4(?:[14]4|56))?"
		],
		"CR": [
			"506",
			"00",
			"(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
			[8, 10],
			[[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[2-7]|8[3-9]"]
			], [
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1-$2-$3",
				["[89]"]
			]],
			0,
			0,
			"(19(?:0[0-2468]|1[09]|20|66|77|99))"
		],
		"CU": [
			"53",
			"119",
			"(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
			[
				6,
				7,
				8,
				10
			],
			[
				[
					"(\\d{2})(\\d{4,6})",
					"$1 $2",
					["2[1-4]|[34]"],
					"(0$1)"
				],
				[
					"(\\d)(\\d{6,7})",
					"$1 $2",
					["7"],
					"(0$1)"
				],
				[
					"(\\d)(\\d{7})",
					"$1 $2",
					["[56]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{7})",
					"$1 $2",
					["8"],
					"0$1"
				]
			],
			"0"
		],
		"CV": [
			"238",
			"0",
			"(?:[2-59]\\d\\d|800)\\d{4}",
			[7],
			[[
				"(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				["[2-589]"]
			]]
		],
		"CW": [
			"599",
			"00",
			"(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
			[7, 8],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[3467]"]
			], [
				"(\\d)(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["9[4-8]"]
			]],
			0,
			0,
			0,
			0,
			0,
			"[69]"
		],
		"CX": [
			"61",
			"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
			"1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
			[
				6,
				7,
				8,
				9,
				10,
				12
			],
			0,
			"0",
			0,
			"([59]\\d{7})$|0",
			"8$1",
			0,
			0,
			[
				["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]],
				["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]],
				["180(?:0\\d{3}|2)\\d{3}", [7, 10]],
				["190[0-26]\\d{6}", [10]],
				0,
				0,
				0,
				0,
				["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]],
				["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [
					6,
					8,
					10,
					12
				]]
			],
			"0011"
		],
		"CY": [
			"357",
			"00",
			"(?:[279]\\d|[58]0)\\d{6}",
			[8],
			[[
				"(\\d{2})(\\d{6})",
				"$1 $2",
				["[257-9]"]
			]]
		],
		"CZ": [
			"420",
			"00",
			"(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
			[
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[2-8]|9[015-7]"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
					"$1 $2 $3 $4",
					["96"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["9"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["9"]
				]
			]
		],
		"DE": [
			"49",
			"00",
			"[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
			[
				4,
				5,
				6,
				7,
				8,
				9,
				10,
				11,
				12,
				13,
				14,
				15
			],
			[
				[
					"(\\d{2})(\\d{3,13})",
					"$1 $2",
					["3[02]|40|[68]9"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3,12})",
					"$1 $2",
					["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{2,11})",
					"$1 $2",
					["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					["138"],
					"0$1"
				],
				[
					"(\\d{5})(\\d{2,10})",
					"$1 $2",
					["3"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{5,11})",
					"$1 $2",
					["181"],
					"0$1"
				],
				[
					"(\\d{3})(\\d)(\\d{4,10})",
					"$1 $2 $3",
					["1(?:3|80)|9"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{7,8})",
					"$1 $2",
					["1[67]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{7,12})",
					"$1 $2",
					["8"],
					"0$1"
				],
				[
					"(\\d{5})(\\d{6})",
					"$1 $2",
					[
						"185",
						"1850",
						"18500"
					],
					"0$1"
				],
				[
					"(\\d{3})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["7"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{7})",
					"$1 $2",
					["18[68]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{7})",
					"$1 $2",
					["15[1279]"],
					"0$1"
				],
				[
					"(\\d{5})(\\d{6})",
					"$1 $2",
					["15[03568]", "15(?:[0568]|3[13])"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{8})",
					"$1 $2",
					["18"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{7,8})",
					"$1 $2 $3",
					["1(?:6[023]|7)"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{2})(\\d{7})",
					"$1 $2 $3",
					["15[279]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{8})",
					"$1 $2 $3",
					["15"],
					"0$1"
				]
			],
			"0"
		],
		"DJ": [
			"253",
			"00",
			"(?:2\\d|77)\\d{6}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[27]"]
			]]
		],
		"DK": [
			"45",
			"00",
			"[2-9]\\d{7}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[2-9]"]
			]]
		],
		"DM": [
			"1",
			"011",
			"(?:[58]\\d\\d|767|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-7]\\d{6})$|1",
			"767$1",
			0,
			"767"
		],
		"DO": [
			"1",
			"011",
			"(?:[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			0,
			0,
			0,
			"8001|8[024]9"
		],
		"DZ": [
			"213",
			"00",
			"(?:[1-4]|[5-79]\\d|80)\\d{7}",
			[8, 9],
			[
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[1-4]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["9"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[5-8]"],
					"0$1"
				]
			],
			"0"
		],
		"EC": [
			"593",
			"00",
			"1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
			[
				8,
				9,
				10,
				11
			],
			[
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2-$3",
					["[2-7]"],
					"(0$1)",
					0,
					"$1-$2-$3"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["9"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["1"]
				]
			],
			"0"
		],
		"EE": [
			"372",
			"00",
			"8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
			[
				7,
				8,
				10
			],
			[
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]
				],
				[
					"(\\d{4})(\\d{3,4})",
					"$1 $2",
					["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{4})",
					"$1 $2 $3",
					["7"]
				],
				[
					"(\\d{4})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["8"]
				]
			]
		],
		"EG": [
			"20",
			"00",
			"[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
			[
				8,
				9,
				10
			],
			[
				[
					"(\\d)(\\d{7,8})",
					"$1 $2",
					["[23]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{6,7})",
					"$1 $2",
					["1[35]|[4-6]|8[2468]|9[235-7]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[89]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{8})",
					"$1 $2",
					["1"],
					"0$1"
				]
			],
			"0"
		],
		"EH": [
			"212",
			"00",
			"[5-8]\\d{8}",
			[9],
			0,
			"0",
			0,
			0,
			0,
			0,
			0,
			[
				["528[89]\\d{5}"],
				["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[016-8]\\d|2[0-8]|3[01]|5[0-5]))\\d{6}"],
				["80[0-7]\\d{6}"],
				["89\\d{7}"],
				0,
				0,
				0,
				0,
				["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]
			]
		],
		"ER": [
			"291",
			"00",
			"[178]\\d{6}",
			[7],
			[[
				"(\\d)(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[178]"],
				"0$1"
			]],
			"0"
		],
		"ES": [
			"34",
			"00",
			"(?:400|[5-9]\\d\\d)\\d{6}",
			[9],
			[[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[89]00"]
			], [
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[4-9]"]
			]]
		],
		"ET": [
			"251",
			"00",
			"(?:11|[2-57-9]\\d)\\d{7}",
			[9],
			[[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["[1-57-9]"],
				"0$1"
			]],
			"0"
		],
		"FI": [
			"358",
			"00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
			"[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
			[
				5,
				6,
				7,
				8,
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{5})",
					"$1",
					["20[2-59]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3,7})",
					"$1 $2",
					["(?:[1-3]0|[68])0|70[07-9]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4,8})",
					"$1 $2",
					["[14]|2[09]|50|7[135]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{6,10})",
					"$1 $2",
					["7"],
					"0$1"
				],
				[
					"(\\d)(\\d{4,9})",
					"$1 $2",
					["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"],
					"0$1"
				]
			],
			"0",
			0,
			0,
			0,
			0,
			"1[03-79]|[2-9]",
			0,
			"00"
		],
		"FJ": [
			"679",
			"0(?:0|52)",
			"45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
			[7, 11],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[235-9]|45"]
			], [
				"(\\d{4})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["0"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		"FK": [
			"500",
			"00",
			"[2-7]\\d{4}",
			[5]
		],
		"FM": [
			"691",
			"00",
			"(?:[39]\\d\\d|820)\\d{4}",
			[7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[389]"]
			]]
		],
		"FO": [
			"298",
			"00",
			"[2-9]\\d{5}",
			[6],
			[[
				"(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				["[2-9]"]
			]],
			0,
			0,
			"(10(?:01|[12]0|88))"
		],
		"FR": [
			"33",
			"00",
			"[1-9]\\d{8}",
			[9],
			[[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["8"],
				"0 $1"
			], [
				"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4 $5",
				["[1-79]"],
				"0$1"
			]],
			"0"
		],
		"GA": [
			"241",
			"00",
			"(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
			[7, 8],
			[
				[
					"(\\d)(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[2-7]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["0"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["11|[67]"],
					"0$1"
				]
			],
			0,
			0,
			"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
			"$1"
		],
		"GB": [
			"44",
			"00",
			"[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
			[
				7,
				9,
				10
			],
			[
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					[
						"800",
						"8001",
						"80011",
						"800111",
						"8001111"
					],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3",
					[
						"845",
						"8454",
						"84546",
						"845464"
					],
					"0$1"
				],
				[
					"(\\d{3})(\\d{6})",
					"$1 $2",
					["800"],
					"0$1"
				],
				[
					"(\\d{5})(\\d{4,5})",
					"$1 $2",
					[
						"1(?:38|5[23]|69|76|94)",
						"1(?:(?:38|69)7|5(?:24|39)|768|946)",
						"1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
					],
					"0$1"
				],
				[
					"(\\d{4})(\\d{5,6})",
					"$1 $2",
					["1(?:[2-69][02-9]|[78])"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{6})",
					"$1 $2",
					["7"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[1389]"],
					"0$1"
				]
			],
			"0",
			0,
			"0|180020",
			0,
			0,
			0,
			[
				["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-5])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|5[01]))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]],
				["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]],
				["80[08]\\d{7}|800\\d{6}|8001111"],
				["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]],
				["70\\d{8}", [10]],
				0,
				["(?:3[0347]|55)\\d{8}", [10]],
				["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]],
				["56\\d{8}", [10]]
			],
			0,
			" x"
		],
		"GD": [
			"1",
			"011",
			"(?:473|[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-9]\\d{6})$|1",
			"473$1",
			0,
			"473"
		],
		"GE": [
			"995",
			"00",
			"(?:[3-57]\\d\\d|800)\\d{6}",
			[9],
			[
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["70"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["32"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[57]"]
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[348]"],
					"0$1"
				]
			],
			"0"
		],
		"GF": [
			"594",
			"00",
			"(?:694\\d|7093)\\d{5}|(?:59|[89]\\d)\\d{7}",
			[9],
			[[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[5-7]|80[6-9]|9[47]"],
				"0$1"
			], [
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[89]"],
				"0$1"
			]],
			"0"
		],
		"GG": [
			"44",
			"00",
			"(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
			[
				7,
				9,
				10
			],
			0,
			"0",
			0,
			"([25-9]\\d{5})$|0|180020",
			"1481$1",
			0,
			0,
			[
				["1481[25-9]\\d{5}", [10]],
				["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]],
				["80[08]\\d{7}|800\\d{6}|8001111"],
				["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]],
				["70\\d{8}", [10]],
				0,
				["(?:3[0347]|55)\\d{8}", [10]],
				["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]],
				["56\\d{8}", [10]]
			]
		],
		"GH": [
			"233",
			"00",
			"[235]\\d{8}|800\\d{5,6}",
			[8, 9],
			[[
				"(\\d{3})(\\d{5})",
				"$1 $2",
				["8"],
				"0$1"
			], [
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["[2358]"],
				"0$1"
			]],
			"0"
		],
		"GI": [
			"350",
			"00",
			"(?:[25]\\d|60)\\d{6}",
			[8],
			[[
				"(\\d{3})(\\d{5})",
				"$1 $2",
				["2"]
			]]
		],
		"GL": [
			"299",
			"00",
			"(?:19|[2-689]\\d|70)\\d{4}",
			[6],
			[[
				"(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				["19|[2-9]"]
			]]
		],
		"GM": [
			"220",
			"00",
			"[48]\\d{8}|[2-9]\\d{6}",
			[7, 9],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[235-9]|4(?:[0-35]|4[16-9])"]
			], [
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["[48]"]
			]]
		],
		"GN": [
			"224",
			"00",
			"722\\d{6}|(?:3|6\\d)\\d{7}",
			[8, 9],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["3"]
			], [
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[67]"]
			]]
		],
		"GP": [
			"590",
			"00",
			"7090\\d{5}|(?:[56]9|[89]\\d)\\d{7}",
			[9],
			[[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[5-79]|80[6-9]"],
				"0$1"
			], [
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["8"],
				"0$1"
			]],
			"0",
			0,
			0,
			0,
			0,
			0,
			[
				["(?:59(?:0(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)|87\\d)|80[6-9]\\d\\d)\\d{4}"],
				["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4}"],
				["80[0-5]\\d{6}"],
				["8[129]\\d{7}"],
				0,
				0,
				0,
				0,
				["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]
			]
		],
		"GQ": [
			"240",
			"00",
			"222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
			[9],
			[[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[235]"]
			], [
				"(\\d{3})(\\d{6})",
				"$1 $2",
				["[89]"]
			]]
		],
		"GR": [
			"30",
			"00",
			"5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
			[
				10,
				11,
				12
			],
			[
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["21|7"]
				],
				[
					"(\\d{4})(\\d{6})",
					"$1 $2",
					["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[2689]"]
				],
				[
					"(\\d{3})(\\d{3,4})(\\d{5})",
					"$1 $2 $3",
					["8"]
				]
			]
		],
		"GT": [
			"502",
			"00",
			"80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
			[8, 11],
			[[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[2-8]"]
			], [
				"(\\d{4})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["1"]
			]]
		],
		"GU": [
			"1",
			"011",
			"(?:[58]\\d\\d|671|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-9]\\d{6})$|1",
			"671$1",
			0,
			"671"
		],
		"GW": [
			"245",
			"00",
			"[49]\\d{8}|4\\d{6}",
			[7, 9],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["40"]
			], [
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[49]"]
			]]
		],
		"GY": [
			"592",
			"001",
			"(?:[2-8]\\d{3}|9008)\\d{3}",
			[7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[2-9]"]
			]]
		],
		"HK": [
			"852",
			"00(?:30|5[09]|[126-9]?)",
			"8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
			[
				5,
				6,
				7,
				8,
				9,
				11
			],
			[
				[
					"(\\d{3})(\\d{2,5})",
					"$1 $2",
					["900", "9003"]
				],
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["8"]
				],
				[
					"(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["9"]
				]
			],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		"HN": [
			"504",
			"00",
			"8\\d{10}|[237-9]\\d{7}",
			[8, 11],
			[[
				"(\\d{4})(\\d{4})",
				"$1-$2",
				["[237-9]"]
			]]
		],
		"HR": [
			"385",
			"00",
			"[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}",
			[
				7,
				8,
				9
			],
			[
				[
					"(\\d{2})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["6[01]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2,3})",
					"$1 $2 $3",
					["8"],
					"0$1"
				],
				[
					"(\\d)(\\d{4})(\\d{3})",
					"$1 $2 $3",
					["1"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["6|7[245]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["9"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[2-57]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["8"],
					"0$1"
				]
			],
			"0"
		],
		"HT": [
			"509",
			"00",
			"[2-589]\\d{7}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{4})",
				"$1 $2 $3",
				["[2-589]"]
			]]
		],
		"HU": [
			"36",
			"00",
			"[235-7]\\d{8}|[1-9]\\d{7}",
			[8, 9],
			[
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["1"],
					"(06 $1)"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],
					"(06 $1)"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[2-9]"],
					"06 $1"
				]
			],
			"06"
		],
		"ID": [
			"62",
			"00[89]",
			"00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
			[
				7,
				8,
				9,
				10,
				11,
				12,
				13,
				14,
				15,
				16,
				17
			],
			[
				[
					"(\\d)(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["15"]
				],
				[
					"(\\d{2})(\\d{5,9})",
					"$1 $2",
					["2[124]|[36]1"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{5,7})",
					"$1 $2",
					["800"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{5,8})",
					"$1 $2",
					["[2-79]"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{3,4})(\\d{3})",
					"$1-$2-$3",
					["8[1-35-9]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{6,8})",
					"$1 $2",
					["1"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["804"],
					"0$1"
				],
				[
					"(\\d{3})(\\d)(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["80"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{4})(\\d{4,5})",
					"$1-$2-$3",
					["8"],
					"0$1"
				]
			],
			"0"
		],
		"IE": [
			"353",
			"00",
			"(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
			[
				7,
				8,
				9,
				10
			],
			[
				[
					"(\\d{2})(\\d{5})",
					"$1 $2",
					["2[24-9]|47|58|6[237-9]|9[35-9]"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{5})",
					"$1 $2",
					["[45]0"],
					"(0$1)"
				],
				[
					"(\\d)(\\d{3,4})(\\d{4})",
					"$1 $2 $3",
					["1"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[2569]|4[1-69]|7[14]"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["70"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["81"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[78]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["1"]
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["4"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3 $4",
					["8"],
					"0$1"
				]
			],
			"0"
		],
		"IL": [
			"972",
			"0(?:0|1(?:05|[2-9]))",
			"1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
			[
				7,
				8,
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{4})(\\d{3})",
					"$1-$2",
					["125"]
				],
				[
					"(\\d{4})(\\d{2})(\\d{2})",
					"$1-$2-$3",
					["121"]
				],
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1-$2-$3",
					["[2-489]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1-$2-$3",
					["[57]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3})(\\d{3})",
					"$1-$2-$3",
					["12"]
				],
				[
					"(\\d{4})(\\d{6})",
					"$1-$2",
					["159"]
				],
				[
					"(\\d)(\\d{3})(\\d{3})(\\d{3})",
					"$1-$2-$3-$4",
					["1[7-9]"]
				],
				[
					"(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
					"$1-$2 $3-$4",
					["15"]
				]
			],
			"0"
		],
		"IM": [
			"44",
			"00",
			"1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
			[10],
			0,
			"0",
			0,
			"([25-8]\\d{5})$|0|180020",
			"1624$1",
			0,
			"74576|(?:16|7[56])24"
		],
		"IN": [
			"91",
			"00",
			"(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
			[
				8,
				9,
				10,
				11,
				12,
				13
			],
			[
				[
					"(\\d{8})",
					"$1",
					[
						"5(?:0|2[23]|3[03]|[67]1|88)",
						"5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
						"5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
					],
					0,
					1
				],
				[
					"(\\d{4})(\\d{4,5})",
					"$1 $2",
					["180", "1800"],
					0,
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["140"],
					0,
					1
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					[
						"11|2[02]|33|4[04]|79[1-6]|80[2-46]",
						"11|2[02]|33|4[04]|79[1-6]|80(?:[2-4]|6[0-589])",
						"11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9]))|80(?:[2-4]|6[0-589])"
					],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					[
						"1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67)[14]",
						"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31)|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
						"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:3171|5[15][2-6]|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|8(?:16|2[014]|3[126]|6[136]|7[78]|83)(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
					],
					"0$1",
					1
				],
				[
					"(\\d{4})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					[
						"1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|3[129]|5[29]|6[02-5]|70)|807",
						"1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7(?:[23569]|8[0-57-9])|8[1-6])|7(?:1(?:[013-8]|9[6-9])|3(?:17|2[0-49]|9[2-57])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
						"1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|8(?:28[235-7]|3))|73179|807(?:1|9[1-3])|(?:1552|6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578])\\d|7(?:[23569]\\d|8[0-57-9])|8(?:[14-6]\\d|2[0-79]))|7(?:1(?:[013-8]\\d|9[6-9])|3(?:2[0-49]|9[2-57])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
					],
					"0$1",
					1
				],
				[
					"(\\d{5})(\\d{5})",
					"$1 $2",
					["16|[6-9]"],
					"0$1",
					1
				],
				[
					"(\\d{4})(\\d{2,4})(\\d{4})",
					"$1 $2 $3",
					["18[06]", "18[06]0"],
					0,
					1
				],
				[
					"(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["18"],
					0,
					1
				]
			],
			"0"
		],
		"IO": [
			"246",
			"00",
			"3\\d{6}",
			[7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["3"]
			]]
		],
		"IQ": [
			"964",
			"00",
			"(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
			[
				8,
				9,
				10
			],
			[
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["1"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[2-6]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["7"],
					"0$1"
				]
			],
			"0"
		],
		"IR": [
			"98",
			"00",
			"[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
			[
				4,
				5,
				6,
				7,
				10
			],
			[
				[
					"(\\d{4,5})",
					"$1",
					["96"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4,5})",
					"$1 $2",
					["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["9"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["[1-8]"],
					"0$1"
				]
			],
			"0"
		],
		"IS": [
			"354",
			"00|1(?:0(?:01|[12]0)|100)",
			"(?:38\\d|[4-9])\\d{6}",
			[7, 9],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[4-9]"]
			], [
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["3"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		"IT": [
			"39",
			"00",
			"0\\d{5,11}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
			[
				6,
				7,
				8,
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{2})(\\d{4,6})",
					"$1 $2",
					["0[26]"]
				],
				[
					"(\\d{3})(\\d{3,6})",
					"$1 $2",
					["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]
				],
				[
					"(\\d{4})(\\d{2,6})",
					"$1 $2",
					["0(?:[13-579][2-46-8]|8[236-8])"]
				],
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["894"]
				],
				[
					"(\\d{2})(\\d{3,4})(\\d{4})",
					"$1 $2 $3",
					["0[26]|5"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["1(?:44|[679])|[378]|43"]
				],
				[
					"(\\d{3})(\\d{3,4})(\\d{4})",
					"$1 $2 $3",
					["0[13-57-9][0159]|14"]
				],
				[
					"(\\d{2})(\\d{4})(\\d{5})",
					"$1 $2 $3",
					["0[26]"]
				],
				[
					"(\\d{4})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["0"]
				],
				[
					"(\\d{3})(\\d{4})(\\d{4,5})",
					"$1 $2 $3",
					["[03]"]
				]
			],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				["0(?:669[0-79]\\d{1,6}|831\\d{2,8})|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[2356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"],
				["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]],
				["80(?:0\\d{3}|3)\\d{3}", [6, 9]],
				["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [
					6,
					8,
					9,
					10
				]],
				["1(?:78\\d|99)\\d{6}", [9, 10]],
				["3[2-8]\\d{9,10}", [11, 12]],
				0,
				0,
				["55\\d{8}", [10]],
				["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]
			]
		],
		"JE": [
			"44",
			"00",
			"1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
			[10],
			0,
			"0",
			0,
			"([0-24-8]\\d{5})$|0|180020",
			"1534$1",
			0,
			0,
			[
				["1534[0-24-8]\\d{5}"],
				["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"],
				["80(?:07(?:35|81)|8901)\\d{4}"],
				["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],
				["701511\\d{4}"],
				0,
				["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],
				["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"],
				["56\\d{8}"]
			]
		],
		"JM": [
			"1",
			"011",
			"(?:[58]\\d\\d|658|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			0,
			0,
			0,
			"658|876"
		],
		"JO": [
			"962",
			"00",
			"(?:(?:[2689]|7\\d)\\d|32|427|53)\\d{6}",
			[8, 9],
			[
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[2356]|87"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{5,6})",
					"$1 $2",
					["[89]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{7})",
					"$1 $2",
					["70"],
					"0$1"
				],
				[
					"(\\d)(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["[47]"],
					"0$1"
				]
			],
			"0"
		],
		"JP": [
			"81",
			"010",
			"00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
			[
				8,
				9,
				10,
				11,
				12,
				13,
				14,
				15,
				16,
				17
			],
			[
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1-$2-$3",
					["(?:12|57|99)0"],
					"0$1"
				],
				[
					"(\\d{4})(\\d)(\\d{4})",
					"$1-$2-$3",
					[
						"1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
						"1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
						"1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
					],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1-$2-$3",
					["60"],
					"0$1"
				],
				[
					"(\\d)(\\d{4})(\\d{4})",
					"$1-$2-$3",
					["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1-$2-$3",
					[
						"1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
						"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
						"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
					],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{4})",
					"$1-$2-$3",
					["[14]|[289][2-9]|5[3-9]|7[2-4679]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1-$2-$3",
					["800"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1-$2-$3",
					["[25-9]"],
					"0$1"
				]
			],
			"0",
			0,
			"(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0",
			"$1"
		],
		"KE": [
			"254",
			"000",
			"(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
			[
				7,
				8,
				9,
				10
			],
			[
				[
					"(\\d{2})(\\d{5,7})",
					"$1 $2",
					["[24-6]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{6})",
					"$1 $2",
					["[17]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[89]"],
					"0$1"
				]
			],
			"0"
		],
		"KG": [
			"996",
			"00",
			"8\\d{9}|[235-9]\\d{8}",
			[9, 10],
			[
				[
					"(\\d{4})(\\d{5})",
					"$1 $2",
					["3(?:1[346]|[24-79])"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[235-79]|88"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
					"$1 $2 $3 $4",
					["8"],
					"0$1"
				]
			],
			"0"
		],
		"KH": [
			"855",
			"00[14-9]",
			"1\\d{9}|[1-9]\\d{7,8}",
			[
				8,
				9,
				10
			],
			[[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				["[1-9]"],
				"0$1"
			], [
				"(\\d{4})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["1"]
			]],
			"0"
		],
		"KI": [
			"686",
			"00",
			"(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
			[5, 8],
			0,
			"0"
		],
		"KM": [
			"269",
			"00",
			"[3478]\\d{6}",
			[7],
			[[
				"(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				["[3478]"]
			]]
		],
		"KN": [
			"1",
			"011",
			"(?:[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-7]\\d{6})$|1",
			"869$1",
			0,
			"869"
		],
		"KP": [
			"850",
			"00|99",
			"85\\d{6}|(?:19\\d|[2-7])\\d{7}",
			[8, 10],
			[
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["8"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[2-7]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["1"],
					"0$1"
				]
			],
			"0"
		],
		"KR": [
			"82",
			"00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
			"00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
			[
				5,
				6,
				8,
				9,
				10,
				11,
				12,
				13,
				14
			],
			[
				[
					"(\\d{2})(\\d{3,4})",
					"$1-$2",
					["(?:3[1-3]|[46][1-4]|5[1-5])1"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{4})",
					"$1-$2",
					["1"]
				],
				[
					"(\\d)(\\d{3,4})(\\d{4})",
					"$1-$2-$3",
					["2"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1-$2-$3",
					["[36]0|8"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3,4})(\\d{4})",
					"$1-$2-$3",
					["[1346]|5[1-5]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1-$2-$3",
					["[57]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{5})(\\d{4})",
					"$1-$2-$3",
					["5"],
					"0$1"
				]
			],
			"0",
			0,
			"0(8(?:[1-46-8]|5\\d\\d))?"
		],
		"KW": [
			"965",
			"00",
			"18\\d{5}|(?:[2569]\\d|41)\\d{6}",
			[7, 8],
			[[
				"(\\d{4})(\\d{3,4})",
				"$1 $2",
				["[169]|2(?:[235]|4[1-35-9])|52"]
			], [
				"(\\d{3})(\\d{5})",
				"$1 $2",
				["[245]"]
			]]
		],
		"KY": [
			"1",
			"011",
			"(?:345|[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-9]\\d{6})$|1",
			"345$1",
			0,
			"345"
		],
		"KZ": [
			"7",
			"810",
			"8\\d{13}|[78]\\d{9}",
			[10, 14],
			0,
			"8",
			0,
			0,
			0,
			0,
			"7",
			0,
			"8~10"
		],
		"LA": [
			"856",
			"00",
			"[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
			[
				8,
				9,
				10
			],
			[
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["2[13]|3[14]|[4-8]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
					"$1 $2 $3 $4",
					["3"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["[23]"],
					"0$1"
				]
			],
			"0"
		],
		"LB": [
			"961",
			"00",
			"[27-9]\\d{7}|[13-9]\\d{6}",
			[7, 8],
			[[
				"(\\d)(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"],
				"0$1"
			], [
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[27-9]"]
			]],
			"0"
		],
		"LC": [
			"1",
			"011",
			"(?:[58]\\d\\d|758|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-8]\\d{6})$|1",
			"758$1",
			0,
			"758"
		],
		"LI": [
			"423",
			"00",
			"[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
			[7, 9],
			[
				[
					"(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3",
					["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["8"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["69"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["6"]
				]
			],
			"0",
			0,
			"(1001)|0"
		],
		"LK": [
			"94",
			"00",
			"[1-9]\\d{8}",
			[9],
			[[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["7"],
				"0$1"
			], [
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[1-689]"],
				"0$1"
			]],
			"0"
		],
		"LR": [
			"231",
			"00",
			"(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
			[
				7,
				8,
				9
			],
			[
				[
					"(\\d)(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["4[67]|[56]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["2"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[2-578]"],
					"0$1"
				]
			],
			"0"
		],
		"LS": [
			"266",
			"00",
			"(?:[256]\\d\\d|800)\\d{5}",
			[8],
			[[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[2568]"]
			]]
		],
		"LT": [
			"370",
			"00",
			"(?:[3469]\\d|52|[78]0)\\d{6}",
			[8],
			[
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["52[0-7]"],
					"(0-$1)",
					1
				],
				[
					"(\\d{3})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["[7-9]"],
					"0 $1",
					1
				],
				[
					"(\\d{2})(\\d{6})",
					"$1 $2",
					["37|4(?:[15]|6[1-8])"],
					"(0-$1)",
					1
				],
				[
					"(\\d{3})(\\d{5})",
					"$1 $2",
					["[3-6]"],
					"(0-$1)",
					1
				]
			],
			"0",
			0,
			"[08]"
		],
		"LU": [
			"352",
			"00",
			"35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
			[
				4,
				5,
				6,
				7,
				8,
				9,
				10,
				11
			],
			[
				[
					"(\\d{2})(\\d{3})",
					"$1 $2",
					["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3",
					["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["20[2-689]"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
					"$1 $2 $3 $4",
					["20"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
					"$1 $2 $3 $4",
					["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]
				],
				[
					"(\\d{3})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["80[01]|90[015]"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
					"$1 $2 $3 $4",
					["20"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["6"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
					"$1 $2 $3 $4 $5",
					["20"]
				]
			],
			0,
			0,
			"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
		],
		"LV": [
			"371",
			"00",
			"(?:[268]\\d|78|90)\\d{6}",
			[8],
			[[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[2679]|8[01]"]
			]]
		],
		"LY": [
			"218",
			"00",
			"[2-9]\\d{8}",
			[9],
			[[
				"(\\d{2})(\\d{7})",
				"$1-$2",
				["[2-9]"],
				"0$1"
			]],
			"0"
		],
		"MA": [
			"212",
			"00",
			"[5-8]\\d{8}",
			[9],
			[
				[
					"(\\d{4})(\\d{5})",
					"$1-$2",
					["892"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{7})",
					"$1-$2",
					["8(?:0[0-7]|9)"],
					"0$1"
				],
				[
					"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4 $5",
					["[5-8]"],
					"0$1"
				]
			],
			"0",
			0,
			0,
			0,
			0,
			"[5-8]"
		],
		"MC": [
			"377",
			"00",
			"(?:[3489]|[67]\\d)\\d{7}",
			[8, 9],
			[
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["4"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[389]"]
				],
				[
					"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4 $5",
					["[67]"],
					"0$1"
				]
			],
			"0"
		],
		"MD": [
			"373",
			"00",
			"(?:[235-7]\\d|[89]0)\\d{6}",
			[8],
			[
				[
					"(\\d{3})(\\d{5})",
					"$1 $2",
					["[89]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["22|3"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["[25-7]"],
					"0$1"
				]
			],
			"0"
		],
		"ME": [
			"382",
			"00",
			"(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
			[8, 9],
			[[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				["[2-9]"],
				"0$1"
			]],
			"0"
		],
		"MF": [
			"590",
			"00",
			"7090\\d{5}|(?:[56]9|[89]\\d)\\d{7}",
			[9],
			0,
			"0",
			0,
			0,
			0,
			0,
			0,
			[
				["(?:59(?:0(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)|87\\d)|80[6-9]\\d\\d)\\d{4}"],
				["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4}"],
				["80[0-5]\\d{6}"],
				["8[129]\\d{7}"],
				0,
				0,
				0,
				0,
				["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]
			]
		],
		"MG": [
			"261",
			"00",
			"[23]\\d{8}",
			[9],
			[[
				"(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
				"$1 $2 $3 $4",
				["[23]"],
				"0$1"
			]],
			"0",
			0,
			"([24-9]\\d{6})$|0",
			"20$1"
		],
		"MH": [
			"692",
			"011",
			"329\\d{4}|(?:[256]\\d|45)\\d{5}",
			[7],
			[[
				"(\\d{3})(\\d{4})",
				"$1-$2",
				["[2-6]"]
			]],
			"1"
		],
		"MK": [
			"389",
			"00",
			"[2-578]\\d{7}",
			[8],
			[
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["2|34[47]|4(?:[37]7|5[47]|64)"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[347]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d)(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[58]"],
					"0$1"
				]
			],
			"0"
		],
		"ML": [
			"223",
			"00",
			"[24-9]\\d{7}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[24-9]"]
			]]
		],
		"MM": [
			"95",
			"00",
			"1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
			[
				6,
				7,
				8,
				9,
				10
			],
			[
				[
					"(\\d)(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["16|2"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[12]|452|678|86", "[12]|452|6788|86"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[4-7]|8[1-35]"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{4,6})",
					"$1 $2 $3",
					["9(?:2[0-4]|[35-9]|4[137-9])"],
					"0$1"
				],
				[
					"(\\d)(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["2"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["8"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["92"],
					"0$1"
				],
				[
					"(\\d)(\\d{5})(\\d{4})",
					"$1 $2 $3",
					["9"],
					"0$1"
				]
			],
			"0"
		],
		"MN": [
			"976",
			"001",
			"[12]\\d{7,9}|[5-9]\\d{7}",
			[
				8,
				9,
				10
			],
			[
				[
					"(\\d{2})(\\d{2})(\\d{4})",
					"$1 $2 $3",
					["11|2[16]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["[5-9]"]
				],
				[
					"(\\d{3})(\\d{5,6})",
					"$1 $2",
					["[12]2[1-3]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{5,6})",
					"$1 $2",
					["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],
					"0$1"
				],
				[
					"(\\d{5})(\\d{4,5})",
					"$1 $2",
					["[12]"],
					"0$1"
				]
			],
			"0"
		],
		"MO": [
			"853",
			"00",
			"0800\\d{3}|(?:28|[68]\\d)\\d{6}",
			[7, 8],
			[[
				"(\\d{4})(\\d{3})",
				"$1 $2",
				["0"]
			], [
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[268]"]
			]]
		],
		"MP": [
			"1",
			"011",
			"[58]\\d{9}|(?:67|90)0\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-9]\\d{6})$|1",
			"670$1",
			0,
			"670"
		],
		"MQ": [
			"596",
			"00",
			"7091\\d{5}|(?:[56]9|[89]\\d)\\d{7}",
			[9],
			[[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[5-79]|8(?:0[6-9]|[36])"],
				"0$1"
			], [
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["8"],
				"0$1"
			]],
			"0"
		],
		"MR": [
			"222",
			"00",
			"(?:[2-4]\\d\\d|800)\\d{5}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[2-48]"]
			]]
		],
		"MS": [
			"1",
			"011",
			"(?:[58]\\d\\d|664|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([34]\\d{6})$|1",
			"664$1",
			0,
			"664"
		],
		"MT": [
			"356",
			"00",
			"3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
			[8],
			[[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[2357-9]"]
			]]
		],
		"MU": [
			"230",
			"0(?:0|[24-7]0|3[03])",
			"(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
			[
				7,
				8,
				10
			],
			[
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					["[2-46]|8[013]"]
				],
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["[57]"]
				],
				[
					"(\\d{5})(\\d{5})",
					"$1 $2",
					["8"]
				]
			],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"020"
		],
		"MV": [
			"960",
			"0(?:0|19)",
			"(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
			[7, 10],
			[[
				"(\\d{3})(\\d{4})",
				"$1-$2",
				["[34679]"]
			], [
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["[89]"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		"MW": [
			"265",
			"00",
			"(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
			[7, 9],
			[[
				"(\\d)(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["1[2-9]"],
				"0$1"
			], [
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[1-37-9]"],
				"0$1"
			]],
			"0"
		],
		"MX": [
			"52",
			"0[09]",
			"[2-9]\\d{9}",
			[10],
			[[
				"(\\d{2})(\\d{4})(\\d{4})",
				"$1 $2 $3",
				["33|5[56]|81"]
			], [
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["[2-9]"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		"MY": [
			"60",
			"00",
			"1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
			[
				8,
				9,
				10
			],
			[
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1-$2 $3",
					["[4-79]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1-$2 $3",
					["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],
					"0$1"
				],
				[
					"(\\d)(\\d{4})(\\d{4})",
					"$1-$2 $3",
					["3"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{2})(\\d{4})",
					"$1-$2-$3-$4",
					["1(?:[367]|80)"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1-$2 $3",
					["15"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1-$2 $3",
					["1"],
					"0$1"
				]
			],
			"0"
		],
		"MZ": [
			"258",
			"00",
			"(?:2|8\\d)\\d{7}",
			[8, 9],
			[[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				["2|8[2-9]"]
			], [
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["8"]
			]]
		],
		"NA": [
			"264",
			"00",
			"[68]\\d{7,8}",
			[8, 9],
			[
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["88"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["6"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["87"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["8"],
					"0$1"
				]
			],
			"0"
		],
		"NC": [
			"687",
			"00",
			"(?:050|[2-57-9]\\d\\d)\\d{3}",
			[6],
			[[
				"(\\d{2})(\\d{2})(\\d{2})",
				"$1.$2.$3",
				["[02-57-9]"]
			]]
		],
		"NE": [
			"227",
			"00",
			"[027-9]\\d{7}",
			[8],
			[[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["08"]
			], [
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[089]|2[013]|7[0467]"]
			]]
		],
		"NF": [
			"672",
			"00",
			"[13]\\d{5}",
			[6],
			[[
				"(\\d{2})(\\d{4})",
				"$1 $2",
				["1[0-3]"]
			], [
				"(\\d)(\\d{5})",
				"$1 $2",
				["[13]"]
			]],
			0,
			0,
			"([0-258]\\d{4})$",
			"3$1"
		],
		"NG": [
			"234",
			"009",
			"(?:20|9\\d)\\d{8}|[78]\\d{9,13}",
			[
				10,
				11,
				12,
				13,
				14
			],
			[
				[
					"(\\d{3})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[7-9]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["20[129]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{2})(\\d{4})",
					"$1 $2 $3",
					["2"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{4})(\\d{4,5})",
					"$1 $2 $3",
					["[78]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{5})(\\d{5,6})",
					"$1 $2 $3",
					["[78]"],
					"0$1"
				]
			],
			"0"
		],
		"NI": [
			"505",
			"00",
			"(?:1800|[25-8]\\d{3})\\d{4}",
			[8],
			[[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[125-8]"]
			]]
		],
		"NL": [
			"31",
			"00",
			"(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
			[
				5,
				6,
				7,
				8,
				9,
				10,
				11
			],
			[
				[
					"(\\d{3})(\\d{4,7})",
					"$1 $2",
					["[89]0"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{7})",
					"$1 $2",
					["66"],
					"0$1"
				],
				[
					"(\\d)(\\d{8})",
					"$1 $2",
					["6"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[1-578]|91"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{5})",
					"$1 $2 $3",
					["9"],
					"0$1"
				]
			],
			"0"
		],
		"NO": [
			"47",
			"00",
			"(?:0|[2-9]\\d{3})\\d{4}",
			[5, 8],
			[[
				"(\\d{3})(\\d{2})(\\d{3})",
				"$1 $2 $3",
				["8"]
			], [
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[2-79]"]
			]],
			0,
			0,
			0,
			0,
			0,
			"[02-689]|7[0-8]"
		],
		"NP": [
			"977",
			"00",
			"(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
			[
				8,
				10,
				11
			],
			[
				[
					"(\\d)(\\d{7})",
					"$1-$2",
					["1[2-6]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{6})",
					"$1-$2",
					["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{7})",
					"$1-$2",
					["9"]
				]
			],
			"0"
		],
		"NR": [
			"674",
			"00",
			"(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}",
			[7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[24-9]"]
			]]
		],
		"NU": [
			"683",
			"00",
			"(?:[4-7]|888\\d)\\d{3}",
			[4, 7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["8"]
			]]
		],
		"NZ": [
			"64",
			"0(?:0|161)",
			"[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
			[
				5,
				6,
				7,
				8,
				9,
				10
			],
			[
				[
					"(\\d{2})(\\d{3,8})",
					"$1 $2",
					["8[1-79]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2,3})",
					"$1 $2 $3",
					["50[036-8]|8|90", "50(?:[0367]|88)|8|90"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["24|[346]|7[2-57-9]|9[2-9]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["2(?:10|74)|[589]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3,4})(\\d{4})",
					"$1 $2 $3",
					["1|2[028]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,5})",
					"$1 $2 $3",
					["2(?:[169]|7[0-35-9])|7"],
					"0$1"
				]
			],
			"0",
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		"OM": [
			"968",
			"00",
			"(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
			[
				7,
				8,
				9
			],
			[
				[
					"(\\d{3})(\\d{4,6})",
					"$1 $2",
					["[58]"]
				],
				[
					"(\\d{2})(\\d{6})",
					"$1 $2",
					["2"]
				],
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["[179]"]
				]
			]
		],
		"PA": [
			"507",
			"00",
			"(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
			[
				7,
				8,
				10,
				11
			],
			[
				[
					"(\\d{3})(\\d{4})",
					"$1-$2",
					["[1-57-9]"]
				],
				[
					"(\\d{4})(\\d{4})",
					"$1-$2",
					["[68]"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["8"]
				]
			]
		],
		"PE": [
			"51",
			"00|19(?:1[124]|77|90)00",
			"(?:[14-8]|9\\d)\\d{7}",
			[8, 9],
			[
				[
					"(\\d{3})(\\d{5})",
					"$1 $2",
					["80"],
					"(0$1)"
				],
				[
					"(\\d)(\\d{7})",
					"$1 $2",
					["1"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{6})",
					"$1 $2",
					["[4-8]"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["9"]
				]
			],
			"0",
			0,
			0,
			0,
			0,
			0,
			0,
			"00",
			" Anexo "
		],
		"PF": [
			"689",
			"00",
			"4\\d{5}(?:\\d{2})?|8\\d{7,8}",
			[
				6,
				8,
				9
			],
			[
				[
					"(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3",
					["44"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["4|8[7-9]"]
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["8"]
				]
			]
		],
		"PG": [
			"675",
			"00|140[1-3]",
			"(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
			[7, 8],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["18|[2-69]|85[02-46-9]"]
			], [
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[78]"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		"PH": [
			"63",
			"00",
			"(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
			[
				6,
				8,
				9,
				10,
				11,
				12,
				13
			],
			[
				[
					"(\\d)(\\d{5})",
					"$1 $2",
					["2"],
					"(0$1)"
				],
				[
					"(\\d{4})(\\d{4,6})",
					"$1 $2",
					["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],
					"(0$1)"
				],
				[
					"(\\d{5})(\\d{4})",
					"$1 $2",
					["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"],
					"(0$1)"
				],
				[
					"(\\d)(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["2"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[3-7]|8[2-8]"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[89]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["1"]
				],
				[
					"(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
					"$1 $2 $3 $4",
					["1"]
				]
			],
			"0"
		],
		"PK": [
			"92",
			"00",
			"122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
			[
				8,
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{3})(\\d{3})(\\d{2,7})",
					"$1 $2 $3",
					["[89]0"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{5})",
					"$1 $2",
					["1"]
				],
				[
					"(\\d{3})(\\d{6,7})",
					"$1 $2",
					["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{7,8})",
					"$1 $2",
					["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],
					"(0$1)"
				],
				[
					"(\\d{5})(\\d{5})",
					"$1 $2",
					["58"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{7})",
					"$1 $2",
					["3"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["[24-9]"],
					"(0$1)"
				]
			],
			"0"
		],
		"PL": [
			"48",
			"00",
			"(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
			[
				6,
				7,
				8,
				9,
				10
			],
			[
				[
					"(\\d{5})",
					"$1",
					["19"]
				],
				[
					"(\\d{3})(\\d{3})",
					"$1 $2",
					["11|20|64"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["30|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "30|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]
				],
				[
					"(\\d{3})(\\d{2})(\\d{2,3})",
					"$1 $2 $3",
					["64"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["1[2-8]|[2-7]|8[1-79]|9[145]"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["8"]
				]
			]
		],
		"PM": [
			"508",
			"00",
			"[78]\\d{8}|[2-9]\\d{5}",
			[6, 9],
			[
				[
					"(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3",
					["[2-9]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["7"]
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["8"],
					"0$1"
				]
			],
			"0"
		],
		"PR": [
			"1",
			"011",
			"(?:[589]\\d\\d|787)\\d{7}",
			[10],
			0,
			"1",
			0,
			0,
			0,
			0,
			"787|939"
		],
		"PS": [
			"970",
			"00",
			"[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
			[
				8,
				9,
				10
			],
			[
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[2489]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["5"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["1"]
				]
			],
			"0"
		],
		"PT": [
			"351",
			"00",
			"1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
			[9],
			[[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["2[12]"]
			], [
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["16|[236-9]"]
			]]
		],
		"PW": [
			"680",
			"01[12]",
			"(?:[24-8]\\d\\d|345|900)\\d{4}",
			[7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[2-9]"]
			]]
		],
		"PY": [
			"595",
			"00",
			"[36-8]\\d{5,8}|4\\d{6,8}|59\\d{6}|9\\d{5,10}|(?:2\\d|5[0-8])\\d{6,7}",
			[
				6,
				7,
				8,
				9,
				10,
				11
			],
			[
				[
					"(\\d{3})(\\d{3,6})",
					"$1 $2",
					["[2-9]0"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{5})",
					"$1 $2",
					["3[289]|4[246-8]|61|7[1-3]|8[1-36]"],
					"(0$1)"
				],
				[
					"(\\d{3})(\\d{4,5})",
					"$1 $2",
					["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["87"]
				],
				[
					"(\\d{3})(\\d{6})",
					"$1 $2",
					["9(?:[5-79]|8[1-7])"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[2-8]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["9"]
				]
			],
			"0"
		],
		"QA": [
			"974",
			"00",
			"800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
			[
				7,
				8,
				9,
				11
			],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["2[136]|8"]
			], [
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[3-7]"]
			]]
		],
		"RE": [
			"262",
			"00",
			"709\\d{6}|(?:26|[689]\\d)\\d{7}",
			[9],
			[[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[26-9]"],
				"0$1"
			]],
			"0",
			0,
			0,
			0,
			0,
			0,
			[
				["2631[0-6]\\d{4}|26(?:2\\d|30|88)\\d{5}"],
				["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"],
				["80\\d{7}"],
				["89[1-37-9]\\d{6}"],
				0,
				0,
				0,
				0,
				["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"],
				["8(?:1[019]|2[0156]|84|90)\\d{6}"]
			]
		],
		"RO": [
			"40",
			"00",
			"(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
			[6, 9],
			[
				[
					"(\\d{3})(\\d{3})",
					"$1 $2",
					["2[3-6]", "2[3-6]\\d9"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4})",
					"$1 $2",
					["219|31"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[23]1"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[236-9]"],
					"0$1"
				]
			],
			"0",
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			" int "
		],
		"RS": [
			"381",
			"00",
			"38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
			[
				6,
				7,
				8,
				9,
				10,
				11,
				12
			],
			[[
				"(\\d{3})(\\d{3,9})",
				"$1 $2",
				["(?:2[389]|39)0|[7-9]"],
				"0$1"
			], [
				"(\\d{2})(\\d{5,10})",
				"$1 $2",
				["[1-36]"],
				"0$1"
			]],
			"0"
		],
		"RU": [
			"7",
			"810",
			"8\\d{13}|[347-9]\\d{9}",
			[10, 14],
			[
				[
					"(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					[
						"7(?:1[0-8]|2[1-9])",
						"7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
						"7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
					],
					"8 ($1)",
					1
				],
				[
					"(\\d{5})(\\d)(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					[
						"7(?:1[0-68]|2[1-9])",
						"7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
						"7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
					],
					"8 ($1)",
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["7"],
					"8 ($1)",
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2-$3-$4",
					["[349]|8(?:[02-7]|1[1-8])"],
					"8 ($1)",
					1
				],
				[
					"(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["8"],
					"8 ($1)"
				]
			],
			"8",
			0,
			0,
			0,
			0,
			"[3489]",
			0,
			"8~10"
		],
		"RW": [
			"250",
			"00",
			"(?:06|[27]\\d\\d|[89]00)\\d{6}",
			[8, 9],
			[
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["0"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["2"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[7-9]"],
					"0$1"
				]
			],
			"0"
		],
		"SA": [
			"966",
			"00",
			"(?:[15]\\d|800|92)\\d{7}",
			[9, 10],
			[
				[
					"(\\d{4})(\\d{5})",
					"$1 $2",
					["9"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["1"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["5"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["8"]
				]
			],
			"0"
		],
		"SB": [
			"677",
			"0[01]",
			"[6-9]\\d{6}|[1-6]\\d{4}",
			[5, 7],
			[[
				"(\\d{2})(\\d{5})",
				"$1 $2",
				["6[89]|7|8[4-9]|9(?:[0-8]|9[0-8])"]
			]]
		],
		"SC": [
			"248",
			"010|0[0-2]",
			"(?:[2489]\\d|64)\\d{5}",
			[7],
			[[
				"(\\d)(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[246]|9[57]"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		"SD": [
			"249",
			"00",
			"[19]\\d{8}",
			[9],
			[[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				["[19]"],
				"0$1"
			]],
			"0"
		],
		"SE": [
			"46",
			"00",
			"(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
			[
				6,
				7,
				8,
				9,
				10,
				12
			],
			[
				[
					"(\\d{2})(\\d{2,3})(\\d{2})",
					"$1-$2 $3",
					["20"],
					"0$1",
					0,
					"$1 $2 $3"
				],
				[
					"(\\d{3})(\\d{4})",
					"$1-$2",
					["9(?:00|39|44|9)"],
					"0$1",
					0,
					"$1 $2"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})",
					"$1-$2 $3",
					["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],
					"0$1",
					0,
					"$1 $2 $3"
				],
				[
					"(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
					"$1-$2 $3 $4",
					["8"],
					"0$1",
					0,
					"$1 $2 $3 $4"
				],
				[
					"(\\d{3})(\\d{2,3})(\\d{2})",
					"$1-$2 $3",
					["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],
					"0$1",
					0,
					"$1 $2 $3"
				],
				[
					"(\\d{3})(\\d{2,3})(\\d{3})",
					"$1-$2 $3",
					["9(?:00|39|44)"],
					"0$1",
					0,
					"$1 $2 $3"
				],
				[
					"(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
					"$1-$2 $3 $4",
					["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],
					"0$1",
					0,
					"$1 $2 $3 $4"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1-$2 $3 $4",
					["10|7"],
					"0$1",
					0,
					"$1 $2 $3 $4"
				],
				[
					"(\\d)(\\d{3})(\\d{3})(\\d{2})",
					"$1-$2 $3 $4",
					["8"],
					"0$1",
					0,
					"$1 $2 $3 $4"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
					"$1-$2 $3 $4",
					["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],
					"0$1",
					0,
					"$1 $2 $3 $4"
				],
				[
					"(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
					"$1-$2 $3 $4",
					["9"],
					"0$1",
					0,
					"$1 $2 $3 $4"
				],
				[
					"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1-$2 $3 $4 $5",
					["[26]"],
					"0$1",
					0,
					"$1 $2 $3 $4 $5"
				]
			],
			"0"
		],
		"SG": [
			"65",
			"0[0-3]\\d",
			"(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
			[
				8,
				10,
				11
			],
			[
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["[369]|8(?:0[1-9]|[1-9])"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["8"]
				],
				[
					"(\\d{4})(\\d{4})(\\d{3})",
					"$1 $2 $3",
					["7"]
				],
				[
					"(\\d{4})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["1"]
				]
			]
		],
		"SH": [
			"290",
			"00",
			"(?:[256]\\d|8)\\d{3}",
			[4, 5],
			0,
			0,
			0,
			0,
			0,
			0,
			"[256]"
		],
		"SI": [
			"386",
			"00|10(?:22|66|88|99)",
			"[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
			[
				5,
				6,
				7,
				8
			],
			[
				[
					"(\\d{2})(\\d{3,6})",
					"$1 $2",
					["8[09]|9"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{5})",
					"$1 $2",
					["59|8"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[37][01]|4[013]|51|6"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[1-57]"],
					"(0$1)"
				]
			],
			"0",
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		"SJ": [
			"47",
			"00",
			"0\\d{4}|(?:[489]\\d|79)\\d{6}",
			[5, 8],
			0,
			0,
			0,
			0,
			0,
			0,
			"79"
		],
		"SK": [
			"421",
			"00",
			"[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
			[
				6,
				7,
				9
			],
			[
				[
					"(\\d)(\\d{2})(\\d{3,4})",
					"$1 $2 $3",
					["21"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{2,3})",
					"$1 $2 $3",
					["[3-5][1-8]1", "[3-5][1-8]1[67]"],
					"0$1"
				],
				[
					"(\\d)(\\d{3})(\\d{3})(\\d{2})",
					"$1 $2 $3 $4",
					["2"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[689]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[3-5]"],
					"0$1"
				]
			],
			"0"
		],
		"SL": [
			"232",
			"00",
			"(?:[237-9]\\d|66)\\d{6}",
			[8],
			[[
				"(\\d{2})(\\d{6})",
				"$1 $2",
				["[236-9]"],
				"(0$1)"
			]],
			"0"
		],
		"SM": [
			"378",
			"00",
			"(?:0549|[5-7]\\d)\\d{6}",
			[8, 10],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[5-7]"]
			], [
				"(\\d{4})(\\d{6})",
				"$1 $2",
				["0"]
			]],
			0,
			0,
			"([89]\\d{5})$",
			"0549$1"
		],
		"SN": [
			"221",
			"00",
			"(?:[378]\\d|93)\\d{7}",
			[9],
			[[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["8"]
			], [
				"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[379]"]
			]]
		],
		"SO": [
			"252",
			"00",
			"[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
			[
				6,
				7,
				8,
				9
			],
			[
				[
					"(\\d{2})(\\d{4})",
					"$1 $2",
					["8[125]"]
				],
				[
					"(\\d{6})",
					"$1",
					["[134]"]
				],
				[
					"(\\d)(\\d{6})",
					"$1 $2",
					["[15]|2[0-79]|3[0-46-8]|4[0-7]"]
				],
				[
					"(\\d{2})(\\d{5,7})",
					"$1 $2",
					["1|28|9[2-9]"]
				],
				[
					"(\\d)(\\d{7})",
					"$1 $2",
					["[267]|904"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[346-9]"]
				]
			],
			"0"
		],
		"SR": [
			"597",
			"00",
			"(?:[2-5]|[6-9]\\d)\\d{5}",
			[6, 7],
			[
				[
					"(\\d{2})(\\d{2})(\\d{2})",
					"$1-$2-$3",
					["56"]
				],
				[
					"(\\d{3})(\\d{3})",
					"$1-$2",
					["[2-5]"]
				],
				[
					"(\\d{3})(\\d{4})",
					"$1-$2",
					["[6-9]"]
				]
			]
		],
		"SS": [
			"211",
			"00",
			"[19]\\d{8}",
			[9],
			[[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[19]"],
				"0$1"
			]],
			"0"
		],
		"ST": [
			"239",
			"00",
			"(?:22|9\\d)\\d{5}",
			[7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[29]"]
			]]
		],
		"SV": [
			"503",
			"00",
			"[25-7]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
			[
				7,
				8,
				11
			],
			[
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					["[89]"]
				],
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["[25-7]"]
				],
				[
					"(\\d{3})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["[89]"]
				]
			]
		],
		"SX": [
			"1",
			"011",
			"7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"(5\\d{6})$|1",
			"721$1",
			0,
			"721"
		],
		"SY": [
			"963",
			"00",
			"[1-359]\\d{8}|[1-5]\\d{7}",
			[8, 9],
			[[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				["[1-4]|5[1-3]"],
				"0$1",
				1
			], [
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[59]"],
				"0$1",
				1
			]],
			"0"
		],
		"SZ": [
			"268",
			"00",
			"0800\\d{4}|(?:[237]\\d|900)\\d{6}",
			[8, 9],
			[[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[0237]"]
			], [
				"(\\d{5})(\\d{4})",
				"$1 $2",
				["9"]
			]]
		],
		"TA": [
			"290",
			"00",
			"8\\d{3}",
			[4],
			0,
			0,
			0,
			0,
			0,
			0,
			"8"
		],
		"TC": [
			"1",
			"011",
			"(?:[58]\\d\\d|649|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-479]\\d{6})$|1",
			"649$1",
			0,
			"649"
		],
		"TD": [
			"235",
			"00|16",
			"(?:22|[3689]\\d|77)\\d{6}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[236-9]"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"00"
		],
		"TG": [
			"228",
			"00",
			"[279]\\d{7}",
			[8],
			[[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[279]"]
			]]
		],
		"TH": [
			"66",
			"00[1-9]",
			"(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
			[
				8,
				9,
				10,
				13
			],
			[
				[
					"(\\d)(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["2"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[13-9]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["1"]
				]
			],
			"0"
		],
		"TJ": [
			"992",
			"810",
			"(?:[0-57-9]\\d|66)\\d{7}",
			[9],
			[
				[
					"(\\d{6})(\\d)(\\d{2})",
					"$1 $2 $3",
					["331", "3317"]
				],
				[
					"(\\d{3})(\\d{2})(\\d{4})",
					"$1 $2 $3",
					["44[02-479]|[34]7"]
				],
				[
					"(\\d{4})(\\d)(\\d{4})",
					"$1 $2 $3",
					["3(?:[1245]|3[12])"]
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["\\d"]
				]
			],
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"8~10"
		],
		"TK": [
			"690",
			"00",
			"[2-47]\\d{3,6}",
			[
				4,
				5,
				6,
				7
			]
		],
		"TL": [
			"670",
			"00",
			"7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
			[7, 8],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[2-489]|70"]
			], [
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["7"]
			]]
		],
		"TM": [
			"993",
			"810",
			"[1-7]\\d{7}",
			[8],
			[
				[
					"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
					"$1 $2-$3-$4",
					["12"],
					"(8 $1)"
				],
				[
					"(\\d{3})(\\d)(\\d{2})(\\d{2})",
					"$1 $2-$3-$4",
					["[1-5]"],
					"(8 $1)"
				],
				[
					"(\\d{2})(\\d{6})",
					"$1 $2",
					["[67]"],
					"8 $1"
				]
			],
			"8",
			0,
			0,
			0,
			0,
			0,
			0,
			"8~10"
		],
		"TN": [
			"216",
			"00",
			"[2-57-9]\\d{7}",
			[8],
			[[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[2-57-9]"]
			]]
		],
		"TO": [
			"676",
			"00",
			"(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
			[5, 7],
			[
				[
					"(\\d{2})(\\d{3})",
					"$1-$2",
					["[2-4]|50|6[09]|7[0-24-69]|8[05]"]
				],
				[
					"(\\d{4})(\\d{3})",
					"$1 $2",
					["0"]
				],
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					["[5-9]"]
				]
			]
		],
		"TR": [
			"90",
			"00",
			"4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
			[
				7,
				10,
				12,
				13
			],
			[
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["512|8[01589]|90"],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["5"],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["[24][1-8]|3[1-9]"],
					"(0$1)",
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{6,7})",
					"$1 $2 $3",
					["80"],
					"0$1",
					1
				]
			],
			"0"
		],
		"TT": [
			"1",
			"011",
			"(?:[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-46-8]\\d{6})$|1",
			"868$1",
			0,
			"868"
		],
		"TV": [
			"688",
			"00",
			"(?:2|7\\d\\d|90)\\d{4}",
			[
				5,
				6,
				7
			],
			[
				[
					"(\\d{2})(\\d{3})",
					"$1 $2",
					["2"]
				],
				[
					"(\\d{2})(\\d{4})",
					"$1 $2",
					["90"]
				],
				[
					"(\\d{2})(\\d{5})",
					"$1 $2",
					["7"]
				]
			]
		],
		"TW": [
			"886",
			"0(?:0[25-79]|19)",
			"[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
			[
				7,
				8,
				9,
				10,
				11
			],
			[
				[
					"(\\d{2})(\\d)(\\d{4})",
					"$1 $2 $3",
					["202"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{5})",
					"$1 $2",
					["826"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{2})(\\d{3})",
					"$1 $2 $3",
					["83"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{2})(\\d{4})",
					"$1 $2 $3",
					["82"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[25]0|37|49|8[09]"],
					"0$1"
				],
				[
					"(\\d)(\\d{3,4})(\\d{4})",
					"$1 $2 $3",
					["[23568]|4(?:0[02-48]|[1-478])|7[1-9]", "[23568]|4(?:0[2-48]|[1-478])|(?:400|7)[1-9]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[49]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{4})(\\d{4,5})",
					"$1 $2 $3",
					["7"],
					"0$1"
				]
			],
			"0",
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			"#"
		],
		"TZ": [
			"255",
			"00[056]",
			"(?:[25-8]\\d|41|90)\\d{7}",
			[9],
			[
				[
					"(\\d{3})(\\d{2})(\\d{4})",
					"$1 $2 $3",
					["[89]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[24]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{7})",
					"$1 $2",
					["5"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[67]"],
					"0$1"
				]
			],
			"0"
		],
		"UA": [
			"380",
			"00",
			"[89]\\d{9}|[3-9]\\d{8}",
			[9, 10],
			[
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{5})",
					"$1 $2",
					["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[3-7]|89|9[1-9]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["[89]"],
					"0$1"
				]
			],
			"0",
			0,
			0,
			0,
			0,
			0,
			0,
			"0~0"
		],
		"UG": [
			"256",
			"00[057]",
			"800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
			[9],
			[
				[
					"(\\d{4})(\\d{5})",
					"$1 $2",
					[
						"202",
						"2024",
						"20240"
					],
					"0$1"
				],
				[
					"(\\d{3})(\\d{6})",
					"$1 $2",
					["20[0-35-7]|4(?:6[45]|[7-9])|[7-9]", "20(?:[0135-7]|2[5-9])|4(?:6[45]|[7-9])|[7-9]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{7})",
					"$1 $2",
					["[2-4]"],
					"0$1"
				]
			],
			"0"
		],
		"US": [
			"1",
			"011",
			"[2-9]\\d{9}|3\\d{6}",
			[10],
			[[
				"(\\d{3})(\\d{4})",
				"$1-$2",
				["310"],
				0,
				1
			], [
				"(\\d{3})(\\d{3})(\\d{4})",
				"($1) $2-$3",
				["[2-9]"],
				0,
				1,
				"$1-$2-$3"
			]],
			"1",
			0,
			0,
			0,
			0,
			0,
			[
				["983[2-57-9]\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[02469]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-3]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[02589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-2478]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}"],
				[""],
				["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],
				["900[2-9]\\d{6}"],
				["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}"]
			]
		],
		"UY": [
			"598",
			"0(?:0|1[3-9]\\d)",
			"0004\\d{2,9}|[1249]\\d{7}|2\\d{3,4}|(?:[49]\\d|80)\\d{5}",
			[
				4,
				5,
				6,
				7,
				8,
				9,
				10,
				11,
				12,
				13
			],
			[
				[
					"(\\d{4,5})",
					"$1",
					["21"]
				],
				[
					"(\\d{3})(\\d{3,4})",
					"$1 $2",
					["0"]
				],
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					["[49]0|8"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["9"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{4})",
					"$1 $2",
					["[124]"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{2,4})",
					"$1 $2 $3",
					["0"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
					"$1 $2 $3 $4",
					["0"]
				]
			],
			"0",
			0,
			0,
			0,
			0,
			0,
			0,
			"00",
			" int. "
		],
		"UZ": [
			"998",
			"00",
			"(?:20|33|[5-9]\\d)\\d{7}",
			[9],
			[[
				"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["[235-9]"]
			]]
		],
		"VA": [
			"39",
			"00",
			"0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
			[
				6,
				7,
				8,
				9,
				10,
				11,
				12
			],
			0,
			0,
			0,
			0,
			0,
			0,
			"06698"
		],
		"VC": [
			"1",
			"011",
			"(?:[58]\\d\\d|784|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-7]\\d{6})$|1",
			"784$1",
			0,
			"784"
		],
		"VE": [
			"58",
			"00",
			"[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
			[10],
			[[
				"(\\d{3})(\\d{7})",
				"$1-$2",
				["[24-689]"],
				"0$1"
			]],
			"0"
		],
		"VG": [
			"1",
			"011",
			"(?:284|[58]\\d\\d|900)\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-578]\\d{6})$|1",
			"284$1",
			0,
			"284"
		],
		"VI": [
			"1",
			"011",
			"[58]\\d{9}|(?:34|90)0\\d{7}",
			[10],
			0,
			"1",
			0,
			"([2-9]\\d{6})$|1",
			"340$1",
			0,
			"340"
		],
		"VN": [
			"84",
			"00",
			"[12]\\d{9}|[135-9]\\d{8}|[16]\\d{6,7}|7\\d{6}",
			[
				7,
				8,
				9,
				10
			],
			[
				[
					"(\\d{4})(\\d{4,6})",
					"$1 $2",
					["1(?:2[02]|[89])"],
					0,
					1
				],
				[
					"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
					"$1 $2 $3 $4",
					["1[26]|6"],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[1357-9]"],
					"0$1",
					1
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["2[48]"],
					"0$1",
					1
				],
				[
					"(\\d{3})(\\d{4})(\\d{3})",
					"$1 $2 $3",
					["2"],
					"0$1",
					1
				]
			],
			"0"
		],
		"VU": [
			"678",
			"00",
			"[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
			[5, 7],
			[[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				["[57-9]"]
			]]
		],
		"WF": [
			"681",
			"00",
			"(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",
			[6, 9],
			[[
				"(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				["[47-9]"]
			], [
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				["8"]
			]]
		],
		"WS": [
			"685",
			"0",
			"(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
			[
				5,
				6,
				7,
				10
			],
			[
				[
					"(\\d{5})",
					"$1",
					["[2-5]|6[1-9]"]
				],
				[
					"(\\d{3})(\\d{3,7})",
					"$1 $2",
					["[68]"]
				],
				[
					"(\\d{2})(\\d{5})",
					"$1 $2",
					["7"]
				]
			]
		],
		"XK": [
			"383",
			"00",
			"2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
			[
				8,
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{3})(\\d{5})",
					"$1 $2",
					["[89]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["[2-4]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["2|39"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{7,10})",
					"$1 $2",
					["3"],
					"0$1"
				]
			],
			"0"
		],
		"YE": [
			"967",
			"00",
			"(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
			[
				7,
				8,
				9
			],
			[[
				"(\\d)(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				["[1-6]|7(?:[24-6]|8[0-7])"],
				"0$1"
			], [
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["7"],
				"0$1"
			]],
			"0"
		],
		"YT": [
			"262",
			"00",
			"(?:639\\d|7093)\\d{5}|(?:26|80|9\\d)\\d{7}",
			[9],
			0,
			"0",
			0,
			0,
			0,
			0,
			0,
			[
				["26(?:89\\d|9(?:0[0-467]|15|5[0-4]|6\\d|[78]0))\\d{4}"],
				["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"],
				["80\\d{7}"],
				0,
				0,
				0,
				0,
				0,
				["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]
			]
		],
		"ZA": [
			"27",
			"00",
			"[1-79]\\d{8}|8\\d{4,9}",
			[
				5,
				6,
				7,
				8,
				9,
				10
			],
			[
				[
					"(\\d{2})(\\d{3,4})",
					"$1 $2",
					["8[1-4]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{2,3})",
					"$1 $2 $3",
					["8[1-4]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["860"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["[1-9]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["8"],
					"0$1"
				]
			],
			"0"
		],
		"ZM": [
			"260",
			"00",
			"800\\d{6}|(?:21|[579]\\d|63)\\d{7}",
			[9],
			[[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[28]"],
				"0$1"
			], [
				"(\\d{2})(\\d{7})",
				"$1 $2",
				["[579]"],
				"0$1"
			]],
			"0"
		],
		"ZW": [
			"263",
			"00",
			"(?:13|8\\d{4})\\d{5}|[235-8]\\d{8}|[23568]\\d{6}",
			[
				7,
				9,
				10
			],
			[
				[
					"(\\d{2})(\\d{3,5})",
					"$1 $2",
					["1|2(?:0[0-36-9]|29|58)|67[0-46-9]|(?:55|68)[0-69]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3,5})",
					"$1 $2",
					["2(?:0[45]|[27]|48)|37|675|(?:55|68)[78]"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{4})",
					"$1 $2",
					["80"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{3,5})",
					"$1 $2",
					["548"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["29[013-9]"],
					"0$1"
				],
				[
					"(\\d{2})(\\d{7})",
					"$1 $2",
					["[256]|39|8[13-59]"],
					"(0$1)"
				],
				[
					"(\\d{2})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["7"],
					"0$1"
				],
				[
					"(\\d{3})(\\d{3})(\\d{3,4})",
					"$1 $2 $3",
					["3"],
					"0$1"
				],
				[
					"(\\d{4})(\\d{6})",
					"$1 $2",
					["8"],
					"0$1"
				]
			],
			"0"
		]
	},
	"nonGeographic": {
		"800": [
			"800",
			0,
			"(?:00|[1-9]\\d)\\d{6}",
			[8],
			[[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["\\d"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				0,
				0,
				["(?:00|[1-9]\\d)\\d{6}"]
			]
		],
		"808": [
			"808",
			0,
			"[1-9]\\d{7}",
			[8],
			[[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				["[1-9]"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				["[1-9]\\d{7}"]
			]
		],
		"870": [
			"870",
			0,
			"7\\d{11}|[235-7]\\d{8}",
			[9, 12],
			[[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				["[235-7]"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				0,
				["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"],
				0,
				0,
				0,
				0,
				0,
				0,
				["2\\d{8}", [9]]
			]
		],
		"878": [
			"878",
			0,
			"10\\d{10}",
			[12],
			[[
				"(\\d{2})(\\d{5})(\\d{5})",
				"$1 $2 $3",
				["1"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				["10\\d{10}"]
			]
		],
		"881": [
			"881",
			0,
			"6\\d{9}|[0-36-9]\\d{8}",
			[9, 10],
			[[
				"(\\d)(\\d{3})(\\d{5})",
				"$1 $2 $3",
				["[0-37-9]"]
			], [
				"(\\d)(\\d{3})(\\d{5,6})",
				"$1 $2 $3",
				["6"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			[0, ["6\\d{9}|[0-36-9]\\d{8}"]]
		],
		"882": [
			"882",
			0,
			"[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
			[
				7,
				8,
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{2})(\\d{5})",
					"$1 $2",
					["16|342"]
				],
				[
					"(\\d{2})(\\d{6})",
					"$1 $2",
					["49"]
				],
				[
					"(\\d{2})(\\d{2})(\\d{4})",
					"$1 $2 $3",
					["1[36]|9"]
				],
				[
					"(\\d{2})(\\d{4})(\\d{3})",
					"$1 $2 $3",
					["3[23]"]
				],
				[
					"(\\d{2})(\\d{3,4})(\\d{4})",
					"$1 $2 $3",
					["16"]
				],
				[
					"(\\d{2})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["10|23|3(?:[15]|4[57])|4|5[12]"]
				],
				[
					"(\\d{3})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["34"]
				],
				[
					"(\\d{2})(\\d{4,5})(\\d{5})",
					"$1 $2 $3",
					["[1-35]"]
				]
			],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				0,
				["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|5(?:0\\d{3}|2[0-2]))\\d{7}", [
					7,
					8,
					9,
					10,
					12
				]],
				0,
				0,
				0,
				["348[57]\\d{7}", [11]],
				0,
				0,
				["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]
			]
		],
		"883": [
			"883",
			0,
			"(?:[1-4]\\d|51)\\d{6,10}",
			[
				8,
				9,
				10,
				11,
				12
			],
			[
				[
					"(\\d{3})(\\d{3})(\\d{2,8})",
					"$1 $2 $3",
					["[14]|2[24-689]|3[02-689]|51[24-9]"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3",
					["510"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{4})",
					"$1 $2 $3",
					["21"]
				],
				[
					"(\\d{4})(\\d{4})(\\d{4})",
					"$1 $2 $3",
					["51[13]"]
				],
				[
					"(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
					"$1 $2 $3 $4",
					["[235]"]
				]
			],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]
			]
		],
		"888": [
			"888",
			0,
			"\\d{11}",
			[11],
			[["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				0,
				0,
				0,
				0,
				0,
				0,
				["\\d{11}"]
			]
		],
		"979": [
			"979",
			0,
			"[1359]\\d{8}",
			[9],
			[[
				"(\\d)(\\d{4})(\\d{4})",
				"$1 $2 $3",
				["[1359]"]
			]],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				0,
				0,
				0,
				["[1359]\\d{8}"]
			]
		]
	}
};
// ../../node_modules/libphonenumber-js/min/exports/withMetadataArgument.js
function withMetadataArgument(func, _arguments) {
	var args = Array.prototype.slice.call(_arguments);
	args.push(metadata_min_json_default);
	return func.apply(this, args);
}
// ../../node_modules/libphonenumber-js/es6/tools/semver-compare.js
function semver_compare_default(a, b) {
	a = a.split("-");
	b = b.split("-");
	var pa = a[0].split(".");
	var pb = b[0].split(".");
	for (var i = 0; i < 3; i++) {
		var na = Number(pa[i]);
		var nb = Number(pb[i]);
		if (na > nb) return 1;
		if (nb > na) return -1;
		if (!isNaN(na) && isNaN(nb)) return 1;
		if (isNaN(na) && !isNaN(nb)) return -1;
	}
	if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
	return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}
// ../../node_modules/libphonenumber-js/es6/helpers/isObject.js
var objectConstructor = {}.constructor;
function isObject(object) {
	return object !== void 0 && object !== null && object.constructor === objectConstructor;
}
// ../../node_modules/libphonenumber-js/es6/helpers/isCallingCode.js
var CALLING_CODE_REG_EXP = /^\d+$/;
function isCallingCode(string) {
	return CALLING_CODE_REG_EXP.test(string);
}
// ../../node_modules/libphonenumber-js/es6/metadata.js
function _typeof$5(o) {
	"@babel/helpers - typeof";
	return _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
		return typeof o;
	} : function(o) {
		return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	}, _typeof$5(o);
}
function _classCallCheck$2(a, n) {
	if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$2(e, r) {
	for (var t = 0; t < r.length; t++) {
		var o = r[t];
		o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey$5(o.key), o);
	}
}
function _createClass$2(e, r, t) {
	return r && _defineProperties$2(e.prototype, r), t && _defineProperties$2(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function _toPropertyKey$5(t) {
	var i = _toPrimitive$5(t, "string");
	return "symbol" == _typeof$5(i) ? i : i + "";
}
function _toPrimitive$5(t, r) {
	if ("object" != _typeof$5(t) || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != _typeof$5(i)) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
var V3 = "1.2.0";
var V4 = "1.7.35";
var DEFAULT_EXT_PREFIX = " ext. ";
/**
* See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
*/
var Metadata = /*#__PURE__*/ function() {
	/**
	* @param {object} metadata — Metadata JSON.
	*/
	function Metadata(metadata) {
		_classCallCheck$2(this, Metadata);
		validateMetadata(metadata);
		this.metadata = metadata;
		setVersion.call(this, metadata);
	}
	return _createClass$2(Metadata, [
		{
			key: "getCountries",
			value: function getCountries() {
				return Object.keys(this.metadata.countries).filter(function(_) {
					return _ !== "001";
				});
			}
		},
		{
			key: "getCountryMetadata",
			value: function getCountryMetadata(countryCode) {
				return this.metadata.countries[countryCode];
			}
		},
		{
			key: "nonGeographic",
			value: function nonGeographic() {
				if (this.v1 || this.v2 || this.v3) return;
				return this.metadata.nonGeographic || this.metadata.nonGeographical;
			}
		},
		{
			key: "hasCountry",
			value: function hasCountry(country) {
				return this.getCountryMetadata(country) !== void 0;
			}
		},
		{
			key: "hasCallingCode",
			value: function hasCallingCode(callingCode) {
				if (this.getCountryCodesForCallingCode(callingCode)) return true;
				if (this.nonGeographic()) {
					if (this.nonGeographic()[callingCode]) return true;
				} else {
					var countryCodes = this.countryCallingCodes()[callingCode];
					if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return true;
				}
			}
		},
		{
			key: "isNonGeographicCallingCode",
			value: function isNonGeographicCallingCode(callingCode) {
				if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
				else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
			}
		},
		{
			key: "country",
			value: function country(countryCode) {
				return this.selectNumberingPlan(countryCode);
			}
		},
		{
			key: "selectNumberingPlan",
			value: function selectNumberingPlan(argument, legacyArgumentCallingCode) {
				var countryCode;
				var callingCode;
				if (argument) {
					if (isCallingCode(argument)) callingCode = argument;
					else countryCode = argument;
				}
				if (legacyArgumentCallingCode) callingCode = legacyArgumentCallingCode;
				if (countryCode && countryCode !== "001") {
					var countryMetadata = this.getCountryMetadata(countryCode);
					if (!countryMetadata) throw new Error("Unknown country: ".concat(countryCode));
					this.numberingPlan = new NumberingPlan(countryMetadata, this);
				} else if (callingCode) {
					if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
					this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
				} else this.numberingPlan = void 0;
				return this;
			}
		},
		{
			key: "getCountryCodesForCallingCode",
			value: function getCountryCodesForCallingCode(callingCode) {
				var countryCodes = this.countryCallingCodes()[callingCode];
				if (countryCodes) {
					if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
					return countryCodes;
				}
			}
		},
		{
			key: "getCountryCodeForCallingCode",
			value: function getCountryCodeForCallingCode(callingCode) {
				var countryCodes = this.getCountryCodesForCallingCode(callingCode);
				if (countryCodes) return countryCodes[0];
			}
		},
		{
			key: "getNumberingPlanMetadata",
			value: function getNumberingPlanMetadata(callingCode) {
				var countryCode = this.getCountryCodeForCallingCode(callingCode);
				if (countryCode) return this.getCountryMetadata(countryCode);
				if (this.nonGeographic()) {
					var metadata = this.nonGeographic()[callingCode];
					if (metadata) return metadata;
				} else {
					var countryCodes = this.countryCallingCodes()[callingCode];
					if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return this.metadata.countries["001"];
				}
			}
		},
		{
			key: "countryCallingCode",
			value: function countryCallingCode() {
				return this.numberingPlan.callingCode();
			}
		},
		{
			key: "IDDPrefix",
			value: function IDDPrefix() {
				return this.numberingPlan.IDDPrefix();
			}
		},
		{
			key: "defaultIDDPrefix",
			value: function defaultIDDPrefix() {
				return this.numberingPlan.defaultIDDPrefix();
			}
		},
		{
			key: "nationalNumberPattern",
			value: function nationalNumberPattern() {
				return this.numberingPlan.nationalNumberPattern();
			}
		},
		{
			key: "possibleLengths",
			value: function possibleLengths() {
				return this.numberingPlan.possibleLengths();
			}
		},
		{
			key: "formats",
			value: function formats() {
				return this.numberingPlan.formats();
			}
		},
		{
			key: "nationalPrefixForParsing",
			value: function nationalPrefixForParsing() {
				return this.numberingPlan.nationalPrefixForParsing();
			}
		},
		{
			key: "nationalPrefixTransformRule",
			value: function nationalPrefixTransformRule() {
				return this.numberingPlan.nationalPrefixTransformRule();
			}
		},
		{
			key: "leadingDigits",
			value: function leadingDigits() {
				return this.numberingPlan.leadingDigits();
			}
		},
		{
			key: "hasTypes",
			value: function hasTypes() {
				return this.numberingPlan.hasTypes();
			}
		},
		{
			key: "type",
			value: function type(_type) {
				return this.numberingPlan.type(_type);
			}
		},
		{
			key: "ext",
			value: function ext() {
				return this.numberingPlan.ext();
			}
		},
		{
			key: "countryCallingCodes",
			value: function countryCallingCodes() {
				if (this.v1) return this.metadata.country_phone_code_to_countries;
				return this.metadata.country_calling_codes;
			}
		},
		{
			key: "chooseCountryByCountryCallingCode",
			value: function chooseCountryByCountryCallingCode(callingCode) {
				return this.selectNumberingPlan(callingCode);
			}
		},
		{
			key: "hasSelectedNumberingPlan",
			value: function hasSelectedNumberingPlan() {
				return this.numberingPlan !== void 0;
			}
		}
	]);
}();
var NumberingPlan = /*#__PURE__*/ function() {
	function NumberingPlan(metadata, globalMetadataObject) {
		_classCallCheck$2(this, NumberingPlan);
		this.globalMetadataObject = globalMetadataObject;
		this.metadata = metadata;
		setVersion.call(this, globalMetadataObject.metadata);
	}
	return _createClass$2(NumberingPlan, [
		{
			key: "callingCode",
			value: function callingCode() {
				return this.metadata[0];
			}
		},
		{
			key: "_getDefaultCountryMetadataForThisCallingCode",
			value: function _getDefaultCountryMetadataForThisCallingCode() {
				return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
			}
		},
		{
			key: "getDefaultCountryMetadataForRegion",
			value: function getDefaultCountryMetadataForRegion() {
				return this._getDefaultCountryMetadataForThisCallingCode();
			}
		},
		{
			key: "IDDPrefix",
			value: function IDDPrefix() {
				if (this.v1 || this.v2) return;
				return this.metadata[1];
			}
		},
		{
			key: "defaultIDDPrefix",
			value: function defaultIDDPrefix() {
				if (this.v1 || this.v2) return;
				return this.metadata[12];
			}
		},
		{
			key: "nationalNumberPattern",
			value: function nationalNumberPattern() {
				if (this.v1 || this.v2) return this.metadata[1];
				return this.metadata[2];
			}
		},
		{
			key: "possibleLengths",
			value: function possibleLengths() {
				if (this.v1) return;
				return this.metadata[this.v2 ? 2 : 3];
			}
		},
		{
			key: "_getFormats",
			value: function _getFormats(metadata) {
				return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
			}
		},
		{
			key: "formats",
			value: function formats() {
				var _this = this;
				return (this._getFormats(this.metadata) || this._getFormats(this._getDefaultCountryMetadataForThisCallingCode()) || []).map(function(_) {
					return new Format(_, _this);
				});
			}
		},
		{
			key: "nationalPrefix",
			value: function nationalPrefix() {
				return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
			}
		},
		{
			key: "_getNationalPrefixFormattingRule",
			value: function _getNationalPrefixFormattingRule(metadata) {
				return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
			}
		},
		{
			key: "nationalPrefixFormattingRule",
			value: function nationalPrefixFormattingRule() {
				return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this._getDefaultCountryMetadataForThisCallingCode());
			}
		},
		{
			key: "_nationalPrefixForParsing",
			value: function _nationalPrefixForParsing() {
				return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
			}
		},
		{
			key: "nationalPrefixForParsing",
			value: function nationalPrefixForParsing() {
				return this._nationalPrefixForParsing() || this.nationalPrefix();
			}
		},
		{
			key: "nationalPrefixTransformRule",
			value: function nationalPrefixTransformRule() {
				return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
			}
		},
		{
			key: "_getNationalPrefixIsOptionalWhenFormatting",
			value: function _getNationalPrefixIsOptionalWhenFormatting() {
				return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
			}
		},
		{
			key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
			value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
				return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this._getDefaultCountryMetadataForThisCallingCode());
			}
		},
		{
			key: "leadingDigits",
			value: function leadingDigits() {
				return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
			}
		},
		{
			key: "types",
			value: function types() {
				return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
			}
		},
		{
			key: "hasTypes",
			value: function hasTypes() {
				/* istanbul ignore next */
				if (this.types() && this.types().length === 0) return false;
				return !!this.types();
			}
		},
		{
			key: "type",
			value: function type(_type2) {
				if (this.hasTypes() && getType(this.types(), _type2)) return new Type(getType(this.types(), _type2), this);
			}
		},
		{
			key: "ext",
			value: function ext() {
				if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
				return this.metadata[13] || DEFAULT_EXT_PREFIX;
			}
		}
	]);
}();
var Format = /*#__PURE__*/ function() {
	function Format(format, metadata) {
		_classCallCheck$2(this, Format);
		this._format = format;
		this.metadata = metadata;
	}
	return _createClass$2(Format, [
		{
			key: "pattern",
			value: function pattern() {
				return this._format[0];
			}
		},
		{
			key: "format",
			value: function format() {
				return this._format[1];
			}
		},
		{
			key: "leadingDigitsPatterns",
			value: function leadingDigitsPatterns() {
				return this._format[2] || [];
			}
		},
		{
			key: "nationalPrefixFormattingRule",
			value: function nationalPrefixFormattingRule() {
				return this._format[3] || this.metadata.nationalPrefixFormattingRule();
			}
		},
		{
			key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
			value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
				return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
			}
		},
		{
			key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
			value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
				return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
			}
		},
		{
			key: "usesNationalPrefix",
			value: function usesNationalPrefix() {
				return this.nationalPrefixFormattingRule() && !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) ? true : false;
			}
		},
		{
			key: "internationalFormat",
			value: function internationalFormat() {
				return this._format[5] || this.format();
			}
		}
	]);
}();
/**
* A pattern that is used to determine if the national prefix formatting rule
* has the first group only, i.e., does not start with the national prefix.
* Note that the pattern explicitly allows for unbalanced parentheses.
*/
var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var Type = /*#__PURE__*/ function() {
	function Type(type, metadata) {
		_classCallCheck$2(this, Type);
		this.type = type;
		this.metadata = metadata;
	}
	return _createClass$2(Type, [{
		key: "pattern",
		value: function pattern() {
			if (this.metadata.v1) return this.type;
			return this.type[0];
		}
	}, {
		key: "possibleLengths",
		value: function possibleLengths() {
			if (this.metadata.v1) return;
			return this.type[1] || this.metadata.possibleLengths();
		}
	}]);
}();
function getType(types, type) {
	switch (type) {
		case "FIXED_LINE": return types[0];
		case "MOBILE": return types[1];
		case "TOLL_FREE": return types[2];
		case "PREMIUM_RATE": return types[3];
		case "PERSONAL_NUMBER": return types[4];
		case "VOICEMAIL": return types[5];
		case "UAN": return types[6];
		case "PAGER": return types[7];
		case "VOIP": return types[8];
		case "SHARED_COST": return types[9];
	}
}
function validateMetadata(metadata) {
	if (!metadata) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
	if (!isObject(metadata) || !isObject(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject(metadata) ? "an object of shape: { " + Object.keys(metadata).join(", ") + " }" : "a " + typeOf(metadata) + ": " + metadata, "."));
}
/* istanbul ignore next */
var typeOf = function typeOf(_) {
	return _typeof$5(_);
};
/**
* Returns "country calling code" for a country.
* Throws an error if the country doesn't exist or isn't supported by this library.
* @param  {string} country
* @param  {object} metadataJson
* @return {string}
* @example
* // Returns "44"
* getCountryCallingCode("GB")
*/
function getCountryCallingCode(country, metadataJson) {
	var metadata = new Metadata(metadataJson);
	if (metadata.hasCountry(country)) return metadata.selectNumberingPlan(country).countryCallingCode();
	throw new Error("Unknown country: ".concat(country));
}
/**
* Tells if a country code is supported.
* @param  {string} country
* @param  {object} metadataJson
* @return {boolean}
* @example
* // Returns `true`
* isSupportedCountry("GB")
*/
function isSupportedCountry(country, metadataJson) {
	return metadataJson.countries.hasOwnProperty(country);
}
/**
* Sets `v1`/`v2`/`v3`/`v4` properties on `this` object.
* @param {object} metadata — Metadata JSON
*/
function setVersion(metadata) {
	var version = metadata.version;
	if (typeof version === "number") {
		this.v1 = version === 1;
		this.v2 = version === 2;
		this.v3 = version === 3;
		this.v4 = version === 4;
	} else if (!version) this.v1 = true;
	else if (semver_compare_default(version, V3) === -1) this.v2 = true;
	else if (semver_compare_default(version, V4) === -1) this.v3 = true;
	else this.v4 = true;
}
// ../../node_modules/libphonenumber-js/es6/helpers/mergeArrays.js
function _createForOfIteratorHelperLoose$3(r, e) {
	var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
	if (t) return (t = t.call(r)).next.bind(t);
	if (Array.isArray(r) || (t = _unsupportedIterableToArray$4(r)) || e && r && "number" == typeof r.length) {
		t && (r = t);
		var o = 0;
		return function() {
			return o >= r.length ? { done: !0 } : {
				done: !1,
				value: r[o++]
			};
		};
	}
	throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$4(r, a) {
	if (r) {
		if ("string" == typeof r) return _arrayLikeToArray$4(r, a);
		var t = {}.toString.call(r).slice(8, -1);
		return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$4(r, a) : void 0;
	}
}
function _arrayLikeToArray$4(r, a) {
	(null == a || a > r.length) && (a = r.length);
	for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
	return n;
}
/**
* Merges two arrays.
* @param  {*} a
* @param  {*} b
* @return {*}
*/
function mergeArrays(a, b) {
	var merged = a.slice();
	for (var _iterator = _createForOfIteratorHelperLoose$3(b), _step; !(_step = _iterator()).done;) {
		var element = _step.value;
		if (a.indexOf(element) < 0) merged.push(element);
	}
	return merged.sort(function(a, b) {
		return a - b;
	});
}
// ../../node_modules/libphonenumber-js/es6/helpers/checkNumberLength.js
/**
* Checks phone number length against the phone numbering plan selected in metadata.
* Optionally, it could be restrained by a specific country.
* @param {string} nationalNumber
* @param {string?} country — Specific country to use rather than the one that is pre-selected in the metadata instance.
* @param {Metadata} metadata — Metadata instance with a selected numbering plan.
* @returns {string}
*/
function checkNumberLength(nationalNumber, country, metadata) {
	return checkNumberLengthForType(nationalNumber, void 0, country, metadata);
}
/**
* Checks phone number length against the phone numbering plan selected in metadata.
* Optionally, it could be restrained by a specific phone number type or a specific country.
* @param {string} nationalNumber
* @param {string?} type — Specific phone number type.
* @param {string?} country — Specific country to use instead of the one that is pre-selected in the metadata instance.
* @param {Metadata} metadata — Metadata instance with a selected numbering plan.
* @returns {string} See the README on `validatePhoneNumberLength()` function, with an addition of a special case: when phone numbers of type `type` aren't possible in the telephone numbering plan, it will return "INVALID_LENGTH".
*/
function checkNumberLengthForType(nationalNumber, type, country, metadata) {
	if (country) {
		metadata = new Metadata(metadata.metadata);
		metadata.selectNumberingPlan(country);
	}
	var type_info = metadata.type(type);
	var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths();
	if (!possible_lengths) return "IS_POSSIBLE";
	if (type === "FIXED_LINE_OR_MOBILE") {
		/* istanbul ignore next */
		if (!metadata.type("FIXED_LINE")) return checkNumberLengthForType(nationalNumber, "MOBILE", country, metadata);
		var mobile_type = metadata.type("MOBILE");
		if (mobile_type) possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths());
	} else if (type && !type_info) return "INVALID_LENGTH";
	var actual_length = nationalNumber.length;
	var minimum_length = possible_lengths[0];
	if (minimum_length === actual_length) return "IS_POSSIBLE";
	if (minimum_length > actual_length) return "TOO_SHORT";
	if (possible_lengths[possible_lengths.length - 1] < actual_length) return "TOO_LONG";
	return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
// ../../node_modules/libphonenumber-js/es6/isPossible.js
/**
* Checks if a phone number is "possible" (basically just checks its length).
*
* isPossible(phoneNumberInstance, { ..., v2: true }, metadata)
*
* isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
* isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
*
* @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
* @param  {object} [options]
* @param  {object} metadataJson
* @return {string}
*/
function isPossiblePhoneNumber(input, options, metadataJson) {
	/* istanbul ignore if */
	if (options === void 0) options = {};
	var metadata = new Metadata(metadataJson);
	if (options.v2) {
		if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
		metadata.selectNumberingPlan(input.country || input.countryCallingCode);
	} else {
		if (!input.phone) return false;
		if (input.country) {
			if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
			metadata.selectNumberingPlan(input.country);
		} else {
			if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
			metadata.selectNumberingPlan(input.countryCallingCode);
		}
	}
	if (metadata.possibleLengths()) return isPossibleNumber(input.phone || input.nationalNumber, metadata);
	if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) return true;
	throw new Error("Missing \"possibleLengths\" in metadata. Perhaps the metadata has been generated before v1.0.18.");
}
/**
* Tells if a given national (significant) number is possible
* @param {string} nationalNumber
* @param {Metadata} metadata = Metadata instance with a pre-selected telephone numbering plan.
* @returns {boolean}
*/
function isPossibleNumber(nationalNumber, metadata) {
	switch (checkNumberLength(nationalNumber, void 0, metadata)) {
		case "IS_POSSIBLE": return true;
		default: return false;
	}
}
// ../../node_modules/libphonenumber-js/es6/helpers/matchesEntirely.js
/**
* Checks whether the entire input sequence can be matched
* against the regular expression.
* @return {boolean}
*/
function matchesEntirely(text, regularExpressionText) {
	text = text || "";
	return new RegExp("^(?:" + regularExpressionText + ")$").test(text);
}
// ../../node_modules/libphonenumber-js/es6/helpers/getNumberType.js
function _createForOfIteratorHelperLoose$2(r, e) {
	var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
	if (t) return (t = t.call(r)).next.bind(t);
	if (Array.isArray(r) || (t = _unsupportedIterableToArray$3(r)) || e && r && "number" == typeof r.length) {
		t && (r = t);
		var o = 0;
		return function() {
			return o >= r.length ? { done: !0 } : {
				done: !1,
				value: r[o++]
			};
		};
	}
	throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$3(r, a) {
	if (r) {
		if ("string" == typeof r) return _arrayLikeToArray$3(r, a);
		var t = {}.toString.call(r).slice(8, -1);
		return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$3(r, a) : void 0;
	}
}
function _arrayLikeToArray$3(r, a) {
	(null == a || a > r.length) && (a = r.length);
	for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
	return n;
}
var NON_FIXED_LINE_PHONE_TYPES = [
	"MOBILE",
	"PREMIUM_RATE",
	"TOLL_FREE",
	"SHARED_COST",
	"VOIP",
	"PERSONAL_NUMBER",
	"PAGER",
	"UAN",
	"VOICEMAIL"
];
function getNumberType(input, options, metadataJson) {
	options = options || {};
	if (!input.country && !input.countryCallingCode) return;
	var metadata = new Metadata(metadataJson);
	metadata.selectNumberingPlan(input.country || input.countryCallingCode);
	var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
	if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) return;
	if (isNumberTypeEqualTo(nationalNumber, "FIXED_LINE", metadata)) {
		if (metadata.type("MOBILE") && metadata.type("MOBILE").pattern() === "") return "FIXED_LINE_OR_MOBILE";
		if (!metadata.type("MOBILE")) return "FIXED_LINE_OR_MOBILE";
		/* istanbul ignore if */
		if (isNumberTypeEqualTo(nationalNumber, "MOBILE", metadata)) return "FIXED_LINE_OR_MOBILE";
		return "FIXED_LINE";
	}
	for (var _iterator = _createForOfIteratorHelperLoose$2(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;) {
		var type = _step.value;
		if (isNumberTypeEqualTo(nationalNumber, type, metadata)) return type;
	}
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
	var typeDefinition = metadata.type(type);
	if (!typeDefinition || !typeDefinition.pattern()) return false;
	if (typeDefinition.possibleLengths() && typeDefinition.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
	return matchesEntirely(nationalNumber, typeDefinition.pattern());
}
// ../../node_modules/libphonenumber-js/es6/isValid.js
/**
* Checks if a given phone number is valid.
*
* isValid(phoneNumberInstance, { ..., v2: true }, metadata)
*
* isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
* isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
*
* If the `number` is a string, it will be parsed to an object,
* but only if it contains only valid phone number characters (including punctuation).
* If the `number` is an object, it is used as is.
*
* The optional `defaultCountry` argument is the default country.
* I.e. it does not restrict to just that country,
* e.g. in those cases where several countries share
* the same phone numbering rules (NANPA, Britain, etc).
* For example, even though the number `07624 369230`
* belongs to the Isle of Man ("IM" country code)
* calling `isValidNumber('07624369230', 'GB', metadata)`
* still returns `true` because the country is not restricted to `GB`,
* it's just that `GB` is the default one for the phone numbering rules.
* For restricting the country see `isValidNumberForRegion()`
* though restricting a country might not be a good idea.
* https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
*
* Examples:
*
* ```js
* isValidNumber('+78005553535', metadata)
* isValidNumber('8005553535', 'RU', metadata)
* isValidNumber('88005553535', 'RU', metadata)
* isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
* ```
*/
function isValidNumber(input, options, metadataJson) {
	options = options || {};
	var metadata = new Metadata(metadataJson);
	metadata.selectNumberingPlan(input.country || input.countryCallingCode);
	if (metadata.hasTypes()) return getNumberType(input, options, metadata.metadata) !== void 0;
	return matchesEntirely(options.v2 ? input.nationalNumber : input.phone, metadata.nationalNumberPattern());
}
// ../../node_modules/libphonenumber-js/es6/helpers/isCountryCode.js
var COUNTRY_CODE_REG_EXP = /^[A-Z]{2}$/;
function isCountryCode(string) {
	return COUNTRY_CODE_REG_EXP.test(string);
}
// ../../node_modules/libphonenumber-js/es6/helpers/getCountryAndCallingCodeFromOneOfThem.js
var USE_NON_GEOGRAPHIC_COUNTRY_CODE$2 = false;
function getCountryAndCallingCodeFromOneOfThem(countryOrCallingCode, metadataJson) {
	var country;
	var callingCode;
	var metadata = new Metadata(metadataJson);
	if (isCountryCode(countryOrCallingCode)) {
		country = countryOrCallingCode;
		metadata.selectNumberingPlan(country);
		callingCode = metadata.countryCallingCode();
	} else {
		callingCode = countryOrCallingCode;
		/* istanbul ignore if */
		if (USE_NON_GEOGRAPHIC_COUNTRY_CODE$2) {
			if (metadata.isNonGeographicCallingCode(callingCode)) country = "001";
		}
	}
	return {
		country,
		callingCode
	};
}
// ../../node_modules/libphonenumber-js/es6/helpers/getPossibleCountriesForNumber.js
/**
* Returns a list of countries that the phone number could potentially belong to.
* @param  {string} callingCode — Calling code.
* @param  {string} nationalNumber — National (significant) number.
* @param  {object} metadata — Metadata.
* @return {string[]} A list of possible countries.
*/
function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata) {
	var possibleCountries = new Metadata(metadata).getCountryCodesForCallingCode(callingCode);
	if (!possibleCountries) return [];
	return possibleCountries.filter(function(country) {
		return couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
	});
}
function couldNationalNumberBelongToCountry(nationalNumber, country, metadataJson) {
	var metadata = new Metadata(metadataJson);
	metadata.selectNumberingPlan(country);
	return metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0;
}
// ../../node_modules/libphonenumber-js/es6/constants.js
var VALID_DIGITS = "0-9０-９٠-٩۰-۹";
var VALID_PUNCTUATION = "".concat("-‐-―−ー－").concat("／/").concat("．.").concat(" \xA0­​⁠　").concat("()（）［］\\[\\]").concat("~⁓∼～");
var PLUS_CHARS = "+＋";
// ../../node_modules/libphonenumber-js/es6/helpers/stripIddPrefix.js
var CAPTURING_DIGIT_PATTERN = new RegExp("([" + VALID_DIGITS + "])");
function stripIddPrefix(number, country, callingCode, metadataJson) {
	if (!country) return;
	var metadata = new Metadata(metadataJson);
	metadata.selectNumberingPlan(country || callingCode);
	var IDDPrefixPattern = new RegExp(metadata.IDDPrefix());
	if (number.search(IDDPrefixPattern) !== 0) return;
	number = number.slice(number.match(IDDPrefixPattern)[0].length);
	var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);
	if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
		if (matchedGroups[1] === "0") return;
	}
	return number;
}
// ../../node_modules/libphonenumber-js/es6/helpers/extractNationalNumberFromPossiblyIncompleteNumber.js
/**
* Strips any national prefix (such as 0, 1) present in a
* (possibly incomplete) number provided.
* "Carrier codes" are only used  in Colombia and Brazil,
* and only when dialing within those countries from a mobile phone to a fixed line number.
* Sometimes it won't actually strip national prefix
* and will instead prepend some digits to the `number`:
* for example, when number `2345678` is passed with `VI` country selected,
* it will return `{ number: "3402345678" }`, because `340` area code is prepended.
* @param {string} number — National number digits.
* @param {object} metadata — Metadata with country selected.
* @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
*/
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
	if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
		var prefixPattern = new RegExp("^(?:" + metadata.numberingPlan.nationalPrefixForParsing() + ")");
		var prefixMatch = prefixPattern.exec(number);
		if (prefixMatch) {
			var nationalNumber;
			var carrierCode;
			var capturedGroupsCount = prefixMatch.length - 1;
			var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
			if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
				nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule());
				if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
			} else {
				var prefixBeforeNationalNumber = prefixMatch[0];
				nationalNumber = number.slice(prefixBeforeNationalNumber.length);
				if (hasCapturedGroups) carrierCode = prefixMatch[1];
			}
			var nationalPrefix;
			if (hasCapturedGroups) {
				var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
				if (number.slice(0, possiblePositionOfTheFirstCapturedGroup) === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
			} else nationalPrefix = prefixMatch[0];
			return {
				nationalNumber,
				nationalPrefix,
				carrierCode
			};
		}
	}
	return { nationalNumber: number };
}
// ../../node_modules/libphonenumber-js/es6/helpers/getCountryByNationalNumber.js
function _createForOfIteratorHelperLoose$1(r, e) {
	var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
	if (t) return (t = t.call(r)).next.bind(t);
	if (Array.isArray(r) || (t = _unsupportedIterableToArray$2(r)) || e && r && "number" == typeof r.length) {
		t && (r = t);
		var o = 0;
		return function() {
			return o >= r.length ? { done: !0 } : {
				done: !1,
				value: r[o++]
			};
		};
	}
	throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$2(r, a) {
	if (r) {
		if ("string" == typeof r) return _arrayLikeToArray$2(r, a);
		var t = {}.toString.call(r).slice(8, -1);
		return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$2(r, a) : void 0;
	}
}
function _arrayLikeToArray$2(r, a) {
	(null == a || a > r.length) && (a = r.length);
	for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
	return n;
}
/**
* Returns the exact country that a given national (significant) number belongs to
* in case of ambiguity, i.e. when multiple countries share the same "country calling code".
* @param {string} [nationalNumber]
* @param {string[]} countries — A list of countries that share the same calling code.
* @param {object} metadata — Metadata JSON.
* @returns {string?} Returns the exact country this number belongs to, or `undefined` if the exact country couldn't be determined.
*/
function getCountryByNationalNumber(nationalNumber, countries, metadataJson) {
	var metadata = new Metadata(metadataJson);
	for (var _iterator = _createForOfIteratorHelperLoose$1(countries), _step; !(_step = _iterator()).done;) {
		var country = _step.value;
		metadata.selectNumberingPlan(country);
		if (metadata.leadingDigits()) {
			if (nationalNumber && nationalNumber.search(metadata.leadingDigits()) === 0) return country;
		} else if (getNumberType({
			phone: nationalNumber,
			country
		}, void 0, metadata.metadata)) return country;
	}
}
// ../../node_modules/libphonenumber-js/es6/helpers/getCountryByCallingCode.js
var USE_NON_GEOGRAPHIC_COUNTRY_CODE$1 = false;
/**
* Returns the exact country that a given national (significant) number belongs to
* in case of ambiguity, i.e. when multiple countries share the same "country calling code".
* @param {string} [callingCode]
* @param {string} [options.nationalNumber] — National (significant) number.
* @param {Metadata} options.metadata — Metadata instance.
* @returns {string?} Returns the most suitable country for this calling code and national (significant) number.
*/
function getCountryByCallingCode(callingCode, _ref) {
	var nationalNumber = _ref.nationalNumber, metadata = _ref.metadata;
	/* istanbul ignore if */
	if (USE_NON_GEOGRAPHIC_COUNTRY_CODE$1) {
		if (metadata.isNonGeographicCallingCode(callingCode)) return "001";
	}
	var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
	if (!possibleCountries) return;
	if (possibleCountries.length === 1) return possibleCountries[0];
	return getCountryByNationalNumber(nationalNumber, possibleCountries, metadata.metadata);
}
// ../../node_modules/libphonenumber-js/es6/helpers/extractNationalNumber.js
/**
* Strips national prefix and carrier code from a complete phone number.
* The difference from the non-"FromCompleteNumber" function is that
* it won't extract national prefix if the resultant number is too short
* to be a complete number for the selected phone numbering plan.
* @param  {string} number — Complete phone number digits.
* @param  {string?} country — Specific country to use instead of the one that is pre-selected in the metadata instance.
* @param  {Metadata} metadata — Metadata instance with a selected numbering plan.
* @return {object} `{ nationalNumber: string, carrierCode: string? }`.
*/
function extractNationalNumber(number, country, metadata) {
	var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
	if (nationalNumber !== number) {
		if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) return { nationalNumber: number };
		if (metadata.numberingPlan.possibleLengths()) {
			if (!country) country = getCountryByCallingCode(metadata.numberingPlan.callingCode(), {
				nationalNumber,
				metadata
			});
			if (!isPossibleIncompleteNationalNumber(nationalNumber, country, metadata)) return { nationalNumber: number };
		}
	}
	return {
		nationalNumber,
		carrierCode
	};
}
function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
	if (matchesEntirely(nationalNumberBefore, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
	return true;
}
/**
* Tells if a given incomplete national number is possible or not.
* @param {string} nationalNumber
* @param {string?} country — Specific country rather than the one that is pre-selected in the metadata instance.
* @param {Metadata} metadata — Metadata instance with a selected numbering plan.
* @returns {boolean}
*/
function isPossibleIncompleteNationalNumber(nationalNumber, country, metadata) {
	switch (checkNumberLength(nationalNumber, country, metadata)) {
		case "TOO_SHORT":
		case "INVALID_LENGTH": return false;
		default: return true;
	}
}
// ../../node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js
/**
* Sometimes some people incorrectly input international phone numbers
* without the leading `+`. This function corrects such input.
* @param  {string} number — Phone number digits (only digits, no `+`).
* @param  {string} [country] — Exact country of the phone number.
* @param  {string} [defaultCountry]
* @param  {string} [defaultCallingCode]
* @param  {object} metadataJson
* @return {object} `{ countryCallingCode: string?, number: string }`, where `countryCallingCode` is the calling code that was extracted from the input `number` string, and `number` is the originally passed `number` without the extracted calling code.
*/
function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, defaultCountry, defaultCallingCode, metadataJson) {
	if (!(country || defaultCountry || defaultCallingCode)) return { number };
	var countryCallingCode = country || defaultCountry ? getCountryCallingCode(country || defaultCountry, metadataJson) : defaultCallingCode;
	if (number.indexOf(countryCallingCode) === 0) {
		var metadata = new Metadata(metadataJson);
		metadata.selectNumberingPlan(country || defaultCountry || defaultCallingCode);
		var possibleShorterNumber = number.slice(countryCallingCode.length);
		var possibleShorterNationalNumber = extractNationalNumber(possibleShorterNumber, void 0, metadata).nationalNumber;
		var nationalNumber = extractNationalNumber(number, void 0, metadata).nationalNumber;
		if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, void 0, metadata) === "TOO_LONG") return {
			countryCallingCode,
			number: possibleShorterNumber
		};
	}
	return { number };
}
// ../../node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCode.js
/**
* Attempts to extract a calling code from a phone number.
* * If the phone number is found to be "international":
*   * It will attempt to identify the calling code part of it and whether that part is complete and valid.
*     * If the calling code part is complete and valid, it will return two properties:
*       that calling code part (without `+`) and the rest of the digits.
*     * Otherwise, i.e. if the calling code part is incomplete or invalid,
*       it will return an empty object.
* * Otherwise, i.e. if the phone number is national, there's no callind code to extract
*   so it will just return the originally-passed `number` string as the only property.
* @param  {string} number — Phone number digits (possibly with a `+`).
* @param  {string} [country] — Country.
* @param  {string} [defaultCountry] — Default country.
* @param  {string} [defaultCallingCode] — Default calling code (some phone numbering plans are non-geographic).
* @param  {object} metadataJson
* @return {object} `{ countryCallingCodeSource: string?, countryCallingCode: string?, number: string }`, where `countryCallingCodeSource` tells how the returned calling code was extracted (if it was extracted), `countryCallingCode` is the calling code that was extracted from the input `number` string, and `number` is the originally passed `number` without the extracted calling code (and without a `+`). If the calling code is present but incomplete or invalid, it will return an empty object.
* @example
* // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
* extractCountryCallingCode('2133734253', 'US', null, null, metadata)
* extractCountryCallingCode('2133734253', null, 'US', null, metadata)
* extractCountryCallingCode('2133734253', null, null, '1', metadata)
* extractCountryCallingCode('+12133734253', null, null, null, metadata)
* extractCountryCallingCode('+12133734253', null, 'RU', null, metadata)
*/
function extractCountryCallingCode(number, country, defaultCountry, defaultCallingCode, metadataJson) {
	if (!number) return {};
	var isNumberWithIddPrefix;
	if (number[0] !== "+") {
		var numberWithoutIDD = stripIddPrefix(number, country || defaultCountry, defaultCallingCode, metadataJson);
		if (numberWithoutIDD && numberWithoutIDD !== number) {
			isNumberWithIddPrefix = true;
			number = "+" + numberWithoutIDD;
		} else {
			if (country || defaultCountry || defaultCallingCode) {
				var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, defaultCountry, defaultCallingCode, metadataJson), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
				if (countryCallingCode) return {
					countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
					countryCallingCode,
					number: shorterNumber
				};
			}
			return { number };
		}
	}
	if (number[1] === "0") return {};
	var metadata = new Metadata(metadataJson);
	var i = 2;
	while (i - 1 <= 3 && i <= number.length) {
		var _countryCallingCode = number.slice(1, i);
		if (metadata.hasCallingCode(_countryCallingCode)) {
			metadata.selectNumberingPlan(_countryCallingCode);
			return {
				countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
				countryCallingCode: _countryCallingCode,
				number: number.slice(i)
			};
		}
		i++;
	}
	return {};
}
// ../../node_modules/libphonenumber-js/es6/helpers/applyInternationalSeparatorStyle.js
function applyInternationalSeparatorStyle(formattedNumber) {
	return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), "g"), " ").trim();
}
// ../../node_modules/libphonenumber-js/es6/helpers/formatNationalNumberUsingFormat.js
var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
	var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix;
	_ref.carrierCode;
	_ref.metadata;
	var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());
	if (useInternationalFormat) return applyInternationalSeparatorStyle(formattedNumber);
	return formattedNumber;
}
// ../../node_modules/libphonenumber-js/es6/helpers/getIddPrefix.js
/**
* Pattern that makes it easy to distinguish whether a region has a single
* international dialing prefix or not. If a region has a single international
* prefix (e.g. 011 in USA), it will be represented as a string that contains
* a sequence of ASCII digits, and possibly a tilde, which signals waiting for
* the tone. If there are multiple available international prefixes in a
* region, they will be represented as a regex string that always contains one
* or more characters that are not ASCII digits or a tilde.
*/
var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function getIddPrefix(country, callingCode, metadata) {
	var countryMetadata = new Metadata(metadata);
	countryMetadata.selectNumberingPlan(country || callingCode);
	if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
	if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}
// ../../node_modules/libphonenumber-js/es6/helpers/extension/createExtensionPattern.js
var RFC3966_EXTN_PREFIX = ";ext=";
/**
* Helper method for constructing regular expressions for parsing. Creates
* an expression that captures up to max_length digits.
* @return {string} RegEx pattern to capture extension digits.
*/
var getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
	return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
/**
* Helper initialiser method to create the regular-expression pattern to match
* extensions.
* Copy-pasted from Google's `libphonenumber`:
* https://github.com/google/libphonenumber/blob/55b2646ec9393f4d3d6661b9c82ef9e258e8b829/javascript/i18n/phonenumbers/phonenumberutil.js#L759-L766
* @return {string} RegEx pattern to capture extensions.
*/
function createExtensionPattern(purpose) {
	/** @type {string} */
	var extLimitAfterExplicitLabel = "20";
	/** @type {string} */
	var extLimitAfterLikelyLabel = "15";
	/** @type {string} */
	var extLimitAfterAmbiguousChar = "9";
	/** @type {string} */
	var extLimitWhenNotSure = "6";
	/** @type {string} */
	var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*";
	/** @type {string} */
	var possibleCharsAfterExtLabel = "[:\\.．]?[ \xA0\\t,-]*";
	/** @type {string} */
	var optionalExtnSuffix = "#?";
	/** @type {string} */
	var explicitExtLabels = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)";
	/** @type {string} */
	var ambiguousExtLabels = "(?:[xｘ#＃~～]|int|ｉｎｔ)";
	/** @type {string} */
	var ambiguousSeparator = "[- ]+";
	/** @type {string} */
	var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*";
	/** @type {string} */
	var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
	/** @type {string} */
	var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
	/** @type {string} */
	var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
	/** @type {string} */
	var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
	/** @type {string} */
	var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
	/** @type {string} */
	var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
	/** @type {string} */
	var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
	return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}
// ../../node_modules/libphonenumber-js/es6/helpers/isViablePhoneNumber.js
var MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + VALID_DIGITS + "]{2}";
var VALID_PHONE_NUMBER = "[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){3,}[" + VALID_PUNCTUATION + VALID_DIGITS + "]*";
var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){1,2}$", "i");
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + "(?:" + createExtensionPattern() + ")?";
var VALID_PHONE_NUMBER_PATTERN = new RegExp("^" + MIN_LENGTH_PHONE_NUMBER_PATTERN + "$|^" + VALID_PHONE_NUMBER_WITH_EXTENSION + "$", "i");
function isViablePhoneNumber(number) {
	return number.length >= 2 && VALID_PHONE_NUMBER_PATTERN.test(number);
}
function isViablePhoneNumberStart(number) {
	return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}
// ../../node_modules/libphonenumber-js/es6/helpers/RFC3966.js
/**
* @param  {object} - `{ ?number, ?extension }`.
* @return {string} Phone URI (RFC 3966).
*/
function formatRFC3966(_ref) {
	var number = _ref.number, ext = _ref.ext;
	if (!number) return "";
	if (number[0] !== "+") throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
	return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}
// ../../node_modules/libphonenumber-js/es6/format.js
var DEFAULT_OPTIONS = { formatExtension: function formatExtension(formattedNumber, extension, metadata) {
	return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
} };
/**
* Formats a phone number.
*
* format(phoneNumberInstance, 'INTERNATIONAL', { ..., v2: true }, metadata)
* format(phoneNumberInstance, 'NATIONAL', { ..., v2: true }, metadata)
*
* format({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', { ... }, metadata)
* format({ phone: '8005553535', country: 'RU' }, 'NATIONAL', undefined, metadata)
*
* @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
* @param  {string} format
* @param  {object} [options]
* @param  {object} metadataJson
* @return {string}
*/
function formatNumber$1(input, format, options, metadataJson) {
	if (options) options = merge({}, DEFAULT_OPTIONS, options);
	else options = DEFAULT_OPTIONS;
	var metadata = new Metadata(metadataJson);
	if (input.country && input.country !== "001") {
		if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
		metadata.selectNumberingPlan(input.country);
	} else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
	else return input.phone || "";
	var countryCallingCode = metadata.countryCallingCode();
	var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
	var number;
	switch (format) {
		case "NATIONAL":
			if (!nationalNumber) return "";
			number = formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata, options);
			return addExtension(number, input.ext, metadata, options.formatExtension);
		case "INTERNATIONAL":
			if (!nationalNumber) return "+".concat(countryCallingCode);
			number = formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata, options);
			number = "+".concat(countryCallingCode, " ").concat(number);
			return addExtension(number, input.ext, metadata, options.formatExtension);
		case "E.164": return "+".concat(countryCallingCode).concat(nationalNumber);
		case "RFC3966": return formatRFC3966({
			number: "+".concat(countryCallingCode).concat(nationalNumber),
			ext: input.ext
		});
		case "IDD":
			if (!options.fromCountry) return;
			var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
			if (!formattedNumber) return;
			return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
		default: throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
	}
}
function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
	var format = chooseFormatForNumber(metadata.formats(), number);
	if (!format) return number;
	return formatNationalNumberUsingFormat(number, format, {
		useInternationalFormat: formatAs === "INTERNATIONAL",
		withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
		carrierCode,
		metadata
	});
}
function chooseFormatForNumber(availableFormats, nationalNumber) {
	return pickFirstMatchingElement(availableFormats, function(format) {
		if (format.leadingDigitsPatterns().length > 0) {
			var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1];
			if (nationalNumber.search(lastLeadingDigitsPattern) !== 0) return false;
		}
		return matchesEntirely(nationalNumber, format.pattern());
	});
}
function addExtension(formattedNumber, ext, metadata, formatExtension) {
	return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
	if (getCountryCallingCode(fromCountry, metadata.metadata) === countryCallingCode) {
		var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata);
		if (countryCallingCode === "1") return countryCallingCode + " " + formattedNumber;
		return formattedNumber;
	}
	var iddPrefix = getIddPrefix(fromCountry, void 0, metadata.metadata);
	if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata));
}
function merge() {
	var i = 1;
	for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) objects[_key] = arguments[_key];
	while (i < objects.length) {
		if (objects[i]) for (var key in objects[i]) objects[0][key] = objects[i][key];
		i++;
	}
	return objects[0];
}
function pickFirstMatchingElement(elements, testFunction) {
	var i = 0;
	while (i < elements.length) {
		if (testFunction(elements[i])) return elements[i];
		i++;
	}
}
// ../../node_modules/libphonenumber-js/es6/PhoneNumber.js
function _typeof$4(o) {
	"@babel/helpers - typeof";
	return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
		return typeof o;
	} : function(o) {
		return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	}, _typeof$4(o);
}
function ownKeys$3(e, r) {
	var t = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var o = Object.getOwnPropertySymbols(e);
		r && (o = o.filter(function(r) {
			return Object.getOwnPropertyDescriptor(e, r).enumerable;
		})), t.push.apply(t, o);
	}
	return t;
}
function _objectSpread$3(e) {
	for (var r = 1; r < arguments.length; r++) {
		var t = null != arguments[r] ? arguments[r] : {};
		r % 2 ? ownKeys$3(Object(t), !0).forEach(function(r) {
			_defineProperty$3(e, r, t[r]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function(r) {
			Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
		});
	}
	return e;
}
function _defineProperty$3(e, r, t) {
	return (r = _toPropertyKey$4(r)) in e ? Object.defineProperty(e, r, {
		value: t,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[r] = t, e;
}
function _classCallCheck$1(a, n) {
	if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(e, r) {
	for (var t = 0; t < r.length; t++) {
		var o = r[t];
		o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey$4(o.key), o);
	}
}
function _createClass$1(e, r, t) {
	return r && _defineProperties$1(e.prototype, r), t && _defineProperties$1(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function _toPropertyKey$4(t) {
	var i = _toPrimitive$4(t, "string");
	return "symbol" == _typeof$4(i) ? i : i + "";
}
function _toPrimitive$4(t, r) {
	if ("object" != _typeof$4(t) || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != _typeof$4(i)) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
var PhoneNumber = /*#__PURE__*/ function() {
	/**
	* @param  {string} countryOrCountryCallingCode
	* @param  {string} nationalNumber
	* @param  {object} metadata — Metadata JSON
	* @return {PhoneNumber}
	*/
	function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
		_classCallCheck$1(this, PhoneNumber);
		if (!countryOrCountryCallingCode) throw new TypeError("First argument is required");
		if (typeof countryOrCountryCallingCode !== "string") throw new TypeError("First argument must be a string");
		if (countryOrCountryCallingCode[0] === "+" && !nationalNumber) throw new TypeError("`metadata` argument not passed");
		if (isObject(nationalNumber) && isObject(nationalNumber.countries)) {
			metadata = nationalNumber;
			var e164Number = countryOrCountryCallingCode;
			if (!E164_NUMBER_REGEXP.test(e164Number)) throw new Error("Invalid `number` argument passed: must consist of a \"+\" followed by digits");
			var _extractCountryCallin = extractCountryCallingCode(e164Number, void 0, void 0, void 0, metadata), _countryCallingCode = _extractCountryCallin.countryCallingCode;
			nationalNumber = _extractCountryCallin.number;
			countryOrCountryCallingCode = _countryCallingCode;
			if (!nationalNumber) throw new Error("Invalid `number` argument passed: too short");
		}
		if (!nationalNumber) throw new TypeError("`nationalNumber` argument is required");
		if (typeof nationalNumber !== "string") throw new TypeError("`nationalNumber` argument must be a string");
		validateMetadata(metadata);
		var _getCountryAndCalling = getCountryAndCallingCodeFromOneOfThem(countryOrCountryCallingCode, metadata), country = _getCountryAndCalling.country, countryCallingCode = _getCountryAndCalling.callingCode;
		this.country = country;
		this.countryCallingCode = countryCallingCode;
		this.nationalNumber = nationalNumber;
		this.number = "+" + this.countryCallingCode + this.nationalNumber;
		this.getMetadata = function() {
			return metadata;
		};
	}
	return _createClass$1(PhoneNumber, [
		{
			key: "setExt",
			value: function setExt(ext) {
				this.ext = ext;
			}
		},
		{
			key: "getPossibleCountries",
			value: function getPossibleCountries() {
				if (this.country) return [this.country];
				return getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
			}
		},
		{
			key: "isPossible",
			value: function isPossible() {
				return isPossiblePhoneNumber(this, { v2: true }, this.getMetadata());
			}
		},
		{
			key: "isValid",
			value: function isValid() {
				return isValidNumber(this, { v2: true }, this.getMetadata());
			}
		},
		{
			key: "isNonGeographic",
			value: function isNonGeographic() {
				return new Metadata(this.getMetadata()).isNonGeographicCallingCode(this.countryCallingCode);
			}
		},
		{
			key: "isEqual",
			value: function isEqual(phoneNumber) {
				return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
			}
		},
		{
			key: "getType",
			value: function getType() {
				return getNumberType(this, { v2: true }, this.getMetadata());
			}
		},
		{
			key: "format",
			value: function format(_format, options) {
				return formatNumber$1(this, _format, options ? _objectSpread$3(_objectSpread$3({}, options), {}, { v2: true }) : { v2: true }, this.getMetadata());
			}
		},
		{
			key: "formatNational",
			value: function formatNational(options) {
				return this.format("NATIONAL", options);
			}
		},
		{
			key: "formatInternational",
			value: function formatInternational(options) {
				return this.format("INTERNATIONAL", options);
			}
		},
		{
			key: "getURI",
			value: function getURI(options) {
				return this.format("RFC3966", options);
			}
		}
	]);
}();
var E164_NUMBER_REGEXP = /^\+\d+$/;
// ../../node_modules/libphonenumber-js/es6/ParseError.js
function _typeof$3(o) {
	"@babel/helpers - typeof";
	return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
		return typeof o;
	} : function(o) {
		return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	}, _typeof$3(o);
}
function _defineProperties(e, r) {
	for (var t = 0; t < r.length; t++) {
		var o = r[t];
		o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey$3(o.key), o);
	}
}
function _createClass(e, r, t) {
	return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function _toPropertyKey$3(t) {
	var i = _toPrimitive$3(t, "string");
	return "symbol" == _typeof$3(i) ? i : i + "";
}
function _toPrimitive$3(t, r) {
	if ("object" != _typeof$3(t) || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != _typeof$3(i)) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _classCallCheck(a, n) {
	if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _callSuper(t, o, e) {
	return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
	if (e && ("object" == _typeof$3(e) || "function" == typeof e)) return e;
	if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
	return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
	if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	return e;
}
function _inherits(t, e) {
	if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
	t.prototype = Object.create(e && e.prototype, { constructor: {
		value: t,
		writable: !0,
		configurable: !0
	} }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
	var r = "function" == typeof Map ? /* @__PURE__ */ new Map() : void 0;
	return _wrapNativeSuper = function _wrapNativeSuper(t) {
		if (null === t || !_isNativeFunction(t)) return t;
		if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
		if (void 0 !== r) {
			if (r.has(t)) return r.get(t);
			r.set(t, Wrapper);
		}
		function Wrapper() {
			return _construct(t, arguments, _getPrototypeOf(this).constructor);
		}
		return Wrapper.prototype = Object.create(t.prototype, { constructor: {
			value: Wrapper,
			enumerable: !1,
			writable: !0,
			configurable: !0
		} }), _setPrototypeOf(Wrapper, t);
	}, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
	if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
	var o = [null];
	o.push.apply(o, e);
	var p = new (t.bind.apply(t, o))();
	return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
	try {
		var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
	} catch (t) {}
	return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
		return !!t;
	})();
}
function _isNativeFunction(t) {
	try {
		return -1 !== Function.toString.call(t).indexOf("[native code]");
	} catch (n) {
		return "function" == typeof t;
	}
}
function _setPrototypeOf(t, e) {
	return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
		return t.__proto__ = e, t;
	}, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
	return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
		return t.__proto__ || Object.getPrototypeOf(t);
	}, _getPrototypeOf(t);
}
var ParseError = /*#__PURE__*/ function(_Error) {
	function ParseError(code) {
		var _this;
		_classCallCheck(this, ParseError);
		_this = _callSuper(this, ParseError, [code]);
		Object.setPrototypeOf(_this, ParseError.prototype);
		_this.name = _this.constructor.name;
		return _this;
	}
	_inherits(ParseError, _Error);
	return _createClass(ParseError);
}(/*#__PURE__*/ _wrapNativeSuper(Error));
// ../../node_modules/libphonenumber-js/es6/helpers/extension/extractExtension.js
var EXTN_PATTERN = new RegExp("(?:" + createExtensionPattern() + ")$", "i");
function extractExtension(number) {
	var start = number.search(EXTN_PATTERN);
	if (start < 0) return {};
	var numberWithoutExtension = number.slice(0, start);
	var matches = number.match(EXTN_PATTERN);
	var i = 1;
	while (i < matches.length) {
		if (matches[i]) return {
			number: numberWithoutExtension,
			ext: matches[i]
		};
		i++;
	}
}
// ../../node_modules/libphonenumber-js/es6/helpers/parseDigits.js
var DIGITS = {
	"0": "0",
	"1": "1",
	"2": "2",
	"3": "3",
	"4": "4",
	"5": "5",
	"6": "6",
	"7": "7",
	"8": "8",
	"9": "9",
	"０": "0",
	"１": "1",
	"２": "2",
	"３": "3",
	"４": "4",
	"５": "5",
	"６": "6",
	"７": "7",
	"８": "8",
	"９": "9",
	"٠": "0",
	"١": "1",
	"٢": "2",
	"٣": "3",
	"٤": "4",
	"٥": "5",
	"٦": "6",
	"٧": "7",
	"٨": "8",
	"٩": "9",
	"۰": "0",
	"۱": "1",
	"۲": "2",
	"۳": "3",
	"۴": "4",
	"۵": "5",
	"۶": "6",
	"۷": "7",
	"۸": "8",
	"۹": "9"
};
function parseDigit(character) {
	return DIGITS[character];
}
// ../../node_modules/libphonenumber-js/es6/parseIncompletePhoneNumber.js
function _createForOfIteratorHelperLoose(r, e) {
	var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
	if (t) return (t = t.call(r)).next.bind(t);
	if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) {
		t && (r = t);
		var o = 0;
		return function() {
			return o >= r.length ? { done: !0 } : {
				done: !1,
				value: r[o++]
			};
		};
	}
	throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(r, a) {
	if (r) {
		if ("string" == typeof r) return _arrayLikeToArray$1(r, a);
		var t = {}.toString.call(r).slice(8, -1);
		return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0;
	}
}
function _arrayLikeToArray$1(r, a) {
	(null == a || a > r.length) && (a = r.length);
	for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
	return n;
}
/**
* Parses phone number characters from a string.
* Drops all punctuation leaving only digits and the leading `+` sign (if any).
* Also converts wide-ascii and arabic-indic numerals to conventional numerals.
* E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
* @param  {string} string
* @return {string}
* @example
* ```js
* // Outputs '8800555'.
* parseIncompletePhoneNumber('8 (800) 555')
* // Outputs '+7800555'.
* parseIncompletePhoneNumber('+7 800 555')
* ```
*/
function parseIncompletePhoneNumber(string) {
	var result = "";
	for (var _iterator = _createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;) {
		var character = _step.value;
		result += parsePhoneNumberCharacter(character, result) || "";
	}
	return result;
}
/**
* Parses next character while parsing phone number digits (including a `+`)
* from text: discards everything except `+` and digits, and `+` is only allowed
* at the start of a phone number.
* For example, is used in `react-phone-number-input` where it uses
* [`input-format`](https://gitlab.com/catamphetamine/input-format).
* @param  {string} character - Yet another character from raw input string.
* @param  {string?} prevParsedCharacters - Previous parsed characters.
* @param  {function?} eventListener - An optional "on event" function.
* @return {string?} The parsed character.
*/
function parsePhoneNumberCharacter(character, prevParsedCharacters, eventListener) {
	if (character === "+") {
		if (prevParsedCharacters) {
			if (typeof eventListener === "function") eventListener("end");
			return;
		}
		return "+";
	}
	return parseDigit(character);
}
var RFC3966_PHONE_DIGIT_ = "([" + VALID_DIGITS + "]|[\\-\\.\\(\\)]?)";
var RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\+" + RFC3966_PHONE_DIGIT_ + "*[" + VALID_DIGITS + "]" + RFC3966_PHONE_DIGIT_ + "*$";
/**
* Regular expression of valid global-number-digits for the phone-context
* parameter, following the syntax defined in RFC3966.
*/
var RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, "g");
var ALPHANUM_ = VALID_DIGITS;
var RFC3966_DOMAINLABEL_ = "[" + ALPHANUM_ + "]+((\\-)*[" + ALPHANUM_ + "])*";
var RFC3966_TOPLABEL_ = "[a-zA-Z]+((\\-)*[" + ALPHANUM_ + "])*";
var RFC3966_DOMAINNAME_ = "^(" + RFC3966_DOMAINLABEL_ + "\\.)*" + RFC3966_TOPLABEL_ + "\\.?$";
/**
* Regular expression of valid domainname for the phone-context parameter,
* following the syntax defined in RFC3966.
*/
var RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, "g");
var RFC3966_PREFIX_ = "tel:";
var RFC3966_PHONE_CONTEXT_ = ";phone-context=";
var RFC3966_ISDN_SUBADDRESS_ = ";isub=";
/**
* Extracts the value of the phone-context parameter of `numberToExtractFrom`,
* following the syntax defined in RFC3966.
*
* @param {string} numberToExtractFrom
* @return {string|null} the extracted string (possibly empty), or `null` if no phone-context parameter is found.
*/
function extractPhoneContext(numberToExtractFrom) {
	var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_);
	if (indexOfPhoneContext < 0) return null;
	var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length;
	if (phoneContextStart >= numberToExtractFrom.length) return "";
	var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart);
	if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
	else return numberToExtractFrom.substring(phoneContextStart);
}
/**
* Returns whether the value of phoneContext follows the syntax defined in RFC3966.
*
* @param {string|null} phoneContext
* @return {boolean}
*/
function isPhoneContextValid(phoneContext) {
	if (phoneContext === null) return true;
	if (phoneContext.length === 0) return false;
	return RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}
// ../../node_modules/libphonenumber-js/es6/helpers/extractFormattedPhoneNumberFromPossibleRfc3966NumberUri.js
/**
* @param  {string} numberToParse
* @param  {string} nationalNumber
* @return {}
*/
function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
	var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
	var phoneContext = extractPhoneContext(numberToParse);
	if (!isPhoneContextValid(phoneContext)) throw new ParseError("NOT_A_NUMBER");
	var phoneNumberString;
	if (phoneContext === null) phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
	else {
		phoneNumberString = "";
		if (phoneContext.charAt(0) === "+") phoneNumberString += phoneContext;
		var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_);
		var indexOfNationalNumber;
		/* istanbul ignore else */
		if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length;
		else indexOfNationalNumber = 0;
		var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
		phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
	}
	var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);
	if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
	if (phoneNumberString !== "") return phoneNumberString;
}
// ../../node_modules/libphonenumber-js/es6/parse.js
var MAX_INPUT_STRING_LENGTH = 250;
var PHONE_NUMBER_START_PATTERN = new RegExp("[" + PLUS_CHARS + VALID_DIGITS + "]");
var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + VALID_DIGITS + "#]+$");
var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
/**
* Parses a phone number.
*
* parse('123456789', { defaultCountry: 'RU', v2: true }, metadata)
* parse('123456789', { defaultCountry: 'RU' }, metadata)
* parse('123456789', undefined, metadata)
*
* @param  {string} input
* @param  {object} [options]
* @param  {object} metadataJson
* @return {object|PhoneNumber?} If `options.v2: true` flag is passed, it returns a `PhoneNumber?` instance. Otherwise, returns an object of shape `{ phone: '...', country: '...' }` (or just `{}` if no phone number was parsed).
*/
function parse$1(text, options, metadataJson) {
	options = options || {};
	var metadata = new Metadata(metadataJson);
	if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
		if (options.v2) throw new ParseError("INVALID_COUNTRY");
		throw new Error("Unknown country: ".concat(options.defaultCountry));
	}
	var _parseInput = parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error;
	if (!formattedPhoneNumber) {
		if (options.v2) {
			if (error === "TOO_SHORT") throw new ParseError("TOO_SHORT");
			throw new ParseError("NOT_A_NUMBER");
		}
		return {};
	}
	var _parsePhoneNumber = parsePhoneNumber$3(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
	if (!metadata.hasSelectedNumberingPlan()) {
		if (options.v2) throw new ParseError("INVALID_COUNTRY");
		return {};
	}
	if (!nationalNumber || nationalNumber.length < 2) {
		/* istanbul ignore if */
		if (options.v2) throw new ParseError("TOO_SHORT");
		return {};
	}
	if (nationalNumber.length > 17) {
		if (options.v2) throw new ParseError("TOO_LONG");
		return {};
	}
	if (options.v2) {
		var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);
		if (country) phoneNumber.country = country;
		if (carrierCode) phoneNumber.carrierCode = carrierCode;
		if (ext) phoneNumber.ext = ext;
		phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
		return phoneNumber;
	}
	var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;
	if (!options.extended) return valid ? result(country, nationalNumber, ext) : {};
	return {
		country,
		countryCallingCode,
		carrierCode,
		valid,
		possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, metadata) ? true : false,
		phone: nationalNumber,
		ext
	};
}
/**
* Extracts a formatted phone number from text.
* Doesn't guarantee that the extracted phone number
* is a valid phone number (for example, doesn't validate its length).
* @param  {string} text
* @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
* @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
* @return {string}
* @example
* // Returns "(213) 373-4253".
* extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
*/
function _extractFormattedPhoneNumber(text, extract, throwOnError) {
	if (!text) return;
	if (text.length > MAX_INPUT_STRING_LENGTH) {
		if (throwOnError) throw new ParseError("TOO_LONG");
		return;
	}
	if (extract === false) return text;
	var startsAt = text.search(PHONE_NUMBER_START_PATTERN);
	if (startsAt < 0) return;
	return text.slice(startsAt).replace(AFTER_PHONE_NUMBER_END_PATTERN, "");
}
/**
* @param  {string} text - Input.
* @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
* @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
* @return {object} `{ ?number, ?ext }`.
*/
function parseInput(text, v2, extract) {
	var number = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text, { extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
		return _extractFormattedPhoneNumber(text, extract, v2);
	} });
	if (!number) return {};
	if (!isViablePhoneNumber(number)) {
		if (isViablePhoneNumberStart(number)) return { error: "TOO_SHORT" };
		return {};
	}
	var withExtensionStripped = extractExtension(number);
	if (withExtensionStripped.ext) return withExtensionStripped;
	return { number };
}
/**
* Creates `parse()` result object.
*/
function result(country, nationalNumber, ext) {
	var result = {
		country,
		phone: nationalNumber
	};
	if (ext) result.ext = ext;
	return result;
}
/**
* Parses a viable phone number.
* @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
* @param {string} [defaultCountry]
* @param {string} [defaultCallingCode]
* @param {Metadata} metadata — Metadata instance with no pre-selected numbering plan. If `country` is returned, its numbering plan will also be selected in `metadata`. Otherwise, if `countryCallingCode` is returned, its numbering plan will also be selected in `metadata`. Otherwise, if neither `country` nor `countryCallingCode` are returned, no numbering plan will be selected in `metadata`.
* @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
*/
function parsePhoneNumber$3(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
	var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), void 0, defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
	var country;
	if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
	else if (number && (defaultCountry || defaultCallingCode)) {
		if (defaultCountry) {
			country = defaultCountry;
			metadata.selectNumberingPlan(defaultCountry);
			countryCallingCode = metadata.numberingPlan.callingCode();
		} else {
			metadata.selectNumberingPlan(defaultCallingCode);
			countryCallingCode = defaultCallingCode;
			/* istanbul ignore if */
			if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
				if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = "001";
			}
		}
	} else return {};
	if (!number) return {
		countryCallingCodeSource,
		countryCallingCode
	};
	var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), void 0, metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
	var exactCountry = getCountryByCallingCode(countryCallingCode, {
		nationalNumber,
		metadata
	});
	if (exactCountry) {
		country = exactCountry;
		/* istanbul ignore if */
		if (exactCountry === "001") {} else metadata.selectNumberingPlan(country);
	}
	return {
		country,
		countryCallingCode,
		countryCallingCodeSource,
		nationalNumber,
		carrierCode
	};
}
// ../../node_modules/libphonenumber-js/es6/parsePhoneNumberWithError_.js
function _typeof$2(o) {
	"@babel/helpers - typeof";
	return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
		return typeof o;
	} : function(o) {
		return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	}, _typeof$2(o);
}
function ownKeys$2(e, r) {
	var t = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var o = Object.getOwnPropertySymbols(e);
		r && (o = o.filter(function(r) {
			return Object.getOwnPropertyDescriptor(e, r).enumerable;
		})), t.push.apply(t, o);
	}
	return t;
}
function _objectSpread$2(e) {
	for (var r = 1; r < arguments.length; r++) {
		var t = null != arguments[r] ? arguments[r] : {};
		r % 2 ? ownKeys$2(Object(t), !0).forEach(function(r) {
			_defineProperty$2(e, r, t[r]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function(r) {
			Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
		});
	}
	return e;
}
function _defineProperty$2(e, r, t) {
	return (r = _toPropertyKey$2(r)) in e ? Object.defineProperty(e, r, {
		value: t,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[r] = t, e;
}
function _toPropertyKey$2(t) {
	var i = _toPrimitive$2(t, "string");
	return "symbol" == _typeof$2(i) ? i : i + "";
}
function _toPrimitive$2(t, r) {
	if ("object" != _typeof$2(t) || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != _typeof$2(i)) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function parsePhoneNumberWithError(text, options, metadata) {
	return parse$1(text, _objectSpread$2(_objectSpread$2({}, options), {}, { v2: true }), metadata);
}
// ../../node_modules/libphonenumber-js/es6/normalizeArguments.js
function _typeof$1(o) {
	"@babel/helpers - typeof";
	return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
		return typeof o;
	} : function(o) {
		return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	}, _typeof$1(o);
}
function ownKeys$1(e, r) {
	var t = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var o = Object.getOwnPropertySymbols(e);
		r && (o = o.filter(function(r) {
			return Object.getOwnPropertyDescriptor(e, r).enumerable;
		})), t.push.apply(t, o);
	}
	return t;
}
function _objectSpread$1(e) {
	for (var r = 1; r < arguments.length; r++) {
		var t = null != arguments[r] ? arguments[r] : {};
		r % 2 ? ownKeys$1(Object(t), !0).forEach(function(r) {
			_defineProperty$1(e, r, t[r]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function(r) {
			Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
		});
	}
	return e;
}
function _defineProperty$1(e, r, t) {
	return (r = _toPropertyKey$1(r)) in e ? Object.defineProperty(e, r, {
		value: t,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[r] = t, e;
}
function _toPropertyKey$1(t) {
	var i = _toPrimitive$1(t, "string");
	return "symbol" == _typeof$1(i) ? i : i + "";
}
function _toPrimitive$1(t, r) {
	if ("object" != _typeof$1(t) || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != _typeof$1(i)) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
	return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
	throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
	if (r) {
		if ("string" == typeof r) return _arrayLikeToArray(r, a);
		var t = {}.toString.call(r).slice(8, -1);
		return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
	}
}
function _arrayLikeToArray(r, a) {
	(null == a || a > r.length) && (a = r.length);
	for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
	return n;
}
function _iterableToArrayLimit(r, l) {
	var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
	if (null != t) {
		var e, n, i, u, a = [], f = !0, o = !1;
		try {
			if (i = (t = t.call(r)).next, 0 === l) {
				if (Object(t) !== t) return;
				f = !1;
			} else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
		} catch (r) {
			o = !0, n = r;
		} finally {
			try {
				if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
			} finally {
				if (o) throw n;
			}
		}
		return a;
	}
}
function _arrayWithHoles(r) {
	if (Array.isArray(r)) return r;
}
function normalizeArguments(args) {
	var _Array$prototype$slic2 = _slicedToArray(Array.prototype.slice.call(args), 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
	var text;
	var options;
	var metadata;
	if (typeof arg_1 === "string") text = arg_1;
	else throw new TypeError("A text for parsing must be a string.");
	if (!arg_2 || typeof arg_2 === "string") {
		if (arg_4) {
			options = arg_3;
			metadata = arg_4;
		} else {
			options = void 0;
			metadata = arg_3;
		}
		if (arg_2) options = _objectSpread$1({ defaultCountry: arg_2 }, options);
	} else if (isObject(arg_2)) {
		if (arg_3) {
			options = arg_2;
			metadata = arg_3;
		} else metadata = arg_2;
	} else throw new Error("Invalid second argument: ".concat(arg_2));
	return {
		text,
		options,
		metadata
	};
}
// ../../node_modules/libphonenumber-js/es6/parsePhoneNumber_.js
function _typeof(o) {
	"@babel/helpers - typeof";
	return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
		return typeof o;
	} : function(o) {
		return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	}, _typeof(o);
}
function ownKeys(e, r) {
	var t = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var o = Object.getOwnPropertySymbols(e);
		r && (o = o.filter(function(r) {
			return Object.getOwnPropertyDescriptor(e, r).enumerable;
		})), t.push.apply(t, o);
	}
	return t;
}
function _objectSpread(e) {
	for (var r = 1; r < arguments.length; r++) {
		var t = null != arguments[r] ? arguments[r] : {};
		r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
			_defineProperty(e, r, t[r]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
			Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
		});
	}
	return e;
}
function _defineProperty(e, r, t) {
	return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
		value: t,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[r] = t, e;
}
function _toPropertyKey(t) {
	var i = _toPrimitive(t, "string");
	return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
	if ("object" != _typeof(t) || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != _typeof(i)) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function parsePhoneNumber$2(text, options, metadata) {
	if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata)) options = _objectSpread(_objectSpread({}, options), {}, { defaultCountry: void 0 });
	try {
		return parsePhoneNumberWithError(text, options, metadata);
	} catch (error) {
		/* istanbul ignore else */
		if (error instanceof ParseError) {} else throw error;
	}
}
// ../../node_modules/libphonenumber-js/es6/parsePhoneNumber.js
function parsePhoneNumber$1() {
	var _normalizeArguments = normalizeArguments(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
	return parsePhoneNumber$2(text, options, metadata);
}
// ../../node_modules/libphonenumber-js/min/exports/parsePhoneNumber.js
function parsePhoneNumber() {
	return withMetadataArgument(parsePhoneNumber$1, arguments);
}
// source/utilities/normalize-phone-number.ts
var normalizePhoneNumber = ({ phone, defaultCountry = "DE", format = "E.164", customSpacing }) => {
	if (!phone) return null;
	const parsed = parsePhoneNumber(phone, defaultCountry);
	if (!parsed?.isValid()) return null;
	let formattedNumber = parsed.format(format);
	if (customSpacing && format === "INTERNATIONAL") {
		const parts = formattedNumber.split(" ");
		formattedNumber = [parts.shift(), ...parts.join("").match(/^.{1,3}|.{1,4}/g) || []].join(" ");
	}
	return formattedNumber;
};
// source/utilities/parse-and-revive-json.ts
var parseAndReviveJson = (json) => {
	try {
		return JSON.parse(json, jsonDateParser);
	} catch {
		return json;
	}
};
// source/utilities/parse-german-float.ts
var parseGermanFloat = (value) => {
	return Number.parseFloat(value.replace(",", "."));
};
// source/utilities/parse-iso-as-utc-date.ts
var parseIsoAsUtcDate = (dateString) => {
	const localDate = parseISO(dateString);
	return new Date(Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate()));
};
// source/utilities/recruiting-phase.ts
/**
* The labels of the "Phase" status column of the monday board "Recruiting".
* Besides "Aktiv", a running campaign can be in one of the guarantee phases,
* which replaced the separate "Garantie" column. "Einstellungsgarantie inaktiv"
* is the same guarantee for the customer, it only no longer counts as a
* campaign the marketing managers work on.
*/
var RecruitingPhase = {
	ACTIVE: "Aktiv",
	HIRING_GUARANTEE: "Einstellungsgarantie",
	GRACE_PERIOD: "Karenzzeit",
	HIRING_GUARANTEE_INACTIVE: "Einstellungsgarantie inaktiv"
};
var normalizePhase = (phase) => (phase ?? "").trim().replace(/\s+/g, " ").toLowerCase();
var isPhaseOneOf = (phase, labels) => labels.some((label) => normalizePhase(label) === normalizePhase(phase));
/**
* Whether the campaign is running for the customer. Every guarantee phase
* counts, the inactive one included.
*/
var isRecruitingPhaseActive = (phase) => isPhaseOneOf(phase, Object.values(RecruitingPhase));
/**
* Whether the campaign shows up in the marketing manager dashboard, which is
* every running phase except "Einstellungsgarantie inaktiv".
*/
var isRecruitingPhaseInMarketing = (phase) => isPhaseOneOf(phase, [
	RecruitingPhase.ACTIVE,
	RecruitingPhase.HIRING_GUARANTEE,
	RecruitingPhase.GRACE_PERIOD
]);
/**
* The guarantee a phase stands for, or null for "Aktiv" and every phase which
* is not running.
*/
var getRecruitingPhaseGuarantee = (phase) => {
	if (isPhaseOneOf(phase, [RecruitingPhase.HIRING_GUARANTEE, RecruitingPhase.HIRING_GUARANTEE_INACTIVE])) return JobPositionQuotaGuarantee.HIRING_GUARANTEE;
	if (isPhaseOneOf(phase, [RecruitingPhase.GRACE_PERIOD])) return JobPositionQuotaGuarantee.GRACE_PERIOD;
	return null;
};
// source/utilities/referrals.ts
var getApplicantSourceFromCareerPageReferral = (referral) => {
	switch (referral) {
		case CareerPageReferralSource.INDEED:
		case CareerPageReferralSource.STEPSTONE:
		case CareerPageReferralSource.OTHER_JOB_PORTAL:
		case CareerPageReferralSource.LINKED_IN: return ApplicantSourceType.JOB_PORTAL;
		case CareerPageReferralSource.EMPLOYEE_REFERRAL: return ApplicantSourceType.EMPLOYEE_REFERRAL;
		case CareerPageReferralSource.TRADE_FAIR: return ApplicantSourceType.TRADE_FAIR;
		case CareerPageReferralSource.SOCIAL_MEDIA_CAMPAIGN: return ApplicantSourceType.SOCIAL_MEDIA_CAMPAIGN;
		case CareerPageReferralSource.GOOGLE_SEARCH: return ApplicantSourceType.GOOGLE_SEARCH;
		case CareerPageReferralSource.OTHER: return ApplicantSourceType.OTHER;
		default: return ApplicantSourceType.OTHER;
	}
};
// ../../node_modules/psl/dist/psl.mjs
function U$1(e) {
	return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var C;
var F$1;
function $() {
	if (F$1) return C;
	F$1 = 1;
	const e = 2147483647, s = 36, c = 1, o = 26, t = 38, d = 700, z = 72, y = 128, g = "-", H = /^xn--/, N = /[^\0-\x7F]/, R = /[\x2E\u3002\uFF0E\uFF61]/g, P = {
		overflow: "Overflow: input needs wider integers to process",
		"not-basic": "Illegal input >= 0x80 (not a basic code point)",
		"invalid-input": "Invalid input"
	}, _ = 35, h = Math.floor, I = String.fromCharCode;
	function v(a) {
		throw new RangeError(P[a]);
	}
	function V(a, i) {
		const m = [];
		let n = a.length;
		for (; n--;) m[n] = i(a[n]);
		return m;
	}
	function L(a, i) {
		const m = a.split("@");
		let n = "";
		m.length > 1 && (n = m[0] + "@", a = m[1]), a = a.replace(R, ".");
		const p = V(a.split("."), i).join(".");
		return n + p;
	}
	function S(a) {
		const i = [];
		let m = 0;
		const n = a.length;
		for (; m < n;) {
			const r = a.charCodeAt(m++);
			if (r >= 55296 && r <= 56319 && m < n) {
				const p = a.charCodeAt(m++);
				(p & 64512) == 56320 ? i.push(((r & 1023) << 10) + (p & 1023) + 65536) : (i.push(r), m--);
			} else i.push(r);
		}
		return i;
	}
	const G = (a) => String.fromCodePoint(...a), W = function(a) {
		return a >= 48 && a < 58 ? 26 + (a - 48) : a >= 65 && a < 91 ? a - 65 : a >= 97 && a < 123 ? a - 97 : s;
	}, D = function(a, i) {
		return a + 22 + 75 * (a < 26) - ((i != 0) << 5);
	}, T = function(a, i, m) {
		let n = 0;
		for (a = m ? h(a / d) : a >> 1, a += h(a / i); a > 455; n += s) a = h(a / _);
		return h(n + 36 * a / (a + t));
	}, E = function(a) {
		const i = [], m = a.length;
		let n = 0, r = y, p = z, j = a.lastIndexOf(g);
		j < 0 && (j = 0);
		for (let u = 0; u < j; ++u) a.charCodeAt(u) >= 128 && v("not-basic"), i.push(a.charCodeAt(u));
		for (let u = j > 0 ? j + 1 : 0; u < m;) {
			const k = n;
			for (let l = 1, b = s;; b += s) {
				u >= m && v("invalid-input");
				const w = W(a.charCodeAt(u++));
				w >= s && v("invalid-input"), w > h((e - n) / l) && v("overflow"), n += w * l;
				const x = b <= p ? c : b >= p + o ? o : b - p;
				if (w < x) break;
				const q = s - x;
				l > h(e / q) && v("overflow"), l *= q;
			}
			const f = i.length + 1;
			p = T(n - k, f, k == 0), h(n / f) > e - r && v("overflow"), r += h(n / f), n %= f, i.splice(n++, 0, r);
		}
		return String.fromCodePoint(...i);
	}, B = function(a) {
		const i = [];
		a = S(a);
		const m = a.length;
		let n = y, r = 0, p = z;
		for (const k of a) k < 128 && i.push(I(k));
		const j = i.length;
		let u = j;
		for (j && i.push(g); u < m;) {
			let k = e;
			for (const l of a) l >= n && l < k && (k = l);
			const f = u + 1;
			k - n > h((e - r) / f) && v("overflow"), r += (k - n) * f, n = k;
			for (const l of a) if (l < n && ++r > e && v("overflow"), l === n) {
				let b = r;
				for (let w = s;; w += s) {
					const x = w <= p ? c : w >= p + o ? o : w - p;
					if (b < x) break;
					const q = b - x, M = s - x;
					i.push(I(D(x + q % M, 0))), b = h(q / M);
				}
				i.push(I(D(b, 0))), p = T(r, f, u === j), r = 0, ++u;
			}
			++r, ++n;
		}
		return i.join("");
	};
	return C = {
		/**
		* A string representing the current Punycode.js version number.
		* @memberOf punycode
		* @type String
		*/
		version: "2.3.1",
		/**
		* An object of methods to convert from JavaScript's internal character
		* representation (UCS-2) to Unicode code points, and back.
		* @see <https://mathiasbynens.be/notes/javascript-encoding>
		* @memberOf punycode
		* @type Object
		*/
		ucs2: {
			decode: S,
			encode: G
		},
		decode: E,
		encode: B,
		toASCII: function(a) {
			return L(a, function(i) {
				return N.test(i) ? "xn--" + B(i) : i;
			});
		},
		toUnicode: function(a) {
			return L(a, function(i) {
				return H.test(i) ? E(i.slice(4).toLowerCase()) : i;
			});
		}
	}, C;
}
var A$1 = /* @__PURE__ */ U$1($());
var Q = [
	"ac",
	"com.ac",
	"edu.ac",
	"gov.ac",
	"mil.ac",
	"net.ac",
	"org.ac",
	"ad",
	"ae",
	"ac.ae",
	"co.ae",
	"gov.ae",
	"mil.ae",
	"net.ae",
	"org.ae",
	"sch.ae",
	"aero",
	"airline.aero",
	"airport.aero",
	"accident-investigation.aero",
	"accident-prevention.aero",
	"aerobatic.aero",
	"aeroclub.aero",
	"aerodrome.aero",
	"agents.aero",
	"air-surveillance.aero",
	"air-traffic-control.aero",
	"aircraft.aero",
	"airtraffic.aero",
	"ambulance.aero",
	"association.aero",
	"author.aero",
	"ballooning.aero",
	"broker.aero",
	"caa.aero",
	"cargo.aero",
	"catering.aero",
	"certification.aero",
	"championship.aero",
	"charter.aero",
	"civilaviation.aero",
	"club.aero",
	"conference.aero",
	"consultant.aero",
	"consulting.aero",
	"control.aero",
	"council.aero",
	"crew.aero",
	"design.aero",
	"dgca.aero",
	"educator.aero",
	"emergency.aero",
	"engine.aero",
	"engineer.aero",
	"entertainment.aero",
	"equipment.aero",
	"exchange.aero",
	"express.aero",
	"federation.aero",
	"flight.aero",
	"freight.aero",
	"fuel.aero",
	"gliding.aero",
	"government.aero",
	"groundhandling.aero",
	"group.aero",
	"hanggliding.aero",
	"homebuilt.aero",
	"insurance.aero",
	"journal.aero",
	"journalist.aero",
	"leasing.aero",
	"logistics.aero",
	"magazine.aero",
	"maintenance.aero",
	"marketplace.aero",
	"media.aero",
	"microlight.aero",
	"modelling.aero",
	"navigation.aero",
	"parachuting.aero",
	"paragliding.aero",
	"passenger-association.aero",
	"pilot.aero",
	"press.aero",
	"production.aero",
	"recreation.aero",
	"repbody.aero",
	"res.aero",
	"research.aero",
	"rotorcraft.aero",
	"safety.aero",
	"scientist.aero",
	"services.aero",
	"show.aero",
	"skydiving.aero",
	"software.aero",
	"student.aero",
	"taxi.aero",
	"trader.aero",
	"trading.aero",
	"trainer.aero",
	"union.aero",
	"workinggroup.aero",
	"works.aero",
	"af",
	"com.af",
	"edu.af",
	"gov.af",
	"net.af",
	"org.af",
	"ag",
	"co.ag",
	"com.ag",
	"net.ag",
	"nom.ag",
	"org.ag",
	"ai",
	"com.ai",
	"net.ai",
	"off.ai",
	"org.ai",
	"al",
	"com.al",
	"edu.al",
	"gov.al",
	"mil.al",
	"net.al",
	"org.al",
	"am",
	"co.am",
	"com.am",
	"commune.am",
	"net.am",
	"org.am",
	"ao",
	"co.ao",
	"ed.ao",
	"edu.ao",
	"gov.ao",
	"gv.ao",
	"it.ao",
	"og.ao",
	"org.ao",
	"pb.ao",
	"aq",
	"ar",
	"bet.ar",
	"com.ar",
	"coop.ar",
	"edu.ar",
	"gob.ar",
	"gov.ar",
	"int.ar",
	"mil.ar",
	"musica.ar",
	"mutual.ar",
	"net.ar",
	"org.ar",
	"senasa.ar",
	"tur.ar",
	"arpa",
	"e164.arpa",
	"home.arpa",
	"in-addr.arpa",
	"ip6.arpa",
	"iris.arpa",
	"uri.arpa",
	"urn.arpa",
	"as",
	"gov.as",
	"asia",
	"at",
	"ac.at",
	"sth.ac.at",
	"co.at",
	"gv.at",
	"or.at",
	"au",
	"asn.au",
	"com.au",
	"edu.au",
	"gov.au",
	"id.au",
	"net.au",
	"org.au",
	"conf.au",
	"oz.au",
	"act.au",
	"nsw.au",
	"nt.au",
	"qld.au",
	"sa.au",
	"tas.au",
	"vic.au",
	"wa.au",
	"act.edu.au",
	"catholic.edu.au",
	"nsw.edu.au",
	"nt.edu.au",
	"qld.edu.au",
	"sa.edu.au",
	"tas.edu.au",
	"vic.edu.au",
	"wa.edu.au",
	"qld.gov.au",
	"sa.gov.au",
	"tas.gov.au",
	"vic.gov.au",
	"wa.gov.au",
	"schools.nsw.edu.au",
	"aw",
	"com.aw",
	"ax",
	"az",
	"biz.az",
	"com.az",
	"edu.az",
	"gov.az",
	"info.az",
	"int.az",
	"mil.az",
	"name.az",
	"net.az",
	"org.az",
	"pp.az",
	"pro.az",
	"ba",
	"com.ba",
	"edu.ba",
	"gov.ba",
	"mil.ba",
	"net.ba",
	"org.ba",
	"bb",
	"biz.bb",
	"co.bb",
	"com.bb",
	"edu.bb",
	"gov.bb",
	"info.bb",
	"net.bb",
	"org.bb",
	"store.bb",
	"tv.bb",
	"*.bd",
	"be",
	"ac.be",
	"bf",
	"gov.bf",
	"bg",
	"0.bg",
	"1.bg",
	"2.bg",
	"3.bg",
	"4.bg",
	"5.bg",
	"6.bg",
	"7.bg",
	"8.bg",
	"9.bg",
	"a.bg",
	"b.bg",
	"c.bg",
	"d.bg",
	"e.bg",
	"f.bg",
	"g.bg",
	"h.bg",
	"i.bg",
	"j.bg",
	"k.bg",
	"l.bg",
	"m.bg",
	"n.bg",
	"o.bg",
	"p.bg",
	"q.bg",
	"r.bg",
	"s.bg",
	"t.bg",
	"u.bg",
	"v.bg",
	"w.bg",
	"x.bg",
	"y.bg",
	"z.bg",
	"bh",
	"com.bh",
	"edu.bh",
	"gov.bh",
	"net.bh",
	"org.bh",
	"bi",
	"co.bi",
	"com.bi",
	"edu.bi",
	"or.bi",
	"org.bi",
	"biz",
	"bj",
	"africa.bj",
	"agro.bj",
	"architectes.bj",
	"assur.bj",
	"avocats.bj",
	"co.bj",
	"com.bj",
	"eco.bj",
	"econo.bj",
	"edu.bj",
	"info.bj",
	"loisirs.bj",
	"money.bj",
	"net.bj",
	"org.bj",
	"ote.bj",
	"restaurant.bj",
	"resto.bj",
	"tourism.bj",
	"univ.bj",
	"bm",
	"com.bm",
	"edu.bm",
	"gov.bm",
	"net.bm",
	"org.bm",
	"bn",
	"com.bn",
	"edu.bn",
	"gov.bn",
	"net.bn",
	"org.bn",
	"bo",
	"com.bo",
	"edu.bo",
	"gob.bo",
	"int.bo",
	"mil.bo",
	"net.bo",
	"org.bo",
	"tv.bo",
	"web.bo",
	"academia.bo",
	"agro.bo",
	"arte.bo",
	"blog.bo",
	"bolivia.bo",
	"ciencia.bo",
	"cooperativa.bo",
	"democracia.bo",
	"deporte.bo",
	"ecologia.bo",
	"economia.bo",
	"empresa.bo",
	"indigena.bo",
	"industria.bo",
	"info.bo",
	"medicina.bo",
	"movimiento.bo",
	"musica.bo",
	"natural.bo",
	"nombre.bo",
	"noticias.bo",
	"patria.bo",
	"plurinacional.bo",
	"politica.bo",
	"profesional.bo",
	"pueblo.bo",
	"revista.bo",
	"salud.bo",
	"tecnologia.bo",
	"tksat.bo",
	"transporte.bo",
	"wiki.bo",
	"br",
	"9guacu.br",
	"abc.br",
	"adm.br",
	"adv.br",
	"agr.br",
	"aju.br",
	"am.br",
	"anani.br",
	"aparecida.br",
	"app.br",
	"arq.br",
	"art.br",
	"ato.br",
	"b.br",
	"barueri.br",
	"belem.br",
	"bet.br",
	"bhz.br",
	"bib.br",
	"bio.br",
	"blog.br",
	"bmd.br",
	"boavista.br",
	"bsb.br",
	"campinagrande.br",
	"campinas.br",
	"caxias.br",
	"cim.br",
	"cng.br",
	"cnt.br",
	"com.br",
	"contagem.br",
	"coop.br",
	"coz.br",
	"cri.br",
	"cuiaba.br",
	"curitiba.br",
	"def.br",
	"des.br",
	"det.br",
	"dev.br",
	"ecn.br",
	"eco.br",
	"edu.br",
	"emp.br",
	"enf.br",
	"eng.br",
	"esp.br",
	"etc.br",
	"eti.br",
	"far.br",
	"feira.br",
	"flog.br",
	"floripa.br",
	"fm.br",
	"fnd.br",
	"fortal.br",
	"fot.br",
	"foz.br",
	"fst.br",
	"g12.br",
	"geo.br",
	"ggf.br",
	"goiania.br",
	"gov.br",
	"ac.gov.br",
	"al.gov.br",
	"am.gov.br",
	"ap.gov.br",
	"ba.gov.br",
	"ce.gov.br",
	"df.gov.br",
	"es.gov.br",
	"go.gov.br",
	"ma.gov.br",
	"mg.gov.br",
	"ms.gov.br",
	"mt.gov.br",
	"pa.gov.br",
	"pb.gov.br",
	"pe.gov.br",
	"pi.gov.br",
	"pr.gov.br",
	"rj.gov.br",
	"rn.gov.br",
	"ro.gov.br",
	"rr.gov.br",
	"rs.gov.br",
	"sc.gov.br",
	"se.gov.br",
	"sp.gov.br",
	"to.gov.br",
	"gru.br",
	"imb.br",
	"ind.br",
	"inf.br",
	"jab.br",
	"jampa.br",
	"jdf.br",
	"joinville.br",
	"jor.br",
	"jus.br",
	"leg.br",
	"leilao.br",
	"lel.br",
	"log.br",
	"londrina.br",
	"macapa.br",
	"maceio.br",
	"manaus.br",
	"maringa.br",
	"mat.br",
	"med.br",
	"mil.br",
	"morena.br",
	"mp.br",
	"mus.br",
	"natal.br",
	"net.br",
	"niteroi.br",
	"*.nom.br",
	"not.br",
	"ntr.br",
	"odo.br",
	"ong.br",
	"org.br",
	"osasco.br",
	"palmas.br",
	"poa.br",
	"ppg.br",
	"pro.br",
	"psc.br",
	"psi.br",
	"pvh.br",
	"qsl.br",
	"radio.br",
	"rec.br",
	"recife.br",
	"rep.br",
	"ribeirao.br",
	"rio.br",
	"riobranco.br",
	"riopreto.br",
	"salvador.br",
	"sampa.br",
	"santamaria.br",
	"santoandre.br",
	"saobernardo.br",
	"saogonca.br",
	"seg.br",
	"sjc.br",
	"slg.br",
	"slz.br",
	"sorocaba.br",
	"srv.br",
	"taxi.br",
	"tc.br",
	"tec.br",
	"teo.br",
	"the.br",
	"tmp.br",
	"trd.br",
	"tur.br",
	"tv.br",
	"udi.br",
	"vet.br",
	"vix.br",
	"vlog.br",
	"wiki.br",
	"zlg.br",
	"bs",
	"com.bs",
	"edu.bs",
	"gov.bs",
	"net.bs",
	"org.bs",
	"bt",
	"com.bt",
	"edu.bt",
	"gov.bt",
	"net.bt",
	"org.bt",
	"bv",
	"bw",
	"co.bw",
	"org.bw",
	"by",
	"gov.by",
	"mil.by",
	"com.by",
	"of.by",
	"bz",
	"co.bz",
	"com.bz",
	"edu.bz",
	"gov.bz",
	"net.bz",
	"org.bz",
	"ca",
	"ab.ca",
	"bc.ca",
	"mb.ca",
	"nb.ca",
	"nf.ca",
	"nl.ca",
	"ns.ca",
	"nt.ca",
	"nu.ca",
	"on.ca",
	"pe.ca",
	"qc.ca",
	"sk.ca",
	"yk.ca",
	"gc.ca",
	"cat",
	"cc",
	"cd",
	"gov.cd",
	"cf",
	"cg",
	"ch",
	"ci",
	"ac.ci",
	"aéroport.ci",
	"asso.ci",
	"co.ci",
	"com.ci",
	"ed.ci",
	"edu.ci",
	"go.ci",
	"gouv.ci",
	"int.ci",
	"net.ci",
	"or.ci",
	"org.ci",
	"*.ck",
	"!www.ck",
	"cl",
	"co.cl",
	"gob.cl",
	"gov.cl",
	"mil.cl",
	"cm",
	"co.cm",
	"com.cm",
	"gov.cm",
	"net.cm",
	"cn",
	"ac.cn",
	"com.cn",
	"edu.cn",
	"gov.cn",
	"mil.cn",
	"net.cn",
	"org.cn",
	"公司.cn",
	"網絡.cn",
	"网络.cn",
	"ah.cn",
	"bj.cn",
	"cq.cn",
	"fj.cn",
	"gd.cn",
	"gs.cn",
	"gx.cn",
	"gz.cn",
	"ha.cn",
	"hb.cn",
	"he.cn",
	"hi.cn",
	"hk.cn",
	"hl.cn",
	"hn.cn",
	"jl.cn",
	"js.cn",
	"jx.cn",
	"ln.cn",
	"mo.cn",
	"nm.cn",
	"nx.cn",
	"qh.cn",
	"sc.cn",
	"sd.cn",
	"sh.cn",
	"sn.cn",
	"sx.cn",
	"tj.cn",
	"tw.cn",
	"xj.cn",
	"xz.cn",
	"yn.cn",
	"zj.cn",
	"co",
	"com.co",
	"edu.co",
	"gov.co",
	"mil.co",
	"net.co",
	"nom.co",
	"org.co",
	"com",
	"coop",
	"cr",
	"ac.cr",
	"co.cr",
	"ed.cr",
	"fi.cr",
	"go.cr",
	"or.cr",
	"sa.cr",
	"cu",
	"com.cu",
	"edu.cu",
	"gob.cu",
	"inf.cu",
	"nat.cu",
	"net.cu",
	"org.cu",
	"cv",
	"com.cv",
	"edu.cv",
	"id.cv",
	"int.cv",
	"net.cv",
	"nome.cv",
	"org.cv",
	"publ.cv",
	"cw",
	"com.cw",
	"edu.cw",
	"net.cw",
	"org.cw",
	"cx",
	"gov.cx",
	"cy",
	"ac.cy",
	"biz.cy",
	"com.cy",
	"ekloges.cy",
	"gov.cy",
	"ltd.cy",
	"mil.cy",
	"net.cy",
	"org.cy",
	"press.cy",
	"pro.cy",
	"tm.cy",
	"cz",
	"de",
	"dj",
	"dk",
	"dm",
	"co.dm",
	"com.dm",
	"edu.dm",
	"gov.dm",
	"net.dm",
	"org.dm",
	"do",
	"art.do",
	"com.do",
	"edu.do",
	"gob.do",
	"gov.do",
	"mil.do",
	"net.do",
	"org.do",
	"sld.do",
	"web.do",
	"dz",
	"art.dz",
	"asso.dz",
	"com.dz",
	"edu.dz",
	"gov.dz",
	"net.dz",
	"org.dz",
	"pol.dz",
	"soc.dz",
	"tm.dz",
	"ec",
	"com.ec",
	"edu.ec",
	"fin.ec",
	"gob.ec",
	"gov.ec",
	"info.ec",
	"k12.ec",
	"med.ec",
	"mil.ec",
	"net.ec",
	"org.ec",
	"pro.ec",
	"edu",
	"ee",
	"aip.ee",
	"com.ee",
	"edu.ee",
	"fie.ee",
	"gov.ee",
	"lib.ee",
	"med.ee",
	"org.ee",
	"pri.ee",
	"riik.ee",
	"eg",
	"ac.eg",
	"com.eg",
	"edu.eg",
	"eun.eg",
	"gov.eg",
	"info.eg",
	"me.eg",
	"mil.eg",
	"name.eg",
	"net.eg",
	"org.eg",
	"sci.eg",
	"sport.eg",
	"tv.eg",
	"*.er",
	"es",
	"com.es",
	"edu.es",
	"gob.es",
	"nom.es",
	"org.es",
	"et",
	"biz.et",
	"com.et",
	"edu.et",
	"gov.et",
	"info.et",
	"name.et",
	"net.et",
	"org.et",
	"eu",
	"fi",
	"aland.fi",
	"fj",
	"ac.fj",
	"biz.fj",
	"com.fj",
	"gov.fj",
	"info.fj",
	"mil.fj",
	"name.fj",
	"net.fj",
	"org.fj",
	"pro.fj",
	"*.fk",
	"fm",
	"com.fm",
	"edu.fm",
	"net.fm",
	"org.fm",
	"fo",
	"fr",
	"asso.fr",
	"com.fr",
	"gouv.fr",
	"nom.fr",
	"prd.fr",
	"tm.fr",
	"avoues.fr",
	"cci.fr",
	"greta.fr",
	"huissier-justice.fr",
	"ga",
	"gb",
	"gd",
	"edu.gd",
	"gov.gd",
	"ge",
	"com.ge",
	"edu.ge",
	"gov.ge",
	"net.ge",
	"org.ge",
	"pvt.ge",
	"school.ge",
	"gf",
	"gg",
	"co.gg",
	"net.gg",
	"org.gg",
	"gh",
	"com.gh",
	"edu.gh",
	"gov.gh",
	"mil.gh",
	"org.gh",
	"gi",
	"com.gi",
	"edu.gi",
	"gov.gi",
	"ltd.gi",
	"mod.gi",
	"org.gi",
	"gl",
	"co.gl",
	"com.gl",
	"edu.gl",
	"net.gl",
	"org.gl",
	"gm",
	"gn",
	"ac.gn",
	"com.gn",
	"edu.gn",
	"gov.gn",
	"net.gn",
	"org.gn",
	"gov",
	"gp",
	"asso.gp",
	"com.gp",
	"edu.gp",
	"mobi.gp",
	"net.gp",
	"org.gp",
	"gq",
	"gr",
	"com.gr",
	"edu.gr",
	"gov.gr",
	"net.gr",
	"org.gr",
	"gs",
	"gt",
	"com.gt",
	"edu.gt",
	"gob.gt",
	"ind.gt",
	"mil.gt",
	"net.gt",
	"org.gt",
	"gu",
	"com.gu",
	"edu.gu",
	"gov.gu",
	"guam.gu",
	"info.gu",
	"net.gu",
	"org.gu",
	"web.gu",
	"gw",
	"gy",
	"co.gy",
	"com.gy",
	"edu.gy",
	"gov.gy",
	"net.gy",
	"org.gy",
	"hk",
	"com.hk",
	"edu.hk",
	"gov.hk",
	"idv.hk",
	"net.hk",
	"org.hk",
	"个人.hk",
	"個人.hk",
	"公司.hk",
	"政府.hk",
	"敎育.hk",
	"教育.hk",
	"箇人.hk",
	"組織.hk",
	"組织.hk",
	"網絡.hk",
	"網络.hk",
	"组織.hk",
	"组织.hk",
	"网絡.hk",
	"网络.hk",
	"hm",
	"hn",
	"com.hn",
	"edu.hn",
	"gob.hn",
	"mil.hn",
	"net.hn",
	"org.hn",
	"hr",
	"com.hr",
	"from.hr",
	"iz.hr",
	"name.hr",
	"ht",
	"adult.ht",
	"art.ht",
	"asso.ht",
	"com.ht",
	"coop.ht",
	"edu.ht",
	"firm.ht",
	"gouv.ht",
	"info.ht",
	"med.ht",
	"net.ht",
	"org.ht",
	"perso.ht",
	"pol.ht",
	"pro.ht",
	"rel.ht",
	"shop.ht",
	"hu",
	"2000.hu",
	"agrar.hu",
	"bolt.hu",
	"casino.hu",
	"city.hu",
	"co.hu",
	"erotica.hu",
	"erotika.hu",
	"film.hu",
	"forum.hu",
	"games.hu",
	"hotel.hu",
	"info.hu",
	"ingatlan.hu",
	"jogasz.hu",
	"konyvelo.hu",
	"lakas.hu",
	"media.hu",
	"news.hu",
	"org.hu",
	"priv.hu",
	"reklam.hu",
	"sex.hu",
	"shop.hu",
	"sport.hu",
	"suli.hu",
	"szex.hu",
	"tm.hu",
	"tozsde.hu",
	"utazas.hu",
	"video.hu",
	"id",
	"ac.id",
	"biz.id",
	"co.id",
	"desa.id",
	"go.id",
	"mil.id",
	"my.id",
	"net.id",
	"or.id",
	"ponpes.id",
	"sch.id",
	"web.id",
	"ie",
	"gov.ie",
	"il",
	"ac.il",
	"co.il",
	"gov.il",
	"idf.il",
	"k12.il",
	"muni.il",
	"net.il",
	"org.il",
	"ישראל",
	"אקדמיה.ישראל",
	"ישוב.ישראל",
	"צהל.ישראל",
	"ממשל.ישראל",
	"im",
	"ac.im",
	"co.im",
	"ltd.co.im",
	"plc.co.im",
	"com.im",
	"net.im",
	"org.im",
	"tt.im",
	"tv.im",
	"in",
	"5g.in",
	"6g.in",
	"ac.in",
	"ai.in",
	"am.in",
	"bihar.in",
	"biz.in",
	"business.in",
	"ca.in",
	"cn.in",
	"co.in",
	"com.in",
	"coop.in",
	"cs.in",
	"delhi.in",
	"dr.in",
	"edu.in",
	"er.in",
	"firm.in",
	"gen.in",
	"gov.in",
	"gujarat.in",
	"ind.in",
	"info.in",
	"int.in",
	"internet.in",
	"io.in",
	"me.in",
	"mil.in",
	"net.in",
	"nic.in",
	"org.in",
	"pg.in",
	"post.in",
	"pro.in",
	"res.in",
	"travel.in",
	"tv.in",
	"uk.in",
	"up.in",
	"us.in",
	"info",
	"int",
	"eu.int",
	"io",
	"co.io",
	"com.io",
	"edu.io",
	"gov.io",
	"mil.io",
	"net.io",
	"nom.io",
	"org.io",
	"iq",
	"com.iq",
	"edu.iq",
	"gov.iq",
	"mil.iq",
	"net.iq",
	"org.iq",
	"ir",
	"ac.ir",
	"co.ir",
	"gov.ir",
	"id.ir",
	"net.ir",
	"org.ir",
	"sch.ir",
	"ایران.ir",
	"ايران.ir",
	"is",
	"it",
	"edu.it",
	"gov.it",
	"abr.it",
	"abruzzo.it",
	"aosta-valley.it",
	"aostavalley.it",
	"bas.it",
	"basilicata.it",
	"cal.it",
	"calabria.it",
	"cam.it",
	"campania.it",
	"emilia-romagna.it",
	"emiliaromagna.it",
	"emr.it",
	"friuli-v-giulia.it",
	"friuli-ve-giulia.it",
	"friuli-vegiulia.it",
	"friuli-venezia-giulia.it",
	"friuli-veneziagiulia.it",
	"friuli-vgiulia.it",
	"friuliv-giulia.it",
	"friulive-giulia.it",
	"friulivegiulia.it",
	"friulivenezia-giulia.it",
	"friuliveneziagiulia.it",
	"friulivgiulia.it",
	"fvg.it",
	"laz.it",
	"lazio.it",
	"lig.it",
	"liguria.it",
	"lom.it",
	"lombardia.it",
	"lombardy.it",
	"lucania.it",
	"mar.it",
	"marche.it",
	"mol.it",
	"molise.it",
	"piedmont.it",
	"piemonte.it",
	"pmn.it",
	"pug.it",
	"puglia.it",
	"sar.it",
	"sardegna.it",
	"sardinia.it",
	"sic.it",
	"sicilia.it",
	"sicily.it",
	"taa.it",
	"tos.it",
	"toscana.it",
	"trentin-sud-tirol.it",
	"trentin-süd-tirol.it",
	"trentin-sudtirol.it",
	"trentin-südtirol.it",
	"trentin-sued-tirol.it",
	"trentin-suedtirol.it",
	"trentino.it",
	"trentino-a-adige.it",
	"trentino-aadige.it",
	"trentino-alto-adige.it",
	"trentino-altoadige.it",
	"trentino-s-tirol.it",
	"trentino-stirol.it",
	"trentino-sud-tirol.it",
	"trentino-süd-tirol.it",
	"trentino-sudtirol.it",
	"trentino-südtirol.it",
	"trentino-sued-tirol.it",
	"trentino-suedtirol.it",
	"trentinoa-adige.it",
	"trentinoaadige.it",
	"trentinoalto-adige.it",
	"trentinoaltoadige.it",
	"trentinos-tirol.it",
	"trentinostirol.it",
	"trentinosud-tirol.it",
	"trentinosüd-tirol.it",
	"trentinosudtirol.it",
	"trentinosüdtirol.it",
	"trentinosued-tirol.it",
	"trentinosuedtirol.it",
	"trentinsud-tirol.it",
	"trentinsüd-tirol.it",
	"trentinsudtirol.it",
	"trentinsüdtirol.it",
	"trentinsued-tirol.it",
	"trentinsuedtirol.it",
	"tuscany.it",
	"umb.it",
	"umbria.it",
	"val-d-aosta.it",
	"val-daosta.it",
	"vald-aosta.it",
	"valdaosta.it",
	"valle-aosta.it",
	"valle-d-aosta.it",
	"valle-daosta.it",
	"valleaosta.it",
	"valled-aosta.it",
	"valledaosta.it",
	"vallee-aoste.it",
	"vallée-aoste.it",
	"vallee-d-aoste.it",
	"vallée-d-aoste.it",
	"valleeaoste.it",
	"valléeaoste.it",
	"valleedaoste.it",
	"valléedaoste.it",
	"vao.it",
	"vda.it",
	"ven.it",
	"veneto.it",
	"ag.it",
	"agrigento.it",
	"al.it",
	"alessandria.it",
	"alto-adige.it",
	"altoadige.it",
	"an.it",
	"ancona.it",
	"andria-barletta-trani.it",
	"andria-trani-barletta.it",
	"andriabarlettatrani.it",
	"andriatranibarletta.it",
	"ao.it",
	"aosta.it",
	"aoste.it",
	"ap.it",
	"aq.it",
	"aquila.it",
	"ar.it",
	"arezzo.it",
	"ascoli-piceno.it",
	"ascolipiceno.it",
	"asti.it",
	"at.it",
	"av.it",
	"avellino.it",
	"ba.it",
	"balsan.it",
	"balsan-sudtirol.it",
	"balsan-südtirol.it",
	"balsan-suedtirol.it",
	"bari.it",
	"barletta-trani-andria.it",
	"barlettatraniandria.it",
	"belluno.it",
	"benevento.it",
	"bergamo.it",
	"bg.it",
	"bi.it",
	"biella.it",
	"bl.it",
	"bn.it",
	"bo.it",
	"bologna.it",
	"bolzano.it",
	"bolzano-altoadige.it",
	"bozen.it",
	"bozen-sudtirol.it",
	"bozen-südtirol.it",
	"bozen-suedtirol.it",
	"br.it",
	"brescia.it",
	"brindisi.it",
	"bs.it",
	"bt.it",
	"bulsan.it",
	"bulsan-sudtirol.it",
	"bulsan-südtirol.it",
	"bulsan-suedtirol.it",
	"bz.it",
	"ca.it",
	"cagliari.it",
	"caltanissetta.it",
	"campidano-medio.it",
	"campidanomedio.it",
	"campobasso.it",
	"carbonia-iglesias.it",
	"carboniaiglesias.it",
	"carrara-massa.it",
	"carraramassa.it",
	"caserta.it",
	"catania.it",
	"catanzaro.it",
	"cb.it",
	"ce.it",
	"cesena-forli.it",
	"cesena-forlì.it",
	"cesenaforli.it",
	"cesenaforlì.it",
	"ch.it",
	"chieti.it",
	"ci.it",
	"cl.it",
	"cn.it",
	"co.it",
	"como.it",
	"cosenza.it",
	"cr.it",
	"cremona.it",
	"crotone.it",
	"cs.it",
	"ct.it",
	"cuneo.it",
	"cz.it",
	"dell-ogliastra.it",
	"dellogliastra.it",
	"en.it",
	"enna.it",
	"fc.it",
	"fe.it",
	"fermo.it",
	"ferrara.it",
	"fg.it",
	"fi.it",
	"firenze.it",
	"florence.it",
	"fm.it",
	"foggia.it",
	"forli-cesena.it",
	"forlì-cesena.it",
	"forlicesena.it",
	"forlìcesena.it",
	"fr.it",
	"frosinone.it",
	"ge.it",
	"genoa.it",
	"genova.it",
	"go.it",
	"gorizia.it",
	"gr.it",
	"grosseto.it",
	"iglesias-carbonia.it",
	"iglesiascarbonia.it",
	"im.it",
	"imperia.it",
	"is.it",
	"isernia.it",
	"kr.it",
	"la-spezia.it",
	"laquila.it",
	"laspezia.it",
	"latina.it",
	"lc.it",
	"le.it",
	"lecce.it",
	"lecco.it",
	"li.it",
	"livorno.it",
	"lo.it",
	"lodi.it",
	"lt.it",
	"lu.it",
	"lucca.it",
	"macerata.it",
	"mantova.it",
	"massa-carrara.it",
	"massacarrara.it",
	"matera.it",
	"mb.it",
	"mc.it",
	"me.it",
	"medio-campidano.it",
	"mediocampidano.it",
	"messina.it",
	"mi.it",
	"milan.it",
	"milano.it",
	"mn.it",
	"mo.it",
	"modena.it",
	"monza.it",
	"monza-brianza.it",
	"monza-e-della-brianza.it",
	"monzabrianza.it",
	"monzaebrianza.it",
	"monzaedellabrianza.it",
	"ms.it",
	"mt.it",
	"na.it",
	"naples.it",
	"napoli.it",
	"no.it",
	"novara.it",
	"nu.it",
	"nuoro.it",
	"og.it",
	"ogliastra.it",
	"olbia-tempio.it",
	"olbiatempio.it",
	"or.it",
	"oristano.it",
	"ot.it",
	"pa.it",
	"padova.it",
	"padua.it",
	"palermo.it",
	"parma.it",
	"pavia.it",
	"pc.it",
	"pd.it",
	"pe.it",
	"perugia.it",
	"pesaro-urbino.it",
	"pesarourbino.it",
	"pescara.it",
	"pg.it",
	"pi.it",
	"piacenza.it",
	"pisa.it",
	"pistoia.it",
	"pn.it",
	"po.it",
	"pordenone.it",
	"potenza.it",
	"pr.it",
	"prato.it",
	"pt.it",
	"pu.it",
	"pv.it",
	"pz.it",
	"ra.it",
	"ragusa.it",
	"ravenna.it",
	"rc.it",
	"re.it",
	"reggio-calabria.it",
	"reggio-emilia.it",
	"reggiocalabria.it",
	"reggioemilia.it",
	"rg.it",
	"ri.it",
	"rieti.it",
	"rimini.it",
	"rm.it",
	"rn.it",
	"ro.it",
	"roma.it",
	"rome.it",
	"rovigo.it",
	"sa.it",
	"salerno.it",
	"sassari.it",
	"savona.it",
	"si.it",
	"siena.it",
	"siracusa.it",
	"so.it",
	"sondrio.it",
	"sp.it",
	"sr.it",
	"ss.it",
	"südtirol.it",
	"suedtirol.it",
	"sv.it",
	"ta.it",
	"taranto.it",
	"te.it",
	"tempio-olbia.it",
	"tempioolbia.it",
	"teramo.it",
	"terni.it",
	"tn.it",
	"to.it",
	"torino.it",
	"tp.it",
	"tr.it",
	"trani-andria-barletta.it",
	"trani-barletta-andria.it",
	"traniandriabarletta.it",
	"tranibarlettaandria.it",
	"trapani.it",
	"trento.it",
	"treviso.it",
	"trieste.it",
	"ts.it",
	"turin.it",
	"tv.it",
	"ud.it",
	"udine.it",
	"urbino-pesaro.it",
	"urbinopesaro.it",
	"va.it",
	"varese.it",
	"vb.it",
	"vc.it",
	"ve.it",
	"venezia.it",
	"venice.it",
	"verbania.it",
	"vercelli.it",
	"verona.it",
	"vi.it",
	"vibo-valentia.it",
	"vibovalentia.it",
	"vicenza.it",
	"viterbo.it",
	"vr.it",
	"vs.it",
	"vt.it",
	"vv.it",
	"je",
	"co.je",
	"net.je",
	"org.je",
	"*.jm",
	"jo",
	"agri.jo",
	"ai.jo",
	"com.jo",
	"edu.jo",
	"eng.jo",
	"fm.jo",
	"gov.jo",
	"mil.jo",
	"net.jo",
	"org.jo",
	"per.jo",
	"phd.jo",
	"sch.jo",
	"tv.jo",
	"jobs",
	"jp",
	"ac.jp",
	"ad.jp",
	"co.jp",
	"ed.jp",
	"go.jp",
	"gr.jp",
	"lg.jp",
	"ne.jp",
	"or.jp",
	"aichi.jp",
	"akita.jp",
	"aomori.jp",
	"chiba.jp",
	"ehime.jp",
	"fukui.jp",
	"fukuoka.jp",
	"fukushima.jp",
	"gifu.jp",
	"gunma.jp",
	"hiroshima.jp",
	"hokkaido.jp",
	"hyogo.jp",
	"ibaraki.jp",
	"ishikawa.jp",
	"iwate.jp",
	"kagawa.jp",
	"kagoshima.jp",
	"kanagawa.jp",
	"kochi.jp",
	"kumamoto.jp",
	"kyoto.jp",
	"mie.jp",
	"miyagi.jp",
	"miyazaki.jp",
	"nagano.jp",
	"nagasaki.jp",
	"nara.jp",
	"niigata.jp",
	"oita.jp",
	"okayama.jp",
	"okinawa.jp",
	"osaka.jp",
	"saga.jp",
	"saitama.jp",
	"shiga.jp",
	"shimane.jp",
	"shizuoka.jp",
	"tochigi.jp",
	"tokushima.jp",
	"tokyo.jp",
	"tottori.jp",
	"toyama.jp",
	"wakayama.jp",
	"yamagata.jp",
	"yamaguchi.jp",
	"yamanashi.jp",
	"三重.jp",
	"京都.jp",
	"佐賀.jp",
	"兵庫.jp",
	"北海道.jp",
	"千葉.jp",
	"和歌山.jp",
	"埼玉.jp",
	"大分.jp",
	"大阪.jp",
	"奈良.jp",
	"宮城.jp",
	"宮崎.jp",
	"富山.jp",
	"山口.jp",
	"山形.jp",
	"山梨.jp",
	"岐阜.jp",
	"岡山.jp",
	"岩手.jp",
	"島根.jp",
	"広島.jp",
	"徳島.jp",
	"愛媛.jp",
	"愛知.jp",
	"新潟.jp",
	"東京.jp",
	"栃木.jp",
	"沖縄.jp",
	"滋賀.jp",
	"熊本.jp",
	"石川.jp",
	"神奈川.jp",
	"福井.jp",
	"福岡.jp",
	"福島.jp",
	"秋田.jp",
	"群馬.jp",
	"茨城.jp",
	"長崎.jp",
	"長野.jp",
	"青森.jp",
	"静岡.jp",
	"香川.jp",
	"高知.jp",
	"鳥取.jp",
	"鹿児島.jp",
	"*.kawasaki.jp",
	"!city.kawasaki.jp",
	"*.kitakyushu.jp",
	"!city.kitakyushu.jp",
	"*.kobe.jp",
	"!city.kobe.jp",
	"*.nagoya.jp",
	"!city.nagoya.jp",
	"*.sapporo.jp",
	"!city.sapporo.jp",
	"*.sendai.jp",
	"!city.sendai.jp",
	"*.yokohama.jp",
	"!city.yokohama.jp",
	"aisai.aichi.jp",
	"ama.aichi.jp",
	"anjo.aichi.jp",
	"asuke.aichi.jp",
	"chiryu.aichi.jp",
	"chita.aichi.jp",
	"fuso.aichi.jp",
	"gamagori.aichi.jp",
	"handa.aichi.jp",
	"hazu.aichi.jp",
	"hekinan.aichi.jp",
	"higashiura.aichi.jp",
	"ichinomiya.aichi.jp",
	"inazawa.aichi.jp",
	"inuyama.aichi.jp",
	"isshiki.aichi.jp",
	"iwakura.aichi.jp",
	"kanie.aichi.jp",
	"kariya.aichi.jp",
	"kasugai.aichi.jp",
	"kira.aichi.jp",
	"kiyosu.aichi.jp",
	"komaki.aichi.jp",
	"konan.aichi.jp",
	"kota.aichi.jp",
	"mihama.aichi.jp",
	"miyoshi.aichi.jp",
	"nishio.aichi.jp",
	"nisshin.aichi.jp",
	"obu.aichi.jp",
	"oguchi.aichi.jp",
	"oharu.aichi.jp",
	"okazaki.aichi.jp",
	"owariasahi.aichi.jp",
	"seto.aichi.jp",
	"shikatsu.aichi.jp",
	"shinshiro.aichi.jp",
	"shitara.aichi.jp",
	"tahara.aichi.jp",
	"takahama.aichi.jp",
	"tobishima.aichi.jp",
	"toei.aichi.jp",
	"togo.aichi.jp",
	"tokai.aichi.jp",
	"tokoname.aichi.jp",
	"toyoake.aichi.jp",
	"toyohashi.aichi.jp",
	"toyokawa.aichi.jp",
	"toyone.aichi.jp",
	"toyota.aichi.jp",
	"tsushima.aichi.jp",
	"yatomi.aichi.jp",
	"akita.akita.jp",
	"daisen.akita.jp",
	"fujisato.akita.jp",
	"gojome.akita.jp",
	"hachirogata.akita.jp",
	"happou.akita.jp",
	"higashinaruse.akita.jp",
	"honjo.akita.jp",
	"honjyo.akita.jp",
	"ikawa.akita.jp",
	"kamikoani.akita.jp",
	"kamioka.akita.jp",
	"katagami.akita.jp",
	"kazuno.akita.jp",
	"kitaakita.akita.jp",
	"kosaka.akita.jp",
	"kyowa.akita.jp",
	"misato.akita.jp",
	"mitane.akita.jp",
	"moriyoshi.akita.jp",
	"nikaho.akita.jp",
	"noshiro.akita.jp",
	"odate.akita.jp",
	"oga.akita.jp",
	"ogata.akita.jp",
	"semboku.akita.jp",
	"yokote.akita.jp",
	"yurihonjo.akita.jp",
	"aomori.aomori.jp",
	"gonohe.aomori.jp",
	"hachinohe.aomori.jp",
	"hashikami.aomori.jp",
	"hiranai.aomori.jp",
	"hirosaki.aomori.jp",
	"itayanagi.aomori.jp",
	"kuroishi.aomori.jp",
	"misawa.aomori.jp",
	"mutsu.aomori.jp",
	"nakadomari.aomori.jp",
	"noheji.aomori.jp",
	"oirase.aomori.jp",
	"owani.aomori.jp",
	"rokunohe.aomori.jp",
	"sannohe.aomori.jp",
	"shichinohe.aomori.jp",
	"shingo.aomori.jp",
	"takko.aomori.jp",
	"towada.aomori.jp",
	"tsugaru.aomori.jp",
	"tsuruta.aomori.jp",
	"abiko.chiba.jp",
	"asahi.chiba.jp",
	"chonan.chiba.jp",
	"chosei.chiba.jp",
	"choshi.chiba.jp",
	"chuo.chiba.jp",
	"funabashi.chiba.jp",
	"futtsu.chiba.jp",
	"hanamigawa.chiba.jp",
	"ichihara.chiba.jp",
	"ichikawa.chiba.jp",
	"ichinomiya.chiba.jp",
	"inzai.chiba.jp",
	"isumi.chiba.jp",
	"kamagaya.chiba.jp",
	"kamogawa.chiba.jp",
	"kashiwa.chiba.jp",
	"katori.chiba.jp",
	"katsuura.chiba.jp",
	"kimitsu.chiba.jp",
	"kisarazu.chiba.jp",
	"kozaki.chiba.jp",
	"kujukuri.chiba.jp",
	"kyonan.chiba.jp",
	"matsudo.chiba.jp",
	"midori.chiba.jp",
	"mihama.chiba.jp",
	"minamiboso.chiba.jp",
	"mobara.chiba.jp",
	"mutsuzawa.chiba.jp",
	"nagara.chiba.jp",
	"nagareyama.chiba.jp",
	"narashino.chiba.jp",
	"narita.chiba.jp",
	"noda.chiba.jp",
	"oamishirasato.chiba.jp",
	"omigawa.chiba.jp",
	"onjuku.chiba.jp",
	"otaki.chiba.jp",
	"sakae.chiba.jp",
	"sakura.chiba.jp",
	"shimofusa.chiba.jp",
	"shirako.chiba.jp",
	"shiroi.chiba.jp",
	"shisui.chiba.jp",
	"sodegaura.chiba.jp",
	"sosa.chiba.jp",
	"tako.chiba.jp",
	"tateyama.chiba.jp",
	"togane.chiba.jp",
	"tohnosho.chiba.jp",
	"tomisato.chiba.jp",
	"urayasu.chiba.jp",
	"yachimata.chiba.jp",
	"yachiyo.chiba.jp",
	"yokaichiba.chiba.jp",
	"yokoshibahikari.chiba.jp",
	"yotsukaido.chiba.jp",
	"ainan.ehime.jp",
	"honai.ehime.jp",
	"ikata.ehime.jp",
	"imabari.ehime.jp",
	"iyo.ehime.jp",
	"kamijima.ehime.jp",
	"kihoku.ehime.jp",
	"kumakogen.ehime.jp",
	"masaki.ehime.jp",
	"matsuno.ehime.jp",
	"matsuyama.ehime.jp",
	"namikata.ehime.jp",
	"niihama.ehime.jp",
	"ozu.ehime.jp",
	"saijo.ehime.jp",
	"seiyo.ehime.jp",
	"shikokuchuo.ehime.jp",
	"tobe.ehime.jp",
	"toon.ehime.jp",
	"uchiko.ehime.jp",
	"uwajima.ehime.jp",
	"yawatahama.ehime.jp",
	"echizen.fukui.jp",
	"eiheiji.fukui.jp",
	"fukui.fukui.jp",
	"ikeda.fukui.jp",
	"katsuyama.fukui.jp",
	"mihama.fukui.jp",
	"minamiechizen.fukui.jp",
	"obama.fukui.jp",
	"ohi.fukui.jp",
	"ono.fukui.jp",
	"sabae.fukui.jp",
	"sakai.fukui.jp",
	"takahama.fukui.jp",
	"tsuruga.fukui.jp",
	"wakasa.fukui.jp",
	"ashiya.fukuoka.jp",
	"buzen.fukuoka.jp",
	"chikugo.fukuoka.jp",
	"chikuho.fukuoka.jp",
	"chikujo.fukuoka.jp",
	"chikushino.fukuoka.jp",
	"chikuzen.fukuoka.jp",
	"chuo.fukuoka.jp",
	"dazaifu.fukuoka.jp",
	"fukuchi.fukuoka.jp",
	"hakata.fukuoka.jp",
	"higashi.fukuoka.jp",
	"hirokawa.fukuoka.jp",
	"hisayama.fukuoka.jp",
	"iizuka.fukuoka.jp",
	"inatsuki.fukuoka.jp",
	"kaho.fukuoka.jp",
	"kasuga.fukuoka.jp",
	"kasuya.fukuoka.jp",
	"kawara.fukuoka.jp",
	"keisen.fukuoka.jp",
	"koga.fukuoka.jp",
	"kurate.fukuoka.jp",
	"kurogi.fukuoka.jp",
	"kurume.fukuoka.jp",
	"minami.fukuoka.jp",
	"miyako.fukuoka.jp",
	"miyama.fukuoka.jp",
	"miyawaka.fukuoka.jp",
	"mizumaki.fukuoka.jp",
	"munakata.fukuoka.jp",
	"nakagawa.fukuoka.jp",
	"nakama.fukuoka.jp",
	"nishi.fukuoka.jp",
	"nogata.fukuoka.jp",
	"ogori.fukuoka.jp",
	"okagaki.fukuoka.jp",
	"okawa.fukuoka.jp",
	"oki.fukuoka.jp",
	"omuta.fukuoka.jp",
	"onga.fukuoka.jp",
	"onojo.fukuoka.jp",
	"oto.fukuoka.jp",
	"saigawa.fukuoka.jp",
	"sasaguri.fukuoka.jp",
	"shingu.fukuoka.jp",
	"shinyoshitomi.fukuoka.jp",
	"shonai.fukuoka.jp",
	"soeda.fukuoka.jp",
	"sue.fukuoka.jp",
	"tachiarai.fukuoka.jp",
	"tagawa.fukuoka.jp",
	"takata.fukuoka.jp",
	"toho.fukuoka.jp",
	"toyotsu.fukuoka.jp",
	"tsuiki.fukuoka.jp",
	"ukiha.fukuoka.jp",
	"umi.fukuoka.jp",
	"usui.fukuoka.jp",
	"yamada.fukuoka.jp",
	"yame.fukuoka.jp",
	"yanagawa.fukuoka.jp",
	"yukuhashi.fukuoka.jp",
	"aizubange.fukushima.jp",
	"aizumisato.fukushima.jp",
	"aizuwakamatsu.fukushima.jp",
	"asakawa.fukushima.jp",
	"bandai.fukushima.jp",
	"date.fukushima.jp",
	"fukushima.fukushima.jp",
	"furudono.fukushima.jp",
	"futaba.fukushima.jp",
	"hanawa.fukushima.jp",
	"higashi.fukushima.jp",
	"hirata.fukushima.jp",
	"hirono.fukushima.jp",
	"iitate.fukushima.jp",
	"inawashiro.fukushima.jp",
	"ishikawa.fukushima.jp",
	"iwaki.fukushima.jp",
	"izumizaki.fukushima.jp",
	"kagamiishi.fukushima.jp",
	"kaneyama.fukushima.jp",
	"kawamata.fukushima.jp",
	"kitakata.fukushima.jp",
	"kitashiobara.fukushima.jp",
	"koori.fukushima.jp",
	"koriyama.fukushima.jp",
	"kunimi.fukushima.jp",
	"miharu.fukushima.jp",
	"mishima.fukushima.jp",
	"namie.fukushima.jp",
	"nango.fukushima.jp",
	"nishiaizu.fukushima.jp",
	"nishigo.fukushima.jp",
	"okuma.fukushima.jp",
	"omotego.fukushima.jp",
	"ono.fukushima.jp",
	"otama.fukushima.jp",
	"samegawa.fukushima.jp",
	"shimogo.fukushima.jp",
	"shirakawa.fukushima.jp",
	"showa.fukushima.jp",
	"soma.fukushima.jp",
	"sukagawa.fukushima.jp",
	"taishin.fukushima.jp",
	"tamakawa.fukushima.jp",
	"tanagura.fukushima.jp",
	"tenei.fukushima.jp",
	"yabuki.fukushima.jp",
	"yamato.fukushima.jp",
	"yamatsuri.fukushima.jp",
	"yanaizu.fukushima.jp",
	"yugawa.fukushima.jp",
	"anpachi.gifu.jp",
	"ena.gifu.jp",
	"gifu.gifu.jp",
	"ginan.gifu.jp",
	"godo.gifu.jp",
	"gujo.gifu.jp",
	"hashima.gifu.jp",
	"hichiso.gifu.jp",
	"hida.gifu.jp",
	"higashishirakawa.gifu.jp",
	"ibigawa.gifu.jp",
	"ikeda.gifu.jp",
	"kakamigahara.gifu.jp",
	"kani.gifu.jp",
	"kasahara.gifu.jp",
	"kasamatsu.gifu.jp",
	"kawaue.gifu.jp",
	"kitagata.gifu.jp",
	"mino.gifu.jp",
	"minokamo.gifu.jp",
	"mitake.gifu.jp",
	"mizunami.gifu.jp",
	"motosu.gifu.jp",
	"nakatsugawa.gifu.jp",
	"ogaki.gifu.jp",
	"sakahogi.gifu.jp",
	"seki.gifu.jp",
	"sekigahara.gifu.jp",
	"shirakawa.gifu.jp",
	"tajimi.gifu.jp",
	"takayama.gifu.jp",
	"tarui.gifu.jp",
	"toki.gifu.jp",
	"tomika.gifu.jp",
	"wanouchi.gifu.jp",
	"yamagata.gifu.jp",
	"yaotsu.gifu.jp",
	"yoro.gifu.jp",
	"annaka.gunma.jp",
	"chiyoda.gunma.jp",
	"fujioka.gunma.jp",
	"higashiagatsuma.gunma.jp",
	"isesaki.gunma.jp",
	"itakura.gunma.jp",
	"kanna.gunma.jp",
	"kanra.gunma.jp",
	"katashina.gunma.jp",
	"kawaba.gunma.jp",
	"kiryu.gunma.jp",
	"kusatsu.gunma.jp",
	"maebashi.gunma.jp",
	"meiwa.gunma.jp",
	"midori.gunma.jp",
	"minakami.gunma.jp",
	"naganohara.gunma.jp",
	"nakanojo.gunma.jp",
	"nanmoku.gunma.jp",
	"numata.gunma.jp",
	"oizumi.gunma.jp",
	"ora.gunma.jp",
	"ota.gunma.jp",
	"shibukawa.gunma.jp",
	"shimonita.gunma.jp",
	"shinto.gunma.jp",
	"showa.gunma.jp",
	"takasaki.gunma.jp",
	"takayama.gunma.jp",
	"tamamura.gunma.jp",
	"tatebayashi.gunma.jp",
	"tomioka.gunma.jp",
	"tsukiyono.gunma.jp",
	"tsumagoi.gunma.jp",
	"ueno.gunma.jp",
	"yoshioka.gunma.jp",
	"asaminami.hiroshima.jp",
	"daiwa.hiroshima.jp",
	"etajima.hiroshima.jp",
	"fuchu.hiroshima.jp",
	"fukuyama.hiroshima.jp",
	"hatsukaichi.hiroshima.jp",
	"higashihiroshima.hiroshima.jp",
	"hongo.hiroshima.jp",
	"jinsekikogen.hiroshima.jp",
	"kaita.hiroshima.jp",
	"kui.hiroshima.jp",
	"kumano.hiroshima.jp",
	"kure.hiroshima.jp",
	"mihara.hiroshima.jp",
	"miyoshi.hiroshima.jp",
	"naka.hiroshima.jp",
	"onomichi.hiroshima.jp",
	"osakikamijima.hiroshima.jp",
	"otake.hiroshima.jp",
	"saka.hiroshima.jp",
	"sera.hiroshima.jp",
	"seranishi.hiroshima.jp",
	"shinichi.hiroshima.jp",
	"shobara.hiroshima.jp",
	"takehara.hiroshima.jp",
	"abashiri.hokkaido.jp",
	"abira.hokkaido.jp",
	"aibetsu.hokkaido.jp",
	"akabira.hokkaido.jp",
	"akkeshi.hokkaido.jp",
	"asahikawa.hokkaido.jp",
	"ashibetsu.hokkaido.jp",
	"ashoro.hokkaido.jp",
	"assabu.hokkaido.jp",
	"atsuma.hokkaido.jp",
	"bibai.hokkaido.jp",
	"biei.hokkaido.jp",
	"bifuka.hokkaido.jp",
	"bihoro.hokkaido.jp",
	"biratori.hokkaido.jp",
	"chippubetsu.hokkaido.jp",
	"chitose.hokkaido.jp",
	"date.hokkaido.jp",
	"ebetsu.hokkaido.jp",
	"embetsu.hokkaido.jp",
	"eniwa.hokkaido.jp",
	"erimo.hokkaido.jp",
	"esan.hokkaido.jp",
	"esashi.hokkaido.jp",
	"fukagawa.hokkaido.jp",
	"fukushima.hokkaido.jp",
	"furano.hokkaido.jp",
	"furubira.hokkaido.jp",
	"haboro.hokkaido.jp",
	"hakodate.hokkaido.jp",
	"hamatonbetsu.hokkaido.jp",
	"hidaka.hokkaido.jp",
	"higashikagura.hokkaido.jp",
	"higashikawa.hokkaido.jp",
	"hiroo.hokkaido.jp",
	"hokuryu.hokkaido.jp",
	"hokuto.hokkaido.jp",
	"honbetsu.hokkaido.jp",
	"horokanai.hokkaido.jp",
	"horonobe.hokkaido.jp",
	"ikeda.hokkaido.jp",
	"imakane.hokkaido.jp",
	"ishikari.hokkaido.jp",
	"iwamizawa.hokkaido.jp",
	"iwanai.hokkaido.jp",
	"kamifurano.hokkaido.jp",
	"kamikawa.hokkaido.jp",
	"kamishihoro.hokkaido.jp",
	"kamisunagawa.hokkaido.jp",
	"kamoenai.hokkaido.jp",
	"kayabe.hokkaido.jp",
	"kembuchi.hokkaido.jp",
	"kikonai.hokkaido.jp",
	"kimobetsu.hokkaido.jp",
	"kitahiroshima.hokkaido.jp",
	"kitami.hokkaido.jp",
	"kiyosato.hokkaido.jp",
	"koshimizu.hokkaido.jp",
	"kunneppu.hokkaido.jp",
	"kuriyama.hokkaido.jp",
	"kuromatsunai.hokkaido.jp",
	"kushiro.hokkaido.jp",
	"kutchan.hokkaido.jp",
	"kyowa.hokkaido.jp",
	"mashike.hokkaido.jp",
	"matsumae.hokkaido.jp",
	"mikasa.hokkaido.jp",
	"minamifurano.hokkaido.jp",
	"mombetsu.hokkaido.jp",
	"moseushi.hokkaido.jp",
	"mukawa.hokkaido.jp",
	"muroran.hokkaido.jp",
	"naie.hokkaido.jp",
	"nakagawa.hokkaido.jp",
	"nakasatsunai.hokkaido.jp",
	"nakatombetsu.hokkaido.jp",
	"nanae.hokkaido.jp",
	"nanporo.hokkaido.jp",
	"nayoro.hokkaido.jp",
	"nemuro.hokkaido.jp",
	"niikappu.hokkaido.jp",
	"niki.hokkaido.jp",
	"nishiokoppe.hokkaido.jp",
	"noboribetsu.hokkaido.jp",
	"numata.hokkaido.jp",
	"obihiro.hokkaido.jp",
	"obira.hokkaido.jp",
	"oketo.hokkaido.jp",
	"okoppe.hokkaido.jp",
	"otaru.hokkaido.jp",
	"otobe.hokkaido.jp",
	"otofuke.hokkaido.jp",
	"otoineppu.hokkaido.jp",
	"oumu.hokkaido.jp",
	"ozora.hokkaido.jp",
	"pippu.hokkaido.jp",
	"rankoshi.hokkaido.jp",
	"rebun.hokkaido.jp",
	"rikubetsu.hokkaido.jp",
	"rishiri.hokkaido.jp",
	"rishirifuji.hokkaido.jp",
	"saroma.hokkaido.jp",
	"sarufutsu.hokkaido.jp",
	"shakotan.hokkaido.jp",
	"shari.hokkaido.jp",
	"shibecha.hokkaido.jp",
	"shibetsu.hokkaido.jp",
	"shikabe.hokkaido.jp",
	"shikaoi.hokkaido.jp",
	"shimamaki.hokkaido.jp",
	"shimizu.hokkaido.jp",
	"shimokawa.hokkaido.jp",
	"shinshinotsu.hokkaido.jp",
	"shintoku.hokkaido.jp",
	"shiranuka.hokkaido.jp",
	"shiraoi.hokkaido.jp",
	"shiriuchi.hokkaido.jp",
	"sobetsu.hokkaido.jp",
	"sunagawa.hokkaido.jp",
	"taiki.hokkaido.jp",
	"takasu.hokkaido.jp",
	"takikawa.hokkaido.jp",
	"takinoue.hokkaido.jp",
	"teshikaga.hokkaido.jp",
	"tobetsu.hokkaido.jp",
	"tohma.hokkaido.jp",
	"tomakomai.hokkaido.jp",
	"tomari.hokkaido.jp",
	"toya.hokkaido.jp",
	"toyako.hokkaido.jp",
	"toyotomi.hokkaido.jp",
	"toyoura.hokkaido.jp",
	"tsubetsu.hokkaido.jp",
	"tsukigata.hokkaido.jp",
	"urakawa.hokkaido.jp",
	"urausu.hokkaido.jp",
	"uryu.hokkaido.jp",
	"utashinai.hokkaido.jp",
	"wakkanai.hokkaido.jp",
	"wassamu.hokkaido.jp",
	"yakumo.hokkaido.jp",
	"yoichi.hokkaido.jp",
	"aioi.hyogo.jp",
	"akashi.hyogo.jp",
	"ako.hyogo.jp",
	"amagasaki.hyogo.jp",
	"aogaki.hyogo.jp",
	"asago.hyogo.jp",
	"ashiya.hyogo.jp",
	"awaji.hyogo.jp",
	"fukusaki.hyogo.jp",
	"goshiki.hyogo.jp",
	"harima.hyogo.jp",
	"himeji.hyogo.jp",
	"ichikawa.hyogo.jp",
	"inagawa.hyogo.jp",
	"itami.hyogo.jp",
	"kakogawa.hyogo.jp",
	"kamigori.hyogo.jp",
	"kamikawa.hyogo.jp",
	"kasai.hyogo.jp",
	"kasuga.hyogo.jp",
	"kawanishi.hyogo.jp",
	"miki.hyogo.jp",
	"minamiawaji.hyogo.jp",
	"nishinomiya.hyogo.jp",
	"nishiwaki.hyogo.jp",
	"ono.hyogo.jp",
	"sanda.hyogo.jp",
	"sannan.hyogo.jp",
	"sasayama.hyogo.jp",
	"sayo.hyogo.jp",
	"shingu.hyogo.jp",
	"shinonsen.hyogo.jp",
	"shiso.hyogo.jp",
	"sumoto.hyogo.jp",
	"taishi.hyogo.jp",
	"taka.hyogo.jp",
	"takarazuka.hyogo.jp",
	"takasago.hyogo.jp",
	"takino.hyogo.jp",
	"tamba.hyogo.jp",
	"tatsuno.hyogo.jp",
	"toyooka.hyogo.jp",
	"yabu.hyogo.jp",
	"yashiro.hyogo.jp",
	"yoka.hyogo.jp",
	"yokawa.hyogo.jp",
	"ami.ibaraki.jp",
	"asahi.ibaraki.jp",
	"bando.ibaraki.jp",
	"chikusei.ibaraki.jp",
	"daigo.ibaraki.jp",
	"fujishiro.ibaraki.jp",
	"hitachi.ibaraki.jp",
	"hitachinaka.ibaraki.jp",
	"hitachiomiya.ibaraki.jp",
	"hitachiota.ibaraki.jp",
	"ibaraki.ibaraki.jp",
	"ina.ibaraki.jp",
	"inashiki.ibaraki.jp",
	"itako.ibaraki.jp",
	"iwama.ibaraki.jp",
	"joso.ibaraki.jp",
	"kamisu.ibaraki.jp",
	"kasama.ibaraki.jp",
	"kashima.ibaraki.jp",
	"kasumigaura.ibaraki.jp",
	"koga.ibaraki.jp",
	"miho.ibaraki.jp",
	"mito.ibaraki.jp",
	"moriya.ibaraki.jp",
	"naka.ibaraki.jp",
	"namegata.ibaraki.jp",
	"oarai.ibaraki.jp",
	"ogawa.ibaraki.jp",
	"omitama.ibaraki.jp",
	"ryugasaki.ibaraki.jp",
	"sakai.ibaraki.jp",
	"sakuragawa.ibaraki.jp",
	"shimodate.ibaraki.jp",
	"shimotsuma.ibaraki.jp",
	"shirosato.ibaraki.jp",
	"sowa.ibaraki.jp",
	"suifu.ibaraki.jp",
	"takahagi.ibaraki.jp",
	"tamatsukuri.ibaraki.jp",
	"tokai.ibaraki.jp",
	"tomobe.ibaraki.jp",
	"tone.ibaraki.jp",
	"toride.ibaraki.jp",
	"tsuchiura.ibaraki.jp",
	"tsukuba.ibaraki.jp",
	"uchihara.ibaraki.jp",
	"ushiku.ibaraki.jp",
	"yachiyo.ibaraki.jp",
	"yamagata.ibaraki.jp",
	"yawara.ibaraki.jp",
	"yuki.ibaraki.jp",
	"anamizu.ishikawa.jp",
	"hakui.ishikawa.jp",
	"hakusan.ishikawa.jp",
	"kaga.ishikawa.jp",
	"kahoku.ishikawa.jp",
	"kanazawa.ishikawa.jp",
	"kawakita.ishikawa.jp",
	"komatsu.ishikawa.jp",
	"nakanoto.ishikawa.jp",
	"nanao.ishikawa.jp",
	"nomi.ishikawa.jp",
	"nonoichi.ishikawa.jp",
	"noto.ishikawa.jp",
	"shika.ishikawa.jp",
	"suzu.ishikawa.jp",
	"tsubata.ishikawa.jp",
	"tsurugi.ishikawa.jp",
	"uchinada.ishikawa.jp",
	"wajima.ishikawa.jp",
	"fudai.iwate.jp",
	"fujisawa.iwate.jp",
	"hanamaki.iwate.jp",
	"hiraizumi.iwate.jp",
	"hirono.iwate.jp",
	"ichinohe.iwate.jp",
	"ichinoseki.iwate.jp",
	"iwaizumi.iwate.jp",
	"iwate.iwate.jp",
	"joboji.iwate.jp",
	"kamaishi.iwate.jp",
	"kanegasaki.iwate.jp",
	"karumai.iwate.jp",
	"kawai.iwate.jp",
	"kitakami.iwate.jp",
	"kuji.iwate.jp",
	"kunohe.iwate.jp",
	"kuzumaki.iwate.jp",
	"miyako.iwate.jp",
	"mizusawa.iwate.jp",
	"morioka.iwate.jp",
	"ninohe.iwate.jp",
	"noda.iwate.jp",
	"ofunato.iwate.jp",
	"oshu.iwate.jp",
	"otsuchi.iwate.jp",
	"rikuzentakata.iwate.jp",
	"shiwa.iwate.jp",
	"shizukuishi.iwate.jp",
	"sumita.iwate.jp",
	"tanohata.iwate.jp",
	"tono.iwate.jp",
	"yahaba.iwate.jp",
	"yamada.iwate.jp",
	"ayagawa.kagawa.jp",
	"higashikagawa.kagawa.jp",
	"kanonji.kagawa.jp",
	"kotohira.kagawa.jp",
	"manno.kagawa.jp",
	"marugame.kagawa.jp",
	"mitoyo.kagawa.jp",
	"naoshima.kagawa.jp",
	"sanuki.kagawa.jp",
	"tadotsu.kagawa.jp",
	"takamatsu.kagawa.jp",
	"tonosho.kagawa.jp",
	"uchinomi.kagawa.jp",
	"utazu.kagawa.jp",
	"zentsuji.kagawa.jp",
	"akune.kagoshima.jp",
	"amami.kagoshima.jp",
	"hioki.kagoshima.jp",
	"isa.kagoshima.jp",
	"isen.kagoshima.jp",
	"izumi.kagoshima.jp",
	"kagoshima.kagoshima.jp",
	"kanoya.kagoshima.jp",
	"kawanabe.kagoshima.jp",
	"kinko.kagoshima.jp",
	"kouyama.kagoshima.jp",
	"makurazaki.kagoshima.jp",
	"matsumoto.kagoshima.jp",
	"minamitane.kagoshima.jp",
	"nakatane.kagoshima.jp",
	"nishinoomote.kagoshima.jp",
	"satsumasendai.kagoshima.jp",
	"soo.kagoshima.jp",
	"tarumizu.kagoshima.jp",
	"yusui.kagoshima.jp",
	"aikawa.kanagawa.jp",
	"atsugi.kanagawa.jp",
	"ayase.kanagawa.jp",
	"chigasaki.kanagawa.jp",
	"ebina.kanagawa.jp",
	"fujisawa.kanagawa.jp",
	"hadano.kanagawa.jp",
	"hakone.kanagawa.jp",
	"hiratsuka.kanagawa.jp",
	"isehara.kanagawa.jp",
	"kaisei.kanagawa.jp",
	"kamakura.kanagawa.jp",
	"kiyokawa.kanagawa.jp",
	"matsuda.kanagawa.jp",
	"minamiashigara.kanagawa.jp",
	"miura.kanagawa.jp",
	"nakai.kanagawa.jp",
	"ninomiya.kanagawa.jp",
	"odawara.kanagawa.jp",
	"oi.kanagawa.jp",
	"oiso.kanagawa.jp",
	"sagamihara.kanagawa.jp",
	"samukawa.kanagawa.jp",
	"tsukui.kanagawa.jp",
	"yamakita.kanagawa.jp",
	"yamato.kanagawa.jp",
	"yokosuka.kanagawa.jp",
	"yugawara.kanagawa.jp",
	"zama.kanagawa.jp",
	"zushi.kanagawa.jp",
	"aki.kochi.jp",
	"geisei.kochi.jp",
	"hidaka.kochi.jp",
	"higashitsuno.kochi.jp",
	"ino.kochi.jp",
	"kagami.kochi.jp",
	"kami.kochi.jp",
	"kitagawa.kochi.jp",
	"kochi.kochi.jp",
	"mihara.kochi.jp",
	"motoyama.kochi.jp",
	"muroto.kochi.jp",
	"nahari.kochi.jp",
	"nakamura.kochi.jp",
	"nankoku.kochi.jp",
	"nishitosa.kochi.jp",
	"niyodogawa.kochi.jp",
	"ochi.kochi.jp",
	"okawa.kochi.jp",
	"otoyo.kochi.jp",
	"otsuki.kochi.jp",
	"sakawa.kochi.jp",
	"sukumo.kochi.jp",
	"susaki.kochi.jp",
	"tosa.kochi.jp",
	"tosashimizu.kochi.jp",
	"toyo.kochi.jp",
	"tsuno.kochi.jp",
	"umaji.kochi.jp",
	"yasuda.kochi.jp",
	"yusuhara.kochi.jp",
	"amakusa.kumamoto.jp",
	"arao.kumamoto.jp",
	"aso.kumamoto.jp",
	"choyo.kumamoto.jp",
	"gyokuto.kumamoto.jp",
	"kamiamakusa.kumamoto.jp",
	"kikuchi.kumamoto.jp",
	"kumamoto.kumamoto.jp",
	"mashiki.kumamoto.jp",
	"mifune.kumamoto.jp",
	"minamata.kumamoto.jp",
	"minamioguni.kumamoto.jp",
	"nagasu.kumamoto.jp",
	"nishihara.kumamoto.jp",
	"oguni.kumamoto.jp",
	"ozu.kumamoto.jp",
	"sumoto.kumamoto.jp",
	"takamori.kumamoto.jp",
	"uki.kumamoto.jp",
	"uto.kumamoto.jp",
	"yamaga.kumamoto.jp",
	"yamato.kumamoto.jp",
	"yatsushiro.kumamoto.jp",
	"ayabe.kyoto.jp",
	"fukuchiyama.kyoto.jp",
	"higashiyama.kyoto.jp",
	"ide.kyoto.jp",
	"ine.kyoto.jp",
	"joyo.kyoto.jp",
	"kameoka.kyoto.jp",
	"kamo.kyoto.jp",
	"kita.kyoto.jp",
	"kizu.kyoto.jp",
	"kumiyama.kyoto.jp",
	"kyotamba.kyoto.jp",
	"kyotanabe.kyoto.jp",
	"kyotango.kyoto.jp",
	"maizuru.kyoto.jp",
	"minami.kyoto.jp",
	"minamiyamashiro.kyoto.jp",
	"miyazu.kyoto.jp",
	"muko.kyoto.jp",
	"nagaokakyo.kyoto.jp",
	"nakagyo.kyoto.jp",
	"nantan.kyoto.jp",
	"oyamazaki.kyoto.jp",
	"sakyo.kyoto.jp",
	"seika.kyoto.jp",
	"tanabe.kyoto.jp",
	"uji.kyoto.jp",
	"ujitawara.kyoto.jp",
	"wazuka.kyoto.jp",
	"yamashina.kyoto.jp",
	"yawata.kyoto.jp",
	"asahi.mie.jp",
	"inabe.mie.jp",
	"ise.mie.jp",
	"kameyama.mie.jp",
	"kawagoe.mie.jp",
	"kiho.mie.jp",
	"kisosaki.mie.jp",
	"kiwa.mie.jp",
	"komono.mie.jp",
	"kumano.mie.jp",
	"kuwana.mie.jp",
	"matsusaka.mie.jp",
	"meiwa.mie.jp",
	"mihama.mie.jp",
	"minamiise.mie.jp",
	"misugi.mie.jp",
	"miyama.mie.jp",
	"nabari.mie.jp",
	"shima.mie.jp",
	"suzuka.mie.jp",
	"tado.mie.jp",
	"taiki.mie.jp",
	"taki.mie.jp",
	"tamaki.mie.jp",
	"toba.mie.jp",
	"tsu.mie.jp",
	"udono.mie.jp",
	"ureshino.mie.jp",
	"watarai.mie.jp",
	"yokkaichi.mie.jp",
	"furukawa.miyagi.jp",
	"higashimatsushima.miyagi.jp",
	"ishinomaki.miyagi.jp",
	"iwanuma.miyagi.jp",
	"kakuda.miyagi.jp",
	"kami.miyagi.jp",
	"kawasaki.miyagi.jp",
	"marumori.miyagi.jp",
	"matsushima.miyagi.jp",
	"minamisanriku.miyagi.jp",
	"misato.miyagi.jp",
	"murata.miyagi.jp",
	"natori.miyagi.jp",
	"ogawara.miyagi.jp",
	"ohira.miyagi.jp",
	"onagawa.miyagi.jp",
	"osaki.miyagi.jp",
	"rifu.miyagi.jp",
	"semine.miyagi.jp",
	"shibata.miyagi.jp",
	"shichikashuku.miyagi.jp",
	"shikama.miyagi.jp",
	"shiogama.miyagi.jp",
	"shiroishi.miyagi.jp",
	"tagajo.miyagi.jp",
	"taiwa.miyagi.jp",
	"tome.miyagi.jp",
	"tomiya.miyagi.jp",
	"wakuya.miyagi.jp",
	"watari.miyagi.jp",
	"yamamoto.miyagi.jp",
	"zao.miyagi.jp",
	"aya.miyazaki.jp",
	"ebino.miyazaki.jp",
	"gokase.miyazaki.jp",
	"hyuga.miyazaki.jp",
	"kadogawa.miyazaki.jp",
	"kawaminami.miyazaki.jp",
	"kijo.miyazaki.jp",
	"kitagawa.miyazaki.jp",
	"kitakata.miyazaki.jp",
	"kitaura.miyazaki.jp",
	"kobayashi.miyazaki.jp",
	"kunitomi.miyazaki.jp",
	"kushima.miyazaki.jp",
	"mimata.miyazaki.jp",
	"miyakonojo.miyazaki.jp",
	"miyazaki.miyazaki.jp",
	"morotsuka.miyazaki.jp",
	"nichinan.miyazaki.jp",
	"nishimera.miyazaki.jp",
	"nobeoka.miyazaki.jp",
	"saito.miyazaki.jp",
	"shiiba.miyazaki.jp",
	"shintomi.miyazaki.jp",
	"takaharu.miyazaki.jp",
	"takanabe.miyazaki.jp",
	"takazaki.miyazaki.jp",
	"tsuno.miyazaki.jp",
	"achi.nagano.jp",
	"agematsu.nagano.jp",
	"anan.nagano.jp",
	"aoki.nagano.jp",
	"asahi.nagano.jp",
	"azumino.nagano.jp",
	"chikuhoku.nagano.jp",
	"chikuma.nagano.jp",
	"chino.nagano.jp",
	"fujimi.nagano.jp",
	"hakuba.nagano.jp",
	"hara.nagano.jp",
	"hiraya.nagano.jp",
	"iida.nagano.jp",
	"iijima.nagano.jp",
	"iiyama.nagano.jp",
	"iizuna.nagano.jp",
	"ikeda.nagano.jp",
	"ikusaka.nagano.jp",
	"ina.nagano.jp",
	"karuizawa.nagano.jp",
	"kawakami.nagano.jp",
	"kiso.nagano.jp",
	"kisofukushima.nagano.jp",
	"kitaaiki.nagano.jp",
	"komagane.nagano.jp",
	"komoro.nagano.jp",
	"matsukawa.nagano.jp",
	"matsumoto.nagano.jp",
	"miasa.nagano.jp",
	"minamiaiki.nagano.jp",
	"minamimaki.nagano.jp",
	"minamiminowa.nagano.jp",
	"minowa.nagano.jp",
	"miyada.nagano.jp",
	"miyota.nagano.jp",
	"mochizuki.nagano.jp",
	"nagano.nagano.jp",
	"nagawa.nagano.jp",
	"nagiso.nagano.jp",
	"nakagawa.nagano.jp",
	"nakano.nagano.jp",
	"nozawaonsen.nagano.jp",
	"obuse.nagano.jp",
	"ogawa.nagano.jp",
	"okaya.nagano.jp",
	"omachi.nagano.jp",
	"omi.nagano.jp",
	"ookuwa.nagano.jp",
	"ooshika.nagano.jp",
	"otaki.nagano.jp",
	"otari.nagano.jp",
	"sakae.nagano.jp",
	"sakaki.nagano.jp",
	"saku.nagano.jp",
	"sakuho.nagano.jp",
	"shimosuwa.nagano.jp",
	"shinanomachi.nagano.jp",
	"shiojiri.nagano.jp",
	"suwa.nagano.jp",
	"suzaka.nagano.jp",
	"takagi.nagano.jp",
	"takamori.nagano.jp",
	"takayama.nagano.jp",
	"tateshina.nagano.jp",
	"tatsuno.nagano.jp",
	"togakushi.nagano.jp",
	"togura.nagano.jp",
	"tomi.nagano.jp",
	"ueda.nagano.jp",
	"wada.nagano.jp",
	"yamagata.nagano.jp",
	"yamanouchi.nagano.jp",
	"yasaka.nagano.jp",
	"yasuoka.nagano.jp",
	"chijiwa.nagasaki.jp",
	"futsu.nagasaki.jp",
	"goto.nagasaki.jp",
	"hasami.nagasaki.jp",
	"hirado.nagasaki.jp",
	"iki.nagasaki.jp",
	"isahaya.nagasaki.jp",
	"kawatana.nagasaki.jp",
	"kuchinotsu.nagasaki.jp",
	"matsuura.nagasaki.jp",
	"nagasaki.nagasaki.jp",
	"obama.nagasaki.jp",
	"omura.nagasaki.jp",
	"oseto.nagasaki.jp",
	"saikai.nagasaki.jp",
	"sasebo.nagasaki.jp",
	"seihi.nagasaki.jp",
	"shimabara.nagasaki.jp",
	"shinkamigoto.nagasaki.jp",
	"togitsu.nagasaki.jp",
	"tsushima.nagasaki.jp",
	"unzen.nagasaki.jp",
	"ando.nara.jp",
	"gose.nara.jp",
	"heguri.nara.jp",
	"higashiyoshino.nara.jp",
	"ikaruga.nara.jp",
	"ikoma.nara.jp",
	"kamikitayama.nara.jp",
	"kanmaki.nara.jp",
	"kashiba.nara.jp",
	"kashihara.nara.jp",
	"katsuragi.nara.jp",
	"kawai.nara.jp",
	"kawakami.nara.jp",
	"kawanishi.nara.jp",
	"koryo.nara.jp",
	"kurotaki.nara.jp",
	"mitsue.nara.jp",
	"miyake.nara.jp",
	"nara.nara.jp",
	"nosegawa.nara.jp",
	"oji.nara.jp",
	"ouda.nara.jp",
	"oyodo.nara.jp",
	"sakurai.nara.jp",
	"sango.nara.jp",
	"shimoichi.nara.jp",
	"shimokitayama.nara.jp",
	"shinjo.nara.jp",
	"soni.nara.jp",
	"takatori.nara.jp",
	"tawaramoto.nara.jp",
	"tenkawa.nara.jp",
	"tenri.nara.jp",
	"uda.nara.jp",
	"yamatokoriyama.nara.jp",
	"yamatotakada.nara.jp",
	"yamazoe.nara.jp",
	"yoshino.nara.jp",
	"aga.niigata.jp",
	"agano.niigata.jp",
	"gosen.niigata.jp",
	"itoigawa.niigata.jp",
	"izumozaki.niigata.jp",
	"joetsu.niigata.jp",
	"kamo.niigata.jp",
	"kariwa.niigata.jp",
	"kashiwazaki.niigata.jp",
	"minamiuonuma.niigata.jp",
	"mitsuke.niigata.jp",
	"muika.niigata.jp",
	"murakami.niigata.jp",
	"myoko.niigata.jp",
	"nagaoka.niigata.jp",
	"niigata.niigata.jp",
	"ojiya.niigata.jp",
	"omi.niigata.jp",
	"sado.niigata.jp",
	"sanjo.niigata.jp",
	"seiro.niigata.jp",
	"seirou.niigata.jp",
	"sekikawa.niigata.jp",
	"shibata.niigata.jp",
	"tagami.niigata.jp",
	"tainai.niigata.jp",
	"tochio.niigata.jp",
	"tokamachi.niigata.jp",
	"tsubame.niigata.jp",
	"tsunan.niigata.jp",
	"uonuma.niigata.jp",
	"yahiko.niigata.jp",
	"yoita.niigata.jp",
	"yuzawa.niigata.jp",
	"beppu.oita.jp",
	"bungoono.oita.jp",
	"bungotakada.oita.jp",
	"hasama.oita.jp",
	"hiji.oita.jp",
	"himeshima.oita.jp",
	"hita.oita.jp",
	"kamitsue.oita.jp",
	"kokonoe.oita.jp",
	"kuju.oita.jp",
	"kunisaki.oita.jp",
	"kusu.oita.jp",
	"oita.oita.jp",
	"saiki.oita.jp",
	"taketa.oita.jp",
	"tsukumi.oita.jp",
	"usa.oita.jp",
	"usuki.oita.jp",
	"yufu.oita.jp",
	"akaiwa.okayama.jp",
	"asakuchi.okayama.jp",
	"bizen.okayama.jp",
	"hayashima.okayama.jp",
	"ibara.okayama.jp",
	"kagamino.okayama.jp",
	"kasaoka.okayama.jp",
	"kibichuo.okayama.jp",
	"kumenan.okayama.jp",
	"kurashiki.okayama.jp",
	"maniwa.okayama.jp",
	"misaki.okayama.jp",
	"nagi.okayama.jp",
	"niimi.okayama.jp",
	"nishiawakura.okayama.jp",
	"okayama.okayama.jp",
	"satosho.okayama.jp",
	"setouchi.okayama.jp",
	"shinjo.okayama.jp",
	"shoo.okayama.jp",
	"soja.okayama.jp",
	"takahashi.okayama.jp",
	"tamano.okayama.jp",
	"tsuyama.okayama.jp",
	"wake.okayama.jp",
	"yakage.okayama.jp",
	"aguni.okinawa.jp",
	"ginowan.okinawa.jp",
	"ginoza.okinawa.jp",
	"gushikami.okinawa.jp",
	"haebaru.okinawa.jp",
	"higashi.okinawa.jp",
	"hirara.okinawa.jp",
	"iheya.okinawa.jp",
	"ishigaki.okinawa.jp",
	"ishikawa.okinawa.jp",
	"itoman.okinawa.jp",
	"izena.okinawa.jp",
	"kadena.okinawa.jp",
	"kin.okinawa.jp",
	"kitadaito.okinawa.jp",
	"kitanakagusuku.okinawa.jp",
	"kumejima.okinawa.jp",
	"kunigami.okinawa.jp",
	"minamidaito.okinawa.jp",
	"motobu.okinawa.jp",
	"nago.okinawa.jp",
	"naha.okinawa.jp",
	"nakagusuku.okinawa.jp",
	"nakijin.okinawa.jp",
	"nanjo.okinawa.jp",
	"nishihara.okinawa.jp",
	"ogimi.okinawa.jp",
	"okinawa.okinawa.jp",
	"onna.okinawa.jp",
	"shimoji.okinawa.jp",
	"taketomi.okinawa.jp",
	"tarama.okinawa.jp",
	"tokashiki.okinawa.jp",
	"tomigusuku.okinawa.jp",
	"tonaki.okinawa.jp",
	"urasoe.okinawa.jp",
	"uruma.okinawa.jp",
	"yaese.okinawa.jp",
	"yomitan.okinawa.jp",
	"yonabaru.okinawa.jp",
	"yonaguni.okinawa.jp",
	"zamami.okinawa.jp",
	"abeno.osaka.jp",
	"chihayaakasaka.osaka.jp",
	"chuo.osaka.jp",
	"daito.osaka.jp",
	"fujiidera.osaka.jp",
	"habikino.osaka.jp",
	"hannan.osaka.jp",
	"higashiosaka.osaka.jp",
	"higashisumiyoshi.osaka.jp",
	"higashiyodogawa.osaka.jp",
	"hirakata.osaka.jp",
	"ibaraki.osaka.jp",
	"ikeda.osaka.jp",
	"izumi.osaka.jp",
	"izumiotsu.osaka.jp",
	"izumisano.osaka.jp",
	"kadoma.osaka.jp",
	"kaizuka.osaka.jp",
	"kanan.osaka.jp",
	"kashiwara.osaka.jp",
	"katano.osaka.jp",
	"kawachinagano.osaka.jp",
	"kishiwada.osaka.jp",
	"kita.osaka.jp",
	"kumatori.osaka.jp",
	"matsubara.osaka.jp",
	"minato.osaka.jp",
	"minoh.osaka.jp",
	"misaki.osaka.jp",
	"moriguchi.osaka.jp",
	"neyagawa.osaka.jp",
	"nishi.osaka.jp",
	"nose.osaka.jp",
	"osakasayama.osaka.jp",
	"sakai.osaka.jp",
	"sayama.osaka.jp",
	"sennan.osaka.jp",
	"settsu.osaka.jp",
	"shijonawate.osaka.jp",
	"shimamoto.osaka.jp",
	"suita.osaka.jp",
	"tadaoka.osaka.jp",
	"taishi.osaka.jp",
	"tajiri.osaka.jp",
	"takaishi.osaka.jp",
	"takatsuki.osaka.jp",
	"tondabayashi.osaka.jp",
	"toyonaka.osaka.jp",
	"toyono.osaka.jp",
	"yao.osaka.jp",
	"ariake.saga.jp",
	"arita.saga.jp",
	"fukudomi.saga.jp",
	"genkai.saga.jp",
	"hamatama.saga.jp",
	"hizen.saga.jp",
	"imari.saga.jp",
	"kamimine.saga.jp",
	"kanzaki.saga.jp",
	"karatsu.saga.jp",
	"kashima.saga.jp",
	"kitagata.saga.jp",
	"kitahata.saga.jp",
	"kiyama.saga.jp",
	"kouhoku.saga.jp",
	"kyuragi.saga.jp",
	"nishiarita.saga.jp",
	"ogi.saga.jp",
	"omachi.saga.jp",
	"ouchi.saga.jp",
	"saga.saga.jp",
	"shiroishi.saga.jp",
	"taku.saga.jp",
	"tara.saga.jp",
	"tosu.saga.jp",
	"yoshinogari.saga.jp",
	"arakawa.saitama.jp",
	"asaka.saitama.jp",
	"chichibu.saitama.jp",
	"fujimi.saitama.jp",
	"fujimino.saitama.jp",
	"fukaya.saitama.jp",
	"hanno.saitama.jp",
	"hanyu.saitama.jp",
	"hasuda.saitama.jp",
	"hatogaya.saitama.jp",
	"hatoyama.saitama.jp",
	"hidaka.saitama.jp",
	"higashichichibu.saitama.jp",
	"higashimatsuyama.saitama.jp",
	"honjo.saitama.jp",
	"ina.saitama.jp",
	"iruma.saitama.jp",
	"iwatsuki.saitama.jp",
	"kamiizumi.saitama.jp",
	"kamikawa.saitama.jp",
	"kamisato.saitama.jp",
	"kasukabe.saitama.jp",
	"kawagoe.saitama.jp",
	"kawaguchi.saitama.jp",
	"kawajima.saitama.jp",
	"kazo.saitama.jp",
	"kitamoto.saitama.jp",
	"koshigaya.saitama.jp",
	"kounosu.saitama.jp",
	"kuki.saitama.jp",
	"kumagaya.saitama.jp",
	"matsubushi.saitama.jp",
	"minano.saitama.jp",
	"misato.saitama.jp",
	"miyashiro.saitama.jp",
	"miyoshi.saitama.jp",
	"moroyama.saitama.jp",
	"nagatoro.saitama.jp",
	"namegawa.saitama.jp",
	"niiza.saitama.jp",
	"ogano.saitama.jp",
	"ogawa.saitama.jp",
	"ogose.saitama.jp",
	"okegawa.saitama.jp",
	"omiya.saitama.jp",
	"otaki.saitama.jp",
	"ranzan.saitama.jp",
	"ryokami.saitama.jp",
	"saitama.saitama.jp",
	"sakado.saitama.jp",
	"satte.saitama.jp",
	"sayama.saitama.jp",
	"shiki.saitama.jp",
	"shiraoka.saitama.jp",
	"soka.saitama.jp",
	"sugito.saitama.jp",
	"toda.saitama.jp",
	"tokigawa.saitama.jp",
	"tokorozawa.saitama.jp",
	"tsurugashima.saitama.jp",
	"urawa.saitama.jp",
	"warabi.saitama.jp",
	"yashio.saitama.jp",
	"yokoze.saitama.jp",
	"yono.saitama.jp",
	"yorii.saitama.jp",
	"yoshida.saitama.jp",
	"yoshikawa.saitama.jp",
	"yoshimi.saitama.jp",
	"aisho.shiga.jp",
	"gamo.shiga.jp",
	"higashiomi.shiga.jp",
	"hikone.shiga.jp",
	"koka.shiga.jp",
	"konan.shiga.jp",
	"kosei.shiga.jp",
	"koto.shiga.jp",
	"kusatsu.shiga.jp",
	"maibara.shiga.jp",
	"moriyama.shiga.jp",
	"nagahama.shiga.jp",
	"nishiazai.shiga.jp",
	"notogawa.shiga.jp",
	"omihachiman.shiga.jp",
	"otsu.shiga.jp",
	"ritto.shiga.jp",
	"ryuoh.shiga.jp",
	"takashima.shiga.jp",
	"takatsuki.shiga.jp",
	"torahime.shiga.jp",
	"toyosato.shiga.jp",
	"yasu.shiga.jp",
	"akagi.shimane.jp",
	"ama.shimane.jp",
	"gotsu.shimane.jp",
	"hamada.shimane.jp",
	"higashiizumo.shimane.jp",
	"hikawa.shimane.jp",
	"hikimi.shimane.jp",
	"izumo.shimane.jp",
	"kakinoki.shimane.jp",
	"masuda.shimane.jp",
	"matsue.shimane.jp",
	"misato.shimane.jp",
	"nishinoshima.shimane.jp",
	"ohda.shimane.jp",
	"okinoshima.shimane.jp",
	"okuizumo.shimane.jp",
	"shimane.shimane.jp",
	"tamayu.shimane.jp",
	"tsuwano.shimane.jp",
	"unnan.shimane.jp",
	"yakumo.shimane.jp",
	"yasugi.shimane.jp",
	"yatsuka.shimane.jp",
	"arai.shizuoka.jp",
	"atami.shizuoka.jp",
	"fuji.shizuoka.jp",
	"fujieda.shizuoka.jp",
	"fujikawa.shizuoka.jp",
	"fujinomiya.shizuoka.jp",
	"fukuroi.shizuoka.jp",
	"gotemba.shizuoka.jp",
	"haibara.shizuoka.jp",
	"hamamatsu.shizuoka.jp",
	"higashiizu.shizuoka.jp",
	"ito.shizuoka.jp",
	"iwata.shizuoka.jp",
	"izu.shizuoka.jp",
	"izunokuni.shizuoka.jp",
	"kakegawa.shizuoka.jp",
	"kannami.shizuoka.jp",
	"kawanehon.shizuoka.jp",
	"kawazu.shizuoka.jp",
	"kikugawa.shizuoka.jp",
	"kosai.shizuoka.jp",
	"makinohara.shizuoka.jp",
	"matsuzaki.shizuoka.jp",
	"minamiizu.shizuoka.jp",
	"mishima.shizuoka.jp",
	"morimachi.shizuoka.jp",
	"nishiizu.shizuoka.jp",
	"numazu.shizuoka.jp",
	"omaezaki.shizuoka.jp",
	"shimada.shizuoka.jp",
	"shimizu.shizuoka.jp",
	"shimoda.shizuoka.jp",
	"shizuoka.shizuoka.jp",
	"susono.shizuoka.jp",
	"yaizu.shizuoka.jp",
	"yoshida.shizuoka.jp",
	"ashikaga.tochigi.jp",
	"bato.tochigi.jp",
	"haga.tochigi.jp",
	"ichikai.tochigi.jp",
	"iwafune.tochigi.jp",
	"kaminokawa.tochigi.jp",
	"kanuma.tochigi.jp",
	"karasuyama.tochigi.jp",
	"kuroiso.tochigi.jp",
	"mashiko.tochigi.jp",
	"mibu.tochigi.jp",
	"moka.tochigi.jp",
	"motegi.tochigi.jp",
	"nasu.tochigi.jp",
	"nasushiobara.tochigi.jp",
	"nikko.tochigi.jp",
	"nishikata.tochigi.jp",
	"nogi.tochigi.jp",
	"ohira.tochigi.jp",
	"ohtawara.tochigi.jp",
	"oyama.tochigi.jp",
	"sakura.tochigi.jp",
	"sano.tochigi.jp",
	"shimotsuke.tochigi.jp",
	"shioya.tochigi.jp",
	"takanezawa.tochigi.jp",
	"tochigi.tochigi.jp",
	"tsuga.tochigi.jp",
	"ujiie.tochigi.jp",
	"utsunomiya.tochigi.jp",
	"yaita.tochigi.jp",
	"aizumi.tokushima.jp",
	"anan.tokushima.jp",
	"ichiba.tokushima.jp",
	"itano.tokushima.jp",
	"kainan.tokushima.jp",
	"komatsushima.tokushima.jp",
	"matsushige.tokushima.jp",
	"mima.tokushima.jp",
	"minami.tokushima.jp",
	"miyoshi.tokushima.jp",
	"mugi.tokushima.jp",
	"nakagawa.tokushima.jp",
	"naruto.tokushima.jp",
	"sanagochi.tokushima.jp",
	"shishikui.tokushima.jp",
	"tokushima.tokushima.jp",
	"wajiki.tokushima.jp",
	"adachi.tokyo.jp",
	"akiruno.tokyo.jp",
	"akishima.tokyo.jp",
	"aogashima.tokyo.jp",
	"arakawa.tokyo.jp",
	"bunkyo.tokyo.jp",
	"chiyoda.tokyo.jp",
	"chofu.tokyo.jp",
	"chuo.tokyo.jp",
	"edogawa.tokyo.jp",
	"fuchu.tokyo.jp",
	"fussa.tokyo.jp",
	"hachijo.tokyo.jp",
	"hachioji.tokyo.jp",
	"hamura.tokyo.jp",
	"higashikurume.tokyo.jp",
	"higashimurayama.tokyo.jp",
	"higashiyamato.tokyo.jp",
	"hino.tokyo.jp",
	"hinode.tokyo.jp",
	"hinohara.tokyo.jp",
	"inagi.tokyo.jp",
	"itabashi.tokyo.jp",
	"katsushika.tokyo.jp",
	"kita.tokyo.jp",
	"kiyose.tokyo.jp",
	"kodaira.tokyo.jp",
	"koganei.tokyo.jp",
	"kokubunji.tokyo.jp",
	"komae.tokyo.jp",
	"koto.tokyo.jp",
	"kouzushima.tokyo.jp",
	"kunitachi.tokyo.jp",
	"machida.tokyo.jp",
	"meguro.tokyo.jp",
	"minato.tokyo.jp",
	"mitaka.tokyo.jp",
	"mizuho.tokyo.jp",
	"musashimurayama.tokyo.jp",
	"musashino.tokyo.jp",
	"nakano.tokyo.jp",
	"nerima.tokyo.jp",
	"ogasawara.tokyo.jp",
	"okutama.tokyo.jp",
	"ome.tokyo.jp",
	"oshima.tokyo.jp",
	"ota.tokyo.jp",
	"setagaya.tokyo.jp",
	"shibuya.tokyo.jp",
	"shinagawa.tokyo.jp",
	"shinjuku.tokyo.jp",
	"suginami.tokyo.jp",
	"sumida.tokyo.jp",
	"tachikawa.tokyo.jp",
	"taito.tokyo.jp",
	"tama.tokyo.jp",
	"toshima.tokyo.jp",
	"chizu.tottori.jp",
	"hino.tottori.jp",
	"kawahara.tottori.jp",
	"koge.tottori.jp",
	"kotoura.tottori.jp",
	"misasa.tottori.jp",
	"nanbu.tottori.jp",
	"nichinan.tottori.jp",
	"sakaiminato.tottori.jp",
	"tottori.tottori.jp",
	"wakasa.tottori.jp",
	"yazu.tottori.jp",
	"yonago.tottori.jp",
	"asahi.toyama.jp",
	"fuchu.toyama.jp",
	"fukumitsu.toyama.jp",
	"funahashi.toyama.jp",
	"himi.toyama.jp",
	"imizu.toyama.jp",
	"inami.toyama.jp",
	"johana.toyama.jp",
	"kamiichi.toyama.jp",
	"kurobe.toyama.jp",
	"nakaniikawa.toyama.jp",
	"namerikawa.toyama.jp",
	"nanto.toyama.jp",
	"nyuzen.toyama.jp",
	"oyabe.toyama.jp",
	"taira.toyama.jp",
	"takaoka.toyama.jp",
	"tateyama.toyama.jp",
	"toga.toyama.jp",
	"tonami.toyama.jp",
	"toyama.toyama.jp",
	"unazuki.toyama.jp",
	"uozu.toyama.jp",
	"yamada.toyama.jp",
	"arida.wakayama.jp",
	"aridagawa.wakayama.jp",
	"gobo.wakayama.jp",
	"hashimoto.wakayama.jp",
	"hidaka.wakayama.jp",
	"hirogawa.wakayama.jp",
	"inami.wakayama.jp",
	"iwade.wakayama.jp",
	"kainan.wakayama.jp",
	"kamitonda.wakayama.jp",
	"katsuragi.wakayama.jp",
	"kimino.wakayama.jp",
	"kinokawa.wakayama.jp",
	"kitayama.wakayama.jp",
	"koya.wakayama.jp",
	"koza.wakayama.jp",
	"kozagawa.wakayama.jp",
	"kudoyama.wakayama.jp",
	"kushimoto.wakayama.jp",
	"mihama.wakayama.jp",
	"misato.wakayama.jp",
	"nachikatsuura.wakayama.jp",
	"shingu.wakayama.jp",
	"shirahama.wakayama.jp",
	"taiji.wakayama.jp",
	"tanabe.wakayama.jp",
	"wakayama.wakayama.jp",
	"yuasa.wakayama.jp",
	"yura.wakayama.jp",
	"asahi.yamagata.jp",
	"funagata.yamagata.jp",
	"higashine.yamagata.jp",
	"iide.yamagata.jp",
	"kahoku.yamagata.jp",
	"kaminoyama.yamagata.jp",
	"kaneyama.yamagata.jp",
	"kawanishi.yamagata.jp",
	"mamurogawa.yamagata.jp",
	"mikawa.yamagata.jp",
	"murayama.yamagata.jp",
	"nagai.yamagata.jp",
	"nakayama.yamagata.jp",
	"nanyo.yamagata.jp",
	"nishikawa.yamagata.jp",
	"obanazawa.yamagata.jp",
	"oe.yamagata.jp",
	"oguni.yamagata.jp",
	"ohkura.yamagata.jp",
	"oishida.yamagata.jp",
	"sagae.yamagata.jp",
	"sakata.yamagata.jp",
	"sakegawa.yamagata.jp",
	"shinjo.yamagata.jp",
	"shirataka.yamagata.jp",
	"shonai.yamagata.jp",
	"takahata.yamagata.jp",
	"tendo.yamagata.jp",
	"tozawa.yamagata.jp",
	"tsuruoka.yamagata.jp",
	"yamagata.yamagata.jp",
	"yamanobe.yamagata.jp",
	"yonezawa.yamagata.jp",
	"yuza.yamagata.jp",
	"abu.yamaguchi.jp",
	"hagi.yamaguchi.jp",
	"hikari.yamaguchi.jp",
	"hofu.yamaguchi.jp",
	"iwakuni.yamaguchi.jp",
	"kudamatsu.yamaguchi.jp",
	"mitou.yamaguchi.jp",
	"nagato.yamaguchi.jp",
	"oshima.yamaguchi.jp",
	"shimonoseki.yamaguchi.jp",
	"shunan.yamaguchi.jp",
	"tabuse.yamaguchi.jp",
	"tokuyama.yamaguchi.jp",
	"toyota.yamaguchi.jp",
	"ube.yamaguchi.jp",
	"yuu.yamaguchi.jp",
	"chuo.yamanashi.jp",
	"doshi.yamanashi.jp",
	"fuefuki.yamanashi.jp",
	"fujikawa.yamanashi.jp",
	"fujikawaguchiko.yamanashi.jp",
	"fujiyoshida.yamanashi.jp",
	"hayakawa.yamanashi.jp",
	"hokuto.yamanashi.jp",
	"ichikawamisato.yamanashi.jp",
	"kai.yamanashi.jp",
	"kofu.yamanashi.jp",
	"koshu.yamanashi.jp",
	"kosuge.yamanashi.jp",
	"minami-alps.yamanashi.jp",
	"minobu.yamanashi.jp",
	"nakamichi.yamanashi.jp",
	"nanbu.yamanashi.jp",
	"narusawa.yamanashi.jp",
	"nirasaki.yamanashi.jp",
	"nishikatsura.yamanashi.jp",
	"oshino.yamanashi.jp",
	"otsuki.yamanashi.jp",
	"showa.yamanashi.jp",
	"tabayama.yamanashi.jp",
	"tsuru.yamanashi.jp",
	"uenohara.yamanashi.jp",
	"yamanakako.yamanashi.jp",
	"yamanashi.yamanashi.jp",
	"ke",
	"ac.ke",
	"co.ke",
	"go.ke",
	"info.ke",
	"me.ke",
	"mobi.ke",
	"ne.ke",
	"or.ke",
	"sc.ke",
	"kg",
	"com.kg",
	"edu.kg",
	"gov.kg",
	"mil.kg",
	"net.kg",
	"org.kg",
	"*.kh",
	"ki",
	"biz.ki",
	"com.ki",
	"edu.ki",
	"gov.ki",
	"info.ki",
	"net.ki",
	"org.ki",
	"km",
	"ass.km",
	"com.km",
	"edu.km",
	"gov.km",
	"mil.km",
	"nom.km",
	"org.km",
	"prd.km",
	"tm.km",
	"asso.km",
	"coop.km",
	"gouv.km",
	"medecin.km",
	"notaires.km",
	"pharmaciens.km",
	"presse.km",
	"veterinaire.km",
	"kn",
	"edu.kn",
	"gov.kn",
	"net.kn",
	"org.kn",
	"kp",
	"com.kp",
	"edu.kp",
	"gov.kp",
	"org.kp",
	"rep.kp",
	"tra.kp",
	"kr",
	"ac.kr",
	"co.kr",
	"es.kr",
	"go.kr",
	"hs.kr",
	"kg.kr",
	"mil.kr",
	"ms.kr",
	"ne.kr",
	"or.kr",
	"pe.kr",
	"re.kr",
	"sc.kr",
	"busan.kr",
	"chungbuk.kr",
	"chungnam.kr",
	"daegu.kr",
	"daejeon.kr",
	"gangwon.kr",
	"gwangju.kr",
	"gyeongbuk.kr",
	"gyeonggi.kr",
	"gyeongnam.kr",
	"incheon.kr",
	"jeju.kr",
	"jeonbuk.kr",
	"jeonnam.kr",
	"seoul.kr",
	"ulsan.kr",
	"kw",
	"com.kw",
	"edu.kw",
	"emb.kw",
	"gov.kw",
	"ind.kw",
	"net.kw",
	"org.kw",
	"ky",
	"com.ky",
	"edu.ky",
	"net.ky",
	"org.ky",
	"kz",
	"com.kz",
	"edu.kz",
	"gov.kz",
	"mil.kz",
	"net.kz",
	"org.kz",
	"la",
	"com.la",
	"edu.la",
	"gov.la",
	"info.la",
	"int.la",
	"net.la",
	"org.la",
	"per.la",
	"lb",
	"com.lb",
	"edu.lb",
	"gov.lb",
	"net.lb",
	"org.lb",
	"lc",
	"co.lc",
	"com.lc",
	"edu.lc",
	"gov.lc",
	"net.lc",
	"org.lc",
	"li",
	"lk",
	"ac.lk",
	"assn.lk",
	"com.lk",
	"edu.lk",
	"gov.lk",
	"grp.lk",
	"hotel.lk",
	"int.lk",
	"ltd.lk",
	"net.lk",
	"ngo.lk",
	"org.lk",
	"sch.lk",
	"soc.lk",
	"web.lk",
	"lr",
	"com.lr",
	"edu.lr",
	"gov.lr",
	"net.lr",
	"org.lr",
	"ls",
	"ac.ls",
	"biz.ls",
	"co.ls",
	"edu.ls",
	"gov.ls",
	"info.ls",
	"net.ls",
	"org.ls",
	"sc.ls",
	"lt",
	"gov.lt",
	"lu",
	"lv",
	"asn.lv",
	"com.lv",
	"conf.lv",
	"edu.lv",
	"gov.lv",
	"id.lv",
	"mil.lv",
	"net.lv",
	"org.lv",
	"ly",
	"com.ly",
	"edu.ly",
	"gov.ly",
	"id.ly",
	"med.ly",
	"net.ly",
	"org.ly",
	"plc.ly",
	"sch.ly",
	"ma",
	"ac.ma",
	"co.ma",
	"gov.ma",
	"net.ma",
	"org.ma",
	"press.ma",
	"mc",
	"asso.mc",
	"tm.mc",
	"md",
	"me",
	"ac.me",
	"co.me",
	"edu.me",
	"gov.me",
	"its.me",
	"net.me",
	"org.me",
	"priv.me",
	"mg",
	"co.mg",
	"com.mg",
	"edu.mg",
	"gov.mg",
	"mil.mg",
	"nom.mg",
	"org.mg",
	"prd.mg",
	"mh",
	"mil",
	"mk",
	"com.mk",
	"edu.mk",
	"gov.mk",
	"inf.mk",
	"name.mk",
	"net.mk",
	"org.mk",
	"ml",
	"com.ml",
	"edu.ml",
	"gouv.ml",
	"gov.ml",
	"net.ml",
	"org.ml",
	"presse.ml",
	"*.mm",
	"mn",
	"edu.mn",
	"gov.mn",
	"org.mn",
	"mo",
	"com.mo",
	"edu.mo",
	"gov.mo",
	"net.mo",
	"org.mo",
	"mobi",
	"mp",
	"mq",
	"mr",
	"gov.mr",
	"ms",
	"com.ms",
	"edu.ms",
	"gov.ms",
	"net.ms",
	"org.ms",
	"mt",
	"com.mt",
	"edu.mt",
	"net.mt",
	"org.mt",
	"mu",
	"ac.mu",
	"co.mu",
	"com.mu",
	"gov.mu",
	"net.mu",
	"or.mu",
	"org.mu",
	"museum",
	"mv",
	"aero.mv",
	"biz.mv",
	"com.mv",
	"coop.mv",
	"edu.mv",
	"gov.mv",
	"info.mv",
	"int.mv",
	"mil.mv",
	"museum.mv",
	"name.mv",
	"net.mv",
	"org.mv",
	"pro.mv",
	"mw",
	"ac.mw",
	"biz.mw",
	"co.mw",
	"com.mw",
	"coop.mw",
	"edu.mw",
	"gov.mw",
	"int.mw",
	"net.mw",
	"org.mw",
	"mx",
	"com.mx",
	"edu.mx",
	"gob.mx",
	"net.mx",
	"org.mx",
	"my",
	"biz.my",
	"com.my",
	"edu.my",
	"gov.my",
	"mil.my",
	"name.my",
	"net.my",
	"org.my",
	"mz",
	"ac.mz",
	"adv.mz",
	"co.mz",
	"edu.mz",
	"gov.mz",
	"mil.mz",
	"net.mz",
	"org.mz",
	"na",
	"alt.na",
	"co.na",
	"com.na",
	"gov.na",
	"net.na",
	"org.na",
	"name",
	"nc",
	"asso.nc",
	"nom.nc",
	"ne",
	"net",
	"nf",
	"arts.nf",
	"com.nf",
	"firm.nf",
	"info.nf",
	"net.nf",
	"other.nf",
	"per.nf",
	"rec.nf",
	"store.nf",
	"web.nf",
	"ng",
	"com.ng",
	"edu.ng",
	"gov.ng",
	"i.ng",
	"mil.ng",
	"mobi.ng",
	"name.ng",
	"net.ng",
	"org.ng",
	"sch.ng",
	"ni",
	"ac.ni",
	"biz.ni",
	"co.ni",
	"com.ni",
	"edu.ni",
	"gob.ni",
	"in.ni",
	"info.ni",
	"int.ni",
	"mil.ni",
	"net.ni",
	"nom.ni",
	"org.ni",
	"web.ni",
	"nl",
	"no",
	"fhs.no",
	"folkebibl.no",
	"fylkesbibl.no",
	"idrett.no",
	"museum.no",
	"priv.no",
	"vgs.no",
	"dep.no",
	"herad.no",
	"kommune.no",
	"mil.no",
	"stat.no",
	"aa.no",
	"ah.no",
	"bu.no",
	"fm.no",
	"hl.no",
	"hm.no",
	"jan-mayen.no",
	"mr.no",
	"nl.no",
	"nt.no",
	"of.no",
	"ol.no",
	"oslo.no",
	"rl.no",
	"sf.no",
	"st.no",
	"svalbard.no",
	"tm.no",
	"tr.no",
	"va.no",
	"vf.no",
	"gs.aa.no",
	"gs.ah.no",
	"gs.bu.no",
	"gs.fm.no",
	"gs.hl.no",
	"gs.hm.no",
	"gs.jan-mayen.no",
	"gs.mr.no",
	"gs.nl.no",
	"gs.nt.no",
	"gs.of.no",
	"gs.ol.no",
	"gs.oslo.no",
	"gs.rl.no",
	"gs.sf.no",
	"gs.st.no",
	"gs.svalbard.no",
	"gs.tm.no",
	"gs.tr.no",
	"gs.va.no",
	"gs.vf.no",
	"akrehamn.no",
	"åkrehamn.no",
	"algard.no",
	"ålgård.no",
	"arna.no",
	"bronnoysund.no",
	"brønnøysund.no",
	"brumunddal.no",
	"bryne.no",
	"drobak.no",
	"drøbak.no",
	"egersund.no",
	"fetsund.no",
	"floro.no",
	"florø.no",
	"fredrikstad.no",
	"hokksund.no",
	"honefoss.no",
	"hønefoss.no",
	"jessheim.no",
	"jorpeland.no",
	"jørpeland.no",
	"kirkenes.no",
	"kopervik.no",
	"krokstadelva.no",
	"langevag.no",
	"langevåg.no",
	"leirvik.no",
	"mjondalen.no",
	"mjøndalen.no",
	"mo-i-rana.no",
	"mosjoen.no",
	"mosjøen.no",
	"nesoddtangen.no",
	"orkanger.no",
	"osoyro.no",
	"osøyro.no",
	"raholt.no",
	"råholt.no",
	"sandnessjoen.no",
	"sandnessjøen.no",
	"skedsmokorset.no",
	"slattum.no",
	"spjelkavik.no",
	"stathelle.no",
	"stavern.no",
	"stjordalshalsen.no",
	"stjørdalshalsen.no",
	"tananger.no",
	"tranby.no",
	"vossevangen.no",
	"aarborte.no",
	"aejrie.no",
	"afjord.no",
	"åfjord.no",
	"agdenes.no",
	"nes.akershus.no",
	"aknoluokta.no",
	"ákŋoluokta.no",
	"al.no",
	"ål.no",
	"alaheadju.no",
	"álaheadju.no",
	"alesund.no",
	"ålesund.no",
	"alstahaug.no",
	"alta.no",
	"áltá.no",
	"alvdal.no",
	"amli.no",
	"åmli.no",
	"amot.no",
	"åmot.no",
	"andasuolo.no",
	"andebu.no",
	"andoy.no",
	"andøy.no",
	"ardal.no",
	"årdal.no",
	"aremark.no",
	"arendal.no",
	"ås.no",
	"aseral.no",
	"åseral.no",
	"asker.no",
	"askim.no",
	"askoy.no",
	"askøy.no",
	"askvoll.no",
	"asnes.no",
	"åsnes.no",
	"audnedaln.no",
	"aukra.no",
	"aure.no",
	"aurland.no",
	"aurskog-holand.no",
	"aurskog-høland.no",
	"austevoll.no",
	"austrheim.no",
	"averoy.no",
	"averøy.no",
	"badaddja.no",
	"bådåddjå.no",
	"bærum.no",
	"bahcavuotna.no",
	"báhcavuotna.no",
	"bahccavuotna.no",
	"báhccavuotna.no",
	"baidar.no",
	"báidár.no",
	"bajddar.no",
	"bájddar.no",
	"balat.no",
	"bálát.no",
	"balestrand.no",
	"ballangen.no",
	"balsfjord.no",
	"bamble.no",
	"bardu.no",
	"barum.no",
	"batsfjord.no",
	"båtsfjord.no",
	"bearalvahki.no",
	"bearalváhki.no",
	"beardu.no",
	"beiarn.no",
	"berg.no",
	"bergen.no",
	"berlevag.no",
	"berlevåg.no",
	"bievat.no",
	"bievát.no",
	"bindal.no",
	"birkenes.no",
	"bjarkoy.no",
	"bjarkøy.no",
	"bjerkreim.no",
	"bjugn.no",
	"bodo.no",
	"bodø.no",
	"bokn.no",
	"bomlo.no",
	"bømlo.no",
	"bremanger.no",
	"bronnoy.no",
	"brønnøy.no",
	"budejju.no",
	"nes.buskerud.no",
	"bygland.no",
	"bykle.no",
	"cahcesuolo.no",
	"čáhcesuolo.no",
	"davvenjarga.no",
	"davvenjárga.no",
	"davvesiida.no",
	"deatnu.no",
	"dielddanuorri.no",
	"divtasvuodna.no",
	"divttasvuotna.no",
	"donna.no",
	"dønna.no",
	"dovre.no",
	"drammen.no",
	"drangedal.no",
	"dyroy.no",
	"dyrøy.no",
	"eid.no",
	"eidfjord.no",
	"eidsberg.no",
	"eidskog.no",
	"eidsvoll.no",
	"eigersund.no",
	"elverum.no",
	"enebakk.no",
	"engerdal.no",
	"etne.no",
	"etnedal.no",
	"evenassi.no",
	"evenášši.no",
	"evenes.no",
	"evje-og-hornnes.no",
	"farsund.no",
	"fauske.no",
	"fedje.no",
	"fet.no",
	"finnoy.no",
	"finnøy.no",
	"fitjar.no",
	"fjaler.no",
	"fjell.no",
	"fla.no",
	"flå.no",
	"flakstad.no",
	"flatanger.no",
	"flekkefjord.no",
	"flesberg.no",
	"flora.no",
	"folldal.no",
	"forde.no",
	"førde.no",
	"forsand.no",
	"fosnes.no",
	"fræna.no",
	"frana.no",
	"frei.no",
	"frogn.no",
	"froland.no",
	"frosta.no",
	"froya.no",
	"frøya.no",
	"fuoisku.no",
	"fuossko.no",
	"fusa.no",
	"fyresdal.no",
	"gaivuotna.no",
	"gáivuotna.no",
	"galsa.no",
	"gálsá.no",
	"gamvik.no",
	"gangaviika.no",
	"gáŋgaviika.no",
	"gaular.no",
	"gausdal.no",
	"giehtavuoatna.no",
	"gildeskal.no",
	"gildeskål.no",
	"giske.no",
	"gjemnes.no",
	"gjerdrum.no",
	"gjerstad.no",
	"gjesdal.no",
	"gjovik.no",
	"gjøvik.no",
	"gloppen.no",
	"gol.no",
	"gran.no",
	"grane.no",
	"granvin.no",
	"gratangen.no",
	"grimstad.no",
	"grong.no",
	"grue.no",
	"gulen.no",
	"guovdageaidnu.no",
	"ha.no",
	"hå.no",
	"habmer.no",
	"hábmer.no",
	"hadsel.no",
	"hægebostad.no",
	"hagebostad.no",
	"halden.no",
	"halsa.no",
	"hamar.no",
	"hamaroy.no",
	"hammarfeasta.no",
	"hámmárfeasta.no",
	"hammerfest.no",
	"hapmir.no",
	"hápmir.no",
	"haram.no",
	"hareid.no",
	"harstad.no",
	"hasvik.no",
	"hattfjelldal.no",
	"haugesund.no",
	"os.hedmark.no",
	"valer.hedmark.no",
	"våler.hedmark.no",
	"hemne.no",
	"hemnes.no",
	"hemsedal.no",
	"hitra.no",
	"hjartdal.no",
	"hjelmeland.no",
	"hobol.no",
	"hobøl.no",
	"hof.no",
	"hol.no",
	"hole.no",
	"holmestrand.no",
	"holtalen.no",
	"holtålen.no",
	"os.hordaland.no",
	"hornindal.no",
	"horten.no",
	"hoyanger.no",
	"høyanger.no",
	"hoylandet.no",
	"høylandet.no",
	"hurdal.no",
	"hurum.no",
	"hvaler.no",
	"hyllestad.no",
	"ibestad.no",
	"inderoy.no",
	"inderøy.no",
	"iveland.no",
	"ivgu.no",
	"jevnaker.no",
	"jolster.no",
	"jølster.no",
	"jondal.no",
	"kafjord.no",
	"kåfjord.no",
	"karasjohka.no",
	"kárášjohka.no",
	"karasjok.no",
	"karlsoy.no",
	"karmoy.no",
	"karmøy.no",
	"kautokeino.no",
	"klabu.no",
	"klæbu.no",
	"klepp.no",
	"kongsberg.no",
	"kongsvinger.no",
	"kraanghke.no",
	"kråanghke.no",
	"kragero.no",
	"kragerø.no",
	"kristiansand.no",
	"kristiansund.no",
	"krodsherad.no",
	"krødsherad.no",
	"kvæfjord.no",
	"kvænangen.no",
	"kvafjord.no",
	"kvalsund.no",
	"kvam.no",
	"kvanangen.no",
	"kvinesdal.no",
	"kvinnherad.no",
	"kviteseid.no",
	"kvitsoy.no",
	"kvitsøy.no",
	"laakesvuemie.no",
	"lærdal.no",
	"lahppi.no",
	"láhppi.no",
	"lardal.no",
	"larvik.no",
	"lavagis.no",
	"lavangen.no",
	"leangaviika.no",
	"leaŋgaviika.no",
	"lebesby.no",
	"leikanger.no",
	"leirfjord.no",
	"leka.no",
	"leksvik.no",
	"lenvik.no",
	"lerdal.no",
	"lesja.no",
	"levanger.no",
	"lier.no",
	"lierne.no",
	"lillehammer.no",
	"lillesand.no",
	"lindas.no",
	"lindås.no",
	"lindesnes.no",
	"loabat.no",
	"loabát.no",
	"lodingen.no",
	"lødingen.no",
	"lom.no",
	"loppa.no",
	"lorenskog.no",
	"lørenskog.no",
	"loten.no",
	"løten.no",
	"lund.no",
	"lunner.no",
	"luroy.no",
	"lurøy.no",
	"luster.no",
	"lyngdal.no",
	"lyngen.no",
	"malatvuopmi.no",
	"málatvuopmi.no",
	"malselv.no",
	"målselv.no",
	"malvik.no",
	"mandal.no",
	"marker.no",
	"marnardal.no",
	"masfjorden.no",
	"masoy.no",
	"måsøy.no",
	"matta-varjjat.no",
	"mátta-várjjat.no",
	"meland.no",
	"meldal.no",
	"melhus.no",
	"meloy.no",
	"meløy.no",
	"meraker.no",
	"meråker.no",
	"midsund.no",
	"midtre-gauldal.no",
	"moareke.no",
	"moåreke.no",
	"modalen.no",
	"modum.no",
	"molde.no",
	"heroy.more-og-romsdal.no",
	"sande.more-og-romsdal.no",
	"herøy.møre-og-romsdal.no",
	"sande.møre-og-romsdal.no",
	"moskenes.no",
	"moss.no",
	"mosvik.no",
	"muosat.no",
	"muosát.no",
	"naamesjevuemie.no",
	"nååmesjevuemie.no",
	"nærøy.no",
	"namdalseid.no",
	"namsos.no",
	"namsskogan.no",
	"nannestad.no",
	"naroy.no",
	"narviika.no",
	"narvik.no",
	"naustdal.no",
	"navuotna.no",
	"návuotna.no",
	"nedre-eiker.no",
	"nesna.no",
	"nesodden.no",
	"nesseby.no",
	"nesset.no",
	"nissedal.no",
	"nittedal.no",
	"nord-aurdal.no",
	"nord-fron.no",
	"nord-odal.no",
	"norddal.no",
	"nordkapp.no",
	"bo.nordland.no",
	"bø.nordland.no",
	"heroy.nordland.no",
	"herøy.nordland.no",
	"nordre-land.no",
	"nordreisa.no",
	"nore-og-uvdal.no",
	"notodden.no",
	"notteroy.no",
	"nøtterøy.no",
	"odda.no",
	"oksnes.no",
	"øksnes.no",
	"omasvuotna.no",
	"oppdal.no",
	"oppegard.no",
	"oppegård.no",
	"orkdal.no",
	"orland.no",
	"ørland.no",
	"orskog.no",
	"ørskog.no",
	"orsta.no",
	"ørsta.no",
	"osen.no",
	"osteroy.no",
	"osterøy.no",
	"valer.ostfold.no",
	"våler.østfold.no",
	"ostre-toten.no",
	"østre-toten.no",
	"overhalla.no",
	"ovre-eiker.no",
	"øvre-eiker.no",
	"oyer.no",
	"øyer.no",
	"oygarden.no",
	"øygarden.no",
	"oystre-slidre.no",
	"øystre-slidre.no",
	"porsanger.no",
	"porsangu.no",
	"porsáŋgu.no",
	"porsgrunn.no",
	"rade.no",
	"råde.no",
	"radoy.no",
	"radøy.no",
	"rælingen.no",
	"rahkkeravju.no",
	"ráhkkerávju.no",
	"raisa.no",
	"ráisa.no",
	"rakkestad.no",
	"ralingen.no",
	"rana.no",
	"randaberg.no",
	"rauma.no",
	"rendalen.no",
	"rennebu.no",
	"rennesoy.no",
	"rennesøy.no",
	"rindal.no",
	"ringebu.no",
	"ringerike.no",
	"ringsaker.no",
	"risor.no",
	"risør.no",
	"rissa.no",
	"roan.no",
	"rodoy.no",
	"rødøy.no",
	"rollag.no",
	"romsa.no",
	"romskog.no",
	"rømskog.no",
	"roros.no",
	"røros.no",
	"rost.no",
	"røst.no",
	"royken.no",
	"røyken.no",
	"royrvik.no",
	"røyrvik.no",
	"ruovat.no",
	"rygge.no",
	"salangen.no",
	"salat.no",
	"sálat.no",
	"sálát.no",
	"saltdal.no",
	"samnanger.no",
	"sandefjord.no",
	"sandnes.no",
	"sandoy.no",
	"sandøy.no",
	"sarpsborg.no",
	"sauda.no",
	"sauherad.no",
	"sel.no",
	"selbu.no",
	"selje.no",
	"seljord.no",
	"siellak.no",
	"sigdal.no",
	"siljan.no",
	"sirdal.no",
	"skanit.no",
	"skánit.no",
	"skanland.no",
	"skånland.no",
	"skaun.no",
	"skedsmo.no",
	"ski.no",
	"skien.no",
	"skierva.no",
	"skiervá.no",
	"skiptvet.no",
	"skjak.no",
	"skjåk.no",
	"skjervoy.no",
	"skjervøy.no",
	"skodje.no",
	"smola.no",
	"smøla.no",
	"snaase.no",
	"snåase.no",
	"snasa.no",
	"snåsa.no",
	"snillfjord.no",
	"snoasa.no",
	"sogndal.no",
	"sogne.no",
	"søgne.no",
	"sokndal.no",
	"sola.no",
	"solund.no",
	"somna.no",
	"sømna.no",
	"sondre-land.no",
	"søndre-land.no",
	"songdalen.no",
	"sor-aurdal.no",
	"sør-aurdal.no",
	"sor-fron.no",
	"sør-fron.no",
	"sor-odal.no",
	"sør-odal.no",
	"sor-varanger.no",
	"sør-varanger.no",
	"sorfold.no",
	"sørfold.no",
	"sorreisa.no",
	"sørreisa.no",
	"sortland.no",
	"sorum.no",
	"sørum.no",
	"spydeberg.no",
	"stange.no",
	"stavanger.no",
	"steigen.no",
	"steinkjer.no",
	"stjordal.no",
	"stjørdal.no",
	"stokke.no",
	"stor-elvdal.no",
	"stord.no",
	"stordal.no",
	"storfjord.no",
	"strand.no",
	"stranda.no",
	"stryn.no",
	"sula.no",
	"suldal.no",
	"sund.no",
	"sunndal.no",
	"surnadal.no",
	"sveio.no",
	"svelvik.no",
	"sykkylven.no",
	"tana.no",
	"bo.telemark.no",
	"bø.telemark.no",
	"time.no",
	"tingvoll.no",
	"tinn.no",
	"tjeldsund.no",
	"tjome.no",
	"tjøme.no",
	"tokke.no",
	"tolga.no",
	"tonsberg.no",
	"tønsberg.no",
	"torsken.no",
	"træna.no",
	"trana.no",
	"tranoy.no",
	"tranøy.no",
	"troandin.no",
	"trogstad.no",
	"trøgstad.no",
	"tromsa.no",
	"tromso.no",
	"tromsø.no",
	"trondheim.no",
	"trysil.no",
	"tvedestrand.no",
	"tydal.no",
	"tynset.no",
	"tysfjord.no",
	"tysnes.no",
	"tysvær.no",
	"tysvar.no",
	"ullensaker.no",
	"ullensvang.no",
	"ulvik.no",
	"unjarga.no",
	"unjárga.no",
	"utsira.no",
	"vaapste.no",
	"vadso.no",
	"vadsø.no",
	"værøy.no",
	"vaga.no",
	"vågå.no",
	"vagan.no",
	"vågan.no",
	"vagsoy.no",
	"vågsøy.no",
	"vaksdal.no",
	"valle.no",
	"vang.no",
	"vanylven.no",
	"vardo.no",
	"vardø.no",
	"varggat.no",
	"várggát.no",
	"varoy.no",
	"vefsn.no",
	"vega.no",
	"vegarshei.no",
	"vegårshei.no",
	"vennesla.no",
	"verdal.no",
	"verran.no",
	"vestby.no",
	"sande.vestfold.no",
	"vestnes.no",
	"vestre-slidre.no",
	"vestre-toten.no",
	"vestvagoy.no",
	"vestvågøy.no",
	"vevelstad.no",
	"vik.no",
	"vikna.no",
	"vindafjord.no",
	"voagat.no",
	"volda.no",
	"voss.no",
	"*.np",
	"nr",
	"biz.nr",
	"com.nr",
	"edu.nr",
	"gov.nr",
	"info.nr",
	"net.nr",
	"org.nr",
	"nu",
	"nz",
	"ac.nz",
	"co.nz",
	"cri.nz",
	"geek.nz",
	"gen.nz",
	"govt.nz",
	"health.nz",
	"iwi.nz",
	"kiwi.nz",
	"maori.nz",
	"māori.nz",
	"mil.nz",
	"net.nz",
	"org.nz",
	"parliament.nz",
	"school.nz",
	"om",
	"co.om",
	"com.om",
	"edu.om",
	"gov.om",
	"med.om",
	"museum.om",
	"net.om",
	"org.om",
	"pro.om",
	"onion",
	"org",
	"pa",
	"abo.pa",
	"ac.pa",
	"com.pa",
	"edu.pa",
	"gob.pa",
	"ing.pa",
	"med.pa",
	"net.pa",
	"nom.pa",
	"org.pa",
	"sld.pa",
	"pe",
	"com.pe",
	"edu.pe",
	"gob.pe",
	"mil.pe",
	"net.pe",
	"nom.pe",
	"org.pe",
	"pf",
	"com.pf",
	"edu.pf",
	"org.pf",
	"*.pg",
	"ph",
	"com.ph",
	"edu.ph",
	"gov.ph",
	"i.ph",
	"mil.ph",
	"net.ph",
	"ngo.ph",
	"org.ph",
	"pk",
	"ac.pk",
	"biz.pk",
	"com.pk",
	"edu.pk",
	"fam.pk",
	"gkp.pk",
	"gob.pk",
	"gog.pk",
	"gok.pk",
	"gon.pk",
	"gop.pk",
	"gos.pk",
	"gov.pk",
	"net.pk",
	"org.pk",
	"web.pk",
	"pl",
	"com.pl",
	"net.pl",
	"org.pl",
	"agro.pl",
	"aid.pl",
	"atm.pl",
	"auto.pl",
	"biz.pl",
	"edu.pl",
	"gmina.pl",
	"gsm.pl",
	"info.pl",
	"mail.pl",
	"media.pl",
	"miasta.pl",
	"mil.pl",
	"nieruchomosci.pl",
	"nom.pl",
	"pc.pl",
	"powiat.pl",
	"priv.pl",
	"realestate.pl",
	"rel.pl",
	"sex.pl",
	"shop.pl",
	"sklep.pl",
	"sos.pl",
	"szkola.pl",
	"targi.pl",
	"tm.pl",
	"tourism.pl",
	"travel.pl",
	"turystyka.pl",
	"gov.pl",
	"ap.gov.pl",
	"griw.gov.pl",
	"ic.gov.pl",
	"is.gov.pl",
	"kmpsp.gov.pl",
	"konsulat.gov.pl",
	"kppsp.gov.pl",
	"kwp.gov.pl",
	"kwpsp.gov.pl",
	"mup.gov.pl",
	"mw.gov.pl",
	"oia.gov.pl",
	"oirm.gov.pl",
	"oke.gov.pl",
	"oow.gov.pl",
	"oschr.gov.pl",
	"oum.gov.pl",
	"pa.gov.pl",
	"pinb.gov.pl",
	"piw.gov.pl",
	"po.gov.pl",
	"pr.gov.pl",
	"psp.gov.pl",
	"psse.gov.pl",
	"pup.gov.pl",
	"rzgw.gov.pl",
	"sa.gov.pl",
	"sdn.gov.pl",
	"sko.gov.pl",
	"so.gov.pl",
	"sr.gov.pl",
	"starostwo.gov.pl",
	"ug.gov.pl",
	"ugim.gov.pl",
	"um.gov.pl",
	"umig.gov.pl",
	"upow.gov.pl",
	"uppo.gov.pl",
	"us.gov.pl",
	"uw.gov.pl",
	"uzs.gov.pl",
	"wif.gov.pl",
	"wiih.gov.pl",
	"winb.gov.pl",
	"wios.gov.pl",
	"witd.gov.pl",
	"wiw.gov.pl",
	"wkz.gov.pl",
	"wsa.gov.pl",
	"wskr.gov.pl",
	"wsse.gov.pl",
	"wuoz.gov.pl",
	"wzmiuw.gov.pl",
	"zp.gov.pl",
	"zpisdn.gov.pl",
	"augustow.pl",
	"babia-gora.pl",
	"bedzin.pl",
	"beskidy.pl",
	"bialowieza.pl",
	"bialystok.pl",
	"bielawa.pl",
	"bieszczady.pl",
	"boleslawiec.pl",
	"bydgoszcz.pl",
	"bytom.pl",
	"cieszyn.pl",
	"czeladz.pl",
	"czest.pl",
	"dlugoleka.pl",
	"elblag.pl",
	"elk.pl",
	"glogow.pl",
	"gniezno.pl",
	"gorlice.pl",
	"grajewo.pl",
	"ilawa.pl",
	"jaworzno.pl",
	"jelenia-gora.pl",
	"jgora.pl",
	"kalisz.pl",
	"karpacz.pl",
	"kartuzy.pl",
	"kaszuby.pl",
	"katowice.pl",
	"kazimierz-dolny.pl",
	"kepno.pl",
	"ketrzyn.pl",
	"klodzko.pl",
	"kobierzyce.pl",
	"kolobrzeg.pl",
	"konin.pl",
	"konskowola.pl",
	"kutno.pl",
	"lapy.pl",
	"lebork.pl",
	"legnica.pl",
	"lezajsk.pl",
	"limanowa.pl",
	"lomza.pl",
	"lowicz.pl",
	"lubin.pl",
	"lukow.pl",
	"malbork.pl",
	"malopolska.pl",
	"mazowsze.pl",
	"mazury.pl",
	"mielec.pl",
	"mielno.pl",
	"mragowo.pl",
	"naklo.pl",
	"nowaruda.pl",
	"nysa.pl",
	"olawa.pl",
	"olecko.pl",
	"olkusz.pl",
	"olsztyn.pl",
	"opoczno.pl",
	"opole.pl",
	"ostroda.pl",
	"ostroleka.pl",
	"ostrowiec.pl",
	"ostrowwlkp.pl",
	"pila.pl",
	"pisz.pl",
	"podhale.pl",
	"podlasie.pl",
	"polkowice.pl",
	"pomorskie.pl",
	"pomorze.pl",
	"prochowice.pl",
	"pruszkow.pl",
	"przeworsk.pl",
	"pulawy.pl",
	"radom.pl",
	"rawa-maz.pl",
	"rybnik.pl",
	"rzeszow.pl",
	"sanok.pl",
	"sejny.pl",
	"skoczow.pl",
	"slask.pl",
	"slupsk.pl",
	"sosnowiec.pl",
	"stalowa-wola.pl",
	"starachowice.pl",
	"stargard.pl",
	"suwalki.pl",
	"swidnica.pl",
	"swiebodzin.pl",
	"swinoujscie.pl",
	"szczecin.pl",
	"szczytno.pl",
	"tarnobrzeg.pl",
	"tgory.pl",
	"turek.pl",
	"tychy.pl",
	"ustka.pl",
	"walbrzych.pl",
	"warmia.pl",
	"warszawa.pl",
	"waw.pl",
	"wegrow.pl",
	"wielun.pl",
	"wlocl.pl",
	"wloclawek.pl",
	"wodzislaw.pl",
	"wolomin.pl",
	"wroclaw.pl",
	"zachpomor.pl",
	"zagan.pl",
	"zarow.pl",
	"zgora.pl",
	"zgorzelec.pl",
	"pm",
	"pn",
	"co.pn",
	"edu.pn",
	"gov.pn",
	"net.pn",
	"org.pn",
	"post",
	"pr",
	"biz.pr",
	"com.pr",
	"edu.pr",
	"gov.pr",
	"info.pr",
	"isla.pr",
	"name.pr",
	"net.pr",
	"org.pr",
	"pro.pr",
	"ac.pr",
	"est.pr",
	"prof.pr",
	"pro",
	"aaa.pro",
	"aca.pro",
	"acct.pro",
	"avocat.pro",
	"bar.pro",
	"cpa.pro",
	"eng.pro",
	"jur.pro",
	"law.pro",
	"med.pro",
	"recht.pro",
	"ps",
	"com.ps",
	"edu.ps",
	"gov.ps",
	"net.ps",
	"org.ps",
	"plo.ps",
	"sec.ps",
	"pt",
	"com.pt",
	"edu.pt",
	"gov.pt",
	"int.pt",
	"net.pt",
	"nome.pt",
	"org.pt",
	"publ.pt",
	"pw",
	"belau.pw",
	"co.pw",
	"ed.pw",
	"go.pw",
	"or.pw",
	"py",
	"com.py",
	"coop.py",
	"edu.py",
	"gov.py",
	"mil.py",
	"net.py",
	"org.py",
	"qa",
	"com.qa",
	"edu.qa",
	"gov.qa",
	"mil.qa",
	"name.qa",
	"net.qa",
	"org.qa",
	"sch.qa",
	"re",
	"asso.re",
	"com.re",
	"ro",
	"arts.ro",
	"com.ro",
	"firm.ro",
	"info.ro",
	"nom.ro",
	"nt.ro",
	"org.ro",
	"rec.ro",
	"store.ro",
	"tm.ro",
	"www.ro",
	"rs",
	"ac.rs",
	"co.rs",
	"edu.rs",
	"gov.rs",
	"in.rs",
	"org.rs",
	"ru",
	"rw",
	"ac.rw",
	"co.rw",
	"coop.rw",
	"gov.rw",
	"mil.rw",
	"net.rw",
	"org.rw",
	"sa",
	"com.sa",
	"edu.sa",
	"gov.sa",
	"med.sa",
	"net.sa",
	"org.sa",
	"pub.sa",
	"sch.sa",
	"sb",
	"com.sb",
	"edu.sb",
	"gov.sb",
	"net.sb",
	"org.sb",
	"sc",
	"com.sc",
	"edu.sc",
	"gov.sc",
	"net.sc",
	"org.sc",
	"sd",
	"com.sd",
	"edu.sd",
	"gov.sd",
	"info.sd",
	"med.sd",
	"net.sd",
	"org.sd",
	"tv.sd",
	"se",
	"a.se",
	"ac.se",
	"b.se",
	"bd.se",
	"brand.se",
	"c.se",
	"d.se",
	"e.se",
	"f.se",
	"fh.se",
	"fhsk.se",
	"fhv.se",
	"g.se",
	"h.se",
	"i.se",
	"k.se",
	"komforb.se",
	"kommunalforbund.se",
	"komvux.se",
	"l.se",
	"lanbib.se",
	"m.se",
	"n.se",
	"naturbruksgymn.se",
	"o.se",
	"org.se",
	"p.se",
	"parti.se",
	"pp.se",
	"press.se",
	"r.se",
	"s.se",
	"t.se",
	"tm.se",
	"u.se",
	"w.se",
	"x.se",
	"y.se",
	"z.se",
	"sg",
	"com.sg",
	"edu.sg",
	"gov.sg",
	"net.sg",
	"org.sg",
	"sh",
	"com.sh",
	"gov.sh",
	"mil.sh",
	"net.sh",
	"org.sh",
	"si",
	"sj",
	"sk",
	"sl",
	"com.sl",
	"edu.sl",
	"gov.sl",
	"net.sl",
	"org.sl",
	"sm",
	"sn",
	"art.sn",
	"com.sn",
	"edu.sn",
	"gouv.sn",
	"org.sn",
	"perso.sn",
	"univ.sn",
	"so",
	"com.so",
	"edu.so",
	"gov.so",
	"me.so",
	"net.so",
	"org.so",
	"sr",
	"ss",
	"biz.ss",
	"co.ss",
	"com.ss",
	"edu.ss",
	"gov.ss",
	"me.ss",
	"net.ss",
	"org.ss",
	"sch.ss",
	"st",
	"co.st",
	"com.st",
	"consulado.st",
	"edu.st",
	"embaixada.st",
	"mil.st",
	"net.st",
	"org.st",
	"principe.st",
	"saotome.st",
	"store.st",
	"su",
	"sv",
	"com.sv",
	"edu.sv",
	"gob.sv",
	"org.sv",
	"red.sv",
	"sx",
	"gov.sx",
	"sy",
	"com.sy",
	"edu.sy",
	"gov.sy",
	"mil.sy",
	"net.sy",
	"org.sy",
	"sz",
	"ac.sz",
	"co.sz",
	"org.sz",
	"tc",
	"td",
	"tel",
	"tf",
	"tg",
	"th",
	"ac.th",
	"co.th",
	"go.th",
	"in.th",
	"mi.th",
	"net.th",
	"or.th",
	"tj",
	"ac.tj",
	"biz.tj",
	"co.tj",
	"com.tj",
	"edu.tj",
	"go.tj",
	"gov.tj",
	"int.tj",
	"mil.tj",
	"name.tj",
	"net.tj",
	"nic.tj",
	"org.tj",
	"test.tj",
	"web.tj",
	"tk",
	"tl",
	"gov.tl",
	"tm",
	"co.tm",
	"com.tm",
	"edu.tm",
	"gov.tm",
	"mil.tm",
	"net.tm",
	"nom.tm",
	"org.tm",
	"tn",
	"com.tn",
	"ens.tn",
	"fin.tn",
	"gov.tn",
	"ind.tn",
	"info.tn",
	"intl.tn",
	"mincom.tn",
	"nat.tn",
	"net.tn",
	"org.tn",
	"perso.tn",
	"tourism.tn",
	"to",
	"com.to",
	"edu.to",
	"gov.to",
	"mil.to",
	"net.to",
	"org.to",
	"tr",
	"av.tr",
	"bbs.tr",
	"bel.tr",
	"biz.tr",
	"com.tr",
	"dr.tr",
	"edu.tr",
	"gen.tr",
	"gov.tr",
	"info.tr",
	"k12.tr",
	"kep.tr",
	"mil.tr",
	"name.tr",
	"net.tr",
	"org.tr",
	"pol.tr",
	"tel.tr",
	"tsk.tr",
	"tv.tr",
	"web.tr",
	"nc.tr",
	"gov.nc.tr",
	"tt",
	"biz.tt",
	"co.tt",
	"com.tt",
	"edu.tt",
	"gov.tt",
	"info.tt",
	"mil.tt",
	"name.tt",
	"net.tt",
	"org.tt",
	"pro.tt",
	"tv",
	"tw",
	"club.tw",
	"com.tw",
	"ebiz.tw",
	"edu.tw",
	"game.tw",
	"gov.tw",
	"idv.tw",
	"mil.tw",
	"net.tw",
	"org.tw",
	"tz",
	"ac.tz",
	"co.tz",
	"go.tz",
	"hotel.tz",
	"info.tz",
	"me.tz",
	"mil.tz",
	"mobi.tz",
	"ne.tz",
	"or.tz",
	"sc.tz",
	"tv.tz",
	"ua",
	"com.ua",
	"edu.ua",
	"gov.ua",
	"in.ua",
	"net.ua",
	"org.ua",
	"cherkassy.ua",
	"cherkasy.ua",
	"chernigov.ua",
	"chernihiv.ua",
	"chernivtsi.ua",
	"chernovtsy.ua",
	"ck.ua",
	"cn.ua",
	"cr.ua",
	"crimea.ua",
	"cv.ua",
	"dn.ua",
	"dnepropetrovsk.ua",
	"dnipropetrovsk.ua",
	"donetsk.ua",
	"dp.ua",
	"if.ua",
	"ivano-frankivsk.ua",
	"kh.ua",
	"kharkiv.ua",
	"kharkov.ua",
	"kherson.ua",
	"khmelnitskiy.ua",
	"khmelnytskyi.ua",
	"kiev.ua",
	"kirovograd.ua",
	"km.ua",
	"kr.ua",
	"kropyvnytskyi.ua",
	"krym.ua",
	"ks.ua",
	"kv.ua",
	"kyiv.ua",
	"lg.ua",
	"lt.ua",
	"lugansk.ua",
	"luhansk.ua",
	"lutsk.ua",
	"lv.ua",
	"lviv.ua",
	"mk.ua",
	"mykolaiv.ua",
	"nikolaev.ua",
	"od.ua",
	"odesa.ua",
	"odessa.ua",
	"pl.ua",
	"poltava.ua",
	"rivne.ua",
	"rovno.ua",
	"rv.ua",
	"sb.ua",
	"sebastopol.ua",
	"sevastopol.ua",
	"sm.ua",
	"sumy.ua",
	"te.ua",
	"ternopil.ua",
	"uz.ua",
	"uzhgorod.ua",
	"uzhhorod.ua",
	"vinnica.ua",
	"vinnytsia.ua",
	"vn.ua",
	"volyn.ua",
	"yalta.ua",
	"zakarpattia.ua",
	"zaporizhzhe.ua",
	"zaporizhzhia.ua",
	"zhitomir.ua",
	"zhytomyr.ua",
	"zp.ua",
	"zt.ua",
	"ug",
	"ac.ug",
	"co.ug",
	"com.ug",
	"go.ug",
	"ne.ug",
	"or.ug",
	"org.ug",
	"sc.ug",
	"uk",
	"ac.uk",
	"co.uk",
	"gov.uk",
	"ltd.uk",
	"me.uk",
	"net.uk",
	"nhs.uk",
	"org.uk",
	"plc.uk",
	"police.uk",
	"*.sch.uk",
	"us",
	"dni.us",
	"fed.us",
	"isa.us",
	"kids.us",
	"nsn.us",
	"ak.us",
	"al.us",
	"ar.us",
	"as.us",
	"az.us",
	"ca.us",
	"co.us",
	"ct.us",
	"dc.us",
	"de.us",
	"fl.us",
	"ga.us",
	"gu.us",
	"hi.us",
	"ia.us",
	"id.us",
	"il.us",
	"in.us",
	"ks.us",
	"ky.us",
	"la.us",
	"ma.us",
	"md.us",
	"me.us",
	"mi.us",
	"mn.us",
	"mo.us",
	"ms.us",
	"mt.us",
	"nc.us",
	"nd.us",
	"ne.us",
	"nh.us",
	"nj.us",
	"nm.us",
	"nv.us",
	"ny.us",
	"oh.us",
	"ok.us",
	"or.us",
	"pa.us",
	"pr.us",
	"ri.us",
	"sc.us",
	"sd.us",
	"tn.us",
	"tx.us",
	"ut.us",
	"va.us",
	"vi.us",
	"vt.us",
	"wa.us",
	"wi.us",
	"wv.us",
	"wy.us",
	"k12.ak.us",
	"k12.al.us",
	"k12.ar.us",
	"k12.as.us",
	"k12.az.us",
	"k12.ca.us",
	"k12.co.us",
	"k12.ct.us",
	"k12.dc.us",
	"k12.fl.us",
	"k12.ga.us",
	"k12.gu.us",
	"k12.ia.us",
	"k12.id.us",
	"k12.il.us",
	"k12.in.us",
	"k12.ks.us",
	"k12.ky.us",
	"k12.la.us",
	"k12.ma.us",
	"k12.md.us",
	"k12.me.us",
	"k12.mi.us",
	"k12.mn.us",
	"k12.mo.us",
	"k12.ms.us",
	"k12.mt.us",
	"k12.nc.us",
	"k12.ne.us",
	"k12.nh.us",
	"k12.nj.us",
	"k12.nm.us",
	"k12.nv.us",
	"k12.ny.us",
	"k12.oh.us",
	"k12.ok.us",
	"k12.or.us",
	"k12.pa.us",
	"k12.pr.us",
	"k12.sc.us",
	"k12.tn.us",
	"k12.tx.us",
	"k12.ut.us",
	"k12.va.us",
	"k12.vi.us",
	"k12.vt.us",
	"k12.wa.us",
	"k12.wi.us",
	"cc.ak.us",
	"lib.ak.us",
	"cc.al.us",
	"lib.al.us",
	"cc.ar.us",
	"lib.ar.us",
	"cc.as.us",
	"lib.as.us",
	"cc.az.us",
	"lib.az.us",
	"cc.ca.us",
	"lib.ca.us",
	"cc.co.us",
	"lib.co.us",
	"cc.ct.us",
	"lib.ct.us",
	"cc.dc.us",
	"lib.dc.us",
	"cc.de.us",
	"cc.fl.us",
	"cc.ga.us",
	"cc.gu.us",
	"cc.hi.us",
	"cc.ia.us",
	"cc.id.us",
	"cc.il.us",
	"cc.in.us",
	"cc.ks.us",
	"cc.ky.us",
	"cc.la.us",
	"cc.ma.us",
	"cc.md.us",
	"cc.me.us",
	"cc.mi.us",
	"cc.mn.us",
	"cc.mo.us",
	"cc.ms.us",
	"cc.mt.us",
	"cc.nc.us",
	"cc.nd.us",
	"cc.ne.us",
	"cc.nh.us",
	"cc.nj.us",
	"cc.nm.us",
	"cc.nv.us",
	"cc.ny.us",
	"cc.oh.us",
	"cc.ok.us",
	"cc.or.us",
	"cc.pa.us",
	"cc.pr.us",
	"cc.ri.us",
	"cc.sc.us",
	"cc.sd.us",
	"cc.tn.us",
	"cc.tx.us",
	"cc.ut.us",
	"cc.va.us",
	"cc.vi.us",
	"cc.vt.us",
	"cc.wa.us",
	"cc.wi.us",
	"cc.wv.us",
	"cc.wy.us",
	"k12.wy.us",
	"lib.fl.us",
	"lib.ga.us",
	"lib.gu.us",
	"lib.hi.us",
	"lib.ia.us",
	"lib.id.us",
	"lib.il.us",
	"lib.in.us",
	"lib.ks.us",
	"lib.ky.us",
	"lib.la.us",
	"lib.ma.us",
	"lib.md.us",
	"lib.me.us",
	"lib.mi.us",
	"lib.mn.us",
	"lib.mo.us",
	"lib.ms.us",
	"lib.mt.us",
	"lib.nc.us",
	"lib.nd.us",
	"lib.ne.us",
	"lib.nh.us",
	"lib.nj.us",
	"lib.nm.us",
	"lib.nv.us",
	"lib.ny.us",
	"lib.oh.us",
	"lib.ok.us",
	"lib.or.us",
	"lib.pa.us",
	"lib.pr.us",
	"lib.ri.us",
	"lib.sc.us",
	"lib.sd.us",
	"lib.tn.us",
	"lib.tx.us",
	"lib.ut.us",
	"lib.va.us",
	"lib.vi.us",
	"lib.vt.us",
	"lib.wa.us",
	"lib.wi.us",
	"lib.wy.us",
	"chtr.k12.ma.us",
	"paroch.k12.ma.us",
	"pvt.k12.ma.us",
	"ann-arbor.mi.us",
	"cog.mi.us",
	"dst.mi.us",
	"eaton.mi.us",
	"gen.mi.us",
	"mus.mi.us",
	"tec.mi.us",
	"washtenaw.mi.us",
	"uy",
	"com.uy",
	"edu.uy",
	"gub.uy",
	"mil.uy",
	"net.uy",
	"org.uy",
	"uz",
	"co.uz",
	"com.uz",
	"net.uz",
	"org.uz",
	"va",
	"vc",
	"com.vc",
	"edu.vc",
	"gov.vc",
	"mil.vc",
	"net.vc",
	"org.vc",
	"ve",
	"arts.ve",
	"bib.ve",
	"co.ve",
	"com.ve",
	"e12.ve",
	"edu.ve",
	"firm.ve",
	"gob.ve",
	"gov.ve",
	"info.ve",
	"int.ve",
	"mil.ve",
	"net.ve",
	"nom.ve",
	"org.ve",
	"rar.ve",
	"rec.ve",
	"store.ve",
	"tec.ve",
	"web.ve",
	"vg",
	"vi",
	"co.vi",
	"com.vi",
	"k12.vi",
	"net.vi",
	"org.vi",
	"vn",
	"ac.vn",
	"ai.vn",
	"biz.vn",
	"com.vn",
	"edu.vn",
	"gov.vn",
	"health.vn",
	"id.vn",
	"info.vn",
	"int.vn",
	"io.vn",
	"name.vn",
	"net.vn",
	"org.vn",
	"pro.vn",
	"angiang.vn",
	"bacgiang.vn",
	"backan.vn",
	"baclieu.vn",
	"bacninh.vn",
	"baria-vungtau.vn",
	"bentre.vn",
	"binhdinh.vn",
	"binhduong.vn",
	"binhphuoc.vn",
	"binhthuan.vn",
	"camau.vn",
	"cantho.vn",
	"caobang.vn",
	"daklak.vn",
	"daknong.vn",
	"danang.vn",
	"dienbien.vn",
	"dongnai.vn",
	"dongthap.vn",
	"gialai.vn",
	"hagiang.vn",
	"haiduong.vn",
	"haiphong.vn",
	"hanam.vn",
	"hanoi.vn",
	"hatinh.vn",
	"haugiang.vn",
	"hoabinh.vn",
	"hungyen.vn",
	"khanhhoa.vn",
	"kiengiang.vn",
	"kontum.vn",
	"laichau.vn",
	"lamdong.vn",
	"langson.vn",
	"laocai.vn",
	"longan.vn",
	"namdinh.vn",
	"nghean.vn",
	"ninhbinh.vn",
	"ninhthuan.vn",
	"phutho.vn",
	"phuyen.vn",
	"quangbinh.vn",
	"quangnam.vn",
	"quangngai.vn",
	"quangninh.vn",
	"quangtri.vn",
	"soctrang.vn",
	"sonla.vn",
	"tayninh.vn",
	"thaibinh.vn",
	"thainguyen.vn",
	"thanhhoa.vn",
	"thanhphohochiminh.vn",
	"thuathienhue.vn",
	"tiengiang.vn",
	"travinh.vn",
	"tuyenquang.vn",
	"vinhlong.vn",
	"vinhphuc.vn",
	"yenbai.vn",
	"vu",
	"com.vu",
	"edu.vu",
	"net.vu",
	"org.vu",
	"wf",
	"ws",
	"com.ws",
	"edu.ws",
	"gov.ws",
	"net.ws",
	"org.ws",
	"yt",
	"امارات",
	"հայ",
	"বাংলা",
	"бг",
	"البحرين",
	"бел",
	"中国",
	"中國",
	"الجزائر",
	"مصر",
	"ею",
	"ευ",
	"موريتانيا",
	"გე",
	"ελ",
	"香港",
	"個人.香港",
	"公司.香港",
	"政府.香港",
	"教育.香港",
	"組織.香港",
	"網絡.香港",
	"ಭಾರತ",
	"ଭାରତ",
	"ভাৰত",
	"भारतम्",
	"भारोत",
	"ڀارت",
	"ഭാരതം",
	"भारत",
	"بارت",
	"بھارت",
	"భారత్",
	"ભારત",
	"ਭਾਰਤ",
	"ভারত",
	"இந்தியா",
	"ایران",
	"ايران",
	"عراق",
	"الاردن",
	"한국",
	"қаз",
	"ລາວ",
	"ලංකා",
	"இலங்கை",
	"المغرب",
	"мкд",
	"мон",
	"澳門",
	"澳门",
	"مليسيا",
	"عمان",
	"پاکستان",
	"پاكستان",
	"فلسطين",
	"срб",
	"ак.срб",
	"обр.срб",
	"од.срб",
	"орг.срб",
	"пр.срб",
	"упр.срб",
	"рф",
	"قطر",
	"السعودية",
	"السعودیة",
	"السعودیۃ",
	"السعوديه",
	"سودان",
	"新加坡",
	"சிங்கப்பூர்",
	"سورية",
	"سوريا",
	"ไทย",
	"ทหาร.ไทย",
	"ธุรกิจ.ไทย",
	"เน็ต.ไทย",
	"รัฐบาล.ไทย",
	"ศึกษา.ไทย",
	"องค์กร.ไทย",
	"تونس",
	"台灣",
	"台湾",
	"臺灣",
	"укр",
	"اليمن",
	"xxx",
	"ye",
	"com.ye",
	"edu.ye",
	"gov.ye",
	"mil.ye",
	"net.ye",
	"org.ye",
	"ac.za",
	"agric.za",
	"alt.za",
	"co.za",
	"edu.za",
	"gov.za",
	"grondar.za",
	"law.za",
	"mil.za",
	"net.za",
	"ngo.za",
	"nic.za",
	"nis.za",
	"nom.za",
	"org.za",
	"school.za",
	"tm.za",
	"web.za",
	"zm",
	"ac.zm",
	"biz.zm",
	"co.zm",
	"com.zm",
	"edu.zm",
	"gov.zm",
	"info.zm",
	"mil.zm",
	"net.zm",
	"org.zm",
	"sch.zm",
	"zw",
	"ac.zw",
	"co.zw",
	"gov.zw",
	"mil.zw",
	"org.zw",
	"aaa",
	"aarp",
	"abb",
	"abbott",
	"abbvie",
	"abc",
	"able",
	"abogado",
	"abudhabi",
	"academy",
	"accenture",
	"accountant",
	"accountants",
	"aco",
	"actor",
	"ads",
	"adult",
	"aeg",
	"aetna",
	"afl",
	"africa",
	"agakhan",
	"agency",
	"aig",
	"airbus",
	"airforce",
	"airtel",
	"akdn",
	"alibaba",
	"alipay",
	"allfinanz",
	"allstate",
	"ally",
	"alsace",
	"alstom",
	"amazon",
	"americanexpress",
	"americanfamily",
	"amex",
	"amfam",
	"amica",
	"amsterdam",
	"analytics",
	"android",
	"anquan",
	"anz",
	"aol",
	"apartments",
	"app",
	"apple",
	"aquarelle",
	"arab",
	"aramco",
	"archi",
	"army",
	"art",
	"arte",
	"asda",
	"associates",
	"athleta",
	"attorney",
	"auction",
	"audi",
	"audible",
	"audio",
	"auspost",
	"author",
	"auto",
	"autos",
	"aws",
	"axa",
	"azure",
	"baby",
	"baidu",
	"banamex",
	"band",
	"bank",
	"bar",
	"barcelona",
	"barclaycard",
	"barclays",
	"barefoot",
	"bargains",
	"baseball",
	"basketball",
	"bauhaus",
	"bayern",
	"bbc",
	"bbt",
	"bbva",
	"bcg",
	"bcn",
	"beats",
	"beauty",
	"beer",
	"bentley",
	"berlin",
	"best",
	"bestbuy",
	"bet",
	"bharti",
	"bible",
	"bid",
	"bike",
	"bing",
	"bingo",
	"bio",
	"black",
	"blackfriday",
	"blockbuster",
	"blog",
	"bloomberg",
	"blue",
	"bms",
	"bmw",
	"bnpparibas",
	"boats",
	"boehringer",
	"bofa",
	"bom",
	"bond",
	"boo",
	"book",
	"booking",
	"bosch",
	"bostik",
	"boston",
	"bot",
	"boutique",
	"box",
	"bradesco",
	"bridgestone",
	"broadway",
	"broker",
	"brother",
	"brussels",
	"build",
	"builders",
	"business",
	"buy",
	"buzz",
	"bzh",
	"cab",
	"cafe",
	"cal",
	"call",
	"calvinklein",
	"cam",
	"camera",
	"camp",
	"canon",
	"capetown",
	"capital",
	"capitalone",
	"car",
	"caravan",
	"cards",
	"care",
	"career",
	"careers",
	"cars",
	"casa",
	"case",
	"cash",
	"casino",
	"catering",
	"catholic",
	"cba",
	"cbn",
	"cbre",
	"center",
	"ceo",
	"cern",
	"cfa",
	"cfd",
	"chanel",
	"channel",
	"charity",
	"chase",
	"chat",
	"cheap",
	"chintai",
	"christmas",
	"chrome",
	"church",
	"cipriani",
	"circle",
	"cisco",
	"citadel",
	"citi",
	"citic",
	"city",
	"claims",
	"cleaning",
	"click",
	"clinic",
	"clinique",
	"clothing",
	"cloud",
	"club",
	"clubmed",
	"coach",
	"codes",
	"coffee",
	"college",
	"cologne",
	"commbank",
	"community",
	"company",
	"compare",
	"computer",
	"comsec",
	"condos",
	"construction",
	"consulting",
	"contact",
	"contractors",
	"cooking",
	"cool",
	"corsica",
	"country",
	"coupon",
	"coupons",
	"courses",
	"cpa",
	"credit",
	"creditcard",
	"creditunion",
	"cricket",
	"crown",
	"crs",
	"cruise",
	"cruises",
	"cuisinella",
	"cymru",
	"cyou",
	"dad",
	"dance",
	"data",
	"date",
	"dating",
	"datsun",
	"day",
	"dclk",
	"dds",
	"deal",
	"dealer",
	"deals",
	"degree",
	"delivery",
	"dell",
	"deloitte",
	"delta",
	"democrat",
	"dental",
	"dentist",
	"desi",
	"design",
	"dev",
	"dhl",
	"diamonds",
	"diet",
	"digital",
	"direct",
	"directory",
	"discount",
	"discover",
	"dish",
	"diy",
	"dnp",
	"docs",
	"doctor",
	"dog",
	"domains",
	"dot",
	"download",
	"drive",
	"dtv",
	"dubai",
	"dunlop",
	"dupont",
	"durban",
	"dvag",
	"dvr",
	"earth",
	"eat",
	"eco",
	"edeka",
	"education",
	"email",
	"emerck",
	"energy",
	"engineer",
	"engineering",
	"enterprises",
	"epson",
	"equipment",
	"ericsson",
	"erni",
	"esq",
	"estate",
	"eurovision",
	"eus",
	"events",
	"exchange",
	"expert",
	"exposed",
	"express",
	"extraspace",
	"fage",
	"fail",
	"fairwinds",
	"faith",
	"family",
	"fan",
	"fans",
	"farm",
	"farmers",
	"fashion",
	"fast",
	"fedex",
	"feedback",
	"ferrari",
	"ferrero",
	"fidelity",
	"fido",
	"film",
	"final",
	"finance",
	"financial",
	"fire",
	"firestone",
	"firmdale",
	"fish",
	"fishing",
	"fit",
	"fitness",
	"flickr",
	"flights",
	"flir",
	"florist",
	"flowers",
	"fly",
	"foo",
	"food",
	"football",
	"ford",
	"forex",
	"forsale",
	"forum",
	"foundation",
	"fox",
	"free",
	"fresenius",
	"frl",
	"frogans",
	"frontier",
	"ftr",
	"fujitsu",
	"fun",
	"fund",
	"furniture",
	"futbol",
	"fyi",
	"gal",
	"gallery",
	"gallo",
	"gallup",
	"game",
	"games",
	"gap",
	"garden",
	"gay",
	"gbiz",
	"gdn",
	"gea",
	"gent",
	"genting",
	"george",
	"ggee",
	"gift",
	"gifts",
	"gives",
	"giving",
	"glass",
	"gle",
	"global",
	"globo",
	"gmail",
	"gmbh",
	"gmo",
	"gmx",
	"godaddy",
	"gold",
	"goldpoint",
	"golf",
	"goo",
	"goodyear",
	"goog",
	"google",
	"gop",
	"got",
	"grainger",
	"graphics",
	"gratis",
	"green",
	"gripe",
	"grocery",
	"group",
	"gucci",
	"guge",
	"guide",
	"guitars",
	"guru",
	"hair",
	"hamburg",
	"hangout",
	"haus",
	"hbo",
	"hdfc",
	"hdfcbank",
	"health",
	"healthcare",
	"help",
	"helsinki",
	"here",
	"hermes",
	"hiphop",
	"hisamitsu",
	"hitachi",
	"hiv",
	"hkt",
	"hockey",
	"holdings",
	"holiday",
	"homedepot",
	"homegoods",
	"homes",
	"homesense",
	"honda",
	"horse",
	"hospital",
	"host",
	"hosting",
	"hot",
	"hotels",
	"hotmail",
	"house",
	"how",
	"hsbc",
	"hughes",
	"hyatt",
	"hyundai",
	"ibm",
	"icbc",
	"ice",
	"icu",
	"ieee",
	"ifm",
	"ikano",
	"imamat",
	"imdb",
	"immo",
	"immobilien",
	"inc",
	"industries",
	"infiniti",
	"ing",
	"ink",
	"institute",
	"insurance",
	"insure",
	"international",
	"intuit",
	"investments",
	"ipiranga",
	"irish",
	"ismaili",
	"ist",
	"istanbul",
	"itau",
	"itv",
	"jaguar",
	"java",
	"jcb",
	"jeep",
	"jetzt",
	"jewelry",
	"jio",
	"jll",
	"jmp",
	"jnj",
	"joburg",
	"jot",
	"joy",
	"jpmorgan",
	"jprs",
	"juegos",
	"juniper",
	"kaufen",
	"kddi",
	"kerryhotels",
	"kerrylogistics",
	"kerryproperties",
	"kfh",
	"kia",
	"kids",
	"kim",
	"kindle",
	"kitchen",
	"kiwi",
	"koeln",
	"komatsu",
	"kosher",
	"kpmg",
	"kpn",
	"krd",
	"kred",
	"kuokgroup",
	"kyoto",
	"lacaixa",
	"lamborghini",
	"lamer",
	"lancaster",
	"land",
	"landrover",
	"lanxess",
	"lasalle",
	"lat",
	"latino",
	"latrobe",
	"law",
	"lawyer",
	"lds",
	"lease",
	"leclerc",
	"lefrak",
	"legal",
	"lego",
	"lexus",
	"lgbt",
	"lidl",
	"life",
	"lifeinsurance",
	"lifestyle",
	"lighting",
	"like",
	"lilly",
	"limited",
	"limo",
	"lincoln",
	"link",
	"lipsy",
	"live",
	"living",
	"llc",
	"llp",
	"loan",
	"loans",
	"locker",
	"locus",
	"lol",
	"london",
	"lotte",
	"lotto",
	"love",
	"lpl",
	"lplfinancial",
	"ltd",
	"ltda",
	"lundbeck",
	"luxe",
	"luxury",
	"madrid",
	"maif",
	"maison",
	"makeup",
	"man",
	"management",
	"mango",
	"map",
	"market",
	"marketing",
	"markets",
	"marriott",
	"marshalls",
	"mattel",
	"mba",
	"mckinsey",
	"med",
	"media",
	"meet",
	"melbourne",
	"meme",
	"memorial",
	"men",
	"menu",
	"merck",
	"merckmsd",
	"miami",
	"microsoft",
	"mini",
	"mint",
	"mit",
	"mitsubishi",
	"mlb",
	"mls",
	"mma",
	"mobile",
	"moda",
	"moe",
	"moi",
	"mom",
	"monash",
	"money",
	"monster",
	"mormon",
	"mortgage",
	"moscow",
	"moto",
	"motorcycles",
	"mov",
	"movie",
	"msd",
	"mtn",
	"mtr",
	"music",
	"nab",
	"nagoya",
	"navy",
	"nba",
	"nec",
	"netbank",
	"netflix",
	"network",
	"neustar",
	"new",
	"news",
	"next",
	"nextdirect",
	"nexus",
	"nfl",
	"ngo",
	"nhk",
	"nico",
	"nike",
	"nikon",
	"ninja",
	"nissan",
	"nissay",
	"nokia",
	"norton",
	"now",
	"nowruz",
	"nowtv",
	"nra",
	"nrw",
	"ntt",
	"nyc",
	"obi",
	"observer",
	"office",
	"okinawa",
	"olayan",
	"olayangroup",
	"ollo",
	"omega",
	"one",
	"ong",
	"onl",
	"online",
	"ooo",
	"open",
	"oracle",
	"orange",
	"organic",
	"origins",
	"osaka",
	"otsuka",
	"ott",
	"ovh",
	"page",
	"panasonic",
	"paris",
	"pars",
	"partners",
	"parts",
	"party",
	"pay",
	"pccw",
	"pet",
	"pfizer",
	"pharmacy",
	"phd",
	"philips",
	"phone",
	"photo",
	"photography",
	"photos",
	"physio",
	"pics",
	"pictet",
	"pictures",
	"pid",
	"pin",
	"ping",
	"pink",
	"pioneer",
	"pizza",
	"place",
	"play",
	"playstation",
	"plumbing",
	"plus",
	"pnc",
	"pohl",
	"poker",
	"politie",
	"porn",
	"pramerica",
	"praxi",
	"press",
	"prime",
	"prod",
	"productions",
	"prof",
	"progressive",
	"promo",
	"properties",
	"property",
	"protection",
	"pru",
	"prudential",
	"pub",
	"pwc",
	"qpon",
	"quebec",
	"quest",
	"racing",
	"radio",
	"read",
	"realestate",
	"realtor",
	"realty",
	"recipes",
	"red",
	"redstone",
	"redumbrella",
	"rehab",
	"reise",
	"reisen",
	"reit",
	"reliance",
	"ren",
	"rent",
	"rentals",
	"repair",
	"report",
	"republican",
	"rest",
	"restaurant",
	"review",
	"reviews",
	"rexroth",
	"rich",
	"richardli",
	"ricoh",
	"ril",
	"rio",
	"rip",
	"rocks",
	"rodeo",
	"rogers",
	"room",
	"rsvp",
	"rugby",
	"ruhr",
	"run",
	"rwe",
	"ryukyu",
	"saarland",
	"safe",
	"safety",
	"sakura",
	"sale",
	"salon",
	"samsclub",
	"samsung",
	"sandvik",
	"sandvikcoromant",
	"sanofi",
	"sap",
	"sarl",
	"sas",
	"save",
	"saxo",
	"sbi",
	"sbs",
	"scb",
	"schaeffler",
	"schmidt",
	"scholarships",
	"school",
	"schule",
	"schwarz",
	"science",
	"scot",
	"search",
	"seat",
	"secure",
	"security",
	"seek",
	"select",
	"sener",
	"services",
	"seven",
	"sew",
	"sex",
	"sexy",
	"sfr",
	"shangrila",
	"sharp",
	"shell",
	"shia",
	"shiksha",
	"shoes",
	"shop",
	"shopping",
	"shouji",
	"show",
	"silk",
	"sina",
	"singles",
	"site",
	"ski",
	"skin",
	"sky",
	"skype",
	"sling",
	"smart",
	"smile",
	"sncf",
	"soccer",
	"social",
	"softbank",
	"software",
	"sohu",
	"solar",
	"solutions",
	"song",
	"sony",
	"soy",
	"spa",
	"space",
	"sport",
	"spot",
	"srl",
	"stada",
	"staples",
	"star",
	"statebank",
	"statefarm",
	"stc",
	"stcgroup",
	"stockholm",
	"storage",
	"store",
	"stream",
	"studio",
	"study",
	"style",
	"sucks",
	"supplies",
	"supply",
	"support",
	"surf",
	"surgery",
	"suzuki",
	"swatch",
	"swiss",
	"sydney",
	"systems",
	"tab",
	"taipei",
	"talk",
	"taobao",
	"target",
	"tatamotors",
	"tatar",
	"tattoo",
	"tax",
	"taxi",
	"tci",
	"tdk",
	"team",
	"tech",
	"technology",
	"temasek",
	"tennis",
	"teva",
	"thd",
	"theater",
	"theatre",
	"tiaa",
	"tickets",
	"tienda",
	"tips",
	"tires",
	"tirol",
	"tjmaxx",
	"tjx",
	"tkmaxx",
	"tmall",
	"today",
	"tokyo",
	"tools",
	"top",
	"toray",
	"toshiba",
	"total",
	"tours",
	"town",
	"toyota",
	"toys",
	"trade",
	"trading",
	"training",
	"travel",
	"travelers",
	"travelersinsurance",
	"trust",
	"trv",
	"tube",
	"tui",
	"tunes",
	"tushu",
	"tvs",
	"ubank",
	"ubs",
	"unicom",
	"university",
	"uno",
	"uol",
	"ups",
	"vacations",
	"vana",
	"vanguard",
	"vegas",
	"ventures",
	"verisign",
	"versicherung",
	"vet",
	"viajes",
	"video",
	"vig",
	"viking",
	"villas",
	"vin",
	"vip",
	"virgin",
	"visa",
	"vision",
	"viva",
	"vivo",
	"vlaanderen",
	"vodka",
	"volvo",
	"vote",
	"voting",
	"voto",
	"voyage",
	"wales",
	"walmart",
	"walter",
	"wang",
	"wanggou",
	"watch",
	"watches",
	"weather",
	"weatherchannel",
	"webcam",
	"weber",
	"website",
	"wed",
	"wedding",
	"weibo",
	"weir",
	"whoswho",
	"wien",
	"wiki",
	"williamhill",
	"win",
	"windows",
	"wine",
	"winners",
	"wme",
	"wolterskluwer",
	"woodside",
	"work",
	"works",
	"world",
	"wow",
	"wtc",
	"wtf",
	"xbox",
	"xerox",
	"xihuan",
	"xin",
	"कॉम",
	"セール",
	"佛山",
	"慈善",
	"集团",
	"在线",
	"点看",
	"คอม",
	"八卦",
	"موقع",
	"公益",
	"公司",
	"香格里拉",
	"网站",
	"移动",
	"我爱你",
	"москва",
	"католик",
	"онлайн",
	"сайт",
	"联通",
	"קום",
	"时尚",
	"微博",
	"淡马锡",
	"ファッション",
	"орг",
	"नेट",
	"ストア",
	"アマゾン",
	"삼성",
	"商标",
	"商店",
	"商城",
	"дети",
	"ポイント",
	"新闻",
	"家電",
	"كوم",
	"中文网",
	"中信",
	"娱乐",
	"谷歌",
	"電訊盈科",
	"购物",
	"クラウド",
	"通販",
	"网店",
	"संगठन",
	"餐厅",
	"网络",
	"ком",
	"亚马逊",
	"食品",
	"飞利浦",
	"手机",
	"ارامكو",
	"العليان",
	"بازار",
	"ابوظبي",
	"كاثوليك",
	"همراه",
	"닷컴",
	"政府",
	"شبكة",
	"بيتك",
	"عرب",
	"机构",
	"组织机构",
	"健康",
	"招聘",
	"рус",
	"大拿",
	"みんな",
	"グーグル",
	"世界",
	"書籍",
	"网址",
	"닷넷",
	"コム",
	"天主教",
	"游戏",
	"vermögensberater",
	"vermögensberatung",
	"企业",
	"信息",
	"嘉里大酒店",
	"嘉里",
	"广东",
	"政务",
	"xyz",
	"yachts",
	"yahoo",
	"yamaxun",
	"yandex",
	"yodobashi",
	"yoga",
	"yokohama",
	"you",
	"youtube",
	"yun",
	"zappos",
	"zara",
	"zero",
	"zip",
	"zone",
	"zuerich",
	"co.krd",
	"edu.krd",
	"art.pl",
	"gliwice.pl",
	"krakow.pl",
	"poznan.pl",
	"wroc.pl",
	"zakopane.pl",
	"lib.de.us",
	"12chars.dev",
	"12chars.it",
	"12chars.pro",
	"cc.ua",
	"inf.ua",
	"ltd.ua",
	"611.to",
	"a2hosted.com",
	"cpserver.com",
	"aaa.vodka",
	"*.on-acorn.io",
	"activetrail.biz",
	"adaptable.app",
	"adobeaemcloud.com",
	"*.dev.adobeaemcloud.com",
	"aem.live",
	"hlx.live",
	"adobeaemcloud.net",
	"aem.page",
	"hlx.page",
	"hlx3.page",
	"adobeio-static.net",
	"adobeioruntime.net",
	"africa.com",
	"beep.pl",
	"airkitapps.com",
	"airkitapps-au.com",
	"airkitapps.eu",
	"aivencloud.com",
	"akadns.net",
	"akamai.net",
	"akamai-staging.net",
	"akamaiedge.net",
	"akamaiedge-staging.net",
	"akamaihd.net",
	"akamaihd-staging.net",
	"akamaiorigin.net",
	"akamaiorigin-staging.net",
	"akamaized.net",
	"akamaized-staging.net",
	"edgekey.net",
	"edgekey-staging.net",
	"edgesuite.net",
	"edgesuite-staging.net",
	"barsy.ca",
	"*.compute.estate",
	"*.alces.network",
	"kasserver.com",
	"altervista.org",
	"alwaysdata.net",
	"myamaze.net",
	"execute-api.cn-north-1.amazonaws.com.cn",
	"execute-api.cn-northwest-1.amazonaws.com.cn",
	"execute-api.af-south-1.amazonaws.com",
	"execute-api.ap-east-1.amazonaws.com",
	"execute-api.ap-northeast-1.amazonaws.com",
	"execute-api.ap-northeast-2.amazonaws.com",
	"execute-api.ap-northeast-3.amazonaws.com",
	"execute-api.ap-south-1.amazonaws.com",
	"execute-api.ap-south-2.amazonaws.com",
	"execute-api.ap-southeast-1.amazonaws.com",
	"execute-api.ap-southeast-2.amazonaws.com",
	"execute-api.ap-southeast-3.amazonaws.com",
	"execute-api.ap-southeast-4.amazonaws.com",
	"execute-api.ap-southeast-5.amazonaws.com",
	"execute-api.ca-central-1.amazonaws.com",
	"execute-api.ca-west-1.amazonaws.com",
	"execute-api.eu-central-1.amazonaws.com",
	"execute-api.eu-central-2.amazonaws.com",
	"execute-api.eu-north-1.amazonaws.com",
	"execute-api.eu-south-1.amazonaws.com",
	"execute-api.eu-south-2.amazonaws.com",
	"execute-api.eu-west-1.amazonaws.com",
	"execute-api.eu-west-2.amazonaws.com",
	"execute-api.eu-west-3.amazonaws.com",
	"execute-api.il-central-1.amazonaws.com",
	"execute-api.me-central-1.amazonaws.com",
	"execute-api.me-south-1.amazonaws.com",
	"execute-api.sa-east-1.amazonaws.com",
	"execute-api.us-east-1.amazonaws.com",
	"execute-api.us-east-2.amazonaws.com",
	"execute-api.us-gov-east-1.amazonaws.com",
	"execute-api.us-gov-west-1.amazonaws.com",
	"execute-api.us-west-1.amazonaws.com",
	"execute-api.us-west-2.amazonaws.com",
	"cloudfront.net",
	"auth.af-south-1.amazoncognito.com",
	"auth.ap-east-1.amazoncognito.com",
	"auth.ap-northeast-1.amazoncognito.com",
	"auth.ap-northeast-2.amazoncognito.com",
	"auth.ap-northeast-3.amazoncognito.com",
	"auth.ap-south-1.amazoncognito.com",
	"auth.ap-south-2.amazoncognito.com",
	"auth.ap-southeast-1.amazoncognito.com",
	"auth.ap-southeast-2.amazoncognito.com",
	"auth.ap-southeast-3.amazoncognito.com",
	"auth.ap-southeast-4.amazoncognito.com",
	"auth.ca-central-1.amazoncognito.com",
	"auth.ca-west-1.amazoncognito.com",
	"auth.eu-central-1.amazoncognito.com",
	"auth.eu-central-2.amazoncognito.com",
	"auth.eu-north-1.amazoncognito.com",
	"auth.eu-south-1.amazoncognito.com",
	"auth.eu-south-2.amazoncognito.com",
	"auth.eu-west-1.amazoncognito.com",
	"auth.eu-west-2.amazoncognito.com",
	"auth.eu-west-3.amazoncognito.com",
	"auth.il-central-1.amazoncognito.com",
	"auth.me-central-1.amazoncognito.com",
	"auth.me-south-1.amazoncognito.com",
	"auth.sa-east-1.amazoncognito.com",
	"auth.us-east-1.amazoncognito.com",
	"auth-fips.us-east-1.amazoncognito.com",
	"auth.us-east-2.amazoncognito.com",
	"auth-fips.us-east-2.amazoncognito.com",
	"auth-fips.us-gov-west-1.amazoncognito.com",
	"auth.us-west-1.amazoncognito.com",
	"auth-fips.us-west-1.amazoncognito.com",
	"auth.us-west-2.amazoncognito.com",
	"auth-fips.us-west-2.amazoncognito.com",
	"*.compute.amazonaws.com.cn",
	"*.compute.amazonaws.com",
	"*.compute-1.amazonaws.com",
	"us-east-1.amazonaws.com",
	"emrappui-prod.cn-north-1.amazonaws.com.cn",
	"emrnotebooks-prod.cn-north-1.amazonaws.com.cn",
	"emrstudio-prod.cn-north-1.amazonaws.com.cn",
	"emrappui-prod.cn-northwest-1.amazonaws.com.cn",
	"emrnotebooks-prod.cn-northwest-1.amazonaws.com.cn",
	"emrstudio-prod.cn-northwest-1.amazonaws.com.cn",
	"emrappui-prod.af-south-1.amazonaws.com",
	"emrnotebooks-prod.af-south-1.amazonaws.com",
	"emrstudio-prod.af-south-1.amazonaws.com",
	"emrappui-prod.ap-east-1.amazonaws.com",
	"emrnotebooks-prod.ap-east-1.amazonaws.com",
	"emrstudio-prod.ap-east-1.amazonaws.com",
	"emrappui-prod.ap-northeast-1.amazonaws.com",
	"emrnotebooks-prod.ap-northeast-1.amazonaws.com",
	"emrstudio-prod.ap-northeast-1.amazonaws.com",
	"emrappui-prod.ap-northeast-2.amazonaws.com",
	"emrnotebooks-prod.ap-northeast-2.amazonaws.com",
	"emrstudio-prod.ap-northeast-2.amazonaws.com",
	"emrappui-prod.ap-northeast-3.amazonaws.com",
	"emrnotebooks-prod.ap-northeast-3.amazonaws.com",
	"emrstudio-prod.ap-northeast-3.amazonaws.com",
	"emrappui-prod.ap-south-1.amazonaws.com",
	"emrnotebooks-prod.ap-south-1.amazonaws.com",
	"emrstudio-prod.ap-south-1.amazonaws.com",
	"emrappui-prod.ap-south-2.amazonaws.com",
	"emrnotebooks-prod.ap-south-2.amazonaws.com",
	"emrstudio-prod.ap-south-2.amazonaws.com",
	"emrappui-prod.ap-southeast-1.amazonaws.com",
	"emrnotebooks-prod.ap-southeast-1.amazonaws.com",
	"emrstudio-prod.ap-southeast-1.amazonaws.com",
	"emrappui-prod.ap-southeast-2.amazonaws.com",
	"emrnotebooks-prod.ap-southeast-2.amazonaws.com",
	"emrstudio-prod.ap-southeast-2.amazonaws.com",
	"emrappui-prod.ap-southeast-3.amazonaws.com",
	"emrnotebooks-prod.ap-southeast-3.amazonaws.com",
	"emrstudio-prod.ap-southeast-3.amazonaws.com",
	"emrappui-prod.ap-southeast-4.amazonaws.com",
	"emrnotebooks-prod.ap-southeast-4.amazonaws.com",
	"emrstudio-prod.ap-southeast-4.amazonaws.com",
	"emrappui-prod.ca-central-1.amazonaws.com",
	"emrnotebooks-prod.ca-central-1.amazonaws.com",
	"emrstudio-prod.ca-central-1.amazonaws.com",
	"emrappui-prod.ca-west-1.amazonaws.com",
	"emrnotebooks-prod.ca-west-1.amazonaws.com",
	"emrstudio-prod.ca-west-1.amazonaws.com",
	"emrappui-prod.eu-central-1.amazonaws.com",
	"emrnotebooks-prod.eu-central-1.amazonaws.com",
	"emrstudio-prod.eu-central-1.amazonaws.com",
	"emrappui-prod.eu-central-2.amazonaws.com",
	"emrnotebooks-prod.eu-central-2.amazonaws.com",
	"emrstudio-prod.eu-central-2.amazonaws.com",
	"emrappui-prod.eu-north-1.amazonaws.com",
	"emrnotebooks-prod.eu-north-1.amazonaws.com",
	"emrstudio-prod.eu-north-1.amazonaws.com",
	"emrappui-prod.eu-south-1.amazonaws.com",
	"emrnotebooks-prod.eu-south-1.amazonaws.com",
	"emrstudio-prod.eu-south-1.amazonaws.com",
	"emrappui-prod.eu-south-2.amazonaws.com",
	"emrnotebooks-prod.eu-south-2.amazonaws.com",
	"emrstudio-prod.eu-south-2.amazonaws.com",
	"emrappui-prod.eu-west-1.amazonaws.com",
	"emrnotebooks-prod.eu-west-1.amazonaws.com",
	"emrstudio-prod.eu-west-1.amazonaws.com",
	"emrappui-prod.eu-west-2.amazonaws.com",
	"emrnotebooks-prod.eu-west-2.amazonaws.com",
	"emrstudio-prod.eu-west-2.amazonaws.com",
	"emrappui-prod.eu-west-3.amazonaws.com",
	"emrnotebooks-prod.eu-west-3.amazonaws.com",
	"emrstudio-prod.eu-west-3.amazonaws.com",
	"emrappui-prod.il-central-1.amazonaws.com",
	"emrnotebooks-prod.il-central-1.amazonaws.com",
	"emrstudio-prod.il-central-1.amazonaws.com",
	"emrappui-prod.me-central-1.amazonaws.com",
	"emrnotebooks-prod.me-central-1.amazonaws.com",
	"emrstudio-prod.me-central-1.amazonaws.com",
	"emrappui-prod.me-south-1.amazonaws.com",
	"emrnotebooks-prod.me-south-1.amazonaws.com",
	"emrstudio-prod.me-south-1.amazonaws.com",
	"emrappui-prod.sa-east-1.amazonaws.com",
	"emrnotebooks-prod.sa-east-1.amazonaws.com",
	"emrstudio-prod.sa-east-1.amazonaws.com",
	"emrappui-prod.us-east-1.amazonaws.com",
	"emrnotebooks-prod.us-east-1.amazonaws.com",
	"emrstudio-prod.us-east-1.amazonaws.com",
	"emrappui-prod.us-east-2.amazonaws.com",
	"emrnotebooks-prod.us-east-2.amazonaws.com",
	"emrstudio-prod.us-east-2.amazonaws.com",
	"emrappui-prod.us-gov-east-1.amazonaws.com",
	"emrnotebooks-prod.us-gov-east-1.amazonaws.com",
	"emrstudio-prod.us-gov-east-1.amazonaws.com",
	"emrappui-prod.us-gov-west-1.amazonaws.com",
	"emrnotebooks-prod.us-gov-west-1.amazonaws.com",
	"emrstudio-prod.us-gov-west-1.amazonaws.com",
	"emrappui-prod.us-west-1.amazonaws.com",
	"emrnotebooks-prod.us-west-1.amazonaws.com",
	"emrstudio-prod.us-west-1.amazonaws.com",
	"emrappui-prod.us-west-2.amazonaws.com",
	"emrnotebooks-prod.us-west-2.amazonaws.com",
	"emrstudio-prod.us-west-2.amazonaws.com",
	"*.cn-north-1.airflow.amazonaws.com.cn",
	"*.cn-northwest-1.airflow.amazonaws.com.cn",
	"*.af-south-1.airflow.amazonaws.com",
	"*.ap-east-1.airflow.amazonaws.com",
	"*.ap-northeast-1.airflow.amazonaws.com",
	"*.ap-northeast-2.airflow.amazonaws.com",
	"*.ap-northeast-3.airflow.amazonaws.com",
	"*.ap-south-1.airflow.amazonaws.com",
	"*.ap-south-2.airflow.amazonaws.com",
	"*.ap-southeast-1.airflow.amazonaws.com",
	"*.ap-southeast-2.airflow.amazonaws.com",
	"*.ap-southeast-3.airflow.amazonaws.com",
	"*.ap-southeast-4.airflow.amazonaws.com",
	"*.ca-central-1.airflow.amazonaws.com",
	"*.ca-west-1.airflow.amazonaws.com",
	"*.eu-central-1.airflow.amazonaws.com",
	"*.eu-central-2.airflow.amazonaws.com",
	"*.eu-north-1.airflow.amazonaws.com",
	"*.eu-south-1.airflow.amazonaws.com",
	"*.eu-south-2.airflow.amazonaws.com",
	"*.eu-west-1.airflow.amazonaws.com",
	"*.eu-west-2.airflow.amazonaws.com",
	"*.eu-west-3.airflow.amazonaws.com",
	"*.il-central-1.airflow.amazonaws.com",
	"*.me-central-1.airflow.amazonaws.com",
	"*.me-south-1.airflow.amazonaws.com",
	"*.sa-east-1.airflow.amazonaws.com",
	"*.us-east-1.airflow.amazonaws.com",
	"*.us-east-2.airflow.amazonaws.com",
	"*.us-west-1.airflow.amazonaws.com",
	"*.us-west-2.airflow.amazonaws.com",
	"s3.dualstack.cn-north-1.amazonaws.com.cn",
	"s3-accesspoint.dualstack.cn-north-1.amazonaws.com.cn",
	"s3-website.dualstack.cn-north-1.amazonaws.com.cn",
	"s3.cn-north-1.amazonaws.com.cn",
	"s3-accesspoint.cn-north-1.amazonaws.com.cn",
	"s3-deprecated.cn-north-1.amazonaws.com.cn",
	"s3-object-lambda.cn-north-1.amazonaws.com.cn",
	"s3-website.cn-north-1.amazonaws.com.cn",
	"s3.dualstack.cn-northwest-1.amazonaws.com.cn",
	"s3-accesspoint.dualstack.cn-northwest-1.amazonaws.com.cn",
	"s3.cn-northwest-1.amazonaws.com.cn",
	"s3-accesspoint.cn-northwest-1.amazonaws.com.cn",
	"s3-object-lambda.cn-northwest-1.amazonaws.com.cn",
	"s3-website.cn-northwest-1.amazonaws.com.cn",
	"s3.dualstack.af-south-1.amazonaws.com",
	"s3-accesspoint.dualstack.af-south-1.amazonaws.com",
	"s3-website.dualstack.af-south-1.amazonaws.com",
	"s3.af-south-1.amazonaws.com",
	"s3-accesspoint.af-south-1.amazonaws.com",
	"s3-object-lambda.af-south-1.amazonaws.com",
	"s3-website.af-south-1.amazonaws.com",
	"s3.dualstack.ap-east-1.amazonaws.com",
	"s3-accesspoint.dualstack.ap-east-1.amazonaws.com",
	"s3.ap-east-1.amazonaws.com",
	"s3-accesspoint.ap-east-1.amazonaws.com",
	"s3-object-lambda.ap-east-1.amazonaws.com",
	"s3-website.ap-east-1.amazonaws.com",
	"s3.dualstack.ap-northeast-1.amazonaws.com",
	"s3-accesspoint.dualstack.ap-northeast-1.amazonaws.com",
	"s3-website.dualstack.ap-northeast-1.amazonaws.com",
	"s3.ap-northeast-1.amazonaws.com",
	"s3-accesspoint.ap-northeast-1.amazonaws.com",
	"s3-object-lambda.ap-northeast-1.amazonaws.com",
	"s3-website.ap-northeast-1.amazonaws.com",
	"s3.dualstack.ap-northeast-2.amazonaws.com",
	"s3-accesspoint.dualstack.ap-northeast-2.amazonaws.com",
	"s3-website.dualstack.ap-northeast-2.amazonaws.com",
	"s3.ap-northeast-2.amazonaws.com",
	"s3-accesspoint.ap-northeast-2.amazonaws.com",
	"s3-object-lambda.ap-northeast-2.amazonaws.com",
	"s3-website.ap-northeast-2.amazonaws.com",
	"s3.dualstack.ap-northeast-3.amazonaws.com",
	"s3-accesspoint.dualstack.ap-northeast-3.amazonaws.com",
	"s3-website.dualstack.ap-northeast-3.amazonaws.com",
	"s3.ap-northeast-3.amazonaws.com",
	"s3-accesspoint.ap-northeast-3.amazonaws.com",
	"s3-object-lambda.ap-northeast-3.amazonaws.com",
	"s3-website.ap-northeast-3.amazonaws.com",
	"s3.dualstack.ap-south-1.amazonaws.com",
	"s3-accesspoint.dualstack.ap-south-1.amazonaws.com",
	"s3-website.dualstack.ap-south-1.amazonaws.com",
	"s3.ap-south-1.amazonaws.com",
	"s3-accesspoint.ap-south-1.amazonaws.com",
	"s3-object-lambda.ap-south-1.amazonaws.com",
	"s3-website.ap-south-1.amazonaws.com",
	"s3.dualstack.ap-south-2.amazonaws.com",
	"s3-accesspoint.dualstack.ap-south-2.amazonaws.com",
	"s3-website.dualstack.ap-south-2.amazonaws.com",
	"s3.ap-south-2.amazonaws.com",
	"s3-accesspoint.ap-south-2.amazonaws.com",
	"s3-object-lambda.ap-south-2.amazonaws.com",
	"s3-website.ap-south-2.amazonaws.com",
	"s3.dualstack.ap-southeast-1.amazonaws.com",
	"s3-accesspoint.dualstack.ap-southeast-1.amazonaws.com",
	"s3-website.dualstack.ap-southeast-1.amazonaws.com",
	"s3.ap-southeast-1.amazonaws.com",
	"s3-accesspoint.ap-southeast-1.amazonaws.com",
	"s3-object-lambda.ap-southeast-1.amazonaws.com",
	"s3-website.ap-southeast-1.amazonaws.com",
	"s3.dualstack.ap-southeast-2.amazonaws.com",
	"s3-accesspoint.dualstack.ap-southeast-2.amazonaws.com",
	"s3-website.dualstack.ap-southeast-2.amazonaws.com",
	"s3.ap-southeast-2.amazonaws.com",
	"s3-accesspoint.ap-southeast-2.amazonaws.com",
	"s3-object-lambda.ap-southeast-2.amazonaws.com",
	"s3-website.ap-southeast-2.amazonaws.com",
	"s3.dualstack.ap-southeast-3.amazonaws.com",
	"s3-accesspoint.dualstack.ap-southeast-3.amazonaws.com",
	"s3-website.dualstack.ap-southeast-3.amazonaws.com",
	"s3.ap-southeast-3.amazonaws.com",
	"s3-accesspoint.ap-southeast-3.amazonaws.com",
	"s3-object-lambda.ap-southeast-3.amazonaws.com",
	"s3-website.ap-southeast-3.amazonaws.com",
	"s3.dualstack.ap-southeast-4.amazonaws.com",
	"s3-accesspoint.dualstack.ap-southeast-4.amazonaws.com",
	"s3-website.dualstack.ap-southeast-4.amazonaws.com",
	"s3.ap-southeast-4.amazonaws.com",
	"s3-accesspoint.ap-southeast-4.amazonaws.com",
	"s3-object-lambda.ap-southeast-4.amazonaws.com",
	"s3-website.ap-southeast-4.amazonaws.com",
	"s3.dualstack.ap-southeast-5.amazonaws.com",
	"s3-accesspoint.dualstack.ap-southeast-5.amazonaws.com",
	"s3-website.dualstack.ap-southeast-5.amazonaws.com",
	"s3.ap-southeast-5.amazonaws.com",
	"s3-accesspoint.ap-southeast-5.amazonaws.com",
	"s3-deprecated.ap-southeast-5.amazonaws.com",
	"s3-object-lambda.ap-southeast-5.amazonaws.com",
	"s3-website.ap-southeast-5.amazonaws.com",
	"s3.dualstack.ca-central-1.amazonaws.com",
	"s3-accesspoint.dualstack.ca-central-1.amazonaws.com",
	"s3-accesspoint-fips.dualstack.ca-central-1.amazonaws.com",
	"s3-fips.dualstack.ca-central-1.amazonaws.com",
	"s3-website.dualstack.ca-central-1.amazonaws.com",
	"s3.ca-central-1.amazonaws.com",
	"s3-accesspoint.ca-central-1.amazonaws.com",
	"s3-accesspoint-fips.ca-central-1.amazonaws.com",
	"s3-fips.ca-central-1.amazonaws.com",
	"s3-object-lambda.ca-central-1.amazonaws.com",
	"s3-website.ca-central-1.amazonaws.com",
	"s3.dualstack.ca-west-1.amazonaws.com",
	"s3-accesspoint.dualstack.ca-west-1.amazonaws.com",
	"s3-accesspoint-fips.dualstack.ca-west-1.amazonaws.com",
	"s3-fips.dualstack.ca-west-1.amazonaws.com",
	"s3-website.dualstack.ca-west-1.amazonaws.com",
	"s3.ca-west-1.amazonaws.com",
	"s3-accesspoint.ca-west-1.amazonaws.com",
	"s3-accesspoint-fips.ca-west-1.amazonaws.com",
	"s3-fips.ca-west-1.amazonaws.com",
	"s3-object-lambda.ca-west-1.amazonaws.com",
	"s3-website.ca-west-1.amazonaws.com",
	"s3.dualstack.eu-central-1.amazonaws.com",
	"s3-accesspoint.dualstack.eu-central-1.amazonaws.com",
	"s3-website.dualstack.eu-central-1.amazonaws.com",
	"s3.eu-central-1.amazonaws.com",
	"s3-accesspoint.eu-central-1.amazonaws.com",
	"s3-object-lambda.eu-central-1.amazonaws.com",
	"s3-website.eu-central-1.amazonaws.com",
	"s3.dualstack.eu-central-2.amazonaws.com",
	"s3-accesspoint.dualstack.eu-central-2.amazonaws.com",
	"s3-website.dualstack.eu-central-2.amazonaws.com",
	"s3.eu-central-2.amazonaws.com",
	"s3-accesspoint.eu-central-2.amazonaws.com",
	"s3-object-lambda.eu-central-2.amazonaws.com",
	"s3-website.eu-central-2.amazonaws.com",
	"s3.dualstack.eu-north-1.amazonaws.com",
	"s3-accesspoint.dualstack.eu-north-1.amazonaws.com",
	"s3.eu-north-1.amazonaws.com",
	"s3-accesspoint.eu-north-1.amazonaws.com",
	"s3-object-lambda.eu-north-1.amazonaws.com",
	"s3-website.eu-north-1.amazonaws.com",
	"s3.dualstack.eu-south-1.amazonaws.com",
	"s3-accesspoint.dualstack.eu-south-1.amazonaws.com",
	"s3-website.dualstack.eu-south-1.amazonaws.com",
	"s3.eu-south-1.amazonaws.com",
	"s3-accesspoint.eu-south-1.amazonaws.com",
	"s3-object-lambda.eu-south-1.amazonaws.com",
	"s3-website.eu-south-1.amazonaws.com",
	"s3.dualstack.eu-south-2.amazonaws.com",
	"s3-accesspoint.dualstack.eu-south-2.amazonaws.com",
	"s3-website.dualstack.eu-south-2.amazonaws.com",
	"s3.eu-south-2.amazonaws.com",
	"s3-accesspoint.eu-south-2.amazonaws.com",
	"s3-object-lambda.eu-south-2.amazonaws.com",
	"s3-website.eu-south-2.amazonaws.com",
	"s3.dualstack.eu-west-1.amazonaws.com",
	"s3-accesspoint.dualstack.eu-west-1.amazonaws.com",
	"s3-website.dualstack.eu-west-1.amazonaws.com",
	"s3.eu-west-1.amazonaws.com",
	"s3-accesspoint.eu-west-1.amazonaws.com",
	"s3-deprecated.eu-west-1.amazonaws.com",
	"s3-object-lambda.eu-west-1.amazonaws.com",
	"s3-website.eu-west-1.amazonaws.com",
	"s3.dualstack.eu-west-2.amazonaws.com",
	"s3-accesspoint.dualstack.eu-west-2.amazonaws.com",
	"s3.eu-west-2.amazonaws.com",
	"s3-accesspoint.eu-west-2.amazonaws.com",
	"s3-object-lambda.eu-west-2.amazonaws.com",
	"s3-website.eu-west-2.amazonaws.com",
	"s3.dualstack.eu-west-3.amazonaws.com",
	"s3-accesspoint.dualstack.eu-west-3.amazonaws.com",
	"s3-website.dualstack.eu-west-3.amazonaws.com",
	"s3.eu-west-3.amazonaws.com",
	"s3-accesspoint.eu-west-3.amazonaws.com",
	"s3-object-lambda.eu-west-3.amazonaws.com",
	"s3-website.eu-west-3.amazonaws.com",
	"s3.dualstack.il-central-1.amazonaws.com",
	"s3-accesspoint.dualstack.il-central-1.amazonaws.com",
	"s3-website.dualstack.il-central-1.amazonaws.com",
	"s3.il-central-1.amazonaws.com",
	"s3-accesspoint.il-central-1.amazonaws.com",
	"s3-object-lambda.il-central-1.amazonaws.com",
	"s3-website.il-central-1.amazonaws.com",
	"s3.dualstack.me-central-1.amazonaws.com",
	"s3-accesspoint.dualstack.me-central-1.amazonaws.com",
	"s3-website.dualstack.me-central-1.amazonaws.com",
	"s3.me-central-1.amazonaws.com",
	"s3-accesspoint.me-central-1.amazonaws.com",
	"s3-object-lambda.me-central-1.amazonaws.com",
	"s3-website.me-central-1.amazonaws.com",
	"s3.dualstack.me-south-1.amazonaws.com",
	"s3-accesspoint.dualstack.me-south-1.amazonaws.com",
	"s3.me-south-1.amazonaws.com",
	"s3-accesspoint.me-south-1.amazonaws.com",
	"s3-object-lambda.me-south-1.amazonaws.com",
	"s3-website.me-south-1.amazonaws.com",
	"s3.amazonaws.com",
	"s3-1.amazonaws.com",
	"s3-ap-east-1.amazonaws.com",
	"s3-ap-northeast-1.amazonaws.com",
	"s3-ap-northeast-2.amazonaws.com",
	"s3-ap-northeast-3.amazonaws.com",
	"s3-ap-south-1.amazonaws.com",
	"s3-ap-southeast-1.amazonaws.com",
	"s3-ap-southeast-2.amazonaws.com",
	"s3-ca-central-1.amazonaws.com",
	"s3-eu-central-1.amazonaws.com",
	"s3-eu-north-1.amazonaws.com",
	"s3-eu-west-1.amazonaws.com",
	"s3-eu-west-2.amazonaws.com",
	"s3-eu-west-3.amazonaws.com",
	"s3-external-1.amazonaws.com",
	"s3-fips-us-gov-east-1.amazonaws.com",
	"s3-fips-us-gov-west-1.amazonaws.com",
	"mrap.accesspoint.s3-global.amazonaws.com",
	"s3-me-south-1.amazonaws.com",
	"s3-sa-east-1.amazonaws.com",
	"s3-us-east-2.amazonaws.com",
	"s3-us-gov-east-1.amazonaws.com",
	"s3-us-gov-west-1.amazonaws.com",
	"s3-us-west-1.amazonaws.com",
	"s3-us-west-2.amazonaws.com",
	"s3-website-ap-northeast-1.amazonaws.com",
	"s3-website-ap-southeast-1.amazonaws.com",
	"s3-website-ap-southeast-2.amazonaws.com",
	"s3-website-eu-west-1.amazonaws.com",
	"s3-website-sa-east-1.amazonaws.com",
	"s3-website-us-east-1.amazonaws.com",
	"s3-website-us-gov-west-1.amazonaws.com",
	"s3-website-us-west-1.amazonaws.com",
	"s3-website-us-west-2.amazonaws.com",
	"s3.dualstack.sa-east-1.amazonaws.com",
	"s3-accesspoint.dualstack.sa-east-1.amazonaws.com",
	"s3-website.dualstack.sa-east-1.amazonaws.com",
	"s3.sa-east-1.amazonaws.com",
	"s3-accesspoint.sa-east-1.amazonaws.com",
	"s3-object-lambda.sa-east-1.amazonaws.com",
	"s3-website.sa-east-1.amazonaws.com",
	"s3.dualstack.us-east-1.amazonaws.com",
	"s3-accesspoint.dualstack.us-east-1.amazonaws.com",
	"s3-accesspoint-fips.dualstack.us-east-1.amazonaws.com",
	"s3-fips.dualstack.us-east-1.amazonaws.com",
	"s3-website.dualstack.us-east-1.amazonaws.com",
	"s3.us-east-1.amazonaws.com",
	"s3-accesspoint.us-east-1.amazonaws.com",
	"s3-accesspoint-fips.us-east-1.amazonaws.com",
	"s3-deprecated.us-east-1.amazonaws.com",
	"s3-fips.us-east-1.amazonaws.com",
	"s3-object-lambda.us-east-1.amazonaws.com",
	"s3-website.us-east-1.amazonaws.com",
	"s3.dualstack.us-east-2.amazonaws.com",
	"s3-accesspoint.dualstack.us-east-2.amazonaws.com",
	"s3-accesspoint-fips.dualstack.us-east-2.amazonaws.com",
	"s3-fips.dualstack.us-east-2.amazonaws.com",
	"s3-website.dualstack.us-east-2.amazonaws.com",
	"s3.us-east-2.amazonaws.com",
	"s3-accesspoint.us-east-2.amazonaws.com",
	"s3-accesspoint-fips.us-east-2.amazonaws.com",
	"s3-deprecated.us-east-2.amazonaws.com",
	"s3-fips.us-east-2.amazonaws.com",
	"s3-object-lambda.us-east-2.amazonaws.com",
	"s3-website.us-east-2.amazonaws.com",
	"s3.dualstack.us-gov-east-1.amazonaws.com",
	"s3-accesspoint.dualstack.us-gov-east-1.amazonaws.com",
	"s3-accesspoint-fips.dualstack.us-gov-east-1.amazonaws.com",
	"s3-fips.dualstack.us-gov-east-1.amazonaws.com",
	"s3.us-gov-east-1.amazonaws.com",
	"s3-accesspoint.us-gov-east-1.amazonaws.com",
	"s3-accesspoint-fips.us-gov-east-1.amazonaws.com",
	"s3-fips.us-gov-east-1.amazonaws.com",
	"s3-object-lambda.us-gov-east-1.amazonaws.com",
	"s3-website.us-gov-east-1.amazonaws.com",
	"s3.dualstack.us-gov-west-1.amazonaws.com",
	"s3-accesspoint.dualstack.us-gov-west-1.amazonaws.com",
	"s3-accesspoint-fips.dualstack.us-gov-west-1.amazonaws.com",
	"s3-fips.dualstack.us-gov-west-1.amazonaws.com",
	"s3.us-gov-west-1.amazonaws.com",
	"s3-accesspoint.us-gov-west-1.amazonaws.com",
	"s3-accesspoint-fips.us-gov-west-1.amazonaws.com",
	"s3-fips.us-gov-west-1.amazonaws.com",
	"s3-object-lambda.us-gov-west-1.amazonaws.com",
	"s3-website.us-gov-west-1.amazonaws.com",
	"s3.dualstack.us-west-1.amazonaws.com",
	"s3-accesspoint.dualstack.us-west-1.amazonaws.com",
	"s3-accesspoint-fips.dualstack.us-west-1.amazonaws.com",
	"s3-fips.dualstack.us-west-1.amazonaws.com",
	"s3-website.dualstack.us-west-1.amazonaws.com",
	"s3.us-west-1.amazonaws.com",
	"s3-accesspoint.us-west-1.amazonaws.com",
	"s3-accesspoint-fips.us-west-1.amazonaws.com",
	"s3-fips.us-west-1.amazonaws.com",
	"s3-object-lambda.us-west-1.amazonaws.com",
	"s3-website.us-west-1.amazonaws.com",
	"s3.dualstack.us-west-2.amazonaws.com",
	"s3-accesspoint.dualstack.us-west-2.amazonaws.com",
	"s3-accesspoint-fips.dualstack.us-west-2.amazonaws.com",
	"s3-fips.dualstack.us-west-2.amazonaws.com",
	"s3-website.dualstack.us-west-2.amazonaws.com",
	"s3.us-west-2.amazonaws.com",
	"s3-accesspoint.us-west-2.amazonaws.com",
	"s3-accesspoint-fips.us-west-2.amazonaws.com",
	"s3-deprecated.us-west-2.amazonaws.com",
	"s3-fips.us-west-2.amazonaws.com",
	"s3-object-lambda.us-west-2.amazonaws.com",
	"s3-website.us-west-2.amazonaws.com",
	"labeling.ap-northeast-1.sagemaker.aws",
	"labeling.ap-northeast-2.sagemaker.aws",
	"labeling.ap-south-1.sagemaker.aws",
	"labeling.ap-southeast-1.sagemaker.aws",
	"labeling.ap-southeast-2.sagemaker.aws",
	"labeling.ca-central-1.sagemaker.aws",
	"labeling.eu-central-1.sagemaker.aws",
	"labeling.eu-west-1.sagemaker.aws",
	"labeling.eu-west-2.sagemaker.aws",
	"labeling.us-east-1.sagemaker.aws",
	"labeling.us-east-2.sagemaker.aws",
	"labeling.us-west-2.sagemaker.aws",
	"notebook.af-south-1.sagemaker.aws",
	"notebook.ap-east-1.sagemaker.aws",
	"notebook.ap-northeast-1.sagemaker.aws",
	"notebook.ap-northeast-2.sagemaker.aws",
	"notebook.ap-northeast-3.sagemaker.aws",
	"notebook.ap-south-1.sagemaker.aws",
	"notebook.ap-south-2.sagemaker.aws",
	"notebook.ap-southeast-1.sagemaker.aws",
	"notebook.ap-southeast-2.sagemaker.aws",
	"notebook.ap-southeast-3.sagemaker.aws",
	"notebook.ap-southeast-4.sagemaker.aws",
	"notebook.ca-central-1.sagemaker.aws",
	"notebook-fips.ca-central-1.sagemaker.aws",
	"notebook.ca-west-1.sagemaker.aws",
	"notebook-fips.ca-west-1.sagemaker.aws",
	"notebook.eu-central-1.sagemaker.aws",
	"notebook.eu-central-2.sagemaker.aws",
	"notebook.eu-north-1.sagemaker.aws",
	"notebook.eu-south-1.sagemaker.aws",
	"notebook.eu-south-2.sagemaker.aws",
	"notebook.eu-west-1.sagemaker.aws",
	"notebook.eu-west-2.sagemaker.aws",
	"notebook.eu-west-3.sagemaker.aws",
	"notebook.il-central-1.sagemaker.aws",
	"notebook.me-central-1.sagemaker.aws",
	"notebook.me-south-1.sagemaker.aws",
	"notebook.sa-east-1.sagemaker.aws",
	"notebook.us-east-1.sagemaker.aws",
	"notebook-fips.us-east-1.sagemaker.aws",
	"notebook.us-east-2.sagemaker.aws",
	"notebook-fips.us-east-2.sagemaker.aws",
	"notebook.us-gov-east-1.sagemaker.aws",
	"notebook-fips.us-gov-east-1.sagemaker.aws",
	"notebook.us-gov-west-1.sagemaker.aws",
	"notebook-fips.us-gov-west-1.sagemaker.aws",
	"notebook.us-west-1.sagemaker.aws",
	"notebook-fips.us-west-1.sagemaker.aws",
	"notebook.us-west-2.sagemaker.aws",
	"notebook-fips.us-west-2.sagemaker.aws",
	"notebook.cn-north-1.sagemaker.com.cn",
	"notebook.cn-northwest-1.sagemaker.com.cn",
	"studio.af-south-1.sagemaker.aws",
	"studio.ap-east-1.sagemaker.aws",
	"studio.ap-northeast-1.sagemaker.aws",
	"studio.ap-northeast-2.sagemaker.aws",
	"studio.ap-northeast-3.sagemaker.aws",
	"studio.ap-south-1.sagemaker.aws",
	"studio.ap-southeast-1.sagemaker.aws",
	"studio.ap-southeast-2.sagemaker.aws",
	"studio.ap-southeast-3.sagemaker.aws",
	"studio.ca-central-1.sagemaker.aws",
	"studio.eu-central-1.sagemaker.aws",
	"studio.eu-north-1.sagemaker.aws",
	"studio.eu-south-1.sagemaker.aws",
	"studio.eu-south-2.sagemaker.aws",
	"studio.eu-west-1.sagemaker.aws",
	"studio.eu-west-2.sagemaker.aws",
	"studio.eu-west-3.sagemaker.aws",
	"studio.il-central-1.sagemaker.aws",
	"studio.me-central-1.sagemaker.aws",
	"studio.me-south-1.sagemaker.aws",
	"studio.sa-east-1.sagemaker.aws",
	"studio.us-east-1.sagemaker.aws",
	"studio.us-east-2.sagemaker.aws",
	"studio.us-gov-east-1.sagemaker.aws",
	"studio-fips.us-gov-east-1.sagemaker.aws",
	"studio.us-gov-west-1.sagemaker.aws",
	"studio-fips.us-gov-west-1.sagemaker.aws",
	"studio.us-west-1.sagemaker.aws",
	"studio.us-west-2.sagemaker.aws",
	"studio.cn-north-1.sagemaker.com.cn",
	"studio.cn-northwest-1.sagemaker.com.cn",
	"*.experiments.sagemaker.aws",
	"analytics-gateway.ap-northeast-1.amazonaws.com",
	"analytics-gateway.ap-northeast-2.amazonaws.com",
	"analytics-gateway.ap-south-1.amazonaws.com",
	"analytics-gateway.ap-southeast-1.amazonaws.com",
	"analytics-gateway.ap-southeast-2.amazonaws.com",
	"analytics-gateway.eu-central-1.amazonaws.com",
	"analytics-gateway.eu-west-1.amazonaws.com",
	"analytics-gateway.us-east-1.amazonaws.com",
	"analytics-gateway.us-east-2.amazonaws.com",
	"analytics-gateway.us-west-2.amazonaws.com",
	"amplifyapp.com",
	"*.awsapprunner.com",
	"webview-assets.aws-cloud9.af-south-1.amazonaws.com",
	"vfs.cloud9.af-south-1.amazonaws.com",
	"webview-assets.cloud9.af-south-1.amazonaws.com",
	"webview-assets.aws-cloud9.ap-east-1.amazonaws.com",
	"vfs.cloud9.ap-east-1.amazonaws.com",
	"webview-assets.cloud9.ap-east-1.amazonaws.com",
	"webview-assets.aws-cloud9.ap-northeast-1.amazonaws.com",
	"vfs.cloud9.ap-northeast-1.amazonaws.com",
	"webview-assets.cloud9.ap-northeast-1.amazonaws.com",
	"webview-assets.aws-cloud9.ap-northeast-2.amazonaws.com",
	"vfs.cloud9.ap-northeast-2.amazonaws.com",
	"webview-assets.cloud9.ap-northeast-2.amazonaws.com",
	"webview-assets.aws-cloud9.ap-northeast-3.amazonaws.com",
	"vfs.cloud9.ap-northeast-3.amazonaws.com",
	"webview-assets.cloud9.ap-northeast-3.amazonaws.com",
	"webview-assets.aws-cloud9.ap-south-1.amazonaws.com",
	"vfs.cloud9.ap-south-1.amazonaws.com",
	"webview-assets.cloud9.ap-south-1.amazonaws.com",
	"webview-assets.aws-cloud9.ap-southeast-1.amazonaws.com",
	"vfs.cloud9.ap-southeast-1.amazonaws.com",
	"webview-assets.cloud9.ap-southeast-1.amazonaws.com",
	"webview-assets.aws-cloud9.ap-southeast-2.amazonaws.com",
	"vfs.cloud9.ap-southeast-2.amazonaws.com",
	"webview-assets.cloud9.ap-southeast-2.amazonaws.com",
	"webview-assets.aws-cloud9.ca-central-1.amazonaws.com",
	"vfs.cloud9.ca-central-1.amazonaws.com",
	"webview-assets.cloud9.ca-central-1.amazonaws.com",
	"webview-assets.aws-cloud9.eu-central-1.amazonaws.com",
	"vfs.cloud9.eu-central-1.amazonaws.com",
	"webview-assets.cloud9.eu-central-1.amazonaws.com",
	"webview-assets.aws-cloud9.eu-north-1.amazonaws.com",
	"vfs.cloud9.eu-north-1.amazonaws.com",
	"webview-assets.cloud9.eu-north-1.amazonaws.com",
	"webview-assets.aws-cloud9.eu-south-1.amazonaws.com",
	"vfs.cloud9.eu-south-1.amazonaws.com",
	"webview-assets.cloud9.eu-south-1.amazonaws.com",
	"webview-assets.aws-cloud9.eu-west-1.amazonaws.com",
	"vfs.cloud9.eu-west-1.amazonaws.com",
	"webview-assets.cloud9.eu-west-1.amazonaws.com",
	"webview-assets.aws-cloud9.eu-west-2.amazonaws.com",
	"vfs.cloud9.eu-west-2.amazonaws.com",
	"webview-assets.cloud9.eu-west-2.amazonaws.com",
	"webview-assets.aws-cloud9.eu-west-3.amazonaws.com",
	"vfs.cloud9.eu-west-3.amazonaws.com",
	"webview-assets.cloud9.eu-west-3.amazonaws.com",
	"webview-assets.aws-cloud9.il-central-1.amazonaws.com",
	"vfs.cloud9.il-central-1.amazonaws.com",
	"webview-assets.aws-cloud9.me-south-1.amazonaws.com",
	"vfs.cloud9.me-south-1.amazonaws.com",
	"webview-assets.cloud9.me-south-1.amazonaws.com",
	"webview-assets.aws-cloud9.sa-east-1.amazonaws.com",
	"vfs.cloud9.sa-east-1.amazonaws.com",
	"webview-assets.cloud9.sa-east-1.amazonaws.com",
	"webview-assets.aws-cloud9.us-east-1.amazonaws.com",
	"vfs.cloud9.us-east-1.amazonaws.com",
	"webview-assets.cloud9.us-east-1.amazonaws.com",
	"webview-assets.aws-cloud9.us-east-2.amazonaws.com",
	"vfs.cloud9.us-east-2.amazonaws.com",
	"webview-assets.cloud9.us-east-2.amazonaws.com",
	"webview-assets.aws-cloud9.us-west-1.amazonaws.com",
	"vfs.cloud9.us-west-1.amazonaws.com",
	"webview-assets.cloud9.us-west-1.amazonaws.com",
	"webview-assets.aws-cloud9.us-west-2.amazonaws.com",
	"vfs.cloud9.us-west-2.amazonaws.com",
	"webview-assets.cloud9.us-west-2.amazonaws.com",
	"awsapps.com",
	"cn-north-1.eb.amazonaws.com.cn",
	"cn-northwest-1.eb.amazonaws.com.cn",
	"elasticbeanstalk.com",
	"af-south-1.elasticbeanstalk.com",
	"ap-east-1.elasticbeanstalk.com",
	"ap-northeast-1.elasticbeanstalk.com",
	"ap-northeast-2.elasticbeanstalk.com",
	"ap-northeast-3.elasticbeanstalk.com",
	"ap-south-1.elasticbeanstalk.com",
	"ap-southeast-1.elasticbeanstalk.com",
	"ap-southeast-2.elasticbeanstalk.com",
	"ap-southeast-3.elasticbeanstalk.com",
	"ca-central-1.elasticbeanstalk.com",
	"eu-central-1.elasticbeanstalk.com",
	"eu-north-1.elasticbeanstalk.com",
	"eu-south-1.elasticbeanstalk.com",
	"eu-west-1.elasticbeanstalk.com",
	"eu-west-2.elasticbeanstalk.com",
	"eu-west-3.elasticbeanstalk.com",
	"il-central-1.elasticbeanstalk.com",
	"me-south-1.elasticbeanstalk.com",
	"sa-east-1.elasticbeanstalk.com",
	"us-east-1.elasticbeanstalk.com",
	"us-east-2.elasticbeanstalk.com",
	"us-gov-east-1.elasticbeanstalk.com",
	"us-gov-west-1.elasticbeanstalk.com",
	"us-west-1.elasticbeanstalk.com",
	"us-west-2.elasticbeanstalk.com",
	"*.elb.amazonaws.com.cn",
	"*.elb.amazonaws.com",
	"awsglobalaccelerator.com",
	"*.private.repost.aws",
	"eero.online",
	"eero-stage.online",
	"apigee.io",
	"panel.dev",
	"siiites.com",
	"appspacehosted.com",
	"appspaceusercontent.com",
	"appudo.net",
	"on-aptible.com",
	"f5.si",
	"arvanedge.ir",
	"user.aseinet.ne.jp",
	"gv.vc",
	"d.gv.vc",
	"user.party.eus",
	"pimienta.org",
	"poivron.org",
	"potager.org",
	"sweetpepper.org",
	"myasustor.com",
	"cdn.prod.atlassian-dev.net",
	"translated.page",
	"myfritz.link",
	"myfritz.net",
	"onavstack.net",
	"*.awdev.ca",
	"*.advisor.ws",
	"ecommerce-shop.pl",
	"b-data.io",
	"balena-devices.com",
	"base.ec",
	"official.ec",
	"buyshop.jp",
	"fashionstore.jp",
	"handcrafted.jp",
	"kawaiishop.jp",
	"supersale.jp",
	"theshop.jp",
	"shopselect.net",
	"base.shop",
	"beagleboard.io",
	"*.beget.app",
	"pages.gay",
	"bnr.la",
	"bitbucket.io",
	"blackbaudcdn.net",
	"of.je",
	"bluebite.io",
	"boomla.net",
	"boutir.com",
	"boxfuse.io",
	"square7.ch",
	"bplaced.com",
	"bplaced.de",
	"square7.de",
	"bplaced.net",
	"square7.net",
	"*.s.brave.io",
	"shop.brendly.hr",
	"shop.brendly.rs",
	"browsersafetymark.io",
	"radio.am",
	"radio.fm",
	"uk0.bigv.io",
	"dh.bytemark.co.uk",
	"vm.bytemark.co.uk",
	"cafjs.com",
	"canva-apps.cn",
	"*.my.canvasite.cn",
	"canva-apps.com",
	"*.my.canva.site",
	"drr.ac",
	"uwu.ai",
	"carrd.co",
	"crd.co",
	"ju.mp",
	"api.gov.uk",
	"cdn77-storage.com",
	"rsc.contentproxy9.cz",
	"r.cdn77.net",
	"cdn77-ssl.net",
	"c.cdn77.org",
	"rsc.cdn77.org",
	"ssl.origin.cdn77-secure.org",
	"za.bz",
	"br.com",
	"cn.com",
	"de.com",
	"eu.com",
	"jpn.com",
	"mex.com",
	"ru.com",
	"sa.com",
	"uk.com",
	"us.com",
	"za.com",
	"com.de",
	"gb.net",
	"hu.net",
	"jp.net",
	"se.net",
	"uk.net",
	"ae.org",
	"com.se",
	"cx.ua",
	"discourse.group",
	"discourse.team",
	"clerk.app",
	"clerkstage.app",
	"*.lcl.dev",
	"*.lclstage.dev",
	"*.stg.dev",
	"*.stgstage.dev",
	"cleverapps.cc",
	"*.services.clever-cloud.com",
	"cleverapps.io",
	"cleverapps.tech",
	"clickrising.net",
	"cloudns.asia",
	"cloudns.be",
	"cloud-ip.biz",
	"cloudns.biz",
	"cloudns.cc",
	"cloudns.ch",
	"cloudns.cl",
	"cloudns.club",
	"dnsabr.com",
	"ip-ddns.com",
	"cloudns.cx",
	"cloudns.eu",
	"cloudns.in",
	"cloudns.info",
	"ddns-ip.net",
	"dns-cloud.net",
	"dns-dynamic.net",
	"cloudns.nz",
	"cloudns.org",
	"ip-dynamic.org",
	"cloudns.ph",
	"cloudns.pro",
	"cloudns.pw",
	"cloudns.us",
	"c66.me",
	"cloud66.ws",
	"cloud66.zone",
	"jdevcloud.com",
	"wpdevcloud.com",
	"cloudaccess.host",
	"freesite.host",
	"cloudaccess.net",
	"*.cloudera.site",
	"cf-ipfs.com",
	"cloudflare-ipfs.com",
	"trycloudflare.com",
	"pages.dev",
	"r2.dev",
	"workers.dev",
	"cloudflare.net",
	"cdn.cloudflare.net",
	"cdn.cloudflareanycast.net",
	"cdn.cloudflarecn.net",
	"cdn.cloudflareglobal.net",
	"cust.cloudscale.ch",
	"objects.lpg.cloudscale.ch",
	"objects.rma.cloudscale.ch",
	"wnext.app",
	"cnpy.gdn",
	"*.otap.co",
	"co.ca",
	"co.com",
	"codeberg.page",
	"csb.app",
	"preview.csb.app",
	"co.nl",
	"co.no",
	"webhosting.be",
	"hosting-cluster.nl",
	"ctfcloud.net",
	"convex.site",
	"ac.ru",
	"edu.ru",
	"gov.ru",
	"int.ru",
	"mil.ru",
	"test.ru",
	"dyn.cosidns.de",
	"dnsupdater.de",
	"dynamisches-dns.de",
	"internet-dns.de",
	"l-o-g-i-n.de",
	"dynamic-dns.info",
	"feste-ip.net",
	"knx-server.net",
	"static-access.net",
	"craft.me",
	"realm.cz",
	"on.crisp.email",
	"*.cryptonomic.net",
	"curv.dev",
	"cfolks.pl",
	"cyon.link",
	"cyon.site",
	"platform0.app",
	"fnwk.site",
	"folionetwork.site",
	"biz.dk",
	"co.dk",
	"firm.dk",
	"reg.dk",
	"store.dk",
	"dyndns.dappnode.io",
	"builtwithdark.com",
	"darklang.io",
	"demo.datadetect.com",
	"instance.datadetect.com",
	"edgestack.me",
	"dattolocal.com",
	"dattorelay.com",
	"dattoweb.com",
	"mydatto.com",
	"dattolocal.net",
	"mydatto.net",
	"ddnss.de",
	"dyn.ddnss.de",
	"dyndns.ddnss.de",
	"dyn-ip24.de",
	"dyndns1.de",
	"home-webserver.de",
	"dyn.home-webserver.de",
	"myhome-server.de",
	"ddnss.org",
	"debian.net",
	"definima.io",
	"definima.net",
	"deno.dev",
	"deno-staging.dev",
	"dedyn.io",
	"deta.app",
	"deta.dev",
	"dfirma.pl",
	"dkonto.pl",
	"you2.pl",
	"ondigitalocean.app",
	"*.digitaloceanspaces.com",
	"us.kg",
	"rss.my.id",
	"diher.solutions",
	"discordsays.com",
	"discordsez.com",
	"jozi.biz",
	"dnshome.de",
	"online.th",
	"shop.th",
	"drayddns.com",
	"shoparena.pl",
	"dreamhosters.com",
	"durumis.com",
	"mydrobo.com",
	"drud.io",
	"drud.us",
	"duckdns.org",
	"dy.fi",
	"tunk.org",
	"dyndns.biz",
	"for-better.biz",
	"for-more.biz",
	"for-some.biz",
	"for-the.biz",
	"selfip.biz",
	"webhop.biz",
	"ftpaccess.cc",
	"game-server.cc",
	"myphotos.cc",
	"scrapping.cc",
	"blogdns.com",
	"cechire.com",
	"dnsalias.com",
	"dnsdojo.com",
	"doesntexist.com",
	"dontexist.com",
	"doomdns.com",
	"dyn-o-saur.com",
	"dynalias.com",
	"dyndns-at-home.com",
	"dyndns-at-work.com",
	"dyndns-blog.com",
	"dyndns-free.com",
	"dyndns-home.com",
	"dyndns-ip.com",
	"dyndns-mail.com",
	"dyndns-office.com",
	"dyndns-pics.com",
	"dyndns-remote.com",
	"dyndns-server.com",
	"dyndns-web.com",
	"dyndns-wiki.com",
	"dyndns-work.com",
	"est-a-la-maison.com",
	"est-a-la-masion.com",
	"est-le-patron.com",
	"est-mon-blogueur.com",
	"from-ak.com",
	"from-al.com",
	"from-ar.com",
	"from-ca.com",
	"from-ct.com",
	"from-dc.com",
	"from-de.com",
	"from-fl.com",
	"from-ga.com",
	"from-hi.com",
	"from-ia.com",
	"from-id.com",
	"from-il.com",
	"from-in.com",
	"from-ks.com",
	"from-ky.com",
	"from-ma.com",
	"from-md.com",
	"from-mi.com",
	"from-mn.com",
	"from-mo.com",
	"from-ms.com",
	"from-mt.com",
	"from-nc.com",
	"from-nd.com",
	"from-ne.com",
	"from-nh.com",
	"from-nj.com",
	"from-nm.com",
	"from-nv.com",
	"from-oh.com",
	"from-ok.com",
	"from-or.com",
	"from-pa.com",
	"from-pr.com",
	"from-ri.com",
	"from-sc.com",
	"from-sd.com",
	"from-tn.com",
	"from-tx.com",
	"from-ut.com",
	"from-va.com",
	"from-vt.com",
	"from-wa.com",
	"from-wi.com",
	"from-wv.com",
	"from-wy.com",
	"getmyip.com",
	"gotdns.com",
	"hobby-site.com",
	"homelinux.com",
	"homeunix.com",
	"iamallama.com",
	"is-a-anarchist.com",
	"is-a-blogger.com",
	"is-a-bookkeeper.com",
	"is-a-bulls-fan.com",
	"is-a-caterer.com",
	"is-a-chef.com",
	"is-a-conservative.com",
	"is-a-cpa.com",
	"is-a-cubicle-slave.com",
	"is-a-democrat.com",
	"is-a-designer.com",
	"is-a-doctor.com",
	"is-a-financialadvisor.com",
	"is-a-geek.com",
	"is-a-green.com",
	"is-a-guru.com",
	"is-a-hard-worker.com",
	"is-a-hunter.com",
	"is-a-landscaper.com",
	"is-a-lawyer.com",
	"is-a-liberal.com",
	"is-a-libertarian.com",
	"is-a-llama.com",
	"is-a-musician.com",
	"is-a-nascarfan.com",
	"is-a-nurse.com",
	"is-a-painter.com",
	"is-a-personaltrainer.com",
	"is-a-photographer.com",
	"is-a-player.com",
	"is-a-republican.com",
	"is-a-rockstar.com",
	"is-a-socialist.com",
	"is-a-student.com",
	"is-a-teacher.com",
	"is-a-techie.com",
	"is-a-therapist.com",
	"is-an-accountant.com",
	"is-an-actor.com",
	"is-an-actress.com",
	"is-an-anarchist.com",
	"is-an-artist.com",
	"is-an-engineer.com",
	"is-an-entertainer.com",
	"is-certified.com",
	"is-gone.com",
	"is-into-anime.com",
	"is-into-cars.com",
	"is-into-cartoons.com",
	"is-into-games.com",
	"is-leet.com",
	"is-not-certified.com",
	"is-slick.com",
	"is-uberleet.com",
	"is-with-theband.com",
	"isa-geek.com",
	"isa-hockeynut.com",
	"issmarterthanyou.com",
	"likes-pie.com",
	"likescandy.com",
	"neat-url.com",
	"saves-the-whales.com",
	"selfip.com",
	"sells-for-less.com",
	"sells-for-u.com",
	"servebbs.com",
	"simple-url.com",
	"space-to-rent.com",
	"teaches-yoga.com",
	"writesthisblog.com",
	"ath.cx",
	"fuettertdasnetz.de",
	"isteingeek.de",
	"istmein.de",
	"lebtimnetz.de",
	"leitungsen.de",
	"traeumtgerade.de",
	"barrel-of-knowledge.info",
	"barrell-of-knowledge.info",
	"dyndns.info",
	"for-our.info",
	"groks-the.info",
	"groks-this.info",
	"here-for-more.info",
	"knowsitall.info",
	"selfip.info",
	"webhop.info",
	"forgot.her.name",
	"forgot.his.name",
	"at-band-camp.net",
	"blogdns.net",
	"broke-it.net",
	"buyshouses.net",
	"dnsalias.net",
	"dnsdojo.net",
	"does-it.net",
	"dontexist.net",
	"dynalias.net",
	"dynathome.net",
	"endofinternet.net",
	"from-az.net",
	"from-co.net",
	"from-la.net",
	"from-ny.net",
	"gets-it.net",
	"ham-radio-op.net",
	"homeftp.net",
	"homeip.net",
	"homelinux.net",
	"homeunix.net",
	"in-the-band.net",
	"is-a-chef.net",
	"is-a-geek.net",
	"isa-geek.net",
	"kicks-ass.net",
	"office-on-the.net",
	"podzone.net",
	"scrapper-site.net",
	"selfip.net",
	"sells-it.net",
	"servebbs.net",
	"serveftp.net",
	"thruhere.net",
	"webhop.net",
	"merseine.nu",
	"mine.nu",
	"shacknet.nu",
	"blogdns.org",
	"blogsite.org",
	"boldlygoingnowhere.org",
	"dnsalias.org",
	"dnsdojo.org",
	"doesntexist.org",
	"dontexist.org",
	"doomdns.org",
	"dvrdns.org",
	"dynalias.org",
	"dyndns.org",
	"go.dyndns.org",
	"home.dyndns.org",
	"endofinternet.org",
	"endoftheinternet.org",
	"from-me.org",
	"game-host.org",
	"gotdns.org",
	"hobby-site.org",
	"homedns.org",
	"homeftp.org",
	"homelinux.org",
	"homeunix.org",
	"is-a-bruinsfan.org",
	"is-a-candidate.org",
	"is-a-celticsfan.org",
	"is-a-chef.org",
	"is-a-geek.org",
	"is-a-knight.org",
	"is-a-linux-user.org",
	"is-a-patsfan.org",
	"is-a-soxfan.org",
	"is-found.org",
	"is-lost.org",
	"is-saved.org",
	"is-very-bad.org",
	"is-very-evil.org",
	"is-very-good.org",
	"is-very-nice.org",
	"is-very-sweet.org",
	"isa-geek.org",
	"kicks-ass.org",
	"misconfused.org",
	"podzone.org",
	"readmyblog.org",
	"selfip.org",
	"sellsyourhome.org",
	"servebbs.org",
	"serveftp.org",
	"servegame.org",
	"stuff-4-sale.org",
	"webhop.org",
	"better-than.tv",
	"dyndns.tv",
	"on-the-web.tv",
	"worse-than.tv",
	"is-by.us",
	"land-4-sale.us",
	"stuff-4-sale.us",
	"dyndns.ws",
	"mypets.ws",
	"ddnsfree.com",
	"ddnsgeek.com",
	"giize.com",
	"gleeze.com",
	"kozow.com",
	"loseyourip.com",
	"ooguy.com",
	"theworkpc.com",
	"casacam.net",
	"dynu.net",
	"accesscam.org",
	"camdvr.org",
	"freeddns.org",
	"mywire.org",
	"webredirect.org",
	"myddns.rocks",
	"dynv6.net",
	"e4.cz",
	"easypanel.app",
	"easypanel.host",
	"*.ewp.live",
	"twmail.cc",
	"twmail.net",
	"twmail.org",
	"mymailer.com.tw",
	"url.tw",
	"at.emf.camp",
	"rt.ht",
	"elementor.cloud",
	"elementor.cool",
	"en-root.fr",
	"mytuleap.com",
	"tuleap-partners.com",
	"encr.app",
	"encoreapi.com",
	"eu.encoway.cloud",
	"eu.org",
	"al.eu.org",
	"asso.eu.org",
	"at.eu.org",
	"au.eu.org",
	"be.eu.org",
	"bg.eu.org",
	"ca.eu.org",
	"cd.eu.org",
	"ch.eu.org",
	"cn.eu.org",
	"cy.eu.org",
	"cz.eu.org",
	"de.eu.org",
	"dk.eu.org",
	"edu.eu.org",
	"ee.eu.org",
	"es.eu.org",
	"fi.eu.org",
	"fr.eu.org",
	"gr.eu.org",
	"hr.eu.org",
	"hu.eu.org",
	"ie.eu.org",
	"il.eu.org",
	"in.eu.org",
	"int.eu.org",
	"is.eu.org",
	"it.eu.org",
	"jp.eu.org",
	"kr.eu.org",
	"lt.eu.org",
	"lu.eu.org",
	"lv.eu.org",
	"me.eu.org",
	"mk.eu.org",
	"mt.eu.org",
	"my.eu.org",
	"net.eu.org",
	"ng.eu.org",
	"nl.eu.org",
	"no.eu.org",
	"nz.eu.org",
	"pl.eu.org",
	"pt.eu.org",
	"ro.eu.org",
	"ru.eu.org",
	"se.eu.org",
	"si.eu.org",
	"sk.eu.org",
	"tr.eu.org",
	"uk.eu.org",
	"us.eu.org",
	"eurodir.ru",
	"eu-1.evennode.com",
	"eu-2.evennode.com",
	"eu-3.evennode.com",
	"eu-4.evennode.com",
	"us-1.evennode.com",
	"us-2.evennode.com",
	"us-3.evennode.com",
	"us-4.evennode.com",
	"relay.evervault.app",
	"relay.evervault.dev",
	"expo.app",
	"staging.expo.app",
	"onfabrica.com",
	"ru.net",
	"adygeya.ru",
	"bashkiria.ru",
	"bir.ru",
	"cbg.ru",
	"com.ru",
	"dagestan.ru",
	"grozny.ru",
	"kalmykia.ru",
	"kustanai.ru",
	"marine.ru",
	"mordovia.ru",
	"msk.ru",
	"mytis.ru",
	"nalchik.ru",
	"nov.ru",
	"pyatigorsk.ru",
	"spb.ru",
	"vladikavkaz.ru",
	"vladimir.ru",
	"abkhazia.su",
	"adygeya.su",
	"aktyubinsk.su",
	"arkhangelsk.su",
	"armenia.su",
	"ashgabad.su",
	"azerbaijan.su",
	"balashov.su",
	"bashkiria.su",
	"bryansk.su",
	"bukhara.su",
	"chimkent.su",
	"dagestan.su",
	"east-kazakhstan.su",
	"exnet.su",
	"georgia.su",
	"grozny.su",
	"ivanovo.su",
	"jambyl.su",
	"kalmykia.su",
	"kaluga.su",
	"karacol.su",
	"karaganda.su",
	"karelia.su",
	"khakassia.su",
	"krasnodar.su",
	"kurgan.su",
	"kustanai.su",
	"lenug.su",
	"mangyshlak.su",
	"mordovia.su",
	"msk.su",
	"murmansk.su",
	"nalchik.su",
	"navoi.su",
	"north-kazakhstan.su",
	"nov.su",
	"obninsk.su",
	"penza.su",
	"pokrovsk.su",
	"sochi.su",
	"spb.su",
	"tashkent.su",
	"termez.su",
	"togliatti.su",
	"troitsk.su",
	"tselinograd.su",
	"tula.su",
	"tuva.su",
	"vladikavkaz.su",
	"vladimir.su",
	"vologda.su",
	"channelsdvr.net",
	"u.channelsdvr.net",
	"edgecompute.app",
	"fastly-edge.com",
	"fastly-terrarium.com",
	"freetls.fastly.net",
	"map.fastly.net",
	"a.prod.fastly.net",
	"global.prod.fastly.net",
	"a.ssl.fastly.net",
	"b.ssl.fastly.net",
	"global.ssl.fastly.net",
	"fastlylb.net",
	"map.fastlylb.net",
	"*.user.fm",
	"fastvps-server.com",
	"fastvps.host",
	"myfast.host",
	"fastvps.site",
	"myfast.space",
	"conn.uk",
	"copro.uk",
	"hosp.uk",
	"fedorainfracloud.org",
	"fedorapeople.org",
	"cloud.fedoraproject.org",
	"app.os.fedoraproject.org",
	"app.os.stg.fedoraproject.org",
	"mydobiss.com",
	"fh-muenster.io",
	"filegear.me",
	"firebaseapp.com",
	"fldrv.com",
	"flutterflow.app",
	"fly.dev",
	"shw.io",
	"edgeapp.net",
	"forgeblocks.com",
	"id.forgerock.io",
	"framer.ai",
	"framer.app",
	"framercanvas.com",
	"framer.media",
	"framer.photos",
	"framer.website",
	"framer.wiki",
	"0e.vc",
	"freebox-os.com",
	"freeboxos.com",
	"fbx-os.fr",
	"fbxos.fr",
	"freebox-os.fr",
	"freeboxos.fr",
	"freedesktop.org",
	"freemyip.com",
	"*.frusky.de",
	"wien.funkfeuer.at",
	"daemon.asia",
	"dix.asia",
	"mydns.bz",
	"0am.jp",
	"0g0.jp",
	"0j0.jp",
	"0t0.jp",
	"mydns.jp",
	"pgw.jp",
	"wjg.jp",
	"keyword-on.net",
	"live-on.net",
	"server-on.net",
	"mydns.tw",
	"mydns.vc",
	"*.futurecms.at",
	"*.ex.futurecms.at",
	"*.in.futurecms.at",
	"futurehosting.at",
	"futuremailing.at",
	"*.ex.ortsinfo.at",
	"*.kunden.ortsinfo.at",
	"*.statics.cloud",
	"aliases121.com",
	"campaign.gov.uk",
	"service.gov.uk",
	"independent-commission.uk",
	"independent-inquest.uk",
	"independent-inquiry.uk",
	"independent-panel.uk",
	"independent-review.uk",
	"public-inquiry.uk",
	"royal-commission.uk",
	"gehirn.ne.jp",
	"usercontent.jp",
	"gentapps.com",
	"gentlentapis.com",
	"lab.ms",
	"cdn-edges.net",
	"localcert.net",
	"localhostcert.net",
	"gsj.bz",
	"githubusercontent.com",
	"githubpreview.dev",
	"github.io",
	"gitlab.io",
	"gitapp.si",
	"gitpage.si",
	"glitch.me",
	"nog.community",
	"co.ro",
	"shop.ro",
	"lolipop.io",
	"angry.jp",
	"babyblue.jp",
	"babymilk.jp",
	"backdrop.jp",
	"bambina.jp",
	"bitter.jp",
	"blush.jp",
	"boo.jp",
	"boy.jp",
	"boyfriend.jp",
	"but.jp",
	"candypop.jp",
	"capoo.jp",
	"catfood.jp",
	"cheap.jp",
	"chicappa.jp",
	"chillout.jp",
	"chips.jp",
	"chowder.jp",
	"chu.jp",
	"ciao.jp",
	"cocotte.jp",
	"coolblog.jp",
	"cranky.jp",
	"cutegirl.jp",
	"daa.jp",
	"deca.jp",
	"deci.jp",
	"digick.jp",
	"egoism.jp",
	"fakefur.jp",
	"fem.jp",
	"flier.jp",
	"floppy.jp",
	"fool.jp",
	"frenchkiss.jp",
	"girlfriend.jp",
	"girly.jp",
	"gloomy.jp",
	"gonna.jp",
	"greater.jp",
	"hacca.jp",
	"heavy.jp",
	"her.jp",
	"hiho.jp",
	"hippy.jp",
	"holy.jp",
	"hungry.jp",
	"icurus.jp",
	"itigo.jp",
	"jellybean.jp",
	"kikirara.jp",
	"kill.jp",
	"kilo.jp",
	"kuron.jp",
	"littlestar.jp",
	"lolipopmc.jp",
	"lolitapunk.jp",
	"lomo.jp",
	"lovepop.jp",
	"lovesick.jp",
	"main.jp",
	"mods.jp",
	"mond.jp",
	"mongolian.jp",
	"moo.jp",
	"namaste.jp",
	"nikita.jp",
	"nobushi.jp",
	"noor.jp",
	"oops.jp",
	"parallel.jp",
	"parasite.jp",
	"pecori.jp",
	"peewee.jp",
	"penne.jp",
	"pepper.jp",
	"perma.jp",
	"pigboat.jp",
	"pinoko.jp",
	"punyu.jp",
	"pupu.jp",
	"pussycat.jp",
	"pya.jp",
	"raindrop.jp",
	"readymade.jp",
	"sadist.jp",
	"schoolbus.jp",
	"secret.jp",
	"staba.jp",
	"stripper.jp",
	"sub.jp",
	"sunnyday.jp",
	"thick.jp",
	"tonkotsu.jp",
	"under.jp",
	"upper.jp",
	"velvet.jp",
	"verse.jp",
	"versus.jp",
	"vivian.jp",
	"watson.jp",
	"weblike.jp",
	"whitesnow.jp",
	"zombie.jp",
	"heteml.net",
	"graphic.design",
	"goip.de",
	"blogspot.ae",
	"blogspot.al",
	"blogspot.am",
	"*.hosted.app",
	"*.run.app",
	"web.app",
	"blogspot.com.ar",
	"blogspot.co.at",
	"blogspot.com.au",
	"blogspot.ba",
	"blogspot.be",
	"blogspot.bg",
	"blogspot.bj",
	"blogspot.com.br",
	"blogspot.com.by",
	"blogspot.ca",
	"blogspot.cf",
	"blogspot.ch",
	"blogspot.cl",
	"blogspot.com.co",
	"*.0emm.com",
	"appspot.com",
	"*.r.appspot.com",
	"blogspot.com",
	"codespot.com",
	"googleapis.com",
	"googlecode.com",
	"pagespeedmobilizer.com",
	"withgoogle.com",
	"withyoutube.com",
	"blogspot.cv",
	"blogspot.com.cy",
	"blogspot.cz",
	"blogspot.de",
	"*.gateway.dev",
	"blogspot.dk",
	"blogspot.com.ee",
	"blogspot.com.eg",
	"blogspot.com.es",
	"blogspot.fi",
	"blogspot.fr",
	"cloud.goog",
	"translate.goog",
	"*.usercontent.goog",
	"blogspot.gr",
	"blogspot.hk",
	"blogspot.hr",
	"blogspot.hu",
	"blogspot.co.id",
	"blogspot.ie",
	"blogspot.co.il",
	"blogspot.in",
	"blogspot.is",
	"blogspot.it",
	"blogspot.jp",
	"blogspot.co.ke",
	"blogspot.kr",
	"blogspot.li",
	"blogspot.lt",
	"blogspot.lu",
	"blogspot.md",
	"blogspot.mk",
	"blogspot.com.mt",
	"blogspot.mx",
	"blogspot.my",
	"cloudfunctions.net",
	"blogspot.com.ng",
	"blogspot.nl",
	"blogspot.no",
	"blogspot.co.nz",
	"blogspot.pe",
	"blogspot.pt",
	"blogspot.qa",
	"blogspot.re",
	"blogspot.ro",
	"blogspot.rs",
	"blogspot.ru",
	"blogspot.se",
	"blogspot.sg",
	"blogspot.si",
	"blogspot.sk",
	"blogspot.sn",
	"blogspot.td",
	"blogspot.com.tr",
	"blogspot.tw",
	"blogspot.ug",
	"blogspot.co.uk",
	"blogspot.com.uy",
	"blogspot.vn",
	"blogspot.co.za",
	"goupile.fr",
	"pymnt.uk",
	"cloudapps.digital",
	"london.cloudapps.digital",
	"gov.nl",
	"grafana-dev.net",
	"grayjayleagues.com",
	"günstigbestellen.de",
	"günstigliefern.de",
	"fin.ci",
	"free.hr",
	"caa.li",
	"ua.rs",
	"conf.se",
	"häkkinen.fi",
	"hrsn.dev",
	"hashbang.sh",
	"hasura.app",
	"hasura-app.io",
	"hatenablog.com",
	"hatenadiary.com",
	"hateblo.jp",
	"hatenablog.jp",
	"hatenadiary.jp",
	"hatenadiary.org",
	"pages.it.hs-heilbronn.de",
	"pages-research.it.hs-heilbronn.de",
	"heiyu.space",
	"helioho.st",
	"heliohost.us",
	"hepforge.org",
	"herokuapp.com",
	"herokussl.com",
	"heyflow.page",
	"heyflow.site",
	"ravendb.cloud",
	"ravendb.community",
	"development.run",
	"ravendb.run",
	"homesklep.pl",
	"*.kin.one",
	"*.id.pub",
	"*.kin.pub",
	"secaas.hk",
	"hoplix.shop",
	"orx.biz",
	"biz.gl",
	"biz.ng",
	"co.biz.ng",
	"dl.biz.ng",
	"go.biz.ng",
	"lg.biz.ng",
	"on.biz.ng",
	"col.ng",
	"firm.ng",
	"gen.ng",
	"ltd.ng",
	"ngo.ng",
	"plc.ng",
	"ie.ua",
	"hostyhosting.io",
	"hf.space",
	"static.hf.space",
	"hypernode.io",
	"iobb.net",
	"co.cz",
	"*.moonscale.io",
	"moonscale.net",
	"gr.com",
	"iki.fi",
	"ibxos.it",
	"iliadboxos.it",
	"smushcdn.com",
	"wphostedmail.com",
	"wpmucdn.com",
	"tempurl.host",
	"wpmudev.host",
	"dyn-berlin.de",
	"in-berlin.de",
	"in-brb.de",
	"in-butter.de",
	"in-dsl.de",
	"in-vpn.de",
	"in-dsl.net",
	"in-vpn.net",
	"in-dsl.org",
	"in-vpn.org",
	"biz.at",
	"info.at",
	"info.cx",
	"ac.leg.br",
	"al.leg.br",
	"am.leg.br",
	"ap.leg.br",
	"ba.leg.br",
	"ce.leg.br",
	"df.leg.br",
	"es.leg.br",
	"go.leg.br",
	"ma.leg.br",
	"mg.leg.br",
	"ms.leg.br",
	"mt.leg.br",
	"pa.leg.br",
	"pb.leg.br",
	"pe.leg.br",
	"pi.leg.br",
	"pr.leg.br",
	"rj.leg.br",
	"rn.leg.br",
	"ro.leg.br",
	"rr.leg.br",
	"rs.leg.br",
	"sc.leg.br",
	"se.leg.br",
	"sp.leg.br",
	"to.leg.br",
	"pixolino.com",
	"na4u.ru",
	"apps-1and1.com",
	"live-website.com",
	"apps-1and1.net",
	"websitebuilder.online",
	"app-ionos.space",
	"iopsys.se",
	"*.dweb.link",
	"ipifony.net",
	"ir.md",
	"is-a-good.dev",
	"is-a.dev",
	"iservschule.de",
	"mein-iserv.de",
	"schulplattform.de",
	"schulserver.de",
	"test-iserv.de",
	"iserv.dev",
	"mel.cloudlets.com.au",
	"cloud.interhostsolutions.be",
	"alp1.ae.flow.ch",
	"appengine.flow.ch",
	"es-1.axarnet.cloud",
	"diadem.cloud",
	"vip.jelastic.cloud",
	"jele.cloud",
	"it1.eur.aruba.jenv-aruba.cloud",
	"it1.jenv-aruba.cloud",
	"keliweb.cloud",
	"cs.keliweb.cloud",
	"oxa.cloud",
	"tn.oxa.cloud",
	"uk.oxa.cloud",
	"primetel.cloud",
	"uk.primetel.cloud",
	"ca.reclaim.cloud",
	"uk.reclaim.cloud",
	"us.reclaim.cloud",
	"ch.trendhosting.cloud",
	"de.trendhosting.cloud",
	"jele.club",
	"dopaas.com",
	"paas.hosted-by-previder.com",
	"rag-cloud.hosteur.com",
	"rag-cloud-ch.hosteur.com",
	"jcloud.ik-server.com",
	"jcloud-ver-jpc.ik-server.com",
	"demo.jelastic.com",
	"paas.massivegrid.com",
	"jed.wafaicloud.com",
	"ryd.wafaicloud.com",
	"j.scaleforce.com.cy",
	"jelastic.dogado.eu",
	"fi.cloudplatform.fi",
	"demo.datacenter.fi",
	"paas.datacenter.fi",
	"jele.host",
	"mircloud.host",
	"paas.beebyte.io",
	"sekd1.beebyteapp.io",
	"jele.io",
	"jc.neen.it",
	"jcloud.kz",
	"cloudjiffy.net",
	"fra1-de.cloudjiffy.net",
	"west1-us.cloudjiffy.net",
	"jls-sto1.elastx.net",
	"jls-sto2.elastx.net",
	"jls-sto3.elastx.net",
	"fr-1.paas.massivegrid.net",
	"lon-1.paas.massivegrid.net",
	"lon-2.paas.massivegrid.net",
	"ny-1.paas.massivegrid.net",
	"ny-2.paas.massivegrid.net",
	"sg-1.paas.massivegrid.net",
	"jelastic.saveincloud.net",
	"nordeste-idc.saveincloud.net",
	"j.scaleforce.net",
	"sdscloud.pl",
	"unicloud.pl",
	"mircloud.ru",
	"enscaled.sg",
	"jele.site",
	"jelastic.team",
	"orangecloud.tn",
	"j.layershift.co.uk",
	"phx.enscaled.us",
	"mircloud.us",
	"myjino.ru",
	"*.hosting.myjino.ru",
	"*.landing.myjino.ru",
	"*.spectrum.myjino.ru",
	"*.vps.myjino.ru",
	"jotelulu.cloud",
	"webadorsite.com",
	"jouwweb.site",
	"*.cns.joyent.com",
	"*.triton.zone",
	"js.org",
	"kaas.gg",
	"khplay.nl",
	"kapsi.fi",
	"ezproxy.kuleuven.be",
	"kuleuven.cloud",
	"keymachine.de",
	"kinghost.net",
	"uni5.net",
	"knightpoint.systems",
	"koobin.events",
	"webthings.io",
	"krellian.net",
	"oya.to",
	"git-repos.de",
	"lcube-server.de",
	"svn-repos.de",
	"leadpages.co",
	"lpages.co",
	"lpusercontent.com",
	"lelux.site",
	"libp2p.direct",
	"runcontainers.dev",
	"co.business",
	"co.education",
	"co.events",
	"co.financial",
	"co.network",
	"co.place",
	"co.technology",
	"linkyard-cloud.ch",
	"linkyard.cloud",
	"members.linode.com",
	"*.nodebalancer.linode.com",
	"*.linodeobjects.com",
	"ip.linodeusercontent.com",
	"we.bs",
	"filegear-sg.me",
	"ggff.net",
	"*.user.localcert.dev",
	"lodz.pl",
	"pabianice.pl",
	"plock.pl",
	"sieradz.pl",
	"skierniewice.pl",
	"zgierz.pl",
	"loginline.app",
	"loginline.dev",
	"loginline.io",
	"loginline.services",
	"loginline.site",
	"lohmus.me",
	"servers.run",
	"krasnik.pl",
	"leczna.pl",
	"lubartow.pl",
	"lublin.pl",
	"poniatowa.pl",
	"swidnik.pl",
	"glug.org.uk",
	"lug.org.uk",
	"lugs.org.uk",
	"barsy.bg",
	"barsy.club",
	"barsycenter.com",
	"barsyonline.com",
	"barsy.de",
	"barsy.dev",
	"barsy.eu",
	"barsy.gr",
	"barsy.in",
	"barsy.info",
	"barsy.io",
	"barsy.me",
	"barsy.menu",
	"barsyonline.menu",
	"barsy.mobi",
	"barsy.net",
	"barsy.online",
	"barsy.org",
	"barsy.pro",
	"barsy.pub",
	"barsy.ro",
	"barsy.rs",
	"barsy.shop",
	"barsyonline.shop",
	"barsy.site",
	"barsy.store",
	"barsy.support",
	"barsy.uk",
	"barsy.co.uk",
	"barsyonline.co.uk",
	"*.magentosite.cloud",
	"hb.cldmail.ru",
	"matlab.cloud",
	"modelscape.com",
	"mwcloudnonprod.com",
	"polyspace.com",
	"mayfirst.info",
	"mayfirst.org",
	"mazeplay.com",
	"mcdir.me",
	"mcdir.ru",
	"vps.mcdir.ru",
	"mcpre.ru",
	"mediatech.by",
	"mediatech.dev",
	"hra.health",
	"medusajs.app",
	"miniserver.com",
	"memset.net",
	"messerli.app",
	"atmeta.com",
	"apps.fbsbx.com",
	"*.cloud.metacentrum.cz",
	"custom.metacentrum.cz",
	"flt.cloud.muni.cz",
	"usr.cloud.muni.cz",
	"meteorapp.com",
	"eu.meteorapp.com",
	"co.pl",
	"*.azurecontainer.io",
	"azure-api.net",
	"azure-mobile.net",
	"azureedge.net",
	"azurefd.net",
	"azurestaticapps.net",
	"1.azurestaticapps.net",
	"2.azurestaticapps.net",
	"3.azurestaticapps.net",
	"4.azurestaticapps.net",
	"5.azurestaticapps.net",
	"6.azurestaticapps.net",
	"7.azurestaticapps.net",
	"centralus.azurestaticapps.net",
	"eastasia.azurestaticapps.net",
	"eastus2.azurestaticapps.net",
	"westeurope.azurestaticapps.net",
	"westus2.azurestaticapps.net",
	"azurewebsites.net",
	"cloudapp.net",
	"trafficmanager.net",
	"blob.core.windows.net",
	"servicebus.windows.net",
	"routingthecloud.com",
	"sn.mynetname.net",
	"routingthecloud.net",
	"routingthecloud.org",
	"csx.cc",
	"mydbserver.com",
	"webspaceconfig.de",
	"mittwald.info",
	"mittwaldserver.info",
	"typo3server.info",
	"project.space",
	"modx.dev",
	"bmoattachments.org",
	"net.ru",
	"org.ru",
	"pp.ru",
	"hostedpi.com",
	"caracal.mythic-beasts.com",
	"customer.mythic-beasts.com",
	"fentiger.mythic-beasts.com",
	"lynx.mythic-beasts.com",
	"ocelot.mythic-beasts.com",
	"oncilla.mythic-beasts.com",
	"onza.mythic-beasts.com",
	"sphinx.mythic-beasts.com",
	"vs.mythic-beasts.com",
	"x.mythic-beasts.com",
	"yali.mythic-beasts.com",
	"cust.retrosnub.co.uk",
	"ui.nabu.casa",
	"cloud.nospamproxy.com",
	"netfy.app",
	"netlify.app",
	"4u.com",
	"nfshost.com",
	"ipfs.nftstorage.link",
	"ngo.us",
	"ngrok.app",
	"ngrok-free.app",
	"ngrok.dev",
	"ngrok-free.dev",
	"ngrok.io",
	"ap.ngrok.io",
	"au.ngrok.io",
	"eu.ngrok.io",
	"in.ngrok.io",
	"jp.ngrok.io",
	"sa.ngrok.io",
	"us.ngrok.io",
	"ngrok.pizza",
	"ngrok.pro",
	"torun.pl",
	"nh-serv.co.uk",
	"nimsite.uk",
	"mmafan.biz",
	"myftp.biz",
	"no-ip.biz",
	"no-ip.ca",
	"fantasyleague.cc",
	"gotdns.ch",
	"3utilities.com",
	"blogsyte.com",
	"ciscofreak.com",
	"damnserver.com",
	"ddnsking.com",
	"ditchyourip.com",
	"dnsiskinky.com",
	"dynns.com",
	"geekgalaxy.com",
	"health-carereform.com",
	"homesecuritymac.com",
	"homesecuritypc.com",
	"myactivedirectory.com",
	"mysecuritycamera.com",
	"myvnc.com",
	"net-freaks.com",
	"onthewifi.com",
	"point2this.com",
	"quicksytes.com",
	"securitytactics.com",
	"servebeer.com",
	"servecounterstrike.com",
	"serveexchange.com",
	"serveftp.com",
	"servegame.com",
	"servehalflife.com",
	"servehttp.com",
	"servehumour.com",
	"serveirc.com",
	"servemp3.com",
	"servep2p.com",
	"servepics.com",
	"servequake.com",
	"servesarcasm.com",
	"stufftoread.com",
	"unusualperson.com",
	"workisboring.com",
	"dvrcam.info",
	"ilovecollege.info",
	"no-ip.info",
	"brasilia.me",
	"ddns.me",
	"dnsfor.me",
	"hopto.me",
	"loginto.me",
	"noip.me",
	"webhop.me",
	"bounceme.net",
	"ddns.net",
	"eating-organic.net",
	"mydissent.net",
	"myeffect.net",
	"mymediapc.net",
	"mypsx.net",
	"mysecuritycamera.net",
	"nhlfan.net",
	"no-ip.net",
	"pgafan.net",
	"privatizehealthinsurance.net",
	"redirectme.net",
	"serveblog.net",
	"serveminecraft.net",
	"sytes.net",
	"cable-modem.org",
	"collegefan.org",
	"couchpotatofries.org",
	"hopto.org",
	"mlbfan.org",
	"myftp.org",
	"mysecuritycamera.org",
	"nflfan.org",
	"no-ip.org",
	"read-books.org",
	"ufcfan.org",
	"zapto.org",
	"no-ip.co.uk",
	"golffan.us",
	"noip.us",
	"pointto.us",
	"stage.nodeart.io",
	"*.developer.app",
	"noop.app",
	"*.northflank.app",
	"*.build.run",
	"*.code.run",
	"*.database.run",
	"*.migration.run",
	"noticeable.news",
	"notion.site",
	"dnsking.ch",
	"mypi.co",
	"n4t.co",
	"001www.com",
	"myiphost.com",
	"forumz.info",
	"soundcast.me",
	"tcp4.me",
	"dnsup.net",
	"hicam.net",
	"now-dns.net",
	"ownip.net",
	"vpndns.net",
	"dynserv.org",
	"now-dns.org",
	"x443.pw",
	"now-dns.top",
	"ntdll.top",
	"freeddns.us",
	"nsupdate.info",
	"nerdpol.ovh",
	"nyc.mn",
	"prvcy.page",
	"obl.ong",
	"observablehq.cloud",
	"static.observableusercontent.com",
	"omg.lol",
	"cloudycluster.net",
	"omniwe.site",
	"123webseite.at",
	"123website.be",
	"simplesite.com.br",
	"123website.ch",
	"simplesite.com",
	"123webseite.de",
	"123hjemmeside.dk",
	"123miweb.es",
	"123kotisivu.fi",
	"123siteweb.fr",
	"simplesite.gr",
	"123homepage.it",
	"123website.lu",
	"123website.nl",
	"123hjemmeside.no",
	"service.one",
	"simplesite.pl",
	"123paginaweb.pt",
	"123minsida.se",
	"is-a-fullstack.dev",
	"is-cool.dev",
	"is-not-a.dev",
	"localplayer.dev",
	"is-local.org",
	"opensocial.site",
	"opencraft.hosting",
	"16-b.it",
	"32-b.it",
	"64-b.it",
	"orsites.com",
	"operaunite.com",
	"*.customer-oci.com",
	"*.oci.customer-oci.com",
	"*.ocp.customer-oci.com",
	"*.ocs.customer-oci.com",
	"*.oraclecloudapps.com",
	"*.oraclegovcloudapps.com",
	"*.oraclegovcloudapps.uk",
	"tech.orange",
	"can.re",
	"authgear-staging.com",
	"authgearapps.com",
	"skygearapp.com",
	"outsystemscloud.com",
	"*.hosting.ovh.net",
	"*.webpaas.ovh.net",
	"ownprovider.com",
	"own.pm",
	"*.owo.codes",
	"ox.rs",
	"oy.lc",
	"pgfog.com",
	"pagexl.com",
	"gotpantheon.com",
	"pantheonsite.io",
	"*.paywhirl.com",
	"*.xmit.co",
	"xmit.dev",
	"madethis.site",
	"srv.us",
	"gh.srv.us",
	"gl.srv.us",
	"lk3.ru",
	"mypep.link",
	"perspecta.cloud",
	"on-web.fr",
	"*.upsun.app",
	"upsunapp.com",
	"ent.platform.sh",
	"eu.platform.sh",
	"us.platform.sh",
	"*.platformsh.site",
	"*.tst.site",
	"platter-app.com",
	"platter-app.dev",
	"platterp.us",
	"pley.games",
	"onporter.run",
	"co.bn",
	"postman-echo.com",
	"pstmn.io",
	"mock.pstmn.io",
	"httpbin.org",
	"prequalifyme.today",
	"xen.prgmr.com",
	"priv.at",
	"protonet.io",
	"chirurgiens-dentistes-en-france.fr",
	"byen.site",
	"pubtls.org",
	"pythonanywhere.com",
	"eu.pythonanywhere.com",
	"qa2.com",
	"qcx.io",
	"*.sys.qcx.io",
	"myqnapcloud.cn",
	"alpha-myqnapcloud.com",
	"dev-myqnapcloud.com",
	"mycloudnas.com",
	"mynascloud.com",
	"myqnapcloud.com",
	"qoto.io",
	"qualifioapp.com",
	"ladesk.com",
	"qbuser.com",
	"*.quipelements.com",
	"vapor.cloud",
	"vaporcloud.io",
	"rackmaze.com",
	"rackmaze.net",
	"cloudsite.builders",
	"myradweb.net",
	"servername.us",
	"web.in",
	"in.net",
	"myrdbx.io",
	"site.rb-hosting.io",
	"*.on-rancher.cloud",
	"*.on-k3s.io",
	"*.on-rio.io",
	"ravpage.co.il",
	"readthedocs-hosted.com",
	"readthedocs.io",
	"rhcloud.com",
	"instances.spawn.cc",
	"onrender.com",
	"app.render.com",
	"replit.app",
	"id.replit.app",
	"firewalledreplit.co",
	"id.firewalledreplit.co",
	"repl.co",
	"id.repl.co",
	"replit.dev",
	"archer.replit.dev",
	"bones.replit.dev",
	"canary.replit.dev",
	"global.replit.dev",
	"hacker.replit.dev",
	"id.replit.dev",
	"janeway.replit.dev",
	"kim.replit.dev",
	"kira.replit.dev",
	"kirk.replit.dev",
	"odo.replit.dev",
	"paris.replit.dev",
	"picard.replit.dev",
	"pike.replit.dev",
	"prerelease.replit.dev",
	"reed.replit.dev",
	"riker.replit.dev",
	"sisko.replit.dev",
	"spock.replit.dev",
	"staging.replit.dev",
	"sulu.replit.dev",
	"tarpit.replit.dev",
	"teams.replit.dev",
	"tucker.replit.dev",
	"wesley.replit.dev",
	"worf.replit.dev",
	"repl.run",
	"resindevice.io",
	"devices.resinstaging.io",
	"hzc.io",
	"adimo.co.uk",
	"itcouldbewor.se",
	"aus.basketball",
	"nz.basketball",
	"git-pages.rit.edu",
	"rocky.page",
	"rub.de",
	"ruhr-uni-bochum.de",
	"io.noc.ruhr-uni-bochum.de",
	"биз.рус",
	"ком.рус",
	"крым.рус",
	"мир.рус",
	"мск.рус",
	"орг.рус",
	"самара.рус",
	"сочи.рус",
	"спб.рус",
	"я.рус",
	"ras.ru",
	"nyat.app",
	"180r.com",
	"dojin.com",
	"sakuratan.com",
	"sakuraweb.com",
	"x0.com",
	"2-d.jp",
	"bona.jp",
	"crap.jp",
	"daynight.jp",
	"eek.jp",
	"flop.jp",
	"halfmoon.jp",
	"jeez.jp",
	"matrix.jp",
	"mimoza.jp",
	"ivory.ne.jp",
	"mail-box.ne.jp",
	"mints.ne.jp",
	"mokuren.ne.jp",
	"opal.ne.jp",
	"sakura.ne.jp",
	"sumomo.ne.jp",
	"topaz.ne.jp",
	"netgamers.jp",
	"nyanta.jp",
	"o0o0.jp",
	"rdy.jp",
	"rgr.jp",
	"rulez.jp",
	"s3.isk01.sakurastorage.jp",
	"s3.isk02.sakurastorage.jp",
	"saloon.jp",
	"sblo.jp",
	"skr.jp",
	"tank.jp",
	"uh-oh.jp",
	"undo.jp",
	"rs.webaccel.jp",
	"user.webaccel.jp",
	"websozai.jp",
	"xii.jp",
	"squares.net",
	"jpn.org",
	"kirara.st",
	"x0.to",
	"from.tv",
	"sakura.tv",
	"*.builder.code.com",
	"*.dev-builder.code.com",
	"*.stg-builder.code.com",
	"*.001.test.code-builder-stg.platform.salesforce.com",
	"*.d.crm.dev",
	"*.w.crm.dev",
	"*.wa.crm.dev",
	"*.wb.crm.dev",
	"*.wc.crm.dev",
	"*.wd.crm.dev",
	"*.we.crm.dev",
	"*.wf.crm.dev",
	"sandcats.io",
	"logoip.com",
	"logoip.de",
	"fr-par-1.baremetal.scw.cloud",
	"fr-par-2.baremetal.scw.cloud",
	"nl-ams-1.baremetal.scw.cloud",
	"cockpit.fr-par.scw.cloud",
	"fnc.fr-par.scw.cloud",
	"functions.fnc.fr-par.scw.cloud",
	"k8s.fr-par.scw.cloud",
	"nodes.k8s.fr-par.scw.cloud",
	"s3.fr-par.scw.cloud",
	"s3-website.fr-par.scw.cloud",
	"whm.fr-par.scw.cloud",
	"priv.instances.scw.cloud",
	"pub.instances.scw.cloud",
	"k8s.scw.cloud",
	"cockpit.nl-ams.scw.cloud",
	"k8s.nl-ams.scw.cloud",
	"nodes.k8s.nl-ams.scw.cloud",
	"s3.nl-ams.scw.cloud",
	"s3-website.nl-ams.scw.cloud",
	"whm.nl-ams.scw.cloud",
	"cockpit.pl-waw.scw.cloud",
	"k8s.pl-waw.scw.cloud",
	"nodes.k8s.pl-waw.scw.cloud",
	"s3.pl-waw.scw.cloud",
	"s3-website.pl-waw.scw.cloud",
	"scalebook.scw.cloud",
	"smartlabeling.scw.cloud",
	"dedibox.fr",
	"schokokeks.net",
	"gov.scot",
	"service.gov.scot",
	"scrysec.com",
	"client.scrypted.io",
	"firewall-gateway.com",
	"firewall-gateway.de",
	"my-gateway.de",
	"my-router.de",
	"spdns.de",
	"spdns.eu",
	"firewall-gateway.net",
	"my-firewall.org",
	"myfirewall.org",
	"spdns.org",
	"seidat.net",
	"sellfy.store",
	"minisite.ms",
	"senseering.net",
	"servebolt.cloud",
	"biz.ua",
	"co.ua",
	"pp.ua",
	"as.sh.cn",
	"sheezy.games",
	"shiftedit.io",
	"myshopblocks.com",
	"myshopify.com",
	"shopitsite.com",
	"shopware.shop",
	"shopware.store",
	"mo-siemens.io",
	"1kapp.com",
	"appchizi.com",
	"applinzi.com",
	"sinaapp.com",
	"vipsinaapp.com",
	"siteleaf.net",
	"small-web.org",
	"aeroport.fr",
	"avocat.fr",
	"chambagri.fr",
	"chirurgiens-dentistes.fr",
	"experts-comptables.fr",
	"medecin.fr",
	"notaires.fr",
	"pharmacien.fr",
	"port.fr",
	"veterinaire.fr",
	"vp4.me",
	"*.snowflake.app",
	"*.privatelink.snowflake.app",
	"streamlit.app",
	"streamlitapp.com",
	"try-snowplow.com",
	"mafelo.net",
	"playstation-cloud.com",
	"srht.site",
	"apps.lair.io",
	"*.stolos.io",
	"spacekit.io",
	"ind.mom",
	"customer.speedpartner.de",
	"myspreadshop.at",
	"myspreadshop.com.au",
	"myspreadshop.be",
	"myspreadshop.ca",
	"myspreadshop.ch",
	"myspreadshop.com",
	"myspreadshop.de",
	"myspreadshop.dk",
	"myspreadshop.es",
	"myspreadshop.fi",
	"myspreadshop.fr",
	"myspreadshop.ie",
	"myspreadshop.it",
	"myspreadshop.net",
	"myspreadshop.nl",
	"myspreadshop.no",
	"myspreadshop.pl",
	"myspreadshop.se",
	"myspreadshop.co.uk",
	"w-corp-staticblitz.com",
	"w-credentialless-staticblitz.com",
	"w-staticblitz.com",
	"stackhero-network.com",
	"runs.onstackit.cloud",
	"stackit.gg",
	"stackit.rocks",
	"stackit.run",
	"stackit.zone",
	"musician.io",
	"novecore.site",
	"api.stdlib.com",
	"feedback.ac",
	"forms.ac",
	"assessments.cx",
	"calculators.cx",
	"funnels.cx",
	"paynow.cx",
	"quizzes.cx",
	"researched.cx",
	"tests.cx",
	"surveys.so",
	"storebase.store",
	"storipress.app",
	"storj.farm",
	"strapiapp.com",
	"media.strapiapp.com",
	"vps-host.net",
	"atl.jelastic.vps-host.net",
	"njs.jelastic.vps-host.net",
	"ric.jelastic.vps-host.net",
	"streak-link.com",
	"streaklinks.com",
	"streakusercontent.com",
	"soc.srcf.net",
	"user.srcf.net",
	"utwente.io",
	"temp-dns.com",
	"supabase.co",
	"supabase.in",
	"supabase.net",
	"syncloud.it",
	"dscloud.biz",
	"direct.quickconnect.cn",
	"dsmynas.com",
	"familyds.com",
	"diskstation.me",
	"dscloud.me",
	"i234.me",
	"myds.me",
	"synology.me",
	"dscloud.mobi",
	"dsmynas.net",
	"familyds.net",
	"dsmynas.org",
	"familyds.org",
	"direct.quickconnect.to",
	"vpnplus.to",
	"mytabit.com",
	"mytabit.co.il",
	"tabitorder.co.il",
	"taifun-dns.de",
	"ts.net",
	"*.c.ts.net",
	"gda.pl",
	"gdansk.pl",
	"gdynia.pl",
	"med.pl",
	"sopot.pl",
	"taveusercontent.com",
	"p.tawk.email",
	"p.tawkto.email",
	"site.tb-hosting.com",
	"edugit.io",
	"s3.teckids.org",
	"telebit.app",
	"telebit.io",
	"*.telebit.xyz",
	"*.firenet.ch",
	"*.svc.firenet.ch",
	"reservd.com",
	"thingdustdata.com",
	"cust.dev.thingdust.io",
	"reservd.dev.thingdust.io",
	"cust.disrec.thingdust.io",
	"reservd.disrec.thingdust.io",
	"cust.prod.thingdust.io",
	"cust.testing.thingdust.io",
	"reservd.testing.thingdust.io",
	"tickets.io",
	"arvo.network",
	"azimuth.network",
	"tlon.network",
	"torproject.net",
	"pages.torproject.net",
	"townnews-staging.com",
	"12hp.at",
	"2ix.at",
	"4lima.at",
	"lima-city.at",
	"12hp.ch",
	"2ix.ch",
	"4lima.ch",
	"lima-city.ch",
	"trafficplex.cloud",
	"de.cool",
	"12hp.de",
	"2ix.de",
	"4lima.de",
	"lima-city.de",
	"1337.pictures",
	"clan.rip",
	"lima-city.rocks",
	"webspace.rocks",
	"lima.zone",
	"*.transurl.be",
	"*.transurl.eu",
	"site.transip.me",
	"*.transurl.nl",
	"tuxfamily.org",
	"dd-dns.de",
	"dray-dns.de",
	"draydns.de",
	"dyn-vpn.de",
	"dynvpn.de",
	"mein-vigor.de",
	"my-vigor.de",
	"my-wan.de",
	"syno-ds.de",
	"synology-diskstation.de",
	"synology-ds.de",
	"diskstation.eu",
	"diskstation.org",
	"typedream.app",
	"pro.typeform.com",
	"*.uberspace.de",
	"uber.space",
	"hk.com",
	"inc.hk",
	"ltd.hk",
	"hk.org",
	"it.com",
	"unison-services.cloud",
	"virtual-user.de",
	"virtualuser.de",
	"name.pm",
	"sch.tf",
	"biz.wf",
	"sch.wf",
	"org.yt",
	"rs.ba",
	"bielsko.pl",
	"upli.io",
	"urown.cloud",
	"dnsupdate.info",
	"us.org",
	"v.ua",
	"express.val.run",
	"web.val.run",
	"vercel.app",
	"v0.build",
	"vercel.dev",
	"vusercontent.net",
	"now.sh",
	"2038.io",
	"router.management",
	"v-info.info",
	"voorloper.cloud",
	"*.vultrobjects.com",
	"wafflecell.com",
	"webflow.io",
	"webflowtest.io",
	"*.webhare.dev",
	"bookonline.app",
	"hotelwithflight.com",
	"reserve-online.com",
	"reserve-online.net",
	"cprapid.com",
	"pleskns.com",
	"wp2.host",
	"pdns.page",
	"plesk.page",
	"wpsquared.site",
	"*.wadl.top",
	"remotewd.com",
	"box.ca",
	"pages.wiardweb.com",
	"toolforge.org",
	"wmcloud.org",
	"wmflabs.org",
	"wdh.app",
	"panel.gg",
	"daemon.panel.gg",
	"wixsite.com",
	"wixstudio.com",
	"editorx.io",
	"wixstudio.io",
	"wix.run",
	"messwithdns.com",
	"woltlab-demo.com",
	"myforum.community",
	"community-pro.de",
	"diskussionsbereich.de",
	"community-pro.net",
	"meinforum.net",
	"affinitylottery.org.uk",
	"raffleentry.org.uk",
	"weeklylottery.org.uk",
	"wpenginepowered.com",
	"js.wpenginepowered.com",
	"half.host",
	"xnbay.com",
	"u2.xnbay.com",
	"u2-local.xnbay.com",
	"cistron.nl",
	"demon.nl",
	"xs4all.space",
	"yandexcloud.net",
	"storage.yandexcloud.net",
	"website.yandexcloud.net",
	"official.academy",
	"yolasite.com",
	"yombo.me",
	"ynh.fr",
	"nohost.me",
	"noho.st",
	"za.net",
	"za.org",
	"zap.cloud",
	"zeabur.app",
	"bss.design",
	"basicserver.io",
	"virtualserver.io",
	"enterprisecloud.nu"
].reduce((e, s) => {
	const c = s.replace(/^(\*\.|\!)/, ""), o = A$1.toASCII(c), t = s.charAt(0);
	if (e.has(o)) throw new Error(`Multiple rules found for ${s} (${o})`);
	return e.set(o, {
		rule: s,
		suffix: c,
		punySuffix: o,
		wildcard: t === "*",
		exception: t === "!"
	}), e;
}, /* @__PURE__ */ new Map());
var X = (e) => {
	const c = A$1.toASCII(e).split(".");
	for (let o = 0; o < c.length; o++) {
		const t = c.slice(o).join("."), d = Q.get(t);
		if (d) return d;
	}
	return null;
};
var Y$1 = {
	DOMAIN_TOO_SHORT: "Domain name too short.",
	DOMAIN_TOO_LONG: "Domain name too long. It should be no more than 255 chars.",
	LABEL_STARTS_WITH_DASH: "Domain name label can not start with a dash.",
	LABEL_ENDS_WITH_DASH: "Domain name label can not end with a dash.",
	LABEL_TOO_LONG: "Domain name label should be at most 63 chars long.",
	LABEL_TOO_SHORT: "Domain name label should be at least 1 character long.",
	LABEL_INVALID_CHARS: "Domain name label can only contain alphanumeric characters or dashes."
};
var Z = (e) => {
	const s = A$1.toASCII(e);
	if (s.length < 1) return "DOMAIN_TOO_SHORT";
	if (s.length > 255) return "DOMAIN_TOO_LONG";
	const c = s.split(".");
	let o;
	for (let t = 0; t < c.length; ++t) {
		if (o = c[t], !o.length) return "LABEL_TOO_SHORT";
		if (o.length > 63) return "LABEL_TOO_LONG";
		if (o.charAt(0) === "-") return "LABEL_STARTS_WITH_DASH";
		if (o.charAt(o.length - 1) === "-") return "LABEL_ENDS_WITH_DASH";
		if (!/^[a-z0-9\-_]+$/.test(o)) return "LABEL_INVALID_CHARS";
	}
};
var O$2 = (e) => {
	if (typeof e != "string") throw new TypeError("Domain name must be a string.");
	let s = e.slice(0).toLowerCase();
	s.charAt(s.length - 1) === "." && (s = s.slice(0, s.length - 1));
	const c = Z(s);
	if (c) return {
		input: e,
		error: {
			message: Y$1[c],
			code: c
		}
	};
	const o = {
		input: e,
		tld: null,
		sld: null,
		domain: null,
		subdomain: null,
		listed: !1
	}, t = s.split(".");
	if (t[t.length - 1] === "local") return o;
	const d = () => (/xn--/.test(s) && (o.domain && (o.domain = A$1.toASCII(o.domain)), o.subdomain && (o.subdomain = A$1.toASCII(o.subdomain))), o), z = X(s);
	if (!z) return t.length < 2 ? o : (o.tld = t.pop(), o.sld = t.pop(), o.domain = [o.sld, o.tld].join("."), t.length && (o.subdomain = t.pop()), d());
	o.listed = !0;
	const y = z.suffix.split("."), g = t.slice(0, t.length - y.length);
	return z.exception && g.push(y.shift()), o.tld = y.join("."), !g.length || (z.wildcard && (y.unshift(g.pop()), o.tld = y.join(".")), !g.length) || (o.sld = g.pop(), o.domain = [o.sld, o.tld].join("."), g.length && (o.subdomain = g.join("."))), d();
};
var aa = (e) => e && O$2(e).domain || null;
var oa = (e) => {
	const s = O$2(e);
	return !!(s.domain && s.listed);
};
var na = {
	parse: O$2,
	get: aa,
	isValid: oa
};
// source/utilities/remove-domain-from-dns-host.ts
var removeDomainFromDnsHost = ({ host, domain }) => {
	const rootDomain = na.parse(domain).domain;
	if (host === rootDomain) return "@";
	return host.replace(new RegExp(`.${rootDomain}\\.?$`), "");
};
// ../../node_modules/handlebars/dist/cjs/handlebars/utils.js
var require_utils = /* @__PURE__ */ __commonJSMin(((exports) => {
	exports.__esModule = true;
	exports.extend = extend;
	exports.indexOf = indexOf;
	exports.escapeExpression = escapeExpression;
	exports.isEmpty = isEmpty;
	exports.createFrame = createFrame;
	exports.blockParams = blockParams;
	exports.appendContextPath = appendContextPath;
	var escape = {
		"&": "&amp;",
		"<": "&lt;",
		">": "&gt;",
		"\"": "&quot;",
		"'": "&#x27;",
		"`": "&#x60;",
		"=": "&#x3D;"
	};
	var badChars = /[&<>"'`=]/g;
	var possible = /[&<>"'`=]/;
	function escapeChar(chr) {
		return escape[chr];
	}
	function extend(obj) {
		for (var i = 1; i < arguments.length; i++) for (var key in arguments[i]) if (Object.prototype.hasOwnProperty.call(arguments[i], key)) obj[key] = arguments[i][key];
		return obj;
	}
	var toString = Object.prototype.toString;
	exports.toString = toString;
	var isFunction = function isFunction(value) {
		return typeof value === "function";
	};
	/* istanbul ignore next */
	if (isFunction(/x/)) exports.isFunction = isFunction = function(value) {
		return typeof value === "function" && toString.call(value) === "[object Function]";
	};
	exports.isFunction = isFunction;
	/* istanbul ignore next */
	var isArray = Array.isArray || function(value) {
		return value && typeof value === "object" ? toString.call(value) === "[object Array]" : false;
	};
	exports.isArray = isArray;
	function indexOf(array, value) {
		for (var i = 0, len = array.length; i < len; i++) if (array[i] === value) return i;
		return -1;
	}
	function escapeExpression(string) {
		if (typeof string !== "string") {
			if (string && typeof string.toHTML === "function") return string.toHTML();
			else if (string == null) return "";
			else if (!string) return string + "";
			string = "" + string;
		}
		if (!possible.test(string)) return string;
		return string.replace(badChars, escapeChar);
	}
	function isEmpty(value) {
		if (!value && value !== 0) return true;
		else if (isArray(value) && value.length === 0) return true;
		else return false;
	}
	function createFrame(object) {
		var frame = extend({}, object);
		frame._parent = object;
		return frame;
	}
	function blockParams(params, ids) {
		params.path = ids;
		return params;
	}
	function appendContextPath(contextPath, id) {
		return (contextPath ? contextPath + "." : "") + id;
	}
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/exception.js
var require_exception = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	var errorProps = [
		"description",
		"fileName",
		"lineNumber",
		"endLineNumber",
		"message",
		"name",
		"number",
		"stack"
	];
	function Exception(message, node) {
		var loc = node && node.loc, line = void 0, endLineNumber = void 0, column = void 0, endColumn = void 0;
		if (loc && loc.start) {
			line = loc.start.line;
			column = loc.start.column;
			if (loc.end) {
				endLineNumber = loc.end.line;
				endColumn = loc.end.column;
			}
			message += " - " + line + ":" + column;
		}
		var tmp = Error.prototype.constructor.call(this, message);
		for (var idx = 0; idx < errorProps.length; idx++) this[errorProps[idx]] = tmp[errorProps[idx]];
		/* istanbul ignore else */
		if (Error.captureStackTrace) Error.captureStackTrace(this, Exception);
		try {
			if (loc) {
				this.lineNumber = line;
				this.endLineNumber = endLineNumber;
				/* istanbul ignore next */
				if (Object.defineProperty) {
					Object.defineProperty(this, "column", {
						value: column,
						enumerable: true
					});
					Object.defineProperty(this, "endColumn", {
						value: endColumn,
						enumerable: true
					});
				} else {
					this.column = column;
					this.endColumn = endColumn;
				}
			}
		} catch (nop) {}
	}
	Exception.prototype = /* @__PURE__ */ new Error();
	exports["default"] = Exception;
	module.exports = exports["default"];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/helpers/block-helper-missing.js
var require_block_helper_missing = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	var _utils = require_utils();
	exports["default"] = function(instance) {
		instance.registerHelper("blockHelperMissing", function(context, options) {
			var inverse = options.inverse, fn = options.fn;
			if (context === true) return fn(this);
			else if (context === false || context == null) return inverse(this);
			else if (_utils.isArray(context)) {
				if (context.length > 0) {
					if (options.ids) options.ids = [options.name];
					return instance.helpers.each(context, options);
				} else return inverse(this);
			} else {
				if (options.data && options.ids) {
					var data = _utils.createFrame(options.data);
					data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
					options = { data };
				}
				return fn(context, options);
			}
		});
	};
	module.exports = exports["default"];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/helpers/each.js
var require_each = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	// istanbul ignore next
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { "default": obj };
	}
	var _utils = require_utils();
	var _exception2 = _interopRequireDefault(require_exception());
	/**
	* Close an unfinished iterator after the block body threw, like for...of does,
	* so that generators can run their cleanup code.
	*
	* Errors thrown while closing, including by a `return` getter, are ignored:
	* the block's error is the cause and is the one the caller must see.
	*
	* @param {Iterator} iterator the iterator that was being consumed
	*/
	function closeIterator(iterator) {
		try {
			var _close = iterator["return"];
			if (_utils.isFunction(_close)) _close.call(iterator);
		} catch (closeError) {}
	}
	exports["default"] = function(instance) {
		instance.registerHelper("each", function(context, options) {
			if (!options) throw new _exception2["default"]("Must pass iterator to #each");
			var fn = options.fn, inverse = options.inverse, i = 0, ret = "", data = void 0, contextPath = void 0;
			if (options.data && options.ids) contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + ".";
			if (_utils.isFunction(context)) context = context.call(this);
			if (options.data) data = _utils.createFrame(options.data);
			function execIteration(field, index, last, value) {
				if (data) {
					data.key = field;
					data.index = index;
					data.first = index === 0;
					data.last = !!last;
					if (contextPath) data.contextPath = contextPath + field;
				}
				ret = ret + fn(value, {
					data,
					blockParams: _utils.blockParams([value, field], [contextPath + field, null])
				});
			}
			if (context && typeof context === "object") {
				if (_utils.isArray(context)) {
					for (var j = context.length; i < j; i++) if (i in context) execIteration(i, i, i === context.length - 1, context[i]);
				} else if (typeof Symbol === "function" && context[Symbol.iterator]) {
					var iterator = context[Symbol.iterator]();
					var current = iterator.next();
					while (!current.done) {
						var next = iterator.next();
						try {
							execIteration(i, i, next.done, current.value);
						} catch (e) {
							if (!next.done) closeIterator(iterator);
							throw e;
						}
						current = next;
						i++;
					}
				} else (function() {
					var priorKey = void 0;
					Object.keys(context).forEach(function(key) {
						if (priorKey !== void 0) execIteration(priorKey, i - 1, false, context[priorKey]);
						priorKey = key;
						i++;
					});
					if (priorKey !== void 0) execIteration(priorKey, i - 1, true, context[priorKey]);
				})();
			}
			if (i === 0) ret = inverse(this);
			return ret;
		});
	};
	module.exports = exports["default"];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/helpers/helper-missing.js
var require_helper_missing = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	// istanbul ignore next
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { "default": obj };
	}
	var _exception2 = _interopRequireDefault(require_exception());
	exports["default"] = function(instance) {
		instance.registerHelper("helperMissing", function() {
			if (arguments.length === 1) return;
			else throw new _exception2["default"]("Missing helper: \"" + arguments[arguments.length - 1].name + "\"");
		});
	};
	module.exports = exports["default"];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/helpers/if.js
var require_if = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	// istanbul ignore next
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { "default": obj };
	}
	var _utils = require_utils();
	var _exception2 = _interopRequireDefault(require_exception());
	exports["default"] = function(instance) {
		instance.registerHelper("if", function(conditional, options) {
			if (arguments.length != 2) throw new _exception2["default"]("#if requires exactly one argument");
			if (_utils.isFunction(conditional)) conditional = conditional.call(this);
			if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) return options.inverse(this);
			else return options.fn(this);
		});
		instance.registerHelper("unless", function(conditional, options) {
			if (arguments.length != 2) throw new _exception2["default"]("#unless requires exactly one argument");
			return instance.helpers["if"].call(this, conditional, {
				fn: options.inverse,
				inverse: options.fn,
				hash: options.hash
			});
		});
	};
	module.exports = exports["default"];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/helpers/log.js
var require_log = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	exports["default"] = function(instance) {
		instance.registerHelper("log", function() {
			var args = [void 0], options = arguments[arguments.length - 1];
			for (var i = 0; i < arguments.length - 1; i++) args.push(arguments[i]);
			var level = 1;
			if (options.hash.level != null) level = options.hash.level;
			else if (options.data && options.data.level != null) level = options.data.level;
			args[0] = level;
			instance.log.apply(instance, args);
		});
	};
	module.exports = exports["default"];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/helpers/lookup.js
var require_lookup = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	exports["default"] = function(instance) {
		instance.registerHelper("lookup", function(obj, field, options) {
			if (!obj) return obj;
			return options.lookupProperty(obj, field);
		});
	};
	module.exports = exports["default"];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/helpers/with.js
var require_with = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	// istanbul ignore next
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { "default": obj };
	}
	var _utils = require_utils();
	var _exception2 = _interopRequireDefault(require_exception());
	exports["default"] = function(instance) {
		instance.registerHelper("with", function(context, options) {
			if (arguments.length != 2) throw new _exception2["default"]("#with requires exactly one argument");
			if (_utils.isFunction(context)) context = context.call(this);
			var fn = options.fn;
			if (!_utils.isEmpty(context)) {
				var data = options.data;
				if (options.data && options.ids) {
					data = _utils.createFrame(options.data);
					data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
				}
				return fn(context, {
					data,
					blockParams: _utils.blockParams([context], [data && data.contextPath])
				});
			} else return options.inverse(this);
		});
	};
	module.exports = exports["default"];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/helpers.js
var require_helpers$1 = /* @__PURE__ */ __commonJSMin(((exports) => {
	exports.__esModule = true;
	exports.registerDefaultHelpers = registerDefaultHelpers;
	exports.moveHelperToHooks = moveHelperToHooks;
	// istanbul ignore next
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { "default": obj };
	}
	var _helpersBlockHelperMissing2 = _interopRequireDefault(require_block_helper_missing());
	var _helpersEach2 = _interopRequireDefault(require_each());
	var _helpersHelperMissing2 = _interopRequireDefault(require_helper_missing());
	var _helpersIf2 = _interopRequireDefault(require_if());
	var _helpersLog2 = _interopRequireDefault(require_log());
	var _helpersLookup2 = _interopRequireDefault(require_lookup());
	var _helpersWith2 = _interopRequireDefault(require_with());
	function registerDefaultHelpers(instance) {
		_helpersBlockHelperMissing2["default"](instance);
		_helpersEach2["default"](instance);
		_helpersHelperMissing2["default"](instance);
		_helpersIf2["default"](instance);
		_helpersLog2["default"](instance);
		_helpersLookup2["default"](instance);
		_helpersWith2["default"](instance);
	}
	function moveHelperToHooks(instance, helperName, keepHelper) {
		if (instance.helpers[helperName]) {
			instance.hooks[helperName] = instance.helpers[helperName];
			if (!keepHelper) instance.helpers[helperName] = void 0;
		}
	}
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/decorators/inline.js
var require_inline = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	var _utils = require_utils();
	exports["default"] = function(instance) {
		instance.registerDecorator("inline", function(fn, props, container, options) {
			var ret = fn;
			if (!props.partials) {
				props.partials = {};
				ret = function(context, options) {
					var original = container.partials;
					container.partials = _utils.extend({}, original, props.partials);
					var ret = fn(context, options);
					container.partials = original;
					return ret;
				};
			}
			props.partials[options.args[0]] = options.fn;
			return ret;
		});
	};
	module.exports = exports["default"];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/decorators.js
var require_decorators = /* @__PURE__ */ __commonJSMin(((exports) => {
	exports.__esModule = true;
	exports.registerDefaultDecorators = registerDefaultDecorators;
	// istanbul ignore next
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { "default": obj };
	}
	var _decoratorsInline2 = _interopRequireDefault(require_inline());
	function registerDefaultDecorators(instance) {
		_decoratorsInline2["default"](instance);
	}
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/logger.js
var require_logger = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	var _utils = require_utils();
	var logger = {
		methodMap: [
			"debug",
			"info",
			"warn",
			"error"
		],
		level: "info",
		lookupLevel: function lookupLevel(level) {
			if (typeof level === "string") {
				var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
				if (levelMap >= 0) level = levelMap;
				else level = parseInt(level, 10);
			}
			return level;
		},
		log: function log(level) {
			level = logger.lookupLevel(level);
			if (typeof console !== "undefined" && logger.lookupLevel(logger.level) <= level) {
				var method = logger.methodMap[level];
				if (!console[method]) method = "log";
				for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) message[_key - 1] = arguments[_key];
				console[method].apply(console, message);
			}
		}
	};
	exports["default"] = logger;
	module.exports = exports["default"];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/internal/proto-access.js
var require_proto_access = /* @__PURE__ */ __commonJSMin(((exports) => {
	exports.__esModule = true;
	exports.createProtoAccessControl = createProtoAccessControl;
	exports.resultIsAllowed = resultIsAllowed;
	exports.isPrototypeConstructor = isPrototypeConstructor;
	exports.resetLoggedProperties = resetLoggedProperties;
	// istanbul ignore next
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { "default": obj };
	}
	var _utils = require_utils();
	var _logger2 = _interopRequireDefault(require_logger());
	var loggedProperties = Object.create(null);
	function createProtoAccessControl(runtimeOptions) {
		var propertyWhiteList = Object.create(null);
		propertyWhiteList["__proto__"] = false;
		_utils.extend(propertyWhiteList, runtimeOptions.allowedProtoProperties);
		var methodWhiteList = Object.create(null);
		methodWhiteList["constructor"] = false;
		methodWhiteList["__defineGetter__"] = false;
		methodWhiteList["__defineSetter__"] = false;
		methodWhiteList["__lookupGetter__"] = false;
		methodWhiteList["__lookupSetter__"] = false;
		_utils.extend(methodWhiteList, runtimeOptions.allowedProtoMethods);
		return {
			properties: {
				whitelist: propertyWhiteList,
				defaultValue: runtimeOptions.allowProtoPropertiesByDefault
			},
			methods: {
				whitelist: methodWhiteList,
				defaultValue: runtimeOptions.allowProtoMethodsByDefault
			}
		};
	}
	function resultIsAllowed(result, protoAccessControl, propertyName) {
		if (typeof result === "function") return checkWhiteList(protoAccessControl.methods, propertyName);
		else return checkWhiteList(protoAccessControl.properties, propertyName);
	}
	/**
	* Detect a prototype object's own "constructor" back-reference, e.g.
	* `Function.prototype.constructor === Function`. Because "constructor" is an
	* "own" property of such objects, it would otherwise bypass the prototype-access
	* checks and expose dangerous constructors (allowing arbitrary code execution).
	*
	* Only functions can be constructors, so other values are never treated as one
	* and their `prototype` is never read.
	*
	* @param {*} parent the object the property is being read from
	* @param {string} propertyName the property being looked up
	* @param {*} result the already-resolved value of `parent[propertyName]`
	* @returns {boolean} true if the lookup resolves `parent`'s own constructor
	*/
	function isPrototypeConstructor(parent, propertyName, result) {
		return propertyName === "constructor" && typeof result === "function" && parent === result.prototype;
	}
	function checkWhiteList(protoAccessControlForType, propertyName) {
		if (protoAccessControlForType.whitelist[propertyName] !== void 0) return protoAccessControlForType.whitelist[propertyName] === true;
		if (protoAccessControlForType.defaultValue !== void 0) return protoAccessControlForType.defaultValue;
		logUnexpecedPropertyAccessOnce(propertyName);
		return false;
	}
	function logUnexpecedPropertyAccessOnce(propertyName) {
		if (loggedProperties[propertyName] !== true) {
			loggedProperties[propertyName] = true;
			_logger2["default"].log("error", "Handlebars: Access has been denied to resolve the property \"" + propertyName + "\" because it is not an \"own property\" of its parent.\nYou can add a runtime option to disable the check or this warning:\nSee https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details");
		}
	}
	function resetLoggedProperties() {
		Object.keys(loggedProperties).forEach(function(propertyName) {
			delete loggedProperties[propertyName];
		});
	}
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/base.js
var require_base$1 = /* @__PURE__ */ __commonJSMin(((exports) => {
	exports.__esModule = true;
	exports.HandlebarsEnvironment = HandlebarsEnvironment;
	// istanbul ignore next
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { "default": obj };
	}
	var _utils = require_utils();
	var _exception2 = _interopRequireDefault(require_exception());
	var _helpers = require_helpers$1();
	var _decorators = require_decorators();
	var _logger2 = _interopRequireDefault(require_logger());
	var _internalProtoAccess = require_proto_access();
	exports.VERSION = "4.7.10";
	exports.COMPILER_REVISION = 8;
	exports.LAST_COMPATIBLE_COMPILER_REVISION = 7;
	exports.REVISION_CHANGES = {
		1: "<= 1.0.rc.2",
		2: "== 1.0.0-rc.3",
		3: "== 1.0.0-rc.4",
		4: "== 1.x.x",
		5: "== 2.0.0-alpha.x",
		6: ">= 2.0.0-beta.1",
		7: ">= 4.0.0 <4.3.0",
		8: ">= 4.3.0"
	};
	var objectType = "[object Object]";
	function HandlebarsEnvironment(helpers, partials, decorators) {
		this.helpers = helpers || {};
		this.partials = partials || {};
		this.decorators = decorators || {};
		_helpers.registerDefaultHelpers(this);
		_decorators.registerDefaultDecorators(this);
	}
	HandlebarsEnvironment.prototype = {
		constructor: HandlebarsEnvironment,
		logger: _logger2["default"],
		log: _logger2["default"].log,
		registerHelper: function registerHelper(name, fn) {
			if (_utils.toString.call(name) === objectType) {
				if (fn) throw new _exception2["default"]("Arg not supported with multiple helpers");
				_utils.extend(this.helpers, name);
			} else this.helpers[name] = fn;
		},
		unregisterHelper: function unregisterHelper(name) {
			delete this.helpers[name];
		},
		registerPartial: function registerPartial(name, partial) {
			if (_utils.toString.call(name) === objectType) _utils.extend(this.partials, name);
			else {
				if (typeof partial === "undefined") throw new _exception2["default"]("Attempting to register a partial called \"" + name + "\" as undefined");
				this.partials[name] = partial;
			}
		},
		unregisterPartial: function unregisterPartial(name) {
			delete this.partials[name];
		},
		registerDecorator: function registerDecorator(name, fn) {
			if (_utils.toString.call(name) === objectType) {
				if (fn) throw new _exception2["default"]("Arg not supported with multiple decorators");
				_utils.extend(this.decorators, name);
			} else this.decorators[name] = fn;
		},
		unregisterDecorator: function unregisterDecorator(name) {
			delete this.decorators[name];
		},
		/**
		* Reset the memory of illegal property accesses that have already been logged.
		* @deprecated should only be used in handlebars test-cases
		*/
		resetLoggedPropertyAccesses: function resetLoggedPropertyAccesses() {
			_internalProtoAccess.resetLoggedProperties();
		}
	};
	exports.log = _logger2["default"].log;
	exports.createFrame = _utils.createFrame;
	exports.logger = _logger2["default"];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/safe-string.js
var require_safe_string = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	function SafeString(string) {
		this.string = string;
	}
	SafeString.prototype.toString = SafeString.prototype.toHTML = function() {
		return "" + this.string;
	};
	exports["default"] = SafeString;
	module.exports = exports["default"];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/internal/wrapHelper.js
var require_wrapHelper = /* @__PURE__ */ __commonJSMin(((exports) => {
	exports.__esModule = true;
	exports.wrapHelper = wrapHelper;
	function wrapHelper(helper, transformOptionsFn) {
		if (typeof helper !== "function") return helper;
		return function wrapper() {
			var options = arguments[arguments.length - 1];
			arguments[arguments.length - 1] = transformOptionsFn(options);
			return helper.apply(this, arguments);
		};
	}
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/runtime.js
var require_runtime = /* @__PURE__ */ __commonJSMin(((exports) => {
	exports.__esModule = true;
	exports.checkRevision = checkRevision;
	exports.template = template;
	exports.wrapProgram = wrapProgram;
	exports.resolvePartial = resolvePartial;
	exports.invokePartial = invokePartial;
	exports.noop = noop;
	// istanbul ignore next
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { "default": obj };
	}
	// istanbul ignore next
	function _interopRequireWildcard(obj) {
		if (obj && obj.__esModule) return obj;
		else {
			var newObj = {};
			if (obj != null) {
				for (var key in obj) if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
			}
			newObj["default"] = obj;
			return newObj;
		}
	}
	var Utils = _interopRequireWildcard(require_utils());
	var _exception2 = _interopRequireDefault(require_exception());
	var _base = require_base$1();
	var _helpers = require_helpers$1();
	var _internalWrapHelper = require_wrapHelper();
	var _internalProtoAccess = require_proto_access();
	function checkRevision(compilerInfo) {
		var compilerRevision = compilerInfo && compilerInfo[0] || 1, currentRevision = _base.COMPILER_REVISION;
		if (compilerRevision >= _base.LAST_COMPATIBLE_COMPILER_REVISION && compilerRevision <= _base.COMPILER_REVISION) return;
		if (compilerRevision < _base.LAST_COMPATIBLE_COMPILER_REVISION) {
			var runtimeVersions = _base.REVISION_CHANGES[currentRevision], compilerVersions = _base.REVISION_CHANGES[compilerRevision];
			throw new _exception2["default"]("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + runtimeVersions + ") or downgrade your runtime to an older version (" + compilerVersions + ").");
		} else throw new _exception2["default"]("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + compilerInfo[1] + ").");
	}
	function template(templateSpec, env) {
		/* istanbul ignore next */
		if (!env) throw new _exception2["default"]("No environment passed to template");
		if (!templateSpec || !templateSpec.main) throw new _exception2["default"]("Unknown template object: " + typeof templateSpec);
		templateSpec.main.decorator = templateSpec.main_d;
		env.VM.checkRevision(templateSpec.compiler);
		var templateWasPrecompiledWithCompilerV7 = templateSpec.compiler && templateSpec.compiler[0] === 7;
		function invokePartialWrapper(partial, context, options) {
			if (options.hash) {
				context = Utils.extend({}, context, options.hash);
				if (options.ids) options.ids[0] = true;
			}
			partial = env.VM.resolvePartial.call(this, partial, context, options);
			options.hooks = this.hooks;
			options.protoAccessControl = this.protoAccessControl;
			var result = env.VM.invokePartial.call(this, partial, context, options);
			if (result == null && Utils.isFunction(partial)) throw new _exception2["default"]("The partial " + options.name + " returned no output: partials must return a string");
			if (result == null && env.compile) {
				if (typeof partial !== "string") throw new _exception2["default"]("The partial " + options.name + " could not be compiled: partials must be strings or functions returning strings");
				options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
				result = options.partials[options.name](context, options);
			}
			if (result != null) {
				if (options.indent) {
					var lines = result.split("\n");
					for (var i = 0, l = lines.length; i < l; i++) {
						if (!lines[i] && i + 1 === l) break;
						lines[i] = options.indent + lines[i];
					}
					result = lines.join("\n");
				}
				return result;
			} else throw new _exception2["default"]("The partial " + options.name + " could not be compiled when running in runtime-only mode");
		}
		var container = {
			strict: function strict(obj, name, loc) {
				if (!obj || !(name in obj)) throw new _exception2["default"]("\"" + name + "\" not defined in " + obj, { loc });
				return container.lookupProperty(obj, name);
			},
			lookupProperty: function lookupProperty(parent, propertyName) {
				var result = parent[propertyName];
				if (result == null) return result;
				if (Object.prototype.hasOwnProperty.call(parent, propertyName) && !_internalProtoAccess.isPrototypeConstructor(parent, propertyName, result)) return result;
				if (_internalProtoAccess.resultIsAllowed(result, container.protoAccessControl, propertyName)) return result;
			},
			lookup: function lookup(depths, name) {
				var len = depths.length;
				for (var i = 0; i < len; i++) {
					var result = depths[i] && container.lookupProperty(depths[i], name);
					if (result != null) return result;
				}
			},
			lambda: function lambda(current, context) {
				return typeof current === "function" ? current.call(context) : current;
			},
			escapeExpression: Utils.escapeExpression,
			invokePartial: invokePartialWrapper,
			fn: function fn(i) {
				var ret = templateSpec[i];
				ret.decorator = templateSpec[i + "_d"];
				return ret;
			},
			programs: [],
			program: function program(i, data, declaredBlockParams, blockParams, depths) {
				var programWrapper = this.programs[i], fn = this.fn(i);
				if (data || depths || blockParams || declaredBlockParams) programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
				else if (!programWrapper) programWrapper = this.programs[i] = wrapProgram(this, i, fn);
				return programWrapper;
			},
			data: function data(value, depth) {
				while (value && depth--) value = value._parent;
				return value;
			},
			mergeIfNeeded: function mergeIfNeeded(param, common) {
				var obj = param || common;
				if (param && common && param !== common) obj = Utils.extend({}, common, param);
				return obj;
			},
			nullContext: Object.seal({}),
			noop: env.VM.noop,
			compilerInfo: templateSpec.compiler
		};
		function ret(context) {
			var options = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1];
			var data = options.data;
			ret._setup(options);
			if (!options.partial && templateSpec.useData) data = initData(context, data);
			var depths = void 0, blockParams = templateSpec.useBlockParams ? [] : void 0;
			if (templateSpec.useDepths) {
				if (options.depths) depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
				else depths = [context];
			}
			function main(context) {
				return "" + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
			}
			main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
			return main(context, options);
		}
		ret.isTop = true;
		ret._setup = function(options) {
			if (!options.partial) {
				var mergedHelpers = {};
				addHelpers(mergedHelpers, env.helpers, container);
				addHelpers(mergedHelpers, options.helpers, container);
				container.helpers = mergedHelpers;
				if (templateSpec.usePartial) container.partials = container.mergeIfNeeded(options.partials, env.partials);
				if (templateSpec.usePartial || templateSpec.useDecorators) container.decorators = Utils.extend({}, env.decorators, options.decorators);
				container.hooks = {};
				container.protoAccessControl = _internalProtoAccess.createProtoAccessControl(options);
				var keepHelperInHelpers = options.allowCallsToHelperMissing || templateWasPrecompiledWithCompilerV7;
				_helpers.moveHelperToHooks(container, "helperMissing", keepHelperInHelpers);
				_helpers.moveHelperToHooks(container, "blockHelperMissing", keepHelperInHelpers);
			} else {
				container.protoAccessControl = options.protoAccessControl;
				container.helpers = options.helpers;
				container.partials = options.partials;
				container.decorators = options.decorators;
				container.hooks = options.hooks;
			}
		};
		ret._child = function(i, data, blockParams, depths) {
			if (templateSpec.useBlockParams && !blockParams) throw new _exception2["default"]("must pass block params");
			if (templateSpec.useDepths && !depths) throw new _exception2["default"]("must pass parent depths");
			return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
		};
		return ret;
	}
	function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
		function prog(context) {
			var options = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1];
			var currentDepths = depths;
			if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) currentDepths = [context].concat(depths);
			return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
		}
		prog = executeDecorators(fn, prog, container, depths, data, blockParams);
		prog.program = i;
		prog.depth = depths ? depths.length : 0;
		prog.blockParams = declaredBlockParams || 0;
		return prog;
	}
	/**
	* This is currently part of the official API, therefore implementation details should not be changed.
	*/
	function resolvePartial(partial, context, options) {
		if (!partial) {
			if (options.name === "@partial-block") partial = lookupOwnProperty(options.data, "partial-block");
			else partial = lookupOwnProperty(options.partials, options.name);
		} else if (typeof partial !== "function" && !options.name) {
			options.name = partial;
			partial = lookupOwnProperty(options.partials, partial);
		}
		return partial;
	}
	function invokePartial(partial, context, options) {
		var currentPartialBlock = lookupOwnProperty(options.data, "partial-block");
		options.partial = true;
		if (options.ids) options.data.contextPath = options.ids[0] || options.data.contextPath;
		var partialBlock = void 0;
		if (options.fn && options.fn !== noop) (function() {
			options.data = _base.createFrame(options.data);
			var fn = options.fn;
			partialBlock = options.data["partial-block"] = function partialBlockWrapper(context) {
				var options = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1];
				options.data = _base.createFrame(options.data);
				options.data["partial-block"] = currentPartialBlock;
				return fn(context, options);
			};
			if (fn.partials) options.partials = Utils.extend({}, options.partials, fn.partials);
		})();
		if (partial === void 0 && partialBlock) partial = partialBlock;
		if (partial === void 0) throw new _exception2["default"]("The partial " + options.name + " could not be found");
		else if (partial instanceof Function) return partial(context, options);
	}
	function noop() {
		return "";
	}
	function lookupOwnProperty(obj, name) {
		if (obj && Object.prototype.hasOwnProperty.call(obj, name)) return obj[name];
	}
	function initData(context, data) {
		if (!data || !("root" in data)) {
			data = data ? _base.createFrame(data) : {};
			data.root = context;
		}
		return data;
	}
	function executeDecorators(fn, prog, container, depths, data, blockParams) {
		if (fn.decorator) {
			var props = {};
			prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
			Utils.extend(prog, props);
		}
		return prog;
	}
	function addHelpers(mergedHelpers, helpers, container) {
		if (!helpers) return;
		Object.keys(helpers).forEach(function(helperName) {
			var helper = helpers[helperName];
			mergedHelpers[helperName] = passLookupPropertyOption(helper, container);
		});
	}
	function passLookupPropertyOption(helper, container) {
		var lookupProperty = container.lookupProperty;
		return _internalWrapHelper.wrapHelper(helper, function(options) {
			options.lookupProperty = lookupProperty;
			return options;
		});
	}
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/no-conflict.js
var require_no_conflict = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	exports["default"] = function(Handlebars) {
		/* istanbul ignore next */
		(function() {
			if (typeof globalThis === "object") return;
			Object.prototype.__defineGetter__("__magic__", function() {
				return this;
			});
			__magic__.globalThis = __magic__;
			delete Object.prototype.__magic__;
		})();
		var $Handlebars = globalThis.Handlebars;
		/* istanbul ignore next */
		Handlebars.noConflict = function() {
			if (globalThis.Handlebars === Handlebars) globalThis.Handlebars = $Handlebars;
			return Handlebars;
		};
	};
	module.exports = exports["default"];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars.runtime.js
var require_handlebars_runtime = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	// istanbul ignore next
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { "default": obj };
	}
	// istanbul ignore next
	function _interopRequireWildcard(obj) {
		if (obj && obj.__esModule) return obj;
		else {
			var newObj = {};
			if (obj != null) {
				for (var key in obj) if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
			}
			newObj["default"] = obj;
			return newObj;
		}
	}
	var base = _interopRequireWildcard(require_base$1());
	var _handlebarsSafeString2 = _interopRequireDefault(require_safe_string());
	var _handlebarsException2 = _interopRequireDefault(require_exception());
	var Utils = _interopRequireWildcard(require_utils());
	var runtime = _interopRequireWildcard(require_runtime());
	var _handlebarsNoConflict2 = _interopRequireDefault(require_no_conflict());
	function create() {
		var hb = new base.HandlebarsEnvironment();
		Utils.extend(hb, base);
		hb.SafeString = _handlebarsSafeString2["default"];
		hb.Exception = _handlebarsException2["default"];
		hb.Utils = Utils;
		hb.escapeExpression = Utils.escapeExpression;
		hb.VM = runtime;
		hb.template = function(spec) {
			return runtime.template(spec, hb);
		};
		return hb;
	}
	var inst = create();
	inst.create = create;
	_handlebarsNoConflict2["default"](inst);
	inst["default"] = inst;
	exports["default"] = inst;
	module.exports = exports["default"];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/compiler/ast.js
var require_ast = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	var AST = { helpers: {
		helperExpression: function helperExpression(node) {
			return node.type === "SubExpression" || (node.type === "MustacheStatement" || node.type === "BlockStatement") && !!(node.params && node.params.length || node.hash);
		},
		scopedId: function scopedId(path) {
			return /^\.|this\b/.test(path.original);
		},
		simpleId: function simpleId(path) {
			return path.parts.length === 1 && !AST.helpers.scopedId(path) && !path.depth;
		}
	} };
	exports["default"] = AST;
	module.exports = exports["default"];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/compiler/parser.js
var require_parser = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	exports["default"] = (function() {
		var parser = {
			trace: function trace() {},
			yy: {},
			symbols_: {
				"error": 2,
				"root": 3,
				"program": 4,
				"EOF": 5,
				"program_repetition0": 6,
				"statement": 7,
				"mustache": 8,
				"block": 9,
				"rawBlock": 10,
				"partial": 11,
				"partialBlock": 12,
				"content": 13,
				"COMMENT": 14,
				"CONTENT": 15,
				"openRawBlock": 16,
				"rawBlock_repetition0": 17,
				"END_RAW_BLOCK": 18,
				"OPEN_RAW_BLOCK": 19,
				"helperName": 20,
				"openRawBlock_repetition0": 21,
				"openRawBlock_option0": 22,
				"CLOSE_RAW_BLOCK": 23,
				"openBlock": 24,
				"block_option0": 25,
				"closeBlock": 26,
				"openInverse": 27,
				"block_option1": 28,
				"OPEN_BLOCK": 29,
				"openBlock_repetition0": 30,
				"openBlock_option0": 31,
				"openBlock_option1": 32,
				"CLOSE": 33,
				"OPEN_INVERSE": 34,
				"openInverse_repetition0": 35,
				"openInverse_option0": 36,
				"openInverse_option1": 37,
				"openInverseChain": 38,
				"OPEN_INVERSE_CHAIN": 39,
				"openInverseChain_repetition0": 40,
				"openInverseChain_option0": 41,
				"openInverseChain_option1": 42,
				"inverseAndProgram": 43,
				"INVERSE": 44,
				"inverseChain": 45,
				"inverseChain_option0": 46,
				"OPEN_ENDBLOCK": 47,
				"OPEN": 48,
				"mustache_repetition0": 49,
				"mustache_option0": 50,
				"OPEN_UNESCAPED": 51,
				"mustache_repetition1": 52,
				"mustache_option1": 53,
				"CLOSE_UNESCAPED": 54,
				"OPEN_PARTIAL": 55,
				"partialName": 56,
				"partial_repetition0": 57,
				"partial_option0": 58,
				"openPartialBlock": 59,
				"OPEN_PARTIAL_BLOCK": 60,
				"openPartialBlock_repetition0": 61,
				"openPartialBlock_option0": 62,
				"param": 63,
				"sexpr": 64,
				"OPEN_SEXPR": 65,
				"sexpr_repetition0": 66,
				"sexpr_option0": 67,
				"CLOSE_SEXPR": 68,
				"hash": 69,
				"hash_repetition_plus0": 70,
				"hashSegment": 71,
				"ID": 72,
				"EQUALS": 73,
				"blockParams": 74,
				"OPEN_BLOCK_PARAMS": 75,
				"blockParams_repetition_plus0": 76,
				"CLOSE_BLOCK_PARAMS": 77,
				"path": 78,
				"dataName": 79,
				"STRING": 80,
				"NUMBER": 81,
				"BOOLEAN": 82,
				"UNDEFINED": 83,
				"NULL": 84,
				"DATA": 85,
				"pathSegments": 86,
				"SEP": 87,
				"$accept": 0,
				"$end": 1
			},
			terminals_: {
				2: "error",
				5: "EOF",
				14: "COMMENT",
				15: "CONTENT",
				18: "END_RAW_BLOCK",
				19: "OPEN_RAW_BLOCK",
				23: "CLOSE_RAW_BLOCK",
				29: "OPEN_BLOCK",
				33: "CLOSE",
				34: "OPEN_INVERSE",
				39: "OPEN_INVERSE_CHAIN",
				44: "INVERSE",
				47: "OPEN_ENDBLOCK",
				48: "OPEN",
				51: "OPEN_UNESCAPED",
				54: "CLOSE_UNESCAPED",
				55: "OPEN_PARTIAL",
				60: "OPEN_PARTIAL_BLOCK",
				65: "OPEN_SEXPR",
				68: "CLOSE_SEXPR",
				72: "ID",
				73: "EQUALS",
				75: "OPEN_BLOCK_PARAMS",
				77: "CLOSE_BLOCK_PARAMS",
				80: "STRING",
				81: "NUMBER",
				82: "BOOLEAN",
				83: "UNDEFINED",
				84: "NULL",
				85: "DATA",
				87: "SEP"
			},
			productions_: [
				0,
				[3, 2],
				[4, 1],
				[7, 1],
				[7, 1],
				[7, 1],
				[7, 1],
				[7, 1],
				[7, 1],
				[7, 1],
				[13, 1],
				[10, 3],
				[16, 5],
				[9, 4],
				[9, 4],
				[24, 6],
				[27, 6],
				[38, 6],
				[43, 2],
				[45, 3],
				[45, 1],
				[26, 3],
				[8, 5],
				[8, 5],
				[11, 5],
				[12, 3],
				[59, 5],
				[63, 1],
				[63, 1],
				[64, 5],
				[69, 1],
				[71, 3],
				[74, 3],
				[20, 1],
				[20, 1],
				[20, 1],
				[20, 1],
				[20, 1],
				[20, 1],
				[20, 1],
				[56, 1],
				[56, 1],
				[79, 2],
				[78, 1],
				[86, 3],
				[86, 1],
				[6, 0],
				[6, 2],
				[17, 0],
				[17, 2],
				[21, 0],
				[21, 2],
				[22, 0],
				[22, 1],
				[25, 0],
				[25, 1],
				[28, 0],
				[28, 1],
				[30, 0],
				[30, 2],
				[31, 0],
				[31, 1],
				[32, 0],
				[32, 1],
				[35, 0],
				[35, 2],
				[36, 0],
				[36, 1],
				[37, 0],
				[37, 1],
				[40, 0],
				[40, 2],
				[41, 0],
				[41, 1],
				[42, 0],
				[42, 1],
				[46, 0],
				[46, 1],
				[49, 0],
				[49, 2],
				[50, 0],
				[50, 1],
				[52, 0],
				[52, 2],
				[53, 0],
				[53, 1],
				[57, 0],
				[57, 2],
				[58, 0],
				[58, 1],
				[61, 0],
				[61, 2],
				[62, 0],
				[62, 1],
				[66, 0],
				[66, 2],
				[67, 0],
				[67, 1],
				[70, 1],
				[70, 2],
				[76, 1],
				[76, 2]
			],
			performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$) {
				var $0 = $$.length - 1;
				switch (yystate) {
					case 1: return $$[$0 - 1];
					case 2:
						this.$ = yy.prepareProgram($$[$0]);
						break;
					case 3:
						this.$ = $$[$0];
						break;
					case 4:
						this.$ = $$[$0];
						break;
					case 5:
						this.$ = $$[$0];
						break;
					case 6:
						this.$ = $$[$0];
						break;
					case 7:
						this.$ = $$[$0];
						break;
					case 8:
						this.$ = $$[$0];
						break;
					case 9:
						this.$ = {
							type: "CommentStatement",
							value: yy.stripComment($$[$0]),
							strip: yy.stripFlags($$[$0], $$[$0]),
							loc: yy.locInfo(this._$)
						};
						break;
					case 10:
						this.$ = {
							type: "ContentStatement",
							original: $$[$0],
							value: $$[$0],
							loc: yy.locInfo(this._$)
						};
						break;
					case 11:
						this.$ = yy.prepareRawBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
						break;
					case 12:
						this.$ = {
							path: $$[$0 - 3],
							params: $$[$0 - 2],
							hash: $$[$0 - 1]
						};
						break;
					case 13:
						this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], false, this._$);
						break;
					case 14:
						this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], true, this._$);
						break;
					case 15:
						this.$ = {
							open: $$[$0 - 5],
							path: $$[$0 - 4],
							params: $$[$0 - 3],
							hash: $$[$0 - 2],
							blockParams: $$[$0 - 1],
							strip: yy.stripFlags($$[$0 - 5], $$[$0])
						};
						break;
					case 16:
						this.$ = {
							path: $$[$0 - 4],
							params: $$[$0 - 3],
							hash: $$[$0 - 2],
							blockParams: $$[$0 - 1],
							strip: yy.stripFlags($$[$0 - 5], $$[$0])
						};
						break;
					case 17:
						this.$ = {
							path: $$[$0 - 4],
							params: $$[$0 - 3],
							hash: $$[$0 - 2],
							blockParams: $$[$0 - 1],
							strip: yy.stripFlags($$[$0 - 5], $$[$0])
						};
						break;
					case 18:
						this.$ = {
							strip: yy.stripFlags($$[$0 - 1], $$[$0 - 1]),
							program: $$[$0]
						};
						break;
					case 19:
						var inverse = yy.prepareBlock($$[$0 - 2], $$[$0 - 1], $$[$0], $$[$0], false, this._$), program = yy.prepareProgram([inverse], $$[$0 - 1].loc);
						program.chained = true;
						this.$ = {
							strip: $$[$0 - 2].strip,
							program,
							chain: true
						};
						break;
					case 20:
						this.$ = $$[$0];
						break;
					case 21:
						this.$ = {
							path: $$[$0 - 1],
							strip: yy.stripFlags($$[$0 - 2], $$[$0])
						};
						break;
					case 22:
						this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
						break;
					case 23:
						this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
						break;
					case 24:
						this.$ = {
							type: "PartialStatement",
							name: $$[$0 - 3],
							params: $$[$0 - 2],
							hash: $$[$0 - 1],
							indent: "",
							strip: yy.stripFlags($$[$0 - 4], $$[$0]),
							loc: yy.locInfo(this._$)
						};
						break;
					case 25:
						this.$ = yy.preparePartialBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
						break;
					case 26:
						this.$ = {
							path: $$[$0 - 3],
							params: $$[$0 - 2],
							hash: $$[$0 - 1],
							strip: yy.stripFlags($$[$0 - 4], $$[$0])
						};
						break;
					case 27:
						this.$ = $$[$0];
						break;
					case 28:
						this.$ = $$[$0];
						break;
					case 29:
						this.$ = {
							type: "SubExpression",
							path: $$[$0 - 3],
							params: $$[$0 - 2],
							hash: $$[$0 - 1],
							loc: yy.locInfo(this._$)
						};
						break;
					case 30:
						this.$ = {
							type: "Hash",
							pairs: $$[$0],
							loc: yy.locInfo(this._$)
						};
						break;
					case 31:
						this.$ = {
							type: "HashPair",
							key: yy.id($$[$0 - 2]),
							value: $$[$0],
							loc: yy.locInfo(this._$)
						};
						break;
					case 32:
						this.$ = yy.id($$[$0 - 1]);
						break;
					case 33:
						this.$ = $$[$0];
						break;
					case 34:
						this.$ = $$[$0];
						break;
					case 35:
						this.$ = {
							type: "StringLiteral",
							value: $$[$0],
							original: $$[$0],
							loc: yy.locInfo(this._$)
						};
						break;
					case 36:
						this.$ = {
							type: "NumberLiteral",
							value: Number($$[$0]),
							original: Number($$[$0]),
							loc: yy.locInfo(this._$)
						};
						break;
					case 37:
						this.$ = {
							type: "BooleanLiteral",
							value: $$[$0] === "true",
							original: $$[$0] === "true",
							loc: yy.locInfo(this._$)
						};
						break;
					case 38:
						this.$ = {
							type: "UndefinedLiteral",
							original: void 0,
							value: void 0,
							loc: yy.locInfo(this._$)
						};
						break;
					case 39:
						this.$ = {
							type: "NullLiteral",
							original: null,
							value: null,
							loc: yy.locInfo(this._$)
						};
						break;
					case 40:
						this.$ = $$[$0];
						break;
					case 41:
						this.$ = $$[$0];
						break;
					case 42:
						this.$ = yy.preparePath(true, $$[$0], this._$);
						break;
					case 43:
						this.$ = yy.preparePath(false, $$[$0], this._$);
						break;
					case 44:
						$$[$0 - 2].push({
							part: yy.id($$[$0]),
							original: $$[$0],
							separator: $$[$0 - 1]
						});
						this.$ = $$[$0 - 2];
						break;
					case 45:
						this.$ = [{
							part: yy.id($$[$0]),
							original: $$[$0]
						}];
						break;
					case 46:
						this.$ = [];
						break;
					case 47:
						$$[$0 - 1].push($$[$0]);
						break;
					case 48:
						this.$ = [];
						break;
					case 49:
						$$[$0 - 1].push($$[$0]);
						break;
					case 50:
						this.$ = [];
						break;
					case 51:
						$$[$0 - 1].push($$[$0]);
						break;
					case 58:
						this.$ = [];
						break;
					case 59:
						$$[$0 - 1].push($$[$0]);
						break;
					case 64:
						this.$ = [];
						break;
					case 65:
						$$[$0 - 1].push($$[$0]);
						break;
					case 70:
						this.$ = [];
						break;
					case 71:
						$$[$0 - 1].push($$[$0]);
						break;
					case 78:
						this.$ = [];
						break;
					case 79:
						$$[$0 - 1].push($$[$0]);
						break;
					case 82:
						this.$ = [];
						break;
					case 83:
						$$[$0 - 1].push($$[$0]);
						break;
					case 86:
						this.$ = [];
						break;
					case 87:
						$$[$0 - 1].push($$[$0]);
						break;
					case 90:
						this.$ = [];
						break;
					case 91:
						$$[$0 - 1].push($$[$0]);
						break;
					case 94:
						this.$ = [];
						break;
					case 95:
						$$[$0 - 1].push($$[$0]);
						break;
					case 98:
						this.$ = [$$[$0]];
						break;
					case 99:
						$$[$0 - 1].push($$[$0]);
						break;
					case 100:
						this.$ = [$$[$0]];
						break;
					case 101: $$[$0 - 1].push($$[$0]);
				}
			},
			table: [
				{
					3: 1,
					4: 2,
					5: [2, 46],
					6: 3,
					14: [2, 46],
					15: [2, 46],
					19: [2, 46],
					29: [2, 46],
					34: [2, 46],
					48: [2, 46],
					51: [2, 46],
					55: [2, 46],
					60: [2, 46]
				},
				{ 1: [3] },
				{ 5: [1, 4] },
				{
					5: [2, 2],
					7: 5,
					8: 6,
					9: 7,
					10: 8,
					11: 9,
					12: 10,
					13: 11,
					14: [1, 12],
					15: [1, 20],
					16: 17,
					19: [1, 23],
					24: 15,
					27: 16,
					29: [1, 21],
					34: [1, 22],
					39: [2, 2],
					44: [2, 2],
					47: [2, 2],
					48: [1, 13],
					51: [1, 14],
					55: [1, 18],
					59: 19,
					60: [1, 24]
				},
				{ 1: [2, 1] },
				{
					5: [2, 47],
					14: [2, 47],
					15: [2, 47],
					19: [2, 47],
					29: [2, 47],
					34: [2, 47],
					39: [2, 47],
					44: [2, 47],
					47: [2, 47],
					48: [2, 47],
					51: [2, 47],
					55: [2, 47],
					60: [2, 47]
				},
				{
					5: [2, 3],
					14: [2, 3],
					15: [2, 3],
					19: [2, 3],
					29: [2, 3],
					34: [2, 3],
					39: [2, 3],
					44: [2, 3],
					47: [2, 3],
					48: [2, 3],
					51: [2, 3],
					55: [2, 3],
					60: [2, 3]
				},
				{
					5: [2, 4],
					14: [2, 4],
					15: [2, 4],
					19: [2, 4],
					29: [2, 4],
					34: [2, 4],
					39: [2, 4],
					44: [2, 4],
					47: [2, 4],
					48: [2, 4],
					51: [2, 4],
					55: [2, 4],
					60: [2, 4]
				},
				{
					5: [2, 5],
					14: [2, 5],
					15: [2, 5],
					19: [2, 5],
					29: [2, 5],
					34: [2, 5],
					39: [2, 5],
					44: [2, 5],
					47: [2, 5],
					48: [2, 5],
					51: [2, 5],
					55: [2, 5],
					60: [2, 5]
				},
				{
					5: [2, 6],
					14: [2, 6],
					15: [2, 6],
					19: [2, 6],
					29: [2, 6],
					34: [2, 6],
					39: [2, 6],
					44: [2, 6],
					47: [2, 6],
					48: [2, 6],
					51: [2, 6],
					55: [2, 6],
					60: [2, 6]
				},
				{
					5: [2, 7],
					14: [2, 7],
					15: [2, 7],
					19: [2, 7],
					29: [2, 7],
					34: [2, 7],
					39: [2, 7],
					44: [2, 7],
					47: [2, 7],
					48: [2, 7],
					51: [2, 7],
					55: [2, 7],
					60: [2, 7]
				},
				{
					5: [2, 8],
					14: [2, 8],
					15: [2, 8],
					19: [2, 8],
					29: [2, 8],
					34: [2, 8],
					39: [2, 8],
					44: [2, 8],
					47: [2, 8],
					48: [2, 8],
					51: [2, 8],
					55: [2, 8],
					60: [2, 8]
				},
				{
					5: [2, 9],
					14: [2, 9],
					15: [2, 9],
					19: [2, 9],
					29: [2, 9],
					34: [2, 9],
					39: [2, 9],
					44: [2, 9],
					47: [2, 9],
					48: [2, 9],
					51: [2, 9],
					55: [2, 9],
					60: [2, 9]
				},
				{
					20: 25,
					72: [1, 35],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{
					20: 36,
					72: [1, 35],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{
					4: 37,
					6: 3,
					14: [2, 46],
					15: [2, 46],
					19: [2, 46],
					29: [2, 46],
					34: [2, 46],
					39: [2, 46],
					44: [2, 46],
					47: [2, 46],
					48: [2, 46],
					51: [2, 46],
					55: [2, 46],
					60: [2, 46]
				},
				{
					4: 38,
					6: 3,
					14: [2, 46],
					15: [2, 46],
					19: [2, 46],
					29: [2, 46],
					34: [2, 46],
					44: [2, 46],
					47: [2, 46],
					48: [2, 46],
					51: [2, 46],
					55: [2, 46],
					60: [2, 46]
				},
				{
					15: [2, 48],
					17: 39,
					18: [2, 48]
				},
				{
					20: 41,
					56: 40,
					64: 42,
					65: [1, 43],
					72: [1, 35],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{
					4: 44,
					6: 3,
					14: [2, 46],
					15: [2, 46],
					19: [2, 46],
					29: [2, 46],
					34: [2, 46],
					47: [2, 46],
					48: [2, 46],
					51: [2, 46],
					55: [2, 46],
					60: [2, 46]
				},
				{
					5: [2, 10],
					14: [2, 10],
					15: [2, 10],
					18: [2, 10],
					19: [2, 10],
					29: [2, 10],
					34: [2, 10],
					39: [2, 10],
					44: [2, 10],
					47: [2, 10],
					48: [2, 10],
					51: [2, 10],
					55: [2, 10],
					60: [2, 10]
				},
				{
					20: 45,
					72: [1, 35],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{
					20: 46,
					72: [1, 35],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{
					20: 47,
					72: [1, 35],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{
					20: 41,
					56: 48,
					64: 42,
					65: [1, 43],
					72: [1, 35],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{
					33: [2, 78],
					49: 49,
					65: [2, 78],
					72: [2, 78],
					80: [2, 78],
					81: [2, 78],
					82: [2, 78],
					83: [2, 78],
					84: [2, 78],
					85: [2, 78]
				},
				{
					23: [2, 33],
					33: [2, 33],
					54: [2, 33],
					65: [2, 33],
					68: [2, 33],
					72: [2, 33],
					75: [2, 33],
					80: [2, 33],
					81: [2, 33],
					82: [2, 33],
					83: [2, 33],
					84: [2, 33],
					85: [2, 33]
				},
				{
					23: [2, 34],
					33: [2, 34],
					54: [2, 34],
					65: [2, 34],
					68: [2, 34],
					72: [2, 34],
					75: [2, 34],
					80: [2, 34],
					81: [2, 34],
					82: [2, 34],
					83: [2, 34],
					84: [2, 34],
					85: [2, 34]
				},
				{
					23: [2, 35],
					33: [2, 35],
					54: [2, 35],
					65: [2, 35],
					68: [2, 35],
					72: [2, 35],
					75: [2, 35],
					80: [2, 35],
					81: [2, 35],
					82: [2, 35],
					83: [2, 35],
					84: [2, 35],
					85: [2, 35]
				},
				{
					23: [2, 36],
					33: [2, 36],
					54: [2, 36],
					65: [2, 36],
					68: [2, 36],
					72: [2, 36],
					75: [2, 36],
					80: [2, 36],
					81: [2, 36],
					82: [2, 36],
					83: [2, 36],
					84: [2, 36],
					85: [2, 36]
				},
				{
					23: [2, 37],
					33: [2, 37],
					54: [2, 37],
					65: [2, 37],
					68: [2, 37],
					72: [2, 37],
					75: [2, 37],
					80: [2, 37],
					81: [2, 37],
					82: [2, 37],
					83: [2, 37],
					84: [2, 37],
					85: [2, 37]
				},
				{
					23: [2, 38],
					33: [2, 38],
					54: [2, 38],
					65: [2, 38],
					68: [2, 38],
					72: [2, 38],
					75: [2, 38],
					80: [2, 38],
					81: [2, 38],
					82: [2, 38],
					83: [2, 38],
					84: [2, 38],
					85: [2, 38]
				},
				{
					23: [2, 39],
					33: [2, 39],
					54: [2, 39],
					65: [2, 39],
					68: [2, 39],
					72: [2, 39],
					75: [2, 39],
					80: [2, 39],
					81: [2, 39],
					82: [2, 39],
					83: [2, 39],
					84: [2, 39],
					85: [2, 39]
				},
				{
					23: [2, 43],
					33: [2, 43],
					54: [2, 43],
					65: [2, 43],
					68: [2, 43],
					72: [2, 43],
					75: [2, 43],
					80: [2, 43],
					81: [2, 43],
					82: [2, 43],
					83: [2, 43],
					84: [2, 43],
					85: [2, 43],
					87: [1, 50]
				},
				{
					72: [1, 35],
					86: 51
				},
				{
					23: [2, 45],
					33: [2, 45],
					54: [2, 45],
					65: [2, 45],
					68: [2, 45],
					72: [2, 45],
					75: [2, 45],
					80: [2, 45],
					81: [2, 45],
					82: [2, 45],
					83: [2, 45],
					84: [2, 45],
					85: [2, 45],
					87: [2, 45]
				},
				{
					52: 52,
					54: [2, 82],
					65: [2, 82],
					72: [2, 82],
					80: [2, 82],
					81: [2, 82],
					82: [2, 82],
					83: [2, 82],
					84: [2, 82],
					85: [2, 82]
				},
				{
					25: 53,
					38: 55,
					39: [1, 57],
					43: 56,
					44: [1, 58],
					45: 54,
					47: [2, 54]
				},
				{
					28: 59,
					43: 60,
					44: [1, 58],
					47: [2, 56]
				},
				{
					13: 62,
					15: [1, 20],
					18: [1, 61]
				},
				{
					33: [2, 86],
					57: 63,
					65: [2, 86],
					72: [2, 86],
					80: [2, 86],
					81: [2, 86],
					82: [2, 86],
					83: [2, 86],
					84: [2, 86],
					85: [2, 86]
				},
				{
					33: [2, 40],
					65: [2, 40],
					72: [2, 40],
					80: [2, 40],
					81: [2, 40],
					82: [2, 40],
					83: [2, 40],
					84: [2, 40],
					85: [2, 40]
				},
				{
					33: [2, 41],
					65: [2, 41],
					72: [2, 41],
					80: [2, 41],
					81: [2, 41],
					82: [2, 41],
					83: [2, 41],
					84: [2, 41],
					85: [2, 41]
				},
				{
					20: 64,
					72: [1, 35],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{
					26: 65,
					47: [1, 66]
				},
				{
					30: 67,
					33: [2, 58],
					65: [2, 58],
					72: [2, 58],
					75: [2, 58],
					80: [2, 58],
					81: [2, 58],
					82: [2, 58],
					83: [2, 58],
					84: [2, 58],
					85: [2, 58]
				},
				{
					33: [2, 64],
					35: 68,
					65: [2, 64],
					72: [2, 64],
					75: [2, 64],
					80: [2, 64],
					81: [2, 64],
					82: [2, 64],
					83: [2, 64],
					84: [2, 64],
					85: [2, 64]
				},
				{
					21: 69,
					23: [2, 50],
					65: [2, 50],
					72: [2, 50],
					80: [2, 50],
					81: [2, 50],
					82: [2, 50],
					83: [2, 50],
					84: [2, 50],
					85: [2, 50]
				},
				{
					33: [2, 90],
					61: 70,
					65: [2, 90],
					72: [2, 90],
					80: [2, 90],
					81: [2, 90],
					82: [2, 90],
					83: [2, 90],
					84: [2, 90],
					85: [2, 90]
				},
				{
					20: 74,
					33: [2, 80],
					50: 71,
					63: 72,
					64: 75,
					65: [1, 43],
					69: 73,
					70: 76,
					71: 77,
					72: [1, 78],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{ 72: [1, 79] },
				{
					23: [2, 42],
					33: [2, 42],
					54: [2, 42],
					65: [2, 42],
					68: [2, 42],
					72: [2, 42],
					75: [2, 42],
					80: [2, 42],
					81: [2, 42],
					82: [2, 42],
					83: [2, 42],
					84: [2, 42],
					85: [2, 42],
					87: [1, 50]
				},
				{
					20: 74,
					53: 80,
					54: [2, 84],
					63: 81,
					64: 75,
					65: [1, 43],
					69: 82,
					70: 76,
					71: 77,
					72: [1, 78],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{
					26: 83,
					47: [1, 66]
				},
				{ 47: [2, 55] },
				{
					4: 84,
					6: 3,
					14: [2, 46],
					15: [2, 46],
					19: [2, 46],
					29: [2, 46],
					34: [2, 46],
					39: [2, 46],
					44: [2, 46],
					47: [2, 46],
					48: [2, 46],
					51: [2, 46],
					55: [2, 46],
					60: [2, 46]
				},
				{ 47: [2, 20] },
				{
					20: 85,
					72: [1, 35],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{
					4: 86,
					6: 3,
					14: [2, 46],
					15: [2, 46],
					19: [2, 46],
					29: [2, 46],
					34: [2, 46],
					47: [2, 46],
					48: [2, 46],
					51: [2, 46],
					55: [2, 46],
					60: [2, 46]
				},
				{
					26: 87,
					47: [1, 66]
				},
				{ 47: [2, 57] },
				{
					5: [2, 11],
					14: [2, 11],
					15: [2, 11],
					19: [2, 11],
					29: [2, 11],
					34: [2, 11],
					39: [2, 11],
					44: [2, 11],
					47: [2, 11],
					48: [2, 11],
					51: [2, 11],
					55: [2, 11],
					60: [2, 11]
				},
				{
					15: [2, 49],
					18: [2, 49]
				},
				{
					20: 74,
					33: [2, 88],
					58: 88,
					63: 89,
					64: 75,
					65: [1, 43],
					69: 90,
					70: 76,
					71: 77,
					72: [1, 78],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{
					65: [2, 94],
					66: 91,
					68: [2, 94],
					72: [2, 94],
					80: [2, 94],
					81: [2, 94],
					82: [2, 94],
					83: [2, 94],
					84: [2, 94],
					85: [2, 94]
				},
				{
					5: [2, 25],
					14: [2, 25],
					15: [2, 25],
					19: [2, 25],
					29: [2, 25],
					34: [2, 25],
					39: [2, 25],
					44: [2, 25],
					47: [2, 25],
					48: [2, 25],
					51: [2, 25],
					55: [2, 25],
					60: [2, 25]
				},
				{
					20: 92,
					72: [1, 35],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{
					20: 74,
					31: 93,
					33: [2, 60],
					63: 94,
					64: 75,
					65: [1, 43],
					69: 95,
					70: 76,
					71: 77,
					72: [1, 78],
					75: [2, 60],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{
					20: 74,
					33: [2, 66],
					36: 96,
					63: 97,
					64: 75,
					65: [1, 43],
					69: 98,
					70: 76,
					71: 77,
					72: [1, 78],
					75: [2, 66],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{
					20: 74,
					22: 99,
					23: [2, 52],
					63: 100,
					64: 75,
					65: [1, 43],
					69: 101,
					70: 76,
					71: 77,
					72: [1, 78],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{
					20: 74,
					33: [2, 92],
					62: 102,
					63: 103,
					64: 75,
					65: [1, 43],
					69: 104,
					70: 76,
					71: 77,
					72: [1, 78],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{ 33: [1, 105] },
				{
					33: [2, 79],
					65: [2, 79],
					72: [2, 79],
					80: [2, 79],
					81: [2, 79],
					82: [2, 79],
					83: [2, 79],
					84: [2, 79],
					85: [2, 79]
				},
				{ 33: [2, 81] },
				{
					23: [2, 27],
					33: [2, 27],
					54: [2, 27],
					65: [2, 27],
					68: [2, 27],
					72: [2, 27],
					75: [2, 27],
					80: [2, 27],
					81: [2, 27],
					82: [2, 27],
					83: [2, 27],
					84: [2, 27],
					85: [2, 27]
				},
				{
					23: [2, 28],
					33: [2, 28],
					54: [2, 28],
					65: [2, 28],
					68: [2, 28],
					72: [2, 28],
					75: [2, 28],
					80: [2, 28],
					81: [2, 28],
					82: [2, 28],
					83: [2, 28],
					84: [2, 28],
					85: [2, 28]
				},
				{
					23: [2, 30],
					33: [2, 30],
					54: [2, 30],
					68: [2, 30],
					71: 106,
					72: [1, 107],
					75: [2, 30]
				},
				{
					23: [2, 98],
					33: [2, 98],
					54: [2, 98],
					68: [2, 98],
					72: [2, 98],
					75: [2, 98]
				},
				{
					23: [2, 45],
					33: [2, 45],
					54: [2, 45],
					65: [2, 45],
					68: [2, 45],
					72: [2, 45],
					73: [1, 108],
					75: [2, 45],
					80: [2, 45],
					81: [2, 45],
					82: [2, 45],
					83: [2, 45],
					84: [2, 45],
					85: [2, 45],
					87: [2, 45]
				},
				{
					23: [2, 44],
					33: [2, 44],
					54: [2, 44],
					65: [2, 44],
					68: [2, 44],
					72: [2, 44],
					75: [2, 44],
					80: [2, 44],
					81: [2, 44],
					82: [2, 44],
					83: [2, 44],
					84: [2, 44],
					85: [2, 44],
					87: [2, 44]
				},
				{ 54: [1, 109] },
				{
					54: [2, 83],
					65: [2, 83],
					72: [2, 83],
					80: [2, 83],
					81: [2, 83],
					82: [2, 83],
					83: [2, 83],
					84: [2, 83],
					85: [2, 83]
				},
				{ 54: [2, 85] },
				{
					5: [2, 13],
					14: [2, 13],
					15: [2, 13],
					19: [2, 13],
					29: [2, 13],
					34: [2, 13],
					39: [2, 13],
					44: [2, 13],
					47: [2, 13],
					48: [2, 13],
					51: [2, 13],
					55: [2, 13],
					60: [2, 13]
				},
				{
					38: 55,
					39: [1, 57],
					43: 56,
					44: [1, 58],
					45: 111,
					46: 110,
					47: [2, 76]
				},
				{
					33: [2, 70],
					40: 112,
					65: [2, 70],
					72: [2, 70],
					75: [2, 70],
					80: [2, 70],
					81: [2, 70],
					82: [2, 70],
					83: [2, 70],
					84: [2, 70],
					85: [2, 70]
				},
				{ 47: [2, 18] },
				{
					5: [2, 14],
					14: [2, 14],
					15: [2, 14],
					19: [2, 14],
					29: [2, 14],
					34: [2, 14],
					39: [2, 14],
					44: [2, 14],
					47: [2, 14],
					48: [2, 14],
					51: [2, 14],
					55: [2, 14],
					60: [2, 14]
				},
				{ 33: [1, 113] },
				{
					33: [2, 87],
					65: [2, 87],
					72: [2, 87],
					80: [2, 87],
					81: [2, 87],
					82: [2, 87],
					83: [2, 87],
					84: [2, 87],
					85: [2, 87]
				},
				{ 33: [2, 89] },
				{
					20: 74,
					63: 115,
					64: 75,
					65: [1, 43],
					67: 114,
					68: [2, 96],
					69: 116,
					70: 76,
					71: 77,
					72: [1, 78],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{ 33: [1, 117] },
				{
					32: 118,
					33: [2, 62],
					74: 119,
					75: [1, 120]
				},
				{
					33: [2, 59],
					65: [2, 59],
					72: [2, 59],
					75: [2, 59],
					80: [2, 59],
					81: [2, 59],
					82: [2, 59],
					83: [2, 59],
					84: [2, 59],
					85: [2, 59]
				},
				{
					33: [2, 61],
					75: [2, 61]
				},
				{
					33: [2, 68],
					37: 121,
					74: 122,
					75: [1, 120]
				},
				{
					33: [2, 65],
					65: [2, 65],
					72: [2, 65],
					75: [2, 65],
					80: [2, 65],
					81: [2, 65],
					82: [2, 65],
					83: [2, 65],
					84: [2, 65],
					85: [2, 65]
				},
				{
					33: [2, 67],
					75: [2, 67]
				},
				{ 23: [1, 123] },
				{
					23: [2, 51],
					65: [2, 51],
					72: [2, 51],
					80: [2, 51],
					81: [2, 51],
					82: [2, 51],
					83: [2, 51],
					84: [2, 51],
					85: [2, 51]
				},
				{ 23: [2, 53] },
				{ 33: [1, 124] },
				{
					33: [2, 91],
					65: [2, 91],
					72: [2, 91],
					80: [2, 91],
					81: [2, 91],
					82: [2, 91],
					83: [2, 91],
					84: [2, 91],
					85: [2, 91]
				},
				{ 33: [2, 93] },
				{
					5: [2, 22],
					14: [2, 22],
					15: [2, 22],
					19: [2, 22],
					29: [2, 22],
					34: [2, 22],
					39: [2, 22],
					44: [2, 22],
					47: [2, 22],
					48: [2, 22],
					51: [2, 22],
					55: [2, 22],
					60: [2, 22]
				},
				{
					23: [2, 99],
					33: [2, 99],
					54: [2, 99],
					68: [2, 99],
					72: [2, 99],
					75: [2, 99]
				},
				{ 73: [1, 108] },
				{
					20: 74,
					63: 125,
					64: 75,
					65: [1, 43],
					72: [1, 35],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{
					5: [2, 23],
					14: [2, 23],
					15: [2, 23],
					19: [2, 23],
					29: [2, 23],
					34: [2, 23],
					39: [2, 23],
					44: [2, 23],
					47: [2, 23],
					48: [2, 23],
					51: [2, 23],
					55: [2, 23],
					60: [2, 23]
				},
				{ 47: [2, 19] },
				{ 47: [2, 77] },
				{
					20: 74,
					33: [2, 72],
					41: 126,
					63: 127,
					64: 75,
					65: [1, 43],
					69: 128,
					70: 76,
					71: 77,
					72: [1, 78],
					75: [2, 72],
					78: 26,
					79: 27,
					80: [1, 28],
					81: [1, 29],
					82: [1, 30],
					83: [1, 31],
					84: [1, 32],
					85: [1, 34],
					86: 33
				},
				{
					5: [2, 24],
					14: [2, 24],
					15: [2, 24],
					19: [2, 24],
					29: [2, 24],
					34: [2, 24],
					39: [2, 24],
					44: [2, 24],
					47: [2, 24],
					48: [2, 24],
					51: [2, 24],
					55: [2, 24],
					60: [2, 24]
				},
				{ 68: [1, 129] },
				{
					65: [2, 95],
					68: [2, 95],
					72: [2, 95],
					80: [2, 95],
					81: [2, 95],
					82: [2, 95],
					83: [2, 95],
					84: [2, 95],
					85: [2, 95]
				},
				{ 68: [2, 97] },
				{
					5: [2, 21],
					14: [2, 21],
					15: [2, 21],
					19: [2, 21],
					29: [2, 21],
					34: [2, 21],
					39: [2, 21],
					44: [2, 21],
					47: [2, 21],
					48: [2, 21],
					51: [2, 21],
					55: [2, 21],
					60: [2, 21]
				},
				{ 33: [1, 130] },
				{ 33: [2, 63] },
				{
					72: [1, 132],
					76: 131
				},
				{ 33: [1, 133] },
				{ 33: [2, 69] },
				{
					15: [2, 12],
					18: [2, 12]
				},
				{
					14: [2, 26],
					15: [2, 26],
					19: [2, 26],
					29: [2, 26],
					34: [2, 26],
					47: [2, 26],
					48: [2, 26],
					51: [2, 26],
					55: [2, 26],
					60: [2, 26]
				},
				{
					23: [2, 31],
					33: [2, 31],
					54: [2, 31],
					68: [2, 31],
					72: [2, 31],
					75: [2, 31]
				},
				{
					33: [2, 74],
					42: 134,
					74: 135,
					75: [1, 120]
				},
				{
					33: [2, 71],
					65: [2, 71],
					72: [2, 71],
					75: [2, 71],
					80: [2, 71],
					81: [2, 71],
					82: [2, 71],
					83: [2, 71],
					84: [2, 71],
					85: [2, 71]
				},
				{
					33: [2, 73],
					75: [2, 73]
				},
				{
					23: [2, 29],
					33: [2, 29],
					54: [2, 29],
					65: [2, 29],
					68: [2, 29],
					72: [2, 29],
					75: [2, 29],
					80: [2, 29],
					81: [2, 29],
					82: [2, 29],
					83: [2, 29],
					84: [2, 29],
					85: [2, 29]
				},
				{
					14: [2, 15],
					15: [2, 15],
					19: [2, 15],
					29: [2, 15],
					34: [2, 15],
					39: [2, 15],
					44: [2, 15],
					47: [2, 15],
					48: [2, 15],
					51: [2, 15],
					55: [2, 15],
					60: [2, 15]
				},
				{
					72: [1, 137],
					77: [1, 136]
				},
				{
					72: [2, 100],
					77: [2, 100]
				},
				{
					14: [2, 16],
					15: [2, 16],
					19: [2, 16],
					29: [2, 16],
					34: [2, 16],
					44: [2, 16],
					47: [2, 16],
					48: [2, 16],
					51: [2, 16],
					55: [2, 16],
					60: [2, 16]
				},
				{ 33: [1, 138] },
				{ 33: [2, 75] },
				{ 33: [2, 32] },
				{
					72: [2, 101],
					77: [2, 101]
				},
				{
					14: [2, 17],
					15: [2, 17],
					19: [2, 17],
					29: [2, 17],
					34: [2, 17],
					39: [2, 17],
					44: [2, 17],
					47: [2, 17],
					48: [2, 17],
					51: [2, 17],
					55: [2, 17],
					60: [2, 17]
				}
			],
			defaultActions: {
				4: [2, 1],
				54: [2, 55],
				56: [2, 20],
				60: [2, 57],
				73: [2, 81],
				82: [2, 85],
				86: [2, 18],
				90: [2, 89],
				101: [2, 53],
				104: [2, 93],
				110: [2, 19],
				111: [2, 77],
				116: [2, 97],
				119: [2, 63],
				122: [2, 69],
				135: [2, 75],
				136: [2, 32]
			},
			parseError: function parseError(str, hash) {
				throw new Error(str);
			},
			parse: function parse(input) {
				var self = this, stack = [0], vstack = [null], lstack = [], table = this.table, yytext = "", yylineno = 0, yyleng = 0, recovering = 0;
				this.lexer.setInput(input);
				this.lexer.yy = this.yy;
				this.yy.lexer = this.lexer;
				this.yy.parser = this;
				if (typeof this.lexer.yylloc == "undefined") this.lexer.yylloc = {};
				var yyloc = this.lexer.yylloc;
				lstack.push(yyloc);
				var ranges = this.lexer.options && this.lexer.options.ranges;
				if (typeof this.yy.parseError === "function") this.parseError = this.yy.parseError;
				function lex() {
					var token = self.lexer.lex() || 1;
					if (typeof token !== "number") token = self.symbols_[token] || token;
					return token;
				}
				var symbol, preErrorSymbol, state, action, r, yyval = {}, p, len, newState, expected;
				while (true) {
					state = stack[stack.length - 1];
					if (this.defaultActions[state]) action = this.defaultActions[state];
					else {
						if (symbol === null || typeof symbol == "undefined") symbol = lex();
						action = table[state] && table[state][symbol];
					}
					if (typeof action === "undefined" || !action.length || !action[0]) {
						var errStr = "";
						if (!recovering) {
							expected = [];
							for (p in table[state]) if (this.terminals_[p] && p > 2) expected.push("'" + this.terminals_[p] + "'");
							if (this.lexer.showPosition) errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
							else errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1 ? "end of input" : "'" + (this.terminals_[symbol] || symbol) + "'");
							this.parseError(errStr, {
								text: this.lexer.match,
								token: this.terminals_[symbol] || symbol,
								line: this.lexer.yylineno,
								loc: yyloc,
								expected
							});
						}
					}
					if (action[0] instanceof Array && action.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
					switch (action[0]) {
						case 1:
							stack.push(symbol);
							vstack.push(this.lexer.yytext);
							lstack.push(this.lexer.yylloc);
							stack.push(action[1]);
							symbol = null;
							if (!preErrorSymbol) {
								yyleng = this.lexer.yyleng;
								yytext = this.lexer.yytext;
								yylineno = this.lexer.yylineno;
								yyloc = this.lexer.yylloc;
								if (recovering > 0) recovering--;
							} else {
								symbol = preErrorSymbol;
								preErrorSymbol = null;
							}
							break;
						case 2:
							len = this.productions_[action[1]][1];
							yyval.$ = vstack[vstack.length - len];
							yyval._$ = {
								first_line: lstack[lstack.length - (len || 1)].first_line,
								last_line: lstack[lstack.length - 1].last_line,
								first_column: lstack[lstack.length - (len || 1)].first_column,
								last_column: lstack[lstack.length - 1].last_column
							};
							if (ranges) yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
							r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
							if (typeof r !== "undefined") return r;
							if (len) {
								stack = stack.slice(0, -1 * len * 2);
								vstack = vstack.slice(0, -1 * len);
								lstack = lstack.slice(0, -1 * len);
							}
							stack.push(this.productions_[action[1]][0]);
							vstack.push(yyval.$);
							lstack.push(yyval._$);
							newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
							stack.push(newState);
							break;
						case 3: return true;
					}
				}
				return true;
			}
		};
		parser.lexer = (function() {
			var lexer = {
				EOF: 1,
				parseError: function parseError(str, hash) {
					if (this.yy.parser) this.yy.parser.parseError(str, hash);
					else throw new Error(str);
				},
				setInput: function setInput(input) {
					this._input = input;
					this._more = this._less = this.done = false;
					this.yylineno = this.yyleng = 0;
					this.yytext = this.matched = this.match = "";
					this.conditionStack = ["INITIAL"];
					this.yylloc = {
						first_line: 1,
						first_column: 0,
						last_line: 1,
						last_column: 0
					};
					if (this.options.ranges) this.yylloc.range = [0, 0];
					this.offset = 0;
					return this;
				},
				input: function input() {
					var ch = this._input[0];
					this.yytext += ch;
					this.yyleng++;
					this.offset++;
					this.match += ch;
					this.matched += ch;
					if (ch.match(/(?:\r\n?|\n).*/g)) {
						this.yylineno++;
						this.yylloc.last_line++;
					} else this.yylloc.last_column++;
					if (this.options.ranges) this.yylloc.range[1]++;
					this._input = this._input.slice(1);
					return ch;
				},
				unput: function unput(ch) {
					var len = ch.length;
					var lines = ch.split(/(?:\r\n?|\n)/g);
					this._input = ch + this._input;
					this.yytext = this.yytext.substr(0, this.yytext.length - len - 1);
					this.offset -= len;
					var oldLines = this.match.split(/(?:\r\n?|\n)/g);
					this.match = this.match.substr(0, this.match.length - 1);
					this.matched = this.matched.substr(0, this.matched.length - 1);
					if (lines.length - 1) this.yylineno -= lines.length - 1;
					var r = this.yylloc.range;
					this.yylloc = {
						first_line: this.yylloc.first_line,
						last_line: this.yylineno + 1,
						first_column: this.yylloc.first_column,
						last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
					};
					if (this.options.ranges) this.yylloc.range = [r[0], r[0] + this.yyleng - len];
					return this;
				},
				more: function more() {
					this._more = true;
					return this;
				},
				less: function less(n) {
					this.unput(this.match.slice(n));
				},
				pastInput: function pastInput() {
					var past = this.matched.substr(0, this.matched.length - this.match.length);
					return (past.length > 20 ? "..." : "") + past.substr(-20).replace(/\n/g, "");
				},
				upcomingInput: function upcomingInput() {
					var next = this.match;
					if (next.length < 20) next += this._input.substr(0, 20 - next.length);
					return (next.substr(0, 20) + (next.length > 20 ? "..." : "")).replace(/\n/g, "");
				},
				showPosition: function showPosition() {
					var pre = this.pastInput();
					var c = new Array(pre.length + 1).join("-");
					return pre + this.upcomingInput() + "\n" + c + "^";
				},
				next: function next() {
					if (this.done) return this.EOF;
					if (!this._input) this.done = true;
					var token, match, tempMatch, index, lines;
					if (!this._more) {
						this.yytext = "";
						this.match = "";
					}
					var rules = this._currentRules();
					for (var i = 0; i < rules.length; i++) {
						tempMatch = this._input.match(this.rules[rules[i]]);
						if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
							match = tempMatch;
							index = i;
							if (!this.options.flex) break;
						}
					}
					if (match) {
						lines = match[0].match(/(?:\r\n?|\n).*/g);
						if (lines) this.yylineno += lines.length;
						this.yylloc = {
							first_line: this.yylloc.last_line,
							last_line: this.yylineno + 1,
							first_column: this.yylloc.last_column,
							last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length
						};
						this.yytext += match[0];
						this.match += match[0];
						this.matches = match;
						this.yyleng = this.yytext.length;
						if (this.options.ranges) this.yylloc.range = [this.offset, this.offset += this.yyleng];
						this._more = false;
						this._input = this._input.slice(match[0].length);
						this.matched += match[0];
						token = this.performAction.call(this, this.yy, this, rules[index], this.conditionStack[this.conditionStack.length - 1]);
						if (this.done && this._input) this.done = false;
						if (token) return token;
						else return;
					}
					if (this._input === "") return this.EOF;
					else return this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
						text: "",
						token: null,
						line: this.yylineno
					});
				},
				lex: function lex() {
					var r = this.next();
					if (typeof r !== "undefined") return r;
					else return this.lex();
				},
				begin: function begin(condition) {
					this.conditionStack.push(condition);
				},
				popState: function popState() {
					return this.conditionStack.pop();
				},
				_currentRules: function _currentRules() {
					return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
				},
				topState: function topState() {
					return this.conditionStack[this.conditionStack.length - 2];
				},
				pushState: function begin(condition) {
					this.begin(condition);
				}
			};
			lexer.options = {};
			lexer.performAction = function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
				function strip(start, end) {
					return yy_.yytext = yy_.yytext.substring(start, yy_.yyleng - end + start);
				}
				switch ($avoiding_name_collisions) {
					case 0:
						if (yy_.yytext.slice(-2) === "\\\\") {
							strip(0, 1);
							this.begin("mu");
						} else if (yy_.yytext.slice(-1) === "\\") {
							strip(0, 1);
							this.begin("emu");
						} else this.begin("mu");
						if (yy_.yytext) return 15;
						break;
					case 1: return 15;
					case 2:
						this.popState();
						return 15;
					case 3:
						this.begin("raw");
						return 15;
					case 4:
						this.popState();
						if (this.conditionStack[this.conditionStack.length - 1] === "raw") return 15;
						else {
							strip(5, 9);
							return "END_RAW_BLOCK";
						}
					case 5: return 15;
					case 6:
						this.popState();
						return 14;
					case 7: return 65;
					case 8: return 68;
					case 9: return 19;
					case 10:
						this.popState();
						this.begin("raw");
						return 23;
					case 11: return 55;
					case 12: return 60;
					case 13: return 29;
					case 14: return 47;
					case 15:
						this.popState();
						return 44;
					case 16:
						this.popState();
						return 44;
					case 17: return 34;
					case 18: return 39;
					case 19: return 51;
					case 20: return 48;
					case 21:
						this.unput(yy_.yytext);
						this.popState();
						this.begin("com");
						break;
					case 22:
						this.popState();
						return 14;
					case 23: return 48;
					case 24: return 73;
					case 25: return 72;
					case 26: return 72;
					case 27: return 87;
					case 28: break;
					case 29:
						this.popState();
						return 54;
					case 30:
						this.popState();
						return 33;
					case 31:
						yy_.yytext = strip(1, 2).replace(/\\"/g, "\"");
						return 80;
					case 32:
						yy_.yytext = strip(1, 2).replace(/\\'/g, "'");
						return 80;
					case 33: return 85;
					case 34: return 82;
					case 35: return 82;
					case 36: return 83;
					case 37: return 84;
					case 38: return 81;
					case 39: return 75;
					case 40: return 77;
					case 41: return 72;
					case 42:
						yy_.yytext = yy_.yytext.replace(/\\([\\\]])/g, "$1");
						return 72;
					case 43: return "INVALID";
					case 44: return 5;
				}
			};
			lexer.rules = [
				/^(?:[^\x00]*?(?=(\{\{)))/,
				/^(?:[^\x00]+)/,
				/^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,
				/^(?:\{\{\{\{(?=[^\/]))/,
				/^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,
				/^(?:[^\x00]+?(?=(\{\{\{\{)))/,
				/^(?:[\s\S]*?--(~)?\}\})/,
				/^(?:\()/,
				/^(?:\))/,
				/^(?:\{\{\{\{)/,
				/^(?:\}\}\}\})/,
				/^(?:\{\{(~)?>)/,
				/^(?:\{\{(~)?#>)/,
				/^(?:\{\{(~)?#\*?)/,
				/^(?:\{\{(~)?\/)/,
				/^(?:\{\{(~)?\^\s*(~)?\}\})/,
				/^(?:\{\{(~)?\s*else\s*(~)?\}\})/,
				/^(?:\{\{(~)?\^)/,
				/^(?:\{\{(~)?\s*else\b)/,
				/^(?:\{\{(~)?\{)/,
				/^(?:\{\{(~)?&)/,
				/^(?:\{\{(~)?!--)/,
				/^(?:\{\{(~)?![\s\S]*?\}\})/,
				/^(?:\{\{(~)?\*?)/,
				/^(?:=)/,
				/^(?:\.\.)/,
				/^(?:\.(?=([=~}\s\/.)|])))/,
				/^(?:[\/.])/,
				/^(?:\s+)/,
				/^(?:\}(~)?\}\})/,
				/^(?:(~)?\}\})/,
				/^(?:"(\\["]|[^"])*")/,
				/^(?:'(\\[']|[^'])*')/,
				/^(?:@)/,
				/^(?:true(?=([~}\s)])))/,
				/^(?:false(?=([~}\s)])))/,
				/^(?:undefined(?=([~}\s)])))/,
				/^(?:null(?=([~}\s)])))/,
				/^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,
				/^(?:as\s+\|)/,
				/^(?:\|)/,
				/^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,
				/^(?:\[(\\\]|[^\]])*\])/,
				/^(?:.)/,
				/^(?:$)/
			];
			lexer.conditions = {
				"mu": {
					"rules": [
						7,
						8,
						9,
						10,
						11,
						12,
						13,
						14,
						15,
						16,
						17,
						18,
						19,
						20,
						21,
						22,
						23,
						24,
						25,
						26,
						27,
						28,
						29,
						30,
						31,
						32,
						33,
						34,
						35,
						36,
						37,
						38,
						39,
						40,
						41,
						42,
						43,
						44
					],
					"inclusive": false
				},
				"emu": {
					"rules": [2],
					"inclusive": false
				},
				"com": {
					"rules": [6],
					"inclusive": false
				},
				"raw": {
					"rules": [
						3,
						4,
						5
					],
					"inclusive": false
				},
				"INITIAL": {
					"rules": [
						0,
						1,
						44
					],
					"inclusive": true
				}
			};
			return lexer;
		})();
		function Parser() {
			this.yy = {};
		}
		Parser.prototype = parser;
		parser.Parser = Parser;
		return new Parser();
	})();
	module.exports = exports["default"];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/compiler/node-types.js
var require_node_types = /* @__PURE__ */ __commonJSMin(((exports) => {
	exports.__esModule = true;
	exports.NODE_TYPES = [
		"Program",
		"BlockStatement",
		"DecoratorBlock",
		"PartialStatement",
		"PartialBlockStatement",
		"Decorator",
		"MustacheStatement",
		"ContentStatement",
		"CommentStatement",
		"SubExpression",
		"PathExpression",
		"StringLiteral",
		"NumberLiteral",
		"BooleanLiteral",
		"UndefinedLiteral",
		"NullLiteral",
		"Hash",
		"HashPair"
	];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/compiler/visitor.js
var require_visitor = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	// istanbul ignore next
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { "default": obj };
	}
	var _exception2 = _interopRequireDefault(require_exception());
	var _utils = require_utils();
	var _nodeTypes = require_node_types();
	function Visitor() {
		this.parents = [];
	}
	/**
	* Whether a visitor may dispatch on a node type.
	*
	* A type is dispatchable if the parser produces it, or if the visitor
	* (typically a subclass) defines a handler for it that is not a method of
	* Visitor itself. `in` is used for the latter so that accept, acceptKey and
	* everything inherited from Object.prototype (constructor, __proto__, ...)
	* can never be reached through a crafted `type`.
	*
	* Subclasses that visit untrusted ASTs, such as WhitespaceControl, must
	* therefore define nothing but node handlers as function properties.
	*
	* @param {Visitor} visitor the visitor that would handle the node
	* @param {*} type the untrusted `type` of the node
	* @returns {boolean} true if the visitor may call its `type` method
	*/
	function isDispatchable(visitor, type) {
		return _utils.indexOf(_nodeTypes.NODE_TYPES, type) !== -1 || !(type in Visitor.prototype) && typeof visitor[type] === "function";
	}
	Visitor.prototype = {
		constructor: Visitor,
		mutating: false,
		acceptKey: function acceptKey(node, name) {
			var value = this.accept(node[name]);
			if (this.mutating) {
				if (value && !isDispatchable(this, value.type)) throw new _exception2["default"]("Unexpected node type \"" + value.type + "\" found when accepting " + name + " on " + node.type);
				node[name] = value;
			}
		},
		acceptRequired: function acceptRequired(node, name) {
			this.acceptKey(node, name);
			if (!node[name]) throw new _exception2["default"](node.type + " requires " + name);
		},
		acceptArray: function acceptArray(array) {
			for (var i = 0, l = array.length; i < l; i++) {
				this.acceptKey(array, i);
				if (!array[i]) {
					array.splice(i, 1);
					i--;
					l--;
				}
			}
		},
		accept: function accept(object) {
			if (!object) return;
			if (!isDispatchable(this, object.type) || !this[object.type]) throw new _exception2["default"]("Unknown type: " + object.type, object);
			if (this.current) this.parents.unshift(this.current);
			this.current = object;
			var ret = this[object.type](object);
			this.current = this.parents.shift();
			if (!this.mutating || ret) return ret;
			else if (ret !== false) return object;
		},
		Program: function Program(program) {
			this.acceptArray(program.body);
		},
		MustacheStatement: visitSubExpression,
		Decorator: visitSubExpression,
		BlockStatement: visitBlock,
		DecoratorBlock: visitBlock,
		PartialStatement: visitPartial,
		PartialBlockStatement: function PartialBlockStatement(partial) {
			visitPartial.call(this, partial);
			this.acceptKey(partial, "program");
		},
		ContentStatement: function ContentStatement() {},
		CommentStatement: function CommentStatement() {},
		SubExpression: visitSubExpression,
		PathExpression: function PathExpression() {},
		StringLiteral: function StringLiteral() {},
		NumberLiteral: function NumberLiteral() {},
		BooleanLiteral: function BooleanLiteral() {},
		UndefinedLiteral: function UndefinedLiteral() {},
		NullLiteral: function NullLiteral() {},
		Hash: function Hash(hash) {
			this.acceptArray(hash.pairs);
		},
		HashPair: function HashPair(pair) {
			this.acceptRequired(pair, "value");
		}
	};
	function visitSubExpression(mustache) {
		this.acceptRequired(mustache, "path");
		this.acceptArray(mustache.params);
		this.acceptKey(mustache, "hash");
	}
	function visitBlock(block) {
		visitSubExpression.call(this, block);
		this.acceptKey(block, "program");
		this.acceptKey(block, "inverse");
	}
	function visitPartial(partial) {
		this.acceptRequired(partial, "name");
		this.acceptArray(partial.params);
		this.acceptKey(partial, "hash");
	}
	exports["default"] = Visitor;
	module.exports = exports["default"];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/compiler/whitespace-control.js
var require_whitespace_control = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	// istanbul ignore next
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { "default": obj };
	}
	var _visitor2 = _interopRequireDefault(require_visitor());
	function WhitespaceControl() {
		var options = arguments.length <= 0 || arguments[0] === void 0 ? {} : arguments[0];
		this.options = options;
	}
	WhitespaceControl.prototype = new _visitor2["default"]();
	WhitespaceControl.prototype.Program = function(program) {
		var doStandalone = !this.options.ignoreStandalone;
		var isRoot = !this.isRootSeen;
		this.isRootSeen = true;
		var body = program.body;
		for (var i = 0, l = body.length; i < l; i++) {
			var current = body[i], strip = this.accept(current);
			if (!strip) continue;
			var _isPrevWhitespace = isPrevWhitespace(body, i, isRoot), _isNextWhitespace = isNextWhitespace(body, i, isRoot), openStandalone = strip.openStandalone && _isPrevWhitespace, closeStandalone = strip.closeStandalone && _isNextWhitespace, inlineStandalone = strip.inlineStandalone && _isPrevWhitespace && _isNextWhitespace;
			if (strip.close) omitRight(body, i, true);
			if (strip.open) omitLeft(body, i, true);
			if (doStandalone && inlineStandalone) {
				omitRight(body, i);
				if (omitLeft(body, i)) {
					if (current.type === "PartialStatement") current.indent = /(?:^|[^ \t])([ \t]+)$/.exec(body[i - 1].original)[1];
				}
			}
			if (doStandalone && openStandalone) {
				omitRight((current.program || current.inverse).body);
				omitLeft(body, i);
			}
			if (doStandalone && closeStandalone) {
				omitRight(body, i);
				omitLeft((current.inverse || current.program).body);
			}
		}
		return program;
	};
	WhitespaceControl.prototype.BlockStatement = WhitespaceControl.prototype.DecoratorBlock = WhitespaceControl.prototype.PartialBlockStatement = function(block) {
		this.accept(block.program);
		this.accept(block.inverse);
		var program = block.program || block.inverse, inverse = block.program && block.inverse, firstInverse = inverse, lastInverse = inverse;
		if (inverse && inverse.chained) {
			firstInverse = inverse.body[0].program;
			while (lastInverse.chained) lastInverse = lastInverse.body[lastInverse.body.length - 1].program;
		}
		var strip = {
			open: block.openStrip.open,
			close: block.closeStrip.close,
			openStandalone: isNextWhitespace(program.body),
			closeStandalone: isPrevWhitespace((firstInverse || program).body)
		};
		if (block.openStrip.close) omitRight(program.body, null, true);
		if (inverse) {
			var inverseStrip = block.inverseStrip;
			if (inverseStrip.open) omitLeft(program.body, null, true);
			if (inverseStrip.close) omitRight(firstInverse.body, null, true);
			if (block.closeStrip.open) omitLeft(lastInverse.body, null, true);
			if (!this.options.ignoreStandalone && isPrevWhitespace(program.body) && isNextWhitespace(firstInverse.body)) {
				omitLeft(program.body);
				omitRight(firstInverse.body);
			}
		} else if (block.closeStrip.open) omitLeft(program.body, null, true);
		return strip;
	};
	WhitespaceControl.prototype.Decorator = WhitespaceControl.prototype.MustacheStatement = function(mustache) {
		return mustache.strip;
	};
	WhitespaceControl.prototype.PartialStatement = WhitespaceControl.prototype.CommentStatement = function(node) {
		/* istanbul ignore next */
		var strip = node.strip || {};
		return {
			inlineStandalone: true,
			open: strip.open,
			close: strip.close
		};
	};
	function isPrevWhitespace(body, i, isRoot) {
		if (i === void 0) i = body.length;
		var prev = body[i - 1], sibling = body[i - 2];
		if (!prev) return isRoot;
		if (prev.type === "ContentStatement") return (sibling || !isRoot ? /(?:^|\S)[^\S\n]*\n\s*$/ : /^\s*$|(?:^|\S)[^\S\n]*\n\s*$/).test(prev.original);
	}
	function isNextWhitespace(body, i, isRoot) {
		if (i === void 0) i = -1;
		var next = body[i + 1], sibling = body[i + 2];
		if (!next) return isRoot;
		if (next.type === "ContentStatement") return (sibling || !isRoot ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(next.original);
	}
	function omitRight(body, i, multiple) {
		var current = body[i == null ? 0 : i + 1];
		if (!current || current.type !== "ContentStatement" || !multiple && current.rightStripped) return;
		var original = current.value;
		current.value = current.value.replace(multiple ? /^\s+/ : /^[ \t]*\r?\n?/, "");
		current.rightStripped = current.value !== original;
	}
	function omitLeft(body, i, multiple) {
		var current = body[i == null ? body.length - 1 : i - 1];
		if (!current || current.type !== "ContentStatement" || !multiple && current.leftStripped) return;
		var original = current.value;
		current.value = current.value.replace(multiple ? /(^|\S)\s+$/ : /(^|[^ \t])[ \t]+$/, "$1");
		current.leftStripped = current.value !== original;
		return current.leftStripped;
	}
	exports["default"] = WhitespaceControl;
	module.exports = exports["default"];
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/compiler/helpers.js
var require_helpers = /* @__PURE__ */ __commonJSMin(((exports) => {
	exports.__esModule = true;
	exports.SourceLocation = SourceLocation;
	exports.id = id;
	exports.stripFlags = stripFlags;
	exports.stripComment = stripComment;
	exports.preparePath = preparePath;
	exports.prepareMustache = prepareMustache;
	exports.prepareRawBlock = prepareRawBlock;
	exports.prepareBlock = prepareBlock;
	exports.prepareProgram = prepareProgram;
	exports.preparePartialBlock = preparePartialBlock;
	// istanbul ignore next
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { "default": obj };
	}
	var _exception2 = _interopRequireDefault(require_exception());
	function validateClose(open, close) {
		close = close.path ? close.path.original : close;
		if (open.path.original !== close) {
			var errorNode = { loc: open.path.loc };
			throw new _exception2["default"](open.path.original + " doesn't match " + close, errorNode);
		}
	}
	function SourceLocation(source, locInfo) {
		this.source = source;
		this.start = {
			line: locInfo.first_line,
			column: locInfo.first_column
		};
		this.end = {
			line: locInfo.last_line,
			column: locInfo.last_column
		};
	}
	function id(token) {
		if (/^\[.*\]$/.test(token)) return token.substring(1, token.length - 1);
		else return token;
	}
	function stripFlags(open, close) {
		return {
			open: open.charAt(2) === "~",
			close: close.charAt(close.length - 3) === "~"
		};
	}
	function stripComment(comment) {
		return comment.replace(/^\{\{~?!-?-?/, "").replace(/-?-?~?\}\}$/, "");
	}
	function preparePath(data, parts, loc) {
		loc = this.locInfo(loc);
		var original = data ? "@" : "", dig = [], depth = 0;
		for (var i = 0, l = parts.length; i < l; i++) {
			var part = parts[i].part, isLiteral = parts[i].original !== part;
			original += (parts[i].separator || "") + part;
			if (!isLiteral && (part === ".." || part === "." || part === "this")) {
				if (dig.length > 0) throw new _exception2["default"]("Invalid path: " + original, { loc });
				else if (part === "..") depth++;
			} else dig.push(part);
		}
		return {
			type: "PathExpression",
			data,
			depth,
			parts: dig,
			original,
			loc
		};
	}
	function prepareMustache(path, params, hash, open, strip, locInfo) {
		var escapeFlag = open.charAt(3) || open.charAt(2), escaped = escapeFlag !== "{" && escapeFlag !== "&";
		return {
			type: /\*/.test(open) ? "Decorator" : "MustacheStatement",
			path,
			params,
			hash,
			escaped,
			strip,
			loc: this.locInfo(locInfo)
		};
	}
	function prepareRawBlock(openRawBlock, contents, close, locInfo) {
		validateClose(openRawBlock, close);
		locInfo = this.locInfo(locInfo);
		var program = {
			type: "Program",
			body: contents,
			strip: {},
			loc: locInfo
		};
		return {
			type: "BlockStatement",
			path: openRawBlock.path,
			params: openRawBlock.params,
			hash: openRawBlock.hash,
			program,
			openStrip: {},
			inverseStrip: {},
			closeStrip: {},
			loc: locInfo
		};
	}
	function prepareBlock(openBlock, program, inverseAndProgram, close, inverted, locInfo) {
		if (close && close.path) validateClose(openBlock, close);
		var decorator = /\*/.test(openBlock.open);
		program.blockParams = openBlock.blockParams;
		var inverse = void 0, inverseStrip = void 0;
		if (inverseAndProgram) {
			if (decorator) throw new _exception2["default"]("Unexpected inverse block on decorator", inverseAndProgram);
			if (inverseAndProgram.chain) inverseAndProgram.program.body[0].closeStrip = close.strip;
			inverseStrip = inverseAndProgram.strip;
			inverse = inverseAndProgram.program;
		}
		if (inverted) {
			inverted = inverse;
			inverse = program;
			program = inverted;
		}
		return {
			type: decorator ? "DecoratorBlock" : "BlockStatement",
			path: openBlock.path,
			params: openBlock.params,
			hash: openBlock.hash,
			program,
			inverse,
			openStrip: openBlock.strip,
			inverseStrip,
			closeStrip: close && close.strip,
			loc: this.locInfo(locInfo)
		};
	}
	function prepareProgram(statements, loc) {
		if (!loc && statements.length) {
			var firstLoc = statements[0].loc, lastLoc = statements[statements.length - 1].loc;
			/* istanbul ignore else */
			if (firstLoc && lastLoc) loc = {
				source: firstLoc.source,
				start: {
					line: firstLoc.start.line,
					column: firstLoc.start.column
				},
				end: {
					line: lastLoc.end.line,
					column: lastLoc.end.column
				}
			};
		}
		return {
			type: "Program",
			body: statements,
			strip: {},
			loc
		};
	}
	function preparePartialBlock(open, program, close, locInfo) {
		validateClose(open, close);
		return {
			type: "PartialBlockStatement",
			name: open.path,
			params: open.params,
			hash: open.hash,
			program,
			openStrip: open.strip,
			closeStrip: close && close.strip,
			loc: this.locInfo(locInfo)
		};
	}
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/compiler/base.js
var require_base = /* @__PURE__ */ __commonJSMin(((exports) => {
	exports.__esModule = true;
	exports.parseWithoutProcessing = parseWithoutProcessing;
	exports.parse = parse;
	// istanbul ignore next
	function _interopRequireWildcard(obj) {
		if (obj && obj.__esModule) return obj;
		else {
			var newObj = {};
			if (obj != null) {
				for (var key in obj) if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
			}
			newObj["default"] = obj;
			return newObj;
		}
	}
	// istanbul ignore next
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { "default": obj };
	}
	var _parser2 = _interopRequireDefault(require_parser());
	var _whitespaceControl2 = _interopRequireDefault(require_whitespace_control());
	var Helpers = _interopRequireWildcard(require_helpers());
	var _utils = require_utils();
	exports.parser = _parser2["default"];
	var yy = {};
	_utils.extend(yy, Helpers);
	function parseWithoutProcessing(input, options) {
		if (input.type === "Program") return input;
		_parser2["default"].yy = yy;
		yy.locInfo = function(locInfo) {
			return new yy.SourceLocation(options && options.srcName, locInfo);
		};
		return _parser2["default"].parse(input);
	}
	function parse(input, options) {
		var ast = parseWithoutProcessing(input, options);
		return new _whitespaceControl2["default"](options).accept(ast);
	}
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/compiler/compiler.js
var require_compiler = /* @__PURE__ */ __commonJSMin(((exports) => {
	exports.__esModule = true;
	exports.Compiler = Compiler;
	exports.precompile = precompile;
	exports.compile = compile;
	// istanbul ignore next
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { "default": obj };
	}
	var _exception2 = _interopRequireDefault(require_exception());
	var _utils = require_utils();
	var _ast2 = _interopRequireDefault(require_ast());
	var _nodeTypes = require_node_types();
	var slice = [].slice;
	function Compiler() {}
	Compiler.prototype = {
		compiler: Compiler,
		equals: function equals(other) {
			var len = this.opcodes.length;
			if (other.opcodes.length !== len) return false;
			for (var i = 0; i < len; i++) {
				var opcode = this.opcodes[i], otherOpcode = other.opcodes[i];
				if (opcode.opcode !== otherOpcode.opcode || !argEquals(opcode.args, otherOpcode.args)) return false;
			}
			len = this.children.length;
			for (var i = 0; i < len; i++) if (!this.children[i].equals(other.children[i])) return false;
			return true;
		},
		guid: 0,
		compile: function compile(program, options) {
			this.sourceNode = [];
			this.opcodes = [];
			this.children = [];
			this.options = options;
			this.stringParams = options.stringParams;
			this.trackIds = options.trackIds;
			options.blockParams = options.blockParams || [];
			options.knownHelpers = _utils.extend(Object.create(null), {
				helperMissing: true,
				blockHelperMissing: true,
				each: true,
				"if": true,
				unless: true,
				"with": true,
				log: true,
				lookup: true
			}, options.knownHelpers);
			return this.accept(program);
		},
		compileProgram: function compileProgram(program) {
			var result = new this.compiler().compile(program, this.options), guid = this.guid++;
			this.usePartial = this.usePartial || result.usePartial;
			this.children[guid] = result;
			this.useDepths = this.useDepths || result.useDepths;
			return guid;
		},
		accept: function accept(node) {
			if (_utils.indexOf(_nodeTypes.NODE_TYPES, node.type) === -1 || !this[node.type]) throw new _exception2["default"]("Unknown type: " + node.type, node);
			this.sourceNode.unshift(node);
			var ret = this[node.type](node);
			this.sourceNode.shift();
			return ret;
		},
		Program: function Program(program) {
			validateBlockParams(program);
			this.options.blockParams.unshift(program.blockParams);
			var body = program.body, bodyLength = body.length;
			for (var i = 0; i < bodyLength; i++) this.accept(body[i]);
			this.options.blockParams.shift();
			this.isSimple = bodyLength === 1;
			this.blockParams = program.blockParams ? program.blockParams.length : 0;
			return this;
		},
		BlockStatement: function BlockStatement(block) {
			transformLiteralToPath(block);
			var program = block.program, inverse = block.inverse;
			program = program && this.compileProgram(program);
			inverse = inverse && this.compileProgram(inverse);
			var type = this.classifySexpr(block);
			if (type === "helper") this.helperSexpr(block, program, inverse);
			else if (type === "simple") {
				this.simpleSexpr(block);
				this.opcode("pushProgram", program);
				this.opcode("pushProgram", inverse);
				this.opcode("emptyHash");
				this.opcode("blockValue", block.path.original);
			} else {
				this.ambiguousSexpr(block, program, inverse);
				this.opcode("pushProgram", program);
				this.opcode("pushProgram", inverse);
				this.opcode("emptyHash");
				this.opcode("ambiguousBlockValue");
			}
			this.opcode("append");
		},
		DecoratorBlock: function DecoratorBlock(decorator) {
			var program = decorator.program && this.compileProgram(decorator.program);
			var params = this.setupFullMustacheParams(decorator, program, void 0), path = decorator.path;
			this.useDecorators = true;
			this.opcode("registerDecorator", params.length, path.original);
		},
		PartialStatement: function PartialStatement(partial) {
			this.usePartial = true;
			var program = partial.program;
			if (program) program = this.compileProgram(partial.program);
			var params = partial.params;
			if (params.length > 1) throw new _exception2["default"]("Unsupported number of partial arguments: " + params.length, partial);
			else if (!params.length) {
				if (this.options.explicitPartialContext) this.opcode("pushLiteral", "undefined");
				else params.push({
					type: "PathExpression",
					parts: [],
					depth: 0
				});
			}
			var partialName = partial.name.original, isDynamic = partial.name.type === "SubExpression";
			if (isDynamic) this.accept(partial.name);
			this.setupFullMustacheParams(partial, program, void 0, true);
			var indent = partial.indent || "";
			if (this.options.preventIndent && indent) {
				this.opcode("appendContent", indent);
				indent = "";
			}
			this.opcode("invokePartial", isDynamic, partialName, indent);
			this.opcode("append");
		},
		PartialBlockStatement: function PartialBlockStatement(partialBlock) {
			this.PartialStatement(partialBlock);
		},
		MustacheStatement: function MustacheStatement(mustache) {
			this.SubExpression(mustache);
			if (mustache.escaped && !this.options.noEscape) this.opcode("appendEscaped");
			else this.opcode("append");
		},
		Decorator: function Decorator(decorator) {
			this.DecoratorBlock(decorator);
		},
		ContentStatement: function ContentStatement(content) {
			if (content.value != null && typeof content.value !== "string") throw invalidAst(content, "value must be a string");
			if (content.value) this.opcode("appendContent", content.value);
		},
		CommentStatement: function CommentStatement() {},
		SubExpression: function SubExpression(sexpr) {
			transformLiteralToPath(sexpr);
			var type = this.classifySexpr(sexpr);
			if (type === "simple") this.simpleSexpr(sexpr);
			else if (type === "helper") this.helperSexpr(sexpr);
			else this.ambiguousSexpr(sexpr);
		},
		ambiguousSexpr: function ambiguousSexpr(sexpr, program, inverse) {
			var path = sexpr.path, name = path.parts[0], isBlock = program != null || inverse != null;
			this.opcode("getContext", validateDepth(path));
			this.opcode("pushProgram", program);
			this.opcode("pushProgram", inverse);
			path.strict = true;
			this.accept(path);
			this.opcode("invokeAmbiguous", name, isBlock);
		},
		simpleSexpr: function simpleSexpr(sexpr) {
			var path = sexpr.path;
			path.strict = true;
			this.accept(path);
			this.opcode("resolvePossibleLambda");
		},
		helperSexpr: function helperSexpr(sexpr, program, inverse) {
			var params = this.setupFullMustacheParams(sexpr, program, inverse), path = sexpr.path, name = path.parts[0];
			if (this.options.knownHelpers[name]) this.opcode("invokeKnownHelper", params.length, name);
			else if (this.options.knownHelpersOnly) throw new _exception2["default"]("You specified knownHelpersOnly, but used the unknown helper " + name, sexpr);
			else {
				path.strict = true;
				path.falsy = true;
				this.accept(path);
				this.opcode("invokeHelper", params.length, path.original, _ast2["default"].helpers.simpleId(path));
			}
		},
		PathExpression: function PathExpression(path) {
			var depth = validateDepth(path);
			var parts = validateParts(path);
			this.addDepth(depth);
			this.opcode("getContext", depth);
			var name = parts[0], scoped = _ast2["default"].helpers.scopedId(path), blockParamId = !depth && !scoped && this.blockParamIndex(name);
			if (blockParamId) this.opcode("lookupBlockParam", blockParamId, parts);
			else if (!name) this.opcode("pushContext");
			else if (path.data) {
				this.options.data = true;
				this.opcode("lookupData", depth, parts, path.strict);
			} else this.opcode("lookupOnContext", parts, path.falsy, path.strict, scoped);
		},
		StringLiteral: function StringLiteral(string) {
			validateLiteral(string);
			this.opcode("pushString", string.value);
		},
		NumberLiteral: function NumberLiteral(number) {
			validateLiteral(number);
			this.opcode("pushLiteral", number.value);
		},
		BooleanLiteral: function BooleanLiteral(bool) {
			validateLiteral(bool);
			this.opcode("pushLiteral", bool.value);
		},
		UndefinedLiteral: function UndefinedLiteral() {
			this.opcode("pushLiteral", "undefined");
		},
		NullLiteral: function NullLiteral() {
			this.opcode("pushLiteral", "null");
		},
		Hash: function Hash(hash) {
			var pairs = hash.pairs, i = 0, l = void 0;
			if (!_utils.isArray(pairs)) throw invalidAst(hash, "pairs must be an array");
			l = pairs.length;
			for (var j = 0; j < l; j++) if (!pairs[j] || typeof pairs[j].key !== "string") throw invalidAst(hash, "pair keys must be strings");
			this.opcode("pushHash");
			for (; i < l; i++) this.pushParam(pairs[i].value);
			while (i--) this.opcode("assignToHash", pairs[i].key);
			this.opcode("popHash");
		},
		opcode: function opcode(name) {
			this.opcodes.push({
				opcode: name,
				args: slice.call(arguments, 1),
				loc: this.sourceNode[0].loc
			});
		},
		addDepth: function addDepth(depth) {
			if (!depth) return;
			this.useDepths = true;
		},
		classifySexpr: function classifySexpr(sexpr) {
			validateParts(sexpr.path);
			var isSimple = _ast2["default"].helpers.simpleId(sexpr.path);
			var isBlockParam = isSimple && !!this.blockParamIndex(sexpr.path.parts[0]);
			var isHelper = !isBlockParam && _ast2["default"].helpers.helperExpression(sexpr);
			var isEligible = !isBlockParam && (isHelper || isSimple);
			if (isEligible && !isHelper) {
				var _name = sexpr.path.parts[0], options = this.options;
				if (options.knownHelpers[_name]) isHelper = true;
				else if (options.knownHelpersOnly) isEligible = false;
			}
			if (isHelper) return "helper";
			else if (isEligible) return "ambiguous";
			else return "simple";
		},
		pushParams: function pushParams(params) {
			for (var i = 0, l = params.length; i < l; i++) this.pushParam(params[i]);
		},
		pushParam: function pushParam(val) {
			validateLiteral(val);
			var value = val.value != null ? val.value : val.original || "";
			var depth = validateDepth(val);
			if (this.stringParams) {
				if (typeof value !== "number" && typeof value !== "boolean") value = String(value);
				if (value.replace) value = value.replace(/^(\.?\.\/)*/g, "").replace(/\//g, ".");
				if (depth) this.addDepth(depth);
				this.opcode("getContext", depth);
				this.opcode("pushStringParam", value, val.type);
				if (val.type === "SubExpression") this.accept(val);
			} else {
				if (this.trackIds) {
					var blockParamIndex = void 0;
					if (val.parts && !_ast2["default"].helpers.scopedId(val) && !depth) blockParamIndex = this.blockParamIndex(validateParts(val)[0]);
					if (blockParamIndex) {
						var blockParamChild = val.parts.slice(1).join(".");
						this.opcode("pushId", "BlockParam", blockParamIndex, blockParamChild);
					} else {
						value = val.original || value;
						if (value.replace) value = value.replace(/^this(?:\.|$)/, "").replace(/^\.\//, "").replace(/^\.$/, "");
						this.opcode("pushId", val.type, value);
					}
				}
				this.accept(val);
			}
		},
		setupFullMustacheParams: function setupFullMustacheParams(sexpr, program, inverse, omitEmpty) {
			var params = sexpr.params;
			this.pushParams(params);
			this.opcode("pushProgram", program);
			this.opcode("pushProgram", inverse);
			if (sexpr.hash) this.accept(sexpr.hash);
			else this.opcode("emptyHash", omitEmpty);
			return params;
		},
		blockParamIndex: function blockParamIndex(name) {
			for (var depth = 0, len = this.options.blockParams.length; depth < len; depth++) {
				var blockParams = this.options.blockParams[depth], param = blockParams && _utils.indexOf(blockParams, name);
				if (blockParams && param >= 0) return [depth, param];
			}
		}
	};
	function precompile(input, options, env) {
		if (input == null || typeof input !== "string" && input.type !== "Program") throw new _exception2["default"]("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + input);
		options = options || {};
		if (!("data" in options)) options.data = true;
		if (options.compat) options.useDepths = true;
		var ast = env.parse(input, options), environment = new env.Compiler().compile(ast, options);
		return new env.JavaScriptCompiler().compile(environment, options);
	}
	function compile(input, options, env) {
		if (options === void 0) options = {};
		if (input == null || typeof input !== "string" && input.type !== "Program") throw new _exception2["default"]("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + input);
		options = _utils.extend({}, options);
		if (!("data" in options)) options.data = true;
		if (options.compat) options.useDepths = true;
		var compiled = void 0;
		function compileInput() {
			var ast = env.parse(input, options), environment = new env.Compiler().compile(ast, options), templateSpec = new env.JavaScriptCompiler().compile(environment, options, void 0, true);
			return env.template(templateSpec);
		}
		function ret(context, execOptions) {
			if (!compiled) compiled = compileInput();
			return compiled.call(this, context, execOptions);
		}
		ret._setup = function(setupOptions) {
			if (!compiled) compiled = compileInput();
			return compiled._setup(setupOptions);
		};
		ret._child = function(i, data, blockParams, depths) {
			if (!compiled) compiled = compileInput();
			return compiled._child(i, data, blockParams, depths);
		};
		return ret;
	}
	/**
	* Create the exception thrown for an AST node that fails validation.
	*
	* @param {Object} node the offending AST node; its `type` is included in the
	*   message and its `loc`, if present, in the error location
	* @param {string} message what is wrong with the node
	* @returns {Exception} the exception to throw
	*/
	function invalidAst(node, message) {
		return new _exception2["default"]("Invalid AST: " + node.type + " " + message, node);
	}
	/**
	* Validate the `depth` of a path or param node.
	*
	* A missing depth is treated as 0, because ASTs built by hand or by other
	* tools commonly omit it. Any depth that is present must be a non-negative
	* integer, since it is written into the generated code.
	*
	* @param {Object} node the AST node whose `depth` is validated
	* @returns {number} the validated depth, or 0 if the node has none
	* @throws {Exception} if the depth is present but not a non-negative integer
	*/
	function validateDepth(node) {
		var depth = node.depth;
		if (depth == null) return 0;
		if (typeof depth !== "number" || !isFinite(depth) || Math.floor(depth) !== depth || depth < 0) throw invalidAst(node, "depth must be a non-negative integer");
		return depth;
	}
	/**
	* Validate the `value` of a StringLiteral, NumberLiteral or BooleanLiteral.
	*
	* Literal values are written into the generated code, so they must have
	* exactly the type their node promises. Nodes of any other type pass through
	* unchanged.
	*
	* Numbers need not be finite: the parser produces Infinity for very long
	* number literals, and Infinity and NaN are emitted as the read-only globals
	* of the same name.
	*
	* @param {Object} node the AST node to validate
	* @throws {Exception} if the value does not match the literal type
	*/
	function validateLiteral(node) {
		var value = node.value;
		if (node.type === "StringLiteral" && typeof value !== "string") throw invalidAst(node, "value must be a string");
		else if (node.type === "NumberLiteral" && typeof value !== "number") throw invalidAst(node, "value must be a number");
		else if (node.type === "BooleanLiteral" && typeof value !== "boolean") throw invalidAst(node, "value must be a boolean");
	}
	/**
	* Validate that a node property is an array containing only strings.
	*
	* @param {Object} node the AST node the property belongs to, for the error
	* @param {*} value the property value to validate
	* @param {string} name the property name, used in the error message
	* @returns {string[]} the validated array
	* @throws {Exception} if the value is not an array or contains non-strings
	*/
	function validateStringArray(node, value, name) {
		if (!_utils.isArray(value)) throw invalidAst(node, name + " must be an array");
		for (var i = 0; i < value.length; i++) if (typeof value[i] !== "string") throw invalidAst(node, name + " must only contain strings");
		return value;
	}
	/**
	* Validate the `parts` of a PathExpression node.
	*
	* @param {Object} path the PathExpression node
	* @returns {string[]} the validated parts
	* @throws {Exception} if `parts` is not an array of strings
	*/
	function validateParts(path) {
		return validateStringArray(path, path.parts, "parts");
	}
	/**
	* Validate the optional `blockParams` of a Program node. Its length is
	* written into the generated code, so it must be an array of strings when
	* present.
	*
	* @param {Object} program the Program node
	* @throws {Exception} if `blockParams` is present and not an array of strings
	*/
	function validateBlockParams(program) {
		if (program.blockParams != null) validateStringArray(program, program.blockParams, "blockParams");
	}
	function argEquals(a, b) {
		if (a === b) return true;
		if (_utils.isArray(a) && _utils.isArray(b) && a.length === b.length) {
			for (var i = 0; i < a.length; i++) if (!argEquals(a[i], b[i])) return false;
			return true;
		}
	}
	function transformLiteralToPath(sexpr) {
		if (!sexpr.path.parts) {
			var literal = sexpr.path;
			sexpr.path = {
				type: "PathExpression",
				data: false,
				depth: 0,
				parts: [literal.original + ""],
				original: literal.original + "",
				loc: literal.loc
			};
		}
	}
}));
// ../../node_modules/source-map/lib/base64.js
var require_base64 = /* @__PURE__ */ __commonJSMin(((exports) => {
	var intToCharMap = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
	/**
	* Encode an integer in the range of 0 to 63 to a single base 64 digit.
	*/
	exports.encode = function(number) {
		if (0 <= number && number < intToCharMap.length) return intToCharMap[number];
		throw new TypeError("Must be between 0 and 63: " + number);
	};
	/**
	* Decode a single base 64 character code digit to an integer. Returns -1 on
	* failure.
	*/
	exports.decode = function(charCode) {
		var bigA = 65;
		var bigZ = 90;
		var littleA = 97;
		var littleZ = 122;
		var zero = 48;
		var nine = 57;
		var plus = 43;
		var slash = 47;
		var littleOffset = 26;
		var numberOffset = 52;
		if (bigA <= charCode && charCode <= bigZ) return charCode - bigA;
		if (littleA <= charCode && charCode <= littleZ) return charCode - littleA + littleOffset;
		if (zero <= charCode && charCode <= nine) return charCode - zero + numberOffset;
		if (charCode == plus) return 62;
		if (charCode == slash) return 63;
		return -1;
	};
}));
// ../../node_modules/source-map/lib/base64-vlq.js
var require_base64_vlq = /* @__PURE__ */ __commonJSMin(((exports) => {
	var base64 = require_base64();
	var VLQ_BASE_SHIFT = 5;
	var VLQ_BASE = 1 << VLQ_BASE_SHIFT;
	var VLQ_BASE_MASK = VLQ_BASE - 1;
	var VLQ_CONTINUATION_BIT = VLQ_BASE;
	/**
	* Converts from a two-complement value to a value where the sign bit is
	* placed in the least significant bit.  For example, as decimals:
	*   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
	*   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
	*/
	function toVLQSigned(aValue) {
		return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
	}
	/**
	* Converts to a two-complement value from a value where the sign bit is
	* placed in the least significant bit.  For example, as decimals:
	*   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
	*   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
	*/
	function fromVLQSigned(aValue) {
		var isNegative = (aValue & 1) === 1;
		var shifted = aValue >> 1;
		return isNegative ? -shifted : shifted;
	}
	/**
	* Returns the base 64 VLQ encoded value.
	*/
	exports.encode = function base64VLQ_encode(aValue) {
		var encoded = "";
		var digit;
		var vlq = toVLQSigned(aValue);
		do {
			digit = vlq & VLQ_BASE_MASK;
			vlq >>>= VLQ_BASE_SHIFT;
			if (vlq > 0) digit |= VLQ_CONTINUATION_BIT;
			encoded += base64.encode(digit);
		} while (vlq > 0);
		return encoded;
	};
	/**
	* Decodes the next base 64 VLQ value from the given string and returns the
	* value and the rest of the string via the out parameter.
	*/
	exports.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
		var strLen = aStr.length;
		var result = 0;
		var shift = 0;
		var continuation, digit;
		do {
			if (aIndex >= strLen) throw new Error("Expected more digits in base 64 VLQ value.");
			digit = base64.decode(aStr.charCodeAt(aIndex++));
			if (digit === -1) throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
			continuation = !!(digit & VLQ_CONTINUATION_BIT);
			digit &= VLQ_BASE_MASK;
			result = result + (digit << shift);
			shift += VLQ_BASE_SHIFT;
		} while (continuation);
		aOutParam.value = fromVLQSigned(result);
		aOutParam.rest = aIndex;
	};
}));
// ../../node_modules/source-map/lib/util.js
var require_util = /* @__PURE__ */ __commonJSMin(((exports) => {
	/**
	* This is a helper function for getting values from parameter/options
	* objects.
	*
	* @param args The object we are extracting values from
	* @param name The name of the property we are getting.
	* @param defaultValue An optional value to return if the property is missing
	* from the object. If this is not specified and the property is missing, an
	* error will be thrown.
	*/
	function getArg(aArgs, aName, aDefaultValue) {
		if (aName in aArgs) return aArgs[aName];
		else if (arguments.length === 3) return aDefaultValue;
		else throw new Error("\"" + aName + "\" is a required argument.");
	}
	exports.getArg = getArg;
	var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/;
	var dataUrlRegexp = /^data:.+\,.+$/;
	function urlParse(aUrl) {
		var match = aUrl.match(urlRegexp);
		if (!match) return null;
		return {
			scheme: match[1],
			auth: match[2],
			host: match[3],
			port: match[4],
			path: match[5]
		};
	}
	exports.urlParse = urlParse;
	function urlGenerate(aParsedUrl) {
		var url = "";
		if (aParsedUrl.scheme) url += aParsedUrl.scheme + ":";
		url += "//";
		if (aParsedUrl.auth) url += aParsedUrl.auth + "@";
		if (aParsedUrl.host) url += aParsedUrl.host;
		if (aParsedUrl.port) url += ":" + aParsedUrl.port;
		if (aParsedUrl.path) url += aParsedUrl.path;
		return url;
	}
	exports.urlGenerate = urlGenerate;
	/**
	* Normalizes a path, or the path portion of a URL:
	*
	* - Replaces consecutive slashes with one slash.
	* - Removes unnecessary '.' parts.
	* - Removes unnecessary '<dir>/..' parts.
	*
	* Based on code in the Node.js 'path' core module.
	*
	* @param aPath The path or url to normalize.
	*/
	function normalize(aPath) {
		var path = aPath;
		var url = urlParse(aPath);
		if (url) {
			if (!url.path) return aPath;
			path = url.path;
		}
		var isAbsolute = exports.isAbsolute(path);
		var parts = path.split(/\/+/);
		for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
			part = parts[i];
			if (part === ".") parts.splice(i, 1);
			else if (part === "..") up++;
			else if (up > 0) {
				if (part === "") {
					parts.splice(i + 1, up);
					up = 0;
				} else {
					parts.splice(i, 2);
					up--;
				}
			}
		}
		path = parts.join("/");
		if (path === "") path = isAbsolute ? "/" : ".";
		if (url) {
			url.path = path;
			return urlGenerate(url);
		}
		return path;
	}
	exports.normalize = normalize;
	/**
	* Joins two paths/URLs.
	*
	* @param aRoot The root path or URL.
	* @param aPath The path or URL to be joined with the root.
	*
	* - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
	*   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
	*   first.
	* - Otherwise aPath is a path. If aRoot is a URL, then its path portion
	*   is updated with the result and aRoot is returned. Otherwise the result
	*   is returned.
	*   - If aPath is absolute, the result is aPath.
	*   - Otherwise the two paths are joined with a slash.
	* - Joining for example 'http://' and 'www.example.com' is also supported.
	*/
	function join(aRoot, aPath) {
		if (aRoot === "") aRoot = ".";
		if (aPath === "") aPath = ".";
		var aPathUrl = urlParse(aPath);
		var aRootUrl = urlParse(aRoot);
		if (aRootUrl) aRoot = aRootUrl.path || "/";
		if (aPathUrl && !aPathUrl.scheme) {
			if (aRootUrl) aPathUrl.scheme = aRootUrl.scheme;
			return urlGenerate(aPathUrl);
		}
		if (aPathUrl || aPath.match(dataUrlRegexp)) return aPath;
		if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
			aRootUrl.host = aPath;
			return urlGenerate(aRootUrl);
		}
		var joined = aPath.charAt(0) === "/" ? aPath : normalize(aRoot.replace(/\/+$/, "") + "/" + aPath);
		if (aRootUrl) {
			aRootUrl.path = joined;
			return urlGenerate(aRootUrl);
		}
		return joined;
	}
	exports.join = join;
	exports.isAbsolute = function(aPath) {
		return aPath.charAt(0) === "/" || urlRegexp.test(aPath);
	};
	/**
	* Make a path relative to a URL or another path.
	*
	* @param aRoot The root path or URL.
	* @param aPath The path or URL to be made relative to aRoot.
	*/
	function relative(aRoot, aPath) {
		if (aRoot === "") aRoot = ".";
		aRoot = aRoot.replace(/\/$/, "");
		var level = 0;
		while (aPath.indexOf(aRoot + "/") !== 0) {
			var index = aRoot.lastIndexOf("/");
			if (index < 0) return aPath;
			aRoot = aRoot.slice(0, index);
			if (aRoot.match(/^([^\/]+:\/)?\/*$/)) return aPath;
			++level;
		}
		return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
	}
	exports.relative = relative;
	var supportsNullProto = function() {
		return !("__proto__" in Object.create(null));
	}();
	function identity(s) {
		return s;
	}
	/**
	* Because behavior goes wacky when you set `__proto__` on objects, we
	* have to prefix all the strings in our set with an arbitrary character.
	*
	* See https://github.com/mozilla/source-map/pull/31 and
	* https://github.com/mozilla/source-map/issues/30
	*
	* @param String aStr
	*/
	function toSetString(aStr) {
		if (isProtoString(aStr)) return "$" + aStr;
		return aStr;
	}
	exports.toSetString = supportsNullProto ? identity : toSetString;
	function fromSetString(aStr) {
		if (isProtoString(aStr)) return aStr.slice(1);
		return aStr;
	}
	exports.fromSetString = supportsNullProto ? identity : fromSetString;
	function isProtoString(s) {
		if (!s) return false;
		var length = s.length;
		if (length < 9) return false;
		if (s.charCodeAt(length - 1) !== 95 || s.charCodeAt(length - 2) !== 95 || s.charCodeAt(length - 3) !== 111 || s.charCodeAt(length - 4) !== 116 || s.charCodeAt(length - 5) !== 111 || s.charCodeAt(length - 6) !== 114 || s.charCodeAt(length - 7) !== 112 || s.charCodeAt(length - 8) !== 95 || s.charCodeAt(length - 9) !== 95) return false;
		for (var i = length - 10; i >= 0; i--) if (s.charCodeAt(i) !== 36) return false;
		return true;
	}
	/**
	* Comparator between two mappings where the original positions are compared.
	*
	* Optionally pass in `true` as `onlyCompareGenerated` to consider two
	* mappings with the same original source/line/column, but different generated
	* line and column the same. Useful when searching for a mapping with a
	* stubbed out mapping.
	*/
	function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
		var cmp = strcmp(mappingA.source, mappingB.source);
		if (cmp !== 0) return cmp;
		cmp = mappingA.originalLine - mappingB.originalLine;
		if (cmp !== 0) return cmp;
		cmp = mappingA.originalColumn - mappingB.originalColumn;
		if (cmp !== 0 || onlyCompareOriginal) return cmp;
		cmp = mappingA.generatedColumn - mappingB.generatedColumn;
		if (cmp !== 0) return cmp;
		cmp = mappingA.generatedLine - mappingB.generatedLine;
		if (cmp !== 0) return cmp;
		return strcmp(mappingA.name, mappingB.name);
	}
	exports.compareByOriginalPositions = compareByOriginalPositions;
	/**
	* Comparator between two mappings with deflated source and name indices where
	* the generated positions are compared.
	*
	* Optionally pass in `true` as `onlyCompareGenerated` to consider two
	* mappings with the same generated line and column, but different
	* source/name/original line and column the same. Useful when searching for a
	* mapping with a stubbed out mapping.
	*/
	function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
		var cmp = mappingA.generatedLine - mappingB.generatedLine;
		if (cmp !== 0) return cmp;
		cmp = mappingA.generatedColumn - mappingB.generatedColumn;
		if (cmp !== 0 || onlyCompareGenerated) return cmp;
		cmp = strcmp(mappingA.source, mappingB.source);
		if (cmp !== 0) return cmp;
		cmp = mappingA.originalLine - mappingB.originalLine;
		if (cmp !== 0) return cmp;
		cmp = mappingA.originalColumn - mappingB.originalColumn;
		if (cmp !== 0) return cmp;
		return strcmp(mappingA.name, mappingB.name);
	}
	exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;
	function strcmp(aStr1, aStr2) {
		if (aStr1 === aStr2) return 0;
		if (aStr1 === null) return 1;
		if (aStr2 === null) return -1;
		if (aStr1 > aStr2) return 1;
		return -1;
	}
	/**
	* Comparator between two mappings with inflated source and name strings where
	* the generated positions are compared.
	*/
	function compareByGeneratedPositionsInflated(mappingA, mappingB) {
		var cmp = mappingA.generatedLine - mappingB.generatedLine;
		if (cmp !== 0) return cmp;
		cmp = mappingA.generatedColumn - mappingB.generatedColumn;
		if (cmp !== 0) return cmp;
		cmp = strcmp(mappingA.source, mappingB.source);
		if (cmp !== 0) return cmp;
		cmp = mappingA.originalLine - mappingB.originalLine;
		if (cmp !== 0) return cmp;
		cmp = mappingA.originalColumn - mappingB.originalColumn;
		if (cmp !== 0) return cmp;
		return strcmp(mappingA.name, mappingB.name);
	}
	exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;
	/**
	* Strip any JSON XSSI avoidance prefix from the string (as documented
	* in the source maps specification), and then parse the string as
	* JSON.
	*/
	function parseSourceMapInput(str) {
		return JSON.parse(str.replace(/^\)]}'[^\n]*\n/, ""));
	}
	exports.parseSourceMapInput = parseSourceMapInput;
	/**
	* Compute the URL of a source given the the source root, the source's
	* URL, and the source map's URL.
	*/
	function computeSourceURL(sourceRoot, sourceURL, sourceMapURL) {
		sourceURL = sourceURL || "";
		if (sourceRoot) {
			if (sourceRoot[sourceRoot.length - 1] !== "/" && sourceURL[0] !== "/") sourceRoot += "/";
			sourceURL = sourceRoot + sourceURL;
		}
		if (sourceMapURL) {
			var parsed = urlParse(sourceMapURL);
			if (!parsed) throw new Error("sourceMapURL could not be parsed");
			if (parsed.path) {
				var index = parsed.path.lastIndexOf("/");
				if (index >= 0) parsed.path = parsed.path.substring(0, index + 1);
			}
			sourceURL = join(urlGenerate(parsed), sourceURL);
		}
		return normalize(sourceURL);
	}
	exports.computeSourceURL = computeSourceURL;
}));
// ../../node_modules/source-map/lib/array-set.js
var require_array_set = /* @__PURE__ */ __commonJSMin(((exports) => {
	var util = require_util();
	var has = Object.prototype.hasOwnProperty;
	var hasNativeMap = typeof Map !== "undefined";
	/**
	* A data structure which is a combination of an array and a set. Adding a new
	* member is O(1), testing for membership is O(1), and finding the index of an
	* element is O(1). Removing elements from the set is not supported. Only
	* strings are supported for membership.
	*/
	function ArraySet() {
		this._array = [];
		this._set = hasNativeMap ? /* @__PURE__ */ new Map() : Object.create(null);
	}
	/**
	* Static method for creating ArraySet instances from an existing array.
	*/
	ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
		var set = new ArraySet();
		for (var i = 0, len = aArray.length; i < len; i++) set.add(aArray[i], aAllowDuplicates);
		return set;
	};
	/**
	* Return how many unique items are in this ArraySet. If duplicates have been
	* added, than those do not count towards the size.
	*
	* @returns Number
	*/
	ArraySet.prototype.size = function ArraySet_size() {
		return hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
	};
	/**
	* Add the given string to this set.
	*
	* @param String aStr
	*/
	ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
		var sStr = hasNativeMap ? aStr : util.toSetString(aStr);
		var isDuplicate = hasNativeMap ? this.has(aStr) : has.call(this._set, sStr);
		var idx = this._array.length;
		if (!isDuplicate || aAllowDuplicates) this._array.push(aStr);
		if (!isDuplicate) {
			if (hasNativeMap) this._set.set(aStr, idx);
			else this._set[sStr] = idx;
		}
	};
	/**
	* Is the given string a member of this set?
	*
	* @param String aStr
	*/
	ArraySet.prototype.has = function ArraySet_has(aStr) {
		if (hasNativeMap) return this._set.has(aStr);
		else {
			var sStr = util.toSetString(aStr);
			return has.call(this._set, sStr);
		}
	};
	/**
	* What is the index of the given string in the array?
	*
	* @param String aStr
	*/
	ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
		if (hasNativeMap) {
			var idx = this._set.get(aStr);
			if (idx >= 0) return idx;
		} else {
			var sStr = util.toSetString(aStr);
			if (has.call(this._set, sStr)) return this._set[sStr];
		}
		throw new Error("\"" + aStr + "\" is not in the set.");
	};
	/**
	* What is the element at the given index?
	*
	* @param Number aIdx
	*/
	ArraySet.prototype.at = function ArraySet_at(aIdx) {
		if (aIdx >= 0 && aIdx < this._array.length) return this._array[aIdx];
		throw new Error("No element indexed by " + aIdx);
	};
	/**
	* Returns the array representation of this set (which has the proper indices
	* indicated by indexOf). Note that this is a copy of the internal array used
	* for storing the members so that no one can mess with internal state.
	*/
	ArraySet.prototype.toArray = function ArraySet_toArray() {
		return this._array.slice();
	};
	exports.ArraySet = ArraySet;
}));
// ../../node_modules/source-map/lib/mapping-list.js
var require_mapping_list = /* @__PURE__ */ __commonJSMin(((exports) => {
	var util = require_util();
	/**
	* Determine whether mappingB is after mappingA with respect to generated
	* position.
	*/
	function generatedPositionAfter(mappingA, mappingB) {
		var lineA = mappingA.generatedLine;
		var lineB = mappingB.generatedLine;
		var columnA = mappingA.generatedColumn;
		var columnB = mappingB.generatedColumn;
		return lineB > lineA || lineB == lineA && columnB >= columnA || util.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
	}
	/**
	* A data structure to provide a sorted view of accumulated mappings in a
	* performance conscious manner. It trades a neglibable overhead in general
	* case for a large speedup in case of mappings being added in order.
	*/
	function MappingList() {
		this._array = [];
		this._sorted = true;
		this._last = {
			generatedLine: -1,
			generatedColumn: 0
		};
	}
	/**
	* Iterate through internal items. This method takes the same arguments that
	* `Array.prototype.forEach` takes.
	*
	* NOTE: The order of the mappings is NOT guaranteed.
	*/
	MappingList.prototype.unsortedForEach = function MappingList_forEach(aCallback, aThisArg) {
		this._array.forEach(aCallback, aThisArg);
	};
	/**
	* Add the given source mapping.
	*
	* @param Object aMapping
	*/
	MappingList.prototype.add = function MappingList_add(aMapping) {
		if (generatedPositionAfter(this._last, aMapping)) {
			this._last = aMapping;
			this._array.push(aMapping);
		} else {
			this._sorted = false;
			this._array.push(aMapping);
		}
	};
	/**
	* Returns the flat, sorted array of mappings. The mappings are sorted by
	* generated position.
	*
	* WARNING: This method returns internal data without copying, for
	* performance. The return value must NOT be mutated, and should be treated as
	* an immutable borrow. If you want to take ownership, you must make your own
	* copy.
	*/
	MappingList.prototype.toArray = function MappingList_toArray() {
		if (!this._sorted) {
			this._array.sort(util.compareByGeneratedPositionsInflated);
			this._sorted = true;
		}
		return this._array;
	};
	exports.MappingList = MappingList;
}));
// ../../node_modules/source-map/lib/source-map-generator.js
var require_source_map_generator = /* @__PURE__ */ __commonJSMin(((exports) => {
	var base64VLQ = require_base64_vlq();
	var util = require_util();
	var ArraySet = require_array_set().ArraySet;
	var MappingList = require_mapping_list().MappingList;
	/**
	* An instance of the SourceMapGenerator represents a source map which is
	* being built incrementally. You may pass an object with the following
	* properties:
	*
	*   - file: The filename of the generated source.
	*   - sourceRoot: A root for all relative URLs in this source map.
	*/
	function SourceMapGenerator(aArgs) {
		if (!aArgs) aArgs = {};
		this._file = util.getArg(aArgs, "file", null);
		this._sourceRoot = util.getArg(aArgs, "sourceRoot", null);
		this._skipValidation = util.getArg(aArgs, "skipValidation", false);
		this._sources = new ArraySet();
		this._names = new ArraySet();
		this._mappings = new MappingList();
		this._sourcesContents = null;
	}
	SourceMapGenerator.prototype._version = 3;
	/**
	* Creates a new SourceMapGenerator based on a SourceMapConsumer
	*
	* @param aSourceMapConsumer The SourceMap.
	*/
	SourceMapGenerator.fromSourceMap = function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
		var sourceRoot = aSourceMapConsumer.sourceRoot;
		var generator = new SourceMapGenerator({
			file: aSourceMapConsumer.file,
			sourceRoot
		});
		aSourceMapConsumer.eachMapping(function(mapping) {
			var newMapping = { generated: {
				line: mapping.generatedLine,
				column: mapping.generatedColumn
			} };
			if (mapping.source != null) {
				newMapping.source = mapping.source;
				if (sourceRoot != null) newMapping.source = util.relative(sourceRoot, newMapping.source);
				newMapping.original = {
					line: mapping.originalLine,
					column: mapping.originalColumn
				};
				if (mapping.name != null) newMapping.name = mapping.name;
			}
			generator.addMapping(newMapping);
		});
		aSourceMapConsumer.sources.forEach(function(sourceFile) {
			var sourceRelative = sourceFile;
			if (sourceRoot !== null) sourceRelative = util.relative(sourceRoot, sourceFile);
			if (!generator._sources.has(sourceRelative)) generator._sources.add(sourceRelative);
			var content = aSourceMapConsumer.sourceContentFor(sourceFile);
			if (content != null) generator.setSourceContent(sourceFile, content);
		});
		return generator;
	};
	/**
	* Add a single mapping from original source line and column to the generated
	* source's line and column for this source map being created. The mapping
	* object should have the following properties:
	*
	*   - generated: An object with the generated line and column positions.
	*   - original: An object with the original line and column positions.
	*   - source: The original source file (relative to the sourceRoot).
	*   - name: An optional original token name for this mapping.
	*/
	SourceMapGenerator.prototype.addMapping = function SourceMapGenerator_addMapping(aArgs) {
		var generated = util.getArg(aArgs, "generated");
		var original = util.getArg(aArgs, "original", null);
		var source = util.getArg(aArgs, "source", null);
		var name = util.getArg(aArgs, "name", null);
		if (!this._skipValidation) this._validateMapping(generated, original, source, name);
		if (source != null) {
			source = String(source);
			if (!this._sources.has(source)) this._sources.add(source);
		}
		if (name != null) {
			name = String(name);
			if (!this._names.has(name)) this._names.add(name);
		}
		this._mappings.add({
			generatedLine: generated.line,
			generatedColumn: generated.column,
			originalLine: original != null && original.line,
			originalColumn: original != null && original.column,
			source,
			name
		});
	};
	/**
	* Set the source content for a source file.
	*/
	SourceMapGenerator.prototype.setSourceContent = function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
		var source = aSourceFile;
		if (this._sourceRoot != null) source = util.relative(this._sourceRoot, source);
		if (aSourceContent != null) {
			if (!this._sourcesContents) this._sourcesContents = Object.create(null);
			this._sourcesContents[util.toSetString(source)] = aSourceContent;
		} else if (this._sourcesContents) {
			delete this._sourcesContents[util.toSetString(source)];
			if (Object.keys(this._sourcesContents).length === 0) this._sourcesContents = null;
		}
	};
	/**
	* Applies the mappings of a sub-source-map for a specific source file to the
	* source map being generated. Each mapping to the supplied source file is
	* rewritten using the supplied source map. Note: The resolution for the
	* resulting mappings is the minimium of this map and the supplied map.
	*
	* @param aSourceMapConsumer The source map to be applied.
	* @param aSourceFile Optional. The filename of the source file.
	*        If omitted, SourceMapConsumer's file property will be used.
	* @param aSourceMapPath Optional. The dirname of the path to the source map
	*        to be applied. If relative, it is relative to the SourceMapConsumer.
	*        This parameter is needed when the two source maps aren't in the same
	*        directory, and the source map to be applied contains relative source
	*        paths. If so, those relative source paths need to be rewritten
	*        relative to the SourceMapGenerator.
	*/
	SourceMapGenerator.prototype.applySourceMap = function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
		var sourceFile = aSourceFile;
		if (aSourceFile == null) {
			if (aSourceMapConsumer.file == null) throw new Error("SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map's \"file\" property. Both were omitted.");
			sourceFile = aSourceMapConsumer.file;
		}
		var sourceRoot = this._sourceRoot;
		if (sourceRoot != null) sourceFile = util.relative(sourceRoot, sourceFile);
		var newSources = new ArraySet();
		var newNames = new ArraySet();
		this._mappings.unsortedForEach(function(mapping) {
			if (mapping.source === sourceFile && mapping.originalLine != null) {
				var original = aSourceMapConsumer.originalPositionFor({
					line: mapping.originalLine,
					column: mapping.originalColumn
				});
				if (original.source != null) {
					mapping.source = original.source;
					if (aSourceMapPath != null) mapping.source = util.join(aSourceMapPath, mapping.source);
					if (sourceRoot != null) mapping.source = util.relative(sourceRoot, mapping.source);
					mapping.originalLine = original.line;
					mapping.originalColumn = original.column;
					if (original.name != null) mapping.name = original.name;
				}
			}
			var source = mapping.source;
			if (source != null && !newSources.has(source)) newSources.add(source);
			var name = mapping.name;
			if (name != null && !newNames.has(name)) newNames.add(name);
		}, this);
		this._sources = newSources;
		this._names = newNames;
		aSourceMapConsumer.sources.forEach(function(sourceFile) {
			var content = aSourceMapConsumer.sourceContentFor(sourceFile);
			if (content != null) {
				if (aSourceMapPath != null) sourceFile = util.join(aSourceMapPath, sourceFile);
				if (sourceRoot != null) sourceFile = util.relative(sourceRoot, sourceFile);
				this.setSourceContent(sourceFile, content);
			}
		}, this);
	};
	/**
	* A mapping can have one of the three levels of data:
	*
	*   1. Just the generated position.
	*   2. The Generated position, original position, and original source.
	*   3. Generated and original position, original source, as well as a name
	*      token.
	*
	* To maintain consistency, we validate that any new mapping being added falls
	* in to one of these categories.
	*/
	SourceMapGenerator.prototype._validateMapping = function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource, aName) {
		if (aOriginal && typeof aOriginal.line !== "number" && typeof aOriginal.column !== "number") throw new Error("original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values.");
		if (aGenerated && "line" in aGenerated && "column" in aGenerated && aGenerated.line > 0 && aGenerated.column >= 0 && !aOriginal && !aSource && !aName) return;
		else if (aGenerated && "line" in aGenerated && "column" in aGenerated && aOriginal && "line" in aOriginal && "column" in aOriginal && aGenerated.line > 0 && aGenerated.column >= 0 && aOriginal.line > 0 && aOriginal.column >= 0 && aSource) return;
		else throw new Error("Invalid mapping: " + JSON.stringify({
			generated: aGenerated,
			source: aSource,
			original: aOriginal,
			name: aName
		}));
	};
	/**
	* Serialize the accumulated mappings in to the stream of base 64 VLQs
	* specified by the source map format.
	*/
	SourceMapGenerator.prototype._serializeMappings = function SourceMapGenerator_serializeMappings() {
		var previousGeneratedColumn = 0;
		var previousGeneratedLine = 1;
		var previousOriginalColumn = 0;
		var previousOriginalLine = 0;
		var previousName = 0;
		var previousSource = 0;
		var result = "";
		var next;
		var mapping;
		var nameIdx;
		var sourceIdx;
		var mappings = this._mappings.toArray();
		for (var i = 0, len = mappings.length; i < len; i++) {
			mapping = mappings[i];
			next = "";
			if (mapping.generatedLine !== previousGeneratedLine) {
				previousGeneratedColumn = 0;
				while (mapping.generatedLine !== previousGeneratedLine) {
					next += ";";
					previousGeneratedLine++;
				}
			} else if (i > 0) {
				if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) continue;
				next += ",";
			}
			next += base64VLQ.encode(mapping.generatedColumn - previousGeneratedColumn);
			previousGeneratedColumn = mapping.generatedColumn;
			if (mapping.source != null) {
				sourceIdx = this._sources.indexOf(mapping.source);
				next += base64VLQ.encode(sourceIdx - previousSource);
				previousSource = sourceIdx;
				next += base64VLQ.encode(mapping.originalLine - 1 - previousOriginalLine);
				previousOriginalLine = mapping.originalLine - 1;
				next += base64VLQ.encode(mapping.originalColumn - previousOriginalColumn);
				previousOriginalColumn = mapping.originalColumn;
				if (mapping.name != null) {
					nameIdx = this._names.indexOf(mapping.name);
					next += base64VLQ.encode(nameIdx - previousName);
					previousName = nameIdx;
				}
			}
			result += next;
		}
		return result;
	};
	SourceMapGenerator.prototype._generateSourcesContent = function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
		return aSources.map(function(source) {
			if (!this._sourcesContents) return null;
			if (aSourceRoot != null) source = util.relative(aSourceRoot, source);
			var key = util.toSetString(source);
			return Object.prototype.hasOwnProperty.call(this._sourcesContents, key) ? this._sourcesContents[key] : null;
		}, this);
	};
	/**
	* Externalize the source map.
	*/
	SourceMapGenerator.prototype.toJSON = function SourceMapGenerator_toJSON() {
		var map = {
			version: this._version,
			sources: this._sources.toArray(),
			names: this._names.toArray(),
			mappings: this._serializeMappings()
		};
		if (this._file != null) map.file = this._file;
		if (this._sourceRoot != null) map.sourceRoot = this._sourceRoot;
		if (this._sourcesContents) map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
		return map;
	};
	/**
	* Render the source map being generated to a string.
	*/
	SourceMapGenerator.prototype.toString = function SourceMapGenerator_toString() {
		return JSON.stringify(this.toJSON());
	};
	exports.SourceMapGenerator = SourceMapGenerator;
}));
// ../../node_modules/source-map/lib/binary-search.js
var require_binary_search = /* @__PURE__ */ __commonJSMin(((exports) => {
	exports.GREATEST_LOWER_BOUND = 1;
	exports.LEAST_UPPER_BOUND = 2;
	/**
	* Recursive implementation of binary search.
	*
	* @param aLow Indices here and lower do not contain the needle.
	* @param aHigh Indices here and higher do not contain the needle.
	* @param aNeedle The element being searched for.
	* @param aHaystack The non-empty array being searched.
	* @param aCompare Function which takes two elements and returns -1, 0, or 1.
	* @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	*     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	*     closest element that is smaller than or greater than the one we are
	*     searching for, respectively, if the exact element cannot be found.
	*/
	function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
		var mid = Math.floor((aHigh - aLow) / 2) + aLow;
		var cmp = aCompare(aNeedle, aHaystack[mid], true);
		if (cmp === 0) return mid;
		else if (cmp > 0) {
			if (aHigh - mid > 1) return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
			if (aBias == exports.LEAST_UPPER_BOUND) return aHigh < aHaystack.length ? aHigh : -1;
			else return mid;
		} else {
			if (mid - aLow > 1) return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
			if (aBias == exports.LEAST_UPPER_BOUND) return mid;
			else return aLow < 0 ? -1 : aLow;
		}
	}
	/**
	* This is an implementation of binary search which will always try and return
	* the index of the closest element if there is no exact hit. This is because
	* mappings between original and generated line/col pairs are single points,
	* and there is an implicit region between each of them, so a miss just means
	* that you aren't on the very start of a region.
	*
	* @param aNeedle The element you are looking for.
	* @param aHaystack The array that is being searched.
	* @param aCompare A function which takes the needle and an element in the
	*     array and returns -1, 0, or 1 depending on whether the needle is less
	*     than, equal to, or greater than the element, respectively.
	* @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	*     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	*     closest element that is smaller than or greater than the one we are
	*     searching for, respectively, if the exact element cannot be found.
	*     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
	*/
	exports.search = function search(aNeedle, aHaystack, aCompare, aBias) {
		if (aHaystack.length === 0) return -1;
		var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack, aCompare, aBias || exports.GREATEST_LOWER_BOUND);
		if (index < 0) return -1;
		while (index - 1 >= 0) {
			if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) break;
			--index;
		}
		return index;
	};
}));
// ../../node_modules/source-map/lib/quick-sort.js
var require_quick_sort = /* @__PURE__ */ __commonJSMin(((exports) => {
	/**
	* Swap the elements indexed by `x` and `y` in the array `ary`.
	*
	* @param {Array} ary
	*        The array.
	* @param {Number} x
	*        The index of the first item.
	* @param {Number} y
	*        The index of the second item.
	*/
	function swap(ary, x, y) {
		var temp = ary[x];
		ary[x] = ary[y];
		ary[y] = temp;
	}
	/**
	* Returns a random integer within the range `low .. high` inclusive.
	*
	* @param {Number} low
	*        The lower bound on the range.
	* @param {Number} high
	*        The upper bound on the range.
	*/
	function randomIntInRange(low, high) {
		return Math.round(low + Math.random() * (high - low));
	}
	/**
	* The Quick Sort algorithm.
	*
	* @param {Array} ary
	*        An array to sort.
	* @param {function} comparator
	*        Function to use to compare two items.
	* @param {Number} p
	*        Start index of the array
	* @param {Number} r
	*        End index of the array
	*/
	function doQuickSort(ary, comparator, p, r) {
		if (p < r) {
			var pivotIndex = randomIntInRange(p, r);
			var i = p - 1;
			swap(ary, pivotIndex, r);
			var pivot = ary[r];
			for (var j = p; j < r; j++) if (comparator(ary[j], pivot) <= 0) {
				i += 1;
				swap(ary, i, j);
			}
			swap(ary, i + 1, j);
			var q = i + 1;
			doQuickSort(ary, comparator, p, q - 1);
			doQuickSort(ary, comparator, q + 1, r);
		}
	}
	/**
	* Sort the given array in-place with the given comparator function.
	*
	* @param {Array} ary
	*        An array to sort.
	* @param {function} comparator
	*        Function to use to compare two items.
	*/
	exports.quickSort = function(ary, comparator) {
		doQuickSort(ary, comparator, 0, ary.length - 1);
	};
}));
// ../../node_modules/source-map/lib/source-map-consumer.js
var require_source_map_consumer = /* @__PURE__ */ __commonJSMin(((exports) => {
	var util = require_util();
	var binarySearch = require_binary_search();
	var ArraySet = require_array_set().ArraySet;
	var base64VLQ = require_base64_vlq();
	var quickSort = require_quick_sort().quickSort;
	function SourceMapConsumer(aSourceMap, aSourceMapURL) {
		var sourceMap = aSourceMap;
		if (typeof aSourceMap === "string") sourceMap = util.parseSourceMapInput(aSourceMap);
		return sourceMap.sections != null ? new IndexedSourceMapConsumer(sourceMap, aSourceMapURL) : new BasicSourceMapConsumer(sourceMap, aSourceMapURL);
	}
	SourceMapConsumer.fromSourceMap = function(aSourceMap, aSourceMapURL) {
		return BasicSourceMapConsumer.fromSourceMap(aSourceMap, aSourceMapURL);
	};
	/**
	* The version of the source mapping spec that we are consuming.
	*/
	SourceMapConsumer.prototype._version = 3;
	SourceMapConsumer.prototype.__generatedMappings = null;
	Object.defineProperty(SourceMapConsumer.prototype, "_generatedMappings", {
		configurable: true,
		enumerable: true,
		get: function() {
			if (!this.__generatedMappings) this._parseMappings(this._mappings, this.sourceRoot);
			return this.__generatedMappings;
		}
	});
	SourceMapConsumer.prototype.__originalMappings = null;
	Object.defineProperty(SourceMapConsumer.prototype, "_originalMappings", {
		configurable: true,
		enumerable: true,
		get: function() {
			if (!this.__originalMappings) this._parseMappings(this._mappings, this.sourceRoot);
			return this.__originalMappings;
		}
	});
	SourceMapConsumer.prototype._charIsMappingSeparator = function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
		var c = aStr.charAt(index);
		return c === ";" || c === ",";
	};
	/**
	* Parse the mappings in a string in to a data structure which we can easily
	* query (the ordered arrays in the `this.__generatedMappings` and
	* `this.__originalMappings` properties).
	*/
	SourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
		throw new Error("Subclasses must implement _parseMappings");
	};
	SourceMapConsumer.GENERATED_ORDER = 1;
	SourceMapConsumer.ORIGINAL_ORDER = 2;
	SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
	SourceMapConsumer.LEAST_UPPER_BOUND = 2;
	/**
	* Iterate over each mapping between an original source/line/column and a
	* generated line/column in this source map.
	*
	* @param Function aCallback
	*        The function that is called with each mapping.
	* @param Object aContext
	*        Optional. If specified, this object will be the value of `this` every
	*        time that `aCallback` is called.
	* @param aOrder
	*        Either `SourceMapConsumer.GENERATED_ORDER` or
	*        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
	*        iterate over the mappings sorted by the generated file's line/column
	*        order or the original's source/line/column order, respectively. Defaults to
	*        `SourceMapConsumer.GENERATED_ORDER`.
	*/
	SourceMapConsumer.prototype.eachMapping = function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
		var context = aContext || null;
		var order = aOrder || SourceMapConsumer.GENERATED_ORDER;
		var mappings;
		switch (order) {
			case SourceMapConsumer.GENERATED_ORDER:
				mappings = this._generatedMappings;
				break;
			case SourceMapConsumer.ORIGINAL_ORDER:
				mappings = this._originalMappings;
				break;
			default: throw new Error("Unknown order of iteration.");
		}
		var sourceRoot = this.sourceRoot;
		mappings.map(function(mapping) {
			var source = mapping.source === null ? null : this._sources.at(mapping.source);
			source = util.computeSourceURL(sourceRoot, source, this._sourceMapURL);
			return {
				source,
				generatedLine: mapping.generatedLine,
				generatedColumn: mapping.generatedColumn,
				originalLine: mapping.originalLine,
				originalColumn: mapping.originalColumn,
				name: mapping.name === null ? null : this._names.at(mapping.name)
			};
		}, this).forEach(aCallback, context);
	};
	/**
	* Returns all generated line and column information for the original source,
	* line, and column provided. If no column is provided, returns all mappings
	* corresponding to a either the line we are searching for or the next
	* closest line that has any mappings. Otherwise, returns all mappings
	* corresponding to the given line and either the column we are searching for
	* or the next closest column that has any offsets.
	*
	* The only argument is an object with the following properties:
	*
	*   - source: The filename of the original source.
	*   - line: The line number in the original source.  The line number is 1-based.
	*   - column: Optional. the column number in the original source.
	*    The column number is 0-based.
	*
	* and an array of objects is returned, each with the following properties:
	*
	*   - line: The line number in the generated source, or null.  The
	*    line number is 1-based.
	*   - column: The column number in the generated source, or null.
	*    The column number is 0-based.
	*/
	SourceMapConsumer.prototype.allGeneratedPositionsFor = function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
		var line = util.getArg(aArgs, "line");
		var needle = {
			source: util.getArg(aArgs, "source"),
			originalLine: line,
			originalColumn: util.getArg(aArgs, "column", 0)
		};
		needle.source = this._findSourceIndex(needle.source);
		if (needle.source < 0) return [];
		var mappings = [];
		var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", util.compareByOriginalPositions, binarySearch.LEAST_UPPER_BOUND);
		if (index >= 0) {
			var mapping = this._originalMappings[index];
			if (aArgs.column === void 0) {
				var originalLine = mapping.originalLine;
				while (mapping && mapping.originalLine === originalLine) {
					mappings.push({
						line: util.getArg(mapping, "generatedLine", null),
						column: util.getArg(mapping, "generatedColumn", null),
						lastColumn: util.getArg(mapping, "lastGeneratedColumn", null)
					});
					mapping = this._originalMappings[++index];
				}
			} else {
				var originalColumn = mapping.originalColumn;
				while (mapping && mapping.originalLine === line && mapping.originalColumn == originalColumn) {
					mappings.push({
						line: util.getArg(mapping, "generatedLine", null),
						column: util.getArg(mapping, "generatedColumn", null),
						lastColumn: util.getArg(mapping, "lastGeneratedColumn", null)
					});
					mapping = this._originalMappings[++index];
				}
			}
		}
		return mappings;
	};
	exports.SourceMapConsumer = SourceMapConsumer;
	/**
	* A BasicSourceMapConsumer instance represents a parsed source map which we can
	* query for information about the original file positions by giving it a file
	* position in the generated source.
	*
	* The first parameter is the raw source map (either as a JSON string, or
	* already parsed to an object). According to the spec, source maps have the
	* following attributes:
	*
	*   - version: Which version of the source map spec this map is following.
	*   - sources: An array of URLs to the original source files.
	*   - names: An array of identifiers which can be referrenced by individual mappings.
	*   - sourceRoot: Optional. The URL root from which all sources are relative.
	*   - sourcesContent: Optional. An array of contents of the original source files.
	*   - mappings: A string of base64 VLQs which contain the actual mappings.
	*   - file: Optional. The generated file this source map is associated with.
	*
	* Here is an example source map, taken from the source map spec[0]:
	*
	*     {
	*       version : 3,
	*       file: "out.js",
	*       sourceRoot : "",
	*       sources: ["foo.js", "bar.js"],
	*       names: ["src", "maps", "are", "fun"],
	*       mappings: "AA,AB;;ABCDE;"
	*     }
	*
	* The second parameter, if given, is a string whose value is the URL
	* at which the source map was found.  This URL is used to compute the
	* sources array.
	*
	* [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
	*/
	function BasicSourceMapConsumer(aSourceMap, aSourceMapURL) {
		var sourceMap = aSourceMap;
		if (typeof aSourceMap === "string") sourceMap = util.parseSourceMapInput(aSourceMap);
		var version = util.getArg(sourceMap, "version");
		var sources = util.getArg(sourceMap, "sources");
		var names = util.getArg(sourceMap, "names", []);
		var sourceRoot = util.getArg(sourceMap, "sourceRoot", null);
		var sourcesContent = util.getArg(sourceMap, "sourcesContent", null);
		var mappings = util.getArg(sourceMap, "mappings");
		var file = util.getArg(sourceMap, "file", null);
		if (version != this._version) throw new Error("Unsupported version: " + version);
		if (sourceRoot) sourceRoot = util.normalize(sourceRoot);
		sources = sources.map(String).map(util.normalize).map(function(source) {
			return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source) ? util.relative(sourceRoot, source) : source;
		});
		this._names = ArraySet.fromArray(names.map(String), true);
		this._sources = ArraySet.fromArray(sources, true);
		this._absoluteSources = this._sources.toArray().map(function(s) {
			return util.computeSourceURL(sourceRoot, s, aSourceMapURL);
		});
		this.sourceRoot = sourceRoot;
		this.sourcesContent = sourcesContent;
		this._mappings = mappings;
		this._sourceMapURL = aSourceMapURL;
		this.file = file;
	}
	BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
	BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;
	/**
	* Utility function to find the index of a source.  Returns -1 if not
	* found.
	*/
	BasicSourceMapConsumer.prototype._findSourceIndex = function(aSource) {
		var relativeSource = aSource;
		if (this.sourceRoot != null) relativeSource = util.relative(this.sourceRoot, relativeSource);
		if (this._sources.has(relativeSource)) return this._sources.indexOf(relativeSource);
		var i = 0;
		for (; i < this._absoluteSources.length; ++i) if (this._absoluteSources[i] == aSource) return i;
		return -1;
	};
	/**
	* Create a BasicSourceMapConsumer from a SourceMapGenerator.
	*
	* @param SourceMapGenerator aSourceMap
	*        The source map that will be consumed.
	* @param String aSourceMapURL
	*        The URL at which the source map can be found (optional)
	* @returns BasicSourceMapConsumer
	*/
	BasicSourceMapConsumer.fromSourceMap = function SourceMapConsumer_fromSourceMap(aSourceMap, aSourceMapURL) {
		var smc = Object.create(BasicSourceMapConsumer.prototype);
		var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
		var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
		smc.sourceRoot = aSourceMap._sourceRoot;
		smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(), smc.sourceRoot);
		smc.file = aSourceMap._file;
		smc._sourceMapURL = aSourceMapURL;
		smc._absoluteSources = smc._sources.toArray().map(function(s) {
			return util.computeSourceURL(smc.sourceRoot, s, aSourceMapURL);
		});
		var generatedMappings = aSourceMap._mappings.toArray().slice();
		var destGeneratedMappings = smc.__generatedMappings = [];
		var destOriginalMappings = smc.__originalMappings = [];
		for (var i = 0, length = generatedMappings.length; i < length; i++) {
			var srcMapping = generatedMappings[i];
			var destMapping = new Mapping();
			destMapping.generatedLine = srcMapping.generatedLine;
			destMapping.generatedColumn = srcMapping.generatedColumn;
			if (srcMapping.source) {
				destMapping.source = sources.indexOf(srcMapping.source);
				destMapping.originalLine = srcMapping.originalLine;
				destMapping.originalColumn = srcMapping.originalColumn;
				if (srcMapping.name) destMapping.name = names.indexOf(srcMapping.name);
				destOriginalMappings.push(destMapping);
			}
			destGeneratedMappings.push(destMapping);
		}
		quickSort(smc.__originalMappings, util.compareByOriginalPositions);
		return smc;
	};
	/**
	* The version of the source mapping spec that we are consuming.
	*/
	BasicSourceMapConsumer.prototype._version = 3;
	/**
	* The list of original sources.
	*/
	Object.defineProperty(BasicSourceMapConsumer.prototype, "sources", { get: function() {
		return this._absoluteSources.slice();
	} });
	/**
	* Provide the JIT with a nice shape / hidden class.
	*/
	function Mapping() {
		this.generatedLine = 0;
		this.generatedColumn = 0;
		this.source = null;
		this.originalLine = null;
		this.originalColumn = null;
		this.name = null;
	}
	/**
	* Parse the mappings in a string in to a data structure which we can easily
	* query (the ordered arrays in the `this.__generatedMappings` and
	* `this.__originalMappings` properties).
	*/
	BasicSourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
		var generatedLine = 1;
		var previousGeneratedColumn = 0;
		var previousOriginalLine = 0;
		var previousOriginalColumn = 0;
		var previousSource = 0;
		var previousName = 0;
		var length = aStr.length;
		var index = 0;
		var cachedSegments = {};
		var temp = {};
		var originalMappings = [];
		var generatedMappings = [];
		var mapping, str, segment, end, value;
		while (index < length) if (aStr.charAt(index) === ";") {
			generatedLine++;
			index++;
			previousGeneratedColumn = 0;
		} else if (aStr.charAt(index) === ",") index++;
		else {
			mapping = new Mapping();
			mapping.generatedLine = generatedLine;
			for (end = index; end < length; end++) if (this._charIsMappingSeparator(aStr, end)) break;
			str = aStr.slice(index, end);
			segment = cachedSegments[str];
			if (segment) index += str.length;
			else {
				segment = [];
				while (index < end) {
					base64VLQ.decode(aStr, index, temp);
					value = temp.value;
					index = temp.rest;
					segment.push(value);
				}
				if (segment.length === 2) throw new Error("Found a source, but no line and column");
				if (segment.length === 3) throw new Error("Found a source and line, but no column");
				cachedSegments[str] = segment;
			}
			mapping.generatedColumn = previousGeneratedColumn + segment[0];
			previousGeneratedColumn = mapping.generatedColumn;
			if (segment.length > 1) {
				mapping.source = previousSource + segment[1];
				previousSource += segment[1];
				mapping.originalLine = previousOriginalLine + segment[2];
				previousOriginalLine = mapping.originalLine;
				mapping.originalLine += 1;
				mapping.originalColumn = previousOriginalColumn + segment[3];
				previousOriginalColumn = mapping.originalColumn;
				if (segment.length > 4) {
					mapping.name = previousName + segment[4];
					previousName += segment[4];
				}
			}
			generatedMappings.push(mapping);
			if (typeof mapping.originalLine === "number") originalMappings.push(mapping);
		}
		quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
		this.__generatedMappings = generatedMappings;
		quickSort(originalMappings, util.compareByOriginalPositions);
		this.__originalMappings = originalMappings;
	};
	/**
	* Find the mapping that best matches the hypothetical "needle" mapping that
	* we are searching for in the given "haystack" of mappings.
	*/
	BasicSourceMapConsumer.prototype._findMapping = function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName, aColumnName, aComparator, aBias) {
		if (aNeedle[aLineName] <= 0) throw new TypeError("Line must be greater than or equal to 1, got " + aNeedle[aLineName]);
		if (aNeedle[aColumnName] < 0) throw new TypeError("Column must be greater than or equal to 0, got " + aNeedle[aColumnName]);
		return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
	};
	/**
	* Compute the last column for each generated mapping. The last column is
	* inclusive.
	*/
	BasicSourceMapConsumer.prototype.computeColumnSpans = function SourceMapConsumer_computeColumnSpans() {
		for (var index = 0; index < this._generatedMappings.length; ++index) {
			var mapping = this._generatedMappings[index];
			if (index + 1 < this._generatedMappings.length) {
				var nextMapping = this._generatedMappings[index + 1];
				if (mapping.generatedLine === nextMapping.generatedLine) {
					mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
					continue;
				}
			}
			mapping.lastGeneratedColumn = Infinity;
		}
	};
	/**
	* Returns the original source, line, and column information for the generated
	* source's line and column positions provided. The only argument is an object
	* with the following properties:
	*
	*   - line: The line number in the generated source.  The line number
	*     is 1-based.
	*   - column: The column number in the generated source.  The column
	*     number is 0-based.
	*   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	*     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	*     closest element that is smaller than or greater than the one we are
	*     searching for, respectively, if the exact element cannot be found.
	*     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	*
	* and an object is returned with the following properties:
	*
	*   - source: The original source file, or null.
	*   - line: The line number in the original source, or null.  The
	*     line number is 1-based.
	*   - column: The column number in the original source, or null.  The
	*     column number is 0-based.
	*   - name: The original identifier, or null.
	*/
	BasicSourceMapConsumer.prototype.originalPositionFor = function SourceMapConsumer_originalPositionFor(aArgs) {
		var needle = {
			generatedLine: util.getArg(aArgs, "line"),
			generatedColumn: util.getArg(aArgs, "column")
		};
		var index = this._findMapping(needle, this._generatedMappings, "generatedLine", "generatedColumn", util.compareByGeneratedPositionsDeflated, util.getArg(aArgs, "bias", SourceMapConsumer.GREATEST_LOWER_BOUND));
		if (index >= 0) {
			var mapping = this._generatedMappings[index];
			if (mapping.generatedLine === needle.generatedLine) {
				var source = util.getArg(mapping, "source", null);
				if (source !== null) {
					source = this._sources.at(source);
					source = util.computeSourceURL(this.sourceRoot, source, this._sourceMapURL);
				}
				var name = util.getArg(mapping, "name", null);
				if (name !== null) name = this._names.at(name);
				return {
					source,
					line: util.getArg(mapping, "originalLine", null),
					column: util.getArg(mapping, "originalColumn", null),
					name
				};
			}
		}
		return {
			source: null,
			line: null,
			column: null,
			name: null
		};
	};
	/**
	* Return true if we have the source content for every source in the source
	* map, false otherwise.
	*/
	BasicSourceMapConsumer.prototype.hasContentsOfAllSources = function BasicSourceMapConsumer_hasContentsOfAllSources() {
		if (!this.sourcesContent) return false;
		return this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function(sc) {
			return sc == null;
		});
	};
	/**
	* Returns the original source content. The only argument is the url of the
	* original source file. Returns null if no original source content is
	* available.
	*/
	BasicSourceMapConsumer.prototype.sourceContentFor = function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
		if (!this.sourcesContent) return null;
		var index = this._findSourceIndex(aSource);
		if (index >= 0) return this.sourcesContent[index];
		var relativeSource = aSource;
		if (this.sourceRoot != null) relativeSource = util.relative(this.sourceRoot, relativeSource);
		var url;
		if (this.sourceRoot != null && (url = util.urlParse(this.sourceRoot))) {
			var fileUriAbsPath = relativeSource.replace(/^file:\/\//, "");
			if (url.scheme == "file" && this._sources.has(fileUriAbsPath)) return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)];
			if ((!url.path || url.path == "/") && this._sources.has("/" + relativeSource)) return this.sourcesContent[this._sources.indexOf("/" + relativeSource)];
		}
		if (nullOnMissing) return null;
		else throw new Error("\"" + relativeSource + "\" is not in the SourceMap.");
	};
	/**
	* Returns the generated line and column information for the original source,
	* line, and column positions provided. The only argument is an object with
	* the following properties:
	*
	*   - source: The filename of the original source.
	*   - line: The line number in the original source.  The line number
	*     is 1-based.
	*   - column: The column number in the original source.  The column
	*     number is 0-based.
	*   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	*     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	*     closest element that is smaller than or greater than the one we are
	*     searching for, respectively, if the exact element cannot be found.
	*     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	*
	* and an object is returned with the following properties:
	*
	*   - line: The line number in the generated source, or null.  The
	*     line number is 1-based.
	*   - column: The column number in the generated source, or null.
	*     The column number is 0-based.
	*/
	BasicSourceMapConsumer.prototype.generatedPositionFor = function SourceMapConsumer_generatedPositionFor(aArgs) {
		var source = util.getArg(aArgs, "source");
		source = this._findSourceIndex(source);
		if (source < 0) return {
			line: null,
			column: null,
			lastColumn: null
		};
		var needle = {
			source,
			originalLine: util.getArg(aArgs, "line"),
			originalColumn: util.getArg(aArgs, "column")
		};
		var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", util.compareByOriginalPositions, util.getArg(aArgs, "bias", SourceMapConsumer.GREATEST_LOWER_BOUND));
		if (index >= 0) {
			var mapping = this._originalMappings[index];
			if (mapping.source === needle.source) return {
				line: util.getArg(mapping, "generatedLine", null),
				column: util.getArg(mapping, "generatedColumn", null),
				lastColumn: util.getArg(mapping, "lastGeneratedColumn", null)
			};
		}
		return {
			line: null,
			column: null,
			lastColumn: null
		};
	};
	exports.BasicSourceMapConsumer = BasicSourceMapConsumer;
	/**
	* An IndexedSourceMapConsumer instance represents a parsed source map which
	* we can query for information. It differs from BasicSourceMapConsumer in
	* that it takes "indexed" source maps (i.e. ones with a "sections" field) as
	* input.
	*
	* The first parameter is a raw source map (either as a JSON string, or already
	* parsed to an object). According to the spec for indexed source maps, they
	* have the following attributes:
	*
	*   - version: Which version of the source map spec this map is following.
	*   - file: Optional. The generated file this source map is associated with.
	*   - sections: A list of section definitions.
	*
	* Each value under the "sections" field has two fields:
	*   - offset: The offset into the original specified at which this section
	*       begins to apply, defined as an object with a "line" and "column"
	*       field.
	*   - map: A source map definition. This source map could also be indexed,
	*       but doesn't have to be.
	*
	* Instead of the "map" field, it's also possible to have a "url" field
	* specifying a URL to retrieve a source map from, but that's currently
	* unsupported.
	*
	* Here's an example source map, taken from the source map spec[0], but
	* modified to omit a section which uses the "url" field.
	*
	*  {
	*    version : 3,
	*    file: "app.js",
	*    sections: [{
	*      offset: {line:100, column:10},
	*      map: {
	*        version : 3,
	*        file: "section.js",
	*        sources: ["foo.js", "bar.js"],
	*        names: ["src", "maps", "are", "fun"],
	*        mappings: "AAAA,E;;ABCDE;"
	*      }
	*    }],
	*  }
	*
	* The second parameter, if given, is a string whose value is the URL
	* at which the source map was found.  This URL is used to compute the
	* sources array.
	*
	* [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
	*/
	function IndexedSourceMapConsumer(aSourceMap, aSourceMapURL) {
		var sourceMap = aSourceMap;
		if (typeof aSourceMap === "string") sourceMap = util.parseSourceMapInput(aSourceMap);
		var version = util.getArg(sourceMap, "version");
		var sections = util.getArg(sourceMap, "sections");
		if (version != this._version) throw new Error("Unsupported version: " + version);
		this._sources = new ArraySet();
		this._names = new ArraySet();
		var lastOffset = {
			line: -1,
			column: 0
		};
		this._sections = sections.map(function(s) {
			if (s.url) throw new Error("Support for url field in sections not implemented.");
			var offset = util.getArg(s, "offset");
			var offsetLine = util.getArg(offset, "line");
			var offsetColumn = util.getArg(offset, "column");
			if (offsetLine < lastOffset.line || offsetLine === lastOffset.line && offsetColumn < lastOffset.column) throw new Error("Section offsets must be ordered and non-overlapping.");
			lastOffset = offset;
			return {
				generatedOffset: {
					generatedLine: offsetLine + 1,
					generatedColumn: offsetColumn + 1
				},
				consumer: new SourceMapConsumer(util.getArg(s, "map"), aSourceMapURL)
			};
		});
	}
	IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
	IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;
	/**
	* The version of the source mapping spec that we are consuming.
	*/
	IndexedSourceMapConsumer.prototype._version = 3;
	/**
	* The list of original sources.
	*/
	Object.defineProperty(IndexedSourceMapConsumer.prototype, "sources", { get: function() {
		var sources = [];
		for (var i = 0; i < this._sections.length; i++) for (var j = 0; j < this._sections[i].consumer.sources.length; j++) sources.push(this._sections[i].consumer.sources[j]);
		return sources;
	} });
	/**
	* Returns the original source, line, and column information for the generated
	* source's line and column positions provided. The only argument is an object
	* with the following properties:
	*
	*   - line: The line number in the generated source.  The line number
	*     is 1-based.
	*   - column: The column number in the generated source.  The column
	*     number is 0-based.
	*
	* and an object is returned with the following properties:
	*
	*   - source: The original source file, or null.
	*   - line: The line number in the original source, or null.  The
	*     line number is 1-based.
	*   - column: The column number in the original source, or null.  The
	*     column number is 0-based.
	*   - name: The original identifier, or null.
	*/
	IndexedSourceMapConsumer.prototype.originalPositionFor = function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
		var needle = {
			generatedLine: util.getArg(aArgs, "line"),
			generatedColumn: util.getArg(aArgs, "column")
		};
		var sectionIndex = binarySearch.search(needle, this._sections, function(needle, section) {
			var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
			if (cmp) return cmp;
			return needle.generatedColumn - section.generatedOffset.generatedColumn;
		});
		var section = this._sections[sectionIndex];
		if (!section) return {
			source: null,
			line: null,
			column: null,
			name: null
		};
		return section.consumer.originalPositionFor({
			line: needle.generatedLine - (section.generatedOffset.generatedLine - 1),
			column: needle.generatedColumn - (section.generatedOffset.generatedLine === needle.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
			bias: aArgs.bias
		});
	};
	/**
	* Return true if we have the source content for every source in the source
	* map, false otherwise.
	*/
	IndexedSourceMapConsumer.prototype.hasContentsOfAllSources = function IndexedSourceMapConsumer_hasContentsOfAllSources() {
		return this._sections.every(function(s) {
			return s.consumer.hasContentsOfAllSources();
		});
	};
	/**
	* Returns the original source content. The only argument is the url of the
	* original source file. Returns null if no original source content is
	* available.
	*/
	IndexedSourceMapConsumer.prototype.sourceContentFor = function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
		for (var i = 0; i < this._sections.length; i++) {
			var content = this._sections[i].consumer.sourceContentFor(aSource, true);
			if (content) return content;
		}
		if (nullOnMissing) return null;
		else throw new Error("\"" + aSource + "\" is not in the SourceMap.");
	};
	/**
	* Returns the generated line and column information for the original source,
	* line, and column positions provided. The only argument is an object with
	* the following properties:
	*
	*   - source: The filename of the original source.
	*   - line: The line number in the original source.  The line number
	*     is 1-based.
	*   - column: The column number in the original source.  The column
	*     number is 0-based.
	*
	* and an object is returned with the following properties:
	*
	*   - line: The line number in the generated source, or null.  The
	*     line number is 1-based. 
	*   - column: The column number in the generated source, or null.
	*     The column number is 0-based.
	*/
	IndexedSourceMapConsumer.prototype.generatedPositionFor = function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
		for (var i = 0; i < this._sections.length; i++) {
			var section = this._sections[i];
			if (section.consumer._findSourceIndex(util.getArg(aArgs, "source")) === -1) continue;
			var generatedPosition = section.consumer.generatedPositionFor(aArgs);
			if (generatedPosition) return {
				line: generatedPosition.line + (section.generatedOffset.generatedLine - 1),
				column: generatedPosition.column + (section.generatedOffset.generatedLine === generatedPosition.line ? section.generatedOffset.generatedColumn - 1 : 0)
			};
		}
		return {
			line: null,
			column: null
		};
	};
	/**
	* Parse the mappings in a string in to a data structure which we can easily
	* query (the ordered arrays in the `this.__generatedMappings` and
	* `this.__originalMappings` properties).
	*/
	IndexedSourceMapConsumer.prototype._parseMappings = function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
		this.__generatedMappings = [];
		this.__originalMappings = [];
		for (var i = 0; i < this._sections.length; i++) {
			var section = this._sections[i];
			var sectionMappings = section.consumer._generatedMappings;
			for (var j = 0; j < sectionMappings.length; j++) {
				var mapping = sectionMappings[j];
				var source = section.consumer._sources.at(mapping.source);
				source = util.computeSourceURL(section.consumer.sourceRoot, source, this._sourceMapURL);
				this._sources.add(source);
				source = this._sources.indexOf(source);
				var name = null;
				if (mapping.name) {
					name = section.consumer._names.at(mapping.name);
					this._names.add(name);
					name = this._names.indexOf(name);
				}
				var adjustedMapping = {
					source,
					generatedLine: mapping.generatedLine + (section.generatedOffset.generatedLine - 1),
					generatedColumn: mapping.generatedColumn + (section.generatedOffset.generatedLine === mapping.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
					originalLine: mapping.originalLine,
					originalColumn: mapping.originalColumn,
					name
				};
				this.__generatedMappings.push(adjustedMapping);
				if (typeof adjustedMapping.originalLine === "number") this.__originalMappings.push(adjustedMapping);
			}
		}
		quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
		quickSort(this.__originalMappings, util.compareByOriginalPositions);
	};
	exports.IndexedSourceMapConsumer = IndexedSourceMapConsumer;
}));
// ../../node_modules/source-map/lib/source-node.js
var require_source_node = /* @__PURE__ */ __commonJSMin(((exports) => {
	var SourceMapGenerator = require_source_map_generator().SourceMapGenerator;
	var util = require_util();
	var REGEX_NEWLINE = /(\r?\n)/;
	var NEWLINE_CODE = 10;
	var isSourceNode = "$$$isSourceNode$$$";
	/**
	* SourceNodes provide a way to abstract over interpolating/concatenating
	* snippets of generated JavaScript source code while maintaining the line and
	* column information associated with the original source code.
	*
	* @param aLine The original line number.
	* @param aColumn The original column number.
	* @param aSource The original source's filename.
	* @param aChunks Optional. An array of strings which are snippets of
	*        generated JS, or other SourceNodes.
	* @param aName The original identifier.
	*/
	function SourceNode(aLine, aColumn, aSource, aChunks, aName) {
		this.children = [];
		this.sourceContents = {};
		this.line = aLine == null ? null : aLine;
		this.column = aColumn == null ? null : aColumn;
		this.source = aSource == null ? null : aSource;
		this.name = aName == null ? null : aName;
		this[isSourceNode] = true;
		if (aChunks != null) this.add(aChunks);
	}
	/**
	* Creates a SourceNode from generated code and a SourceMapConsumer.
	*
	* @param aGeneratedCode The generated code
	* @param aSourceMapConsumer The SourceMap for the generated code
	* @param aRelativePath Optional. The path that relative sources in the
	*        SourceMapConsumer should be relative to.
	*/
	SourceNode.fromStringWithSourceMap = function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
		var node = new SourceNode();
		var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
		var remainingLinesIndex = 0;
		var shiftNextLine = function() {
			return getNextLine() + (getNextLine() || "");
			function getNextLine() {
				return remainingLinesIndex < remainingLines.length ? remainingLines[remainingLinesIndex++] : void 0;
			}
		};
		var lastGeneratedLine = 1, lastGeneratedColumn = 0;
		var lastMapping = null;
		aSourceMapConsumer.eachMapping(function(mapping) {
			if (lastMapping !== null) {
				if (lastGeneratedLine < mapping.generatedLine) {
					addMappingWithCode(lastMapping, shiftNextLine());
					lastGeneratedLine++;
					lastGeneratedColumn = 0;
				} else {
					var nextLine = remainingLines[remainingLinesIndex] || "";
					var code = nextLine.substr(0, mapping.generatedColumn - lastGeneratedColumn);
					remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn - lastGeneratedColumn);
					lastGeneratedColumn = mapping.generatedColumn;
					addMappingWithCode(lastMapping, code);
					lastMapping = mapping;
					return;
				}
			}
			while (lastGeneratedLine < mapping.generatedLine) {
				node.add(shiftNextLine());
				lastGeneratedLine++;
			}
			if (lastGeneratedColumn < mapping.generatedColumn) {
				var nextLine = remainingLines[remainingLinesIndex] || "";
				node.add(nextLine.substr(0, mapping.generatedColumn));
				remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn);
				lastGeneratedColumn = mapping.generatedColumn;
			}
			lastMapping = mapping;
		}, this);
		if (remainingLinesIndex < remainingLines.length) {
			if (lastMapping) addMappingWithCode(lastMapping, shiftNextLine());
			node.add(remainingLines.splice(remainingLinesIndex).join(""));
		}
		aSourceMapConsumer.sources.forEach(function(sourceFile) {
			var content = aSourceMapConsumer.sourceContentFor(sourceFile);
			if (content != null) {
				if (aRelativePath != null) sourceFile = util.join(aRelativePath, sourceFile);
				node.setSourceContent(sourceFile, content);
			}
		});
		return node;
		function addMappingWithCode(mapping, code) {
			if (mapping === null || mapping.source === void 0) node.add(code);
			else {
				var source = aRelativePath ? util.join(aRelativePath, mapping.source) : mapping.source;
				node.add(new SourceNode(mapping.originalLine, mapping.originalColumn, source, code, mapping.name));
			}
		}
	};
	/**
	* Add a chunk of generated JS to this source node.
	*
	* @param aChunk A string snippet of generated JS code, another instance of
	*        SourceNode, or an array where each member is one of those things.
	*/
	SourceNode.prototype.add = function SourceNode_add(aChunk) {
		if (Array.isArray(aChunk)) aChunk.forEach(function(chunk) {
			this.add(chunk);
		}, this);
		else if (aChunk[isSourceNode] || typeof aChunk === "string") {
			if (aChunk) this.children.push(aChunk);
		} else throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk);
		return this;
	};
	/**
	* Add a chunk of generated JS to the beginning of this source node.
	*
	* @param aChunk A string snippet of generated JS code, another instance of
	*        SourceNode, or an array where each member is one of those things.
	*/
	SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
		if (Array.isArray(aChunk)) for (var i = aChunk.length - 1; i >= 0; i--) this.prepend(aChunk[i]);
		else if (aChunk[isSourceNode] || typeof aChunk === "string") this.children.unshift(aChunk);
		else throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk);
		return this;
	};
	/**
	* Walk over the tree of JS snippets in this node and its children. The
	* walking function is called once for each snippet of JS and is passed that
	* snippet and the its original associated source's line/column location.
	*
	* @param aFn The traversal function.
	*/
	SourceNode.prototype.walk = function SourceNode_walk(aFn) {
		var chunk;
		for (var i = 0, len = this.children.length; i < len; i++) {
			chunk = this.children[i];
			if (chunk[isSourceNode]) chunk.walk(aFn);
			else if (chunk !== "") aFn(chunk, {
				source: this.source,
				line: this.line,
				column: this.column,
				name: this.name
			});
		}
	};
	/**
	* Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
	* each of `this.children`.
	*
	* @param aSep The separator.
	*/
	SourceNode.prototype.join = function SourceNode_join(aSep) {
		var newChildren;
		var i;
		var len = this.children.length;
		if (len > 0) {
			newChildren = [];
			for (i = 0; i < len - 1; i++) {
				newChildren.push(this.children[i]);
				newChildren.push(aSep);
			}
			newChildren.push(this.children[i]);
			this.children = newChildren;
		}
		return this;
	};
	/**
	* Call String.prototype.replace on the very right-most source snippet. Useful
	* for trimming whitespace from the end of a source node, etc.
	*
	* @param aPattern The pattern to replace.
	* @param aReplacement The thing to replace the pattern with.
	*/
	SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
		var lastChild = this.children[this.children.length - 1];
		if (lastChild[isSourceNode]) lastChild.replaceRight(aPattern, aReplacement);
		else if (typeof lastChild === "string") this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
		else this.children.push("".replace(aPattern, aReplacement));
		return this;
	};
	/**
	* Set the source content for a source file. This will be added to the SourceMapGenerator
	* in the sourcesContent field.
	*
	* @param aSourceFile The filename of the source file
	* @param aSourceContent The content of the source file
	*/
	SourceNode.prototype.setSourceContent = function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
		this.sourceContents[util.toSetString(aSourceFile)] = aSourceContent;
	};
	/**
	* Walk over the tree of SourceNodes. The walking function is called for each
	* source file content and is passed the filename and source content.
	*
	* @param aFn The traversal function.
	*/
	SourceNode.prototype.walkSourceContents = function SourceNode_walkSourceContents(aFn) {
		for (var i = 0, len = this.children.length; i < len; i++) if (this.children[i][isSourceNode]) this.children[i].walkSourceContents(aFn);
		var sources = Object.keys(this.sourceContents);
		for (var i = 0, len = sources.length; i < len; i++) aFn(util.fromSetString(sources[i]), this.sourceContents[sources[i]]);
	};
	/**
	* Return the string representation of this source node. Walks over the tree
	* and concatenates all the various snippets together to one string.
	*/
	SourceNode.prototype.toString = function SourceNode_toString() {
		var str = "";
		this.walk(function(chunk) {
			str += chunk;
		});
		return str;
	};
	/**
	* Returns the string representation of this source node along with a source
	* map.
	*/
	SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
		var generated = {
			code: "",
			line: 1,
			column: 0
		};
		var map = new SourceMapGenerator(aArgs);
		var sourceMappingActive = false;
		var lastOriginalSource = null;
		var lastOriginalLine = null;
		var lastOriginalColumn = null;
		var lastOriginalName = null;
		this.walk(function(chunk, original) {
			generated.code += chunk;
			if (original.source !== null && original.line !== null && original.column !== null) {
				if (lastOriginalSource !== original.source || lastOriginalLine !== original.line || lastOriginalColumn !== original.column || lastOriginalName !== original.name) map.addMapping({
					source: original.source,
					original: {
						line: original.line,
						column: original.column
					},
					generated: {
						line: generated.line,
						column: generated.column
					},
					name: original.name
				});
				lastOriginalSource = original.source;
				lastOriginalLine = original.line;
				lastOriginalColumn = original.column;
				lastOriginalName = original.name;
				sourceMappingActive = true;
			} else if (sourceMappingActive) {
				map.addMapping({ generated: {
					line: generated.line,
					column: generated.column
				} });
				lastOriginalSource = null;
				sourceMappingActive = false;
			}
			for (var idx = 0, length = chunk.length; idx < length; idx++) if (chunk.charCodeAt(idx) === NEWLINE_CODE) {
				generated.line++;
				generated.column = 0;
				if (idx + 1 === length) {
					lastOriginalSource = null;
					sourceMappingActive = false;
				} else if (sourceMappingActive) map.addMapping({
					source: original.source,
					original: {
						line: original.line,
						column: original.column
					},
					generated: {
						line: generated.line,
						column: generated.column
					},
					name: original.name
				});
			} else generated.column++;
		});
		this.walkSourceContents(function(sourceFile, sourceContent) {
			map.setSourceContent(sourceFile, sourceContent);
		});
		return {
			code: generated.code,
			map
		};
	};
	exports.SourceNode = SourceNode;
}));
// ../../node_modules/source-map/source-map.js
var require_source_map = /* @__PURE__ */ __commonJSMin(((exports) => {
	exports.SourceMapGenerator = require_source_map_generator().SourceMapGenerator;
	exports.SourceMapConsumer = require_source_map_consumer().SourceMapConsumer;
	exports.SourceNode = require_source_node().SourceNode;
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/compiler/code-gen.js
var require_code_gen = /* @__PURE__ */ __commonJSMin(((exports) => {
	exports.__esModule = true;
	exports.safeJsonLiteral = safeJsonLiteral;
	var _utils = require_utils();
	var NEEDS_ESCAPING = /[\x00-\x1f\\"\u2028\u2029<\ud800-\udfff]/;
	var SCRIPT_DELIMITERS = /<(?=!--|\/?script)/gi;
	/**
	* Escape the "<" of every sequence that could end or change the parsing of
	* an enclosing <script> element.
	*
	* Only pass JavaScript or JSON code in which "<" can only occur inside string
	* literals, where "\u003C" has the same value.
	*
	* @param {string} code the code to escape
	* @returns {string} the escaped code
	*/
	function escapeScriptDelimiters(code) {
		return code.replace(SCRIPT_DELIMITERS, "\\u003C");
	}
	/**
	* Escape a UTF-16 surrogate code unit as a "\uXXXX" escape sequence.
	*
	* @param {string} surrogate a single surrogate code unit
	* @returns {string} the escape sequence
	*/
	function escapeSurrogate(surrogate) {
		return "\\u" + surrogate.charCodeAt(0).toString(16);
	}
	/**
	* Convert a value to a JSON literal that is safe to write into generated
	* code: valid in ES5, where line and paragraph separators end string literals,
	* encodable as UTF-8 on every engine, and safe inside an enclosing <script>
	* element.
	*
	* @param {*} value the value to convert
	* @returns {string} the JavaScript literal
	*/
	function safeJsonLiteral(value) {
		return escapeScriptDelimiters(JSON.stringify(value).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/[\ud800-\udfff]/g, escapeSurrogate));
	}
	var SourceNode = void 0;
	try {
		/* istanbul ignore next */
		if (typeof define !== "function" || !define.amd) SourceNode = require_source_map().SourceNode;
	} catch (err) {}
	/* istanbul ignore if: tested but not covered in istanbul due to dist build  */
	if (!SourceNode) {
		SourceNode = function(line, column, srcFile, chunks) {
			this.src = "";
			if (chunks) this.add(chunks);
		};
		/* istanbul ignore next */
		SourceNode.prototype = {
			add: function add(chunks) {
				if (_utils.isArray(chunks)) chunks = chunks.join("");
				this.src += chunks;
			},
			prepend: function prepend(chunks) {
				if (_utils.isArray(chunks)) chunks = chunks.join("");
				this.src = chunks + this.src;
			},
			toStringWithSourceMap: function toStringWithSourceMap() {
				return { code: this.toString() };
			},
			toString: function toString() {
				return this.src;
			}
		};
	}
	function castChunk(chunk, codeGen, loc) {
		if (_utils.isArray(chunk)) {
			var ret = [];
			for (var i = 0, len = chunk.length; i < len; i++) ret.push(codeGen.wrap(chunk[i], loc));
			return ret;
		} else if (typeof chunk === "boolean" || typeof chunk === "number") return chunk + "";
		return chunk;
	}
	function CodeGen(srcFile) {
		this.srcFile = srcFile;
		this.source = [];
	}
	CodeGen.prototype = {
		isEmpty: function isEmpty() {
			return !this.source.length;
		},
		prepend: function prepend(source, loc) {
			this.source.unshift(this.wrap(source, loc));
		},
		push: function push(source, loc) {
			this.source.push(this.wrap(source, loc));
		},
		merge: function merge() {
			var source = this.empty();
			this.each(function(line) {
				source.add([
					"  ",
					line,
					"\n"
				]);
			});
			return source;
		},
		each: function each(iter) {
			for (var i = 0, len = this.source.length; i < len; i++) iter(this.source[i]);
		},
		empty: function empty() {
			var loc = this.currentLocation || { start: {} };
			return new SourceNode(loc.start.line, loc.start.column, this.srcFile);
		},
		wrap: function wrap(chunk) {
			var loc = arguments.length <= 1 || arguments[1] === void 0 ? this.currentLocation || { start: {} } : arguments[1];
			if (chunk instanceof SourceNode) return chunk;
			chunk = castChunk(chunk, this, loc);
			return new SourceNode(loc.start.line, loc.start.column, this.srcFile, chunk);
		},
		functionCall: function functionCall(fn, type, params) {
			params = this.generateList(params);
			return this.wrap([
				fn,
				type ? "." + type + "(" : "(",
				params,
				")"
			]);
		},
		quotedString: function quotedString(str) {
			str = str + "";
			if (!NEEDS_ESCAPING.test(str)) return "\"" + str + "\"";
			return safeJsonLiteral(str);
		},
		objectLiteral: function objectLiteral(obj) {
			// istanbul ignore next
			var _this = this;
			var pairs = [];
			Object.keys(obj).forEach(function(key) {
				var value = castChunk(obj[key], _this);
				if (value !== "undefined") pairs.push([
					_this.quotedString(key),
					":",
					value
				]);
			});
			var ret = this.generateList(pairs);
			ret.prepend("{");
			ret.add("}");
			return ret;
		},
		generateList: function generateList(entries) {
			var ret = this.empty();
			for (var i = 0, len = entries.length; i < len; i++) {
				if (i) ret.add(",");
				ret.add(castChunk(entries[i], this));
			}
			return ret;
		},
		generateArray: function generateArray(entries) {
			var ret = this.generateList(entries);
			ret.prepend("[");
			ret.add("]");
			return ret;
		}
	};
	exports["default"] = CodeGen;
}));
// ../../node_modules/handlebars/dist/cjs/handlebars/compiler/javascript-compiler.js
var require_javascript_compiler = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	// istanbul ignore next
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { "default": obj };
	}
	var _base = require_base$1();
	var _exception2 = _interopRequireDefault(require_exception());
	var _utils = require_utils();
	var _codeGen = require_code_gen();
	var _codeGen2 = _interopRequireDefault(_codeGen);
	function Literal(value) {
		this.value = value;
	}
	function JavaScriptCompiler() {}
	JavaScriptCompiler.prototype = {
		nameLookup: function nameLookup(parent, name) {
			return this.internalNameLookup(parent, name);
		},
		depthedLookup: function depthedLookup(name) {
			return [
				this.aliasable("container.lookup"),
				"(depths, ",
				this.quotedString(name),
				")"
			];
		},
		compilerInfo: function compilerInfo() {
			var revision = _base.COMPILER_REVISION;
			return [revision, _base.REVISION_CHANGES[revision]];
		},
		appendToBuffer: function appendToBuffer(source, location, explicit) {
			if (!_utils.isArray(source)) source = [source];
			source = this.source.wrap(source, location);
			if (this.environment.isSimple) return [
				"return ",
				source,
				";"
			];
			else if (explicit) return [
				"buffer += ",
				source,
				";"
			];
			else {
				source.appendToBuffer = true;
				return source;
			}
		},
		initializeBuffer: function initializeBuffer() {
			return this.quotedString("");
		},
		internalNameLookup: function internalNameLookup(parent, name) {
			this.lookupPropertyFunctionIsUsed = true;
			return [
				"lookupProperty(",
				parent,
				",",
				this.quotedString(name),
				")"
			];
		},
		lookupPropertyFunctionIsUsed: false,
		compile: function compile(environment, options, context, asObject) {
			this.environment = environment;
			this.options = options;
			this.stringParams = this.options.stringParams;
			this.trackIds = this.options.trackIds;
			this.precompile = !asObject;
			this.name = this.environment.name;
			this.isChild = !!context;
			this.context = context || {
				decorators: [],
				programs: [],
				environments: []
			};
			this.preamble();
			this.stackSlot = 0;
			this.stackVars = [];
			this.aliases = {};
			this.registers = { list: [] };
			this.hashes = [];
			this.compileStack = [];
			this.inlineStack = [];
			this.blockParams = [];
			this.compileChildren(environment, options);
			this.useDepths = this.useDepths || environment.useDepths || environment.useDecorators || this.options.compat;
			this.useBlockParams = this.useBlockParams || environment.useBlockParams;
			var opcodes = environment.opcodes, opcode = void 0, firstLoc = void 0, i = void 0, l = void 0;
			for (i = 0, l = opcodes.length; i < l; i++) {
				opcode = opcodes[i];
				this.source.currentLocation = opcode.loc;
				firstLoc = firstLoc || opcode.loc;
				this[opcode.opcode].apply(this, opcode.args);
			}
			this.source.currentLocation = firstLoc;
			this.pushSource("");
			/* istanbul ignore next */
			if (this.stackSlot || this.inlineStack.length || this.compileStack.length) throw new _exception2["default"]("Compile completed with content left on stack");
			if (!this.decorators.isEmpty()) {
				this.useDecorators = true;
				this.decorators.prepend([
					"var decorators = container.decorators, ",
					this.lookupPropertyFunctionVarDeclaration(),
					";\n"
				]);
				this.decorators.push("return fn;");
				if (asObject) this.decorators = Function.apply(this, [
					"fn",
					"props",
					"container",
					"depth0",
					"data",
					"blockParams",
					"depths",
					this.decorators.merge()
				]);
				else {
					this.decorators.prepend("function(fn, props, container, depth0, data, blockParams, depths) {\n");
					this.decorators.push("}\n");
					this.decorators = this.decorators.merge();
				}
			} else this.decorators = void 0;
			var fn = this.createFunctionContext(asObject);
			if (!this.isChild) {
				var ret = {
					compiler: this.compilerInfo(),
					main: fn
				};
				if (this.decorators) {
					ret.main_d = this.decorators;
					ret.useDecorators = true;
				}
				var _context = this.context;
				var programs = _context.programs;
				var decorators = _context.decorators;
				for (i = 0, l = programs.length; i < l; i++) {
					ret[i] = programs[i];
					if (decorators[i]) {
						ret[i + "_d"] = decorators[i];
						ret.useDecorators = true;
					}
				}
				if (this.environment.usePartial) ret.usePartial = true;
				if (this.options.data) ret.useData = true;
				if (this.useDepths) ret.useDepths = true;
				if (this.useBlockParams) ret.useBlockParams = true;
				if (this.options.compat) ret.compat = true;
				if (!asObject) {
					ret.compiler = JSON.stringify(ret.compiler);
					this.source.currentLocation = { start: {
						line: 1,
						column: 0
					} };
					ret = this.objectLiteral(ret);
					if (options.srcName) {
						ret = ret.toStringWithSourceMap({ file: options.destName });
						ret.map = ret.map && ret.map.toString();
					} else ret = ret.toString();
				} else ret.compilerOptions = this.options;
				return ret;
			} else return fn;
		},
		preamble: function preamble() {
			this.lastContext = 0;
			this.source = new _codeGen2["default"](this.options.srcName);
			this.decorators = new _codeGen2["default"](this.options.srcName);
		},
		createFunctionContext: function createFunctionContext(asObject) {
			// istanbul ignore next
			var _this = this;
			var varDeclarations = "";
			var locals = this.stackVars.concat(this.registers.list);
			if (locals.length > 0) varDeclarations += ", " + locals.join(", ");
			var aliasCount = 0;
			Object.keys(this.aliases).forEach(function(alias) {
				var node = _this.aliases[alias];
				if (node.children && node.referenceCount > 1) {
					varDeclarations += ", alias" + ++aliasCount + "=" + alias;
					node.children[0] = "alias" + aliasCount;
				}
			});
			if (this.lookupPropertyFunctionIsUsed) varDeclarations += ", " + this.lookupPropertyFunctionVarDeclaration();
			var params = [
				"container",
				"depth0",
				"helpers",
				"partials",
				"data"
			];
			if (this.useBlockParams || this.useDepths) params.push("blockParams");
			if (this.useDepths) params.push("depths");
			var source = this.mergeSource(varDeclarations);
			if (asObject) {
				params.push(source);
				return Function.apply(this, params);
			} else return this.source.wrap([
				"function(",
				params.join(","),
				") {\n  ",
				source,
				"}"
			]);
		},
		mergeSource: function mergeSource(varDeclarations) {
			var isSimple = this.environment.isSimple, appendOnly = !this.forceBuffer, appendFirst = void 0, sourceSeen = void 0, bufferStart = void 0, bufferEnd = void 0;
			this.source.each(function(line) {
				if (line.appendToBuffer) {
					if (bufferStart) line.prepend("  + ");
					else bufferStart = line;
					bufferEnd = line;
				} else {
					if (bufferStart) {
						if (!sourceSeen) appendFirst = true;
						else bufferStart.prepend("buffer += ");
						bufferEnd.add(";");
						bufferStart = bufferEnd = void 0;
					}
					sourceSeen = true;
					if (!isSimple) appendOnly = false;
				}
			});
			if (appendOnly) {
				if (bufferStart) {
					bufferStart.prepend("return ");
					bufferEnd.add(";");
				} else if (!sourceSeen) this.source.push("return \"\";");
			} else {
				varDeclarations += ", buffer = " + (appendFirst ? "" : this.initializeBuffer());
				if (bufferStart) {
					bufferStart.prepend("return buffer + ");
					bufferEnd.add(";");
				} else this.source.push("return buffer;");
			}
			if (varDeclarations) this.source.prepend("var " + varDeclarations.substring(2) + (appendFirst ? "" : ";\n"));
			return this.source.merge();
		},
		lookupPropertyFunctionVarDeclaration: function lookupPropertyFunctionVarDeclaration() {
			return "\n      lookupProperty = container.lookupProperty || function(parent, propertyName) {\n        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {\n          return parent[propertyName];\n        }\n        return undefined\n    }\n    ".trim();
		},
		blockValue: function blockValue(name) {
			var blockHelperMissing = this.aliasable("container.hooks.blockHelperMissing"), params = [this.contextName(0)];
			this.setupHelperArgs(name, 0, params);
			var blockName = this.popStack();
			params.splice(1, 0, blockName);
			this.push(this.source.functionCall(blockHelperMissing, "call", params));
		},
		ambiguousBlockValue: function ambiguousBlockValue() {
			var blockHelperMissing = this.aliasable("container.hooks.blockHelperMissing"), params = [this.contextName(0)];
			this.setupHelperArgs("", 0, params, true);
			this.flushInline();
			var current = this.topStack();
			params.splice(1, 0, current);
			this.pushSource([
				"if (!",
				this.lastHelper,
				") { ",
				current,
				" = ",
				this.source.functionCall(blockHelperMissing, "call", params),
				"}"
			]);
		},
		appendContent: function appendContent(content) {
			if (this.pendingContent) content = this.pendingContent + content;
			else this.pendingLocation = this.source.currentLocation;
			this.pendingContent = content;
		},
		append: function append() {
			if (this.isInline()) {
				this.replaceStack(function(current) {
					return [
						" != null ? ",
						current,
						" : \"\""
					];
				});
				this.pushSource(this.appendToBuffer(this.popStack()));
			} else {
				var local = this.popStack();
				this.pushSource([
					"if (",
					local,
					" != null) { ",
					this.appendToBuffer(local, void 0, true),
					" }"
				]);
				if (this.environment.isSimple) this.pushSource([
					"else { ",
					this.appendToBuffer("''", void 0, true),
					" }"
				]);
			}
		},
		appendEscaped: function appendEscaped() {
			this.pushSource(this.appendToBuffer([
				this.aliasable("container.escapeExpression"),
				"(",
				this.popStack(),
				")"
			]));
		},
		getContext: function getContext(depth) {
			this.lastContext = depth;
		},
		pushContext: function pushContext() {
			this.pushStackLiteral(this.contextName(this.lastContext));
		},
		lookupOnContext: function lookupOnContext(parts, falsy, strict, scoped) {
			var i = 0;
			if (!scoped && this.options.compat && !this.lastContext) this.push(this.depthedLookup(parts[i++]));
			else this.pushContext();
			this.resolvePath("context", parts, i, falsy, strict);
		},
		lookupBlockParam: function lookupBlockParam(blockParamId, parts) {
			this.useBlockParams = true;
			this.push([
				"blockParams[",
				blockParamId[0],
				"][",
				blockParamId[1],
				"]"
			]);
			this.resolvePath("context", parts, 1);
		},
		lookupData: function lookupData(depth, parts, strict) {
			if (!depth) this.pushStackLiteral("data");
			else this.pushStackLiteral("container.data(data, " + depth + ")");
			this.resolvePath("data", parts, 0, true, strict);
		},
		resolvePath: function resolvePath(type, parts, startPartIndex, falsy, strict) {
			// istanbul ignore next
			var _this2 = this;
			if (this.options.strict || this.options.assumeObjects) {
				this.push(strictLookup(this.options.strict && strict, this, parts, startPartIndex, type));
				return;
			}
			var len = parts.length;
			var _loop = function(i) {
				_this2.replaceStack(function(current) {
					var lookup = _this2.nameLookup(current, parts[i], type);
					if (!falsy) return [
						" != null ? ",
						lookup,
						" : ",
						current
					];
					else return [" && ", lookup];
				});
			};
			for (var i = startPartIndex; i < len; i++) _loop(i);
		},
		resolvePossibleLambda: function resolvePossibleLambda() {
			this.push([
				this.aliasable("container.lambda"),
				"(",
				this.popStack(),
				", ",
				this.contextName(0),
				")"
			]);
		},
		pushStringParam: function pushStringParam(string, type) {
			this.pushContext();
			this.pushString(type);
			if (type !== "SubExpression") {
				if (typeof string === "string") this.pushString(string);
				else this.pushStackLiteral(string);
			}
		},
		emptyHash: function emptyHash(omitEmpty) {
			if (this.trackIds) this.push("{}");
			if (this.stringParams) {
				this.push("{}");
				this.push("{}");
			}
			this.pushStackLiteral(omitEmpty ? "undefined" : "{}");
		},
		pushHash: function pushHash() {
			if (this.hash) this.hashes.push(this.hash);
			this.hash = {
				values: {},
				types: [],
				contexts: [],
				ids: []
			};
		},
		popHash: function popHash() {
			var hash = this.hash;
			this.hash = this.hashes.pop();
			if (this.trackIds) this.push(this.objectLiteral(hash.ids));
			if (this.stringParams) {
				this.push(this.objectLiteral(hash.contexts));
				this.push(this.objectLiteral(hash.types));
			}
			this.push(this.objectLiteral(hash.values));
		},
		pushString: function pushString(string) {
			this.pushStackLiteral(this.quotedString(string));
		},
		pushLiteral: function pushLiteral(value) {
			this.pushStackLiteral(value);
		},
		pushProgram: function pushProgram(guid) {
			if (guid != null) this.pushStackLiteral(this.programExpression(guid));
			else this.pushStackLiteral(null);
		},
		registerDecorator: function registerDecorator(paramSize, name) {
			var foundDecorator = this.nameLookup("decorators", name, "decorator"), options = this.setupHelperArgs(name, paramSize);
			this.decorators.push([
				"var decorator = ",
				foundDecorator,
				";"
			]);
			this.decorators.push([
				"if (typeof decorator !== \"function\") { throw new Error(",
				this.quotedString("Missing decorator: \"" + name + "\""),
				"); }"
			]);
			this.decorators.push([
				"fn = ",
				this.decorators.functionCall("decorator", "", [
					"fn",
					"props",
					"container",
					options
				]),
				" || fn;"
			]);
		},
		invokeHelper: function invokeHelper(paramSize, name, isSimple) {
			var nonHelper = this.popStack(), helper = this.setupHelper(paramSize, name);
			var possibleFunctionCalls = [];
			if (isSimple) possibleFunctionCalls.push(helper.name);
			possibleFunctionCalls.push(nonHelper);
			if (!this.options.strict) possibleFunctionCalls.push(this.aliasable("container.hooks.helperMissing"));
			var functionLookupCode = [
				"(",
				this.itemsSeparatedBy(possibleFunctionCalls, "||"),
				")"
			];
			var functionCall = this.source.functionCall(functionLookupCode, "call", helper.callParams);
			this.push(functionCall);
		},
		itemsSeparatedBy: function itemsSeparatedBy(items, separator) {
			var result = [];
			result.push(items[0]);
			for (var i = 1; i < items.length; i++) result.push(separator, items[i]);
			return result;
		},
		invokeKnownHelper: function invokeKnownHelper(paramSize, name) {
			var helper = this.setupHelper(paramSize, name);
			this.push(this.source.functionCall(helper.name, "call", helper.callParams));
		},
		invokeAmbiguous: function invokeAmbiguous(name, helperCall) {
			this.useRegister("helper");
			var nonHelper = this.popStack();
			this.emptyHash();
			var helper = this.setupHelper(0, name, helperCall);
			var lookup = [
				"(",
				"(helper = ",
				this.lastHelper = this.nameLookup("helpers", name, "helper"),
				" || ",
				nonHelper,
				")"
			];
			if (!this.options.strict) {
				lookup[0] = "(helper = ";
				lookup.push(" != null ? helper : ", this.aliasable("container.hooks.helperMissing"));
			}
			this.push([
				"(",
				lookup,
				helper.paramsInit ? ["),(", helper.paramsInit] : [],
				"),",
				"(typeof helper === ",
				this.aliasable("\"function\""),
				" ? ",
				this.source.functionCall("helper", "call", helper.callParams),
				" : helper))"
			]);
		},
		invokePartial: function invokePartial(isDynamic, name, indent) {
			var params = [], options = this.setupParams(name, 1, params);
			if (isDynamic) {
				name = this.popStack();
				delete options.name;
			}
			if (indent) options.indent = this.quotedString(indent);
			options.helpers = "helpers";
			options.partials = "partials";
			options.decorators = "container.decorators";
			if (!isDynamic) params.unshift(this.nameLookup("partials", name, "partial"));
			else params.unshift(name);
			if (this.options.compat) options.depths = "depths";
			options = this.objectLiteral(options);
			params.push(options);
			this.push(this.source.functionCall("container.invokePartial", "", params));
		},
		assignToHash: function assignToHash(key) {
			var value = this.popStack(), context = void 0, type = void 0, id = void 0;
			if (this.trackIds) id = this.popStack();
			if (this.stringParams) {
				type = this.popStack();
				context = this.popStack();
			}
			var hash = this.hash;
			if (context) hash.contexts[key] = context;
			if (type) hash.types[key] = type;
			if (id) hash.ids[key] = id;
			hash.values[key] = value;
		},
		pushId: function pushId(type, name, child) {
			if (type === "BlockParam") this.pushStackLiteral("blockParams[" + name[0] + "].path[" + name[1] + "]" + (child ? " + " + this.quotedString("." + child) : ""));
			else if (type === "PathExpression") this.pushString(name);
			else if (type === "SubExpression") this.pushStackLiteral("true");
			else this.pushStackLiteral("null");
		},
		compiler: JavaScriptCompiler,
		compileChildren: function compileChildren(environment, options) {
			var children = environment.children, child = void 0, compiler = void 0;
			for (var i = 0, l = children.length; i < l; i++) {
				child = children[i];
				compiler = new this.compiler();
				var existing = this.matchExistingProgram(child);
				if (existing == null) {
					var index = this.context.programs.push("") - 1;
					child.index = index;
					child.name = "program" + index;
					this.context.programs[index] = compiler.compile(child, options, this.context, !this.precompile);
					this.context.decorators[index] = compiler.decorators;
					this.context.environments[index] = child;
					this.useDepths = this.useDepths || compiler.useDepths;
					this.useBlockParams = this.useBlockParams || compiler.useBlockParams;
					child.useDepths = this.useDepths;
					child.useBlockParams = this.useBlockParams;
				} else {
					child.index = existing.index;
					child.name = "program" + existing.index;
					this.useDepths = this.useDepths || existing.useDepths;
					this.useBlockParams = this.useBlockParams || existing.useBlockParams;
				}
			}
		},
		matchExistingProgram: function matchExistingProgram(child) {
			for (var i = 0, len = this.context.environments.length; i < len; i++) {
				var environment = this.context.environments[i];
				if (environment && environment.equals(child)) return environment;
			}
		},
		programExpression: function programExpression(guid) {
			var child = this.environment.children[guid], programParams = [
				child.index,
				"data",
				child.blockParams
			];
			if (this.useBlockParams || this.useDepths) programParams.push("blockParams");
			if (this.useDepths) programParams.push("depths");
			return "container.program(" + programParams.join(", ") + ")";
		},
		useRegister: function useRegister(name) {
			if (!this.registers[name]) {
				this.registers[name] = true;
				this.registers.list.push(name);
			}
		},
		push: function push(expr) {
			if (!(expr instanceof Literal)) expr = this.source.wrap(expr);
			this.inlineStack.push(expr);
			return expr;
		},
		pushStackLiteral: function pushStackLiteral(item) {
			this.push(new Literal(item));
		},
		pushSource: function pushSource(source) {
			if (this.pendingContent) {
				this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation));
				this.pendingContent = void 0;
			}
			if (source) this.source.push(source);
		},
		replaceStack: function replaceStack(callback) {
			var prefix = ["("], stack = void 0, createdStack = void 0, usedLiteral = void 0;
			/* istanbul ignore next */
			if (!this.isInline()) throw new _exception2["default"]("replaceStack on non-inline");
			var top = this.popStack(true);
			if (top instanceof Literal) {
				stack = [top.value];
				prefix = ["(", stack];
				usedLiteral = true;
			} else {
				createdStack = true;
				var _name = this.incrStack();
				prefix = [
					"((",
					this.push(_name),
					" = ",
					top,
					")"
				];
				stack = this.topStack();
			}
			var item = callback.call(this, stack);
			if (!usedLiteral) this.popStack();
			if (createdStack) this.stackSlot--;
			this.push(prefix.concat(item, ")"));
		},
		incrStack: function incrStack() {
			this.stackSlot++;
			if (this.stackSlot > this.stackVars.length) this.stackVars.push("stack" + this.stackSlot);
			return this.topStackName();
		},
		topStackName: function topStackName() {
			return "stack" + this.stackSlot;
		},
		flushInline: function flushInline() {
			var inlineStack = this.inlineStack;
			this.inlineStack = [];
			for (var i = 0, len = inlineStack.length; i < len; i++) {
				var entry = inlineStack[i];
				/* istanbul ignore if */
				if (entry instanceof Literal) this.compileStack.push(entry);
				else {
					var stack = this.incrStack();
					this.pushSource([
						stack,
						" = ",
						entry,
						";"
					]);
					this.compileStack.push(stack);
				}
			}
		},
		isInline: function isInline() {
			return this.inlineStack.length;
		},
		popStack: function popStack(wrapped) {
			var inline = this.isInline(), item = (inline ? this.inlineStack : this.compileStack).pop();
			if (!wrapped && item instanceof Literal) return item.value;
			else {
				if (!inline) {
					/* istanbul ignore next */
					if (!this.stackSlot) throw new _exception2["default"]("Invalid stack pop");
					this.stackSlot--;
				}
				return item;
			}
		},
		topStack: function topStack() {
			var stack = this.isInline() ? this.inlineStack : this.compileStack, item = stack[stack.length - 1];
			/* istanbul ignore if */
			if (item instanceof Literal) return item.value;
			else return item;
		},
		contextName: function contextName(context) {
			if (this.useDepths && context) return "depths[" + context + "]";
			else return "depth" + context;
		},
		quotedString: function quotedString(str) {
			return this.source.quotedString(str);
		},
		objectLiteral: function objectLiteral(obj) {
			return this.source.objectLiteral(obj);
		},
		aliasable: function aliasable(name) {
			var ret = this.aliases[name];
			if (ret) {
				ret.referenceCount++;
				return ret;
			}
			ret = this.aliases[name] = this.source.wrap(name);
			ret.aliasable = true;
			ret.referenceCount = 1;
			return ret;
		},
		setupHelper: function setupHelper(paramSize, name, blockHelper) {
			var params = [];
			return {
				params,
				paramsInit: this.setupHelperArgs(name, paramSize, params, blockHelper),
				name: this.nameLookup("helpers", name, "helper"),
				callParams: [this.aliasable(this.contextName(0) + " != null ? " + this.contextName(0) + " : (container.nullContext || {})")].concat(params)
			};
		},
		setupParams: function setupParams(helper, paramSize, params) {
			var options = {}, contexts = [], types = [], ids = [], objectArgs = !params, param = void 0;
			if (objectArgs) params = [];
			options.name = this.quotedString(helper);
			options.hash = this.popStack();
			if (this.trackIds) options.hashIds = this.popStack();
			if (this.stringParams) {
				options.hashTypes = this.popStack();
				options.hashContexts = this.popStack();
			}
			var inverse = this.popStack(), program = this.popStack();
			if (program || inverse) {
				options.fn = program || "container.noop";
				options.inverse = inverse || "container.noop";
			}
			var i = paramSize;
			while (i--) {
				param = this.popStack();
				params[i] = param;
				if (this.trackIds) ids[i] = this.popStack();
				if (this.stringParams) {
					types[i] = this.popStack();
					contexts[i] = this.popStack();
				}
			}
			if (objectArgs) options.args = this.source.generateArray(params);
			if (this.trackIds) options.ids = this.source.generateArray(ids);
			if (this.stringParams) {
				options.types = this.source.generateArray(types);
				options.contexts = this.source.generateArray(contexts);
			}
			if (this.options.data) options.data = "data";
			if (this.useBlockParams) options.blockParams = "blockParams";
			return options;
		},
		setupHelperArgs: function setupHelperArgs(helper, paramSize, params, useRegister) {
			var options = this.setupParams(helper, paramSize, params);
			options.loc = locationLiteral(this);
			options = this.objectLiteral(options);
			if (useRegister) {
				this.useRegister("options");
				params.push("options");
				return ["options=", options];
			} else if (params) {
				params.push(options);
				return "";
			} else return options;
		}
	};
	(function() {
		var reservedWords = "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(" ");
		var compilerWords = JavaScriptCompiler.RESERVED_WORDS = {};
		for (var i = 0, l = reservedWords.length; i < l; i++) compilerWords[reservedWords[i]] = true;
	})();
	/**
	* @deprecated May be removed in the next major version
	*/
	JavaScriptCompiler.isValidJavaScriptVariableName = function(name) {
		return !JavaScriptCompiler.RESERVED_WORDS[name] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(name);
	};
	/**
	* The compiler's current source location as a JavaScript literal.
	*
	* Hand-built ASTs may omit `loc`; emitting the literal `undefined` then
	* keeps the generated code valid and drops the key from object literals.
	* The location's `source` is the `srcName` option, so it is escaped like
	* every other string in the generated code.
	*
	* @param {JavaScriptCompiler} compiler the compiler whose location is emitted
	* @returns {string} a JSON object literal, or the string "undefined"
	*/
	function locationLiteral(compiler) {
		var loc = compiler.source.currentLocation;
		return loc ? _codeGen.safeJsonLiteral(loc) : "undefined";
	}
	function strictLookup(requireTerminal, compiler, parts, startPartIndex, type) {
		var stack = compiler.popStack(), len = parts.length;
		if (requireTerminal) len--;
		for (var i = startPartIndex; i < len; i++) stack = compiler.nameLookup(stack, parts[i], type);
		if (requireTerminal) return [
			compiler.aliasable("container.strict"),
			"(",
			stack,
			", ",
			compiler.quotedString(parts[len]),
			", ",
			locationLiteral(compiler),
			" )"
		];
		else return stack;
	}
	exports["default"] = JavaScriptCompiler;
	module.exports = exports["default"];
}));
// source/utilities/render-template.ts
var import_handlebars = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((exports, module) => {
	exports.__esModule = true;
	// istanbul ignore next
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { "default": obj };
	}
	var _handlebarsRuntime2 = _interopRequireDefault(require_handlebars_runtime());
	var _handlebarsCompilerAst2 = _interopRequireDefault(require_ast());
	var _handlebarsCompilerBase = require_base();
	var _handlebarsCompilerCompiler = require_compiler();
	var _handlebarsCompilerJavascriptCompiler2 = _interopRequireDefault(require_javascript_compiler());
	var _handlebarsCompilerVisitor2 = _interopRequireDefault(require_visitor());
	var _handlebarsNoConflict2 = _interopRequireDefault(require_no_conflict());
	var _create = _handlebarsRuntime2["default"].create;
	function create() {
		var hb = _create();
		hb.compile = function(input, options) {
			return _handlebarsCompilerCompiler.compile(input, options, hb);
		};
		hb.precompile = function(input, options) {
			return _handlebarsCompilerCompiler.precompile(input, options, hb);
		};
		hb.AST = _handlebarsCompilerAst2["default"];
		hb.Compiler = _handlebarsCompilerCompiler.Compiler;
		hb.JavaScriptCompiler = _handlebarsCompilerJavascriptCompiler2["default"];
		hb.Parser = _handlebarsCompilerBase.parser;
		hb.parse = _handlebarsCompilerBase.parse;
		hb.parseWithoutProcessing = _handlebarsCompilerBase.parseWithoutProcessing;
		return hb;
	}
	var inst = create();
	inst.create = create;
	_handlebarsNoConflict2["default"](inst);
	inst.Visitor = _handlebarsCompilerVisitor2["default"];
	inst["default"] = inst;
	exports["default"] = inst;
	module.exports = exports["default"];
})))(), 1);
import_handlebars.default.registerHelper("ifEquals", function(arg1, arg2, options) {
	return arg1 === arg2 ? options.fn(this) : options.inverse(this);
});
import_handlebars.default.registerHelper("jobPositionLabel", formatJobPositionLabel);
import_handlebars.default.registerHelper("jobPositionLabelWithLocation", (jobPosition) => {
	const formattedLabel = formatJobPositionLabel(jobPosition);
	const location = jobPosition.location;
	let locationPart = "";
	if (location?.city || location?.zipCode) locationPart = ` (${`${location.zipCode} ${location.city}`.trim()})`;
	else if (location?.name) locationPart = ` (${location.name})`;
	return `${formattedLabel}${locationPart}`;
});
import_handlebars.default.registerHelper("jobPositionTypeNoun", formatJobPositionTypeNoun);
import_handlebars.default.registerHelper("jobPositionTypeNounWithArticle", formatJobPositionTypeNounWithArticle);
import_handlebars.default.registerHelper("companyLegalInfo", (company) => {
	return [company.localCourt ? `AG ${company.localCourt}` : "", company.commercialRegisterNumber ?? ""].filter(Boolean).join(" | ");
});
var renderTemplate = ({ templateString, context }) => {
	if (typeof templateString !== "string") return templateString;
	const template = import_handlebars.default.compile(templateString);
	try {
		return template(context);
	} catch {
		return templateString;
	}
};
// source/utilities/render-email-template.ts
var buildCustomerEmailContext = ({ applicant }) => {
	return { bewerberName: applicant?.name };
};
var buildEmailContext = ({ applicant, jobPosition, customer, company, domain, applicantSources }) => {
	const applicantSource = applicant.sourceId ? applicantSources?.find((source) => source.id === applicant.sourceId) : void 0;
	return {
		resumeLink: getResumeBuilderUrl(applicant),
		sharedApplicantUrl: getSharedApplicantUrl(applicant),
		domain,
		customer: {
			projectManagerName: customer?.projectManager?.name,
			projectManagerEmail: customer?.projectManager?.emailAddress,
			projectManagerPhoneNumber: customer?.projectManager?.phoneNumber
		},
		company: {
			longName: company?.longName,
			shortName: company?.shortName,
			mondayName: company?.mondayName,
			localCourt: company?.localCourt,
			commercialRegisterNumber: company?.commercialRegisterNumber,
			address: company?.address,
			zipCode: company?.zipCode,
			city: company?.city,
			ceoName: company?.ceoName
		},
		jobPosition: {
			name: jobPosition?.name,
			type: jobPosition?.type,
			fullName: jobPosition?.fullName,
			specialization: jobPosition?.specialization,
			contactPersonName: jobPosition?.contactPersonName,
			contactPersonPosition: jobPosition?.contactPersonPosition,
			contactPersonEmail: jobPosition?.contactPersonEmail,
			location: jobPosition && "location" in jobPosition ? jobPosition.location : void 0
		},
		applicant: {
			url: getApplicantUrl(applicant),
			name: applicant?.name,
			phoneNumber: applicant?.phoneNumber,
			sourceName: applicantSource?.name
		}
	};
};
var buildEmailTemplate = ({ emailTemplate, withSignature = true }) => {
	let body = emailTemplate?.body || "";
	let signature = "";
	if (!body) return body;
	if (withSignature && emailTemplate.signature?.type === EmailContentType.HTML) signature = emailTemplate.signature.signature;
	else if (withSignature && emailTemplate.signature?.type === EmailContentType.TEXT) signature = transformLineBreaksToHtml(emailTemplate.signature.signature);
	if (emailTemplate.type === EmailContentType.HTML) body = mergeHtmlBodyAndSignature({
		body,
		signature
	});
	else body = mergeTextBodyAndSignature({
		body: transformLineBreaksToHtml(body),
		signature
	});
	return body;
};
var renderEmailTemplate = ({ emailTemplate, context, withSignature = true }) => {
	const body = typeof emailTemplate === "string" ? emailTemplate : buildEmailTemplate({
		emailTemplate,
		withSignature
	});
	if (!body) throw new Error("Email template body is empty");
	if (!context || typeof context !== "object") return body;
	return renderTemplate({
		templateString: body,
		context
	});
};
// source/utilities/resolve-on-behalf-of.ts
/**
* V2 customers always contact imported and manually created candidates on
* behalf of Stahlhart, the setting is not editable for them.
*
* Shared so that the UI (which locks the switch and seeds the form value) and
* the API (which enforces it on update and on Monday sync) cannot drift apart.
*/
var isImportedAndManualOnBehalfOfLocked = (productVersion) => productVersion === ProductVersion.V2;
/**
* Resolves on whose behalf an applicant email/SMS is sent, based on the two
* company settings.
*
* - Career page applicants follow
*   `contactCareerPageApplicantsOnBehalfOfStahlhart`.
* - Everyone else (Perspective, WL landing page or manually created) follows
*   `contactImportedAndManualApplicantsOnBehalfOfStahlhart`.
*
* The relevant flag is asserted to be a boolean instead of being coerced: the
* `createFromDbObject` factories are untyped, so a `companies` select that
* forgets the column yields `undefined` and would silently resolve to the
* customer — a different email template, a different sender and a different
* rejection phase. Failing here is loud and points at the incomplete select.
*/
var resolveOnBehalfOf = ({ contactCareerPageApplicantsOnBehalfOfStahlhart, contactImportedAndManualApplicantsOnBehalfOfStahlhart, applicantOrigin }) => {
	const [flagName, flag] = applicantOrigin === ApplicantOrigin.CAREER_PAGE ? ["contactCareerPageApplicantsOnBehalfOfStahlhart", contactCareerPageApplicantsOnBehalfOfStahlhart] : ["contactImportedAndManualApplicantsOnBehalfOfStahlhart", contactImportedAndManualApplicantsOnBehalfOfStahlhart];
	if (typeof flag !== "boolean") throw new Error(`resolveOnBehalfOf: ${flagName} is missing on the company. The company was most likely loaded with a select that does not include the on-behalf-of columns.`);
	return flag ? OnBehalfOf.STAHLHART : OnBehalfOf.CUSTOMER;
};
// source/utilities/safe-parse-date.ts
var safeParseDate = (dateString) => {
	if (!dateString) return null;
	if (dateString instanceof Date) return new Date(dateString);
	const date = new Date(dateString);
	if (Number.isNaN(date.getTime())) return null;
	return date;
};
// source/utilities/safely-append-suffix-to-string.ts
var safelyAppendSuffixToString = (value, suffix) => {
	if (!value.trim().endsWith(suffix)) return `${value}${suffix}`;
	return value;
};
// source/utilities/safely-remove-suffix-from-string.ts
var safelyRemoveSuffixFromString = (value, suffix) => {
	if (!value || typeof value !== "string" || !suffix || typeof suffix !== "string") return value;
	if (value.endsWith(suffix)) return value.slice(0, value.length - suffix.length);
	return value;
};
// source/utilities/status-update-due-date.ts
var BERLIN_TIME_ZONE = "Europe/Berlin";
var STATUS_UPDATE_FIRST_DUE_BUSINESS_DAYS = 2;
var STATUS_UPDATE_DUE_BUSINESS_DAYS = 3;
var TERMINAL_APPLICANT_PHASE_TYPES = [
	...endPhaseTypes,
	ApplicantPhaseType.HIRED,
	ApplicantPhaseType.TALENT_POOL
];
var isTerminalApplicantPhaseType = (type) => TERMINAL_APPLICANT_PHASE_TYPES.includes(type);
/**
* The subset of the terminal phases that ends the process without a hire, which
* is what gets logged automatically as a status update. `HIRED` and
* `TALENT_POOL` are terminal too, but they are not an end phase.
*/
var isEndApplicantPhaseType = (type) => endPhaseTypes.includes(type);
/**
* Whether status updates are tracked for an applicant at all.
*
* Status updates exist to prove the hiring guarantee is being honoured, so they
* only apply to V2 customers whose contract carries the guarantee, and only once
* the applicant has been forwarded — before that there is no anchor to compute a
* deadline from.
*
* Shared so the due-date chip, the overdue cron and the automatic phase-change
* logging all gate on the same condition.
*/
var isStatusUpdateTrackingActive = ({ productVersion, hiringGuarantee, forwardedAt }) => productVersion === ProductVersion.V2 && hiringGuarantee && forwardedAt != null;
/**
* Content of the status update that is logged automatically when an applicant is
* moved into an end phase. The decline reason is appended as-is and omitted
* along with its separating space when the applicant has none.
*/
var buildPhaseMovedStatusUpdateContent = ({ phaseName, declineReason }) => {
	const trimmedDeclineReason = declineReason?.trim();
	return `In die Phase ${phaseName} verschoben.${trimmedDeclineReason ? ` ${trimmedDeclineReason}` : ""}`;
};
var toBerlinWallClock = (date) => toZonedTime(new Date(date), BERLIN_TIME_ZONE);
var fromBerlinWallClock = (wallClock) => fromZonedTime(wallClock, BERLIN_TIME_ZONE);
var addDueInterval = (anchor, businessDays) => setHoursToBeforeMidnight(addBusinessDays(anchor, businessDays));
var getLatestStatusUpdate = (statusUpdates) => statusUpdates.reduce((latest, statusUpdate) => latest === null || new Date(statusUpdate.createdAt).getTime() > new Date(latest.createdAt).getTime() ? statusUpdate : latest, null);
/**
* Computes the date by which the next status update for an applicant is due.
*
* Shared between the API (overdue-notification cron) and the app (due-date chip)
* so both derive the deadline identically.
*
* The very first status update is due
* {@link STATUS_UPDATE_FIRST_DUE_BUSINESS_DAYS} business days after
* `forwardedAt`, at the end of the resulting day in {@link BERLIN_TIME_ZONE}. An
* applicant forwarded on Monday is due at the end of Wednesday; one forwarded on
* Friday is due at the end of the following Tuesday, because the weekend is
* skipped rather than counted.
*
* From the second update on, the cadence switches to
* {@link STATUS_UPDATE_DUE_BUSINESS_DAYS} business days after the most recent
* update was filed, at the end of the resulting day in
* {@link BERLIN_TIME_ZONE}. Only the most recent update counts, so filing early
* or late shifts the whole cadence instead of keeping the original rhythm: an
* update filed on a Tuesday makes the next deadline the following Friday, and
* one filed on the next Monday moves it to the Thursday after that.
*
* A manually chosen `followUpDate` on the most recent status update pushes the
* deadline later when it falls beyond the cadence step, but never pulls it
* forward — a follow-up scheduled before the next cadence step leaves that step
* untouched.
*/
var computeStatusUpdateDueDate = ({ forwardedAt, statusUpdates }) => {
	const latestStatusUpdate = getLatestStatusUpdate(statusUpdates);
	if (!latestStatusUpdate) return fromBerlinWallClock(addDueInterval(toBerlinWallClock(forwardedAt), 2));
	let dueDate = addDueInterval(toBerlinWallClock(latestStatusUpdate.createdAt), 3);
	if (latestStatusUpdate.followUpDate) {
		const followUpDueDate = setHoursToBeforeMidnight(toBerlinWallClock(latestStatusUpdate.followUpDate));
		if (followUpDueDate > dueDate) dueDate = followUpDueDate;
	}
	return fromBerlinWallClock(dueDate);
};
/**
* How many calendar days in {@link BERLIN_TIME_ZONE} the status update has been
* overdue, counted the same way as the due-date chip ("Überfällig seit 24
* Tagen"). Zero once the deadline has passed but no midnight has followed yet.
*/
var countStatusUpdateOverdueDays = ({ dueDate, now = /* @__PURE__ */ new Date() }) => differenceInCalendarDays(toBerlinWallClock(now), toBerlinWallClock(dueDate));
// source/utilities/transform-to-minimal-white-space-string.ts
var transformToMinimalWhiteSpaceString = (value) => value.replace(/\s+/g, " ").trim();
// source/utilities/url.ts
var getWwwDomainVariant = (domain) => {
	if (!domain) return "";
	return `www.${domain.replace(/^www\./i, "")}`;
};
var addProtocolToUrl = (url, protocol = "https://") => {
	let normalized;
	try {
		normalized = new URL(url).href;
	} catch {
		normalized = new URL(`${protocol}${url}`).href;
	}
	return normalized.endsWith("/") ? normalized.slice(0, -1) : normalized;
};
// source/utilities/version.ts
var version = "1.0.0";
// ../../node_modules/codsen-format-diagnostic-value/dist/codsen-format-diagnostic-value.esm.js
/**
* @name codsen-format-diagnostic-value
* @fileoverview Safely format untrusted JavaScript values for diagnostics
* @version 1.1.1
* @author Roy Revelt
* @license MIT
* {@link https://codsen.com/os/codsen-format-diagnostic-value/}
*/
function I$1() {
	let t = [], o = 0, e = !1;
	return {
		append(r) {
			return e ? !1 : o + r.length > 1999 ? (t.push("…"), o += 1, e = !0, !1) : (t.push(r), o += r.length, !0);
		},
		result() {
			return t.join("");
		},
		stopped() {
			return e;
		}
	};
}
function P(t) {
	return `\\u${t.toString(16).padStart(4, "0")}`;
}
function d$1(t, o) {
	if (t.append("\"")) {
		for (let e = 0; e < o.length && !t.stopped(); e += 1) {
			let r = o.charCodeAt(e);
			r === 34 ? t.append("\\\"") : r === 92 ? t.append("\\\\") : r === 8 ? t.append("\\b") : r === 9 ? t.append("\\t") : r === 10 ? t.append("\\n") : r === 12 ? t.append("\\f") : r === 13 ? t.append("\\r") : r < 32 || r === 8232 || r === 8233 || r >= 55296 && r <= 57343 ? t.append(P(r)) : t.append(o[e]);
		}
		t.append("\"");
	}
}
function S$1(t) {
	return t.get && t.set ? "[Getter/Setter]" : t.get ? "[Getter]" : t.set ? "[Setter]" : "[Accessor]";
}
function m(t, o) {
	t.append("Symbol(");
	let e = String(o);
	e.length > 8 && d$1(t, e.slice(7, -1)), t.append(")");
}
function U(t, o) {
	typeof o == "symbol" ? m(t, o) : d$1(t, String(o));
}
function R$2(t, o = 0) {
	let e = I$1(), r = o === 4 ? 4 : 0, u = /* @__PURE__ */ new WeakSet(), f = 0;
	function y(n) {
		r && e.append(" ".repeat(n * r));
	}
	function c(n, p) {
		n && e.append(","), r && (e.append(`
`), y(p + 1));
	}
	function g(n, p, s) {
		r && p && (e.append(`
`), y(s)), e.append(n);
	}
	function M(n, p) {
		Object.prototype.hasOwnProperty.call(n, "value") ? A(n.value, p) : e.append(S$1(n));
	}
	function T(n, p) {
		let s;
		try {
			s = Reflect.getOwnPropertyDescriptor(n, "length");
		} catch {
			e.append("[Uninspectable]");
			return;
		}
		let a = s?.value;
		if (!Number.isSafeInteger(a) || a < 0) {
			e.append("[Uninspectable]");
			return;
		}
		e.append("[");
		let i = !1;
		for (let l = 0; l < a && !e.stopped(); l += 1) {
			if (c(i, p), i = !0, f >= 50) {
				e.append("[MaxEntries]");
				break;
			}
			f += 1;
			let b;
			try {
				b = Reflect.getOwnPropertyDescriptor(n, String(l));
			} catch {
				e.append("[Uninspectable]");
				continue;
			}
			b?.enumerable ? M(b, p + 1) : e.append("[Empty]");
		}
		g("]", i, p);
	}
	function h(n, p) {
		let s;
		try {
			s = Reflect.ownKeys(n);
		} catch {
			e.append("[Uninspectable]");
			return;
		}
		e.append("{");
		let a = !1;
		for (let i of s) {
			if (e.stopped()) break;
			if (f >= 50) {
				c(a, p), a = !0, d$1(e, "…"), e.append(r ? ": " : ":"), e.append("[MaxEntries]");
				break;
			}
			f += 1;
			let l;
			try {
				l = Reflect.getOwnPropertyDescriptor(n, i);
			} catch {
				c(a, p), a = !0, U(e, i), e.append(r ? ": " : ":"), e.append("[Uninspectable]");
				continue;
			}
			l?.enumerable && (c(a, p), a = !0, U(e, i), e.append(r ? ": " : ":"), M(l, p + 1));
		}
		g("}", a, p);
	}
	function E(n, p) {
		if (u.has(n)) {
			e.append("[Circular]");
			return;
		}
		if (p >= 5) {
			e.append("[MaxDepth]");
			return;
		}
		let s;
		try {
			s = Array.isArray(n);
		} catch {
			e.append("[Uninspectable]");
			return;
		}
		u.add(n);
		try {
			s ? T(n, p) : h(n, p);
		} finally {
			u.delete(n);
		}
	}
	function A(n, p) {
		n === null ? e.append("null") : typeof n == "string" ? d$1(e, n) : typeof n == "number" ? e.append(Object.is(n, -0) ? "-0" : String(n)) : typeof n == "boolean" ? e.append(n ? "true" : "false") : typeof n > "u" ? e.append("undefined") : typeof n == "bigint" ? e.append(`${n}n`) : typeof n == "symbol" ? m(e, n) : typeof n == "function" ? e.append("[Function]") : E(n, p);
	}
	try {
		return A(t, 0), e.result();
	} catch {
		return "[Uninspectable]";
	}
}
// ../../node_modules/codsen-utils/dist/codsen-utils.esm.js
/**
* @name codsen-utils
* @fileoverview Various utility functions
* @version 1.10.3
* @author Roy Revelt
* @license MIT
* {@link https://codsen.com/os/codsen-utils/}
*/
var L$2 = [
	"_16_0_a_0_4_0_5_m_1_u_1_cp_4_b_e_4_7_0_1_0_3l_4_1_1_2_3_1_0_6_0_1_2_1_0_1_j_1_2a_1_3u_8_4l_1_11_2_0_",
	"6_14_1z_q_4_3_19_16_z_1_1_2q_1_0_f_1_7_1_a_2_2_0_g_0_1_t_t_2g_b_0_o_w_9_1_4_0_5_l_4_0_9_0_3_0_n_o_7_",
	"a_5_n_1_6_g_15_1m_1h_3_0_i_0_7_9_f_f_4_7_2_1_2_l_1_6_1_0_3_3_3_0_g_0_d_1_1_2_e_1_a_0_8_5_4_1_2_l_1_6",
	"_1_1_1_1_1_1_v_3_1_0_j_2_g_8_1_2_1_l_1_6_1_1_1_4_3_0_i_0_f_1_n_0_b_7_2_1_2_l_1_6_1_1_1_4_3_0_u_1_1_2",
	"_f_0_h_0_1_5_3_2_1_3_3_1_1_0_1_1_3_1_3_2_3_b_m_0_1g_7_1_2_1_m_1_f_3_0_q_2_1_1_2_1_u_0_4_7_1_2_1_m_1_",
	"9_1_4_3_0_u_2_1_1_f_1_h_8_1_2_1_14_2_0_g_0_5_2_8_2_o_5_5_h_3_n_1_8_1_0_2_6_1m_1b_1_1_c_6_1m_1_1_0_1_",
	"4_1_n_1_0_1_9_1_1_9_0_2_4_1_0_l_3_w_0_1r_7_1_z_r_4_37_16_k_0_g_5_4_3_3_0_3_1_7_2_4_c_c_0_h_11_1_0_5_",
	"0_2_16_1_98_1_3_2_6_1_0_1_3_2_14_1_3_2_w_1_3_2_6_1_0_1_3_2_e_1_1k_1_3_2_1u_11_f_g_2d_2_5_3_h7_2_g_1_",
	"p_5_22_6_7_7_h_d_i_e_h_e_c_1_2_f_1f_z_0_4_0_1v_2g_7_4_2_x_1_0_5_1x_a_u_1d_t_2_4_b_17_4_p_1i_m_9_1g_2",
	"a_0_2l_1a_h_7_1i_t_d_1_a_17_q_z_15_2_a_z_2_a_5_16_2_2_15_3_1_5_1_1_3_0_5_5b_1s_7p_2_5_2_11_2_5_2_7_1",
	"_0_1_0_1_0_1_u_2_1g_1_6_1_0_3_2_1_6_3_3_2_5_4_c_5_2_1_6_38_0_d_0_g_c_2t_0_4_0_2_9_1_0_3_4_6_0_1_0_1_",
	"0_1_3_1_a_2_3_5_4_4_0_1g_1_22j_6c_6_3_3_1_c_11_1_0_5_0_2_1j_7_0_g_m_9_6_1_6_1_6_1_6_1_6_1_6_1_6_1_6_",
	"28_0_d1_1_16_4_5_1_4_2d_6_2_1_2h_1_3_5_16_1_2l_h_v_1c_f_e8_533_1s_h3g_1v_19_2_7g_3_f_a_1_k_1a_g_u_2_",
	"1x_1d_8_2_2u_2_29_k_g_1_2_1_3_1_m_t_1f_e_1d_1q_5_3_0_1_1_b_r_a_m_p_s_7_1a_s_0_g_4_1_9_a_4_1_14_n_2_1",
	"_7_k_m_3_0_3_1d_1_0_3_1_2_4_2_0_1_0_o_2_2_a_7_2_c_5_2_5_2_5_9_6_1_6_1_16_1_d_6_36_t_8mb_c_m_4_1c_6is",
	"_a5_2_2x_12_6_c_4_5_0_1_9_1_c_1_4_1_0_1_1_1_1_1_2z_x_a2_i_1r_2_1h_14_b_38_4_1_3q_10_p_6_p_b_2g_3_5_2",
	"_5_2_5_2_2_z_b_1_p_1_i_1_1_1_e_2_d_y_3e_at_s_3_1c_1b_v_d_j_1_7_6_11_a_t_2_z_4_7_1c_4d_i_z_4_z_4_13_8",
	"_1f_c_a_1_e_1_6_1_1_1_a_1_e_1_6_1_1_3_1f_c_8m_9_l_a_7_o_5_1_15_1_8_1x_5_2_0_1_17_1_1_3_0_2_m_a_m_9_u",
	"_1t_i_1_1_a_l_a_p_6_p_12_1j_6_1_1s_0_f_3_1_2_1_s_16_s_3_s_z_7_1_r_r_1h_a_l_a_i_d_h_32_20_1j_1e_d_1e_",
	"d_z_12_r_9_m_6y_15_6_1_g_5_1k_s_a_0_8_l_16_h_1a_k_r_m_c_1g_1l_1_2_0_d_18_w_o_q_z_t_0_2_0_8_y_3_0_c_1",
	"b_e_3_l_0_1_0_z_h_1_o_j_1_1r_6_1_0_1_3_1_e_1_9_7_1a_12_7_2_1_2_l_1_6_1_1_1_4_3_0_i_0_c_4_u_9_1_0_2_0",
	"_1_11_1_0_p_0_1_0_18_1g_i_3_k_2_u_1b_k_1_1_0_54_1a_15_3_10_1b_k_0_1n_16_d_0_1z_q_11_6_55_17_38_1r_v_",
	"7_2_0_2_7_1_1_1_n_f_0_1_0_2m_7_2_12_g_0_1_0_s_0_a_13_7_0_l_0_b_19_j_0_i_20_5j_w_v_8_1_10_h_0_1d_t_34",
	"_6_1_1_1_11_l_0_p_5_1_1_1_v_e_0_n_17_78_i_f_0_1_c_1_x_3g_0_27_pl_6e_5f_218_2o_f_tr_h_5_p_32y_5_g6_5a",
	"1_t_1cy_fs_7_u_h_26_h_t_i_1b_g_3_v_k_5_i_c0_18_5v_1r_w_o_2_o_18_22_5_0_1u_c_1s_1_1_0_e_1_c_5p1_15_v_",
	"2p_36_6pp_3_1_6_1_1_1_82_f_0_t_2_2_0_e_3_8_az_1s4_2y_5_c_3_8_7_9_4me_2c_1_1y_1_1_2_0_2_1_2_3_1_b_1_0",
	"_1_6_1_1s_1_3_2_7_1_6_1_r_1_3_1_4_1_0_3_6_1_9f_2_o_1_o_1_u_1_o_1_u_1_o_1_u_1_o_1_u_1_o_1_7_1f8_u_6_5",
	"_79_1p_42_18_a_6_g_0_8x_t_i_17_dg_r_6c_t_2_0_5r_u_1_2_1_1_1_6_2_4_9_1_68_6_1_3_1_1_1_e_1_5g_1n_1v_7_",
	"0_xg_3_1_q_1_1_1_0_2_0_1_9_1_3_1_0_1_0_6_0_4_0_1_0_1_0_1_2_1_1_1_0_2_0_1_0_1_0_1_0_1_0_1_1_1_0_2_3_1",
	"_6_1_3_1_3_1_0_1_9_1_g_5_2_1_4_1_g_3es_wyn_w_3dp_2_4gd_2_5rk_f_h9_1wi_f1_15u_3t6_5_6jt"
].join("").slice(1).split("_");
var W = [];
var Y = 127;
for (let e = 0; e < L$2.length; e += 2) {
	let t = Y + 1 + Number.parseInt(L$2[e], 36), n = t + Number.parseInt(L$2[e + 1], 36);
	W.push([t, n]), Y = n;
}
var T$2 = Object.prototype.hasOwnProperty;
var ne = Function.prototype.toString;
var pe = ne.call(Object);
Map.prototype.entries;
Set.prototype.values;
Object.getOwnPropertyDescriptor(ArrayBuffer.prototype, "byteLength")?.get;
Object.getOwnPropertyDescriptor(RegExp.prototype, "flags")?.get;
Object.getOwnPropertyDescriptor(RegExp.prototype, "global")?.get;
Object.getOwnPropertyDescriptor(RegExp.prototype, "source")?.get;
RegExp.prototype.test;
function Re(e) {
	if (e == null || typeof e != "object") return !1;
	let t = Object.getPrototypeOf(e);
	if (t === null || t === Object.prototype) return !0;
	let n = Object.getOwnPropertyDescriptor(t, "constructor");
	return !n || !("value" in n) || typeof n.value != "function" ? !1 : Object.getOwnPropertyDescriptor(n.value, "prototype")?.value === t && ne.call(n.value) === pe;
}
function b$2(e) {
	return typeof e == "string";
}
function Pe$1(e) {
	return Number.isFinite(e);
}
function Mt(e) {
	return Number.isSafeInteger(e) && e >= 0;
}
Date.prototype.getTime;
function Te(e, t) {
	let n = /* @__PURE__ */ new Set();
	for (let _ = 0; _ < t.length;) {
		let s = t.codePointAt(_);
		n.add(s), _ += s > 65535 ? 2 : 1;
	}
	let r = 0, o = e.length;
	for (; r < o;) {
		let _ = e.codePointAt(r);
		if (!n.has(_)) break;
		r += _ > 65535 ? 2 : 1;
	}
	for (; o > r;) {
		let _ = e.codePointAt(o - 2) || 0, s = _ > 65535 ? 2 : 1, c = s === 2 ? _ : e.charCodeAt(o - 1);
		if (!n.has(c)) break;
		o -= s;
	}
	return r === 0 && o === e.length ? e : e.slice(r, o);
}
function Dt(e, t) {
	if (!e || !t) return e;
	for (let o = t.length; o--;) {
		let _ = t.charCodeAt(o);
		if (_ >= 55296 && _ <= 57343) return Te(e, t);
	}
	let n = 0, r = e.length;
	if (t.length === 1) {
		let o = t.charCodeAt(0);
		for (; n < r && e.charCodeAt(n) === o;) n++;
		for (; r > n && e.charCodeAt(r - 1) === o;) r--;
	} else {
		for (; n < r && t.includes(e[n]);) n++;
		for (; r > n && t.includes(e[r - 1]);) r--;
	}
	return n === 0 && r === e.length ? e : e.slice(n, r);
}
function Bt(e = [], t = []) {
	if (!e || !Array.isArray(e) || !e.length) return [];
	if (!t || !Array.isArray(t) || !t.length) return e.slice();
	if (e.length * t.length < 400) return e.filter((r) => !t.includes(r));
	let n = new Set(t);
	return e.filter((r) => !n.has(r));
}
function Lt(e) {
	return e != null;
}
function Vt(e, t) {
	return e != null && T$2.call(e, t);
}
// ../../node_modules/html-entity-codec/dist/html-entity-codec.esm.js
/**
* @name html-entity-codec
* @fileoverview Decode, encode, and escape HTML character references
* @version 1.1.0
* @author Roy Revelt
* @license MIT
* {@link https://codsen.com/os/html-entity-codec/}
*/
var d = {
	AElig: "Æ",
	"AElig;": "Æ",
	AMP: "&",
	"AMP;": "&",
	Aacute: "Á",
	"Aacute;": "Á",
	"Abreve;": "Ă",
	Acirc: "Â",
	"Acirc;": "Â",
	"Acy;": "А",
	"Afr;": "𝔄",
	Agrave: "À",
	"Agrave;": "À",
	"Alpha;": "Α",
	"Amacr;": "Ā",
	"And;": "⩓",
	"Aogon;": "Ą",
	"Aopf;": "𝔸",
	"ApplyFunction;": "⁡",
	Aring: "Å",
	"Aring;": "Å",
	"Ascr;": "𝒜",
	"Assign;": "≔",
	Atilde: "Ã",
	"Atilde;": "Ã",
	Auml: "Ä",
	"Auml;": "Ä",
	"Backslash;": "∖",
	"Barv;": "⫧",
	"Barwed;": "⌆",
	"Bcy;": "Б",
	"Because;": "∵",
	"Bernoullis;": "ℬ",
	"Beta;": "Β",
	"Bfr;": "𝔅",
	"Bopf;": "𝔹",
	"Breve;": "˘",
	"Bscr;": "ℬ",
	"Bumpeq;": "≎",
	"CHcy;": "Ч",
	COPY: "©",
	"COPY;": "©",
	"Cacute;": "Ć",
	"Cap;": "⋒",
	"CapitalDifferentialD;": "ⅅ",
	"Cayleys;": "ℭ",
	"Ccaron;": "Č",
	Ccedil: "Ç",
	"Ccedil;": "Ç",
	"Ccirc;": "Ĉ",
	"Cconint;": "∰",
	"Cdot;": "Ċ",
	"Cedilla;": "¸",
	"CenterDot;": "·",
	"Cfr;": "ℭ",
	"Chi;": "Χ",
	"CircleDot;": "⊙",
	"CircleMinus;": "⊖",
	"CirclePlus;": "⊕",
	"CircleTimes;": "⊗",
	"ClockwiseContourIntegral;": "∲",
	"CloseCurlyDoubleQuote;": "”",
	"CloseCurlyQuote;": "’",
	"Colon;": "∷",
	"Colone;": "⩴",
	"Congruent;": "≡",
	"Conint;": "∯",
	"ContourIntegral;": "∮",
	"Copf;": "ℂ",
	"Coproduct;": "∐",
	"CounterClockwiseContourIntegral;": "∳",
	"Cross;": "⨯",
	"Cscr;": "𝒞",
	"Cup;": "⋓",
	"CupCap;": "≍",
	"DD;": "ⅅ",
	"DDotrahd;": "⤑",
	"DJcy;": "Ђ",
	"DScy;": "Ѕ",
	"DZcy;": "Џ",
	"Dagger;": "‡",
	"Darr;": "↡",
	"Dashv;": "⫤",
	"Dcaron;": "Ď",
	"Dcy;": "Д",
	"Del;": "∇",
	"Delta;": "Δ",
	"Dfr;": "𝔇",
	"DiacriticalAcute;": "´",
	"DiacriticalDot;": "˙",
	"DiacriticalDoubleAcute;": "˝",
	"DiacriticalGrave;": "`",
	"DiacriticalTilde;": "˜",
	"Diamond;": "⋄",
	"DifferentialD;": "ⅆ",
	"Dopf;": "𝔻",
	"Dot;": "¨",
	"DotDot;": "⃜",
	"DotEqual;": "≐",
	"DoubleContourIntegral;": "∯",
	"DoubleDot;": "¨",
	"DoubleDownArrow;": "⇓",
	"DoubleLeftArrow;": "⇐",
	"DoubleLeftRightArrow;": "⇔",
	"DoubleLeftTee;": "⫤",
	"DoubleLongLeftArrow;": "⟸",
	"DoubleLongLeftRightArrow;": "⟺",
	"DoubleLongRightArrow;": "⟹",
	"DoubleRightArrow;": "⇒",
	"DoubleRightTee;": "⊨",
	"DoubleUpArrow;": "⇑",
	"DoubleUpDownArrow;": "⇕",
	"DoubleVerticalBar;": "∥",
	"DownArrow;": "↓",
	"DownArrowBar;": "⤓",
	"DownArrowUpArrow;": "⇵",
	"DownBreve;": "̑",
	"DownLeftRightVector;": "⥐",
	"DownLeftTeeVector;": "⥞",
	"DownLeftVector;": "↽",
	"DownLeftVectorBar;": "⥖",
	"DownRightTeeVector;": "⥟",
	"DownRightVector;": "⇁",
	"DownRightVectorBar;": "⥗",
	"DownTee;": "⊤",
	"DownTeeArrow;": "↧",
	"Downarrow;": "⇓",
	"Dscr;": "𝒟",
	"Dstrok;": "Đ",
	"ENG;": "Ŋ",
	ETH: "Ð",
	"ETH;": "Ð",
	Eacute: "É",
	"Eacute;": "É",
	"Ecaron;": "Ě",
	Ecirc: "Ê",
	"Ecirc;": "Ê",
	"Ecy;": "Э",
	"Edot;": "Ė",
	"Efr;": "𝔈",
	Egrave: "È",
	"Egrave;": "È",
	"Element;": "∈",
	"Emacr;": "Ē",
	"EmptySmallSquare;": "◻",
	"EmptyVerySmallSquare;": "▫",
	"Eogon;": "Ę",
	"Eopf;": "𝔼",
	"Epsilon;": "Ε",
	"Equal;": "⩵",
	"EqualTilde;": "≂",
	"Equilibrium;": "⇌",
	"Escr;": "ℰ",
	"Esim;": "⩳",
	"Eta;": "Η",
	Euml: "Ë",
	"Euml;": "Ë",
	"Exists;": "∃",
	"ExponentialE;": "ⅇ",
	"Fcy;": "Ф",
	"Ffr;": "𝔉",
	"FilledSmallSquare;": "◼",
	"FilledVerySmallSquare;": "▪",
	"Fopf;": "𝔽",
	"ForAll;": "∀",
	"Fouriertrf;": "ℱ",
	"Fscr;": "ℱ",
	"GJcy;": "Ѓ",
	GT: ">",
	"GT;": ">",
	"Gamma;": "Γ",
	"Gammad;": "Ϝ",
	"Gbreve;": "Ğ",
	"Gcedil;": "Ģ",
	"Gcirc;": "Ĝ",
	"Gcy;": "Г",
	"Gdot;": "Ġ",
	"Gfr;": "𝔊",
	"Gg;": "⋙",
	"Gopf;": "𝔾",
	"GreaterEqual;": "≥",
	"GreaterEqualLess;": "⋛",
	"GreaterFullEqual;": "≧",
	"GreaterGreater;": "⪢",
	"GreaterLess;": "≷",
	"GreaterSlantEqual;": "⩾",
	"GreaterTilde;": "≳",
	"Gscr;": "𝒢",
	"Gt;": "≫",
	"HARDcy;": "Ъ",
	"Hacek;": "ˇ",
	"Hat;": "^",
	"Hcirc;": "Ĥ",
	"Hfr;": "ℌ",
	"HilbertSpace;": "ℋ",
	"Hopf;": "ℍ",
	"HorizontalLine;": "─",
	"Hscr;": "ℋ",
	"Hstrok;": "Ħ",
	"HumpDownHump;": "≎",
	"HumpEqual;": "≏",
	"IEcy;": "Е",
	"IJlig;": "Ĳ",
	"IOcy;": "Ё",
	Iacute: "Í",
	"Iacute;": "Í",
	Icirc: "Î",
	"Icirc;": "Î",
	"Icy;": "И",
	"Idot;": "İ",
	"Ifr;": "ℑ",
	Igrave: "Ì",
	"Igrave;": "Ì",
	"Im;": "ℑ",
	"Imacr;": "Ī",
	"ImaginaryI;": "ⅈ",
	"Implies;": "⇒",
	"Int;": "∬",
	"Integral;": "∫",
	"Intersection;": "⋂",
	"InvisibleComma;": "⁣",
	"InvisibleTimes;": "⁢",
	"Iogon;": "Į",
	"Iopf;": "𝕀",
	"Iota;": "Ι",
	"Iscr;": "ℐ",
	"Itilde;": "Ĩ",
	"Iukcy;": "І",
	Iuml: "Ï",
	"Iuml;": "Ï",
	"Jcirc;": "Ĵ",
	"Jcy;": "Й",
	"Jfr;": "𝔍",
	"Jopf;": "𝕁",
	"Jscr;": "𝒥",
	"Jsercy;": "Ј",
	"Jukcy;": "Є",
	"KHcy;": "Х",
	"KJcy;": "Ќ",
	"Kappa;": "Κ",
	"Kcedil;": "Ķ",
	"Kcy;": "К",
	"Kfr;": "𝔎",
	"Kopf;": "𝕂",
	"Kscr;": "𝒦",
	"LJcy;": "Љ",
	LT: "<",
	"LT;": "<",
	"Lacute;": "Ĺ",
	"Lambda;": "Λ",
	"Lang;": "⟪",
	"Laplacetrf;": "ℒ",
	"Larr;": "↞",
	"Lcaron;": "Ľ",
	"Lcedil;": "Ļ",
	"Lcy;": "Л",
	"LeftAngleBracket;": "⟨",
	"LeftArrow;": "←",
	"LeftArrowBar;": "⇤",
	"LeftArrowRightArrow;": "⇆",
	"LeftCeiling;": "⌈",
	"LeftDoubleBracket;": "⟦",
	"LeftDownTeeVector;": "⥡",
	"LeftDownVector;": "⇃",
	"LeftDownVectorBar;": "⥙",
	"LeftFloor;": "⌊",
	"LeftRightArrow;": "↔",
	"LeftRightVector;": "⥎",
	"LeftTee;": "⊣",
	"LeftTeeArrow;": "↤",
	"LeftTeeVector;": "⥚",
	"LeftTriangle;": "⊲",
	"LeftTriangleBar;": "⧏",
	"LeftTriangleEqual;": "⊴",
	"LeftUpDownVector;": "⥑",
	"LeftUpTeeVector;": "⥠",
	"LeftUpVector;": "↿",
	"LeftUpVectorBar;": "⥘",
	"LeftVector;": "↼",
	"LeftVectorBar;": "⥒",
	"Leftarrow;": "⇐",
	"Leftrightarrow;": "⇔",
	"LessEqualGreater;": "⋚",
	"LessFullEqual;": "≦",
	"LessGreater;": "≶",
	"LessLess;": "⪡",
	"LessSlantEqual;": "⩽",
	"LessTilde;": "≲",
	"Lfr;": "𝔏",
	"Ll;": "⋘",
	"Lleftarrow;": "⇚",
	"Lmidot;": "Ŀ",
	"LongLeftArrow;": "⟵",
	"LongLeftRightArrow;": "⟷",
	"LongRightArrow;": "⟶",
	"Longleftarrow;": "⟸",
	"Longleftrightarrow;": "⟺",
	"Longrightarrow;": "⟹",
	"Lopf;": "𝕃",
	"LowerLeftArrow;": "↙",
	"LowerRightArrow;": "↘",
	"Lscr;": "ℒ",
	"Lsh;": "↰",
	"Lstrok;": "Ł",
	"Lt;": "≪",
	"Map;": "⤅",
	"Mcy;": "М",
	"MediumSpace;": " ",
	"Mellintrf;": "ℳ",
	"Mfr;": "𝔐",
	"MinusPlus;": "∓",
	"Mopf;": "𝕄",
	"Mscr;": "ℳ",
	"Mu;": "Μ",
	"NJcy;": "Њ",
	"Nacute;": "Ń",
	"Ncaron;": "Ň",
	"Ncedil;": "Ņ",
	"Ncy;": "Н",
	"NegativeMediumSpace;": "​",
	"NegativeThickSpace;": "​",
	"NegativeThinSpace;": "​",
	"NegativeVeryThinSpace;": "​",
	"NestedGreaterGreater;": "≫",
	"NestedLessLess;": "≪",
	"NewLine;": `
`,
	"Nfr;": "𝔑",
	"NoBreak;": "⁠",
	"NonBreakingSpace;": "\xA0",
	"Nopf;": "ℕ",
	"Not;": "⫬",
	"NotCongruent;": "≢",
	"NotCupCap;": "≭",
	"NotDoubleVerticalBar;": "∦",
	"NotElement;": "∉",
	"NotEqual;": "≠",
	"NotEqualTilde;": "≂̸",
	"NotExists;": "∄",
	"NotGreater;": "≯",
	"NotGreaterEqual;": "≱",
	"NotGreaterFullEqual;": "≧̸",
	"NotGreaterGreater;": "≫̸",
	"NotGreaterLess;": "≹",
	"NotGreaterSlantEqual;": "⩾̸",
	"NotGreaterTilde;": "≵",
	"NotHumpDownHump;": "≎̸",
	"NotHumpEqual;": "≏̸",
	"NotLeftTriangle;": "⋪",
	"NotLeftTriangleBar;": "⧏̸",
	"NotLeftTriangleEqual;": "⋬",
	"NotLess;": "≮",
	"NotLessEqual;": "≰",
	"NotLessGreater;": "≸",
	"NotLessLess;": "≪̸",
	"NotLessSlantEqual;": "⩽̸",
	"NotLessTilde;": "≴",
	"NotNestedGreaterGreater;": "⪢̸",
	"NotNestedLessLess;": "⪡̸",
	"NotPrecedes;": "⊀",
	"NotPrecedesEqual;": "⪯̸",
	"NotPrecedesSlantEqual;": "⋠",
	"NotReverseElement;": "∌",
	"NotRightTriangle;": "⋫",
	"NotRightTriangleBar;": "⧐̸",
	"NotRightTriangleEqual;": "⋭",
	"NotSquareSubset;": "⊏̸",
	"NotSquareSubsetEqual;": "⋢",
	"NotSquareSuperset;": "⊐̸",
	"NotSquareSupersetEqual;": "⋣",
	"NotSubset;": "⊂⃒",
	"NotSubsetEqual;": "⊈",
	"NotSucceeds;": "⊁",
	"NotSucceedsEqual;": "⪰̸",
	"NotSucceedsSlantEqual;": "⋡",
	"NotSucceedsTilde;": "≿̸",
	"NotSuperset;": "⊃⃒",
	"NotSupersetEqual;": "⊉",
	"NotTilde;": "≁",
	"NotTildeEqual;": "≄",
	"NotTildeFullEqual;": "≇",
	"NotTildeTilde;": "≉",
	"NotVerticalBar;": "∤",
	"Nscr;": "𝒩",
	Ntilde: "Ñ",
	"Ntilde;": "Ñ",
	"Nu;": "Ν",
	"OElig;": "Œ",
	Oacute: "Ó",
	"Oacute;": "Ó",
	Ocirc: "Ô",
	"Ocirc;": "Ô",
	"Ocy;": "О",
	"Odblac;": "Ő",
	"Ofr;": "𝔒",
	Ograve: "Ò",
	"Ograve;": "Ò",
	"Omacr;": "Ō",
	"Omega;": "Ω",
	"Omicron;": "Ο",
	"Oopf;": "𝕆",
	"OpenCurlyDoubleQuote;": "“",
	"OpenCurlyQuote;": "‘",
	"Or;": "⩔",
	"Oscr;": "𝒪",
	Oslash: "Ø",
	"Oslash;": "Ø",
	Otilde: "Õ",
	"Otilde;": "Õ",
	"Otimes;": "⨷",
	Ouml: "Ö",
	"Ouml;": "Ö",
	"OverBar;": "‾",
	"OverBrace;": "⏞",
	"OverBracket;": "⎴",
	"OverParenthesis;": "⏜",
	"PartialD;": "∂",
	"Pcy;": "П",
	"Pfr;": "𝔓",
	"Phi;": "Φ",
	"Pi;": "Π",
	"PlusMinus;": "±",
	"Poincareplane;": "ℌ",
	"Popf;": "ℙ",
	"Pr;": "⪻",
	"Precedes;": "≺",
	"PrecedesEqual;": "⪯",
	"PrecedesSlantEqual;": "≼",
	"PrecedesTilde;": "≾",
	"Prime;": "″",
	"Product;": "∏",
	"Proportion;": "∷",
	"Proportional;": "∝",
	"Pscr;": "𝒫",
	"Psi;": "Ψ",
	QUOT: "\"",
	"QUOT;": "\"",
	"Qfr;": "𝔔",
	"Qopf;": "ℚ",
	"Qscr;": "𝒬",
	"RBarr;": "⤐",
	REG: "®",
	"REG;": "®",
	"Racute;": "Ŕ",
	"Rang;": "⟫",
	"Rarr;": "↠",
	"Rarrtl;": "⤖",
	"Rcaron;": "Ř",
	"Rcedil;": "Ŗ",
	"Rcy;": "Р",
	"Re;": "ℜ",
	"ReverseElement;": "∋",
	"ReverseEquilibrium;": "⇋",
	"ReverseUpEquilibrium;": "⥯",
	"Rfr;": "ℜ",
	"Rho;": "Ρ",
	"RightAngleBracket;": "⟩",
	"RightArrow;": "→",
	"RightArrowBar;": "⇥",
	"RightArrowLeftArrow;": "⇄",
	"RightCeiling;": "⌉",
	"RightDoubleBracket;": "⟧",
	"RightDownTeeVector;": "⥝",
	"RightDownVector;": "⇂",
	"RightDownVectorBar;": "⥕",
	"RightFloor;": "⌋",
	"RightTee;": "⊢",
	"RightTeeArrow;": "↦",
	"RightTeeVector;": "⥛",
	"RightTriangle;": "⊳",
	"RightTriangleBar;": "⧐",
	"RightTriangleEqual;": "⊵",
	"RightUpDownVector;": "⥏",
	"RightUpTeeVector;": "⥜",
	"RightUpVector;": "↾",
	"RightUpVectorBar;": "⥔",
	"RightVector;": "⇀",
	"RightVectorBar;": "⥓",
	"Rightarrow;": "⇒",
	"Ropf;": "ℝ",
	"RoundImplies;": "⥰",
	"Rrightarrow;": "⇛",
	"Rscr;": "ℛ",
	"Rsh;": "↱",
	"RuleDelayed;": "⧴",
	"SHCHcy;": "Щ",
	"SHcy;": "Ш",
	"SOFTcy;": "Ь",
	"Sacute;": "Ś",
	"Sc;": "⪼",
	"Scaron;": "Š",
	"Scedil;": "Ş",
	"Scirc;": "Ŝ",
	"Scy;": "С",
	"Sfr;": "𝔖",
	"ShortDownArrow;": "↓",
	"ShortLeftArrow;": "←",
	"ShortRightArrow;": "→",
	"ShortUpArrow;": "↑",
	"Sigma;": "Σ",
	"SmallCircle;": "∘",
	"Sopf;": "𝕊",
	"Sqrt;": "√",
	"Square;": "□",
	"SquareIntersection;": "⊓",
	"SquareSubset;": "⊏",
	"SquareSubsetEqual;": "⊑",
	"SquareSuperset;": "⊐",
	"SquareSupersetEqual;": "⊒",
	"SquareUnion;": "⊔",
	"Sscr;": "𝒮",
	"Star;": "⋆",
	"Sub;": "⋐",
	"Subset;": "⋐",
	"SubsetEqual;": "⊆",
	"Succeeds;": "≻",
	"SucceedsEqual;": "⪰",
	"SucceedsSlantEqual;": "≽",
	"SucceedsTilde;": "≿",
	"SuchThat;": "∋",
	"Sum;": "∑",
	"Sup;": "⋑",
	"Superset;": "⊃",
	"SupersetEqual;": "⊇",
	"Supset;": "⋑",
	THORN: "Þ",
	"THORN;": "Þ",
	"TRADE;": "™",
	"TSHcy;": "Ћ",
	"TScy;": "Ц",
	"Tab;": "	",
	"Tau;": "Τ",
	"Tcaron;": "Ť",
	"Tcedil;": "Ţ",
	"Tcy;": "Т",
	"Tfr;": "𝔗",
	"Therefore;": "∴",
	"Theta;": "Θ",
	"ThickSpace;": "  ",
	"ThinSpace;": " ",
	"Tilde;": "∼",
	"TildeEqual;": "≃",
	"TildeFullEqual;": "≅",
	"TildeTilde;": "≈",
	"Topf;": "𝕋",
	"TripleDot;": "⃛",
	"Tscr;": "𝒯",
	"Tstrok;": "Ŧ",
	Uacute: "Ú",
	"Uacute;": "Ú",
	"Uarr;": "↟",
	"Uarrocir;": "⥉",
	"Ubrcy;": "Ў",
	"Ubreve;": "Ŭ",
	Ucirc: "Û",
	"Ucirc;": "Û",
	"Ucy;": "У",
	"Udblac;": "Ű",
	"Ufr;": "𝔘",
	Ugrave: "Ù",
	"Ugrave;": "Ù",
	"Umacr;": "Ū",
	"UnderBar;": "_",
	"UnderBrace;": "⏟",
	"UnderBracket;": "⎵",
	"UnderParenthesis;": "⏝",
	"Union;": "⋃",
	"UnionPlus;": "⊎",
	"Uogon;": "Ų",
	"Uopf;": "𝕌",
	"UpArrow;": "↑",
	"UpArrowBar;": "⤒",
	"UpArrowDownArrow;": "⇅",
	"UpDownArrow;": "↕",
	"UpEquilibrium;": "⥮",
	"UpTee;": "⊥",
	"UpTeeArrow;": "↥",
	"Uparrow;": "⇑",
	"Updownarrow;": "⇕",
	"UpperLeftArrow;": "↖",
	"UpperRightArrow;": "↗",
	"Upsi;": "ϒ",
	"Upsilon;": "Υ",
	"Uring;": "Ů",
	"Uscr;": "𝒰",
	"Utilde;": "Ũ",
	Uuml: "Ü",
	"Uuml;": "Ü",
	"VDash;": "⊫",
	"Vbar;": "⫫",
	"Vcy;": "В",
	"Vdash;": "⊩",
	"Vdashl;": "⫦",
	"Vee;": "⋁",
	"Verbar;": "‖",
	"Vert;": "‖",
	"VerticalBar;": "∣",
	"VerticalLine;": "|",
	"VerticalSeparator;": "❘",
	"VerticalTilde;": "≀",
	"VeryThinSpace;": " ",
	"Vfr;": "𝔙",
	"Vopf;": "𝕍",
	"Vscr;": "𝒱",
	"Vvdash;": "⊪",
	"Wcirc;": "Ŵ",
	"Wedge;": "⋀",
	"Wfr;": "𝔚",
	"Wopf;": "𝕎",
	"Wscr;": "𝒲",
	"Xfr;": "𝔛",
	"Xi;": "Ξ",
	"Xopf;": "𝕏",
	"Xscr;": "𝒳",
	"YAcy;": "Я",
	"YIcy;": "Ї",
	"YUcy;": "Ю",
	Yacute: "Ý",
	"Yacute;": "Ý",
	"Ycirc;": "Ŷ",
	"Ycy;": "Ы",
	"Yfr;": "𝔜",
	"Yopf;": "𝕐",
	"Yscr;": "𝒴",
	"Yuml;": "Ÿ",
	"ZHcy;": "Ж",
	"Zacute;": "Ź",
	"Zcaron;": "Ž",
	"Zcy;": "З",
	"Zdot;": "Ż",
	"ZeroWidthSpace;": "​",
	"Zeta;": "Ζ",
	"Zfr;": "ℨ",
	"Zopf;": "ℤ",
	"Zscr;": "𝒵",
	aacute: "á",
	"aacute;": "á",
	"abreve;": "ă",
	"ac;": "∾",
	"acE;": "∾̳",
	"acd;": "∿",
	acirc: "â",
	"acirc;": "â",
	acute: "´",
	"acute;": "´",
	"acy;": "а",
	aelig: "æ",
	"aelig;": "æ",
	"af;": "⁡",
	"afr;": "𝔞",
	agrave: "à",
	"agrave;": "à",
	"alefsym;": "ℵ",
	"aleph;": "ℵ",
	"alpha;": "α",
	"amacr;": "ā",
	"amalg;": "⨿",
	amp: "&",
	"amp;": "&",
	"and;": "∧",
	"andand;": "⩕",
	"andd;": "⩜",
	"andslope;": "⩘",
	"andv;": "⩚",
	"ang;": "∠",
	"ange;": "⦤",
	"angle;": "∠",
	"angmsd;": "∡",
	"angmsdaa;": "⦨",
	"angmsdab;": "⦩",
	"angmsdac;": "⦪",
	"angmsdad;": "⦫",
	"angmsdae;": "⦬",
	"angmsdaf;": "⦭",
	"angmsdag;": "⦮",
	"angmsdah;": "⦯",
	"angrt;": "∟",
	"angrtvb;": "⊾",
	"angrtvbd;": "⦝",
	"angsph;": "∢",
	"angst;": "Å",
	"angzarr;": "⍼",
	"aogon;": "ą",
	"aopf;": "𝕒",
	"ap;": "≈",
	"apE;": "⩰",
	"apacir;": "⩯",
	"ape;": "≊",
	"apid;": "≋",
	"apos;": "'",
	"approx;": "≈",
	"approxeq;": "≊",
	aring: "å",
	"aring;": "å",
	"ascr;": "𝒶",
	"ast;": "*",
	"asymp;": "≈",
	"asympeq;": "≍",
	atilde: "ã",
	"atilde;": "ã",
	auml: "ä",
	"auml;": "ä",
	"awconint;": "∳",
	"awint;": "⨑",
	"bNot;": "⫭",
	"backcong;": "≌",
	"backepsilon;": "϶",
	"backprime;": "‵",
	"backsim;": "∽",
	"backsimeq;": "⋍",
	"barvee;": "⊽",
	"barwed;": "⌅",
	"barwedge;": "⌅",
	"bbrk;": "⎵",
	"bbrktbrk;": "⎶",
	"bcong;": "≌",
	"bcy;": "б",
	"bdquo;": "„",
	"becaus;": "∵",
	"because;": "∵",
	"bemptyv;": "⦰",
	"bepsi;": "϶",
	"bernou;": "ℬ",
	"beta;": "β",
	"beth;": "ℶ",
	"between;": "≬",
	"bfr;": "𝔟",
	"bigcap;": "⋂",
	"bigcirc;": "◯",
	"bigcup;": "⋃",
	"bigodot;": "⨀",
	"bigoplus;": "⨁",
	"bigotimes;": "⨂",
	"bigsqcup;": "⨆",
	"bigstar;": "★",
	"bigtriangledown;": "▽",
	"bigtriangleup;": "△",
	"biguplus;": "⨄",
	"bigvee;": "⋁",
	"bigwedge;": "⋀",
	"bkarow;": "⤍",
	"blacklozenge;": "⧫",
	"blacksquare;": "▪",
	"blacktriangle;": "▴",
	"blacktriangledown;": "▾",
	"blacktriangleleft;": "◂",
	"blacktriangleright;": "▸",
	"blank;": "␣",
	"blk12;": "▒",
	"blk14;": "░",
	"blk34;": "▓",
	"block;": "█",
	"bne;": "=⃥",
	"bnequiv;": "≡⃥",
	"bnot;": "⌐",
	"bopf;": "𝕓",
	"bot;": "⊥",
	"bottom;": "⊥",
	"bowtie;": "⋈",
	"boxDL;": "╗",
	"boxDR;": "╔",
	"boxDl;": "╖",
	"boxDr;": "╓",
	"boxH;": "═",
	"boxHD;": "╦",
	"boxHU;": "╩",
	"boxHd;": "╤",
	"boxHu;": "╧",
	"boxUL;": "╝",
	"boxUR;": "╚",
	"boxUl;": "╜",
	"boxUr;": "╙",
	"boxV;": "║",
	"boxVH;": "╬",
	"boxVL;": "╣",
	"boxVR;": "╠",
	"boxVh;": "╫",
	"boxVl;": "╢",
	"boxVr;": "╟",
	"boxbox;": "⧉",
	"boxdL;": "╕",
	"boxdR;": "╒",
	"boxdl;": "┐",
	"boxdr;": "┌",
	"boxh;": "─",
	"boxhD;": "╥",
	"boxhU;": "╨",
	"boxhd;": "┬",
	"boxhu;": "┴",
	"boxminus;": "⊟",
	"boxplus;": "⊞",
	"boxtimes;": "⊠",
	"boxuL;": "╛",
	"boxuR;": "╘",
	"boxul;": "┘",
	"boxur;": "└",
	"boxv;": "│",
	"boxvH;": "╪",
	"boxvL;": "╡",
	"boxvR;": "╞",
	"boxvh;": "┼",
	"boxvl;": "┤",
	"boxvr;": "├",
	"bprime;": "‵",
	"breve;": "˘",
	brvbar: "¦",
	"brvbar;": "¦",
	"bscr;": "𝒷",
	"bsemi;": "⁏",
	"bsim;": "∽",
	"bsime;": "⋍",
	"bsol;": "\\",
	"bsolb;": "⧅",
	"bsolhsub;": "⟈",
	"bull;": "•",
	"bullet;": "•",
	"bump;": "≎",
	"bumpE;": "⪮",
	"bumpe;": "≏",
	"bumpeq;": "≏",
	"cacute;": "ć",
	"cap;": "∩",
	"capand;": "⩄",
	"capbrcup;": "⩉",
	"capcap;": "⩋",
	"capcup;": "⩇",
	"capdot;": "⩀",
	"caps;": "∩︀",
	"caret;": "⁁",
	"caron;": "ˇ",
	"ccaps;": "⩍",
	"ccaron;": "č",
	ccedil: "ç",
	"ccedil;": "ç",
	"ccirc;": "ĉ",
	"ccups;": "⩌",
	"ccupssm;": "⩐",
	"cdot;": "ċ",
	cedil: "¸",
	"cedil;": "¸",
	"cemptyv;": "⦲",
	cent: "¢",
	"cent;": "¢",
	"centerdot;": "·",
	"cfr;": "𝔠",
	"chcy;": "ч",
	"check;": "✓",
	"checkmark;": "✓",
	"chi;": "χ",
	"cir;": "○",
	"cirE;": "⧃",
	"circ;": "ˆ",
	"circeq;": "≗",
	"circlearrowleft;": "↺",
	"circlearrowright;": "↻",
	"circledR;": "®",
	"circledS;": "Ⓢ",
	"circledast;": "⊛",
	"circledcirc;": "⊚",
	"circleddash;": "⊝",
	"cire;": "≗",
	"cirfnint;": "⨐",
	"cirmid;": "⫯",
	"cirscir;": "⧂",
	"clubs;": "♣",
	"clubsuit;": "♣",
	"colon;": ":",
	"colone;": "≔",
	"coloneq;": "≔",
	"comma;": ",",
	"commat;": "@",
	"comp;": "∁",
	"compfn;": "∘",
	"complement;": "∁",
	"complexes;": "ℂ",
	"cong;": "≅",
	"congdot;": "⩭",
	"conint;": "∮",
	"copf;": "𝕔",
	"coprod;": "∐",
	copy: "©",
	"copy;": "©",
	"copysr;": "℗",
	"crarr;": "↵",
	"cross;": "✗",
	"cscr;": "𝒸",
	"csub;": "⫏",
	"csube;": "⫑",
	"csup;": "⫐",
	"csupe;": "⫒",
	"ctdot;": "⋯",
	"cudarrl;": "⤸",
	"cudarrr;": "⤵",
	"cuepr;": "⋞",
	"cuesc;": "⋟",
	"cularr;": "↶",
	"cularrp;": "⤽",
	"cup;": "∪",
	"cupbrcap;": "⩈",
	"cupcap;": "⩆",
	"cupcup;": "⩊",
	"cupdot;": "⊍",
	"cupor;": "⩅",
	"cups;": "∪︀",
	"curarr;": "↷",
	"curarrm;": "⤼",
	"curlyeqprec;": "⋞",
	"curlyeqsucc;": "⋟",
	"curlyvee;": "⋎",
	"curlywedge;": "⋏",
	curren: "¤",
	"curren;": "¤",
	"curvearrowleft;": "↶",
	"curvearrowright;": "↷",
	"cuvee;": "⋎",
	"cuwed;": "⋏",
	"cwconint;": "∲",
	"cwint;": "∱",
	"cylcty;": "⌭",
	"dArr;": "⇓",
	"dHar;": "⥥",
	"dagger;": "†",
	"daleth;": "ℸ",
	"darr;": "↓",
	"dash;": "‐",
	"dashv;": "⊣",
	"dbkarow;": "⤏",
	"dblac;": "˝",
	"dcaron;": "ď",
	"dcy;": "д",
	"dd;": "ⅆ",
	"ddagger;": "‡",
	"ddarr;": "⇊",
	"ddotseq;": "⩷",
	deg: "°",
	"deg;": "°",
	"delta;": "δ",
	"demptyv;": "⦱",
	"dfisht;": "⥿",
	"dfr;": "𝔡",
	"dharl;": "⇃",
	"dharr;": "⇂",
	"diam;": "⋄",
	"diamond;": "⋄",
	"diamondsuit;": "♦",
	"diams;": "♦",
	"die;": "¨",
	"digamma;": "ϝ",
	"disin;": "⋲",
	"div;": "÷",
	divide: "÷",
	"divide;": "÷",
	"divideontimes;": "⋇",
	"divonx;": "⋇",
	"djcy;": "ђ",
	"dlcorn;": "⌞",
	"dlcrop;": "⌍",
	"dollar;": "$",
	"dopf;": "𝕕",
	"dot;": "˙",
	"doteq;": "≐",
	"doteqdot;": "≑",
	"dotminus;": "∸",
	"dotplus;": "∔",
	"dotsquare;": "⊡",
	"doublebarwedge;": "⌆",
	"downarrow;": "↓",
	"downdownarrows;": "⇊",
	"downharpoonleft;": "⇃",
	"downharpoonright;": "⇂",
	"drbkarow;": "⤐",
	"drcorn;": "⌟",
	"drcrop;": "⌌",
	"dscr;": "𝒹",
	"dscy;": "ѕ",
	"dsol;": "⧶",
	"dstrok;": "đ",
	"dtdot;": "⋱",
	"dtri;": "▿",
	"dtrif;": "▾",
	"duarr;": "⇵",
	"duhar;": "⥯",
	"dwangle;": "⦦",
	"dzcy;": "џ",
	"dzigrarr;": "⟿",
	"eDDot;": "⩷",
	"eDot;": "≑",
	eacute: "é",
	"eacute;": "é",
	"easter;": "⩮",
	"ecaron;": "ě",
	"ecir;": "≖",
	ecirc: "ê",
	"ecirc;": "ê",
	"ecolon;": "≕",
	"ecy;": "э",
	"edot;": "ė",
	"ee;": "ⅇ",
	"efDot;": "≒",
	"efr;": "𝔢",
	"eg;": "⪚",
	egrave: "è",
	"egrave;": "è",
	"egs;": "⪖",
	"egsdot;": "⪘",
	"el;": "⪙",
	"elinters;": "⏧",
	"ell;": "ℓ",
	"els;": "⪕",
	"elsdot;": "⪗",
	"emacr;": "ē",
	"empty;": "∅",
	"emptyset;": "∅",
	"emptyv;": "∅",
	"emsp13;": " ",
	"emsp14;": " ",
	"emsp;": " ",
	"eng;": "ŋ",
	"ensp;": " ",
	"eogon;": "ę",
	"eopf;": "𝕖",
	"epar;": "⋕",
	"eparsl;": "⧣",
	"eplus;": "⩱",
	"epsi;": "ε",
	"epsilon;": "ε",
	"epsiv;": "ϵ",
	"eqcirc;": "≖",
	"eqcolon;": "≕",
	"eqsim;": "≂",
	"eqslantgtr;": "⪖",
	"eqslantless;": "⪕",
	"equals;": "=",
	"equest;": "≟",
	"equiv;": "≡",
	"equivDD;": "⩸",
	"eqvparsl;": "⧥",
	"erDot;": "≓",
	"erarr;": "⥱",
	"escr;": "ℯ",
	"esdot;": "≐",
	"esim;": "≂",
	"eta;": "η",
	eth: "ð",
	"eth;": "ð",
	euml: "ë",
	"euml;": "ë",
	"euro;": "€",
	"excl;": "!",
	"exist;": "∃",
	"expectation;": "ℰ",
	"exponentiale;": "ⅇ",
	"fallingdotseq;": "≒",
	"fcy;": "ф",
	"female;": "♀",
	"ffilig;": "ﬃ",
	"fflig;": "ﬀ",
	"ffllig;": "ﬄ",
	"ffr;": "𝔣",
	"filig;": "ﬁ",
	"fjlig;": "fj",
	"flat;": "♭",
	"fllig;": "ﬂ",
	"fltns;": "▱",
	"fnof;": "ƒ",
	"fopf;": "𝕗",
	"forall;": "∀",
	"fork;": "⋔",
	"forkv;": "⫙",
	"fpartint;": "⨍",
	frac12: "½",
	"frac12;": "½",
	"frac13;": "⅓",
	frac14: "¼",
	"frac14;": "¼",
	"frac15;": "⅕",
	"frac16;": "⅙",
	"frac18;": "⅛",
	"frac23;": "⅔",
	"frac25;": "⅖",
	frac34: "¾",
	"frac34;": "¾",
	"frac35;": "⅗",
	"frac38;": "⅜",
	"frac45;": "⅘",
	"frac56;": "⅚",
	"frac58;": "⅝",
	"frac78;": "⅞",
	"frasl;": "⁄",
	"frown;": "⌢",
	"fscr;": "𝒻",
	"gE;": "≧",
	"gEl;": "⪌",
	"gacute;": "ǵ",
	"gamma;": "γ",
	"gammad;": "ϝ",
	"gap;": "⪆",
	"gbreve;": "ğ",
	"gcirc;": "ĝ",
	"gcy;": "г",
	"gdot;": "ġ",
	"ge;": "≥",
	"gel;": "⋛",
	"geq;": "≥",
	"geqq;": "≧",
	"geqslant;": "⩾",
	"ges;": "⩾",
	"gescc;": "⪩",
	"gesdot;": "⪀",
	"gesdoto;": "⪂",
	"gesdotol;": "⪄",
	"gesl;": "⋛︀",
	"gesles;": "⪔",
	"gfr;": "𝔤",
	"gg;": "≫",
	"ggg;": "⋙",
	"gimel;": "ℷ",
	"gjcy;": "ѓ",
	"gl;": "≷",
	"glE;": "⪒",
	"gla;": "⪥",
	"glj;": "⪤",
	"gnE;": "≩",
	"gnap;": "⪊",
	"gnapprox;": "⪊",
	"gne;": "⪈",
	"gneq;": "⪈",
	"gneqq;": "≩",
	"gnsim;": "⋧",
	"gopf;": "𝕘",
	"grave;": "`",
	"gscr;": "ℊ",
	"gsim;": "≳",
	"gsime;": "⪎",
	"gsiml;": "⪐",
	gt: ">",
	"gt;": ">",
	"gtcc;": "⪧",
	"gtcir;": "⩺",
	"gtdot;": "⋗",
	"gtlPar;": "⦕",
	"gtquest;": "⩼",
	"gtrapprox;": "⪆",
	"gtrarr;": "⥸",
	"gtrdot;": "⋗",
	"gtreqless;": "⋛",
	"gtreqqless;": "⪌",
	"gtrless;": "≷",
	"gtrsim;": "≳",
	"gvertneqq;": "≩︀",
	"gvnE;": "≩︀",
	"hArr;": "⇔",
	"hairsp;": " ",
	"half;": "½",
	"hamilt;": "ℋ",
	"hardcy;": "ъ",
	"harr;": "↔",
	"harrcir;": "⥈",
	"harrw;": "↭",
	"hbar;": "ℏ",
	"hcirc;": "ĥ",
	"hearts;": "♥",
	"heartsuit;": "♥",
	"hellip;": "…",
	"hercon;": "⊹",
	"hfr;": "𝔥",
	"hksearow;": "⤥",
	"hkswarow;": "⤦",
	"hoarr;": "⇿",
	"homtht;": "∻",
	"hookleftarrow;": "↩",
	"hookrightarrow;": "↪",
	"hopf;": "𝕙",
	"horbar;": "―",
	"hscr;": "𝒽",
	"hslash;": "ℏ",
	"hstrok;": "ħ",
	"hybull;": "⁃",
	"hyphen;": "‐",
	iacute: "í",
	"iacute;": "í",
	"ic;": "⁣",
	icirc: "î",
	"icirc;": "î",
	"icy;": "и",
	"iecy;": "е",
	iexcl: "¡",
	"iexcl;": "¡",
	"iff;": "⇔",
	"ifr;": "𝔦",
	igrave: "ì",
	"igrave;": "ì",
	"ii;": "ⅈ",
	"iiiint;": "⨌",
	"iiint;": "∭",
	"iinfin;": "⧜",
	"iiota;": "℩",
	"ijlig;": "ĳ",
	"imacr;": "ī",
	"image;": "ℑ",
	"imagline;": "ℐ",
	"imagpart;": "ℑ",
	"imath;": "ı",
	"imof;": "⊷",
	"imped;": "Ƶ",
	"in;": "∈",
	"incare;": "℅",
	"infin;": "∞",
	"infintie;": "⧝",
	"inodot;": "ı",
	"int;": "∫",
	"intcal;": "⊺",
	"integers;": "ℤ",
	"intercal;": "⊺",
	"intlarhk;": "⨗",
	"intprod;": "⨼",
	"iocy;": "ё",
	"iogon;": "į",
	"iopf;": "𝕚",
	"iota;": "ι",
	"iprod;": "⨼",
	iquest: "¿",
	"iquest;": "¿",
	"iscr;": "𝒾",
	"isin;": "∈",
	"isinE;": "⋹",
	"isindot;": "⋵",
	"isins;": "⋴",
	"isinsv;": "⋳",
	"isinv;": "∈",
	"it;": "⁢",
	"itilde;": "ĩ",
	"iukcy;": "і",
	iuml: "ï",
	"iuml;": "ï",
	"jcirc;": "ĵ",
	"jcy;": "й",
	"jfr;": "𝔧",
	"jmath;": "ȷ",
	"jopf;": "𝕛",
	"jscr;": "𝒿",
	"jsercy;": "ј",
	"jukcy;": "є",
	"kappa;": "κ",
	"kappav;": "ϰ",
	"kcedil;": "ķ",
	"kcy;": "к",
	"kfr;": "𝔨",
	"kgreen;": "ĸ",
	"khcy;": "х",
	"kjcy;": "ќ",
	"kopf;": "𝕜",
	"kscr;": "𝓀",
	"lAarr;": "⇚",
	"lArr;": "⇐",
	"lAtail;": "⤛",
	"lBarr;": "⤎",
	"lE;": "≦",
	"lEg;": "⪋",
	"lHar;": "⥢",
	"lacute;": "ĺ",
	"laemptyv;": "⦴",
	"lagran;": "ℒ",
	"lambda;": "λ",
	"lang;": "⟨",
	"langd;": "⦑",
	"langle;": "⟨",
	"lap;": "⪅",
	laquo: "«",
	"laquo;": "«",
	"larr;": "←",
	"larrb;": "⇤",
	"larrbfs;": "⤟",
	"larrfs;": "⤝",
	"larrhk;": "↩",
	"larrlp;": "↫",
	"larrpl;": "⤹",
	"larrsim;": "⥳",
	"larrtl;": "↢",
	"lat;": "⪫",
	"latail;": "⤙",
	"late;": "⪭",
	"lates;": "⪭︀",
	"lbarr;": "⤌",
	"lbbrk;": "❲",
	"lbrace;": "{",
	"lbrack;": "[",
	"lbrke;": "⦋",
	"lbrksld;": "⦏",
	"lbrkslu;": "⦍",
	"lcaron;": "ľ",
	"lcedil;": "ļ",
	"lceil;": "⌈",
	"lcub;": "{",
	"lcy;": "л",
	"ldca;": "⤶",
	"ldquo;": "“",
	"ldquor;": "„",
	"ldrdhar;": "⥧",
	"ldrushar;": "⥋",
	"ldsh;": "↲",
	"le;": "≤",
	"leftarrow;": "←",
	"leftarrowtail;": "↢",
	"leftharpoondown;": "↽",
	"leftharpoonup;": "↼",
	"leftleftarrows;": "⇇",
	"leftrightarrow;": "↔",
	"leftrightarrows;": "⇆",
	"leftrightharpoons;": "⇋",
	"leftrightsquigarrow;": "↭",
	"leftthreetimes;": "⋋",
	"leg;": "⋚",
	"leq;": "≤",
	"leqq;": "≦",
	"leqslant;": "⩽",
	"les;": "⩽",
	"lescc;": "⪨",
	"lesdot;": "⩿",
	"lesdoto;": "⪁",
	"lesdotor;": "⪃",
	"lesg;": "⋚︀",
	"lesges;": "⪓",
	"lessapprox;": "⪅",
	"lessdot;": "⋖",
	"lesseqgtr;": "⋚",
	"lesseqqgtr;": "⪋",
	"lessgtr;": "≶",
	"lesssim;": "≲",
	"lfisht;": "⥼",
	"lfloor;": "⌊",
	"lfr;": "𝔩",
	"lg;": "≶",
	"lgE;": "⪑",
	"lhard;": "↽",
	"lharu;": "↼",
	"lharul;": "⥪",
	"lhblk;": "▄",
	"ljcy;": "љ",
	"ll;": "≪",
	"llarr;": "⇇",
	"llcorner;": "⌞",
	"llhard;": "⥫",
	"lltri;": "◺",
	"lmidot;": "ŀ",
	"lmoust;": "⎰",
	"lmoustache;": "⎰",
	"lnE;": "≨",
	"lnap;": "⪉",
	"lnapprox;": "⪉",
	"lne;": "⪇",
	"lneq;": "⪇",
	"lneqq;": "≨",
	"lnsim;": "⋦",
	"loang;": "⟬",
	"loarr;": "⇽",
	"lobrk;": "⟦",
	"longleftarrow;": "⟵",
	"longleftrightarrow;": "⟷",
	"longmapsto;": "⟼",
	"longrightarrow;": "⟶",
	"looparrowleft;": "↫",
	"looparrowright;": "↬",
	"lopar;": "⦅",
	"lopf;": "𝕝",
	"loplus;": "⨭",
	"lotimes;": "⨴",
	"lowast;": "∗",
	"lowbar;": "_",
	"loz;": "◊",
	"lozenge;": "◊",
	"lozf;": "⧫",
	"lpar;": "(",
	"lparlt;": "⦓",
	"lrarr;": "⇆",
	"lrcorner;": "⌟",
	"lrhar;": "⇋",
	"lrhard;": "⥭",
	"lrm;": "‎",
	"lrtri;": "⊿",
	"lsaquo;": "‹",
	"lscr;": "𝓁",
	"lsh;": "↰",
	"lsim;": "≲",
	"lsime;": "⪍",
	"lsimg;": "⪏",
	"lsqb;": "[",
	"lsquo;": "‘",
	"lsquor;": "‚",
	"lstrok;": "ł",
	lt: "<",
	"lt;": "<",
	"ltcc;": "⪦",
	"ltcir;": "⩹",
	"ltdot;": "⋖",
	"lthree;": "⋋",
	"ltimes;": "⋉",
	"ltlarr;": "⥶",
	"ltquest;": "⩻",
	"ltrPar;": "⦖",
	"ltri;": "◃",
	"ltrie;": "⊴",
	"ltrif;": "◂",
	"lurdshar;": "⥊",
	"luruhar;": "⥦",
	"lvertneqq;": "≨︀",
	"lvnE;": "≨︀",
	"mDDot;": "∺",
	macr: "¯",
	"macr;": "¯",
	"male;": "♂",
	"malt;": "✠",
	"maltese;": "✠",
	"map;": "↦",
	"mapsto;": "↦",
	"mapstodown;": "↧",
	"mapstoleft;": "↤",
	"mapstoup;": "↥",
	"marker;": "▮",
	"mcomma;": "⨩",
	"mcy;": "м",
	"mdash;": "—",
	"measuredangle;": "∡",
	"mfr;": "𝔪",
	"mho;": "℧",
	micro: "µ",
	"micro;": "µ",
	"mid;": "∣",
	"midast;": "*",
	"midcir;": "⫰",
	middot: "·",
	"middot;": "·",
	"minus;": "−",
	"minusb;": "⊟",
	"minusd;": "∸",
	"minusdu;": "⨪",
	"mlcp;": "⫛",
	"mldr;": "…",
	"mnplus;": "∓",
	"models;": "⊧",
	"mopf;": "𝕞",
	"mp;": "∓",
	"mscr;": "𝓂",
	"mstpos;": "∾",
	"mu;": "μ",
	"multimap;": "⊸",
	"mumap;": "⊸",
	"nGg;": "⋙̸",
	"nGt;": "≫⃒",
	"nGtv;": "≫̸",
	"nLeftarrow;": "⇍",
	"nLeftrightarrow;": "⇎",
	"nLl;": "⋘̸",
	"nLt;": "≪⃒",
	"nLtv;": "≪̸",
	"nRightarrow;": "⇏",
	"nVDash;": "⊯",
	"nVdash;": "⊮",
	"nabla;": "∇",
	"nacute;": "ń",
	"nang;": "∠⃒",
	"nap;": "≉",
	"napE;": "⩰̸",
	"napid;": "≋̸",
	"napos;": "ŉ",
	"napprox;": "≉",
	"natur;": "♮",
	"natural;": "♮",
	"naturals;": "ℕ",
	nbsp: "\xA0",
	"nbsp;": "\xA0",
	"nbump;": "≎̸",
	"nbumpe;": "≏̸",
	"ncap;": "⩃",
	"ncaron;": "ň",
	"ncedil;": "ņ",
	"ncong;": "≇",
	"ncongdot;": "⩭̸",
	"ncup;": "⩂",
	"ncy;": "н",
	"ndash;": "–",
	"ne;": "≠",
	"neArr;": "⇗",
	"nearhk;": "⤤",
	"nearr;": "↗",
	"nearrow;": "↗",
	"nedot;": "≐̸",
	"nequiv;": "≢",
	"nesear;": "⤨",
	"nesim;": "≂̸",
	"nexist;": "∄",
	"nexists;": "∄",
	"nfr;": "𝔫",
	"ngE;": "≧̸",
	"nge;": "≱",
	"ngeq;": "≱",
	"ngeqq;": "≧̸",
	"ngeqslant;": "⩾̸",
	"nges;": "⩾̸",
	"ngsim;": "≵",
	"ngt;": "≯",
	"ngtr;": "≯",
	"nhArr;": "⇎",
	"nharr;": "↮",
	"nhpar;": "⫲",
	"ni;": "∋",
	"nis;": "⋼",
	"nisd;": "⋺",
	"niv;": "∋",
	"njcy;": "њ",
	"nlArr;": "⇍",
	"nlE;": "≦̸",
	"nlarr;": "↚",
	"nldr;": "‥",
	"nle;": "≰",
	"nleftarrow;": "↚",
	"nleftrightarrow;": "↮",
	"nleq;": "≰",
	"nleqq;": "≦̸",
	"nleqslant;": "⩽̸",
	"nles;": "⩽̸",
	"nless;": "≮",
	"nlsim;": "≴",
	"nlt;": "≮",
	"nltri;": "⋪",
	"nltrie;": "⋬",
	"nmid;": "∤",
	"nopf;": "𝕟",
	not: "¬",
	"not;": "¬",
	"notin;": "∉",
	"notinE;": "⋹̸",
	"notindot;": "⋵̸",
	"notinva;": "∉",
	"notinvb;": "⋷",
	"notinvc;": "⋶",
	"notni;": "∌",
	"notniva;": "∌",
	"notnivb;": "⋾",
	"notnivc;": "⋽",
	"npar;": "∦",
	"nparallel;": "∦",
	"nparsl;": "⫽⃥",
	"npart;": "∂̸",
	"npolint;": "⨔",
	"npr;": "⊀",
	"nprcue;": "⋠",
	"npre;": "⪯̸",
	"nprec;": "⊀",
	"npreceq;": "⪯̸",
	"nrArr;": "⇏",
	"nrarr;": "↛",
	"nrarrc;": "⤳̸",
	"nrarrw;": "↝̸",
	"nrightarrow;": "↛",
	"nrtri;": "⋫",
	"nrtrie;": "⋭",
	"nsc;": "⊁",
	"nsccue;": "⋡",
	"nsce;": "⪰̸",
	"nscr;": "𝓃",
	"nshortmid;": "∤",
	"nshortparallel;": "∦",
	"nsim;": "≁",
	"nsime;": "≄",
	"nsimeq;": "≄",
	"nsmid;": "∤",
	"nspar;": "∦",
	"nsqsube;": "⋢",
	"nsqsupe;": "⋣",
	"nsub;": "⊄",
	"nsubE;": "⫅̸",
	"nsube;": "⊈",
	"nsubset;": "⊂⃒",
	"nsubseteq;": "⊈",
	"nsubseteqq;": "⫅̸",
	"nsucc;": "⊁",
	"nsucceq;": "⪰̸",
	"nsup;": "⊅",
	"nsupE;": "⫆̸",
	"nsupe;": "⊉",
	"nsupset;": "⊃⃒",
	"nsupseteq;": "⊉",
	"nsupseteqq;": "⫆̸",
	"ntgl;": "≹",
	ntilde: "ñ",
	"ntilde;": "ñ",
	"ntlg;": "≸",
	"ntriangleleft;": "⋪",
	"ntrianglelefteq;": "⋬",
	"ntriangleright;": "⋫",
	"ntrianglerighteq;": "⋭",
	"nu;": "ν",
	"num;": "#",
	"numero;": "№",
	"numsp;": " ",
	"nvDash;": "⊭",
	"nvHarr;": "⤄",
	"nvap;": "≍⃒",
	"nvdash;": "⊬",
	"nvge;": "≥⃒",
	"nvgt;": ">⃒",
	"nvinfin;": "⧞",
	"nvlArr;": "⤂",
	"nvle;": "≤⃒",
	"nvlt;": "<⃒",
	"nvltrie;": "⊴⃒",
	"nvrArr;": "⤃",
	"nvrtrie;": "⊵⃒",
	"nvsim;": "∼⃒",
	"nwArr;": "⇖",
	"nwarhk;": "⤣",
	"nwarr;": "↖",
	"nwarrow;": "↖",
	"nwnear;": "⤧",
	"oS;": "Ⓢ",
	oacute: "ó",
	"oacute;": "ó",
	"oast;": "⊛",
	"ocir;": "⊚",
	ocirc: "ô",
	"ocirc;": "ô",
	"ocy;": "о",
	"odash;": "⊝",
	"odblac;": "ő",
	"odiv;": "⨸",
	"odot;": "⊙",
	"odsold;": "⦼",
	"oelig;": "œ",
	"ofcir;": "⦿",
	"ofr;": "𝔬",
	"ogon;": "˛",
	ograve: "ò",
	"ograve;": "ò",
	"ogt;": "⧁",
	"ohbar;": "⦵",
	"ohm;": "Ω",
	"oint;": "∮",
	"olarr;": "↺",
	"olcir;": "⦾",
	"olcross;": "⦻",
	"oline;": "‾",
	"olt;": "⧀",
	"omacr;": "ō",
	"omega;": "ω",
	"omicron;": "ο",
	"omid;": "⦶",
	"ominus;": "⊖",
	"oopf;": "𝕠",
	"opar;": "⦷",
	"operp;": "⦹",
	"oplus;": "⊕",
	"or;": "∨",
	"orarr;": "↻",
	"ord;": "⩝",
	"order;": "ℴ",
	"orderof;": "ℴ",
	ordf: "ª",
	"ordf;": "ª",
	ordm: "º",
	"ordm;": "º",
	"origof;": "⊶",
	"oror;": "⩖",
	"orslope;": "⩗",
	"orv;": "⩛",
	"oscr;": "ℴ",
	oslash: "ø",
	"oslash;": "ø",
	"osol;": "⊘",
	otilde: "õ",
	"otilde;": "õ",
	"otimes;": "⊗",
	"otimesas;": "⨶",
	ouml: "ö",
	"ouml;": "ö",
	"ovbar;": "⌽",
	"par;": "∥",
	para: "¶",
	"para;": "¶",
	"parallel;": "∥",
	"parsim;": "⫳",
	"parsl;": "⫽",
	"part;": "∂",
	"pcy;": "п",
	"percnt;": "%",
	"period;": ".",
	"permil;": "‰",
	"perp;": "⊥",
	"pertenk;": "‱",
	"pfr;": "𝔭",
	"phi;": "φ",
	"phiv;": "ϕ",
	"phmmat;": "ℳ",
	"phone;": "☎",
	"pi;": "π",
	"pitchfork;": "⋔",
	"piv;": "ϖ",
	"planck;": "ℏ",
	"planckh;": "ℎ",
	"plankv;": "ℏ",
	"plus;": "+",
	"plusacir;": "⨣",
	"plusb;": "⊞",
	"pluscir;": "⨢",
	"plusdo;": "∔",
	"plusdu;": "⨥",
	"pluse;": "⩲",
	plusmn: "±",
	"plusmn;": "±",
	"plussim;": "⨦",
	"plustwo;": "⨧",
	"pm;": "±",
	"pointint;": "⨕",
	"popf;": "𝕡",
	pound: "£",
	"pound;": "£",
	"pr;": "≺",
	"prE;": "⪳",
	"prap;": "⪷",
	"prcue;": "≼",
	"pre;": "⪯",
	"prec;": "≺",
	"precapprox;": "⪷",
	"preccurlyeq;": "≼",
	"preceq;": "⪯",
	"precnapprox;": "⪹",
	"precneqq;": "⪵",
	"precnsim;": "⋨",
	"precsim;": "≾",
	"prime;": "′",
	"primes;": "ℙ",
	"prnE;": "⪵",
	"prnap;": "⪹",
	"prnsim;": "⋨",
	"prod;": "∏",
	"profalar;": "⌮",
	"profline;": "⌒",
	"profsurf;": "⌓",
	"prop;": "∝",
	"propto;": "∝",
	"prsim;": "≾",
	"prurel;": "⊰",
	"pscr;": "𝓅",
	"psi;": "ψ",
	"puncsp;": " ",
	"qfr;": "𝔮",
	"qint;": "⨌",
	"qopf;": "𝕢",
	"qprime;": "⁗",
	"qscr;": "𝓆",
	"quaternions;": "ℍ",
	"quatint;": "⨖",
	"quest;": "?",
	"questeq;": "≟",
	quot: "\"",
	"quot;": "\"",
	"rAarr;": "⇛",
	"rArr;": "⇒",
	"rAtail;": "⤜",
	"rBarr;": "⤏",
	"rHar;": "⥤",
	"race;": "∽̱",
	"racute;": "ŕ",
	"radic;": "√",
	"raemptyv;": "⦳",
	"rang;": "⟩",
	"rangd;": "⦒",
	"range;": "⦥",
	"rangle;": "⟩",
	raquo: "»",
	"raquo;": "»",
	"rarr;": "→",
	"rarrap;": "⥵",
	"rarrb;": "⇥",
	"rarrbfs;": "⤠",
	"rarrc;": "⤳",
	"rarrfs;": "⤞",
	"rarrhk;": "↪",
	"rarrlp;": "↬",
	"rarrpl;": "⥅",
	"rarrsim;": "⥴",
	"rarrtl;": "↣",
	"rarrw;": "↝",
	"ratail;": "⤚",
	"ratio;": "∶",
	"rationals;": "ℚ",
	"rbarr;": "⤍",
	"rbbrk;": "❳",
	"rbrace;": "}",
	"rbrack;": "]",
	"rbrke;": "⦌",
	"rbrksld;": "⦎",
	"rbrkslu;": "⦐",
	"rcaron;": "ř",
	"rcedil;": "ŗ",
	"rceil;": "⌉",
	"rcub;": "}",
	"rcy;": "р",
	"rdca;": "⤷",
	"rdldhar;": "⥩",
	"rdquo;": "”",
	"rdquor;": "”",
	"rdsh;": "↳",
	"real;": "ℜ",
	"realine;": "ℛ",
	"realpart;": "ℜ",
	"reals;": "ℝ",
	"rect;": "▭",
	reg: "®",
	"reg;": "®",
	"rfisht;": "⥽",
	"rfloor;": "⌋",
	"rfr;": "𝔯",
	"rhard;": "⇁",
	"rharu;": "⇀",
	"rharul;": "⥬",
	"rho;": "ρ",
	"rhov;": "ϱ",
	"rightarrow;": "→",
	"rightarrowtail;": "↣",
	"rightharpoondown;": "⇁",
	"rightharpoonup;": "⇀",
	"rightleftarrows;": "⇄",
	"rightleftharpoons;": "⇌",
	"rightrightarrows;": "⇉",
	"rightsquigarrow;": "↝",
	"rightthreetimes;": "⋌",
	"ring;": "˚",
	"risingdotseq;": "≓",
	"rlarr;": "⇄",
	"rlhar;": "⇌",
	"rlm;": "‏",
	"rmoust;": "⎱",
	"rmoustache;": "⎱",
	"rnmid;": "⫮",
	"roang;": "⟭",
	"roarr;": "⇾",
	"robrk;": "⟧",
	"ropar;": "⦆",
	"ropf;": "𝕣",
	"roplus;": "⨮",
	"rotimes;": "⨵",
	"rpar;": ")",
	"rpargt;": "⦔",
	"rppolint;": "⨒",
	"rrarr;": "⇉",
	"rsaquo;": "›",
	"rscr;": "𝓇",
	"rsh;": "↱",
	"rsqb;": "]",
	"rsquo;": "’",
	"rsquor;": "’",
	"rthree;": "⋌",
	"rtimes;": "⋊",
	"rtri;": "▹",
	"rtrie;": "⊵",
	"rtrif;": "▸",
	"rtriltri;": "⧎",
	"ruluhar;": "⥨",
	"rx;": "℞",
	"sacute;": "ś",
	"sbquo;": "‚",
	"sc;": "≻",
	"scE;": "⪴",
	"scap;": "⪸",
	"scaron;": "š",
	"sccue;": "≽",
	"sce;": "⪰",
	"scedil;": "ş",
	"scirc;": "ŝ",
	"scnE;": "⪶",
	"scnap;": "⪺",
	"scnsim;": "⋩",
	"scpolint;": "⨓",
	"scsim;": "≿",
	"scy;": "с",
	"sdot;": "⋅",
	"sdotb;": "⊡",
	"sdote;": "⩦",
	"seArr;": "⇘",
	"searhk;": "⤥",
	"searr;": "↘",
	"searrow;": "↘",
	sect: "§",
	"sect;": "§",
	"semi;": ";",
	"seswar;": "⤩",
	"setminus;": "∖",
	"setmn;": "∖",
	"sext;": "✶",
	"sfr;": "𝔰",
	"sfrown;": "⌢",
	"sharp;": "♯",
	"shchcy;": "щ",
	"shcy;": "ш",
	"shortmid;": "∣",
	"shortparallel;": "∥",
	shy: "­",
	"shy;": "­",
	"sigma;": "σ",
	"sigmaf;": "ς",
	"sigmav;": "ς",
	"sim;": "∼",
	"simdot;": "⩪",
	"sime;": "≃",
	"simeq;": "≃",
	"simg;": "⪞",
	"simgE;": "⪠",
	"siml;": "⪝",
	"simlE;": "⪟",
	"simne;": "≆",
	"simplus;": "⨤",
	"simrarr;": "⥲",
	"slarr;": "←",
	"smallsetminus;": "∖",
	"smashp;": "⨳",
	"smeparsl;": "⧤",
	"smid;": "∣",
	"smile;": "⌣",
	"smt;": "⪪",
	"smte;": "⪬",
	"smtes;": "⪬︀",
	"softcy;": "ь",
	"sol;": "/",
	"solb;": "⧄",
	"solbar;": "⌿",
	"sopf;": "𝕤",
	"spades;": "♠",
	"spadesuit;": "♠",
	"spar;": "∥",
	"sqcap;": "⊓",
	"sqcaps;": "⊓︀",
	"sqcup;": "⊔",
	"sqcups;": "⊔︀",
	"sqsub;": "⊏",
	"sqsube;": "⊑",
	"sqsubset;": "⊏",
	"sqsubseteq;": "⊑",
	"sqsup;": "⊐",
	"sqsupe;": "⊒",
	"sqsupset;": "⊐",
	"sqsupseteq;": "⊒",
	"squ;": "□",
	"square;": "□",
	"squarf;": "▪",
	"squf;": "▪",
	"srarr;": "→",
	"sscr;": "𝓈",
	"ssetmn;": "∖",
	"ssmile;": "⌣",
	"sstarf;": "⋆",
	"star;": "☆",
	"starf;": "★",
	"straightepsilon;": "ϵ",
	"straightphi;": "ϕ",
	"strns;": "¯",
	"sub;": "⊂",
	"subE;": "⫅",
	"subdot;": "⪽",
	"sube;": "⊆",
	"subedot;": "⫃",
	"submult;": "⫁",
	"subnE;": "⫋",
	"subne;": "⊊",
	"subplus;": "⪿",
	"subrarr;": "⥹",
	"subset;": "⊂",
	"subseteq;": "⊆",
	"subseteqq;": "⫅",
	"subsetneq;": "⊊",
	"subsetneqq;": "⫋",
	"subsim;": "⫇",
	"subsub;": "⫕",
	"subsup;": "⫓",
	"succ;": "≻",
	"succapprox;": "⪸",
	"succcurlyeq;": "≽",
	"succeq;": "⪰",
	"succnapprox;": "⪺",
	"succneqq;": "⪶",
	"succnsim;": "⋩",
	"succsim;": "≿",
	"sum;": "∑",
	"sung;": "♪",
	sup1: "¹",
	"sup1;": "¹",
	sup2: "²",
	"sup2;": "²",
	sup3: "³",
	"sup3;": "³",
	"sup;": "⊃",
	"supE;": "⫆",
	"supdot;": "⪾",
	"supdsub;": "⫘",
	"supe;": "⊇",
	"supedot;": "⫄",
	"suphsol;": "⟉",
	"suphsub;": "⫗",
	"suplarr;": "⥻",
	"supmult;": "⫂",
	"supnE;": "⫌",
	"supne;": "⊋",
	"supplus;": "⫀",
	"supset;": "⊃",
	"supseteq;": "⊇",
	"supseteqq;": "⫆",
	"supsetneq;": "⊋",
	"supsetneqq;": "⫌",
	"supsim;": "⫈",
	"supsub;": "⫔",
	"supsup;": "⫖",
	"swArr;": "⇙",
	"swarhk;": "⤦",
	"swarr;": "↙",
	"swarrow;": "↙",
	"swnwar;": "⤪",
	szlig: "ß",
	"szlig;": "ß",
	"target;": "⌖",
	"tau;": "τ",
	"tbrk;": "⎴",
	"tcaron;": "ť",
	"tcedil;": "ţ",
	"tcy;": "т",
	"tdot;": "⃛",
	"telrec;": "⌕",
	"tfr;": "𝔱",
	"there4;": "∴",
	"therefore;": "∴",
	"theta;": "θ",
	"thetasym;": "ϑ",
	"thetav;": "ϑ",
	"thickapprox;": "≈",
	"thicksim;": "∼",
	"thinsp;": " ",
	"thkap;": "≈",
	"thksim;": "∼",
	thorn: "þ",
	"thorn;": "þ",
	"tilde;": "˜",
	times: "×",
	"times;": "×",
	"timesb;": "⊠",
	"timesbar;": "⨱",
	"timesd;": "⨰",
	"tint;": "∭",
	"toea;": "⤨",
	"top;": "⊤",
	"topbot;": "⌶",
	"topcir;": "⫱",
	"topf;": "𝕥",
	"topfork;": "⫚",
	"tosa;": "⤩",
	"tprime;": "‴",
	"trade;": "™",
	"triangle;": "▵",
	"triangledown;": "▿",
	"triangleleft;": "◃",
	"trianglelefteq;": "⊴",
	"triangleq;": "≜",
	"triangleright;": "▹",
	"trianglerighteq;": "⊵",
	"tridot;": "◬",
	"trie;": "≜",
	"triminus;": "⨺",
	"triplus;": "⨹",
	"trisb;": "⧍",
	"tritime;": "⨻",
	"trpezium;": "⏢",
	"tscr;": "𝓉",
	"tscy;": "ц",
	"tshcy;": "ћ",
	"tstrok;": "ŧ",
	"twixt;": "≬",
	"twoheadleftarrow;": "↞",
	"twoheadrightarrow;": "↠",
	"uArr;": "⇑",
	"uHar;": "⥣",
	uacute: "ú",
	"uacute;": "ú",
	"uarr;": "↑",
	"ubrcy;": "ў",
	"ubreve;": "ŭ",
	ucirc: "û",
	"ucirc;": "û",
	"ucy;": "у",
	"udarr;": "⇅",
	"udblac;": "ű",
	"udhar;": "⥮",
	"ufisht;": "⥾",
	"ufr;": "𝔲",
	ugrave: "ù",
	"ugrave;": "ù",
	"uharl;": "↿",
	"uharr;": "↾",
	"uhblk;": "▀",
	"ulcorn;": "⌜",
	"ulcorner;": "⌜",
	"ulcrop;": "⌏",
	"ultri;": "◸",
	"umacr;": "ū",
	uml: "¨",
	"uml;": "¨",
	"uogon;": "ų",
	"uopf;": "𝕦",
	"uparrow;": "↑",
	"updownarrow;": "↕",
	"upharpoonleft;": "↿",
	"upharpoonright;": "↾",
	"uplus;": "⊎",
	"upsi;": "υ",
	"upsih;": "ϒ",
	"upsilon;": "υ",
	"upuparrows;": "⇈",
	"urcorn;": "⌝",
	"urcorner;": "⌝",
	"urcrop;": "⌎",
	"uring;": "ů",
	"urtri;": "◹",
	"uscr;": "𝓊",
	"utdot;": "⋰",
	"utilde;": "ũ",
	"utri;": "▵",
	"utrif;": "▴",
	"uuarr;": "⇈",
	uuml: "ü",
	"uuml;": "ü",
	"uwangle;": "⦧",
	"vArr;": "⇕",
	"vBar;": "⫨",
	"vBarv;": "⫩",
	"vDash;": "⊨",
	"vangrt;": "⦜",
	"varepsilon;": "ϵ",
	"varkappa;": "ϰ",
	"varnothing;": "∅",
	"varphi;": "ϕ",
	"varpi;": "ϖ",
	"varpropto;": "∝",
	"varr;": "↕",
	"varrho;": "ϱ",
	"varsigma;": "ς",
	"varsubsetneq;": "⊊︀",
	"varsubsetneqq;": "⫋︀",
	"varsupsetneq;": "⊋︀",
	"varsupsetneqq;": "⫌︀",
	"vartheta;": "ϑ",
	"vartriangleleft;": "⊲",
	"vartriangleright;": "⊳",
	"vcy;": "в",
	"vdash;": "⊢",
	"vee;": "∨",
	"veebar;": "⊻",
	"veeeq;": "≚",
	"vellip;": "⋮",
	"verbar;": "|",
	"vert;": "|",
	"vfr;": "𝔳",
	"vltri;": "⊲",
	"vnsub;": "⊂⃒",
	"vnsup;": "⊃⃒",
	"vopf;": "𝕧",
	"vprop;": "∝",
	"vrtri;": "⊳",
	"vscr;": "𝓋",
	"vsubnE;": "⫋︀",
	"vsubne;": "⊊︀",
	"vsupnE;": "⫌︀",
	"vsupne;": "⊋︀",
	"vzigzag;": "⦚",
	"wcirc;": "ŵ",
	"wedbar;": "⩟",
	"wedge;": "∧",
	"wedgeq;": "≙",
	"weierp;": "℘",
	"wfr;": "𝔴",
	"wopf;": "𝕨",
	"wp;": "℘",
	"wr;": "≀",
	"wreath;": "≀",
	"wscr;": "𝓌",
	"xcap;": "⋂",
	"xcirc;": "◯",
	"xcup;": "⋃",
	"xdtri;": "▽",
	"xfr;": "𝔵",
	"xhArr;": "⟺",
	"xharr;": "⟷",
	"xi;": "ξ",
	"xlArr;": "⟸",
	"xlarr;": "⟵",
	"xmap;": "⟼",
	"xnis;": "⋻",
	"xodot;": "⨀",
	"xopf;": "𝕩",
	"xoplus;": "⨁",
	"xotime;": "⨂",
	"xrArr;": "⟹",
	"xrarr;": "⟶",
	"xscr;": "𝓍",
	"xsqcup;": "⨆",
	"xuplus;": "⨄",
	"xutri;": "△",
	"xvee;": "⋁",
	"xwedge;": "⋀",
	yacute: "ý",
	"yacute;": "ý",
	"yacy;": "я",
	"ycirc;": "ŷ",
	"ycy;": "ы",
	yen: "¥",
	"yen;": "¥",
	"yfr;": "𝔶",
	"yicy;": "ї",
	"yopf;": "𝕪",
	"yscr;": "𝓎",
	"yucy;": "ю",
	yuml: "ÿ",
	"yuml;": "ÿ",
	"zacute;": "ź",
	"zcaron;": "ž",
	"zcy;": "з",
	"zdot;": "ż",
	"zeetrf;": "ℨ",
	"zeta;": "ζ",
	"zfr;": "𝔷",
	"zhcy;": "ж",
	"zigrarr;": "⇝",
	"zopf;": "𝕫",
	"zscr;": "𝓏",
	"zwj;": "‍",
	"zwnj;": "‌"
};
var B$1 = 32;
var F = {
	AE: ["AElig"],
	AM: ["AMP"],
	Aa: ["Aacute"],
	Ab: [],
	Ac: ["Acirc"],
	Af: [],
	Ag: ["Agrave"],
	Al: [],
	Am: [],
	An: [],
	Ao: [],
	Ap: [],
	Ar: ["Aring"],
	As: [],
	At: ["Atilde"],
	Au: ["Auml"],
	Ba: [],
	Bc: [],
	Be: [],
	Bf: [],
	Bo: [],
	Br: [],
	Bs: [],
	Bu: [],
	CH: [],
	CO: ["COPY"],
	Ca: [],
	Cc: ["Ccedil"],
	Cd: [],
	Ce: [],
	Cf: [],
	Ch: [],
	Ci: [],
	Cl: [],
	Co: [],
	Cr: [],
	Cs: [],
	Cu: [],
	DD: [],
	DJ: [],
	DS: [],
	DZ: [],
	Da: [],
	Dc: [],
	De: [],
	Df: [],
	Di: [],
	Do: [],
	Ds: [],
	EN: [],
	ET: ["ETH"],
	Ea: ["Eacute"],
	Ec: ["Ecirc"],
	Ed: [],
	Ef: [],
	Eg: ["Egrave"],
	El: [],
	Em: [],
	Eo: [],
	Ep: [],
	Eq: [],
	Es: [],
	Et: [],
	Eu: ["Euml"],
	Ex: [],
	Fc: [],
	Ff: [],
	Fi: [],
	Fo: [],
	Fs: [],
	GJ: [],
	GT: ["GT"],
	Ga: [],
	Gb: [],
	Gc: [],
	Gd: [],
	Gf: [],
	Gg: [],
	Go: [],
	Gr: [],
	Gs: [],
	Gt: [],
	HA: [],
	Ha: [],
	Hc: [],
	Hf: [],
	Hi: [],
	Ho: [],
	Hs: [],
	Hu: [],
	IE: [],
	IJ: [],
	IO: [],
	Ia: ["Iacute"],
	Ic: ["Icirc"],
	Id: [],
	If: [],
	Ig: ["Igrave"],
	Im: [],
	In: [],
	Io: [],
	Is: [],
	It: [],
	Iu: ["Iuml"],
	Jc: [],
	Jf: [],
	Jo: [],
	Js: [],
	Ju: [],
	KH: [],
	KJ: [],
	Ka: [],
	Kc: [],
	Kf: [],
	Ko: [],
	Ks: [],
	LJ: [],
	LT: ["LT"],
	La: [],
	Lc: [],
	Le: [],
	Lf: [],
	Ll: [],
	Lm: [],
	Lo: [],
	Ls: [],
	Lt: [],
	Ma: [],
	Mc: [],
	Me: [],
	Mf: [],
	Mi: [],
	Mo: [],
	Ms: [],
	Mu: [],
	NJ: [],
	Na: [],
	Nc: [],
	Ne: [],
	Nf: [],
	No: [],
	Ns: [],
	Nt: ["Ntilde"],
	Nu: [],
	OE: [],
	Oa: ["Oacute"],
	Oc: ["Ocirc"],
	Od: [],
	Of: [],
	Og: ["Ograve"],
	Om: [],
	Oo: [],
	Op: [],
	Or: [],
	Os: ["Oslash"],
	Ot: ["Otilde"],
	Ou: ["Ouml"],
	Ov: [],
	Pa: [],
	Pc: [],
	Pf: [],
	Ph: [],
	Pi: [],
	Pl: [],
	Po: [],
	Pr: [],
	Ps: [],
	QU: ["QUOT"],
	Qf: [],
	Qo: [],
	Qs: [],
	RB: [],
	RE: ["REG"],
	Ra: [],
	Rc: [],
	Re: [],
	Rf: [],
	Rh: [],
	Ri: [],
	Ro: [],
	Rr: [],
	Rs: [],
	Ru: [],
	SH: [],
	SO: [],
	Sa: [],
	Sc: [],
	Sf: [],
	Sh: [],
	Si: [],
	Sm: [],
	So: [],
	Sq: [],
	Ss: [],
	St: [],
	Su: [],
	TH: ["THORN"],
	TR: [],
	TS: [],
	Ta: [],
	Tc: [],
	Tf: [],
	Th: [],
	Ti: [],
	To: [],
	Tr: [],
	Ts: [],
	Ua: ["Uacute"],
	Ub: [],
	Uc: ["Ucirc"],
	Ud: [],
	Uf: [],
	Ug: ["Ugrave"],
	Um: [],
	Un: [],
	Uo: [],
	Up: [],
	Ur: [],
	Us: [],
	Ut: [],
	Uu: ["Uuml"],
	VD: [],
	Vb: [],
	Vc: [],
	Vd: [],
	Ve: [],
	Vf: [],
	Vo: [],
	Vs: [],
	Vv: [],
	Wc: [],
	We: [],
	Wf: [],
	Wo: [],
	Ws: [],
	Xf: [],
	Xi: [],
	Xo: [],
	Xs: [],
	YA: [],
	YI: [],
	YU: [],
	Ya: ["Yacute"],
	Yc: [],
	Yf: [],
	Yo: [],
	Ys: [],
	Yu: [],
	ZH: [],
	Za: [],
	Zc: [],
	Zd: [],
	Ze: [],
	Zf: [],
	Zo: [],
	Zs: [],
	aa: ["aacute"],
	ab: [],
	ac: ["acirc", "acute"],
	ae: ["aelig"],
	af: [],
	ag: ["agrave"],
	al: [],
	am: ["amp"],
	an: [],
	ao: [],
	ap: [],
	ar: ["aring"],
	as: [],
	at: ["atilde"],
	au: ["auml"],
	aw: [],
	bN: [],
	ba: [],
	bb: [],
	bc: [],
	bd: [],
	be: [],
	bf: [],
	bi: [],
	bk: [],
	bl: [],
	bn: [],
	bo: [],
	bp: [],
	br: ["brvbar"],
	bs: [],
	bu: [],
	ca: [],
	cc: ["ccedil"],
	cd: [],
	ce: ["cedil", "cent"],
	cf: [],
	ch: [],
	ci: [],
	cl: [],
	co: ["copy"],
	cr: [],
	cs: [],
	ct: [],
	cu: ["curren"],
	cw: [],
	cy: [],
	dA: [],
	dH: [],
	da: [],
	db: [],
	dc: [],
	dd: [],
	de: ["deg"],
	df: [],
	dh: [],
	di: ["divide"],
	dj: [],
	dl: [],
	do: [],
	dr: [],
	ds: [],
	dt: [],
	du: [],
	dw: [],
	dz: [],
	eD: [],
	ea: ["eacute"],
	ec: ["ecirc"],
	ed: [],
	ee: [],
	ef: [],
	eg: ["egrave"],
	el: [],
	em: [],
	en: [],
	eo: [],
	ep: [],
	eq: [],
	er: [],
	es: [],
	et: ["eth"],
	eu: ["euml"],
	ex: [],
	fa: [],
	fc: [],
	fe: [],
	ff: [],
	fi: [],
	fj: [],
	fl: [],
	fn: [],
	fo: [],
	fp: [],
	fr: [
		"frac12",
		"frac14",
		"frac34"
	],
	fs: [],
	gE: [],
	ga: [],
	gb: [],
	gc: [],
	gd: [],
	ge: [],
	gf: [],
	gg: [],
	gi: [],
	gj: [],
	gl: [],
	gn: [],
	go: [],
	gr: [],
	gs: [],
	gt: ["gt"],
	gv: [],
	hA: [],
	ha: [],
	hb: [],
	hc: [],
	he: [],
	hf: [],
	hk: [],
	ho: [],
	hs: [],
	hy: [],
	ia: ["iacute"],
	ic: ["icirc"],
	ie: ["iexcl"],
	if: [],
	ig: ["igrave"],
	ii: [],
	ij: [],
	im: [],
	in: [],
	io: [],
	ip: [],
	iq: ["iquest"],
	is: [],
	it: [],
	iu: ["iuml"],
	jc: [],
	jf: [],
	jm: [],
	jo: [],
	js: [],
	ju: [],
	ka: [],
	kc: [],
	kf: [],
	kg: [],
	kh: [],
	kj: [],
	ko: [],
	ks: [],
	lA: [],
	lB: [],
	lE: [],
	lH: [],
	la: ["laquo"],
	lb: [],
	lc: [],
	ld: [],
	le: [],
	lf: [],
	lg: [],
	lh: [],
	lj: [],
	ll: [],
	lm: [],
	ln: [],
	lo: [],
	lp: [],
	lr: [],
	ls: [],
	lt: ["lt"],
	lu: [],
	lv: [],
	mD: [],
	ma: ["macr"],
	mc: [],
	md: [],
	me: [],
	mf: [],
	mh: [],
	mi: ["middot", "micro"],
	ml: [],
	mn: [],
	mo: [],
	mp: [],
	ms: [],
	mu: [],
	nG: [],
	nL: [],
	nR: [],
	nV: [],
	na: [],
	nb: ["nbsp"],
	nc: [],
	nd: [],
	ne: [],
	nf: [],
	ng: [],
	nh: [],
	ni: [],
	nj: [],
	nl: [],
	nm: [],
	no: ["not"],
	np: [],
	nr: [],
	ns: [],
	nt: ["ntilde"],
	nu: [],
	nv: [],
	nw: [],
	oS: [],
	oa: ["oacute"],
	oc: ["ocirc"],
	od: [],
	oe: [],
	of: [],
	og: ["ograve"],
	oh: [],
	oi: [],
	ol: [],
	om: [],
	oo: [],
	op: [],
	or: ["ordf", "ordm"],
	os: ["oslash"],
	ot: ["otilde"],
	ou: ["ouml"],
	ov: [],
	pa: ["para"],
	pc: [],
	pe: [],
	pf: [],
	ph: [],
	pi: [],
	pl: ["plusmn"],
	pm: [],
	po: ["pound"],
	pr: [],
	ps: [],
	pu: [],
	qf: [],
	qi: [],
	qo: [],
	qp: [],
	qs: [],
	qu: ["quot"],
	rA: [],
	rB: [],
	rH: [],
	ra: ["raquo"],
	rb: [],
	rc: [],
	rd: [],
	re: ["reg"],
	rf: [],
	rh: [],
	ri: [],
	rl: [],
	rm: [],
	rn: [],
	ro: [],
	rp: [],
	rr: [],
	rs: [],
	rt: [],
	ru: [],
	rx: [],
	sa: [],
	sb: [],
	sc: [],
	sd: [],
	se: ["sect"],
	sf: [],
	sh: ["shy"],
	si: [],
	sl: [],
	sm: [],
	so: [],
	sp: [],
	sq: [],
	sr: [],
	ss: [],
	st: [],
	su: [
		"sup1",
		"sup2",
		"sup3"
	],
	sw: [],
	sz: ["szlig"],
	ta: [],
	tb: [],
	tc: [],
	td: [],
	te: [],
	tf: [],
	th: ["thorn"],
	ti: ["times"],
	to: [],
	tp: [],
	tr: [],
	ts: [],
	tw: [],
	uA: [],
	uH: [],
	ua: ["uacute"],
	ub: [],
	uc: ["ucirc"],
	ud: [],
	uf: [],
	ug: ["ugrave"],
	uh: [],
	ul: [],
	um: ["uml"],
	uo: [],
	up: [],
	ur: [],
	us: [],
	ut: [],
	uu: ["uuml"],
	uw: [],
	vA: [],
	vB: [],
	vD: [],
	va: [],
	vc: [],
	vd: [],
	ve: [],
	vf: [],
	vl: [],
	vn: [],
	vo: [],
	vp: [],
	vr: [],
	vs: [],
	vz: [],
	wc: [],
	we: [],
	wf: [],
	wo: [],
	wp: [],
	wr: [],
	ws: [],
	xc: [],
	xd: [],
	xf: [],
	xh: [],
	xi: [],
	xl: [],
	xm: [],
	xn: [],
	xo: [],
	xr: [],
	xs: [],
	xu: [],
	xv: [],
	xw: [],
	ya: ["yacute"],
	yc: [],
	ye: ["yen"],
	yf: [],
	yi: [],
	yo: [],
	ys: [],
	yu: ["yuml"],
	za: [],
	zc: [],
	zd: [],
	ze: [],
	zf: [],
	zh: [],
	zi: [],
	zo: [],
	zs: [],
	zw: []
};
function f$1(u, t) {
	let o = t.reportProgressFunc, s = t.reportCompletionFunc, e = s ? Date.now() : 0, c = 0;
	return o?.(0), {
		advance: o ? (i) => {
			let a = Math.min(99, Math.floor(i * 100 / u.length));
			a > c && (c = a, o(a));
		} : void 0,
		finish(i, a) {
			return o?.(100), s?.({
				inputLength: u.length,
				outputLength: i.length,
				replacements: a,
				timeTakenInMilliseconds: Date.now() - e
			}), i;
		}
	};
}
function A(u, t) {
	if (typeof u != "string") throw new TypeError(`html-entity-codec/${t}(): [THROW_ID_01] The input must be a string.`);
}
var x$1 = [
	8364,
	129,
	8218,
	402,
	8222,
	8230,
	8224,
	8225,
	710,
	8240,
	352,
	8249,
	338,
	141,
	381,
	143,
	144,
	8216,
	8217,
	8220,
	8221,
	8226,
	8211,
	8212,
	732,
	8482,
	353,
	8250,
	339,
	157,
	382,
	376
];
var y$1 = /[0-9]+/y;
var L$1 = /[0-9a-fA-F]+/y;
var S = /0*([0-9]*)/y;
var k$2 = /0*([0-9a-fA-F]*)/y;
function T$1(u, t, o, s) {
	if (s <= 1114111) {
		let c = o === 10 ? S : k$2;
		c.lastIndex = t;
		let i = c.exec(u);
		return {
			end: c.lastIndex,
			code: Number.parseInt(i[1].slice(0, 8), o) || 0
		};
	}
	let e = o === 10 ? y$1 : L$1;
	return e.lastIndex = t, e.test(u), {
		end: e.lastIndex,
		code: s
	};
}
function h$2(u) {
	return u >= 48 && u <= 57 || u >= 65 && u <= 90 || u >= 97 && u <= 122;
}
function g$1(u) {
	throw new SyntaxError(`Parse error: ${u}`);
}
function v$3(u, t, o, s) {
	if (u.charCodeAt(t) !== 38) return null;
	let e = t + 1;
	if (u.charCodeAt(e) === 35) {
		e++;
		let n = 10;
		(u[e] === "x" || u[e] === "X") && (n = 16, e++);
		let l = e, r = 0;
		for (; e < u.length; e++) {
			let D = u.charCodeAt(e), p = -1;
			if (D >= 48 && D <= 57 ? p = D - 48 : n === 16 && D >= 65 && D <= 70 ? p = D - 55 : n === 16 && D >= 97 && D <= 102 && (p = D - 87), p < 0) break;
			if (r <= 1114111 && (r = r * n + p), e - l === 32 && !s) {
				let E = T$1(u, l, n, r);
				e = E.end, r = E.code;
				break;
			}
			s && !(e % 16384) && s(e);
		}
		if (e === l) return o.strict && g$1("absence-of-digits-in-numeric-character-reference"), null;
		if (u[e] === ";") e++;
		else if (o.strict && g$1("missing-semicolon-after-character-reference"), o.requireSemicolon) return null;
		return !r || r > 1114111 || r >= 55296 && r <= 57343 ? (o.strict && g$1("invalid-numeric-character-reference"), r = 65533) : (r >= 64976 && r <= 65007 || (r & 65535) >= 65534 || r === 13 || r < 32 && r !== 9 && r !== 10 && r !== 12 || r >= 127 && r <= 159) && o.strict && g$1("disallowed-numeric-character-reference"), r >= 128 && r <= 159 && (r = x$1[r - 128]), {
			end: e,
			value: String.fromCodePoint(r)
		};
	}
	let c = F[u.slice(e, e + 2)], i = 0, a = "";
	if (c) {
		let n = u.slice(e, e + B$1), l = n.indexOf(";");
		if (l !== -1) {
			let r = d[n.slice(0, l + 1)];
			if (typeof r == "string") return {
				end: e + l + 1,
				value: r
			};
		}
		if (o.requireSemicolon && !o.strict) return null;
		for (let r of c) if (u.startsWith(r, e)) {
			i = e + r.length, a = d[r];
			break;
		}
	}
	if (!i) {
		if (o.strict && h$2(u.charCodeAt(t + 1))) {
			for (; h$2(u.charCodeAt(e));) e++;
			u[e] === ";" && g$1("unknown-named-character-reference");
		}
		return null;
	}
	return o.context === "attribute" && (u[i] === "=" || h$2(u.charCodeAt(i))) || (o.strict && g$1("missing-semicolon-after-character-reference"), o.requireSemicolon) ? null : {
		end: i,
		value: a
	};
}
function O$1(u, t = {}) {
	A(u, "decode");
	let o = {
		context: t.context,
		requireSemicolon: t.requireSemicolon,
		strict: t.strict
	}, s = t.reportProgressFunc || t.reportCompletionFunc ? f$1(u, t) : void 0, e = u.indexOf("&"), c = 0, i = "", a = 0;
	for (; e !== -1;) {
		s?.advance?.(e);
		let n = v$3(u, e, o, s?.advance);
		n && (i += u.slice(c, e) + n.value, c = n.end, a++), e = u.indexOf("&", n ? n.end : e + 1);
	}
	return i = a ? i + u.slice(c) : u, s ? s.finish(i, a) : i;
}
/*!
* Generated from WHATWG HTML entities.json (2026-09-05).
* Source: https://html.spec.whatwg.org/entities.json
* SHA-256: d741d877ac77c4194c4ad526b5b4a19aef8dfe411ab840a466891cdbb9f362e6
* Copyright © WHATWG (Apple, Google, Mozilla, Microsoft).
* BSD 3-Clause License
*
* Redistribution and use in source and binary forms, with or without
* modification, are permitted provided that the following conditions are met:
*
* 1. Redistributions of source code must retain the above copyright notice, this
*    list of conditions and the following disclaimer.
*
* 2. Redistributions in binary form must reproduce the above copyright notice,
*    this list of conditions and the following disclaimer in the documentation
*    and/or other materials provided with the distribution.
*
* 3. Neither the name of the copyright holder nor the names of its
*    contributors may be used to endorse or promote products derived from
*    this software without specific prior written permission.
*
* THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
* AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
* IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
* DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
* FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
* DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
* SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
* CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
* OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
* OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/
// ../../node_modules/ranges-sort/dist/ranges-sort.esm.js
/**
* @name ranges-sort
* @fileoverview Sort string index ranges
* @version 6.2.5
* @author Roy Revelt
* @license MIT
* {@link https://codsen.com/os/ranges-sort/}
*/
var g = {
	strictlyTwoElementsInRangeArrays: !1,
	progressFn: null
};
function b$1(t, s) {
	let u, o = 0;
	for (; o < t.length;) {
		let n = o + 1;
		for (; n < t.length && t[o][0] === t[n][0] && t[o][1] === t[n][1];) n += 1;
		if (n - o > 1) {
			u || (u = new Map(s.map((p, e) => [p, e])));
			let i = u, l = t.slice(o, n).sort((p, e) => i.get(p) - i.get(e));
			t.splice(o, l.length, ...l);
		}
		o = n;
	}
	return t;
}
function I(t, s) {
	if (!Array.isArray(t) || !t.length) return t;
	let u = s === void 0 ? !0 : Re(s);
	if (s !== void 0 && u && s?.strictlyTwoElementsInRangeArrays === !0) for (let e = 0; e < t.length; e += 1) {
		let r = t[e];
		if (!Array.isArray(r) || r.length !== 2) throw new TypeError(`ranges-sort/rSort(): [THROW_ID_01] The first argument should be an array and must consist of arrays which are natural number indexes representing TWO string index ranges. However, range at index ${e} (${R$2(r, 4)}) is ${Array.isArray(r) ? `an array with ${r.length} elements` : "not an array"}!`);
		if (!Number.isInteger(r[0]) || r[0] < 0 || !Number.isInteger(r[1]) || r[1] < 0) throw new TypeError(`ranges-sort/rSort(): [THROW_ID_02] The first argument should be an array and must consist of arrays which are natural number indexes representing string index ranges. However, range at index ${e} (${R$2(r, 4)}) does not consist of only natural numbers!`);
	}
	else for (let e = 0; e < t.length; e += 1) {
		let r = t[e];
		if (!Array.isArray(r) || !Number.isInteger(r[0]) || r[0] < 0 || !Number.isInteger(r[1]) || r[1] < 0) throw new TypeError(`ranges-sort/rSort(): [THROW_ID_02] The first argument should be an array and must consist of arrays which are natural number indexes representing string index ranges. However, range at index ${e} (${R$2(r, 4)}) does not consist of only natural numbers!`);
	}
	if (s !== void 0 && !u) throw new TypeError(`ranges-sort/rSort(): [THROW_ID_03] The second argument must be a plain options object; received ${R$2(s, 4)} (type ${typeof s})!`);
	let n = g.progressFn;
	if (s !== void 0) {
		let e = s.strictlyTwoElementsInRangeArrays;
		if (e !== void 0 && typeof e != "boolean") throw new TypeError(`ranges-sort/rSort(): [THROW_ID_04] opts.strictlyTwoElementsInRangeArrays must be a boolean; received ${R$2(e, 4)} (type ${typeof e})!`);
		if (n = s.progressFn ?? g.progressFn, n !== !1 && n !== null && typeof n != "function") throw new TypeError(`ranges-sort/rSort(): [THROW_ID_05] opts.progressFn must be a function, false, null, or undefined; received ${R$2(n, 4)} (type ${typeof n})!`);
	}
	let i, l;
	if (n) {
		let e = t.length ** 2, r = 0, m;
		l = (a) => {
			a !== m && (m = a, n(a));
		}, i = Array.from(t).sort((a, d) => (r += 1, l?.(Math.min(99, Math.floor(r * 100 / e))), a[0] === d[0] ? a[1] < d[1] ? -1 : a[1] > d[1] ? 1 : 0 : a[0] < d[0] ? -1 : 1));
	} else i = Array.from(t).sort((e, r) => e[0] === r[0] ? e[1] < r[1] ? -1 : e[1] > r[1] ? 1 : 0 : e[0] < r[0] ? -1 : 1);
	let p = i.length > 10 ? b$1(i, t) : i;
	return l?.(100), p;
}
// ../../node_modules/ranges-merge/dist/ranges-merge.esm.js
/**
* @name ranges-merge
* @fileoverview Merge and sort string index ranges
* @version 9.2.6
* @author Roy Revelt
* @license MIT
* {@link https://codsen.com/os/ranges-merge/}
*/
var x = {
	mergeType: 1,
	progressFn: null,
	joinRangesThatTouchEdges: !0
};
function k$1(p, c) {
	if (!Array.isArray(p) || !p.length) return null;
	if (c !== void 0 && !Re(c)) throw new TypeError(`ranges-merge/rMerge(): [THROW_ID_01] the second input argument must be a plain object. It was given as:
${R$2(c, 4)} (type ${typeof c})`);
	let e = {
		...x,
		...c
	};
	if (e.progressFn && Re(e.progressFn) && !Object.keys(e.progressFn).length) e.progressFn = null;
	else if (e.progressFn && typeof e.progressFn != "function") throw new TypeError(`ranges-merge/rMerge(): [THROW_ID_02] opts.progressFn must be a function! It was given of a type: "${typeof e.progressFn}", equal to ${R$2(e.progressFn, 4)}`);
	if (e.mergeType !== 1 && e.mergeType !== 2 && e.mergeType !== "1" && e.mergeType !== "2") throw new TypeError(`ranges-merge/rMerge(): [THROW_ID_03] opts.mergeType was customised to a wrong thing! It was given of a type: "${typeof e.mergeType}", equal to ${R$2(e.mergeType, 4)}`);
	if (typeof e.joinRangesThatTouchEdges != "boolean") throw new TypeError(`ranges-merge/rMerge(): [THROW_ID_04] opts.joinRangesThatTouchEdges was customised to a wrong thing! It was given of a type: "${typeof e.joinRangesThatTouchEdges}", equal to ${R$2(e.joinRangesThatTouchEdges, 4)}`);
	let a = e.progressFn, R = e.joinRangesThatTouchEdges, u = [];
	for (let n of p) Array.isArray(n) && (n[2] !== void 0 || n[0] !== n[1]) && u.push([...n]);
	let t, i, o;
	a ? t = I(u, { progressFn: (n) => {
		o = Math.floor(n / 5), o !== i && (i = o, a(o));
	} }) : t = I(u);
	let m = t.length - 1, T = e.mergeType === 2 || e.mergeType === "2", g = t.length;
	for (let n = m; n >= 0; n--) {
		let s = t[n];
		for (a && n < m && (o = Math.floor((1 - (n + 1) / m) * 78) + 21, o !== i && o > i && (i = o, a(o))); g < t.length;) {
			let r = t[g], d = r[0] === s[0];
			if (!d && (R ? r[0] > s[1] : r[0] >= s[1])) break;
			let y = r[1] >= s[1];
			y && (s[1] = r[1]), r[2] === null ? s[2] = null : r[2] !== void 0 && (d || y) && s[2] !== null && (s[2] != null ? T && d ? s[2] = r[2] : s[2] += r[2] : s[2] = r[2]), g += 1;
		}
		g -= 1, t[g] = s;
	}
	let f = t.length - g;
	for (let n = 0; n < f; n++) t[n] = t[g + n];
	return t.length = f, a && i !== 99 && a(99), t.length ? t : null;
}
// ../../node_modules/ranges-apply/dist/ranges-apply.esm.js
/**
* @name ranges-apply
* @fileoverview Take an array of string index ranges, delete/replace the string according to them
* @version 7.2.6
* @author Roy Revelt
* @license MIT
* {@link https://codsen.com/os/ranges-apply/}
*/
function y(n) {
	if (typeof n == "number") return Number.isInteger(n) && n >= 0;
	if (typeof n != "string" || !n.trim()) return !1;
	let r = Number(n);
	return Number.isInteger(r) && r >= 0;
}
function v$2(n, r, t) {
	let a = 0, i = 0;
	if (n === void 0 && r === void 0 && t === void 0) throw new Error("ranges-apply/rApply(): [THROW_ID_01] inputs missing!");
	if (typeof n != "string") throw new TypeError(`ranges-apply/rApply(): [THROW_ID_02] first input argument must be a string! Currently it's: ${typeof n}, equal to: ${R$2(n, 4)}`);
	if (r != null && !Array.isArray(r)) throw new TypeError(`ranges-apply/rApply(): [THROW_ID_03] second input argument must be an array (or null)! Currently it's: ${typeof r}, equal to: ${R$2(r, 4)}`);
	if (t != null && t !== !1 && t !== 0 && t !== "" && typeof t != "function") throw new TypeError(`ranges-apply/rApply(): [THROW_ID_04] the third input argument must be a function, false, null, undefined, 0, or an empty string! Currently it's: ${typeof t}, equal to: ${R$2(t, 4)}`);
	if (r == null || !r.length || r.every((e) => e == null)) return t && t(100), n;
	let s;
	Array.isArray(r) && !Array.isArray(r[0]) && y(r[0]) && y(r[1]) ? s = [Array.from(r)] : s = Array.from(r);
	let h = s.length, f = 0;
	s.forEach((e, p) => {
		if (e) {
			if (t && (a = Math.floor(f / h * 10), a !== i && (i = a, t(a))), !Array.isArray(e)) throw new TypeError(`ranges-apply/rApply(): [THROW_ID_05] ranges array, second input arg., has ${p}th element not an array: ${R$2(e, 4)}, which is ${typeof e}`);
			if (!y(e[0])) throw new TypeError(`ranges-apply/rApply(): [THROW_ID_06] ranges array, second input arg. has ${p}th element, array ${R$2(e)}. Its first element is not a non-negative integer or string index, but ${typeof e[0]}, equal to: ${R$2(e[0], 4)}.`);
			if (typeof e[0] == "string" && (s[p] = [...e], s[p][0] = Number(e[0])), !y(e[1])) throw new TypeError(`ranges-apply/rApply(): [THROW_ID_07] ranges array, second input arg. has ${p}th element, array ${R$2(e)}. Its second element is not a non-negative integer or string index, but ${typeof e[1]}, equal to: ${R$2(e[1], 4)}.`);
			if (typeof e[1] == "string" && (s[p] === e && (s[p] = [...e]), s[p][1] = Number(e[1])), s[p][0] > s[p][1]) throw new RangeError(`ranges-apply/rApply(): [THROW_ID_08] ranges array, second input arg. has ${p}th element, array ${R$2(e)}. Its first index (${s[p][0]}) must not be greater than its second index (${s[p][1]}).`);
			f += 1;
		}
	});
	let l = t ? k$1(s, { progressFn: (e) => {
		a = 10 + Math.floor(e / 10), a !== i && (i = a, t(a));
	} }) : k$1(s), c = l?.length || 0;
	if (l && c > 0) {
		let e = n.slice(l[c - 1][1]);
		n = l.reduce((p, $, u, m) => {
			t && (a = 20 + Math.floor(u / c * 80), a !== i && (i = a, t(a)));
			let I = u === 0 ? 0 : m[u - 1][1], b = m[u][0];
			return `${p}${n.slice(I, b)}${m[u][2] ?? ""}`;
		}, ""), n += e;
	}
	return t && i !== 100 && t(100), n;
}
// ../../node_modules/string-collapse-leading-whitespace/dist/string-collapse-leading-whitespace.esm.js
/**
* @name string-collapse-leading-whitespace
* @fileoverview Collapse the leading and trailing whitespace of a string
* @version 7.3.1
* @author Roy Revelt
* @license MIT
* {@link https://codsen.com/os/string-collapse-leading-whitespace/}
*/
function h$1(l, u = 1) {
	let g = "\xA0";
	function m(e) {
		return e.length < 2 ? e : Array.from(e).reverse().join("");
	}
	function $(e, r, i) {
		let s = i ? `
` : "\r", c = i ? "\r" : `
`;
		if (!e) return e;
		let t = 0, o = "";
		for (let n = 0, p = e.length; n < p; n++) (e[n] === s || e[n] === c && e[n - 1] !== s) && t++, `\r
`.includes(e[n]) || e[n] === g ? e[n] === g ? o += e[n] : e[n] === s ? t <= r && (o += e[n], e[n + 1] === c && (o += e[n + 1], n++)) : e[n] === c && e?.[n - 1] !== s && t <= r && (o += e[n]) : !e[n + 1] && !t && (o += " ");
		return o;
	}
	if (typeof l == "string" && l.length) {
		let e = l.trim();
		if (e.length === l.length) return l;
		let r = 1;
		typeof u == "number" && Number.isInteger(u) && u >= 0 && (r = u);
		let i = "", s = "";
		if (!e) i = l;
		else if (!l[0].trim()) {
			for (let t = 0, o = l.length; t < o; t++) if (l[t].trim()) {
				i = l.slice(0, t);
				break;
			}
		}
		let c = l[l.length - 1];
		if (e && (c.trim() === "" || c === g)) {
			for (let t = l.length; t--;) if (l[t].trim()) {
				s = l.slice(t + 1);
				break;
			}
		}
		return `${$(i, r, !1)}${e}${m($(m(s), r, !0))}`;
	}
	return l;
}
// ../../node_modules/ranges-push/dist/ranges-push.esm.js
/**
* @name ranges-push
* @fileoverview Gather string index ranges
* @version 7.3.3
* @author Roy Revelt
* @license MIT
* {@link https://codsen.com/os/ranges-push/}
*/
var v$1 = {
	mergeType: 1,
	progressFn: null,
	joinRangesThatTouchEdges: !0
};
function V(o, e, n) {
	return e === void 0 || o === null ? o : e === null ? null : o === void 0 || n ? e : o + e;
}
function O(o, e) {
	function n(l) {
		return !!l && typeof l == "object" && !Array.isArray(l);
	}
	if (!Array.isArray(o) || !o.length) return null;
	if (e && !n(e)) throw new TypeError(`ranges-push/rMerge(): [THROW_ID_07] the second input argument must be a plain object. It was given as:
${R$2(e, 4)} (type ${typeof e})`);
	let t = e?.progressFn ?? v$1.progressFn, r = e?.mergeType ?? v$1.mergeType, a = e?.joinRangesThatTouchEdges ?? v$1.joinRangesThatTouchEdges;
	if (t && n(t) && !Object.keys(t).length) t = null;
	else if (t && typeof t != "function") throw new TypeError(`ranges-push/rMerge(): [THROW_ID_08] resolvedOpts.progressFn must be a function! It was given of a type: "${typeof t}", equal to ${R$2(t, 4)}`);
	if (r !== 1 && r !== 2 && r !== "1" && r !== "2") throw new TypeError(`ranges-push/rMerge(): [THROW_ID_09] resolvedOpts.mergeType was customised to a wrong thing! It was given of a type: "${typeof r}", equal to ${R$2(r, 4)}`);
	if (typeof a != "boolean") throw new TypeError(`ranges-push/rMerge(): [THROW_ID_10] resolvedOpts.joinRangesThatTouchEdges was customised to a wrong thing! It was given of a type: "${typeof a}", equal to ${R$2(a, 4)}`);
	let s = [];
	for (let l of o) Array.isArray(l) && (l[2] !== void 0 || l[0] !== l[1]) && s.push([...l]);
	let i, d, g;
	t ? i = I(s, { progressFn: (l) => {
		g = Math.floor(l / 5), g !== d && (d = g, t?.(g));
	} }) : i = I(s);
	let y = i.length - 1, b = +r == 2, f = i.length;
	for (let l = y; l >= 0; l--) {
		let c = i[l];
		for (t && l < y && (g = Math.floor((1 - (l + 1) / y) * 78) + 21, g !== d && g > d && (d = g, t(g))); f < i.length;) {
			let p = i[f], T = p[0] === c[0];
			if (!T && (a ? p[0] > c[1] : p[0] >= c[1])) break;
			let E = p[1] >= c[1];
			E && (c[1] = p[1]), p[2] === null ? c[2] = null : p[2] !== void 0 && (T || E) && (c[2] = V(c[2], p[2], b && T)), f += 1;
		}
		f -= 1, i[f] = c;
	}
	let x = i.length - f;
	for (let l = 0; l < x; l++) i[l] = i[f + l];
	return i.length = x, i.length ? i : null;
}
var R$1 = Object.freeze({
	limitToBeAddedWhitespace: !1,
	limitLinebreaksCount: 1,
	mergeType: 1
});
function h(o) {
	if (Mt(o)) return o;
	if (typeof o == "string" && /^\d+$/.test(o)) {
		let e = Number(o);
		return Mt(e) ? e : null;
	}
	return null;
}
function j(o) {
	if (!Array.isArray(o)) return `a ranges batch must contain only range arrays; received ${R$2(o, 4)}`;
	if (o.length > 3) return `a range must contain at most three values; received ${R$2(o, 4)}`;
	let [e, n, t] = o;
	if (e == null && n == null) return;
	if (e != null && n == null) return `the first index is set (${R$2(e)}) but the second index is not (${R$2(n)})`;
	if (e == null && n != null) return `the second index is set (${R$2(n)}) but the first index is not (${R$2(e)})`;
	let r = h(e), a = h(n);
	if (r === null) return `the first index must be a natural number, zero, or a digit-only numeric string; received ${R$2(e, 4)} (type ${typeof e})`;
	if (a === null) return `the second index must be a natural number, zero, or a digit-only numeric string; received ${R$2(n, 4)} (type ${typeof n})`;
	if (Lt(t) && !b$2(t) && !Pe$1(t)) return `the third value must be a string, number, null, or undefined; received ${R$2(t, 4)} (type ${typeof t})`;
	if (r > a) return `the first index (${r}) must not be greater than the second index (${a})`;
}
function N(o) {
	if (o.length > 3) return {
		error: `expected at most three arguments but received ${o.length}`,
		ranges: []
	};
	if (o.length <= 1 && Array.isArray(o[0])) {
		let n = o[0];
		if (!n.length) return { ranges: [] };
		o = Array.isArray(n[0]) ? n : [n];
	} else o = [o];
	let e = [];
	for (let n of o) {
		let t = j(n);
		if (t) return {
			error: t,
			ranges: []
		};
		let [r, a, s] = n;
		if (r == null && a == null) continue;
		let i = h(r), d = h(a);
		e.push(s !== void 0 && !(b$2(s) && !s.length) ? [
			i,
			d,
			s
		] : [i, d]);
	}
	return { ranges: e };
}
function L(o) {
	return o[2] === void 0 && o[0] === o[1];
}
function M(o) {
	let e = -1;
	for (let n = 0, t = o.length; n < t; n++) {
		let r = o[n];
		if (Array.isArray(r)) {
			if (r[0] < e) return !1;
			e = r[0];
		}
	}
	return !0;
}
var k = class {
	constructor(e) {
		if (e != null && !Re(e)) throw new TypeError(`ranges-push/Ranges/constructor(): [THROW_ID_01] The options argument must be a plain object. It was given as ${R$2(e, 4)} (type ${typeof e}).`);
		if (e === void 0) {
			this.opts = R$1, this.ranges = [];
			return;
		}
		let n = e, t = n.limitToBeAddedWhitespace === void 0 ? R$1.limitToBeAddedWhitespace : n.limitToBeAddedWhitespace, r = n.limitLinebreaksCount === void 0 ? R$1.limitLinebreaksCount : n.limitLinebreaksCount, a = n.mergeType === void 0 ? R$1.mergeType : n.mergeType, s = a === "1" ? 1 : a === "2" ? 2 : a, i;
		if (typeof t != "boolean" ? i = `opts.limitToBeAddedWhitespace must be a boolean; received ${R$2(t, 4)} (type ${typeof t})` : Mt(r) ? s !== 1 && s !== 2 && (i = `opts.mergeType must be 1, 2, "1", or "2"; received ${R$2(a, 4)} (type ${typeof a})`) : i = `opts.limitLinebreaksCount must be a natural number or zero; received ${R$2(r, 4)} (type ${typeof r})`, i) throw new TypeError(`ranges-push/Ranges/constructor(): [THROW_ID_02] ${i}.`);
		let d = Object.freeze({
			limitToBeAddedWhitespace: t,
			limitLinebreaksCount: r,
			mergeType: s
		});
		this.opts = d, this.ranges = [];
	}
	ranges;
	opts;
	currentCache = null;
	rangeListsMatch(e, n) {
		if (!Array.isArray(e)) return n === null;
		if (!Array.isArray(n) || e.length !== n[0]) return !1;
		let t = 1;
		for (let r = 0, a = e.length; r < a; r++) {
			let s = e[r];
			if (!Array.isArray(s)) {
				if (n[t++] !== -1 || s !== n[t++]) return !1;
				continue;
			}
			if (s.length !== n[t++]) return !1;
			for (let i = 0; i < s.length; i++) if (s[i] !== n[t++]) return !1;
		}
		return t === n.length;
	}
	snapshotRanges(e) {
		if (!Array.isArray(e)) return null;
		let n = new Array(1 + e.length * 4);
		n[0] = e.length;
		let t = 1;
		for (let r = 0, a = e.length; r < a; r++) {
			let s = e[r];
			if (Array.isArray(s)) {
				n[t++] = s.length;
				for (let i = 0; i < s.length; i++) n[t++] = s[i];
			} else n[t++] = -1, n[t++] = s;
		}
		return n.length = t, n;
	}
	currentStateMatchesSnapshot() {
		let e = this.currentCache;
		return e !== null && this.rangeListsMatch(this.ranges, e.rangesSnapshot) && this.rangeListsMatch(e.result, e.resultSnapshot);
	}
	recordCurrentSnapshot(e) {
		let n = this.snapshotRanges(this.ranges);
		this.currentCache = {
			rangesSnapshot: n,
			result: e,
			resultSnapshot: e === this.ranges ? n : this.snapshotRanges(e)
		};
	}
	invalidateCurrentCache() {
		this.currentCache = null;
	}
	addValidated(e, n, t) {
		this.invalidateCurrentCache();
		let r = this.last();
		if (Lt(this.ranges) && Array.isArray(r) && e === r[1]) {
			if (r[1] = n, t !== void 0 && !(b$2(t) && !t.length)) {
				let s = V(r[2], t, this.opts.mergeType === 2 && r[0] === e);
				this.opts.limitToBeAddedWhitespace && typeof s == "string" && (s = h$1(s, this.opts.limitLinebreaksCount)), b$2(s) && !s.length || (r[2] = s);
			}
			return;
		}
		this.ranges || (this.ranges = []);
		let a = t !== void 0 ? [
			e,
			n,
			typeof t == "string" && this.opts.limitToBeAddedWhitespace ? h$1(t, this.opts.limitLinebreaksCount) : t
		] : [e, n];
		this.ranges.push(a);
	}
	add(e, n, t) {
		let r = arguments.length, a;
		if (r > 3) a = `expected at most three arguments but received ${r}`;
		else if (r === 1 && Array.isArray(e)) {
			let s = Array.isArray(e[0]) ? e : [e];
			for (let i = 0, d = s.length; i < d && (a = j(s[i]), !a); i++);
			if (!a) for (let i = 0, d = s.length; i < d; i++) {
				let [g, y, b] = s[i];
				g == null && y == null || this.addValidated(h(g), h(y), b$2(b) && !b.length ? void 0 : b);
			}
		} else {
			if (e == null && n == null) return;
			if (e != null && n == null) a = `the first index is set (${R$2(e)}) but the second index is not (${R$2(n)})`;
			else if (e == null && n != null) a = `the second index is set (${R$2(n)}) but the first index is not (${R$2(e)})`;
			else {
				let s = h(e), i = h(n);
				s === null ? a = `the first index must be a natural number, zero, or a digit-only numeric string; received ${R$2(e, 4)} (type ${typeof e})` : i === null ? a = `the second index must be a natural number, zero, or a digit-only numeric string; received ${R$2(n, 4)} (type ${typeof n})` : Lt(t) && !b$2(t) && !Pe$1(t) ? a = `the third value must be a string, number, null, or undefined; received ${R$2(t, 4)} (type ${typeof t})` : s > i ? a = `the first index (${s}) must not be greater than the second index (${i})` : this.addValidated(s, i, b$2(t) && !t.length ? void 0 : t);
			}
		}
		if (a) throw new TypeError(`ranges-push/Ranges/add(): [THROW_ID_03] ${a}.`);
	}
	push(e, n, t) {
		this.add.apply(this, arguments);
	}
	current() {
		if (this.currentStateMatchesSnapshot()) return this.currentCache?.result ?? null;
		if (Array.isArray(this.ranges) && this.ranges.length) {
			this.ranges = O(this.ranges, this.opts.mergeType === 1 ? void 0 : { mergeType: 2 });
			let e = this.ranges;
			return e && this.opts.limitToBeAddedWhitespace && (e = e.map((n) => typeof n[2] == "string" ? [
				n[0],
				n[1],
				h$1(n[2], this.opts.limitLinebreaksCount)
			] : n)), this.recordCurrentSnapshot(e), e;
		}
		return this.recordCurrentSnapshot(null), null;
	}
	firstCovers(e) {
		if (!Mt(e)) throw new TypeError(`ranges-push/Ranges/firstCovers(): [THROW_ID_04] the input argument must be a natural number or zero! It was given as ${R$2(e, 4)} (type ${typeof e})`);
		if (!Array.isArray(this.ranges) || !this.ranges.length) return !1;
		let n = M(this.ranges) ? this.ranges : this.ranges.filter((r) => Array.isArray(r)).slice().sort((r, a) => r[0] - a[0] || r[1] - a[1]), t = null;
		for (let r = 0, a = n.length; r < a; r++) {
			let s = n[r];
			if (!(!Array.isArray(s) || L(s))) {
				if (t === null) {
					if (s[0] !== 0) return !1;
					t = s[1];
				} else {
					if (s[0] > t) break;
					s[1] > t && (t = s[1]);
				}
				if (t >= e) return !0;
			}
		}
		return t !== null && t >= e;
	}
	wipe() {
		this.ranges = [], this.invalidateCurrentCache();
	}
	replace(e) {
		if (Array.isArray(e) && e.length) if (Array.isArray(e[0])) {
			let n = N([e]);
			if (n.error) throw new TypeError(`ranges-push/Ranges/replace(): [THROW_ID_06] ${n.error}.`);
			this.ranges = n.ranges, this.invalidateCurrentCache();
		} else throw new Error(`ranges-push/Ranges/replace(): [THROW_ID_05] Single range was given but we expected array of arrays! The first element, ${R$2(e[0], 4)} should be an array.`);
		else this.ranges = [], this.invalidateCurrentCache();
	}
	last() {
		return Array.isArray(this.ranges) && this.ranges.length ? this.ranges[this.ranges.length - 1] : null;
	}
};
// ../../node_modules/string-left-right/dist/string-left-right.esm.js
/**
* @name string-left-right
* @fileoverview Looks up the first non-whitespace character to the left/right of a given index
* @version 6.2.5
* @author Roy Revelt
* @license MIT
* {@link https://codsen.com/os/string-left-right/}
*/
function f(e) {
	return e === 32 || e >= 9 && e <= 13 || e === 160 || e === 5760 || e >= 8192 && e <= 8202 || e === 8232 || e === 8233 || e === 8239 || e === 8287 || e === 12288 || e === 65279;
}
function v(e, n) {
	return n == null ? 0 : typeof n != "number" || !Number.isInteger(n) || n < 0 ? null : n > e ? e : n;
}
function b(e, n) {
	return n === -1 ? -1 : v(e, n);
}
function R(e, n = 0) {
	if (typeof e != "string" || !e.length) return null;
	let l = b(e.length, n);
	if (l === null || l + 1 >= e.length) return null;
	let t = l + 1;
	if (!f(e.charCodeAt(t))) return t;
	if (t += 1, t >= e.length) return null;
	if (!f(e.charCodeAt(t))) return t;
	for (t += 1; t < e.length; t++) if (!f(e.charCodeAt(t))) return t;
	return null;
}
// ../../node_modules/string-strip-html/dist/string-strip-html.esm.js
/**
* @name string-strip-html
* @fileoverview Strip HTML tags from strings. No parser, accepts mixed sources.
* @version 13.7.7
* @author Roy Revelt
* @license MIT
* {@link https://codsen.com/os/string-strip-html/}
*/
function tn(e) {
	return e > 96 && e < 123 || e > 64 && e < 91 || e > 47 && e < 58 || e === 45 || e === 95;
}
function T(e) {
	return e === 32 || e > 8 && e < 14 ? !0 : e < 128 ? !1 : e === 160 || e === 5760 || e > 8191 && e < 8203 || e === 8232 || e === 8233 || e === 8239 || e === 8287 || e === 12288 || e === 65279;
}
function on(e, l, g) {
	if (e > 96 && e < 123 || e > 64 && e < 91) return !0;
	if (!(e >= 128)) return !1;
	let r = l[g];
	return r.toLowerCase() !== r.toUpperCase();
}
function an(e) {
	for (let l = 0, g = e.length; l < g; l++) if (e.charCodeAt(l) !== 45) return !1;
	return !0;
}
function Be(e, l) {
	let g = 0;
	for (let r in e) if (++g > l) return !0;
	return !1;
}
function we(e, l) {
	if (!e) return [];
	if (Array.isArray(e)) return e.length ? e.filter((g) => typeof g == "string" && g.trim()) : e;
	if (typeof e == "string") return e.trim() ? [e] : [];
	throw new TypeError(`string-strip-html/stripHtml(): [THROW_ID_08] ${l} must be array containing zero or more strings or something falsy. Currently it's equal to: ${e}, that a type of ${typeof e}.`);
}
function nn(e, l, g, r) {
	for (let c = l, i = e.length; c < i; c++) {
		if (e.startsWith(g, c)) return !0;
		if (e.startsWith(r, c)) return !1;
	}
	return !1;
}
function Pe(e, l, g) {
	let r = !e?.quotes, c = !r && !nn(l, g + 1, e.quotes.value, ">"), i = c && e.quotes.next !== -1, n = i && nn(l, e.quotes.next - 1, e.quotes.value, ">");
	return r || c && i && n;
}
function sn(e, l) {
	return (l.match(new RegExp(e, "g")) || []).length;
}
var ie = /* @__PURE__ */ new Set([
	"!doctype",
	"abbr",
	"address",
	"area",
	"article",
	"aside",
	"audio",
	"base",
	"bdi",
	"bdo",
	"blockquote",
	"body",
	"br",
	"button",
	"canvas",
	"caption",
	"cite",
	"code",
	"col",
	"colgroup",
	"data",
	"datalist",
	"dd",
	"del",
	"details",
	"dfn",
	"dialog",
	"div",
	"dl",
	"doctype",
	"dt",
	"em",
	"embed",
	"fieldset",
	"figcaption",
	"figure",
	"footer",
	"form",
	"h1",
	"h2",
	"h3",
	"h4",
	"h5",
	"h6",
	"head",
	"header",
	"hgroup",
	"hr",
	"html",
	"iframe",
	"img",
	"input",
	"ins",
	"kbd",
	"keygen",
	"label",
	"legend",
	"li",
	"link",
	"main",
	"map",
	"mark",
	"math",
	"menu",
	"menuitem",
	"meta",
	"meter",
	"nav",
	"noscript",
	"object",
	"ol",
	"optgroup",
	"option",
	"output",
	"param",
	"picture",
	"pre",
	"progress",
	"rb",
	"rp",
	"rt",
	"rtc",
	"ruby",
	"samp",
	"script",
	"section",
	"select",
	"slot",
	"small",
	"source",
	"span",
	"strong",
	"style",
	"sub",
	"summary",
	"sup",
	"svg",
	"table",
	"tbody",
	"td",
	"template",
	"textarea",
	"tfoot",
	"th",
	"thead",
	"time",
	"title",
	"tr",
	"track",
	"ul",
	"var",
	"video",
	"wbr",
	"xml"
]);
var fe = /* @__PURE__ */ new Set([
	"a",
	"b",
	"i",
	"p",
	"q",
	"s",
	"u"
]);
var be = /* @__PURE__ */ new Set([
	".",
	",",
	";",
	"!",
	"?"
]);
var ln = /* @__PURE__ */ new Set(["\"", "("]);
var rn = /* @__PURE__ */ new Set([
	";",
	".",
	":",
	"!"
]);
var We = /* @__PURE__ */ new Set([
	".",
	",",
	"?",
	";",
	")",
	"…",
	"\"",
	"»"
]);
var un = /* @__PURE__ */ new Set([
	"a",
	"abbr",
	"acronym",
	"audio",
	"b",
	"bdi",
	"bdo",
	"big",
	"button",
	"canvas",
	"cite",
	"code",
	"data",
	"datalist",
	"del",
	"dfn",
	"em",
	"embed",
	"i",
	"iframe",
	"input",
	"ins",
	"kbd",
	"label",
	"map",
	"mark",
	"meter",
	"noscript",
	"object",
	"output",
	"picture",
	"progress",
	"q",
	"ruby",
	"s",
	"samp",
	"select",
	"slot",
	"small",
	"span",
	"strong",
	"sub",
	"sup",
	"svg",
	"template",
	"textarea",
	"time",
	"u",
	"tt",
	"var",
	"video",
	"wbr"
]);
var Le = 32;
var fn = 33;
var Fe = 34;
var te = 37;
var ve = 39;
var K = 47;
var H = 60;
var ue = 61;
var ge = 62;
var bn = {
	ignoreTags: [],
	ignoreTagsWithTheirContents: [],
	onlyStripTags: [],
	stripTogetherWithTheirContents: [
		"script",
		"style",
		"xml"
	],
	skipHtmlDecoding: !1,
	trimOnlySpaces: !1,
	stripRecognisedHTMLOnly: !1,
	dumpLinkHrefsNearby: {
		enabled: !1,
		putOnNewLine: !1,
		wrapHeads: "",
		wrapTails: ""
	},
	ignoreIndentations: !1,
	cb: null,
	reportProgressFunc: null,
	reportProgressFuncFrom: 0,
	reportProgressFuncTo: 100
};
function An(e, l) {
	let g = Date.now(), r = [], c = [], i = [], n = {}, d, E = "";
	function O() {
		n = { attributes: [] }, d = void 0, E = "";
	}
	function y(t) {
		return typeof t.name != "string" ? "" : t !== n ? t.name.toLowerCase() : (d !== t.name && (d = t.name, E = t.name.toLowerCase()), E);
	}
	O();
	let V = null, I = null, N = null, J = !1, s = {}, w = 0;
	function x() {
		s = {}, w = 0;
	}
	let je = null, k = {
		tagName: "",
		hrefValue: "",
		openingTagEnds: void 0
	}, P = "", Q = !1, ce = null, Y = null, z = !0, U = -1, pe = 0, X = [];
	function me(t, o, f) {
		let b = y(n);
		if (Array.isArray(o.stripTogetherWithTheirContents) && (o.stripTogetherWithTheirContents.includes("*") || o.stripTogetherWithTheirContents.includes(b))) if (n.slashPresent && Array.isArray(r) && r.some((p) => y(p) === b)) {
			for (let p = r.length; p--;) if (y(r[p]) === b) {
				let u = n.lastClosingBracketAt === t ? t + 1 : t;
				We.has(e[t]) ? W(n, [
					r[p].lastOpeningBracketAt,
					u,
					null
				], "tag", typeof n.lastClosingBracketAt == "number" ? "complete" : "incomplete", n.lastOpeningBracketAt, typeof n.lastClosingBracketAt == "number" ? n.lastClosingBracketAt + 1 : ee(t) ? t : t + 1) : W(n, [
					r[p].lastOpeningBracketAt,
					u,
					""
				], "tag", typeof n.lastClosingBracketAt == "number" ? "complete" : "incomplete", n.lastOpeningBracketAt, typeof n.lastClosingBracketAt == "number" ? n.lastClosingBracketAt + 1 : ee(t) ? t : t + 1), r.splice(p, 1);
				break;
			}
		} else n.slashPresent || r.push(n);
		else Array.isArray(o.ignoreTagsWithTheirContents) && o.ignoreTagsWithTheirContents.length && _e(t, o, n) && (z = !1);
	}
	function He(t) {
		t = ae(t);
		let o = h.ranges, f = o ? o.length : 0;
		if (!f) return !1;
		let b = f - 1, p = !1;
		for (; pe < b;) {
			let $ = o[pe];
			pe += 1, qe($) && ((U === -1 ? $[0] === 0 : $[0] <= U) ? $[1] > U && (U = $[1], p = !0) : X.push($));
		}
		p && (U = Je(U, !0));
		let u = U, m = o[b];
		return qe(m) && (u === -1 ? m[0] === 0 : m[0] <= u) && m[1] > u && (u = Je(m[1], !1)), u !== -1 && u >= t;
	}
	function qe(t) {
		return Array.isArray(t) && (t[2] !== void 0 || t[0] !== t[1]);
	}
	function Je(t, o) {
		let f = !0;
		for (; f && X.length;) {
			f = !1;
			let b = 0;
			for (let p = 0, u = X.length; p < u; p++) {
				let m = X[p];
				m[0] <= t ? m[1] > t && (t = m[1], f = !0) : o && (X[b] = m, b += 1);
			}
			o && (X.length = b);
		}
		return t;
	}
	function Z(t, o, f, b, p, u) {
		if (typeof f == "number" && He(f)) return "";
		if (e.length === b && u && !a?.dumpLinkHrefsNearby?.enabled) return null;
		let m = "";
		if (Number.isInteger(f) && f < p && (m += t.slice(f, p)), Number.isInteger(b) && b > u + 1) {
			let R$3 = t.slice(u + 1, b);
			b && !R(e, b - 1) && (R$3 = R$3.trimRight()), R$3.includes(`
`) && ee(b, t) ? m += " " : m += R$3;
		}
		let $ = !We.has(t[o]), S = t[b - 1] !== ">" || !t[f].trim(), D = !ln.has(t[p - 1]), xe = !rn.has(t[o]);
		if (($ || S && D && xe) && (S || D) && t[o] !== "!" && (!un.has(y(n)) || typeof f == "number" && f < p || typeof b == "number" && b > u + 1)) {
			let R = 0;
			for (let le = m.indexOf(`
`); le !== -1 && R < 3; le = m.indexOf(`
`, le + 1)) R += 1;
			return R ? R === 1 ? `
` : R === 2 ? `

` : `


` : " ";
		}
		return "";
	}
	function de(t, o) {
		if (P = "", t.dumpLinkHrefsNearby?.enabled && k.tagName && k.tagName.toLowerCase() === y(n) && n.lastOpeningBracketAt && (k.openingTagEnds && n.lastOpeningBracketAt > k.openingTagEnds || !k.openingTagEnds) && (Q = !0), Q) {
			let f = t.dumpLinkHrefsNearby?.putOnNewLine ? `

` : "";
			P = `${f}${k.hrefValue}`, (typeof o != "number" || R(e, o - 1)) && (P += f);
		}
	}
	function Ue(t, o) {
		return P && !o && !t.dumpLinkHrefsNearby?.putOnNewLine ? `${n.leftOuterWhitespace && !He(n.leftOuterWhitespace) ? " " : ""}${P} ` : `${o}${P}${o}`;
	}
	function ee(t, o) {
		return t == null ? !1 : o ? o.charCodeAt(t) === H && o.charCodeAt(t + 1) !== te : e.charCodeAt(t) === H && e.charCodeAt(t + 1) !== te;
	}
	function he(t) {
		return t != null && e.charCodeAt(t) === ge && e.charCodeAt(t - 1) !== te;
	}
	function dn(t) {
		if (e.charCodeAt(t) !== H) return !1;
		let o = R(e, t);
		if (o === null || e.charCodeAt(o) !== 47) return !1;
		let f = R(e, o);
		if (f === null) return !1;
		for (let u = 0; u < C.length; u++) if ((e.charCodeAt(f + u) | 32) !== C.charCodeAt(u)) return !1;
		let b = f + C.length;
		if (Ce && L.slice(ae(t), ae(b + 1)) !== e.slice(t, b + 1)) return !1;
		let p = e.charCodeAt(b);
		return Number.isNaN(p) || p === Le || p === 9 || p === 10 || p === 12 || p === 13 || p === 47 || p === ge || p === H;
	}
	function _e(t, o, f) {
		if (!o.ignoreTagsWithTheirContents.length) return !1;
		if (o.ignoreTagsWithTheirContents.includes("*")) return !0;
		let b = typeof f.name == "string" ? f.name.toLowerCase() : "";
		if (!o.ignoreTagsWithTheirContents.includes(b)) return !1;
		ce === null && (ce = Fn(e));
		let p = ce.indexOf(`<${b}`, t), u = ce.indexOf(`</${b}`, t);
		return !f.slashPresent && u === -1 || f.slashPresent && !c.some((m) => y(m) === b) || u > -1 && p > -1 && p < u ? !1 : o.ignoreTagsWithTheirContents.includes(b);
	}
	if (typeof e != "string") throw new TypeError(`string-strip-html/stripHtml(): [THROW_ID_01] Input must be string! Currently it's: ${(typeof e).toLowerCase()}, equal to:
${R$2(e, 4)}`);
	if (l) if (Re(l)) {
		if (l.reportProgressFunc && typeof l.reportProgressFunc != "function") throw new Error(`string-strip-html/stripHtml(): [THROW_ID_03] The Optional Options Object's key reportProgressFunc, callback function, should be a function but it was given as type ${typeof l.reportProgressFunc}, equal to ${R$2(l.reportProgressFunc, 4)}`);
		if (typeof l.dumpLinkHrefsNearby == "boolean" && l.dumpLinkHrefsNearby != null) throw new Error(`string-strip-html/stripHtml(): [THROW_ID_04] The Optional Options Object's key should be a plain object but it was given as type ${typeof l.dumpLinkHrefsNearby}, equal to ${R$2(l.dumpLinkHrefsNearby, 4)}`);
	} else throw new TypeError(`string-strip-html/stripHtml(): [THROW_ID_02] Optional Options Object must be a plain object! Currently it's: ${(typeof l).toLowerCase()}, equal to:
${R$2(l, 4)}`);
	function ye() {
		Q && (k = {
			tagName: "",
			hrefValue: "",
			openingTagEnds: void 0
		}, Q = !1);
	}
	let Te = !!l?.cb, a = {
		...bn,
		...l,
		dumpLinkHrefsNearby: Object.assign({}, bn.dumpLinkHrefsNearby, l?.dumpLinkHrefsNearby)
	};
	if (Vt(a, "returnRangesOnly")) throw new TypeError("string-strip-html/stripHtml(): [THROW_ID_05] The Optional Options Object's key returnRangesOnly has been removed from the API since v.5 release.");
	if (a.reportProgressFunc) {
		if (typeof a.reportProgressFuncFrom != "number") throw new Error(`string-strip-html/stripHtml(): [THROW_ID_06] The Optional Options Object's key reportProgressFuncFrom, callback function's "from" range, should be a number but it was given as type ${typeof a.reportProgressFuncFrom}, equal to ${R$2(a.reportProgressFuncFrom, 4)}`);
		if (typeof a.reportProgressFuncTo != "number") throw new Error(`string-strip-html/stripHtml(): [THROW_ID_07] The Optional Options Object's key reportProgressFuncTo, callback function's "to" range, should be a number but it was given as type ${typeof a.reportProgressFuncTo}, equal to ${R$2(a.reportProgressFuncTo, 4)}`);
	}
	let Ee = we(a.ignoreTags, "resolvedOpts.ignoreTags");
	a.ignoreTags = Ee.length ? Ee.map((t) => t.toLowerCase()) : Ee;
	let Oe = we(a.onlyStripTags, "resolvedOpts.onlyStripTags");
	a.onlyStripTags = Oe.length ? Oe.map((t) => t.toLowerCase()) : Oe, Array.isArray(a.ignoreTagsWithTheirContents) && a.ignoreTagsWithTheirContents.length && (a.ignoreTagsWithTheirContents = a.ignoreTagsWithTheirContents.map((t) => typeof t == "string" ? t.toLowerCase() : t));
	let Se = !!a.onlyStripTags.length;
	a.onlyStripTags.length && a.ignoreTags.length && (a.onlyStripTags = Bt(a.onlyStripTags, a.ignoreTags)), a.stripTogetherWithTheirContents ? typeof a.stripTogetherWithTheirContents == "string" && a.stripTogetherWithTheirContents.length && (a.stripTogetherWithTheirContents = [a.stripTogetherWithTheirContents]) : a.stripTogetherWithTheirContents = [];
	let oe = {};
	if (a.stripTogetherWithTheirContents && Array.isArray(a.stripTogetherWithTheirContents) && a.stripTogetherWithTheirContents.length && !a.stripTogetherWithTheirContents.every((t, o) => typeof t != "string" ? (oe.el = t, oe.i = o, !1) : !0)) throw new TypeError(`string-strip-html/stripHtml(): [THROW_ID_09] Optional Options Object's key stripTogetherWithTheirContents was set to contain not just string elements! For example, element at index ${oe.i} has a value ${oe.el} which is not string but ${(typeof oe.el).toLowerCase()}.`);
	Array.isArray(a.stripTogetherWithTheirContents) && (a.stripTogetherWithTheirContents = a.stripTogetherWithTheirContents.map((t) => t.toLowerCase()));
	let Me = !!(a.stripRecognisedHTMLOnly || a.ignoreTags.length || a.ignoreTagsWithTheirContents.length || Se);
	if (a.cb && typeof a.cb != "function") throw new TypeError(`string-strip-html/stripHtml(): [THROW_ID_10] The Optional Options Object's key cb should be a function or something falsy but it was given as type ${typeof a.cb}, equal to ${R$2(a.cb, 4)}`);
	let h = pn(), De = !0;
	function W(t, o, f, b, p, u) {
		let m = o ? A ? Ie(o, e, A) : o : null;
		if (!Te) {
			m && h.push(m);
			return;
		}
		if (A) {
			let $ = {
				tag: Vn(t, f, b, p, u, e, A),
				deleteFrom: m ? m[0] : null,
				deleteTo: m ? m[1] : null,
				insert: m ? m[2] : null,
				rangesArr: h,
				proposedReturn: m ? [...m] : null
			}, S = De, D = S ? Pn(h.current()) : null;
			a.cb?.($), S && !Wn(h.current(), Ln(D, m)) && (De = !1);
		}
	}
	let L = e, ne = a.skipHtmlDecoding || !e.includes("&") ? null : Cn(e);
	ne && (e = v$2(e, ne));
	let A = ne || Te ? kn(L, e, ne) : null;
	function ae(t) {
		return A ? B(t, e, A).idx : t;
	}
	function Ae(t) {
		h.push(A ? Ie(t, e, A) : t);
	}
	let C = "", Ce = !1, F = !1, v = null, Ge = 0, Ke = -1, Qe = !1, _ = e.length, se = L.length, hn = Math.floor(se / 2);
	function ke(t) {
		let o = A ? Math.max(0, q(t + 1, e, A).idx - 1) : t;
		if (!(o <= Ke)) {
			if (Ke = o, se > 1e3 && se < 2e3) !Qe && o >= hn && (Qe = !0, a.reportProgressFunc?.(a.reportProgressFuncFrom + Math.floor((a.reportProgressFuncTo - a.reportProgressFuncFrom) / 2)));
			else if (se >= 2e3) {
				let f = a.reportProgressFuncFrom + Math.floor(o / se * (a.reportProgressFuncTo - a.reportProgressFuncFrom));
				f !== Ge && (Ge = f, a.reportProgressFunc?.(f));
			}
		}
	}
	function Re$1() {
		O(), x(), F = !1;
	}
	function yn(t) {
		let o = t.name?.length;
		if (o !== 5 && o !== 6 && o !== 8) return !1;
		let f = y(t);
		return f === "script" || f === "title" || f === "textarea";
	}
	function Ye() {
		if (!yn(n)) return !1;
		if (n.slashPresent) C = "", Ce = !1;
		else {
			let t = y(n);
			C !== t && (Ce = ne !== null && t !== "script" && L.charCodeAt(ae(n.lastOpeningBracketAt)) === H, C = t);
		}
		return !0;
	}
	function Ve() {
		Ye(), v = null, Re$1();
	}
	function ze(t, o, f) {
		let b = y(n), p = a.ignoreTags.includes(b), u = _e(t, a, n);
		if (!(!z || a.stripRecognisedHTMLOnly && typeof n.name == "string" && !ie.has(b) && !fe.has(b) || !Se && (p || u) || Se && !a.onlyStripTags.includes(b) || a.ignoreTagsWithTheirContents.includes(b))) return !1;
		if (u) if (n.slashPresent) {
			for (let $ = c.length; $--;) if (c[$].name?.toLowerCase() === b) {
				c.splice($, 1);
				break;
			}
			c.length || (z = !0);
		} else z && (z = !1), c.push(n);
		return W(n, null, "tag", o, n.lastOpeningBracketAt, f), v = null, Re$1(), !0;
	}
	for (let t = 0; t < _; t++) {
		let o = e.charCodeAt(t), f = o === H && e.charCodeAt(t + 1) !== te, b = o === ge && e.charCodeAt(t - 1) !== te;
		if (a.reportProgressFunc && ke(t), Y === null && o !== Le && n.lastClosingBracketAt && n.lastClosingBracketAt < t && (n.attributes !== void 0 || Be(n, 1)) && (Y = t), !C && o === te && e[t - 1] === "{" && e.includes("%}", t + 1)) {
			N = null;
			let u = e.indexOf("%}", t) - 1;
			if (u > t) {
				t = u, a.reportProgressFunc && ke(t);
				continue;
			}
		}
		if (!C && b && (!n || !Be(n, 1)) && t > 1) {
			for (let u = t; u--;) if (e[u - 1] === void 0 || he(u)) {
				let m = e[u - 1] === void 0 ? u : u + 1, $ = e.slice(m, t + 1) || "", S = $.trim(), D = Dt(S.split(/\s+/, 1)[0] || "", "/>"), xe = Dt(S, "/>"), R = D.toLowerCase();
				if (($.includes("/>") || $.includes("/ >") || $.includes("=\"") || $.includes("='")) && e !== `<${xe}>` && ie.has(R) && An(`<${S}>`, {
					skipHtmlDecoding: !0,
					cb: null,
					reportProgressFunc: null
				}).result === "") {
					(!i.length || i[i.length - 1][0] !== n.lastOpeningBracketAt) && i.push([m, t + 1]);
					let le = Z(e, t, m, t + 1, m, t + 1), re = t + 1;
					if (e[re] && T(e.charCodeAt(re))) {
						for (let $e = re; $e < _; $e++) if (!T(e.charCodeAt($e))) {
							re = $e;
							break;
						}
					}
					let Ze = m + $.indexOf(D);
					W({
						name: D,
						nameStarts: Ze,
						nameEnds: Ze + D.length,
						nameContainsLetters: !0
					}, [
						m,
						re,
						le
					], "tag", "inferred", m, t + 1);
				}
				break;
			}
		}
		if (!F && o === K && !n.quotes?.value && (typeof s.equalsAt != "number" || s.valueEnds !== void 0) && Number.isInteger(n.lastOpeningBracketAt) && !Number.isInteger(n.lastClosingBracketAt) && (n.slashPresent = t), o === Fe || o === ve) if (!F && n.nameStarts && n?.quotes?.value === e[t]) if (je = t, s.valueStarts === void 0) x(), n.quotes = void 0;
		else {
			s.valueEnds = t, s.value = e.slice(s.valueStarts, t), n.attributes.push(s), x(), n.quotes = void 0;
			let u = a.dumpLinkHrefsNearby?.enabled && !r.length ? n.attributes.find((m) => typeof m.name == "string" && m.name.toLowerCase() === "href") : void 0;
			typeof u?.value == "string" && (k = {
				tagName: n.name,
				hrefValue: `${a.dumpLinkHrefsNearby?.wrapHeads || ""}${u.value}${a.dumpLinkHrefsNearby?.wrapTails || ""}`,
				openingTagEnds: void 0
			});
		}
		else !F && !n.quotes && n.nameStarts && s.valueStarts === void 0 && (n.quotes = {}, n.quotes.value = e[t], n.quotes.start = t, n.quotes.next = e.indexOf(e[t], t + 1), w = 0, s.nameStarts && s.nameEnds && s.nameEnds < t && s.nameStarts < t && !s.valueStarts && (s.name = e.slice(s.nameStarts, s.nameEnds)));
		if (n.nameStarts !== void 0 && n.nameEnds === void 0 && (T(o) || !tn(o))) {
			if (n.nameEnds = t, n.name = e.slice(n.nameStarts, n.nameEnds + (!b && o !== K && e[t + 1] === void 0 ? 1 : 0)), e[n.nameStarts - 1] !== "!" && an(n.name) || n.name.charCodeAt(0) > 47 && n.name.charCodeAt(0) < 58) {
				n = {};
				continue;
			}
			if (typeof n.name == "string" && y(n) === "doctype" && (F = !0), f) {
				de(a);
				let u = Z(e, t, n.leftOuterWhitespace, t, n.lastOpeningBracketAt, t);
				W(n, [
					n.leftOuterWhitespace,
					t,
					Ue(a, u)
				], "tag", "incomplete", n.lastOpeningBracketAt, t), ye(), me(t, a, h), Ve();
			}
		}
		if (s.nameEnds && s.equalsAt && !s.valueStarts && n.quotes?.start && n.quotes.start < t && !n.quotes.end && (s.valueStarts = t), w && (w === 1 && s.valueStarts === void 0 && s.equalsAt < t && !T(o) && o !== Fe && o !== ve && o !== ue && !f && !b && (s.valueStarts = t, w = 2), w === 2 && (T(o) || b || e[t + 1] === void 0) && (s.valueEnds = T(o) || b ? t : t + 1, s.value = e.slice(s.valueStarts, s.valueEnds), a.dumpLinkHrefsNearby?.enabled && !r.length && typeof s.name == "string" && s.name.toLowerCase() === "href" && (k = {
			tagName: n.name,
			hrefValue: `${a.dumpLinkHrefsNearby.wrapHeads || ""}${s.value}${a.dumpLinkHrefsNearby.wrapTails || ""}`,
			openingTagEnds: void 0
		}), n.attributes.push(s), x())), o === ue && s.nameEnds && !s.valueStarts && !s.equalsAt && !n.quotes && (s.equalsAt = t, w = 1), s.nameEnds && s.nameStarts && !s.valueStarts && !s.equalsAt && !T(o) && o !== ue && !n.quotes && (n.attributes.push(s), x()), s.nameStarts && !s.nameEnds && !n.quotes && (F && `'"`.includes(e[s.nameStarts]) ? s.nameStarts < t && e[t] === e[s.nameStarts] && (s.nameEnds = t + 1, s.name = e.slice(s.nameStarts, s.nameEnds)) : T(o) ? (s.nameEnds = t, s.name = e.slice(s.nameStarts, s.nameEnds)) : o === ue ? s.equalsAt || (s.nameEnds = t, s.equalsAt = t, w = 1, s.name = e.slice(s.nameStarts, s.nameEnds)) : (o === K || b || f) && (s.nameEnds = t, s.name = e.slice(s.nameStarts, s.nameEnds), n.attributes.push(s), x())), T(e.charCodeAt(t - 1)) && je !== t && !T(o) && o !== H && o !== ge && o !== K && o !== fn && !s.nameStarts && n.nameEnds < t && !n.lastClosingBracketAt && !n.quotes && (s.nameStarts = t), o === K && n.lastOpeningBracketAt !== null && n.lastOpeningBracketAt < t && n.onlyPlausible && (n.onlyPlausible = !1), n.lastOpeningBracketAt !== null && n.lastOpeningBracketAt < t && o !== K && (n.onlyPlausible === void 0 && ((T(o) || f) && !n.slashPresent ? n.onlyPlausible = !0 : n.onlyPlausible = !1), !T(o) && n.nameStarts === void 0 && !f && o !== K && !b && o !== fn && (o > 96 && o < 123 || o > 64 && o < 91 || o === 45 || o === 63 || o === 95 ? (n.nameStarts = t, n.nameContainsLetters = !1) : (O(), x()))), n.nameStarts && !n.quotes && on(o, e, t) && (n.nameContainsLetters = !0), b && (!n.quotes || typeof s.equalsAt != "number" || n.quotes.next === -1) && (Pe(n, e, t) || n.quotes.value && typeof n.lastOpeningBracketAt == "number" && sn(n.quotes.value, e.slice(n.lastOpeningBracketAt, t)) % 2 === 1 && !e.slice(n.lastOpeningBracketAt + 1, t).includes("<") && !e.slice(n.lastOpeningBracketAt + 1, t).includes(">")) && n.lastOpeningBracketAt !== void 0 && (n.lastClosingBracketAt = t, Y = null, Object.keys(s).length && (n.attributes.push(s), x()), a.dumpLinkHrefsNearby?.enabled && k.tagName && !k.openingTagEnds && (k.openingTagEnds = t)), (!F || o === ge) && n.lastOpeningBracketAt !== void 0) {
			if (n.lastClosingBracketAt === void 0) {
				if (n.lastOpeningBracketAt < t && !f && (e[t + 1] === void 0 || ee(t + 1) && !n?.quotes?.value) && n.nameContainsLetters && typeof n.nameStarts == "number") {
					let u = !1;
					if (n.nameEnds ??= t + 1, n.name = e.slice(n.nameStarts, n.nameEnds).toLowerCase(), (!i.length || i[i.length - 1][0] !== n.lastOpeningBracketAt) && i.push([n.lastOpeningBracketAt, t + 1]), Me && ze(t, "incomplete", t + 1)) continue;
					if ((ie.has(n.name) || fe.has(n.name)) && (n.onlyPlausible === !1 || n.onlyPlausible === !0 && n.attributes.length) || e[t + 1] === void 0 && n.onlyPlausible !== !0) {
						de(a);
						let m = Z(e, t, n.leftOuterWhitespace, t + 1, n.lastOpeningBracketAt, n.lastClosingBracketAt);
						C && y(n) === C && n.slashPresent && (C = "");
						let $;
						m === null || P === null ? $ = null : $ = Ue(a, m), W(n, [
							n.leftOuterWhitespace,
							t + 1,
							$
						], "tag", "incomplete", n.lastOpeningBracketAt, t + 1), u = !0, ye(), me(t, a, h);
					}
					u ? Ve() : (v = n.onlyPlausible === !1 ? v ?? n.leftOuterWhitespace : null, Re$1());
				}
			} else if (t > n.lastClosingBracketAt && !T(o) || e[t + 1] === void 0 || a.ignoreIndentations && `\r
`.includes(e[t])) {
				let u = n.lastClosingBracketAt === t ? t + 1 : t;
				if (a.trimOnlySpaces && u === _ - 1 && Y !== null && Y < t && (u = Y), (!i.length || i[i.length - 1][0] !== n.lastOpeningBracketAt) && i.push([n.lastOpeningBracketAt, n.lastClosingBracketAt + 1]), !(Me && ze(t, "complete", n.lastClosingBracketAt + 1))) if (!n.onlyPlausible || n.attributes.length === 0 && n.name && (ie.has(y(n)) || fe.has(y(n))) || n.attributes?.some((m) => m.equalsAt)) {
					let m = Z(e, t, n.leftOuterWhitespace, u, n.lastOpeningBracketAt, n.lastClosingBracketAt);
					Q = !1, de(a, u);
					let $;
					typeof P == "string" && P.length ? ($ = `${m}${P}${m === `

` ? `
` : m}`, u === n.lastClosingBracketAt + 1 && (!e[u] || !be.has(e[u])) && ($ += " "), n.leftOuterWhitespace === n.lastOpeningBracketAt && h.last() && h.last()[1] < ae(n.lastOpeningBracketAt) && (!a?.dumpLinkHrefsNearby?.putOnNewLine || !be.has(e[u])) && ($ = ` ${$}`)) : $ = m, $ !== null && (n.leftOuterWhitespace === 0 || !R(e, u - 1)) && (!a.dumpLinkHrefsNearby?.enabled || y(n) !== "a") && ($ = void 0);
					let S = 0;
					if (Q && be.has(e[u])) {
						a.dumpLinkHrefsNearby?.putOnNewLine && ($ = `${e[u]}${$ || ""}`);
						let D = R(e, u);
						D && $?.endsWith(`
`) ? S += D - t : (!D || D > t) && S++;
					}
					W(n, [
						n.leftOuterWhitespace,
						u + S,
						$
					], "tag", "complete", n.lastOpeningBracketAt, n.lastClosingBracketAt + 1), ye(), me(t, a, h), v = null;
				} else n = {}, v = null;
				b || (n = {});
			}
			F && (F = !1);
		}
		if ((!C || o === H && dn(t)) && f && (!n.quotes || typeof s.equalsAt != "number" || n.quotes.next === -1 || n.quotes.next + 1 < _ && !T(e.charCodeAt(n.quotes.next + 1)) && e[n.quotes.next + 1] !== ">" && e[n.quotes.next + 1] !== "/") && !ee(t - 1) && !`'"`.includes(e[t + 1]) && (!`'"`.includes(e[t + 2]) || /\w/.test(e[t + 1])) && !(e[t + 1] === "c" && e[t + 2] === ":") && !(e[t + 1] === "f" && e[t + 2] === "m" && e[t + 3] === "t" && e[t + 4] === ":") && !(e[t + 1] === "s" && e[t + 2] === "q" && e[t + 3] === "l" && e[t + 4] === ":") && !(e[t + 1] === "x" && e[t + 2] === ":") && !(e[t + 1] === "f" && e[t + 2] === "n" && e[t + 3] === ":") && Pe(n, e, t)) {
			if (he(R(e, t))) continue;
			if (n.nameEnds && n.nameEnds < t && !n.lastClosingBracketAt && (n.onlyPlausible === !0 && n.attributes?.length || n.onlyPlausible === !1)) {
				let u = Z(e, t, n.leftOuterWhitespace, t, n.lastOpeningBracketAt, t);
				W(n, [
					n.leftOuterWhitespace,
					t,
					u
				], "tag", "incomplete", n.lastOpeningBracketAt, t), me(t, a, h), Ve();
			}
			if (n.lastOpeningBracketAt !== void 0 && n.onlyPlausible && n.name && !n.quotes && (n.lastOpeningBracketAt = void 0, n.name = void 0, n.onlyPlausible = !1), (n.lastOpeningBracketAt === void 0 || !n.onlyPlausible) && !n.quotes && (n.lastOpeningBracketAt = t, n.slashPresent = !1, n.attributes = [], V === null ? n.leftOuterWhitespace = t : a.trimOnlySpaces && V === 0 ? n.leftOuterWhitespace = I || t : n.leftOuterWhitespace = V, v !== null && (n.leftOuterWhitespace = v), e.startsWith("!--", t + 1) || e.startsWith("![CDATA[", t + 1))) {
				let u = !0;
				e[t + 2] === "-" && (u = !1);
				let m;
				for (let $ = t; $ < _; $++) if (a.reportProgressFunc && ke($), $ > 1 && (!m && u && e.startsWith("]]>", $ - 2) || !u && e.startsWith("-->", $ - 2)) && (m = $), m && (m < $ && !T(e.charCodeAt($)) || e[$ + 1] === void 0)) {
					let S = $;
					(e[$ + 1] === void 0 && T(e.charCodeAt($)) || e[$] === ">") && (S += 1), (!i.length || i[i.length - 1][0] !== n.lastOpeningBracketAt) && i.push([n.lastOpeningBracketAt, m + 1]);
					let D = Z(e, $, n.leftOuterWhitespace, S, n.lastOpeningBracketAt, m);
					W(n, [
						n.leftOuterWhitespace,
						S,
						D
					], u ? "cdata" : "comment", void 0, n.lastOpeningBracketAt, m + 1), v = null, t = $ - 1, e[$] === ">" && (t = $), o = e.charCodeAt(t), f = ee(t), b = he(t), n = {}, x();
					break;
				}
			}
		}
		if (T(o) || o === 847) V === null && (V = t, n.lastOpeningBracketAt !== void 0 && n.lastOpeningBracketAt < t && n.nameStarts && n.nameStarts < n.lastOpeningBracketAt && t === n.lastOpeningBracketAt + 1 && !r.some((u) => y(u) === y(n)) && (n.onlyPlausible = !0, n.name = void 0, n.nameStarts = void 0)), (o === 10 || o === 13) && (N = t, J && (J = !1));
		else if (V !== null && (!n.quotes && s.valueStarts === void 0 && s.equalsAt > V - 1 && s.nameEnds && s.equalsAt > s.nameEnds && o !== ue && o !== Fe && o !== ve && (Re(s) && n.attributes.push(s), x(), n.equalsSpottedAt = void 0), V = null), !J && (J = !0, z && !C && typeof N == "number" && t && N < t - 1)) {
			if (e.slice(N + 1, t).trim()) N = null;
			else if (!a.ignoreIndentations) {
				let u = h.last(), m = A ? Ie([N + 1, t], e, A) : [N + 1, t];
				(!u || u[0] > m[0] || u[1] !== m[1]) && h.push(m);
			}
		}
		o === Le ? I === null && (I = t) : I !== null && (I = null);
		let p = n.name?.length;
		(p === 5 || p === 6 || p === 8) && Ye();
	}
	if (e && !a.ignoreIndentations && (a.trimOnlySpaces && e[0] === " " || !a.trimOnlySpaces && T(e.charCodeAt(0)))) for (let t = 0; t < _; t++) if (a.trimOnlySpaces && e[t] !== " " || !a.trimOnlySpaces && !T(e.charCodeAt(t))) {
		Ae([0, t]);
		break;
	} else e[t + 1] || Ae([0, t + 1]);
	if (e && (a.trimOnlySpaces && e[~-e.length] === " " || !a.trimOnlySpaces && T(e.charCodeAt(~-e.length)))) {
		for (let t = e.length; t--;) if (a.trimOnlySpaces && e[t] !== " " || !a.trimOnlySpaces && !T(e.charCodeAt(t))) {
			Ae([t + 1, _]);
			break;
		}
	}
	let j = h.current();
	if ((!Te || De) && j) {
		if (j[0] && !j[0][0]) {
			j[0][1];
			let o = h.ranges?.[0]?.[2];
			h.ranges[0] = [h.ranges[0][0], h.ranges[0][1]], o?.trim() && h.ranges[0].push(o);
		}
		if (j[j.length - 1]?.[1] === L.length) {
			j[j.length - 1][0];
			if (h.ranges) {
				let o = h.ranges[h.ranges.length - 1][0];
				L[o - 1] && (a.trimOnlySpaces && L[o - 1] === " " || !a.trimOnlySpaces && T(L.charCodeAt(o - 1))) && (o -= 1);
				let f = h.ranges[h.ranges.length - 1][2];
				h.ranges[h.ranges.length - 1] = [o, h.ranges[h.ranges.length - 1][1]], f?.trim() && h.ranges[h.ranges.length - 1].push(f.trimRight());
			}
		}
	}
	let Ne = xn(ne, h.current()), Xe = A ? Bn(i, e, A) : i;
	return {
		log: { timeTakenInMilliseconds: Date.now() - g },
		result: v$2(L, Ne),
		ranges: Ne,
		allTagLocations: Xe,
		filteredTagLocations: wn(Xe, Ne)
	};
}
function Cn(e) {
	let l = /&(?:#?[^;\W]+;)+/g, g = [], r;
	for (r = l.exec(e); r; r = l.exec(e)) {
		let c = r[0], i = O$1(c, { requireSemicolon: !0 });
		for (; c !== i;) c = i, i = O$1(c, { requireSemicolon: !0 });
		c !== r[0] && g.push([
			r.index,
			r.index + r[0].length,
			c
		]);
	}
	return g.length ? g : null;
}
function kn(e, l, g) {
	if (!g) return [{
		decodedFrom: 0,
		decodedTo: l.length,
		originalFrom: 0,
		originalTo: e.length,
		replacement: !1
	}];
	let r = [], c = 0, i = 0;
	return g.forEach(([n, d, E]) => {
		if (c < n) {
			let y = n - c;
			r.push({
				decodedFrom: i,
				decodedTo: i + y,
				originalFrom: c,
				originalTo: n,
				replacement: !1
			}), i += y;
		}
		let O = E || "";
		r.push({
			decodedFrom: i,
			decodedTo: i + O.length,
			originalFrom: n,
			originalTo: d,
			replacement: !0
		}), i += O.length, c = d;
	}), c < e.length && r.push({
		decodedFrom: i,
		decodedTo: l.length,
		originalFrom: c,
		originalTo: e.length,
		replacement: !1
	}), r;
}
function B(e, l, g) {
	let r = 0, c = g.length - 1, i;
	for (; r <= c;) {
		let n = r + c >> 1, d = g[n];
		if (e < d.decodedFrom) c = n - 1;
		else if (e >= d.decodedTo) r = n + 1;
		else {
			i = d;
			break;
		}
	}
	return i ? i.replacement ? {
		idx: i.originalFrom,
		prefix: l.slice(i.decodedFrom, e),
		segment: i
	} : {
		idx: i.originalFrom + e - i.decodedFrom,
		prefix: "",
		segment: i
	} : {
		idx: g.length ? g[g.length - 1].originalTo : 0,
		prefix: "",
		segment: void 0
	};
}
function q(e, l, g) {
	if (!e) return {
		idx: 0,
		suffix: "",
		segment: void 0
	};
	let r = 0, c = g.length - 1, i;
	for (; r <= c;) {
		let n = r + c >> 1, d = g[n];
		if (e <= d.decodedFrom) c = n - 1;
		else if (e > d.decodedTo) r = n + 1;
		else {
			i = d;
			break;
		}
	}
	return i ? i.replacement ? {
		idx: i.originalTo,
		suffix: l.slice(e, i.decodedTo),
		segment: i
	} : {
		idx: i.originalFrom + e - i.decodedFrom,
		suffix: "",
		segment: i
	} : {
		idx: g.length ? g[g.length - 1].originalTo : 0,
		suffix: "",
		segment: void 0
	};
}
function Ie(e, l, g) {
	let [r, c, i] = e, n = B(r, l, g), d = q(c, l, g), E = e.length === 3;
	if (!!(n.prefix || d.suffix)) {
		let y = `${n.prefix}${i || ""}${d.suffix}`;
		return y ? [
			n.idx,
			d.idx,
			y
		] : E ? [
			n.idx,
			d.idx,
			i
		] : [n.idx, d.idx];
	}
	return E ? [
		n.idx,
		d.idx,
		i
	] : [n.idx, d.idx];
}
function Rn(e, l, g) {
	let r = {};
	return typeof e.nameStarts == "number" && (r.nameStarts = B(e.nameStarts, l, g).idx), typeof e.nameEnds == "number" && (r.nameEnds = q(e.nameEnds, l, g).idx), typeof e.equalsAt == "number" && (r.equalsAt = B(e.equalsAt, l, g).idx), typeof e.name == "string" && (r.name = e.name), typeof e.valueStarts == "number" && (r.valueStarts = B(e.valueStarts, l, g).idx), typeof e.valueEnds == "number" && (r.valueEnds = q(e.valueEnds, l, g).idx), typeof e.value == "string" && (r.value = e.value), r;
}
function Vn(e, l, g, r, c, i, n) {
	let d = B(r, i, n).idx, E = q(c, i, n).idx;
	if (l !== "tag") return {
		kind: l,
		start: d,
		end: E
	};
	let O = typeof e.name == "string" ? e.name : typeof e.nameStarts == "number" && typeof e.nameEnds == "number" ? i.slice(e.nameStarts, e.nameEnds) : "", y = typeof e.nameStarts == "number" ? B(e.nameStarts, i, n).idx : d, V = typeof e.nameEnds == "number" ? q(e.nameEnds, i, n).idx : y + O.length, I = typeof e.nameContainsLetters == "boolean" ? e.nameContainsLetters : /[A-Za-z]/.test(O);
	if (g === "inferred") return {
		kind: "tag",
		status: "inferred",
		start: d,
		end: E,
		nameStarts: y,
		nameContainsLetters: I,
		nameEnds: V,
		name: O
	};
	let N = {
		kind: "tag",
		start: d,
		end: E,
		attributes: Array.isArray(e.attributes) ? e.attributes.map((w) => Rn(w, i, n)) : [],
		slashPresent: typeof e.slashPresent == "number" ? B(e.slashPresent, i, n).idx : !1,
		leftOuterWhitespace: typeof e.leftOuterWhitespace == "number" ? B(e.leftOuterWhitespace, i, n).idx : d,
		onlyPlausible: typeof e.onlyPlausible == "boolean" ? e.onlyPlausible : !1,
		nameStarts: y,
		nameContainsLetters: I,
		nameEnds: V,
		name: O
	}, J = typeof e.lastOpeningBracketAt == "number" ? B(e.lastOpeningBracketAt, i, n).idx : d;
	if (g === "incomplete") return {
		...N,
		status: "incomplete",
		lastOpeningBracketAt: J
	};
	let s = typeof e.lastClosingBracketAt == "number" ? q(e.lastClosingBracketAt + 1, i, n).idx - 1 : E - 1;
	return {
		...N,
		status: "complete",
		lastOpeningBracketAt: J,
		lastClosingBracketAt: s
	};
}
function Nn(e) {
	let l = [...e].sort((r, c) => r[0] - c[0] || r[1] - c[1]), g = [];
	return l.forEach((r) => {
		let c = g.length ? g[g.length - 1] : void 0;
		if (c && c[1] === r[0]) {
			let i = `${c[2] || ""}${r[2] || ""}`;
			c[1] = r[1], i ? c[2] = i : c.length = 2;
		} else g.push([...r]);
	}), g.length ? g : null;
}
function xn(e, l) {
	if (!e) return l;
	let g = l || [];
	return Nn([...e.filter(([c, i]) => !g.some(([n, d]) => n < i && d > c)), ...g]);
}
function Bn(e, l, g) {
	return e.map(([r, c]) => [B(r, l, g).idx, q(c, l, g).idx]);
}
function wn(e, l) {
	if (!l) return [];
	let g = [], r = 0;
	for (let c = 0; c < e.length; c++) {
		let i = e[c], n = i[0], d = i[1];
		for (; r < l.length && l[r][1] <= n;) r += 1;
		let E = r, O = n;
		for (; E < l.length && l[E][0] <= O;) {
			if (O = Math.max(O, l[E][1]), O >= d) {
				g.push(i);
				break;
			}
			E += 1;
		}
	}
	return g;
}
function pn() {
	return new k({
		limitToBeAddedWhitespace: !0,
		limitLinebreaksCount: 2
	});
}
function Pn(e) {
	return e ? e.map((l) => [...l]) : null;
}
function Wn(e, l) {
	return e === null || l === null ? e === l : e.length === l.length && e.every((g, r) => g.length === l[r].length && g.every((c, i) => c === l[r][i]));
}
function Ln(e, l) {
	let g = pn();
	return e?.forEach((r) => {
		g.push([...r]);
	}), l && g.push([...l]), g.current();
}
function Fn(e) {
	let l = "", g = 0;
	for (let r = 0; r < e.length; r++) {
		let c = e.charCodeAt(r);
		c > 64 && c < 91 && (l += `${e.slice(g, r)}${String.fromCharCode(c + 32)}`, g = r + 1);
	}
	return g ? l + e.slice(g) : e;
}
// source/validation/validation-options.ts
var validationOptions = {
	abortEarly: false,
	allowUnknown: false,
	convert: true,
	dateFormat: "date",
	errors: {
		language: "de",
		wrap: {
			label: "",
			array: ""
		}
	},
	messages: {
		en: {
			"any.invalid": "{#invalids} are invalid values",
			"any.only": "Only {#valids} are valid values",
			"any.required": "Must not be empty",
			"any.unknown": "Must not have this value",
			"array.max": "{{#label}} must contain less than or equal to {{#limit}} items",
			"array.min": "{{#label}} must contain at least {{#limit}} items",
			"date.base": "Must be a date",
			"date.dateOnly": "Must not contain time",
			"date.format": "Must be a date",
			"date.greater": "Must be earlier than {#limit}",
			"date.less": "Must be later than {#limit}",
			"date.max": "Must be at most {#limit}",
			"date.min": "Must be at least {#limit}",
			"date.strict": "Must be a date",
			"myString.noEmojis": "Must not contain emojis",
			"number.base": "Must be a number",
			"number.greater": "Must be less than {#limit}",
			"number.infinity": "Must not be infinite",
			"number.integer": "Must be an integer",
			"number.less": "Must be greater than {#limit}",
			"number.max": "Must be at most {#limit}",
			"number.min": "Must be at least {#limit}",
			"number.multiple": "Must be divisible by {#mutliple}",
			"number.negative": "Must be negative",
			"number.positive": "Must be positive",
			"number.precision": "Must have a minimum precision of {#limit}",
			"number.unsafe": "Must not be that high",
			"object.myEmptyObject": "Must be empty",
			"passwordComplexity.lowercase": "Must contain at least one lowercase letter",
			"passwordComplexity.numeric": "Must contain at least one digit",
			"passwordComplexity.requirementCount": "Must have a minimum security level of 4",
			"passwordComplexity.symbol": "Must contain at least one symbol",
			"passwordComplexity.tooLong": "Must be at most 25 characters",
			"passwordComplexity.tooShort": "Must be at least 8 characters",
			"passwordComplexity.uppercase": "Must contain at least one uppercase letter",
			"phone.invalidFormat": "Invalid phone number format",
			"string.alphanum": "Must only contain letters and numbers",
			"string.base": "Must be a text",
			"string.creditCard": "Must be a credit card number",
			"string.email": "Must be an email address",
			"string.emailNonAscii": "Must not contain umlauts or special characters",
			"string.empty": "Must not be empty",
			"string.length": "Must be exactly {#limit} characters long",
			"string.lowercase": "Must only contain lowercase letters",
			"string.max": "Must be at most {#limit} characters",
			"string.min": "Must be at least {#limit} characters",
			"string.myColor": "Must be a color",
			"string.myPasswordConfirmation": "Must be the same as password",
			"string.myUrl": "Must be a URL",
			"string.pattern.base": "Must be filled",
			"string.trim": "Must not contain leading or trailing spaces",
			"string.uppercase": "Must only contain uppercase letters",
			"string.uri": "Must be a URI",
			"string.uriCustomScheme": "Must be a custom URI"
		},
		de: {
			"any.invalid": "{#invalids} sind ungültige Werte",
			"any.only": "Nur {#valids} sind gültige Werte",
			"any.required": "Darf nicht leer sein",
			"any.unknown": "Darf nicht diesen Wert haben",
			"array.max": "Darf höchstens {{#limit}} {if(#limit == 1, 'Eintrag', 'Einträge')} haben",
			"array.min": "Muss mindestens {{#limit}} {if(#limit == 1, 'Eintrag', 'Einträge')} haben",
			"date.base": "Muss ein Datum sein",
			"date.dateOnly": "Darf keine Zeit enthalten",
			"date.format": "Muss ein Datum sein",
			"date.greater": "Muss früher als {#limit} sein",
			"date.less": "Muss später als {#limit} sein",
			"date.max": "Darf max. {#limit} sein",
			"date.min": "Muss mind. {#limit} sein",
			"date.strict": "Muss ein Datum sein",
			"myString.noEmojis": "Darf keine Emojis enthalten",
			"number.base": "Muss eine Zahl sein",
			"number.greater": "Muss kleiner als {#limit} sein",
			"number.infinity": "Darf nicht unendlich sein",
			"number.integer": "Muss eine ganzzahlige Zahl sein",
			"number.less": "Muss größer als {#limit} sein",
			"number.max": "Darf max. {#limit} sein",
			"number.min": "Muss mind. {#limit} sein",
			"number.multiple": "Muss durch {#mutliple} teilbar sein",
			"number.negative": "Muss negativ sein",
			"number.positive": "Muss positiv sein",
			"number.precision": "Muss mind. auf {#limit} Stellen genau sein",
			"number.unsafe": "Darf nicht so hoch sein",
			"object.myEmptyObject": "Muss leer sein",
			"passwordComplexity.lowercase": "Muss mind. einen Kleinbuchstaben enthalten",
			"passwordComplexity.numeric": "Muss mind. eine Ziffer enthalten",
			"passwordComplexity.requirementCount": "Muss mind. Sicherheitsstufe 4 sicher sein",
			"passwordComplexity.symbol": "Muss mind. ein Symbol enthalten",
			"passwordComplexity.tooLong": "Darf max. 25 Zeichen enthalten",
			"passwordComplexity.tooShort": "Muss mind. 8 Zeichen enthalten",
			"passwordComplexity.uppercase": "Muss mind. einen Großbuchstaben enthalten",
			"phone.invalidFormat": "Ungültiges Telefonformat",
			"string.alphanum": "Darf nur Buchstaben und Zahlen enthalten",
			"string.base": "Muss ein Text sein",
			"string.creditCard": "Muss eine Kreditkartennummer sein",
			"string.email": "Muss eine Email-Adresse sein",
			"string.emailNonAscii": "Darf keine Umlaute oder Sonderzeichen enthalten",
			"string.empty": "Darf nicht leer sein",
			"string.length": "Muss genau {#limit} Zeichen lang sein",
			"string.lowercase": "Darf nur Kleinbuchstaben enthalten",
			"string.max": "Darf max. {#limit} Zeichen enthalten",
			"string.min": "Muss mind. {#limit} Zeichen enthalten",
			"string.myPasswordConfirmation": "Muss das gleiche wie Passwort sein",
			"string.pattern.base": "Ungültiges Format",
			"string.trim": "Darf keine leeren Zeichen drumherum enthalten",
			"string.uppercase": "Darf nur Großbuchstaben enthalten",
			"boolean.base": "Muss gesetzt sein",
			"string.uri": "Muss eine gültige URI sein",
			"string.uriCustomScheme": "URI muss eine gültige URI mit einem Schema sein, das dem Muster {{#scheme}} entspricht."
		}
	}
};
// source/validation/my-joi.ts
var MyJoi = Joi.extend((joi) => ({
	type: "myEnum",
	base: joi.string(),
	rules: {}
})).extend((joi) => ({
	type: "string",
	base: joi.string(),
	rules: {
		myNanoId: { validate(value, helpers) {
			const { value: value2, error } = joi.string().length(21).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myObjectId: { validate(value, helpers) {
			const { value: value2, error } = joi.string().min(1).max(100).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myPassword: { validate(value, helpers) {
			const { value: value2, error } = joiPasswordComplexity({
				min: 8,
				max: 25,
				lowerCase: 1,
				upperCase: 1,
				numeric: 1,
				symbol: 1,
				requirementCount: 4
			}).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myPasswordConfirmation: {
			method(password) {
				return this.$_addRule({
					name: "myPasswordConfirmation",
					args: { password }
				});
			},
			args: [{
				name: "password",
				ref: true,
				assert: () => true,
				message: "must be a ref"
			}],
			validate(value, helpers, args) {
				const { value: value2, error } = joi.string().valid(args.password).validate(value, validationOptions);
				if (error !== void 0) {
					if (error.details[0].type === "any.only") return helpers.error("string.myPasswordConfirmation");
					return helpers.error(error.details[0].type, error.details[0].context);
				}
				return value2;
			}
		}
	}
})).extend((joi) => ({
	type: "number",
	base: joi.number(),
	rules: {
		myEmployeeCount: { validate(value, helpers) {
			const { value: value2, error } = joi.number().min(1).max(1e4).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myFoundingYear: { validate(value, helpers) {
			const { value: value2, error } = joi.number().min(1700).max(2100).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myObjectId: { validate(value, helpers) {
			const { value: value2, error } = joi.number().integer().min(0).max(Number.MAX_SAFE_INTEGER).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} }
	}
})).extend((joi) => ({
	type: "date",
	base: joi.date(),
	rules: {}
})).extend((joi) => ({
	type: "object",
	base: joi.object(),
	rules: {
		myEmptyObject: { validate(value, helpers) {
			const { value: value2, error } = joi.object({}).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myFormObject: { validate(value, helpers) {
			const { value: value2, error } = joi.object({ id: joi.string().myObjectId().required() }).unknown(true).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} }
	}
})).extend((joi) => ({
	type: "myString",
	base: joi.string(),
	validate(value, helpers) {
		if (generateEmojiRegex().test(value)) return {
			value,
			errors: helpers.error("myString.noEmojis")
		};
		return { value: transformToMinimalWhiteSpaceString(value).trim() };
	},
	rules: {
		myAddressCity: { validate(value, helpers) {
			const { value: value2, error } = joi.string().min(2).max(50).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myAddressHouseNumber: { validate(value, helpers) {
			const { value: value2, error } = joi.string().min(1).max(10).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myAddressPostalCode: { validate(value, helpers) {
			const { value: value2, error } = joi.string().min(2).max(10).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myAddressStreet: { validate(value, helpers) {
			const { value: value2, error } = joi.string().min(2).max(50).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myAddressState: { validate(value, helpers) {
			const { value: value2, error } = joi.string().min(2).max(50).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myNormalizedPhone: { validate(value, helpers) {
			const formattedNumber = normalizePhoneNumber({
				phone: value,
				format: "INTERNATIONAL",
				customSpacing: true
			});
			if (!formattedNumber) return helpers.error("phone.invalidFormat");
			return formattedNumber;
		} },
		myEmailAddress: { validate(value, helpers) {
			const { value: value2, error } = joi.string().email({ tlds: { allow: false } }).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			if (/[^\x20-\x7E]/.test(value2)) return helpers.error("string.emailNonAscii");
			return value2;
		} },
		myEmailAddressAllowNonAscii: { validate(value, helpers) {
			const { value: value2, error } = joi.string().email({ tlds: { allow: false } }).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myName: { validate(value, helpers) {
			const { value: value2, error } = joi.string().min(2).max(75).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myMediumName: { validate(value, helpers) {
			const { value: value2, error } = joi.string().min(2).max(40).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myShortName: { validate(value, helpers) {
			const { value: value2, error } = joi.string().min(2).max(25).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myTinyName: { validate(value, helpers) {
			const { value: value2, error } = joi.string().min(2).max(15).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myUsername: { validate(value, helpers) {
			const { value: value2, error } = joi.string().alphanum().min(2).max(25).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myColor: { validate(value, helpers) {
			const { value: value2, error } = joi.string().regex(/^#[A-Fa-f0-9]{6}$/).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myApplicantPhaseType: { validate(value, helpers) {
			const { value: value2, error } = joi.string().valid(...Object.values(ApplicantPhaseType)).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myApplicantSourceType: { validate(value, helpers) {
			const { value: value2, error } = joi.string().valid(...Object.values(ApplicantSourceType)).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myDocumentSource: { validate(value, helpers) {
			const { value: value2, error } = joi.string().valid(...Object.values(DocumentSource)).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myDocumentType: { validate(value, helpers) {
			const { value: value2, error } = joi.string().valid(...Object.values(DocumentType)).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myJobPositionType: { validate(value, helpers) {
			const { value: value2, error } = joi.string().valid(...Object.values(JobPositionType)).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myWebhookType: { validate(value, helpers) {
			const { value: value2, error } = joi.string().valid(...Object.values(WebhookSources)).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myCareerPageStatus: { validate(value, helpers) {
			const { value: value2, error } = joi.string().valid(...Object.values(CareerPageStatus)).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		mySearchAdStatus: { validate(value, helpers) {
			const { value: value2, error } = joi.string().valid(...Object.values(SearchAdStatus)).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myJobPositionPotential: { validate(value, helpers) {
			const { value: value2, error } = joi.string().valid(...Object.values(JobPositionPotential)).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myLoginDataPlatform: { validate(value, helpers) {
			const { value: value2, error } = joi.string().valid(...Object.values(LoginDataPlatform)).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myApplicantScoreRating: { validate(value, helpers) {
			const { value: value2, error } = joi.string().valid(...Object.values(ApplicantScoreRatings)).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myHtmlSignature: { validate(value, helpers) {
			const text = An(value).result.trim();
			const { value: value2, error } = joi.string().min(10).validate(text, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} },
		myGender: { validate(value, helpers) {
			const { value: value2, error } = joi.string().valid(...Object.values(Gender)).validate(value, validationOptions);
			if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
			return value2;
		} }
	}
})).extend((joi) => ({
	type: "jsonString",
	base: joi.any(),
	messages: { "jsonString.invalid": "{{#label}} must be a valid JSON string" },
	coerce(value, helpers) {
		if (typeof value !== "string") return { value };
		try {
			return { value: JSON.parse(value) };
		} catch {
			return { errors: helpers.error("jsonString.invalid") };
		}
	}
})).extend((joi) => ({
	type: "myArray",
	base: joi.array(),
	rules: { myEmptyArray: { validate(value, helpers) {
		const { value: value2, error } = joi.array().items(MyJoi.object({})).max(0).min(0).validate(value, validationOptions);
		if (error !== void 0) return helpers.error(error.details[0].type, error.details[0].context);
		return value2;
	} } }
}));
var validateJsonString = (schema) => MyJoi.jsonString().custom((value, helpers) => {
	const { error } = schema.validate(value);
	if (error) return helpers.error("any.invalid", { message: error.message });
	return value;
});
// source/validation/base-validation-schemas.ts
var BaseValidationSchemas = class BaseValidationSchemas {
	constructor() {
		if (this.constructor === BaseValidationSchemas) throw new Error("Abstract class");
	}
};
// source/validation/validation-schema-case-set.ts
var ValidationSchemaCaseSet = class {
	queryParams;
	params;
	body;
	form;
	constructor({ queryParams = void 0, params = void 0, body = void 0, form = void 0 } = {}) {
		this.queryParams = queryParams;
		this.params = params;
		this.body = body;
		this.form = form;
	}
};
// source/validation/validation-schema-input-set.ts
var ValidationSchemaInputSet = class {
	preAuthentication;
	full;
	constructor({ preAuthentication, full } = {}) {
		this.preAuthentication = preAuthentication;
		this.full = full;
	}
};
// source/validation/applicant-automation-template-validation-schemas.ts
var ApplicantAutomationValidationTemplateSchemas = class extends BaseValidationSchemas {
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			queryParams: MyJoi.object({ onBehalfOf: MyJoi.string().valid(...Object.values(OnBehalfOf)).required() }).required()
		})
	});
	static getAll = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
};
// source/validation/customer-email-validation-schemas.ts
var CustomerEmailValidationSchemas = class CustomerEmailValidationSchemas extends BaseValidationSchemas {
	static nestedObject = MyJoi.object().pattern(MyJoi.string(), MyJoi.alternatives().try(MyJoi.string().trim().empty([
		"",
		"null",
		null
	]), MyJoi.number().empty([
		"",
		"null",
		null
	]), MyJoi.date().empty([
		"",
		"null",
		null
	]), MyJoi.boolean().empty([
		"",
		"null",
		null
	]), MyJoi.object().pattern(MyJoi.string(), MyJoi.alternatives().try(MyJoi.string().trim().empty([
		"",
		"null",
		null
	]), MyJoi.number().empty([
		"",
		"null",
		null
	]), MyJoi.date().empty([
		"",
		"null",
		null
	]), MyJoi.boolean().empty([
		"",
		"null",
		null
	]), MyJoi.object().pattern(MyJoi.string(), MyJoi.alternatives().try(MyJoi.string().trim().empty([
		"",
		"null",
		null
	]), MyJoi.number().empty([
		"",
		"null",
		null
	]), MyJoi.date().empty([
		"",
		"null",
		null
	]), MyJoi.boolean().empty([
		"",
		"null",
		null
	])).optional()).empty([
		"",
		"null",
		null
	])).optional()).empty([
		"",
		"null",
		null
	])).optional()).required();
	static sendFormSchema = MyJoi.object({
		recipient: MyJoi.myString().myEmailAddressAllowNonAscii().required(),
		body: MyJoi.string().trim().required(),
		subject: MyJoi.string().trim().required(),
		signature: MyJoi.string().trim().allow(""),
		emailProviderId: MyJoi.number().integer().required(),
		delayInBusinessDays: MyJoi.number().integer().min(0).optional(),
		applicantId: MyJoi.number().integer().optional()
	});
	static sendBodySchema = MyJoi.object({
		recipient: MyJoi.myString().myEmailAddressAllowNonAscii().required(),
		body: MyJoi.string().trim().required(),
		subject: MyJoi.string().trim().required(),
		emailProviderId: MyJoi.number().integer().required(),
		signature: MyJoi.string().trim().allow(""),
		delayInBusinessDays: MyJoi.number().integer().min(0).optional(),
		applicantId: MyJoi.number().integer().optional()
	});
	static sendTestEmail = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({
				recipient: MyJoi.myString().myEmailAddressAllowNonAscii().required(),
				emailProviderId: MyJoi.number().integer().required(),
				context: CustomerEmailValidationSchemas.nestedObject
			}).required(),
			body: MyJoi.object({
				recipient: MyJoi.myString().myEmailAddressAllowNonAscii().required(),
				emailProviderId: MyJoi.number().integer().required(),
				context: CustomerEmailValidationSchemas.nestedObject
			}).required()
		})
	});
	static send = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: CustomerEmailValidationSchemas.sendFormSchema.required(),
			body: CustomerEmailValidationSchemas.sendBodySchema.required()
		})
	});
};
// source/validation/applicant-automation-validation-schemas.ts
var ApplicantAutomationValidationSchemas = class extends BaseValidationSchemas {
	static run = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({
		form: MyJoi.object({
			applicantId: MyJoi.number().integer().required(),
			emails: MyJoi.array().items(MyJoi.object({
				emailTemplateKey: MyJoi.string().empty("").allow(null).optional(),
				emailBody: MyJoi.string().trim().empty("").allow(null).optional(),
				emailSubject: MyJoi.string().trim().empty("").allow(null).optional(),
				emailSignature: MyJoi.string().trim().empty("").allow(null).optional(),
				emailDelayInMs: MyJoi.number().integer().positive().empty("").allow(null).optional(),
				emailDelayInBusinessDays: MyJoi.number().integer().min(0).empty("").allow(null).optional(),
				applicantId: MyJoi.number().integer().positive().empty("").allow(null).optional()
			})).empty("").allow(null).optional(),
			currentState: MyJoi.string().trim().empty("").allow(null).optional(),
			phaseId: MyJoi.number().integer().positive().empty("").allow(null).optional(),
			forwardedAt: MyJoi.date().empty("").allow(null).optional(),
			declineReason: MyJoi.string().trim().empty("").allow(null).optional(),
			declineReasonRequired: MyJoi.boolean().empty("").allow(null).optional(),
			deadline: MyJoi.date().empty("").allow(null).optional(),
			markApplicantDocumentsAsRead: MyJoi.boolean().empty("").allow(null).optional(),
			customerEmail: CustomerEmailValidationSchemas.sendFormSchema,
			prequalificationStatus: MyJoi.string().valid(...Object.values(PrequalificationStatus)).empty("").allow(null).optional()
		}).required(),
		body: MyJoi.object({
			applicantId: MyJoi.number().integer().required(),
			applicantAutomationDto: MyJoi.object({
				emails: MyJoi.array().items(MyJoi.object({
					emailTemplateKey: MyJoi.string().empty("").allow(null).optional(),
					emailBody: MyJoi.string().trim().empty("").allow(null).optional(),
					emailSubject: MyJoi.string().trim().empty("").allow(null).optional(),
					emailSignature: MyJoi.string().trim().empty("").allow(null).optional(),
					emailDelayInMs: MyJoi.number().integer().positive().empty("").allow(null).optional(),
					emailDelayInBusinessDays: MyJoi.number().integer().min(0).empty("").allow(null).optional(),
					applicantId: MyJoi.number().integer().positive().empty("").allow(null).optional()
				})).empty("").allow(null).optional(),
				currentState: MyJoi.string().trim().empty("").allow(null).optional(),
				phaseId: MyJoi.number().integer().positive().empty("").allow(null).optional(),
				forwardedAt: MyJoi.date().empty("").allow(null).optional(),
				declineReason: MyJoi.string().trim().empty("").allow(null).optional(),
				declineReasonRequired: MyJoi.boolean().empty("").allow(null).optional(),
				deadline: MyJoi.date().empty("").allow(null).optional(),
				markApplicantDocumentsAsRead: MyJoi.boolean().empty("").allow(null).optional(),
				prequalificationStatus: MyJoi.string().valid(...Object.values(PrequalificationStatus)).empty("").allow(null).optional()
			}).required()
		}).required()
	}) });
};
// source/validation/applicant-document-validation-schemas.ts
var ApplicantDocumentValidationSchemas = class extends BaseValidationSchemas {
	static creation = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ applicantId: MyJoi.number().integer() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ body: MyJoi.object({
			applicantId: MyJoi.number().integer(),
			file: MyJoi.object({
				originalFilename: MyJoi.string().required(),
				mimetype: MyJoi.string().valid(...Object.values(UploadDocumentMimeTypeMap)).required(),
				size: MyJoi.number().integer().max(config.documentFileSizeLimit).required()
			}).unknown()
		}).required() })
	});
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getByApplicantId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getByShareLinkToken = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ token: MyJoi.string().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ token: MyJoi.string().required() }).required() })
	});
	static getDownloadUrl = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getDownloadAllForApplicantUrl = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getDownloadUrlByShareLinkToken = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required(),
			queryParams: MyJoi.object({ token: MyJoi.string().required() }).unknown(true)
		}),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			queryParams: MyJoi.object({ token: MyJoi.string().required() })
		})
	});
	static getPreviewUrl = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getPreviewUrlByShareLinkToken = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required(),
			queryParams: MyJoi.object({ token: MyJoi.string().required() }).unknown(true)
		}),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			queryParams: MyJoi.object({ token: MyJoi.string().required() })
		})
	});
	static getThumbnailUrl = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getThumbnailUrlByShareLinkToken = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required(),
			queryParams: MyJoi.object({ token: MyJoi.string().required() }).unknown(true)
		}),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			queryParams: MyJoi.object({ token: MyJoi.string().required() })
		})
	});
	static rename = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({ name: MyJoi.myString().myName() }).required(),
			body: MyJoi.object({ name: MyJoi.myString().myName() }).required()
		})
	});
	static removal = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static markRead = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static markAllReadForApplicant = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static markUnread = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
};
// source/validation/applicant-manager-validation-schemas.ts
var ApplicantManagerValidationSchemas = class extends BaseValidationSchemas {
	static getByFirebaseUid = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ firebaseUid: MyJoi.string().required() }).required() }),
		full: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ firebaseUid: MyJoi.string().required() }).required() })
	});
	static getCustomToken = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ firebaseUid: MyJoi.string() }).unknown(true) }),
		full: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ firebaseUid: MyJoi.string() }) })
	});
};
// source/validation/applicant-phase-validation-schemas.ts
var ApplicantPhaseValidationSchemas = class extends BaseValidationSchemas {
	static addSupported = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({
		form: MyJoi.object({
			phaseId: MyJoi.number().myObjectId().required(),
			supportedPhaseId: MyJoi.number().myObjectId().required()
		}).required(),
		body: MyJoi.object({
			phaseId: MyJoi.number().myObjectId().required(),
			supportedPhaseId: MyJoi.number().myObjectId().required()
		}).required()
	}) });
	static creation = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({
		form: MyJoi.object({
			name: MyJoi.myString().myShortName().required(),
			color: MyJoi.myString().myColor().required(),
			type: MyJoi.myString().myApplicantPhaseType().required()
		}).required(),
		body: MyJoi.object({ applicantPhaseCreationDto: MyJoi.object({
			name: MyJoi.myString().myShortName().required(),
			color: MyJoi.myString().myColor().required(),
			type: MyJoi.myString().myApplicantPhaseType().required()
		}).required() }).required()
	}) });
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getAll = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({
				name: MyJoi.myString().myShortName().required(),
				color: MyJoi.myString().myColor().required(),
				type: MyJoi.myString().myApplicantPhaseType().required()
			}).required(),
			body: MyJoi.object({ applicantPhaseUpdateDto: MyJoi.object({
				name: MyJoi.myString().myShortName().required(),
				color: MyJoi.myString().myColor().required(),
				type: MyJoi.myString().myApplicantPhaseType().required()
			}).required() }).required()
		})
	});
	static removal = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static removeSupported = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({
		form: MyJoi.object({
			phaseId: MyJoi.number().myObjectId().required(),
			supportedPhaseId: MyJoi.number().myObjectId().required()
		}).required(),
		body: MyJoi.object({
			phaseId: MyJoi.number().myObjectId().required(),
			supportedPhaseId: MyJoi.number().myObjectId().required()
		}).required()
	}) });
};
// source/validation/applicant-processing-state-validation-schemas.ts
var idParamsSchema = MyJoi.object({ id: MyJoi.string().myObjectId().required() });
var sessionBodySchema = MyJoi.object({ sessionId: MyJoi.string().trim().max(64).required() }).required();
var lockBodySchema = MyJoi.object({
	sessionId: MyJoi.string().trim().max(64).required(),
	loginFirebaseUid: MyJoi.string().trim().max(128),
	loginName: MyJoi.myString().max(200),
	loginPhotoUrl: MyJoi.string().trim().max(2e3)
}).required();
var ApplicantProcessingStateValidationSchemas = class extends BaseValidationSchemas {
	static getAllByApplicantManagerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: idParamsSchema.unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: idParamsSchema.required() })
	});
	static resolve = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: idParamsSchema.unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: idParamsSchema.required() })
	});
	static unresolve = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: idParamsSchema.unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: idParamsSchema.required() })
	});
	static lock = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: idParamsSchema.unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: idParamsSchema.required(),
			body: lockBodySchema
		})
	});
	static unlock = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: idParamsSchema.unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: idParamsSchema.required(),
			body: sessionBodySchema
		})
	});
};
// source/validation/applicant-score-validation-schemas.ts
var ApplicantScoreValidationSchemas = class extends BaseValidationSchemas {
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getForApplicant = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({
			applicantId: MyJoi.number().required(),
			jobPositionId: MyJoi.number().required()
		}).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({
			applicantId: MyJoi.number().required(),
			jobPositionId: MyJoi.number().required()
		}).unknown(true).required() })
	});
	static create = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ applicantScoreCreationDto: MyJoi.object({
			applicantId: MyJoi.number().integer().required(),
			scoreCardId: MyJoi.number().integer().required()
		}).unknown(true).required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				applicantId: MyJoi.number().integer().required(),
				scoreCardId: MyJoi.number().integer().required(),
				rating: MyJoi.myString().myApplicantScoreRating().empty("").default(null).allow(null),
				notes: MyJoi.string().trim().empty("").default(null).allow(null)
			}),
			body: MyJoi.object({ applicantScoreCreationDto: MyJoi.object({
				applicantId: MyJoi.number().integer().required(),
				scoreCardId: MyJoi.number().integer().required(),
				rating: MyJoi.myString().myApplicantScoreRating().allow(null),
				notes: MyJoi.string().trim().allow(null)
			}).required() }).required()
		})
	});
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				rating: MyJoi.myString().myApplicantScoreRating().empty("").default(null).allow(null),
				notes: MyJoi.string().trim().empty("").default(null).allow(null)
			}),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			body: MyJoi.object({ applicantScoreUpdateDto: MyJoi.object({
				rating: MyJoi.myString().myApplicantScoreRating().allow(null),
				notes: MyJoi.string().trim().allow(null)
			}).required() }).required()
		})
	});
	static upsert = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.alternatives(MyJoi.object({ applicantScoreUpsertDto: MyJoi.object({ id: MyJoi.number().integer().required() }).unknown(true).required() }).unknown(true).required(), MyJoi.object({ applicantScoreUpsertDto: MyJoi.object({
			applicantId: MyJoi.number().integer().required(),
			scoreCardId: MyJoi.number().integer().required()
		}).unknown(true).required() }).unknown(true).required()) }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.alternatives(MyJoi.object({
				id: MyJoi.number().integer().required(),
				applicantId: MyJoi.number().integer(),
				scoreCardId: MyJoi.number().integer(),
				rating: MyJoi.myString().myApplicantScoreRating().empty(["", "null"]).default(null).allow(null),
				notes: MyJoi.string().trim().empty("").default(null).allow(null)
			}), MyJoi.object({
				applicantId: MyJoi.number().integer().required(),
				scoreCardId: MyJoi.number().integer().required(),
				rating: MyJoi.myString().myApplicantScoreRating().empty("").default(null).allow(null),
				notes: MyJoi.string().trim().empty("").default(null).allow(null)
			})),
			body: MyJoi.alternatives(MyJoi.object({ applicantScoreUpsertDto: MyJoi.object({
				id: MyJoi.number().integer().required(),
				applicantId: MyJoi.number().integer(),
				scoreCardId: MyJoi.number().integer(),
				rating: MyJoi.myString().myApplicantScoreRating().allow(null),
				notes: MyJoi.string().trim().allow(null)
			}).required() }).required(), MyJoi.object({ applicantScoreUpsertDto: MyJoi.object({
				applicantId: MyJoi.number().integer().required(),
				scoreCardId: MyJoi.number().integer().required(),
				rating: MyJoi.myString().myApplicantScoreRating().allow(null),
				notes: MyJoi.string().trim().allow(null)
			}).required() }).required())
		})
	});
	static remove = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
};
// source/validation/applicant-source-validation-schemas.ts
var ApplicantSourceValidationSchemas = class extends BaseValidationSchemas {
	static creation = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({
		form: MyJoi.object({
			name: MyJoi.myString().myShortName().required(),
			color: MyJoi.myString().myColor().required(),
			type: MyJoi.myString().myApplicantSourceType().required()
		}).required(),
		body: MyJoi.object({ applicantSourceCreationDto: MyJoi.object({
			name: MyJoi.myString().myShortName().required(),
			color: MyJoi.myString().myColor().required(),
			type: MyJoi.myString().myApplicantSourceType().required()
		}).required() }).required()
	}) });
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getAll = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({
				name: MyJoi.myString().myShortName().required(),
				color: MyJoi.myString().myColor().required(),
				type: MyJoi.myString().myApplicantSourceType().required()
			}).required(),
			body: MyJoi.object({ applicantSourceUpdateDto: MyJoi.object({
				name: MyJoi.myString().myShortName().required(),
				color: MyJoi.myString().myColor().required(),
				type: MyJoi.myString().myApplicantSourceType().required()
			}).required() }).required()
		})
	});
	static removal = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
};
// source/validation/applicant-status-update-validation-schemas.ts
var ApplicantStatusUpdateValidationSchemas = class extends BaseValidationSchemas {
	static getForApplicant = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ applicantId: MyJoi.number().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ applicantId: MyJoi.number().required() }).unknown(true).required() })
	});
	static create = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ applicantStatusUpdateCreationDto: MyJoi.object({ applicantId: MyJoi.number().integer().required() }).unknown(true).required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				applicantId: MyJoi.number().integer().required(),
				content: MyJoi.string().trim().required(),
				hasFollowUp: MyJoi.boolean().optional(),
				followUpDate: MyJoi.alternatives().conditional("hasFollowUp", {
					is: true,
					then: MyJoi.date().required(),
					otherwise: MyJoi.date().empty("").default(null).allow(null)
				}),
				followUpContent: MyJoi.alternatives().conditional("hasFollowUp", {
					is: true,
					then: MyJoi.string().trim().required(),
					otherwise: MyJoi.string().trim().empty("").default(null).allow(null)
				})
			}),
			body: MyJoi.object({ applicantStatusUpdateCreationDto: MyJoi.object({
				applicantId: MyJoi.number().integer().required(),
				content: MyJoi.string().trim().required(),
				followUpDate: MyJoi.date().allow(null),
				followUpContent: MyJoi.string().trim().allow(null)
			}).and("followUpDate", "followUpContent").required() }).required()
		})
	});
	static getGuaranteeForfeitureEmail = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.number().integer().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.number().integer().required() }).required() })
	});
	static sendGuaranteeForfeitureEmail = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.number().integer().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.number().integer().required() }).required() })
	});
};
// source/validation/applicant-validation-schemas.ts
var ApplicantValidationSchemas = class extends BaseValidationSchemas {
	static archive = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static restore = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static markCustomerNoteCommentsAsRead = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static creation = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ jobPositionId: MyJoi.number().integer().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				name: MyJoi.myString().myName().required(),
				jobPositionId: MyJoi.number().integer().empty("").required(),
				phaseId: MyJoi.number().integer().empty("").required(),
				currentState: MyJoi.string().trim().empty("").default(null).allow(null),
				profile: MyJoi.string().empty("").default(null).allow(null),
				sourceId: MyJoi.number().integer().empty(""),
				sourcePlatformId: MyJoi.number().empty("").integer(),
				sourceCampaign: MyJoi.string().empty("").default(null).allow(null),
				sourceMedium: MyJoi.string().empty("").default(null).allow(null),
				sourceKeyword: MyJoi.string().empty("").default(null).allow(null),
				declineReason: MyJoi.string().trim().empty("").default(null).allow(null),
				emailAddress: MyJoi.string().trim().empty("").default(null).allow(null),
				phoneNumber: MyJoi.myString().myNormalizedPhone().empty("").default(null).allow(null),
				deadline: MyJoi.date().empty("").default(null).allow(null),
				landingPageVersion: MyJoi.string().empty("").default(null).allow(null),
				forwardedAt: MyJoi.date().empty("").default(null).allow(null),
				receivedAt: MyJoi.date().empty(""),
				customerNotes: MyJoi.string().trim().empty("").default(null).allow(null),
				files: MyJoi.array().items(MyJoi.any()).single()
			}).required(),
			body: MyJoi.object({
				name: MyJoi.myString().myName().required(),
				jobPositionId: MyJoi.number().integer().required(),
				phaseId: MyJoi.number().integer().required(),
				currentState: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
				profile: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
				sourceId: MyJoi.number().integer(),
				sourcePlatformId: MyJoi.number().integer(),
				sourceCampaign: MyJoi.string().empty(["", "null"]).default(null).allow(null),
				sourceMedium: MyJoi.string().empty(["", "null"]).default(null).allow(null),
				sourceKeyword: MyJoi.string().empty(["", "null"]).default(null).allow(null),
				declineReason: MyJoi.string().empty(["", "null"]).default(null).allow(null),
				emailAddress: MyJoi.string().empty(["", "null"]).default(null).allow(null),
				phoneNumber: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
				deadline: MyJoi.date().empty(["", "null"]).default(null).allow(null),
				landingPageVersion: MyJoi.string().empty(["", "null"]).default(null).allow(null),
				forwardedAt: MyJoi.date().empty(["", "null"]).default(null).allow(null),
				receivedAt: MyJoi.date().empty(["", "null"]),
				customerNotes: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
				files: MyJoi.array().items(MyJoi.object({
					originalFilename: MyJoi.string().required(),
					mimetype: MyJoi.string().valid(...Object.values(UploadDocumentMimeTypeMap)).required(),
					size: MyJoi.number().integer().max(config.documentFileSizeLimit).required()
				}).unknown(true)).single()
			}).required()
		})
	});
	static upload = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ jobPositionId: MyJoi.number().integer().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				jobPositionId: MyJoi.number().integer().required(),
				applicants: MyJoi.array().items(MyJoi.object({
					name: MyJoi.myString().myName().required().label("Name"),
					phaseName: MyJoi.string().required().label("Phase"),
					currentState: MyJoi.string().trim().empty("").label("Aktueller Stand"),
					profile: MyJoi.string().trim().empty("").label("Profil"),
					sourceName: MyJoi.string().required().empty("").label("Quelle"),
					sourcePlatformName: MyJoi.string().empty("").label("Platform"),
					sourceCampaign: MyJoi.string().empty("").label("Kampagne"),
					sourceMedium: MyJoi.string().empty("").label("Medium"),
					sourceKeyword: MyJoi.string().empty("").label("Keyword"),
					declineReason: MyJoi.string().trim().empty("").label("Absagegrund"),
					emailAddress: MyJoi.string().trim().empty("").label("Email"),
					phoneNumber: MyJoi.myString().myNormalizedPhone().empty("").label("Telefon"),
					deadline: MyJoi.date().empty("").label("Deadline"),
					landingPageVersion: MyJoi.string().empty("").label("Landingpage Version"),
					forwardedAt: MyJoi.date().empty("").label("Weitergeleitet am"),
					receivedAt: MyJoi.date().empty("").label("Bewerbereingang"),
					fileUrls: MyJoi.string().empty("").label("Dokumente"),
					prequalificationStatus: MyJoi.string().valid(...Object.values(PrequalificationStatus)).empty(["", "null"]).default(null).allow(null)
				}).label("Bewerber")).required().label("Bewerberliste")
			}).required(),
			body: MyJoi.object({
				jobPositionId: MyJoi.number().integer().required(),
				applicants: MyJoi.array().items(MyJoi.object({
					name: MyJoi.myString().myName().required(),
					phaseName: MyJoi.string().required(),
					currentState: MyJoi.string().trim(),
					profile: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
					sourceName: MyJoi.string().required(),
					sourcePlatformName: MyJoi.string().empty(["", "null"]).default(null).allow(null),
					sourceCampaign: MyJoi.string().empty(["", "null"]).default(null).allow(null),
					sourceMedium: MyJoi.string().empty(["", "null"]).default(null).allow(null),
					sourceKeyword: MyJoi.string().empty(["", "null"]).default(null).allow(null),
					declineReason: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
					emailAddress: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
					phoneNumber: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
					deadline: MyJoi.date().allow(null).empty(["", "null"]).default(null).allow(null),
					landingPageVersion: MyJoi.string().empty(["", "null"]).default(null).allow(null),
					forwardedAt: MyJoi.date().empty(["", "null"]).default(null).allow(null),
					receivedAt: MyJoi.date().empty(["", "null"]),
					fileUrls: MyJoi.array().items(MyJoi.string().uri({ scheme: ["http", "https"] })),
					prequalificationStatus: MyJoi.string().valid(...Object.values(PrequalificationStatus)).empty(["", "null"]).default(null).allow(null)
				}).required()).required()
			}).required()
		})
	});
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getByShareLinkToken = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ token: MyJoi.string().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ token: MyJoi.string().required() }).required() })
	});
	static find = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({
			search: MyJoi.string().min(3).required(),
			exact: MyJoi.boolean()
		}).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({
			search: MyJoi.string().min(3).required(),
			exact: MyJoi.boolean()
		}) })
	});
	static getByJobId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getAll = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({
			archived: MyJoi.string(),
			limit: MyJoi.number().integer().min(1),
			offset: MyJoi.number().integer().min(0)
		}).unknown(true) }),
		full: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({
			archived: MyJoi.string(),
			limit: MyJoi.number().integer().min(1),
			offset: MyJoi.number().integer().min(0)
		}) })
	});
	static getAllByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			queryParams: MyJoi.object({
				archived: MyJoi.string(),
				excludedPhaseTypes: MyJoi.string(),
				phaseType: MyJoi.string(),
				limit: MyJoi.number().integer().min(1),
				jobPositionIds: MyJoi.string(),
				receivedAtStart: MyJoi.date(),
				receivedAtEnd: MyJoi.date(),
				prequalified: MyJoi.boolean(),
				sourceCampaigns: MyJoi.string(),
				landingPageVersions: MyJoi.string(),
				receivedOrForwardedSince: MyJoi.date(),
				filterValue: MyJoi.string()
			}).unknown(true),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required()
		}),
		full: new ValidationSchemaCaseSet({
			queryParams: MyJoi.object({
				archived: MyJoi.string(),
				excludedPhaseTypes: MyJoi.string(),
				phaseType: MyJoi.string(),
				limit: MyJoi.number().integer().min(1),
				jobPositionIds: MyJoi.string(),
				receivedAtStart: MyJoi.date(),
				receivedAtEnd: MyJoi.date(),
				prequalified: MyJoi.boolean(),
				sourceCampaigns: MyJoi.string(),
				landingPageVersions: MyJoi.string(),
				receivedOrForwardedSince: MyJoi.date(),
				filterValue: MyJoi.string()
			}),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required()
		})
	});
	static getEndPhaseByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			queryParams: MyJoi.object({
				archived: MyJoi.string(),
				excludedPhaseTypes: MyJoi.string(),
				phaseType: MyJoi.string(),
				limit: MyJoi.number().integer().min(1),
				jobPositionIds: MyJoi.string(),
				receivedAtStart: MyJoi.date(),
				receivedAtEnd: MyJoi.date(),
				prequalified: MyJoi.boolean(),
				sourceCampaigns: MyJoi.string(),
				landingPageVersions: MyJoi.string(),
				filterValue: MyJoi.string(),
				showInternalPhases: MyJoi.boolean()
			}).unknown(true),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required()
		}),
		full: new ValidationSchemaCaseSet({
			queryParams: MyJoi.object({
				archived: MyJoi.string(),
				excludedPhaseTypes: MyJoi.string(),
				phaseType: MyJoi.string(),
				limit: MyJoi.number().integer().min(1),
				jobPositionIds: MyJoi.string(),
				receivedAtStart: MyJoi.date(),
				receivedAtEnd: MyJoi.date(),
				prequalified: MyJoi.boolean(),
				sourceCampaigns: MyJoi.string(),
				landingPageVersions: MyJoi.string(),
				filterValue: MyJoi.string(),
				showInternalPhases: MyJoi.boolean()
			}),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required()
		})
	});
	static getCountByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			queryParams: MyJoi.object({
				phaseType: MyJoi.string(),
				jobPositionIds: MyJoi.string(),
				receivedAtStart: MyJoi.date(),
				receivedAtEnd: MyJoi.date(),
				forwardedAtStart: MyJoi.date(),
				forwardedAtEnd: MyJoi.date(),
				prequalified: MyJoi.boolean(),
				guaranteeCandidatesOnly: MyJoi.boolean(),
				sourceCampaigns: MyJoi.string(),
				landingPageVersions: MyJoi.string(),
				filterValue: MyJoi.string()
			}).unknown(true),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required()
		}),
		full: new ValidationSchemaCaseSet({
			queryParams: MyJoi.object({
				phaseType: MyJoi.string(),
				jobPositionIds: MyJoi.string(),
				receivedAtStart: MyJoi.date(),
				receivedAtEnd: MyJoi.date(),
				forwardedAtStart: MyJoi.date(),
				forwardedAtEnd: MyJoi.date(),
				prequalified: MyJoi.boolean(),
				guaranteeCandidatesOnly: MyJoi.boolean(),
				sourceCampaigns: MyJoi.string(),
				landingPageVersions: MyJoi.string(),
				filterValue: MyJoi.string()
			}),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required()
		})
	});
	static getCampaignsByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getLandingPageVersionsByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getAllByApplicantManagerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			queryParams: MyJoi.object({
				archived: MyJoi.string(),
				phaseType: MyJoi.string().valid(...Object.values(ApplicantPhaseType))
			}).unknown(true),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required()
		}),
		full: new ValidationSchemaCaseSet({
			queryParams: MyJoi.object({
				archived: MyJoi.string(),
				phaseType: MyJoi.string().valid(...Object.values(ApplicantPhaseType))
			}),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required()
		})
	});
	static getAllDuplicatedByApplicantManagerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			queryParams: MyJoi.object({ archived: MyJoi.string() }).unknown(true),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required()
		}),
		full: new ValidationSchemaCaseSet({
			queryParams: MyJoi.object({ archived: MyJoi.string() }),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required()
		})
	});
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				name: MyJoi.myString().myName().empty(""),
				jobPositionId: MyJoi.number().integer().empty(""),
				phaseId: MyJoi.number().integer().empty(""),
				currentState: MyJoi.string().trim().empty("").default(null).allow(null),
				profile: MyJoi.string().trim().empty("").default(null).allow(null),
				sourceId: MyJoi.number().integer().empty(""),
				sourcePlatformId: MyJoi.number().empty("").integer(),
				sourceCampaign: MyJoi.string().empty("").default(null).allow(null),
				sourceMedium: MyJoi.string().empty("").default(null).allow(null),
				sourceKeyword: MyJoi.string().empty("").default(null).allow(null),
				declineReason: MyJoi.string().trim().empty("").default(null).allow(null),
				emailAddress: MyJoi.string().trim().empty("").default(null).allow(null),
				phoneNumber: MyJoi.myString().myNormalizedPhone().empty("").default(null).allow(null),
				deadline: MyJoi.date().empty("").default(null).allow(null),
				landingPageVersion: MyJoi.string().empty("").default(null).allow(null),
				forwardedAt: MyJoi.date().empty("").default(null).allow(null),
				receivedAt: MyJoi.date().empty(""),
				customerNotes: MyJoi.string().trim().empty("").default(null).allow(null),
				prequalificationStatus: MyJoi.string().valid(...Object.values(PrequalificationStatus)).empty(["", "null"]).allow(null)
			}),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			body: MyJoi.object({ applicantUpdateDto: MyJoi.object({
				name: MyJoi.myString().myName().empty(""),
				jobPositionId: MyJoi.number().integer().empty(""),
				phaseId: MyJoi.number().integer().empty(""),
				currentState: MyJoi.string().trim().empty("").allow(null),
				profile: MyJoi.string().trim().empty("").allow(null),
				sourceId: MyJoi.number().integer().empty(""),
				sourcePlatformId: MyJoi.number().integer().empty(""),
				sourceCampaign: MyJoi.string().empty("").allow(null),
				sourceMedium: MyJoi.string().empty("").allow(null),
				sourceKeyword: MyJoi.string().empty("").allow(null),
				declineReason: MyJoi.string().trim().empty("").allow(null),
				emailAddress: MyJoi.string().trim().empty("").allow(null),
				phoneNumber: MyJoi.string().trim().empty("").allow(null),
				deadline: MyJoi.date().empty("").allow(null),
				landingPageVersion: MyJoi.string().empty("").allow(null),
				forwardedAt: MyJoi.date().empty("").allow(null),
				receivedAt: MyJoi.date().empty(""),
				customerNotes: MyJoi.string().trim().empty("").allow(null),
				hasCustomerNoteComments: MyJoi.boolean().empty("").allow(null),
				prequalificationStatus: MyJoi.string().valid(...Object.values(PrequalificationStatus)).empty(["", "null"]).allow(null)
			}).required() }).required()
		})
	});
	static comment = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				comment: MyJoi.string().empty(""),
				commenterName: MyJoi.string().empty(""),
				hasCustomerNoteComments: MyJoi.boolean()
			}),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			body: MyJoi.object({ applicantUpdateDto: MyJoi.object({
				customerNotes: MyJoi.string().trim().empty("").allow(null),
				hasCustomerNoteComments: MyJoi.boolean().empty("").allow(null)
			}).required() }).required()
		})
	});
	static updateByShareLinkToken = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ token: MyJoi.string().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({ customerNotes: MyJoi.string().trim().empty("").default(null).allow(null) }),
			params: MyJoi.object({ token: MyJoi.string().required() }).required(),
			body: MyJoi.object({ applicantUpdateDto: MyJoi.object({
				customerNotes: MyJoi.string().trim().empty("").allow(null),
				hasCustomerNoteComments: MyJoi.boolean().empty("").allow(null)
			}).required() }).required()
		})
	});
	static updatePersonalInfo = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ token: MyJoi.string().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				name: MyJoi.myString().myName().empty(""),
				emailAddress: MyJoi.string().trim().empty("").default(null).allow(null),
				phoneNumber: MyJoi.myString().myNormalizedPhone().empty("").default(null).allow(null)
			}),
			params: MyJoi.object({ token: MyJoi.string().required() }).required(),
			body: MyJoi.object({ applicantPersonalInfoUpdateDto: MyJoi.object({
				name: MyJoi.myString().myName().empty(""),
				emailAddress: MyJoi.string().trim().empty("").allow(null),
				phoneNumber: MyJoi.string().trim().empty("").allow(null)
			}).required() }).required()
		})
	});
	static removal = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
};
// source/validation/blocked-applicant-validation-schemas.ts
var BlockedApplicantValidationSchemas = class extends BaseValidationSchemas {
	static creation = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({
		form: MyJoi.alternatives().try(MyJoi.object({
			normalizedPhoneNumber: MyJoi.myString().required(),
			email: MyJoi.myString().allow(null).empty("").default(null),
			reason: MyJoi.string().trim().allow(null).empty("").default(null)
		}), MyJoi.object({
			normalizedPhoneNumber: MyJoi.myString().allow(null).empty("").default(null),
			email: MyJoi.myString().required(),
			reason: MyJoi.string().trim().allow(null).empty("").default(null)
		}), MyJoi.object({
			normalizedPhoneNumber: MyJoi.myString().required(),
			email: MyJoi.myString().required(),
			reason: MyJoi.string().trim().allow(null).empty("").default(null)
		})),
		body: MyJoi.object({ blockedApplicantCreationDto: MyJoi.alternatives().try(MyJoi.object({
			normalizedPhoneNumber: MyJoi.myString().required(),
			email: MyJoi.myString().allow(null).empty("").default(null),
			reason: MyJoi.string().trim().allow(null).empty("").default(null)
		}), MyJoi.object({
			normalizedPhoneNumber: MyJoi.myString().allow(null).empty("").default(null),
			email: MyJoi.myString().required(),
			reason: MyJoi.string().trim().allow(null).empty("").default(null)
		}), MyJoi.object({
			normalizedPhoneNumber: MyJoi.myString().required(),
			email: MyJoi.myString().required(),
			reason: MyJoi.string().trim().allow(null).empty("").default(null)
		})) }).required()
	}) });
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getAll = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({
				normalizedPhoneNumber: MyJoi.myString(),
				email: MyJoi.myString(),
				reason: MyJoi.myString()
			}).or("normalizedPhoneNumber", "email").required(),
			body: MyJoi.object({ blockedApplicantUpdateDto: MyJoi.object({
				normalizedPhoneNumber: MyJoi.myString(),
				email: MyJoi.myString(),
				reason: MyJoi.myString()
			}).or("normalizedPhoneNumber", "email").required() }).required()
		})
	});
	static removal = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
};
// source/validation/career-domain-validation-schemas.ts
var CareerDomainValidationSchemas = class extends BaseValidationSchemas {
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static create = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ careerDomainCreationDto: MyJoi.object({ customerId: MyJoi.number().integer().required() }).unknown(true).required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({ domain: MyJoi.string().replace(/^www\./, "").domain().required() }).required(),
			body: MyJoi.object({ careerDomainCreationDto: MyJoi.object({
				customerId: MyJoi.number().integer().required(),
				domain: MyJoi.string().pattern(/^www\./, {
					name: "no-www-prefix",
					invert: true
				}).domain().required()
			}).required() }).required()
		})
	});
	static remove = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
};
// source/validation/career-page-validation-schemas.ts
var CareerPageValidationSchemas = class extends BaseValidationSchemas {
	static check = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static needsPublishing = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static generate = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ customerId: MyJoi.number().myObjectId().required() }).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({ body: MyJoi.object({ customerId: MyJoi.number().myObjectId().required() }).required() }).required(),
			body: MyJoi.object({ customerId: MyJoi.number().myObjectId().required() }).required()
		})
	});
};
// ../../node_modules/drizzle-orm/entity.js
var entityKind = Symbol.for("drizzle:entityKind");
function is(value, type) {
	if (!value || typeof value !== "object") return false;
	if (value instanceof type) return true;
	if (!Object.prototype.hasOwnProperty.call(type, entityKind)) throw new Error(`Class "${type.name ?? "<unknown>"}" doesn't look like a Drizzle entity. If this is incorrect and the class is provided by Drizzle, please report this as a bug.`);
	let cls = Object.getPrototypeOf(value).constructor;
	if (cls) while (cls) {
		if (entityKind in cls && cls[entityKind] === type[entityKind]) return true;
		cls = Object.getPrototypeOf(cls);
	}
	return false;
}
// ../../node_modules/drizzle-orm/column.js
var Column = class {
	constructor(table, config) {
		this.table = table;
		this.config = config;
		this.name = config.name;
		this.keyAsName = config.keyAsName;
		this.notNull = config.notNull;
		this.default = config.default;
		this.defaultFn = config.defaultFn;
		this.onUpdateFn = config.onUpdateFn;
		this.hasDefault = config.hasDefault;
		this.primary = config.primaryKey;
		this.isUnique = config.isUnique;
		this.uniqueName = config.uniqueName;
		this.uniqueType = config.uniqueType;
		this.dataType = config.dataType;
		this.columnType = config.columnType;
		this.generated = config.generated;
		this.generatedIdentity = config.generatedIdentity;
	}
	static [entityKind] = "Column";
	name;
	keyAsName;
	primary;
	notNull;
	default;
	defaultFn;
	onUpdateFn;
	hasDefault;
	isUnique;
	uniqueName;
	uniqueType;
	dataType;
	columnType;
	enumValues = void 0;
	generated = void 0;
	generatedIdentity = void 0;
	config;
	mapFromDriverValue(value) {
		return value;
	}
	mapToDriverValue(value) {
		return value;
	}
	shouldDisableInsert() {
		return this.config.generated !== void 0 && this.config.generated.type !== "byDefault";
	}
};
// ../../node_modules/drizzle-orm/column-builder.js
var ColumnBuilder = class {
	static [entityKind] = "ColumnBuilder";
	config;
	constructor(name, dataType, columnType) {
		this.config = {
			name,
			keyAsName: name === "",
			notNull: false,
			default: void 0,
			hasDefault: false,
			primaryKey: false,
			isUnique: false,
			uniqueName: void 0,
			uniqueType: void 0,
			dataType,
			columnType,
			generated: void 0
		};
	}
	/**
	* Changes the data type of the column. Commonly used with `json` columns. Also, useful for branded types.
	*
	* @example
	* ```ts
	* const users = pgTable('users', {
	* 	id: integer('id').$type<UserId>().primaryKey(),
	* 	details: json('details').$type<UserDetails>().notNull(),
	* });
	* ```
	*/
	$type() {
		return this;
	}
	/**
	* Adds a `not null` clause to the column definition.
	*
	* Affects the `select` model of the table - columns *without* `not null` will be nullable on select.
	*/
	notNull() {
		this.config.notNull = true;
		return this;
	}
	/**
	* Adds a `default <value>` clause to the column definition.
	*
	* Affects the `insert` model of the table - columns *with* `default` are optional on insert.
	*
	* If you need to set a dynamic default value, use {@link $defaultFn} instead.
	*/
	default(value) {
		this.config.default = value;
		this.config.hasDefault = true;
		return this;
	}
	/**
	* Adds a dynamic default value to the column.
	* The function will be called when the row is inserted, and the returned value will be used as the column value.
	*
	* **Note:** This value does not affect the `drizzle-kit` behavior, it is only used at runtime in `drizzle-orm`.
	*/
	$defaultFn(fn) {
		this.config.defaultFn = fn;
		this.config.hasDefault = true;
		return this;
	}
	/**
	* Alias for {@link $defaultFn}.
	*/
	$default = this.$defaultFn;
	/**
	* Adds a dynamic update value to the column.
	* The function will be called when the row is updated, and the returned value will be used as the column value if none is provided.
	* If no `default` (or `$defaultFn`) value is provided, the function will be called when the row is inserted as well, and the returned value will be used as the column value.
	*
	* **Note:** This value does not affect the `drizzle-kit` behavior, it is only used at runtime in `drizzle-orm`.
	*/
	$onUpdateFn(fn) {
		this.config.onUpdateFn = fn;
		this.config.hasDefault = true;
		return this;
	}
	/**
	* Alias for {@link $onUpdateFn}.
	*/
	$onUpdate = this.$onUpdateFn;
	/**
	* Adds a `primary key` clause to the column definition. This implicitly makes the column `not null`.
	*
	* In SQLite, `integer primary key` implicitly makes the column auto-incrementing.
	*/
	primaryKey() {
		this.config.primaryKey = true;
		this.config.notNull = true;
		return this;
	}
	/** @internal Sets the name of the column to the key within the table definition if a name was not given. */
	setName(name) {
		if (this.config.name !== "") return;
		this.config.name = name;
	}
};
// ../../node_modules/drizzle-orm/table.utils.js
var TableName = Symbol.for("drizzle:Name");
// ../../node_modules/drizzle-orm/pg-core/foreign-keys.js
var ForeignKeyBuilder = class {
	static [entityKind] = "PgForeignKeyBuilder";
	/** @internal */
	reference;
	/** @internal */
	_onUpdate = "no action";
	/** @internal */
	_onDelete = "no action";
	constructor(config, actions) {
		this.reference = () => {
			const { name, columns, foreignColumns } = config();
			return {
				name,
				columns,
				foreignTable: foreignColumns[0].table,
				foreignColumns
			};
		};
		if (actions) {
			this._onUpdate = actions.onUpdate;
			this._onDelete = actions.onDelete;
		}
	}
	onUpdate(action) {
		this._onUpdate = action === void 0 ? "no action" : action;
		return this;
	}
	onDelete(action) {
		this._onDelete = action === void 0 ? "no action" : action;
		return this;
	}
	/** @internal */
	build(table) {
		return new ForeignKey(table, this);
	}
};
var ForeignKey = class {
	constructor(table, builder) {
		this.table = table;
		this.reference = builder.reference;
		this.onUpdate = builder._onUpdate;
		this.onDelete = builder._onDelete;
	}
	static [entityKind] = "PgForeignKey";
	reference;
	onUpdate;
	onDelete;
	getName() {
		const { name, columns, foreignColumns } = this.reference();
		const columnNames = columns.map((column) => column.name);
		const foreignColumnNames = foreignColumns.map((column) => column.name);
		const chunks = [
			this.table[TableName],
			...columnNames,
			foreignColumns[0].table[TableName],
			...foreignColumnNames
		];
		return name ?? `${chunks.join("_")}_fk`;
	}
};
// ../../node_modules/drizzle-orm/tracing-utils.js
function iife(fn, ...args) {
	return fn(...args);
}
// ../../node_modules/drizzle-orm/pg-core/unique-constraint.js
function unique(name) {
	return new UniqueOnConstraintBuilder(name);
}
function uniqueKeyName(table, columns) {
	return `${table[TableName]}_${columns.join("_")}_unique`;
}
var UniqueConstraintBuilder = class {
	constructor(columns, name) {
		this.name = name;
		this.columns = columns;
	}
	static [entityKind] = "PgUniqueConstraintBuilder";
	/** @internal */
	columns;
	/** @internal */
	nullsNotDistinctConfig = false;
	nullsNotDistinct() {
		this.nullsNotDistinctConfig = true;
		return this;
	}
	/** @internal */
	build(table) {
		return new UniqueConstraint(table, this.columns, this.nullsNotDistinctConfig, this.name);
	}
};
var UniqueOnConstraintBuilder = class {
	static [entityKind] = "PgUniqueOnConstraintBuilder";
	/** @internal */
	name;
	constructor(name) {
		this.name = name;
	}
	on(...columns) {
		return new UniqueConstraintBuilder(columns, this.name);
	}
};
var UniqueConstraint = class {
	constructor(table, columns, nullsNotDistinct, name) {
		this.table = table;
		this.columns = columns;
		this.name = name ?? uniqueKeyName(this.table, this.columns.map((column) => column.name));
		this.nullsNotDistinct = nullsNotDistinct;
	}
	static [entityKind] = "PgUniqueConstraint";
	columns;
	name;
	nullsNotDistinct = false;
	getName() {
		return this.name;
	}
};
// ../../node_modules/drizzle-orm/pg-core/utils/array.js
function parsePgArrayValue(arrayString, startFrom, inQuotes) {
	for (let i = startFrom; i < arrayString.length; i++) {
		const char = arrayString[i];
		if (char === "\\") {
			i++;
			continue;
		}
		if (char === "\"") return [arrayString.slice(startFrom, i).replace(/\\/g, ""), i + 1];
		if (inQuotes) continue;
		if (char === "," || char === "}") return [arrayString.slice(startFrom, i).replace(/\\/g, ""), i];
	}
	return [arrayString.slice(startFrom).replace(/\\/g, ""), arrayString.length];
}
function parsePgNestedArray(arrayString, startFrom = 0) {
	const result = [];
	let i = startFrom;
	let lastCharIsComma = false;
	while (i < arrayString.length) {
		const char = arrayString[i];
		if (char === ",") {
			if (lastCharIsComma || i === startFrom) result.push("");
			lastCharIsComma = true;
			i++;
			continue;
		}
		lastCharIsComma = false;
		if (char === "\\") {
			i += 2;
			continue;
		}
		if (char === "\"") {
			const [value2, startFrom2] = parsePgArrayValue(arrayString, i + 1, true);
			result.push(value2);
			i = startFrom2;
			continue;
		}
		if (char === "}") return [result, i + 1];
		if (char === "{") {
			const [value2, startFrom2] = parsePgNestedArray(arrayString, i + 1);
			result.push(value2);
			i = startFrom2;
			continue;
		}
		const [value, newStartFrom] = parsePgArrayValue(arrayString, i, false);
		result.push(value);
		i = newStartFrom;
	}
	return [result, i];
}
function parsePgArray(arrayString) {
	const [result] = parsePgNestedArray(arrayString, 1);
	return result;
}
function makePgArray(array) {
	return `{${array.map((item) => {
		if (Array.isArray(item)) return makePgArray(item);
		if (typeof item === "string") return `"${item.replace(/\\/g, "\\\\").replace(/"/g, "\\\"")}"`;
		return `${item}`;
	}).join(",")}}`;
}
// ../../node_modules/drizzle-orm/pg-core/columns/common.js
var PgColumnBuilder = class extends ColumnBuilder {
	foreignKeyConfigs = [];
	static [entityKind] = "PgColumnBuilder";
	array(size) {
		return new PgArrayBuilder(this.config.name, this, size);
	}
	references(ref, actions = {}) {
		this.foreignKeyConfigs.push({
			ref,
			actions
		});
		return this;
	}
	unique(name, config) {
		this.config.isUnique = true;
		this.config.uniqueName = name;
		this.config.uniqueType = config?.nulls;
		return this;
	}
	generatedAlwaysAs(as) {
		this.config.generated = {
			as,
			type: "always",
			mode: "stored"
		};
		return this;
	}
	/** @internal */
	buildForeignKeys(column, table) {
		return this.foreignKeyConfigs.map(({ ref, actions }) => {
			return iife((ref2, actions2) => {
				const builder = new ForeignKeyBuilder(() => {
					const foreignColumn = ref2();
					return {
						columns: [column],
						foreignColumns: [foreignColumn]
					};
				});
				if (actions2.onUpdate) builder.onUpdate(actions2.onUpdate);
				if (actions2.onDelete) builder.onDelete(actions2.onDelete);
				return builder.build(table);
			}, ref, actions);
		});
	}
	/** @internal */
	buildExtraConfigColumn(table) {
		return new ExtraConfigColumn(table, this.config);
	}
};
var PgColumn = class extends Column {
	constructor(table, config) {
		if (!config.uniqueName) config.uniqueName = uniqueKeyName(table, [config.name]);
		super(table, config);
		this.table = table;
	}
	static [entityKind] = "PgColumn";
};
var ExtraConfigColumn = class extends PgColumn {
	static [entityKind] = "ExtraConfigColumn";
	getSQLType() {
		return this.getSQLType();
	}
	indexConfig = {
		order: this.config.order ?? "asc",
		nulls: this.config.nulls ?? "last",
		opClass: this.config.opClass
	};
	defaultConfig = {
		order: "asc",
		nulls: "last",
		opClass: void 0
	};
	asc() {
		this.indexConfig.order = "asc";
		return this;
	}
	desc() {
		this.indexConfig.order = "desc";
		return this;
	}
	nullsFirst() {
		this.indexConfig.nulls = "first";
		return this;
	}
	nullsLast() {
		this.indexConfig.nulls = "last";
		return this;
	}
	/**
	* ### PostgreSQL documentation quote
	*
	* > An operator class with optional parameters can be specified for each column of an index.
	* The operator class identifies the operators to be used by the index for that column.
	* For example, a B-tree index on four-byte integers would use the int4_ops class;
	* this operator class includes comparison functions for four-byte integers.
	* In practice the default operator class for the column's data type is usually sufficient.
	* The main point of having operator classes is that for some data types, there could be more than one meaningful ordering.
	* For example, we might want to sort a complex-number data type either by absolute value or by real part.
	* We could do this by defining two operator classes for the data type and then selecting the proper class when creating an index.
	* More information about operator classes check:
	*
	* ### Useful links
	* https://www.postgresql.org/docs/current/sql-createindex.html
	*
	* https://www.postgresql.org/docs/current/indexes-opclass.html
	*
	* https://www.postgresql.org/docs/current/xindex.html
	*
	* ### Additional types
	* If you have the `pg_vector` extension installed in your database, you can use the
	* `vector_l2_ops`, `vector_ip_ops`, `vector_cosine_ops`, `vector_l1_ops`, `bit_hamming_ops`, `bit_jaccard_ops`, `halfvec_l2_ops`, `sparsevec_l2_ops` options, which are predefined types.
	*
	* **You can always specify any string you want in the operator class, in case Drizzle doesn't have it natively in its types**
	*
	* @param opClass
	* @returns
	*/
	op(opClass) {
		this.indexConfig.opClass = opClass;
		return this;
	}
};
var IndexedColumn = class {
	static [entityKind] = "IndexedColumn";
	constructor(name, keyAsName, type, indexConfig) {
		this.name = name;
		this.keyAsName = keyAsName;
		this.type = type;
		this.indexConfig = indexConfig;
	}
	name;
	keyAsName;
	type;
	indexConfig;
};
var PgArrayBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgArrayBuilder";
	constructor(name, baseBuilder, size) {
		super(name, "array", "PgArray");
		this.config.baseBuilder = baseBuilder;
		this.config.size = size;
	}
	/** @internal */
	build(table) {
		const baseColumn = this.config.baseBuilder.build(table);
		return new PgArray(table, this.config, baseColumn);
	}
};
var PgArray = class PgArray extends PgColumn {
	constructor(table, config, baseColumn, range) {
		super(table, config);
		this.baseColumn = baseColumn;
		this.range = range;
		this.size = config.size;
	}
	size;
	static [entityKind] = "PgArray";
	getSQLType() {
		return `${this.baseColumn.getSQLType()}[${typeof this.size === "number" ? this.size : ""}]`;
	}
	mapFromDriverValue(value) {
		if (typeof value === "string") value = parsePgArray(value);
		return value.map((v) => this.baseColumn.mapFromDriverValue(v));
	}
	mapToDriverValue(value, isNestedArray = false) {
		const a = value.map((v) => v === null ? null : is(this.baseColumn, PgArray) ? this.baseColumn.mapToDriverValue(v, true) : this.baseColumn.mapToDriverValue(v));
		if (isNestedArray) return a;
		return makePgArray(a);
	}
};
// ../../node_modules/drizzle-orm/pg-core/columns/enum.js
var PgEnumObjectColumnBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgEnumObjectColumnBuilder";
	constructor(name, enumInstance) {
		super(name, "string", "PgEnumObjectColumn");
		this.config.enum = enumInstance;
	}
	/** @internal */
	build(table) {
		return new PgEnumObjectColumn(table, this.config);
	}
};
var PgEnumObjectColumn = class extends PgColumn {
	static [entityKind] = "PgEnumObjectColumn";
	enum;
	enumValues = this.config.enum.enumValues;
	constructor(table, config) {
		super(table, config);
		this.enum = config.enum;
	}
	getSQLType() {
		return this.enum.enumName;
	}
};
var isPgEnumSym = Symbol.for("drizzle:isPgEnum");
function isPgEnum(obj) {
	return !!obj && typeof obj === "function" && isPgEnumSym in obj && obj[isPgEnumSym] === true;
}
var PgEnumColumnBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgEnumColumnBuilder";
	constructor(name, enumInstance) {
		super(name, "string", "PgEnumColumn");
		this.config.enum = enumInstance;
	}
	/** @internal */
	build(table) {
		return new PgEnumColumn(table, this.config);
	}
};
var PgEnumColumn = class extends PgColumn {
	static [entityKind] = "PgEnumColumn";
	enum = this.config.enum;
	enumValues = this.config.enum.enumValues;
	constructor(table, config) {
		super(table, config);
		this.enum = config.enum;
	}
	getSQLType() {
		return this.enum.enumName;
	}
};
function pgEnum(enumName, input) {
	return Array.isArray(input) ? pgEnumWithSchema(enumName, [...input], void 0) : pgEnumObjectWithSchema(enumName, input, void 0);
}
function pgEnumWithSchema(enumName, values, schema) {
	const enumInstance = Object.assign((name) => new PgEnumColumnBuilder(name ?? "", enumInstance), {
		enumName,
		enumValues: values,
		schema,
		[isPgEnumSym]: true
	});
	return enumInstance;
}
function pgEnumObjectWithSchema(enumName, values, schema) {
	const enumInstance = Object.assign((name) => new PgEnumObjectColumnBuilder(name ?? "", enumInstance), {
		enumName,
		enumValues: Object.values(values),
		schema,
		[isPgEnumSym]: true
	});
	return enumInstance;
}
// ../../node_modules/drizzle-orm/subquery.js
var Subquery = class {
	static [entityKind] = "Subquery";
	constructor(sql, fields, alias, isWith = false, usedTables = []) {
		this._ = {
			brand: "Subquery",
			sql,
			selectedFields: fields,
			alias,
			isWith,
			usedTables
		};
	}
};
// ../../node_modules/drizzle-orm/tracing.js
var tracer = { startActiveSpan(name, fn) {
	return fn();
} };
// ../../node_modules/drizzle-orm/view-common.js
var ViewBaseConfig = Symbol.for("drizzle:ViewBaseConfig");
// ../../node_modules/drizzle-orm/table.js
var Schema = Symbol.for("drizzle:Schema");
var Columns = Symbol.for("drizzle:Columns");
var ExtraConfigColumns = Symbol.for("drizzle:ExtraConfigColumns");
var OriginalName = Symbol.for("drizzle:OriginalName");
var BaseName = Symbol.for("drizzle:BaseName");
var IsAlias = Symbol.for("drizzle:IsAlias");
var ExtraConfigBuilder = Symbol.for("drizzle:ExtraConfigBuilder");
var IsDrizzleTable = Symbol.for("drizzle:IsDrizzleTable");
var Table = class {
	static [entityKind] = "Table";
	/** @internal */
	static Symbol = {
		Name: TableName,
		Schema,
		OriginalName,
		Columns,
		ExtraConfigColumns,
		BaseName,
		IsAlias,
		ExtraConfigBuilder
	};
	/**
	* @internal
	* Can be changed if the table is aliased.
	*/
	[TableName];
	/**
	* @internal
	* Used to store the original name of the table, before any aliasing.
	*/
	[OriginalName];
	/** @internal */
	[Schema];
	/** @internal */
	[Columns];
	/** @internal */
	[ExtraConfigColumns];
	/**
	*  @internal
	* Used to store the table name before the transformation via the `tableCreator` functions.
	*/
	[BaseName];
	/** @internal */
	[IsAlias] = false;
	/** @internal */
	[IsDrizzleTable] = true;
	/** @internal */
	[ExtraConfigBuilder] = void 0;
	constructor(name, schema, baseName) {
		this[TableName] = this[OriginalName] = name;
		this[Schema] = schema;
		this[BaseName] = baseName;
	}
};
// ../../node_modules/drizzle-orm/sql/sql.js
function isSQLWrapper(value) {
	return value !== null && value !== void 0 && typeof value.getSQL === "function";
}
function mergeQueries(queries) {
	const result = {
		sql: "",
		params: []
	};
	for (const query of queries) {
		result.sql += query.sql;
		result.params.push(...query.params);
		if (query.typings?.length) {
			if (!result.typings) result.typings = [];
			result.typings.push(...query.typings);
		}
	}
	return result;
}
var StringChunk = class {
	static [entityKind] = "StringChunk";
	value;
	constructor(value) {
		this.value = Array.isArray(value) ? value : [value];
	}
	getSQL() {
		return new SQL([this]);
	}
};
var SQL = class SQL {
	constructor(queryChunks) {
		this.queryChunks = queryChunks;
		for (const chunk of queryChunks) if (is(chunk, Table)) {
			const schemaName = chunk[Table.Symbol.Schema];
			this.usedTables.push(schemaName === void 0 ? chunk[Table.Symbol.Name] : schemaName + "." + chunk[Table.Symbol.Name]);
		}
	}
	static [entityKind] = "SQL";
	/** @internal */
	decoder = noopDecoder;
	shouldInlineParams = false;
	/** @internal */
	usedTables = [];
	append(query) {
		this.queryChunks.push(...query.queryChunks);
		return this;
	}
	toQuery(config) {
		return tracer.startActiveSpan("drizzle.buildSQL", (span) => {
			const query = this.buildQueryFromSourceParams(this.queryChunks, config);
			span?.setAttributes({
				"drizzle.query.text": query.sql,
				"drizzle.query.params": JSON.stringify(query.params)
			});
			return query;
		});
	}
	buildQueryFromSourceParams(chunks, _config) {
		const config = Object.assign({}, _config, {
			inlineParams: _config.inlineParams || this.shouldInlineParams,
			paramStartIndex: _config.paramStartIndex || { value: 0 }
		});
		const { casing, escapeName, escapeParam, prepareTyping, inlineParams, paramStartIndex } = config;
		return mergeQueries(chunks.map((chunk) => {
			if (is(chunk, StringChunk)) return {
				sql: chunk.value.join(""),
				params: []
			};
			if (is(chunk, Name)) return {
				sql: escapeName(chunk.value),
				params: []
			};
			if (chunk === void 0) return {
				sql: "",
				params: []
			};
			if (Array.isArray(chunk)) {
				const result = [new StringChunk("(")];
				for (const [i, p] of chunk.entries()) {
					result.push(p);
					if (i < chunk.length - 1) result.push(new StringChunk(", "));
				}
				result.push(new StringChunk(")"));
				return this.buildQueryFromSourceParams(result, config);
			}
			if (is(chunk, SQL)) return this.buildQueryFromSourceParams(chunk.queryChunks, {
				...config,
				inlineParams: inlineParams || chunk.shouldInlineParams
			});
			if (is(chunk, Table)) {
				const schemaName = chunk[Table.Symbol.Schema];
				const tableName = chunk[Table.Symbol.Name];
				return {
					sql: schemaName === void 0 || chunk[IsAlias] ? escapeName(tableName) : escapeName(schemaName) + "." + escapeName(tableName),
					params: []
				};
			}
			if (is(chunk, Column)) {
				const columnName = casing.getColumnCasing(chunk);
				if (_config.invokeSource === "indexes") return {
					sql: escapeName(columnName),
					params: []
				};
				const schemaName = chunk.table[Table.Symbol.Schema];
				return {
					sql: chunk.table[IsAlias] || schemaName === void 0 ? escapeName(chunk.table[Table.Symbol.Name]) + "." + escapeName(columnName) : escapeName(schemaName) + "." + escapeName(chunk.table[Table.Symbol.Name]) + "." + escapeName(columnName),
					params: []
				};
			}
			if (is(chunk, View)) {
				const schemaName = chunk[ViewBaseConfig].schema;
				const viewName = chunk[ViewBaseConfig].name;
				return {
					sql: schemaName === void 0 || chunk[ViewBaseConfig].isAlias ? escapeName(viewName) : escapeName(schemaName) + "." + escapeName(viewName),
					params: []
				};
			}
			if (is(chunk, Param)) {
				if (is(chunk.value, Placeholder)) return {
					sql: escapeParam(paramStartIndex.value++, chunk),
					params: [chunk],
					typings: ["none"]
				};
				const mappedValue = chunk.value === null ? null : chunk.encoder.mapToDriverValue(chunk.value);
				if (is(mappedValue, SQL)) return this.buildQueryFromSourceParams([mappedValue], config);
				if (inlineParams) return {
					sql: this.mapInlineParam(mappedValue, config),
					params: []
				};
				let typings = ["none"];
				if (prepareTyping) typings = [prepareTyping(chunk.encoder)];
				return {
					sql: escapeParam(paramStartIndex.value++, mappedValue),
					params: [mappedValue],
					typings
				};
			}
			if (is(chunk, Placeholder)) return {
				sql: escapeParam(paramStartIndex.value++, chunk),
				params: [chunk],
				typings: ["none"]
			};
			if (is(chunk, SQL.Aliased) && chunk.fieldAlias !== void 0) return {
				sql: escapeName(chunk.fieldAlias),
				params: []
			};
			if (is(chunk, Subquery)) {
				if (chunk._.isWith) return {
					sql: escapeName(chunk._.alias),
					params: []
				};
				return this.buildQueryFromSourceParams([
					new StringChunk("("),
					chunk._.sql,
					new StringChunk(") "),
					new Name(chunk._.alias)
				], config);
			}
			if (isPgEnum(chunk)) {
				if (chunk.schema) return {
					sql: escapeName(chunk.schema) + "." + escapeName(chunk.enumName),
					params: []
				};
				return {
					sql: escapeName(chunk.enumName),
					params: []
				};
			}
			if (isSQLWrapper(chunk)) {
				if (chunk.shouldOmitSQLParens?.()) return this.buildQueryFromSourceParams([chunk.getSQL()], config);
				return this.buildQueryFromSourceParams([
					new StringChunk("("),
					chunk.getSQL(),
					new StringChunk(")")
				], config);
			}
			if (inlineParams) return {
				sql: this.mapInlineParam(chunk, config),
				params: []
			};
			return {
				sql: escapeParam(paramStartIndex.value++, chunk),
				params: [chunk],
				typings: ["none"]
			};
		}));
	}
	mapInlineParam(chunk, { escapeString }) {
		if (chunk === null) return "null";
		if (typeof chunk === "number" || typeof chunk === "boolean") return chunk.toString();
		if (typeof chunk === "string") return escapeString(chunk);
		if (typeof chunk === "object") {
			const mappedValueAsString = chunk.toString();
			if (mappedValueAsString === "[object Object]") return escapeString(JSON.stringify(chunk));
			return escapeString(mappedValueAsString);
		}
		throw new Error("Unexpected param value: " + chunk);
	}
	getSQL() {
		return this;
	}
	as(alias) {
		if (alias === void 0) return this;
		return new SQL.Aliased(this, alias);
	}
	mapWith(decoder) {
		this.decoder = typeof decoder === "function" ? { mapFromDriverValue: decoder } : decoder;
		return this;
	}
	inlineParams() {
		this.shouldInlineParams = true;
		return this;
	}
	/**
	* This method is used to conditionally include a part of the query.
	*
	* @param condition - Condition to check
	* @returns itself if the condition is `true`, otherwise `undefined`
	*/
	if(condition) {
		return condition ? this : void 0;
	}
};
var Name = class {
	constructor(value) {
		this.value = value;
	}
	static [entityKind] = "Name";
	brand;
	getSQL() {
		return new SQL([this]);
	}
};
function isDriverValueEncoder(value) {
	return typeof value === "object" && value !== null && "mapToDriverValue" in value && typeof value.mapToDriverValue === "function";
}
var noopDecoder = { mapFromDriverValue: (value) => value };
var noopEncoder = { mapToDriverValue: (value) => value };
({
	...noopDecoder,
	...noopEncoder
});
var Param = class {
	/**
	* @param value - Parameter value
	* @param encoder - Encoder to convert the value to a driver parameter
	*/
	constructor(value, encoder = noopEncoder) {
		this.value = value;
		this.encoder = encoder;
	}
	static [entityKind] = "Param";
	brand;
	getSQL() {
		return new SQL([this]);
	}
};
function sql(strings, ...params) {
	const queryChunks = [];
	if (params.length > 0 || strings.length > 0 && strings[0] !== "") queryChunks.push(new StringChunk(strings[0]));
	for (const [paramIndex, param2] of params.entries()) queryChunks.push(param2, new StringChunk(strings[paramIndex + 1]));
	return new SQL(queryChunks);
}
((sql2) => {
	function empty() {
		return new SQL([]);
	}
	sql2.empty = empty;
	function fromList(list) {
		return new SQL(list);
	}
	sql2.fromList = fromList;
	function raw(str) {
		return new SQL([new StringChunk(str)]);
	}
	sql2.raw = raw;
	function join(chunks, separator) {
		const result = [];
		for (const [i, chunk] of chunks.entries()) {
			if (i > 0 && separator !== void 0) result.push(separator);
			result.push(chunk);
		}
		return new SQL(result);
	}
	sql2.join = join;
	function identifier(value) {
		return new Name(value);
	}
	sql2.identifier = identifier;
	function placeholder2(name2) {
		return new Placeholder(name2);
	}
	sql2.placeholder = placeholder2;
	function param2(value, encoder) {
		return new Param(value, encoder);
	}
	sql2.param = param2;
})(sql || (sql = {}));
((SQL2) => {
	class Aliased {
		constructor(sql2, fieldAlias) {
			this.sql = sql2;
			this.fieldAlias = fieldAlias;
		}
		static [entityKind] = "SQL.Aliased";
		/** @internal */
		isSelectionField = false;
		getSQL() {
			return this.sql;
		}
		/** @internal */
		clone() {
			return new Aliased(this.sql, this.fieldAlias);
		}
	}
	SQL2.Aliased = Aliased;
})(SQL || (SQL = {}));
var Placeholder = class {
	constructor(name2) {
		this.name = name2;
	}
	static [entityKind] = "Placeholder";
	getSQL() {
		return new SQL([this]);
	}
};
var IsDrizzleView = Symbol.for("drizzle:IsDrizzleView");
var View = class {
	static [entityKind] = "View";
	/** @internal */
	[ViewBaseConfig];
	/** @internal */
	[IsDrizzleView] = true;
	constructor({ name: name2, schema, selectedFields, query }) {
		this[ViewBaseConfig] = {
			name: name2,
			originalName: name2,
			schema,
			selectedFields,
			query,
			isExisting: !query,
			isAlias: false
		};
	}
	getSQL() {
		return new SQL([this]);
	}
};
Column.prototype.getSQL = function() {
	return new SQL([this]);
};
Table.prototype.getSQL = function() {
	return new SQL([this]);
};
Subquery.prototype.getSQL = function() {
	return new SQL([this]);
};
// ../../node_modules/drizzle-orm/pg-core/checks.js
var CheckBuilder = class {
	constructor(name, value) {
		this.name = name;
		this.value = value;
	}
	static [entityKind] = "PgCheckBuilder";
	brand;
	/** @internal */
	build(table) {
		return new Check(table, this);
	}
};
var Check = class {
	constructor(table, builder) {
		this.table = table;
		this.name = builder.name;
		this.value = builder.value;
	}
	static [entityKind] = "PgCheck";
	name;
	value;
};
function check(name, value) {
	return new CheckBuilder(name, value);
}
// ../../node_modules/drizzle-orm/utils.js
function getColumnNameAndConfig(a, b) {
	return {
		name: typeof a === "string" && a.length > 0 ? a : "",
		config: typeof a === "object" ? a : b
	};
}
typeof TextDecoder === "undefined" || new TextDecoder();
// ../../node_modules/drizzle-orm/pg-core/columns/int.common.js
var PgIntColumnBaseBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgIntColumnBaseBuilder";
	generatedAlwaysAsIdentity(sequence) {
		if (sequence) {
			const { name, ...options } = sequence;
			this.config.generatedIdentity = {
				type: "always",
				sequenceName: name,
				sequenceOptions: options
			};
		} else this.config.generatedIdentity = { type: "always" };
		this.config.hasDefault = true;
		this.config.notNull = true;
		return this;
	}
	generatedByDefaultAsIdentity(sequence) {
		if (sequence) {
			const { name, ...options } = sequence;
			this.config.generatedIdentity = {
				type: "byDefault",
				sequenceName: name,
				sequenceOptions: options
			};
		} else this.config.generatedIdentity = { type: "byDefault" };
		this.config.hasDefault = true;
		this.config.notNull = true;
		return this;
	}
};
// ../../node_modules/drizzle-orm/pg-core/columns/bigint.js
var PgBigInt53Builder = class extends PgIntColumnBaseBuilder {
	static [entityKind] = "PgBigInt53Builder";
	constructor(name) {
		super(name, "number", "PgBigInt53");
	}
	/** @internal */
	build(table) {
		return new PgBigInt53(table, this.config);
	}
};
var PgBigInt53 = class extends PgColumn {
	static [entityKind] = "PgBigInt53";
	getSQLType() {
		return "bigint";
	}
	mapFromDriverValue(value) {
		if (typeof value === "number") return value;
		return Number(value);
	}
};
var PgBigInt64Builder = class extends PgIntColumnBaseBuilder {
	static [entityKind] = "PgBigInt64Builder";
	constructor(name) {
		super(name, "bigint", "PgBigInt64");
	}
	/** @internal */
	build(table) {
		return new PgBigInt64(table, this.config);
	}
};
var PgBigInt64 = class extends PgColumn {
	static [entityKind] = "PgBigInt64";
	getSQLType() {
		return "bigint";
	}
	mapFromDriverValue(value) {
		return BigInt(value);
	}
};
function bigint(a, b) {
	const { name, config } = getColumnNameAndConfig(a, b);
	if (config.mode === "number") return new PgBigInt53Builder(name);
	return new PgBigInt64Builder(name);
}
// ../../node_modules/drizzle-orm/pg-core/columns/bigserial.js
var PgBigSerial53Builder = class extends PgColumnBuilder {
	static [entityKind] = "PgBigSerial53Builder";
	constructor(name) {
		super(name, "number", "PgBigSerial53");
		this.config.hasDefault = true;
		this.config.notNull = true;
	}
	/** @internal */
	build(table) {
		return new PgBigSerial53(table, this.config);
	}
};
var PgBigSerial53 = class extends PgColumn {
	static [entityKind] = "PgBigSerial53";
	getSQLType() {
		return "bigserial";
	}
	mapFromDriverValue(value) {
		if (typeof value === "number") return value;
		return Number(value);
	}
};
var PgBigSerial64Builder = class extends PgColumnBuilder {
	static [entityKind] = "PgBigSerial64Builder";
	constructor(name) {
		super(name, "bigint", "PgBigSerial64");
		this.config.hasDefault = true;
	}
	/** @internal */
	build(table) {
		return new PgBigSerial64(table, this.config);
	}
};
var PgBigSerial64 = class extends PgColumn {
	static [entityKind] = "PgBigSerial64";
	getSQLType() {
		return "bigserial";
	}
	mapFromDriverValue(value) {
		return BigInt(value);
	}
};
function bigserial(a, b) {
	const { name, config } = getColumnNameAndConfig(a, b);
	if (config.mode === "number") return new PgBigSerial53Builder(name);
	return new PgBigSerial64Builder(name);
}
// ../../node_modules/drizzle-orm/pg-core/columns/boolean.js
var PgBooleanBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgBooleanBuilder";
	constructor(name) {
		super(name, "boolean", "PgBoolean");
	}
	/** @internal */
	build(table) {
		return new PgBoolean(table, this.config);
	}
};
var PgBoolean = class extends PgColumn {
	static [entityKind] = "PgBoolean";
	getSQLType() {
		return "boolean";
	}
};
function boolean(name) {
	return new PgBooleanBuilder(name ?? "");
}
// ../../node_modules/drizzle-orm/pg-core/columns/char.js
var PgCharBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgCharBuilder";
	constructor(name, config) {
		super(name, "string", "PgChar");
		this.config.length = config.length;
		this.config.enumValues = config.enum;
	}
	/** @internal */
	build(table) {
		return new PgChar(table, this.config);
	}
};
var PgChar = class extends PgColumn {
	static [entityKind] = "PgChar";
	length = this.config.length;
	enumValues = this.config.enumValues;
	getSQLType() {
		return this.length === void 0 ? `char` : `char(${this.length})`;
	}
};
function char(a, b = {}) {
	const { name, config } = getColumnNameAndConfig(a, b);
	return new PgCharBuilder(name, config);
}
// ../../node_modules/drizzle-orm/pg-core/columns/cidr.js
var PgCidrBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgCidrBuilder";
	constructor(name) {
		super(name, "string", "PgCidr");
	}
	/** @internal */
	build(table) {
		return new PgCidr(table, this.config);
	}
};
var PgCidr = class extends PgColumn {
	static [entityKind] = "PgCidr";
	getSQLType() {
		return "cidr";
	}
};
function cidr(name) {
	return new PgCidrBuilder(name ?? "");
}
// ../../node_modules/drizzle-orm/pg-core/columns/custom.js
var PgCustomColumnBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgCustomColumnBuilder";
	constructor(name, fieldConfig, customTypeParams) {
		super(name, "custom", "PgCustomColumn");
		this.config.fieldConfig = fieldConfig;
		this.config.customTypeParams = customTypeParams;
	}
	/** @internal */
	build(table) {
		return new PgCustomColumn(table, this.config);
	}
};
var PgCustomColumn = class extends PgColumn {
	static [entityKind] = "PgCustomColumn";
	sqlName;
	mapTo;
	mapFrom;
	constructor(table, config) {
		super(table, config);
		this.sqlName = config.customTypeParams.dataType(config.fieldConfig);
		this.mapTo = config.customTypeParams.toDriver;
		this.mapFrom = config.customTypeParams.fromDriver;
	}
	getSQLType() {
		return this.sqlName;
	}
	mapFromDriverValue(value) {
		return typeof this.mapFrom === "function" ? this.mapFrom(value) : value;
	}
	mapToDriverValue(value) {
		return typeof this.mapTo === "function" ? this.mapTo(value) : value;
	}
};
function customType(customTypeParams) {
	return (a, b) => {
		const { name, config } = getColumnNameAndConfig(a, b);
		return new PgCustomColumnBuilder(name, config, customTypeParams);
	};
}
// ../../node_modules/drizzle-orm/pg-core/columns/date.common.js
var PgDateColumnBaseBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgDateColumnBaseBuilder";
	defaultNow() {
		return this.default(sql`now()`);
	}
};
// ../../node_modules/drizzle-orm/pg-core/columns/date.js
var PgDateBuilder = class extends PgDateColumnBaseBuilder {
	static [entityKind] = "PgDateBuilder";
	constructor(name) {
		super(name, "date", "PgDate");
	}
	/** @internal */
	build(table) {
		return new PgDate(table, this.config);
	}
};
var PgDate = class extends PgColumn {
	static [entityKind] = "PgDate";
	getSQLType() {
		return "date";
	}
	mapFromDriverValue(value) {
		if (typeof value === "string") return new Date(value);
		return value;
	}
	mapToDriverValue(value) {
		return value.toISOString();
	}
};
var PgDateStringBuilder = class extends PgDateColumnBaseBuilder {
	static [entityKind] = "PgDateStringBuilder";
	constructor(name) {
		super(name, "string", "PgDateString");
	}
	/** @internal */
	build(table) {
		return new PgDateString(table, this.config);
	}
};
var PgDateString = class extends PgColumn {
	static [entityKind] = "PgDateString";
	getSQLType() {
		return "date";
	}
	mapFromDriverValue(value) {
		if (typeof value === "string") return value;
		return value.toISOString().slice(0, -14);
	}
};
function date(a, b) {
	const { name, config } = getColumnNameAndConfig(a, b);
	if (config?.mode === "date") return new PgDateBuilder(name);
	return new PgDateStringBuilder(name);
}
// ../../node_modules/drizzle-orm/pg-core/columns/double-precision.js
var PgDoublePrecisionBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgDoublePrecisionBuilder";
	constructor(name) {
		super(name, "number", "PgDoublePrecision");
	}
	/** @internal */
	build(table) {
		return new PgDoublePrecision(table, this.config);
	}
};
var PgDoublePrecision = class extends PgColumn {
	static [entityKind] = "PgDoublePrecision";
	getSQLType() {
		return "double precision";
	}
	mapFromDriverValue(value) {
		if (typeof value === "string") return Number.parseFloat(value);
		return value;
	}
};
function doublePrecision(name) {
	return new PgDoublePrecisionBuilder(name ?? "");
}
// ../../node_modules/drizzle-orm/pg-core/columns/inet.js
var PgInetBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgInetBuilder";
	constructor(name) {
		super(name, "string", "PgInet");
	}
	/** @internal */
	build(table) {
		return new PgInet(table, this.config);
	}
};
var PgInet = class extends PgColumn {
	static [entityKind] = "PgInet";
	getSQLType() {
		return "inet";
	}
};
function inet(name) {
	return new PgInetBuilder(name ?? "");
}
// ../../node_modules/drizzle-orm/pg-core/columns/integer.js
var PgIntegerBuilder = class extends PgIntColumnBaseBuilder {
	static [entityKind] = "PgIntegerBuilder";
	constructor(name) {
		super(name, "number", "PgInteger");
	}
	/** @internal */
	build(table) {
		return new PgInteger(table, this.config);
	}
};
var PgInteger = class extends PgColumn {
	static [entityKind] = "PgInteger";
	getSQLType() {
		return "integer";
	}
	mapFromDriverValue(value) {
		if (typeof value === "string") return Number.parseInt(value);
		return value;
	}
};
function integer(name) {
	return new PgIntegerBuilder(name ?? "");
}
// ../../node_modules/drizzle-orm/pg-core/columns/interval.js
var PgIntervalBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgIntervalBuilder";
	constructor(name, intervalConfig) {
		super(name, "string", "PgInterval");
		this.config.intervalConfig = intervalConfig;
	}
	/** @internal */
	build(table) {
		return new PgInterval(table, this.config);
	}
};
var PgInterval = class extends PgColumn {
	static [entityKind] = "PgInterval";
	fields = this.config.intervalConfig.fields;
	precision = this.config.intervalConfig.precision;
	getSQLType() {
		return `interval${this.fields ? ` ${this.fields}` : ""}${this.precision ? `(${this.precision})` : ""}`;
	}
};
function interval(a, b = {}) {
	const { name, config } = getColumnNameAndConfig(a, b);
	return new PgIntervalBuilder(name, config);
}
// ../../node_modules/drizzle-orm/pg-core/columns/json.js
var PgJsonBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgJsonBuilder";
	constructor(name) {
		super(name, "json", "PgJson");
	}
	/** @internal */
	build(table) {
		return new PgJson(table, this.config);
	}
};
var PgJson = class extends PgColumn {
	static [entityKind] = "PgJson";
	constructor(table, config) {
		super(table, config);
	}
	getSQLType() {
		return "json";
	}
	mapToDriverValue(value) {
		return JSON.stringify(value);
	}
	mapFromDriverValue(value) {
		if (typeof value === "string") try {
			return JSON.parse(value);
		} catch {
			return value;
		}
		return value;
	}
};
function json(name) {
	return new PgJsonBuilder(name ?? "");
}
// ../../node_modules/drizzle-orm/pg-core/columns/jsonb.js
var PgJsonbBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgJsonbBuilder";
	constructor(name) {
		super(name, "json", "PgJsonb");
	}
	/** @internal */
	build(table) {
		return new PgJsonb(table, this.config);
	}
};
var PgJsonb = class extends PgColumn {
	static [entityKind] = "PgJsonb";
	constructor(table, config) {
		super(table, config);
	}
	getSQLType() {
		return "jsonb";
	}
	mapToDriverValue(value) {
		return JSON.stringify(value);
	}
	mapFromDriverValue(value) {
		if (typeof value === "string") try {
			return JSON.parse(value);
		} catch {
			return value;
		}
		return value;
	}
};
function jsonb(name) {
	return new PgJsonbBuilder(name ?? "");
}
// ../../node_modules/drizzle-orm/pg-core/columns/line.js
var PgLineBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgLineBuilder";
	constructor(name) {
		super(name, "array", "PgLine");
	}
	/** @internal */
	build(table) {
		return new PgLineTuple(table, this.config);
	}
};
var PgLineTuple = class extends PgColumn {
	static [entityKind] = "PgLine";
	getSQLType() {
		return "line";
	}
	mapFromDriverValue(value) {
		const [a, b, c] = value.slice(1, -1).split(",");
		return [
			Number.parseFloat(a),
			Number.parseFloat(b),
			Number.parseFloat(c)
		];
	}
	mapToDriverValue(value) {
		return `{${value[0]},${value[1]},${value[2]}}`;
	}
};
var PgLineABCBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgLineABCBuilder";
	constructor(name) {
		super(name, "json", "PgLineABC");
	}
	/** @internal */
	build(table) {
		return new PgLineABC(table, this.config);
	}
};
var PgLineABC = class extends PgColumn {
	static [entityKind] = "PgLineABC";
	getSQLType() {
		return "line";
	}
	mapFromDriverValue(value) {
		const [a, b, c] = value.slice(1, -1).split(",");
		return {
			a: Number.parseFloat(a),
			b: Number.parseFloat(b),
			c: Number.parseFloat(c)
		};
	}
	mapToDriverValue(value) {
		return `{${value.a},${value.b},${value.c}}`;
	}
};
function line(a, b) {
	const { name, config } = getColumnNameAndConfig(a, b);
	if (!config?.mode || config.mode === "tuple") return new PgLineBuilder(name);
	return new PgLineABCBuilder(name);
}
// ../../node_modules/drizzle-orm/pg-core/columns/macaddr.js
var PgMacaddrBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgMacaddrBuilder";
	constructor(name) {
		super(name, "string", "PgMacaddr");
	}
	/** @internal */
	build(table) {
		return new PgMacaddr(table, this.config);
	}
};
var PgMacaddr = class extends PgColumn {
	static [entityKind] = "PgMacaddr";
	getSQLType() {
		return "macaddr";
	}
};
function macaddr(name) {
	return new PgMacaddrBuilder(name ?? "");
}
// ../../node_modules/drizzle-orm/pg-core/columns/macaddr8.js
var PgMacaddr8Builder = class extends PgColumnBuilder {
	static [entityKind] = "PgMacaddr8Builder";
	constructor(name) {
		super(name, "string", "PgMacaddr8");
	}
	/** @internal */
	build(table) {
		return new PgMacaddr8(table, this.config);
	}
};
var PgMacaddr8 = class extends PgColumn {
	static [entityKind] = "PgMacaddr8";
	getSQLType() {
		return "macaddr8";
	}
};
function macaddr8(name) {
	return new PgMacaddr8Builder(name ?? "");
}
// ../../node_modules/drizzle-orm/pg-core/columns/numeric.js
var PgNumericBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgNumericBuilder";
	constructor(name, precision, scale) {
		super(name, "string", "PgNumeric");
		this.config.precision = precision;
		this.config.scale = scale;
	}
	/** @internal */
	build(table) {
		return new PgNumeric(table, this.config);
	}
};
var PgNumeric = class extends PgColumn {
	static [entityKind] = "PgNumeric";
	precision;
	scale;
	constructor(table, config) {
		super(table, config);
		this.precision = config.precision;
		this.scale = config.scale;
	}
	mapFromDriverValue(value) {
		if (typeof value === "string") return value;
		return String(value);
	}
	getSQLType() {
		if (this.precision !== void 0 && this.scale !== void 0) return `numeric(${this.precision}, ${this.scale})`;
		else if (this.precision === void 0) return "numeric";
		else return `numeric(${this.precision})`;
	}
};
var PgNumericNumberBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgNumericNumberBuilder";
	constructor(name, precision, scale) {
		super(name, "number", "PgNumericNumber");
		this.config.precision = precision;
		this.config.scale = scale;
	}
	/** @internal */
	build(table) {
		return new PgNumericNumber(table, this.config);
	}
};
var PgNumericNumber = class extends PgColumn {
	static [entityKind] = "PgNumericNumber";
	precision;
	scale;
	constructor(table, config) {
		super(table, config);
		this.precision = config.precision;
		this.scale = config.scale;
	}
	mapFromDriverValue(value) {
		if (typeof value === "number") return value;
		return Number(value);
	}
	mapToDriverValue = String;
	getSQLType() {
		if (this.precision !== void 0 && this.scale !== void 0) return `numeric(${this.precision}, ${this.scale})`;
		else if (this.precision === void 0) return "numeric";
		else return `numeric(${this.precision})`;
	}
};
var PgNumericBigIntBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgNumericBigIntBuilder";
	constructor(name, precision, scale) {
		super(name, "bigint", "PgNumericBigInt");
		this.config.precision = precision;
		this.config.scale = scale;
	}
	/** @internal */
	build(table) {
		return new PgNumericBigInt(table, this.config);
	}
};
var PgNumericBigInt = class extends PgColumn {
	static [entityKind] = "PgNumericBigInt";
	precision;
	scale;
	constructor(table, config) {
		super(table, config);
		this.precision = config.precision;
		this.scale = config.scale;
	}
	mapFromDriverValue = BigInt;
	mapToDriverValue = String;
	getSQLType() {
		if (this.precision !== void 0 && this.scale !== void 0) return `numeric(${this.precision}, ${this.scale})`;
		else if (this.precision === void 0) return "numeric";
		else return `numeric(${this.precision})`;
	}
};
function numeric(a, b) {
	const { name, config } = getColumnNameAndConfig(a, b);
	const mode = config?.mode;
	return mode === "number" ? new PgNumericNumberBuilder(name, config?.precision, config?.scale) : mode === "bigint" ? new PgNumericBigIntBuilder(name, config?.precision, config?.scale) : new PgNumericBuilder(name, config?.precision, config?.scale);
}
// ../../node_modules/drizzle-orm/pg-core/columns/point.js
var PgPointTupleBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgPointTupleBuilder";
	constructor(name) {
		super(name, "array", "PgPointTuple");
	}
	/** @internal */
	build(table) {
		return new PgPointTuple(table, this.config);
	}
};
var PgPointTuple = class extends PgColumn {
	static [entityKind] = "PgPointTuple";
	getSQLType() {
		return "point";
	}
	mapFromDriverValue(value) {
		if (typeof value === "string") {
			const [x, y] = value.slice(1, -1).split(",");
			return [Number.parseFloat(x), Number.parseFloat(y)];
		}
		return [value.x, value.y];
	}
	mapToDriverValue(value) {
		return `(${value[0]},${value[1]})`;
	}
};
var PgPointObjectBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgPointObjectBuilder";
	constructor(name) {
		super(name, "json", "PgPointObject");
	}
	/** @internal */
	build(table) {
		return new PgPointObject(table, this.config);
	}
};
var PgPointObject = class extends PgColumn {
	static [entityKind] = "PgPointObject";
	getSQLType() {
		return "point";
	}
	mapFromDriverValue(value) {
		if (typeof value === "string") {
			const [x, y] = value.slice(1, -1).split(",");
			return {
				x: Number.parseFloat(x),
				y: Number.parseFloat(y)
			};
		}
		return value;
	}
	mapToDriverValue(value) {
		return `(${value.x},${value.y})`;
	}
};
function point(a, b) {
	const { name, config } = getColumnNameAndConfig(a, b);
	if (!config?.mode || config.mode === "tuple") return new PgPointTupleBuilder(name);
	return new PgPointObjectBuilder(name);
}
// ../../node_modules/drizzle-orm/pg-core/columns/postgis_extension/utils.js
function hexToBytes(hex) {
	const bytes = [];
	for (let c = 0; c < hex.length; c += 2) bytes.push(Number.parseInt(hex.slice(c, c + 2), 16));
	return new Uint8Array(bytes);
}
function bytesToFloat64(bytes, offset) {
	const view = /* @__PURE__ */ new DataView(/* @__PURE__ */ new ArrayBuffer(8));
	for (let i = 0; i < 8; i++) view.setUint8(i, bytes[offset + i]);
	return view.getFloat64(0, true);
}
function parseEWKB(hex) {
	const bytes = hexToBytes(hex);
	let offset = 0;
	const byteOrder = bytes[offset];
	offset += 1;
	const view = new DataView(bytes.buffer);
	const geomType = view.getUint32(offset, byteOrder === 1);
	offset += 4;
	if (geomType & 536870912) {
		view.getUint32(offset, byteOrder === 1);
		offset += 4;
	}
	if ((geomType & 65535) === 1) {
		const x = bytesToFloat64(bytes, offset);
		offset += 8;
		const y = bytesToFloat64(bytes, offset);
		offset += 8;
		return [x, y];
	}
	throw new Error("Unsupported geometry type");
}
// ../../node_modules/drizzle-orm/pg-core/columns/postgis_extension/geometry.js
var PgGeometryBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgGeometryBuilder";
	constructor(name) {
		super(name, "array", "PgGeometry");
	}
	/** @internal */
	build(table) {
		return new PgGeometry(table, this.config);
	}
};
var PgGeometry = class extends PgColumn {
	static [entityKind] = "PgGeometry";
	getSQLType() {
		return "geometry(point)";
	}
	mapFromDriverValue(value) {
		return parseEWKB(value);
	}
	mapToDriverValue(value) {
		return `point(${value[0]} ${value[1]})`;
	}
};
var PgGeometryObjectBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgGeometryObjectBuilder";
	constructor(name) {
		super(name, "json", "PgGeometryObject");
	}
	/** @internal */
	build(table) {
		return new PgGeometryObject(table, this.config);
	}
};
var PgGeometryObject = class extends PgColumn {
	static [entityKind] = "PgGeometryObject";
	getSQLType() {
		return "geometry(point)";
	}
	mapFromDriverValue(value) {
		const parsed = parseEWKB(value);
		return {
			x: parsed[0],
			y: parsed[1]
		};
	}
	mapToDriverValue(value) {
		return `point(${value.x} ${value.y})`;
	}
};
function geometry(a, b) {
	const { name, config } = getColumnNameAndConfig(a, b);
	if (!config?.mode || config.mode === "tuple") return new PgGeometryBuilder(name);
	return new PgGeometryObjectBuilder(name);
}
// ../../node_modules/drizzle-orm/pg-core/columns/real.js
var PgRealBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgRealBuilder";
	constructor(name, length) {
		super(name, "number", "PgReal");
		this.config.length = length;
	}
	/** @internal */
	build(table) {
		return new PgReal(table, this.config);
	}
};
var PgReal = class extends PgColumn {
	static [entityKind] = "PgReal";
	constructor(table, config) {
		super(table, config);
	}
	getSQLType() {
		return "real";
	}
	mapFromDriverValue = (value) => {
		if (typeof value === "string") return Number.parseFloat(value);
		return value;
	};
};
function real(name) {
	return new PgRealBuilder(name ?? "");
}
// ../../node_modules/drizzle-orm/pg-core/columns/serial.js
var PgSerialBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgSerialBuilder";
	constructor(name) {
		super(name, "number", "PgSerial");
		this.config.hasDefault = true;
		this.config.notNull = true;
	}
	/** @internal */
	build(table) {
		return new PgSerial(table, this.config);
	}
};
var PgSerial = class extends PgColumn {
	static [entityKind] = "PgSerial";
	getSQLType() {
		return "serial";
	}
};
function serial(name) {
	return new PgSerialBuilder(name ?? "");
}
// ../../node_modules/drizzle-orm/pg-core/columns/smallint.js
var PgSmallIntBuilder = class extends PgIntColumnBaseBuilder {
	static [entityKind] = "PgSmallIntBuilder";
	constructor(name) {
		super(name, "number", "PgSmallInt");
	}
	/** @internal */
	build(table) {
		return new PgSmallInt(table, this.config);
	}
};
var PgSmallInt = class extends PgColumn {
	static [entityKind] = "PgSmallInt";
	getSQLType() {
		return "smallint";
	}
	mapFromDriverValue = (value) => {
		if (typeof value === "string") return Number(value);
		return value;
	};
};
function smallint(name) {
	return new PgSmallIntBuilder(name ?? "");
}
// ../../node_modules/drizzle-orm/pg-core/columns/smallserial.js
var PgSmallSerialBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgSmallSerialBuilder";
	constructor(name) {
		super(name, "number", "PgSmallSerial");
		this.config.hasDefault = true;
		this.config.notNull = true;
	}
	/** @internal */
	build(table) {
		return new PgSmallSerial(table, this.config);
	}
};
var PgSmallSerial = class extends PgColumn {
	static [entityKind] = "PgSmallSerial";
	getSQLType() {
		return "smallserial";
	}
};
function smallserial(name) {
	return new PgSmallSerialBuilder(name ?? "");
}
// ../../node_modules/drizzle-orm/pg-core/columns/text.js
var PgTextBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgTextBuilder";
	constructor(name, config) {
		super(name, "string", "PgText");
		this.config.enumValues = config.enum;
	}
	/** @internal */
	build(table) {
		return new PgText(table, this.config);
	}
};
var PgText = class extends PgColumn {
	static [entityKind] = "PgText";
	enumValues = this.config.enumValues;
	getSQLType() {
		return "text";
	}
};
function text(a, b = {}) {
	const { name, config } = getColumnNameAndConfig(a, b);
	return new PgTextBuilder(name, config);
}
// ../../node_modules/drizzle-orm/pg-core/columns/time.js
var PgTimeBuilder = class extends PgDateColumnBaseBuilder {
	constructor(name, withTimezone, precision) {
		super(name, "string", "PgTime");
		this.withTimezone = withTimezone;
		this.precision = precision;
		this.config.withTimezone = withTimezone;
		this.config.precision = precision;
	}
	static [entityKind] = "PgTimeBuilder";
	/** @internal */
	build(table) {
		return new PgTime(table, this.config);
	}
};
var PgTime = class extends PgColumn {
	static [entityKind] = "PgTime";
	withTimezone;
	precision;
	constructor(table, config) {
		super(table, config);
		this.withTimezone = config.withTimezone;
		this.precision = config.precision;
	}
	getSQLType() {
		return `time${this.precision === void 0 ? "" : `(${this.precision})`}${this.withTimezone ? " with time zone" : ""}`;
	}
};
function time(a, b = {}) {
	const { name, config } = getColumnNameAndConfig(a, b);
	return new PgTimeBuilder(name, config.withTimezone ?? false, config.precision);
}
// ../../node_modules/drizzle-orm/pg-core/columns/timestamp.js
var PgTimestampBuilder = class extends PgDateColumnBaseBuilder {
	static [entityKind] = "PgTimestampBuilder";
	constructor(name, withTimezone, precision) {
		super(name, "date", "PgTimestamp");
		this.config.withTimezone = withTimezone;
		this.config.precision = precision;
	}
	/** @internal */
	build(table) {
		return new PgTimestamp(table, this.config);
	}
};
var PgTimestamp = class extends PgColumn {
	static [entityKind] = "PgTimestamp";
	withTimezone;
	precision;
	constructor(table, config) {
		super(table, config);
		this.withTimezone = config.withTimezone;
		this.precision = config.precision;
	}
	getSQLType() {
		return `timestamp${this.precision === void 0 ? "" : ` (${this.precision})`}${this.withTimezone ? " with time zone" : ""}`;
	}
	mapFromDriverValue(value) {
		if (typeof value === "string") return new Date(this.withTimezone ? value : value + "+0000");
		return value;
	}
	mapToDriverValue = (value) => {
		return value.toISOString();
	};
};
var PgTimestampStringBuilder = class extends PgDateColumnBaseBuilder {
	static [entityKind] = "PgTimestampStringBuilder";
	constructor(name, withTimezone, precision) {
		super(name, "string", "PgTimestampString");
		this.config.withTimezone = withTimezone;
		this.config.precision = precision;
	}
	/** @internal */
	build(table) {
		return new PgTimestampString(table, this.config);
	}
};
var PgTimestampString = class extends PgColumn {
	static [entityKind] = "PgTimestampString";
	withTimezone;
	precision;
	constructor(table, config) {
		super(table, config);
		this.withTimezone = config.withTimezone;
		this.precision = config.precision;
	}
	getSQLType() {
		return `timestamp${this.precision === void 0 ? "" : `(${this.precision})`}${this.withTimezone ? " with time zone" : ""}`;
	}
	mapFromDriverValue(value) {
		if (typeof value === "string") return value;
		const shortened = value.toISOString().slice(0, -1).replace("T", " ");
		if (this.withTimezone) {
			const offset = value.getTimezoneOffset();
			return `${shortened}${offset <= 0 ? "+" : "-"}${Math.floor(Math.abs(offset) / 60).toString().padStart(2, "0")}`;
		}
		return shortened;
	}
};
function timestamp(a, b = {}) {
	const { name, config } = getColumnNameAndConfig(a, b);
	if (config?.mode === "string") return new PgTimestampStringBuilder(name, config.withTimezone ?? false, config.precision);
	return new PgTimestampBuilder(name, config?.withTimezone ?? false, config?.precision);
}
// ../../node_modules/drizzle-orm/pg-core/columns/uuid.js
var PgUUIDBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgUUIDBuilder";
	constructor(name) {
		super(name, "string", "PgUUID");
	}
	/**
	* Adds `default gen_random_uuid()` to the column definition.
	*/
	defaultRandom() {
		return this.default(sql`gen_random_uuid()`);
	}
	/** @internal */
	build(table) {
		return new PgUUID(table, this.config);
	}
};
var PgUUID = class extends PgColumn {
	static [entityKind] = "PgUUID";
	getSQLType() {
		return "uuid";
	}
};
function uuid(name) {
	return new PgUUIDBuilder(name ?? "");
}
// ../../node_modules/drizzle-orm/pg-core/columns/varchar.js
var PgVarcharBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgVarcharBuilder";
	constructor(name, config) {
		super(name, "string", "PgVarchar");
		this.config.length = config.length;
		this.config.enumValues = config.enum;
	}
	/** @internal */
	build(table) {
		return new PgVarchar(table, this.config);
	}
};
var PgVarchar = class extends PgColumn {
	static [entityKind] = "PgVarchar";
	length = this.config.length;
	enumValues = this.config.enumValues;
	getSQLType() {
		return this.length === void 0 ? `varchar` : `varchar(${this.length})`;
	}
};
function varchar(a, b = {}) {
	const { name, config } = getColumnNameAndConfig(a, b);
	return new PgVarcharBuilder(name, config);
}
// ../../node_modules/drizzle-orm/pg-core/columns/vector_extension/bit.js
var PgBinaryVectorBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgBinaryVectorBuilder";
	constructor(name, config) {
		super(name, "string", "PgBinaryVector");
		this.config.dimensions = config.dimensions;
	}
	/** @internal */
	build(table) {
		return new PgBinaryVector(table, this.config);
	}
};
var PgBinaryVector = class extends PgColumn {
	static [entityKind] = "PgBinaryVector";
	dimensions = this.config.dimensions;
	getSQLType() {
		return `bit(${this.dimensions})`;
	}
};
function bit(a, b) {
	const { name, config } = getColumnNameAndConfig(a, b);
	return new PgBinaryVectorBuilder(name, config);
}
// ../../node_modules/drizzle-orm/pg-core/columns/vector_extension/halfvec.js
var PgHalfVectorBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgHalfVectorBuilder";
	constructor(name, config) {
		super(name, "array", "PgHalfVector");
		this.config.dimensions = config.dimensions;
	}
	/** @internal */
	build(table) {
		return new PgHalfVector(table, this.config);
	}
};
var PgHalfVector = class extends PgColumn {
	static [entityKind] = "PgHalfVector";
	dimensions = this.config.dimensions;
	getSQLType() {
		return `halfvec(${this.dimensions})`;
	}
	mapToDriverValue(value) {
		return JSON.stringify(value);
	}
	mapFromDriverValue(value) {
		return value.slice(1, -1).split(",").map((v) => Number.parseFloat(v));
	}
};
function halfvec(a, b) {
	const { name, config } = getColumnNameAndConfig(a, b);
	return new PgHalfVectorBuilder(name, config);
}
// ../../node_modules/drizzle-orm/pg-core/columns/vector_extension/sparsevec.js
var PgSparseVectorBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgSparseVectorBuilder";
	constructor(name, config) {
		super(name, "string", "PgSparseVector");
		this.config.dimensions = config.dimensions;
	}
	/** @internal */
	build(table) {
		return new PgSparseVector(table, this.config);
	}
};
var PgSparseVector = class extends PgColumn {
	static [entityKind] = "PgSparseVector";
	dimensions = this.config.dimensions;
	getSQLType() {
		return `sparsevec(${this.dimensions})`;
	}
};
function sparsevec(a, b) {
	const { name, config } = getColumnNameAndConfig(a, b);
	return new PgSparseVectorBuilder(name, config);
}
// ../../node_modules/drizzle-orm/pg-core/columns/vector_extension/vector.js
var PgVectorBuilder = class extends PgColumnBuilder {
	static [entityKind] = "PgVectorBuilder";
	constructor(name, config) {
		super(name, "array", "PgVector");
		this.config.dimensions = config.dimensions;
	}
	/** @internal */
	build(table) {
		return new PgVector(table, this.config);
	}
};
var PgVector = class extends PgColumn {
	static [entityKind] = "PgVector";
	dimensions = this.config.dimensions;
	getSQLType() {
		return `vector(${this.dimensions})`;
	}
	mapToDriverValue(value) {
		return JSON.stringify(value);
	}
	mapFromDriverValue(value) {
		return value.slice(1, -1).split(",").map((v) => Number.parseFloat(v));
	}
};
function vector(a, b) {
	const { name, config } = getColumnNameAndConfig(a, b);
	return new PgVectorBuilder(name, config);
}
// ../../node_modules/drizzle-orm/pg-core/columns/all.js
function getPgColumnBuilders() {
	return {
		bigint,
		bigserial,
		boolean,
		char,
		cidr,
		customType,
		date,
		doublePrecision,
		inet,
		integer,
		interval,
		json,
		jsonb,
		line,
		macaddr,
		macaddr8,
		numeric,
		point,
		geometry,
		real,
		serial,
		smallint,
		smallserial,
		text,
		time,
		timestamp,
		uuid,
		varchar,
		bit,
		halfvec,
		sparsevec,
		vector
	};
}
// ../../node_modules/drizzle-orm/pg-core/table.js
var InlineForeignKeys = Symbol.for("drizzle:PgInlineForeignKeys");
var EnableRLS = Symbol.for("drizzle:EnableRLS");
var PgTable = class extends Table {
	static [entityKind] = "PgTable";
	/** @internal */
	static Symbol = Object.assign({}, Table.Symbol, {
		InlineForeignKeys,
		EnableRLS
	});
	/**@internal */
	[InlineForeignKeys] = [];
	/** @internal */
	[EnableRLS] = false;
	/** @internal */
	[Table.Symbol.ExtraConfigBuilder] = void 0;
	/** @internal */
	[Table.Symbol.ExtraConfigColumns] = {};
};
function pgTableWithSchema(name, columns, extraConfig, schema, baseName = name) {
	const rawTable = new PgTable(name, schema, baseName);
	const parsedColumns = typeof columns === "function" ? columns(getPgColumnBuilders()) : columns;
	const builtColumns = Object.fromEntries(Object.entries(parsedColumns).map(([name2, colBuilderBase]) => {
		const colBuilder = colBuilderBase;
		colBuilder.setName(name2);
		const column = colBuilder.build(rawTable);
		rawTable[InlineForeignKeys].push(...colBuilder.buildForeignKeys(column, rawTable));
		return [name2, column];
	}));
	const builtColumnsForExtraConfig = Object.fromEntries(Object.entries(parsedColumns).map(([name2, colBuilderBase]) => {
		const colBuilder = colBuilderBase;
		colBuilder.setName(name2);
		return [name2, colBuilder.buildExtraConfigColumn(rawTable)];
	}));
	const table = Object.assign(rawTable, builtColumns);
	table[Table.Symbol.Columns] = builtColumns;
	table[Table.Symbol.ExtraConfigColumns] = builtColumnsForExtraConfig;
	if (extraConfig) table[PgTable.Symbol.ExtraConfigBuilder] = extraConfig;
	return Object.assign(table, { enableRLS: () => {
		table[PgTable.Symbol.EnableRLS] = true;
		return table;
	} });
}
var pgTable = (name, columns, extraConfig) => {
	return pgTableWithSchema(name, columns, extraConfig, void 0);
};
// ../../node_modules/drizzle-orm/pg-core/indexes.js
var IndexBuilderOn = class {
	constructor(unique, name) {
		this.unique = unique;
		this.name = name;
	}
	static [entityKind] = "PgIndexBuilderOn";
	on(...columns) {
		return new IndexBuilder(columns.map((it) => {
			if (is(it, SQL)) return it;
			it = it;
			const clonedIndexedColumn = new IndexedColumn(it.name, !!it.keyAsName, it.columnType, it.indexConfig);
			it.indexConfig = JSON.parse(JSON.stringify(it.defaultConfig));
			return clonedIndexedColumn;
		}), this.unique, false, this.name);
	}
	onOnly(...columns) {
		return new IndexBuilder(columns.map((it) => {
			if (is(it, SQL)) return it;
			it = it;
			const clonedIndexedColumn = new IndexedColumn(it.name, !!it.keyAsName, it.columnType, it.indexConfig);
			it.indexConfig = it.defaultConfig;
			return clonedIndexedColumn;
		}), this.unique, true, this.name);
	}
	/**
	* Specify what index method to use. Choices are `btree`, `hash`, `gist`, `spgist`, `gin`, `brin`, or user-installed access methods like `bloom`. The default method is `btree.
	*
	* If you have the `pg_vector` extension installed in your database, you can use the `hnsw` and `ivfflat` options, which are predefined types.
	*
	* **You can always specify any string you want in the method, in case Drizzle doesn't have it natively in its types**
	*
	* @param method The name of the index method to be used
	* @param columns
	* @returns
	*/
	using(method, ...columns) {
		return new IndexBuilder(columns.map((it) => {
			if (is(it, SQL)) return it;
			it = it;
			const clonedIndexedColumn = new IndexedColumn(it.name, !!it.keyAsName, it.columnType, it.indexConfig);
			it.indexConfig = JSON.parse(JSON.stringify(it.defaultConfig));
			return clonedIndexedColumn;
		}), this.unique, true, this.name, method);
	}
};
var IndexBuilder = class {
	static [entityKind] = "PgIndexBuilder";
	/** @internal */
	config;
	constructor(columns, unique, only, name, method = "btree") {
		this.config = {
			name,
			columns,
			unique,
			only,
			method
		};
	}
	concurrently() {
		this.config.concurrently = true;
		return this;
	}
	with(obj) {
		this.config.with = obj;
		return this;
	}
	where(condition) {
		this.config.where = condition;
		return this;
	}
	/** @internal */
	build(table) {
		return new Index(this.config, table);
	}
};
var Index = class {
	static [entityKind] = "PgIndex";
	config;
	constructor(config, table) {
		this.config = {
			...config,
			table
		};
	}
};
function index(name) {
	return new IndexBuilderOn(false, name);
}
function uniqueIndex(name) {
	return new IndexBuilderOn(true, name);
}
// ../../node_modules/drizzle-orm/pg-core/primary-keys.js
function primaryKey(...config) {
	if (config[0].columns) return new PrimaryKeyBuilder(config[0].columns, config[0].name);
	return new PrimaryKeyBuilder(config);
}
var PrimaryKeyBuilder = class {
	static [entityKind] = "PgPrimaryKeyBuilder";
	/** @internal */
	columns;
	/** @internal */
	name;
	constructor(columns, name) {
		this.columns = columns;
		this.name = name;
	}
	/** @internal */
	build(table) {
		return new PrimaryKey(table, this.columns, this.name);
	}
};
var PrimaryKey = class {
	constructor(table, columns, name) {
		this.table = table;
		this.columns = columns;
		this.name = name;
	}
	static [entityKind] = "PgPrimaryKey";
	columns;
	name;
	getName() {
		return this.name ?? `${this.table[PgTable.Symbol.Name]}_${this.columns.map((column) => column.name).join("_")}_pk`;
	}
};
// ../../node_modules/drizzle-orm/sql/expressions/conditions.js
function bindIfParam(value, column) {
	if (isDriverValueEncoder(column) && !isSQLWrapper(value) && !is(value, Param) && !is(value, Placeholder) && !is(value, Column) && !is(value, Table) && !is(value, View)) return new Param(value, column);
	return value;
}
var eq = (left, right) => {
	return sql`${left} = ${bindIfParam(right, left)}`;
};
// ../db/source/schemas/enums/analytics-type-db-enum.ts
var analyticsTypeDbEnum = pgEnum("analytics_type", ["FOLLOWERS", "IMPRESSIONS"]);
// ../db/source/schemas/enums/applicant-document-status-db-enum.ts
var applicantDocumentStatusDbEnum = pgEnum("applicant_document_status", [
	"NOT_SCANNED",
	"NEEDS_SCAN",
	"SCAN_FAILED",
	"INFECTED",
	"CLEAN"
]);
// ../db/source/schemas/enums/applicant-origin-db-enum.ts
var applicantOriginDbEnum = pgEnum("applicant_origin", [
	"MANUAL",
	"PERSPECTIVE",
	"CAREER_PAGE",
	"WL_LANDING_PAGE"
]);
// ../db/source/schemas/enums/applicant-phase-type-db-enum.ts
var applicantPhaseTypeDbEnum = pgEnum("applicant_phase_type", [
	"CONTACT_STAHLHART",
	"WAITING_FOR_DOCUMENTS_STAHLHART",
	"CONTACT_PARTNER",
	"WAITING_FOR_INTERVIEW",
	"SECOND_INTERVIEW_SCHEDULED",
	"WAITING_FOR_SECOND_INTERVIEW",
	"CONTRACT_PENDING",
	"WAITING_FOR_SIGNATURE",
	"HIRED",
	"TALENT_POOL",
	"NOT_REACHED_STAHLHART",
	"NOT_REACHED_PARTNER",
	"REJECTED_STAHLHART",
	"REJECTED_PARTNER",
	"REJECTED_APPLICANT"
]);
// ../db/source/schemas/enums/applicant-score-rating-db-enum.ts
var applicantScoreRatingDbEnum = pgEnum("applicant_score_rating", [
	"APPROVED",
	"PARTIAL",
	"REJECTED"
]);
// ../db/source/schemas/enums/applicant-source-type-db-enum.ts
var applicantSourceTypeDbEnum = pgEnum("applicant_source_type", [
	"SOCIAL_MEDIA_CAMPAIGN",
	"GOOGLE_ADS",
	"DIRECT_APPROACH",
	"JOB_PORTAL",
	"EMPLOYEE_REFERRAL",
	"TRADE_FAIR",
	"INTERNAL_TALENT_POOL",
	"GOOGLE_SEARCH",
	"GOOGLE_FOR_JOBS",
	"OTHER"
]);
// ../db/source/schemas/enums/career-domain-status-db-enum.ts
var careerDomainStatusDbEnum = pgEnum("career_domain_status", [
	"PENDING",
	"SUCCESS",
	"FAILED"
]);
// ../db/source/schemas/enums/career-page-publish-status-db-enum.ts
var careerPagePublishStatusDbEnum = pgEnum("career_page_publish_status", [
	"DRAFT",
	"PENDING",
	"SUCCESS",
	"FAILED"
]);
// ../db/source/schemas/enums/career-page-status-db-enum.ts
var careerPageStatusDbEnum = pgEnum("career_page_status", [
	"ACTIVE",
	"INACTIVE",
	"IN_PREPARATION",
	"NOT_BOOKED"
]);
// ../db/source/schemas/enums/country-code-db-enum.ts
var countryCodeDbEnum = pgEnum("country_code", [
	"DE",
	"AT",
	"CH"
]);
// ../db/source/schemas/enums/customer-acquisition-search-ad-status-db-enum.ts
var customerAcquisitionSearchAdStatusDbEnum = pgEnum("customer_acquisition_search_ad_status", [
	"ACTIVE",
	"IN_PREPARATION",
	"INACTIVE",
	"NOT_BOOKED"
]);
// ../db/source/schemas/enums/document-source-db-enum.ts
var documentSourceDbEnum = pgEnum("document_source", ["G_CLOUD"]);
// ../db/source/schemas/enums/document-type-db-enum.ts
var documentTypeDbEnum = pgEnum("document_type", [
	"PDF",
	"DOC",
	"DOCX",
	"TXT",
	"JPG",
	"PNG",
	"SVG"
]);
// ../db/source/schemas/enums/email-content-type-db-enum.ts
var emailContentTypeDbEnum = pgEnum("email_content_type", [
	"TEXT",
	"HTML",
	"MJML"
]);
// ../db/source/schemas/enums/email-provider-db-enum.ts
var emailProviderDbEnum = pgEnum("email_provider", [
	"GOOGLE",
	"MICROSOFT",
	"SMTP",
	"CUSTOM"
]);
// ../db/source/schemas/enums/email-target-db-enum.ts
var emailTargetDbEnum = pgEnum("email_target", [
	"CUSTOMER",
	"EMPLOYEE",
	"TRAINEE_AND_DUAL_STUDENT",
	"INTERNAL"
]);
// ../db/source/schemas/enums/font-source-db-enum.ts
var fontSourceDbEnum = pgEnum("font_source", ["G_CLOUD"]);
// ../db/source/schemas/enums/font-type-db-enum.ts
var fontTypeDbEnum = pgEnum("font_type", [
	"TTF",
	"OTF",
	"WOFF",
	"WOFF2",
	"EOT",
	"SVG"
]);
// ../db/source/schemas/enums/gender-db-enum.ts
var genderDbEnum = pgEnum("gender", [
	"FEMALE",
	"MALE",
	"DIVERSE"
]);
// ../db/source/schemas/enums/hrbaxml-last-action-db-enum.ts
var hrbaxmlLastActionDbEnum = pgEnum("hrbaxml_last_action", [
	"INSERT",
	"UPDATE",
	"DELETE"
]);
// ../db/source/schemas/enums/hrbaxml-partner-type-db-enum.ts
var hrbaxmlPartnerTypeDbEnum = pgEnum("hrbaxml_partner_type", ["employer", "job_board"]);
// ../db/source/schemas/enums/hrbaxml-sync-status-db-enum.ts
var hrbaxmlSyncStatusDbEnum = pgEnum("hrbaxml_sync_status", [
	"PENDING",
	"SYNCED",
	"ERROR",
	"DELETED"
]);
// ../db/source/schemas/enums/job-position-campaign-status-db-enum.ts
var jobPositionCampaignStatusDbEnum = pgEnum("job_position_campaign_status", [
	"ACTIVE",
	"INACTIVE",
	"IN_PREPARATION"
]);
// ../db/source/schemas/enums/job-position-potential-db-enum.ts
var jobPositionPotentialDbEnum = pgEnum("job_position_potential", [
	"NOT_CHECKED",
	"NO_POTENTIAL",
	"HAS_POTENTIAL"
]);
// ../db/source/schemas/enums/job-position-quota-guarantee-db-enum.ts
var jobPositionQuotaGuaranteeDbEnum = pgEnum("job_position_quota_guarantee", ["GRACE_PERIOD", "HIRING_GUARANTEE"]);
// ../db/source/schemas/enums/job-position-schedule-db-enum.ts
var jobPositionScheduleDbEnum = pgEnum("job_position_schedule", [
	"FULL_TIME",
	"PART_TIME",
	"RANGE"
]);
// ../db/source/schemas/enums/job-position-type-db-enum.ts
var jobPositionTypeDbEnum = pgEnum("job_position_type", [
	"TRAINEE",
	"EMPLOYEE",
	"DUAL_STUDENT"
]);
// ../db/source/schemas/enums/last-phase-change-role-db-enum.ts
var lastPhaseChangeRoleDbEnum = pgEnum("last_phase_change_role", [
	"MANAGER",
	"CUSTOMER",
	"APPLICANT_MANAGER",
	"ADMIN",
	"AUTOMATION"
]);
// ../db/source/schemas/enums/monday-recruiting-status-db-enum.ts
var mondayRecruitingStatusDbEnum = pgEnum("monday_recruiting_status", [
	"UNRESOLVED",
	"PROBLEM",
	"RESOLVED"
]);
// ../db/source/schemas/enums/oauth-error-type-db-enum.ts
var oAuthErrorTypeDbEnum = pgEnum("oauth_error_taype", ["INVALID_ACCESS_TOKEN", "INVALID_REFRESH_TOKEN"]);
// ../db/source/schemas/enums/oauth-provider-db-enum.ts
var oAuthProviderDbEnum = pgEnum("oauth_provider", ["GOOGLE", "MICROSOFT"]);
// ../db/source/schemas/enums/on-behalf-of-db-enum.ts
var onBehalfOfDbEnum = pgEnum("on_behalf_of", ["STAHLHART", "CUSTOMER"]);
// ../db/source/schemas/enums/platform-type-db-enum.ts
var platformTypeDbEnum = pgEnum("platform_type", [
	"FACEBOOK",
	"INSTAGRAM",
	"LINKEDIN",
	"TIKTOK"
]);
// ../db/source/schemas/enums/prequalification-status-db-enum.ts
var prequalificationStatusDbEnum = pgEnum("prequalification_status", [
	"APPROVED",
	"REJECTED",
	"NOT_REACHED",
	"APPROVED_WITHOUT_GUARANTEE"
]);
// ../db/source/schemas/enums/product-version-db-enum.ts
var productVersionDbEnum = pgEnum("product_version", ["V1", "V2"]);
// ../db/source/schemas/enums/salutation-db-enum.ts
var salutationDbEnum = pgEnum("salutation", ["FORMAL", "INFORMAL"]);
// ../db/source/schemas/enums/search-ad-status-db-enum.ts
var searchAdStatusDbEnum = pgEnum("search_ad_status", [
	"ACTIVE",
	"IN_PREPARATION",
	"INACTIVE",
	"NOT_BOOKED"
]);
// ../db/source/schemas/enums/smtp-port-db-enum.ts
var smtpPortDbEnum = pgEnum("smtp_port", ["465", "587"]);
// ../db/source/schemas/enums/social-media-support-status-db-enum.ts
var socialMediaSupportStatusDbEnum = pgEnum("social_media_support_status", [
	"ACTIVE",
	"IN_PREPARATION",
	"INACTIVE",
	"NOT_BOOKED"
]);
// ../db/source/schemas/enums/webhook-sources-db-enum.ts
var webhookSourcesDbEnum = pgEnum("webhook_sources", ["PERSPECTIVE", "WL_LANDING_PAGE"]);
// ../db/source/schemas/enums/website-status-db-enum.ts
var websiteStatusDbEnum = pgEnum("website_status", [
	"ACTIVE",
	"INACTIVE",
	"IN_PREPARATION",
	"NOT_BOOKED"
]);
// ../db/source/schemas/tables/applicant-phases-db-table.ts
var applicantPhasesDbTable = pgTable("applicant_phases", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	name: varchar({ length: 50 }).notNull(),
	color: varchar({ length: 10 }).notNull(),
	type: applicantPhaseTypeDbEnum().unique().notNull(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
});
// ../db/source/schemas/tables/applicant-sources-db-table.ts
var applicantSourcesDbTable = pgTable("applicant_sources", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	name: varchar({ length: 50 }).notNull(),
	color: varchar({ length: 10 }).notNull(),
	type: applicantSourceTypeDbEnum().unique().notNull(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	position: integer().notNull().default(0),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
});
// ../db/source/schemas/tables/customers-db-table.ts
var customersDbTable = pgTable("customers", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	firebase_uid: text().notNull().unique(),
	monday_item_id: text().notNull().unique(),
	email_address: text().notNull(),
	/**
	* @deprecated NPS logs are not used anymore, kept for backward compatibility and removal in future versions
	*/
	last_nps_sent_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	/**
	* @deprecated NPS logs are not used anymore, kept for backward compatibility and removal in future versions
	*/
	last_nps_score: integer(),
	is_framework_agreement: boolean().notNull().default(false),
	agreement_end: timestamp({ withTimezone: true }),
	career_page_status: careerPageStatusDbEnum().notNull().default("NOT_BOOKED"),
	career_page_end_date: timestamp({ withTimezone: true }),
	career_page_monthly_ad_budget: integer(),
	search_ad_booked: boolean().notNull().default(false),
	search_ad_end_date: timestamp({ withTimezone: true }),
	search_ad_monthly_budget: integer(),
	search_ad_status: searchAdStatusDbEnum().notNull().default("NOT_BOOKED"),
	social_media_support_booked: boolean().notNull().default(false),
	social_media_support_end_date: timestamp({ withTimezone: true }),
	social_media_total_credits: numeric({
		precision: 8,
		scale: 2
	}),
	social_media_credit_transactions: json().$type().default([]),
	social_media_monthly_ads_budget: integer(),
	social_media_monthly_post_count: integer(),
	social_media_figma_board_url: text(),
	social_media_support_status: socialMediaSupportStatusDbEnum().notNull().default("NOT_BOOKED"),
	customer_acquisition_search_ad_booked: boolean().notNull().default(false),
	customer_acquisition_search_ad_end_date: timestamp({ withTimezone: true }),
	customer_acquisition_search_ad_monthly_budget: integer(),
	customer_acquisition_search_ad_status: customerAcquisitionSearchAdStatusDbEnum().notNull().default("NOT_BOOKED"),
	project_manager: json().$type().default(null),
	is_archived: boolean().notNull().default(false),
	has_direct_approaches: boolean().notNull().default(false),
	is_commission_agreement: boolean().notNull().default(false),
	is_recruiting_agreement: boolean().notNull().default(false),
	is_career_page_receipt_confirmation_active: boolean().notNull().default(false),
	is_social_media_analytics_active: boolean().notNull().default(false),
	website_status: websiteStatusDbEnum().notNull().default("NOT_BOOKED"),
	website_end_date: timestamp({ withTimezone: true }),
	product_version: productVersionDbEnum().notNull().default("V1"),
	is_recruiting_auto_renew_active: boolean().notNull().default(false),
	is_career_page_auto_renew_active: boolean().notNull().default(false),
	is_website_auto_renew_active: boolean().notNull().default(false),
	is_social_media_support_auto_renew_active: boolean().notNull().default(false),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => {
	return {
		userIndex: uniqueIndex("user_index").on(t.firebase_uid, t.monday_item_id),
		archivedIndex: index("idx_customers_is_archived").on(t.is_archived),
		createdAtIndex: index("idx_customers_created_at").on(t.created_at)
	};
});
// ../db/source/schemas/tables/locations-db-table.ts
var locationsDbTable = pgTable("locations", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	name: text(),
	customer_id: integer().references(() => customersDbTable.id).notNull(),
	zip_code: text(),
	city: text(),
	country: countryCodeDbEnum().notNull().default("DE"),
	address: text(),
	google_maps_is_active: boolean().notNull().default(true),
	google_maps_title: text(),
	google_maps_latitude: numeric(),
	google_maps_longitude: numeric(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => {
	return { customerIdIndex: index("locations_customer_id_index").on(t.customer_id) };
});
// ../db/source/schemas/tables/work-area-db-table.ts
var workAreaDbTable = pgTable("work_area", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	customer_id: integer().references(() => customersDbTable.id).notNull(),
	name: text().notNull(),
	type: jobPositionTypeDbEnum().notNull(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => {
	return { customerIdIndex: index("work_area_customer_id_index").on(t.customer_id) };
});
// ../db/source/schemas/tables/job-position-settings-columns.ts
var jobPositionSettingsColumns = {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	customer_id: integer().references(() => customersDbTable.id).notNull(),
	/**
	* @deprecated merged into other_manager_info
	*/
	field_service_and_home_office: json().$type().default([]),
	other_manager_info: json().$type().default([]),
	training_duration: numeric({
		precision: 5,
		scale: 2
	}),
	is_flexible_internship_possible: boolean(),
	address_zip_code: text(),
	address_city: text(),
	weekly_hours: numeric({
		precision: 5,
		scale: 2
	}),
	/**
	* weekly_hours_max can be used together with weekly_hours to define a range.
	* Total of 5 digits, 2 of them are decimal places e.g. 40.12
	*/
	weekly_hours_max: numeric({
		precision: 5,
		scale: 2
	}),
	schedule: jobPositionScheduleDbEnum(),
	start_date: timestamp({ withTimezone: true }),
	shift_work: text(),
	salary: text(),
	salary_is_public: boolean(),
	/**
	* @deprecated Salutation not needed anymore, we use always "Du"
	*/
	salutation: salutationDbEnum(),
	search_area: text(),
	search_radius: integer(),
	search_center: text(),
	/**
	* Country the search_center is geocoded against. Geocoding is restricted to
	* this country, so a center without it can only be resolved in Germany.
	*/
	search_center_country: countryCodeDbEnum().default("DE"),
	cv_required: boolean(),
	cv_required_in_form: boolean(),
	email_recipients: json().$type().default([]),
	tasks: json().$type().default([]),
	benefits: json().$type().default([]),
	contact_person_name: text(),
	contact_person_position: text(),
	contact_person_email: text(),
	contact_person_salutation: genderDbEnum(),
	/**
	* @deprecated address_link is not needed anymore, instead a reference to location is used
	*/
	address_link: text(),
	trainee_first_year_salary: numeric({
		precision: 8,
		scale: 2
	}),
	trainee_second_year_salary: numeric({
		precision: 8,
		scale: 2
	}),
	trainee_third_year_salary: numeric({
		precision: 8,
		scale: 2
	}),
	trainee_fourth_year_salary: numeric({
		precision: 8,
		scale: 2
	}),
	dual_student_salary: text(),
	location_id: integer().references(() => locationsDbTable.id, { onDelete: "set null" }),
	work_area_id: integer().references(() => workAreaDbTable.id, { onDelete: "set null" }),
	type: jobPositionTypeDbEnum().notNull(),
	type_order: integer().notNull().generatedAlwaysAs(sql`CASE type WHEN 'EMPLOYEE' THEN 1 WHEN 'TRAINEE' THEN 2 ELSE 3 END`),
	/**
	* We use a JSON column for the requirements and additional_requirements to keep it simple.
	* In the future, we might want to create separate tables for this.
	* and reference them here. The data can be transferred using the jsonb_array_elements
	* function to expand the JSON array into rows, then extract the content field into
	* the content column of the new table.
	*/
	requirements: json().$type().default([]),
	additional_requirements: json().$type().default([]),
	applicant_notes_template: text(),
	documents_required_for_forwarding: boolean(),
	required_documents_description: text(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
};
// ../db/source/schemas/tables/job-positions-db-table.ts
var jobPositionsDbTable = pgTable("job_positions", {
	...jobPositionSettingsColumns,
	name: text().notNull(),
	full_name: text(),
	specialization: text(),
	university: text(),
	external_application_url: text(),
	monday_item_id: text().unique(),
	is_pre_qualified: boolean(),
	is_campaign_active: boolean().notNull().default(false),
	campaign_status: jobPositionCampaignStatusDbEnum().notNull().default("INACTIVE"),
	campaign_id: text(),
	campaign_related_job_position_names: text().array().notNull().default(sql`ARRAY[]::text[]`),
	campaign_error: text(),
	monthly_advertising_budget: integer(),
	landing_page_url: text(),
	is_campaign_expiring: boolean().notNull().default(false),
	campaign_end_date: timestamp({ withTimezone: true }),
	direct_approaches: json().$type().notNull().default([]),
	direct_approaches_error: text(),
	potential: jobPositionPotentialDbEnum(),
	is_indeed_active: boolean().notNull().default(false),
	indeed_deadline: timestamp({ withTimezone: true }),
	indeed_monthly_budget: integer(),
	is_stepstone_active: boolean().notNull().default(false),
	stepstone_deadline: timestamp({ withTimezone: true }),
	job_portal_error: text(),
	is_archived: boolean().notNull().default(false),
	career_page_active: boolean().notNull().default(false),
	/**
	* When the position was last re-advertised. Drives Google for Jobs
	* `datePosted`, which falls back to created_at while this is null.
	* Only ever set for positions that are genuinely still being hired for.
	*/
	reposted_at: timestamp({ withTimezone: true }),
	search_ad_status: searchAdStatusDbEnum().notNull().default("INACTIVE"),
	hero_image_path: text(),
	hero_video_path: text(),
	hero_video_vimeo_id: text(),
	hero_video_active: boolean().notNull().default(false),
	second_image_path: text(),
	third_image_path: text(),
	/**
	* @deprecated Fourth image is not used anymore, but kept for now in case it is needed in the future
	*/
	fourth_image_path: text(),
	is_quota_active: boolean().notNull().default(false),
	quota_end_date: timestamp({ withTimezone: true }),
	is_quota_expiring: boolean().notNull().default(false),
	quota_related_job_position_names: text().array().notNull().default(sql`ARRAY[]::text[]`),
	quota_budget: integer(),
	quota_guarantee: jobPositionQuotaGuaranteeDbEnum(),
	is_unsolicited: boolean().notNull().default(false),
	ba_sync_status: hrbaxmlSyncStatusDbEnum(),
	ba_last_action: hrbaxmlLastActionDbEnum(),
	ba_last_xml_hash: text(),
	ba_last_error_message: text(),
	ba_beruf_id: integer(),
	ba_region_code: integer(),
	ba_education_type: smallint(),
	ba_delete_count: integer().notNull().default(0)
}, (table) => ({
	nameIndex: index("job_positions_name_index").on(table.name),
	customerIdIndex: index("job_positions_customer_id_index").on(table.customer_id)
}));
// ../db/source/schemas/tables/platforms-db-table.ts
var platformsDbTable = pgTable("platforms", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	name: varchar({ length: 50 }).unique().notNull(),
	color: varchar({ length: 10 }).notNull(),
	is_outreach_possible: boolean().notNull(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
});
// ../db/source/schemas/tables/applicants-db-table.ts
var applicantsDbTable = pgTable("applicants", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	name: varchar({ length: 50 }).notNull(),
	customer_id: integer().references(() => customersDbTable.id).notNull(),
	job_position_id: integer().references(() => jobPositionsDbTable.id).notNull(),
	phase_id: integer().references(() => applicantPhasesDbTable.id).notNull(),
	is_archived: boolean().notNull().default(false),
	current_state: varchar(),
	profile: text(),
	source_id: integer().references(() => applicantSourcesDbTable.id),
	source_platform_id: integer().references(() => platformsDbTable.id),
	source_campaign: varchar(),
	source_medium: varchar(),
	source_keyword: varchar(),
	decline_reason: varchar(),
	email_address: varchar({ length: 256 }),
	phone_number: varchar({ length: 25 }),
	normalized_phone_number: varchar({ length: 25 }),
	deadline: timestamp({ withTimezone: true }),
	landing_page_version: varchar(),
	forwarded_at: timestamp({ withTimezone: true }),
	status_update_overdue_notified_at: timestamp({ withTimezone: true }),
	customer_notes: text(),
	received_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	token: text().notNull().default(sql`substring(md5(random()::text || clock_timestamp()::text) from 1 for 32)`),
	referralSource: text(),
	talent_pool_consent_given: boolean().notNull().default(false),
	share_link_with_notes: boolean().notNull().default(true),
	share_link_token: text().notNull().default(sql`substring(md5(random()::text || clock_timestamp()::text) from 1 for 32)`),
	has_customer_note_comments: boolean().notNull().default(false),
	duplicated_applicants: jsonb().$type().default(sql`'[]'::jsonb`).notNull(),
	origin: applicantOriginDbEnum().notNull().default("MANUAL"),
	prequalification_status: prequalificationStatusDbEnum(),
	last_phase_change_role: lastPhaseChangeRoleDbEnum().notNull(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (table) => {
	return {
		customerArchivedIdx: index("idx_applicants_customer_id_is_archived").on(table.customer_id, table.is_archived),
		jobPositionIdx: index("idx_applicants_job_position_id").on(table.job_position_id),
		sourceIdx: index("idx_applicants_source_id").on(table.source_id),
		createdAtIdx: index("idx_applicants_created_at").on(table.created_at),
		phaseIdx: index("idx_applicants_phase_id").on(table.phase_id)
	};
});
pgTable("applicant_documents", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	applicant_id: integer().references(() => applicantsDbTable.id, { onDelete: "cascade" }).notNull(),
	name: text().notNull(),
	source: documentSourceDbEnum().notNull(),
	file_path: varchar().notNull().unique(),
	thumbnail_path: varchar(),
	type: documentTypeDbEnum().notNull(),
	status: applicantDocumentStatusDbEnum().notNull().default("NOT_SCANNED"),
	read_at: timestamp({ withTimezone: true }).defaultNow(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (table) => {
	return {
		applicantIdIdx: index("idx_ad_applicant_id").on(table.applicant_id),
		applicantIdStatusIdx: index("idx_ad_applicant_id_status").on(table.applicant_id, table.status),
		applicantIdReadAtIdx: index("idx_ad_applicant_id_read_at").on(table.applicant_id, table.read_at)
	};
});
// ../db/source/schemas/tables/applicant-managers-db-table.ts
var applicantManagersDbTable = pgTable("applicant_managers", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	firebase_uid: text().notNull().unique(),
	email_address: text().notNull().unique(),
	name: text().notNull().unique(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => {
	return { firebaseUidIndex: index("applicant_managers_firebase_uid_index").on(t.firebase_uid) };
});
pgTable("applicant_phase_changes", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	applicant_id: integer().references(() => applicantsDbTable.id, { onDelete: "cascade" }).notNull(),
	from_phase_id: integer().references(() => applicantPhasesDbTable.id).notNull(),
	to_phase_id: integer().references(() => applicantPhasesDbTable.id).notNull(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
});
pgTable("applicant_phases_to_supported_applicant_phases", {
	phase_id: integer().references(() => applicantPhasesDbTable.id, { onDelete: "cascade" }).notNull(),
	supported_phase_id: integer().references(() => applicantPhasesDbTable.id, { onDelete: "cascade" }).notNull()
}, (t) => [primaryKey({ columns: [t.phase_id, t.supported_phase_id] })]);
pgTable("applicant_processing_states", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	applicant_id: integer().references(() => applicantsDbTable.id, { onDelete: "cascade" }).notNull().unique(),
	resolved_at: timestamp({ withTimezone: true }),
	locked_by_applicant_manager_id: integer().references(() => applicantManagersDbTable.id, { onDelete: "set null" }),
	locked_by_session_id: text(),
	locked_by_login_firebase_uid: text(),
	locked_by_login_name: text(),
	locked_by_login_photo_url: text(),
	locked_at: timestamp({ withTimezone: true }),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
});
// ../db/source/schemas/tables/score-cards-db-table.ts
var scoreCardsDbTable = pgTable("score_cards", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	job_position_id: integer().references(() => jobPositionsDbTable.id, { onDelete: "cascade" }),
	title: text().notNull(),
	description: text(),
	position: integer().notNull(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => {
	return { jobPositionIdIndex: index("score_cards_job_position_id_index").on(t.job_position_id) };
});
pgTable("applicant_scores", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	applicant_id: integer().references(() => applicantsDbTable.id, { onDelete: "cascade" }),
	score_card_id: integer().references(() => scoreCardsDbTable.id, { onDelete: "cascade" }),
	rating: applicantScoreRatingDbEnum(),
	notes: text(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => {
	return {
		applicantIdIndex: index("applicant_scores_applicant_id_index").on(t.applicant_id),
		scoreCardIdIndex: index("applicant_scores_score_card_id_index").on(t.score_card_id)
	};
});
pgTable("applicant_status_updates", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	applicant_id: integer().references(() => applicantsDbTable.id, { onDelete: "cascade" }),
	content: text().notNull(),
	follow_up_date: timestamp({ withTimezone: true }),
	follow_up_content: text(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => {
	return { applicantIdIndex: index("applicant_status_updates_applicant_id_index").on(t.applicant_id) };
});
pgTable("blocked_applicants", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	normalized_phone_number: text(),
	email: text(),
	reason: text(),
	blocked_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
});
pgTable("career_domains", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	customer_id: integer().references(() => customersDbTable.id).notNull(),
	domain: text().unique().notNull(),
	is_active: boolean().notNull().default(false),
	is_deleting: boolean().notNull().default(false),
	initial_setup_complete: boolean().notNull().default(false),
	dns_resource_records: json().$type().default([]),
	dns_status: careerDomainStatusDbEnum().notNull().default("PENDING"),
	ssl_certificate_status: careerDomainStatusDbEnum().notNull().default("PENDING"),
	load_balancer_status: careerDomainStatusDbEnum().notNull().default("PENDING"),
	load_balancer_ip: text().notNull(),
	last_dns_check_at: timestamp({ withTimezone: true }),
	analytics_id: text(),
	google_search_console_token: text(),
	google_search_console_verification_initiated_at: timestamp({ withTimezone: true }),
	google_search_console_status: careerDomainStatusDbEnum().notNull().default("PENDING"),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => {
	return {
		customerIdIndex: index("career_domains_customer_id_index").on(t.customer_id),
		analyticsIdIndex: index("career_domains_analytics_id_index").on(t.analytics_id)
	};
});
// ../db/source/schemas/tables/career-settings-db-table.ts
var pageIds = [
	"trainee",
	"jobs",
	"job-details",
	"trainee-details",
	"dual-student-details",
	"home",
	"thank-you",
	"global"
];
var sectionIds = [
	"navigation",
	"hero",
	"offeneStellen",
	"offeneAusbildungen",
	"arbeitgeberfilm",
	"azubifilm",
	"praktikum",
	"vorteile",
	"bilder",
	"testimonials",
	"unternehmensvorstellung",
	"googleMaps",
	"instagramFeed",
	"ansprechpartner",
	"faq",
	"footer",
	"detailsHero",
	"detailsBenefits",
	"detailsProfile",
	"applicationForm",
	"detailsTasks",
	"cookieBanner"
];
pgTable("career_settings", {
	id: integer("id").primaryKey().generatedAlwaysAsIdentity(),
	customer_id: integer("customer_id").notNull().unique().references(() => customersDbTable.id),
	is_active: boolean("is_active").notNull().default(false),
	publish_status: careerPagePublishStatusDbEnum().notNull().default("DRAFT"),
	publish_task_id: text("publish_task_id"),
	published_at: timestamp("published_at", { withTimezone: true }).notNull().defaultNow(),
	publish: jsonb("publish").$type().notNull(),
	general: jsonb("general").$type().notNull(),
	design: jsonb("design").$type().notNull(),
	global: jsonb("global").$type().notNull(),
	trainees: jsonb("trainees").$type().notNull(),
	jobs: jsonb("jobs").$type().notNull(),
	created_at: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => {
	return { customerIdIndex: index("career_settings_customer_id_index").on(t.customer_id) };
});
pgTable("companies", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	customer_id: integer().references(() => customersDbTable.id).unique().notNull(),
	applicant_manager_id: integer().references(() => applicantManagersDbTable.id),
	long_name: text().notNull(),
	short_name: text(),
	monday_name: text().notNull(),
	website_url: text(),
	employee_count: integer(),
	founding_year: integer(),
	description: text(),
	is_work_areas_active: boolean().notNull().default(false),
	is_trainee_work_areas_active: boolean().notNull().default(false),
	google_jobs_logo_path: text(),
	platform_credentials: json().$type().default([]),
	ceo_name: text(),
	local_court: text(),
	commercial_register_number: text(),
	zip_code: text(),
	city: text(),
	address: text(),
	design_colors: json().$type().default([]),
	resume_primary_color: text(),
	resume_primary_contrast_color: text(),
	privacy: text(),
	imprint: text(),
	logo_path: text(),
	portal_logo_path: text(),
	start_screen_image_path: text(),
	google_drive_download_url: text(),
	google_drive_upload_url: text(),
	partner_todos: json().$type().default([]),
	dynamic_recruiting: boolean().notNull().default(true),
	contact_career_page_applicants_on_behalf_of_stahlhart: boolean().notNull().default(false),
	contact_imported_and_manual_applicants_on_behalf_of_stahlhart: boolean().notNull().default(false),
	hiring_guarantee: boolean().notNull().default(true),
	hide_customer_applicant_table_columns: boolean().notNull().default(false),
	show_general_analytics_tab: boolean().notNull().default(false),
	facebook_business_id: text(),
	instagram_follower_goal: integer(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => {
	return {
		customerIdIndex: uniqueIndex("companies_customer_id_index").on(t.customer_id),
		applicantManagerIdIndex: index("companies_applicant_manager_id_index").on(t.applicant_manager_id)
	};
});
// ../db/source/schemas/tables/customer-email-signatures-db-table.ts
var customerEmailSignaturesDbTable = pgTable("customer_email_signatures", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	customer_id: integer().references(() => customersDbTable.id).notNull(),
	name: text().notNull(),
	type: emailContentTypeDbEnum().notNull(),
	signature: text().notNull(),
	is_default: boolean().notNull().default(false),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => [uniqueIndex().on(t.customer_id, t.is_default).where(eq(t.is_default, sql`true`)), index("customer_email_signatures_customer_id_index").on(t.customer_id)]);
// ../db/source/schemas/tables/oauth-tokens-table.ts
var oAuthTokensDbTable = pgTable("oauth_tokens", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	external_account_id: text().notNull(),
	customer_id: integer().references(() => customersDbTable.id).notNull(),
	email: text(),
	provider: oAuthProviderDbEnum().notNull(),
	access_token: text().notNull(),
	refresh_token: text().notNull(),
	expires_at: timestamp({ withTimezone: true }).notNull(),
	refresh_expires_at: timestamp({ withTimezone: true }),
	token_type: text(),
	refresh_in_progress: boolean().notNull().default(false),
	error_message: text(),
	error_type: oAuthErrorTypeDbEnum(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
});
// ../db/source/schemas/tables/email-providers-table.ts
var emailProvidersDbTable = pgTable("email_providers", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	customer_id: integer().references(() => customersDbTable.id).notNull(),
	with_signature: boolean().notNull().default(true),
	email: text(),
	alternative_sender: text(),
	encrypted_password: text(),
	smtp_host: text(),
	smtp_port: smtpPortDbEnum().notNull().default("465"),
	smtp_secure: boolean().notNull().default(false),
	provider: emailProviderDbEnum().notNull(),
	oauth_token_id: integer().references(() => oAuthTokensDbTable.id).unique(),
	signature_id: integer().references(() => customerEmailSignaturesDbTable.id, { onDelete: "cascade" }).notNull(),
	error_type: oAuthErrorTypeDbEnum(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => {
	return { customerIdIndex: index("email_providers_customer_id_index").on(t.customer_id) };
});
pgTable("customer_email_templates", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	customer_id: integer().references(() => customersDbTable.id).notNull(),
	name: text().notNull(),
	type: emailContentTypeDbEnum().notNull(),
	subject: text().notNull(),
	body: text().notNull(),
	key: text(),
	signature_id: integer().references(() => customerEmailSignaturesDbTable.id),
	email_provider_id: integer().references(() => emailProvidersDbTable.id),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => [uniqueIndex().on(t.customer_id, t.key), index("customer_email_templates_customer_id_index").on(t.customer_id)]);
// ../db/source/schemas/tables/email-signatures-db-table.ts
var emailSignaturesDbTable = pgTable("email_signatures", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	key: text().notNull().unique(),
	name: text().notNull(),
	type: emailContentTypeDbEnum().notNull(),
	signature: text().notNull(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
});
pgTable("email_templates", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	key: text().notNull(),
	on_behalf_of: onBehalfOfDbEnum().notNull().default("CUSTOMER"),
	name: text().notNull(),
	type: emailContentTypeDbEnum().notNull(),
	target: emailTargetDbEnum().notNull(),
	subject: text().notNull(),
	body: text().notNull(),
	signature_id: integer().references(() => emailSignaturesDbTable.id),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => [uniqueIndex().on(t.key, t.on_behalf_of)]);
pgTable("job_position_analytics", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	customer_id: integer().references(() => customersDbTable.id, { onDelete: "cascade" }).notNull(),
	job_position_id: integer().references(() => jobPositionsDbTable.id, { onDelete: "cascade" }),
	name: text(),
	fb_campaign_id: text(),
	fb_ads_analytics: json().$type().notNull().default([]),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
});
pgTable("job_position_templates", { ...jobPositionSettingsColumns }, (t) => ({ unique_type_for_customer: unique().on(t.customer_id, t.type) }));
pgTable("monday_recruiting", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	monday_item_id: text().notNull().unique(),
	job_position_name: text().notNull(),
	customer_name: text(),
	customer_monday_item_id: text(),
	account_manager: json().$type().default(null),
	marketing_manager: json().$type().default(null),
	job_position_ids: integer().array().notNull().default(sql`ARRAY[]::integer[]`),
	phase: text(),
	landing_page_url: text(),
	landing_page_wl_url: text(),
	ads_url: text(),
	monthly_advertising_budget: integer(),
	daily_advertising_budget_28_days: numeric({
		precision: 8,
		scale: 2
	}),
	daily_advertising_budget_31_days: numeric({
		precision: 8,
		scale: 2
	}),
	document_object_id: text(),
	quota_ends_at: timestamp({ withTimezone: true }),
	should_expire: boolean().notNull().default(false),
	customer_decision_freedom: text(),
	customer_document_url: text(),
	customer_agreement: text(),
	product_version: productVersionDbEnum().notNull().default("V1"),
	customer_guarantee: text(),
	subitem_monday_item_ids: text().array().notNull().default(sql`ARRAY[]::text[]`),
	/**
	* Whether the campaign was already worked through. Belongs to the
	* campaign and not to a user, since the marketing managers share one
	* account. It is not scraped from monday, so the sync leaves it alone.
	*/
	status: mondayRecruitingStatusDbEnum().notNull().default("UNRESOLVED"),
	status_changed_at: timestamp({ withTimezone: true }),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => {
	return { customerMondayItemIdIndex: index("monday_recruiting_customer_monday_item_id_index").on(t.customer_monday_item_id) };
});
pgTable("monday_settings_data", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	employee_benefits: json().$type().default([]),
	employee_requirements: json().$type().default([]),
	trainee_benefits: json().$type().default([]),
	trainee_requirements: json().$type().default([]),
	trainee_professions_and_specializations: json().$type().default([]),
	dual_student_benefits: json().$type().default([]),
	dual_student_requirements: json().$type().default([]),
	faq_employee_templates: json().$type().default([]),
	faq_trainee_templates: json().$type().default([]),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => ({ singleColumnConstraint: check("single_column_check", sql`${t.id} = 1`) }));
pgTable("recruiting_log_entries", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	monday_item_id: text().notNull(),
	happened_on: date().notNull(),
	description: text().notNull().default(""),
	/**
	* The same text with the emphasis the sheets were written with, as
	* html. Kept beside the plain text rather than replacing it, so the key
	* a row is recognized by and the comparison against the sheet keep
	* working on words alone. Null for everything written before the
	* formatting was carried over, which then renders as plain text.
	*/
	description_html: text(),
	/**
	* The "Art/Status" column. Kept as free text like the other values
	* mirrored from monday, so a label nobody told us about does not fail
	* the import.
	*/
	type: text().notNull().default(""),
	/**
	* Identifies the sheet row an entry was imported from, so importing the
	* same sheet again recognizes it even after its wording was corrected
	* here. Rows added in the portal carry no key, and postgres treats
	* those as distinct, which keeps the unique index out of their way.
	*/
	source_key: text(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => {
	return {
		mondayItemIdIndex: index("recruiting_log_entries_monday_item_id_index").on(t.monday_item_id),
		/**
		* Makes an import idempotent in the database rather than in a read
		* followed by a write, which two imports running at once would both
		* pass.
		*/
		sourceKeyIndex: uniqueIndex("recruiting_log_entries_source_key_index").on(t.monday_item_id, t.source_key)
	};
});
pgTable("scheduled_emails", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	customer_id: integer().references(() => customersDbTable.id, { onDelete: "cascade" }).notNull(),
	applicant_id: integer().references(() => applicantsDbTable.id, { onDelete: "set null" }),
	email_provider_id: integer().references(() => emailProvidersDbTable.id, { onDelete: "cascade" }).notNull(),
	subject: text().notNull(),
	body: text().notNull(),
	signature: text(),
	error: text(),
	recipients: json().$type().default([]),
	scheduled_for: timestamp({ withTimezone: true }).notNull(),
	delay_in_business_days: integer(),
	sent_at: timestamp({ withTimezone: true }),
	cloud_task_name: text(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (table) => ({ customerIdIndex: index("scheduled_emails_customer_id_index").on(table.customer_id) }));
pgTable("sms_templates", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	key: text().notNull(),
	on_behalf_of: onBehalfOfDbEnum().notNull().default("CUSTOMER"),
	name: text().notNull(),
	target: emailTargetDbEnum().notNull(),
	body: text().notNull(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => [uniqueIndex().on(t.key, t.on_behalf_of)]);
// ../db/source/schemas/tables/webhooks-db-table.ts
var webhooksDbTable = pgTable("webhooks", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	customer_id: integer().references(() => customersDbTable.id, { onDelete: "cascade" }).notNull(),
	job_position_id: integer().references(() => jobPositionsDbTable.id, { onDelete: "cascade" }),
	name: text().notNull(),
	source: webhookSourcesDbEnum().notNull(),
	token: text().unique().notNull(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
});
pgTable("webhook_events", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	webhook_id: integer().references(() => webhooksDbTable.id, { onDelete: "cascade" }).notNull(),
	payload: text(),
	processed_at: timestamp({ withTimezone: true }),
	documents_processed: boolean(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
});
pgTable("customer_fonts", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	customer_id: integer().references(() => customersDbTable.id).notNull(),
	name: text().notNull(),
	source: fontSourceDbEnum().notNull(),
	type: fontTypeDbEnum().notNull(),
	file_path: varchar().notNull().unique(),
	active_for_weight_100: boolean().notNull().default(false),
	active_for_weight_200: boolean().notNull().default(false),
	active_for_weight_300: boolean().notNull().default(false),
	active_for_weight_400: boolean().notNull().default(false),
	active_for_weight_500: boolean().notNull().default(false),
	active_for_weight_600: boolean().notNull().default(false),
	active_for_weight_700: boolean().notNull().default(false),
	active_for_weight_800: boolean().notNull().default(false),
	active_for_weight_900: boolean().notNull().default(false),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => {
	return { customerIdIndex: index("customer_fonts_customer_id_index").on(t.customer_id) };
});
pgTable("customer_analytics", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	customer_id: integer().references(() => customersDbTable.id, { onDelete: "cascade" }).notNull(),
	platform: platformTypeDbEnum().notNull(),
	type: analyticsTypeDbEnum().notNull(),
	value: integer().notNull().default(0),
	date: timestamp({ withTimezone: true }).notNull(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => {
	return {
		customerIdIndex: index("customer_analytics_customer_id_index").on(t.customer_id),
		uniqueCustomerAnalyticsPerDay: uniqueIndex("unique_customer_analytics_per_day").on(t.customer_id, t.platform, t.type, t.date)
	};
});
pgTable("hrbaxml_configs", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	customer_id: integer().references(() => customersDbTable.id).notNull().unique(),
	supplier_id: varchar({ length: 10 }),
	allianz_partner_nr: varchar({ length: 20 }),
	hiring_org_id: varchar({ length: 10 }),
	supplier_name: varchar({ length: 45 }),
	partner_type: hrbaxmlPartnerTypeDbEnum().notNull().default("employer"),
	certificate_p12_encrypted: text(),
	certificate_password_encrypted: text(),
	certificate_expires_at: timestamp({ withTimezone: true }),
	is_active: boolean().notNull().default(false),
	supervision_desired: boolean().notNull().default(false),
	sync_task_id: text(),
	last_sync_at: timestamp({ withTimezone: true }),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow(),
	updated_at: timestamp({ withTimezone: true }).notNull().defaultNow().$onUpdate(() => /* @__PURE__ */ new Date())
}, (t) => ({ customerIdIndex: index("hrbaxml_configs_customer_id_index").on(t.customer_id) }));
pgTable("hrbaxml_sync_logs", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	customer_id: integer().references(() => customersDbTable.id).notNull(),
	filename: varchar({ length: 100 }).notNull(),
	xml_file: text(),
	direction: varchar({ length: 10 }).notNull(),
	record_count: integer(),
	status: varchar({ length: 20 }).notNull(),
	error_details: jsonb(),
	http_status_code: integer(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow()
}, (t) => ({
	customerIdIndex: index("hrbaxml_sync_logs_customer_id_index").on(t.customer_id),
	createdAtIndex: index("hrbaxml_sync_logs_created_at_index").on(t.created_at)
}));
pgTable("email_logs", {
	id: integer().primaryKey().generatedAlwaysAsIdentity(),
	customer_id: integer().references(() => customersDbTable.id, { onDelete: "set null" }),
	job_position_id: integer().references(() => jobPositionsDbTable.id, { onDelete: "set null" }),
	applicant_id: integer().references(() => applicantsDbTable.id, { onDelete: "set null" }),
	email_template_key: text(),
	sender_address: text().notNull(),
	recipients: json().$type().notNull().default([]),
	subject: text().notNull(),
	mailersend_account: varchar({ length: 10 }).notNull(),
	mailersend_message_id: text(),
	status: varchar({ length: 20 }).notNull(),
	http_status_code: integer(),
	attempt_count: integer().notNull(),
	error_details: jsonb(),
	created_at: timestamp({ withTimezone: true }).notNull().defaultNow()
}, (t) => ({
	customerIdIndex: index("email_logs_customer_id_index").on(t.customer_id),
	jobPositionIdIndex: index("email_logs_job_position_id_index").on(t.job_position_id),
	applicantIdIndex: index("email_logs_applicant_id_index").on(t.applicant_id),
	createdAtIndex: index("email_logs_created_at_index").on(t.created_at)
}));
// source/validation/career-validation-schemas.ts
var designSectionValidation = MyJoi.object({
	foreground: MyJoi.object({
		color: MyJoi.string().allow("", null).optional(),
		text: MyJoi.string().allow("", null).optional()
	}).optional(),
	background: MyJoi.object({
		color: MyJoi.string().allow("", null).optional(),
		text: MyJoi.string().allow("", null).optional()
	}).optional(),
	accent: MyJoi.object({
		color: MyJoi.string().allow("", null).optional(),
		text: MyJoi.string().allow("", null).optional()
	}).optional(),
	title: MyJoi.object({
		color: MyJoi.string().allow("", null).optional(),
		text: MyJoi.string().allow("", null).optional()
	}).optional(),
	titleAccent: MyJoi.object({
		color: MyJoi.string().allow("", null).optional(),
		text: MyJoi.string().allow("", null).optional()
	}).optional(),
	button: MyJoi.object({
		color: MyJoi.string().allow("", null).optional(),
		text: MyJoi.string().allow("", null).optional()
	}).optional(),
	colorOnButton: MyJoi.object({
		color: MyJoi.string().allow("", null).optional(),
		text: MyJoi.string().allow("", null).optional()
	}).optional(),
	map: MyJoi.object({
		color: MyJoi.string().allow("", null).optional(),
		text: MyJoi.string().allow("", null).optional()
	}).optional(),
	textOnMap: MyJoi.object({
		color: MyJoi.string().allow("", null).optional(),
		text: MyJoi.string().allow("", null).optional()
	}).optional(),
	accentOnMap: MyJoi.object({
		color: MyJoi.string().allow("", null).optional(),
		text: MyJoi.string().allow("", null).optional()
	}).optional(),
	isActive: MyJoi.boolean()
}).optional();
var sharedFormAndBodyValidation = MyJoi.object({
	publish: MyJoi.object({ status: MyJoi.string().valid("jobs", "ausbildung").optional() }).default({}).optional(),
	general: MyJoi.object({
		pages: MyJoi.array().items(MyJoi.object({
			id: MyJoi.string().valid(...pageIds).optional(),
			title: MyJoi.string().trim().allow("", null).optional(),
			isActive: MyJoi.boolean().optional(),
			required: MyJoi.boolean().optional()
		})).default([]).optional(),
		sections: MyJoi.array().items(MyJoi.object({
			id: MyJoi.string().valid(...sectionIds).optional(),
			title: MyJoi.string().trim().allow("", null).optional(),
			isActive: MyJoi.boolean().optional(),
			pageId: MyJoi.string().valid(...pageIds).optional(),
			required: MyJoi.boolean().optional(),
			theme: MyJoi.string().valid("theme-a", "theme-b", "theme-c", "theme-d", "theme-e").optional()
		})).default([]).optional(),
		selectionPageText: MyJoi.string().trim().allow("", null).optional(),
		selectionPageImage: MyJoi.any().default(null).allow(null),
		isWorkAreasActive: MyJoi.boolean().empty(""),
		isTraineeWorkAreasActive: MyJoi.boolean().empty(""),
		isExternalApplicationActive: MyJoi.boolean().empty("")
	}).default({}).optional(),
	design: MyJoi.object({
		logo: MyJoi.any().default(null).allow(null),
		careerPageLogo: MyJoi.any().default(null).allow(null),
		favicon: MyJoi.any().default(null).allow(null),
		googleJobsLogo: MyJoi.any().default(null).allow(null),
		fontFamily: MyJoi.string().allow("", null).optional(),
		headers: MyJoi.object({
			uppercase: MyJoi.boolean().optional(),
			italic: MyJoi.boolean().optional(),
			colored: MyJoi.boolean().optional()
		}).optional(),
		borderRadiusButtons: MyJoi.string().valid("none", "6px", "12px", "96px").optional(),
		borderRadiusCards: MyJoi.string().valid("none", "6px", "12px").optional(),
		colors: MyJoi.object({
			sectionA: designSectionValidation,
			sectionB: designSectionValidation,
			sectionC: designSectionValidation,
			sectionD: designSectionValidation,
			sectionE: designSectionValidation,
			general: MyJoi.object({
				specialColor: MyJoi.object({
					color: MyJoi.string().allow("", null).optional(),
					text: MyJoi.string().allow("", null).optional()
				}).optional(),
				isActive: MyJoi.boolean()
			}).optional()
		}).optional(),
		background: MyJoi.object({ image: MyJoi.any().default(null).allow(null) }).optional(),
		shareImage: MyJoi.any().default(null).allow(null)
	}).default({}).optional(),
	global: MyJoi.object({
		googleMapsUrl: MyJoi.string().default(null).allow("", null).optional(),
		enableMultipleLocations: MyJoi.boolean().default(null).allow("", null).optional(),
		googleMapsEmbeds: MyJoi.array().items(MyJoi.object({
			locationId: MyJoi.number().required(),
			embedUrl: MyJoi.string().required()
		})).default([]).optional(),
		companyImage: MyJoi.object({
			active: MyJoi.boolean().optional(),
			mediaUrl: MyJoi.any().default(null).allow(null)
		}).optional(),
		companyVideo: MyJoi.object({
			active: MyJoi.boolean().optional(),
			mediaUrl: MyJoi.string().default(null).allow("", null).optional()
		}).optional(),
		facts: MyJoi.array().items(MyJoi.object({
			value: MyJoi.string().max(6).allow("", null).optional(),
			text: MyJoi.string().trim().max(20).allow("", null).optional()
		})).default([]).optional(),
		instagramUsername: MyJoi.string().default(null).allow("", null).optional()
	}).default({}).optional(),
	trainees: MyJoi.object({
		introduction: MyJoi.object({
			text: MyJoi.string().trim().allow("", null).optional(),
			logo: MyJoi.any().default(null).allow(null)
		}).optional(),
		videoUrl: MyJoi.string().default(null).allow("", null).optional(),
		internshipLogo: MyJoi.any().default(null).allow(null),
		benefits: MyJoi.array().items(MyJoi.object({
			icon: MyJoi.string().allow("", null).optional(),
			title: MyJoi.string().trim().max(30).allow("", null).optional(),
			benefits: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().max(150).allow("", null).optional() }).optional()).default([]).optional()
		})).default([]).optional(),
		images: MyJoi.array().items(MyJoi.any().default(null).allow(null)).default([]).optional(),
		testimonials: MyJoi.array().items(MyJoi.object({
			logo: MyJoi.any().default(null).allow(null),
			name: MyJoi.string().trim().max(25).allow("", null).optional(),
			position: MyJoi.string().trim().max(30).allow("", null).optional(),
			text: MyJoi.string().trim().allow("", null).optional()
		})).default([]).optional(),
		faq: MyJoi.array().items(MyJoi.object({
			question: MyJoi.string().trim().max(100).allow("", null).optional(),
			answer: MyJoi.string().trim().max(800).allow("", null).optional()
		})).default([]).optional(),
		contacts: MyJoi.object({
			name: MyJoi.string().trim().max(25).allow("", null).optional(),
			salutation: MyJoi.myString().myGender().allow("", null).optional(),
			openingHours: MyJoi.string().trim().max(50).allow("", null).optional(),
			email: MyJoi.myString().max(40).myEmailAddress().allow("", null).optional(),
			phone: MyJoi.string().allow("", null).optional(),
			logo: MyJoi.any().default(null).allow(null),
			whatsappNumber: MyJoi.myString().myNormalizedPhone().allow("", null).optional()
		}).default({}).optional(),
		isUnsolicitedJobsActive: MyJoi.boolean().optional(),
		unsolicitedJobImagePath: MyJoi.any().default(null).allow(null),
		unsolicitedJobEmailRecipients: MyJoi.alternatives().conditional("isUnsolicitedJobsActive", {
			is: false,
			then: MyJoi.array().items(MyJoi.object({ email: MyJoi.myString().myEmailAddress().required() })).max(config.jobPositionEmailRecipientLimit),
			otherwise: MyJoi.array().items(MyJoi.object({ email: MyJoi.myString().myEmailAddress().required() })).min(1).max(config.jobPositionEmailRecipientLimit).required()
		}),
		unsolicitedJobExternalApplicationUrl: MyJoi.string().empty(["", "null"]).default(null).allow(null)
	}).default({}).optional(),
	jobs: MyJoi.object().keys({
		introduction: MyJoi.object({
			text: MyJoi.string().trim().allow("", null).optional(),
			logo: MyJoi.any().default(null).allow(null)
		}).optional(),
		videoUrl: MyJoi.string().default(null).allow("", null).optional(),
		internshipLogo: MyJoi.any().default(null).allow(null),
		benefits: MyJoi.array().items(MyJoi.object({
			icon: MyJoi.string().allow("", null).optional(),
			title: MyJoi.string().trim().max(30).allow("", null).optional(),
			benefits: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().max(150).allow("", null).optional() }).optional()).default([]).optional()
		})).default([]).optional(),
		images: MyJoi.array().items(MyJoi.any().default(null).allow(null)).default([]).optional(),
		testimonials: MyJoi.array().items(MyJoi.object({
			logo: MyJoi.any().empty("").default(null).allow(null),
			name: MyJoi.string().trim().max(25).allow("", null).optional(),
			position: MyJoi.string().trim().max(30).allow("", null).optional(),
			text: MyJoi.string().trim().allow("", null).optional()
		})).default([]).optional(),
		faq: MyJoi.array().items(MyJoi.object({
			question: MyJoi.string().trim().max(100).allow("", null).optional(),
			answer: MyJoi.string().trim().max(800).allow("", null).optional()
		})).default([]).optional(),
		contacts: MyJoi.object({
			name: MyJoi.string().trim().max(25).allow("", null).optional(),
			salutation: MyJoi.myString().myGender().allow("", null).optional(),
			openingHours: MyJoi.string().trim().max(50).allow("", null).optional(),
			email: MyJoi.myString().max(40).myEmailAddress().allow("", null).optional(),
			phone: MyJoi.string().allow("", null).optional(),
			logo: MyJoi.any().default(null).allow(null),
			whatsappNumber: MyJoi.myString().myNormalizedPhone().allow("", null).optional()
		}).default({}).optional(),
		isUnsolicitedJobsActive: MyJoi.boolean().optional(),
		unsolicitedJobImagePath: MyJoi.any().default(null).allow(null),
		unsolicitedJobEmailRecipients: MyJoi.alternatives().conditional("isUnsolicitedJobsActive", {
			is: false,
			then: MyJoi.array().items(MyJoi.object({ email: MyJoi.myString().myEmailAddress().required() })).max(config.jobPositionEmailRecipientLimit),
			otherwise: MyJoi.array().items(MyJoi.object({ email: MyJoi.myString().myEmailAddress().required() })).min(1).max(config.jobPositionEmailRecipientLimit).required()
		}),
		unsolicitedJobExternalApplicationUrl: MyJoi.string().empty(["", "null"]).default(null).allow(null)
	}).default({}).optional()
}).optional();
var CareerValidationSchemas = class extends BaseValidationSchemas {
	/** GET /customers/:customerId/career */
	static getByCustomerId = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().required() }).required() }) });
	/** PUT /career-settings/by-customer-id/:id */
	static updateByCustomerId = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({
		params: MyJoi.object({ id: MyJoi.string().required() }).required(),
		form: sharedFormAndBodyValidation,
		body: sharedFormAndBodyValidation
	}) });
	/** PUT /career-settings/active/:id */
	static setActiveByCustomerId = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({
		params: MyJoi.object({ id: MyJoi.string().required() }).required(),
		form: MyJoi.object({ isActive: MyJoi.boolean().required() }).required(),
		body: MyJoi.object({ isActive: MyJoi.boolean().required() }).required()
	}) });
	/** DELETE /customers/:customerId/career */
	static delete = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({ params: MyJoi.object({ customerId: MyJoi.string().optional() }).optional() }) });
	/** POST /career-settings/:id/upload */
	static upload = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({
		params: MyJoi.object({ id: MyJoi.string().required() }).required(),
		form: MyJoi.object({ file: MyJoi.any().required() }).required(),
		body: MyJoi.object({
			field: MyJoi.string().required(),
			category: MyJoi.string().required(),
			file: MyJoi.alternatives().try(MyJoi.object({
				originalFilename: MyJoi.string().required(),
				mimetype: MyJoi.string().valid(UploadDocumentMimeTypeMap.JPG, UploadDocumentMimeTypeMap.PNG).required(),
				size: MyJoi.number().integer().max(config.largeImageFileSize).required()
			}).unknown(true).allow(null), MyJoi.string().empty(["", "null"]).default(null).allow(null))
		}).required()
	}) });
	static sendApplication = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ jobPositionId: MyJoi.number().integer().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				name: MyJoi.myString().myName().required(),
				jobPositionId: MyJoi.number().integer().empty("").required(),
				emailAddress: MyJoi.string().trim().empty("").default(null).allow(null),
				referralSource: MyJoi.string().trim().empty("").default(null).allow(null),
				phoneNumber: MyJoi.string().trim().empty("").default(null).allow(null),
				files: MyJoi.array().items(MyJoi.any()).single()
			}).required(),
			body: MyJoi.object({
				name: MyJoi.myString().myName().required(),
				jobPositionId: MyJoi.number().integer().required(),
				emailAddress: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
				phoneNumber: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
				referralSource: MyJoi.string().trim().empty("").default(null).allow(null),
				utm_source: MyJoi.string().trim().empty("").default(null).allow(null),
				utm_medium: MyJoi.string().trim().empty("").default(null).allow(null),
				utm_campaign: MyJoi.string().trim().empty("").default(null).allow(null),
				utm_keyword: MyJoi.string().trim().empty("").default(null).allow(null),
				Platzierung: MyJoi.string().trim().empty("").default(null).allow(null),
				platzierung: MyJoi.string().trim().empty("").default(null).allow(null),
				Kanal: MyJoi.string().trim().empty("").default(null).allow(null),
				kanal: MyJoi.string().trim().empty("").default(null).allow(null),
				Werbeanzeige: MyJoi.string().trim().empty("").default(null).allow(null),
				werbeanzeige: MyJoi.string().trim().empty("").default(null).allow(null),
				Keyword: MyJoi.string().trim().empty("").default(null).allow(null),
				keyword: MyJoi.string().trim().empty("").default(null).allow(null),
				files: MyJoi.array().items(MyJoi.object({
					originalFilename: MyJoi.string().required(),
					mimetype: MyJoi.string().valid(...Object.values(UploadDocumentMimeTypeMap)).required(),
					size: MyJoi.number().integer().max(config.documentFileSizeLimit).required()
				}).unknown(true)).single()
			}).custom((obj) => {
				const renames = [
					["platzierung", "Platzierung"],
					["kanal", "Kanal"],
					["werbeanzeige", "Werbeanzeige"],
					["keyword", "Keyword"]
				];
				const result = { ...obj };
				for (const [from, to] of renames) if (from in result && !(to in result)) {
					result[to] = result[from];
					delete result[from];
				} else if (from in result) delete result[from];
				return result;
			}).required()
		})
	});
};
// source/validation/company-validation-schemas.ts
var CompanyValidationSchemas = class extends BaseValidationSchemas {
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getByCompanyId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getByJobPositionId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getAll = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				longName: MyJoi.string().min(2).max(75).empty(""),
				shortName: MyJoi.string().min(2).max(50).empty("").default(null).allow(null),
				websiteUrl: MyJoi.string().uri().empty("").default(null).allow(null),
				employeeCount: MyJoi.number().myEmployeeCount().empty("").default(null).allow(null),
				foundingYear: MyJoi.number().myFoundingYear().empty("").default(null).allow(null),
				description: MyJoi.string().empty("").default(null).allow(null),
				platformCredentials: MyJoi.array().items(MyJoi.object({
					url: MyJoi.string().uri().empty("").default(null).allow(null),
					platform: MyJoi.myString().myLoginDataPlatform().required(),
					username: MyJoi.string().trim().empty("").default(null).allow(null),
					password: MyJoi.string().empty("").default(null).allow(null)
				})).required(),
				designColors: MyJoi.array().items({ color: MyJoi.string().required() }).empty("").default([]),
				logo: MyJoi.any().default(null).allow(null),
				imprint: MyJoi.string().uri().empty("").default(null).allow(null),
				privacy: MyJoi.string().uri().empty("").default(null).allow(null),
				resumePrimaryColor: MyJoi.myString().myColor().empty("").default("#000000").allow(null),
				resumePrimaryContrastColor: MyJoi.myString().myColor().empty("").default("#FFFFFF").allow(null),
				ceoName: MyJoi.string().trim().empty("").default(null).allow(null),
				localCourt: MyJoi.string().empty("").default(null).allow(null),
				commercialRegisterNumber: MyJoi.string().trim().empty("").default(null).allow(null),
				zipCode: MyJoi.string().trim().empty("").default(null).allow(null),
				city: MyJoi.string().trim().empty("").default(null).allow(null),
				address: MyJoi.string().trim().empty("").default(null).allow(null),
				contactCareerPageApplicantsOnBehalfOfStahlhart: MyJoi.boolean(),
				contactImportedAndManualApplicantsOnBehalfOfStahlhart: MyJoi.boolean(),
				hiringGuarantee: MyJoi.boolean(),
				hideCustomerApplicantTableColumns: MyJoi.boolean(),
				showGeneralAnalyticsTab: MyJoi.boolean()
			}),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			body: MyJoi.object({
				longName: MyJoi.string().min(2).max(75).empty(""),
				shortName: MyJoi.string().min(2).max(50).empty(["", "null"]).default(null).allow(null),
				websiteUrl: MyJoi.string().uri().empty(["", "null"]).default(null).allow(null),
				employeeCount: MyJoi.number().myEmployeeCount().empty(["", "null"]).default(null).allow(null),
				foundingYear: MyJoi.number().myFoundingYear().empty(["", "null"]).default(null).allow(null),
				description: MyJoi.string().empty(["", "null"]).default(null).allow(null),
				platformCredentials: validateJsonString(MyJoi.array().items(MyJoi.object({
					url: MyJoi.string().uri().empty("").default(null).allow(null),
					platform: MyJoi.myString().myLoginDataPlatform().required(),
					username: MyJoi.string().trim().empty("").default(null).allow(null),
					password: MyJoi.string().empty("").default(null).allow(null)
				})).required()),
				designColors: validateJsonString(MyJoi.array().items({ color: MyJoi.string().required() }).required()),
				logo: MyJoi.alternatives().try(MyJoi.object({
					originalFilename: MyJoi.string().required(),
					mimetype: MyJoi.string().valid(UploadDocumentMimeTypeMap.JPG, UploadDocumentMimeTypeMap.PNG, UploadDocumentMimeTypeMap.PDF, UploadDocumentMimeTypeMap.SVG).required(),
					size: MyJoi.number().integer().max(config.mediumImageFileSize).required()
				}).unknown(true).allow(null), MyJoi.string().empty(["", "null"]).default(null).allow(null)),
				imprint: MyJoi.string().uri().empty(["", "null"]).default(null).allow(null),
				privacy: MyJoi.string().uri().empty(["", "null"]).default(null).allow(null),
				resumePrimaryColor: MyJoi.myString().myColor().default("#000000").allow(null),
				resumePrimaryContrastColor: MyJoi.myString().myColor().default("#FFFFFF"),
				ceoName: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
				localCourt: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
				commercialRegisterNumber: MyJoi.string().empty(["", "null"]).default(null).allow(null),
				zipCode: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
				city: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
				address: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
				contactCareerPageApplicantsOnBehalfOfStahlhart: MyJoi.boolean(),
				contactImportedAndManualApplicantsOnBehalfOfStahlhart: MyJoi.boolean(),
				hiringGuarantee: MyJoi.boolean(),
				hideCustomerApplicantTableColumns: MyJoi.boolean(),
				showGeneralAnalyticsTab: MyJoi.boolean()
			}).required()
		})
	});
	static partialUpdate = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({
				platformCredentials: MyJoi.array().items(MyJoi.object({
					url: MyJoi.string().uri().empty("").default(null).allow(null),
					platform: MyJoi.myString().myLoginDataPlatform().required(),
					username: MyJoi.string().trim().empty("").default(null).allow(null),
					password: MyJoi.string().empty("").default(null).allow(null)
				})).optional(),
				facebookBusinessId: MyJoi.string().trim().empty("").allow(null).optional(),
				instagramFollowerGoal: MyJoi.number().integer().min(0).allow(null).optional(),
				websiteUrl: MyJoi.string().uri().empty("").allow(null).optional(),
				description: MyJoi.string().empty("").allow(null).optional()
			}).required(),
			body: MyJoi.object({ companyUpdateDto: MyJoi.object({
				platformCredentials: validateJsonString(MyJoi.array().items(MyJoi.object({
					url: MyJoi.string().uri().empty("").default(null).allow(null),
					platform: MyJoi.myString().myLoginDataPlatform().required(),
					username: MyJoi.string().trim().empty("").default(null).allow(null),
					password: MyJoi.string().empty("").default(null).allow(null)
				})).required()).optional(),
				facebookBusinessId: MyJoi.string().trim().empty("").allow(null).optional(),
				instagramFollowerGoal: MyJoi.number().integer().min(0).allow(null).optional(),
				websiteUrl: MyJoi.string().uri().empty("").allow(null).optional(),
				description: MyJoi.string().empty("").allow(null).optional()
			}).required() }).required()
		})
	});
};
// source/validation/cron-validation-schemas.ts
var CronValidationSchemas = class extends BaseValidationSchemas {
	static syncCustomersFromMonday = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static syncSettingsFromMonday = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static syncRecruitingFromMonday = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static scrapeOutdatedCustomers = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static syncJobPositionsAdsAnalytics = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static deleteOutdatedArchivedApplicants = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static verifyDomainOwnerships = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static monitor = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	/**
	* Any day of a past week, for catching up on a sunday the schedule missed.
	* Stays a plain "YYYY-MM-DD" string so the time zone of the api cannot move
	* it into the neighbouring week.
	*/
	static createWeeklyRecruitingLogEntries = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ weekOf: MyJoi.string().pattern(/^\d{4}-\d{2}-\d{2}$/) }) }) });
	static syncCustomerAnalytics = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static checkUmami = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static processHrbaxmlErrorLogs = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static syncHrbaxmlPostings = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static regenerateCareerPages = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static checkOverdueStatusUpdates = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static checkSocialMediaCreditDocuments = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static checkJobPositionQuotaEndDates = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
};
// source/validation/customer-analytics-validation-schemas.ts
var CustomerAnalyticsValidationSchemas = class extends BaseValidationSchemas {
	static getByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required(),
			queryParams: MyJoi.object({
				type: MyJoi.string().valid(...Object.values(AnalyticsType)).optional(),
				platform: MyJoi.string().valid(...Object.values(PlatformType)).optional(),
				startedAt: MyJoi.date().empty("").optional(),
				endedAt: MyJoi.date().empty("").optional()
			}).unknown(true)
		}),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			queryParams: MyJoi.object({
				type: MyJoi.string().valid(...Object.values(AnalyticsType)).optional(),
				platform: MyJoi.string().valid(...Object.values(PlatformType)).optional(),
				startedAt: MyJoi.date().empty("").optional(),
				endedAt: MyJoi.date().empty("").optional()
			}).unknown(true)
		})
	});
	static getEarliestByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
};
// source/validation/customer-email-signature-validation-schemas.ts
var CustomerEmailSignatureValidationSchemas = class extends BaseValidationSchemas {
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({
				name: MyJoi.string().trim().required(),
				signature: MyJoi.string().trim().required()
			}).required(),
			body: MyJoi.object({ customerEmailSignatureUpdateDto: MyJoi.object({
				name: MyJoi.string().trim().required(),
				signature: MyJoi.string().trim().required()
			}).required() }).required()
		})
	});
	static create = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ customerEmailSignatureCreationDto: MyJoi.object({ customerId: MyJoi.number().integer().required() }).unknown(true).required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				name: MyJoi.string().trim().required(),
				signature: MyJoi.myString().myHtmlSignature().required(),
				customerId: MyJoi.number().integer().required()
			}).required(),
			body: MyJoi.object({ customerEmailSignatureCreationDto: MyJoi.object({
				name: MyJoi.string().trim().required(),
				signature: MyJoi.myString().myHtmlSignature().required(),
				customerId: MyJoi.number().integer().required()
			}).required() }).required()
		})
	});
	static remove = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
};
// source/validation/customer-email-template-validation-schemas.ts
var CustomerEmailTemplateValidationSchemas = class extends BaseValidationSchemas {
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getByKey = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			queryParams: MyJoi.object({ key: MyJoi.string().required() }).unknown(true),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required()
		}),
		full: new ValidationSchemaCaseSet({
			queryParams: MyJoi.object({ key: MyJoi.string().required() }),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required()
		})
	});
	static getByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({
				key: MyJoi.string().required(),
				name: MyJoi.string().trim().required(),
				subject: MyJoi.string().trim().required(),
				body: MyJoi.string().trim().required(),
				signatureId: MyJoi.number().integer().empty("").allow(null),
				emailProviderId: MyJoi.alternatives().conditional("key", {
					is: MyJoi.valid(automaticJobCareerPageReceiptConfirmation.key, automaticTraineeAndDualStudentCareerPageReceiptConfirmation.key),
					then: MyJoi.number().integer().empty("").required(),
					otherwise: MyJoi.any().empty("").allow(null)
				})
			}).required(),
			body: MyJoi.object({ customerEmailTemplateUpdateDto: MyJoi.object({
				key: MyJoi.string().required(),
				name: MyJoi.string().trim().required(),
				subject: MyJoi.string().trim().required(),
				body: MyJoi.string().trim().required(),
				signatureId: MyJoi.number().integer().empty("").allow(null),
				emailProviderId: MyJoi.alternatives().conditional("key", {
					is: MyJoi.valid(automaticJobCareerPageReceiptConfirmation.key, automaticTraineeAndDualStudentCareerPageReceiptConfirmation.key),
					then: MyJoi.number().integer().empty("").required(),
					otherwise: MyJoi.any().empty("").allow(null)
				})
			}).required() }).required()
		})
	});
	static create = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ customerEmailTemplateCreationDto: MyJoi.object({ customerId: MyJoi.number().integer().required() }).unknown(true).required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				name: MyJoi.string().trim().required(),
				subject: MyJoi.string().trim().required(),
				body: MyJoi.string().trim().required(),
				signatureId: MyJoi.number().integer().empty("").allow(null),
				customerId: MyJoi.number().integer().required()
			}).required(),
			body: MyJoi.object({ customerEmailTemplateCreationDto: MyJoi.object({
				name: MyJoi.string().trim().required(),
				subject: MyJoi.string().trim().required(),
				body: MyJoi.string().trim().required(),
				signatureId: MyJoi.number().integer().empty("").allow(null),
				customerId: MyJoi.number().integer().required()
			}).required() }).required()
		})
	});
	static remove = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
};
// source/validation/customer-font-validation-schemas.ts
var CustomerFontValidationSchemas = class extends BaseValidationSchemas {
	static creation = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ customerId: MyJoi.number().integer() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ body: MyJoi.object({
			customerId: MyJoi.number().integer(),
			file: MyJoi.object({
				originalFilename: MyJoi.string().required(),
				mimetype: MyJoi.string().valid(...Object.values(FontMimeTypeMap), "application/octet-stream").required(),
				size: MyJoi.number().integer().max(config.documentFileSizeLimit).required()
			}).unknown()
		}).required() })
	});
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static rename = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({ name: MyJoi.myString().myName() }).required(),
			body: MyJoi.object({ name: MyJoi.myString().myName() }).required()
		})
	});
	static setActiveWeight = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({ key: MyJoi.string().valid("activeForWeight100", "activeForWeight200", "activeForWeight300", "activeForWeight400", "activeForWeight500", "activeForWeight600", "activeForWeight700", "activeForWeight800", "activeForWeight900").required() }).required(),
			body: MyJoi.object({ key: MyJoi.string().valid("activeForWeight100", "activeForWeight200", "activeForWeight300", "activeForWeight400", "activeForWeight500", "activeForWeight600", "activeForWeight700", "activeForWeight800", "activeForWeight900").required() }).required()
		})
	});
	static removal = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
};
// source/validation/customer-validation-schemas.ts
var CustomerValidationSchemas = class extends BaseValidationSchemas {
	static creation = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ customerCreationDto: MyJoi.object({
			emailAddress: MyJoi.myString().myEmailAddress().required(),
			password: MyJoi.string().myPassword().required(),
			mondayItemId: MyJoi.string().required()
		}).unknown(true).required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				emailAddress: MyJoi.myString().myEmailAddress().required(),
				password: MyJoi.string().myPassword().required(),
				mondayItemId: MyJoi.string().required()
			}).required(),
			body: MyJoi.object({ customerCreationDto: MyJoi.object({
				emailAddress: MyJoi.myString().myEmailAddress().required(),
				password: MyJoi.string().myPassword().required(),
				mondayItemId: MyJoi.string().required()
			}).required() }).required()
		})
	});
	static mondayEvent = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ token: MyJoi.string() }).unknown(true) }),
		full: new ValidationSchemaCaseSet({
			queryParams: MyJoi.object({ token: MyJoi.string() }),
			body: MyJoi.alternatives().try(MyJoi.object({ event: MyJoi.object({
				type: MyJoi.string().required(),
				boardId: MyJoi.number().required(),
				itemId: MyJoi.number(),
				triggerUuid: MyJoi.string().required(),
				value: MyJoi.object({ label: MyJoi.object({ text: MyJoi.string().allow(null) }).unknown(true) }).unknown(true),
				columnId: MyJoi.string().allow(null),
				pulseId: MyJoi.number().allow(null)
			}).unknown(true).required() }).unknown(true).required(), MyJoi.object({ challenge: MyJoi.string().required() }))
		})
	});
	static scrape = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.number().integer().required() }).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.number().integer().required() }).required() })
	});
	static scrapeOutdated = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.number().integer().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.number().integer().required() }).required() })
	});
	static getByCompanyId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.number().integer().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.number().integer().required() }).required() })
	});
	static getByFirebaseUid = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ firebaseUid: MyJoi.string().required() }).required() }),
		full: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ firebaseUid: MyJoi.string().required() }).required() })
	});
	static toggleCareerReceiptConfirmation = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			body: MyJoi.object({ isActive: MyJoi.boolean().required() }).unknown(true).required()
		}),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			body: MyJoi.object({ isActive: MyJoi.boolean().required() }).required()
		})
	});
	static getAll = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static getAllLight = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static getAllByApplicantManagerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ applicantManagerId: MyJoi.string().required() }).required() }),
		full: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ applicantManagerId: MyJoi.string().required() }).required() })
	});
	static syncAll = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
};
// source/validation/email-provider-validation-schemas.ts
var EmailProviderValidationSchemas = class extends BaseValidationSchemas {
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static createSmtpProvider = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({
				email: MyJoi.string().trim().required(),
				password: MyJoi.string().trim().required(),
				smtpHost: MyJoi.string().trim().required(),
				smtpPort: MyJoi.string().trim().valid(...Object.values(SmtpPort)).required(),
				smtpSecure: MyJoi.boolean().required()
			}).required(),
			body: MyJoi.object({ emailProviderCreationDto: MyJoi.object({
				email: MyJoi.string().trim().required(),
				password: MyJoi.string().trim().required(),
				smtpHost: MyJoi.string().trim().required(),
				smtpPort: MyJoi.string().trim().valid(...Object.values(SmtpPort)).required(),
				smtpSecure: MyJoi.boolean().required()
			}).required() }).required()
		})
	});
	static updateWithRelations = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({
				withSignature: MyJoi.boolean().required(),
				signature: MyJoi.string().trim().required(),
				alternativeSender: MyJoi.myString().myEmailAddress().empty("").allow(null).default(null)
			}).required(),
			body: MyJoi.object({ emailProviderUpdateDto: MyJoi.object({
				withSignature: MyJoi.boolean().required(),
				signature: MyJoi.string().trim().required(),
				alternativeSender: MyJoi.myString().myEmailAddress().empty("").allow(null).default(null)
			}).required() }).required()
		})
	});
	static remove = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
};
// source/validation/email-signature-validation-schemas.ts
var EmailSignatureValidationSchemas = class extends BaseValidationSchemas {
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getAll = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({
				name: MyJoi.string().trim().required(),
				signature: MyJoi.string().trim().min(10).required()
			}).required(),
			body: MyJoi.object({ emailSignatureUpdateDto: MyJoi.object({
				name: MyJoi.string().trim().required(),
				signature: MyJoi.string().trim().min(10).required()
			}).required() }).required()
		})
	});
};
// source/validation/email-template-validation-schemas.ts
var EmailTemplateValidationSchemas = class EmailTemplateValidationSchemas extends BaseValidationSchemas {
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getAll = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ onBehalfOf: MyJoi.string().valid(...Object.values(OnBehalfOf)) }) }) });
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({
				name: MyJoi.string().trim().required(),
				subject: MyJoi.string().trim().required(),
				body: MyJoi.string().trim().required()
			}).required(),
			body: MyJoi.object({ emailTemplateUpdateDto: MyJoi.object({
				name: MyJoi.string().trim().required(),
				subject: MyJoi.string().trim().required(),
				body: MyJoi.string().trim().required()
			}).required() }).required()
		})
	});
	static nestedObject = MyJoi.object().pattern(MyJoi.string(), MyJoi.alternatives().try(MyJoi.string().trim().empty([
		"",
		"null",
		null
	]), MyJoi.number().empty([
		"",
		"null",
		null
	]), MyJoi.date().empty([
		"",
		"null",
		null
	]), MyJoi.boolean().empty([
		"",
		"null",
		null
	]), MyJoi.object().pattern(MyJoi.string(), MyJoi.alternatives().try(MyJoi.string().trim().empty([
		"",
		"null",
		null
	]), MyJoi.number().empty([
		"",
		"null",
		null
	]), MyJoi.date().empty([
		"",
		"null",
		null
	]), MyJoi.boolean().empty([
		"",
		"null",
		null
	]), MyJoi.object().pattern(MyJoi.string(), MyJoi.alternatives().try(MyJoi.string().trim().empty([
		"",
		"null",
		null
	]), MyJoi.number().empty([
		"",
		"null",
		null
	]), MyJoi.date().empty([
		"",
		"null",
		null
	]), MyJoi.boolean().empty([
		"",
		"null",
		null
	])).optional()).empty([
		"",
		"null",
		null
	])).optional()).empty([
		"",
		"null",
		null
	])).optional()).required();
	static sendTestEmail = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({
				recipient: MyJoi.myString().myEmailAddressAllowNonAscii().required(),
				context: EmailTemplateValidationSchemas.nestedObject
			}).required(),
			body: MyJoi.object({
				recipient: MyJoi.myString().myEmailAddressAllowNonAscii().required(),
				context: EmailTemplateValidationSchemas.nestedObject
			}).required()
		})
	});
};
// source/validation/google-for-jobs-validation-schemas.ts
var GoogleForJobsValidationSchemas = class extends BaseValidationSchemas {
	static inputValues = MyJoi.object({
		type: MyJoi.myString().myJobPositionType(),
		name: MyJoi.string().trim().required().label("Stellentitel"),
		addressZipCode: MyJoi.string().trim().required().label("PLZ"),
		addressCity: MyJoi.string().trim().required().label("Stadt"),
		addressCountry: MyJoi.string().trim().label("Land"),
		id: MyJoi.number().required(),
		workingHours: MyJoi.alternatives().conditional("type", {
			is: JobPositionType.EMPLOYEE,
			then: MyJoi.number().label("Wochenstunden"),
			otherwise: MyJoi.any().forbidden().label("Wochenstunden")
		}),
		companyName: MyJoi.string().trim().required().label("Unternehmensname (Rufname)"),
		companyWebsiteUrl: MyJoi.string().trim().required().label("Link zur Unternehmenswebsite"),
		companyLogoUrl: MyJoi.string().trim().required().label("Unternehmenslogo für Google for Jobs"),
		companyDescription: MyJoi.string().trim().required().label("Unternehmensbeschreibung"),
		jobBenefits: MyJoi.string().trim().label("Vorteile"),
		skills: MyJoi.string().trim().label("Anforderungen"),
		tasks: MyJoi.string().trim().label("Aufgaben")
	}).required();
};
// source/validation/health-validation-schemas.ts
var HealthValidationSchemas = class extends BaseValidationSchemas {
	static migrations = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
};
// source/validation/hrbaxml-validation-schemas.ts
var HrbaxmlValidationSchemas = class extends BaseValidationSchemas {
	static getByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static create = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				supplierId: MyJoi.string().trim().pattern(/^[APVK][0-9]{9}$/).allow(null, "").optional(),
				supplierName: MyJoi.string().trim().max(45).allow(null, "").optional(),
				allianzPartnerNr: MyJoi.string().trim().pattern(/^[0-9]{5}$/).allow(null, "").optional(),
				hiringOrgId: MyJoi.string().trim().pattern(/^[A-Z][0-9]{3}[A-Z][0-9]{5}$/).allow(null, "").optional(),
				isActive: MyJoi.boolean().optional(),
				supervisionDesired: MyJoi.boolean().optional()
			}),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			body: MyJoi.object({ hrbaxmlConfigCreationDto: MyJoi.object({
				supplierId: MyJoi.string().trim().pattern(/^[APVK][0-9]{9}$/).allow(null, "").optional(),
				supplierName: MyJoi.string().trim().max(45).allow(null, "").optional(),
				allianzPartnerNr: MyJoi.string().trim().pattern(/^[0-9]{5}$/).allow(null, "").optional(),
				hiringOrgId: MyJoi.string().trim().pattern(/^[A-Z][0-9]{3}[A-Z][0-9]{5}$/).allow(null, "").optional(),
				supervisionDesired: MyJoi.boolean().optional()
			}).required() }).required()
		})
	});
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			body: MyJoi.object({ hrbaxmlConfigUpdateDto: MyJoi.object({
				supplierId: MyJoi.string().trim().pattern(/^[APVK][0-9]{9}$/).allow(null, "").optional(),
				supplierName: MyJoi.string().trim().max(45).allow(null, "").optional(),
				allianzPartnerNr: MyJoi.string().trim().pattern(/^[0-9]{5}$/).allow(null, "").optional(),
				hiringOrgId: MyJoi.string().trim().pattern(/^[A-Z][0-9]{3}[A-Z][0-9]{5}$/).allow(null, "").optional(),
				isActive: MyJoi.boolean().optional(),
				supervisionDesired: MyJoi.boolean().optional()
			}).required() }).required()
		})
	});
	static uploadCertificate = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				certificate: MyJoi.any().required(),
				password: MyJoi.string().required()
			}),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			body: MyJoi.object({
				password: MyJoi.string().required(),
				certificate: MyJoi.any().required()
			}).required()
		})
	});
	static proxy = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({
		params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
		queryParams: MyJoi.object({ path: MyJoi.string().optional() }).optional()
	}) });
	static syncByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getPostingSync = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getHrbaxmlByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			queryParams: MyJoi.object({ skipHashCheck: MyJoi.boolean().optional() }).optional()
		})
	});
	static updatePostingSync = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			body: MyJoi.object({ hrbaxmlPostingSyncUpdateDto: MyJoi.object({
				baSyncStatus: MyJoi.string().valid(HrbaxmlSyncStatus.PENDING, HrbaxmlSyncStatus.DELETED).optional(),
				baBerufId: MyJoi.number().integer().allow(null).optional(),
				baStatus: MyJoi.number().integer().valid(1, 2, 3).optional(),
				baRegionCode: MyJoi.number().integer().min(1).allow(null).optional(),
				baEducationType: MyJoi.number().integer().valid(0, 1).allow(null).optional()
			}).required() }).required()
		})
	});
};
// source/validation/integration-validation-schemas.ts
var calendarDayPattern = /^\d{4}-\d{2}-\d{2}$/;
var IntegrationValidationSchemas = class extends BaseValidationSchemas {
	static getCompanies = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static getCompany = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({ params: MyJoi.object({ customerId: MyJoi.number().myObjectId().required() }).required() }) });
	static getJobPositions = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ customerId: MyJoi.number().myObjectId().required() }).required() }) });
	static getJobPosition = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).required() }) });
	static getJobPositionApplicantCounts = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({
		params: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).required(),
		queryParams: MyJoi.object({
			origin: MyJoi.string().valid(...Object.values(ApplicantOrigin)).required(),
			from: MyJoi.string().pattern(calendarDayPattern),
			to: MyJoi.string().pattern(calendarDayPattern)
		}).required()
	}) });
	static upsertJobPositionWebhook = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).required() }) });
	static removeJobPositionWebhook = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).required() }) });
};
// source/validation/job-position-analytics-validation-schemas.ts
var JobPositionAnalyticsValidationSchemas = class extends BaseValidationSchemas {
	static getByJobPositionId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getReach = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({
			campaignIds: MyJoi.array().items(MyJoi.string()).required(),
			startDate: MyJoi.alternatives().try(MyJoi.string().empty(""), MyJoi.date()).required(),
			endDate: MyJoi.alternatives().try(MyJoi.string().empty(""), MyJoi.date()).required()
		}).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				campaignIds: MyJoi.array().items(MyJoi.string()).required(),
				startDate: MyJoi.alternatives().try(MyJoi.string().empty(""), MyJoi.date()).required(),
				endDate: MyJoi.alternatives().try(MyJoi.string().empty(""), MyJoi.date()).required()
			}),
			body: MyJoi.object({
				campaignIds: MyJoi.array().items(MyJoi.string()).required(),
				startDate: MyJoi.alternatives().try(MyJoi.string().empty(""), MyJoi.date()).required(),
				endDate: MyJoi.alternatives().try(MyJoi.string().empty(""), MyJoi.date()).required()
			}).required()
		})
	});
};
// source/validation/job-position-template-validation-schemas.ts
var JobPositionTemplateValidationSchemas = class extends BaseValidationSchemas {
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().required() }).unknown(true).required(),
			queryParams: MyJoi.object({ type: MyJoi.myString().myJobPositionType() }).unknown(true)
		}),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().required() }).required(),
			queryParams: MyJoi.object({ type: MyJoi.myString().myJobPositionType() }).unknown(true)
		})
	});
	static create = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ jobPositionTemplateCreationDto: MyJoi.object({ customerId: MyJoi.number().myObjectId().required() }).unknown(true).required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				customerId: MyJoi.number().myObjectId().required(),
				addressZipCode: MyJoi.string().empty("").default(null).allow(null),
				addressCity: MyJoi.string().trim().empty("").default(null).allow(null),
				weeklyHours: MyJoi.number().positive().precision(2).empty("").default(null).allow(null),
				weeklyHoursMax: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.number().positive().precision(2).empty("").default(null).allow(null),
					otherwise: MyJoi.string().trim().empty("").default(null).valid(null)
				}),
				schedule: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().valid(...Object.values(JobPositionSchedule)).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				startDate: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.date().empty("").default(null).allow(null),
					otherwise: MyJoi.string().trim().empty("").default(null).valid(null)
				}),
				shiftWork: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().trim().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				salary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().trim().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				salaryIsPublic: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.boolean().empty("").default(null).allow(null),
					otherwise: MyJoi.boolean().empty("").default(null).valid(null)
				}),
				salutation: MyJoi.string().valid(...Object.values(Salutation)).empty("").default(null).allow(null),
				searchArea: MyJoi.string().trim().empty("").default(null).allow(null),
				searchCenter: MyJoi.string().trim().empty("").default(null).allow(null),
				searchCenterCountry: MyJoi.string().valid(...Object.values(CountryCode)).empty("").default(null).allow(null),
				searchRadius: MyJoi.number().positive().empty(["", "null"]).default(null).allow(null),
				cvRequired: MyJoi.boolean().empty("").default(null).allow(null),
				cvRequiredInForm: MyJoi.boolean().empty("").default(null).allow(null),
				emailRecipients: MyJoi.array().items(MyJoi.object({ email: MyJoi.myString().myEmailAddress().required() })).max(config.jobPositionEmailRecipientLimit).required(),
				type: MyJoi.myString().myJobPositionType().required(),
				specialization: MyJoi.string().trim().empty("").default(null).valid(null),
				university: MyJoi.string().trim().empty("").default(null).valid(null),
				fieldServiceAndHomeOffice: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
					otherwise: MyJoi.any().allow(null)
				}),
				otherManagerInfo: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
				trainingDuration: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.number().positive().precision(2).empty("").default(null).allow(null),
					otherwise: MyJoi.number().empty("").default(null).valid(null)
				}),
				isFlexibleInternshipPossible: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.boolean().empty("").default(null).allow(null),
					otherwise: MyJoi.boolean().empty("").default(null).valid(null)
				}),
				requirements: MyJoi.array().items(MyJoi.object({
					value: MyJoi.string().trim().empty("").default(null).allow(null),
					isKoCriteria: MyJoi.alternatives().conditional("isPublicOnly", {
						is: true,
						then: MyJoi.forbidden(),
						otherwise: MyJoi.boolean().empty("").default(null).allow(null)
					}),
					isPublicOnly: MyJoi.boolean().required(),
					label: MyJoi.string().trim(),
					selectOptions: MyJoi.array().items(MyJoi.string().trim()),
					isProtected: MyJoi.boolean()
				})).required(),
				additionalRequirements: MyJoi.array().items(MyJoi.object({
					value: MyJoi.string().trim().empty("").default(null).allow(null),
					isKoCriteria: MyJoi.boolean().empty("").default(null).allow(null),
					isDirect: MyJoi.boolean().required(),
					label: MyJoi.string().trim(),
					selectOptions: MyJoi.array().items(MyJoi.string().trim()),
					isProtected: MyJoi.boolean()
				})).required(),
				benefits: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
				contactPersonName: MyJoi.string().trim().empty("").default(null).allow(null),
				contactPersonPosition: MyJoi.string().trim().empty("").default(null).allow(null),
				contactPersonEmail: MyJoi.myString().myEmailAddress().empty("").default(null).allow(null),
				addressLink: MyJoi.string().uri().empty("").default(null).allow(null),
				traineeFirstYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				traineeSecondYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				traineeThirdYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				traineeFourthYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				dualStudentSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.DUAL_STUDENT,
					then: MyJoi.string().trim().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				locationId: MyJoi.number().integer().empty("").default(null).allow(null),
				workAreaId: MyJoi.number().integer().empty("").default(null).allow(null),
				documentsRequiredForForwarding: MyJoi.boolean().empty(["", "null"]).default(null).allow(null),
				requiredDocumentsDescription: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null)
			}).required(),
			body: MyJoi.object({ jobPositionTemplateCreationDto: MyJoi.object({
				customerId: MyJoi.number().myObjectId().required(),
				addressZipCode: MyJoi.string().trim().allow(null),
				addressCity: MyJoi.string().trim().allow(null),
				weeklyHours: MyJoi.number().positive().precision(2).allow(null),
				weeklyHoursMax: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.number().positive().precision(2).allow(null),
					otherwise: MyJoi.valid(null)
				}),
				schedule: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().valid(...Object.values(JobPositionSchedule)).allow(null),
					otherwise: MyJoi.valid(null)
				}),
				startDate: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.date().allow(null),
					otherwise: MyJoi.valid(null)
				}),
				shiftWork: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().trim().allow(null),
					otherwise: MyJoi.valid(null)
				}),
				salary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().trim().allow(null),
					otherwise: MyJoi.valid(null)
				}),
				salaryIsPublic: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.boolean().allow(null),
					otherwise: MyJoi.valid(null)
				}),
				salutation: MyJoi.string().valid(...Object.values(Salutation)).allow(null),
				searchArea: MyJoi.string().trim().allow(null),
				searchCenter: MyJoi.string().trim().allow(null),
				searchCenterCountry: MyJoi.string().valid(...Object.values(CountryCode)).allow(null),
				searchRadius: MyJoi.number().positive().empty(["", "null"]).default(null).allow(null),
				cvRequired: MyJoi.boolean().allow(null),
				cvRequiredInForm: MyJoi.boolean().allow(null),
				emailRecipients: MyJoi.array().items(MyJoi.object({ email: MyJoi.myString().myEmailAddress().required() })).max(config.jobPositionEmailRecipientLimit).required(),
				type: MyJoi.myString().myJobPositionType().required(),
				specialization: MyJoi.allow(null),
				university: MyJoi.allow(null),
				fieldServiceAndHomeOffice: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
					otherwise: MyJoi.any().allow(null)
				}),
				otherManagerInfo: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
				trainingDuration: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.number().positive().precision(2).allow(null),
					otherwise: MyJoi.valid(null)
				}),
				isFlexibleInternshipPossible: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.boolean().allow(null),
					otherwise: MyJoi.valid(null)
				}),
				requirements: MyJoi.array().items(MyJoi.object({
					value: MyJoi.string().trim().empty("").default(null).allow(null),
					isKoCriteria: MyJoi.alternatives().conditional("isPublicOnly", {
						is: true,
						then: MyJoi.forbidden(),
						otherwise: MyJoi.boolean().empty("").default(null).allow(null)
					}),
					isPublicOnly: MyJoi.boolean().required(),
					label: MyJoi.string().trim(),
					selectOptions: MyJoi.array().items(MyJoi.string().trim()),
					isProtected: MyJoi.boolean()
				})).required(),
				additionalRequirements: MyJoi.array().items(MyJoi.object({
					value: MyJoi.string().empty("").default(null).allow(null),
					isKoCriteria: MyJoi.boolean().empty("").default(null).allow(null),
					isDirect: MyJoi.boolean().required(),
					label: MyJoi.string().trim(),
					selectOptions: MyJoi.array().items(MyJoi.string().trim()),
					isProtected: MyJoi.boolean()
				})).required(),
				benefits: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
				contactPersonName: MyJoi.string().trim().allow(null),
				contactPersonPosition: MyJoi.string().trim().allow(null),
				contactPersonEmail: MyJoi.myString().myEmailAddress().allow(null),
				addressLink: MyJoi.string().uri().allow(null),
				traineeFirstYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).allow(null),
					otherwise: MyJoi.valid(null)
				}),
				traineeSecondYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).allow(null),
					otherwise: MyJoi.valid(null)
				}),
				traineeThirdYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).allow(null),
					otherwise: MyJoi.valid(null)
				}),
				traineeFourthYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).allow(null),
					otherwise: MyJoi.valid(null)
				}),
				dualStudentSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.DUAL_STUDENT,
					then: MyJoi.string().trim().allow(null),
					otherwise: MyJoi.valid(null)
				}),
				locationId: MyJoi.number().integer().allow(null),
				workAreaId: MyJoi.number().integer().allow(null),
				documentsRequiredForForwarding: MyJoi.boolean().empty(["", "null"]).default(null).allow(null),
				requiredDocumentsDescription: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null)
			}).required() }).required()
		})
	});
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({
				addressZipCode: MyJoi.string().empty("").default(null).allow(null),
				addressCity: MyJoi.string().trim().empty("").default(null).allow(null),
				weeklyHours: MyJoi.number().positive().precision(2).empty("").default(null).allow(null),
				weeklyHoursMax: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.number().positive().precision(2).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				schedule: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().valid(...Object.values(JobPositionSchedule)).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				startDate: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.date().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				shiftWork: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().trim().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				salary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().trim().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				salaryIsPublic: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.boolean().empty("").default(null).allow(null),
					otherwise: MyJoi.boolean().empty("").default(null).valid(null)
				}),
				salutation: MyJoi.string().valid(...Object.values(Salutation)).empty("").default(null).allow(null),
				searchArea: MyJoi.string().trim().empty("").default(null).allow(null),
				searchCenter: MyJoi.string().trim().empty("").default(null).allow(null),
				searchCenterCountry: MyJoi.string().valid(...Object.values(CountryCode)).empty("").default(null).allow(null),
				searchRadius: MyJoi.number().positive().empty(["", "null"]).default(null).allow(null),
				cvRequired: MyJoi.boolean().empty("").default(null).allow(null),
				cvRequiredInForm: MyJoi.boolean().empty("").default(null).allow(null),
				emailRecipients: MyJoi.array().items(MyJoi.object({ email: MyJoi.myString().myEmailAddress().required() })).max(config.jobPositionEmailRecipientLimit).required(),
				type: MyJoi.myString().myJobPositionType().required(),
				specialization: MyJoi.string().trim().empty("").default(null).valid(null),
				university: MyJoi.string().trim().empty("").default(null).valid(null),
				fieldServiceAndHomeOffice: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
					otherwise: MyJoi.any().allow(null)
				}),
				otherManagerInfo: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
				trainingDuration: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.number().positive().precision(2).empty("").default(null).allow(null),
					otherwise: MyJoi.number().empty("").default(null).valid(null)
				}),
				isFlexibleInternshipPossible: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.boolean().empty("").default(null).allow(null),
					otherwise: MyJoi.boolean().empty("").default(null).valid(null)
				}),
				requirements: MyJoi.array().items(MyJoi.object({
					value: MyJoi.string().trim().empty("").default(null).allow(null),
					isKoCriteria: MyJoi.alternatives().conditional("isPublicOnly", {
						is: true,
						then: MyJoi.forbidden(),
						otherwise: MyJoi.boolean().empty("").default(null).allow(null)
					}),
					isPublicOnly: MyJoi.boolean().required(),
					label: MyJoi.string().trim(),
					selectOptions: MyJoi.array().items(MyJoi.string().trim()),
					isProtected: MyJoi.boolean()
				})).required(),
				additionalRequirements: MyJoi.array().items(MyJoi.object({
					value: MyJoi.string().trim().empty("").default(null).allow(null),
					isKoCriteria: MyJoi.boolean().empty("").default(null).allow(null),
					isDirect: MyJoi.boolean().required(),
					label: MyJoi.string().trim(),
					selectOptions: MyJoi.array().items(MyJoi.string().trim()),
					isProtected: MyJoi.boolean()
				})).required(),
				benefits: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
				contactPersonName: MyJoi.string().trim().empty("").default(null).allow(null),
				contactPersonPosition: MyJoi.string().trim().empty("").default(null).allow(null),
				contactPersonEmail: MyJoi.myString().myEmailAddress().empty("").default(null).allow(null),
				addressLink: MyJoi.string().uri().empty("").default(null).allow(null),
				traineeFirstYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				traineeSecondYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				traineeThirdYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				traineeFourthYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				dualStudentSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.DUAL_STUDENT,
					then: MyJoi.string().trim().empty("").trim().default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				locationId: MyJoi.number().integer().empty("").default(null).allow(null),
				workAreaId: MyJoi.number().integer().empty("").default(null).allow(null),
				documentsRequiredForForwarding: MyJoi.boolean().empty(["", "null"]).default(null).allow(null),
				requiredDocumentsDescription: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null)
			}).required(),
			body: MyJoi.object({ JobPositionTemplateUpdateDto: MyJoi.object({
				addressZipCode: MyJoi.string().trim().allow(null),
				addressCity: MyJoi.string().trim().allow(null),
				weeklyHours: MyJoi.number().positive().precision(2).allow(null),
				weeklyHoursMax: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.number().positive().precision(2).allow(null),
					otherwise: MyJoi.valid(null)
				}),
				schedule: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().valid(...Object.values(JobPositionSchedule)).allow(null),
					otherwise: MyJoi.valid(null)
				}),
				startDate: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.date().allow(null),
					otherwise: MyJoi.valid(null)
				}),
				shiftWork: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().trim().allow(null),
					otherwise: MyJoi.valid(null)
				}),
				salary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().trim().allow(null),
					otherwise: MyJoi.valid(null)
				}),
				salaryIsPublic: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.boolean().allow(null),
					otherwise: MyJoi.valid(null)
				}),
				salutation: MyJoi.string().valid(...Object.values(Salutation)).allow(null),
				searchArea: MyJoi.string().trim().allow(null),
				searchCenter: MyJoi.string().trim().allow(null),
				searchCenterCountry: MyJoi.string().valid(...Object.values(CountryCode)).allow(null),
				searchRadius: MyJoi.number().positive().empty(["", "null"]).default(null).allow(null),
				cvRequired: MyJoi.boolean().allow(null),
				cvRequiredInForm: MyJoi.boolean().allow(null),
				emailRecipients: MyJoi.array().items(MyJoi.object({ email: MyJoi.myString().myEmailAddress().required() })).max(config.jobPositionEmailRecipientLimit).required(),
				type: MyJoi.myString().myJobPositionType().required(),
				specialization: MyJoi.allow(null),
				university: MyJoi.allow(null),
				fieldServiceAndHomeOffice: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
					otherwise: MyJoi.any().allow(null)
				}),
				otherManagerInfo: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
				trainingDuration: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.number().positive().precision(2),
					otherwise: MyJoi.any().allow(null)
				}),
				isFlexibleInternshipPossible: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.boolean(),
					otherwise: MyJoi.any().allow(null)
				}),
				requirements: MyJoi.array().items(MyJoi.object({
					value: MyJoi.string().trim().empty("").default(null).allow(null),
					isKoCriteria: MyJoi.alternatives().conditional("isPublicOnly", {
						is: true,
						then: MyJoi.forbidden(),
						otherwise: MyJoi.boolean().empty("").default(null).allow(null)
					}),
					isPublicOnly: MyJoi.boolean().required(),
					label: MyJoi.string().trim(),
					selectOptions: MyJoi.array().items(MyJoi.string().trim()),
					isProtected: MyJoi.boolean()
				})).required(),
				additionalRequirements: MyJoi.array().items(MyJoi.object({
					value: MyJoi.string().trim().empty("").default(null).allow(null),
					isKoCriteria: MyJoi.boolean().empty("").default(null).allow(null),
					isDirect: MyJoi.boolean().required(),
					label: MyJoi.string().trim(),
					selectOptions: MyJoi.array().items(MyJoi.string().trim()),
					isProtected: MyJoi.boolean()
				})).required(),
				benefits: MyJoi.array().items(MyJoi.object({ content: MyJoi.myString().myEmailAddress().required() })).required(),
				contactPersonName: MyJoi.string().trim().allow(null),
				contactPersonPosition: MyJoi.string().trim().allow(null),
				contactPersonEmail: MyJoi.myString().myEmailAddress().allow(null),
				addressLink: MyJoi.string().uri().allow(null),
				traineeFirstYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).allow(null),
					otherwise: MyJoi.valid(null)
				}),
				traineeSecondYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).allow(null),
					otherwise: MyJoi.valid(null)
				}),
				traineeThirdYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).allow(null),
					otherwise: MyJoi.valid(null)
				}),
				traineeFourthYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).allow(null),
					otherwise: MyJoi.valid(null)
				}),
				dualStudentSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.DUAL_STUDENT,
					then: MyJoi.string().allow(null),
					otherwise: MyJoi.valid(null)
				}),
				locationId: MyJoi.number().integer().allow(null),
				workAreaId: MyJoi.number().integer().allow(null),
				documentsRequiredForForwarding: MyJoi.boolean().empty(["", "null"]).default(null).allow(null),
				requiredDocumentsDescription: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null)
			}).required() }).required()
		})
	});
	static removal = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
};
// source/validation/job-position-validation-schemas.ts
var JobPositionValidationSchemas = class extends BaseValidationSchemas {
	static removal = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getAll = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ customerId: MyJoi.string().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ customerId: MyJoi.string().required() }).required() })
	});
	static getAllByApplicantManagerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static searchSalary = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({
			searchText: MyJoi.string().required(),
			page: MyJoi.number().integer().min(1).required(),
			pageSize: MyJoi.number().integer().min(1).max(100).required()
		}).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({
			searchText: MyJoi.string().required(),
			page: MyJoi.number().integer().min(1).required(),
			pageSize: MyJoi.number().integer().min(1).max(100).required()
		}).required() })
	});
	static create = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ customerId: MyJoi.number().integer().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				name: MyJoi.myString().min(2).max(30).required(),
				fullName: MyJoi.myString().myName().empty("").default(null).allow(null),
				isPreQualified: MyJoi.boolean().required(),
				addressZipCode: MyJoi.string().empty("").default(null).allow(null),
				addressCity: MyJoi.string().trim().empty("").default(null).allow(null),
				weeklyHours: MyJoi.number().positive().precision(2).empty("").default(null).allow(null),
				weeklyHoursMax: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.number().positive().precision(2).empty("").default(null).allow(null),
					otherwise: MyJoi.number().empty("").default(null).allow(null)
				}),
				schedule: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().valid(...Object.values(JobPositionSchedule)).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null)
				}),
				startDate: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.date().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null)
				}),
				shiftWork: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().trim().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null)
				}),
				salary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().trim().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null)
				}),
				salaryIsPublic: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.boolean().empty("").default(null).allow(null),
					otherwise: MyJoi.boolean().empty([
						"",
						"null",
						true,
						false
					]).default(null).valid(null)
				}),
				salutation: MyJoi.string().valid(...Object.values(Salutation)).empty("").default(null).allow(null),
				searchArea: MyJoi.string().trim().empty("").default(null).allow(null),
				searchCenter: MyJoi.string().trim().empty("").default(null).allow(null),
				searchCenterCountry: MyJoi.string().valid(...Object.values(CountryCode)).empty("").default(null).allow(null),
				searchRadius: MyJoi.number().positive().empty(["", "null"]).default(null).allow(null),
				cvRequired: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.alternatives().conditional("type", {
						is: JobPositionType.EMPLOYEE,
						then: MyJoi.boolean().required(),
						otherwise: MyJoi.string().empty("").default(null)
					}),
					otherwise: MyJoi.boolean().empty("").default(null)
				}),
				cvRequiredInForm: MyJoi.alternatives().conditional("isPreQualified", {
					is: false,
					then: MyJoi.alternatives().conditional("type", {
						is: JobPositionType.EMPLOYEE,
						then: MyJoi.boolean().required(),
						otherwise: MyJoi.boolean().empty("").default(null)
					}),
					otherwise: MyJoi.boolean().empty("").default(null)
				}),
				emailRecipients: MyJoi.array().items(MyJoi.object({ email: MyJoi.myString().myEmailAddress().required() })).min(1).max(config.jobPositionEmailRecipientLimit).required(),
				type: MyJoi.myString().myJobPositionType().required(),
				specialization: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.string().trim().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null)
				}),
				university: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.DUAL_STUDENT,
					then: MyJoi.string().trim().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null)
				}),
				fieldServiceAndHomeOffice: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.alternatives().conditional("isPreQualified", {
						is: true,
						then: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
						otherwise: MyJoi.array()
					}),
					otherwise: MyJoi.array()
				}),
				otherManagerInfo: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
					otherwise: MyJoi.array()
				}),
				trainingDuration: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.number().positive().precision(2).empty("").default(null).allow(null),
					otherwise: MyJoi.number().empty("").default(null)
				}),
				isFlexibleInternshipPossible: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.boolean().required(),
					otherwise: MyJoi.boolean().empty("").default(null)
				}),
				requirements: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.array().items(MyJoi.object({
						value: MyJoi.string().trim().required(),
						isKoCriteria: MyJoi.alternatives().conditional("isPublicOnly", {
							is: true,
							then: MyJoi.forbidden(),
							otherwise: MyJoi.boolean().required()
						}),
						isPublicOnly: MyJoi.boolean().required(),
						label: MyJoi.string().trim().empty(""),
						selectOptions: MyJoi.array().items(MyJoi.string().trim()),
						isProtected: MyJoi.boolean()
					})).required(),
					otherwise: MyJoi.array().items(MyJoi.object({
						value: MyJoi.string().trim().required(),
						isKoCriteria: MyJoi.boolean().allow(null),
						isPublicOnly: MyJoi.boolean().required(),
						label: MyJoi.string().trim().empty(""),
						selectOptions: MyJoi.array().items(MyJoi.string().trim()),
						isProtected: MyJoi.boolean()
					})).required()
				}),
				additionalRequirements: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.array().items(MyJoi.object({
						value: MyJoi.string().trim().required(),
						isKoCriteria: MyJoi.boolean().required(),
						isDirect: MyJoi.boolean().required(),
						label: MyJoi.string().trim().empty(""),
						selectOptions: MyJoi.array().items(MyJoi.string().trim()),
						isProtected: MyJoi.boolean()
					})).required(),
					otherwise: MyJoi.array()
				}),
				tasks: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
				benefits: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
				contactPersonName: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.string().trim().required(),
					otherwise: MyJoi.string().empty("").default(null)
				}),
				contactPersonPosition: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.string().trim().required(),
					otherwise: MyJoi.string().empty("").default(null)
				}),
				contactPersonEmail: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.myString().myEmailAddress().required(),
					otherwise: MyJoi.string().empty("").default(null)
				}),
				addressLink: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.string().uri().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null)
				}),
				externalApplicationUrl: MyJoi.string().uri().empty("").default(null).allow(null),
				potential: MyJoi.string().valid(...Object.values(JobPositionPotential)).empty("").default(null).allow(null),
				traineeFirstYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty("").default(null).allow(null),
					otherwise: MyJoi.number().empty("").default(null)
				}),
				traineeSecondYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty("").default(null).allow(null),
					otherwise: MyJoi.number().empty("").default(null)
				}),
				traineeThirdYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty("").default(null).allow(null),
					otherwise: MyJoi.number().empty("").default(null)
				}),
				traineeFourthYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty("").default(null).allow(null),
					otherwise: MyJoi.number().empty("").default(null)
				}),
				dualStudentSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.DUAL_STUDENT,
					then: MyJoi.string().trim().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null)
				}),
				locationId: MyJoi.number().integer().empty("").default(null).allow(null),
				workAreaId: MyJoi.number().integer().empty("").default(null).allow(null),
				isArchived: MyJoi.boolean(),
				documentsRequiredForForwarding: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.alternatives().conditional("type", {
						is: JobPositionType.EMPLOYEE,
						then: MyJoi.string().empty("").default(null),
						otherwise: MyJoi.boolean().required()
					}),
					otherwise: MyJoi.boolean().empty("").default(null)
				}),
				requiredDocumentsDescription: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.alternatives().conditional("documentsRequiredForForwarding", {
						is: true,
						then: MyJoi.string().empty(["", "null"]).required(),
						otherwise: MyJoi.string().trim().empty(["", "null"]).default(null)
					}),
					otherwise: MyJoi.string().trim().empty(["", "null"]).default(null)
				}),
				heroImage: MyJoi.any().empty(["", "null"]).allow(null),
				heroVideo: MyJoi.any().empty(["", "null"]).allow(null),
				heroVideoVimeoId: MyJoi.string().empty(["", "null"]).default(null).allow(null),
				heroVideoActive: MyJoi.boolean(),
				secondImage: MyJoi.any().empty(["", "null"]).allow(null),
				thirdImage: MyJoi.any().empty(["", "null"]).allow(null)
			}).required(),
			body: MyJoi.object({
				customerId: MyJoi.number().integer().required(),
				name: MyJoi.myString().min(2).max(30).required(),
				fullName: MyJoi.myString().myName().empty(["", "null"]).default(null).allow(null),
				isPreQualified: MyJoi.boolean().required(),
				addressZipCode: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
				addressCity: MyJoi.string().trim().allow(null),
				weeklyHours: MyJoi.number().positive().precision(2).empty(["", "null"]).default(null).allow(null),
				weeklyHoursMax: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.number().positive().precision(2).empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				schedule: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().valid(...Object.values(JobPositionSchedule)).empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				startDate: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.date().empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				shiftWork: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				salary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				salaryIsPublic: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.boolean().empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				salutation: MyJoi.string().valid(...Object.values(Salutation)).empty(["", "null"]).default(null).allow(null),
				searchArea: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
				searchCenter: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
				searchCenterCountry: MyJoi.string().valid(...Object.values(CountryCode)).empty(["", "null"]).default(null).allow(null),
				searchRadius: MyJoi.number().positive().empty(["", "null"]).default(null).allow(null),
				cvRequired: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.alternatives().conditional("type", {
						is: JobPositionType.EMPLOYEE,
						then: MyJoi.boolean().required(),
						otherwise: MyJoi.any().custom(() => null).default(null)
					}),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				cvRequiredInForm: MyJoi.alternatives().conditional("isPreQualified", {
					is: false,
					then: MyJoi.alternatives().conditional("type", {
						is: JobPositionType.EMPLOYEE,
						then: MyJoi.boolean().required(),
						otherwise: MyJoi.any().custom(() => null).default(null)
					}),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				emailRecipients: validateJsonString(MyJoi.array().items(MyJoi.object({ email: MyJoi.myString().myEmailAddress().required() })).min(1).max(config.jobPositionEmailRecipientLimit).required()),
				type: MyJoi.myString().myJobPositionType().required(),
				specialization: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				university: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.DUAL_STUDENT,
					then: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				fieldServiceAndHomeOffice: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.alternatives().conditional("isPreQualified", {
						is: true,
						then: validateJsonString(MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required()),
						otherwise: validateJsonString(MyJoi.any().custom(() => []).default([]))
					}),
					otherwise: validateJsonString(MyJoi.any().custom(() => []).default([]))
				}),
				otherManagerInfo: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: validateJsonString(MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required()),
					otherwise: validateJsonString(MyJoi.any().custom(() => []).default([]))
				}),
				trainingDuration: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.number().positive().precision(2).empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				isFlexibleInternshipPossible: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.boolean().required(),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				requirements: validateJsonString(MyJoi.array().items(MyJoi.object({
					value: MyJoi.string().trim().required(),
					isKoCriteria: MyJoi.boolean().allow(null),
					isPublicOnly: MyJoi.boolean().required(),
					label: MyJoi.string().trim(),
					selectOptions: MyJoi.array().items(MyJoi.string().trim()),
					isProtected: MyJoi.boolean()
				})).required()),
				additionalRequirements: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: validateJsonString(MyJoi.array().items(MyJoi.object({
						value: MyJoi.string().trim().required(),
						isKoCriteria: MyJoi.boolean().required(),
						isDirect: MyJoi.boolean().required(),
						label: MyJoi.string().trim().empty(""),
						selectOptions: MyJoi.array().items(MyJoi.string().trim()),
						isProtected: MyJoi.boolean()
					})).required()),
					otherwise: validateJsonString(MyJoi.any().custom(() => []).default([]))
				}),
				tasks: validateJsonString(MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required()),
				benefits: validateJsonString(MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required()),
				contactPersonName: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.string().trim().required(),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				contactPersonPosition: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.string().trim().required(),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				contactPersonEmail: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.myString().myEmailAddress().required(),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				addressLink: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.string().uri().empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				externalApplicationUrl: MyJoi.string().uri().empty(["", "null"]).default(null).allow(null),
				potential: MyJoi.string().valid(...Object.values(JobPositionPotential)).empty(["", "null"]).default(null).allow(null),
				traineeFirstYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				traineeSecondYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				traineeThirdYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				traineeFourthYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				dualStudentSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.DUAL_STUDENT,
					then: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				locationId: MyJoi.number().integer().empty(["", "null"]).default(null).allow(null),
				workAreaId: MyJoi.number().integer().empty(["", "null"]).default(null).allow(null),
				isArchived: MyJoi.boolean(),
				documentsRequiredForForwarding: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.alternatives().conditional("type", {
						is: JobPositionType.EMPLOYEE,
						then: MyJoi.any().custom(() => null).default(null),
						otherwise: MyJoi.boolean().required()
					}),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				requiredDocumentsDescription: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.alternatives().conditional("documentsRequiredForForwarding", {
						is: true,
						then: MyJoi.string().trim().empty(["", "null"]).required(),
						otherwise: MyJoi.string().trim().empty(["", "null"]).default(null)
					}),
					otherwise: MyJoi.string().trim().empty(["", "null"]).default(null)
				}),
				heroImage: MyJoi.alternatives().try(MyJoi.object({
					originalFilename: MyJoi.string().required(),
					mimetype: MyJoi.string().valid(UploadDocumentMimeTypeMap.JPG, UploadDocumentMimeTypeMap.PNG).required(),
					size: MyJoi.number().integer().max(config.largeImageFileSize).required()
				}).unknown(true).allow(null), MyJoi.string().empty([""]).custom((value) => value === "null" ? null : value).allow(null)),
				heroVideo: MyJoi.alternatives().try(MyJoi.object({
					originalFilename: MyJoi.string().required(),
					mimetype: MyJoi.string().valid(UploadDocumentMimeTypeMap.JPG, UploadDocumentMimeTypeMap.PNG).required(),
					size: MyJoi.number().integer().max(config.largeImageFileSize).required()
				}).unknown(true).allow(null), MyJoi.string().empty([""]).custom((value) => value === "null" ? null : value).allow(null)),
				heroVideoVimeoId: MyJoi.string().empty([""]).custom((value) => value === "null" ? null : value).allow(null),
				heroVideoActive: MyJoi.boolean(),
				secondImage: MyJoi.alternatives().try(MyJoi.object({
					originalFilename: MyJoi.string().required(),
					mimetype: MyJoi.string().valid(UploadDocumentMimeTypeMap.JPG, UploadDocumentMimeTypeMap.PNG).required(),
					size: MyJoi.number().integer().max(config.largeImageFileSize).required()
				}).unknown(true).allow(null), MyJoi.string().empty([""]).custom((value) => value === "null" ? null : value).allow(null)),
				thirdImage: MyJoi.alternatives().try(MyJoi.object({
					originalFilename: MyJoi.string().required(),
					mimetype: MyJoi.string().valid(UploadDocumentMimeTypeMap.JPG, UploadDocumentMimeTypeMap.PNG).required(),
					size: MyJoi.number().integer().max(config.largeImageFileSize).required()
				}).unknown(true).allow(null), MyJoi.string().empty([""]).custom((value) => value === "null" ? null : value).allow(null))
			}).required()
		})
	});
	static partialUpdate = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({
				careerPageActive: MyJoi.boolean(),
				searchAdStatus: MyJoi.myString().mySearchAdStatus(),
				potential: MyJoi.myString().myJobPositionPotential(),
				applicantNotesTemplate: MyJoi.string().trim().empty("").default(null).allow(null)
			}).required(),
			body: MyJoi.object({ jobPositionUpdateDto: MyJoi.object({
				careerPageActive: MyJoi.boolean(),
				searchAdStatus: MyJoi.myString().mySearchAdStatus(),
				potential: MyJoi.myString().myJobPositionPotential(),
				applicantNotesTemplate: MyJoi.string().empty("").default(null).allow(null)
			}).required() }).required()
		})
	});
	static mediaUpdate = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({
				heroImage: MyJoi.any().empty(["", "null"]).allow(null),
				heroVideo: MyJoi.any().empty(["", "null"]).allow(null),
				heroVideoVimeoId: MyJoi.string().empty(["", "null"]).default(null).allow(null),
				heroVideoActive: MyJoi.boolean(),
				secondImage: MyJoi.any().empty(["", "null"]).allow(null),
				thirdImage: MyJoi.any().empty(["", "null"]).allow(null)
			}).required(),
			body: MyJoi.object({
				heroImage: MyJoi.alternatives().try(MyJoi.object({
					originalFilename: MyJoi.string().required(),
					mimetype: MyJoi.string().valid(UploadDocumentMimeTypeMap.JPG, UploadDocumentMimeTypeMap.PNG).required(),
					size: MyJoi.number().integer().max(config.largeImageFileSize).required()
				}).unknown(true).allow(null), MyJoi.string().empty([""]).custom((value) => value === "null" ? null : value).allow(null)),
				heroVideo: MyJoi.alternatives().try(MyJoi.object({
					originalFilename: MyJoi.string().required(),
					mimetype: MyJoi.string().valid(UploadDocumentMimeTypeMap.JPG, UploadDocumentMimeTypeMap.PNG).required(),
					size: MyJoi.number().integer().max(config.largeImageFileSize).required()
				}).unknown(true).allow(null), MyJoi.string().empty([""]).custom((value) => value === "null" ? null : value).allow(null)),
				heroVideoVimeoId: MyJoi.string().empty([""]).custom((value) => value === "null" ? null : value).allow(null),
				heroVideoActive: MyJoi.boolean(),
				secondImage: MyJoi.alternatives().try(MyJoi.object({
					originalFilename: MyJoi.string().required(),
					mimetype: MyJoi.string().valid(UploadDocumentMimeTypeMap.JPG, UploadDocumentMimeTypeMap.PNG).required(),
					size: MyJoi.number().integer().max(config.largeImageFileSize).required()
				}).unknown(true).allow(null), MyJoi.string().empty([""]).custom((value) => value === "null" ? null : value).allow(null)),
				thirdImage: MyJoi.alternatives().try(MyJoi.object({
					originalFilename: MyJoi.string().required(),
					mimetype: MyJoi.string().valid(UploadDocumentMimeTypeMap.JPG, UploadDocumentMimeTypeMap.PNG).required(),
					size: MyJoi.number().integer().max(config.largeImageFileSize).required()
				}).unknown(true).allow(null), MyJoi.string().empty([""]).custom((value) => value === "null" ? null : value).allow(null))
			}).required()
		})
	});
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({
				name: MyJoi.myString().min(2).max(30).required(),
				fullName: MyJoi.myString().myName().empty("").default(null).allow(null),
				isPreQualified: MyJoi.boolean().required(),
				addressZipCode: MyJoi.string().trim().empty("").default(null).allow(null),
				addressCity: MyJoi.string().trim().empty("").default(null).allow(null),
				weeklyHours: MyJoi.number().positive().precision(2).empty("").default(null).allow(null),
				weeklyHoursMax: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.number().positive().precision(2).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				schedule: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().valid(...Object.values(JobPositionSchedule)).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				startDate: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.date().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				shiftWork: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().trim().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				salary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().trim().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				salaryIsPublic: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.boolean().empty("").default(null).allow(null),
					otherwise: MyJoi.boolean().empty([
						"",
						"null",
						true,
						false
					]).default(null).valid(null)
				}),
				salutation: MyJoi.string().valid(...Object.values(Salutation)).empty("").default(null).allow(null),
				searchArea: MyJoi.string().trim().empty("").default(null).allow(null),
				searchCenter: MyJoi.string().trim().empty("").default(null).allow(null),
				searchCenterCountry: MyJoi.string().valid(...Object.values(CountryCode)).empty("").default(null).allow(null),
				searchRadius: MyJoi.number().positive().empty(["", "null"]).default(null).allow(null),
				cvRequired: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.alternatives().conditional("type", {
						is: JobPositionType.EMPLOYEE,
						then: MyJoi.boolean().required(),
						otherwise: MyJoi.string().empty("").default(null).valid(null)
					}),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				cvRequiredInForm: MyJoi.alternatives().conditional("isPreQualified", {
					is: false,
					then: MyJoi.alternatives().conditional("type", {
						is: JobPositionType.EMPLOYEE,
						then: MyJoi.boolean().required(),
						otherwise: MyJoi.string().empty("").default(null).valid(null)
					}),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				emailRecipients: MyJoi.array().items(MyJoi.object({ email: MyJoi.myString().myEmailAddress().required() })).min(1).max(config.jobPositionEmailRecipientLimit).required(),
				type: MyJoi.myString().myJobPositionType().required(),
				specialization: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.string().trim().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				university: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.DUAL_STUDENT,
					then: MyJoi.string().trim().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				fieldServiceAndHomeOffice: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.alternatives().conditional("isPreQualified", {
						is: true,
						then: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
						otherwise: MyJoi.myArray().myEmptyArray()
					}),
					otherwise: MyJoi.myArray().myEmptyArray()
				}),
				otherManagerInfo: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
					otherwise: MyJoi.myArray().myEmptyArray()
				}),
				trainingDuration: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.number().positive().precision(2).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				isFlexibleInternshipPossible: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.boolean().required(),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				requirements: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.array().items(MyJoi.object({
						value: MyJoi.string().trim().required(),
						isKoCriteria: MyJoi.alternatives().conditional("isPublicOnly", {
							is: true,
							then: MyJoi.forbidden(),
							otherwise: MyJoi.boolean().required()
						}),
						isPublicOnly: MyJoi.boolean().required(),
						label: MyJoi.string().trim().empty(""),
						selectOptions: MyJoi.array().items(MyJoi.string().trim()),
						isProtected: MyJoi.boolean()
					})).required(),
					otherwise: MyJoi.array().items(MyJoi.object({
						value: MyJoi.string().trim().required(),
						isKoCriteria: MyJoi.boolean().allow(null),
						isPublicOnly: MyJoi.boolean().required(),
						label: MyJoi.string().trim().empty(""),
						selectOptions: MyJoi.array().items(MyJoi.string().trim()),
						isProtected: MyJoi.boolean()
					})).required()
				}),
				additionalRequirements: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.array().items(MyJoi.object({
						value: MyJoi.string().trim().required(),
						isKoCriteria: MyJoi.boolean().required(),
						isDirect: MyJoi.boolean().required(),
						label: MyJoi.string().trim().empty(""),
						selectOptions: MyJoi.array().items(MyJoi.string().trim()),
						isProtected: MyJoi.boolean()
					})).required(),
					otherwise: MyJoi.any().custom(() => [], "map to empty array")
				}),
				tasks: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
				benefits: MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required(),
				contactPersonName: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.string().trim().required(),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				contactPersonPosition: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.string().trim().required(),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				contactPersonEmail: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.myString().myEmailAddress().required(),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				addressLink: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.string().uri().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				externalApplicationUrl: MyJoi.string().uri().empty("").default(null).allow(null),
				potential: MyJoi.string().valid(...Object.values(JobPositionPotential)).empty("").default(null).allow(null),
				traineeFirstYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				traineeSecondYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				traineeThirdYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				traineeFourthYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				dualStudentSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.DUAL_STUDENT,
					then: MyJoi.string().trim().empty("").default(null).allow(null),
					otherwise: MyJoi.string().empty("").default(null).valid(null)
				}),
				locationId: MyJoi.number().integer().empty("").default(null).allow(null),
				workAreaId: MyJoi.number().integer().empty("").default(null).allow(null),
				isArchived: MyJoi.boolean(),
				documentsRequiredForForwarding: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.alternatives().conditional("type", {
						is: JobPositionType.EMPLOYEE,
						then: MyJoi.string().empty("").default(null),
						otherwise: MyJoi.boolean().required()
					}),
					otherwise: MyJoi.boolean().empty("").default(null)
				}),
				requiredDocumentsDescription: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.alternatives().conditional("documentsRequiredForForwarding", {
						is: true,
						then: MyJoi.string().empty(["", "null"]).required(),
						otherwise: MyJoi.string().trim().empty(["", "null"]).default(null)
					}),
					otherwise: MyJoi.string().trim().empty(["", "null"]).default(null)
				}),
				heroImage: MyJoi.any().empty(["", "null"]).allow(null),
				heroVideo: MyJoi.any().empty(["", "null"]).allow(null),
				heroVideoVimeoId: MyJoi.string().empty(["", "null"]).default(null).allow(null),
				heroVideoActive: MyJoi.boolean(),
				secondImage: MyJoi.any().empty(["", "null"]).allow(null),
				thirdImage: MyJoi.any().empty(["", "null"]).allow(null)
			}).required(),
			body: MyJoi.object({
				name: MyJoi.myString().min(2).max(30).required(),
				fullName: MyJoi.myString().myName().empty(["", "null"]).default(null).allow(null),
				isPreQualified: MyJoi.boolean().required(),
				addressZipCode: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
				addressCity: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
				weeklyHours: MyJoi.number().positive().precision(2).empty(["", "null"]).default(null).allow(null),
				weeklyHoursMax: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.number().positive().precision(2).empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				schedule: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().valid(...Object.values(JobPositionSchedule)).empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				startDate: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.date().empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				shiftWork: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				salary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				salaryIsPublic: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.boolean().empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				salutation: MyJoi.string().valid(...Object.values(Salutation)).empty(["", "null"]).default(null).allow(null),
				searchArea: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
				searchCenter: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
				searchCenterCountry: MyJoi.string().valid(...Object.values(CountryCode)).empty(["", "null"]).default(null).allow(null),
				searchRadius: MyJoi.number().positive().empty(["", "null"]).default(null).allow(null),
				cvRequired: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.alternatives().conditional("type", {
						is: JobPositionType.EMPLOYEE,
						then: MyJoi.boolean().required(),
						otherwise: MyJoi.string().empty(["", "null"]).default(null).valid(null)
					}),
					otherwise: MyJoi.string().empty(["", "null"]).default(null).valid(null)
				}),
				cvRequiredInForm: MyJoi.alternatives().conditional("isPreQualified", {
					is: false,
					then: MyJoi.alternatives().conditional("type", {
						is: JobPositionType.EMPLOYEE,
						then: MyJoi.boolean().required(),
						otherwise: MyJoi.any().custom(() => null).default(null)
					}),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				emailRecipients: validateJsonString(MyJoi.array().items(MyJoi.object({ email: MyJoi.myString().myEmailAddress().required() })).min(1).max(config.jobPositionEmailRecipientLimit).required()),
				type: MyJoi.myString().myJobPositionType().required(),
				specialization: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				university: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.DUAL_STUDENT,
					then: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				fieldServiceAndHomeOffice: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.EMPLOYEE,
					then: MyJoi.alternatives().conditional("isPreQualified", {
						is: true,
						then: validateJsonString(MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required()),
						otherwise: validateJsonString(MyJoi.myArray().myEmptyArray())
					}),
					otherwise: validateJsonString(MyJoi.myArray().myEmptyArray())
				}),
				otherManagerInfo: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: validateJsonString(MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required()),
					otherwise: validateJsonString(MyJoi.myArray().myEmptyArray())
				}),
				trainingDuration: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.number().positive().precision(2).empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				isFlexibleInternshipPossible: MyJoi.alternatives().conditional("type", {
					is: MyJoi.valid(JobPositionType.TRAINEE, JobPositionType.DUAL_STUDENT),
					then: MyJoi.boolean().required(),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				requirements: validateJsonString(MyJoi.array().items(MyJoi.object({
					value: MyJoi.string().trim().required(),
					isKoCriteria: MyJoi.boolean().allow(null),
					isPublicOnly: MyJoi.boolean().required(),
					label: MyJoi.string().trim(),
					selectOptions: MyJoi.array().items(MyJoi.string().trim()),
					isProtected: MyJoi.boolean()
				})).required()),
				additionalRequirements: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: validateJsonString(MyJoi.array().items(MyJoi.object({
						value: MyJoi.string().trim().required(),
						isKoCriteria: MyJoi.boolean().required(),
						isDirect: MyJoi.boolean().required(),
						label: MyJoi.string().trim(),
						selectOptions: MyJoi.array().items(MyJoi.string().trim()),
						isProtected: MyJoi.boolean()
					})).required()),
					otherwise: validateJsonString(MyJoi.myArray().myEmptyArray())
				}),
				tasks: validateJsonString(MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required()),
				benefits: validateJsonString(MyJoi.array().items(MyJoi.object({ content: MyJoi.string().trim().required() })).required()),
				contactPersonName: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.string().trim().required(),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				contactPersonPosition: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.string().trim().required(),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				contactPersonEmail: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.myString().myEmailAddress().required(),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				addressLink: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.string().uri().empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				externalApplicationUrl: MyJoi.string().uri().empty(["", "null"]).default(null).allow(null),
				potential: MyJoi.string().valid(...Object.values(JobPositionPotential)).empty(["", "null"]).default(null).allow(null),
				traineeFirstYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				traineeSecondYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				traineeThirdYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				traineeFourthYearSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.TRAINEE,
					then: MyJoi.number().positive().precision(2).max(999999).empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				dualStudentSalary: MyJoi.alternatives().conditional("type", {
					is: JobPositionType.DUAL_STUDENT,
					then: MyJoi.string().trim().empty(["", "null"]).default(null).allow(null),
					otherwise: MyJoi.any().empty(["", "null"]).default(null).valid(null)
				}),
				locationId: MyJoi.number().integer().empty(["", "null"]).default(null).allow(null),
				workAreaId: MyJoi.number().integer().empty(["", "null"]).default(null).allow(null),
				isArchived: MyJoi.boolean().empty(["", "null"]).default(null).allow(null),
				documentsRequiredForForwarding: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.alternatives().conditional("type", {
						is: JobPositionType.EMPLOYEE,
						then: MyJoi.any().custom(() => null).default(null),
						otherwise: MyJoi.boolean().required()
					}),
					otherwise: MyJoi.any().custom(() => null).default(null)
				}),
				requiredDocumentsDescription: MyJoi.alternatives().conditional("isPreQualified", {
					is: true,
					then: MyJoi.alternatives().conditional("documentsRequiredForForwarding", {
						is: true,
						then: MyJoi.string().trim().empty(["", "null"]).required(),
						otherwise: MyJoi.string().trim().empty(["", "null"]).default(null)
					}),
					otherwise: MyJoi.string().trim().empty(["", "null"]).default(null)
				}),
				heroImage: MyJoi.alternatives().try(MyJoi.object({
					originalFilename: MyJoi.string().required(),
					mimetype: MyJoi.string().valid(UploadDocumentMimeTypeMap.JPG, UploadDocumentMimeTypeMap.PNG).required(),
					size: MyJoi.number().integer().max(config.largeImageFileSize).required()
				}).unknown(true).allow(null), MyJoi.string().empty([""]).custom((value) => value === "null" ? null : value).allow(null)),
				heroVideo: MyJoi.alternatives().try(MyJoi.object({
					originalFilename: MyJoi.string().required(),
					mimetype: MyJoi.string().valid(UploadDocumentMimeTypeMap.JPG, UploadDocumentMimeTypeMap.PNG).required(),
					size: MyJoi.number().integer().max(config.largeImageFileSize).required()
				}).unknown(true).allow(null), MyJoi.string().empty([""]).custom((value) => value === "null" ? null : value).allow(null)),
				heroVideoVimeoId: MyJoi.string().empty([""]).custom((value) => value === "null" ? null : value).allow(null),
				heroVideoActive: MyJoi.boolean(),
				secondImage: MyJoi.alternatives().try(MyJoi.object({
					originalFilename: MyJoi.string().required(),
					mimetype: MyJoi.string().valid(UploadDocumentMimeTypeMap.JPG, UploadDocumentMimeTypeMap.PNG).required(),
					size: MyJoi.number().integer().max(config.largeImageFileSize).required()
				}).unknown(true).allow(null), MyJoi.string().empty([""]).custom((value) => value === "null" ? null : value).allow(null)),
				thirdImage: MyJoi.alternatives().try(MyJoi.object({
					originalFilename: MyJoi.string().required(),
					mimetype: MyJoi.string().valid(UploadDocumentMimeTypeMap.JPG, UploadDocumentMimeTypeMap.PNG).required(),
					size: MyJoi.number().integer().max(config.largeImageFileSize).required()
				}).unknown(true).allow(null), MyJoi.string().empty([""]).custom((value) => value === "null" ? null : value).allow(null))
			}).required()
		})
	});
};
// source/validation/location-validation-schemas.ts
var LocationValidationSchemas = class extends BaseValidationSchemas {
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static create = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ locationCreationDto: MyJoi.object({ customerId: MyJoi.number().integer().required() }).unknown(true).required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				customerId: MyJoi.number().integer().required(),
				address: MyJoi.myString().allow("", null).optional(),
				zipCode: MyJoi.myString().allow("", null).optional(),
				city: MyJoi.myString().allow("", null).optional(),
				country: MyJoi.string().valid(...Object.values(CountryCode)).optional(),
				googleMapsTitle: MyJoi.myString().allow("", null).optional(),
				googleMapsLatitude: MyJoi.number().allow(null).optional(),
				googleMapsLongitude: MyJoi.number().allow(null).optional(),
				name: MyJoi.myString().allow("", null)
			}),
			body: MyJoi.object({ locationCreationDto: MyJoi.object({
				customerId: MyJoi.number().integer().required(),
				address: MyJoi.myString().allow("", null).optional(),
				zipCode: MyJoi.myString().allow("", null).optional(),
				city: MyJoi.myString().allow("", null).optional(),
				country: MyJoi.string().valid(...Object.values(CountryCode)).optional(),
				googleMapsTitle: MyJoi.myString().allow("", null).optional(),
				googleMapsLatitude: MyJoi.number().allow(null).optional(),
				googleMapsLongitude: MyJoi.number().allow(null).optional(),
				name: MyJoi.myString().allow("", null).empty("").default(null)
			}).required() }).required()
		})
	});
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				address: MyJoi.myString().allow("", null).optional(),
				zipCode: MyJoi.myString().allow("", null).optional(),
				city: MyJoi.myString().allow("", null).optional(),
				country: MyJoi.string().valid(...Object.values(CountryCode)).optional(),
				googleMapsTitle: MyJoi.myString().allow("", null).optional(),
				googleMapsLatitude: MyJoi.number().allow(null).optional(),
				googleMapsLongitude: MyJoi.number().allow(null).optional(),
				name: MyJoi.myString().allow("", null)
			}),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			body: MyJoi.object({ locationUpdateDto: MyJoi.object({
				address: MyJoi.myString().allow("", null).optional(),
				zipCode: MyJoi.myString().allow("", null).optional(),
				city: MyJoi.myString().allow("", null).optional(),
				country: MyJoi.string().valid(...Object.values(CountryCode)).optional(),
				googleMapsTitle: MyJoi.myString().allow("", null).optional(),
				googleMapsLatitude: MyJoi.number().allow(null).optional(),
				googleMapsLongitude: MyJoi.number().allow(null).optional(),
				name: MyJoi.myString().allow("", null).empty("").default(null)
			}).required() }).required()
		})
	});
	static remove = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static routeByPostalCode = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({
			postalCode: MyJoi.string().trim().required(),
			destinationAddress: MyJoi.string().trim().required(),
			country: MyJoi.string().valid(...Object.values(CountryCode)).optional()
		}).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({
			postalCode: MyJoi.string().trim().required(),
			destinationAddress: MyJoi.string().trim().required(),
			country: MyJoi.string().valid(...Object.values(CountryCode)).optional()
		}) })
	});
	static mapLocationByPostalCode = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({
			postalCode: MyJoi.string().trim().required(),
			country: MyJoi.string().valid(...Object.values(CountryCode)).optional()
		}).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({
			postalCode: MyJoi.string().trim().required(),
			country: MyJoi.string().valid(...Object.values(CountryCode)).optional()
		}) })
	});
};
// source/validation/metrics-validation-schemas.ts
var MetricsValidationSchemas = class extends BaseValidationSchemas {
	static latestWebsite = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() })
	});
	static values = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required(),
			queryParams: MyJoi.object({
				startAt: MyJoi.number().integer().min(0).required(),
				endAt: MyJoi.number().integer().min(0).required()
			}).unknown(true)
		}),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required(),
			queryParams: MyJoi.object({
				startAt: MyJoi.number().integer().min(0).required(),
				endAt: MyJoi.number().integer().min(0).required()
			})
		})
	});
	static metrics = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required(),
			queryParams: MyJoi.object({
				type: MyJoi.string().required(),
				url: MyJoi.string(),
				search: MyJoi.string(),
				startAt: MyJoi.number().integer().min(0).required(),
				endAt: MyJoi.number().integer().min(0).required()
			}).unknown(true)
		}),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required(),
			queryParams: MyJoi.object({
				type: MyJoi.string().required(),
				url: MyJoi.string(),
				search: MyJoi.string(),
				startAt: MyJoi.number().integer().min(0).required(),
				endAt: MyJoi.number().integer().min(0).required()
			})
		})
	});
	static pageViews = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required(),
			queryParams: MyJoi.object({
				url: MyJoi.string(),
				unit: MyJoi.string().valid(...umamiUnits).required(),
				startAt: MyJoi.number().integer().min(0).required(),
				endAt: MyJoi.number().integer().min(0).required()
			}).unknown(true)
		}),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required(),
			queryParams: MyJoi.object({
				url: MyJoi.string(),
				unit: MyJoi.string().valid(...umamiUnits).required(),
				startAt: MyJoi.number().integer().min(0).required(),
				endAt: MyJoi.number().integer().min(0).required()
			})
		})
	});
	static stats = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required(),
			queryParams: MyJoi.object({
				url: MyJoi.string(),
				startAt: MyJoi.number().integer().min(0).required(),
				endAt: MyJoi.number().integer().min(0).required()
			}).unknown(true)
		}),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required(),
			queryParams: MyJoi.object({
				url: MyJoi.string(),
				startAt: MyJoi.number().integer().min(0).required(),
				endAt: MyJoi.number().integer().min(0).required()
			})
		})
	});
	static events = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required(),
			queryParams: MyJoi.object({
				event: MyJoi.string(),
				startAt: MyJoi.number().integer().min(0).required(),
				endAt: MyJoi.number().integer().min(0).required(),
				unit: MyJoi.string().valid(...umamiUnits).required()
			}).unknown(true)
		}),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required(),
			queryParams: MyJoi.object({
				event: MyJoi.string(),
				startAt: MyJoi.number().integer().min(0).required(),
				endAt: MyJoi.number().integer().min(0).required(),
				unit: MyJoi.string().valid(...umamiUnits).required()
			})
		})
	});
	static detailedEvents = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required(),
			queryParams: MyJoi.object({
				event: MyJoi.string(),
				startAt: MyJoi.number().integer().min(0).required(),
				endAt: MyJoi.number().integer().min(0).required(),
				unit: MyJoi.string().valid(...umamiUnits)
			}).unknown(true)
		}),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required(),
			queryParams: MyJoi.object({
				event: MyJoi.string(),
				startAt: MyJoi.number().integer().min(0).required(),
				endAt: MyJoi.number().integer().min(0).required(),
				unit: MyJoi.string().valid(...umamiUnits)
			})
		})
	});
};
// source/validation/migration-validation-schemas.ts
var MigrationValidationSchemas = class extends BaseValidationSchemas {
	static migration = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({ params: MyJoi.object({ name: MyJoi.myString().myName().required() }).required() }) });
};
// source/validation/monday-recruiting-validation-schemas.ts
var MondayRecruitingValidationSchemas = class extends BaseValidationSchemas {
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).required() })
	});
	static getAll = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static getAllLight = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static sync = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static syncOne = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).required() })
	});
	static updateStatus = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).required(),
			body: MyJoi.object({ status: MyJoi.string().valid(...Object.values(MondayRecruitingStatus)).required() }).required()
		})
	});
};
// source/validation/monday-settings-data-validation-schemas.ts
var MondaySettingsDataValidationSchemas = class extends BaseValidationSchemas {
	static get = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
};
// source/validation/monday-validation-schemas.ts
var MondayValidationSchemas = class extends BaseValidationSchemas {
	static jobPositionSettingsGroup = MyJoi.array().items(MyJoi.object({
		name: MyJoi.myString().required(),
		subitems: MyJoi.array().items(MyJoi.object({
			name: MyJoi.myString().required(),
			column_values: MyJoi.array().items(MyJoi.object({
				id: MyJoi.myString().required(),
				text: MyJoi.myString().allow("").required()
			})).required()
		})).required()
	})).required();
	static faqTemplates = MyJoi.array().items(MyJoi.object({
		name: MyJoi.myString().required(),
		column_values: MyJoi.array().items(MyJoi.object({
			id: MyJoi.myString().required(),
			text: MyJoi.myString().required()
		})).required()
	})).required();
};
// source/validation/nps-log-validation-schemas.ts
var NpsLogValidationSchemas = class extends BaseValidationSchemas {
	static creation = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ npsLogCreationDto: MyJoi.object({ customerId: MyJoi.number().integer().required() }).unknown(true).required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({ value: MyJoi.number().min(0).max(10).required() }).required(),
			body: MyJoi.object({ npsLogCreationDto: MyJoi.object({
				customerId: MyJoi.number().integer().required(),
				value: MyJoi.number().min(0).max(10).required()
			}).required() }).required()
		})
	});
};
// source/validation/oauth-validation-schemas.ts
var OAuthValidationSchemas = class extends BaseValidationSchemas {
	static googleInitiate = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() })
	});
	static googleCallback = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({
			code: MyJoi.string().required(),
			state: validateJsonString(MyJoi.object({ customerId: MyJoi.number().required() }).required()).required()
		}).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({
			code: MyJoi.string().required(),
			state: validateJsonString(MyJoi.object({ customerId: MyJoi.number().required() }).required()).required()
		}).unknown(true).required() })
	});
	static microsoftInitiate = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() })
	});
	static microsoftCallback = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({
			code: MyJoi.string().required(),
			state: validateJsonString(MyJoi.object({ customerId: MyJoi.number().required() }).required()).required()
		}).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({
			code: MyJoi.string().required(),
			state: validateJsonString(MyJoi.object({ customerId: MyJoi.number().required() }).required()).required()
		}).unknown(true).required() })
	});
};
// source/validation/platform-validation-schemas.ts
var PlatformValidationSchemas = class extends BaseValidationSchemas {
	static creation = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({
		form: MyJoi.object({
			name: MyJoi.myString().myShortName().required(),
			color: MyJoi.myString().myColor().required(),
			isOutreachPossible: MyJoi.boolean().required()
		}).required(),
		body: MyJoi.object({ platformCreationDto: MyJoi.object({
			name: MyJoi.myString().myShortName().required(),
			color: MyJoi.myString().myColor().required(),
			isOutreachPossible: MyJoi.boolean().required()
		}).required() }).required()
	}) });
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getAll = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({
				name: MyJoi.myString().myShortName().required(),
				color: MyJoi.myString().myColor().required(),
				isOutreachPossible: MyJoi.boolean().required()
			}).required(),
			body: MyJoi.object({ platformUpdateDto: MyJoi.object({
				name: MyJoi.myString().myShortName().required(),
				color: MyJoi.myString().myColor().required(),
				isOutreachPossible: MyJoi.boolean().required()
			}).required() }).required()
		})
	});
	static removal = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
};
// source/validation/recruiting-log-entry-validation-schemas.ts
var idParams = MyJoi.object({ id: MyJoi.number().myObjectId().required() });
/**
* The date stays a plain "YYYY-MM-DD" string all the way into the date column.
* Converting it into a Date first would read it in the time zone of the api and
* move it onto the day before whenever that differs from the browser.
*
* The type stays a free string, so a label from a sheet nobody told us about
* does not fail the import. The dropdown of the ui offers the known ones.
*
* The html carries the emphasis of the same text and deliberately has no
* default: the validator replaces the whole body with its own output, so a
* default would silently erase the formatting of everyone who does not send it.
* Leaving it out means "no formatting", which reads as plain text.
*/
var entryBody = {
	happenedOn: MyJoi.string().pattern(/^\d{4}-\d{2}-\d{2}$/).required(),
	description: MyJoi.string().allow("").default(""),
	descriptionHtml: MyJoi.string().allow("", null),
	type: MyJoi.string().allow("").default("")
};
var RecruitingLogEntryValidationSchemas = class extends BaseValidationSchemas {
	static getAllByMondayRecruitingId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: idParams.unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: idParams.required() })
	});
	static create = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: idParams.unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: idParams.required(),
			body: MyJoi.object(entryBody).required()
		})
	});
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: idParams.unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: idParams.required(),
			body: MyJoi.object(entryBody).required()
		})
	});
	static remove = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: idParams.unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: idParams.required() })
	});
};
// source/validation/resume-validation-schemas.ts
var ResumeValidationSchemas = class extends BaseValidationSchemas {
	static getData = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ token: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ token: MyJoi.string().myObjectId().required() }).required() })
	});
	static sendResume = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ token: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ token: MyJoi.string().myObjectId().required() }).required(),
			body: MyJoi.object({
				email: MyJoi.myString().myEmailAddressAllowNonAscii(),
				resume: MyJoi.object({
					originalFilename: MyJoi.string().required(),
					mimetype: MyJoi.string().valid(UploadDocumentMimeTypeMap.PDF).required(),
					size: MyJoi.number().integer().max(config.documentFileSizeLimit).required()
				}).unknown(true).required()
			}).required()
		})
	});
};
// source/validation/sanity-validation-schema.ts
var SanityValidationSchemas = class extends BaseValidationSchemas {
	static getCourse = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getCourses = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet() });
	static getChapter = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getLesson = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
};
// source/validation/scheduled-email-validation-schemas.ts
var ScheduledEmailValidationSchemas = class extends BaseValidationSchemas {
	static getByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required(),
			queryParams: MyJoi.object({
				page: MyJoi.number().integer().min(1).required(),
				pageSize: MyJoi.number().integer().min(1).max(100).required()
			}).unknown(true).required()
		}),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			queryParams: MyJoi.object({
				page: MyJoi.number().integer().min(1).required(),
				pageSize: MyJoi.number().integer().min(1).max(100).required()
			}).required()
		})
	});
	static cancel = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
};
// source/validation/score-card-validation-schemas.ts
var ScoreCardValidationSchemas = class extends BaseValidationSchemas {
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getByJobPositionId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static create = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ scoreCardCreationDto: MyJoi.object({ jobPositionId: MyJoi.number().integer().required() }).unknown(true).required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				jobPositionId: MyJoi.number().integer().required(),
				title: MyJoi.string().trim().empty("").required(),
				description: MyJoi.string().trim().empty("").default(null).allow(null),
				position: MyJoi.number().integer().required()
			}),
			body: MyJoi.object({ scoreCardCreationDto: MyJoi.object({
				jobPositionId: MyJoi.number().integer().required(),
				title: MyJoi.string().trim().required(),
				description: MyJoi.string().trim().allow(null),
				position: MyJoi.number().integer().required()
			}).required() }).required()
		})
	});
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				title: MyJoi.string().trim().empty(""),
				description: MyJoi.string().trim().empty("").default(null).allow(null),
				position: MyJoi.number().integer().empty("")
			}),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			body: MyJoi.object({ scoreCardUpdateDto: MyJoi.object({
				title: MyJoi.string().trim().empty(""),
				description: MyJoi.string().trim().allow(null),
				position: MyJoi.number().integer().empty("")
			}).required() }).required()
		})
	});
	static upsertMany = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ scoreCardUpsertDtos: MyJoi.array().items(MyJoi.object({
			jobPositionId: MyJoi.number().integer().required(),
			title: MyJoi.string().trim().empty("")
		}).unknown(true).required()) }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({ scoreCardUpsertDtos: MyJoi.array().items(MyJoi.object({
				id: MyJoi.number().integer(),
				jobPositionId: MyJoi.number().integer().required(),
				title: MyJoi.string().trim().required(),
				description: MyJoi.string().trim().empty("").default(null).allow(null),
				position: MyJoi.number().integer().required()
			})) }),
			body: MyJoi.object({ scoreCardUpsertDtos: MyJoi.array().items(MyJoi.object({
				id: MyJoi.number().integer(),
				jobPositionId: MyJoi.number().integer().required(),
				title: MyJoi.string().trim().required(),
				description: MyJoi.string().trim().allow(null),
				position: MyJoi.number().integer().required()
			}).required()) }).required()
		})
	});
	static remove = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
};
// source/validation/sms-template-validation-schemas.ts
var SmsTemplateValidationSchemas = class extends BaseValidationSchemas {
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getAll = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ onBehalfOf: MyJoi.string().valid(...Object.values(OnBehalfOf)) }) }) });
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({
				name: MyJoi.string().trim().required(),
				body: MyJoi.string().trim().required()
			}).required(),
			body: MyJoi.object({ smsTemplateUpdateDto: MyJoi.object({
				name: MyJoi.string().trim().required(),
				body: MyJoi.string().trim().required()
			}).required() }).required()
		})
	});
};
// source/validation/user-validation-schemas.ts
var UserValidationSchemas = class extends BaseValidationSchemas {
	static login = new ValidationSchemaInputSet({ full: new ValidationSchemaCaseSet({ form: MyJoi.object({
		emailAddress: MyJoi.myString().myEmailAddress().required(),
		password: MyJoi.string().required()
	}).required() }) });
};
// source/validation/webhook-validation-schemas.ts
var WebhookValidationSchemas = class extends BaseValidationSchemas {
	static perspective = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ token: MyJoi.string() }).unknown(true) }),
		full: new ValidationSchemaCaseSet({
			queryParams: MyJoi.object({ token: MyJoi.string() }),
			body: MyJoi.object({
				id: MyJoi.string().required(),
				/**
				* We accept all events from perspective, for tracking purposes.
				* For now we just comment out the validation in case we need it later.
				*/
				values: MyJoi.object({}).custom((obj) => {
					const renames = [
						["platzierung", "Platzierung"],
						["kanal", "Kanal"],
						["werbeanzeige", "Werbeanzeige"],
						["keyword", "Keyword"]
					];
					const result = { ...obj };
					for (const [from, to] of renames) if (from in result && !(to in result)) {
						result[to] = result[from];
						delete result[from];
					} else if (from in result) delete result[from];
					return result;
				}).unknown(true)
			}).unknown(true)
		})
	});
	static generateCareerPage = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({
			customerId: MyJoi.number().myObjectId().required(),
			taskId: MyJoi.string()
		}).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({ body: MyJoi.object({
				customerId: MyJoi.number().myObjectId().required(),
				taskId: MyJoi.string()
			}).required() }).required(),
			body: MyJoi.object({
				customerId: MyJoi.number().myObjectId().required(),
				taskId: MyJoi.string()
			}).required()
		})
	});
	static sendScheduledMail = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ scheduledEmailId: MyJoi.number().myObjectId().required() }).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({ body: MyJoi.object({ scheduledEmailId: MyJoi.number().myObjectId().required() }).required() }).required(),
			body: MyJoi.object({ scheduledEmailId: MyJoi.number().myObjectId().required() }).required()
		})
	});
	static removeCareerDomain = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).required(),
			body: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).required()
		})
	});
	static scanDocument = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).required(),
			body: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).required()
		})
	});
	static syncCustomerAnalytics = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).required(),
			body: MyJoi.object({ id: MyJoi.number().myObjectId().required() }).required()
		})
	});
	static checkSocialMediaCreditDocument = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({
			customerId: MyJoi.number().myObjectId().required(),
			documentObjectId: MyJoi.string().required()
		}).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({ body: MyJoi.object({
				customerId: MyJoi.number().myObjectId().required(),
				documentObjectId: MyJoi.string().required()
			}).required() }).required(),
			body: MyJoi.object({
				customerId: MyJoi.number().myObjectId().required(),
				documentObjectId: MyJoi.string().required()
			}).required()
		})
	});
	static mailersendBounce = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ queryParams: MyJoi.object({ token: MyJoi.string() }).unknown(true) }),
		full: new ValidationSchemaCaseSet({
			queryParams: MyJoi.object({ token: MyJoi.string() }).unknown(true),
			body: MyJoi.object({ type: MyJoi.string().required() }).unknown(true).required()
		})
	});
	static syncHrbaxmlPosting = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({
			customerId: MyJoi.number().myObjectId().required(),
			taskId: MyJoi.string()
		}).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({ body: MyJoi.object({
				customerId: MyJoi.number().myObjectId().required(),
				taskId: MyJoi.string()
			}).required() }).required(),
			body: MyJoi.object({
				customerId: MyJoi.number().myObjectId().required(),
				taskId: MyJoi.string()
			}).required()
		})
	});
	static generateIndeedXmlFeed = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet(),
		full: new ValidationSchemaCaseSet()
	});
	static processHrbaxmlErrorLogs = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ customerId: MyJoi.number().myObjectId().required() }).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({ body: MyJoi.object({ customerId: MyJoi.number().myObjectId().required() }).required() }).required(),
			body: MyJoi.object({ customerId: MyJoi.number().myObjectId().required() }).required()
		})
	});
	static getByJobPositionId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static creation = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ webhookCreationDto: MyJoi.object({ customerId: MyJoi.number().myObjectId().required() }).unknown(true).required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				customerId: MyJoi.number().myObjectId().required(),
				source: MyJoi.myString().myWebhookType().required(),
				name: MyJoi.myString().myName().required(),
				jobPositionId: MyJoi.alternatives().conditional("source", {
					is: MyJoi.valid(WebhookSources.PERSPECTIVE, WebhookSources.WL_LANDING_PAGE),
					then: MyJoi.number().integer().required(),
					otherwise: MyJoi.forbidden()
				})
			}).required(),
			body: MyJoi.object({ webhookCreationDto: MyJoi.object({
				customerId: MyJoi.number().myObjectId().required(),
				source: MyJoi.myString().myWebhookType().required(),
				name: MyJoi.myString().myName().required(),
				jobPositionId: MyJoi.alternatives().conditional("source", {
					is: MyJoi.valid(WebhookSources.PERSPECTIVE, WebhookSources.WL_LANDING_PAGE),
					then: MyJoi.number().integer().required(),
					otherwise: MyJoi.forbidden()
				})
			}).required() }).required()
		})
	});
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() }),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			form: MyJoi.object({ name: MyJoi.myString().myName().required() }).required(),
			body: MyJoi.object({ webhookUpdateDto: MyJoi.object({ name: MyJoi.myString().myName().required() }).required() }).required()
		})
	});
	static remove = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
};
// source/validation/work-area-validation-schemas.ts
var WorkAreaValidationSchemas = class extends BaseValidationSchemas {
	static get = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
	static getByCustomerId = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required(),
			queryParams: MyJoi.object({ type: MyJoi.myString().myJobPositionType() }).unknown(true)
		}),
		full: new ValidationSchemaCaseSet({
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			queryParams: MyJoi.object({ type: MyJoi.myString().myJobPositionType() })
		})
	});
	static create = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ body: MyJoi.object({ workAreaCreationDto: MyJoi.object({ customerId: MyJoi.number().integer().required() }).unknown(true).required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({
				customerId: MyJoi.number().integer().required(),
				name: MyJoi.string().trim().empty("").required(),
				type: MyJoi.myString().myJobPositionType().required()
			}),
			body: MyJoi.object({ workAreaCreationDto: MyJoi.object({
				customerId: MyJoi.number().integer().required(),
				name: MyJoi.string().trim().required(),
				type: MyJoi.myString().myJobPositionType().required()
			}).required() }).required()
		})
	});
	static update = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({
			form: MyJoi.object({ name: MyJoi.string().trim().empty("").required() }),
			params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required(),
			body: MyJoi.object({ workAreaUpdateDto: MyJoi.object({ name: MyJoi.string().trim().required() }).required() }).required()
		})
	});
	static remove = new ValidationSchemaInputSet({
		preAuthentication: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).unknown(true).required() }),
		full: new ValidationSchemaCaseSet({ params: MyJoi.object({ id: MyJoi.string().myObjectId().required() }).required() })
	});
};
// source/index.ts
dateFns.setDefaultOptions({ locale: de });
export { AcceptedDocuments, AcceptedFonts, AcceptedImages, AcceptedLogoImages, AdditionalRequirement, AnalyticsType, AppError, AppErrorType, AppErrorTypeGroupNames, Applicant, ApplicantAutomation, ApplicantAutomationDto, ApplicantAutomationTemplate, ApplicantAutomationTemplateDto, ApplicantAutomationTemplateWithRelations, ApplicantAutomationTemplateWithRelationsDto, ApplicantAutomationValidationSchemas, ApplicantAutomationValidationTemplateSchemas, ApplicantCreationDto, ApplicantDocument, ApplicantDocumentCreationDto, ApplicantDocumentDto, ApplicantDocumentStatus, ApplicantDocumentValidationSchemas, ApplicantDto, ApplicantManager, ApplicantManagerDto, ApplicantManagerValidationSchemas, ApplicantOrigin, ApplicantPersonalInfoUpdateDto, ApplicantPhase, ApplicantPhaseCreationDto, ApplicantPhaseDto, ApplicantPhaseType, ApplicantPhaseUpdateDto, ApplicantPhaseValidationSchemas, ApplicantProcessingState, ApplicantProcessingStateDto, ApplicantProcessingStateValidationSchemas, ApplicantPublic, ApplicantPublicDto, ApplicantScore, ApplicantScoreCreationDto, ApplicantScoreDto, ApplicantScoreRatings, ApplicantScoreUpdateDto, ApplicantScoreUpsertDto, ApplicantScoreValidationSchemas, ApplicantScoreWithRelations, ApplicantScoreWithRelationsDto, ApplicantShared, ApplicantSharedDto, ApplicantSharedWithRelations, ApplicantSharedWithRelationsDto, ApplicantSource, ApplicantSourceCreationDto, ApplicantSourceDto, ApplicantSourceType, ApplicantSourceUpdateDto, ApplicantSourceValidationSchemas, ApplicantStatusUpdate, ApplicantStatusUpdateCreationDto, ApplicantStatusUpdateDto, ApplicantStatusUpdateValidationSchemas, ApplicantUpdateDto, ApplicantValidationSchemas, ApplicantWithRelations, ApplicantWithRelationsDto, BlockedApplicant, BlockedApplicantCreationDto, BlockedApplicantDto, BlockedApplicantUpdateDto, BlockedApplicantValidationSchemas, Career, CareerCreationDto, CareerDomain, CareerDomainCreationDto, CareerDomainDto, CareerDomainStatus, CareerDomainValidationSchemas, CareerDto, CareerPagePublishStatus, CareerPageReferralSource, CareerPageStatus, CareerPageValidationSchemas, CareerUpdateDto, CareerValidationSchemas, Chapter, ChapterDto, ChapterWithRelations, ChapterWithRelationsDto, Company, CompanyCreationDto, CompanyDto, CompanyLight, CompanyLightDto, CompanyPublic, CompanyPublicDto, CompanyUpdateDto, CompanyValidationSchemas, CountryCode, Course, CourseDto, CourseWithRelations, CourseWithRelationsDto, CronValidationSchemas, Customer, CustomerAcquisitionSearchAdStatus, CustomerAnalytics, CustomerAnalyticsCreationDto, CustomerAnalyticsDto, CustomerAnalyticsValidationSchemas, CustomerCreationDto, CustomerDto, CustomerEmailSignature, CustomerEmailSignatureCreationDto, CustomerEmailSignatureDto, CustomerEmailSignatureUpdateDto, CustomerEmailSignatureValidationSchemas, CustomerEmailTemplate, CustomerEmailTemplateCreationDto, CustomerEmailTemplateDto, CustomerEmailTemplateUpdateDto, CustomerEmailTemplateValidationSchemas, CustomerEmailTemplateWithRelations, CustomerEmailTemplateWithRelationsDto, CustomerEmailValidationSchemas, CustomerFont, CustomerFontCreationDto, CustomerFontDto, CustomerFontUpdateDto, CustomerFontValidationSchemas, CustomerLight, CustomerLightDto, CustomerUpdateDto, CustomerValidationSchemas, CustomerWithRelations, CustomerWithRelationsDto, DangerousApplicantDocumentStatuses, DataShId, DocumentMimeTypeMap, DocumentSource, DocumentType, EditableLoginDataPlatform, EmailContentType, EmailProvider, EmailProviderCreationDto, EmailProviderDto, EmailProviderOption, EmailProviderUpdateDto, EmailProviderValidationSchemas, EmailProviderWithRelations, EmailProviderWithRelationsDto, EmailProviderWithRelationsUpdateDto, EmailSignature, EmailSignatureDto, EmailSignatureUpdateDto, EmailSignatureValidationSchemas, EmailTarget, EmailTemplate, EmailTemplateDto, EmailTemplateKey, EmailTemplateUpdateDto, EmailTemplateValidationSchemas, EmailTemplateWithRelations, EmailTemplateWithRelationsDto, Environment, FontMimeTypeMap, FontSource, FontType, Gender, GoogleForJobsValidationSchemas, HealthValidationSchemas, HrbaxmlConfig, HrbaxmlConfigCreationDto, HrbaxmlConfigUpdateDto, HrbaxmlLastAction, HrbaxmlPostingSync, HrbaxmlSyncStatus, HrbaxmlValidationSchemas, InitialCareerFormValues, IntegrationValidationSchemas, InverseDocumentMimeTypeMap, InverseFontMimeTypeMap, JobPosition, JobPositionAnalytics, JobPositionAnalyticsDto, JobPositionAnalyticsValidationSchemas, JobPositionCampaignStatus, JobPositionCreationDto, JobPositionDirectApproachChannelPlatform, JobPositionDirectApproachChannelPotential, JobPositionDto, JobPositionInfo, JobPositionInfoDto, JobPositionPotential, JobPositionPresets, JobPositionPublic, JobPositionPublicDto, JobPositionQuotaEndDateError, JobPositionQuotaGuarantee, JobPositionSchedule, JobPositionSettings, JobPositionTemplate, JobPositionTemplateCreationDto, JobPositionTemplateDto, JobPositionTemplateUpdateDto, JobPositionTemplateValidationSchemas, JobPositionType, JobPositionUpdateDto, JobPositionValidationSchemas, JobPositionWithRelations, JobPositionWithRelationsDto, LastPhaseChangeRole, Lesson, LessonDto, LessonWithRelations, LessonWithRelationsDto, Location, LocationCreationDto, LocationDto, LocationUpdateDto, LocationValidationSchemas, LoginDataPlatform, LoginViewableDataPlatform, MapLocation, MapLocationDto, MetricEvent, MetricsValidationSchemas, MigrationValidationSchemas, MondayCustomState, MondayCustomStateFormatting, MondayCustomer, MondayCustomerDataPackage, MondayJobPositionType, MondayProjectManager, MondayRecruiting, MondayRecruitingDto, MondayRecruitingStatus, MondayRecruitingValidationSchemas, MondaySettingsData, MondaySettingsDataDto, MondaySettingsDataValidationSchemas, MondaySocialMediaCampaignCreditTransaction, MondaySocialMediaCampaignCredits, MondaySocialMediaSupport, MondayValidationSchemas, MyJoi, NpsLog, NpsLogCreationDto, NpsLogDto, NpsLogValidationSchemas, OAuthErrorType, OAuthProvider, OAuthValidationSchemas, OnBehalfOf, Platform, PlatformCreationDto, PlatformDto, PlatformType, PlatformUpdateDto, PlatformValidationSchemas, PrequalificationStatus, ProductVersion, RecruitingLogEntry, RecruitingLogEntryDto, RecruitingLogEntryValidationSchemas, RecruitingPhase, ResumeData, ResumeDataDto, ResumeValidationSchemas, Role, Route, RouteDto, STATUS_UPDATE_DUE_BUSINESS_DAYS, STATUS_UPDATE_FIRST_DUE_BUSINESS_DAYS, Salutation, SanityValidationSchemas, ScheduledEmail, ScheduledEmailDto, ScheduledEmailValidationSchemas, ScoreCard, ScoreCardCreationDto, ScoreCardDto, ScoreCardUpdateDto, ScoreCardUpsertDto, ScoreCardValidationSchemas, SearchAdStatus, SmsTemplate, SmsTemplateDto, SmsTemplateKey, SmsTemplateUpdateDto, SmsTemplateValidationSchemas, SmtpPort, SocialDataPlatform, SocialMediaSupportStatus, StahlhartApplicantCountsDto, StahlhartCompanyDto, StahlhartJobPositionDto, TERMINAL_APPLICANT_PHASE_TYPES, UmamiUnit, UploadDocumentMimeTypeMap, UserValidationSchemas, ValidationSchemaCaseSet, ValidationSchemaInputSet, Video, VideoDto, Webhook, WebhookCreationDto, WebhookDto, WebhookSources, WebhookUpdateDto, WebhookValidationSchemas, WebsiteStatus, WorkArea, WorkAreaCreationDto, WorkAreaDto, WorkAreaUpdateDto, WorkAreaValidationSchemas, activePhaseTypes, addProtocolToUrl, apiRoutes, appRoutes, applicantAutomationTemplates, applicantForwardedAutomationTemplate, applicantMovedToRejectedPartner, applicantNotePrefix, applicantPhaseMovedAutomationTemplates, applicantRejectedTemplate, applicantRejectedThroughRecruiterTemplate, asyncEvery, asyncForEach, asyncMap, asyncSome, automaticJobCareerPageReceiptConfirmation, automaticTraineeAndDualStudentCareerPageReceiptConfirmation, buildCustomerEmailContext, buildEmailContext, buildPhaseMovedStatusUpdateContent, callAttemptFailedFiveTimesAutomationTemplate, callAttemptFailedOneTime, callAttemptFailedOneTimeAutomationTemplate, callAttemptFailedOneTimeSmsTemplate, checkIsDevelopmentEnvironment, checkIsMondayCustomStateActive, checkIsProductionEnvironment, checkIsProductionOrStagingEnvironment, combineMondayCustomStates, computeStatusUpdateDueDate, config, convertBoolToCustomState, convertScheduleToEmailDelay, convertScheduleToTimestamp, countStatusUpdateOverdueDays, countryCodeToLabelMap, countryCodes, customerEmailContextKeys, customerPhaseTypes, dataShIdToJsonPath, defaultDualStudentAdditionalRequirements, defaultEmailSignature, defaultEmployeeAdditionalRequirements, defaultNotesTemplates, defaultTraineeAdditionalRequirements, disqualifiedAtCallAutomationTemplate, disqualifiedAutomationTemplate, documentsNotReceivedAutomationTemplate, documentsReceivedAutomationTemplate, documentsReminderAutomationTemplate, domainToGcpName, emailTemplateKeyToSmsTemplateKey, emptyEmailBody, endPhaseTypes, fontFormatMap, fontMimeTypes, formatAppErrorType, formatApplicantOrigin, formatApplicantScoreRating, formatCredits, formatCurrency, formatDate, formatDateDuration, formatDuration, formatJobPositionCampaignStatus, formatJobPositionDirectApproachChannelPlatform, formatJobPositionLabel, formatJobPositionQuotaGuarantee, formatJobPositionQuotaState, formatJobPositionTypeNoun, formatJobPositionTypeNounWithArticle, formatLocation, formatLoginDataPlatform, formatMondayCustomState, formatMondayJobPositionDirectApproachChannelPotential, formatNumber, formatPercent, formatPhoneNumber, formatTimeAgo, forwardedPrequalificationStatuses, genderOptions, generateEmail, generatePassword, genericRejectionAfterInterview, genericRejectionBeforeInterview, getApplicantSourceFromCareerPageReferral, getApplicantUrl, getBucketObjectURL, getCareerSectionThemesForPage, getConditionalJobPositionValues, getCurrentIp, getCustomerCareerDnsAuthIdName, getCustomerCareerHttpForwardingRuleName, getCustomerCareerHttpProxyName, getCustomerCareerHttpRedirectUrlMapName, getCustomerCareerHttpsForwardingRuleName, getCustomerCareerHttpsProxyName, getCustomerCareerIpName, getCustomerCareerPageBackendBucketName, getCustomerCareerPageBucketName, getCustomerCareerPageBucketUrl, getCustomerCareerUrlMapName, getDefaultCareerData, getDefaultPlatformCredentials, getEnvironment, getFontWeightRanges, getGoogleMapsAddressUrl, getGoogleMapsRouteUrl, getGoogleMapsUrl, getJobPositionDirectApproachChannelPlatformIconName, getJobPositionQuotaEndDateError, getLastPhaseChangeRoleFromRole, getLastWeekMonday, getLoginDataPlatformIcon, getMondayCustomStateColor, getMondayJobPositionDirectApproachChannelPotentialColor, getMonthsBetweenDates, getRecruitingPhaseGuarantee, getRedirectPathMatcherName, getResumeBuilderUrl, getSharedApplicantUrl, getValueAtPath, getWwwDomainVariant, importedAndManualApplicantOrigins, indirectRejectionAutomationTemplate, internalPhaseTypes, introductoryMeetingConfirmation, isDuplicatedApplicant, isEndApplicantPhaseType, isForwardedPrequalificationStatus, isGuaranteeCandidate, isHiringGuaranteeAvailable, isImportedAndManualOnBehalfOfLocked, isRecruitingPhaseActive, isRecruitingPhaseInMarketing, isStatusUpdateTrackingActive, isTerminalApplicantPhaseType, isValidUrl, iso3166Map, jobPositionPresets, joinList, mergeHtmlBodyAndSignature, nonThemeableSectionIds, normalizeEmail, normalizePhoneNumber, padArray, parseAndReviveJson, parseGermanFloat, parseIsoAsUtcDate, parseMondayStateToMondayJobPositionType, phoneNumberMissingAutomationTemplate, phoneNumberNotReceivedAutomationTemplate, polyfillMondayCustomState, prequalificationStatusToLabelMap, removeDomainFromDnsHost, renderEmailTemplate, renderTemplate, resolveOnBehalfOf, resumeIncompleteAutomationTemplate, resumeNotReceivedAutomationTemplate, resumeReceivedAutomationTemplate, resumeReminderAutomationTemplate, resumeReminderSmsTemplate, safeParseDate, safelyAppendSuffixToString, safelyRemoveSuffixFromString, sectionMapping, setHoursToBeforeMidnight, setHoursToMidnight, smsEmailMap, splitDateRangeIntoMonths, talentPoolPermissionRequest, transformLineBreaksToHtml, transformToMinimalWhiteSpaceString, umamiUnits, utmParameterKeys, validationOptions, version, waitingForDocumentsAutomationTemplate, waitingForResumeAutomationTemplate, waitingForResumeSmsTemplate };

//# sourceMappingURL=common.js.map